export const translations = {
    "en-US": {
        // Preferred hour cycle for locale
        // NOTE: Only necessary to specify if default for country/region from CLDR supplementary data used by browser Intl API is incorrect
        // See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle
        // See: https://github.com/unicode-org/cldr/blob/master/common/supplemental/supplementalData.xml#L4768
        "date-time-hour-cycle": "h12",

        // Date and time formats as Luxon format strings
        // See: https://moment.github.io/luxon/docs/manual/formatting.html#table-of-tokens
        "date-time-format-date": "MM/dd/yyyy",
        "date-time-format-long-date": "MMMM d, yyyy",
        "date-time-format-month-day": "MMM d",
        "date-time-format-weekday-long-date": "EEEE, MMMM d, yyyy",
        "date-time-format-day-and-date": "EEEE dd/MM",
        "date-time-format-time": "hh:mm\u00A0a",
        "date-time-format-time-hms": "hh:mm:ss\u00A0a",
        "date-time-format-date-and-time": "MM/dd/yyyy\u00A0hh:mm\u00A0a",
        "date-time-format-duration-hours-minutes": "h'h.' m'min.'",
        "date-time-format-duration-minutes": "m'min.'",
        "date-time-format-duration-seconds": "s's'",
        "date-time-compact-period-start": "M/d-yy 'at' HH:mm\u00A0a",
        "date-time-short-relative-units": "s|m|h|d|w|mo|y",
        "date-time-invalid-date": "N/A",

        // Money formats
        "money-amount-unit-month": "mo.",
        "money-amount-unit-year": "yr.",

        // Numeric field validation
        "numeric-field-invalid-error": "{ $label } must be a number",
        "numeric-field-integer-error": "{ $label } must be a whole number",
        "numeric-field-positive-error": "{ $label } must be greater than 0",
        "numeric-field-non-negative-error": "{ $label } must be 0 or greater",
        "numeric-field-negative-error": "{ $label } must be less than 0",
        "numeric-field-non-positive-error": "{ $label } must be 0 or less",
        "vat-code-vat-percentage-field-name": "VAT percentage",
        "price-list-percentage-field-name": "Percentage",

        // User types
        "-user-type-support": "Support",
        "-user-type-supplier": "Supplier",
        "-user-type-merchant": "Merchant",
        "-user-type-company": "Company",
        "-user-type-office-manager": "Office manager",
        "-user-type-user": "User",
        "-user-type-service-center": "Service center",


        // Shared components
        "error-boundary-modal": "\n .title = Something went wrong\n .message = Error code: { $errorCode }\n .buttonLabel = Close dialog",
        "query-error-boundary": "\n .title = Something went wrong\n .message = Error code: { $errorCode }\n .buttonLabel = Retry",
        "confirmation-dialog-cancel": "Cancel",
        "confirmation-dialog-approve": "Approve",
        "coming-soon-dialog-title": "Coming soon",
        "coming-soon-dialog-message": "We are working to bring you this feature.",
        "coming-soon-dialog-ok-button": "OK",
        "meeting-time-label-today": "Today at { $period }",
        "meeting-time-label-tomorrow": "Tomorrow at { $period }",
        "meeting-time-label-yesterday": "Yesterday at { $period }",
        "meeting-time-label-date": "{ $date } at { $period }",
        "error-dialog-show-details-label": "Show details",
        "error-dialog-close-button": "Close",
        "error-dialog-support-request": "Please contact <supportMessage>support@facilitynet.dk</supportMessage> if the problem persists.",
        "error-route": "\n .title = Something went wrong \n .message This page cannot be shown due to an unknown error \n .buttonLabel = Go to home",
        "time-or-date-picker-time-label": "Time",
        "api-call-timeout-message": "Request is taking longer than expected",
        "api-call-generic-success": "Operation completed successfully",

        // authenticate common texts
        "-authenticate-submit-button": "Next",

        // --- Error boundaries ---
        "app-error-boundary": "\n .title = Something went wrong\n .buttonLabel = Close dialog",
        "app-error-boundary-title": "Something went wrong",
        "app-error-boundary-button": "Close dialog",
        "route-error-boundary": "\n .title = Something went wrong\n .buttonLabel = Go home",
        "inline-error-boundary-message": "Could not render component",
        "inline-error-boundary-calendar-event-message": 'Could not parse event',
        "query-error-boundary-message": "Error fetching data.",
        "query-error-boundary-no-data-message": "No data.",
        "query-error-boundary-retry-button": "Retry",


        // --- Language selector ---
        "language-selector-lang-en-us": "English",
        "language-selector-lang-da-dk": "Danish",
        "language-selector-lang-nb-no": "Norwegian",
        "language-selector-lang-sv-se": "Swedish",


        // --- Footer ---
        "footer-read-more": "Read more at <linkElem>{ $linkName }</linkElem>",


        // --- Avatar menu ---
        "avatar-menu-menu-item-help": "Help",
        "avatar-menu-menu-item-merchant-tour": "Tour guide",
        "avatar-menu-menu-item-news": "Facilitynet news",
        "avatar-menu-menu-item-profile": "User account",
        "avatar-menu-menu-item-archive": "Archive",
        "avatar-menu-menu-item-change-user-account": "Switch user account",
        "avatar-menu-menu-item-swift-merchant": "Switch merchant",
        "avatar-menu-menu-item-settings": "Settings",
        "avatar-menu-menu-item-logout": "Log out",
        "avatar-menu-menu-item-system-status": "System status",
        "avatar-menu-tooltip-profile": "\n .title = View your user account",
        "avatar-menu-tooltip-settings": "\n .title = Change settings for your user account",
        "avatar-menu-tooltip-change-user-account": "\n .title = If you have multiple user accounts, you can switch between them here",
        "avatar-menu-tooltip-switch-merchant": "\n .title = If you have access to more than one merchant, you can switch between them here",
        "avatar-menu-tooltip-news": "\n .title = Read news from Facilitynet",
        "avatar-menu-tooltip-help": "\n .title = Get help for using the system",
        "avatar-menu-tooltip-merchant-tour": "\n .title = Start the tour guide",
        "avatar-menu-tooltip-system-status": "\n .title = View and subscribe to important messages about the system",
        "avatar-menu-tooltip-logout": "\n .title = Log out of the system",


        // --- Confirm dialogs ---
        "confirm-modal-confirm-label": "Are you sure",
        "delete-confirm-modal-title": "Delete { $itemType }",
        "delete-confirm-modal-question": "Are you sure you want to delete '{ $itemName }'?",
        "delete-confirm-modal-button-delete": "Delete",
        "delete-confirm-modal-button-cancel": "Cancel",
        "delete-confirm-modal-button-submit": "Submit",
        "cancel-subscription-modal-title": "Cancel Subscription",
        "cancel-subscription-modal-message": "Are you sure you want to cancel the subscription '{ $subscriptionName }' for { $customerName }?",
        "cancel-subscription-modal-label-ignore-terms": "\n .label = Effective immediately",
        "cancel-subscription-modal-helper-text-ignore-terms": "This will ignore the terms of the subscription.",
        "cancel-subscription-modal-button-delete": "Delete",


        // --- Not found ---
        "not-found-title": "Not Found",
        "not-found-explanation": "The page you are looking for does not exist.",
        "not-found-path-label": "Path:",
        "not-found-go-home-button": "Go home",


        // --- Access denied ---
        "access-denied-title": "Access Denied",
        "access-denied-explanation": "Your user profile does not have access to this page.",
        "access-denied-required-usertype-label": "Required user type:",
        "access-denied-actual-usertype-label": "Your user type:",
        "access-denied-path-label": "Path:",
        "access-denied-go-home-button": "Go home",
        "access-denied-logout-button": "Logout",

        "access-denied-usertype-support": "{ -user-type-support }",
        "access-denied-usertype-supplier": "{ -user-type-supplier }",
        "access-denied-usertype-merchant": "{ -user-type-merchant }",
        "access-denied-usertype-company": "{ -user-type-company }",
        "access-denied-usertype-office-manager": "{ -user-type-office-manager }",
        "access-denied-usertype-unknown": "Unknown",


        "login-email-label": "Sign in",
        "login-password-label": "Enter your password",
        "login-email-field-label": "\n .label = Email",
        "test": "Test",
        "bottom-menu-item-home": "\n .label = Home",
        "bottom-menu-item-profile": "\n .label = Profile",

        "confirm-email-button": "Confirm\n .loadingLabel = Confirming...",
        "confirm-email-description": "The following user accounts are all registered with the email address <email>{ $email }</email> and will be able to switch account. Make sure they all belong to you:",
        "confirm-email-title": "Confirm account access",
        "confirm-email-success-message": "You can now switch between your user accounts",
        "confirm-email-error-message": "We could not confirm your email",
        "confirm-email-missing-userid-or-otp": "Missing user id or otp",

        "purchases-payment-method-free": "Free",
        "purchases-payment-method-credit-card": "Credit card",
        "purchases-payment-method-one-click-payment": "Credit card",
        "purchases-payment-method-mobile-pay": "MobilePay",
        "purchases-payment-method-payroll-deduction": "Payroll deduction",
        "purchases-payment-method-lunch-registration": "Lunch registration",
        "purchases-payment-method-gopay-wallet": "GoPay Wallet",
        "purchases-payment-method-invoice": "Invoice",
        "purchases-payment-method-cash": "Cash",
        "purchases-payment-method-gopay-account": "GoPay Wallet",
        "purchases-payment-method-refund": "Refund",
        "purchases-payment-method-subscribe-payment-card": "Subscribe payment card",
        "purchases-payment-method-id-card": "ID card",

        // --- Error handling ---
        "api-call-error-title-unknown-error": "Unknown Error",
        "api-call-error-title-network-error": "Network Error",
        "api-call-error-title-bad-request": "Bad Request",
        "api-call-error-title-unauthorized": "Invalid login",
        "api-call-error-title-forbidden": "Access Denied",
        "api-call-error-title-not-found": "Not Found",
        "api-call-error-title-conflict": "Conflict",
        "api-call-error-title-too-many-requests": "Too Many Requests",
        "api-call-error-title-internal-server-error": "Internal Server Error",
        "api-call-error-title-service-unavailable": "Service Unavailable",
        "api-call-error-title-request-failed": "Request Failed",
        "api-call-error-unknown-error": "Unknown error",
        "api-call-error-no-internet-connection": "No Internet connection",
        "api-call-error-could-not-reach-server": "Could not reach server",
        "api-call-error-protocol-error": "Server error: { $responseCode } { $responseStatus }",
        "api-call-error-api-returned-error": "Unexpected server error",
        "api-call-error-response-not-json": "Unexpected response from server",
        "api-call-error-retry-button": "Retry",


        // --- Receipts ---

        // Page
        "receipt-title": "Receipt",

        // Payment methods
        "receipt-payment-method-free": "Free",
        "receipt-payment-method-credit-card": "Credit card",
        "receipt-payment-method-one-click-payment": "Credit card",
        "receipt-payment-method-mobile-pay": "MobilePay",
        "receipt-payment-method-payroll-deduction": "Payroll deduction",
        "receipt-payment-method-lunch-registration": "Lunch registration",
        "receipt-payment-method-gopay-account": "GoPay Wallet",
        "receipt-payment-method-gopay-wallet": "GoPay Wallet",
        "receipt-payment-method-invoice": "Invoice",
        "receipt-payment-method-cash": "Cash",
        "receipt-payment-method-id-card": "ID card",

        // Purchase section
        "receipt-purchase-details-section": "\n .heading = Purchase Details",
        "receipt-purchase-payment-status-paid": "PAID",
        "receipt-purchase-payment-status-unpaid": "UNPAID",
        "receipt-purchase-payment-status-invoiced": "INVOICED",
        "receipt-purchase-payment-status-refunded": "REFUNDED",
        "receipt-purchase-payment-status-cancelled": "REFUNDED",
        "receipt-purchase-payment-status-failed": "FAILED",
        "receipt-purchase-address-item": "\n .label = Location:",
        "receipt-purchase-seller-vat-number": "VAT\u00A0No:\u00A0{ $vatNumber }",
        "receipt-purchase-customer-item": "\n .label = Customer:",
        "receipt-purchase-employee-id-item": "\n .label = Employee id:",
        "receipt-purchase-company-item": "\n .label = Company:",
        "receipt-purchase-time-item": "\n .label = Purchase time:",
        "receipt-purchase-payment-method-item": "\n .label = Payment method:",
        "receipt-purchase-order-id-item": "\n .label = Order id:",
        "receipt-purchase-shop-channel-item": "\n .label = Channel:",
        "receipt-purchase-receipt-error": "Failed to load order with id #{ $orderId }",
        "receipt-purchase-receipt-error-description": "This order could not be processed due to missing or invalid data.",

        // Delivery section
        "receipt-delivery-details-section": "\n .heading = Delivery",
        "receipt-delivery-order-type-item": "\n .label = Order type:",
        "receipt-order-type-catering": "Meeting services",
        "receipt-order-type-lunch": "Lunch",
        "receipt-order-type-takeaway": "Takeaway",
        "receipt-order-type-take-away": "Takeaway",
        "receipt-order-type-refill-account": "Wallet Top up",
        "receipt-order-type-auto-refill-account": "Automatic top up subscription",
        "receipt-order-type-lunch-subscription": "Subscription",
        "receipt-order-type-subscribe-payment-card": "Payment card subscription",
        "receipt-order-type-meeting": "Meeting",
        "receipt-order-type-refund": "Refund",
        "receipt-delivery-type-item": "\n .label = Delivery type:",
        "receipt-delivery-type-pick-up": "Pick up",
        "receipt-delivery-type-take-away": "Takeaway",
        "receipt-delivery-location-item": "\n .label = Delivery location:",
        "receipt-delivery-pickup-location-item": "\n .label = Pickup location:",
        "receipt-delivery-time-item": "\n .label = Delivery time:",
        "receipt-delivery-pickup-time-item": "\n .label = Pickup time:",
        "receipt-delivery-comment-item": "\n .label = Comment:",

        // Order details section
        "receipt-order-details-buyerparty-private": "Private purchase",
        "receipt-order-details-buyerparty-company": "Company purchase",
        "receipt-order-details-payment-method-item": "\n .label = Payment method:",
        "receipt-order-details-total": "\n .label = Total:",
        "receipt-order-details-vat-total": "\n .label = VAT amounts to (25%):",

        // Subscription details section
        "receipt-subscription-details-section": "\n .heading = Subscription",
        "receipt-subscription-details-subscription-id": "\n .label = Subscription id:",
        "receipt-subscription-details-subscription-name": "\n .label = Subscription name:",
        "receipt-subscription-details-subscription-valid-from": "\n .label = Valid from:",
        "receipt-subscription-details-subscription-valid-to": "\n .label = Valid to:",
        "receipt-subscription-details-subscription-price": "\n .label = Subscription price:",

        // Actions section
        "receipt-actions-forward-receipt-button": "Send Receipt",
        "receipt-actions-cancel-order-button": "Refund Order",
        "receipt-actions-confirm-cancel-dialog": "\n .description = You are about to refund this order. Are you sure?\n .confirmLabel = Yes\n .cancelLabel = No\n .loadingDescription = Refunding order...",
        "receipt-actions-cancel-disabled-dialog": "\n .title = Refunding not implemented\n .message = This function is not yet ready. It will come later.\n .buttonLabel = Understood",
        "receipt-actions-cancel-unavailable-dialog": "\n .buttonLabel = Understood",

        "receipt-order-label": "Receipt #{ $orderId }, { $orderDate }",

        // Forward receipt
        "receipt-forward-receipt-dialog": "\n .title = { $receipts -> \n *[one] Send Receipt \n [other] Send Receipts \n } \n .cancelButtonLabel = Cancel\n .submitButtonLabel = Send\n .submitButtonLoadingLabel = Sending...",
        "receipt-forward-receipt-email-field": "\n .label = Email Address",
        "receipt-forward-receipt-email-field-is-required": "Email address is required",
        "receipt-forward-receipt-email-field-must-be-valid": "Invalid email address",


        // --- Login domain ---

        // login auth flow hook
        "auth-flow-authentication-result-server-error": "Client expected authentication complete but server said: { $action }.",
        "auth-flow-authentication-unexpected-server-error":  `Unexpected authentication action { $action } in API response`,

        // Create password page
        "create-password-required": "This is a required field",
        "create-password-password-invalid-for-policy": "Password does not follow the password policy",
        "create-password-new-required": "This is a required field",
        "create-password-matching": "Passwords do not match",
        "create-password-title": "New Password",
        "create-password-new-password-field": "\n .label = New Password",
        "create-password-submit-button": "Reset Password",
        "create-password-confirm-password-field": "\n .label = Confirm Password",
        "create-password-missing-token-title": "Error",
        "create-password-missing-token-description": "Not provided required token to create password.",


        // Forgot password page
        "forgot-password-username-required": "Username is required",
        "forgot-password-username-title": "Forgotten Password",
        "forgot-password-username-invalid": "Username is not valid",
        "forgot-password-button-label": "Next",
        "forgot-password-enter-username-field": "\n .label = Enter your email or username:",

        // SignInWithActivationCode page
        "sign-in-with-activation-code-min-length": "Activation code should be of minimum 6 characters length",
        "sign-in-with-activation-code-required": "Activation code is required",
        "sign-in-with-activation-code-title": "Enter your activation code",
        "sign-in-with-activation-code-field-label": "\n .label = Activation code",
        "sign-in-with-activation-code-submit-button": "Next",

        // SignInWithPassword page
        "sign-in-with-password-required": "Password is required",
        "sign-in-with-password-title": "Enter your password",
        "sign-in-with-password-field-label": "\n .label = Password",
        "sign-in-with-password-submit-button": "Sign in",
        "sign-in-with-password-reset-password-link": "Forgot password",

        // SignInWithUsername page
        "sign-in-with-username-min-length": "Username should be of minimum 3 characters length",
        "sign-in-with-username-required": "Username is required",
        "sign-in-with-username-title": "Welcome",
        "sign-in-with-username-subtitle": " Welcome to Facilitynet",
        "sign-in-with-username-field-label": "\n .label = Username\n .placeholder = Enter your username",
        "sign-in-with-username-remember-me": "Remember me",
        "sign-in-with-username-submit-button": "Next",
        "sign-in-with-username-reset-password-link": "Forgot password?",

        // StartPageLayout
        "start-page-layout-title": "Your portal to meeting planning and canteen services",
        "start-page-layout-sub-title-1": "Accept payments with the POS and mobile phone",
        "start-page-layout-sub-title-2": "Get insight into sales figures with Facilitynet Manager",
        "start-page-layout-sub-title-3": "Better communication between merchant and customers",
        "start-page-layout-login-button-label": "Login",

        // Login Layout
        "login-layout-card-title": "Facilitynet Manager",
        "login-layout-card-subtitle": "Canteen management made easy",
        "auto-login-title":"Signing you in...",
        "auto-login-description":"Please wait while we authenticate you.",
        "auto-login-error-title":" otp token not found",
        "auto-login-error-description":"  You have received an invalid link. Please contact support.",

        // Invitation
        "invitation-title": "Create your passwords to Facilitynet",
        "invitation-username-rules": "The username must be at least 3 characters long.",
        "invitation-password-rules": "The password must be at least 8 characters long and contain a lowercase letter, an uppercase letter and a number.",
        "invitation-usertype-support": "{ -user-type-support }",
        "invitation-usertype-supplier": "{ -user-type-supplier }",
        "invitation-usertype-merchant": "{ -user-type-merchant }",
        "invitation-usertype-company": "{ -user-type-company }",
        "invitation-usertype-office-manager": "{ -user-type-office-manager }",
        "invitation-usertype-unknown": "Unknown user type",
        "invitation-field-username": "\n .label = Username",
        "invitation-field-password": "\n .label = Password",
        "invitation-field-repeat-password": "\n .label = Repeat password",
        "invitation-submit-button": "Activate account\n .loadingLabel = Activating...",
        "invitation-field-username-required": "Username is required",
        "invitation-field-username-min-chars": "Username must be at least { $minChars } characters",
        "invitation-field-password-required": "Password is required",
        "invitation-field-password-invalid-for-policy": "Password does not follow the password policy",
        "invitation-field-password-min-chars": "Password must be at least { $minChars } characters",
        "invitation-field-password-contain-lowercase": "Password must contain lowercase character",
        "invitation-field-password-contain-uppercase": "Password must contain uppercase character",
        "invitation-field-password-contain-number": "Password must contain number",
        "invitation-field-repeatPassword-required": "Field is required",
        "invitation-field-repeatPassword-match-password": "Passwords do not match",

        // Confirm account change
        "confirm-account-change-confirming-email-message": "Confirming email address...",
        "confirm-account-change-login-button": "Sign in",
        "confirm-account-change-failure-message": "Email address could not be confirmed",

        // Id Card Signup
        "id-card-signup-title": "Complete registration",
        "id-card-signup-description": "Please complete the registration process. Once you have registered your ID card, you can use it to purchase food in the canteen by simply scanning it at the POS screen.",
        "id-card-signup-subscription": "Select subscription",
        "id-card-signup-next-button": "Next",
        "id-card-signup-back-button": "Back",
        "id-card-signup-field-company": "\n .label = Your company:\n .placeholder = Select the company you work for",
        "id-card-signup-field-user-group": "\n .label = Your user group:\n .placeholder = Select user group",
        "id-card-signup-field-name": "\n .label = Your name:\n .placeholder = Enter your full name",
        "id-card-signup-field-mobile-number": "\n .label = Your phone:\n .placeholder = Enter your mobile number (optional)",
        "id-card-signup-field-mobile-number-invalid": "Invalid mobile number",
        "id-card-signup-field-name-max-length": "Name cannot exceed 50 characters",
        "id-card-signup-companies-error": "Failed to load companies. Please try again.",
        "id-card-activation-generic-error": "Failed to load companies. Please try again.",
        "id-card-signup-no-subscriptions": "An error occurred while activating your card. Please try again.",
        "id-card-signup-using-company": "Your company: ",
        "id-card-signup-using-user-group": "Your user group: ",
        "id-card-signup-using-user-name": "User name: ",
        "id-card-signup-complete": "Congratulation",
        "id-card-signup-complete-description": "Your card has now been subscribed and you can start using it.",
        "id-card-signup-complete-learn-more": "Learn more:",
        "id-card-signup-complete-learn-more-link": "How to I use Facilitynet payment solution?",

        // Activate account
        "activation-account-username-title": "Activate account",
        "activation-account-username-subtitle": "In order to use Facilitynet, please activate your account below",
        "activation-account-username-button": "Activate",
        "activation-account-username-field": "\n .label = Enter your e-mail-address:",
        "activation-account-username-email-required": "Email address is required",
        "activation-account-username-email-invalid": "Please enter a valid email address",
        "activation-account-password-title": "Create password",
        "activation-account-password-new-password-field": "\n .label = Enter password",
        "activation-account-password-button": "Create password",

        // select company
        "authenticate-select-company-header-reason-multiple-companies-for-domain": "Choose company",
        "authenticate-select-company-header-reason-multiple-accounts-for-username": "Select user account",
        "authenticate-select-company-reason-message-multiple-companies-for-domain": "We were unable to determine your company automatically since your email domain <duplicateValue>{ $duplicateValue }</duplicateValue> occurs multiple times in our system.",
        "authenticate-select-company-reason-message-multiple-accounts-for-username": "We found multiple accounts in our system for the email address <duplicateValue>{ $duplicateValue }</duplicateValue>.",
        "authenticate-select-company-action-message-multiple-companies-for-domain": "Please choose the location (company) that you wish to create your account under:",
        "authenticate-select-company-action-message-multiple-accounts-for-username": "Please select the user account you want to log in with.",
        "authenticate-select-company-show-list-button": "Show companies",
        "authenticate-select-company-submit-button": "{ -authenticate-submit-button }\n .loadingLabel = Saving...",
        "authenticate-select-company-form-error-message": "Please select a company",
        "authenticate-select-company-company-group-unknown-uid": "Unknown Company UID",
        "authenticate-select-company-company-group-unknown-name": "Unknown Name",
        "authenticate-select-company-company-group-unknown-address": "Unknown Address",
        "authenticate-select-company-no-companies-available": "No companies available",
        "authenticate-select-company-account-role-support": "{ -user-type-support }",
        "authenticate-select-company-account-role-supplier": "{ -user-type-supplier }",
        "authenticate-select-company-account-role-merchant": "{ -user-type-merchant }",
        "authenticate-select-company-account-role-company": "{ -user-type-company }",
        "authenticate-select-company-account-role-office-manager": "{ -user-type-office-manager }",
        "authenticate-select-company-account-role-user": "{ -user-type-user }",
        "authenticate-select-company-account-role-service-center": "{ -user-type-service-center }",

        // Public > Self Sign Up
        "self-sign-up-title": "Sign Up",
        "self-sign-up-description": "Please complete the registration process. Once you have finished signing up, you can use account",
        "self-sign-up-field-company": "\n .label = Your company:\n .placeholder = Select the company you work for",
        "self-sign-up-field-user-group": "\n .label = Your user group:\n .placeholder = Select user group",
        "self-sign-up-field-department": "\n .label = Department:\n .placeholder = Select your department",
        "self-sign-up-department-missing-notice": "Please contact your company administrator if your department is missing in the list.",
        "self-sign-up-field-name": "\n .label = Name:\n .placeholder = Enter your full name",
        "self-sign-up-field-email": "\n .label = Email:\n .placeholder = Enter your email",
        "self-sign-up-field-mobile-number": "\n .label = Phone:\n .placeholder = Enter your mobile number (optional)",
        "self-sign-up-complete-button": "Sign Up",
        "self-sign-up-field-email-invalid": "Invalid email address",
        "self-sign-up-email-domain-hint": "Please use an email from an approved domain: { $domains }",
        "self-sign-up-field-email-domain-not-allowed": "Email must use an approved domain: { $domains }",
        "self-sign-up-congratulation-title": "Congratulation",
        "self-sign-up-congratulation-message": "We have sent an activation link to your email address.",
        "self-sign-up-error-message": "Something went wrong. Please try again.",
        "self-sign-up-confirm-dialog": "\n .title = Confirm details\n .message = Are you sure you want to create your account with the provided information?\n .buttonLabelSubmit = Confirm\n .buttonLabelCancel = Cancel",
        "self-sign-up-confirm-company": "\n .label = Company:",
        "self-sign-up-confirm-user-group": "\n .label = User group:",
        "self-sign-up-confirm-department": "\n .label = Department:",
        "self-sign-up-confirm-name": "\n .label = Name:",
        "self-sign-up-confirm-email": "\n .label = Email:",
        "self-sign-up-confirm-mobile-number": "\n .label = Phone:",

        // Booking > Confirm Booking
        'confirm-booking-complete': "Congratulation",
        'confirm-booking-failed': "Failed",
        'confirm-booking-loading': "Loading...",

        // ExportButton
        "export-button-export-text": "\n .title = Export\n .aria-label = Export",
        "export-button-export-all": "Export all",
        "export-button-export-all-with-filter": "Export all with filter",
        "export-button-export-selected": "Export selected",
        "export-button-export-selected-rows": "Export Selected rows",
        "export-button-export-as-csv-title": "\n .title = Save as CSV",
        "export-button-export-as-pdf-title": "\n .title = Save as PDF",
        "export-button-print": "Print",
        "export-button-remove-print-title": "\n .title = Remove from printer queue",

        // Export
        "export-period": "Period",

        // print
        "print-queued": "Your request is queued",


        // --- ContextDisplay ---
        "context-display-org-unit-supplier": "\n .label = Supplier:",
        "context-display-org-unit-merchant": "\n .label = Merchant:",
        "context-display-org-unit-tenant": "\n .label = Tenant:",
        "context-display-org-unit-company": "\n .label = Company:",
        "context-display-org-unit-user": "\n .label = User:",
        "context-display-org-unit-service-center": "\n .label = Service center:",


        // --- Environment dropdown ---
        "env-dropdown-menu-header": "Switch environment to:",
        "env-dropdown-title-admin-support":"Admin",
        "env-dropdown-title-reports-support":"Dashboard",
        "env-dropdown-title-admin-supplier":"Admin",
        "env-dropdown-title-reports-supplier":"Dashboard",
        "env-dropdown-title-admin-merchant":"Admin",
        "env-dropdown-title-reports-merchant":"Production",
        "env-dropdown-title-accounting-merchant":"Accounting",
        "env-dropdown-title-admin-company":"Admin",
        "env-dropdown-title-reports-company":"Dashboard",
        "env-dropdown-title-admin-office-manager":"Admin",
        "env-dropdown-title-reports-office-manager":"Dashboard",
        "env-dropdown-title-reports-service-center":"Service center reports",
        "env-dropdown-title-admin-service-center":"Admin",
        "env-dropdown-subtitle-admin-support":"Manage entities and users.",
        "env-dropdown-subtitle-reports-support":"View system reports.",
        "env-dropdown-subtitle-admin-supplier":"Manage merchants and global settings.",
        "env-dropdown-subtitle-reports-supplier":"View aggregate reports across your merchants.",
        "env-dropdown-subtitle-admin-merchant":"Manage products, shops, and customer communication.",
        "env-dropdown-subtitle-reports-merchant":"Get an operational overview and view production figures.",
        "env-dropdown-subtitle-admin-company":"Manage organizational data, users and administrators.",
        "env-dropdown-subtitle-reports-company":"View accounting figures.",
        "env-dropdown-subtitle-admin-office-manager":"Manage users and administrators.",
        "env-dropdown-subtitle-reports-office-manager":"View accounting figures.",
        "env-dropdown-subtitle-reports-service-center":"Service center reports",
        "env-dropdown-subtitle-admin-service-center":"Service center admin",
        "env-dropdown-subtitle-accounting-merchant":"View accounting reports.",


        // --- API components ---
        "api-query-table-fetch-error-message": "Error loading data",
        "api-query-autocomplete": "\n .loadingText = Loading data...",
        "api-query-autocomplete-fetch-error-message": "Error loading data. <retryLink>Retry</retryLink>",

        // Top Bar
        "help-tooltip-text": "\n .title = Help",
        "notifications-tooltip-text": "\n .title = View messages",
        "new-order-tooltip-text": "\n .title = Create new order",
        "qa-env-warning-part-one": "You are in QA environment. This is not intended for customers. Please use",
        "qa-env-warning-part-two": "instead.",

        // Top Bar > Help
        "help-dialog-search-title": "Hello, how can we help you?",
        "help-dialog-search":"\n .placeholder = Search for articles...",
        "help-dialog-support": "\n .title = Support",
        "help-dialog-email-support": "\n .title = Email support \n .description = If you still need help, you can email us here.",
        "help-dialog-chat-support": "\n .title = Chat support \n .description = For quick questions, you can chat with our customer support team.",
        "help-dialog-troubleshooting": "\n .title = Troubleshooting",
        "help-dialog-troubleshooting-pos-screen": "\n .title = POS screen \n .description = Get help for your POS screen, receipt printer and credit card terminal.",
        "help-dialog-troubleshooting-check-in-screen": "\n .title = Check in screen \n .description = Get help for your check in screen and receipt printer.",
        "help-breadcrumb": "Help",
        "help-dialog-troubleshooting-breadcrumb": "Troubleshooting",
        "help-dialog-troubleshooting-printer-not-working": "\n .title = Printer not working",
        "help-dialog-troubleshooting-credit-card-terminal-not-working": "\n .title = Credit card terminal not working",
        "help-dialog-troubleshooting-pos-screen-not-working": "\n .title = POS screen not working",
        "help-dialog-troubleshooting-check-in-screen-not-working": "\n .title = Check-in screen not working",
        "help-dialog-troubleshooting-start-up-backup-terminal": "\n .title = Start up backup terminal",
        "help-dialog-training": "\n .title = Training",
        "help-dialog-training-education-center": "\n .title = Education Center \n .description = In the Education Center you can view Get Started guides and other training material.",
        "help-dialog-training-guide-button": "View Guide",
        "consent-dialog": "\n .title = Allow Intercom \n .message = We make use of Intercom for our chat support. If you consent, we will share the data below with Intercom. \n .skipLabel = Not now \n .consentLabel = Allow",
        "consent-dialog-personal-information": "Personal Information",
        "consent-dialog-pii-category-contact-info": "Contact Information",
        "consent-dialog-pii-category-identifiers": "Identifiers",
        "consent-dialog-pii-category-purchases": "Purchases",
        "consent-dialog-pii-category-user-content": "User Content",
        "consent-dialog-privacy-policy": "Privacy",
        "consent-dialog-view-company-privacy-policy": "View company privacy policy",
        "consent-dialog-pii-item-name": "Name",
        "consent-dialog-pii-item-email-address": "E-mail",
        "consent-dialog-pii-item-phone-number": "Phone Number",
        "consent-dialog-pii-item-user-id": "User ID",
        "consent-dialog-pii-item-device-id": "Device ID",
        "consent-dialog-pii-item-customer-support": "Customer Service",
        "consent-dialog-pii-item-purchase-history": "Purchase History",
        "intercom-error-dialog": "\n .title = Chat Failed\n .message = Something went wrong when loading the chat. You can send an email to support instead.\n .buttonLabel = Understood",
        "intercom-loading-dialog": "\n .description = Chat is loading...",
        "intercom-unavailable-snackbar": "Chat support is currently unavailable. Please email us at support@facilitynet.dk instead.",

        //ControlKitchen page
        "control-kitchen-checked-in-yes-chip": "Yes",
        "control-kitchen-checked-in-no-chip": "No",
        "control-kitchen-column-check-in-time": "Check-in time",
        "control-kitchen-column-id": "User id",
        "control-kitchen-column-name": "Name",
        "control-kitchen-column-items": "Items",
        "control-kitchen-column-order-details": "Order",
        "control-kitchen-checked-in": "Checked in",
        "control-kitchen-checked-in-sub-title": "Todays control code:",
        "control-kitchen-last-updated": "Last updated: {$lastUpdated}",
        "control-kitchen-refresh": "Refresh page",
        "control-kitchen-receipt": "Receipt",
        "control-kitchen-date-label": "Purchase date",
        "control-kitchen-date-delivery-label": "Delivery",
        "control-kitchen-datetime-from-label": "From",
        "control-kitchen-datetime-to-label": "To",
        "control-kitchen-period-label": "Period",
        "control-kitchen-check-in-type": "Type",
        "control-kitchen-checked-in-filter-all": "All",
        "control-kitchen-checked-in-filter-checked-in": "Checked in",
        "control-kitchen-checked-in-filter-not-checked-in": "Not checked in",
        "control-kitchen-control-code-not-ready": "Not ready",

        // News folder
        "news-published": "Published: {$date}",
        "news-implemented": "Released: {$date}",
        "news-created": "Created: {$date}",
        "news-updated": "Updated: {$date}",
        "news-gopay": "Facilitynet news ",
        "news-roadmap": "Roadmap",
        "news-new-features": "New features",
        "news-new-load-error": "Error loading roadmap features",
        "news-start-date": "Start Date",
        "news-end-date": "End Date",
        "news-type": "Type",
        "news-bug-fix": "Bug fix",
        "news-new-feature": "New feature",
        "news-upcoming": "Upcoming",
        "news-all": "All",
        "news-roadmap-type-filter-bugfix": "Bug fix",
        "news-roadmap-type-filter-feature": "New feature",
        "news-roadmap-type-filter-upcoming": "Upcoming",
        "news-implemented-feature": "Implemented feature",
        "news-upcoming-feature": "Upcoming feature",
        "news-current-news": "Current news",
        "news-archive-news": "Archive",
        "news-create-new-button": "Create new",
        "news-draft-type": "Draft",
        "news-published-type": "Published",
        "news-schedule-type": "Scheduled",
        "news-expired-type": "Expired",
        "news-edit": "Edit",
        "news-delete": "Delete",
        "news-default-error-message": "Something went wrong",
        "news-archive-title": "Title",
        "news-archive-expiration-date": "Expiration Date",
        "news-archive-active-status": "Status",
        "merchant-news-header": "\n .title = News",
        "news-no-news-title": "No news",
        "news-no-roadmap-title": "No roadmaps",
        "news-no-news-body": "Create your first news ",
        "news-no-news-here-link": "here",
        "news-gopay-read-more": "Read more",
        "news-table-delete-success-message": "Article deleted",
        "create-news-header": "\n .title = Create news",
        "edit-news-header": "\n .title = Edit news",
        "nav-item-create-news-header": "Create news",
        "nav-item-edit-news-header": "Edit news",
        "create-news-save-button": "Create",
        "edit-news-save-button": "Save",


        // Office folder
        "office-period-total": "Total for period: {$periodTotal}",
        "office-transation-period-total": "Total transations for period: {$transactionPeriodTotal}",
        "office-purchase-time": "Time",
        "office-purchase-name": "Name",
        "office-purchase-payment-details": "Payment method",
        "office-purchase-payment-channel": "Channel",
        "office-purchase-amount": "Amount",
        "office-purchase-receipt": "Receipt",
        "upcoming-orders-purchases-table-order-type": "Order type",
        "upcoming-orders-purchases-table-delivery-status": "Delivery status",
        "upcoming-orders-purchases-table-order-type-pos": "POS",
        "upcoming-orders-purchases-table-order-type-takeaway": "Takeaway",
        "order-action-menu-refund": "Refund",
        "order-action-menu-print-label": "Print label",
        "standard-refresh-button-last-updated-label": "Updated { $relativeTime }",
        "standard-refresh-button-last-updated-just-now-label": "Updated just now",
        "standard-refresh-button-tooltip-hint": "Click to refresh",
        "standard-refresh-button-error-tooltip": "Update failed · click to retry",
        "standard-refresh-button-aria-label": "Refresh",
        "standard-new-items-pill-label": "{ $count ->\n [one] { $count } new order\n *[other] { $count } new orders\n}",
        "standard-new-items-pill-show-button": "Show",

        "office-meeting-service-title": "Meeting service",
        "office-meeting-service-header": "\n .title = Meeting service",
        "office-meeting-service-table-booked-start-date": "Booked start date",
        "office-meeting-service-table-booked-end-date": "Booked end date",
        "office-meeting-service-table-merchant": "Merchant",
        "office-meeting-service-table-order-id-column": "Order ID",
        "office-meeting-service-table-booked-date-column": "Booked date",
        "office-meeting-service-table-delivery-time-column": "Delivery time",
        "office-meeting-service-table-creator-column": "Creator",
        "office-meeting-service-table-amount-column": "Amount (DKK)",
        "office-meeting-service-table-show-receipt": "Show receipt",
        "office-meeting-service-table-floating-action-bar-receipts": "\n .title = Receipts",
        "office-meeting-service-table-floating-action-bar-export": "\n .title = Export",


        // --- Profile page ---
        "profile-user-account-id": "ID:",
        "profile-administrator-for": "Administrator for",
        "profile-hosted-by": "Hosted by",
        "profile-hosted-by-office-hotel": "Office Hotel",
        "profile-actions": "Shortcuts",
        "profile-settings-card": "Settings",
        "profile-password-card": "Password",
        "profile-actions-change-password": "Change password",
        "profile-actions-edit-profile": "Edit profile",
        "profile-actions-delete-account": "Delete account",
        "profile-security": "Security",
        "profile-security-manage-admins": "Manage admins:",
        "profile-security-manage-admins-yes": "Yes",
        "profile-security-manage-admins-no": "No",
        "profile-security-ip-address-allowlist": "IP address allowlist:",
        "profile-roles": "Your roles",
        "profile-user-info": "User account",
        "profile-user-type": "User Type",
        "profile-username": "Username:",
        "profile-email": "Email:",
        "profile-phone-number": "Phone number:",
        "profile-mobil-number": "Mobile number:",
        "profile-name": "Name:",
        "profile-page-header": "\n .title = User account",
        "profile-nav-item-home": "Home",
        "profile-user-type-info-mode-supplier": "As a supplier administrator, you can access and manage merchants and administrators on behalf of your company. For each merchant, you can do everything a merchant administrator can do. Additionally you can manage shared settings and view cross-merchant reports.",
        "profile-user-type-info-mode-merchant": "As a merchant administrator, you can manage shops and products under your merchant. You also have access to detailed accounting reports and production views, where you can manage and fulfill customer orders.",
        "profile-user-type-info-mode-company": "As a company administrator, you can manage users and integrations for your company. You can also view accounting reports for orders made by your company employees.",
        "profile-user-type-info-mode-office-manager": "As an office manager, you can manage users and integrations for your tenant. You can also view accounting reports for orders made by your company employees.",
        "profile-user-type-info-mode-support": "As a supporter, you can manage users, devices and entities for the whole system. You can also lookup necessary information about orders, users and entities for handling support tickets.",
        "profile-user-type-info-mode-user": "As a user you can make orders in the system and view your previous orders.",
        "profile-roles-mode-agreement-owner": "Agreement owner",
        "profile-roles-mode-bookkeeper": "Bookkeeper",
        "profile-roles-mode-dpo": "DPO",
        "profile-roles-mode-it-administrator": "IT administrator",
        "profile-roles-mode-news-subscriber": "News subscriber",
        "profile-roles-mode-system-operation-subscriber": "System operation subscriber",
        "profile-roles-read-more": "Read about administrator roles",
        "profile-roles-no-roles": "You have no roles",
        "profile-tab-profile": "General",
        "profile-tab-gdpr": "GDPR",
        "profile-gdpr-info-box": "\n .description = Here you can download a copy of your own personal data we have registered in Facilitynet.",
        "profile-gdpr-export-button": "Export my data",
        "profile-gdpr-correction-info-box": "\n .description = Here you can request correction of your personal data.",
        "profile-gdpr-correction-button": "Request correction of my data",

        // --- Profile page > Change password ---
        "profile-change-password-page-header": "\n .title = Change password",
        "profile-change-password": "Change password",
        "profile-change-password-profile": "Profile",
        "profile-change-password-profile-currentPassword": "\n .label = Current password",
        "profile-change-password-profile-newPassword": "\n .label = New password",
        "profile-change-password-profile-confirmPassword": "\n .label = Confirm password",
        "profile-change-password-profile-match-password": "Passwords do not match",
        "profile-change-password-password-policy": "\n .title = Password policy",
        "profile-change-password-default-policy": "Facilitynet default policy",
        "profile-change-password-info": "To define or change the password policy for your company, please contact support.",
        "profile-change-password-submit-button": "Update password",

        // --- Change User Account > Dialog ---
        "change-user-account-dialog-title": "Change user account",
        "change-user-account-dialog-pending-state-email-has-been-sent": "An email has been sent. Please check your inbox.",
        "change-user-account-dialog-pending-state-pending-approval":
            "Pending approval...\n .loadingLabel = Pending approval...",
        "change-user-account-dialog-confirm-email-subtitle": "Before you can switch between user accounts, you must first confirm that you own the email account <element>{ $email }</element>.",
        "change-user-account-dialog-click-below-subtitle": "Click on the button below to send me a confirmation link:",
        "change-user-account-dialog-send-confirmation-button": "Send confirmation link",
        "change-user-account-dialog-empty-content-subtitle": "No other accounts were found with the email address <email>{ $email }</email>.",
        "change-user-account-dialog-users-list-available-accounts-subtitle": "You have { $totalUserAccounts } other user accounts with the e-mail: { $email }",
        "change-user-account-dialog-users-list-swift-to-another-account": "Switch to another account below:",
        "change-user-account-dialog-error-message": "We couldn't load your accounts. Switching accounts may not be available for this account type.",

        // User Types
        "profile-usertype-support": "{ -user-type-support }",
        "profile-usertype-supplier": "{ -user-type-supplier }",
        "profile-usertype-merchant": "{ -user-type-merchant }",
        "profile-usertype-company": "{ -user-type-company }",
        "profile-usertype-office-manager": "{ -user-type-office-manager }",
        "profile-usertype-user": "{ -user-type-user }",
        "profile-usertype-service-center": "{ -user-type-service-center }",


        // --- Settings page ---
        "settings-page-header": "\n .title = Settings",
        "settings-title": "Settings",
        "settings-nav-item-home": "Home",
        "settings-language-setting": "Language",
        "settings-social-media-label": "Social media",
        "settings-social-media-text": "Follow us on LinkedIn",
        "settings-notifications-label": "Notifications",
        "settings-sms-notifications": "Text (SMS) notifications",
        "settings-receipts-meeting-service": "Meeting service receipts",
        "settings-receipts-canteen": "Canteen receipts",


        // --- Admin home card ---
        "admin-home-card-show-all-button": "Show all",


        // Back Button
        "back-button-label": "Back",

        //AvatarMenu
        "avatar-menu-tooltip": "Open settings",


        // ArticleSettingsPanel
        "article-settings-panel-settings-title": "\n .title = Visibility",
        "article-settings-panel-published": "\n .label = Published",
        "article-settings-panel-schedule-for": "\n .label = Publish date",
        "article-settings-panel-expires": "\n .label = Expiration date",



        // ImageUploader
        "image-uploader-button-label": "Upload image",
        "image-uploader-drag-and-drop": "Drag and Drop or Browse",
        "image-uploader-max-file-size-exceeded": "File size exceeds { $maxFileSize } limit.",
        "image-previewer-button-label": "Upload new image",
        "image-previewer-button-delete": "Delete",

        // CreateOrEditMerchantArticle
        "create-or-edit-merchant-article-mode-normal-article": "Normal article",
        "create-or-edit-merchant-article-mode-external-article": "External article",
        "create-or-edit-merchant-article-mode-product-news": "Product news",
        "create-or-edit-merchant-article-title": "\n .label = Title",
        "create-or-edit-merchant-article-body": `\n .placeholder = Description\n .helperText = Remaining characters: { $charsRemaining }`,
        "create-or-edit-merchant-article-body-too-long": `You have exceed the max amount of characters: { $charsLimit }`,
        "create-or-edit-merchant-article-product-id": "\n .label = Product id",
        "create-or-edit-merchant-article-info-label-draft": "\n .label = Article is a draft. It will not be visible to users until you publish it.",
        "create-or-edit-merchant-article-info-label-schedule": "\n .label = Article is a schedule for publication on: ",
        "create-or-edit-merchant-article-type": "\n .label = Article type",
        "create-or-edit-merchant-article-delete": "article",
        "news-create-image-field-label": "\n .label = Upload image",

        // CreateAndPublishSplitButton
        "create-and-publish-split-button-create-draft": "Draft",
        "create-and-publish-split-button-publish": "Publish",
        "create-and-publish-split-button-save": "Save",
        "create-and-publish-split-button-unpublish": "Unpublish",
        "create-and-publish-split-button-cancel-publication": "Cancel publication",
        "create-and-publish-split-button-republish": "Republish",


        "table-summary-box-total-period": "\n .title = Total this period",
        "table-summary-box-number-of-orders": "\n .title = Number of orders",
        "table-summary-box-number-of-subscriptions": "\n .title = Number of subscriptions",

        // --- Office manager ---

        // Navigation
        "tenant-nav-item-home": "Home",

        // - reporting
        "tenant-nav-item-accounting": "\n .title = Accounting",
        "tenant-nav-item-accounting-header": "Accounting",
        "tenant-nav-item-pos": "POS",
        "tenant-nav-item-meeting-service": "Meeting service",
        "tenant-nav-item-subscriptions": "Subscriptions",

        // - admin
        "tenant-nav-item-users": "Users",
        "tenant-nav-item-organization-page-header":"\n .title = Organization",
        "tenant-nav-item-organization-header":"Organization",
        "tenant-nav-item-administrators": "Administrators",

        // Reports

        // Home
        "tenant-reports-home-placeholder": "\n .title = Office manager dashboard coming soon\n .body = Your dashboard will show an overview of important key figures, so you always have a good overview of purchases.",

        // Purchases
        "tenant-purchases-header": "\n .title = POS",
        "tenant-subscriptions-header": "\n .title = Subscriptions",

        // Admin

        // Home page
        "office-manager-home-user-card-group": "\n .title = Users",
        "office-manager-home-user-admin-placeholder": "Coming soon. Here you will be able to manage your users and office managers.",
        "office-manager-home-user-card": "  \n .title = Users\n .description = Manage users for your tenant",
        "office-manager-home-admin-card": "  \n .title = Administrators\n .description = Manage administrators",
        "office-manager-home-card-show-all": "Show all",
        "office-manager-users-header": "\n .title = Users",
        "office-manager-users-tab-users": "Users",
        "office-manager-users-tab-admins": "Administrators",
        "office-manager-users-table-id-column": "User-ID",
        "office-manager-users-table-name-column": "Name",
        "office-manager-users-table-email-column": "Email",
        "office-manager-users-table-status-column": "Status",
        "office-manager-users-table-status-column-active": "Active",
        "office-manager-users-table-status-column-inactive": "In active",
        "office-manager-user-show-details": "Show details",
        "office-manager-user-edit": "Edit user",
        "office-manager-user-delete": "Delete user",
        "office-manager-user-delete-title": "user",
        "office-manager-users-create-user-button": "Create new",
        "office-manager-users-create-admin-button": "Create new",
        "office-manager-user-details-dialog-title": "User Details",
        "office-manager-settings-panel": "\n .title = Settings",
        "office-manager-settings-send-invitation": "Send email invitation",
        "office-manager-settings-disable-sync": "Disable synchronization",
        "office-manager-settings-disable-sync-text": "When disabled this user will be ignored by user synchronization jobs",

        // show user details dialog
        "user-details-user-id": "User id:",
        "user-details-employee-id": "Employee id:",
        "user-details-user-group": "User group:",
        "user-details-department": "Department:",
        "user-details-workgroups-title": "Workgroups",
        "user-details-name": "Name:",
        "user-details-role-type-news-subscriber" : "Subscriber",
        "user-details-role-type-system-operation-subscriber" : "System status subscriber",
        "user-details-email": "Email:",
        "user-details-mobile": "Mobile:",
        "user-details-phone": "Phone:",
        "user-details-language": "Language:",
        "user-details-role": "User roles:",
        "user-details-sync-jobs": "Disconnect sync jobs:",
        "user-details-sync-jobs-ignored": "YES",
        "user-details-sync-jobs-included": "NO",
        "user-details-security-title": "Security",
        "user-details-settings-title": "Settings",
        "user-details-security-settings-yes": "YES",
        "user-details-security-settings-no": "NO",
        "user-details-security-manage-admins": "Manage admins:",
        "user-details-security-ip-address": "IP address allowlist:",
        "user-details-history-title": "History",
        "user-details-history-created": "Created:",
        "user-details-history-edited": "Edited:",

        // Create or edit user page
        "office-manager-create-user-form": "Create",
        "office-manager-edit-user-form": "Save",
        "office-manager-create-user-form-title": "\n .title = Create user",
        "office-manager-edit-user-form-title": "\n .title = Edit user",
        "office-manager-create-user-home-breadcrumb": "Home",
        "office-manager-create-user-users-breadcrumb": "Account",
        "office-manager-create-user-create-breadcrumb": "Create user",
        "office-manager-create-user-edit-breadcrumb": "Edit user",
        "office-manager-create-user-missing-context-error":
            "Could not determine which account this user belongs to. Please reload the page and try again.",
        "office-manager-create-admin-missing-context-error":
            "Could not determine which account this administrator belongs to. Please reload the page and try again.",
        // Create/edit administrator pages (shared across all portals)
        "administrators-create-page-title": "\n .title = Create administrator",
        "administrators-create-page-save-button": "Create",
        "administrators-create-breadcrumb": "Create administrator",
        "administrators-edit-page-title": "\n .title = Edit administrator",
        "administrators-edit-page-save-button": "Save",
        "administrators-edit-breadcrumb": "Edit administrator",
        "office-manager-create-user-field-id": "\n .label = Employee ID",
        "office-manager-create-user-field-username": "\n .label = Username",
        "office-manager-create-user-field-name": "\n .label = Name",
        "office-manager-create-user-field-email": "\n .label = Email",
        "office-manager-create-user-field-mobile": "\n .label = Mobile",
        "office-manager-create-user-field-phone": "\n .label = Phone no.",
        "office-manager-create-user-field-active": "Active",
        "office-manager-settings-resend-invitation": "Resend invitation",
        "office-manager-security-panel": "\n .title = Security",
        "office-manager-security-manage-admins": "Can manage other admins",
        "office-manager-security-pin-field": "\n .label = PIN",
        "office-manager-security-pin-info": "\n .title = PIN is used by staff members to sign into POS screen.",
        "office-manager-security-pin-invalid": "PIN must be 4 digits",
        "office-manager-create-user-required-field-empty": "This field is required",
        "office-manager-create-user-invalid-email-address": "Invalid email address",
        "office-manager-create-user-invalid-phone-number": "Invalid phone number",

        // Create or edit room
        "resource-room-create-form-title": "\n .title = Create room",
        "resource-room-edit-form-title": "\n .title = Edit room",
        "resource-room-create-required-field-empty": "This field is required",
        "resource-room-create-user-home-breadcrumb": "Home",
        "resource-room-create-user-users-breadcrumb": "Users",
        "resource-room-create-room-breadcrumb":"Create room",
        "resource-room-edit-room-breadcrumb":"Edit room",

        // Purchases page
        "tenant-pos-title": "POS",
        "tenant-purchases-tab-orders":"\n .title = Orders",
        "tenant-purchases-tab-subscriptions-details":"Details",
        "tenant-purchases-tab-subscriptions-cancel": "Cancel",

        //Admin roles field
        "tenant-admin-roles-field-label": "Assign roles",
        "tenant-admin-role-agreement-owner": "System owner",
        "tenant-admin-role-dpo": "GDPR responsible",
        "tenant-admin-role-it-administrator": "IT administrator",
        "tenant-admin-role-bookkeeper": "Bookkeeper",
        "tenant-admin-role-news-subscriber": "News subscriber",
        "tenant-admin-role-system-operation-subscriber": "System operation subscriber",


        // Survey Page
        "survey-header": "\n .title = Survey",
        "survey-tab-overview": "Overview",
        "survey-tab-ratings": "All ratings",
        "survey-tab-ratings-no-survey-data": "No data available.",
        "survey-tab-overview-no-surveys": "No surveys defined yet.",
        "survey-tab-overview-no-questions": "No questions defined for this survey.",
        "survey-tab-ratings-good-topics-card": "\n .title = Satisfied with\n .datasetLabel = Votes",
        "survey-tab-ratings-bad-topics-card": "\n .title = Dissatisfied with\n .datasetLabel = Votes",
        "survey-tab-overview-trend-card": "\n .title = Satisfaction trend\n .scoreLabel = Average score\n .votesLabel = Number of ratings",
        "survey-tab-comment": "Comments",
        "survey-tab-surveys": "Surveys",
        "survey-period-select": "\n .label = Period",
        "survey-period-today": "Today",
        "survey-period-last-day": "Last day",
        "survey-period-last-week": "Last week",
        "survey-period-last-month": "Last month",
        "survey-period-last-quarter": "Last quarter",
        "survey-period-last-year": "Last year",

        // All rating
        "all-rating-time": "Time",
        "all-rating-question": "Question",
        "all-rating-score": "Score",
        "all-rating-topics": "Topics",
        "all-rating-comment": "Comment",

        // SelectSurvey
        "select-survey": "\n .label = Survey",

        // --- Smiley summary card ---
        "survey-smiley-summary-card": "\n .title = Overall score",
        "survey-smiley-summary-card-overall-score-label": "Score: { $averageScore }",

        // --- Survey participation card ---
        "survey-participation-card": "\n .title = Participation",
        "survey-participation-card-participants-label": "Participants",
        "survey-participation-card-non-participants-label": "Non participants",
        "survey-participation-card-participation-label": "Percentage",
        "survey-participation-card-participation-breakdown": "{ $ratings } ratings of { $orders } purchases",

        // --- Survey smiley distribution card ---
        "survey-smiley-distribution-card": "\n .title = Satisfaction",
        "survey-smiley-distribution-card-votes-label": "Votes",
        "smiley-label-bad": "Very bad",
        "smiley-label-poor": "Poor",
        "smiley-label-medium": "Medium",
        "smiley-label-good": "Good",
        "smiley-label-excellent": "Excellent",


        // Production
        "production-meeting-service-breadcrumb": "Meeting service",
        "production-planning-breadcrumb": "Planning",
        "production-pos-purchases-breadcrumb": "POS purchases",
        "production-takeaway-page-header": "\n .title = Takeaway",
        "production-takeaway-breadcrumb": "Takeaway",
        "production-transactions-print-label": "Print label",
        "production-table-toolbar-banner-unprinted-receipts-message": "Receipts not printed on the cloud printer.",
        "production-table-toolbar-banner-show-button": "Show",
        "production-table-toolbar-banner-showing-unprinted-message": "Showing unprinted orders.",
        "production-table-toolbar-banner-clear-filter-button": "Clear filter",
        "production-planning-page-header": "\n .title = Planning",
        "production-meeting-service-page-header": "\n .title = Meeting service",
        "meeting-service-production-view-fullscreen-link": "Fullscreen Mode",
        "meeting-service-production-view-tab-delivery-time": "Delivery time",
        "meeting-service-production-view-tab-delivery-location": "Delivery location",
        "meeting-service-production-view-not-approved-toggle": "Not approved",
        "meeting-service-production-view-sittings-label": "\n .title = Sittings:",
        "meeting-service-production-view-host-label": "\n .title = Meeting host:",
        "meeting-service-production-view-meeting-time-label": "\n .title = Meeting time:",
        "meeting-service-production-view-users-dialog-title": "Contact details",
        "meeting-service-production-view-users-dialog-name-label": "Name:",
        "meeting-service-production-view-users-dialog-email-label": "Email:",
        "meeting-service-production-view-users-dialog-phone-label": "Phone:",
        "meeting-service-production-view-select-all-orders": "\n .label = Select all",
        "meeting-service-production-view-organizer-type-creator": "Creator",
        "meeting-service-production-view-organizer-type-organizer": "Organizer",
        "meeting-service-production-view-organizer-type-responsible": "Responsible",
        "meeting-service-production-view-hour-group-orders-count": "{ $count -> \n *[other] { $count } orders \n [one] { $count } order \n }",
        "meeting-service-production-view-ready-count": "{ $ready }/{ $total } ready",
        "meeting-service-production-view-card-menu-button": "\n .aria-label = More",
        "meeting-service-production-view-card-full-edit": "Full edit",
        "meeting-service-production-view-card-delete-button": "Delete",
        "meeting-service-production-view-edit-items-button": "Edit",
        "meeting-service-production-view-saved-dialog-title": "Order updated",
        "meeting-service-production-view-print-menu": "Print",
        "meeting-service-production-view-print-menu-tooltip": "\n .title = Print",
        "meeting-service-production-view-location-unknown": "Unknown location",
        "meeting-service-production-view-filter-button": "Filters",
        "meeting-service-production-view-search-input": "\n .placeholder = Search for order id, meeting name, location or person.\n .title = Search for order id, meeting name, location or person.",
        "meeting-service-production-view-date-button": "Pick a date",
        "meeting-service-production-view-time-left": "{ $minutes } min left",
        "meeting-service-production-view-order-comment-read-more": "Read more",
        "meeting-service-production-view-order-comment-dialog-title": "Order comment",
        "meeting-service-production-filter-delivery-title": "\n .title = Delivery",
        "meeting-service-production-filter-locked-label": "Locked",
        "meeting-service-production-filter-locked-all": "All",
        "meeting-service-production-filter-locked-locked": "Locked",
        "meeting-service-production-filter-locked-unlocked": "Unlocked",
        "meeting-service-production-view-add-menu-button": "Add Product",
        "meeting-service-production-view-add-menu-catalog": "Product from catalog",
        "meeting-service-production-view-add-menu-wish": "Product wish",
        "meeting-service-production-view-add-menu-extra-service": "Service",
        "meeting-service-order-drawer-order-number": "Order #{ $number }",
        "meeting-service-order-drawer-delivery-tab": "DELIVERY { $index }",
        "meeting-service-order-drawer-order-lines-title": "Order lines",
        "meeting-service-order-drawer-total-label": "TOTAL",
        "meeting-service-order-drawer-status": "Status",
        "meeting-service-order-drawer-delivery-time": "Delivery time",
        "meeting-service-order-drawer-contact": "Contact",
        "meeting-service-order-drawer-contact-info-button": "\n .title = Show contact information",
        "meeting-service-order-drawer-contact-dialog-title": "Contact details",
        "meeting-service-contact-info-disclaimer": "\n .title = Customer contact information. Handle it with care.",
        "meeting-service-contact-info-print-footer": "Confidential: contains customer contact information",
        "meeting-service-order-drawer-covers": "Covers",
        "meeting-service-order-drawer-covers-value": "{ $count } people",
        "meeting-service-order-drawer-delivery-type": "Delivery type",
        "meeting-service-order-drawer-location": "Delivery location",
        "meeting-service-order-drawer-order-note": "Order note",
        "meeting-service-order-drawer-chat-customer": "Chat with canteen",
        "meeting-service-recurrence-series-button-tooltip": "Show all orders in the series",
        "meeting-service-recurrence-series-drawer-subtitle": "Recurring series · { $count ->\n [one] { $count } order\n *[other] { $count } orders\n}",
        "meeting-service-recurrence-series-drawer-recurrence": "Recurrence",
        "meeting-service-recurrence-series-drawer-period": "Period",
        "meeting-service-recurrence-series-drawer-contact": "Contact",
        "meeting-service-recurrence-series-drawer-covers": "Covers",
        "meeting-service-recurrence-series-drawer-covers-value": "{ $count } people",
        "meeting-service-recurrence-series-drawer-delivery-type": "Delivery type",
        "meeting-service-recurrence-series-drawer-location": "Delivery location",
        "meeting-service-recurrence-series-drawer-orders-title": "Orders in series",
        "meeting-service-recurrence-series-drawer-orders-id-column": "Order ID",
        "meeting-service-recurrence-series-drawer-orders-date-column": "Delivery date",
        "meeting-service-recurrence-series-drawer-current-order": "This order",
        "meeting-service-recurrence-series-drawer-locked": "Locked",
        "meeting-service-recurrence-series-drawer-orders-empty": "No orders found in this series",
        "meeting-service-recurrence-series-drawer-close-button": "Close",
        "meeting-service-recurrence-series-drawer-subtitle-no-count": "Recurring series",
        "meeting-service-recurrence-series-drawer-order-menu-button": "More actions for order { $orderId }",
        "meeting-service-recurrence-series-drawer-order-menu-view": "View order",
        "meeting-service-recurrence-series-drawer-order-menu-edit": "Edit order",
        "meeting-service-recurrence-series-drawer-order-menu-copy": "Copy order",
        "meeting-service-recurrence-series-drawer-order-menu-print": "Print order",
        "meeting-service-order-drawer-chat-merchant": "Chat with customer",
        "meeting-service-order-drawer-replied": "Replied",
        "meeting-service-order-drawer-quick-edit": "Quick edit",
        "meeting-service-order-drawer-quick-edit-save-button": "Save",
        "meeting-service-order-drawer-full-edit": "Full edit",
        "meeting-service-order-drawer-delivery-label": "Delivery { $index }",
        "meeting-service-order-drawer-total": "Total",
        "meeting-service-order-drawer-vat": "Incl. VAT ({ $rate }%)",
        "meeting-service-order-drawer-order-lines-count": "{ $count } order lines",
        "meeting-service-order-drawer-send": "Send",
        "meeting-service-order-drawer-add-catalog-title": "Item from catalogue",
        "meeting-service-order-drawer-add-catalog-desc": "Search the catalogue — price filled automatically",
        "meeting-service-order-drawer-add-wish-title": "Free-text request",
        "meeting-service-order-drawer-add-wish-desc": "Free text — the chef reviews it",
        "meeting-service-order-drawer-add-service-title": "Service",
        "meeting-service-order-drawer-add-service-desc": "Table setting, serving, clearing etc.",
        "meeting-service-order-drawer-messages-empty": "No messages yet",
        "meeting-service-order-drawer-duplicate": "Duplicate",
        "meeting-service-order-drawer-resource-bookings": "Resource bookings",
        "meeting-service-order-drawer-booking-time": "Booking time",
        "meeting-service-order-drawer-load-error": "Couldn't load the order",
        "meeting-service-order-drawer-retry": "Try again",
        "meeting-service-order-drawer-saved-snackbar": "The order has been updated",
        "meeting-service-production-view-wish-badge": "\n .label = Wish",
        "meeting-service-production-view-service-badge": "\n .label = Service",
        "meeting-service-production-view-legacy-service-tooltip": "\n .title = This is a legacy extra service from the old portal. It cannot be changed, but it can be removed.",
        "meeting-service-production-view-service-already-added-snackbar": "The service has already been added to this delivery, so it can't be added again.",
        "meeting-service-production-view-only-services-snackbar": "An order can't contain only extra services. Add at least one product.",
        "meeting-service-production-view-add-service-confirm-button": "Add",
        "meeting-service-production-view-add-service-required-error": "This field is required",
        "meeting-service-production-view-wish-name-field": "\n .placeholder = Product name",
        "meeting-service-production-view-wish-price-field": "\n .placeholder = Price",
        "meeting-service-production-view-add-product-autocomplete-label": "Select product",
        "meeting-service-production-view-add-extra-service-autocomplete-label": "Select extra service",
        "meeting-service-production-view-add-picker-cancel": "Cancel",
        "meeting-service-production-view-save-changes-button": "Done",
        "meeting-service-production-view-total-with-amount": "Total: { $amount }",
        "meeting-service-production-view-product-search-placeholder": "Search dish",
        "meeting-service-production-view-product-out-of-stock": "Out of stock",
        "meeting-service-production-view-product-already-added-snackbar": "The product has already been added to this order, so it can't be added again. Please update the existing order line instead.",
        "meeting-service-production-view-product-required": "Product is required",
        "meeting-service-production-view-saved-banner": "\n .title = Order #{ $orderNumber } has been updated. Total: { $total }",
        "meeting-service-production-view-saved-banner-no-total": "\n .title = Order #{ $orderNumber } has been updated",
        "meeting-service-production-view-cancel-button": "Cancel",
        "meeting-service-production-view-remove-line-button": "\n .aria-label = Remove",
        "meeting-service-production-view-product-name-dialog-title": "Product name",
        "meeting-service-production-view-meeting-name-dialog-title": "Meeting name",
        "meeting-service-production-view-empty": "No orders to produce",
        "production-pos-purchases-page-header": "\n .title = POS purchases",
        "production-tab-production-list": "Production list",
        "production-tab-pos-transactions": "POS transactions",
        "production-tab-orders": "Production {$amount}",
        "planning-tab-takeaway": "Takeaway",
        "planning-tab-calendar": "Calendar",
        "planning-tab-not-approved": "Awaiting approval {$amount}",
        "planning-tab-to-be-booked": "To be invoiced {$amount}",
        "planning-tabs-placeholder": "\n .title = Coming soon \n .body = We are working to bring you this feature.",
        "production-list-no-result": "No result",
        "production-orders-action-bar-confirm-queue-remove-dialog": "\n .title = Remove from printer queue\n .message = Are you sure that you want to remove selected receipts from the printer queue?\n .buttonLabelSubmit = Remove",
        "production-orders-action-bar-confirm-print-dialog": "\n .title = Print Receipts\n .message = Are you sure that you want to print the selected receipts?\n .buttonLabelSubmit = Print",
        "production-meeting-service-shortcuts-button": "Shortcuts",
        "production-meeting-service-shortcut-booked-orders": "Booked orders",
        "production-meeting-service-search-field": "\n .label = Search order\n .placeholder = Type order id, meeting name or host.",
        "production-orders-search-field": "\n .label = Search order\n .placeholder = Type order id, name or email.",
        "accounting-orders-search-field": "\n .label = Search order\n .placeholder = Type order id, name or email.",
        "accounting-orders-meeting-service-search-field": "\n .label = Search order\n .placeholder = Type order id, meeting name or host.",

        // Production package slip
        "production-package-slip-order-error": "Failed to load packing slip with id #{ $orderId }",
        "production-package-slip-order-error-description": "This order could not be processed due to missing or invalid data.",
        "production-package-slip-order-id-number": "Order ID: {$orderId}",
        "production-package-slip-section-delivery-details-title": "Delivery details",
        "production-package-slip-section-delivery-details-type": "Delivery type:",
        "production-package-slip-section-delivery-details-time": "Delivery time:",
        "production-package-slip-section-delivery-details-meeting-time": "Meeting time:",
        "production-package-slip-section-delivery-details-location": "Delivery location:",
        "production-package-slip-section-delivery-details-sittings": "Sittings:",
        "production-package-slip-section-delivery-details-merchant": "Merchant:",
        "production-package-slip-section-contact-details-title": "Contact details",
        "production-package-slip-section-contact-details-meeting-creator": "\n .label = Creator:",
        "production-package-slip-section-contact-details-meeting-host": "\n .label = Meeting host:",
        "production-package-slip-table-column-items": "Items",
        "production-package-slip-table-column-products": "Products",
        "production-package-slip-table-column-delivery-time": "Delivery time",
        "production-package-slip-section-note-title": "Note",
        "production-package-slip-section-header-slip-title": "Packing slip",
        "print-page-header-printed-label": "{ $title } · printed { $date } at { $time }",
        "print-page-footer-page-counter": "Page { $page } of { $pages }",
        "print-page-footer-order-label": "Order { $orderId }",
        "production-export-exported-label": "Exported",
        "production-package-slip-section-header-digital-slip-title": "Digital slip",
        "production-package-slip-header-orders-count": "Packing slips: {$orderCount} selected",
        "production-package-slip-navigation-counter": "Packing slip { $current } of { $total }",

        // Production credit note
        "production-credit-note-dialog-title": "\n .dialogTitle = Create credit note",
        "production-credit-note-credit-info": "\n .title = A credit note is used to reverser parts of a booked order.",
        "production-credit-note-debit-info": "\n .title = A supplementary order is used to add items to an order that is already booked.",
        "production-credit-note-table-column-order-id": "Order ID",
        "production-credit-note-table-column-type": "Type",
        "production-credit-note-table-column-booked": "Booked",
        "production-credit-note-table-column-amount": "Amount (DKK)",
        "production-credit-note-table-column-type-cell-original-order": "Original order",
        "production-credit-note-table-column-type-cell-credit": "Credit note",
        "production-credit-note-table-column-type-cell-debit": "Supplementary order",
        "production-credit-note-button-next": "Next",
        "production-credit-note-button-cancel": "Cancel",
        "production-credit-note-select-label": "Create",

        // Accounting
        "accounting-header": "\n .title = Accounting",
        "accounting-product-sales-page-header": "\n .title = Product sales",
        "merchant-nav-item-accounting-product-sales": "Product sales",
        "accounting-orders-page-header": "\n .title = Orders",
        "merchant-nav-item-accounting-orders": "Orders",
        "accounting-subscriptions-page-header": "\n .title = Subscriptions",
        "merchant-nav-item-accounting-subscriptions": "Subscriptions",
        "accounting-cash-register-page-header": "\n .title = Balance",
        "merchant-nav-item-accounting-cash-register": "Balance",
        "accounting-customers-page-header": "\n .title = Customers",
        "merchant-nav-item-accounting-customers": "Customers",
        "accounting-customer-balance-page-header": "\n .title = User balance",
        "merchant-nav-item-accounting-customer-balance": "User balance",
        "merchant-nav-item-accounting-z-report": "Z-report",
        "merchant-nav-item-accounting-custom-reports": "Custom reports",
        "merchant-accounting-z-reports-table-date-range-filter": "\n .label = Date range",

        "accounting-product-sales-breadcrumb-title": "Product sales",
        "accounting-orders-breadcrumb-title": "Orders",
        "accounting-subscriptions-breadcrumb-title": "Subscriptions",
        "accounting-cash-register-breadcrumb-title": "Balance",
        "accounting-customers-breadcrumb-title": "Customers",
        "accounting-customer-balance-breadcrumb-title": "User balance",
        "accounting-customers-button-expand-all": "Expand all",
        "accounting-customers-button-collapse-all": "Collapse all",

        "accounting-orders-tab-transactions": "Transactions",
        "accounting-orders-tab-refill": "Refill",
        "accounting-orders-tab-meetingService": "Meeting service",
        "transactions-table-list-refund-title": "Refund",
        "transactions-table-list-refund": "\n .title = Refund \n .message = Are you sure you want to refund order #{ $orderId } ({ $amount })? \n .buttonLabelSubmit = Confirm\n .buttonLabelCancel = Cancel",
        "transactions-table-list-refund-success-dialog-title": "Order was refunded",
        "transactions-table-list-refund-error-message": "Failed to refund order. Please try again.",
        "order-accounting-refund-pos-order-confirm-dialog": "\n .title = Refund \n .message = Are you sure you want to refund order #{ $orderId }? \n .buttonLabelSubmit = Confirm\n .buttonLabelCancel = Cancel",
        "order-accounting-refund-pos-order-title": "Refund",
        "order-accounting-refund-pos-order-locked-dialog-title": "Order cannot be refunded",
        "order-accounting-refund-pos-order-locked-dialog-body": "This order cannot be refunded.",
        "order-accounting-refund-pos-order-already-refunded-title": "Order already refunded",
        "order-accounting-refund-pos-order-already-refunded-body": "This order has already been refunded.",
        "transactions-table-list-message-customer": "Message customer",

        "filter-menu-title": "Filters",
        "filter-menu-clear-all-button": "Clear all",
        "filter-menu-clear-button": "Clear",

        "filter-menu-accordion-shops-title": "\n .title = Shops",
        "filter-menu-accordion-customers-title": "\n .title = Customers",
        "filter-menu-accordion-transactions-order-details-title": "\n .title = Order details",
        "filter-menu-accordion-transactions-order-number": "\n .label = Order number \n .placeholder = Search by order no...",
        "filter-menu-accordion-transactions-user": "\n .label = User \n .placeholder = Enter id or email",

        "standard-email-filter-label": "\n .label = Email",
        "standard-email-filter-error-message": "Invalid email address",
        "standard-id-filter-order-id-label": "\n .label = Order ID",
        "standard-id-filter-employee-id-label": "\n .label = Employee ID",
        "standard-id-filter-only-numbers-error-message": "Must contain only numbers",
        "standard-last-4-numbers-filter": "\n .label = Credit card, last 4 digits",
        "standard-last-4-numbers-filter-error-message": "Only last 4 numbers",
        "standard-payment-method-input-label": "Payment method",
        "standard-payment-method-item-credit-card": "Credit card",
        "standard-payment-method-item-contant": "Contant",
        "standard-payment-method-item-invoicing": "Invoicing",
        "standard-payment-method-item-wallet": "Wallet",
        "standard-payment-method-item-free": "Free",
        "standard-merchants-filter-label": "Merchants",
        "standard-merchants-shops-filter-label": "Shops",

        "standard-start-date-picker": "\n .label = Start date",
        "standard-end-date-picker": "\n .label = End date",
        "standard-period-date-picker": "Period",

        "table-select-data-type-filter-on-label": "Filter on",
        "table-select-data-type-filter-on-label-label": "\n .label = Filter on",
        "table-select-data-type-filter-on-item-order-date": "Order date",
        "table-select-data-type-filter-on-item-delivery-date": "Delivery date",
        "table-select-data-type-filter-on-item-booked-date": "Booked date",

        "table-select-date-period-filter-by-label": "Period",
        "table-select-date-period-filter-by-label-label": "\n .label = Period",
        "table-select-date-period-filter-by-all": "All",
        "table-select-date-period-filter-by-today": "Today",
        "table-select-date-period-filter-by-yesterday": "Yesterday",
        "table-select-date-period-filter-by-tomorrow": "Tomorrow",
        "table-select-date-period-filter-by-this-week": "This week",
        "table-select-date-period-filter-by-this-month": "This month",
        "table-select-date-period-filter-by-7d": "Next 7 days",
        "table-select-date-period-filter-by-30d": "Next 30 days",

        "table-select-resource-type-filter-by-label": "Resource type",
        "table-select-resource-type-filter-by-label-label": "\n .label = Resource type",
        "table-select-resource-type-filter-by-all": "All",
        "table-select-resource-type-filter-by-room": "Room",
        "table-select-resource-type-filter-by-mobile-av": "Mobile av",
        "table-select-resource-type-filter-by-car": "Car",

        "resource-dashboard-type-all": "All types",
        "resource-dashboard-type-room": "Meeting rooms",
        "resource-dashboard-type-mobile-av": "AV equipment",
        "resource-dashboard-type-car": "Cars",

        "standard-order-type-filter-mode-all": "All",
        "standard-order-type-filter-mode-pos": "POS",
        "standard-order-type-filter-mode-lunch": "Canteen",
        "standard-order-type-filter-mode-meeting-service": "Meeting service",
        "standard-order-type-filter-mode-resource-booking": "Resource booking",
        "standard-order-type-filter-mode-internal": "Internal",
        "standard-order-type-filter-mode-external": "External",
        "standard-order-type-filter-mode-take-away": "Takeaway",

        // Accounting > Orders > Meeting service
        "accounting-orders-meeting-service-receipt": "Receipt",
        "accounting-orders-meeting-service-table-startDate-date-picker": "\n .label = Booked start date",
        "accounting-orders-meeting-service-table-endDate-date-picker": "\n .label = Booked end date",
        "accounting-orders-meeting-service-table-number": "Order id",
        "accounting-orders-meeting-service-table-ref": "Ref.",
        "accounting-orders-meeting-service-table-booked-date": "Booked date",
        "accounting-orders-meeting-service-table-delivery-date": "Delivery date",
        "accounting-orders-meeting-service-table-creator": "Creator",
        "accounting-orders-meeting-service-table-status": "Status",
        "accounting-orders-meeting-service-table-amount": "Amount",
        "filter-menu-accordion-booked-date-title": "\n .title = Booked date",
        "filter-menu-accordion-delivery-date-title": "\n .title = Delivery date",
        "filter-menu-accordion-order-details-title": "\n .title = Order details",
        "filter-menu-accordion-meeting-service-start-date-picker": "\n .label = Start date",
        "filter-menu-accordion-meeting-service-end-date-picker": "\n .label = End date",
        "filter-menu-accordion-meeting-service-order-number": "\n .label = Order number \n .placeholder = Search by order no...",
        "filter-menu-accordion-meeting-service-customer": "\n .label = Customer \n .placeholder = Name of customer...",
        "accounting-orders-meeting-service-payment-type-credit": "Credit note",
        "accounting-orders-meeting-service-payment-type-debit": "",

        // Accounting subscription
        "accounting-subscription-title": "Subscription",
        "accounting-subscription-name": "Name",
        "accounting-subscription-subscribed": "Subscribed",
        "accounting-subscription-unsubscribed": "Unsubscribed",
        "accounting-subscription-payment-method": "Payment method",
        "accounting-subscription-amount": "Amount",
        "accounting-subscription-cancel": "Cancel subscription",
        "accounting-subscription-cancel-true": "Your subscription has been cancelled",


        // Accounting product sale
        "accounting-product-sale-product-code": "Product code",
        "accounting-product-sale-product": "Products",
        "accounting-product-sale-product-quantity": "Quantity",
        "accounting-product-sale-product-amount": "Amount",
        "accounting-product-sale-export-empty": "No sales for this period.",
        "accounting-product-sale-date-range-label": "\n .label = Period",

        // Accounting balance
        "accounting-amount": "Amount",
        "accounting-amount-no-sales": "No sales in the given period",

        // Accounting debtors
        "accounting-debtors-export-items-label": "Items",
        "accounting-debtors-export-amount-label": "Amount",
        "accounting-debtors-export-subtotal-label": "Subtotal",
        "accounting-debtors-export-failed": "Failed to export debtors",
        "accounting-debtors-export-account-total":  "Account total",
        "accounting-debtors-export-subtotal": "Subtotal",
        "accounting-customers-export-sales-summary": "Customer sales summary",
        "accounting-customers-export-payroll": "Customer payroll files (ZIP file)",


        // Merchant > Reports > Accounting > Z-report
        "merchant-accounting-z-reports-page-header": "\n .title = Z-report",
        "merchant-accounting-z-reports-table-date-column": "Date",
        "merchant-accounting-z-reports-table-pos-terminal-column": "POS terminal",
        "merchant-accounting-z-reports-table-amount-column": "Amount",

        // Merchant > Reports > Accounting > Z-report
        "merchant-accounting-custom-reports-page-header": "\n .title = Custom reports",
        "merchant-accounting-custom-reports-table-name-column": "Name",
        "merchant-accounting-custom-reports-table-interval-column": "Interval",
        "merchant-accounting-custom-reports-table-last-run-column": "Last run",
        "merchant-accounting-custom-reports-table-status-column": "Status",
        "merchant-accounting-custom-reports-table-button-details": "Details",
        "merchant-accounting-custom-reports-table-button-download-report": "Download report",
        "merchant-accounting-custom-reports-table-button-activate": "Activate",
        "merchant-accounting-custom-reports-table-button-deactivate": "Deactivate",
        "merchant-accounting-custom-reports-confirm-modal-question": "Are you sure you want to { $status} '{ $itemName }'?",
        "merchant-accounting-custom-reports-run-modal-form-title": "Download report",
        "merchant-accounting-custom-reports-run-modal-form-subtitle-name": "Name:",
        "merchant-accounting-custom-reports-run-modal-form-subtitle": "Payroll deduction",
        "merchant-accounting-custom-reports-run-modal-form-startDate-date-picker": "\n .label = Start date",
        "merchant-accounting-custom-reports-run-modal-form-endDate-date-picker": "\n .label = End date",
        "merchant-accounting-custom-reports-run-form-save-button": "Download",

        // SelectCustomer
        "select-customer": "\n .label = Customer",
        "select-debtor": "\n .label = Company",
        "select-customer-all": "All",

        // SelectShop
        "select-shop": "Shop",
        "select-shop-label": "\n .label = Shop",
        "select-shop-all": "All",


        // SelectWeek
        "select-week": "Select week",
        "select-week-week": "Week",

        // Select Kitchen
        "control-kitchen-mode-delivery-time": "Delivery time",
        "control-kitchen-mode-purchase-time": "Purchase time",
        "control-kitchen-mode-period-report": "Period report",

        // Merchant > Reports > Menu Planning
        "merchant-menu-planning-header": "\n .title = Menu planning",
        "merchant-menu-planning-tab-calendar": "Calendar",
        "merchant-menu-planning-tab-menus": "Menus",
        "merchant-menu-planning-tab-digital-signage": "Digital signage",
        "merchant-menu-templates-row-meta": "{ $categories } categories · { $dishes } dishes",
        "merchant-menu-templates-row-no-channels": "No channel",
        "merchant-menu-templates-row-delete-item": "Delete",
        "merchant-menu-templates-row-edit-button": "Edit",
        "merchant-menu-templates-create-button": "Create new",
        "merchant-menu-templates-empty": "No templates yet. Create your first template.",
        "merchant-menu-templates-load-error": "The template could not be loaded. Please try again.",
        "merchant-menu-templates-list-load-error": "The templates could not be loaded. Please try again.",
        "merchant-menu-templates-delete-entity": "\n .typeOfEntity = menu template",
        "merchant-menu-templates-channel-mobile-app": "Mobile app",
        "merchant-menu-templates-channel-canteen-display": "Canteen display",
        "merchant-menu-templates-channel-digital-signs": "Digital dish signs",
        "merchant-menu-templates-channel-print": "Print sheet",
        "merchant-menu-templates-editor-new-title": "New template",
        "merchant-menu-templates-editor-name-label": "Template name",
        "merchant-menu-templates-editor-name-field": "\n .placeholder = Template name",
        "merchant-menu-templates-editor-name-hint": "Internal name — not shown to customers.",
        "merchant-menu-templates-editor-channels-label": "Published to",
        "merchant-menu-templates-editor-channels-hint": "Where this template's menu is shown. A template can target one or more channels; different templates can target different ones.",
        "merchant-menu-templates-editor-categories-title": "Categories",
        "merchant-menu-templates-editor-add-category-button": "Add category",
        "merchant-menu-templates-editor-cancel-button": "Cancel",
        "merchant-menu-templates-editor-save-button": "Save template",
        "merchant-menu-templates-category-dish-count": "{ $count } dishes",
        "merchant-menu-templates-category-edit-button": "Edit",
        "merchant-menu-templates-category-delete-item": "Delete",
        "merchant-menu-templates-category-dialog-add-title": "\n .dialogTitle = Add category",
        "merchant-menu-templates-category-dialog-edit-title": "\n .dialogTitle = Edit category",
        "merchant-menu-templates-category-dialog-name-field": "\n .label = Category name \n .placeholder = e.g. Warm dishes",
        "merchant-menu-templates-category-dialog-cancel-button": "Cancel",
        "merchant-menu-templates-category-dialog-save-button": "Save",
        "merchant-menu-templates-delete-category-dialog-title": "Delete category",
        "merchant-menu-templates-delete-category-dialog-message": "Are you sure you want to delete '{ $name }'?",
        "merchant-menu-templates-delete-category-dialog-dishes-warning": "{ $count ->\n [one] It contains { $count } dish, which will be deleted too.\n *[other] It contains { $count } dishes, which will be deleted too.\n}",
        "merchant-menu-templates-delete-dish-dialog-title": "Delete dish",
        "merchant-menu-templates-delete-dish-dialog-message": "Are you sure you want to delete '{ $name }'?",
        "merchant-menu-templates-delete-dish-dialog-message-unnamed": "Are you sure you want to delete this dish?",
        "merchant-menu-templates-add-dish-card": "Add dish",
        "merchant-menu-templates-dish-remove-button": "\n .aria-label = Remove dish",
        "merchant-menu-templates-dish-name-label": "Dish Name",
        "merchant-menu-templates-week-day-short-monday": "Mo",
        "merchant-menu-templates-week-day-short-tuesday": "Tu",
        "merchant-menu-templates-week-day-short-wednesday": "We",
        "merchant-menu-templates-week-day-short-thursday": "Th",
        "merchant-menu-templates-week-day-short-friday": "Fr",
        "merchant-menu-templates-week-day-short-saturday": "Sa",
        "merchant-menu-templates-week-day-short-sunday": "Su",
        "merchant-menu-templates-dish-cancel-button": "Cancel",
        "merchant-menu-templates-dish-done-button": "Done",
        "merchant-menu-templates-availability-hint": "Which weekdays this dish appears on in the week menu.",
        "merchant-menu-templates-dish-fields-title": "Fields",
        "merchant-menu-templates-dish-new-title": "New dish",
        "merchant-menu-templates-dish-no-photo": "No template photo",
        "merchant-menu-templates-dish-no-mandatory-fields": "No mandatory fields",
        "merchant-menu-templates-ai-can-fill-label": "AI can fill this field",
        "merchant-menu-templates-ai-hint-on": "AI generation in the week menu may fill this field.",
        "merchant-menu-templates-ai-hint-off": "AI generation in the week menu leaves this field blank — the kitchen fills it.",
        "merchant-menu-templates-ai-off-label": "AI off",
        "merchant-menu-templates-field-value-default-label": "Default value (optional)",
        "merchant-menu-templates-field-value-locked-label": "Locked value · required for this template",
        "merchant-menu-templates-field-price": "Price",
        "merchant-menu-templates-field-description": "Description",
        "merchant-menu-templates-field-allergens": "Allergens",
        "merchant-menu-templates-field-availability": "Availability",
        "merchant-menu-templates-field-marketing-tag": "Marketing tag",
        "merchant-menu-templates-field-image": "Picture",
        "merchant-menu-templates-field-title": "Title",
        "merchant-menu-templates-field-ingredients": "Ingredients",
        "merchant-menu-templates-field-nutrition": "Nutrition",
        "merchant-menu-templates-field-co2-footprint": "CO₂ footprint",
        "merchant-menu-templates-title-value-field": "\n .placeholder = Title text…",
        "merchant-menu-templates-ingredients-value-field": "\n .placeholder = e.g. Tomatoes, basil, garlic, olive oil…",
        "merchant-menu-templates-nutrition-value-field": "\n .placeholder = e.g. 320 kcal · 12g P · 40g C · 8g F",
        "merchant-menu-templates-co2-unit": "kg CO₂ eq",
        "merchant-menu-templates-dish-details-title": "Details",
        "merchant-menu-templates-dish-details-subtitle": "shown in a dialog in the week menu",
        "merchant-menu-templates-mode-locked": "Locked",
        "merchant-menu-templates-mode-mandatory": "Mandatory",
        "merchant-menu-templates-mode-optional": "Optional",
        "merchant-menu-templates-mode-hint-locked": "Locked — a starting value is required here in the template; it carries into every week menu. The kitchen can still edit it for a given day.",
        "merchant-menu-templates-mode-hint-mandatory": "Mandatory — the kitchen must fill this field in the week menu. A default value here is optional.",
        "merchant-menu-templates-mode-hint-optional": "Optional — the kitchen may fill this field in the week menu. A default value here is optional.",
        "merchant-menu-templates-field-show-toggle": "Show",
        "merchant-menu-templates-field-hidden-hint": "Hidden in week menu",
        "merchant-menu-templates-price-value-field": "\n .label = Price",
        "merchant-menu-templates-price-same-week-checkbox": "Same price all week",
        "merchant-menu-templates-description-value-field": "\n .placeholder = Description text…",
        "merchant-menu-templates-marketing-tag-value-field": "\n .label = Marketing tag \n .helperText = Examples: Offer of the day, Discount",
        "merchant-menu-templates-image-upload": "\n .label = Upload image",
        "merchant-menu-templates-validation-required": "This field is required",
        "merchant-menu-templates-validation-number": "Must be a number",
        "merchant-menu-planning-tab-week-menu": "Week menu",
        "merchant-week-menu-cell-title-field": "\n .placeholder = Write dish name…",
        "merchant-week-menu-cell-recent-dishes-title": "Previous menus",
        "merchant-week-menu-cell-description-field": "\n .placeholder = Add description…",
        "merchant-week-menu-cell-description-expand-tooltip": "\n .title = Open full description",
        "merchant-week-menu-cell-add-allergen-label": "Allergen",
        "merchant-week-menu-cell-price-field": "\n .placeholder = 0",
        "merchant-week-menu-cell-price-locked-all-week": "{ $price } DKK · all week",
        "merchant-week-menu-cell-price-locked": "{ $price } DKK",
        "merchant-week-menu-currency-label": "DKK",
        "merchant-week-menu-cell-marketing-field": "\n .placeholder = Marketing tag (optional)",
        "merchant-week-menu-cell-add-image-label": "Photo",
        "merchant-week-menu-cell-image-from-template-label": "Picture from template",
        "merchant-week-menu-cell-image-delete-button": "\n .aria-label = Delete",
        "merchant-week-menu-cell-menu-button": "\n .aria-label = Dish actions",
        "merchant-week-menu-cell-copy-tooltip": "\n .title = Copy to other days…",
        "merchant-week-menu-cell-clear-tooltip": "\n .title = Clear dish",
        "merchant-week-menu-cell-details-tooltip": "\n .title = Dish details",
        "merchant-week-menu-details-dialog": "\n .dialogTitle = Dish Details",
        "merchant-week-menu-details-ingredients-label": "Ingredients",
        "merchant-week-menu-details-nutrition-label": "Nutrition",
        "merchant-week-menu-details-co2-label": "CO₂ Footprint (kg CO₂ eq)",
        "merchant-week-menu-details-dialog-close-button": "Close",
        "merchant-week-menu-details-dialog-save-button": "Save",
        "merchant-week-menu-cell-unavailable": "Not available",
        "merchant-week-menu-cell-drag-tooltip": "\n .title = Drag to another day",
        "merchant-week-menu-cell-status-ready": "Ready",
        "merchant-week-menu-cell-status-missing": "Missing",
        "merchant-week-menu-missing-tooltip-title": "Still missing",
        "merchant-week-menu-missing-field-name": "Name",
        "merchant-week-menu-missing-field-description": "Description",
        "merchant-week-menu-missing-field-price": "Price",
        "merchant-week-menu-missing-field-photo": "Photo",
        "merchant-week-menu-missing-field-allergens": "Allergens",
        "merchant-week-menu-missing-field-marketing-tag": "Marketing tag",
        "merchant-week-menu-cell-status-optional": "Optional",
        "merchant-week-menu-cell-ai-regen-tooltip": "\n .title = Regenerate with AI",
        "merchant-week-menu-description-dialog": "\n .dialogTitle = Edit Description",
        "merchant-week-menu-description-dialog-field-label": "Description",
        "merchant-week-menu-description-dialog-field": "\n .placeholder = Write a longer, more detailed description here…",
        "merchant-week-menu-description-dialog-close-button": "Close",
        "merchant-week-menu-description-dialog-save-button": "Save",
        "merchant-week-menu-copy-dish-dialog": "\n .dialogTitle = Copy dish to other days",
        "merchant-week-menu-copy-week-to-label": "\n .label = Copy to",
        "merchant-week-menu-copy-overwrite-label": "Overwrite filled dishes",
        "merchant-week-menu-copy-overwrite-sublabel": "Off — only empty slots are filled, existing dishes are kept.",
        "merchant-week-menu-copy-overwrite-sublabel-on": "On — existing dishes will be overwritten too.",
        "merchant-week-menu-copy-dish-cancel-button": "Cancel",
        "merchant-week-menu-copy-dish-confirm-button": "Copy",
        "merchant-week-menu-week-label": "Week { $week } · { $period }",
        "merchant-week-menu-prev-week-button": "\n .aria-label = Previous week",
        "merchant-week-menu-next-week-button": "\n .aria-label = Next week",
        "merchant-week-menu-days-ready-label": "{ $ready }/{ $total } Days ready",
        "merchant-week-menu-dish-column-label": "Dish",
        "merchant-week-menu-clear-week-snackbar": "Week cleared",
        "merchant-week-menu-clear-week-dialog": "\n .title = Clear week\n .buttonLabelSubmit = Clear",
        "merchant-week-menu-clear-week-dialog-message": "This removes all dishes entered for this week. The action cannot be undone.",
        "merchant-week-menu-close-day-dialog": "\n .title = Close this day\n .buttonLabelSubmit = Close day",
        "merchant-week-menu-close-day-dialog-message": "{ $count } filled dishes on this day will not be published while it is closed.",
        "merchant-week-menu-remove-theme-dialog": "\n .title = Switch back to template\n .buttonLabelSubmit = Switch back",
        "merchant-week-menu-remove-theme-dialog-message": "Discard { $count } theme dishes on this day and switch back to the template?",
        "merchant-week-menu-publish-button": "Publish ready days",
        "merchant-week-menu-autosaved-label": "Saved automatically",
        "merchant-week-menu-day-publish-tooltip": "\n .title = Publish this day to customers",
        "merchant-week-menu-day-status-draft": "Draft",
        "merchant-week-menu-day-status-published": "Published",
        "merchant-week-menu-day-status-updated": "Updated",
        "merchant-week-menu-day-menu-button": "\n .aria-label = Day actions",
        "merchant-week-menu-day-menu-theme-item": "Make this a theme day",
        "merchant-week-menu-day-menu-rename-theme-item": "Edit theme name…",
        "merchant-week-menu-day-menu-remove-theme-item": "Switch back to template",
        "merchant-week-menu-day-menu-close-item": "Mark day as closed",
        "merchant-week-menu-theme-dialog-add-title": "\n .dialogTitle = Make { $day } a theme day",
        "merchant-week-menu-theme-dialog-rename-title": "\n .dialogTitle = Edit theme name",
        "merchant-week-menu-theme-dialog-name-label": "Theme name",
        "merchant-week-menu-theme-dialog-name-field": "\n .placeholder = Write theme...",
        "merchant-week-menu-theme-dialog-hint": "Give the theme a short name like \"Spanish day\" or \"Christmas\".",
        "merchant-week-menu-theme-dialog-close-button": "Close",
        "merchant-week-menu-theme-dialog-save-button": "Save",
        "merchant-week-menu-theme-add-dish-button": "Add dish",
        "merchant-week-menu-closed-panel-title": "Closed",
        "merchant-week-menu-closed-panel-message": "No menu on this day. Customers see this day as closed.",
        "merchant-week-menu-closed-reopen-button": "Reopen day",
        "merchant-week-menu-copy-week-dialog": "\n .dialogTitle = Copy week to other weeks",
        "merchant-week-menu-copy-week-cancel-button": "Cancel",
        "merchant-week-menu-copy-week-confirm-button": "Copy",
        "merchant-week-menu-ai-button": "AI",
        "merchant-week-menu-ai-menu-quick-title": "Quick Menu",
        "merchant-week-menu-ai-menu-quick-subtitle": "Generate the whole week automatically",
        "merchant-week-menu-ai-menu-customize-title": "Customize Menu",
        "merchant-week-menu-ai-menu-customize-subtitle": "Set themes & rules per day, then generate",
        "merchant-week-menu-ai-banner-title": "AI generated this menu",
        "merchant-week-menu-ai-banner-subtitle": "Review the dishes before publishing.",
        "merchant-week-menu-ai-banner-regenerate-button": "Regenerate",
        "merchant-week-menu-ai-banner-undo-button": "Undo",
        "merchant-week-menu-ai-banner-close-button": "\n .aria-label = Close",
        "merchant-week-menu-ai-dialog": "\n .dialogTitle = Customize menu generation",
        "merchant-week-menu-ai-dialog-subtitle": "Set a theme and rules, then let the AI fill the week",
        "merchant-week-menu-ai-theme-label": "Theme",
        "merchant-week-menu-ai-inspiration-label": "Inspiration",
        "merchant-week-menu-ai-dialog-notes-field": "\n .placeholder = Add your own ideas or rules, e.g. some certain requirements",
        "merchant-week-menu-ai-overwrite-label": "Overwrite existing dishes",
        "merchant-week-menu-ai-overwrite-helper": "Off = AI only fills empty slots",
        "merchant-week-menu-ai-overwrite-dialog": "\n .dialogTitle = This menu already has dishes",
        "merchant-week-menu-ai-overwrite-subtitle": "How should the AI handle the days that are already filled?",
        "merchant-week-menu-ai-overwrite-fill-title": "Fill empty slots only",
        "merchant-week-menu-ai-overwrite-fill-subtitle": "Keep the dishes you already wrote",
        "merchant-week-menu-ai-overwrite-replace-title": "Replace all dishes",
        "merchant-week-menu-ai-overwrite-replace-subtitle": "Overwrite the whole week",
        "merchant-week-menu-ai-overwrite-choose-button": "Choose",
        "merchant-week-menu-ai-overwrite-cancel-button": "Cancel",
        "merchant-week-menu-ai-dialog-cancel-button": "Cancel",
        "merchant-week-menu-ai-dialog-generate-button": "Generate",
        "merchant-week-menu-ai-theme-surprise": "Surprise me",
        "merchant-week-menu-no-templates-title": "No menu templates yet",
        "merchant-week-menu-no-templates-message": "To plan a week menu, first create a template with your categories and dishes.",
        "merchant-week-menu-create-template-button": "Create template",
        "merchant-week-menu-load-error": "The week menu could not be loaded. Please try again.",
        "merchant-week-menu-legend-empty": "Empty",
        "merchant-week-menu-legend-filled": "Filled (complete)",
        "merchant-week-menu-legend-needs-fill": "Started, required field missing",
        "merchant-week-menu-legend-default": "Template default — editable, not yet edited",
        "merchant-week-menu-legend-ai-mode": "AI mode",
        "merchant-week-menu-cell-description-field-optional": "\n .placeholder = Add description (optional)…",
        "merchant-week-menu-cell-add-allergen-label-optional": "Allergen (optional)",
        "merchant-week-menu-copy-dish-dialog-sub": "Copies this dish to the same row on the days you pick.",
        "merchant-week-menu-copy-dish-select-all": "Select all",
        "merchant-week-menu-theme-dish-remove-button": "\n .aria-label = Remove theme dish",
        "merchant-week-menu-copy-dish-clear": "Clear",
        "merchant-week-menu-copy-dish-source-suffix": "(source)",
        "merchant-week-menu-copy-dish-warning": "Some selected days already have a dish. They'll be skipped unless you turn on overwrite.",
        "merchant-week-menu-copy-dish-snackbar": "Dish copied to { $count } days.",
        "merchant-week-menu-copy-dish-skipped-snackbar": "Dish copied to { $count } days · { $skipped } skipped (already filled).",
        "merchant-week-menu-copy-week-source-subtitle": "Full week menu · { $period }",
        "merchant-week-menu-copy-week-next-prefix": "Next week ({ $label })",
        "merchant-week-menu-copy-week-snackbar": "Week menu copied to { $week }.",
        "merchant-week-menu-swap-snackbar": "Swapped { $dish } between { $dayA } and { $dayB }.",
        "merchant-week-menu-theme-created-snackbar": "Theme day created: { $name }.",
        "merchant-week-menu-theme-reverted-snackbar": "Day switched back to the template.",
        "merchant-week-menu-day-closed-snackbar": "{ $day } marked as closed.",
        "merchant-week-menu-day-reopened-snackbar": "{ $day } reopened.",
        "merchant-week-menu-publish-count-snackbar": "{ $count } days published to customers.",
        "merchant-week-menu-publish-none-snackbar": "No days are toggled on to publish.",
        "merchant-week-menu-ai-ready-snackbar": "AI menu ready — review and keep.",
        "merchant-week-menu-ai-regenerated-snackbar": "Dish regenerated.",
        "merchant-week-menu-ai-reverted-snackbar": "Reverted to the previous menu.",
        "merchant-week-menu-ai-no-open-days-snackbar": "No open days to generate for this week.",
        "merchant-week-menu-ai-banner-working-title": "Generating menu…",
        "merchant-week-menu-ai-banner-working-subtitle": "Creating dishes for { $template }",
        "merchant-week-menu-theme-dialog-create-button": "Save",
        "merchant-week-menu-theme-dialog-warning": "{ $day } has { $count } filled cells from the template. Switching to a theme day will discard them.",
        "merchant-week-menu-theme-panel-edit-tooltip": "\n .title = Edit theme name",
        "merchant-week-menu-theme-panel-revert-tooltip": "\n .title = Switch back to template",
        "merchant-week-menu-recent-dishes-matching-title": "Previous menus · matching \"{ $query }\"",
        "merchant-week-menu-recent-dishes-meta": "This week",
        "merchant-week-menu-recent-dish-price": "· { $price } DKK",
        "merchant-week-menu-details-title-label": "Title",
        "merchant-week-menu-details-description-label": "Description",
        "merchant-week-menu-details-price-label": "Price",
        "merchant-week-menu-details-allergens-label": "Allergens",
        "merchant-week-menu-details-marketing-label": "Marketing tag",
        "merchant-week-menu-details-image-label": "Image",
        "merchant-week-menu-details-accordion-title": "Nutrition & environment",
        "merchant-week-menu-details-co2-unit": "kg CO₂ eq",
        "merchant-week-menu-ai-theme-asian": "Asian",
        "merchant-week-menu-ai-theme-mediterranean": "Mediterranean",
        "merchant-week-menu-ai-theme-nordic": "Nordic",
        "merchant-week-menu-ai-theme-italian": "Italian",
        "merchant-week-menu-ai-theme-mexican": "Mexican",
        "merchant-week-menu-ai-theme-indian": "Indian",
        "merchant-week-menu-ai-theme-middle-eastern": "Middle Eastern",
        "merchant-week-menu-ai-spice-label": "Spice level",
        "merchant-week-menu-ai-spice-low": "Low",
        "merchant-week-menu-ai-spice-medium": "Medium",
        "merchant-week-menu-ai-spice-spicy": "Spicy",
        "merchant-week-menu-ai-health-label": "Healthiness",
        "merchant-week-menu-ai-health-healthy": "Healthy",
        "merchant-week-menu-ai-health-balanced": "Balanced",
        "merchant-week-menu-ai-health-comfort": "Comfort",
        "merchant-week-menu-ai-style-label": "Style",
        "merchant-week-menu-ai-style-normal": "Normal",
        "merchant-week-menu-ai-style-gourmet": "Gourmet",
        "merchant-week-menu-ai-style-fun": "Fun",
        "merchant-week-menu-ai-style-party": "Party",
        "merchant-week-menu-ai-style-celebration": "Celebration",
        "merchant-week-menu-ai-ingredients-label": "Ingredients to include",
        "merchant-week-menu-ai-ingredients-input": "\n .placeholder = Type and press Enter…",
        "merchant-week-menu-ai-mode-all": "All days the same",
        "merchant-week-menu-ai-mode-per-day": "Customize each day",
        "merchant-week-menu-marketing-popover-title": "Suggested tags",
        "merchant-week-menu-marketing-add-custom-tag": "Add custom tag",
        "merchant-week-menu-overflow-button": "\n .aria-label = More actions",
        "merchant-week-menu-overflow-manage-templates-item": "Manage Templates",
        "merchant-week-menu-overflow-customer-preview-item": "Customer Preview",
        "merchant-week-menu-overflow-copy-week-item": "Copy Week",
        "merchant-week-menu-overflow-clear-week-item": "Clear Week",
        "merchant-week-menu-overflow-export-pdf-item": "Export to PDF",
        "merchant-week-menu-overflow-print-item": "Print kitchen sheet",
        "merchant-week-menu-customer-view-button": "Customer View",
        "merchant-week-menu-feature-not-ready-snackbar": "Not available yet",
        "merchant-week-menu-autosaved-just-now": "Saved automatically just now",
        "merchant-week-menu-autosaved-minutes": "Saved automatically · { $minutes } min ago",
        "merchant-week-menu-row-ready-label": "{ $filled }/{ $total } Ready",
        "merchant-week-menu-row-template-default-chip": "Template default",
        "merchant-menu-planning-table-startDate-date-picker": "\n .label = Start date",
        "merchant-menu-planning-table-endDate-date-picker": "\n .label = End date",
        "merchant-menu-planning-table-week-select": "\n .label = Week",
        "merchant-menu-planning-table-week-select-option": "Week { $countOfWeek } ({ $startDate } - { $endDate })",
        "merchant-menu-planning-table-date-column": "Date",
        "merchant-menu-planning-table-dish": "Dish { $counter }:",
        "merchant-menu-planning-table-price": "Price: { $price }",
        "merchant-menu-planning-table-allergens": "Allergens: { $allergens }",
        "merchant-menu-planning-table-type-mode-digital-signage": "Digital signage",
        "merchant-menu-planning-table-type-mode-web-menu": "Web menu",
        "merchant-menu-planning-table-type-recurring": "Recurring",
        "merchant-menu-planning-table-status-column": "Status",
        "merchant-menu-planning-table-active-column-active": "Active",
        "merchant-menu-planning-table-active-column-inactive": "Inactive",
        "merchant-menu-planning-table-active-column-active-filter-yes": "Active",
        "merchant-menu-planning-table-active-column-inactive-filter-no": "Inactive",
        "merchant-menu-planning-table-dishes-count": "dishes",
        "merchant-menu-planning-table-recurrence": "Recurrence",
        "merchant-menu-planning-table-create-button": "Create new",
        "merchant-menu-planning-table-week-menu-rss-button": "Week menu as RSS",
        "merchant-menu-planning-table-week-menu-atom-button": "Week menu as Atom",
        "merchant-menu-planning-table-week-menu-page-button": "Week menu as web page",
        "public-canteen-week-menu-title": "Canteen menu",
        "public-canteen-week-menu-week-label": "Week { $weekNumber }",
        "public-canteen-week-menu-allergens-label": "Allergens:",
        "public-canteen-week-menu-empty": "Unfortunately, no menus have been created this week.",
        "public-canteen-week-menu-load-error": "We couldn't load the menu due to an error.\n    Please contact support for assistance.",
        "public-menu-display-status-offline": "No internet",
        "public-menu-display-status-server-down": "Could not reach server",
        "public-menu-display-status-refresh-failed": "Could not update the menu",
        "public-menu-display-header-title": "Today's menu",
        "public-menu-display-empty-message": "No menu published for today",
        "public-menu-display-unavailable-message": "The menu could not be loaded",
        "public-menu-display-pagination-label": "{$current} of {$total} menus",
        "public-menu-display-allergens-contains-label": "Contains",
        "public-menu-display-scan-qr-text": "Scan for week menu",
        "merchant-menu-planning-table-menu-item-edit": "Edit",
        "merchant-menu-planning-table-menu-item-set-inactive": "Set inactive",
        "merchant-menu-planning-table-menu-item-set-active": "Set active",
        "merchant-menu-planning-table-menu-item-delete": "Delete",
        "merchant-menu-planning-confirm-delete-shop-dialog": "\n .typeOfEntity = menu",
        "merchant-menu-planning-dialog-create-title": "Create menu",
        "merchant-menu-planning-dialog-edit-title": "Edit menu",
        "merchant-menu-planning-dialog-max-dishes": "Available dish signs: { $countOfDishes }",
        "merchant-menu-planning-dialog-add-marketing-details-button": "\n .title =+ Add marketing details",
        "merchant-menu-planning-dialog-add-dish-button": "Add dish",
        "merchant-menu-planning-dialog-add-recurrence-button": "\n .title =+ Add Recurrence",
        "merchant-menu-planning-dialog-remove-recurrence-button": "\n .title =Remove Recurrence",
        "merchant-menu-planning-dialog-create-submit-button": "Create",
        "merchant-menu-planning-dialog-save-submit-button": "Save",
        "merchant-menu-planning-dialog-dish": "Dish { $countOfDish }",
        "merchant-menu-planning-dialog-publishDate-date-picker": "\n .label = Publish date",
        "merchant-menu-planning-dialog-recurrence": "Recurrence",
        "merchant-menu-planning-dialog-name-of-dish-field": "\n .label = Name of dish",
        "merchant-menu-planning-dialog-brief-field": "\n .label = Brief \n .placeholder = Short description, max. 80 characters including space.",
        "merchant-menu-planning-dialog-marketing-tag-field": "\n .label = Marketing tag \n .helperText = Examples: Offer of the day, Discount",
        "merchant-menu-planning-dialog-from-date-picker": "\n .label = From date",
        "merchant-menu-planning-dialog-to-date-picker": "\n .label = To date",
        "merchant-menu-planning-dialog-currency-field": "\n .label = Currency",
        "merchant-menu-planning-dialog-price-field": "\n .label = Price",
        "merchant-menu-planning-dialog-upload-image": "\n .label = Upload image",
        "merchant-menu-planning-week-day-monday": "Monday",
        "merchant-menu-planning-week-day-tuesday": "Tuesday",
        "merchant-menu-planning-week-day-wednesday": "Wednesday",
        "merchant-menu-planning-week-day-thursday": "Thursday",
        "merchant-menu-planning-week-day-friday": "Friday",
        "merchant-menu-planning-week-day-saturday": "Saturday",
        "merchant-menu-planning-week-day-sunday": "Sunday",
        "merchant-menu-planning-dialog-signageTypes-label": "Publish to:",
        "merchant-menu-planning-dialog-signageTypes-mode-web-menu": "Web menu",
        "merchant-menu-planning-dialog-signageTypes-mode-buffet-sign": "Buffet sign",
        "merchant-menu-planning-dialog-signageTypes-mode-day-menu-sign": "Todays menu sign",
        "merchant-menu-planning-dialog-signageTypes-min-error": "Please select at least one signage type",
        "merchant-menu-planning-digital-signage-card-serial-no": "Serialno:",
        "merchant-menu-planning-digital-signage-card-device-id": "Device ID:",
        "merchant-menu-planning-digital-signage-card-device-name": "Device name:",
        "merchant-menu-planning-digital-signage-card-last-update": "Last updated:",
        "merchant-menu-planning-digital-signage-card-battery-status": "Battery status:",
        "merchant-menu-planning-digital-signage-card-battery-status-0": "Undefined",
        "merchant-menu-planning-digital-signage-card-battery-status-1": "Unknown",
        "merchant-menu-planning-digital-signage-card-battery-status-2": "Good",
        "merchant-menu-planning-digital-signage-card-battery-status-3": "Poor",
        "merchant-menu-planning-digital-signage-card-battery-status-4": "Poor chiller",
        "merchant-menu-planning-digital-signage-card-battery-status-5": "Replace",
        "merchant-menu-planning-digital-signage-card-battery-status-6": "Replace chiller",
        "merchant-menu-planning-digital-signage-card-status-code": "Status code:",
        "merchant-menu-planning-digital-signage-card-status-code--99": "Unknown",
        "merchant-menu-planning-digital-signage-card-status-code--10": "Failed Cleansing",
        "merchant-menu-planning-digital-signage-card-status-code--2": "Failed System Configuration",
        "merchant-menu-planning-digital-signage-card-status-code--1": "Failed Network Configuration",
        "merchant-menu-planning-digital-signage-card-status-code-0": "Not Configured",
        "merchant-menu-planning-digital-signage-card-status-code-1": "Network Configured",
        "merchant-menu-planning-digital-signage-card-status-code-2": "Failed Communication",
        "merchant-menu-planning-digital-signage-card-status-code-3": "Low Battery",
        "merchant-menu-planning-digital-signage-card-status-code-4": "Current Page Design Not Found",
        "merchant-menu-planning-digital-signage-card-status-code-5": "Current Page Product Not Found",
        "merchant-menu-planning-digital-signage-card-status-code-6": "Current Page Failed Update",
        "merchant-menu-planning-digital-signage-card-status-code-7": "Alternate Page Design Not Found",
        "merchant-menu-planning-digital-signage-card-status-code-8": "Alternate Page Product Not Found",
        "merchant-menu-planning-digital-signage-card-status-code-9": "Alternate Page Failed Update",
        "merchant-menu-planning-digital-signage-card-status-code-10": "Ok",
        "merchant-menu-planning-digital-signage-card-status-code-11": "Failed Health Check",
        "merchant-menu-planning-digital-signage-card-status-code-12": "Low Temperature",
        "merchant-menu-planning-digital-signage-card-status-code-20": "Image Overwritten",
        "merchant-menu-planning-digital-signage-card-status-code-50": "Preconfigured",
        "merchant-menu-planning-digital-signage-card-status-code-99": "Queued",
        "merchant-menu-planning-digital-signage-empty": "No digital signage devices found",
        "merchant-menu-planning-digital-signage-dialog-title": "Digital sign",
        "merchant-menu-planning-digital-signage-menu-details": "Details",
        "merchant-menu-planning-digital-signage-menu-clear-sign": "Clear sign",
        "merchant-menu-planning-color-field-label": "\n .label = Color",

        // --- Merchant ---

        // Navigation
        "merchant-nav-item-home": "Home",

        //  - reporting
        "merchant-nav-item-production": "\n .title = Production",
        "merchant-nav-item-menu-planning": "Menu planning",
        "merchant-nav-item-group-menu-planning": "\n .title = Menu planning",
        "merchant-nav-item-menu-planning-header": "Menu planning",
        "merchant-nav-item-menu-planning-v2": "Menu planning v2",
        "merchant-nav-item-group-id-cards": "\n .title = ID cards",
        "merchant-nav-item-id-cards-header": "ID cards",
        "merchant-admin-menu-planning-header": "\n .title = Menu planning",
        "merchant-nav-item-purchase-control": "Purchase control",
        "merchant-nav-item-survey": "Survey",
        "merchant-nav-item-accounting": "Accounting",
        "merchant-nav-item-accounting-page-header": "\n .title = Accounting",
        "merchant-nav-item-production-planning": "Planning",
        "merchant-nav-item-production-meeting-service": "Meeting service",
        "merchant-nav-item-production-meeting-service-view": "Production view",
        "merchant-nav-item-production-takeaway": "Takeaway",
        "merchant-nav-item-production-pos-purchases": "POS purchases",

        //  - admin
        "merchant-nav-item-settings-page-header": "\n .title = Settings",
        "merchant-nav-item-settings-header": "Settings",
        "merchant-nav-item-customer-access": "Customer access",
        "merchant-nav-item-id-cards": "ID cards",
        "merchant-nav-item-custom-jobs":"Custom jobs",
        "merchant-nav-item-merchant-news": "News",
        "merchant-nav-item-messaging": "Push messages",
        "merchant-nav-item-news": "Merchant news",
        "merchant-nav-item-info-displays": "Integration feeds",
        "merchant-info-displays-header": "\n .title = Integration feeds",
        "merchant-info-displays-page-subtitle":
            "Screens published from Facilitynet. Preview a display, share it as a link or embed, or reset its link to revoke access.",
        "merchant-info-displays-filter-all": "All displays",
        "merchant-info-displays-filter-menu": "Menu",
        "merchant-info-displays-filter-production": "Production",
        "merchant-info-displays-count-label": "{ $count } displays",
        "merchant-info-displays-card-thumbnail-label": "display preview",
        "merchant-info-displays-card-status-live": "\n .label = Live",
        "merchant-info-displays-card-status-inactive": "\n .label = Inactive",
        "merchant-info-displays-card-menu-simple-name": "Week menu — Simple (iFrame)",
        "merchant-info-displays-card-menu-simple-description": "Used to show menu on website / intranet.",
        "merchant-info-displays-card-menu-layout-name": "Today's menu — Layout 1",
        "merchant-info-displays-card-menu-layout-description": "Used to display on screen in canteen.",
        "merchant-info-displays-card-production-name": "Production screen",
        "merchant-info-displays-card-production-description":
            "Used to display on screen in the production areas to manage upcoming orders.",
        "merchant-info-displays-menu-preview-item": "Preview",
        "merchant-info-displays-menu-link-item": "Permalink / embed",
        "merchant-info-displays-menu-permalink-item": "Permalink",
        "merchant-info-displays-menu-reset-item": "Reset",
        "merchant-info-displays-menu-inactivate-item": "Inactivate",
        "merchant-info-displays-menu-activate-item": "Activate",
        "merchant-info-displays-link-dialog-embed": "\n .dialogTitle = Permalink / embed\n .subtitle = { $name } — anyone with this link can view the display.",
        "merchant-info-displays-link-dialog-permalink": "\n .dialogTitle = Permalink\n .subtitle = { $name } — anyone with this link can view the display.",
        "merchant-info-displays-link-dialog-permalink-login-required": "\n .dialogTitle = Permalink\n .subtitle = { $name } — requires a Facilitynet login; opens the screen in fullscreen.",
        "merchant-info-displays-link-dialog-permalink-label": "Permalink",
        "merchant-info-displays-link-dialog-embed-label": "Embed code",
        "merchant-info-displays-copy-tooltip": "\n .title = Copy",
        "merchant-info-displays-link-dialog-reset-button": "Reset link",
        "merchant-info-displays-link-dialog-done-button": "Done",
        "merchant-info-displays-copy-success": "Copied to clipboard",
        "merchant-info-displays-reset-dialog":
            "\n .title = Reset link?\n .message = A new link will be generated for { $name }. The current link and any embeds using it stop working immediately.\n .buttonLabelSubmit = Reset link",
        "merchant-nav-item-users": "Administrators",
        "merchant-nav-item-shops": "Shops",
        "merchant-nav-item-payment-links": "Payment links",
        "merchant-nav-item-products": "Products",
        "merchant-nav-item-product-create": "Create product",
        "merchant-nav-item-extra-service-create": 'Create extra service',
        "merchant-nav-item-extra-service-edit": 'Edit extra service',
        "merchant-nav-item-product-update": "Edit product",
        "merchant-nav-item-product-groups": "Product groups",
        "merchant-nav-item-extra-services": "Extra services",
        "merchant-nav-item-product-group-create": "Create product group",
        "merchant-nav-item-product-group-update": "Edit product group",
        "merchant-nav-item-price-lists": "Price lists",
        "merchant-nav-item-price-list-create": "Create price list",
        "merchant-nav-item-price-list-edit": "Edit price list",
        "merchant-nav-item-surveys": "Surveys",
        "merchant-nav-item-devices": "Devices",
        "merchant-nav-item-communication-page-header":"\n .title = Communication",
        "merchant-nav-item-communication-header":"Communication",
        "merchant-nav-item-group-products":"\n .title = Products",
        "merchant-nav-item-products-header":"Products",
        "merchant-nav-item-group-shops":"\n .title = Shops",
        "merchant-nav-item-offers":"Offers",
        "merchant-nav-item-vat-codes":"VAT codes",
        "merchant-nav-item-create-vat-code":"Create VAT code",
        "merchant-nav-item-edit-vat-code":"Edit VAT code",
        "merchant-nav-item-group-organization":"\n .title = Organization",
        "merchant-nav-item-group-account":"\n .title = Account",
        "merchant-nav-item-billing":"Billing",
        "merchant-nav-item-account":"Account",
        "merchant-nav-item-merchant-account":"Merchant account",
        "merchant-nav-item-delivery-locations": "Delivery locations",
        "merchant-nav-item-sales-accounts": "Sales accounts",
        "merchant-nav-item-live-dashboard": "Live dashboard",

        // Admin home
        "merchant-admin-home-products-group": "\n .title = Products",
        "merchant-admin-home-communication-group": "\n .title = Communication",
        "merchant-admin-home-customers-group": "\n .title = Customers",
        "merchant-admin-home-settings-group": "\n .title = Settings",
        "merchant-admin-home-customers-card": "\n .title = Customer access\n .description = Manage customer access to your merchant.",
        "merchant-admin-home-merchant-news-card": "\n .title = Merchant news\n .description = Write and publish news articles for your merchant to your customers.",
        "merchant-admin-home-admin-card": "\n .title = Administrators\n .description = Manage administrators for your merchant.",
        "merchant-admin-home-shop": "\n .title = Shops \n .description = Sell your products through shops with customizable branding.",
        "merchant-admin-home-payment-links": "\n .title = Payment links \n .description = Create a unique payment link for guest or course participants.",
        "merchant-admin-home-products": "\n .title = Products \n .description = Add and maintain products for your shops",
        "merchant-admin-home-product-groups": "\n .title = Product groups \n .description = Group your products and control the visibility of groups throughout the day.",
        "merchant-admin-home-price-list": "\n .title = Price lists\n .description = Use price lists to offer differentiated  products and prices to customers.",
        "merchant-admin-home-extra-services": "\n .title = Extra services\n .description = Add and maintain extra services for your shops.",
        "merchant-admin-home-merchant-surveys": "\n .title = Surveys\n .description = Monitor your customer satisfaction by creating and managing surveys.",
        "merchant-admin-home-push-messages-card": "\n .title = Push messages\n .description = Send and manage messages",
        "merchant-admin-home-info-displays-card":
            "\n .title = Integration feeds\n .description = Preview and share your integration feeds.",
        "merchant-admin-home-devices-card": "\n .title = Devices\n .description = Show devices like screens, printers and credit card terminals.",
        "merchant-admin-home-offers-card": "\n .title = Offers\n .description = Manage your offers",
        "merchant-admin-home-vat-codes-card": "\n .title = VAT codes\n .description = Manage VAT codes",
        "merchant-admin-home-id-cards-card": "\n .title = ID cards\n .description = View your customers ID cards used for POS payments.",
        "merchant-admin-home-id-cards-group": "\n .title = ID cards",
        "merchant-admin-home-menu-planning-card": "\n .title = Menu planning\n .description = Create and manage menu templates.",
        "merchant-admin-home-custom-jobs-card": "\n .title = Custom jobs\n .description = View and run custom jobs for your merchant.",
        "merchant-admin-home-account-group": "\n .title = Account",
        "merchant-admin-home-merchant-account-card": "\n .title = Merchant account\n .description = Maintain your merchant account details\n .buttonText = Show",
        "merchant-admin-home-delivery-locations-card": "\n .title = Delivery locations\n .description = Manage delivery locations where customers can pick up orders.",

        // Merchant > Admin > Settings > Custom jobs
        "merchant-admin-settings-custom-jobs-title":" \n .title = Custom jobs",
        "merchant-admin-settings-custom-jobs-table-name":"Name",
        "merchant-admin-settings-custom-jobs-table-interval":"Interval",
        "merchant-admin-settings-custom-jobs-table-last-run":"Last run",
        "merchant-admin-settings-custom-jobs-table-status":"Status",
        "merchant-admin-settings-custom-jobs-table-action-details":"Details",
        "merchant-admin-settings-custom-jobs-table-action-run-job":"Run job",
        "merchant-admin-settings-custom-jobs-table-action-activate":"Activate",
        "merchant-admin-settings-custom-jobs-table-action-inactivate":"Inactivate",

        // Messages
        "messages-list-header": "\n .title = Push messages",
        "messages-list-create-button": "Create new",
        "merchant-nav-item-messages": "Push messages",
        "messages-table-subject-column" : "Subject",
        "messages-table-publish-time-column": "Publish time",
        "messages-table-expire-time-column": "Expiration time",
        "messages-table-publish-type-filter-label": "Publish type",
        "messages-table-publish-type-filter-label-label": "\n .label = Publish type",
        "messages-table-publish-type-filter-item-published": "Published",
        "messages-table-publish-type-filter-item-upcoming": "Upcoming",
        "messages-table-publish-type-filter-item-expired": "Expired",
        "messages-table-edit-button": "Edit",
        "messages-table-delete-button": "Delete",
        "messages-table-delete-modal-title": "message",
        "messages-table-delete-success-message": "Message was deleted",
        "messages-table-update-delete-dialog-title": "This message can't be updated / deleted",
        "messages-table-update-delete-dialog-description": "Messages can't be updated or deleted because it's published.",
        "messages-table-update-delete-dialog-button": "Close",

        // create / edit messages
        "create-message-header": "\n .title = Create message",
        "edit-message-header": "\n .title = Edit message",
        "nav-item-create-message-header": "Create message",
        "nav-item-edit-message-header": "Edit message",
        "create-message-save-button": "Create",
        "edit-message-save-button": "Save",
        "create-or-edit-message-info": "\n .title = Send short important messages to the users, eg. about closing days, events or similar. Messages will be visible for all users who are connected to your shops.",
        "create-or-edit-message-field-subject":
            "\n .label = Subject\n .placeholder = Add a catchy subject, which users wish to read *\n .helperText = Add a catchy subject, which users wish to read.",
        "create-or-edit-message-dialog-field-subject-label": "Subject:",
        "create-or-edit-message-field-title-page": "\n .label = Subject\n .placeholder = Subject\n .helperText = Add a catchy subject, which users wish to read.",
        "create-or-edit-message-dialog-field-message-label": "Message:",
        "create-or-edit-message-field-message": "\n .label = Message\n .placeholder = Enter a message *\n .helperText = Remaining characters: { $charsRemaining }",
        "create-or-edit-message-settings": "\n .title = Settings",
        "create-or-edit-message-field-publishDate": "\n .label = Publication:",
        "create-or-edit-message-field-publish-title": "Publication:",
        "create-or-edit-message-accordion-title": "Settings",
        "create-or-edit-message-field-publishDate-page": "\n .label = Publication",
        "create-or-edit-message-field-publishDate-helperText": "The time that the message will be visible to users.",
        "create-or-edit-message-field-expirationDate-info": "\n .title = The expiration time only applies to info screen and room screen messages.",
        "create-or-edit-message-field-expirationDate-title": "Expiration:",
        "create-or-edit-message-field-expirationDate": "\n .label = Expiration:",
        "create-or-edit-message-field-expirationDate-page": "\n .label = Expiration",
        "create-or-edit-message-field-title-required": "Subject is required",
        "create-or-edit-message-field-body-required": "Message is required",
        "create-or-edit-message-field-body-too-long": `You have exceed the max amount of characters: { $charsLimit }`,
        "create-or-edit-message-field-channels-required": "Select at least one channel",
        "create-or-edit-message-field-channel-type-mode-in-app": "App message",
        "create-or-edit-message-field-channel-type-description-mode-in-app": "Sent as message in web and app",
        "create-or-edit-message-field-channel-type-mode-push": "Push notification",
        "create-or-edit-message-field-channel-type-description-mode-push": "Send as mobile push notification",
        "create-or-edit-message-field-channel-type-mode-sms": "SMS message",
        "create-or-edit-message-field-channel-type-description-mode-sms": "Send as SMS text message",
        "create-or-edit-message-field-channel-type-mode-email": "Email",
        "create-or-edit-message-field-channel-type-description-mode-email": "Send as an email",
        "create-or-edit-message-field-channel-type-mode-in-app-card": "App card",
        "create-or-edit-message-field-channel-type-description-mode-in-app-card": "Show as a card inside GoPay app",
        "create-or-edit-message-field-channel-type-mode-info-display": "Info screens",
        "create-or-edit-message-field-channel-type-description-mode-info-display": "Show on meeting displays and info displays",
        "create-or-edit-message-field-channel-type-mode-room-display": "Room screens",
        "create-or-edit-message-field-channel-type-description-mode-room-display": "Show on meeting room screens",
        "create-or-edit-message-field-tag": "\n .label = Topic: \n .placeholder = Select a topic",
        "create-or-edit-message-dialog-topic-label": "Topic:",
        "create-or-edit-message-dialog-topic-placeholder": "Select a topic *",
        "create-or-edit-message-field-tag-page": "\n .label = Topic",
        "create-or-edit-message-field-tag-mode-info": "Info",
        "create-or-edit-message-field-tag-description-mode-info": "For general information about the merchant, opening hours, food selection or procedures.",
        "create-or-edit-message-field-tag-mode-important": "Important",
        "create-or-edit-message-field-tag-description-mode-important": "For critical messages such as changes to opening hours, health- and safety related information or other urgent messages.",
        "create-or-edit-message-field-tag-mode-offer": "Offer",
        "create-or-edit-message-field-tag-description-mode-offer": "For offers, discounts, campaigns or special arrangements.",
        "create-or-edit-message-field-tag-mode-menu-change": "Menu",
        "create-or-edit-message-field-tag-description-mode-menu-change": "To inform users about changes to the daily menu, new dishes or seasonal offers.",
        "create-or-edit-message-field-tag-mode-event": "Event",
        "create-or-edit-message-field-tag-description-mode-event": "For upcoming events such as theme days, food festivals or special events in the canteen.",
        "create-or-edit-message-field-tag-mode-reminder": "Reminder",
        "create-or-edit-message-field-tag-description-mode-reminder": "To remind users of important dates or deadlines for example registration for events or deadline for preorder of food.",
        "create-or-edit-message-field-tag-mode-feedback": "Feedback",
        "create-or-edit-message-field-tag-description-mode-feedback": "To request feedback for food and service or customer satisfaction surveys.",
        "create-or-edit-message-field-tag-mode-news": "News",
        "create-or-edit-message-field-tag-description-mode-news": "For updates about the activities of the merchant, measures or changes to operation that could be of interest to customers.",
        "create-or-edit-message-field-tag-mode-health": "Health",
        "create-or-edit-message-field-tag-description-mode-health": "For information about healthy choices, nutrition tips or allergy information related to the menu.",
        "create-or-edit-message-field-tag-mode-social": "Social",
        "create-or-edit-message-field-tag-description-mode-social": "To promote social initiatives, theme days or social events.",
        "create-or-edit-message-field-tag-required": "Tag is required",
        "create-message-success-dialog-title": "Message has been created",
        "create-message-success-dialog-view-archive": "View message archive",
        "create-message-success-dialog-close-button": "Close",
        "create-message-success-dialog-view-list-button": "Go to messages",


        // Customer access
        "merchant-customer-access-header": "\n .title = Customer access",
        "merchant-customer-access-customers-table-name-column": "Name",
        "merchant-customer-access-customers-table-active-column": "Status",
        "merchant-customer-access-customers-table-domains-column": "Domains",
        "merchant-customer-access-customers-table-active-filter-yes": "Active",
        "merchant-customer-access-customers-table-active-filter-no": "Inactive",
        "merchant-customer-access-customers-table-active-column-active": "Active",
        "merchant-customer-access-customers-table-active-column-inactive": "Inactive",

        // Merchant account > Swift dialog
        "merchant-account-swift-dialog-title":"Switch merchant",
        "merchant-account-swift-dialog-subtitle":"You have access to the following merchant. Select one to swift.",
        "merchant-account-swift-dialog-empty-title":"You don't have access to other merchants.",

        // Merchant home
        "merchant-home-today-card-group": "\n .title = POS Sales \n .subtitle = today",
        "merchant-home-todays-control-code": "\n .title = Todays control code",
        "merchant-home-todays-control-code-title": "Todays control code",
        "merchant-home-todays-offers": "Todays offers\n .title = Todays offers",
        "merchant-product-tour-step-welcome": "Welcome to Facilitynet. This is a quick introduction on how to use it.",
        "merchant-product-tour-step-order-notifications-button": "Click here to open an overview of todays orders and activities.",
        "merchant-product-tour-step-order-notifications": "Here you can get an overview of todays orders and activities, that need your attention.",
        "merchant-product-tour-step-new-button": "Click here to open shortcuts for creating messages and orders.",
        "merchant-product-tour-step-new": "Click the New button to create push messages, create meeting service order on behalf of customers and easy shortcuts access",
        "merchant-product-tour-step-environment-button": "Click here to open the menu for switching between environments.",
        "merchant-product-tour-step-environment": "The portal is split into 3 environments that each focus on a particular subject. You change environment here.",
        "merchant-product-tour-step-nav-production": "In Production you can plan and manage orders.",
        "merchant-product-tour-step-nav-menu-planning": "In Menu Planning, you can create weekly menus to keep your customers informed.",
        "merchant-product-tour-step-nav-purchase-control": "Use Purchase control to check that everyone pays for their food.",
        "merchant-product-tour-step-nav-survey": "View the results of user feedback and keep track of user satisfaction.",
        "merchant-product-tour-locale-back": "Back",
        "merchant-product-tour-locale-next": "Next",
        "merchant-product-tour-locale-last": "Finish",
        "merchant-product-tour-locale-skip": "Skip",
        "merchant-product-tour-locale-close": "Close",
        "takeaway-announcement-tour-step-intro": "We have launched a dedicated page for takeaway.",
        "takeaway-announcement-tour-step-nav-takeaway": "From now on you will find takeaway orders here.",
        "merchant-home-number-of-orders": "\n .title = Orders \n .titleTooltip = Number of POS orders for today",
        "merchant-home-turnover": "\n .title = Turnover \n .titleTooltip = Total POS sales amount for today",
        "merchant-home-avg-amount": "\n .title = Avg. amount \n .titleTooltip = Average order amount for today's orders\n .subtitle = DKK",
        "merchant-home-subscriptions": "\n .title = Subscriptions \n .titleTooltip = Today's active lunch subscriptions",
        "merchant-home-takeaway-card-group": "\n .title = Takeaway \n .subtitle = today",
        "merchant-home-takeaway-number-of-orders": "\n .title = Orders \n .titleTooltip = Number of takeaway orders for today",
        "merchant-home-takeaway-turnover": "\n .title = Turnover \n .titleTooltip = Total takeaway sales amount for today",
        "merchant-home-takeaway-avg-amount": "\n .title = Avg. amount \n .titleTooltip = Average order amount for today's takeaway orders\n .subtitle = DKK",
        "merchant-home-statistics-card-group": "\n .title = Statistics",
        "merchant-home-checkin-card": "\n .title = Check-in screen\n .titleTooltip = Shows how many customers remember to scan their proof of purchase on the check-in screen versus how many forget to do it",
        "merchant-home-checkin-card-participants": "Checked in ({ $checkedIn })",
        "merchant-home-checkin-card-none-participants": "Not checked in ({ $notCheckedIn })",
        "merchant-home-checkin-card-participation-percentage": "Percentage",
        "merchant-home-survey-card-empty": "\n .title = Satisfaction",
        "merchant-home-meeting-service-card-group": "\n .title = Meeting service\n .subtitle = Today",
        "merchant-home-meeting-service-number-of-orders-card": "\n .title = Orders\n .titleTooltip = Number of meeting service orders today",
        "merchant-home-meeting-service-awaiting-approval-card": "\n .title = Awaiting approval\n .titleTooltip = Total number of meeting service orders awaiting approval",
        "merchant-home-meeting-service-ready-for-invoicing-card": "\n .title = Ready for invoicing\n .titleTooltip = Total number of meeting service orders awaiting booking",
        "merchant-home-meeting-service-ready-for-invoicing-card-description": "&gt; {$overdueDays} days ago",
        "merchant-home-meeting-service-delivery-planning-card": "\n .title = Delivery planning\n .titleTooltip = Shows the distribution of meeting service orders during today",
        "merchant-home-meeting-service-delivery-planning-delivery": "Delivery",
        "merchant-home-meeting-service-delivery-planning-picked-up": "Picked up",
        "merchant-home-meeting-service-delivery-planning-eating-in-canteen": "Eating in canteen",
        "merchant-home-meeting-service-next-deliveries-card": "\n .title = Next {$numberOfOrders} deliveries\n .titleTooltip = The next 5 deliveries for today",
        "merchant-home-meeting-service-table-name-column": "Customer",
        "merchant-home-meeting-service-table-meeting-column": "Meeting",
        "merchant-home-meeting-service-table-delivery-column": "Delivery",
        "merchant-home-meeting-service-no-upcoming-deliveries": "There are no upcoming deliveries.",
        "merchant-home-views-button": "Live Dashboards",
        "merchant-home-views-dialog-title": "Live Dashboards",
        "merchant-home-views-dialog-subtitle": "Select a dashboard below:",
        "merchant-home-views-dialog-conference": "Conference",
        "merchant-home-views-dialog-conference-live-sales-part-1": "Live",
        "merchant-home-views-dialog-conference-live-sales-part-2": "sales",
        "merchant-home-views-dialog-conference-orders": "Orders",
        "merchant-home-views-dialog-conference-turnover": "Turnover",
        "merchant-home-views-dialog-conference-avg-price": "Avg price",
        "merchant-home-views-dialog-conference-free-riders": "Free riders",
        "merchant-home-views-dialog-conference-satisfaction": "Satisfaction",
        "merchant-home-statistics-pos-turnover-card": "\n .title = POS turnover \n .titleTooltip = Shows POS sales for the selected period versus the sales for the previous period",
        "merchant-home-statistics-pos-orders-card": "\n .title = POS orders \n .titleTooltip = Shows number of POS for the selected period versus the orders for the previous period",
        "merchant-home-statistics-number-of-users-card": "\n .title = Number of users \n .titleTooltip = Shows number of new users for selected period versus new users for previous period",
        "merchant-home-statistics-period-base-3": "Last 3 days",
        "merchant-home-statistics-period-base-14": "Last 14 days",
        "merchant-home-statistics-period-base-30": "Last 30 days",
        "merchant-home-statistics-period-base-60": "Last 60 days",
        "merchant-home-statistics-period-base-180": "Last 180 days",
        "merchant-home-statistics-compared-to-last-period": "compared to last period",

        // Merchant home tooltips
        "merchant-home-todays-control-code-tooltip": "\n .title = This will be displayed on the proof of purchase (app) and the printed receipt",
        "merchant-home-todays-offers-tooltip": "\n .title = Number of active offers for today",

        // Merchant Account
        "merchant-update-account-page-header": "\n .title = Merchant account",
        "merchant-update-account-save-button": "Save",
        "merchant-update-account-opening-hours-title":"\n .title = Opening hours",
        "merchant-update-account-opening-hours-action-button-add":"Add",
        "merchant-update-account-opening-hours-action-button-edit":"Edit",
        "merchant-update-account-opening-hours-empty-text":"Opening hours not set",
        "merchant-update-account-opening-hours-dialog-title":"Opening hours",
        "merchant-update-account-opening-hours-dialog-save-button":"Save",
        "merchant-update-account-opening-hours-dialog-before-start-error":"Before start time",
        "merchant-update-account-opening-hours-dialog-closed-time-select-from":"\n .label = From",
        "merchant-update-account-opening-hours-dialog-time-select-to":"\n .label = To",
        "merchant-update-account-opening-hours-dialog-closed":"Closed",
        "merchant-update-account-opening-hours-day-monday": "Monday",
        "merchant-update-account-opening-hours-day-tuesday": "Tuesday",
        "merchant-update-account-opening-hours-day-wednesday": "Wednesday",
        "merchant-update-account-opening-hours-day-thursday": "Thursday",
        "merchant-update-account-opening-hours-day-friday": "Friday",
        "merchant-update-account-opening-hours-day-saturday": "Saturday",
        "merchant-update-account-opening-hours-day-sunday": "Sunday",



        //Merchant reports
        "merchant-reports-id-cards-title": "\n .title = ID cards",
        "merchant-reports-id-cards-nav-item-home": "Home",
        "merchant-reports-id-cards-nav-item-id-cars": "ID cards",

        // Merchant ID table
        "merchant-id-cards-table-card-number": "Card number",
        "merchant-id-cards-table-card-type": "Card type",
        "merchant-id-cards-table-user": "User",
        "merchant-id-cards-table-company": "Company",
        "merchant-id-cards-table-status": "Status",
        "merchant-id-cards-table-card-type-select-label": "\n .label = Card type",
        "merchant-id-cards-table-company-select-label": "\n .label = Company",
        "merchant-id-cards-table-card-type-select-item-wallet":"Wallet",
        "merchant-id-cards-table-card-type-select-item-company-credit":"Company credit",
        "merchant-id-cards-table-card-type-select-item-tickets":"Tickets",
        "merchant-id-cards-table-card-type-select-item-unlimited-tickets":"Unlimited tickets",
        "merchant-id-cards-table-card-type-select-item-tickets-unlimited":"Unlimited tickets",
        "merchant-id-cards-table-card-type-select-item-top-up": "Top up",
        "merchant-id-cards-table-card-type-select-item-payroll-deduction": "Payroll deduction",


        // Merchant ID Cards Dialog
        "merchant-id-cards-dialog-title": "ID card details",
        "merchant-id-cards-dialog-status": "Status:",
        "merchant-id-cards-dialog-card-name": "Card name:",
        "merchant-id-cards-dialog-card-type": "Card type:",
        "merchant-id-cards-dialog-card-type-top-up": "Top up",
        "merchant-id-cards-dialog-card-type-wallet": "Wallet",
        "merchant-id-cards-dialog-card-type-company-credit": "Company credit",
        "merchant-id-cards-dialog-card-type-tickets": "Tickets",
        "merchant-id-cards-dialog-card-type-tickets-unlimited": "Tickets unlimited",
        "merchant-id-cards-dialog-card-type-payroll-deduction": "Payroll deduction",
        "merchant-id-cards-dialog-validated": "Validated:",
        "merchant-id-cards-dialog-expiry": "Expiry:",
        "merchant-id-cards-dialog-payment-method": "Payment method:",
        "merchant-id-cards-dialog-user-id": "User ID:",
        "merchant-id-cards-dialog-employee-id": "Employee ID:",
        "merchant-id-cards-dialog-name": "Name:",
        "merchant-id-cards-dialog-email": "Email:",
        "merchant-id-cards-dialog-mobile": "Mobile:",
        "merchant-id-cards-dialog-phone": "Phone:",

        "id-cars-table-button-details": "Details",
        "id-cars-filter-card-title":"\n .title = Card",
        "id-cars-filter-debtor-title":"\n .title = Debtor",
        "id-cars-filter-end-user-title":"\n .title = End user",
        "id-cars-filter-card-number-label":"\n .label = Card number \n .placeholder = Search by card number",
        "id-cars-filter-switch-label":"\n .label = Include inactive cards",
        "id-cars-filter-debtor-label":"\n .label = Debtor",
        "id-cars-filter-email-label":"\n .label = Email",
        "id-cars-filter-employee-id-label":"\n .label = Employee ID",

        "merchant-production": "Production",

        // Merchant > Admin > Shops > Products
        "products-page-header": "\n .title = Products",
        "products-tab-all-products": "All products",
        "products-tab-sort-products": "Sort products",
        "products-table-info-box": "Please select a shop to proceed",
        "products-table-show-inactive": "\n .label = Show inactive",
        "products-move-availability-dialog":
            "\n .title = Narrow the product's availability?\n .message = “{ $productName }” is available outside the days or hours of “{ $groupName }”. After the move it will be available: { $days }, { $hours }.\n .buttonLabelSubmit = Move and narrow\n .buttonLabelCancel = Cancel",
        "products-move-availability-dialog-no-overlap-alert":
            "\n .title = The product has no days or hours in common with the group, so its own days and hours are replaced by the group's.",
        "products-move-availability-dialog-every-day-label": "every day",
        "products-move-availability-dialog-all-day-label": "all day",
        "products-page-table-price-list-label": "\n .label = Price list",
        "products-no-price-list-tab": "No price list",
        "products-action-bar-move-to-price-list": "Move to price list",
        "products-action-bar-copy-to-price-list": "Copy to price list",
        "products-action-bar-status": "\n .title = Status",
        "products-action-bar-set-active": "\n .title = Active",
        "products-action-bar-set-inactive": "\n .title = Inactive",
        "products-select-price-list-label": "Select price list:",
        "products-move-to-price-list-dialog-title": "Move to price list",
        "products-copy-to-price-list-dialog-title": "Copy to price list",
        "products-price-list-dialog-accordion-title": "Products ({ $count })",
        "products-name-column": "Name",
        "products-price-column": "Price",
        "products-status-column": "Status",
        "products-create-product-button": "Create new",
        "merchant-admin-enable-product-sort-button": "Enable product sort",
        "merchant-admin-enable-product-sort-info": "\n .title = When you first enable product sort, we will sort the products and product groups in a default order. From there you can move them around as you wish.",
        "products-edit-product-menu-item": "Edit",
        "products-delete-product-menu-item": "Delete",
        "products-confirm-delete-product-dialog": "\n .typeOfEntity = product",
        "products-export-id": "Product ID",
        "products-export-product-number": "Product number",
        "products-export-group": "Product group",
        "products-export-name": "Product name",
        "products-export-price": "Price",
        "products-export-status": "Status",
        "products-export-stock-total": "Stock total",
        "products-export-items-for-sale-per-day": "Items for sale per day",
        "products-export-items-left-today": "Items left today",
        "product-offer-chip": "\n .label = Offer",

        // Merchant > Admin > Products > Info icons
        "product-info-icon-deadline-label": "Deadline",
        "product-info-icon-deadline-value": "{ $daysBefore } days before, at { $timeOfDay }",
        "product-info-icon-availability-label": "Availability",
        "product-info-icon-offer-label": "Offer",
        "product-info-icon-offer-percentage-value": "-{ $percentage }%",
        "product-info-icon-offer-discount-price-value": "Discounted price",
        "product-info-icon-marketing-tag-label": "Marketing tag",
        "product-info-icon-allergens-label": "Allergens",
        "product-info-icon-allow-pre-order-label": "Allow pre-order",
        "product-info-icon-description-label": "Description",
        "product-info-icon-pin-code-label": "PIN code",
        "product-info-icon-pin-code-value": "Required",
        "products-edit-product-group-menu-item": "Edit",
        "products-delete-product-group-menu-item": "Delete",

        // Merchant > Admin > Shops > Price list dropdown selector
        "price-list-dropdown-selector-field-label": "Price list",
        "price-list-dropdown-selector-placeholder": "Select price list",
        "price-list-dropdown-selector-active-only-checkbox": "\n .label = Active only",
        "price-list-dropdown-selector-inactive-chip": "\n .label = Inactive",
        "price-list-dropdown-selector-internal-note-label": "Internal note",
        "price-list-dropdown-selector-message-to-customers-label": "Message to customers",
        "price-list-dropdown-selector-no-info": "No additional info",
        "price-list-dropdown-selector-vat-inclusive": "Price incl. VAT",
        "price-list-dropdown-selector-vat-exclusive": "Price excl. VAT",

        // Merchant > Admin > Products > Stock
        "product-stock-chip-label": "Stock: { $count }",
        "product-stock-daily-sales": "Sold today: { $sold }/{ $total }",
        "product-stock-on-sale-per-day-label": "On sale per day:",
        "product-stock-on-sale-per-day-info": "\n .title = Using this you can limit the number of items on sale each day.\n .description = Using this you can limit the number of items on sale each day.",
        "product-stock-on-sale-per-day-required-error": "On sale per day is required",
        "product-stock-on-sale-per-day-min-error": "On sale per day must be at least 1",
        "product-stock-total-stock-label": "Total stock:",
        "product-stock-total-stock-items": "{ $count } items",
        "product-stock-current-stock-label": "Current stock:",
        "product-stock-tab-inventory": "Stock adjustment",
        "product-stock-tab-daily": "On sale per day",
        "product-stock-type-label": "\n .label = Type:",
        "product-stock-type-option-inbound": "Add to stock",
        "product-stock-type-option-outbound": "Remove from stock",
        "product-stock-adjustment-amount-label": "Quantity:",
        "product-stock-adjustment-amount-tooltip": "\n .title = Enter the quantity to adjust",
        "product-stock-reason-label": "Reason:",
        "product-stock-reason-tooltip": "\n .title = Select the reason for this stock adjustment",
        // Outbound reasons
        "product-stock-reason-option-sold": "Sold",
        "product-stock-reason-tooltip-sold": "\n .title = Items sold to a customer.",
        "product-stock-reason-option-reserved": "Reserved",
        "product-stock-reason-tooltip-reserved": "\n .title = Stock set aside for a specific order.",
        "product-stock-reason-option-shipped": "Shipped",
        "product-stock-reason-tooltip-shipped": "\n .title = Items have left the facility.",
        "product-stock-reason-option-returned-to-vendor": "Returned to vendor",
        "product-stock-reason-tooltip-returned-to-vendor": "\n .title = Items sent back to the supplier.",
        "product-stock-reason-option-consumed-in-production": "Consumed in production",
        "product-stock-reason-tooltip-consumed-in-production": "\n .title = Ingredients used during food preparation.",
        "product-stock-reason-option-scrapped": "Discarded",
        "product-stock-reason-tooltip-scrapped": "\n .title = Items discarded as unusable.",
        "product-stock-reason-option-lost": "Lost",
        "product-stock-reason-tooltip-lost": "\n .title = Item cannot be located.",
        "product-stock-reason-option-stolen": "Stolen",
        "product-stock-reason-tooltip-stolen": "\n .title = Items removed through theft.",
        "product-stock-reason-option-sample-given": "Sample given",
        "product-stock-reason-tooltip-sample-given": "\n .title = Items given away for tasting or testing.",
        // Inbound reasons
        "product-stock-reason-option-purchased": "Purchased",
        "product-stock-reason-tooltip-purchased": "\n .title = New stock received from a supplier.",
        "product-stock-reason-option-returned-from-customer": "Returned by customer",
        "product-stock-reason-tooltip-returned-from-customer": "\n .title = Items returned to stock by a customer.",
        "product-stock-reason-option-produced": "Produced",
        "product-stock-reason-tooltip-produced": "\n .title = Finished goods added after preparation.",
        "product-stock-reason-option-found-during-count": "Found during count",
        "product-stock-reason-tooltip-found-during-count": "\n .title = Extra stock discovered during inventory.",
        "product-stock-reason-option-transferred-in": "Transferred in",
        "product-stock-reason-tooltip-transferred-in": "\n .title = Stock moved from another location.",
        "product-stock-items-per-day-label": "Items on sale per day",
        "product-stock-items-per-day-tooltip": "\n .title = Number of items available for sale each day",
        "product-stock-note-label": "Note:",
        "product-stock-note-placeholder": "\n .placeholder = Optional extra info about adjustment",
        "product-stock-confirm-button": "Confirm",
        "product-stock-cancel-button": "Cancel",
        "product-stock-adjustment-button": "Stock adjustment",
        "product-stock-update-success": "Stock updated successfully",
        "product-create-stock-switch-label": "Stock management:",
        "product-create-stock-total-field": "\n .label = Total stock",
        "product-create-stock-items-per-day-field": "\n .label = Items per day",
        "product-create-stock-info": "Set the total stock count and how many items can be sold per day.",

        // Merchant > Admin > Extra Services
        "extra-services-page-header": "\n .title = Extra services",
        "extra-services-edit-submit-button": "Save",
        "extra-services-create-service-button": "Create new",
        "extra-services-services-column": "Services",
        "extra-services-service-type-column": "Service type",
        "extra-services-price-type-column": "Price type",
        "extra-services-status-column": "Status",
        "extra-services-price-subline-fixed": "Fixed price",
        "extra-services-price-subline-per-seat": "Price per seat",
        "extra-services-price-subline-min": "Min price",
        "extra-services-price-subline-max": "Max price",

        // Merchant > Admin > Extra Services > Create / Edit
        "extra-services-create-page-header": "\n .title = Create extra service",
        "extra-services-edit-page-header": "\n .title = Edit extra service",
        "extra-services-create-active-switch": "Active:",
        "extra-services-create-mandatory": "Always add to order",
        "extra-services-create-mandatory-without-pickup": "Add when picked up",
        "extra-services-create-meeting-location-required-switch": "Require meeting location",
        "extra-services-create-meeting-time-required-switch": "Require meeting time",
        "extra-services-create-service-time-weekdays-min-error": "Please select at least one day",
        "extra-services-create-price-field-label": "\n .label = Price",
        "extra-services-create-min-price-field-label": "\n .label = Min.price",
        "extra-services-create-max-price-field-label": "\n .label = Max.price",
        "extra-services-create-price-per-seat-field-label": "\n .label = Price per seat",
        "extra-services-create-currency-field-label": "\n .label = Currency",
        "extra-services-create-service-description-field":  "\n .label = Description",
        "extra-services-create-service-description-field-max-length": "Description cannot exceed { $maxLength } characters",
        "extra-services-create-service-name-field":  "\n .label = Name",
        "extra-services-create-service-type-field":  "\n .label = Service type",
        "extra-services-create-service-pricing-type-field":  "\n .label = Pricing type",
        "extra-services-create-panel-pricing": "\n .label = Pricing",
        "extra-services-create-settings-panel": "\n .title = Settings",
        "extra-services-create-service-time-panel": "\n .title = Available time",
        "extra-services-create-form-type-dropdown-item-pickup-fee": "Pickup fee",
        "extra-services-create-form-type-dropdown-item-eat-in-canteen-fee": "Eat in canteen fee",
        "extra-services-create-form-type-dropdown-item-delivery-fee": "Delivery fee",
        "extra-services-create-form-type-dropdown-item-table-setting-fee": "Table setting fee",
        "extra-services-create-form-type-dropdown-item-cleanup-fee": "Cleanup fee",
        "extra-services-create-form-type-dropdown-item-out-of-opening-hours-fee": "Out of opening hours fee",
        "extra-services-create-form-type-dropdown-item-other": "Other",
        "extra-services-create-form-pricing-type-dropdown-item-per-seat": "Per seat",
        "extra-services-create-form-pricing-type-dropdown-item-flat-fee": "Flat fee",
        "extra-services-create-when-add-to-order-field": "\n .label = Action",
        "extra-services-create-when-add-to-order-no-action": "No actions selected",
        "extra-services-create-form-action-dropdown-item-add-always": "Add always",
        "extra-services-create-form-action-dropdown-item-add-when-pick-up": "Add when pick up",
        "extra-services-create-form-action-dropdown-item-add-when-delivered": "Add when delivered",

        // Merchant > Admin > Shops > Products > Create / Edit
        "product-create-page-header": "\n .title = Create product",
        "product-create-submit-button": "Create",
        "product-edit-page-header": "\n .title = Edit product",
        "product-edit-submit-button": "Save\n .loadingLabel = Saving...",
        "product-create-shops-field-label": "Shops",
        "product-create-group-field-label": "\n .label = Product group",
        "product-create-number-field-label": "\n .label = Product number",
        "product-create-name-field-label": "\n .label = Product name",
        "product-create-price-field-label": "\n .label = Price",
        "product-create-price-field-title": "Price",
        "product-create-price-field-vat-included-badge": "\n .label = Incl. VAT",
        "product-create-price-field-vat-excluded-badge": "\n .label = Excl. VAT",
        "product-create-price-field-no-price-list-badge": "\n .label = Select price list",
        "product-create-price-field-no-price-list-placeholder": "Select price list first",
        "product-create-currency-field-label": "\n .label = Currency",
        "product-create-description-field-label": "\n .label = Description",
        "product-create-panel-access": "\n .title = Access",
        "product-create-panel-access-shop-alert-title": "\n .title = A shop represents a virtual or physical point of sale, such as webshops in the GoPay app or the shop connected to POS terminals in a canteen. A user that is NOT connected to a price list will see the products that are directly assigned to shops here. ",
        "product-create-panel-access-price-list-alert-title": "\n .title = Price lists can be used to offer different selections of products or different prices to different groups of users. Several price lists can be associated with the same shop in order to show different selections. A user will always see a single price list - or - the default selection. What price list is shown depends on the user group or - in the case of POS - the subscription type of the user.",
        "product-create-panel-description": "\n .title = Description",
        "product-create-image-field-label": "\n .label = Image",
        "create-image-file-support": "File types supported: { $supportedFileTypes }. Max size: { $maxSize }",
        "product-create-general-panel": "\n .title = General",
        "product-create-active-switch": "Active:",
        "product-create-admin-only-switch": "Staff only:",
        "product-create-product-description-panel": "\n .title = Product description",
        "product-create-product-description-marketing-tag-field": "\n .label = Marketing tag\n .helperText = Examples: 'Offer', 'CO2', 'Hot dish', 'Vegetarian'",
        "product-create-product-description-allergens-field": "\n .label = Allergens",
        "product-create-availability-panel": "\n .title = Availability\n .description = Limit to specific days and times",
        "product-create-availability-from-date-picker": "\n .label = From date",
        "product-create-availability-to-date-picker": "\n .label = To date",
        "product-create-availability-preorder-switch": "Disallow pre-order:",
        "product-create-availability-info": "Customers can pre-order products for future dates in the GoPay app unless you disallow it here.",
        "product-create-availability-date-error": "End date cannot be before start date",
        "product-create-availability-week-days-label": "Available on:",
        "product-create-availability-week-days-helper-text": "Leave all days unselected to sell the product every day.",
        "product-create-availability-week-days-group-helper-text": "Only the product group's days can be selected. Leave all days unselected to sell the product on all of them.",
        "product-create-availability-week-days-group-error": "Select only days when the product group is available",
        "product-create-availability-from-time-picker": "\n .label = From time",
        "product-create-availability-to-time-picker": "\n .label = To time",
        "product-create-availability-time-helper-text": "Leave both times empty to sell the product all day.",
        "product-create-availability-time-group-helper-text": "Must be within the product group's hours, { $start } – { $end }. Leave both times empty to use the product group's hours.",
        "product-create-availability-time-incomplete-error": "Set both 'From time' and 'To time'",
        "product-create-availability-time-error": "'To time' should be greater than 'From time'",
        "product-create-availability-time-group-error": "Times must be within the product group's hours",
        "product-create-deadline-panel": "\n .title = Deadline\n .description = How long before delivery orders must be placed",
        "product-create-deadline-purchases-subtitle": "Purchases:",
        "product-create-deadline-cancellation-subtitle": "Cancellation:",
        "product-create-deadline-day-field": "\n .label = Day",
        "product-create-deadline-day-limit-day-before": "The day before",
        "product-create-deadline-day-limit-x-days-before": "{ $daysBefore } days before",
        "product-create-deadline-time-picker": "\n .label = Time",
        "product-create-barcode-panel": "\n .title = ERP numbers",
        "product-create-barcode-field-label": "\n .label = Barcode",
        "product-create-sales-rules-panel": "\n .title = Sales rules",
        "product-create-offer-panel": "\n .title = Offer\n .description = Temporarily reduced price for a period",
        "product-create-offer-discount-percentage": "Discount percentage:",
        "product-create-offer-discount-price": "New price:",
        "product-create-offer-items-in-stock": "Items in stock:",
        "product-create-offer-available-from": "Available from:",
        "product-create-offer-available-to": "Available to:",
        "product-create-offer-edit-button": "Edit",
        "product-create-offer-create-button": "Create",
        "product-create-offer-dialog-create-title": "Create offer",
        "product-create-offer-dialog-edit-title": "Edit offer",
        "product-create-offer-dialog-normal-price": "Original price:",
        "product-create-offer-dialog-price-adjustment-field": "\n .label = Price adjustment",
        "product-create-offer-dialog-price-adjustment-option-none": "None",
        "product-create-offer-dialog-price-adjustment-option-discount-price": "Discount",
        "product-create-offer-dialog-price-adjustment-option-discount-percentage": "Discount percentage",
        "product-create-offer-dialog-adjust-price-field": "\n .label = New price",
        "product-create-offer-dialog-items-field": "Available items per day:",
        "product-create-offer-dialog-percentage-field": "\n .label = Percentage",
        "product-create-offer-dialog-available-offer-period": "Offer period",
        "product-create-offer-dialog-available-from-date-picker": "\n .label = Available from",
        "product-create-offer-dialog-available-to-date-picker": "\n .label = Available to",
        "product-create-offer-dialog-marketing-tag-label": "Marketing tag:",
        "product-create-offer-dialog-marketing-tag-mode-old-new-price-new": "25,00 kr",
        "product-create-offer-dialog-marketing-tag-mode-old-new-price-old": "35,00 kr",
        "product-create-offer-dialog-marketing-tag-mode-old-new-price": "25,00 kr 35,00 kr",
        "product-create-offer-dialog-marketing-tag-mode-save-x": "Save -[x] %",
        "product-create-offer-dialog-marketing-tag-mode-limited-on-sale": "Save [x] kr",
        "product-create-offer-dialog-marketing-tag-mode-great-offer": "Great offer",
        "product-create-offer-dialog-marketing-tag-mode-buy-now": "Buy now",
        "product-create-offer-dialog-marketing-tag-mode-good-price": "Good price",
        "product-create-offer-dialog-marketing-tag-mode-discount": "Discount",
        "product-create-offer-dialog-marketing-tag-mode-week-offer": "Week's offer",
        "product-create-offer-dialog-marketing-tag-mode-day-offer": "Todays offer",
        "product-create-offer-dialog-save-button": "Save",
        "product-create-add-price-list-button": "Add to price list",
        "product-create-add-to-price-list": "Add to price list",
        "product-create-price-list-step-one": "Select price list",
        "product-create-price-list-step-two": "Specify price",
        "product-create-price-list-table-name-column": "Name",
        "product-create-price-list-table-status-column": "Status",
        "product-create-price-list-table-active-column-active": "Active",
        "product-create-price-list-table-active-column-inactive": "Inactive",
        "product-create-price-list-table-active-column-active-filter-yes": "Active",
        "product-create-price-list-table-active-column-inactive-filter-no": "Inactive",
        "product-create-price-list-table-currency": "Currency:",
        "product-create-price-list-table-vat": "VAT:",
        "product-create-price-list-table-connected-shops": "Connected shops:",
        "product-create-price-list-table-connected-customers": "Connected customers:",
        "product-create-price-list-table-vat-code": "VAT code:",
        "product-create-price-list-table-select-button": "Select",
        "product-create-price-list-selected-price-list": "Selected price list:",
        "product-create-price-list-price-field-label": "\n .label = Price",
        "product-create-price-list-add-button": "Add",
        "product-create-payment-panel": "\n .title = Payment",
        "product-create-pos-panel": "\n .title = POS",
        "product-create-payment-price-switch": "Hide price:",
        "product-create-variable-price-switch": "Activate variable price:",
        "product-create-require-staff-pin-switch": "Require staff PIN:",
        "product-create-price-disabled-tooltip": "\n .title = Price is disabled because variable price is active",
        "product-create-delivery-panel": "\n .title = Delivery",
        "product-create-delivery-deliveryDetails-field": "\n .label = Pickup location",
        "product-create-order-limits-panel": "\n .title = Order limits",
        "product-create-price-lists-field-label": "\n .label = Price lists",
        "product-create-price-list-field-label": "\n .label = Price list",
        "products-no-price-lists-message": "You don't have a price list yet. You must create a price list before creating products.",
        "products-go-to-price-lists-button": "Go to price lists",
        "product-create-item-limits-panel": "\n .title = Item limits",
        "product-create-item-limits-max-field": "Max. daily items per person:",
        "product-create-item-limits-max-info": "This determines how many items total of this type a customer can order per day.",
        "product-create-item-limits-min-field": "Min. items per order:",
        "product-create-item-limits-min-info": "This determines minimum number of items of this type a customer has to add to an order.",
        "product-create-item-limits-error": "Either max daily items or min items per order must be filled out",
        "product-create-item-limits-min-error": "Min items per order should be empty or >= 2",
        "product-create-item-limits-max-error": "Max daily items should be empty or >= 1",


        // Merchant > Admin > Shops > Product groups
        "product-groups-page-header-title": "\n .title = Product groups",
        "product-groups-create-button": "Create new",
        "product-groups-no-price-lists-message": "You don't have a price list yet. You must create a price list before creating product groups.",
        "create-product-group-create-button": "Create",
        "create-product-group-save-button": "Save",
        "product-group-page-title-create": "\n .title = Create product group",
        "product-group-page-title-update": "\n .title = Edit product group",
        "product-group-edit-products-outside-availability-dialog":
            "\n .title = Narrow the products' availability?\n .message = These products have their own days or hours outside the group's new availability. They will be narrowed to the group's days and hours.\n .buttonLabelSubmit = Save and narrow\n .buttonLabelCancel = Cancel",
        "product-group-edit-products-outside-availability-dialog-no-overlap-description":
            "No days or hours in common with the group, so it will follow the group's availability.",
        "product-group-delete": "product group",
        "product-group-delete-success-message": "Product group deleted",
        "product-group-code-column-header": "ERP no.",
        "product-group-name-column-header": "Name",
        "product-group-status-column-header": "Status",

        // Merchant > Admin > Shops > Product groups > Create / Edit
        "product-group-form-name-field": "\n .label = Name",
        "product-group-form-code-field": "\n .label = ERP number",
        "product-group-form-code-field-helper-text": "ERP numbers are used when integrating with an accounting system. They are created by a supplier admin.",
        "product-group-form-code-field-helper-text-no-items": "No available product codes for supplier",
        "product-group-form-settings-panel": "\n .title = Settings",
        "product-group-form-active-switch": "Active:",
        "product-group-form-pin-code-required-switch": "PIN code required:",
        "product-group-form-pin-code-required-explanation": "Products in this group will require a staff PIN code to purchase. PIN code can be seen in device details.",
        "product-group-form-limited-availability-panel-title": "\n .title = Limited availability \n .offContent = Products in this group are always available for purchase",
        "product-group-form-start-time-picker": "\n .label = From time",
        "product-group-form-end-time-picker": "\n .label = To time",
        "product-group-form-week-day-monday": "Monday",
        "product-group-form-week-day-tuesday": "Tuesday",
        "product-group-form-week-day-wednesday": "Wednesday",
        "product-group-form-week-day-thursday": "Thursday",
        "product-group-form-week-day-friday": "Friday",
        "product-group-form-week-day-saturday": "Saturday",
        "product-group-form-week-day-sunday": "Sunday",
        "product-group-form-end-time-picker-min-error-label": "Should be greater than 'From time'",


        // Merchant > Admin > Shops > Price lists
        "price-lists-header": "\n .title = Price lists",
        "price-lists-create-button": "Create new",
        "price-list-vat-code": "VAT code:",
        "price-list-currency": "Currency:",
        "price-list-shops": "Connected Shops:",
        "price-list-company": "Connected Company:",
        "price-list-no-result": "There are no price lists. Please create you first price list",
        "price-list-delete": "price list",
        "price-list-delete-success-message": "Price list deleted",

        // Merchant > Admin > Price lists > Adjust prices
        "price-lists-adjust-prices-action": "Adjust prices",
        "adjust-price-list-page-header": "\n .title = Adjust prices",
        "adjust-price-list-breadcrumb": "Adjust prices",
        "adjust-price-list-page-subtitle": "{ $priceList } · { $count } items",
        "adjust-price-list-cancel-button": "Cancel",
        "adjust-price-list-scope-select-all": "Select all",
        "adjust-price-list-scope-deselect-all": "Deselect all",
        "adjust-price-list-preview-summary": "{ $count ->\n [one] { $count } item\n *[other] { $count } items\n } changed · e.g. { $from } → { $to }",
        "adjust-price-list-preview-show": "Show prices",
        "adjust-price-list-preview-hide": "Hide",
        "adjust-price-list-preview-showing": "Showing { $shown } of { $total } items.",
        "adjust-price-list-preview-show-all": "Show all",
        "adjust-price-list-summary-change": "Change",
        "adjust-price-list-summary-change-value": "{ $sign }{ $value }",
        "adjust-price-list-summary-rounding": "Rounding",
        "adjust-price-list-summary-rounding-none": "None",
        "adjust-price-list-summary-rounding-quarter": "{ $step }",
        "adjust-price-list-summary-rounding-half": "{ $step }",
        "adjust-price-list-summary-rounding-whole": "Whole { $currency }",
        "adjust-price-list-submit-button": "Approve",
        "adjust-price-list-adjustment-panel": "\n .title = Adjustment",
        "adjust-price-list-banner": "\n .title = A price adjustment creates a new price list\n .description = The current list is left untouched. You decide when the new list takes effect and which list it takes over from — the old one is deactivated automatically on that date.",
        "adjust-price-list-base-list-field": "\n .label = Take prices over from\n .helperText = Chosen when you opened the adjustment.",
        "adjust-price-list-scope-subtitle-empty": "Choose at least one product group.",
        "adjust-price-list-preview-showing-all": "Showing all { $total } items.",
        "adjust-price-list-direction-increase": "Raise prices",
        "adjust-price-list-direction-reduction": "Lower prices",
        "adjust-price-list-value-field": "\n .label = By how much?",
        "adjust-price-list-value-max-value": "The value cannot exceed { $max } { $unit }",
        "adjust-price-list-value-negative-price": "This change would make at least one price negative. Choose a smaller value.",
        "adjust-price-list-value-no-change": "This adjustment does not change any price. Choose a larger value or other product groups.",
        "adjust-price-list-value-field-name": "Value",
        "adjust-price-list-no-prices": "This price list has no prices to adjust.",
        "adjust-price-list-unit-percentage": "%",
        "adjust-price-list-unit-amount": "{ $currency }",
        "adjust-price-list-rounding-field": "\n .label = Rounding",
        "adjust-price-list-rounding-hint-none": "Prices may end up like { $example0 }.",
        "adjust-price-list-rounding-hint-quarter": "E.g. { $example0 } or { $example1 }.",
        "adjust-price-list-rounding-hint-half": "E.g. { $example0 } or { $example1 }.",
        "adjust-price-list-rounding-hint-whole": "E.g. { $example0 } or { $example1 }.",
        "adjust-price-list-rounding-none": "No rounding",
        "adjust-price-list-rounding-quarter": "Nearest { $step }",
        "adjust-price-list-rounding-half": "Nearest { $step }",
        "adjust-price-list-rounding-whole": "Nearest whole { $currency }",
        "adjust-price-list-summary-empty": "Choose how much to change the prices by, and from which date.",
        "adjust-price-list-summary-raises": "Raises { $count } items by { $value } from { $date }.",
        "adjust-price-list-summary-lowers": "Lowers { $count } items by { $value } from { $date }.",
        "adjust-price-list-effective-from-field": "\n .label = Effective from",
        "adjust-price-list-customers-notice": "\n .title = Customers see the change\n .description = Prices are updated in { $shops ->\n [one] { $shops } shop\n *[other] { $shops } shops\n } for { $customers } customers.",
        "adjust-price-list-effective-from-invalid": "Choose today or a later date",
        "adjust-price-list-existing-orders-note-kept": "Unposted orders keep their current prices.",
        "adjust-price-list-existing-orders-note-updated": "Unposted orders delivering from { $date } get the new prices.",
        "adjust-price-list-existing-orders-checkbox": "Update these orders too",
        "adjust-price-list-existing-orders-title": "Unposted orders",
        "adjust-price-list-scope-panel": "\n .title = Scope",
        "adjust-price-list-scope-subtitle-all": "All product groups · { $items } items",
        "adjust-price-list-scope-subtitle-some": "{ $groups } of { $total } groups · { $items } items",
        "adjust-price-list-scope-required": "Choose at least one product group",
        "adjust-price-list-preview-panel": "\n .title = Preview",
        "adjust-price-list-preview-empty": "Enter a percentage and pick at least one product group to see the new prices.",
        "adjust-price-list-preview-column-item": "Item",
        "adjust-price-list-preview-column-now": "Now",
        "adjust-price-list-preview-column-new": "New price",
        "adjust-price-list-preview-column-change": "Change",
        "adjust-price-list-summary-panel": "\n .title = What it adds up to",
        "adjust-price-list-summary-items": "Items affected",

        // Merchant > Admin > Shops > Price lists > Create / Edit
        "create-price-list-page-header": "\n .title = Create price list",
        "edit-price-list-page-header":"\n .title = Edit price list",
        "create-price-list-save-button": "Save",
        "create-price-list-create-button": "Create",
        "create-price-list-tab-general": "General",
        "create-price-list-tab-customers": "Customers",
        "create-price-list-tab-products": "Products",
        "create-price-list-tab-pos": "POS",
        "create-price-list-required-name": "Name is required",
        "create-price-list-required-shops": "You must attach the price list to one or more shops",
        "create-price-list-required-price-adjustment": "Price adjustment is required",
        "create-price-list-required-currency-code": "Currency is required",
        "create-price-list-required-percentage": "Percentage is required",
        "create-price-list-max-percentage":"Percentage cannot be more than 100",
        "create-or-edit-price-list-field-name":"\n .label = Name",
        "create-or-edit-price-list-field-shops":"\n .label = Shops",
        "create-or-edit-price-list-field-aside-settings":"\n .title = Settings",
        "create-or-edit-price-list-field-active":"Active:",
        "create-or-edit-price-list-field-message-to-customers":"\n .label = Message to customers",
        "create-or-edit-price-list-aside-pricing":"\n .title = Pricing",
        "create-or-edit-price-list-field-price-includes-vat":"Price list incl. VAT:",
        "create-or-edit-price-list-field-vat-code":"\n .label = VAT code",
        "create-or-edit-price-list-field-currency-code":"\n .label = Currency",
        "create-or-edit-price-list-field-dropdown-dkk":"DKK",
        "create-or-edit-price-list-field-price-adjustment":"\n .label = Price adjustment",
        "create-or-edit-price-list-field-dropdown-none":"None",
        "create-or-edit-price-list-field-dropdown-discount": "Discount",
        "create-or-edit-price-list-field-dropdown-increase": "Increase",
        "create-or-edit-price-list-field-internal-note":"\n .placeholder = Internal note",
        "create-or-edit-price-list-field-percentage":"Percentage (%):",
        "create-or-edit-price-list-customer-table-header-name":"Name",
        "create-or-edit-price-list-customer-table-header-user-group":"User group",
        "create-or-edit-price-list-customer-table-button-remove":"Remove",
        "create-or-edit-price-list-customer-table-button-details":"Details",
        "create-or-edit-price-list-customer-subtitle":"If no customers are added here, then all customers can access the price list.",
        "create-or-edit-price-list-customer-table-title":"Customers with access",
        "create-or-edit-price-list-customer-button-add-customer":"Add customer",
        "create-or-edit-price-list-customer-table-empty-state":"All customers have access",
        "create-or-edit-price-list-general-tab-error":"General tab has validation errors",
        "create-or-edit-price-list-customer-tab-error":"Customer tab has validation errors",
        "create-or-edit-price-list-products-tab-error":"Products tab has validation errors",
        "create-or-edit-price-list-pos-tab-error":"POS tab has validation errors",
        "create-or-edit-price-list-customer-table-add-customers-title":"Add customers",
        "create-or-edit-price-list-customer-table-add-button":"Add",
        "create-or-edit-price-list-products-table-title":"Products",
        "create-or-edit-price-list-products-table-header-name":"Name",
        "create-or-edit-price-list-products-table-header-product-no":"Product no.",
        "create-or-edit-price-list-products-table-header-normal-price":"Normal price",
        "create-or-edit-price-list-products-table-header-adjusted-price":"Adjusted price",
        "create-or-edit-price-list-products-table-header-status":"Status",
        "create-or-edit-price-list-products-table-status-active":"Active",
        "create-or-edit-price-list-products-table-status-inactive":"Inactive",
        "create-or-edit-price-list-pos-table-title":"ID card subscriptions",
        "create-or-edit-price-list-pos-info-description":"\n .description = One price list must be the default for the POS system. If an ID card is scanned and its subscription type is not assigned to a price list, the default price list will be shown.",
        "create-or-edit-price-list-pos-is-default-price-list":"Default price list",
        "create-or-edit-price-list-pos-table-type":"Type",
        "create-or-edit-price-list-pos-table-description":"Description",

        // Merchant > Admin > Shops > Shops
        "shops-page-header": "\n .title = Shops",
        "shops-table-case-column": "Case no.",
        "shops-table-name-column": "Name",
        "shops-table-type-column": "Type",
        "shops-table-status-column": "Status",
        "shops-table-status-column-active": "Active",
        "shops-table-status-column-inactive": "Inactive",
        "shops-table-status-column-demo": "Demo",
        "shops-table-status-column-active-filter-active": "Active",
        "shops-table-status-column-inactive-filter-inactive": "Inactive",
        "shops-table-status-column-demo-filter-demo": "Demo",
        "shops-table-create-button": "Create new",
        "shops-table-menu-item-edit": "Edit",
        "shops-table-menu-item-delete": "Delete",
        "shops-confirm-delete-shop-dialog": "\n .typeOfEntity = shop",

        // Merchant > Admin > Shops > Shops > Create - Edit shop
        "merchant-shop-create-header": "\n .title = Create shop",
        "merchant-shop-edit-header": "\n .title = Edit shop",
        "merchant-shop-create-breadcrumb": "Create shop",
        "merchant-shop-edit-breadcrumb": "Edit shop",
        "merchant-shop-create-button": "Create",
        "merchant-shop-save-button": "Save",
        "merchant-create-edit-shop-tab-general": "General",
        "merchant-create-edit-shop-tab-settings": "Settings",
        "merchant-shop-form-field-name": "\n .label = Name \n .helperText = The shop name will be visible for your customers.",
        "merchant-shop-form-field-type": "\n .label = Type",
        "merchant-shop-form-field-type-helperText": "Select the type of shop.",
        "merchant-shop-form-field-type-mode-meeting-service": "Meeting service",
        "merchant-shop-form-field-type-mode-take-away": "Takeaway",
        "merchant-shop-form-field-type-mode-lunch": "GoPay",
        "merchant-shop-form-field-type-mode-pos": "POS",
        "merchant-shop-form-field-type-mode-subscription": "Subscription",
        "merchant-shop-form-hardware-packages": "Select hardware packages",
        "merchant-shop-form-hardware-packages-info": "\n .description = Selecting products below will not result in a purchase. You will subsequently receive an offer for hardware, which you can approve.",
        "merchant-shop-form-hardware-packages-tablet-size": "Tablet size:",
        "merchant-shop-form-hardware-packages-color": "Color:",
        "merchant-shop-form-payment-methods": "Available payment methods",
        "merchant-shop-form-make-shop-public": "\n .title = Public shop \n .offContent = This shop is only accessible to invited companies.",
        "merchant-shop-form-make-shop-public-info": "\n .description = A public shop is accessible to everyone.",
        "merchant-shop-form-make-shop-public-title": "Share the following with your customers",
        "merchant-shop-form-make-shop-public-description": "To pay as a guest, you must either scan a QR code or enter the shop number to access the shop. Read more about public shops <externalLink>here</externalLink>.",
        "merchant-shop-form-make-shop-public-number": "Shop number:",
        "merchant-shop-form-make-shop-public-url": "Direct public url:",
        "merchant-shop-form-make-shop-public-qr-code": "- or users can scan the following QR with their mobile phone",
        "merchant-shop-form-make-shop-public-offContent": "Save to see sharing details.",
        "merchant-shop-form-field-isVisibleForAppUsers": "\n .label = Make shop visible for internal users in GoPay mobile app",
        "merchant-shop-form-general": "\n .title = General",
        "merchant-shop-form-field-active": "Active:",
        "merchant-shop-form-field-demo": "Demo:",
        "merchant-shop-form-erp": "\n .title = ERP",
        "merchant-shop-form-field-case-number": "\n .label = Case number \n .helperText = The case number is used to import sales data into your organizations ERP.",
        "merchant-shop-form-internal-note": "\n .title = Internal note",
        "merchant-shop-form-field-internal-note": "\n .label = Internal note:",
        "merchant-shop-form-posDetails-defaultLanguage-field-label": "\n .label = Default language",
        "merchant-shop-form-posDetails-defaultLanguage-lang-en": "Engelsk",
        "merchant-shop-form-posDetails-defaultLanguage-lang-da": "Dansk",
        "merchant-shop-form-check-in": "Check in",
        "merchant-shop-form-check-in-qr-code-on-receipt": "Show check in QR code on receipt",
        "merchant-shop-form-accept-multiple-check-ins": "Accept multiple check ins",
        "merchant-shop-form-deadline": "\n .title = Deadline \n .offContent = Deadline not activated",
        "merchant-shop-form-purchases": "Purchases:",
        "merchant-shop-form-cancellation": "Cancellation:",
        "merchant-shop-form-deadline-day-field": "\n .label = Day",
        "merchant-shop-form-deadline-day-limit-day-before": "The day before",
        "merchant-shop-form-deadline-day-limit-x-days-before": "{ $daysBefore } days before",
        "merchant-shop-form-deadline-time-picker": "\n .label = Time",
        "merchant-shop-form-posDetails-configuration-for-supporters": "\n .title = Configuration for supporters",
        "merchant-shop-form-posDetails-configuration-for-supporters-returnToHomeScreenDelay-field-label": "\n .label = Return to home screen delay",
        "merchant-shop-form-posDetails-configuration-for-supporters-returnToHomeAfterPurchase-field-label": "\n .label = Return to home after purchase",
        "merchant-shop-form-posDetails-configuration-for-supporters-ms": "ms",

        // Merchant > Admin > Shops > Offers
        "offers-page-header": "\n .title = Offers",
        "offers-table-name-column": "Product name",
        "offers-table-price-column": "New price",
        "offers-table-original-price-column": "Original price",
        "offers-table-valid-from-column": "Valid from",
        "offers-table-expires-column": "Expires",
        "offers-table-status-column": "Status",
        "offers-table-edit-menu-item": "Edit",
        "offers-table-remove-offer-menu-item": "Remove offer",
        "offers-table-remove-offer-confirm-dialog": "\n .typeOfEntity = offer",
        "offers-table-remove-offer-success": "Offer removed successfully",


        // Merchant > Admin > Shops > VAT Codes
        "merchant-vat-codes-header": "\n .title = VAT codes",
        "merchant-vat-codes-list-create-button": "Create new",
        "merchant-vat-codes-create-button": "Create",
        "merchant-vat-codes-save-button": "Save",
        "merchant-vat-codes-delete-entity-dialog": "\n .typeOfEntity = VAT code",
        "merchant-vat-codes-table-header-vat-code":"VAT code",
        "merchant-vat-codes-table-header-name":"Name",
        "merchant-vat-codes-table-header-percentage":"Percentage",
        "merchant-vat-codes-table-button-edit":"Edit",
        "merchant-vat-codes-table-button-delete":"Delete",

        // Merchant > Admin > Shops > Create/Edit VAT Codes
        "merchant-vat-codes-create-header": "\n .title = Create VAT code",
        "merchant-vat-codes-edit-header": "\n .title = Edit Create VAT code",
        "merchant-vat-codes-create-edit-field-code":"\n .label = Code",
        "merchant-vat-codes-create-edit-field-name":"\n .label = Name",
        "merchant-vat-codes-create-edit-vat-percentage-amount":"\n .label = VAT percentage",
        "merchant-vat-codes-create-edit-required-name": "Name is required",
        "merchant-vat-codes-create-edit-required-code": "Code is required",
        "merchant-vat-codes-create-edit-required-vat-percentage-amount": "VAT percentage is required",

        // Merchant > Admin > Shops > Delivery locations
        "merchant-delivery-locations-header": "\n .title = Delivery locations",
        "merchant-delivery-locations-create-button-link": "Create new",
        "merchant-delivery-locations-delete-entity-dialog": "\n .typeOfEntity = delivery location",
        "merchant-delivery-locations-table-header-name": "Name",
        "merchant-delivery-locations-table-header-webshop": "Webshop",
        "merchant-delivery-locations-table-header-status": "Status",
        "merchant-delivery-locations-table-active-column-active": "Active",
        "merchant-delivery-locations-table-active-column-inactive": "Inactive",
        "merchant-delivery-locations-table-active-column-active-filter-yes": "Active",
        "merchant-delivery-locations-table-active-column-inactive-filter-no": "Inactive",
        "merchant-delivery-locations-table-button-edit": "Edit",
        "merchant-delivery-locations-table-button-delete": "Delete",

        // Merchant > Admin > Shops > Delivery locations
        "merchant-delivery-location-create-header": "\n .title = Create delivery location",
        "merchant-delivery-location-edit-header": "\n .title = Edit delivery location",
        "merchant-delivery-location-create-breadcrumb": "Create delivery location",
        "merchant-delivery-location-edit-breadcrumb": "Edit delivery location",
        "merchant-delivery-location-form-field-name": "\n .label = Name",
        "merchant-delivery-location-form-pickup-details-title": "Pickup details:",
        "merchant-delivery-location-form-field-description": "\n .label = Description",
        "merchant-delivery-location-form-pickup-time-helper": "Select the pick up time, so customer knows the time period to pickup the order:",
        "merchant-delivery-location-form-field-webshop": "\n .label = Webshop",
        "merchant-delivery-location-form-start-time-picker": "\n .label = From:",
        "merchant-delivery-location-form-end-time-picker": "\n .label = To:",
        "merchant-delivery-location-form-end-time-picker-min-error-label": "Should be greater than 'From time'",
        "merchant-delivery-location-form-settings": "\n .title = Settings",
        "merchant-delivery-location-form-field-active": "Active:",
        "merchant-delivery-locations-create-button": "Create",
        "merchant-delivery-locations-save-button": "Save",

        // Merchant > Admin > Shops > Payment links
        "payment-links-page-header": "\n .title = Payment links",
        "payment-links-table-name-column": "Name",
        "payment-links-table-shop-column": "Shop",
        "payment-links-table-valid-from-column": "Valid from",
        "payment-links-table-valid-to-column": "Valid to",
        "payment-links-table-create-button": "Create new",
        "payment-links-table-menu-item-edit": "Edit",
        "payment-links-table-menu-item-delete": "Delete",
        "payment-links-confirm-delete-dialog": "\n .typeOfEntity = payment links",

        // Merchant > Admin > Shops > Payment links > Create / Edit
        "payment-links-create-page-header": "\n .title = Create payment link",
        "payment-links-create-page": "Create payment link",
        "payment-links-form-create-submit-button": "Create",
        "payment-links-edit-page-header": "\n .title = Edit payment link",
        "payment-links-edit-page": "Edit payment link",
        "payment-links-form-edit-submit-button": "Save",
        "payment-links-form-public-title-label": "\n .label = Title",
        "payment-links-form-description-label": "\n .label = Description",
        "payment-links-form-public-shop-field-label": "\n .label = Public shop",
        "payment-links-form-sales-account-field-label": "\n .label = Sales account",
        "payment-links-form-hasPasswordProtection-switch": "Password protected",
        "payment-links-form-password-field-label": "\n .label = Password \n .helperText = Protect your link with a password if the shop supports invoicing as a payment method.",
        "payment-links-form-general-panel": "\n .title = General",
        "payment-links-form-active-switch": "Active:",
        "payment-links-form-availability-panel": "\n .title = Validity period \n .offContent = Valid indefinitely",
        "payment-links-form-availability-from-date-picker": "\n .label = Start date",
        "payment-links-form-availability-to-date-picker": "\n .label = End date",
        "payment-links-form-availability-error-picker": "Start date and End date must be filled in",

        // Merchant > Admin > Setting > Sales accounts
        "sales-accounts-page-header": "\n .title = Sales accounts",
        "sales-accounts-table-name-column": "Name",
        "sales-accounts-table-number-column": "Number",
        "sales-accounts-table-create-button": "Create new",
        "sales-accounts-table-menu-item-edit": "Edit",
        "sales-accounts-table-menu-item-delete": "Delete",
        "sales-accounts-confirm-delete-dialog": "\n .typeOfEntity = sales accounts",

        // Merchant > Admin > Setting > Sales accounts > Create / Edit
        "sales-accounts-create-page-header": "\n .title = Create sales account",
        "sales-accounts-create-page": "Create sales account",
        "sales-accounts-form-create-submit-button": "Create",
        "sales-accounts-edit-page-header": "\n .title = Edit sales account",
        "sales-accounts-edit-page": "Edit sales account",
        "sales-accounts-form-edit-submit-button": "Save",
        "sales-accounts-form-public-name-label": "\n .label = Name \n .placeholder = Enter a name for the sales account",
        "sales-accounts-form-number-label": "\n .label = Number \n .placeholder = Enter account number from ERP system",
        "sales-accounts-form-general-panel": "\n .title = General",
        "sales-accounts-form-active-switch": "Active:",

        // ADMIN DEVICES
        "merchant-admin-devices-page-header": "\n .title = Devices",
        // Merchant users
        "merchant-admin-users-create-admin-button": "Create new",
        "merchant-admin-users-page-title": "\n .title = Administrators",


        // --- Supplier ---

        // Supplier > Navigation
        "supplier-nav-item-home": "Home",
        "supplier-nav-item-accounting-title": "\n .title = Accounting",
        "supplier-nav-item-accounting": "Accounting",
        "supplier-nav-item-pos": "POS",
        "supplier-nav-item-meeting-service": "Meeting service",
        "supplier-nav-item-subscriptions": "Subscriptions",
        "supplier-nav-item-z-reports": "Z-reports",
        "supplier-nav-item-merchant-sales": "Merchant sales",
        "supplier-nav-item-customer-sales": "Customer sales",
        "supplier-nav-item-balance": "Balance",

        // Supplier > Navigation > Reports
        "supplier-nav-item-merchant-access": "Merchant access",

        // Supplier > Navigation > Admin
        "supplier-nav-item-merchants-page-header":"\n .title = Merchants",
        "supplier-nav-item-settings-page-header":"\n .title = Settings",
        "supplier-nav-item-account-page-header":"\n .title = Account",
        "supplier-nav-item-erp-page-header":"\n .title = ERP",
        "supplier-nav-item-acquiring-reports-page-header":"\n .title = Reconciliation",
        "supplier-admin-nav-item-merchants": "Merchants",
        "supplier-admin-nav-item-merchants-create": "Create merchant",
        "supplier-admin-nav-item-merchants-edit": "Edit merchant",
        "supplier-admin-nav-item-administrators": "Administrators",
        "supplier-admin-nav-item-admins": "Administrators",
        "supplier-admin-nav-item-devices": "Devices",
        "supplier-admin-nav-item-settings": "Settings",
        "supplier-admin-nav-item-acquiring": "Payment acquiring",
        "supplier-admin-nav-item-terms-and-conditions": "Terms and conditions",
        "supplier-admin-nav-item-pos-settings":"POS settings",
        "supplier-admin-nav-item-pos-settings-template-create": "Create template",
        "supplier-admin-nav-item-pos-settings-template-edit": "Edit template",
        "supplier-admin-nav-item-company-account":"Company account",
        "supplier-admin-nav-item-account-gdpr":"GDPR",
        "supplier-admin-nav-item-erp":"ERP",
        "supplier-admin-nav-item-acquiring-fees": "Acquiring fees",
        "supplier-admin-nav-item-bank-transfers":"Bank transfers",
        "supplier-admin-nav-item-product-numbers":"Product numbers",
        "supplier-admin-nav-item-create-product-group-number":"Create product number",
        "supplier-admin-nav-item-update-product-group-number":"Update product number",
        "supplier-admin-nav-item-create-terms-and-conditions": "Create terms and conditions",
        "supplier-admin-nav-item-update-terms-and-conditions": "Update terms and conditions",

        // Supplier > Reports > Home

        // Supplier > Reports > Home > Accounting > Meeting Service
        "supplier-meeting-service-header": "\n .title = Meeting service",
        "supplier-meeting-service-table-merchant": "Merchant",
        "supplier-meeting-service-table-order-id-column": "Order ID",
        "supplier-meeting-service-order-id-label": "\n .label = Order ID",
        "supplier-meeting-service-table-booked-date-column": "Booked date",
        "supplier-meeting-service-table-delivery-time-column": "Delivery time",
        "supplier-meeting-service-table-employee-column": "Merchant",
        "supplier-meeting-service-table-status":"Status",
        "supplier-meeting-service-table-status-confirmed":"Confirmed",
        "supplier-meeting-service-table-status-canceled":"Canceled",
        "supplier-meeting-service-table-amount-column": "Amount (DKK)",
        "supplier-meeting-service-table-show-receipt": "Show receipt",
        "supplier-meeting-service-table-floating-action-bar-receipts": "\n .title = Receipts",
        "supplier-meeting-service-table-floating-action-bar-export": "\n .title = Export",
        "supplier-meeting-service-order-title":"\n .title = Order",
        "supplier-meeting-service-drawer-pending-approval-label":"\n .label = Pending approval",
        "supplier-meeting-service-invoicing-title":"\n .title = Invoicing",
        "supplier-meeting-service-drawer-invoice-status-label":" Invoice status",
        "supplier-meeting-service-drawer-invoice-status-all-label":"All",
        "supplier-meeting-service-drawer-invoice-status-sent-label":"Sent",
        "supplier-meeting-service-drawer-invoice-status-not-sent-label":"Not sent",
        "supplier-meeting-service-drawer-booked-label":"Booked",
        "supplier-meeting-service-drawer-booked-all-label":"All",
        "supplier-meeting-service-drawer-booked-booked-label":"Booked",
        "supplier-meeting-service-drawer-booked-not-booked-label":"Not booked",
        "supplier-meeting-service-booked-date-title":"\n .title = Booked date",
        "supplier-meeting-service-delivery-date-title":"\n .title = Delivery date",
        "supplier-meeting-service-merchant-title":"\n .title = Merchant",
        "supplier-meeting-service-debtor-title":"\n .title = Debtor",
        "supplier-meeting-service-end-user-title":"\n .title = End User",
        "supplier-meeting-service-payment-title":"\n .title = Payment",
        "supplier-meeting-service-drawer-from-date-label":"\n .label = From date",
        "supplier-meeting-service-drawer-to-date-label":"\n .label = To date",
        "supplier-meeting-service-drawer-bill-receivers-label":"Bill receivers",
        "supplier-meeting-service-drawer-bill-receivers-select-company-helper-text":"To filter on bill receiver, you must select a company first",
        "supplier-meeting-service-drawer-satellites-label":"Satellites",
        "supplier-meeting-service-drawer-to-date-info-label":"\n .title = Do not use delivery date for invoicing. Use booking date instead.",

        // Supplier > Reports > Home > Accounting > POS
        "supplier-pos-table-header-title": "\n .title = POS",
        "supplier-pos-table-header-order-id": "Order ID",
        "supplier-pos-table-header-transaction-time": "Transaction time",
        "supplier-pos-table-header-merchant-name": "Merchant name",
        "supplier-pos-table-header-employee": "Creator",
        "supplier-pos-table-header-payment": "Payment method",
        "supplier-pos-table-header-payment-channel": "Channel",
        "supplier-pos-table-header-amount": "Amount (DKK)",
        "supplier-pos-table-table-button-show-receipt": "Show receipt",
        "supplier-pos-table-filters-order-title":"\n .title = Order",
        "supplier-pos-table-filters-period-title":"\n .title = Period",
        "supplier-pos-table-filters-merchant-title":"\n .title = Merchant",
        "supplier-pos-table-filters-debtor-title":"\n .title = Debtor",
        "supplier-pos-table-filters-end-user-title":"\n .title = End user",
        "supplier-pos-table-filters-payment-title":"\n .title = Payment",
        "supplier-pos-table-filters-from-date-label":"\n .label = Transaction from date",
        "supplier-pos-table-filters-to-date-label":"\n .label = Transaction to date",

        // Supplier > Reports > Home > Accounting > Subscriptions
        "supplier-subscriptions-header": "\n .title = Subscriptions",
        "supplier-subscriptions-table-order-id-column": "Order ID",
        "supplier-subscriptions-table-employee-column": "Employee",
        "supplier-subscriptions-table-subscribed-column": "Subscribed",
        "supplier-subscriptions-table-unsubscribed-column": "Unsubscribed",
        "supplier-subscriptions-table-payment-column": "Payment method",
        "supplier-subscriptions-table-amount-column": "Amount",
        "supplier-subscriptions-table-cancel-subscription": "Cancel subscription",
        "supplier-subscriptions-table-details": "Details",
        "supplier-subscriptions-table-filters-order-title":"\n .title = Order",
        "supplier-subscriptions-table-filters-period-title":"\n .title = Period",
        "supplier-subscriptions-table-filters-from-date-label":"\n .label = Valid from date",
        "supplier-subscriptions-table-filters-to-date-label":"\n .label = Valid to date",
        "supplier-subscriptions-table-filters-merchant-title":"\n .title = Merchant",
        "supplier-subscriptions-table-filters-debtor-title":"\n .title = Debtor",
        "supplier-subscriptions-table-filters-end-user-title":"\n .title = End user",
        "supplier-subscriptions-table-filters-payment-title":"\n .title = Payment",
        "supplier-subscriptions-drawer-subscription-label":"Subscription",


        // Supplier > Reports > Home > Accounting > Z-reports
        "supplier-accounting-z-reports-page-header":" \n .title = Z-reports",
        "supplier-accounting-z-reports-table-date-column":"Date",
        "supplier-accounting-z-reports-table-pos-terminal-column":"POS device",
        "supplier-accounting-z-reports-table-amount-column":"Amount",

        // Supplier > Reports > Home > Accounting > Merchant Sales
        "supplier-merchant-sales-header": "\n .title = Merchant sales",
        "supplier-merchant-sales-table-shop-type": "\n .label = Shop Type",
        "supplier-merchant-sales-table-red-no-column": "Case no.",
        "supplier-merchant-sales-table-name-column": "Name",
        "supplier-merchant-sales-table-upcoming-sales-column": "Upcoming sales ({ $currencyCode })",
        "supplier-merchant-sales-table-booked-sales-column": "Booked sales ({ $currencyCode })",
        "supplier-merchant-sales-table-floating-action-bar-export": "\n .title = Export",
        "supplier-merchant-sales-table-shop-type-input-label": "Shop type",
        "supplier-merchant-sales-table-shop-type-item-pos": "POS",
        "supplier-merchant-sales-table-shop-type-item-meeting-service": "Meeting service",
        "supplier-merchant-sales-table-shop-type-item-subscription": "Subscription",
        "supplier-merchant-sales-detailed-table-total-footer-column": "Total",
        "supplier-merchant-sales-detailed-table-sales-column": "Sales (DKK)",

        // Supplier > Reports > Home > Accounting > Customer Sales
        "supplier-customer-sales-header": "\n .title = Customer sales",
        "supplier-customer-sales-table-name-column": "Name",
        "supplier-customer-sales-table-upcoming-sales-column": "Upcoming sales ({ $currencyCode })",
        "supplier-customer-sales-table-booked-sales-column": "Booked sales ({ $currencyCode })",
        "supplier-customer-sales-table-floating-action-bar-export": "\n .title = Export",
        "supplier-customer-sales-detailed-table-total-footer-column": "Total",
        "supplier-customer-sales-detailed-table-sales-column": "Sales (DKK)",


        // Supplier > Admin > Home
        "supplier-admin-home-merchants-group": "\n .title = Merchants",
        "supplier-admin-home-merchant-card": "\n .title = Merchants\n .description = Manage merchants, which are physical sales locations.",
        "supplier-admin-home-administrators-card": "\n .title = Administrators\n .description = Manage supplier and merchant administrators.",
        "supplier-admin-home-devices-card": "\n .title = Devices\n .description = Manage devices, such as POS tablets, check-in screens and printers.",
        "supplier-admin-home-settings-group": "\n .title = Settings",
        "supplier-admin-home-payment-acquiring-card": "\n .title = Payment acquiring\n .description = Manage and check status of credit card acquiring agreements.\n .buttonText = Show",
        "supplier-admin-home-terms-and-conditions-card": "\n .title = Terms and conditions\n .description = Manage your sales terms and conditions towards your customers.",
        "supplier-admin-home-pos-settings-card": "\n .title = POS settings \n .description = Manage POS settings.",
        "supplier-admin-home-account-group":  "\n .title = Account",
        "supplier-admin-home-company-account-card":  "\n .title = Company account\n .description = Manage your company account.\n .buttonText = Show",
        "supplier-admin-home-erp-group":  "\n .title = ERP",
        "supplier-admin-home-product-numbers-card":  "\n .title = Product numbers\n .description = Manage product numbers for ERP integration.",
        "supplier-admin-home-account-gdpr-card":  "\n .title = GDPR \n .description = General Data Protection Regulation \n .buttonText = Show",
        "supplier-admin-home-acquiring-reports-group":  "\n .title = Reconciliation",
        "supplier-admin-home-bank-transfers-card":  "\n .title = Bank transfers\n .description = Report showing transfers between your acquiring accounts and bank accounts.\n .buttonText = Show",
        "supplier-admin-home-acquiring-fees":  "\n .title = Acquiring fees\n .description = Report showing fees for acquiring. Useful for reconciliation.\n .buttonText = Show",
        "supplier-admin-home-balance":  "\n .title = Balance\n .description = Report showing total sales, fees and transfers for a period.\n .buttonText = Show",

        // Supplier > Admin > Devices
        "supplier-admin-devices-page-header": "\n .title = Devices",

        // Supplier > Admin > ERP > Product Group Numbers
        "supplier-admin-erp-product-group-numbers-header": "\n .title = Product numbers",
        "supplier-admin-erp-product-group-numbers-create-new-button":"Create new",
        "supplier-admin-erp-product-group-numbers-save-button":"Save",
        "supplier-admin-erp-product-group-numbers-table-header-erp-number":"ERP no.",
        "supplier-admin-erp-product-group-numbers-table-header-name":"Name",
        "supplier-admin-erp-product-group-numbers-table-header-status":"Status",
        "supplier-admin-erp-product-group-numbers-table-active-column-active":"Active",
        "supplier-admin-erp-product-group-numbers-table-active-column-inactive":"Inactive",
        "supplier-admin-erp-product-group-numbers-table-active-filter-yes":"Active",
        "supplier-admin-erp-product-group-numbers-table-active-filter-no":"Inactive",
        "supplier-admin-erp-product-group-numbers-table-button-edit":"Edit",
        "supplier-admin-erp-product-group-numbers-table-button-delete":"Delete",
        "supplier-admin-erp-product-group-numbers-delete-entity-dialog":"\n .typeOfEntity = Product numbers",

        // Supplier > Admin > ERP > Product Group Numbers > Create/Update
        "supplier-admin-erp-product-group-numbers-create-header": "\n .title = Create product number",
        "supplier-admin-erp-product-group-numbers-update-header": "\n .title = Edit product number",
        "supplier-admin-erp-product-group-numbers-create-button":"Create",
        "supplier-admin-erp-product-group-numbers-field-code":"\n .label = ERP number",
        "supplier-admin-erp-product-group-numbers-field-name":"\n .label = Name",
        "supplier-admin-erp-product-group-numbers-description":"\n .label = Description\n .placeholder = Here you can explain intended usage of this product number",
        "supplier-admin-erp-product-group-numbers-required-code":"ERP number is required",
        "supplier-admin-erp-product-group-numbers-required-name":"Name is required",
        "supplier-admin-erp-product-group-numbers-aside-settings":"\n .title = Settings",
        "supplier-admin-erp-product-group-numbers-active":"Active:",
        "supplier-admin-erp-product-group-numbers-history":"\n .title = History",
        "supplier-admin-erp-product-group-numbers-aside-created":"Created:",
        "supplier-admin-erp-product-group-numbers-aside-updated":"Updated:",

        // DEVICE TABLE GENERAL
        "devices-table-header-name": "Name",
        "devices-table-header-group": "Group",
        "devices-table-header-type": "Type",
        "devices-table-header-status": "Status",
        "devices-table-button-details": "Details",
        "devices-table-button-edit": "Edit",
        "devices-table-status-column-online": "Online",
        "devices-table-status-column-offline": "Offline",
        "devices-table-header-reg": "Reg. no.",
        "devices-table-header-merchant": "Merchant",

        // DEVICE DETAILS
        "device-details-title": "Device details",
        "device-details-type-info-shop": "\n .label = Shop:",
        "device-details-type-info-device-number": "\n .label = Device number:",
        "device-details-type-info-serial-number": "\n .label = Serial number:",
        "device-details-type-info-hardware-id": "\n .label = Hardware-ID:",
        "device-details-type-info-language": "\n .label = Language:",
        "device-details-type-info-pos-mode": "\n .label = POS mode:",
        "device-details-type-info-card-terminal-acquirer-name": "\n .label = Card terminal acquirer name:",
        "device-details-status-info-title": "\n .title = Status",
        "device-details-status-info-diagnostics-title": "\n .title = Show diagnostics",
        "device-details-status-info-diagnostics-subject": "Subject",
        "device-details-status-info-diagnostics-message": "Message",
        "device-details-pin-code-info-title": "\n .title = PIN Code",
        "device-details-pin-code-info-helper": "\n .title = PIN code: \n .description = Helper: It is a long established fact that a reader will be distracted",
        "device-details-group-info-title": "\n .title = Group",
        "device-details-group-info-name": "\n .label = Name:",
        "device-details-group-info-connected-devices": "\n .label = Connected devices:",
        "device-details-group-table-header-name": "Name",
        "device-details-group-table-header-type": "Type",
        "device-details-group-table-header-status": "Status",
        "device-details-device-info-title": "\n .title = Device",
        "device-details-device-info-name": "\n .label = Name:",
        "device-details-device-info-shop": "\n .label = Shop:",
        "device-details-device-info-device-number": "\n .label = Device number:",
        "device-details-identification-info-title": "\n .title = Identification",
        "device-details-identification-info-serial-number": "\n .label = Serial number:",
        "device-details-identification-info-hardware-id": "\n .label = Hardware ID:",
        "device-details-identification-info-acquirer": "\n .label = Card terminal acquirer name:",
        "device-details-settings-info-title": "\n .title = Settings",
        "device-details-settings-info-language": "\n .label = Language:",
        "device-details-settings-info-pos-mode": "\n .label = POS mode:",
        "device-details-settings-info-pin-code-info": "PIN code is used to enter protected areas in the app.",
        "device-details-history-info-title": "\n .title = History",
        "device-details-history-info-created": "\n .label = Created:",
        "device-details-history-info-edited": "\n .label = Edited:",
        "device-details-type-mode-cloud-pos": "GoPay CloudPOS",
        "device-details-type-mode-soft-pos": "GoPay SoftPOS",
        "device-details-type-mode-display": "Display",
        "device-details-type-mode-cloud-credit-card-reader": "Cloud Printer",
        "device-details-type-mode-star-cloud-printer": "Cloud Credit Card Reader",
        "device-details-type-mode-receipt-control": "Receipt Control",
        "device-details-type-mode-room-display": "Room Display",
        "device-details-type-mode-meeting-display": "Meeting Display",
        "device-details-type-mode-guest-check-in": "Guest Check In",
        "device-details-group-table-device-type-filter-label": "Device Type",
        "device-details-group-table-device-type-filter-placeholder": "All",
        "device-details-group-table-device-type-filter-label-label": "\n .label = Device Type",
        "devices-table-select-filter-on-item-room-display": "Room display",
        "devices-table-select-filter-on-item-meeting-display": "Meeting display",
        "devices-table-select-filter-on-item-guest-check-in": "Guest check in",


        // Create or edit device
        "service-center-admin-organization-create-devices-title": "\n .title = Create display",
        "service-center-admin-organization-edit-devices-title": "\n .title = Edit display",
        "devices-create-device-form": "Create",
        "devices-edit-device-form": "Save",
        "devices-edit-breadcrumb": "Edit display",
        "devices-create-breadcrumb": "Create display",
        "devices-create-or-edit-form-select-template-label": "\n .label = Template",
        "devices-create-or-edit-form-select-field-name": "\n .label = Name",
        "devices-create-or-edit-form-select-field-device-number": "\n .label = Device number",
        "devices-create-or-edit-form-floor-label": "\n .label = Floor",
        "devices-create-or-edit-form-select-field-room": "\n .label = Room",
        "devices-create-or-edit-form-select-field-serial-number": "\n .label = Serial number",
        "devices-create-or-edit-form-select-display-type": "\n .label = Display type",
        "devices-create-or-edit-form-type-room-details-info": "\n .title = Room displays are put up in front of meeting rooms to show if the room is currently available or occupied. It also offers a convenient way to book the room.",
        "devices-create-or-edit-form-type-meeting-details-info": "\n .title = Meeting displays are typically put up on each floor and are designed to let people now where to go for their meeting.",

        "devices-create-or-edit-form-display-type-dropdown-item-room-display": "Room display",
        "devices-create-or-edit-form-display-type-dropdown-item-meeting-display": "Meeting display",
        "devices-create-or-edit-form-display-type-dropdown-item-guest-check-in": "Guest check in",

        // Display types
        "display-types-dropdown-select-item-room-display": "Room display",

        // Supplier > Admin > POS settings
        "supplier-admin-pos-settings-page-header": "\n .title = POS settings",
        "supplier-admin-pos-settings-tab-templates": "Templates",
        "supplier-admin-pos-settings-tab-general": "General",
        "supplier-admin-pos-settings-create-button": "Create new",
        "supplier-admin-pos-settings-templates-table-header-name": "Name",
        "supplier-admin-pos-settings-templates-table-header-language": "Language",
        "supplier-admin-pos-settings-templates-table-header-status": "Status",
        "supplier-admin-pos-settings-templates-table-edit-button": "Edit",
        "supplier-admin-pos-settings-templates-table-duplicate-button": "Duplicate",
        "supplier-admin-pos-settings-templates-table-delete-button": "Delete",
        "supplier-admin-pos-settings-templates-table-status-column-active":"In use",
        "supplier-admin-pos-settings-templates-table-status-column-inactive":"Not in use",
        "supplier-admin-pos-settings-templates-table-status-column-active-filter-yes": "In use",
        "supplier-admin-pos-settings-templates-table-status-column-inactive-filter-no": "Not in use",

        // Supplier > Admin > POS settings > Templates > Create / Edit
        "supplier-admin-pos-settings-create-template-page-header": "\n .title = Create template",
        "supplier-admin-pos-settings-edit-template-page-header": "\n .title = Edit template",
        "supplier-admin-pos-settings-create-submit-button": "Create",
        "supplier-admin-pos-settings-edit-submit-button": "Save",
        "supplier-admin-pos-settings-template-shortcuts": "\n .title = Shortcuts",
        "supplier-admin-pos-settings-template-name-field-label": "\n .label = Template name",
        "supplier-admin-pos-settings-template-languageCode-field-label": "\n .label = Language",
        "supplier-admin-pos-settings-lang-en": "English",
        "supplier-admin-pos-settings-lang-da": "Danish",
        "supplier-admin-pos-settings-template-button-field-label": "\n .label = Button text \n .helperText = Customize the text of the start purchase button.",
        "supplier-admin-pos-settings-template-title-field-label": "\n .label = Title",
        "supplier-admin-pos-settings-template-subtitle-field-label": "\n .label = Subtitle",
        "supplier-admin-pos-settings-template-companyLogo-field-label": "\n .label = Upload company logo:",
        "supplier-admin-pos-settings-template-companyLogo-info": "Image hints: background should be transparent. We recommend using a 180x180 px image with logo centered inside.",
        "supplier-admin-pos-settings-template-shortcuts-help-field": "Help / terms and conditions:",
        "supplier-admin-pos-settings-template-shortcuts-downloadApp-field": "Download GoPay app:",
        "supplier-admin-pos-settings-template-frontpage-layout": "Frontpage layout",
        "supplier-admin-pos-settings-template-select-theme-style": "Select theme style:",

        // Supplier > Admin > POS settings > General
        "supplier-admin-pos-settings-general-submit-button": "Save",
        "supplier-admin-pos-settings-general-defaultLanguage-field-label": "\n .label = Default language \n .helperText = Can be adjusted on each device.",
        "supplier-admin-pos-settings-general-posPrintingMode-field-label": "\n .label = Receipt print mode",
        "supplier-admin-pos-settings-general-posPrintingMode-option-qr-only": "QR code only",
        "supplier-admin-pos-settings-general-posPrintingMode-option-auto": "Automatic print",
        "supplier-admin-pos-settings-general-posPrintingMode-option-manually": "Manual print",
        "supplier-admin-pos-settings-general-info": "The print mode controls how the receipt is made available to the customer. “Automatic print” will print a paper receipt automatically whereas “Manual print” allows the user to print paper receipt or scan QR code to get a digital receipt. Choose “QR code only” if you want a paperless POS system.",
        "supplier-admin-pos-settings-general-configuration-for-supporters": "Configuration for supporters",
        "supplier-admin-pos-settings-general-configuration-for-supporters-returnToHomeScreenDelay-field-label": "\n .label = Return to home screen delay",
        "supplier-admin-pos-settings-general-configuration-for-supporters-returnToHomeAfterPurchase-field-label": "\n .label = Return to home after purchase",
        "supplier-admin-pos-settings-general-configuration-for-supporters-ms": "ms",

        // Supplier > Admin > Merchant Access
        "supplier-merchant-access-page-header": "\n .title = Merchant access",
        "supplier-merchant-access-table-header-case-no": "Case No.",
        "supplier-merchant-access-table-header-name": "Name",
        "supplier-merchant-access-table-header-address": "Address",
        "supplier-merchant-access-table-details-no-companies": "There are no connected companies",
        "supplier-merchant-access-table-details-customers-title":"Customers:",

        // Supplier > Admin > Acquiring
        "supplier-admin-pos-acquirer-page-header": "\n .title = Payment acquiring agreement",
        "supplier-admin-pos-acquirer-adyen-question":"Who is Adyen?",
        "supplier-admin-pos-acquirer-adyen-answer":"Adyen is our credit card payment company with the status of an acquiring bank that allows you to accept credit card payments. Adyen is responsible for processing payments for your company. Before you can start accepting payment cards you must apply for an agreement with Adyen.",
        "supplier-admin-pos-acquirer-adyen-read-more":"Read more: <externalLink>{ $adyenWebsite }</externalLink>",
        "supplier-admin-pos-acquirer-status-title":"Status:",
        "supplier-admin-pos-acquirer-status-create-business-lines": "No industry codes",
        "supplier-admin-pos-acquirer-status-info-create-business-lines": "You need to select your lines of business before applying.",
        "supplier-admin-pos-acquirer-status-action-create-business-lines": "Please add one or more industry codes below.",
        "supplier-admin-pos-acquirer-status-start": "Start application",
        "supplier-admin-pos-acquirer-status-info-start": "You are now ready to begin the application with the acquirer.",
        "supplier-admin-pos-acquirer-status-action-start": "Start application below.",
        "supplier-admin-pos-acquirer-status-pending": "Pending",
        "supplier-admin-pos-acquirer-status-info-pending": "Verification is in progress.",
        "supplier-admin-pos-acquirer-status-action-pending": "Please wait for acquirer to verify your application.",
        "supplier-admin-pos-acquirer-status-invalid": "Invalid",
        "supplier-admin-pos-acquirer-status-info-invalid": "There are errors in the data provided.",
        "supplier-admin-pos-acquirer-status-action-invalid": "Please correct your application.",
        "supplier-admin-pos-acquirer-status-valid": "Approved",
        "supplier-admin-pos-acquirer-status-info-valid": "Your application has been approved.",
        "supplier-admin-pos-acquirer-status-check-valid":"You are  now ready to setup credit card payments for your merchants.",
        "supplier-admin-pos-acquirer-status-rejected": "Rejected",
        "supplier-admin-pos-acquirer-status-info-rejected": "Acquirer has verified the information, but has found reasons to refuse working with your entity.",
        "supplier-admin-pos-acquirer-start-application-button": "Start application at Adyen",
        "supplier-admin-pos-acquirer-continue-application-button": "Continue the  application at Adyen",
        "supplier-admin-pos-acquirer-status-no-payment-title": "You have no payment acquiring agreement.",
        "supplier-admin-pos-acquirer-status-no-payment-error": "No acquirers available",
        "supplier-admin-acquiring-terms-and-conditions-title": "Requirements for terms and conditions",
        "supplier-admin-acquiring-terms-and-conditions-explanation": "To proceed, you must agree to the acquirer's requirements for your <requirementsLink>Terms and Conditions of Sale</requirementsLink>. These terms and conditions must be clearly visible for your customers on your website.",
        "supplier-admin-acquiring-terms-and-conditions-template-text": "You can download our Terms and Conditions template <templateLink>here</templateLink>.",
        "supplier-admin-acquiring-terms-and-conditions-label": "\n .label = I agree to fulfill these requirements.",
        "supplier-admin-acquiring-accept-terms-dialog-title": "Accept Requirements for T&C",
        "supplier-admin-acquiring-accept-terms-dialog-description": "Are you sure you want to accept the requirements for the terms and conditions?",
        "supplier-admin-acquiring-accept-terms-dialog-button": "Accept",
        "supplier-acquiring-industry-codes-accordion-industry-codes-title": "Industry codes",
        "supplier-acquiring-industry-codes-accordion-industry-codes-info-box": "\n .description = If you apply for a canteen, select industry code 722514 - cafeterias, grill buffets.",
        "supplier-acquiring-industry-codes-table-industry-code-column": "Industry code",
        "supplier-acquiring-industry-codes-table-description-column": "Description",
        "supplier-acquiring-industry-codes-table-remove-action": "Remove",
        "supplier-acquiring-industry-codes-add-industry-code": "Add new industry code",
        "supplier-acquiring-industry-codes-info-text": "The industry codes describes your lines of business and determines what products you are allowed to sell in your shops. Some industry codes require approval from the acquirer. See all industry codes <industryCodesLink>here</industryCodesLink>.",
        "supplier-acquiring-industry-codes-confirm-delete-dialog": "\n .title = Remove industry code\n .message = Do you wish to remove the industry code { $industryCode }?\n .buttonLabelSubmit = Remove",
        "supplier-acquiring-bank-accounts-accordion-bank-accounts-title": "Bank accounts",
        "supplier-acquiring-bank-accounts-table-bank-name-column": "Bank",
        "supplier-acquiring-bank-accounts-table-account-column": "Account",
        "supplier-acquiring-bank-accounts-table-merchant-caseno-column": "Case no.",
        "supplier-acquiring-bank-accounts-table-merchant-column": "Merchant",
        "supplier-acquiring-bank-accounts-table-status-column": "Status",
        "supplier-acquiring-bank-accounts-table-remove-action": "Remove",
        "supplier-acquiring-bank-accounts-add-bank-account": "Add new bank account",
        "supplier-acquiring-bank-accounts-info-text": "If you want sales to be transfered to a separate bank account for each merchant you can add the bank account here. See <guideLink>guide</guideLink> on how to add a new bank account on the Adyen platform and afterwards connect the bank account to your merchant.",
        "supplier-acquiring-bank-accounts-status-pending": "Pending",
        "supplier-acquiring-bank-accounts-status-invalid": "Invalid",
        "supplier-acquiring-bank-accounts-status-valid": "Valid",
        "supplier-acquiring-bank-accounts-status-rejected": "Rejected",
        "supplier-acquiring-bank-accounts-confirm-delete-dialog": "\n .title = Remove bank account\n .message = Do you wish to remove the bank account { $accountIdentifier }?\n .buttonLabelSubmit = Remove",
        "supplier-acquiring-industry-codes-button-add": "Add",
        "supplier-acquiring-industry-codes-button-save": "Save",
        "supplier-acquiring-industry-codes-alert-title": " Adding new industry codes might change your payment acquiring agreement status to pending if the acquirer needs to verify.",

       // Supplier > Admin > Reconciliation
       "supplier-acquiring-reports": "Reconciliation",
       "supplier-acquiring-reports-table-booked-time-column": "Booked time",
       "supplier-acquiring-reports-table-merchant-label": "\n .label = Merchant",
       "supplier-acquiring-reports-table-adyen-account-label": "\n .label = Adyen account",
       "supplier-acquiring-reports-table-merchant-column": "Merchant",
       "supplier-acquiring-reports-table-amount-column": "Amount",

       // Supplier > Admin > Reconciliation > Fees
       "supplier-acquiring-fees-header": "\n .title = Acquiring fees",
       "supplier-acquiring-fees": "Acquiring fees",
       "supplier-acquiring-fees-table-order-id-column": "Order ID",
       "supplier-acquiring-fees-table-psp-reference-column": "PSP Reference",
       "supplier-acquiring-fees-table-available-date-column": "Available date",
       "supplier-acquiring-fees-table-type-column": "Type",
       "supplier-acquiring-fees-table-select-filter-on-label": "Filter on",
       "supplier-acquiring-fees-table-select-filter-on-label-label": "\n .label = Filter on",
        "supplier-acquiring-fees-table-select-filter-on-item-booking-date": "Booking date",
        "supplier-acquiring-fees-table-select-filter-on-item-value-date": "Available date",
       "supplier-acquiring-fees-table-type-mode-payment": "Payment",
       "supplier-acquiring-fees-table-type-mode-transfer": "Transfer",
       "supplier-acquiring-fees-table-type-mode-refund": "Refund",
       "supplier-acquiring-fees-table-number-of-transactions": "\n .title = Number of transactions",
       "supplier-acquiring-fees-table-info-banner": "\n .description = Data for this report becomes available on the next day, so you cannot see transactions for today.",

       // Supplier > Admin > Reconciliation > Bank transfers
       "supplier-acquiring-bank-transfers-header": "\n .title = Bank transfers",
       "supplier-acquiring-bank-transfers": "Bank transfers",
       "supplier-acquiring-bank-transfers-table-transfer-id-column": "Transfer ID",
       "supplier-acquiring-bank-transfers-table-available-time-column": "Available time",
       "supplier-acquiring-bank-transfers-table-bank-account-column": "Bank account",
       "supplier-acquiring-bank-transfers-table-details-menu-item": "Details",
       "supplier-acquiring-bank-transfers-table-number-of-transfers": "\n .title = Number of transfers",
       "supplier-acquiring-bank-transfers-table-info-banner": "\n .description = Data for this report becomes available on the next day, so you cannot see bank transfers for today or future transfers.",
        "supplier-acquiring-bank-transfers-table-details-table-order-id-column": "Order ID",
        "supplier-acquiring-bank-transfers-table-details-table-psp-reference-column": "PSP Reference",
        "supplier-acquiring-bank-transfers-table-details-table-booked-column": "Booked",
        "supplier-acquiring-bank-transfers-table-details-table-available-column": "Available",
        "supplier-acquiring-bank-transfers-table-details-table-gross-column": "Gross",
        "supplier-acquiring-bank-transfers-table-details-table-net-column": "Net",
        "supplier-acquiring-bank-transfers-table-details-table-fee-column": "Fee",
        "supplier-acquiring-bank-transfers-details-dialog-title": "\n .dialogTitle = Transfer details\n .subtitle = Period: { $periodStart} - { $periodEnd }",
        "supplier-acquiring-bank-transfers-details-dialog-title-no-start-date": "Agreement start",
        "supplier-acquiring-bank-transfers-details-dialog-number-of-orders": "\n .title = Number of orders",
        "supplier-acquiring-bank-transfers-details-dialog-table-gross-total": "\n .title = Gross total",
        "supplier-acquiring-bank-transfers-details-dialog-table-fee-total": "\n .title = Fee total",
        "supplier-acquiring-bank-transfers-details-dialog-table-net-total": "\n .title = Net total",

       // Supplier > Admin > Reconciliation > Balance
       "supplier-overview-header": "\n .title = Balance",
       "supplier-overview-table-amount": "Amount",
       "supplier-overview-table-account": "Account",
       "supplier-overview-table-view-details": "View details",
       "supplier-overview-balance-details-dialog": "\n .dialogTitle = Balance details\n .subtitle = Period: { $periodStart} - { $periodEnd }",
       "supplier-overview-balance-details-dialog-select-order": "Show orders",
       "supplier-overview-balance-details-dialog-select-order-label": "\n .label = Show orders",
       "supplier-overview-balance-details-dialog-select-order-mode-net-sales": "Net turnover",
       "supplier-overview-balance-details-dialog-select-order-mode-bank-transfers": "Bank transfers",
       "supplier-overview-balance-details-dialog-select-order-mode-balance": "Balance",
       "supplier-overview-balance-details-dialog-compact-view-label": "Show gross turnover and fees",
       "supplier-overview-balance-details-dialog-table-order-id-column": "Order ID",
       "supplier-overview-balance-details-dialog-table-rsp-reference-column": "PSP Reference",
       "supplier-overview-balance-details-dialog-table-booked-column": "Booked",
       "supplier-overview-balance-details-dialog-table-available-column": "Available",
       "supplier-overview-balance-details-dialog-table-gross-column": "Gross",
       "supplier-overview-balance-details-dialog-table-fee-column": "Fee",
       "supplier-overview-balance-details-dialog-table-net-column": "Net",
       "supplier-overview-balance-details-dialog-table-effective-column": "Effective amount",
       "supplier-overview-balance-details-dialog-table-type-column": "Type",
       "supplier-overview-balance-details-dialog-table-payment-type-bank-transfer": "Payout",
       "supplier-overview-balance-details-dialog-table-payment-type-previous-revenue": "Earlier",
       "supplier-overview-balance-details-dialog-table-payment-type-deferred-revenue": "Deferred revenue",
       "supplier-overview-balance-details-dialog-table-payment-type-normal-revenue": "Revenue",
       "supplier-overview-balance-details-dialog-table-payment-type-accrued-revenue": "Accrued",
       "supplier-overview-balance-details-dialog-number-of-orders": "\n .title = Number of orders",
       "supplier-overview-balance-details-dialog-table-effective-total": "\n .title = Total effective amount",
       "supplier-overview-balance-details-dialog-table-gross-total": "\n .title = Gross total",
       "supplier-overview-balance-details-dialog-table-fee-total": "\n .title = Fee total",
       "supplier-overview-balance-details-dialog-table-net-total": "\n .title = Net total",

        // Supplier > Admin > Merchants
        "supplier-admin-merchants-header": "\n .title = Merchants",
        "supplier-admin-merchants-create-button": "Create new",
        "supplier-admin-merchants-table-edit-button": "Edit",
        "supplier-admin-merchants-table-delete-button": "Delete",
        "supplier-admin-merchants-table-delete-modal-title": "merchant",
        "supplier-admin-merchants-table-reg-no-column": "Case no.",
        "supplier-admin-merchants-table-merchant-column": "Merchant",
        "supplier-admin-merchants-table-connected-shops": "Shops:",
        "supplier-admin-merchants-table-connected-customers": "Customers:",
        "supplier-admin-merchants-table-connected-devices": "Devices:",
        "supplier-admin-merchant-create-title": "\n .title = Create merchant",
        "supplier-admin-merchant-edit-title": "\n .title = Edit merchant",
        "supplier-admin-merchants-save-button": "Save",
        "create-or-edit-supplier-admin-merchant-field-caseNumber": "\n .label = Case no.\n .placeholder = Enter a Case no.\n .helperText = Your internal reference number for this merchant",
        "create-or-edit-supplier-admin-merchant-field-name": "\n .label = Name\n .placeholder = Enter merchant name",
        "create-or-edit-supplier-admin-merchant-field-street": "\n .label = Street\n .placeholder = Enter street",
        "create-or-edit-supplier-admin-merchant-field-streetNumber": "\n .label = Street no\n .placeholder = Enter street no",
        "create-or-edit-supplier-admin-merchant-field-postalCode": "\n .label = Postal code\n .placeholder = Enter postal code",
        "create-or-edit-supplier-admin-merchant-field-city": "\n .label = City\n .placeholder = Enter city",
        "create-or-edit-supplier-admin-merchant-field-country": "\n .label = Country",
        "create-or-edit-supplier-admin-merchant-contact-details-title": "\n .title = Contact details",
        "create-or-edit-supplier-admin-merchant-country-denmark-item": "Denmark",
        "create-or-edit-supplier-admin-merchant-contact-details-info": "Contact details will be public for the customers.",
        "create-or-edit-supplier-admin-merchant-field-contact-details-name": "\n .label = Name\n .placeholder = Enter name",
        "create-or-edit-supplier-admin-merchant-field-contact-details-email": "\n .label = Email\n .placeholder = Enter email",
        "create-or-edit-supplier-admin-merchant-field-contact-details-phone": "\n .label = Phone number\n .placeholder = Enter phone number",
        "create-or-edit-supplier-admin-merchant-field-is-required": "Field is required",
        "create-or-edit-supplier-admin-merchant-credit-card-payments-title": "\n .title = Credit card payments",
        "create-or-edit-supplier-admin-merchant-status-approved": "Active",
        "create-or-edit-supplier-admin-merchant-status-no-registered-bank-account": "No registered bank account",
        "create-or-edit-supplier-admin-merchant-status-no-registered-bank-account-description": "Register a bank account for your acquiring agreement <retryLink>here.</retryLink>",
        "create-or-edit-supplier-admin-merchant-status-no-registered-bank-account-description-readonly": "Register a bank account for your acquiring agreement.",
        "create-or-edit-supplier-admin-merchant-status-invalid": "Agreement invalid",
        "create-or-edit-supplier-admin-merchant-status-invalid-description": "Correct your application for acquiring agreement <retryLink>here.</retryLink>",
        "create-or-edit-supplier-admin-merchant-status-invalid-description-readonly": "Correct your application for acquiring agreement.",
        "create-or-edit-supplier-admin-merchant-status-pending": "Agreement pending",
        "create-or-edit-supplier-admin-merchant-status-pending-description": "Wait for acquirer to finish processing your acquiring agreement application.",
        "create-or-edit-supplier-admin-merchant-status-no-payment-setup": "No payment setup",
        "create-or-edit-supplier-admin-merchant-status-no-payment-setup-description": "Setup credit card payments for this merchant to begin receiving payments.",
        "create-or-edit-supplier-admin-merchant-status-bank-account-pending": "Bank account pending",
        "create-or-edit-supplier-admin-merchant-status-bank-account-pending-description": "Wait for acquirer to finish verifying your bank account.",
        "create-or-edit-supplier-admin-merchant-acquirer": "Acquirer:",
        "create-or-edit-supplier-admin-merchant-acquirer-type-adyen-pos": "Adyen",
        "create-or-edit-supplier-admin-merchant-acquirer-type-adyen": "Adyen",
        "create-or-edit-supplier-admin-merchant-bank-details": "Bank details:",
        "create-or-edit-supplier-admin-merchant-industry-codes": "Industry codes:",
        "create-or-edit-supplier-admin-merchant-status-action-button-setup": "Setup",
        "create-or-edit-supplier-admin-merchant-status-action-button-edit": "Edit",
        "create-or-edit-supplier-admin-merchant-dialog-title": "Credit card payment setup",
        "create-or-edit-supplier-admin-merchant-dialog-field-acquiring-agreement": "\n .label = Acquiring agreement",
        "create-or-edit-supplier-admin-merchant-dialog-field-sales-channels": "\n .label = Sales channel",
        "create-or-edit-supplier-admin-merchant-dialog-field-bank-account": "\n .label = Bank account",
        "create-or-edit-supplier-admin-merchant-dialog-field-bank-account-helper": "Select the bank account where to sales will be transfered. You will only see banks accounts which have been created in the Adyen platform. To add a new bank account see <retryLink>guide.</retryLink>",
        "create-or-edit-supplier-admin-merchant-dialog-field-industry-codes": "\n .label = Industry codes",
        "create-or-edit-supplier-admin-merchant-dialog-field-default-currency": "\n .label = Default currency",
        "create-or-edit-supplier-admin-merchant-dialog-save-button": "Save",

        //Supplier > Admin > T&C
        "supplier-admin-settings-terms-and-conditions": "\n .title = Terms and conditions",
        "supplier-admin-settings-terms-and-conditions-list-create-button": "Create new",
        "supplier-admin-settings-terms-and-conditions-create-button": "Create",
        "supplier-admin-settings-terms-and-conditions-update-button": "Update",


        // TERMS AND CONDITIONS CREATE
        "supplier-terms-and-conditions-alert-title": "Terms and conditions",
        "supplier-terms-and-conditions-alert-subtitle1": "It is your own responsibility to ensure that the terms and conditions comply with the applicable requirements.",
        "supplier-terms-and-conditions-alert-subtitle2": "Read about Adyen's required T&C, which you must comply with <externalLink>here</externalLink>.",
        "supplier-terms-and-conditions-alert-subtitle3": "Download our T&C template: <externalLinkDA>Danish</externalLinkDA> | <externalLinkEN>English</externalLinkEN>.",
        "supplier-terms-and-conditions-dropdown-english": "English",
        "supplier-terms-and-conditions-dropdown-danish": "Danish",
        "supplier-terms-and-conditions-name-label": "\n .label = Name",
        "supplier-terms-and-conditions-language-label": "\n .label = Language",
        "supplier-terms-and-conditions-type-label": "\n .label = Type",
        "supplier-terms-and-conditions-dropdown-pos": "POS",
        "supplier-terms-and-conditions-type-ecom": "E-Commerce",
        "supplier-terms-and-conditions-aside-settings": "\n .title = Settings",
        "supplier-terms-and-conditions-aside-active": "Active: ",
        "supplier-terms-and-conditions-aside-history": "\n .title = History",
        "supplier-terms-and-conditions-aside-version": "Version: ",
        "supplier-terms-and-conditions-aside-created": "Created: ",
        "supplier-terms-and-conditions-aside-updated": "Updated: ",
        "terms-and-conditions-error-label-name": "Name",
        "terms-and-conditions-error-label-type": "Type",
        "terms-and-conditions-error-label-language": "Language",
        "terms-and-conditions-error-label-text": "Text",


        // TERMS AND CONDITIONS TABLE GENERAL
        "terms-and-conditions-table-header-name": "Name",
        "terms-and-conditions-table-header-language": "Language",
        "terms-and-conditions-table-header-name-type": "Type",
        "terms-and-conditions-table-header-name-status": "Status",
        "terms-and-conditions-table-button-edit":"Edit",
        "terms-and-conditions-table-button-delete":"Delete",
        "terms-and-conditions-table-button-approval":"Approval",
        "terms-and-conditions-table-status-active":"Active",
        "terms-and-conditions-table-status-inactive":"Inactive",
        "terms-and-conditions-table-status-pending":"Pending",


        "terms-and-conditions-modal-button-delete-label": "Delete",
        "terms-and-conditions-modal-question": "Are you sure you want to delete",
        "terms-and-conditions-modal-title": "Terms and conditions",


        // Supplier > Admin > Administrators
        "supplier-users-page-header": "\n .title = Administrators",
        "supplier-users-suppliers-tab-title": "Supplier administrators",
        "supplier-users-merchants-tab-title": "Merchant administrators",
        "supplier-users-table-merchant-column": "Merchant",
        "supplier-users-create-admin-button": "Create new",


        // Supplier > Admin > Account > Company Account
        "supplier-update-account-title":"\n .title = Supplier account",
        "supplier-update-account-update-button":"Update",
        "supplier-update-account-nav-item-home":"Home",
        "supplier-update-account-nav-item-account":"Account",
        "supplier-update-account-registration-number-label":"\n .label = Registration number",
        "supplier-update-account-error-label-registration-number":"Registration number",

        // Supplier > Admin > Account > GDPR
        "supplier-account-gdpr-title":"\n .title = GDPR",
        "supplier-account-gdpr-tab-documents":"Documents",
        "supplier-account-gdpr-tab-export":"Exports",
        "supplier-account-gdpr-export-title":"Download users",
        "supplier-account-gdpr-export-info":"\n .description = This feature enables you to export administrators and/or users from all administrative units, including supplier, merchant, company, tenant, and service center. In order to download users from other administrative units, you must register one or more email domains associated with your company. These domains will be used to identify your company's users. If your company does not have any verified domains, you will be unable to download users from other units. For assistance with domain verification, please contact our Support Team.",
        "supplier-account-gdpr-export-user-types-select-item-user": "Users",
        "supplier-account-gdpr-export-user-types-select-item-administrator": "Administrators",

        "supplier-account-gdpr-export-user-types-select-label":"\n .label = User types",
        "supplier-account-gdpr-export-user-types-select-input-label":"User types",
        "supplier-account-gdpr-export-user-deletion-period-select-input-label":"User deletion period",
        "supplier-account-gdpr-export-user-deletion-period-select-label":"\n .label = User deletion period",
        "supplier-account-gdpr-export-user-deletion-period-select-item-days-180":"180 days",
        "supplier-account-gdpr-export-user-deletion-period-select-item-days-90":"90 days",
        "supplier-account-gdpr-export-user-deletion-period-select-item-days-30":"30 days",
        "supplier-account-gdpr-export-user-deletion-period-select-item-days-7":"7 days",
        "supplier-account-gdpr-export-include-deleted-switch-label":"\n .label = Include deleted users",
        "supplier-account-gdpr-export-exported-domains-subtitle":"Verified domains being exported:",
        "supplier-account-gdpr-export-no-domains-registered":"No verified company domains have been registered.",
        "supplier-account-gdpr-export-export-button":"Export to CSV",



        // --- Support ---

        // Support > Admin > Features
        "support-admin-features-header": "\n .title = Features",
        "support-admin-features-table-header-name": "Name",
        "support-admin-features-table-header-plan": "Plan",
        "support-admin-features-table-plan-none": "None",
        "support-admin-features-table-plan-professional": "Professional",
        "support-admin-features-table-plan-enterprise": "Enterprise",
        "support-admin-features-table-header-status": "Status",
        "support-admin-features-table-header-enabled": "Enabled",
        "support-admin-features-table-action-edit": "Edit",
        "support-admin-features-status-label-new": "\n .label = NEW",
        "support-admin-features-status-label-beta": "\n .label = BETA",
        "support-admin-features-status-new": "NEW",
        "support-admin-features-status-beta": "BETA",

         // Support > Admin > Features > Edit
        "support-admin-feature-edit-header": "\n .title = Edit feature",
        "support-admin-feature-edit-save-button": "Save",
        "support-admin-feature-edit-nav-item-feature": "Edit feature",
        "support-admin-feature-edit-programmatic-id-label": "\n .label = Programmatic ID",
        "support-admin-feature-edit-name-label": "\n .label = Name",
        "support-admin-feature-edit-plan-label": "\n .label = Plan",
        "support-admin-feature-edit-status-label": "\n .label = Status",
        "support-admin-feature-edit-enabled-label": "Enabled:",
        "support-admin-feature-edit-settings-title": "\n .title = Settings",

        // Support > Admin > GDPR
        "support-nav-item-gdpr": "GDPR",
        "support-admin-gdpr-page-header": "\n .title = GDPR",
        "support-admin-gdpr-breadcrumb": "GDPR",
        "support-admin-gdpr-administrators-title": "Administrators",
        "support-admin-gdpr-user-type-label": "\n .label = User type",
        "support-admin-gdpr-user-type-select-item-merchant-admins": "Merchant admins",
        "support-admin-gdpr-user-type-select-item-supplier-admins": "Supplier admins",
        "support-admin-gdpr-user-type-select-item-company-admins": "Company admins",
        "support-admin-gdpr-user-type-select-item-company-agreement-owners": "Company agreement owners",
        "support-admin-gdpr-include-active-users": "Include active users",
        "support-admin-gdpr-include-inactive-users": "Include inactive users",
        "support-admin-gdpr-export-button": "Export contact list",
        "support-admin-gdpr-export-button-label": "Export contact list",
        "support-admin-gdpr-export-button-exporting": "Exporting...",

        // Support > Reports > Entities
        "support-entity-header-title" : "\n .title = Entities",
        "support-entity-header-menu-button-create": "Create",
        "support-entity-header-menu-button-create-supplier": "Create Supplier",
        "support-entity-header-menu-button-create-merchant": "Create Merchant",
        "support-entity-header-menu-button-create-company": "Create Company",
        "support-entity-header-menu-button-create-tenant": "Create Tenant",
        "support-entity-header-nav-item-home" : "Home",
        "support-entity-header-nav-item-entities" : "Entities",
        "support-entity-table-header-id": "ID",
        "support-entity-table-header-name": "Name",
        "support-entity-table-header-address": "Address",
        "support-entity-table-header-type": "Type",
        "support-entity-table-header-status": "Status",
        "support-entity-table-button-details": "Details",
        "support-entity-table-button-edit": "Edit",
        "support-entity-table-button-delete": "Delete",
        "support-entity-table-status-active": "Active",
        "support-entity-table-status-inactive": "Inactive",
        "support-entity-confirm-delete-entity-dialog": "\n .typeOfEntity = entity",
        "support-entity-table-cell-name-agreement-owner": "Agreement owner",
        "support-entity-table-cell-name-reg-no": "Reg. no.:",
        "support-entity-table-type-supplier": "\n .label = Supplier",
        "support-entity-table-show-inactive": "\n .label = Show inactive",
        "support-entity-table-type-merchant": "\n .label = Merchant",
        "support-entity-table-type-company": "\n .label = Company",
        "support-entity-table-type-tenant": "\n .label = Tenant",
        "support-entity-table-type-service-center": "\n .label = Service Center",
        "support-entity-table-type-user": "\n .label = User",
        "support-entity-details-connected-merchants": "\n .title = Connected merchants",
        "support-entity-details-connected-companies": "\n .title = Connected companies",
        "support-entity-details-connected-suppliers": "\n .title = Connected suppliers",
        "support-entity-details-connected-devices": "\n .title = Connected devices",
        "support-entity-details-id": "ID: { $id }",
        "support-entity-table-entity-type-label":"Entity Type",
        "support-entity-table-entity-type-select-item-all":"All",
        "support-entity-table-entity-type-select-item-supplier":"Supplier",
        "support-entity-table-entity-type-select-item-merchant":"Merchant",
        "support-entity-table-entity-type-select-item-company":"Company",
        "support-entity-table-entity-type-select-item-service-center":"Service center",
        "support-create-entity-error-label-company-invalid-type":"Invalid type",
        "support-create-entity-error-label-company-type":"Type",
        "support-create-entity-error-label-system-owner":"Agreement owner",
        "support-create-entity-error-label-company-number":"Company number",
        "support-create-entity-error-label-ean-number":"EAN number",
        "support-create-entity-error-label-invoice-type":"Invoice Type",
        "support-create-entity-error-label-invoice-email":"Email",
        "support-create-entity-error-label-attention":"Attention",
        "support-create-entity-error-label-debitot-no":"Debitor number",
        "support-create-entity-error-label-reminder-email":"Email",
        "support-create-entity-error-label-po-number":"Purchase order number",
        "support-create-entity-error-label-company-name":"Company name",
        "support-create-entity-error-label-address":"Address",
        "support-create-entity-error-label-country":"Country",
        "support-create-entity-error-label-postal-code":"Postal code",
        "support-create-entity-error-label-city":"City",
        "support-create-entity-error-label-contact-person":"Contact person",
        "support-create-entity-error-label-email":"Email",
        "support-create-entity-error-label-telephone":"Telephone",
        "support-create-entity-agreement-owner-subtitle":"Agreement owner",
        "support-create-entity-ean-number-label":"\n .label = EAN number",
        "support-create-entity-address1-label":"\n .label = Address line 1\n .placeholder = Street and street number",
        "support-create-entity-address2-label":"\n .label = Address line 2\n .placeholder = Floor, apartment no., etc.",
        "support-create-entity-postal-code-label":"\n .label = Postal code",
        "support-create-entity-city-label":"\n .label = City",
        "support-create-entity-contact-person-label":"\n .label = Contact person",
        "support-create-entity-email-label":"\n .label = Email",
        "support-create-entity-telephone-label": "\n .label = Telephone",
        "support-create-entity-type-choose-label":"\n .label = Choose",
        "support-create-entity-dropdown-choose-yes":"Yes",
        "support-create-entity-dropdown-choose-no":"No",
        "support-create-entity-alert-title":"\n .title = An agreement owner owns the agreement with FacilityNet and will receive related invoices. For this reason we need invoice details for agreement owners.",
        "support-create-entity-subscription-details-subtitle": "Subscription details",
        "support-create-entity-subscription-details-field-implementationDeadline": "\n .label = Deadline for implementation",
        "support-create-entity-subscription-details-alert-title": "\n .title = This is the date by which the customer wants the system to go into production. This means onboarding, internal testing and any trial period must be completed before this date.",
        "support-create-entity-contact-details-subtitle":"Contact details",
        "support-create-entity-invoice-details-subtitle":"Invoice details",
        "support-create-entity-send-invoice-to-label":"\n .label = Send invoice to",
        "support-create-entity-dropdown-ean-number":"EAN number",
        "support-create-entity-dropdown-email":"Email",
        "support-create-entity-debitor-number-label":"\n .label = Debitor Number\n .helperText = This identifies the debtor in FacilityNet accounting system.",
        "support-create-entity-invoice-email-label":"\n .label = Email",
        "support-create-entity-attention-label":"\n .label = Attention",
        "support-create-entity-reminder-email-label":"\n .label = Email for reminders / account statements",
        "support-create-entity-po-number-label":"\n .label = Purchase order number",
        "support-create-entity-type-label":"\n .label = Type",
        "support-create-entity-country-label":"\n .label = Country",
        "support-create-entity-dropdown-country-denmark":"Denmark",
        "support-create-entity-dropdown-private-company":"Private company",
        "support-create-entity-dropdown-private-person":"Private person",
        "support-create-entity-dropdown-public-limited-company":"Public limited company",
        "support-create-entity-aside-history": "\n .title = History",
        "support-create-entity-aside-version": "Version:",
        "support-create-entity-aside-created": "Created:",
        "support-create-entity-aside-updated": "Updated:",

        // ---  Support Reports --- Messages > Email
        "support-messages-email-title": "\n .title = Email",
        "support-messages-email-subject-label":"\n .label = Email subject",
        "support-messages-email-receiver-label":"\n .label = Receiver \n .placeholder = Enter email or user id",
        "support-messages-email-table-header-receiver":"Receiver",
        "support-messages-email-table-header-subject":"Subject",
        "support-messages-email-table-header-sent-time":"Sent time",
        "support-messages-email-table-header-status":"Status",
        "support-messages-email-table-status-sent":"Sent",
        "support-messages-email-table-status-not-sent":"Not sent",
        "support-messages-email-table-cell-subject-created":"Created: { $time }",
        "support-messages-email-resend-button":"Resend",
        "support-messages-email-export-button":"Export",
        "support-messages-email-details-status-label":"Status:",
        "support-messages-email-details-created-label":"Created:",
        "support-messages-email-details-sent-time-label":"Sent time:",
        "support-messages-email-details-error-message-label":"Error message:",
        "support-messages-email-details-from-label":"From:",
        "support-messages-email-details-subject-label":"Subject:",
        "support-messages-email-details-to-label":"To:",
        "support-messages-email-details-cc-label":"CC:",
        "support-messages-email-details-bcc-label":"BCC:",
        "support-messages-email-details-resend-email-button":"Resend email",
        "support-messages-email-details-resend-email-title":"Resend email",
        "support-messages-email-details-sent-button":"Sent",
        "support-messages-email-resent-dialog-title":"Confirm to resend emails",
        "support-messages-email-resent-dialog-subtitle":"Are you sure you want to resend { $itemsAmount } emails?",
        "support-messages-email-resent-dialog-cancel-button":"No",
        "support-messages-email-resent-dialog-submit-button":"Yes",

        // ---  Support Reports --- Messages > SMS
        "support-messages-sms-title": "\n .title = SMS",
        "support-messages-sms-receiver-label":"\n .label = Receiver",
        "support-messages-sms-text-body-label":"\n .label = Text body",
        "support-messages-sms-table-header-receiver":"Receiver",
        "support-messages-sms-table-header-created":"Created",
        "support-messages-sms-table-header-sent":"Sent",
        "support-messages-sms-table-header-status":"Status",
        "support-messages-sms-table-status-sent":"Sent",
        "support-messages-sms-table-status-not-sent":"Not sent",
        "support-messages-sms-export-button":"Export",
        "support-messages-sms-details-status-label":"Status:",
        "support-messages-sms-details-id-label":"id:",
        "support-messages-sms-details-created-label":"Created:",
        "support-messages-sms-details-sent-time-label":"Sent time:",
        "support-messages-sms-details-error-message-label":"Error message:",
        "support-messages-sms-details-text-message-label":"Text message:",
        "support-messages-sms-details-from-label":"From:",
        "support-messages-sms-details-to-label":"To:",


        // ---  Support Reports --- Accounting > Subscriptions
        "support-subscriptions-header": "\n .title = Subscriptions",
        "support-subscriptions-table-order-id-column": "Order ID",
        "support-subscriptions-table-employee-column": "Employee",
        "support-subscriptions-table-subscribed-column": "Subscribed",
        "support-subscriptions-table-unsubscribed-column": "Unsubscribed",
        "support-subscriptions-table-payment-column": "Payment",
        "support-subscriptions-table-amount-column": "Amount",
        "support-subscriptions-table-cancel-subscription": "Cancel subscription",
        "support-subscriptions-table-details": "Details",
        "support-subscriptions-table-filters-merchant-title":"\n .title = Merchant",
        "support-subscriptions-table-filters-customer-title":"\n .title = Customer",
        "support-subscriptions-table-filters-payment-title":"\n .title = Payment",

        // ---  Support Reports --- Accounting > Meeting Service
        "support-accounting-meeting-service-header": "\n .title = Meeting service",
        "support-accounting-meeting-service-table-order-id-column": "Order ID",
        "support-accounting-meeting-service-table-booked-date-column": "Booked date",
        "support-accounting-meeting-service-table-delivery-time-column": "Delivery time",
        "support-accounting-meeting-service-table-employee-column": "Creator",
        "support-accounting-meeting-service-table-status":"Status",
        "support-accounting-meeting-service-table-amount-column": "Amount (DKK)",
        "support-accounting-meeting-service-table-show-receipt": "Show receipt",
        "support-accounting-meeting-service-table-floating-action-bar-export": "\n .title = Export",


        // ---  Support Reports --> Printer Queue
        "support-printer-queue-title": "\n .title = Printer queue",
        "support-printer-queue-merchant-label":"\n .label = Merchant",
        "support-printer-queue-order-id-label":"\n .label = Order ID",
        "support-printer-queue-table-header-id":"Id",
        "support-printer-queue-table-header-created":"Created",
        "support-printer-queue-table-header-print-at":"Print at",
        "support-printer-queue-table-header-device-name":"Device name",
        "support-printer-queue-table-header-order-id":"Order ID",
        "support-printer-queue-table-header-status":"Status",
        "support-printer-queue-table-device-group":" Group: ",
        "support-printer-queue-table-status-printed":"Printed",
        "support-printer-queue-table-status-queue":"Queue",
        "support-printer-queue-table-raw-receipt-action":"Raw receipt",
        "support-printer-details-status-label":"Status:",
        "support-printer-details-created-label":"Created:",
        "support-printer-details-printed-at-label":"Printed at:",
        "support-printer-details-device-group-subtitle":"Device group:",
        "support-printer-details-device-subtitle":"Device:",
        "support-printer-details-id-label":"ID:",
        "support-printer-details-name-label":"Name:",
        "support-printer-details-mime-type-label":"Mime type:",
        "support-printer-details-priority-label":"Priority:",
        "support-printer-details-job-token-label":"Job token:",


         // ---  Support Reports --- Orders > POS
        "support-orders-pos-title": "\n .title = POS",
        "support-orders-pos-order-id-label":"\n .label = Order ID",
        "support-orders-pos-email-label":"\n .label = Email",
        "support-orders-pos-table-header-order-id":"Order id",
        "support-orders-pos-table-header-transaction-time":"Transaction time",
        "support-orders-pos-table-header-customer":"Customer",
        "support-orders-pos-table-header-merchant":"Merchant",
        "support-orders-pos-table-header-amount":"Amount",
        "support-orders-pos-table-action-show-receipt":"Show receipt",
        "support-orders-pos-table-action-show-order-details":"Show order details",



        // --- Support entity---
        "support-create-supplier-title": "\n .title = Create supplier",
        "support-update-supplier-title": "\n .title = Update supplier",
        "support-create-supplier-create-button": "Create",
        "support-create-supplier-update-button": "Update",
        "support-create-supplier-nav-item-home": "Home",
        "support-create-supplier-nav-item-entities": "Entities",
        "support-create-supplier-nav-item-create-supplier": "Create supplier",
        "support-create-supplier-nav-item-update-supplier": "Update supplier",
        "support-create-supplier-aside-settings": "\n .title = Settings",
        "support-create-supplier-aside-active": "Active:",
        "support-create-supplier-company-number-label":"\n .label = Company number",
        "support-create-supplier-company-name-label":"\n .label = Company name",
        "support-create-subscription-status-title": "\n .title = Subscription status",
        "support-create-supplier-subscription-status": "Status",
        "support-create-supplier-subscription-status-mode-creating": "Creating",
        "support-create-supplier-subscription-status-mode-onboarding": "Onboarding",
        "support-create-supplier-subscription-status-mode-trial": "Trial",
        "support-create-supplier-subscription-status-mode-live": "LIVE",
        "support-create-supplier-subscription-status-mode-unsubscribing": "Unsubscribing",
        "support-create-supplier-subscription-status-mode-unsubscribed": "Unsubscribed",
        "support-create-supplier-subscription-status-created": "Created",
        "support-create-supplier-subscription-status-implementation-deadline": "Implementation deadline",
        "support-create-supplier-subscription-status-onboarding-email-sent": "Onboarding email sent",
        "support-create-supplier-subscription-status-trial-started": "Trial started",
        "support-create-supplier-subscription-status-subscription-started": "Subscription started",
        "support-create-supplier-subscription-status-subscription-ending": "Subscription ending",
        "support-create-supplier-subscription-status-button-mode-creating": "Send onboarding articles",
        "support-create-supplier-subscription-status-button-mode-onboarding": "Complete onboarding",
        "support-create-supplier-subscription-status-button-mode-trial": "Go live",
        "support-create-supplier-subscription-status-button-mode-live": "End subscription",
        "support-create-supplier-subscription-status-button-mode-unsubscribing": "Edit",
        "support-create-supplier-subscription-status-button-mode-unsubscribed": "Edit",
        "support-create-supplier-subscription-status-begin-onboarding-dialog": "Begin onboarding",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-articles-to-send": "Articles to send",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-destination": "Destination",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-button-next": "Next",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-existing-administrators": "Existing administrators",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-extra-receivers": "Extra receivers",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-button-begin": "Begin",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-supplier-admin": "Supplier admin: {$adminDetails}",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-kitchen-admin": "Kitchen admin: {$adminDetails}",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-label-email": "\n .label = Email \n .placeholder = Receiver email",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-button-add": "Add",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-email-error": "Invalid email address",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-administrators-error": "At least one administrator must be selected",


        // --- Support company ---
        "support-create-company-title": "\n .title = Create company",
        "support-update-company-title": "\n .title = Update company",
        "support-create-company-create-button": "Create",
        "support-create-company-update-button": "Update",
        "support-create-company-nav-item-home": "Home",
        "support-create-company-nav-item-entities": "Entities",
        "support-create-company-nav-item-create-company": "Create company",
        "support-create-company-nav-item-update-company": "Update company",
        "support-create-company-aside-settings": "\n .title = Settings",
        "support-create-company-aside-active": "Active:",
        "support-create-company-office-hotel-label":"Office hotel:",
        "support-create-company-office-hotel-helper-text":"Helper text",
        "support-create-company-company-number-label":"\n .label = Company number",
        "support-create-company-main-ean-number-label":"\n .label = Main EAN number",
        "support-create-company-company-name-label":"\n .label = Company name",
        "support-create-company-error-label-main-ean-number":"Main Ean Number",
        "support-create-company-error-label-url-identifier":"Url identifier",
        "support-create-company-aside-is-self-sign-up":"\n .title = Self sign-up",
        "support-create-company-url-identifier-label":"\n .label = Signup URL identifier\n .helperText = This is used for generating the user signup URL.",
        "support-create-company-signup-link-subtitle":"Signup link:",

        // Invoicing
        "support-reports-basis-for-invoicing-page-header": "\n .title = Basis for invoicing",
        "support-reports-invoicing-header-nav-item": "Invoicing",
        "support-reports-invoicing-header-nav-item-basis-for-invoicing": "Basis for invoicing",
        "support-reports-invoicing-table-debtor-label": "\n .label = Debtor",
        "support-reports-invoicing-table-header-product-no": "Product no.",
        "support-reports-invoicing-table-header-name": "Name",
        "support-reports-invoicing-table-header-price": "Price",
        "support-reports-invoicing-table-header-items": "Items",
        "support-reports-invoicing-table-header-total": "Total",
        "support-reports-invoicing-table-bottom-transactions": "Transactions",
        "support-reports-invoicing-table-bottom-subscriptions": "Subscriptions",
        "support-reports-invoicing-table-bottom-total": "Total",

        // Support > Reports > Health > Server Memory
        "support-reports-health-server-memory-page-header": "\n .title = Server memory",
        "support-reports-health-server-memory-table-header-memory-type": "Memory type",
        "support-reports-health-server-memory-table-header-used": "Used",
        "support-reports-health-server-memory-table-header-commited": "Comitted",
        "support-reports-health-server-memory-table-header-max": "Max",


        // Support > Reports > Health > Database health
        "support-reports-health-database-page-header": "\n .title = Database health",


        // Support > Reports > Health > Adyen
        "support-reports-health-adyen-page-header": "\n .title = Adyen",
        "support-reports-health-adyen-tab-summary": "Summary",
        "support-reports-health-adyen-tab-account-holders": "Account Holders",
        'support-reports-health-adyen-run-button':"Run",
        'support-reports-health-adyen-results':"Results:",
        'support-reports-health-adyen-api-status-unknown':"Unknown",
        'support-reports-health-adyen-api-status-ok':"Ok",
        'support-reports-health-adyen-api-status-failed':"Failed",
        'support-reports-health-adyen-summary-aside-title':"API connection test",
        'support-reports-health-adyen-summary-last-run':"Last run: {$lastRun}",
        'support-reports-health-adyen-summary-legal-entity-management':"Legal Entity Management:",
        'support-reports-health-adyen-summary-balance-platform':"Balance Platform:",
        'support-reports-health-adyen-summary-psp-platform':"PSP Platform:",
        'support-reports-health-adyen-summary-main-title':"Terminal cheatsheet",
        'support-reports-health-adyen-summary-terminal-key':"Key",
        'support-reports-health-adyen-summary-terminal-function':"Function",
        'support-reports-health-adyen-summary-terminal-key-cancel':"Cancel",
        'support-reports-health-adyen-summary-terminal-key-clear':"Clear",
        'support-reports-health-adyen-summary-terminal-key-confirm':"Confirm",
        'support-reports-health-adyen-summary-terminal-press-1':"Press 1 +",
        'support-reports-health-adyen-summary-terminal-press-5':"Press 5 +",
        'support-reports-health-adyen-summary-terminal-press-8':"Press 8 +",
        'support-reports-health-adyen-summary-terminal-press-9':"Press 9 +",
        'support-reports-health-adyen-summary-terminal-function-custom-menu':"Custom menu",
        'support-reports-health-adyen-summary-terminal-function-informational-menu':"Informational menu",
        'support-reports-health-adyen-summary-terminal-function-payments-menu':"Payments menu",
        'support-reports-health-adyen-summary-terminal-function-admin-menu':"Admin menu",


        // Support > Reports > Health > Adyen > Account Holders
        "adyen-account-holders-table-header-id": "ID",
        "adyen-account-holders-table-cell-entity-id": "Legal entity ID: {$entityId}",
        "adyen-account-holders-table-cell-entity-liable": "Liable",
        "adyen-account-holders-table-details-balance-accounts": "Balance accounts:",
        "adyen-account-holders-table-details-stores": "Stores:",
        "adyen-account-holders-table-header-supplier": "Supplier",
        "adyen-account-holders-table-header-status": "Status",
        "adyen-account-holders-table-header-status-valid": "Valid",
        "adyen-account-holders-table-header-status-invalid": "Invalid",
        "adyen-account-holders-table-header-status-pending": "Pending",
        "adyen-account-holders-table-header-updated": "Updated",


        // Support > Reports > Health > Scheduler
        "support-reports-health-scheduler-page-header": "\n .title = Scheduler",
        "support-reports-health-scheduler-page-subtitle-main-job": "Main job:",
        "support-reports-health-scheduler-page-subtitle-load-in-seconds": "Load in seconds:",
        "support-reports-health-scheduler-table-header-name": "Name",
        "support-reports-health-scheduler-table-header-cron": "Cron",
        "support-reports-health-scheduler-table-header-last-run": "Last run",
        "support-reports-health-scheduler-table-header-next-run": "Next run",
        "support-reports-health-scheduler-table-header-status": "Status",
        "support-reports-health-scheduler-table-status-active": "Active",
        "support-reports-health-scheduler-table-status-inactive": "Inactive",
        "support-reports-health-scheduler-table-status-paused": "Paused",
        "support-reports-health-scheduler-table-action-edit": "Edit",
        "support-reports-health-scheduler-table-action-pause": "Pause",
        "support-reports-health-scheduler-table-action-start": "Start",
        "support-reports-health-scheduler-table-action-stop": "Stop",


        // Support > Reports > Health > Scheduler > Edit Job
        "support-reports-health-schedule-edit-page-header": "\n .title = Edit scheduler job",
        "support-reports-health-schedule-edit-page-nav-item-edit-job":"Edit Job",
        "support-reports-health-schedule-edit-page-edit-button":"Edit",
        "support-reports-health-schedule-edit-page-start-time-label":"\n .label = Start time",
        "support-reports-health-schedule-edit-page-cron-expression-label":"\n .label = Cron expression",
        "support-reports-health-schedule-edit-page-settings-title":"\n .title = Settings",
        "support-reports-health-schedule-edit-page-settings-active-label":"Active:",
        "support-reports-health-schedule-edit-page-information-title":"\n .title = Information",
        "support-reports-health-schedule-edit-page-information-id":"ID:",
        "support-reports-health-schedule-edit-page-information-name":"Name:",
        "support-reports-health-schedule-edit-page-information-last-run":"Last run:",

        // Support > TopBar > Awaiting approval
        "awaiting-approval-popover-not-approved-item": "\n .title = Awaiting approval\n .description = Orders that need to be approved",
        "awaiting-approval-popover-to-be-booked-item": "\n .title = To be invoiced\n .description = Meeting service orders that have been bookable for 3+ days",
        "awaiting-approval-popover-tooltip": "\n .title = Order notifications",
        "awaiting-approval-popover-section-meeting-service-title": "\n .title = Meeting service",
        "awaiting-approval-popover-section-takeaway-title": "\n .title = Takeaway",
        "awaiting-approval-popover-todays-orders-item": "\n .title = Today's orders\n .description = Meeting service orders for delivery today",
        "awaiting-approval-popover-todays-takeaway-orders-item": "\n .title = Today's orders\n .description = Takeaway orders for today",

        // Support > TopBar > Instructions Dialog
        "support-instructions-dialog-title": "Instructions",
        "support-instructions-button": "Instructions",

        // Non Admin User > TopBar > Create new

        // TopBar > New button > menu
        "top-bar-new-button": "New",
        "top-bar-new-menu-resource-booking-title": "Resource booking",
        "top-bar-new-menu-resource-booking-description": "Book rooms and other resources",
        "top-bar-new-menu-meeting-service-title": "Meeting service",
        "top-bar-new-menu-meeting-service-description": "Order meeting service",
        "top-bar-new-menu-take-away-title": "Takeaway",
        "top-bar-new-menu-take-away-description": "Purchase takeaway and other goods",
        // Takeaway
        "takeaway-kitchen-selector-title": "Select Shop",
        "takeaway-show-order-button": "Show order: { $price }",
        "create-order-take-away-title": "Takeaway",
        "create-order-take-away-title-with-kitchen": "Takeaway - { $kitchenName }",
        "takeaway-no-shops-empty": "\n .title = No takeaway shops available",

        // Takeaway > Date bar
        "takeaway-date-bar-or": "OR",
        "takeaway-date-bar-view-store-details": "View store details",

        // Takeaway > Menu
        "takeaway-menu-no-products-for-date": "No products available for { $date }",
        "takeaway-menu-no-products-for-date-empty": "\n .title = No products available\n .description = There are no products available at this time",
        "takeaway-menu-no-favorites-empty": "\n .title = No favorites yet\n .description = Tap the heart icon on a product to add it as a favorite",
        "takeaway-menu-no-search-results-empty": "\n .title = No results\n .description = Try adjusting your search",
        "takeaway-order-is-empty-button": "Order is empty",
        "takeaway-checkout-discount-label": "Save -{ $percentage }%",
        "takeaway-product-sold-out-snackbar": "The item is sold out",

        // Takeaway > Store details dialog
        "takeaway-store-details-title": "Store details",
        "takeaway-store-details-contact": "Contact",
        "takeaway-store-details-address": "Address",
        "takeaway-store-details-show-on-map": "Show on map",
        "takeaway-store-details-close-button": "Close",
        "takeaway-store-details-opening-hours-banner": "\n .title = Opening hours: { $hours }",

        // Takeaway > Basket drawer
        "takeaway-basket-date-card-delivery-date-label": "Delivery date:",
        "takeaway-checkout-total-label": "Total",
        "takeaway-checkout-vat-label": "VAT (25%)",
        "takeaway-checkout-confirm-button": "Complete payment",
        "takeaway-checkout-confirm-button-with-price": "Complete payment: { $price }",
        "takeaway-checkout-opening-hours-banner": "\n .title = { $kitchenName } is open { $hours }",

        // Takeaway > Checkout dialog
        "takeaway-confirm-order-dialog-title": "Confirm order",
        "takeaway-confirm-order-dialog-go-back-button": "Go Back",
        "takeaway-checkout-order-summary-title": "Order summary",
        "takeaway-checkout-private-section": "Private",
        "takeaway-checkout-payment-hint-by-method": "via { $method }",
        "takeaway-confirm-order-payment-method-title": "Payment Method",
        "takeaway-confirm-order-accounting-title": "Accounting",
        "takeaway-confirm-order-correct-order": "Correct order",
        "takeaway-checkout-order-summary-delivery-date": "Delivery: { $date }",
        "takeaway-checkout-order-summary-delivery-label": "Delivery:",
        "takeaway-confirm-order-items-column": "ITEMS",
        "takeaway-confirm-order-qty-column": "Q-TY",
        "takeaway-confirm-order-amount-column": "AMOUNT",
        "takeaway-confirm-order-company-section": "Company",
        "takeaway-confirm-order-wallet-balance": "Balance: { $balance }",
        "takeaway-confirm-order-wallet-name-with-balance": "{ $name } ({ $balance })",
        "takeaway-confirm-order-pay-using-card": "Pay using { $card }",
        "takeaway-confirm-order-card-expires": "Expires { $date }",
        "takeaway-confirm-order-comment-title": "Order comment:",
        "takeaway-confirm-order-comment-placeholder": "\n .label = Write a comment (optional)\n .helperText = Remaining characters: { $charsRemaining }",
        "takeaway-confirm-order-guest-name-label": "\n .label = Full Name\n .placeholder = Your full name:",
        "takeaway-confirm-order-guest-email-label": "\n .label = Email\n .placeholder = Your e-mail:",
        "takeaway-confirm-order-guest-phone-label": "\n .label = Phone Number (optional)\n .placeholder = Your phone number:",
        "takeaway-confirm-order-personal-info-title": "Personal Information",
        "takeaway-confirm-order-personal-info-name-label": "Name:",
        "takeaway-confirm-order-personal-info-email-label": "Email:",
        "takeaway-confirm-order-personal-info-phone-label": "Phone Number:",
        "takeaway-confirm-order-personal-info-edit-email-field": "\n .label = Email",
        "takeaway-confirm-order-personal-info-edit-phone-field": "\n .label = Phone number",
        "takeaway-confirm-order-personal-info-edit-save-button": "Save",
        "takeaway-confirm-order-personal-info-edit-email-invalid": "Please enter a valid email address",
        "takeaway-confirm-order-personal-info-edit-phone-invalid": "Phone number must contain only digits and the characters + - ( ) and spaces",
        "takeaway-confirm-order-delivery-section-title": "Delivery",
        "takeaway-confirm-order-delivery-pickup-label": "Pickup { $hours }",
        "takeaway-checkout-delivery-location-pickup-label": "Pick up:",
        "takeaway-checkout-delivery-location-pickup-time": "{ $start } - { $end }",
        "takeaway-checkout-delivery-location-show-more-button": "Show more",
        "takeaway-payment-mobilepay-notice": "You will need to use the MobilePay app on your phone to complete the payment. You must approve the payment in MobilePay within 5 minutes and return here.",
        "takeaway-checkout-terms-accepted-label": "I accept the <conditionsLink>terms and conditions</conditionsLink>",
        "takeaway-checkout-terms-not-accepted": "You must accept the terms and conditions.",
        "takeaway-checkout-payment-method-required": "Please select a payment method",
        "takeaway-checkout-comment-max-length": "Comment must be at most { $max } characters",
        "takeaway-payment-poll-title": "Processing Payment",
        "takeaway-payment-poll-description": "Please wait while we process your payment. This may take a few moments.",
        "takeaway-payment-failed": "\n .title = Payment Failed\n .description = Payment could not be completed due to an unknown error. Please try again later.",
        "takeaway-payment-canceled": "\n .title = Purchase canceled\n .description = You canceled the payment of your order.",
        "takeaway-payment-timeout": "\n .title = Payment Timed Out\n .description = We haven't received confirmation from your payment provider. Please check your netbank to be sure that the payment was completed.",
        "takeaway-payment-back-to-dashboard-button": "Back to Dashboard",
        "takeaway-order-confirmed-dialog-title": "Order completed!",
        "takeaway-order-confirmed-dialog-order-id": "Order ID: { $orderId }",
        "takeaway-order-confirmed-dialog-pickup-hours-label": "Pickup:",
        "takeaway-order-confirmed-dialog-pickup-location-value": "{ $name } between { $start } and { $end }",
        "takeaway-order-confirmed-dialog-delivery-date-label": "Delivery date:",
        "takeaway-order-confirmed-dialog-amount-label": "Amount:",
        "takeaway-order-confirmed-dialog-total-amount-label": "Total amount:",
        "takeaway-order-confirmed-dialog-go-to-dashboard-button": "Go to Dashboard",
        "takeaway-order-confirmed-dialog-show-receipt-button": "Show Receipt",
        "takeaway-order-confirmed-dialog-show-receipts-button": "Show { $count } Receipts",
        "takeaway-receipt-send-button": "Send Receipt",
        "top-bar-new-menu-make-purchase-title": "Make a purchase",
        "top-bar-new-menu-make-purchase-description": "Order lunch at the canteen",
        "top-bar-new-menu-refill-wallet-title": "Refill wallet",
        "top-bar-new-menu-refill-wallet-description": "Top up money at your digital wallet",
        "top-bar-new-menu-section-booking-title": "Booking",
        "top-bar-new-menu-section-purchase-title": "Purchase",
        "top-bar-new-menu-book-for-another-user-button": "Book for another user",
        "top-bar-new-menu-push-message-title": "Push message",
        "top-bar-new-menu-push-message-dialog-title": "New push message",
        "top-bar-new-menu-push-message-description": 'Send messages to your customers',
        "top-bar-new-menu-shortcuts-title": "Shortcuts:",
        "top-bar-new-menu-shortcut-accounting": "Accounting",
        "top-bar-new-menu-shortcut-manage-products": "Manage products",
        "top-bar-new-menu-shortcut-manage-push-messages": "Manage push messages",

        // Navigation
        "support-nav-item-home": "Home",
        "support-nav-item-devices": "Devices",
        "support-nav-item-messages": "\n .title = Messages",
        "support-nav-item-orders-title": "\n .title = Orders",
        "support-nav-item-orders": "Orders",
        "support-nav-item-orders-pos": "POS",
        "support-nav-item-accounting-title": "\n .title = Accounting",
        "support-nav-item-accounting": "Accounting",
        "support-nav-item-subscriptions": "Subscriptions",
        "support-nav-item-accounting-meeting-service": "Meeting service",
        "support-nav-item-email": "Email",
        "support-nav-item-sms": "SMS",
        "support-nav-item-printer-queue": "Printer queue",

        // Support ADMIN DEVICES
        "support-admin-nav-item-devices": "Devices",
        "support-admin-entities-card-group": "\n .title = Entities",
        "support-admin-entities-card": "\n .title = Entities\n .description = Manage entities in the system such as suppliers, merchants and companies.",
        "support-admin-devices-page-header": "\n .title = Devices",
        "support-table-header-supplier": "Supplier",
        "support-table-header-merchant": "Merchant",

        // - reporting

        // - admin
        "support-nav-item-supplier-access": "Suppliers",
        "support-nav-item-merchant-access": "Merchants",
        "support-nav-item-entities-access": "Entities",
        "support-nav-item-payments": "Payments",
        "support-nav-item-features": "Features",
        "support-nav-item-invoicing": "\n .title = Invoicing",
        "support-nav-item-invoicing-basis-for-invoicing": "Basis for invoicing",
        "support-nav-item-health-title": "\n .title = Health",
        "support-nav-item-health": "Health",
        "support-nav-item-health-database": "Database health",
        "support-nav-item-health-server-memory": "Server memory",
        "support-nav-item-health-scheduler": "Scheduler",
        "support-nav-item-health-adyen": "Adyen",

        // Access
        "support-supplier-access-page-header": "\n .title = Supplier access",
        "support-merchant-access-page-header": "\n .title = Merchant access",


        // Page header
        "page-header-help-tooltip": "\n .title = Click here for more info",
        "page-header-help-text": "Help guides",
        "page-header-help-status-mode-new": "New",
        "page-header-help-status-mode-beta": "Beta",
        "page-header-help-maintenance": "Sorry, the page is currently unavailable as it is undergoing maintenance.",

        // YUP validation
        "validation-title-required": "Title is required",
        "validation-body-required": "Body is required",
        "validation-type-required": "Type is required",

        // Field validation
        "validation-date-must-be-in-past": "Date must be in the past",
        "validation-date-must-be-today-or-past": "Date must be today or earlier",
        "validation-date-must-be-in-future": "Date must be in the future",
        "validation-date-must-be-today-or-future": "Date must be today or later",
        "validation-datetime-must-be-in-past": "Date and time must be in the past",
        "validation-datetime-must-be-in-future": "Date and time must be in the future",
        "validation-number-exceeds-max": "Value must be at most { $max }",
        "validation-number-below-min": "Value must be at least { $min }",

        // Common
        "employee-id": "Employee-id",
        "id": "id",
        "name": "Name",
        "price": "Price",
        "email": "Email",
        "amount": "Amount",
        "for": "for",
        "yes": "Yes",
        "no": "No",
        "status": "Status",
        "active": "Active",
        "inactive": "Inactive",
        "edit": "Edit",
        "delete": "Delete",

        "create": "Create",
        "save": "Save",
        "required-field": "This field is required",
        "invalid-email": "Invalid email address",

        // History block
        "history-card": "\n .title = History",
        "history-created": "Created:",
        "history-edited": "Edited:",


        // Production order
        "production-order-status-received": "Received",
        "production-order-status-confirmed": "Confirmed",
        "production-order-status-cancelled": "Cancelled",
        "production-order-status-ready": "Ready",
        "production-order-number": "ID",
        "production-order-status": "Status",
        "production-order-payment-status": "Payment method",
        "production-order-payment-channel": "Channel",
        "production-order-time": "Order time",
        "production-order-delivery-time": "Delivery time",
        "production-order-placeholder-comment": "Comment for customer",
        "production-order-show-cancelled": "Show cancelled",

        // Pos order
        "pos-order-delivery-date-title": "Delivery list - takeaway",
        "pos-order-delivery-date": "\n .label =  Delivery date:",
        "pos-order-purchase-time": "\n .label =  Purchase time:",
        "pos-order-customer": "\n .label =  Customer:",

        // Merchant > Reports > Production > Meeting service
        "meeting-service-table-approved-orders": "Approved orders",
        "meeting-service-table-unapproved-orders": "\n .label = Unapproved orders",
        "meeting-service-table-time": "Time",
        "meeting-service-table-start-date": "Start Date",
        "meeting-service-table-end-date": "End Date",
        "meeting-service-table-delivery-type": "Delivery type",
        "delivery-type-filter-all": "All",
        "delivery-type-filter-delivery": "Delivery",
        "delivery-type-filter-pick-up": "Picked up",
        "delivery-type-filter-eating-in-canteen": "Eating in canteen",
        "meeting-service-table-order-id-column": "Order ID",
        "meeting-service-table-delivery-time-column": "Delivery time",
        "meeting-service-table-delivery-location-column": "Meeting",
        "meeting-service-table-meeting-name-column": "Meeting name",
        "meeting-service-table-location-column": "Location",
        "meeting-service-table-amount-column": "Amount",
        "meeting-service-table-changes-column": "Changes",
        "meeting-service-table-changes-column-tooltip-changed": "\n .title = The order has been changed on {$date}",
        "meeting-service-table-changes-column-tooltip-unchanged": "\n .title = The order has not been changed",
        "meeting-service-table-changes-column-active-filter-yes": "Active",
        "meeting-service-table-changes-column-inactive-filter-no": "Inactive",
        "meeting-service-table-lock-column": "Lock",
        "meeting-service-table-lock-column-tooltip-open": "\n .title = The order is open for changes",
        "meeting-service-table-lock-column-tooltip-closed": "\n .title = The order is locked for changes",
        "meeting-service-table-lock-column-lock-tooltip": "\n .title = Block creator from changing this order",
        "meeting-service-table-lock-column-unlock-tooltip": "\n .title = Allow creator to change this order",
        "meeting-service-table-lock-column-active-filter-yes": "Active",
        "meeting-service-table-lock-column-inactive-filter-no": "Inactive",
        "meeting-service-table-meeting": "Delivery: {$locationName}",
        "meeting-service-table-production-slip-button": "Packing slip",
        "meeting-service-table-credit-note-button": "Credit note",
        "meeting-service-table-receipt-button": "Receipt",
        "meeting-service-table-update-button": "Edit",
        "meeting-service-table-duplicate-button": "Duplicate",
        "meeting-service-table-book-button": "Book",
        "meeting-service-table-send-message-button": "Send message",
        "meeting-service-table-delete-button": "Delete",
        "meeting-service-table-date-range-filter": "Date range",
        "meeting-service-table-floating-action-bar-read": "\n .title = Read",
        "meeting-service-table-floating-action-bar-lock-unlock": "\n .title = Lock/unlock",
        "meeting-service-table-floating-action-bar-lock": "\n .title = Lock",
        "meeting-service-table-floating-action-bar-lock-tooltip": "\n .title = Block creator from changing selected orders",
        "meeting-service-table-floating-action-bar-unlock": "\n .title = Unlock",
        "meeting-service-table-floating-action-bar-unlock-tooltip": "\n .title = Allow creator to change selected orders",
        "meeting-service-table-floating-action-bar-book": "\n .title = Book",
        "meeting-service-table-floating-action-bar-status": "\n .title = Status",
        "meeting-service-table-floating-action-bar-delete": "\n .title = Delete",
        "meeting-service-table-floating-action-bar-print": "\n .title = Print",
        "meeting-service-table-floating-action-bar-production-slip": "\n .title = Packing slip",
        "meeting-service-table-floating-action-bar-delivery-list": "\n .title = Delivery list",
        "meeting-service-table-floating-action-bar-receipt": "\n .title = Receipt",
        "meeting-service-table-floating-action-bar-export": "\n .title = Export selected",
        "calendar-button-show-calendar": "\n .title = Show calendar\n .aria-label = Show calendar",
        "meeting-service-delete-orders-title": "Delete orders",
        "meeting-service-delete-order-title": "Delete order",
        "meeting-service-delete-orders-checkbox-label-meeting-service": "\n .label = Meeting service",
        "meeting-service-delete-orders-checkbox-label-booking": "\n .label = Cancel resource booking",
        "meeting-service-delete-orders-checkbox-label-booking-lock": "Cancel resource booking",
        "meeting-service-delete-orders-checkbox-label-meeting-service-cancel": "\n .label = Cancel meeting service",
        "meeting-service-delete-orders-checkbox-label-meeting-service-cancel-lock": "Cancel meeting service",
        "meeting-service-delete-orders-helper-merchant-cancellation-field": `.label = Cancellation message \n .placeholder = Write a reason for cancellation. This message will be sent to the customer. \n .helperText = Remaining characters: { $charsRemaining }`,
        "meeting-service-delete-orders-helper-merchant": "Note: If a resource booking is attached to the meeting service order, it will not be canceled.",
        "meeting-service-delete-orders-helper-line-one": "OBS: If a resource booking is attached to the meeting service order, you can cancel the resource booking on behalf of the creator.",
        "meeting-service-delete-orders-helper-line-two": "Be aware that if you cancel the resource booking, a possible reservation of rooms and associated AV equipment is also canceled and released to other users.",
        "meeting-service-table-order-name-column": "Order name",
        "meeting-service-book-orders-title": "Book orders",
        "meeting-service-book-orders-description": "Orders labeled 'Future' cannot be processed as the delivery date is set for a future date. For orders labeled 'Cash,' please ensure a payment date is specified for the day of payment receipt.",
        "meeting-service-table-status-column": "Status",
        "meeting-service-table-cash-payment-received-column": "Cash payment received",
        "meeting-service-book-orders-subtotal": "Subtotal",
        "meeting-service-book-orders-button": "Book",
        "meeting-service-delete-orders-button": "Delete",
        "meeting-service-delete-single-order-id-label": "Order id:",
        "meeting-service-delete-single-order-delivery-date-label": "Delivery date:",
        "meeting-service-delete-single-order-meeting-name-label": "Meeting name:",
        "meeting-service-delete-single-order-responsible-label": "Responsible:",
        "meeting-service-delete-single-order-amount-label": "Amount:",
        "merchant-home-meeting-service-awaiting-approval-title": "Awaiting approval",
        "filter-menu-accordion-order-status-title": "\n .title = Order Status",
        "filter-menu-accordion-companies-title": "\n .title = Companies",
        "filter-menu-accordion-checkbox-awaiting-approval": "\n .optionLabel = Awaiting approval",
        "filter-menu-accordion-checkbox-to-be-invoiced": "\n .optionLabel = To be invoiced",
        "meeting-service-table-header-date-range-button": "Date range",
        "meeting-service-table-header-period-picker-button": "Period picker",
        "meeting-service-table-lock-column-locked":"\n .title = The order has been locked by the merchant. Contact merchant for updates.",
        "meeting-service-snackbar-undo": "UNDO",
        "meeting-service-snackbar-undo-message": "{ $amount ->\n  [one] { $amount } order has been set to \n *[other] { $amount } orders have been set to \n}",
        "meeting-service-delivery-list": "Delivery list",
        "meeting-service-delivery-list-period": "Period:<dateRange>{$startLabel} - {$endLabel}</dateRange><icon />",
        "meeting-service-delivery-list-period-all": "Period:<all>All</all><icon />",
        "meeting-service-delivery-list-header-period": "Period: {$startLabel} - {$endLabel}",
        "meeting-service-delivery-list-header-period-all": "Period: All",
        "meeting-service-delivery-list-orders-selected": "Orders: {$ordersLength} selected",
        "meeting-service-delivery-list-group-by-label": "Group by:",
        "meeting-service-delivery-list-group-by-location": "Delivery location",
        "meeting-service-delivery-list-group-by-time": "Delivery time",
        "meeting-service-delivery-list-group-by-item": "Group by: delivery {$value}",
        "meeting-service-delivery-list-delivery": "Delivery type:<value>{$value}</value>",
        "meeting-service-delivery-list-filter-all": "All",
        "meeting-service-delivery-list-empty": "No delivery orders for the selected criteria",
        "meeting-service-delivery-list-delivery-details-meeting-time": "\n .label = Meeting time:",
        "meeting-service-delivery-list-delivery-details-location": "\n .label = Delivery location:",
        "meeting-service-delivery-list-delivery-details-sittings": "\n .label = Sittings:",
        "meeting-service-delivery-list-contact-details-meeting-creator": "\n .label = Creator:",
        "meeting-service-delivery-list-contact-details-meeting-host": "\n .label = Meeting host:",
        "meeting-service-delivery-list-table-column-items": "Items",
        "meeting-service-delivery-list-table-column-products": "Products",
        "meeting-service-delivery-list-table-column-delivery-time": "Delivery time",

        // Batch modal
        "meeting-service-batch-modal-title": "\n .dialogTitle = Change status",
        "meeting-service-batch-modal-button-change-label": "Confirm",
        "meeting-service-batch-modal-button-close-label": "Close",
        "meeting-service-batch-modal-button-close-tooltip-label": "\n .title = No orders can change status",
        "meeting-service-batch-modal-warning-message": "Could not change status for orders with this icon",
        "meeting-service-batch-modal-cancellation-reason-message": "Write a reason for the cancellation. This message will be sent out to everyone on the list.",
        "meeting-service-batch-modal-customer-message": "Message to customer",
        "meeting-service-batch-modal-order-id": "Order ID",
        "meeting-service-batch-modal-delivery-time": "Delivery time",
        "meeting-service-batch-modal-order-details": "Order details",
        "meeting-service-batch-modal-from": "From",
        "meeting-service-batch-modal-to": "To",
        "meeting-service-batch-modal-batch-error": "{ $ordersCount ->\n  [one] Could not change status for { $ordersCount } order\n *[other] Could not change status for { $ordersCount } orders\n}",

        // Package slip handle PDF open
        "meeting-service-handle-pdf-open-error": "Couldn't open pdf",

        // Merchant > Reports > Production > Calendar
        "orders-for-calendar-multi-select": "\n .label = Shop type",
        "orders-for-calendar-search": "\n .label = Search \n .placeholder = Search for order id or order name",
        "expandable-search-search-button": "Search",
        "expandable-search-clear-button": "Clear search",
        "production-slip-dialog-title": "Production slip",
        "production-slip-dialog-table-header-items": "Items",
        "production-slip-dialog-table-header-products": "Products",
        "production-slip-dialog-table-header-delivery-time": "Delivery time",
        "production-slip-dialog-note": "Order note",
        "production-slip-dialog-order-id": "Order ID: { $orderId }",
        "production-slip-dialog-delivery-details": "Delivery details",
        "production-slip-dialog-delivery-type": "Delivery type:",
        "production-slip-dialog-delivery-time": "Delivery time:",
        "production-slip-dialog-delivery-meeting-time": "Meeting time:",
        "production-slip-dialog-delivery-delivery-location": "Delivery location:",
        "production-slip-dialog-delivery-sittings": "Sittings:",
        "production-slip-dialog-delivery-shop": "Shop:",
        "production-slip-dialog-contact-details": "Contact details",
        "production-slip-dialog-contact-details-creator": "Creator:",
        "production-slip-dialog-contact-details-meeting-host": "Meeting host:",
        "production-slip-dialog-scan": "View production slip on mobile device",

        // Accounting customer
        "customer-accounting-show-customers-with-sales-only": "Show customers with sales only",


        // FloatingActionButton
        "floating-action-button": "Close",
        "floating-action-button-picked": "Selected items",
        "floating-action-button-order-status": "\n .title = Status",
        "floating-action-button-order-status-menu-item": "Change order status",
        "floating-action-button-receipt": "Receipt",
        "floating-action-button-print": "\n .title = Print",
        "floating-action-button-print-receipt": "\n .title = Print receipt",
        "floating-action-button-print-label": "\n .title = Print label",
        "print-label-copies-modal": "\n .title = Print label\n .message = How many copies do you want to print?\n .buttonLabelSubmit = Print\n .buttonLabelCancel = Cancel",
        "floating-action-button-export": "\n .title = Export",


        //ChangeOrderStatusModal
        "change-order-status": "Change order status",
        "change-order-status-received": "Received",
        "change-order-status-confirmed": "Confirmed",
        "change-order-status-ready": "Ready",
        "change-order-status-cancelled": "Cancelled",
        "change-order-status-title": "Result",

        "change-order-status-received-info-text": "An order is automatically assigned the status Received, when created. If you want to roll back the status from Confirmed to Received, the customer receives a notification. Do only make a roll back in status if you set Confirmed by an accident.",
        "change-order-status-confirmed-info-text": "When an order is set to Confirmed, the customer receives a notification that the order will be processed. The customer can expect to receive his order.",
        "change-order-status-ready-info-text": "When an order is set to Ready, the customer receives a notification that the order can be picked up.",
        "change-order-status-cancelled-info-text": "When an order is set to Canceled, the customer receives a notification that the order will not be delivered. You can write a comment to the customer, why it has been cancelled.",


        //ChangeOrderStatusResponseModal
        "change-order-status-response-modal-title": "Result",
        "change-order-status-response-modal-order-id": "Order id",
        "change-order-status-response-modal-order-delivery": "Delivery date",
        "change-order-status-response-modal-order-message": "Message",
        "change-order-status-response-modal-error": "failed",
        "change-order-status-response-modal-error-aciton": "action",
        "change-order-status-response-modal-error-acitons": "actions",


        // --- Surveys List ---
        "surveys-list-header": "\n .title = Surveys",
        "surveys-list-create-button": "Create new",
        "surveys-list-survey-table-name-column": "Name",
        "surveys-list-survey-table-start-date-column": "Start Date",
        "surveys-list-survey-table-end-date-column": "End Date",
        "surveys-list-survey-table-active-column-active": "Active",
        "surveys-list-survey-table-active-column-inactive": "Inactive",
        "surveys-list-survey-table-active-column-active-filter-yes": "Active",
        "surveys-list-survey-table-active-column-inactive-filter-no": "Inactive",
        "surveys-table-list-delete-modal-title": "survey",
        "surveys-table-list-show-ratings": "Show ratings",
        "surveys-table-list-delete-success-message": "Survey was deleted",

        // Create / edit survey
        "create-survey-header": "\n .title = Create survey",
        "edit-survey-header": "\n .title = Edit survey",
        "nav-item-create-survey-header": "Create survey",
        "nav-item-edit-survey-header": "Edit survey",
        "create-merchant-survey-save-button": "Create",
        "edit-merchant-survey-save-button": "Save",
        "create-or-edit-merchant-survey-field-name": "\n .label = Name\n .placeholder = Enter a name for the survey\n .helperText = Description is not shown to the user",
        "create-or-edit-merchant-survey-field-name-required": "Name is required",
        "create-or-edit-merchant-survey-field-description":
            "\n .label = Description\n .placeholder = Enter an optional description for your own use\n .helperText = Description is not shown to the user",
        "create-or-edit-merchant-survey-questions": "Your questions:",
        "create-or-edit-merchant-survey-questions-empty": "You have not created any questions yet.",
        "create-or-edit-merchant-survey-field-questions-minError":"You need at least one question",
        "create-or-edit-merchant-survey-add-questions-button": "Add question",
        "create-or-edit-merchant-survey-title-general": "\n .title = General",
        "create-or-edit-merchant-survey-field-active": "Active:",
        "create-or-edit-merchant-survey-field-start-date": "Start date",
        "create-or-edit-merchant-survey-field-end-date": "End date",
        "create-or-edit-merchant-survey-title-user-visibility": "\n .title = User Visibility",
        "create-or-edit-merchant-survey-field-timeOfDay": "\n .label = Time of day",
        "create-or-edit-merchant-survey-field-timeOfDay-helperText": "Determines the time of day rating card for this survey will be shown.",
        "create-or-edit-merchant-survey-field-expirationDays": "\n .label = Expiration days\n .helperText = Days until an unanswered rating card is hidden.",
        "edit-merchant-survey-success-save-message": "Survey was updated",
        "create-merchant-survey-success-save-message": "Survey created",
        "create-or-edit-merchant-survey-dialog-save-button": "Save",
        "create-or-edit-merchant-survey-dialog-title": "Add question",
        "create-or-edit-merchant-survey-dialog-field-question": "\n .label = Question",
        "create-or-edit-merchant-survey-dialog-topics-title": "Select topics:",
        "create-or-edit-merchant-survey-dialog-topics-good": "\n .label = Good topics",
        "create-or-edit-merchant-survey-dialog-topics-bad": "\n .label = Bad topics",
        "create-or-edit-merchant-survey-dialog-topics-info": "Good topics can be used by participant to select what they found particularly good. Bad topics can be used to specify what they would like to see improved.",


        // --- Company ---

        "company-home-purchases-card-group": "\n .title = Purchases",
        "company-home-purchases-period-base-3": "Last 3 days",
        "company-home-purchases-period-base-14": "Last 14 days",
        "company-home-purchases-period-base-30": "Last 30 days",
        "company-home-purchases-period-base-60": "Last 60 days",
        "company-home-purchases-period-base-180": "Last 180 days",
        "company-home-purchases-pos-purchases-title": " \n .title = POS purchases",
        "company-home-purchases-pos-orders-title": " \n .title = POS Orders",
        "company-home-purchases-meeting-service-purchases-title": " \n .title = Meeting service purchases",
        "company-home-purchases-meeting-service-orders-title": " \n .title = Meeting service orders",
        "company-home-purchases-users-title": " \n .title = Users",
        "company-home-purchases-check-in-title": " \n .title = Check-ins",


        // Company > Admin > Home
        "company-admin-home-organization-users-card":  "\n .title = Users \n .description = Manage users.",
        "company-admin-home-organization-bill-receivers-card":  "\n .title = Bill receivers \n .description = Manage bill receivers.",
        "company-admin-home-organization-user-group-card":  "\n .title = User groups \n .description = Manage user groups.",
        "company-admin-home-organization-departments-card":  "\n .title = Departments \n .description = Manage departments.",
        "company-admin-home-organization-workgroups-card":  "\n .title = Workgroups \n .description = Manage workgroups.",
        "company-admin-home-organization-locations-card":  "\n .title = Locations \n .description = Manage locations.",
        "company-admin-home-account-gdpr-card":  "\n .title = GDPR \n .description = General Data Protection Regulation \n .buttonText = Show",
        "company-admin-home-account-administrator-card":  "\n .title = Administrators \n .description = Manage administrators.",

        // Navigation
        "company-nav-item-home": "Home",
        "company-home-coming-soon-placeholder": "\n .title = Coming soon",
        "company-home-coming-soon-placeholder-body": "You are logged in as a company administrator. We are working to bring you this feature. For now, please use <externalLink>bestil-nu.net</externalLink>.",
        "company-nav-item-accounting": "\n .title = Accounting",
        "company-nav-item-pos": "POS",
        "company-nav-item-meeting-service": "Meeting service",
        "company-nav-item-subscriptions": "Subscriptions",
        "company-nav-item-organization": "\n .title = Organization",
        "company-nav-item-users": "Users",
        "company-nav-item-admins": "Administrators",
        "company-nav-item-user-groups": "User groups",
        "company-nav-item-departments": "Departments",
        "company-nav-item-workgroups": "Workgroups",
        "company-nav-item-locations": "Locations",
        "company-nav-item-bill-receivers": "Bill receivers",
        "company-nav-item-account-dimensions": "Account dimensions",
        "company-nav-item-settings": "Settings",
        "company-nav-item-account-title": "\n .title = Account",
        "company-nav-item-account": "Account",
        "company-nav-item-gdpr": "GDPR",
        "company-nav-item-data-import-title": "\n .title = Data import",
        "company-nav-item-data-import": "Data import",
        "company-nav-item-id-cards": "ID cards",
        "company-nav-item-account-numbers": "Account numbers",
        "company-nav-item-import-users": "Users",
        "company-nav-item-import-bill-receivers": "Bill receivers",
        "company-nav-item-settings-title": "\n .title = Settings",
        "company-nav-item-custom-jobs": "Custom jobs",


        // Company > Admin > Organization > Departments
        "company-organization-title": "\n .title = Organization",
        "company-organization-departments-title": "Departments",
        "company-organization-departments-header": "\n .title = Departments",
        "company-organization-departments-create-button": "Create new",
        "company-organization-departments-table-department-no-column": "Department no.",
        "company-organization-departments-table-name-column": "Name",
        "company-organization-departments-table-status-column": "Status",
        "company-organization-departments-table-active-column-active": "Active",
        "company-organization-departments-table-active-column-inactive": "Inactive",
        "company-organization-departments-table-active-column-active-filter-yes": "Active",
        "company-organization-departments-table-active-column-inactive-filter-no": "Inactive",
        "company-organization-departments-table-edit": "Edit",
        "company-organization-departments-table-delete": "Delete",
        "company-organization-departments-table-delete-modal-title": "department",
        "company-organization-departments-edit-title": "Edit department",
        "company-organization-departments-create-title": "Create department",
        "create-department-header": "\n .title = Create department",
        "edit-department-header": "\n .title = Edit department",
        "edit-department-save-button": "Save",
        "create-department-save-button": "Create",
        "create-or-edit-company-department-field-departmentNo": "\n .label = Department no.\n .placeholder = Enter department no.",
        "create-or-edit-company-department-field-name": "\n .label = Name\n .placeholder = Enter name",
        "create-or-edit-company-department-field-is-required": "Field is required",
        "create-or-edit-company-department-field-active": "Active",
        "create-or-edit-company-department-settings": "\n .title = Settings",
        "create-or-edit-company-department-history": "\n .title = History",

        // Company > Admin > Organization > Workgroups
        "company-organization-workgroups-title": "Workgroups",
        "company-organization-workgroups-header": "\n .title = Workgroups",
        "company-organization-workgroups-create-button": "Create new",
        "company-organization-workgroups-table-name-column": "Name",
        "company-organization-workgroups-table-calendar-column": "Calendar email address",
        "company-organization-workgroups-table-members-column": "Members",
        "company-organization-workgroups-table-status-column": "Status",
        "company-organization-workgroups-table-edit": "Edit",
        "company-organization-workgroups-table-delete": "Delete",
        "company-organization-workgroups-table-delete-modal-title": "workgroup",
        "company-organization-workgroups-edit-title": "Edit workgroup",
        "company-organization-workgroups-create-title": "Create workgroup",
        "create-workgroup-header": "\n .title = Create workgroup",
        "edit-workgroup-header": "\n .title = Edit workgroup",
        "edit-workgroup-save-button": "Save",
        "create-workgroup-save-button": "Create",
        "create-or-edit-company-workgroup-field-name": "\n .label = Name\n .placeholder = Enter name",
        "create-or-edit-company-workgroup-field-description": "\n .label = Description for users\n .placeholder = Enter description for users",
        "create-or-edit-company-workgroup-field-description-info": "\n .title = Shown to users when they pick a workgroup, so describe who the group is for.",
        "create-or-edit-company-workgroup-field-calendar-email": "\n .label = Calendar email address\n .placeholder = Enter calendar email address",
        "create-or-edit-company-workgroup-field-calendar-email-info": "\n .title = The shared mailbox or calendar address for this workgroup. Bookings and meeting service orders made by members are collected here, so members can see each other's arrangements.",
        "create-or-edit-company-workgroup-field-is-required": "Field is required",
        "create-or-edit-company-workgroup-field-invalid-email": "Enter a valid email address",
        "create-or-edit-company-workgroup-field-name-max-length": "Name must be at most { $maxLength } characters",
        "create-or-edit-company-workgroup-field-calendar-email-max-length": "Calendar email address must be at most { $maxLength } characters",
        "create-or-edit-company-workgroup-field-description-max-length": "Description must be at most { $maxLength } characters",
        "create-or-edit-company-workgroup-field-active": "Active",
        "create-or-edit-company-workgroup-settings": "\n .title = Settings",
        "create-or-edit-company-workgroup-history": "\n .title = History",
        "create-or-edit-company-workgroup-members": "\n .title = Members",
        "create-or-edit-company-workgroup-members-empty": "\n .title = No members yet\n .description = Add the people who should share the mailbox and see each other's bookings and meeting service orders.",
        "create-or-edit-company-workgroup-members-remove": "Remove from group",
        "create-or-edit-company-workgroup-members-add-field": "\n .label = Add member\n .placeholder = Search by name, at least 3 characters",
        "create-or-edit-company-workgroup-members-table-header-user-id": "User ID",
        "create-or-edit-company-workgroup-members-table-header-name": "Name",
        "create-or-edit-company-workgroup-members-table-header-email": "E-mail",
        "create-or-edit-company-workgroup-members-table-header-status": "Status",
        "create-or-edit-company-workgroup-members-department-filter-label": "Department",
        "create-or-edit-company-workgroup-members-department-filter": "\n .label = Department",
        "create-or-edit-company-workgroup-members-department-filter-all": "All departments",
        "create-or-edit-company-workgroup-members-department-filter-none": "No department",
        "create-or-edit-company-workgroup-members-details-button": "Details",
        "create-or-edit-company-workgroup-members-removed": "{ $count ->\n [one] { $count } member removed from the group\n *[other] { $count } members removed from the group\n}",
        "create-or-edit-company-workgroup-members-undo-button": "Undo",
        "create-or-edit-company-workgroup-members-bulk-remove": "\n .title = Remove from group",
        "create-or-edit-company-workgroup-members-remove-dialog-title": "{ $count ->\n [one] Remove { $count } member from the group?\n *[other] Remove { $count } members from the group?\n}",
        "create-or-edit-company-workgroup-members-remove-dialog-message": "{ $names }{ $hidden ->\n [0] {\"\"}\n [one] {\" \"}and { $hidden } more\n *[other] {\" \"}and { $hidden } more\n} will be removed from { $workgroup } and will no longer see the group's appointments. The users will not be deleted.",
        "create-or-edit-company-workgroup-members-remove-dialog-message-unnamed": "{ $names }{ $hidden ->\n [0] {\"\"}\n [one] {\" \"}and { $hidden } more\n *[other] {\" \"}and { $hidden } more\n} will be removed from this group and will no longer see the group's appointments. The users will not be deleted.",
        "create-or-edit-company-workgroup-members-remove-dialog": "\n .buttonLabelSubmit = { $count ->\n [one] Remove { $count } member\n *[other] Remove { $count } members\n }\n .buttonLabelCancel = Cancel",
        "company-user-workgroups-panel": "\n .title = Workgroups",
        "company-user-workgroups-panel-empty": "This user is not a member of any workgroups yet.",
        "company-user-workgroups-panel-add-button": "Add",
        "company-user-workgroups-panel-remove": "Remove",
        "company-user-workgroups-panel-add-dialog-title": "Add to workgroup",
        "company-user-workgroups-panel-add-dialog-empty": "There are no more workgroups to add.",

        // Company Admin Organization > Users (create/edit form)
        "company-user-create-page-title": "\n .title = Create user",
        "company-user-edit-page-title": "\n .title = Edit user",
        "company-user-create-submit": "Create",
        "company-user-edit-submit": "Save",
        "company-user-create-breadcrumb": "Create user",
        "company-user-edit-breadcrumb": "Edit user",
        "company-user-tab-details": "User details",
        "company-user-tab-workgroups": "Workgroups",
        "company-user-tab-approvals": "User approvals",
        "company-user-tab-catalog": "Canteen access",
        "company-user-tab-guest-checkin": "Guest check-in",
        "company-user-workgroups-tab-description":
            "Select one or more workgroups for the user. In a workgroup, members can work together — for example, see each other's bookings and meeting service orders through a shared calendar.",
        "company-user-workgroups-calendar-email-label": "Calendar email:",
        "company-user-workgroups-empty": "No workgroups available.",
        "company-user-sync-warning":
            "This user is kept in directory sync — name, email and department may be overwritten by the next sync. Disable user sync to edit them permanently.",
        "company-user-field-user-group": "User group",
        "company-user-field-user-group-placeholder": "Select user group...",
        "company-user-field-department": "Department",
        "company-user-field-department-placeholder": "Select department...",
        "company-user-field-employee-id": "Employee ID",
        "company-user-field-employee-id-placeholder": "e.g. 10062",
        "company-user-field-name": "Name",
        "company-user-field-name-placeholder": "Full name",
        "company-user-field-initials": "Initials",
        "company-user-field-initials-placeholder": "Auto-filled from name",
        "company-user-field-username": "Username",
        "company-user-field-username-placeholder": "Auto-generated if empty",
        "company-user-field-email": "Email",
        "company-user-field-email-placeholder": "name@company.com",
        "company-user-field-mobile": "Mobile",
        "company-user-field-mobile-placeholder": "12 34 56 78",
        "company-user-field-phone": "Phone no.",
        "company-user-field-phone-placeholder": "12 34 56 78",
        "company-user-field-language": "Language",
        "company-user-field-select-placeholder": "Not selected",
        "company-user-language-option-danish": "Danish",
        "company-user-language-option-english": "English",
        "company-user-approvals-description": "Select the user groups this user approves when their members sign up themselves.",
        "company-user-approvals-heading": "Approve user groups",
        "company-user-catalog-description": "A user can access one or more canteens; expand a canteen to pick its pricelists.",
        "company-user-catalog-heading": "Delegated canteens / pricelists",
        "company-user-catalog-summary-empty": "No canteens / pricelists selected",
        "company-user-catalog-summary-counts": "{ $count } pricelists across { $canteens } canteens",
        "company-user-catalog-search-placeholder": "Search canteens...",
        "company-user-catalog-empty": "No canteens found.",
        "company-user-guest-checkin-description": "Choose whether this user is notified when a guest checks in.",
        "company-user-guest-checkin-toggle": "Notify on guest check-in",
        "company-user-details-account-user-id": "User ID",
        "company-user-details-account-username": "Username",
        "company-user-details-account-employee-id": "Employee ID",
        "company-user-details-account-user-group": "User group",
        "company-user-details-account-department": "Department",
        "company-user-details-account-phone": "Phone",
        "company-user-details-account-language": "Language",
        "company-user-details-section-idcard": "ID card",
        "company-user-details-idcard-empty": "No ID card connected.",
        "company-user-details-last-signin": "Last sign-in",
        "company-user-details-never": "Never",
        "company-user-details-section-tracking": "Tracking",
        "company-user-details-sync-status": "User sync",
        "company-user-details-sync-source": "Sync source",
        "company-user-details-sync-last-synced": "Last synced",
        "company-user-details-sync-none": "Not synchronized",
        "company-user-details-section-roles": "Roles",
        "company-user-details-roles-empty": "No roles assigned.",
        "company-user-details-role-secretary": "Secretary",
        "company-user-details-edit-button": "Edit user",
        "company-user-details-impersonate-button": "Log in as",
        "company-user-details-error-title": "Couldn't load user",
        "company-user-details-error-message": "Something went wrong while loading this user. Please try again.",
        "company-user-settings-panel-title": "\n .title = Settings",
        "company-user-settings-active": "Active",
        "company-user-settings-send-invitation": "Send email invitation",
        "company-user-settings-send-invitation-helper": "The user receives a sign-in link by email.",
        "company-user-settings-disable-sync": "Disable user sync",
        "company-user-settings-disable-sync-helper": "When disabled, this user is ignored by the user-sync job.",
        "company-user-settings-secretary": "Secretary",
        "company-user-settings-secretary-helper": "Gets access to secretary tools for booking and managing orders on behalf of other users.",
        "company-user-validation-required": "This field is required",
        "company-user-validation-invalid-email": "Enter a valid email address",
        "company-user-validation-invalid-phone": "Enter a valid phone number",

        // Company Admin Organization > Users (list & bulk actions)
        "company-users-status-filter-all": "All",
        "company-users-status-filter-active": "Active",
        "company-users-status-filter-inactive": "Inactive",
        "company-users-status-active": "Active",
        "company-users-status-inactive": "Inactive",
        "company-users-cell-internal-id": "Internal ID: { $id }",
        "company-users-cell-sync-badge": "Sync",
        "company-users-cell-rights": "{ $count -> \n *[other] { $count } rights \n [one] { $count } right \n }",
        "company-users-delete-entity": "user",
        "company-users-bulk-status": "\n .title = Status",
        "company-users-bulk-set-active": "\n .title = Active",
        "company-users-bulk-set-inactive": "\n .title = Inactive",
        "company-users-bulk-resend-invite": "\n .title = Resend invite",
        "company-users-bulk-move-group": "\n .title = Move to group",
        "company-users-bulk-export": "\n .title = Export",
        "company-users-bulk-success": "{ $count } users updated",
        "company-users-export-header-name": "Name",
        "company-users-export-header-first-name": "First name",
        "company-users-export-header-last-name": "Last name",
        "company-users-export-header-username": "Username",
        "company-users-export-header-email": "Email",
        "company-users-export-header-mobile": "Mobile",
        "company-users-export-header-phone": "Phone",
        "company-users-export-header-employee-id": "Employee ID",
        "company-users-export-header-user-group": "User group",
        "company-users-export-header-department": "Department",
        "company-users-export-header-language": "Language",
        "company-users-export-header-roles": "Roles",
        "company-users-export-header-user-sync": "User sync",
        "company-users-export-header-last-signin": "Last sign-in",
        "company-users-export-header-status": "Status",

        // Company Admin Organization > User Groups
        "company-organization-user-groups-title": "User groups",
        "company-organization-user-groups-header": "\n .title = User groups",
        "company-organization-user-groups-create-button": "Create new",
        "company-organization-user-groups-table-name-column": "Name",
        "company-organization-user-groups-table-domain-column": "Domain",
        "company-organization-user-groups-table-status-column": "Status",
        "company-organization-user-groups-table-active-column-active": "Active",
        "company-organization-user-groups-table-active-column-inactive": "Inactive",
        "company-organization-user-groups-table-active-column-active-filter-yes": "Active",
        "company-organization-user-groups-table-active-column-inactive-filter-no": "Inactive",
        "company-organization-user-groups-table-edit": "Edit",
        "company-organization-user-groups-table-delete": "Delete",
        "company-organization-user-groups-table-delete-modal-title": "\n .typeOfEntity = user group",
        "company-organization-user-group-edit-title": "Edit user group",
        "company-organization-user-group-create-title": "Create user group",
        "create-user-group-header": "\n .title = Create user group",
        "edit-user-group-header": "\n .title = Edit user group",
        "edit-user-group-save-button": "Save",
        "create-user-group-save-button": "Create",
        "create-or-edit-company-user-group-field-name": "\n .label = Name\n .placeholder = Enter name",
        "create-or-edit-company-user-group-field-active": "Active",
        "create-or-edit-company-user-group-settings": "\n .title = Settings",
        "create-or-edit-company-user-group-history": "\n .title = History",
        "create-or-edit-company-user-group-connected-domains": "Connected domains",
        "create-or-edit-company-user-group-connected-domains-empty": "You have not created any domains yet.",
        "create-or-edit-company-user-group-connected-domains-add-button": "\n .title = Add domain",
        "create-or-edit-company-user-group-connected-domains-table-domain": "Domain",
        "create-or-edit-company-user-group-connected-domains-table-status": "Status",
        "create-or-edit-company-user-group-connected-domains-table-status-active": "Active",
        "create-or-edit-company-user-group-connected-domains-table-status-pending": "Pending / Invitation sent",
        "create-or-edit-company-user-group-connected-domains-table-resend-invitation": "Resend invitation",
        "create-or-edit-company-user-group-connected-domains-table-delete": "Delete",
        "company-organization-user-groups-table-delete-modal-domain": "\n .typeOfEntity = domain",
        "create-or-edit-company-user-group-connected-domains-modal-add-domain": "Add domain",
        "create-or-edit-company-user-group-connected-domains-modal-resend-invitation": "Resend invitation for domain",
        "create-or-edit-company-user-group-connected-domains-modal-field-domain": "\n .label = Domain\n .placeholder = Enter domain",
        "create-or-edit-company-user-group-connected-domains-modal-field-username": "\n .label = User name\n .placeholder = Enter user name",
        "create-or-edit-company-user-group-connected-domains-modal-send-invitation": "Send invitation",
        "create-or-edit-company-user-group-connected-bill-receiver": "Bill receiver",
        "create-or-edit-company-user-group-connected-bill-receiver-empty": "You have not created bill receiver yet.",
        "create-or-edit-company-user-group-connected-bill-receiver-add-button": "\n .title = Add bill receiver",
        "create-or-edit-company-user-group-connected-bill-receiver-table-name": "Name",
        "create-or-edit-company-user-group-connected-bill-receiver-table-address": "Address",
        "create-or-edit-company-user-group-connected-bill-receiver-table-end-point": "End point",
        "create-or-edit-company-user-group-connected-bill-receiver-table-remove": "Remove",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-add-bill-receiver": "\n .title = Add bill receiver",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-update-bill-receiver": "\n .title = Found similar bill receivers. Are you sure you want to create a new?",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-field-search": "\n .label = Search\n .placeholder = Search by name, CVR, EAN, email or address",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-info-text": "Start typing to show search results",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-info-warning": "You should create a new bill receiver with the same identifier (CVR, EAN, email) only if the contact details differ. For example, this may be necessary if the bill needs to be directed to a different individual.",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-empty": "No search results found",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-cvr": "CVR:",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-ean": "EAN:",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-email": "Email:",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-address": "Address:",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-or": "Or",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-submit-button": "Choose selected bill receiver",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-submit-update-button": "Update selected bill receiver",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-create-button": " Create new bill receiver",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-bill-found": "{ $count } bill receiver(s) already exists with the same identifier.",

        // Company > Admin > Account > GDPR
        "company-account-gdpr-title":"\n .title = GDPR",

        // Company > Admin > Data import
        "data-import-csv-field-update-key": "\n .label = Update key",
        "data-import-csv-settings": "\n .title = Settings",
        "data-import-csv-field-update-identical": "Update identical",
        "data-import-csv-field-delete-existing": "Delete existing",

        // Company > Admin > Data import > ID cards
        "company-data-import-id-cards-title": "\n .title = Import ID cards",
        "create-or-edit-company-id-cards-field-user-group": "\n .label = User group",
        "create-or-edit-company-id-cards-select-item-all": "All",
        "create-or-edit-company-id-cards-update-key-mode-initials": "Initials",
        "create-or-edit-company-id-cards-update-key-mode-email": "Email",
        "create-or-edit-company-id-cards-update-key-mode-employee-number": "Employee number",


        // Company > Admin > Data import > Account number
        "company-data-import-account-numbers-title": "\n .title = Import account numbers",
        "create-or-edit-company-account-numbers-field-accounting-dimension": "\n .label = Accounting dimension",
        "create-or-edit-company-account-numbers-select-item-all": "All",
        "create-or-edit-company-account-numbers-update-key-mode-account-number": "Account number",
        "create-or-edit-company-account-numbers-update-key-mode-account-name": "Account name",

        // Company > Admin > Data import > Users
        "company-data-import-users-title": "\n .title = Import users",
        "company-data-import-users-field-user-group": "\n .label = User group",
        "company-data-import-users-select-item-from-file": "From file",

        // Company > Admin > Data import > Bill receivers
        "company-data-import-bill-receivers-title": "\n .title = Import bill receivers",
        "company-data-import-bill-receivers-receiver-type": "\n .label = Receiver type",
        "company-data-import-bill-receivers-receiver-type-mode-private-person": "Private person / association",
        "company-data-import-bill-receivers-receiver-type-mode-public-institution": "Public institution",
        "company-data-import-bill-receivers-receiver-type-mode-private-company": "Private company",
        "company-data-import-bill-receivers-receiver-type-mode-from-file": "From file",

        // Company > Admin > Settings > Custom jobs
        "company-admin-settings-custom-jobs-title":" \n .title = Custom jobs",
        "company-admin-settings-custom-jobs-table-name":"Name",
        "company-admin-settings-custom-jobs-table-interval":"Interval",
        "company-admin-settings-custom-jobs-table-last-run":"Last run",
        "company-admin-settings-custom-jobs-table-status":"Status",
        "company-admin-settings-custom-jobs-table-action-details":"Details",
        "company-admin-settings-custom-jobs-table-action-run-job":"Run job",
        "company-admin-settings-custom-jobs-table-action-activate":"Activate",
        "company-admin-settings-custom-jobs-table-action-inactivate":"Inactivate",

        // Import result
        "import-result-title": "\n .title = Import result",
        "import-result-breadcrumb": "Result",
        "import-result-succeeded": "Import succeeded",
        "import-result-results": "Results:",
        "import-result-created": "Created:",
        "import-result-updated": "Updated:",
        "import-result-deleted": "Deleted:",

        // Company Meeting Service
        "company-meeting-service-title": "Meeting service",
        "company-meeting-service-header": "\n .title = Meeting service",
        "company-meeting-service-table-booked-start-date": "Book from",
        "company-meeting-service-table-booked-end-date": "Book to",
        "company-meeting-service-table-merchant": "Merchant",
        "company-meeting-service-table-order-id-column": "Order ID",
        "company-meeting-service-table-booked-date-column": "Booked date",
        "company-meeting-service-table-delivery-time-column": "Delivery time",
        "company-meeting-service-table-employee-column": "Employee",
        "company-meeting-service-table-amount-column": "Amount (DKK)",
        "company-meeting-service-table-show-receipt": "Show receipt",
        "company-meeting-service-table-floating-action-bar-receipts": "\n .title = Receipts",
        "company-meeting-service-table-floating-action-bar-export": "\n .title = Export",

        // Company Subscriptions
        "company-subscriptions-title": "Subscriptions",
        "company-subscriptions-header": "\n .title = Subscriptions",
        "company-subscriptions-table-subscription-column": "Subscription",
        "company-subscriptions-table-order-id-column": "Order ID",
        "company-subscriptions-table-employee-column": "Employee",
        "company-subscriptions-table-subscribed-column": "Subscribed",
        "company-subscriptions-table-unsubscribed-column": "Unsubscribed",
        "company-subscriptions-table-payment-column": "Payment",
        "company-subscriptions-table-amount-column": "Amount",
        "company-subscriptions-table-cancel-subscription": "Cancel subscription",
        "company-subscriptions-table-details": "Details",

        // Accounting - POS Purchases
        "accounting-pos-table-header-title": "\n .title = POS",
        "accounting-pos-table-header-nav-item-home": "Home",
        "accounting-pos-table-header-nav-item-accounting": "Accounting",
        "accounting-pos-table-header-nav-item-pos": "POS",
        "accounting-pos-table-header-order-id": "Order ID",
        "accounting-pos-table-header-transaction-time": "Transaction time",
        "accounting-pos-table-header-employee": "Employee",
        "accounting-pos-table-header-payment": "Payment",
        "accounting-pos-table-header-amount": "Amount (DKK)",
        "support-entity-table-button-show-receipt": "Show receipt",
        "accounting-pos-table-header-merchant-label":"\n .label = Merchant",
        "accounting-pos-table-footer-total-in-period":"Total in this period (DKK)",

          // Organization - Users
        "company-organization-users-page-header": "\n .title = Users",
        "company-organization-users-table-header-user-group":"User Group",
        "company-organization-users-table-header-name":"Name",
        "company-organization-users-table-header-employee-id":"Employee id",
        "company-organization-users-table-header-email":"Email",
        "company-organization-users-table-header-status":"Status",
        "company-organization-users-table-status-active":"Active",
        "company-organization-users-table-status-inactive": "Inactive",
        "company-organization-users-table-button-details": "Details",
        "company-organization-users-table-button-edit": "Edit",
        "company-organization-users-table-button-delete": "Delete",
        "company-organization-users-table-button-impersonate": "Log in as",
        "company-organization-users-button-create": "Create new",
        "company-organization-users-tooltip-export": "\n .title = Export",
        "company-admin-nav-item-organization": "Organization",
        "company-admin-nav-item-users": "Users",
        "company-organization-users-table-header-select-label-user-group": "User Group",
        "company-organization-users-table-header-select-user-group-field": "\n .label = User Group",
        "company-organization-users-table-header-select-label-workgroup": "Workgroup",
        "company-organization-users-table-header-select-workgroup-field": "\n .label = Workgroup",
        "company-organization-users-table-header-select-item-all": "All",


        // Organization - Admins
        "company-organization-admins-page-header": "\n .title = Administrators",
        "company-organization-admins-table-header-name":"Name",
        "company-organization-admins-table-header-email":"Email",
        "company-organization-admins-table-header-status":"Status",
        "company-organization-admins-table-status-active":"Active",
        "company-organization-admins-table-status-inactive": "Inactive",
        "company-organization-admins-table-button-details": "Show details",
        "company-organization-admins-table-button-edit": "Edit user",
        "company-organization-admins-table-button-delete": "Delete user",
        "company-organization-admins-table-button-impersonate": "Log in as",
        "merchant-admin-users-table-button-impersonate": "Log in as",
        "supplier-admin-account-admins-table-button-impersonate": "Log in as",
        "service-center-admin-account-admins-table-button-impersonate": "Log in as",
        "supplier-admin-merchant-admins-table-button-impersonate": "Log in as",
        "office-manager-admins-table-button-impersonate": "Log in as",
        "company-organization-admins-button-create": "Create new",
        "company-admin-nav-item-admins": "Administrators",
        "impersonation-confirm-dialog":
            "\n .title = Log in as { $name }?\n .buttonLabelSubmit = Log in as { $firstName }\n .buttonLabelCancel = Cancel",
        "impersonation-confirm-dialog-message":
            "You'll see the portal exactly as { $firstName } sees it. Everything you do is recorded in { $firstName }'s history under your own name.",

        // Company Admin Organization Locations
        "company-organization-locations-title": "Locations",
        "company-organization-locations-header": "\n .title = Locations",
        "company-organization-locations-create-button": "Create new",
        "company-organization-locations-table-name-column": "Name",
        "company-organization-locations-table-status-column": "Status",
        "company-organization-locations-table-active-column-active": "Active",
        "company-organization-locations-table-active-column-inactive": "Inactive",
        "company-organization-locations-table-active-column-active-filter-yes": "Active",
        "company-organization-locations-table-active-column-inactive-filter-no": "Inactive",
        "company-organization-locations-table-edit": "Edit",
        "company-organization-locations-table-delete": "Delete",
        "company-organization-locations-table-delete-modal-title": "location",
        "company-organization-locations-edit-title": "Edit location",
        "company-organization-locations-create-title": "Create location",
        "create-location-header": "\n .title = Create location",
        "edit-location-header": "\n .title = Edit location",
        "edit-location-save-button": "Save",
        "create-location-save-button": "Create",
        "create-or-edit-company-location-field-name": "\n .label = Name\n .placeholder = Enter name",
        "create-or-edit-company-location-field-is-required": "Field is required",
        "create-or-edit-company-location-field-active": "Active",
        "create-or-edit-company-location-settings": "\n .title = Settings",
        "create-or-edit-company-location-history": "\n .title = History",
        "create-or-edit-company-location-field-street": "\n .label = Street\n .placeholder = Enter street",
        "create-or-edit-company-location-field-streetNumber": "\n .label = Street no\n .placeholder = Enter street no",
        "create-or-edit-company-location-field-postalCode": "\n .label = Postal code\n .placeholder = Enter postal code",
        "create-or-edit-company-location-field-city": "\n .label = City\n .placeholder = Enter city",
        "create-or-edit-company-location-field-country": "\n .label = Country",
        "create-or-edit-company-location-field-country-denmark-item": "Denmark",
        "create-or-edit-company-location-field-shops": "\n .label = Connected shops",

        // Accounting - Bill receivers
        "company-accounting-bill-receivers-table-header-title": "\n .title = Bill receivers",
        "company-accounting-bill-receivers-table-header-name":"Name",
        "company-accounting-bill-receivers-table-header-endpoint":"Endpoint",
        "company-accounting-bill-receivers-table-header-debitor-id":"Debitor id",
        "company-accounting-bill-receivers-table-header-status":"Status",
        "company-accounting-bill-receivers-table-status-active":"Active",
        "company-accounting-bill-receivers-table-status-inactive": "Inactive",
        "company-accounting-bill-receivers-table-button-edit": "Edit",
        "company-accounting-bill-receivers-table-button-delete": "Delete",
        "company-accounting-bill-receivers-button-create": "Create new",
        "company-accounting-bill-receivers-table-header-nav-item-home": "Home",
        "company-accounting-bill-receivers-table-header-nav-item-accounting": "Accounting",
        "company-accounting-bill-receivers-table-header-nav-item-bill-receivers": "Bill receivers",

        // Accounting - Bill receivers - Create Dialog
        "bill-receivers-create-dialog-title": "Create bill receiver",
        "bill-receivers-create-dialog-customer-type": "Customer type:",
        "bill-receivers-create-dialog-select-bill-receiver": " Select existing bill receiver:",
        "bill-receivers-create-dialog-country": "Country:",
        "bill-receivers-create-dialog-button-create": "Create",
        "bill-receivers-create-dialog-button-save": "Save",
        "bill-receivers-form-error-label-country":"Country",
        "bill-receivers-form-error-label-debtor-number":"Debtor number",
        "bill-receivers-form-error-label-address-line-1":"Address line 1",
        "bill-receivers-form-error-label-address-line-2":"Address line 2",
        "bill-receivers-form-error-label-postal-code":"Postal code",
        "bill-receivers-form-error-label-city":"City",
        "bill-receivers-form-error-label-telephone":"Telephone",
        "bill-receivers-form-error-label-name":"Name",
        "bill-receivers-form-error-label-institution-name":"Institution name",
        "bill-receivers-form-error-label-email":"Email",
        "bill-receivers-form-error-label-contact-person":"Contact person",
        "bill-receivers-form-error-label-company-name":"Company name",
        "bill-receivers-validation-ean-13-digits": "EAN number must be 13 digits",
        "bill-receivers-validation-cvr-8-digits": "CVR number must be 8 digits",
        "bill-receivers-validation-postal-code-4-digits": "Postal code must be 4 digits",
        "bill-receivers-validation-email-invalid": "Please enter a valid email address",
        "bill-receivers-validation-telephone-invalid": "Telephone must contain only digits and the characters + - ( ) and spaces",
        "bill-receivers-validation-max-length": "{ $label } must be at most { $max } characters",
        "bill-receivers-select-type":"Select type:",
        "bill-receivers-select-list-label": "Select bill receiver",
        "bill-receivers-select-label":"Select receiver:",
        "bill-receivers-select-private-person":"Private person / association",
        "bill-receivers-select-email":"Email",
        "bill-receivers-select-public-institution":"Public institution",
        "bill-receivers-select-ean-number":"EAN number",
        "bill-receivers-select-private-company":"Private company",
        "bill-receivers-select-cvr-number":"CVR number",
        "bill-receivers-company-number":"Enter company number:",
        "bill-receivers-input-search-label-number-cvr":"\n .label = CVR number",
        "bill-receivers-button-continue":"Continue",
        "bill-receivers-send-invoice":"Send invoice to:",
        "bill-receivers-select-label-input-type":"Type",
        "bill-receivers-dropdown-type":"\n .label = Type",
        "bill-receivers-select-item-email":"Email",
        "bill-receivers-select-item-ean-number":"EAN Number",
        "bill-receivers-form-label-address-1":"\n .label = Address line 1\n .placeholder = Street and street number",
        "bill-receivers-form-label-address-2":"\n .label = Address line 2\n .placeholder = Floor, apartment no., etc.",
        "bill-receivers-form-label-postal-code":"\n .label = Postal code",
        "bill-receivers-form-label-city":"\n .label = City",
        "bill-receivers-form-label-country":"\n .label = Country",
        "bill-receivers-form-country-select-da": "Denmark",
        "bill-receivers-form-contact-person":"Contact person",
        "bill-receivers-form-label-contact-person":"\n .label = Contact person",
        "bill-receivers-form-label-email":"\n .label = Email",
        "bill-receivers-form-label-telephone":"\n .label = Telephone",
        "bill-receivers-form-label-name":"\n .label = Name",
        "bill-receivers-form-label-institution-name":"\n .label = Institution name",
        "bill-receivers-form-label-debtor-number":"\n .label = Debtor number\n .placeholder = Identifier of debtor in your accounting system",
        "bill-receivers-form-label-company-name":"\n .label = Company name",
        "bill-receivers-form-label-company-number":"\n .label = Company number",
        "bill-receivers-input-search-label-email":"\n .label = Email",
        "bill-receivers-input-search-label-ean-number":"\n .label = EAN Number",


        // --- Service center --
        "service-center-home-coming-soon-placeholder": "\n .title = Coming soon\n .body = We are working to bring you the new service center portal. In the meantime please use https://bestil-nu.net.",

        // Navigation
        "service-center-nav-item-home": "Home",

        // Navigation > Admin
        "service-center-admin-nav-item-organization-page-header": "\n .title = Organization",
        "service-center-admin-nav-item-organization": "Organization",
        "service-center-admin-nav-item-organization-resources": "Resources",
        "service-center-admin-nav-item-organization-devices": "Devices",
        "service-center-admin-nav-item-organization-devices-create": "Create devices",
        "service-center-admin-nav-item-organization-devices-edit": "Edit devices",
        "service-center-admin-nav-item-organization-manage-bookings": "Manage bookings for user",
        "service-center-admin-nav-item-account-page-header": "\n .title = Account",
        "service-center-admin-nav-item-reports-page-header": "\n .title = Reports",
        "service-center-admin-nav-item-statistics": "Statistics",
        "service-center-admin-home-reports-statistics-card": "\n .title = Statistics \n .description = See usage, occupancy and guest statistics for your service center.",
        "service-center-admin-nav-item-account-administrators": "Administrators",
        "service-center-admin-nav-item-organization-resource-crate-room": "Create room",
        "service-center-admin-nav-item-organization-resource-update-room": "Update room",
        "service-center-admin-nav-item-organization-resource-crate-car": "Create car",
        "service-center-admin-nav-item-organization-resource-update-car": "Update car",
        "service-center-admin-nav-item-organization-resource-crate-mobile-av": "Create Mobile AV",
        "service-center-admin-nav-item-organization-resource-update-mobile-av": "Update Mobile AV",
        "service-center-admin-nav-item-communication": "Communication",
        "service-center-admin-nav-item-communication-page-header": "\n .title = Communication",
        "service-center-admin-nav-item-communication-messages": "Messages",
        "service-center-admin-nav-item-communication-reminders": "Reminders",
        "service-center-nav-item-messages": "Messages",
        "service-center-messages-list-header": "\n .title = Messages",
        "service-center-reminders-page-header": "\n .title = Reminders",
        "service-center-reminders-create-button": "Create new",
        "service-center-reminders-table-confirmation-content": "Confirmation for booking",

        // Service center > Admin > Home >
        "service-center-admin-home-organization-resources-card": "\n .title = Resources \n .description = Create and manage the resources that can be booked in your service center.",
        "service-center-admin-home-organization-devices-card": "\n .title = Devices \n .description = Manage your hardware devices such as room displays and info screens.",
        "service-center-admin-home-organization-manage-bookings-card": "\n .title = Administrate orders \n .description = Manage orders owned by a user. \n .buttonText = Manage",
        "service-center-admin-home-account-administrators-card": "\n .title = Administrators \n .description = Manage the administrators for your merchant.",
        "service-center-admin-home-communication-messages-card": "\n .title = Push messages \n .description = Send and manage push messages.",
        "service-center-admin-home-communication-reminders-card": "\n .title = Reminders \n .description = Manage reminders shared across resources.",


        // --- User --

        // Navigation
        "user-nav-item-home": "Home",
        "user-nav-item-archive-title": "\n .title = Archive" ,
        "user-nav-item-archive": "Archive",
        "user-nav-item-settings": "Settings" ,
        "user-nav-item-wallets-title": "\n .title = Wallets" ,
        "user-nav-item-wallets": "Wallets",
        "user-nav-item-wallets-refill": "Refill",
        "user-nav-item-home-label": "\n .title = Go to home dashboard" ,
        "user-nav-item-calendar-label": "\n .title = Show calendar with orders" ,
        "user-nav-item-archive-label": "\n .title = Show archived orders" ,
        "user-nav-item-settings-label": "\n .title = Settings",
        "user-nav-bottom-bar-home-label": "Home",
        "user-nav-bottom-bar-calendar-label": "Calendar",
        "user-nav-bottom-bar-archive-label": "Archive",
        "user-nav-bottom-bar-settings-label": "Settings",

        // User > Home > Top bar
        "user-home-top-bar-tab-switcher-overview": "Overview",
        "user-home-top-bar-tab-switcher-upcoming": "Upcoming",

        // User > Home > Top bar > News drawer
        "user-home-top-bar-news-title": "\n .title = Facilitynet news",
        "user-home-top-bar-news-no-notifications": "\n .title = No messages right now\n .description = Here you will be able to read messages from the merchant and service center.",
        "user-home-top-bar-news-notification-time-type-news": "News",
        "user-home-top-bar-news-notification-time-type-info": "Information",
        "user-home-top-bar-news-notification-time-type-important": "Important",
        "user-home-top-bar-news-notification-time-type-offer": "Offer",
        "user-home-top-bar-news-notification-time-type-event": "Event",
        "user-home-top-bar-news-notification-time-type-reminder": "Reminder",
        "user-home-top-bar-news-notification-time-type-menu-change": "Menu",
        "user-home-top-bar-news-notification-time-type-feedback": "Feedback",
        "user-home-top-bar-news-notification-time-type-health": "Health",
        "user-home-top-bar-news-notification-sender-type-merchant": "Merchant",
        "user-home-top-bar-news-notification-sender-type-service-center": "Service",
        "user-home-top-bar-news-notification-menu-title": "Messages",

        // User > Home > Week menus
        "user-home-week-menu-title": "Week menu",
        "user-home-week-menu-no-menus-title": "No menu available",
        "user-home-week-menu-no-menus": "Unfortunately, no menus have been created this week.",
        "user-home-week-menu-no-menus-today": "No menu for this day",
        "user-home-top-bar-location-button-empty": "Choose location",
        "user-home-week-menu-select-location-dialog-title": "Change location",
        "user-home-week-menu-select-location-dialog-title-first-time": "Choose location",
        "user-home-week-menu-select-location-search-filter": "\n .placeholder = Search on name, address, shop number...",
        "user-home-week-menu-select-location-dialog-kitchen-item-button": "Select",
        "user-home-week-menu-dialog-title": "Todays menu",
        "user-home-week-menu-dialog-allergens": "Allergens:",


        // User > Home >Dashboard
        "user-home-upcoming-orders": "Upcoming orders",
        "user-home-reminders-check-out-title": "Check guests out ({ $count })",
        "user-home-reminders-check-out-button": "Check out",
        "user-home-reminders-check-in-title": "Check into { $roomName } before { $deadline }",
        "user-home-reminders-check-in-button": "Check in",
        "user-home-reminders-check-out-dialog": "\n .title = Check guests out\n .message = Select the guests who are leaving.\n .buttonLabelSubmit = { $count ->\n [0] Check out\n *[other] Check out ({ $count })\n }\n .buttonLabelCancel = Cancel",
        "user-home-reminders-check-out-dialog-guests-title": "Guests ({ $count })",
        "user-home-reminders-check-out-dialog-select-all-checkbox": "\n .label = Select all",
        "user-home-reminders-check-out-dialog-guest-checked-in": "Checked in { $time }",
        "user-home-reminders-check-out-dialog-success": "{ $count ->\n [one] Guest checked out\n *[other] { $count } guests checked out\n}",
        "user-home-reminders-check-in-dialog": "\n .title = Check into meeting room\n .message = Confirm that your meeting has started.\n .buttonLabelSubmit = Check in\n .buttonLabelCancel = Cancel",
        "user-home-reminders-check-in-dialog-deadline-label": "Before",
        "user-home-reminders-check-in-dialog-note": "If nobody checks in before { $deadline }, the room is released and becomes available to others.",
        "user-home-reminders-check-in-dialog-success": "You're checked in",
        "user-home-canteen": "Canteen",
        "user-home-canteen-offers": "Offers",
        "user-home-canteen-today-menu": "Today's Menu",
        "user-home-canteen-today-menu-show-menu": " Show menu signage...",
        "user-home-canteen-news": "News",
        "user-home-upcoming-meetings": "Meetings",
        "user-home-upcoming-meetings-modal-title": "\n    .title = Meetings",
        "user-home-upcoming-takeaway-modal-title": "\n    .title = Takeaway",
        "user-home-upcoming-canteen-purchases-modal-title": "\n    .title = Canteen purchases",
        "user-home-upcoming-meetings-no-meetings": "No meetings in period\n    .title = No meetings in period",
        "user-home-meeting-day-today": "Today",
        "user-home-meeting-day-tomorrow": "Tomorrow",
        "user-home-meeting-day-unknown": "Unscheduled",
        "user-home-upcoming-meeting-min-left":
            "{ $hours ->\n    [0] { $minutes } min left\n   *[other] { $minutes ->\n        [0] { $hours } hr left\n       *[other] { $hours } hr { $minutes } min left\n    }\n}",
        "user-home-upcoming-meeting-service-sub-title": "Meeting service",
        "user-home-meetings-collapse": "Collapse meetings",
        "user-home-meetings-expand": "Expand meetings",
        "user-home-meetings-panel-actions": "\n .collapseAriaLabel = { user-home-meetings-collapse }\n .expandAriaLabel = { user-home-meetings-expand }",
        "user-home-panel-action-show-all": "\n    .title = Show all",
        "user-home-empty-offers-text": "You have no offers right now",
        "user-home-upcoming-purchases": "Purchases",
        "user-home-upcoming-purchases-load-error": "Could not load purchases",
        "user-home-wallet-my-wallet": "My wallet",
        "user-home-wallets-section-title": "Wallets",
        "user-home-subscriptions-section-title": "Subscriptions",
        "user-home-subscription-card-used-count": "{ $used } of { $total }",
        "user-home-subscription-card-used-this-week": "used this week",
        "user-home-subscription-card-used-this-month": "used this month",
        "user-home-subscription-card-active-from": "Active from: { $date }",
        "user-home-subscription-card-expires": "Expires: { $date }",
        "user-home-upcoming-purchase-card-title-lunch": "Lunch order",
        "user-home-upcoming-purchase-card-title-take-away": "Takeaway",
        "user-home-upcoming-purchase-card-title-pos": "Lunch order",
        "user-home-upcoming-purchase-card-title-lunch-subscription": "Lunch subscription",
        "user-home-upcoming-purchases-no-purchases": "No upcoming purchases",
        "user-home-upcoming-canteen-purchases": "Canteen purchases",
        "user-home-upcoming-canteen-purchases-no-purchases": "No canteen purchases in period\n    .title = No canteen purchases in period",
        "user-home-canteen-purchases-collapse": "Collapse canteen purchases",
        "user-home-canteen-purchases-expand": "Expand canteen purchases",
        "user-home-upcoming-takeaway": "Takeaway",
        "user-home-upcoming-takeaway-no-orders": "No takeaway in period\n    .title = No takeaway in period",
        "user-home-takeaway-collapse": "Collapse takeaway",
        "user-home-takeaway-expand": "Expand takeaway",
        "user-home-upcoming-meeting-service-approved": "\n .label = Approved",
        "user-home-upcoming-meeting-service-approved-tooltip":  "\n .label = The order has been approved by the merchant.",
        "user-home-upcoming-meeting-service-sittings": "{ $sittings } seats",
        "user-home-upcoming-meeting-service-attendees": "{ $attendees } participants",
        "user-home-upcoming-meeting-service-locked": "Locked",
        "user-home-upcoming-purchases-check-in-reminder": "Check-in reminder",
        "user-home-upcoming-purchases-learn-more": "View more",
        "user-home-upcoming-purchases-check-in-subtitle": "Remember to check into the canteen today.",
        "user-home-canteen-contact-canteen": "Contact canteen",
        "user-dashboard-error-offers-unavailable": "Offers is temporarily unavailable.",
        "user-dashboard-error-week-menu-unavailable": "Week menu is temporarily unavailable.",
        "user-dashboard-error-news-menu-unavailable": "News menu is temporarily unavailable.",
        "user-dashboard-error-merchant-contact-unavailable": "Merchant contact details is temporarily unavailable.",
        "user-home-canteen-news-category-company": "\n .label = Company",
        "user-home-canteen-news-category-service-center": "\n .label = Service Center",
        "user-home-canteen-news-category-kitchen": "\n .label = Kitchen",
        "user-home-canteen-news-category-no-actions":  "No actions available for order #{ $orderId }",
        "user-home-canteen-upcoming-orders-dialog-ok-button": "Ok",
        "user-home-canteen-upcoming-orders-cancel-order-item": "Cancel order",
        "user-home-canteen-upcoming-orders-cancel-booking-item": "Cancel booking",
        "user-home-canteen-upcoming-orders-delete-order": "Delete order",
        "user-home-canteen-upcoming-orders-delete-order-restriction-message": "You are not allowed to delete this order",
        "user-home-canteen-upcoming-orders-refund-order": "Refund order",
        "user-home-canteen-upcoming-orders-refund-order-restriction-message": "You are not allowed to refund this order",
        "user-home-canteen-upcoming-orders-receipt-item": "Receipt",
        "user-home-canteen-upcoming-orders-edit-item": "Edit",
        "user-home-canteen-upcoming-orders-update-booking-restriction-message": "You are not allowed to update booking",
        "user-home-canteen-upcoming-orders-extend-booking-item": "Extend booking",
        "user-home-canteen-upcoming-orders-extend-booking-restriction-message": "You are not allowed to extend booking",
        "user-home-canteen-upcoming-orders-end-booking-restriction-message": "You are not allowed to end booking",
        "user-home-canteen-upcoming-orders-update-meeting-service-item-meeting-service": "Update",
        "user-home-canteen-upcoming-orders-update": "Edit",
        "user-home-canteen-upcoming-orders-update-meeting-restriction-message": "You are not allowed to update this order",
        "user-home-canteen-upcoming-orders-duplicate-meeting-service-item-meeting-service": "Duplicate",
        "user-home-canteen-upcoming-orders-duplicate-meeting-service-item-resource-booking": "Duplicate meeting service",
        "user-home-canteen-upcoming-orders-duplicate-meeting-service-restriction-message": "You are not allowed to duplicate this order",
        "user-home-canteen-upcoming-orders-end-modal-confirm": "Confirm",
        "user-home-canteen-upcoming-orders-cancel-modal-confirm": "Cancel",
        "user-home-canteen-upcoming-orders-extend-modal-title": "Extend booking",
        "user-home-canteen-upcoming-orders-extend-modal-subtitle": "Extend booking { $meetingName } to { $meetingTime }?",
        "user-home-canteen-upcoming-orders-extend-modal-max-error": "Maximum available time is { $maxAvailableMinutes } minutes.",
        "user-home-canteen-upcoming-orders-extend-input-custom-time": "\n .label = Select end time:",
        "user-home-canteen-upcoming-orders-extend-other-button": "Other",
        "user-home-canteen-upcoming-orders-delete-modal-error": "Could not delete order",
        "user-home-canteen-upcoming-orders-delete-modal-booking-label": "\n .label = Cancel booking",
        "user-home-canteen-upcoming-orders-delete-modal-meeting-label": "\n .label = Cancel meeting service",
        "user-home-canteen-upcoming-orders-cancel-modal":
            "\n .title = Cancel { $itemType ->\n [order] order\n *[booking] booking\n }\n .message = Are you sure you want to cancel the { $itemType } '{ $itemName }'?\n .buttonLabelSubmit = Cancel { $itemType ->\n [order] order\n *[booking] booking\n }\n .buttonLabelCancel = Back",
        "user-home-canteen-upcoming-orders-cancel-started-modal":
            "\n .title = Cancel booking\n .message = The meeting #{ $orderId }, { $meetingName } has already started, so the booking will be ended now instead of deleted. Do you want to continue?\n .buttonLabelSubmit = Cancel booking\n .buttonLabelCancel = Back",
        "user-home-canteen-upcoming-orders-cancel-ended-booking-message": "The meeting is already over, so the booking can no longer be cancelled.",
        "user-home-meeting-service-action-update-booking": "Update Booking",
        "user-home-meeting-service-action-edit": "Edit order",
        "user-home-meeting-service-action-update-meeting-service": "Update Meeting Service",
        "user-home-meeting-service-action-duplicate-meeting-service": "Duplicate Order",
        "user-home-meeting-service-description-update-booking": "Are you sure you want to update booking #{ $orderId }, { $meetingName }?",
        "user-home-meeting-service-description-update-meeting-service-catering": "Do you want to update order #{ $orderId }, { $meetingName } with delivery on { $deliveryDate }?",
        "user-home-meeting-service-description-update-meeting-service": "Do you want to update order #{ $orderId }, { $meetingName } for meeting on { $deliveryDate }?",
        "user-home-meeting-service-description-duplicate-meeting-service": "Do you want to duplicate order #{ $orderId }, { $meetingName } with delivery on { $deliveryDate }?",
        "user-home-meeting-service-action-confirm-modal-meeting-name": "Meeting Name:",
        "user-home-meeting-service-action-confirm-modal-delivery-date-name": "Delivery Date:",
        "user-home-meeting-service-action-confirm-modal-order-id": "Order ID:",
        "user-home-canteen-upcoming-orders-extend-success-dialog-title": "Booking was extended",
        "user-home-canteen-upcoming-orders-delete-success-dialog-title": "Booking was cancelled",
        "user-home-canteen-upcoming-orders-delete-order-success-dialog-title":
            "{ $ordersCount ->\n *[one] Order was deleted\n [other] Orders were deleted\n }",
        "user-home-canteen-upcoming-orders-end-success-dialog-title": "Booking was ended",


        // User > Home > Offers
        "user-home-offers-title": "Offers",

        // User > Home > Offers
        "user-home-news-from-kitchen": "News from the kitchen",


         // User > Home > Opening hours
        "user-home-opening-hours-title": "Opening hours",
        "user-home-opening-day-1": "Mon:",
        "user-home-opening-day-2": "Tue:",
        "user-home-opening-day-3": "Wed:",
        "user-home-opening-day-4": "Thu:",
        "user-home-opening-day-5": "Fri:",

        // User > Home > Room finder
        "user-homeroom-finder-title": "Room finder",
        "user-home-room-finder-resource-type-dropdown": "\n .label = Resource type",
        "user-home-room-finder-resource-date": "\n .label = Date:",
        "user-home-room-finder-resource-duration": "\n .label = Duration:",
        "user-home-room-finder-resource-time": "Time:",
        "user-home-room-finder-resource-seats": "Seats:",
        "user-home-room-finder-resource-book-button": "Book ({ $amount })",
        "user-home-room-finder-resource-results-amount": "{ $amount } results",
        "user-home-room-finder-resource-select-button": "Select",
        "user-home-room-finder-resource-unselect-button": "Remove",
        "user-home-room-finder-go-to-timeline-button": "Go To Timeline",
        "user-home-room-finder-subtitle": "Your intelligent companion for finding resources.",
        "user-home-room-finder-find-a-room-button": "Find a room",
        "user-home-room-finder-available-rooms": "available rooms",
        "user-home-room-finder-available-time-slot": "from { $timeSlot }",


        // User > Upcoming orders > Meeting service
        "user-upcoming-orders-meeting-service-title": "\n .title = Meeting service",

        // User > Upcoming orders > Resource bookings
        "user-upcoming-orders-resource-booking-table-id": "Order ID",
        "user-upcoming-orders-resource-booking-table-time": "Time",
        "user-upcoming-orders-resource-booking-table-meeting": "Meeting",
        "user-upcoming-orders-resource-booking-table-visibility": "Visibility",
        "user-upcoming-orders-resource-booking-table-visibility-public": "Public",
        "user-upcoming-orders-resource-booking-table-visibility-public-tooltip": "The booking is public which means that the meeting name and attendee names are visible for co-workers.",
        "user-upcoming-orders-resource-booking-table-visibility-private": "Private",
        "user-upcoming-orders-resource-booking-table-visibility-private-tooltip": "The booking is private which means that the meeting name and attendee names are not visible to anyone.",
        "user-upcoming-orders-resource-booking-table-action-delete": "Delete",
        "user-upcoming-orders-resource-booking-table-remove-dialog": "\n .title = Remove booking\n .message = Are you sure that you want to remove booking?\n .buttonLabelSubmit = Remove",


        // User > Settings
        "user-settings-page-title": "\n .title = Settings",
        "user-settings-tab-bill-receivers": "My bill receivers",
        "user-settings-tab-guest-reception": "Guest reception",
        "user-settings-tab-calendar-sharing": "Calendar sharing",
        "user-settings-tab-access-control": "Access control",
        "user-settings-table-header-name": "Name",
        "user-settings-table-header-address": "Address",
        "user-settings-table-header-endpoint": "Endpoint",
        "user-settings-table-header-status": "Status",
        "user-settings-status-active": "Active",
        "user-settings-status-inactive": "Inactive",
        "user-settings-status-pending": "Pending",
        "user-settings-action-edit": "Edit",
        "user-settings-action-delete": "Delete",
        "user-settings-action-activate": "Activate",
        "user-settings-action-deactivate": "Deactivate",
        "user-settings-coming-soon": "Coming soon",
        "user-settings-bill-receivers-info": "\n .title = Here are your personal bill receivers, which you can select when ordering meeting service. You have the option to create a new bill receiver during the ordering process, if the selected canteen allows it.",
        "user-settings-delete-bill-receiver-dialog": "\n .typeOfEntity = bill receiver",
        "user-settings-edit-bill-receiver-dialog-title": "Edit bill receiver",
        "user-settings-edit-bill-receiver-page-header": "\n .title = Edit bill receiver",
        "user-settings-edit-bill-receiver-name-field": "\n .label = Name",
        "user-settings-edit-bill-receiver-vatnumber-field": "\n .label = VAT number",
        "user-settings-edit-bill-receiver-address-panel": "\n .title = Address",
        "user-settings-edit-bill-receiver-endpoint-panel": "\n .title = Bill receiver",
        "user-settings-edit-bill-receiver-endpoint-type-field": "\n .label = Type",
        "user-settings-edit-bill-receiver-endpoint-value-field": "\n .label = Value",
        "user-settings-edit-bill-receiver-contact-panel": "\n .title = Contact person",
        "user-settings-edit-bill-receiver-settings-panel": "\n .title = Settings",
        "user-settings-edit-bill-receiver-active-switch": "Active",
        "user-settings-edit-bill-receiver-save-button": "Save",
        "user-nav-item-edit-bill-receiver": "Edit bill receiver",

        // User > Settings > Wallets
        "user-settings-wallets-title": "\n .title = Wallets",

        // User > Wallets > Refill
        "user-wallets-refill-title": "\n .title = Refill wallet",
        "user-wallets-refill-manual-top-up-nav-tab": "Manual top up",
        "user-wallets-refill-automatic-top-up-nav-tab": "Automatic top up",
        "user-wallets-refill-manual-type": "\n .statusLabel = Manual",
        "user-wallets-refill-automatic-type": "\n .statusLabel = Automatic",
        "user-wallets-refill-payment-success": "Order processed",
        "user-wallets-refill-payment-unexpected-error": "An unexpected error occurred",
        "user-wallets-refill-payment-timeout": "Payment timed out",
        "user-wallets-refill-payment-wait-label": "Processing Payment",
        "user-wallets-refill-payment-wait-description":  "Please wait while we process your payment. This may take a few moments.",
        "user-wallets-refill-payment-back-action-button-label": "Back to dashboard",
        "user-wallets-refill-payment-timeout-label": "Payment Timed Out",
        "user-wallets-refill-payment-timeout-description": "We haven't received confirmation from your payment provider. Please check your netbank to be sure that the payment was completed.",
        "user-wallets-refill-payment-canceled-label":  "Payment canceled",
        "user-wallets-refill-payment-canceled-description":  "You've canceled the payment process. No charges have been made to your account.",
        "user-wallets-refill-payment-failed-label": "Payment failed.",
        "user-wallets-refill-payment-failed-description": "Your payment could not be completed. Please confirm your details and try again.",

        // User > Wallets > Refill > Manual tab
        "user-wallets-refill-manual-main-amount-label": "\n .label = Amount",
        "user-wallets-refill-manual-main-amount-error":"Your wallet can't exceed { $maxBalance}. You can max refill { $maxRefillAmount }",
        "user-wallets-refill-manual-main-amount-max-error":"Maximum amount to refill is { $maxRefillAmount }",
        "user-wallets-refill-manual-main-amount-zero-error":"Amount must be greater than 0",
        "user-wallets-refill-auto-amount-max-threshold-error":"Maximum threshold is { $maxThreshold }",
        "user-wallets-refill-payment-method-error":"Payment method is required",
        "user-wallets-refill-manual-main-custom-amount-label": "\n .label = Enter amount:",
        "user-wallets-refill-manual-main-amount-amount-100": "100,00 kr",
        "user-wallets-refill-manual-main-amount-amount-300": "300,00 kr",
        "user-wallets-refill-manual-main-amount-amount-500": "500,00 kr",
        "user-wallets-refill-manual-main-amount-amount-other": "Other",
        "user-wallets-refill-manual-main-payment-method": "Payment methods:",
        "user-wallets-refill-manual-main-select-payment-method": "Select payment method",
        "user-wallets-refill-manual-main-perform-refill-button": "Confirm payment",
        "user-wallets-refill-select-card-dialog-title": "Select wallet",
        "user-wallets-refill-select-card-dialog-no-wallets": " The merchant don't offer digital wallets for your company.",
        "user-wallets-refill-select-card-balance": "Balance:",


        // User > Wallets > Refill > Auto tab
        "user-wallets-refill-auto-activate-card-title": "Activate automatic top up",
        "user-wallets-refill-auto-activate-modal-title": "Activate auto top up",
        "user-wallets-refill-auto-activate-modal-threshold-placeholder": "\n .label = Amount (DKK)",
        "user-wallets-refill-auto-activate-modal-threshold-subtitle": "When balance falls below:",
        "user-wallets-refill-auto-activate-modal-refill-subtitle": "Refill with amount:",
        "user-wallets-refill-auto-activate-modal-submit-button": "Activate auto refill",
        "user-wallets-refill-auto-activate-modal-update-button": "Update auto refill",
        "user-wallets-refill-auto-activate-modal-delete-button": "Delete auto refill",
        "user-wallets-refill-auto-activate-success-modal-subtitle": "Auto top up activated",


        // User > Archive > Drawer
        "user-archive-drawer-resource-booking": "Resource booking",
        "user-archive-drawer-meeting-service": "Meeting service",
        "user-archive-drawer-daily-purchases": "Daily purchases",
        "user-archive-drawer-refill-wallet": "Wallet top-ups",

        // User > Archive > Drawer > Transactions
        "user-archive-transactions-table-id": "Order ID",
        "user-archive-transactions-table-transaction-time": "Transaction time",
        "user-archive-transactions-table-delivery-time": "Delivery time",


         // User > Archive > Meeting service
        "user-archive-meeting-service-title": "\n .title = Meeting service",
        "user-archive-meeting-service-info-box": "In the archive you can only see meeting service orders that have been invoiced by the merchant.",
        "user-archive-meeting-service-table-id": "Order ID",
        "user-archive-meeting-service-table-booked-date": "Booked date",
        "user-archive-meeting-service-table-delivery-time": "Delivery time",
        "user-archive-meeting-service-table-meeting": "Meeting",
        "user-archive-meeting-service-table-amount": "Amount",
        "user-archive-meeting-service-table-action-receipt": "Receipt",
        "user-archive-meeting-service-table-action-duplicate": "Duplicate",
        "user-archive-meeting-service-table-action-send-message": "Send message",
        "user-archive-meeting-service-table-filter-start-date": "Start date",
        "user-archive-meeting-service-table-filter-end-date": "End date",



        // Standard components

        // Standard components > Filter button
        "table-filters-button": "\n .title = Filters\n .aria-label = Filters",

        // Create order
        "create-order-access-denied-on-behalf-of": "You don't have access to order on behalf of chosen user.",
        "create-order-confirm-order-button": "Next",
        "create-order-meeting-service-mobile-bar-continue-button": "Continue",
        "create-order-meeting-service-mobile-back-to-products-button": "Back to products",
        "create-order-book-button": "Book",
        "create-order-update-button": "Update",
        "create-order-undo-button": "\n .title = Undo all",
        "create-order-wish": "\n .title = Wish",
        "create-order-wish-dialog-title": "\n .dialogTitle = Add product wish",
        "create-order-order-line-dialog-title": "\n .dialogTitle = Add product",
        "create-order-wish-dialog-edit-price-title": "\n .dialogTitle = Set price",
        "create-order-wish-dialog-message": "If you add a product wish, your order needs to be manually approved by the merchant.",
        "create-order-wish-dialog-product-name-field": "\n .label =Product name \n .placeholder =Enter product name:",
        "create-order-wish-dialog-product-items-field": "\n .label =Product items \n .placeholder =Enter items:",
        "create-order-wish-dialog-product-price-field": "\n .label =Product price \n .placeholder =Enter price (DKK):",
        "create-order-wish-dialog-submit-button": "Confirm",
        "create-order-wish-dialog-product-name-max-length": "Product name cannot exceed { $maxLength } characters",
        "create-order-wish-dialog-quantity-min-value": "Quantity must be at least 1",
        "create-order-wish-dialog-quantity-max-value": "Quantity cannot exceed { $max }",
        "create-order-wish-dialog-price-min-value": "Price must be greater than 0",
        "create-order-wish-dialog-price-max-value": "Price cannot exceed { $max }",
        "create-order-favorite": "\n .title = View my favorite products",
        "create-order-favorite-show-all-products": "\n .title = Show all products",
        "create-order-list": "\n .title = Show a list of products",
        "create-order-grid": "\n .title = Show a grid of products",
        "create-order-products-empty": "No results",
        "create-order-product-staff-only-tag": "Staff only",
        "create-order-product-sale-text": "Only 10 left",
        "offer-tag-good-price": "Good price",
        "offer-tag-great-offer": "Great offer",
        "offer-tag-buy-now": "Buy now",
        "offer-tag-discount": "Discount",
        "offer-tag-week-offer": "Week's offer",
        "offer-tag-day-offer": "Today's offer",
        "offer-tag-save-x-price": "Save { $amount } kr",
        "offer-tag-save-x-percentage": "{ $amount } off",
        "offer-tag-limited-on-sale": "{ $amount } left",
        "offer-tag-available-from": "Available from: { $date }",
        "create-order-tooltip-order-summary-button": "\n .title = View order summary",
        "create-order-order-summary-no-items": "Order summary is currently empty. Add items to your order to see the details.",
        "create-order-order-summary": "Order summary",
        "create-order-order-summary-resources": "\n .title = Resources",
        "create-order-order-summary-resources-booking-time": "Booking",
        "create-order-order-summary-meeting-services": "\n .title = Meeting services",
        "create-order-order-summary-meeting-services-delivery-time": "Delivery { $number }",
        "create-order-order-summary-meeting-services-total": "Total",
        "create-order-order-summary-meeting-services-empty": "No items added yet",
        "create-order-order-summary-meeting-services-add-order-line-button": "+ Add order line",
        "create-order-order-summary-meeting-services-wish-set-price-button": "Set price",
        "create-order-order-summary-meeting-services-wish-edit-price-button": "\n .title = Edit price\n .aria-label = Edit price",
        "create-order-order-summary-meeting-services-product-item": "{$count} item",
        "create-order-order-summary-meeting-services-product-items": "{$count} items",
        "create-order-order-summary-meeting-services-product-warning-price-list-tooltip": "\n .title = The selected price list does not match the product price list — increase is not available.",
        "create-order-order-summary-meeting-services-product-warning-missing-product-tooltip": "\n .title = This product is not available in the selected shop list",
        "create-order-order-summary-meeting-services-product-staff-only-tooltip": "\n .title = Only the merchant can change this item",
        "create-order-order-summary-meeting-services-legacy-extra-service-tooltip": "\n .title = This is a legacy extra service from the old portal. It cannot be changed, but it can be removed.",
        "create-order-order-summary-meeting-services-wish-locked-quantity-tooltip": "\n .title = Only the merchant can change the number of items in a product wish",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog": "\n .dialogTitle = Prices updated",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-message": "Some prices have changed since this order was created. Review below to continue.",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-section-price-changed": "Price changed ({ $count })",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-section-missing-product": "Not available in price list { $priceList } ({ $count })",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-section-other-price-list": "From another price list ({ $count })",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-section-unchanged-hint": "The price of these items stays as it is in the order.",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-submit-button": "Update",
        "create-order-order-summary-meeting-services-invalid-time-card-empty-title": "Delivery without items",
        "create-order-order-summary-meeting-services-invalid-time-card-empty": "No item was added to delivery at {$time}. Please add items or remove the delivery time.",
        "create-order-order-summary-meeting-services-invalid-times-card-empty": "No items was added to delivery at {$time}. Please add items or remove the delivery times.",
        "create-order-order-summary-meeting-services-invalid-times-card-empty-button": "Ok",
        "create-order-confirm-booking-meeting-details": "Meeting details",
        "create-order-outlook-private-meeting-default-name": "Private meeting",
        "create-order-outlook-on-behalf-of-chip": "On behalf of { $name }",
        "create-order-confirm-booking-update-meeting-details": "Update meeting details #{ $id }",
        "create-order-confirm-booking-dialog-add-attendees": "Add participants",
        "create-order-confirm-booking-dialog-back-button": "Back",
        "create-order-confirm-booking-meeting-information-tab": "Meeting information",
        "create-order-confirm-booking-participants-tab": "Participants",
        "create-order-confirm-booking-other-tab": "Other",
        "create-order-confirm-booking-dialog-confirm-button": "Confirm",
        "create-order-confirm-booking-dialog-submit-button": "Complete booking",
        "create-order-confirm-booking-dialog-add-attendee-button": "Add participants",
        "create-order-confirm-booking-dialog-bulk-add-attendees-drawer-button": "Add participants",
        "create-order-confirm-booking-dialog-bulk-add-attendees-button": "Copy and paste",
        "create-order-confirm-booking-dialog-bulk-add-attendees-button-tooltip": "\n .title = Add multiple participants by pasting a list of names and companies",
        "create-order-confirm-booking-dialog-bulk-add-attendees-description": "Input one name and company per line.",
        "create-order-confirm-booking-dialog-bulk-add-attendees-field": "\n .placeholder = Name, Company",
        "create-order-confirm-booking-selected-resources": "Selected resources ({ $count }):",
        "create-order-confirm-booking-booking-time": "Booking time: { $time }",
        "create-order-confirm-booking-rooms": "Rooms:",
        "create-order-confirm-booking-equipment": "AV Equipment:",
        "create-order-confirm-booking-cars": "Cars:",
        "create-order-confirm-booking-time-range-picker-from-field": "\n .label =From time:",
        "create-order-confirm-booking-time-range-picker-to-field": "\n .label =To time:",
        "create-order-confirm-booking-time-range-picker-error": "Resource is not available at this time",
        "create-order-meeting-details-start-time-label": "Meeting start time",
        "create-order-meeting-details-end-time-label": "Meeting end time",
        "create-order-meeting-details-duration-helper-text":
            "Enter the meeting duration so the canteen can plan delivery and cleanup.",
        "create-order-confirm-booking-table-setup": "Table setup",
        "create-order-confirm-booking-select-setup": "Select setup",
        "create-order-confirm-booking-message-title": "Messages to service center",
        "create-order-attendees-dialog-submit-button": "Save",
        "create-order-attendees-dialog-title": "Participants",
        "create-order-note-add-button": "Add",
        "create-order-note-edit-button": "Edit",
        "create-order-note-dialog-title": "\n .dialogTitle = Order message",
        "create-order-note-dialog-alert": "\n .title = Your order notification will be visible on the order specification. You must not include personally identifiable information, such as details about your health or your religion.",
        "create-order-note-dialog-field": "\n .label = Your order message \n .helperText = Remaining characters: { $count }",
        "create-order-note-save-button": "Save",
        "create-order-extra-services": "Extra services:",
        "create-order-extra-services-delivery": "\n .title = Delivery at { $time }",
        "create-order-extra-services-min-max": "Min. { $min } - Max. { $max }",
        "create-order-extra-services-add-button": "Add",
        "create-order-extra-services-remove-button": "Remove",
        "create-order-extra-services-mandatory-tooltip": "\n .title = This service is mandatory",
        "create-order-extra-services-always-added-label": "Included",
        "create-order-extra-services-auto-added-snackbar": "A service fee of { $amount } for \"{ $name }\" has been added to your cart.",
        "create-order-extra-services-removed-notification": "\"{ $name }\" is no longer available and has been removed from your cart.",
        "create-order-extra-services-seats-breakdown": "{ $count } seats x { $price }",
        "create-order-extra-services-total": "Total: { $amount }",
        "create-order-extra-services-min-price": "Min. price { $price }",
        "create-order-extra-services-max-price": "Max. price { $price }",
        "create-order-extra-services-tooltip-price-per-seat-label": "Price per seat:",
        "create-order-extra-services-tooltip-min-price-label": "Min. price:",
        "create-order-extra-services-tooltip-max-price-label": "Max. price:",
        "create-order-extra-services-additional-fields-title": "Additional meeting details:",
        "create-order-extra-services-additional-fields-intro": "\n .title = In order to deliver some extra services we need some additional meeting details.",
        "create-order-extra-services-additional-fields-start-time-label": "Start time",
        "create-order-extra-services-additional-fields-end-time-label": "End time",
        "create-order-extra-services-additional-fields-location-label": "Where is the meeting located?",
        "create-order-workgroup-label": "\n .label = Workgroup",
        "create-order-participants-add-button": "+ Add participants",
        "create-order-participants-edit-button": "Edit participants",
        "create-order-participants-count-list": "{ $count } participants",
        "create-order-participants-count-one-item": "{ $count } participant",
        "create-order-share-outlook-attendees-toggle-label": "\n    .label = Add participants from Outlook",
        "create-order-share-outlook-attendees-toggle-helper":
            "Turning this on adds { $count } participant(s) from your Outlook meeting.",
        "create-order-share-outlook-attendees-list-title": "Participants from Outlook ({ $count }):",
        "create-order-share-outlook-attendees-show-all-button": "+{ $count } more",
        "create-order-share-outlook-attendees-show-less-button": "Show less",
        "create-order-share-outlook-attendees-remove": "Remove participant",
        "create-order-participants-dialog-name-column": "Name",
        "create-order-participants-dialog-company-column": "Company",
        "create-order-participants-dialog-email-column": "Email",
        "create-order-participants-dialog-external-internal-column": "External",
        "create-order-participants-dialog-field-name": "\n .placeholder = Participant name",
        "create-order-participants-dialog-field-company": "\n .placeholder = Company",
        "create-order-participants-dialog-field-email": "\n .placeholder = Email address",
        "create-order-add-filters-button": "Add filters",
        "create-order-add-search-input": "\n .placeholder = Search",
        "create-order-view-timeline": "Timeline",
        "create-order-view-available-time": "Availability",
        "create-order-view-room-finder": "Room Finder",
        "create-order-view-room-finder-upcoming-tooltip": "\n .title = Upcoming",
        "create-order-calendar-today-button": "Today",
        "create-order-calendar-today-button-hint": "Go to today",
        "create-order-calendar-prev-day-button": "Go to previous day",
        "create-order-calendar-next-day-button": "Go to next day",
        "create-order-calendar-go-to-date-button": "Go to date",
        "create-order-calendar-go-to-date-button-hint": "Choose your wanted date",
        "create-order-calendar-no-resources-message": "There are no available resources. Please adjust the filters",
        "create-order-calendar-go-to-date-label": "\n .label = Select date",
        "create-order-calendar-go-button": "Go",
        "create-order-calendar-all-day-label": "All day",
        "create-order-calendar-week-button": "Current week",
        "create-order-calendar-prev-week-button": "Previous week",
        "create-order-calendar-next-week-button": "Next week",
        "create-order-calendar-event-tooltip": "\n .title = Click to book",
        "create-order-confirm-booking-confirm-dialog": "\n .title = Confirm booking\n .message =Your booking has not been completed. Please confirm your booking before proceeding.\n .buttonLabelSubmit = Confirm\n .buttonLabelCancel=Cancel",
        "create-order-confirm-booking-confirm-no-resources-dialog": "\n .title = Booking not complete\n .message =You haven't selected any resources yet. If you leave now, your booking will not be completed.\n .buttonLabelSubmit = Select resources\n .buttonLabelCancel=Leave anyway",
        "create-order-change-time-dialog": "\n .title = Change booking time?\n .buttonLabelSubmit = Use new time\n .buttonLabelCancel=Keep original time",
        "create-order-change-time-dialog-message-top": "Your Outlook meeting request is scheduled for:",
        "create-order-change-time-dialog-message-bottom": "Do you want to change booking time to:",
        "create-order-drawer-other-location": "+ Other location",
        "create-order-drawer-delivery-location-field": "\n .label = Delivery location",
        "create-order-drawer-meeting-location-field": "\n .label = Meeting location",
        "create-order-drawer-meeting-location-label": "Meeting location",
        "create-order-drawer-repeat-order": "Repeat order",
        "create-order-drawer-repeat-order-every": "Repeat every:",
        "create-order-drawer-repeat-order-every-day": "\n .label = Day",
        "create-order-drawer-repeat-order-every-week": "\n .label = Week",
        "create-order-drawer-repeat-order-on": "Repeat on:",
        "create-order-drawer-repeat-order-starts": "Starts:",
        "create-order-drawer-repeat-order-start-date-locked-message": "The start date is the order’s first delivery. To change it, close this dialog and edit the first delivery date on the order. Then open Repeat order again.",
        "create-order-drawer-repeat-order-ends": "Ends:",
        "create-order-drawer-repeat-order-ends-on": "\n .label = On",
        "create-order-drawer-repeat-order-ends-after": "\n .label = After",
        "create-order-drawer-repeat-order-ends-after-deliveries": "deliveries",
        "create-order-drawer-repeat-order-end-before-start-error": "End date must be on or after the start date",
        "create-order-drawer-repeat-order-confirm-button": "Confirm",
        "create-order-drawer-repeat-order-summary": "Occurs every { $interval }{ $days }, running from { $startDate }{ $repeatCount }{ $endDate }{ $exceptions }.",
        "create-order-drawer-repeat-order-summary-interval-day": "day",
        "create-order-drawer-repeat-order-summary-interval-days": "{ $count } days",
        "create-order-drawer-repeat-order-summary-interval-week": "week",
        "create-order-drawer-repeat-order-summary-interval-weeks": "{ $count } weeks",
        "create-order-drawer-repeat-order-summary-days-suffix": " on { $days }",
        "create-order-drawer-repeat-order-summary-repeat-count-suffix": ", { $count } times",
        "create-order-drawer-repeat-order-summary-end-date-suffix": ", ending on { $date }",
        "create-order-drawer-repeat-order-summary-exceptions-suffix": "{ $count ->\n [one] ({ $count } exception)\n *[other] ({ $count } exceptions)\n}",
        "create-order-drawer-repeat-order-delete-confirm-dialog": "\n .title = Delete repeat \n .buttonLabelSubmit = Delete",
        "create-order-drawer-repeat-order-delete-confirm-dialog-message": "The repeat and any deselected days will be removed. The order itself is kept.",
        "create-order-drawer-repeat-order-applies-to": "Applies to:",
        "create-order-drawer-repeat-order-applies-to-weekdays": "\n .label = Weekdays (Mon–Fri)",
        "create-order-drawer-repeat-order-applies-to-every-day": "\n .label = Every day",
        "create-order-drawer-repeat-order-start-date-help": "The order’s delivery date – cannot be changed",
        "create-order-drawer-repeat-order-start-date-missing-error": "The order has no delivery date.",
        "create-order-drawer-repeat-order-end-date-missing-error": "Choose an end date.",
        "create-order-drawer-repeat-order-span-error": "A repeat can span at most one year.",
        "create-order-drawer-repeat-order-count-missing-error": "Enter how many deliveries to create.",
        "create-order-drawer-repeat-order-no-deliveries-error": "This repeat has no delivery days. Edit the repeat or remove it.",
        "create-order-drawer-repeat-order-delivery-days": "Delivery days:",
        "create-order-drawer-repeat-order-delivery-days-hint": "Untick the days that should not be delivered.",
        "create-order-drawer-repeat-order-delivery-days-reset-button": "Reset deselections",
        "create-order-drawer-repeat-order-delivery-days-show-button": "View and deselect days ({ $count })",
        "create-order-drawer-repeat-order-delivery-days-hide-button": "Hide days",
        "create-order-drawer-repeat-order-delivery-days-none-selected": "No days selected",
        "create-order-drawer-repeat-order-delivery-days-all-selected": "All days in the period are selected",
        "create-order-drawer-repeat-order-delivery-days-deselected": "{ $count ->\n [one] { $count } day deselected\n *[other] { $count } days deselected\n}",
        "create-order-drawer-repeat-order-delivery-days-month-count": "{ $count ->\n [one] { $count } delivery\n *[other] { $count } deliveries\n}",
        "create-order-drawer-repeat-order-delivery-days-month-deselected": "· { $count } deselected",
        "create-order-drawer-repeat-order-delivery-days-start-day": "Start date",
        "create-order-drawer-repeat-order-confirm-orders-button": "{ $count ->\n [one] Confirm { $count } order\n *[other] Confirm { $count } orders\n}",
        "create-order-drawer-repeat-order-summary-weekdays-suffix": "on weekdays",
        "create-order-tooltip-resource-info-button": "\n .title = Show resource details",
        "create-order-tooltip-resource-lock-button-has-access": "\n .title = Can only be booked by selected users. You have access to book.",
        "create-order-tooltip-resource-lock-button-no-access": "\n .title = Can only be booked by selected users. You do not have access.",
        "create-order-tooltip-resource-image-button": "\n .title = View floor plan image",
        "create-order-hover-local-event-start": "Start time: { $start }",
        "create-order-hover-local-event-end": "End time: { $end }",
        "create-order-hover-local-event-host": "Host: { $host }",
        "create-order-tabs-error": "You can't place an order",
        "create-order-tabs-error-body": "You can't place an order because your account doesn't have the required access. Please contact support if you need more information.",
        "create-order-invalid-user-permissions-merchant-meeting-service-dialog-body": "You are attempting to create a meeting service order on behalf of <displayName>{ $displayName }</displayName>. However, the user does not have access to your meeting service shop. Please contact support for assistance.",
        "create-order-invalid-user-permissions-merchant-resource-booking-dialog-body": "You are attempting to create a resource booking on behalf of <displayName>{ $displayName }</displayName>. Please contact support for assistance.",
        "create-order-invalid-user-permissions-non-create-dialog-title": "Access restriction",
        "create-order-invalid-user-permissions-non-create-dialog-body": "You don't have access to perform this action on behalf of <displayName>{ $displayName }</displayName>. Please contact support for assistance.",
        "create-order-tabs-error-dialog-close-button": "Go back",
        "create-order-tabs-error-dialog-confirm-button": "Select another user",
        "create-order-price-list-confirm-dialog": "\n .title = Remove products\n .buttonLabelSubmit = Remove",
        "create-order-price-list-confirm-dialog-message": "Are you sure that you want to remove all products from all delivery times?",
        "create-order-close-confirm-dialog": "\n .title = Discard changes \n .buttonLabelSubmit = Discard",
        "create-order-close-confirm-dialog-message": "If you click Discard, all entered information will be lost.",
        "create-order-drawer-messages-dialog-title": "\n .dialogTitle = Messages from the merchant",
        "create-order-drawer-message-read-more": "...Read more",
        "expandable-text-read-more": "Read more",
        "expandable-text-read-less": "Show less",
        "create-order-book-period-message-dialog-title": "\n .dialogTitle = You cannot click on the timeline while using `Book Period` mode",
        "create-order-book-period-message-dialog-note": "To book resources, please click on the resources from the left panel",
        "create-order-book-period-filter-intro": "Reserve period is used to book periods of several days. When you have selected a start and end time, just click on the wanted resource in the left column",
        "create-order-book-period-filter-intro-recurring":
            "This is a recurring meeting — just click the wanted resource in the left column to book it for every occurrence.",
        "create-order-book-period-busy-message": "The selected resource is not available for the full period",
        "create-order-book-period-busy-error": "Could't check resource availability",
        "create-order-book-period-confirm-cancel-changes-dialog": "\n .title = Remove current selection\n .buttonLabelSubmit = Confirm\n .buttonLabelCancel=Cancel",
        "create-order-book-period-confirm-cancel-changes-dialog-message": "Changing the period will clear your current selection. Do you want to continue?",
        "create-order-past-booking-attempt-message": "You can't book back in time. The start time of the booking must be equal or later than current time",
        "create-order-book-period-past-booking": "Can't select a period in the past",
        "create-order-change-current-event-dialog": "\n .title = You are currently updating booking { $currentBooking }\n .message = Reset your changes and switch to { $targetBooking }?\n .buttonLabelSubmit = Confirm\n .buttonLabelCancel = Cancel",
        "create-order-change-current-event-create-dialog": "\n .title = You are currently creating a booking\n .message = Reset your changes and switch to { $targetBooking }?\n .buttonLabelSubmit = Confirm\n .buttonLabelCancel = Cancel",
        "create-order-timeline-permission-error": "You don't have permission to update this booking as it belongs to a different user",
        "create-order-timeline-error-select": "This time slot is't available for the selected resources",
        "create-order-timeline-error-busy-or-overlap": "This resource is already busy at the selected time or buffer overlap detected!",
        "create-order-timeline-slot-taken-message": "Someone booked this time while you were choosing. The timeline has been updated — please select another time or resource.",
        "create-order-resource-row-events-loading-tooltip": "Calendar events are still loading. Please wait before selecting a resource.",

        "create-order-select-price-list-dialog": "Select price list",
        "create-order-empty-price-list-dialog": "No pricelist available",
        "create-order-empty-price-list-dialog-body": "Currently there are no pricelist available",
        "create-order-empty-price-list-dialog-body-message": "Please reach out to the merchant to request access to them",
        "create-order-select-price-list-no-price-lists-title": "Currently, there are no price lists available. Please reach out to the merchant to request access to them.",
        "create-order-select-price-list-no-search-results": "Your search returned no results",
        "create-order-select-price-list-no-search-results-description": "Try a different search term",
        "create-order-select-price-list-favorites-section": "My favorites ({ $count })",
        "create-order-select-price-list-favorites-view-all": "View all ({ $count })",
        "create-order-select-price-list-favorites-toggle-label": "Favorites",
        "create-order-select-price-list-nearby-note": "Showing price lists near your booked room.",
        "create-order-select-price-list-nearby-see-all-button": "See all canteens",
        "create-order-select-price-list-nearby-only-button": "Show only canteens near your booked room",
        "create-order-select-price-list-other-canteens-section": "Other canteens",
        "create-order-no-products-dialog-title": "\n .dialogTitle = Pricelist has no products",
        "create-order-no-products-dialog-message": "Please contact the merchant to get access to the products",
        "create-order-no-longer-available-dialog-title": "\n .dialogTitle = Price list no longer available",
        "create-order-no-longer-available-dialog-message": "The price list used for this order is no longer available. Please pick another price list to continue.",
        "create-order-no-products-dialog-button-label-cancel": "Go to home",
        "create-order-no-products-dialog-button-label-submit": "Select another Pricelist",
        "create-order-products-empty-favorites-title": "You do not have any favorite items",
        "create-order-products-empty-favorites-description": "You can add favorite items so that you can complete an order more quickly. Add a favorite item by clicking on the heart icon found on the product card",
        "create-order-credit-note-overlay-title": "Credit note",
        "create-order-credit-note-overlay-intro-with-order-id": "You are creating a credit note for order ID <orderIdLink>#{ $orderId }</orderIdLink>.",
        "create-order-credit-note-overlay-callout-title": "How to make a credit note:",
        "create-order-credit-note-overlay-callout-body": "Adjust the products in the cart. The items currently in the cart are being credited. You can add your own order line if needed.",
        "create-order-select-price-list-dialog-subtitle": "Meeting catering",
        "create-order-select-price-list-search-placeholder": "\n .placeholder = Search price list or canteen",
        "create-order-select-price-list-close-button": "Close",
        "create-order-select-price-list-footer-empty": "Choose a price list",
        "create-order-select-price-list-footer-selected": "{ $priceList } · { $merchant }",
        "create-order-select-price-list-continue-button": "Continue",
        "create-order-select-price-list-selected-badge": "Selected",
        "create-order-select-price-list-address-map-link": "Open in Google Maps",
        "create-order-select-price-list-address-show-map": "Show map",
        "create-order-select-price-list-address-hide-map": "Hide map",
        "create-order-select-price-list-info-button-tooltip": "Show details",
        "create-order-select-price-list-info-close-button": "Close details",
        "create-order-select-price-list-favorite-add-button-tooltip": "Add to favorites",
        "create-order-select-price-list-favorite-remove-button-tooltip": "Remove from favorites",
        "create-order-on-behalf-of-dialog": "Order on behalf of",
        "create-order-on-behalf-of-dialog-description": "To create an order as an administrator, you must first select a user for whom you are placing the order.",
        "create-order-on-behalf-of-dialog-user-description": "Choose who you're ordering for. They'll be the organizer and can update the order from their dashboard.",
        "create-order-on-behalf-of-dialog-select-company-field": "\n .label = Select company",
        "create-order-on-behalf-of-dialog-select-user-field": "\n .label = Select user\n .placeholder = Enter user name:",
        "create-order-on-behalf-of-dialog-user-organizer-field": "\n .label = Organizer:\n .placeholder = Organizer name",
        "create-order-on-behalf-of-dialog-select-user-field-no-results": "No results",
        "create-order-on-behalf-of-dialog-select-company-host-field": "\n .label = Host company",
        "create-order-on-behalf-of-dialog-select-host-field": "\n .label = Host name\n .placeholder = Enter host name:",
        "create-order-on-behalf-of-dialog-button": "Continue",
        "create-order-bill-receiver-ean": "EAN:",
        "create-order-bill-receiver-email": "E-mail:",
        "create-order-bill-receiver-contact": "Contact:",
        "create-order-bill-receiver-add-button": "+ Add bill receiver",
        "create-order-bill-receiver-autocomplete-no-options": "No billing receivers found. Please contact your administrator to add one.",
        "create-order-vat-included": "(VAT incl.)",
        "create-order-vat-excl": "(VAT excl.)",


        "create-order-recurrence-outlook-managed": "This meeting repeats (managed in Outlook)",
        "create-order-busy-resource-dates-dialog-title": "Some dates could not be booked",
        "create-order-busy-resource-dates-dialog-message":
            "The selected resources were already booked on the following dates, so those occurrences were not booked:",
        "create-order-busy-resource-dates-dialog-copy-button": "Copy list",
        "create-order-busy-resource-dates-dialog-copied-button": "Copied",
        "create-order-busy-resource-dates-dialog-continue-button": "Continue",
        "create-order-success-dialog-resource-booking-title": "Booking created!",
        "create-order-success-dialog-resource-booking-title-with-order-id": "Booking #{ $orderId } created!",
        "create-order-success-dialog-resource-booking-title-updated-with-order-id":
            "Booking #{ $orderId } is updated!",
        "create-order-success-dialog-meeting-service-title": "Order completed!",
        "create-order-success-dialog-meeting-service-title-with-order-id": "Order #{ $orderId } created!",
        "create-order-success-dialog-meeting-service-title-updated-with-order-id": "Order #{ $orderId } is updated!",
        "create-order-success-dialog-series-orders-title": "{ $count } orders have been created!",
        "create-order-success-dialog-description": "What do you want to do next?",
        "create-order-success-dialog-outlook-cancel-note":
            "Need to cancel? Cancel the order in Facilitynet before you delete the meeting in Outlook.",
        "create-order-success-dialog-action-meeting-service": "Add meeting service to order",
        "create-order-success-dialog-action-meeting-service-update": "Update meeting service",
        "create-order-success-dialog-action-add-resource-booking": "Add resource booking",
        "create-order-success-dialog-action-update-resource-booking": "Update resource booking",
        "create-order-success-dialog-action-create-booking": "Create another booking",
        "create-order-success-dialog-action-create-meeting-service": "Create another meeting service",
        "create-order-success-dialog-action-finish": "I'm finished",
        "create-order-success-dialog-action-calendar": "Add meeting to calendar",

        "create-order-outlook-finish-step": "You can now return to Outlook",

        // Confirm order dialog
        "confirm-order-dialog-order-error": "Failed to load packing slip with id #{ $orderId }",
        "confirm-order-dialog-order-error-description": "This order could not be processed due to missing or invalid data.",
        "confirm-order-dialog-title": "Confirm order",
        "confirm-order-dialog-title-update-order": "Update order #{ $id }",
        "confirm-order-dialog-title-credit-note-order": "Create credit note",
        "confirm-order-dialog-title-supplementary-order": "Create supplementary order",
        "confirm-order-dialog-meeting-details": "Meeting details",
        "confirm-order-dialog-meeting-time": "Meeting time:",
        "confirm-order-dialog-delivery-date": "Delivery date:",
        "confirm-order-dialog-delivery-location": "Delivery location:",
        "confirm-order-dialog-delivery-location-mode-eating-in-canteen": "Eating in canteen",
        "confirm-order-dialog-delivery-location-mode-pick-up": "Pick up",
        "confirm-order-dialog-seats": "Seats:",
        "confirm-order-dialog-merchant": "Merchant:",
        "confirm-order-dialog-workgroup": "Workgroup:",
        "confirm-order-dialog-workgroup-members-title": "Workgroup members",
        "confirm-order-dialog-workgroup-members-empty": "No members to show",
        "confirm-order-dialog-workgroup-members-error": "We cannot show the members right now",
        "confirm-order-dialog-workgroup-members-no-access": "You do not have access to view group members",
        "confirm-order-timestamp-created": "Created:",
        "confirm-order-timestamp-updated": "Updated:",
        "confirm-order-dialog-contact": "Contact",
        "confirm-order-dialog-host": "Host:",
        "confirm-order-dialog-ordered-by": "Ordered by:",
        "confirm-order-dialog-bill-receiver": "Bill receiver",
        "confirm-order-dialog-bill-receiver-contact": "Contact:",
        "confirm-order-dialog-bill-receiver-contact-email": "Email:",
        "confirm-order-dialog-bill-receiver-cost-centers": "Cost centers:",
        "confirm-order-dialog-bill-receiver-meeting-type": "Meeting type:",
        "confirm-order-dialog-bill-receiver-department": "Department:",
        "confirm-order-dialog-order-summary": "Order summary",
        "confirm-order-dialog-order-summary-delivery-date": "Delivery: { $date }",
        "confirm-order-dialog-order-summary-delivery-date-time": "Delivery: { $date }, { $time }",
        "confirm-order-dialog-order-summary-table-meeting-service": "Meeting service",
        "confirm-order-dialog-order-summary-table-items": "Items",
        "confirm-order-dialog-order-summary-table-amount": "Amount",
        "confirm-order-dialog-order-summary-table-amount-no-vat": "Amount",
        "confirm-order-dialog-order-summary-table-meeting-services-total": "Total",
        "confirm-order-dialog-order-summary-table-meeting-services-total-no-vat": "Total",
        "confirm-order-dialog-order-summary-table-meeting-services-vat": "VAT amounts to ({ $percentage }%)",
        "confirm-order-dialog-order-summary-table-meeting-services-total-include-vat": "Total amount incl. VAT",
        "confirm-order-dialog-repeat-order": "\n .title = Repeat order",
        "confirm-order-dialog-repeat-order-text": "Repeat order",
        "confirm-order-dialog-repeat-order-summary-weekdays": "Weekdays",
        "confirm-order-dialog-repeat-order-summary-every-day": "Every day",
        "confirm-order-dialog-repeat-order-summary-rule": "Every { $interval }{ $days }",
        "confirm-order-dialog-repeat-order-summary-deliveries": "{ $count ->\n [one] { $count } delivery\n *[other] { $count } deliveries\n}",
        "confirm-order-dialog-repeat-order-summary-deselected": "({ $count } deselected)",
        "confirm-order-dialog-repeat-order-day-deselected": "deselected",
        "confirm-order-dialog-attendees": "\n .title = Participants",
        "confirm-order-dialog-attendees-subtitle": "{ $internalCount } { $internalCount ->\n  [one] internal\n *[other] internal\n}, { $externalCount } { $externalCount ->\n  [one] external\n *[other] external\n}",
        "confirm-order-dialog-attendees-internal": "\n .title = Internal attendees:",
        "confirm-order-dialog-attendees-external": "\n .title = External attendees:",
        "confirm-order-dialog-resources": "\n .title = Resources",
        "confirm-order-dialog-back-button": "Keep editing",
        "confirm-order-dialog-next-button": "Confirm order",
        "confirm-order-dialog-booking-time": "Booking time: { $timeRange }",

        "user-order-receipt-page-share-button": "Share",
        "user-order-receipt-page-not-loaded-message": "  Order id { $orderId } could not be read. Please contact support.",
        "user-order-receipt-page-not-found-public-message": "Sorry, the order wasn't found. Please contact support at <link>{ $supportEmail }</link> if you need help.",
        "user-order-receipt-page-loading": "Loading order...",
        "user-order-receipt-page-share-modal-title": "Share receipt",
        "user-order-receipt-page-share-modal-subtitle": "Share this link to let others view the receipt.",
        "user-order-receipt-page-print-button": "Print",
        "user-order-receipt-page-header-orders-count": "Orders: {$orderCount} selected",
        "user-pos-order-receipt-page-header-orders-count": "Receipts: {$orderCount} selected",
        "user-order-receipt-page-navigation-counter": "Order { $current } of { $total }",
        "user-pos-order-receipt-page-navigation-counter": "Receipt { $current } of { $total }",
        "receipt-order-navigation-previous-button": "Previous",
        "receipt-order-navigation-next-button": "Next",
        "merchant-receipt-dropdown-search-label": "\n .placeholder = Search by order no., name or email",
        "merchant-receipt-dropdown-group-today-label": "Today · { $date }",
        "merchant-receipt-dropdown-orders-count": "{ $count ->\n [one] { $count } order\n *[other] { $count } orders\n}",

        "create-order-delivery-times-add-button": "Add deliveries",
        "create-order-delivery-times-add-btn": "Add",
        "create-order-delivery-times-add-delivery-time-title": "Delivery times",
        "create-order-delivery-times-update-delivery-time": "Update delivery times",
        "create-order-delivery-times-add-delivery-time": "Add delivery times:",
        "create-order-delivery-times-dialog-title-add": "Add deliveries",
        "create-order-delivery-times-dialog-title-edit": "Edit deliveries",
        "create-order-delivery-times-dialog-subtitle": "You need to select a date for the delivery.",
        "create-order-delivery-times-dialog-subtitle-example": "You can specify multiple delivery times for full-day meetings, e.g., delivery at 10:00 AM and delivery at 1:00 PM.",
        "create-order-delivery-times-dialog-booking-date-mismatch": "Your booking is on { $bookingDate } at { $bookingTime }, but the meeting service is on { $deliveryDate }.",
        "create-order-delivery-times-dialog-delivery-date": "Delivery date",
        "create-order-delivery-times-dialog-delivery-date-details": "Delivery date:",
        "create-order-delivery-times-dialog-delivery-time-event-start": "Your meeting starts at { $bookingTime }, but the shop owner only delivers between { $minTime } and { $maxTime }. Please pick a delivery time within that window.",
        "create-order-delivery-times-dialog-delivery-time-event-start-today": "Unfortunately you can't create a meeting service order today, because merchant do not deliver later than { $time }",
        "create-order-delivery-times-dialog-delivery-date-close-tooltip": "Merchant is closed on this date",
        "create-order-delivery-times-dialog-delivery-date-kept-tooltip":
            "Merchant is closed on this date — kept from the original order",
        "create-order-closed-delivery-date-warning-admin":
            "Please note: The canteen is closed on { $date }. Regular canteen users cannot place orders for this date, but as a canteen administrator, you can create the order.",
        "create-order-closed-delivery-date-warning-editing":
            "Please note: The canteen is closed on { $date }. This order was placed for that date and can still be saved.",
        "create-order-closed-delivery-date-banner-admin":
            "\n .title = Please note: The canteen is closed on { $date }. Regular canteen users cannot place orders for this date, but as a canteen administrator, you can create the order.",
        "create-order-closed-delivery-date-banner-editing":
            "\n .title = Please note: The canteen is closed on { $date }. This order was placed for that date and can still be saved.",
        "create-order-delivery-times-dialog-delivery-times": "Delivery times",
        "create-order-delivery-times-dialog-delivery-field": "\n .label = Delivery { $count }",
        "create-order-delivery-times-dialog-add-delivery-button": "+ Add delivery",
        "create-order-delivery-times-dialog-submit-button": "Confirm",
        "create-order-delivery-times-dialog-close-button": "Ok",
        "create-order-delivery-times-empty-error": "No active delivery time selected",
        "create-order-cost-centers-missing-dialog-title": "Cost centers unavailable",
        "create-order-cost-centers-missing-message": "There are no cost centers available for \"{ $dimensionName }\". Please contact your administrator to have cost centers created.",
        "create-order-delivery-location-required": "Please select a delivery location",
        "create-order-meeting-location-required": "Meeting location is required when an extra service requires it",
        "create-order-meeting-time-required": "Meeting time is required when an extra service requires it",
        "create-order-multiple-deliveries-date-and-time-required": "You must select a delivery date and at least one delivery time",
        "create-order-validation-date-invalid": "{ $label } must be a valid date",
        "create-order-validation-must-be-checked": "{ $label } must be checked",
        "create-order-validation-required": "{ $label } is required",
        "create-order-validation-min": "{ $label } must be at least { $min }",
        "create-order-validation-max": "{ $label } must be at most { $max }",
        "create-order-validation-must-be-true": "{ $label } must be true",
        "create-order-validation-email-invalid": "{ $label } must be a valid email",
        "create-order-validation-format-invalid": "{ $label } is not in the correct format",
        "create-order-delivery-times-same-time-error": "The same time can't be added twice",
        "create-order-delivery-times-opening-hours-error": "The selected time is't within the business hours for this date",
        "create-order-delivery-times-past-time-error": "Delivery time can't be in the past",
        "create-order-refund-amount-exceeds-initial-error": "Credit note cannot exceed the initial amount",
        "create-order-refund-quantity-exceeds-initial-error": "Credited quantity cannot exceed the initial quantity for this product",
        "create-order-delivery-deadline-message-dialog-title": "\n .title = Deadline has been exceeded \n .buttonLabelSubmit = Place order \n .buttonLabelCancel = Cancel order",
        "create-order-delivery-deadline-message-dialog-description": "You can still place the order, but the order needs to be approved by the staff, which means you can not expect the order to be delivered.",
        "create-order-delivery-deadline-message-dialog-product-wish-staff-description": "There is a product wish on this order. You must set a price and approve the order, if you want to accommodate the request.",
        "create-order-add-product-deadline-dialog-title": "\n .title = Deadline has been exceeded \n .buttonLabelSubmit = OK",

        "create-order-timeline-booked-period": "Book period",
        "create-order-timeline-booked-period-tooltip": "Pick a start and end time to book resources for a longer period",
        "create-order-timeline-booked-period-selected-tooltip": "Click a resource in the left column to book it for this period. The timeline can't be clicked in this mode",
        "create-order-timeline-booked-period-recurring-tooltip": "The period is set by the meeting series. Click a resource in the left column to book it for every occurrence",
        "create-order-timeline-booked-period-start-date-time-label": "\n .label = Start time",
        "create-order-timeline-booked-period-end-date-time-label": "\n .label = End time",
        "create-order-timeline-meeting-availability-hidden-count": "{ $count } resources hidden",
        "create-order-timeline-meeting-availability-show-all-button": "Show all",
        "create-order-timeline-meeting-fit-banner-title-fallback": "Your meeting",
        "create-order-timeline-meeting-fit-banner-summary":
            "{ $date }, { $time } · { $count ->\n [one] { $count } attendee\n *[other] { $count } attendees\n}",
        "create-order-timeline-meeting-fit-banner-summary-no-attendees": "{ $date }, { $time }",
        "create-order-timeline-meeting-fit-banner-summary-attendees-only":
            "{ $count ->\n [one] { $count } attendee\n *[other] { $count } attendees\n}",
        "create-order-timeline-meeting-fit-banner-fits-segment": "Match your meeting",
        "create-order-timeline-meeting-fit-banner-all-segment": "All resources",
        "create-order-timeline-meeting-fit-banner-fits-segment-tooltip-seats-and-availability":
            "Shows only resources with enough seats that are free at the meeting time",
        "create-order-timeline-meeting-fit-banner-fits-segment-tooltip-availability":
            "Shows only resources that are free at the meeting time",
        "create-order-timeline-meeting-fit-banner-fits-segment-tooltip-seats":
            "Shows only resources with enough seats for the attendees",
        "create-order-timeline-meeting-fit-banner-all-segment-tooltip":
            "Shows all resources, including ones that don't fit the meeting",
        "create-order-timeline-meeting-fit-banner-go-to-meeting-button": "Go to meeting",

        "resource-booking-chip-filter-select-booking-duration-hours": "hours",
        "resource-booking-chip-filter-select-booking-duration-minutes": "minutes",
        "resource-booking-chip-filter-select-meeting-type-title-internal-meeting": "Internal meeting",
        "resource-booking-chip-filter-select-meeting-type-title-internal-meeting-description": "The meeting is with coworkers only, no external guests.",
        "resource-booking-chip-filter-select-meeting-type-title-external-meeting": "External meeting",
        "resource-booking-chip-filter-select-meeting-type-title-external-meeting-description": "Meeting has external guests.",
        "resource-booking-chip-filter-select-title-floors": "Select floor",
        "resource-booking-chip-filter-select-title-fixedavids": "Select fixed AV-equipment",
        "resource-booking-chip-filter-select-title-meetingtype": "Select meeting type",
        "resource-booking-chip-filter-select-title-sittings": "Number of seats",
        "resource-booking-chip-filter-select-title-tablesetupids": "Select table arrangements",
        "resource-booking-chip-filter-select-title-deliverytype": "Select delivery type",
        "resource-booking-chip-filter-select-title-mobileav": "Mobile AV equipment",
        "resource-booking-chip-filter-select-title-settables": "Set tables",
        "resource-booking-chip-filter-select-title-cleanup": "Cleanup tables",
        "resource-booking-chip-filter-select-title-resourcetypeids": "Select resource type",
        "resource-booking-chip-filter-select-title-servicecenterids": "Select service centers",
        "resource-booking-chip-filter-select-title-satelliteids": "Select satellites",
        "resource-booking-chip-filter-select-title-meetingduration": "Booking duration",
        "resource-booking-chip-filter-tooltip-resourcetypeids": "Shows only resources of the selected types",
        "resource-booking-chip-filter-tooltip-sittings": "{ $count ->\n [one] Shows rooms with at least { $count } seat\n *[other] Shows rooms with at least { $count } seats\n}",
        "resource-booking-chip-filter-tooltip-servicecenterids": "Shows only resources at the selected service centers",
        "resource-booking-chip-filter-tooltip-floors": "Shows only resources on the selected floors",
        "resource-booking-chip-filter-tooltip-fixedavids": "Shows only rooms with all the selected fixed AV equipment",
        "resource-booking-chip-filter-tooltip-tablesetupids": "Shows only rooms that offer at least one of the selected table arrangements",
        "resource-booking-chip-filter-rooms": "Rooms",
        "resource-booking-chip-filter-equipment": "AV Equipment",
        "resource-booking-chip-filter-cars": "Cars",

        // Resource filter API keys (groups and elements)
        "key_group_1": "Resource types",
        "key_group_2": "Meeting duration",
        "key_group_3": "Meeting time",
        "key_group_4": "Participants",
        "key_group_5": "Extended search",
        "key_1": "Resource types",
        "key_2": "Meeting duration",
        "key_3": "Meeting time",
        "key_4": "Seats",
        "key_5": "Servicecenter",
        "key_6": "Floor",
        "key_7": "Table setups",
        "key_8": "AV-Equipment",

        // Resource details dialog
        "resource-details-dialog-service-center": "Service center",
        "resource-details-dialog-floor": "Floor",
        "resource-details-dialog-description": "Description",
        "resource-details-dialog-empty": "\n .title = No details available\n .description = The details for this resource could not be found.",
        "resource-details-dialog-square-meters": "Square meters",
        "resource-details-dialog-walk-direction":"Walk direction",
        "resource-details-dialog-capacity": "Capacity",
        "resource-details-dialog-capacity-quantity": "{ $quantity } people",
        "resource-details-dialog-table-arrangement": "Table arrangement",


        // Service center > Navigation
        "service-center-top-bar-info-screens-online": "Info screens online",
        "service-center-top-bar-info-screens-offline": "{ $count ->\n [one] { $count } screen offline\n *[other] { $count } screens offline\n}",
        "service-center-nav-item-user-label": "\n .title = Home" ,
        "service-center-nav-item-canteen-label": "\n .title = Upcoming meetings" ,
        "service-center-nav-item-guests-label": "\n .title = Guest list" ,
        "service-center-nav-item-meeting-rooms-label": "\n .title = Meeting rooms" ,
        "service-center-nav-item-settings-label": "\n .title = Administration" ,
        "service-center-nav-bottom-bar-home-label": "Home",
        "service-center-nav-bottom-bar-canteen-label": "Meetings",
        "service-center-nav-bottom-bar-meeting-rooms-label": "Meeting rooms",
        "service-center-nav-bottom-bar-guests-label": "Guests",
        "service-center-nav-bottom-bar-settings-label": "Administration",

        // Service center > Reports > Dashboard
        "service-center-reports-dashboard-check-in-button": "Check-in",
        "service-center-reports-dashboard-checked-id": "Checked in",
        "service-center-reports-dashboard-check-in-guests-button": "Guest check-in",
        "service-center-reports-dashboard-guests-overview-in-house-title": "Guests in house",
        "service-center-reports-dashboard-guests-overview-in-house-unit": "in house",
        "service-center-reports-dashboard-guests-overview-print-guest-list": "Print guest list",
        "service-center-reports-dashboard-guests-overview-export-guest-list": "Export to Excel",
        "service-center-reports-dashboard-guests-overview-chart-title": "Today",
        "service-center-reports-dashboard-guests-overview-chart-empty": "No meetings today",
        "service-center-reports-dashboard-guests-overview-chart-legend-meetings": "Meetings",
        "service-center-reports-dashboard-guests-overview-chart-legend-guests": "Guests",
        "service-center-reports-dashboard-guests-overview-chart-slot-tooltip": "{ $from }–{ $to }: { $meetings } meetings, { $guests } guests",
        "service-center-reports-dashboard-guests-overview-group-label": "Group of { $count }",
        "service-center-reports-dashboard-guests-overview-print-title": "Guests in house · { $date }",
        "service-center-reports-dashboard-guests-overview-print-empty": "No guests in house",
        "service-center-reports-dashboard-guests-overview-csv-name-header": "Name",
        "service-center-reports-dashboard-guests-overview-csv-company-header": "Company",
        "service-center-reports-dashboard-guests-overview-csv-meeting-header": "Meeting",
        "service-center-reports-dashboard-guests-overview-csv-host-header": "Host",
        "service-center-reports-dashboard-guests-overview-csv-room-header": "Room",
        "service-center-reports-dashboard-guests-overview-csv-time-header": "Time",
        "service-center-reports-dashboard-bookings-title": "Bookings",
        "service-center-reports-dashboard-bookings-print-title": "Bookings – { $tab } · { $date }",
        "service-center-reports-dashboard-bookings-tab-room": "Meetings",
        "service-center-reports-dashboard-bookings-tab-car": "Cars",
        "service-center-reports-dashboard-bookings-tab-mobile-av": "AV",
        "service-center-reports-dashboard-bookings-empty-room": "No meetings on this day",
        "service-center-reports-dashboard-bookings-empty-car": "No car bookings on this day",
        "service-center-reports-dashboard-bookings-empty-mobile-av": "No AV bookings on this day",
        "service-center-reports-dashboard-bookings-export-menu-csv": "Export to CSV",
        "service-center-reports-dashboard-meeting-audience-filter-label": "Show meetings",
        "service-center-reports-dashboard-meetings-list-row-audience-internal": "Internal",
        "service-center-reports-dashboard-meetings-list-row-audience-external": "External",
        "service-center-reports-dashboard-meetings-csv-start-header": "Start",
        "service-center-reports-dashboard-meetings-csv-end-header": "End",
        "service-center-reports-dashboard-meetings-csv-title-header": "Title",
        "service-center-reports-dashboard-meetings-csv-type-header": "Type",
        "service-center-reports-dashboard-meetings-csv-host-header": "Host",
        "service-center-reports-dashboard-meetings-csv-company-header": "Company",
        "service-center-reports-dashboard-meetings-csv-location-header": "Room",
        "service-center-reports-dashboard-search-label": "\n .placeholder = Search",
        "service-center-reports-dashboard-meeting-pagination": "Results per page",
        "service-center-reports-dashboard-check-in-title": "Check-in Queue",
        "service-center-reports-dashboard-guest-check-in-title": "Guest check-in",
        "service-center-reports-dashboard-no-guests":"No guests in check-in queue",
        "service-center-reports-dashboard-news-title": "News",
        "service-center-reports-dashboard-no-news":"No news",
        "service-center-reports-dashboard-no-meeting-selected":"No meeting selected",
        "service-center-reports-dashboard-no-meetings":"No upcoming meetings today",

        // Service center > Reports > Upcoming meetings
        "service-center-reports-upcoming-meetings-title": "\n .title = Upcoming meetings",
        "service-center-reports-upcoming-meetings-empty": "\n .title = Nothing scheduled in this period",
        "service-center-reports-upcoming-meetings-period-today": "Today",
        "service-center-reports-upcoming-meetings-period-tomorrow": "Tomorrow",
        "service-center-reports-upcoming-meetings-period-this-week": "This week",
        "service-center-reports-upcoming-meetings-period-next-7-days": "Next 7 days",
        "service-center-reports-upcoming-meetings-period-next-30-days": "Next 30 days",
        "service-center-reports-upcoming-meetings-period-all": "All upcoming",
        "service-center-reports-upcoming-meetings-date-filter-hint-start": "Pick a start date in the calendar",
        "service-center-reports-upcoming-meetings-date-filter-hint-end": "Now pick the end date in the calendar",
        "service-center-reports-upcoming-meetings-date-filter-apply-button": "Apply",
        "service-center-reports-upcoming-meetings-search-input": "\n .placeholder = Search meeting, no. or room",
        "service-center-reports-upcoming-meetings-export-menu-csv": "Export to CSV",
        "service-center-reports-upcoming-meetings-audience-filter-label": "Show",
        "service-center-reports-upcoming-meetings-resource-type-tab-all": "All types",
        "service-center-reports-upcoming-meetings-resource-type-tab-room": "Meeting rooms",
        "service-center-reports-upcoming-meetings-resource-type-tab-mobile-av": "AV",
        "service-center-reports-upcoming-meetings-resource-type-tab-car": "Cars",
        "service-center-reports-upcoming-meetings-row-tag-room": "Room",
        "service-center-reports-upcoming-meetings-row-tag-mobile-av": "AV",
        "service-center-reports-upcoming-meetings-row-tag-car": "Car",
        "service-center-reports-upcoming-meetings-row-tag-meeting-service": "Meeting service",
        "service-center-reports-upcoming-meetings-group-bookings-count": "{ $count ->\n [one] { $count } booking\n *[other] { $count } bookings\n}",
        "service-center-reports-upcoming-meetings-group-orders-count": "{ $count ->\n [one] { $count } order\n *[other] { $count } orders\n}",
        "service-center-reports-upcoming-meetings-csv-date-header": "Date",
        "service-center-reports-upcoming-meetings-csv-number-header": "No.",
        "service-center-reports-upcoming-meetings-csv-start-header": "Start",
        "service-center-reports-upcoming-meetings-csv-end-header": "End",
        "service-center-reports-upcoming-meetings-csv-title-header": "Title",
        "service-center-reports-upcoming-meetings-csv-type-header": "Type",
        "service-center-reports-upcoming-meetings-csv-location-header": "Room/delivery",
        "service-center-reports-upcoming-meetings-csv-price-header": "Price",

        // Service center > Reports > Dashboard > Check in modal
        "service-center-reports-dashboard-check-in-modal-title": "Guest check-in",
        "service-center-reports-dashboard-print-labels-modal-title": "Print guest labels",
        "service-center-reports-dashboard-printing-labels-modal-title": "Printing guest labels",
        "service-center-reports-dashboard-printing-labels-modal-subtitle": "Guest labels to print ({ $amount})",

        "service-center-reports-dashboard-printing-labels-of": "of",
        "service-center-reports-dashboard-printing-labels-cancel": "Cancel",
        "service-center-reports-dashboard-printing-labels-print": "Print",

        // Label printer errors
        "label-printer-error-no-labels": "No labels to print",
        "label-printer-error-cancelled": "Printing cancelled by user",
        "label-printer-error-required-fields": "Please fill in all required fields and ensure group size is at least 1",
        "label-printer-error-failed-guest-label": "Failed to print guest label",
        "label-printer-error-unknown-guest-label": "Unknown error printing guest label",
        "label-printer-error-failed-label-for": "Failed to print label for { $name }",
        "label-printer-error-printing-label-for": "Error printing label for { $name }",
        "label-printer-error-failed-group-labels": "Failed to print group labels",
        "label-printer-error-unknown-group-labels": "Unknown error printing group labels",
        "label-printer-error-failed-takeaway-labels": "Failed to print takeaway labels",
        "label-printer-error-unknown-takeaway-labels": "Unknown error printing takeaway labels",
        "label-printer-error-printer-not-found": "No printer was detected. Please connect the label printer.",
        "label-printer-error-failed-labels-summary": "Could not print { $failed } of { $total } labels",
        "label-printer-success-labels-printed": "Labels printed",
        "label-printer-dialog-not-installed-title": "Printer extension required",
        "label-printer-dialog-install-chrome-button": "Install for Chrome",
        "label-printer-dialog-install-edge-button": "Install for Edge",
        "label-printer-dialog-install-tooltip": "Add the Brother b-PAC extension to your browser.",
        "label-printer-dialog-refresh-after-install": "After installation refresh page by <refreshLink>clicking here</refreshLink> or type F5.",
        "label-printer-dialog-need-help": "Need help?",
        "label-printer-dialog-printer-guide-link": "Printer guide",
        "label-printer-dialog-order-printer-link": "Order a Brother label printer",
        "label-printer-dialog-not-found-title": "No printer detected",
        "label-printer-dialog-not-found-message": "No printer was detected. Did you connect the label printer?",
        "label-printer-dialog-try-again-button": "Try again",

        "service-center-reports-check-in-modal-guest-details": "Guest details",
        "service-center-reports-check-success-title": "Guest checked in",
        "service-center-reports-check-group-success-title": "Group checked in",
        "service-center-reports-check-in-modal-guest-name-min": "Guest name must be at least { $min } characters",
        "service-center-reports-check-in-modal-guest-name-max": "Guest name must be at most { $max } characters",
        "service-center-reports-check-in-modal-guest-company-max": "Guest company must be at most { $max } characters",
        "service-center-reports-check-in-modal-number-of-guests-min": "Number of guests must be at least { $min }",
        "service-center-reports-check-in-modal-number-of-guests-max": "Number of guests must be at most { $max }",
        "service-center-reports-check-in-modal-message-max": "Message must be at most { $max } characters",
        "service-center-reports-check-in-modal-single": "Single",
        "service-center-reports-check-in-modal-group": "Group",
        "service-center-reports-check-in-modal-host-name": "\n .label = Host name",
        "service-center-reports-check-in-modal-host-company": "\n .label = Host company",
        "service-center-reports-check-in-modal-guest-name": "\n .label = Guest name",
        "service-center-reports-check-in-modal-number-of-guests": "\n .label = Number of guests",
        "service-center-reports-check-in-modal-guest-company": "\n .label = Guest company",
        "service-center-reports-check-in-modal-guests-company": "\n .label = Group name",
        "service-center-reports-check-in-modal-print-guest-card": "\n .label = Print guest card",
        "service-center-reports-check-in-modal-send-host-notification": "\n .label = Notify host",
        "service-center-reports-check-in-modal-send-host-notification-tooltip": "\n .title = Host will receive notification that the guest has been checked in.",
        "service-center-reports-check-in-modal-write-message-to-host": "\n .label = Write a message to host",
        "service-center-reports-check-in-modal-settings": "Settings",
        "service-center-reports-check-in-modal-check-in-button": "Check-in",
        "service-center-reports-check-in-modal-guest-check-in-title": "Guest check-in",
        "service-center-reports-check-in-modal-guest-check-in-subtitle": "Guests to check in ({ $amount})",


        "service-center-check-in-error-generic": "An error occurred while checking in the guest. Please try again.",
        "service-center-check-in-error-not-found": "The guest or host could not be found. Please verify the details and try again.",
        "service-center-check-in-error-invalid-data": "Invalid check-in data. Please verify the details and try again.",
        "service-center-check-in-print-failed-snackbar": "Guest checked in, but the guest card could not be printed.",
        "service-center-check-in-host-contact-link": "Show host contact details",

        // Service center > Reports > Dashboard > Meetings drawer
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-title": "Host contact details",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-name": "Name:",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-company-name": "Company: ",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-department-name": "Department: ",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-email": "E-mail: ",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-business-phone": "Phone number: ",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-mobile-phone": "Mobile number: ",
        "service-center-reports-dashboard-meetings-drawer-meeting-time": "Meeting time: ",
        "service-center-reports-dashboard-meetings-drawer-host": "Host: ",
        "service-center-reports-dashboard-meetings-drawer-host-company": "Company: ",
        "service-center-reports-dashboard-meetings-drawer-location": "Location: ",
        "service-center-reports-dashboard-meetings-drawer-select-all": "\n .label = Select all",
        "service-center-reports-dashboard-meetings-drawer-guests-title": "Guests",
        "service-center-reports-dashboard-meetings-drawer-guests-empty": "No participants registered.",
        "service-center-reports-dashboard-meetings-drawer-guests-list-checked-title": "\n .title = Checked in",
        "service-center-reports-dashboard-meetings-drawer-guests-list-not-checked-title": "\n .title = Not checked in",
        "service-center-reports-dashboard-meetings-drawer-guests-list-floating-check-action": "\n .title = Check in",
        "service-center-reports-dashboard-meetings-drawer-guests-list-floating-check-out-action": "\n .title = Check out",
        "service-center-reports-dashboard-meetings-drawer-check-out-done": "\n .title = Done",
        "service-center-reports-dashboard-meetings-drawer-check-out-success": "Guests checked out",
        "service-center-reports-dashboard-meetings-drawer-guests-list-floating-print-guest-action": "Print guest labels",
        "service-center-reports-dashboard-meetings-drawer-guests-list-floating-other-action":"\n .title = Other",
        "service-center-reports-dashboard-meetings-drawer-selected-guests": "Selected guests",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-dropdown-item-manage-meeting-display": "Update meeting display",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-name-field-required-error": "Name is required",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-success-message": "Successfully updated meeting display",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-title": "Manage meeting on displays",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-meeting-name-label": "\n .label = New meeting name on displays \n .placeholder = Enter new meeting name",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-switch-label": "Show as canceled",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-show-on-screens-switch-label": "Show on screens",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-submit-button": "Save",
        "service-center-reports-dashboard-meetings-list-row-shown-on-displays-tooltip": "\n .title = Shown on meeting displays",
        "service-center-reports-dashboard-meetings-list-row-arrivals-tooltip": "\n .title = Checked in",

        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-alert-change-name-label": "Change meeting name:",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-alert-change-name-description": " If the meeting name is not appropriate for display on meeting displays, you can edit it here. This modification will only affect the name shown on the displays.",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-alert-cancel-meeting-label": "Cancel meeting:",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-alert-cancel-meeting-description": " If you need to cancel a meeting while keeping it visible, you can simply mark it as canceled.",

        // Service center > Reports > Dashboard > Statistics
        "service-center-reports-statistics-page-header": "\n .title = Statistics",
        "service-center-reports-statistics-occupancy-tab-title": "Occupancy",
        "service-center-reports-statistic-occupancy-table-date-range-filter": "\n .label = Date range",
        "service-center-reports-statistic-occupancy-table-resource-title": "Resource",
        "service-center-reports-statistic-occupancy-table-occupancy-rate-title": "Occupancy rate",
        "service-center-reports-statistic-occupancy-table-status-title": "Status",
        "service-center-reports-occupancy-dashboard-chart-title": "Occupancy by resource",
        "service-center-reports-occupancy-dashboard-hero-overall-occupancy-label": "Overall occupancy",
        "service-center-reports-occupancy-dashboard-hero-resources-tracked-label": "Resources tracked",
        "service-center-reports-occupancy-dashboard-chart-empty": "No occupancy data for this period.",
        "service-center-reports-occupancy-dashboard-empty": "No resources found for this service center.",

        "service-center-reports-statistics-cancellations-tab-title": "Cancellations",
        "service-center-reports-statistic-cancellations-table-cancellation-rate-title": "Cancellation rate",

        "service-center-reports-statistics-booking-duration-tab-title": "Booking duration",
        "service-center-reports-statistic-booking-duration-table-number-of-bookings-title": "Bookings amount",
        "service-center-reports-statistic-booking-duration-table-average-duration-title":  "Avg. duration",
        "service-center-reports-bookings-dashboard-chart-title": "Average duration by resource",
        "service-center-reports-bookings-dashboard-hero-total-bookings-label": "Total bookings",
        "service-center-reports-bookings-dashboard-hero-average-duration-label": "Average booking duration",
        "service-center-reports-bookings-dashboard-chart-empty": "No bookings for this period.",
        "service-center-reports-bookings-dashboard-empty": "No resources found for this service center.",

        "service-center-reports-statistics-guests-tab-title": "Guests",
        "service-center-reports-statistic-guests-table-date-title": "Date",
        "service-center-reports-statistic-guests-table-guests-title": "Guests",

        "service-center-reports-statistics-peak-hours-tab-title": "Peak hours",
        "service-center-reports-statistics-peak-hours-heat-map-title": "Peak hours",

        "service-center-reports-statistics-customer-usage-tab-title": "Tenant usage",

        // Service center > Statistics > Tenant usage (redesign)
        "service-center-usage-per-tenant-header-title": "Usage by tenant",
        "service-center-usage-per-tenant-header-subtitle": "How each tenant draws on shared resources across your service center.",
        "service-center-usage-per-tenant-filter-date-range": "\n .label = Date range",
        "service-center-usage-per-tenant-filter-tenant-label": "\n .label = Tenant",
        "service-center-usage-per-tenant-resource-type-all": "All types",
        "service-center-usage-per-tenant-tenant-all": "All tenants",
        "service-center-usage-per-tenant-summary-center-caption": "booked in period",
        "service-center-usage-per-tenant-summary-hours": "{ $hours }h",
        "service-center-usage-per-tenant-summary-resources-tracked": "Resources tracked",
        "service-center-usage-per-tenant-summary-tenants-active": "Tenants active",
        "service-center-usage-per-tenant-summary-legend-other": "Other ({ $count } tenants)",
        "service-center-usage-per-tenant-detail-other-tenants": "{ $count } other tenants",
        "service-center-usage-per-tenant-section-title-room": "Meeting rooms",
        "service-center-usage-per-tenant-section-title-mobile-av": "AV equipment",
        "service-center-usage-per-tenant-section-title-car": "Cars",
        "service-center-usage-per-tenant-section-title-unknown": "Other resources",
        "service-center-usage-per-tenant-empty-resources": "No resource usage for the selected filters.",
        "service-center-usage-per-tenant-empty-tenants": "No tenant activity for the selected filters.",

        // Service center > Reports > Meeting rooms
        "service-center-meeting-rooms-page-header": "\n .title = Meeting room occupancy",
        "service-center-meeting-rooms-status-filter-all": "All",
        "service-center-meeting-rooms-status-filter-booked": "Booked",
        "service-center-meeting-rooms-status-filter-available": "Available",
        "service-center-meeting-rooms-floor-filter-all": "All floors",
        "service-center-meeting-rooms-search-input": "\n .placeholder = Search room or organizer",
        "service-center-meeting-rooms-occupancy-by-hour-title": "Occupancy today",
        "service-center-meeting-rooms-occupancy-by-day-title": "Occupancy",
        "service-center-meeting-rooms-table-room-header": "Room",
        "service-center-meeting-rooms-table-booking-header": "Booking",
        "service-center-meeting-rooms-table-time-header": "Time",
        "service-center-meeting-rooms-table-status-header": "Status",
        "service-center-meeting-rooms-table-room-seats": "{ $floor } · { $seats ->\n [one] { $seats } seat\n *[other] { $seats } seats\n}",
        "service-center-meeting-rooms-table-no-booking": "No booking",
        "service-center-meeting-rooms-table-occupied-without-booking": "Occupied, no details",
        "service-center-meeting-rooms-table-footer-count": "Showing { $shown } of { $total } rooms",
        "service-center-meeting-rooms-table-free-until": "Available until { $time }",
        "service-center-meeting-rooms-table-free-rest-of-day": "Available for the rest of the day",
        "service-center-meeting-rooms-view-status": "Status",
        "service-center-meeting-rooms-view-by-hour": "By hour",
        "service-center-meeting-rooms-view-by-room": "By room",
        "service-center-meeting-rooms-previous-day-button": "\n .aria-label = Previous day",
        "service-center-meeting-rooms-next-day-button": "\n .aria-label = Next day",
        "service-center-meeting-rooms-print-button": "\n .title = Print\n .aria-label = Print",
        "service-center-meeting-rooms-occupancy-peak-button": "Busiest { $hour } · { $peak } of { $total } rooms booked <action>Show</action>",
        "service-center-meeting-rooms-occupancy-hide-chart-button": "Hide chart",
        "service-center-meeting-rooms-occupancy-show-chart-button": "Show chart",
        "service-center-meeting-rooms-occupancy-hint": "Click an hour to filter",
        "service-center-meeting-rooms-occupancy-peak-tooltip": "\n .title = Show { $hour } in the table",
        "service-center-meeting-rooms-status-live-tooltip": "\n .title = Meeting in progress now: { $meeting } ({ $time })",
        "service-center-meeting-rooms-occupancy-now-badge": "Now",
        "service-center-meeting-rooms-booking-state-in-progress": "In progress",
        "service-center-meeting-rooms-booking-state-finished": "Finished",
        "service-center-meeting-rooms-booking-state-upcoming": "Upcoming",
        "service-center-meeting-rooms-group-hour-meta": "{ $count } of { $total } rooms",
        "service-center-meeting-rooms-group-hour-empty": "No bookings in this hour",
        "service-center-meeting-rooms-group-room-empty": "No bookings today",
        "service-center-meeting-rooms-drawer-room-section": "About the room",
        "service-center-meeting-rooms-drawer-equipment-label": "Equipment",
        "service-center-meeting-rooms-drawer-department-label": "Department",
        "service-center-meeting-rooms-drawer-phone-label": "Phone",
        "service-center-meeting-rooms-drawer-email-label": "E-mail",
        "service-center-meeting-rooms-drawer-receipt-button": "View receipt",
        "service-center-meeting-rooms-drawer-status-occupied": "Occupied until { $time }",
        "service-center-meeting-rooms-drawer-status-occupied-next": "Occupied until { $time } · next { $nextTime } { $meeting }",
        "service-center-meeting-rooms-drawer-status-free-next": "Available now · next { $nextTime } { $meeting }",
        "service-center-meeting-rooms-drawer-status-free-rest-of-day": "Available for the rest of the day",
        "service-center-meeting-rooms-drawer-floor-label": "Floor",
        "service-center-meeting-rooms-drawer-capacity-label": "Capacity",
        "service-center-meeting-rooms-drawer-capacity-value": "{ $seats ->\n [one] { $seats } person\n *[other] { $seats } people\n}",
        "service-center-meeting-rooms-drawer-booking-id-label": "Booking ID",
        "service-center-meeting-rooms-drawer-owner-subheading": "Meeting owner",
        "service-center-meeting-rooms-drawer-name-label": "Name",
        "service-center-meeting-rooms-drawer-activity-section": "Activity",
        "service-center-meeting-rooms-drawer-activity-status-label": "Status { $time }",
        "service-center-meeting-rooms-drawer-activity-status-in-use": "In use",
        "service-center-meeting-rooms-drawer-activity-status-free": "Available",
        "service-center-meeting-rooms-drawer-next-booking-label": "Next booking",
        "service-center-meeting-rooms-drawer-next-booking-none": "None today",
        "service-center-meeting-rooms-drawer-next-booking-value": "{ $time } · { $meeting }",
        "service-center-meeting-rooms-drawer-bookings-today-label": "Bookings today",
        "service-center-meeting-rooms-drawer-bookings-today-value": "{ $count ->\n [one] { $count } booking\n *[other] { $count } bookings\n}",
        "service-center-meeting-rooms-drawer-timeline-hint-from-now": "{ $count ->\n [one] { $count } booking\n *[other] { $count } bookings\n} · From now on · select a meeting for details",
        "service-center-meeting-rooms-drawer-timeline-hint-whole-day": "{ $count ->\n [one] { $count } booking\n *[other] { $count } bookings\n} · Whole day · select a meeting for details",
        "service-center-meeting-rooms-drawer-timeline-title": "Today's schedule",
        "service-center-meeting-rooms-drawer-timeline-mode-from-now": "From now",
        "service-center-meeting-rooms-drawer-timeline-mode-whole-day": "Whole day",
        "service-center-meeting-rooms-drawer-timeline-free": "Available",
        "service-center-meeting-rooms-drawer-timeline-occupied": "Occupied",
        "service-center-meeting-rooms-table-free-from": "Available from { $time }",
        "service-center-meeting-rooms-table-free-between": "Available { $timeRange }",
        "service-center-meeting-rooms-table-free-later": "then { $windows }{ $hidden ->\n [0] {\"\"}\n *[other] {\" \"}+{ $hidden }\n}",
        "service-center-meeting-rooms-table-booked-rest-of-day": "Booked for the rest of the day",
        "service-center-meeting-rooms-table-no-free-time-today": "No available time today",
        "service-center-meeting-rooms-table-action-view-details": "View details",
        "service-center-meeting-rooms-table-action-book": "Book { $hour }",
        "service-center-meeting-rooms-status-booked": "Booked { $hour }",
        "service-center-meeting-rooms-status-available": "Available { $hour }",
        "service-center-meeting-rooms-status-not-checked-in": "Not checked in",
        "service-center-meeting-rooms-status-out-of-service": "Out of service",
        "service-center-meeting-rooms-reset-filters-button": "Reset",
        "service-center-meeting-rooms-group-hour-free-label": "Available",
        "service-center-meeting-rooms-group-hour-free-seats": "{ $seats ->\n [one] { $seats } seat\n *[other] { $seats } seats\n}",
        "service-center-meeting-rooms-group-hour-free-empty": "No available rooms",
        "service-center-meeting-rooms-group-room-column-room": "Room",
        "service-center-meeting-rooms-group-room-column-time": "Time",
        "service-center-meeting-rooms-group-room-column-meeting": "Meeting",
        "service-center-meeting-rooms-group-room-column-duration": "Duration",
        "service-center-meeting-rooms-group-room-column-attendees": "Attendees",
        "service-center-meeting-rooms-occupancy-hour-tooltip": "\n .title = { $hour }: { $booked } of { $total } rooms booked",
        "service-center-meeting-rooms-occupancy-hour-tooltip-jump-to-now": "\n .title = { $hour }: { $booked } of { $total } rooms booked · click to jump to now",
        "service-center-meeting-rooms-table-no-match": "No rooms match the filters — reset status, floor or search.",
        "service-center-meeting-rooms-table-footer-no-match": "No rooms match the filters",
        "service-center-meeting-rooms-booking-participants": "{ $participants ->\n [one] { $participants } person\n *[other] { $participants } people\n}",
        "service-center-meeting-rooms-booking-participants-of-seats": "{ $participants } of { $seats ->\n [one] { $seats } seat\n *[other] { $seats } seats\n}",
        "service-center-meeting-rooms-booking-catering-chip": "Catering",
        "service-center-meeting-rooms-booking-over-capacity-chip": "Over capacity",
        "service-center-meeting-rooms-drawer-participants-label": "Participants",
        "service-center-meeting-rooms-drawer-table-setup-label": "Table setup",
        "service-center-meeting-rooms-drawer-catering-label": "Catering",
        "service-center-meeting-rooms-drawer-catering-ordered": "Ordered",
        "service-center-meeting-rooms-drawer-catering-not-ordered": "Not ordered",

        // Service center > Reports > Dashboard > Guests
        "service-center-reports-dashboard-guests-page-header": "\n .title = Guests",
        "service-center-reports-dashboard-guests-table-guest-title": "Guest",
        "service-center-reports-dashboard-guests-table-host-title": "Host",
        "service-center-reports-dashboard-guests-table-check-in-time-title": "Check-in",
        "service-center-reports-dashboard-guests-table-check-in-time-tooltip": "Meeting start",
        "service-center-reports-dashboard-guests-table-check-out-time-title": "Checkout",
        "service-center-reports-dashboard-guests-table-host-company-title": "Host company",
        "service-center-reports-dashboard-guests-table-host-company-status": "Status",
        "service-center-reports-dashboard-guests-table-host-company-status-checked-in": "Checked in",
        "service-center-reports-dashboard-guests-table-host-company-status-checked-out": "Checked out",
        "service-center-reports-dashboard-guests-table-host-company-status-expected": "Expected",
        "service-center-reports-dashboard-guests-table-host-company-status-pending": "Pending",
        "service-center-reports-dashboard-guests-table-host-company-status-checked-in-hover-tooltip": "The guest has been checked in.",
        "service-center-reports-dashboard-guests-table-host-company-status-checked-out-hover-tooltip": "The guest has been checked out.",
        "service-center-reports-dashboard-guests-table-host-company-status-expected-hover-tooltip": "The guest has been invited but has not checked in yet.",
        "service-center-reports-dashboard-guests-table-host-company-status-pending-hover-tooltip": "The guest has completed self-check-in; however, the reception team should extend a warm welcome and provide a guest card.",
        "service-center-reports-dashboard-guests-table-floating-action-bar-guest-card": "\n .title = Guest card",
        "service-center-reports-dashboard-guests-table-date-range-filter": "\n .label = Meeting period",


        // Service center > Admin > Organization > DEVICES
        "service-center-admin-organization-devices-title": "\n .title = Devices",
        "service-center-admin-organization-devices-button-title": "Create Device",

        // Service center > Admin > Organization > Resources
        "service-center-admin-organization-resources-title": "\n .title = Resources",
        "service-center-admin-organization-resources-create-button": "Create new",
        "service-center-admin-organization-resources-rooms-tab": "Rooms",
        "service-center-admin-organization-resources-mobile-av-equipment-tab": "AV equipment",
        "service-center-admin-organization-resources-cars-tab": "Cars",
        "service-center-admin-organization-resources-table-header-name": "Name",
        "service-center-admin-organization-resources-table-room-header-id": "Room no",
        "service-center-admin-organization-resources-table-mobile-av-header-id": "Serial no",
        "service-center-admin-organization-resources-table-cars-header-id": "Reg no",
        "service-center-admin-organization-resources-table-header-status": "Status",
        "service-center-admin-organization-resources-table-edit-item": "Edit",
        "service-center-admin-organization-resources-table-delete-item": "Delete",
        "service-center-admin-organization-resources-table-room-delete-modal-title": "room",
        "service-center-admin-organization-resources-table-mobile-av-equipment-delete-modal-title": "mobile AV equipment",
        "service-center-admin-organization-resources-table-car-delete-modal-title": "car",

        "service-center-admin-organization-resources-create-room": "Room",
        "service-center-admin-organization-resources-create-car": "Car",
        "service-center-admin-organization-resources-status-not-approved": "Not approved",
        "service-center-admin-organization-resources-status-approved": "Approved",
        "service-center-admin-organization-resources-status-rejected": "Rejected",
        "service-center-admin-organization-resources-status-locked": "Locked",
        "service-center-admin-organization-resources-status-preparing": "Preparing",
        "service-center-admin-organization-resources-status-delivered": "Delivered",
        "service-center-admin-organization-resources-status-to-be-booked": "To be booked",
        "service-center-admin-organization-resources-status-booked": "Booked",
        "service-center-admin-organization-resources-status-completed": "Completed",

        "service-center-admin-organization-resources-status-menu-not-approved": "Unapprove",
        "service-center-admin-organization-resources-status-menu-approved": "Approve",
        "service-center-admin-organization-resources-status-menu-rejected": "Reject",
        "service-center-admin-organization-resources-status-menu-locked": "Lock",
        "service-center-admin-organization-resources-status-menu-preparing": "Preparing",
        "service-center-admin-organization-resources-status-menu-delivered": "Delivered",
        "service-center-admin-organization-resources-status-menu-booked": "Book",
        "service-center-admin-organization-resources-status-menu-ready": "Ready",
        "service-center-admin-organization-resources-status-menu-completed": "Complete",
        "service-center-admin-organization-resources-status-menu-default": "No status",

        // Service center > Admin > Organization > Resources > Create Mobile AV
        "service-center-admin-organization-resources-create-mobile-av-title": "\n .title = Create Mobile AV",
        "service-center-admin-organization-resources-update-mobile-av-title": "\n .title = Update Mobile AV",
        "resources-create-edit-mobile-av-general-tab-error": "General tab has validation error",

        // Service center > Admin > Organization > Resources > Create car
        "service-center-admin-organization-resources-create-car-title": "\n .title = Create car",
        "service-center-admin-organization-resources-update-car-title": "\n .title = Update car",
        "resources-create-edit-car-general-tab-error": "General tab has validation error",

        // Service center > Admin > Organization > Resources > Create car > General
        "resources-create-edit-car-general-tab-general": "General",
        "resources-create-car-tab-general-registration-number-label": "\n .label = Registration number",
        "resources-create-car-tab-general-name-label": "\n .label = Name",
        "resources-create-car-tab-general-description-label": "\n .label = Description",
        "resources-create-car-tab-general-car-type-label": "\n .label = Car type",
        "resources-create-car-tab-general-location-of-keys-label": "\n .label = Location of keys",
        "resources-create-car-tab-general-parking-location-label": "\n .label = Parking location",
        "resources-create-car-tab-general-active-label": "Active:",
        "resources-create-car-tab-general-in-service-label": "In service:",
        "resources-create-car-tab-general-side-settings": "\n .title = Settings",

        // Service center > Admin > Organization > Resources > Create Mobile AV > General
        "resources-create-edit-mobile-av-general-tab-general": "General",
        "resources-create-mobile-av-tab-general-serial-number-label": "\n .label = Serial number",
        "resources-create-mobile-av-tab-general-name-label": "\n .label = Name",
        "resources-create-mobile-av-tab-general-floor-label": "\n .label = Floor",
        "resources-create-mobile-av-tab-general-description-label": "\n .label = Description",
        "resources-create-mobile-av-tab-general-storage-location-label": "\n .label = Storage location",
        "resources-create-mobile-av-tab-general-cleanup-buffer-label": "\n .label = Cleanup buffer",
        "resources-create-mobile-av-tab-general-color-code-label": "\n .label = Color code",
        "resources-create-mobile-av-tab-general-active-label": "Active:",
        "resources-create-mobile-av-tab-general-side-settings": "\n .title = Settings",


        // Service center > Admin > Organization > Resources > Create room
        "service-center-admin-organization-resources-create-room-title": "\n .title = Create room",
        "resources-create-edit-room-general-tab-error": "General tab has validation error",

        // Service center > Admin > Organization > Resources > Create room > General
        "resources-create-edit-room-general-tab-general": "General",
        "resources-create-room-tab-general-room-number-label": "\n .label = Room number",
        "resources-create-room-tab-general-name-label": "\n .label = Name",
        "resources-create-room-tab-general-description-label": "\n .label = Description",
        "resources-create-room-tab-general-seats-label": "\n .label = Seats",
        "resources-create-room-tab-general-active-label": "Active:",
        "resources-create-room-tab-general-other-location-label": "Other location:",
        "resources-create-room-tab-general-other-location-description": `\n .title = Marking a room as "Other location" will allow the user to type an ad-hoc location to hold the meeting such as their office.`,
        "resources-create-room-tab-general-side-settings": "\n .title = Settings",
        "resources-create-room-tab-general-floor-label": "\n .label = Floor",
        "resources-create-room-tab-general-walk-direction-label": "\n .label = Walk direction",
        "resources-create-room-tab-general-walk-direction-north": "North",
        "resources-create-room-tab-general-walk-direction-east": "East",
        "resources-create-room-tab-general-walk-direction-south": "South",
        "resources-create-room-tab-general-walk-direction-west": "West",
        "resources-create-room-tab-general-color-red": "Red",
        "resources-create-room-tab-general-color-green": "Green",
        "resources-create-room-tab-general-color-blue": "Blue",
        "resources-create-room-tab-general-color-black": "Black",
        "resources-create-room-tab-general-color-lightblue": "Light blue",
        "resources-create-room-tab-general-tags-label":  "\n .label = Tags",
        "resources-create-room-tab-general-tags-info-description":  `\n .label = Create one or more tags to be used for filtering resources. For example "External meeting room", "Guest meeting room", "Conference room", "Call room" etc.`,
        "resources-create-room-tab-general-fixed-av-equipment-label":  "\n .label = Fixed AV equipment",
        "resources-create-room-tab-general-side-filter-details": "\n .title = Filter details",
        "resources-create-room-tab-general-area-label": "\n .label = Area (sqm) \n .placeholder = Area of room in sqm",
        "resources-create-room-tab-general-cleanup-buffer-label": "\n .label = Cleanup buffer",
        "resources-create-room-tab-general-color-code-label": "\n .label = Color code",
        "resources-create-room-tab-general-email-address-label": "\n .label = Email address",
        "resources-create-room-tab-general-side-integrations": "\n .title = Calendar integration",
        "resources-create-room-tab-general-side-integrations-meeting-invite": "\n .description = Used for integrating with Exchange or other calendar systems. The email address will be added to the meeting invitation by FacilityNet Outlook Add-in when booking the room.",
        "resources-create-room-tab-general-side-integrations-starleaf": "\n .description =Used for integrating with StarLeaf equipment that come with a dedicated email address used for integration.",
        "resources-create-room-tab-general-side-integrations-ews": "\n .description = Used for integrating with equipment that reads from a calendar. The calendar of the mailbox will be booked using an EWS service account when booking the room.",

        "resources-create-room-tab-general-book-using-ews": "Book using EWS",

        // Service center > Admin > Organization > Resources > Create room > Table arrangements
        "resources-create-edit-room-general-tab-table-arrangements": "Table arrangements",
        "service-center-reports-dashboard-meeting-filter-mobile-av": "Mobile AV equipment",
        "service-center-reports-dashboard-meeting-filter-set-tables": "Set tables",
        "service-center-reports-dashboard-meeting-filter-cleanup": "Cleanup tables",
        "tab-table-arrangements-standard": "Standard",
        "tab-table-arrangements-optional-chip": "Optional",
        "tab-table-arrangements-make-standard-button": "Make standard",
        "tab-table-arrangements-add-new-card": "Add new table setting",
        "tab-table-arrangements-label-meeting-room": "Meeting room",
        "tab-table-arrangements-label-cinema": "Cinema",
        "tab-table-arrangements-label-u-form": "U-form",
        "tab-table-arrangements-label-school": "School",
        "tab-table-arrangements-label-group": "Group",
        "tab-table-arrangements-label-negotiation": "Negotiation",
        "tab-table-arrangements-label-cafe": "Cafe",
        "tab-table-arrangements-label-conference": "Conference",
        "tab-table-arrangements-label-herringbone": "Herringbone",
        "tab-table-arrangements-create-dialog-title": "New table setting",
        "tab-table-arrangements-create-dialog-name-label": "\n .label = Name",
        "tab-table-arrangements-create-dialog-image-label": "Image",
        "tab-table-arrangements-create-dialog-submit-button": "Create",
        "tab-table-arrangements-create-dialog-name-required-error": "Name is required",
        "tab-table-arrangements-create-dialog-image-required-error": "Image is required",

        // Service center > Admin > Organization > Resources > Create room > Notifiations
        "resources-create-edit-room-general-tab-table-header-type": "Type",
        "resources-create-edit-room-general-tab-table-header-sent": "Sent",
        "resources-create-edit-room-general-tab-table-header-content": "Content",

        // Service center > Admin > Organization > Resources > Create room > Availability
        "resources-create-edit-room-general-tab-availability": "Availability",
        "tab-availability-closed-periods-title": "Unavailable period",
        "tab-availability-table-start-header": "Start",
        "tab-availability-table-end-header": "End",
        "tab-availability-table-reason-header": "Reason",
        "tab-availability-table-edit-action": "Edit",
        "tab-availability-table-delete-action": "Delete",
        "tab-availability-add-closed-period-action": "Add unavailable period",
        "tab-availability-side-daily-closing-times-title": "\n .title = Daily closing times",
        "tab-availability-side-daily-booking-times-title": "\n .title = Daily booking hours",
        "tab-availability-booking-time-option-all-day": "\n .label = Available all day",
        "tab-availability-booking-time-option-specific-hours": "\n .label = Only available during specific hours",
        "tab-availability-booking-time-option-daily-break": "\n .label = Unavailable during a daily break",
        "tab-availability-booking-time-from-label": "\n .label = From",
        "tab-availability-booking-time-to-label": "\n .label = To",
        "tab-availability-side-start-time-label": "\n .label = Start time",
        "tab-availability-side-end-time-label": "\n .label = End time",
        "tab-availability-modal-reason-label": "\n .label = Reason",
        "tab-availability-modal-reason-max": "Reason must be at most { $max } characters",
        "tab-availability-modal-title": "Add closed period",
        "tab-availability-modal-add-button": "Add",

        "tab-availability-add-reminder-dialog-title": "Add reminder",
        "tab-availability-add-reminder-edit-dialog-title": "Edit reminder",
        "tab-availability-add-reminder-dialog-field-type-label": "\n .label = Type",
        "tab-availability-add-reminder-dialog-field-time-label": "\n .label = Sent",
        "tab-availability-add-reminder-dialog-field-text-label": "\n .label = Text",
        "tab-availability-add-reminder-dialog-text-max": "Text must be at most { $max } characters",
        "tab-availability-add-reminder-dialog-submit-button-label": "Add",

        "tab-availability-add-reminder-dialog-form-time-suffix-hours-before": "hours before meeting start",
        "tab-availability-add-reminder-dialog-form-time-suffix-minutes-before": "minutes before meeting start",
        "tab-availability-add-reminder-dialog-form-time-suffix-hours-after": "hours after meeting end",
        "tab-availability-add-reminder-dialog-form-time-suffix-minutes-after": "minutes after meeting end",

        "reminder-type-option-meeting-start": "Meeting start reminder",
        "reminder-type-option-first-reminder": "First  reminder",
        "reminder-type-option-preparation": "Preparation",
        "reminder-type-option-cleanup": "Cleanup",
        "reminder-type-option-custom-reminder": "Custom reminder",
        "reminder-type-option-meeting-confirmation": "Meeting confirmation",

        "integration-type-option-none": "None",
        "integration-type-option-meeting-invite": "Meeting Invite",
        "integration-type-option-ews": "EWS",
        "integration-type-option-starleaf": "Starleaf",

        // Service center > Admin > Organization > Resources > Create room > Access control
        "resources-create-edit-room-general-tab-access-control": "Access control",
        "tab-access-control-restricted-access-title": "\n .title =Restricted access",
        "tab-access-control-visible-everyone-switch":'Visible for everyone',
        "tab-access-control-reserved-for-company-title":"Reserved for company:",
        "tab-access-control-bookable-by-departments-title":"Bookable by departments:",
        "tab-access-control-select-department-select-item":"Select a department",
        "tab-access-control-add-button":"Add",


        // Service center > Admin > Account > Admins
        "service-center-admin-account-admins-page-header": "\n .title = Administrators",
        "service-center-admin-account-admins-table-header-name":"Name",
        "service-center-admin-account-admins-table-header-email":"Email",
        "service-center-admin-account-admins-table-header-status":"Status",
        "service-center-admin-account-admins-table-status-active":"Active",
        "service-center-admin-account-admins-table-status-inactive": "Inactive",
        "service-center-admin-account-admins-table-button-details": "Show details",
        "service-center-admin-account-admins-table-button-edit": "Edit user",
        "service-center-admin-account-admins-table-button-delete": "Delete user",
        "service-center-admin-account-admins-delete-dialog-entity-type": "user",
        "service-center-admin-account-admins-button-create": "Create new",

        // Service center > Admin > Organization > Manage bookings
        "service-center-admin-organization-manage-bookings-page-header": "\n .title = Administrate orders",
        "service-center-admin-organization-manage-bookings-breadcrumb": "Administrate orders",
        "service-center-admin-organization-manage-bookings-confirm-button": "Continue",
        "service-center-admin-organization-manage-bookings-action-move": "Move to new owner",
        "service-center-admin-organization-manage-bookings-action-delete": "Delete",
        "service-center-admin-organization-manage-bookings-select-action": "\n .label = Select action:",
        "service-center-admin-organization-manage-bookings-select-action-placeholder": "Select",
        "service-center-admin-organization-manage-bookings-select-company": "\n .label = Select company:",
        "service-center-admin-organization-manage-bookings-select-user": "\n .label = Select user:",
        "service-center-admin-organization-manage-bookings-select-new-owner": "\n .label = Select new owner:",
        "service-center-admin-organization-manage-bookings-what-to-move-label": "What to move:",
        "service-center-admin-organization-manage-bookings-what-to-delete-label": "What to delete:",
        "service-center-admin-organization-manage-bookings-current-owner-title": "Current owner",
        "service-center-admin-organization-manage-bookings-new-owner-title": "New owner",
        "service-center-admin-organization-manage-bookings-checkbox-bookings": "Bookings",
        "service-center-admin-organization-manage-bookings-checkbox-meeting-service": "Meeting service orders",
        "service-center-admin-organization-manage-bookings-error-company-required": "Company is required",
        "service-center-admin-organization-manage-bookings-error-user-required": "User is required",
        "service-center-admin-organization-manage-bookings-error-action-required": "Action is required",
        "service-center-admin-organization-manage-bookings-error-new-owner-required": "New booking owner is required",
        "service-center-admin-organization-manage-bookings-error-at-least-one-option": "Select at least one option",
        "service-center-admin-organization-manage-bookings-alert-move": "\n .title = Orders will be moved to a new owner, which you select below.",
        "service-center-admin-organization-manage-bookings-alert-delete": "\n .title = All future bookings for this user will be canceled.",
        "service-center-admin-organization-manage-bookings-confirm-modal-move-title": "Move orders",
        "service-center-admin-organization-manage-bookings-confirm-modal-delete-title": "Delete orders",
        "service-center-admin-organization-manage-bookings-confirm-modal-move-message": "Please confirm that you want to move { $count } orders.",
        "service-center-admin-organization-manage-bookings-confirm-modal-delete-message": "Please confirm that you want to delete { $count } orders.",
        "service-center-admin-organization-manage-bookings-confirm-modal-move-no-orders": "There are no orders to move.",
        "service-center-admin-organization-manage-bookings-confirm-modal-delete-no-orders": "There are no orders to delete.",
        "service-center-admin-organization-manage-bookings-confirm-modal-from": "From: { $name }",
        "service-center-admin-organization-manage-bookings-confirm-modal-user": "User: { $name }",
        "service-center-admin-organization-manage-bookings-confirm-modal-to": "To: { $name }",
        "service-center-admin-organization-manage-bookings-confirm-modal-user-id-tooltip": "\n .title = Internal user ID",
        "service-center-admin-organization-manage-bookings-confirm-modal-submit-button": "Confirm",
        "service-center-admin-organization-manage-bookings-confirm-modal-cancel-button": "Cancel",
        "service-center-admin-organization-manage-bookings-confirm-modal-close-button": "Close",
        "service-center-admin-organization-manage-bookings-confirm-modal-excluded-orders": "\n .title = { $count } orders excluded: { $reason }",
        "service-center-admin-organization-manage-bookings-success-modal-move-title": "Orders moved successfully",
        "service-center-admin-organization-manage-bookings-success-modal-delete-title": "Orders deleted successfully",
        "service-center-admin-organization-manage-bookings-submit-missing-data-error": "Missing required data, please try again",
        "service-center-admin-organization-manage-bookings-user-no-results": "No users found",
        "service-center-admin-organization-manage-bookings-select-placeholder": "Select",

        // Product availability
        "product-unavailable-dialog-close": "Close",
        "product-unavailable-snackbar": "This product is currently unavailable",
        "product-daily-limit-exceeded-snackbar": "Daily purchase limit reached for this product",
        "product-stock-limit-exceeded-snackbar": "Not enough items in stock",
        "product-stock-negative-error": "Stock cannot be negative",

        // Order chat
        "order-chat-drawer-title-customer": "Chat with canteen",
        "order-chat-drawer-title-merchant": "Chat with customer",
        "order-chat-disclaimer-text": "This chat is used to communicate about the order. Messages will not appear on the order specification.",
        "order-chat-disclaimer-warning": "NOTE: Avoid entering sensitive personal information, e.g. if you are vegetarian, have allergies.",
        "order-chat-disclaimer-link": "Read more <a>here</a>.",
        "order-chat-disclaimer-accept": "Understood",
        "order-chat-placeholder-merchant": "Message to customer...",
        "order-chat-placeholder-customer": "Message to canteen...",
        "order-chat-empty": "\n .title = No messages yet\n .description = Start the conversation!",
        "order-chat-exceeded-characters": "Maximum { $limit } characters exceeded",
        "order-chat-menu-item-customer": "Chat with canteen",
        "order-chat-menu-item-merchant": "Chat with customer",
        "order-chat-tooltip-needs-response": "New message - needs response",
        "order-chat-tooltip-responded": "Chat",
        "order-chat-history-print-with-button": "Print with chat history",
        "order-chat-history-print-without-button": "Print",
        "meeting-service-print-view-order-menu-print-button": "Print (with order note)",
        "meeting-service-print-view-order-menu-print-with-chat-button": "Print (with order note and chat)",
        "meeting-service-print-view-order-menu-print-section-title": "Print order",
        "order-chat-history-print-title": "Chat history",
        "order-chat-status-card-messages-badge": "\n .label = { $count -> \n [one] { $count } message \n *[other] { $count } messages \n }",
        "order-chat-status-card-reply-own": "You replied on { $date } at { $time }: <quote>“{ $message }”</quote>",
        "order-chat-status-card-reply-user": "Customer replied on { $date } at { $time }: <quote>“{ $message }”</quote>",
        "order-chat-status-card-reply-merchant": "Canteen replied on { $date } at { $time }: <quote>“{ $message }”</quote>",
    },
    "da-DK": {

        // Preferred hour cycle for locale
        // NOTE: Only necessary to specify if default for country/region from CLDR supplementary data used by browser Intl API is incorrect
        // See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle
        // See: https://github.com/unicode-org/cldr/blob/master/common/supplemental/supplementalData.xml#L4768
        "date-time-hour-cycle": "h23",

        // Date and time formats as Luxon format strings
        // See: https://moment.github.io/luxon/docs/manual/formatting.html#table-of-tokens
        "date-time-format-date": "dd/MM/yyyy",
        "date-time-format-long-date": "d. MMMM yyyy",
        "date-time-format-month-day": "d. MMM",
        "date-time-format-weekday-long-date": "EEEE 'den' d. MMMM yyyy",
        "date-time-format-day-and-date": "EEEE dd/MM",
        "date-time-format-time": "HH:mm",
        "date-time-format-time-hms": "HH:mm:ss",
        "date-time-format-date-and-time": "dd/MM/yyyy\u00A0HH:mm",
        "date-time-format-duration-hours-minutes": "h't.' m'min.'",
        "date-time-format-duration-minutes": "m'min.'",
        "date-time-format-duration-seconds": "s's'",
        "date-time-compact-period-start": "d/M-yy 'kl.' HH:mm",
        "date-time-short-relative-units": "s|m|t|d|u|md|å",
        "date-time-invalid-date": "N/A",

        // Money formats
        "money-amount-unit-month": "md.",
        "money-amount-unit-year": "år",

        // Numeric field validation
        "numeric-field-invalid-error": "{ $label } skal være et tal",
        "numeric-field-integer-error": "{ $label } skal være et helt tal",
        "numeric-field-positive-error": "{ $label } skal være større end 0",
        "numeric-field-non-negative-error": "{ $label } skal være 0 eller derover",
        "numeric-field-negative-error": "{ $label } skal være mindre end 0",
        "numeric-field-non-positive-error": "{ $label } skal være 0 eller derunder",
        "vat-code-vat-percentage-field-name": "Moms-procent",
        "price-list-percentage-field-name": "Procentsats",

        // User types
        "-user-type-support": "Supporter",
        "-user-type-supplier": "Kantineforpagter",
        "-user-type-merchant": "Shopejer",
        "-user-type-company": "Firmaadministrator",
        "-user-type-office-manager": "Kontorchef",
        "-user-type-user": "Bruger",
        "-user-type-service-center": "Servicecenter",


        // Shared components
        "error-boundary-modal": "\n .title = Noget gik galt\n .message = Fejlkode: { $errorCode }\n .buttonLabel = Luk vinduet",
        "query-error-boundary": "\n .title = Noget gik galt\n .message = Fejlkode: { $errorCode }\n .buttonLabel = Prøv igen",
        "confirmation-dialog-cancel": "Annuller",
        "confirmation-dialog-approve": "Godkend",
        "coming-soon-dialog-title": "Kommer snart",
        "coming-soon-dialog-message": "Vi arbejder på at levere denne funktion til dig.",
        "coming-soon-dialog-ok-button": "OK",
        "meeting-time-label-today": "I dag kl. { $period }",
        "meeting-time-label-tomorrow": "I morgen kl. { $period }",
        "meeting-time-label-yesterday": "I går kl. { $period }",
        "meeting-time-label-date": "{ $date } kl. { $period }",
        "error-dialog-show-details-label": "Vis detaljer",
        "error-dialog-close-button": "Luk",
        "error-dialog-support-request": "Kontakt venligst <supportMessage>support@facilitynet.dk</supportMessage> hvis problemet fortsætter.",
        "error-route": "\n .title = Noget gik galt \n .message Denne side kan ikke vises på grund af en ukendt fejl \n .buttonLabel = Gå til forsiden",
        "time-or-date-picker-time-label": "Tid",
        "api-call-timeout-message": "Anmodningen tager længere tid end forventet",
        "api-call-generic-success": "Handlingen blev gennemført",

        // authenticate common
        "-authenticate-submit-button": "Næste",

        // --- Error boundaries ---
        "app-error-boundary": "\n .title = Noget gik galt\n .buttonLabel = Luk vinduet",
        "app-error-boundary-title": "Noget gik galt",
        "app-error-boundary-button": "Luk vinduet",
        "route-error-boundary": "\n .title = Noget gik galt\n .buttonLabel = Gå til Hjem",
        "inline-error-boundary-message": "Kunne ikke rendere komponent",
        "inline-error-boundary-calendar-event-message": 'Could not parse event',
        "query-error-boundary-message": "Fejl ved indlæsning af data.",
        "query-error-boundary-no-data-message": "Ingen data.",
        "query-error-boundary-retry-button": "Prøv igen",


        // --- Language selector ---
        "language-selector-lang-en-us": "Engelsk",
        "language-selector-lang-da-dk": "Dansk",
        "language-selector-lang-nb-no": "Norsk",
        "language-selector-lang-sv-se": "Svensk",


        // --- Footer ---
        "footer-read-more": "Læs mere på <linkElem>{ $linkName }</linkElem>",


        // --- Avatar menu ---
        "avatar-menu-menu-item-help": "Hjælp",
        "avatar-menu-menu-item-merchant-tour": "Rundvisning",
        "avatar-menu-menu-item-news": "Facilitynet nyheder",
        "avatar-menu-menu-item-profile": "Brugerkonto",
        "avatar-menu-menu-item-archive": "Arkiv",
        "avatar-menu-menu-item-change-user-account": "Skift brugerkonto",
        "avatar-menu-menu-item-swift-merchant": "Skift salgssted",
        "avatar-menu-menu-item-settings": "Indstillinger",
        "avatar-menu-menu-item-logout": "Log ud",
        "avatar-menu-menu-item-system-status": "Systemstatus",
        "avatar-menu-tooltip-profile": "\n .title = Vis din brugerkonto",
        "avatar-menu-tooltip-settings": "\n .title = Skift indstillinger for din brugerkonto",
        "avatar-menu-tooltip-change-user-account": "\n .title = Hvis du har flere brugerkonti, kan du skifte mellem dem her",
        "avatar-menu-tooltip-switch-merchant": "\n .title = Hvis du har adgang til flere salgssteder, kan du skifte mellem dem her",
        "avatar-menu-tooltip-news": "\n .title = Læs nyheder fra Facilitynet",
        "avatar-menu-tooltip-help": "\n .title = Få hjælp til brug af systemet",
        "avatar-menu-tooltip-merchant-tour": "\n .title = Start guidet tur",
        "avatar-menu-tooltip-system-status": "\n .title = Vis og abonner på vigtige beskeder om systemet",
        "avatar-menu-tooltip-logout": "\n .title = Log ud af systemet",


        // --- Confirm dialogs ---
        "confirm-modal-confirm-label": "Er du sikker?",
        "delete-confirm-modal-title": "Slet { $itemType }",
        "delete-confirm-modal-question": "Er du sikker på, at du vil slette '{ $itemName }'?",
        "delete-confirm-modal-button-delete": "Slet",
        "delete-confirm-modal-button-cancel": "Annuller",
        "delete-confirm-modal-button-submit": "Send",
        "cancel-subscription-modal-title": "Opsig abonnement",
        "cancel-subscription-modal-message": "Er du sikker på, at du vil opsige abonnementet '{ $subscriptionName }' for { $customerName }?",
        "cancel-subscription-modal-label-ignore-terms": "\n .label = Med øjeblikkelig virkning",
        "cancel-subscription-modal-helper-text-ignore-terms": "Dette vil tilsidesætte abonnementsbetingelserne.",
        "cancel-subscription-modal-button-delete": "Opsig",


        // --- Not found ---
        "not-found-title": "Ikke fundet",
        "not-found-explanation": "Siden du leder efter findes ikke.",
        "not-found-path-label": "Sti:",
        "not-found-go-home-button": "Gå hjem",


        // --- Access denied ---
        "access-denied-title": "Adgang nægtet",
        "access-denied-explanation": "Din brugerprofil har ikke adgang til denne side.",
        "access-denied-required-usertype-label": "Påkrævet brugertype:",
        "access-denied-actual-usertype-label": "Din brugertype:",
        "access-denied-path-label": "Sti:",
        "access-denied-go-home-button": "Gå hjem",
        "access-denied-logout-button": "Log af",

        "access-denied-usertype-support": "{ -user-type-support }",
        "access-denied-usertype-supplier": "{ -user-type-supplier }",
        "access-denied-usertype-merchant": "{ -user-type-merchant }",
        "access-denied-usertype-company": "{ -user-type-company }",
        "access-denied-usertype-office-manager": "{ -user-type-office-manager }",
        "access-denied-usertype-unknown": "Ukendt",


        "login-email-label": "Log ind",
        "login-password-label": "Indtast dit kodeord",
        "login-email-field-label": "\n .label = Email",
        "test": "Tæææst",
        "bottom-menu-item-home": "\n .label = Hjem",
        "bottom-menu-item-profile": "\n .label = Profil",

        "confirm-email-button": "Bekræft\n .loadingLabel = Bekræfter...",
        "confirm-email-description": "Følgende brugerkonti er alle registreret med e-mailadressen <email>{ $email }</email> og vil kunne skifte konto. Sørg for, at de alle tilhører dig:",
        "confirm-email-title": "Bekræft kontoadgang",
        "confirm-email-success-message": "Du kan nu skifte mellem dine brugerkonti",
        "confirm-email-error-message": "Vi kunne ikke bekræfte din e-mailadresse",
        "confirm-email-missing-userid-or-otp": "Manglende bruger-id eller otp",

        "purchases-payment-method-free": "Gratis",
        "purchases-payment-method-credit-card": "Kreditkort",
        "purchases-payment-method-one-click-payment": "Kreditkort",
        "purchases-payment-method-mobile-pay": "MobilePay",
        "purchases-payment-method-payroll-deduction": "Løntræk",
        "purchases-payment-method-lunch-registration": "Frokostordning",
        "purchases-payment-method-gopay-wallet": "GoPay Wallet",
        "purchases-payment-method-invoice": "Faktura",
        "purchases-payment-method-cash": "Kontant",
        "purchases-payment-method-gopay-account": "GoPay Wallet",
        "purchases-payment-method-refund": "Refunderet",
        "purchases-payment-method-subscribe-payment-card": "Tilmeld betalingskort",
        "purchases-payment-method-id-card": "ID-kort",




        // --- Error handling ---
        "api-call-error-title-unknown-error": "Ukendt fejl",
        "api-call-error-title-network-error": "Netværksfejl",
        "api-call-error-title-bad-request": "Forespørgsel afvist",
        "api-call-error-title-unauthorized": "Ugyldigt login",
        "api-call-error-title-forbidden": "Adgang nægtet",
        "api-call-error-title-not-found": "Ikke fundet",
        "api-call-error-title-conflict": "Konflikt",
        "api-call-error-title-too-many-requests": "For mange forespørgsler",
        "api-call-error-title-internal-server-error": "Intern server fejl",
        "api-call-error-title-service-unavailable": "Service ikke tilgængelig",
        "api-call-error-title-request-failed": "Forespørgsel fejlede",
        "api-call-error-unknown-error": "Ukendt fejl",
        "api-call-error-no-internet-connection": "Ingen Internet forbindelse",
        "api-call-error-could-not-reach-server": "Kunne ikke opnå forbindelse til server",
        "api-call-error-protocol-error": "Server fejl: { $responseCode } { $responseStatus }",
        "api-call-error-api-returned-error": "Uventet server fejl",
        "api-call-error-response-not-json": "Uventet svar fra server",
        "api-call-error-retry-button": "Forsøg igen",

        // --- Receipts ---

        // Page
        "receipt-title": "Kvittering",

        // Payment methods
        "receipt-payment-method-free": "Gratis",
        "receipt-payment-method-credit-card": "Kreditkort",
        "receipt-payment-method-one-click-payment": "Kreditkort",
        "receipt-payment-method-mobile-pay": "MobilePay",
        "receipt-payment-method-payroll-deduction": "Løntræk",
        "receipt-payment-method-lunch-registration": "Frokostordning",
        "receipt-payment-method-gopay-account": "GoPay Wallet",
        "receipt-payment-method-gopay-wallet": "GoPay Wallet",
        "receipt-payment-method-invoice": "Faktura",
        "receipt-payment-method-cash": "Kontant",
        "receipt-payment-method-id-card": "ID-kort",

        // Purchase section
        "receipt-purchase-details-section": "\n .heading = Købsdetaljer",
        "receipt-purchase-payment-status-paid": "BETALT",
        "receipt-purchase-payment-status-unpaid": "EJ BETALT",
        "receipt-purchase-payment-status-invoiced": "FAKTURERET",
        "receipt-purchase-payment-status-refunded": "REFUNDERET",
        "receipt-purchase-payment-status-cancelled": "REFUNDERET",
        "receipt-purchase-payment-status-failed": "FEJLET",
        "receipt-purchase-address-item": "\n .label = Købssted:",
        "receipt-purchase-seller-vat-number": "CVR:\u00A0{ $vatNumber }",
        "receipt-purchase-customer-item": "\n .label = Kunde:",
        "receipt-purchase-employee-id-item": "\n .label = Medarbejder-id:",
        "receipt-purchase-company-item": "\n .label = Firmaadministrator:",
        "receipt-purchase-time-item": "\n .label = Købstidspunkt:",
        "receipt-purchase-payment-method-item": "\n .label = Betalingsmetode:",
        "receipt-purchase-order-id-item": "\n .label = Ordre-id:",
        "receipt-purchase-shop-channel-item": "\n .label = Via:",
        "receipt-purchase-receipt-error": "Kunne ikke indlæse ordre med id  #{ $orderId }",
        "receipt-purchase-receipt-error-description": "Denne ordre kunne ikke behandles på grund af manglende eller ugyldige data.",

        // Delivery section
        "receipt-delivery-details-section": "\n .heading = Levering",
        "receipt-delivery-order-type-item": "\n .label = Ordretype:",
        "receipt-order-type-catering": "Mødeforplejning",
        "receipt-order-type-lunch": "Frokost",
        "receipt-order-type-takeaway": "Takeaway",
        "receipt-order-type-take-away": "Takeaway",
        "receipt-order-type-refill-account": "Optankning",
        "receipt-order-type-auto-refill-account": "Automatisk tank-op tilmelding",
        "receipt-order-type-lunch-subscription": "Abonnement tilmelding",
        "receipt-order-type-subscribe-payment-card": "Tilmelding af betalingskort",
        "receipt-order-type-meeting": "Møde",
        "receipt-order-type-refund": "Refundering",
        "receipt-delivery-type-item": "\n .label = Leveringstype:",
        "receipt-delivery-type-pick-up": "Afhentning",
        "receipt-delivery-type-take-away": "Takeaway",
        "receipt-delivery-location-item": "\n .label = Afhentningssted:",
        "receipt-delivery-pickup-location-item": "\n .label = Afhentningssted:",
        "receipt-delivery-time-item": "\n .label = Leveringstid:",
        "receipt-delivery-pickup-time-item": "\n .label = Afhentingstidspunkt:",
        "receipt-delivery-comment-item": "\n .label = Kommentar:",

        // Order details section
        "receipt-order-details-buyerparty-private": "Privatkøb",
        "receipt-order-details-buyerparty-company": "Firmakøb",
        "receipt-order-details-payment-method-item": "\n .label = Betalingsmetode:",
        "receipt-order-details-total": "\n .label = I alt:",
        "receipt-order-details-vat-total": "\n .label = Moms udgør (25%):",

        // Subscription details section
        "receipt-subscription-details-section": "\n .heading = Abonnement",
        "receipt-subscription-details-subscription-id": "\n .label = Abonnements-id:",
        "receipt-subscription-details-subscription-name": "\n .label = Abonnementsnavn:",
        "receipt-subscription-details-subscription-valid-from": "\n .label = Gældende fra:",
        "receipt-subscription-details-subscription-valid-to": "\n .label = Gælder til:",
        "receipt-subscription-details-subscription-price": "\n .label = Abonnementspris:",

        // Actions section
        "receipt-actions-forward-receipt-button": "Send kvittering",
        "receipt-actions-cancel-order-button": "Refunder bestilling",
        "receipt-actions-confirm-cancel-dialog": "\n .description = Du er ved at refundere denne bestilling. Er du sikker?\n .confirmLabel = Ja\n .cancelLabel = Nej\n .loadingDescription = Refunderer bestilling...",
        "receipt-actions-cancel-disabled-dialog": "\n .title = Refundering ikke tilgængelig\n .message = Denne funktion er endnu ikke klar. Den vil komme senere.\n .buttonLabel = Forstået",
        "receipt-actions-cancel-unavailable-dialog": "\n .buttonLabel = Forstået",

        "receipt-order-label": "Kvittering #{ $orderId }, { $orderDate }",

        // Forward receipt
        "receipt-forward-receipt-dialog": "\n .title = { $receipts -> \n *[one] Send kvittering \n [other] Send kvitteringer \n } \n .cancelButtonLabel = Annuller\n .submitButtonLabel = Send\n .submitButtonLoadingLabel = Sender...",
        "receipt-forward-receipt-email-field": "\n .label = E-mail adresse",
        "receipt-forward-receipt-email-field-is-required": "E-mail adresse skal udfyldes",
        "receipt-forward-receipt-email-field-must-be-valid": "Ugyldig e-mail adresse",


        // --- Login domain ---

        // login auth flow hook
        "auth-flow-authentication-result-server-error": "Klienten forventede, at godkendelsen var fuldført, men serveren svarede: { $action }.",
        "auth-flow-authentication-unexpected-server-error":  `Unexpected authentication action { $action } in API response`,

        // Create password page
        "create-password-required": "Feltet er påkrævet",
        "create-password-password-invalid-for-policy": "Kodeord overholder ikke password politik",
        "create-password-new-required": "Feltet er påkrævet",
        "create-password-matching": "Kodeordene stemmer ikke overens",
        "create-password-title": "Nyt kodeord",
        "create-password-new-password-field": "\n .label = Nyt kodeord",
        "create-password-submit-button": "Nulstil adgangskode",
        "create-password-confirm-password-field": "\n .label = Bekræft kodeord",
        "create-password-missing-token-title": "Fejl",
        "create-password-missing-token-description": "Der er ikke angivet det nødvendige token til at oprette adgangskode.",

        // Forgot password page
        "forgot-password-username-required": "Brugernavn er påkrævet",
        "forgot-password-username-title": "Glemt Kodeord",
        "forgot-password-username-invalid": "Brugernavn er ikke gyldigt",
        "forgot-password-button-label": "Næste",
        "forgot-password-enter-username-field": "\n .label = Indtast din e-mail eller dit brugernavn:",


        // SignInWithActivationCode page
        "sign-in-with-activation-code-min-length": "Aktivationskoden skal være minimum 6 tegn langt",
        "sign-in-with-activation-code-required": "Aktivationskoden er påkrævet",
        "sign-in-with-activation-code-title": "Indtast din aktiveringskode",
        "sign-in-with-activation-code-field-label": "\n .label = Aktiveringskode",
        "sign-in-with-activation-code-submit-button": "Næste",

        // SignInWithPassword page
        "sign-in-with-password-required": "Kodeord er påkrævet",
        "sign-in-with-password-title": "Indtast dit kodeord",
        "sign-in-with-password-field-label": "\n .label = Kodeord",
        "sign-in-with-password-submit-button": "Log ind",
        "sign-in-with-password-reset-password-link": "Glemt kodeord",

        // SignInWithUsername page
        "sign-in-with-username-min-length": "Brugernavnet skal være på minimum 3 tegn",
        "sign-in-with-username-required": "Brugernavn er påkrævet",
        "sign-in-with-username-title": "Log ind",
        "sign-in-with-username-subtitle": " Velkommen til Facilitynet",
        "sign-in-with-username-field-label": "\n .label = Username\n .placeholder = Indtast dit brugernavn",
        "sign-in-with-username-remember-me": "Husk mig",
        "sign-in-with-username-submit-button": "Næste",
        "sign-in-with-username-reset-password-link": "Glemt kodeord?",

        // StartPageLayout
        "start-page-layout-title": "Din portal til mødeplanlægning og kantineydelser",
        "start-page-layout-sub-title-1": "Accepter betalinger med POS og mobiltelefon",
        "start-page-layout-sub-title-2": "Få indsigt i salgstal med Facilitynet Manager",
        "start-page-layout-sub-title-3": "Bedre kommunikation mellem køkken og kunder",
        "start-page-layout-login-button-label": "Log in",

        // Login Layout
        "login-layout-card-title": "Facilitynet Manager",
        "login-layout-card-subtitle": "Kantineadministration gjort nemt",
        "auto-login-title":"Logger dig ind...",
        "auto-login-description":"Vent venligst mens vi automatisk logger dig ind.",
        "auto-login-error-title":" otp token ikke fundet",
        "auto-login-error-description":"  Du har modtaget et ugyldigt link. Kontakt venligst support.",

        // Invitation
        "invitation-title": "Opret dine adgangskoder til Facilitynet",
        "invitation-username-rules": "Brugernavn skal være på mindst 3 tegn.",
        "invitation-password-rules": "Adgangskode skal være på mindst 8 tegn og indeholde et lille bogstav, et stort bogstav og et tal.",
        "invitation-usertype-support": "{ -user-type-support }",
        "invitation-usertype-supplier": "{ -user-type-supplier }",
        "invitation-usertype-merchant": "{ -user-type-merchant }",
        "invitation-usertype-company": "{ -user-type-company }",
        "invitation-usertype-office-manager": "{ -user-type-office-manager }",
        "invitation-usertype-unknown": "Ukendt brugertype",
        "invitation-field-username": "\n .label = Brugernavn",
        "invitation-field-password": "\n .label = Adgangskode",
        "invitation-field-repeat-password": "\n .label = Gentag adgangskode",
        "invitation-submit-button": "Aktiver konto\n .loadingLabel = Aktiverer...",
        "invitation-field-username-required": "Brugernavn skal udfyldes",
        "invitation-field-username-min-chars": "Brugernavn skal være på mindst { $minChars } tegn",
        "invitation-field-password-required": "Adgangskode skal udfyldes",
        "invitation-field-password-invalid-for-policy": "Kodeord overholder ikke password politikken",
        "invitation-field-password-min-chars": "Adgangskode skal være på mindst { $minChars } tegn",
        "invitation-field-password-contain-lowercase": "Adgangskode skal indeholde et lille bogstav",
        "invitation-field-password-contain-uppercase": "Adgangskode skal indeholde et stort bogstav",
        "invitation-field-password-contain-number": "Adgangskode skal indeholde et tal",
        "invitation-field-repeatPassword-required": "Dette felt skal udfyldes",
        "invitation-field-repeatPassword-match-password": "Kodeord stemmer ikke overens",

        // Confirm account change
        "confirm-account-change-confirming-email-message": "Bekræfter e-mailadresse...",
        "confirm-account-change-login-button": "Log ind",
        "confirm-account-change-failure-message": "Kunne ikke bekræfte e-mailadressen",

        // Id Card Signup
        "id-card-signup-title": "Gennemfør registrering",
        "id-card-signup-description": "Gennemfør venligst registreringsprocessen. Når du har registreret dit ID-kort, kan du bruge det til at købe mad i kantinen ved blot at scanne det på POS-skærmen.",
        "id-card-signup-subscription": "Vælg abonnement",
        "id-card-signup-next-button": "Næste",
        "id-card-signup-back-button": "Tilbage",
        "id-card-signup-field-company": "\n .label = Din virksomhed:\n .placeholder = Vælg den virksomhed, du arbejder for",
        "id-card-signup-field-user-group": "\n .label = Din brugergruppe:\n .placeholder = Vælg brugergruppe",
        "id-card-signup-field-name": "\n .label = Dit navn:\n .placeholder = Indtast dit fulde navn",
        "id-card-signup-field-mobile-number": "\n .label = Din telefon:\n .placeholder = Indtast dit mobilnummer (valgfrit)",
        "id-card-signup-field-mobile-number-invalid": "Ugyldigt mobilnummer",
        "id-card-signup-field-name-max-length": "Navn må ikke overstige 50 tegn",
        "id-card-signup-companies-error": "Kunne ikke indlæse virksomheder. Prøv igen.",
        "id-card-activation-generic-error": "Kunne ikke indlæse virksomheder. Prøv igen.",
        "id-card-signup-no-subscriptions": "Der opstod en fejl under aktivering af dit kort. Prøv igen.",
        "id-card-signup-using-company": "Din virksomhed: ",
        "id-card-signup-using-user-group": "Din brugergruppe: ",
        "id-card-signup-using-user-name": "Brugernavn: ",
        "id-card-signup-complete": "Tillykke",
        "id-card-signup-complete-description": "Dit kort er nu tilmeldt abonnement, og du kan begynde at bruge det.",
        "id-card-signup-complete-learn-more": "Læs mere:",
        "id-card-signup-complete-learn-more-link": "Hvordan bruger jeg Facilitynet betalingsløsning?",

        // Activate account
        "activation-account-username-title": "Aktiver konto",
        "activation-account-username-subtitle": "For at bruge Facilitynet, skal du aktivere din konto nedenfor",
        "activation-account-username-button": "Aktiver",
        "activation-account-username-field": "\n .label = Indtast din e-mail-adresse:",
        "activation-account-username-email-required": "E-mailadresse er påkrævet",
        "activation-account-username-email-invalid": "Indtast venligst en gyldig e-mailadresse",
        "activation-account-password-title": "Opret adgangskode",
        "activation-account-password-new-password-field": "\n .label = Indtast adgangskode",
        "activation-account-password-button": "Opret adgangskode",

        // select company
        "authenticate-select-company-header-reason-multiple-companies-for-domain": "Vælg firma",
        "authenticate-select-company-header-reason-multiple-accounts-for-username": "Vælg brugerkonto",
        "authenticate-select-company-reason-message-multiple-companies-for-domain": "Vi var ikke i stand til at bestemme dit firma automatisk, da dit e-mail domæne <duplicateValue>{ $duplicateValue }</duplicateValue> optræder flere steder i vores system.",
        "authenticate-select-company-reason-message-multiple-accounts-for-username": "Vi fandt flere konti i vores system med e-mail adressen <duplicateValue>{ $duplicateValue }</duplicateValue>.",
        "authenticate-select-company-action-message-multiple-companies-for-domain": "Vælg lokation (firma), som du ønsker at oprette din konto under:",
        "authenticate-select-company-action-message-multiple-accounts-for-username": "Vælg venligst den brugerkonto, som du ønsker at logge ind med.",
        "authenticate-select-company-show-list-button": "Vis valgmuligheder",
        "authenticate-select-company-submit-button": "{ -authenticate-submit-button }\n .loadingLabel = Gemmer...",
        "authenticate-select-company-form-error-message": "Vælg venligst en virksomhed",
        "authenticate-select-company-company-group-unknown-uid": "Ukendt virksomheds-UID",
        "authenticate-select-company-company-group-unknown-name": "Ukendt navn",
        "authenticate-select-company-company-group-unknown-address": "Ukendt adresse",
        "authenticate-select-company-no-companies-available": "Ingen firmaer tilgængelige",
        "authenticate-select-company-account-role-support": "{ -user-type-support }",
        "authenticate-select-company-account-role-supplier": "{ -user-type-supplier }",
        "authenticate-select-company-account-role-merchant": "{ -user-type-merchant }",
        "authenticate-select-company-account-role-company": "{ -user-type-company }",
        "authenticate-select-company-account-role-office-manager": "{ -user-type-office-manager }",
        "authenticate-select-company-account-role-user": "{ -user-type-user }",
        "authenticate-select-company-account-role-service-center": "{ -user-type-service-center }",

        // Public > Self Sign Up
        "self-sign-up-title": "Tilmeld",
        "self-sign-up-description": "Gennemfør venligst registreringsprocessen. Når du er færdig med tilmeldingen, kan du bruge kontoen",
        "self-sign-up-field-company": "\n .label = Din virksomhed:\n .placeholder = Vælg den virksomhed, du arbejder for",
        "self-sign-up-field-user-group": "\n .label = Din brugergruppe:\n .placeholder = Vælg brugergruppe",
        "self-sign-up-field-department": "\n .label = Afdeling:\n .placeholder = Vælg din afdeling",
        "self-sign-up-department-missing-notice": "Kontakt venligst din virksomhedsadministrator, hvis din afdeling mangler på listen.",
        "self-sign-up-field-name": "\n .label = Navn:\n .placeholder = Indtast dit fulde navn",
        "self-sign-up-field-email": "\n .label = E-mail:\n .placeholder = Indtast din e-mail",
        "self-sign-up-field-mobile-number": "\n .label = Telefon:\n .placeholder = Indtast dit mobilnummer (valgfrit)",
        "self-sign-up-complete-button": "Tilmeld",
        "self-sign-up-field-email-invalid": "Ugyldig e-mailadresse",
        "self-sign-up-email-domain-hint": "Brug venligst en e-mail fra et godkendt domæne: { $domains }",
        "self-sign-up-field-email-domain-not-allowed": "E-mailen skal bruge et godkendt domæne: { $domains }",
        "self-sign-up-congratulation-title": "Tillykke",
        "self-sign-up-congratulation-message": "Vi har sendt et aktiveringslink til din email adresse.",
        "self-sign-up-error-message": "Noget gik galt. Prøv venligst igen.",
        "self-sign-up-confirm-dialog": "\n .title = Bekræft detaljer\n .message = Er du sikker på, at du vil oprette din konto med de angivne oplysninger?\n .buttonLabelSubmit = Bekræft\n .buttonLabelCancel = Annuller",
        "self-sign-up-confirm-company": "\n .label = Firma:",
        "self-sign-up-confirm-user-group": "\n .label = Brugergruppe:",
        "self-sign-up-confirm-department": "\n .label = Afdeling:",
        "self-sign-up-confirm-name": "\n .label = Navn:",
        "self-sign-up-confirm-email": "\n .label = E-mail:",
        "self-sign-up-confirm-mobile-number": "\n .label = Telefon:",


         // Booking > Confirm Booking
        'confirm-booking-complete': "Tillykke",
        'confirm-booking-failed': "Mislykket",
        'confirm-booking-loading': "Indlæser...",

        // ExportButton
        "export-button-export-text": "\n .title = Eksport\n .aria-label = Eksport",
        "export-button-export-all": "Eksporter alle",
        "export-button-export-all-with-filter": "Eksporter alt med filter",
        "export-button-export-selected": "Eksporter valgte",
        "export-button-export-selected-rows": "Eksporter valgte rækker",
        "export-button-export-as-csv-title": "\n .title = Hent som CSV-fil",
        "export-button-export-as-pdf-title": "\n .title = Hent som PDF-fil",
        "export-button-print": "Udskriv",
        "export-button-remove-print-title": "\n .title = Fjern fra printerkø",



        // Export
        "export-period": "Periode",

        // print
        "print-queued": "Din anmodning er i kø",


        // --- ContextDisplay ---
        "context-display-org-unit-supplier": "\n .label = Forpagter:",
        "context-display-org-unit-merchant": "\n .label = Salgssted:",
        "context-display-org-unit-tenant": "\n .label = Lejer:",
        "context-display-org-unit-company": "\n .label = Firma:",
        "context-display-org-unit-user": "\n .label = Bruger:",
        "context-display-org-unit-service-center": "\n .label = Servicecenter:",



        // --- Environment dropdown ---
        "env-dropdown-menu-header": "Skift miljø til:",
        "env-dropdown-title-admin-support":"Administration",
        "env-dropdown-title-reports-support":"Dashboard",
        "env-dropdown-title-admin-supplier":"Administration",
        "env-dropdown-title-reports-supplier":"Dashboard",
        "env-dropdown-title-admin-merchant":"Administration",
        "env-dropdown-title-reports-merchant":"Produktion",
        "env-dropdown-title-accounting-merchant":"Regnskab",
        "env-dropdown-title-admin-company":"Administration",
        "env-dropdown-title-reports-company":"Dashboard",
        "env-dropdown-title-admin-office-manager":"Administration",
        "env-dropdown-title-reports-office-manager":"Dashboard",
        "env-dropdown-title-reports-service-center":"Dashboard",
        "env-dropdown-title-admin-service-center":"Administration",
        "env-dropdown-subtitle-admin-support":"Administrer entiteter og brugere.",
        "env-dropdown-subtitle-reports-support":"Se systemrapporter.",
        "env-dropdown-subtitle-admin-supplier":"Administrer salgssteder og globale indstillinger.",
        "env-dropdown-subtitle-reports-supplier":"Se tværgående rapporter over regnskabstal.",
        "env-dropdown-subtitle-admin-merchant":"Administrer produkter, shops og kundekommunikation.",
        "env-dropdown-subtitle-reports-merchant":"Se driftsoverblik og produktionstal.",
        "env-dropdown-subtitle-admin-company":"Administrer organisationsdata, brugere og administratorer.",
        "env-dropdown-subtitle-reports-company":"Se regnskabstal.",
        "env-dropdown-subtitle-admin-office-manager":"Administrer brugere og administratorer.",
        "env-dropdown-subtitle-reports-office-manager":"Se regnskabstal.",
        "env-dropdown-subtitle-reports-service-center":"Service center rapporter",
        "env-dropdown-subtitle-admin-service-center":"Service center administration",
        "env-dropdown-subtitle-accounting-merchant":"Vis regnskabsrapporter.",


        // --- API components ---
        "api-query-table-fetch-error-message": "Fejl ved indlæsning af data",
        "api-query-autocomplete": "\n .loadingText = Indlæser data...",
        "api-query-autocomplete-fetch-error-message": "Fejl ved indlæsning af data. <retryLink>Prøv igen</retryLink>",

        // Top Bar
        "help-tooltip-text": "\n .title = Vis hjælp",
        "notifications-tooltip-text": "\n .title = Vis beskeder",
        "new-order-tooltip-text": "\n .title = Opret ny ordre",
        "qa-env-warning-part-one": "Du er i QA-miljøet. Dette er ikke beregnet til kunder. Brug venligst",
        "qa-env-warning-part-two": "i stedet.",

        // Top Bar > Help
        "help-dialog-search-title": "Hej, hvordan kan vi hjælpe dig?",
        "help-dialog-search":"\n .placeholder = Søg efter artikler...",
        "help-dialog-support": "\n .title = Support",
        "help-dialog-email-support": "\n .title = E-mailsupport \n .description = Hvis du stadig har brug for hjælp, kan du sende os en e-mail her.",
        "help-dialog-chat-support": "\n .title = Chatsupport \n .description = Har du hurtige spørgsmål, kan du chatte med vores kundeserviceteam.",
        "help-dialog-troubleshooting": "\n .title = Fejlfinding",
        "help-dialog-troubleshooting-pos-screen": "\n .title = POS-skærm \n .description = Få hjælp til din POS-skærm, kvitteringsprinter og betalingsterminal.",
        "help-dialog-troubleshooting-check-in-screen": "\n .title = Check-in-skærm \n .description = Få hjælp til din check-in-skærm og kvitteringsprinter.",
        "help-breadcrumb": "Hjælp",
        "help-dialog-troubleshooting-breadcrumb": "Fejlfinding",
        "help-dialog-troubleshooting-printer-not-working": "\n .title = Printeren virker ikke",
        "help-dialog-troubleshooting-credit-card-terminal-not-working": "\n .title = Betalingsterminalen virker ikke",
        "help-dialog-troubleshooting-pos-screen-not-working": "\n .title = POS-skærmen virker ikke",
        "help-dialog-troubleshooting-check-in-screen-not-working": "\n .title = Check-in-skærmen virker ikke",
        "help-dialog-troubleshooting-start-up-backup-terminal": "\n .title = Start backup-terminalen op",
        "help-dialog-training": "\n .title = Undervisning",
        "help-dialog-training-education-center": "\n .title = Uddannelsescenter \n .description = I Uddannelsescenteret kan du se kom godt i gang-guides og andet undervisningsmateriale.",
        "help-dialog-training-guide-button": "Se guide",
        "consent-dialog": "\n .title = Tillad chat \n .message = Vi benytter Intercom til vores chat support. Hvis du godkender, deler vi nedenstående oplysninger med Intercom. \n .skipLabel = Ikke nu \n .consentLabel = Tillad",
        "consent-dialog-personal-information": "Personoplysninger",
        "consent-dialog-pii-category-contact-info": "Kontaktinformation",
        "consent-dialog-pii-category-identifiers": "Identifikation",
        "consent-dialog-pii-category-purchases": "Køb",
        "consent-dialog-pii-category-user-content": "Brugerindhold",
        "consent-dialog-privacy-policy": "Privatliv",
        "consent-dialog-view-company-privacy-policy": "Se firmaets privatlivspolitik",
        "consent-dialog-pii-item-name": "Navn",
        "consent-dialog-pii-item-email-address": "E-mail",
        "consent-dialog-pii-item-phone-number": "Telefonnummer",
        "consent-dialog-pii-item-user-id": "Bruger id",
        "consent-dialog-pii-item-device-id": "Device id",
        "consent-dialog-pii-item-customer-support": "Kundeservice",
        "consent-dialog-pii-item-purchase-history": "Købshistorik",
        "intercom-error-dialog": "\n .title = Chat fejlede\n .message = Der opstod en fejl under indlæsning af chatten. Du kan i stedet sende en e-mail til support.\n .buttonLabel = Forstået",
        "intercom-loading-dialog": "\n .description = Chatten indlæser...",
        "intercom-unavailable-snackbar": "Chatsupport er i øjeblikket ikke tilgængelig. Send os i stedet en e-mail på support@facilitynet.dk.",

        //ControlKitchen page
        "control-kitchen-checked-in-yes-chip": "Ja",
        "control-kitchen-checked-in-no-chip": "Nej",
        "control-kitchen-column-check-in-time": "Indtjekning tid",
        "control-kitchen-column-id": "Medarbejder-id",
        "control-kitchen-column-name": "Navn",
        "control-kitchen-column-items": "Antal",
        "control-kitchen-column-order-details": "Ordre",
        "control-kitchen-checked-in": "Indtjekket",
        "control-kitchen-checked-in-sub-title": "Dagens kontrolkode:",
        "control-kitchen-last-updated": "Sidst opdateret: {$lastUpdated}",
        "control-kitchen-refresh": "Opdater siden",
        "control-kitchen-receipt": "Kvittering",
        "control-kitchen-date-label": "Købsdato",
        "control-kitchen-date-delivery-label": "Leveringsdato",
        "control-kitchen-datetime-from-label": "Fra",
        "control-kitchen-datetime-to-label": "Til",
        "control-kitchen-period-label": "Periode",
        "control-kitchen-check-in-type": "Type",
        "control-kitchen-checked-in-filter-all": "Alle",
        "control-kitchen-checked-in-filter-checked-in": "Indtjekket",
        "control-kitchen-checked-in-filter-not-checked-in": "Ikke tjekket ind",
        "control-kitchen-control-code-not-ready": "Ikke klar",


        // News folder
        "news-published": "Publiceres: {$date}",
        "news-implemented": "Implementeret: {$date}",
        "news-created": "Oprettet: {$date}",
        "news-updated": "Opdateret: {$date}",
        "news-gopay": "Facilitynet nyheder",
        "news-roadmap": "Roadmap",
        "news-new-features": "Nye funktioner",
        "news-new-load-error": "Fejl ved indlæsning af roadmap-funktioner",
        "news-start-date": "Startdato",
        "news-end-date": "Slutdato",
        "news-type": "Type",
        "news-bug-fix": "Fejlrettelse",
        "news-new-feature": "Ny funktion",
        "news-upcoming": "Kommende",
        "news-all": "Alle",
        "news-roadmap-type-filter-bugfix": "Fejlrettelse",
        "news-roadmap-type-filter-feature": "Ny funktion",
        "news-roadmap-type-filter-upcoming": "Kommende",
        "news-implemented-feature": "Implementeret funktion",
        "news-upcoming-feature": "Kommende funktion",
        "news-current-news": "Aktuelle nyheder",
        "news-archive-news": "Arkiv",
        "news-create-new-button": "Opret ny",
        "news-draft-type": "Kladde",
        "news-published-type": "Udgivet",
        "news-schedule-type": "Planlagt",
        "news-expired-type": "Udløbet",
        "news-edit": "Rediger",
        "news-delete": "Slet",
        "news-default-error-message": "Noget gik galt",
        "news-archive-title": "Titel",
        "news-archive-expiration-date": "Udløber",
        "news-archive-active-status": "Status",
        "merchant-news-header": "\n .title = Kundenyheder",
        "news-no-news-title": "Ingen nyheder",
        "news-no-roadmap-title": "Ingen roadmaps",
        "news-no-news-body": "Opret din første nyhed ",
        "news-no-news-here-link": "her",
        "news-gopay-read-more": "Læs mere",
        "news-table-delete-success-message": "Artikel slettet",
        "create-news-header": "\n .title = Opret nyhed",
        "edit-news-header": "\n .title = Rediger nyhed",
        "nav-item-create-news-header": "Opret nyhed",
        "nav-item-edit-news-header": "Rediger nyhed",
        "create-news-save-button": "Opret",
        "edit-news-save-button": "Gem",

        // Office folder
        "office-period-total": "I alt for perioden: {$periodTotal}",
        "office-transation-period-total": "Samlede transaktioner for perioden: {$transactionPeriodTotal}",
        "office-purchase-time": "Tid",
        "office-purchase-name": "Navn",
        "office-purchase-payment-details": "Betalingsmetode",
        "office-purchase-payment-channel": "Kanal",
        "office-purchase-amount": "Beløb",
        "office-purchase-receipt": "Kvittering",
        "upcoming-orders-purchases-table-order-type": "Ordretype",
        "upcoming-orders-purchases-table-delivery-status": "Leveringsstatus",
        "upcoming-orders-purchases-table-order-type-pos": "POS",
        "upcoming-orders-purchases-table-order-type-takeaway": "Takeaway",
        "order-action-menu-refund": "Refunder",
        "order-action-menu-print-label": "Udskriv label",
        "standard-refresh-button-last-updated-label": "Opdateret { $relativeTime }",
        "standard-refresh-button-last-updated-just-now-label": "Opdateret lige nu",
        "standard-refresh-button-tooltip-hint": "Klik for at opdatere",
        "standard-refresh-button-error-tooltip": "Opdatering mislykkedes · klik for at prøve igen",
        "standard-refresh-button-aria-label": "Opdater",
        "standard-new-items-pill-label": "{ $count ->\n [one] { $count } ny ordre\n *[other] { $count } nye ordrer\n}",
        "standard-new-items-pill-show-button": "Vis",

        "office-meeting-service-title": "Mødeforplejning",
        "office-meeting-service-header": "\n .title = Mødeforplejning",
        "office-meeting-service-table-booked-start-date": "Booket startdato",
        "office-meeting-service-table-booked-end-date": "Booket slutdato",
        "office-meeting-service-table-merchant": "Salgssted",
        "office-meeting-service-table-order-id-column": "Ordre ID",
        "office-meeting-service-table-booked-date-column": "Bogføringsdato",
        "office-meeting-service-table-delivery-time-column": "Leveringstid",
        "office-meeting-service-table-creator-column": "Bestiller",
        "office-meeting-service-table-amount-column": "Beløb (DKK)",
        "office-meeting-service-table-show-receipt": "Vis kvittering",
        "office-meeting-service-table-floating-action-bar-receipts": "\n .title = Kvitteringer",
        "office-meeting-service-table-floating-action-bar-export": "\n .title = Eksport",


        // --- Profile page ---
        "profile-user-account-id": "ID:",
        "profile-administrator-for": "Administrator for",
        "profile-hosted-by": "Udlejet af",
        "profile-hosted-by-office-hotel": "Kontorhotel",
        "profile-actions": "Genveje",
        "profile-settings-card": "Indstillinger",
        "profile-password-card": "Adgangskode",
        "profile-actions-change-password": "Skift kodeord",
        "profile-actions-edit-profile": "Ret profil",
        "profile-actions-delete-account": "Slet brugerkonto",
        "profile-security": "Sikkerhed",
        "profile-security-manage-admins": "Kan administrere andre administratorer:",
        "profile-security-manage-admins-yes": "Ja",
        "profile-security-manage-admins-no": "Nej",
        "profile-security-ip-address-allowlist": "IP-adresse allowlist:",
        "profile-roles": "Dine roller",
        "profile-user-info": "Brugerkonto",
        "profile-user-type": "Brugertype",
        "profile-username": "Brugernavn:",
        "profile-email": "E-mail:",
        "profile-phone-number": "Telefonnummer:",
        "profile-mobil-number": "Mobilnummer:",
        "profile-name": "Navn:",
        "profile-page-header": "\n .title = Brugerkonto",
        "profile-nav-item-home": "Hjem",
        "profile-user-type-info-mode-supplier": "“Som leverandør-administrator kan du få adgang til og administrere salgssteder og administratorer på vegne af din virksomhed. For hvert salgssted kan du gøre alt, hvad en salgssteds-administrator kan gøre. Derudover kan du styre delte indstillinger og se tværgående rapporter.",
        "profile-user-type-info-mode-merchant": "Som salgssteds-administrator kan du administrere shops og produkter under dit salgssted. Du har også adgang til detaljerede regnskabsrapporter og produktionsoversigter, hvor du kan administrere og opfylde kundeordrer.",
        "profile-user-type-info-mode-company": "Som virksomheds-administrator kan du administrere brugere og integrationer for din virksomhed. Du kan også se regnskabsrapporter for ordrer foretaget af virksomhedens medarbejdere.",
        "profile-user-type-info-mode-office-manager": "Som office manager kan du administrere brugere og integrationer for din lejer. Du kan også se regnskabsrapporter for ordrer foretaget af virksomhedens medarbejdere.",
        "profile-user-type-info-mode-support": "Som supporter kan du administrere brugere, hardwareenheder og entiteter for hele systemet. Du kan også slå nødvendige oplysninger op om ordrer, brugere og enheder for at håndtere support tickets.",
        "profile-user-type-info-mode-user": "Som bruger kan du afgive ordrer i systemet og se dine tidligere ordrer.",
        "profile-roles-mode-agreement-owner": "Aftaleejer",
        "profile-roles-mode-bookkeeper": "Bogholder",
        "profile-roles-mode-dpo": "DPO",
        "profile-roles-mode-it-administrator": "IT-administrator",
        "profile-roles-mode-news-subscriber": "Nyhedsabonnent",
        "profile-roles-mode-system-operation-subscriber": "System-meddelelsesabonnent",
        "profile-roles-read-more": "Læs om administratorroller",
        "profile-roles-no-roles": "Du har ingen roller",
        "profile-tab-profile": "Generelt",
        "profile-tab-gdpr": "GDPR",
        "profile-gdpr-info-box": "\n .description = Her kan du downloade en kopi af dine egne personlige data, vi har registreret i Facilitynet.",
        "profile-gdpr-export-button": "Eksporter mine data",
        "profile-gdpr-correction-info-box": "\n .description = Her kan du anmode om rettelse af dine personlige data.",
        "profile-gdpr-correction-button": "Anmod om rettelse af mine data",

        // --- Profile page > Change password ---
        "profile-change-password-page-header": "\n .title = Skift kodeord",
        "profile-change-password": "Skift kodeord",
        "profile-change-password-profile": "Profil",
        "profile-change-password-profile-currentPassword": "\n .label = Nuværende kodeord",
        "profile-change-password-profile-newPassword": "\n .label = Nyt kodeord",
        "profile-change-password-profile-confirmPassword": "\n .label = Bekræft kodeord",
        "profile-change-password-profile-match-password": "Kodeord stemmer ikke overens",
        "profile-change-password-password-policy": "\n .title = Kodeordspolitik",
        "profile-change-password-default-policy": "Facilitynet standardpolitik",
        "profile-change-password-info": "Kontakt venligst support for at definere eller ændre politikken for din organisation.",
        "profile-change-password-submit-button": "Opdatere adgangskode",

        // --- Change User Account > Dialog ---
        "change-user-account-dialog-title": "Skift brugerkonto",
        "change-user-account-dialog-pending-state-email-has-been-sent": "An email has been sent. Please check you email inbox.",
        "change-user-account-dialog-pending-state-pending-approval":
            "Afventer godkendelse...\n .loadingLabel = Afventer godkendelse...",
        "change-user-account-dialog-confirm-email-subtitle": "Før du kan skifte mellem dine brugerkonti, skal du bekræfte, at du ejer e-mailkontoen <element>{ $email }</element>.",
        "change-user-account-dialog-click-below-subtitle": "Klik på knappen nedenfor for at sende mig et bekræftelseslink:",
        "change-user-account-dialog-send-confirmation-button": "Send bekræftelseslink",
        "change-user-account-dialog-empty-content-subtitle": "No other user accounts were found with the email:",
        "change-user-account-dialog-users-list-available-accounts-subtitle": "Du har { $totalUserAccounts } andre brugerkonti med e-mailen: { $email }",
        "change-user-account-dialog-users-list-swift-to-another-account": "Swift to another account below:",
        "change-user-account-dialog-error-message": "Vi kunne ikke indlæse dine konti. Skift af konto er muligvis ikke tilgængeligt for denne kontotype.",

        // User Types
        "profile-usertype-support": "{ -user-type-support }",
        "profile-usertype-supplier": "{ -user-type-supplier }",
        "profile-usertype-merchant": "{ -user-type-merchant }",
        "profile-usertype-company": "{ -user-type-company }",
        "profile-usertype-office-manager": "{ -user-type-office-manager }",
        "profile-usertype-user": "{ -user-type-user }",
        "profile-usertype-service-center": "{ -user-type-service-center }",




        // --- Settings page ---
        "settings-page-header": "\n .title = Indstillinger",
        "settings-title": "Indstillinger",
        "settings-nav-item-home": "Hjem",
        "settings-language-setting": "Sprog",
        "settings-social-media-label": "Sociale medier",
        "settings-social-media-text": "Følg os på LinkedIn",
        "settings-notifications-label": "Notifikationer",
        "settings-sms-notifications": "SMS notifikationer",
        "settings-receipts-meeting-service": "Kvitteringer for mødeservice",
        "settings-receipts-canteen": "Kvitteringer for kantine",


        // --- Admin home card ---
        "admin-home-card-show-all-button": "Vis alle",


        // Back Button
        "back-button-label": "Tilbage",

        //AvatarMenu
        "avatar-menu-tooltip": "Åbn indstillinger",


        // ArticleSettingsPanel
        "article-settings-panel-settings-title": "\n .title = Visning",
        "article-settings-panel-published": "\n .label = Publiceret",
        "article-settings-panel-schedule-for": "\n .label = Udgivelsesdato",
        "article-settings-panel-expires": "\n .label = Udløbsdato",

        // CardDropdownMenu

        // ImageUploader
        "image-uploader-button-label": "Upload billede",
        "image-uploader-drag-and-drop": "Træk og slip eller Gennemse",
        "image-uploader-max-file-size-exceeded": "Filen er større end grænsen på { $maxFileSize }.",
        "image-previewer-button-label": "Upload nyt billede",
        "image-previewer-button-delete": "Slet",




        // CreateOrEditMerchantArticle
        "create-or-edit-merchant-article-mode-normal-article": "Normal artikel",
        "create-or-edit-merchant-article-mode-external-article": "Ekstern artikel",
        "create-or-edit-merchant-article-mode-product-news": "Produkt nyheder",
        "create-or-edit-merchant-article-title": "\n .label = Titel",
        "create-or-edit-merchant-article-body": `\n .placeholder = Beskrivelse\n .helperText = Resterende tegn: { $charsRemaining }`,
        "create-or-edit-merchant-article-body-too-long": `Du har overskredet det maksimale antal tegn: { $charsLimit }`,
        "create-or-edit-merchant-article-product-id": "\n .label = Produkt id",
        "create-or-edit-merchant-article-info-label-draft": "\n .label = Artiklen er et udkast. Den vil ikke være synlig for brugerne, før du udgiver den.",
        "create-or-edit-merchant-article-info-label-schedule": "\n .label = Artiklen er planlagt til publicering den: { $date }",
        "create-or-edit-merchant-article-type": "\n .label = Artikel type",
        "create-or-edit-merchant-article-delete": "artikel",
        "news-create-image-field-label": "\n .label = Upload billede",

        // CreateAndPublishSplitButton
        "create-and-publish-split-button-create-draft": "Kladde",
        "create-and-publish-split-button-publish": "Udgiv",
        "create-and-publish-split-button-save": "Gem",
        "create-and-publish-split-button-unpublish": "Fjern",
        "create-and-publish-split-button-cancel-publication": "Annuller udgivelsen publication",
        "create-and-publish-split-button-republish": "Genudgiv",


        "table-summary-box-total-period": "\n .title = Total i denne periode",
        "table-summary-box-number-of-orders": "\n .title = Antal ordrer",
        "table-summary-box-number-of-subscriptions": "\n .title = Antal abonnementer",

        // --- Office manager ---

        // Navigation
        "tenant-nav-item-home": "Hjem",

        // - reporting
        "tenant-nav-item-accounting": "\n .title = Regnskab",
        "tenant-nav-item-accounting-header": "Regnskab",
        "tenant-nav-item-pos": "POS",
        "tenant-nav-item-meeting-service": "Mødeforplejning",
        "tenant-nav-item-subscriptions": "Abonnementer",

        // - admin
        "tenant-nav-item-users": "Brugere",
        "tenant-nav-item-organization-page-header":"\n .title = Organisation",
        "tenant-nav-item-organization-header":"Organisation",
        "tenant-nav-item-administrators": "Administratorer",

        // Reporting pages

        // Home
        "tenant-reports-home-placeholder": "\n .title = Office manager dashboard kommer snart\n .body = Dit dashboard vil vise en oversigt over vigtige nøgletal, så du altid har et godt overblik over dine medarbejderes køb.",

        // Purchases
        "tenant-purchases-header": "\n .title = POS",
        "tenant-subscriptions-header": "\n .title = Abonnementer",

        // Admin pages

        // Home
        "office-manager-home-user-card-group": "\n .title = Brugere",
        "office-manager-home-user-admin-placeholder": "Kommer snart. Her vil du kunne styre brugere og administratorer under din organisation.",
        "office-manager-home-user-card": "  \n .title = Brugere\n .description = Administrer brugere for din organisation",
        "office-manager-home-admin-card": "  \n .title = Administratorer\n .description = Administrer jeres administratorer",
        "office-manager-home-card-show-all": "Vis alle",
        "office-manager-users-header": "\n .title = Brugere",
        "office-manager-users-tab-users": "Brugere",
        "office-manager-users-tab-admins": "Administratorer",
        "office-manager-users-table-id-column": "Medarbejder-id",
        "office-manager-users-table-name-column": "Navn",
        "office-manager-users-table-email-column": "E-mail",
        "office-manager-users-table-status-column": "Status",
        "office-manager-users-table-status-column-active": "Aktiv",
        "office-manager-users-table-status-column-inactive": "Inaktiv",
        "office-manager-user-show-details": "Vis detaljer",
        "office-manager-user-edit": "Ret bruger",
        "office-manager-user-delete": "Slet bruger",
        "office-manager-user-delete-title": "bruger",
        "office-manager-users-create-user-button": "Opret ny",
        "office-manager-users-create-admin-button": "Opret ny",
        "office-manager-user-details-dialog-title": "Brugerdetaljer",
        "office-manager-settings-panel": "\n .title = Indstillinger",
        "office-manager-settings-send-invitation": "Send e-mailinvitation",
        "office-manager-settings-disable-sync": "Frakobl synkroniseringsjob",
        "office-manager-settings-disable-sync-text": "Hvis frakoblet, vil denne bruger blive ignoreret af brugersynkroniseringsjob.",

        // show user details dialog
        "user-details-user-id": "Bruger-id:",
        "user-details-employee-id": "Medarbejder-id:",
        "user-details-user-group": "Brugergruppe:",
        "user-details-department": "Afdeling:",
        "user-details-workgroups-title": "Arbejdsgrupper",
        "user-details-name": "Navn:",
        "user-details-role-type-news-subscriber" : "Nyhedsabonnent",
        "user-details-role-type-system-operation-subscriber" : "System status-abonnent",
        "user-details-email": "E-mail:",
        "user-details-mobile": "Mobilnr.:",
        "user-details-phone": "Tlfnr.:",
        "user-details-language": "Sprog:",
        "user-details-role": "Brugerroller:",
        "user-details-settings-title": "Indstillinger",
        "user-details-sync-jobs": "Frakoblet synkroniseringsjob:",
        "user-details-sync-jobs-ignored": "JA",
        "user-details-sync-jobs-included": "NEJ",
        "user-details-security-title": "Sikkerhed",
        "user-details-security-settings-yes": "JA",
        "user-details-security-settings-no": "NEJ",
        "user-details-security-manage-admins": "Kan administrere andre administratorer:",
        "user-details-security-ip-address": "Tilladte IP-adresser:",
        "user-details-history-title": "Historik",
        "user-details-history-created": "Oprettet:",
        "user-details-history-edited": "Sidst ændret:",

        //Create user form
        "office-manager-create-user-form": "Opret",
        "office-manager-edit-user-form": "Gem",
        "office-manager-create-user-form-title": "\n .title = Opret bruger",
        "office-manager-edit-user-form-title": "\n .title = Ret bruger",
        "office-manager-create-user-home-breadcrumb": "Hjem",
        "office-manager-create-user-users-breadcrumb": "Konto",
        "office-manager-create-user-create-breadcrumb": "Opret bruger",
        "office-manager-create-user-edit-breadcrumb": "Ret bruger",
        "office-manager-create-user-missing-context-error":
            "Kunne ikke afgøre, hvilken konto denne bruger hører til. Genindlæs siden, og prøv igen.",
        "office-manager-create-admin-missing-context-error":
            "Kunne ikke afgøre, hvilken konto denne administrator hører til. Genindlæs siden, og prøv igen.",
        // Create/edit administrator pages (shared across all portals)
        "administrators-create-page-title": "\n .title = Opret administrator",
        "administrators-create-page-save-button": "Opret",
        "administrators-create-breadcrumb": "Opret administrator",
        "administrators-edit-page-title": "\n .title = Ret administrator",
        "administrators-edit-page-save-button": "Gem",
        "administrators-edit-breadcrumb": "Ret administrator",
        "office-manager-create-user-field-id": "\n .label = Medarbejder-id",
        "office-manager-create-user-field-username": "\n .label = Brugernavn",
        "office-manager-create-user-field-name": "\n .label = Navn",
        "office-manager-create-user-field-email": "\n .label = E-mail",
        "office-manager-create-user-field-mobile": "\n .label = Mobilnr.",
        "office-manager-create-user-field-phone": "\n .label = Tlfnr.",
        "office-manager-create-user-field-active": "Aktiv",
        "office-manager-settings-resend-invitation": "Send invitation igen",
        "office-manager-security-panel": "\n .title = Sikkerhed",
        "office-manager-security-manage-admins": "Kan administrere andre admins",
        "office-manager-security-pin-field": "\n .label = PIN-kode",
        "office-manager-security-pin-info": "\n .title = PIN-koden bruges af medarbejdere til at logge ind på POS-skærmen.",
        "office-manager-security-pin-invalid": "PIN-koden skal være 4 cifre",
        "office-manager-create-user-required-field-empty": "Dette felt er påkrævet",
        "office-manager-create-user-invalid-email-address": "Ugyldig e-mailadresse",
        "office-manager-create-user-invalid-phone-number": "Ugyldigt telefonnummer",

        // Create or edit room
        "resource-room-create-form-title": "\n .title = Opret lokale",
        "resource-room-edit-form-title": "\n .title = Rediger lokale",
        "resource-room-create-required-field-empty": "Dette felt er påkrævet",
        "resource-room-create-user-home-breadcrumb": "Hjem",
        "resource-room-create-user-users-breadcrumb": "Brugere",
        "resource-room-create-room-breadcrumb":"Opret lokale",
        "resource-room-edit-room-breadcrumb":"Rediger lokale",


        // Purchases page
        "tenant-pos-title": "POS",
        "tenant-purchases-tab-orders": "\n .title = Ordrer",
        "tenant-purchases-tab-subscriptions-details": "Detaljer",
        "tenant-purchases-tab-subscriptions-cancel": "Opsig",

        //Admin roles field
        "tenant-admin-roles-field-label": "Tildel roller",
        "tenant-admin-role-agreement-owner": "System-ejer",
        "tenant-admin-role-dpo": "GDPR-ansvarlig",
        "tenant-admin-role-it-administrator": "IT-administrator",
        "tenant-admin-role-bookkeeper": "Bogholder",
        "tenant-admin-role-news-subscriber": "Nyhedsabonnent",
        "tenant-admin-role-system-operation-subscriber": "Systemdrift abonnent",


        // Survey Page
        "survey-header": "\n .title = Brugertilfredshed",
        "survey-tab-overview": "Overblik",
        "survey-tab-ratings": "Alle bedømmelser",
        "survey-tab-ratings-no-survey-data": "Ingen data tilgængelige",
        "survey-tab-overview-no-surveys": "Ingen undersøgelser defineret endnu.",
        "survey-tab-overview-no-questions": "Ingen spørgsmål defineret for denne undersøgelse.",
        "survey-tab-ratings-good-topics-card": "\n .title = Tilfredse med\n .datasetLabel = Bedømmelser",
        "survey-tab-ratings-bad-topics-card": "\n .title = Utilfredse med\n .datasetLabel = Bedømmelser",
        "survey-tab-overview-trend-card": "\n .title = Udvikling af tilfredshed\n .scoreLabel = Gennemsnitsscore\n .votesLabel = Antal bedømmelser",
        "survey-tab-comment": "Kommentar",
        "survey-tab-surveys": "Brugerundersøgelser",
        "survey-period-select": "\n .label = Periode",
        "survey-period-today": "I dag",
        "survey-period-last-day": "Sidste døgn",
        "survey-period-last-week": "Sidste uge",
        "survey-period-last-month": "Sidste måned",
        "survey-period-last-quarter": "Sidste kvartal",
        "survey-period-last-year": "Sidste år",

        // All rating
        "all-rating-time": "Tid",
        "all-rating-question": "Spørgsmål",
        "all-rating-score": "Score",
        "all-rating-topics": "Emner",
        "all-rating-comment": "Kommentar",

        // SelectSurvey
        "select-survey": "\n .label = Brugerundersøgelse",

        // --- Smiley summary card ---
        "survey-smiley-summary-card": "\n .title = Samlet score",
        "survey-smiley-summary-card-overall-score-label": "Score: { $averageScore }",

        // --- Survey participation card ---
        "survey-participation-card": "\n .title = Deltagelse",
        "survey-participation-card-participants-label": "Deltagere",
        "survey-participation-card-non-participants-label": "Ikke deltagende",
        "survey-participation-card-participation-label": "Procentdel",
        "survey-participation-card-participation-breakdown": "{ $ratings } besvarelser af { $orders } køb",

        // --- Survey smiley distribution card ---
        "survey-smiley-distribution-card": "\n .title = Tilfredshed",
        "survey-smiley-distribution-card-votes-label": "Bedømmelser",
        "smiley-label-bad": "Meget dårlig",
        "smiley-label-poor": "Ringe",
        "smiley-label-medium": "Middel",
        "smiley-label-good": "God",
        "smiley-label-excellent": "Fremragende",


        // Production
        "production-meeting-service-breadcrumb": "Mødeforplejning",
        "production-planning-breadcrumb": "Planlægning",
        "production-pos-purchases-breadcrumb": "POS køb",
        "production-takeaway-page-header": "\n .title = Takeaway",
        "production-takeaway-breadcrumb": "Takeaway",
        "production-transactions-print-label": "Print etiket",
        "production-table-toolbar-banner-unprinted-receipts-message": "Kvitteringer er ikke udskrevet på cloudprinteren.",
        "production-table-toolbar-banner-show-button": "Vis",
        "production-table-toolbar-banner-showing-unprinted-message": "Viser ikke-udskrevne ordrer.",
        "production-table-toolbar-banner-clear-filter-button": "Ryd filter",
        "production-planning-page-header": "\n .title = Planlægning",
        "production-meeting-service-page-header": "\n .title = Mødeforplejning",
        "meeting-service-production-view-fullscreen-link": "Fuldskærmstilstand",
        "meeting-service-production-view-tab-delivery-time": "Leveringstid",
        "meeting-service-production-view-tab-delivery-location": "Leveringssted",
        "meeting-service-production-view-not-approved-toggle": "Ikke godkendt",
        "meeting-service-production-view-sittings-label": "\n .title = Siddepladser:",
        "meeting-service-production-view-host-label": "\n .title = Mødeansvarlig:",
        "meeting-service-production-view-meeting-time-label": "\n .title = Mødetid:",
        "meeting-service-production-view-users-dialog-title": "Kontaktoplysninger",
        "meeting-service-production-view-users-dialog-name-label": "Navn:",
        "meeting-service-production-view-users-dialog-email-label": "E-mail:",
        "meeting-service-production-view-users-dialog-phone-label": "Telefon:",
        "meeting-service-production-view-select-all-orders": "\n .label = Vælg alle",
        "meeting-service-production-view-organizer-type-creator": "Opretter",
        "meeting-service-production-view-organizer-type-organizer": "Arrangør",
        "meeting-service-production-view-organizer-type-responsible": "Ansvarlig",
        "meeting-service-production-view-hour-group-orders-count": "{ $count -> \n *[other] { $count } ordrer \n [one] { $count } ordre \n }",
        "meeting-service-production-view-ready-count": "{ $ready }/{ $total } klar",
        "meeting-service-production-view-card-menu-button": "\n .aria-label = Mere",
        "meeting-service-production-view-card-full-edit": "Fuld redigering",
        "meeting-service-production-view-card-delete-button": "Slet",
        "meeting-service-production-view-edit-items-button": "Rediger",
        "meeting-service-production-view-saved-dialog-title": "Ordre opdateret",
        "meeting-service-production-view-print-menu": "Udskriv",
        "meeting-service-production-view-print-menu-tooltip": "\n .title = Udskriv",
        "meeting-service-production-view-location-unknown": "Ukendt sted",
        "meeting-service-production-view-filter-button": "Filtre",
        "meeting-service-production-view-search-input": "\n .placeholder = Søg efter ordre-id, mødenavn, lokation eller person.\n .title = Søg efter ordre-id, mødenavn, lokation eller person.",
        "meeting-service-production-view-date-button": "Vælg dato",
        "meeting-service-production-view-time-left": "{ $minutes } min tilbage",
        "meeting-service-production-view-order-comment-read-more": "Læs mere",
        "meeting-service-production-view-order-comment-dialog-title": "Ordrekommentar",
        "meeting-service-production-filter-delivery-title": "\n .title = Levering",
        "meeting-service-production-filter-locked-label": "Låst",
        "meeting-service-production-filter-locked-all": "Alle",
        "meeting-service-production-filter-locked-locked": "Låst",
        "meeting-service-production-filter-locked-unlocked": "Ulåst",
        "meeting-service-production-view-add-menu-button": "Tilføj produkt",
        "meeting-service-production-view-add-menu-catalog": "Vare fra katalog",
        "meeting-service-production-view-add-menu-wish": "Fritekst-ønske",
        "meeting-service-production-view-add-menu-extra-service": "Service",
        "meeting-service-order-drawer-order-number": "Ordre #{ $number }",
        "meeting-service-order-drawer-delivery-tab": "LEVERING { $index }",
        "meeting-service-order-drawer-order-lines-title": "Ordrelinjer",
        "meeting-service-order-drawer-total-label": "TOTAL",
        "meeting-service-order-drawer-status": "Status",
        "meeting-service-order-drawer-delivery-time": "Leveringstid",
        "meeting-service-order-drawer-contact": "Kontakt",
        "meeting-service-order-drawer-contact-info-button": "\n .title = Vis kontaktoplysninger",
        "meeting-service-order-drawer-contact-dialog-title": "Kontaktoplysninger",
        "meeting-service-contact-info-disclaimer": "\n .title = Kundens kontaktoplysninger. Behandl dem fortroligt.",
        "meeting-service-contact-info-print-footer": "Fortroligt: indeholder kundens kontaktoplysninger",
        "meeting-service-order-drawer-covers": "Kuverter",
        "meeting-service-order-drawer-covers-value": "{ $count } personer",
        "meeting-service-order-drawer-delivery-type": "Leveringstype",
        "meeting-service-order-drawer-location": "Leveringssted",
        "meeting-service-order-drawer-order-note": "Ordrenote",
        "meeting-service-order-drawer-chat-customer": "Chat med kantinen",
        "meeting-service-recurrence-series-button-tooltip": "Vis alle ordrer i serien",
        "meeting-service-recurrence-series-drawer-subtitle": "Tilbagevendende serie · { $count ->\n [one] { $count } ordre\n *[other] { $count } ordrer\n}",
        "meeting-service-recurrence-series-drawer-recurrence": "Gentagelse",
        "meeting-service-recurrence-series-drawer-period": "Periode",
        "meeting-service-recurrence-series-drawer-contact": "Kontakt",
        "meeting-service-recurrence-series-drawer-covers": "Kuverter",
        "meeting-service-recurrence-series-drawer-covers-value": "{ $count } personer",
        "meeting-service-recurrence-series-drawer-delivery-type": "Leveringstype",
        "meeting-service-recurrence-series-drawer-location": "Leveringssted",
        "meeting-service-recurrence-series-drawer-orders-title": "Ordrer i serien",
        "meeting-service-recurrence-series-drawer-orders-id-column": "Ordre-ID",
        "meeting-service-recurrence-series-drawer-orders-date-column": "Leveringsdato",
        "meeting-service-recurrence-series-drawer-current-order": "Denne ordre",
        "meeting-service-recurrence-series-drawer-locked": "Låst",
        "meeting-service-recurrence-series-drawer-orders-empty": "Ingen ordrer fundet i denne serie",
        "meeting-service-recurrence-series-drawer-close-button": "Luk",
        "meeting-service-recurrence-series-drawer-subtitle-no-count": "Tilbagevendende serie",
        "meeting-service-recurrence-series-drawer-order-menu-button": "Flere handlinger for ordre { $orderId }",
        "meeting-service-recurrence-series-drawer-order-menu-view": "Vis ordre",
        "meeting-service-recurrence-series-drawer-order-menu-edit": "Rediger ordre",
        "meeting-service-recurrence-series-drawer-order-menu-copy": "Kopiér ordre",
        "meeting-service-recurrence-series-drawer-order-menu-print": "Udskriv ordre",
        "meeting-service-order-drawer-chat-merchant": "Chat med kunden",
        "meeting-service-order-drawer-replied": "Besvaret",
        "meeting-service-order-drawer-quick-edit": "Hurtig redigering",
        "meeting-service-order-drawer-quick-edit-save-button": "Gem",
        "meeting-service-order-drawer-full-edit": "Fuld redigering",
        "meeting-service-order-drawer-delivery-label": "Levering { $index }",
        "meeting-service-order-drawer-total": "Total",
        "meeting-service-order-drawer-vat": "Inkl. moms ({ $rate }%)",
        "meeting-service-order-drawer-order-lines-count": "{ $count } ordrelinjer",
        "meeting-service-order-drawer-send": "Send",
        "meeting-service-order-drawer-add-catalog-title": "Vare fra katalog",
        "meeting-service-order-drawer-add-catalog-desc": "Søg i kataloget — pris udfyldes automatisk",
        "meeting-service-order-drawer-add-wish-title": "Fritekst-ønske",
        "meeting-service-order-drawer-add-wish-desc": "Fri tekst — køkkenchefen gennemgår den",
        "meeting-service-order-drawer-add-service-title": "Service",
        "meeting-service-order-drawer-add-service-desc": "Opdækning, servering, oprydning m.m.",
        "meeting-service-order-drawer-messages-empty": "Ingen beskeder endnu",
        "meeting-service-order-drawer-duplicate": "Dupliker",
        "meeting-service-order-drawer-resource-bookings": "Ressourcebookinger",
        "meeting-service-order-drawer-booking-time": "Bookingtid",
        "meeting-service-order-drawer-load-error": "Kunne ikke indlæse ordren",
        "meeting-service-order-drawer-retry": "Prøv igen",
        "meeting-service-order-drawer-saved-snackbar": "Ordren er opdateret",
        "meeting-service-production-view-wish-badge": "\n .label = Ønske",
        "meeting-service-production-view-service-badge": "\n .label = Service",
        "meeting-service-production-view-legacy-service-tooltip": "\n .title = Dette er en ekstra service fra den gamle portal. Den kan ikke ændres, men den kan fjernes.",
        "meeting-service-production-view-service-already-added-snackbar": "Servicen er allerede tilføjet til denne levering, så den kan ikke tilføjes igen.",
        "meeting-service-production-view-only-services-snackbar": "En ordre kan ikke kun bestå af services. Tilføj mindst ét produkt.",
        "meeting-service-production-view-add-service-confirm-button": "Tilføj",
        "meeting-service-production-view-add-service-required-error": "Dette felt er påkrævet",
        "meeting-service-production-view-wish-name-field": "\n .placeholder = Produktnavn",
        "meeting-service-production-view-wish-price-field": "\n .placeholder = Pris",
        "meeting-service-production-view-add-product-autocomplete-label": "Vælg produkt",
        "meeting-service-production-view-add-extra-service-autocomplete-label": "Vælg ekstra service",
        "meeting-service-production-view-add-picker-cancel": "Annuller",
        "meeting-service-production-view-save-changes-button": "Færdig",
        "meeting-service-production-view-total-with-amount": "I alt: { $amount }",
        "meeting-service-production-view-product-search-placeholder": "Søg ret",
        "meeting-service-production-view-product-out-of-stock": "Udsolgt",
        "meeting-service-production-view-product-already-added-snackbar": "Produktet er allerede tilføjet til denne ordre, så det kan ikke tilføjes igen. Opdater i stedet den eksisterende ordrelinje.",
        "meeting-service-production-view-product-required": "Produkt er påkrævet",
        "meeting-service-production-view-saved-banner": "\n .title = Ordre #{ $orderNumber } er opdateret. Total: { $total }",
        "meeting-service-production-view-saved-banner-no-total": "\n .title = Ordre #{ $orderNumber } er opdateret",
        "meeting-service-production-view-cancel-button": "Annuller",
        "meeting-service-production-view-remove-line-button": "\n .aria-label = Fjern",
        "meeting-service-production-view-product-name-dialog-title": "Produktnavn",
        "meeting-service-production-view-meeting-name-dialog-title": "Mødenavn",
        "meeting-service-production-view-empty": "Ingen ordrer at producere",
        "production-pos-purchases-page-header": "\n .title = POS køb",
        "production-tab-production-list": "Produktionsliste",
        "production-tab-pos-transactions": "POS transaktioner",
        "production-tab-orders": "Produktion {$amount}",
        "planning-tab-takeaway": "Takeaway",
        "planning-tab-calendar": "Kalender",
        "planning-tab-not-approved": "Afventer godkendelse {$amount}",
        "planning-tab-to-be-booked": "Skal bogføres {$amount}",
        "planning-tabs-placeholder": "\n .title = Kommer snart \n .body = Vi arbejder på at levere denne funktion til dig.",
        "production-list-no-result": "Ingen resultater",
        "production-orders-action-bar-confirm-queue-remove-dialog": "\n .title = Fjern fra printerkø\n .message = Er du sikker på at du vil fjerne de valgte kvitteringer fra printerkøen?\n .buttonLabelSubmit = Fjern",
        "production-orders-action-bar-confirm-print-dialog": "\n .title = Udskriv kvitteringer\n .message = Er du sikker på, at du vil udskrive de valgte kvitteringer?\n .buttonLabelSubmit = Udskriv",
        "production-meeting-service-shortcuts-button": "Genveje",
        "production-meeting-service-shortcut-booked-orders": "Bogførte ordrer",
        "production-meeting-service-search-field": "\n .label = Søg ordre\n .placeholder = Indtast ordrenr., mødenavn eller værtens navn.",
        "production-orders-search-field": "\n .label = Søg ordre\n .placeholder = Indtast ordrenr., navn eller e-mail.",
        "accounting-orders-search-field": "\n .label = Søg ordre\n .placeholder = Indtast ordrenr., navn eller e-mail.",
        "accounting-orders-meeting-service-search-field": "\n .label = Søg ordre\n .placeholder = Indtast ordrenr., mødenavn eller værtens navn.",

        // Production package slip
        "production-package-slip-order-error": "Kunne ikke indlæse følgeseddel med id #{ $orderId }",
        "production-package-slip-order-error-description": "Denne ordre kunne ikke behandles på grund af manglende eller ugyldige data.",
        "production-package-slip-order-id-number": "Ordre ID: {$orderId}",
        "production-package-slip-section-delivery-details-title": "Leveringsdetaljer",
        "production-package-slip-section-delivery-details-type": "Leveringstype:",
        "production-package-slip-section-delivery-details-time": "Leveringstid:",
        "production-package-slip-section-delivery-details-meeting-time": "Mødetid:",
        "production-package-slip-section-delivery-details-location": "Leveringssted:",
        "production-package-slip-section-delivery-details-sittings": "Kuverter:",
        "production-package-slip-section-delivery-details-merchant": "Leverandør:",
        "production-package-slip-section-contact-details-title": "Kontaktoplysninger",
        "production-package-slip-section-contact-details-meeting-creator": "\n .label = Opretter:",
        "production-package-slip-section-contact-details-meeting-host": "\n .label = Mødevært:",
        "production-package-slip-table-column-items": "Antal",
        "production-package-slip-table-column-products": "Produkter",
        "production-package-slip-table-column-delivery-time": "Leveringstid",
        "production-package-slip-section-note-title": "Note",
        "production-package-slip-section-header-slip-title": "Følgeseddel",
        "print-page-header-printed-label": "{ $title } · udskrevet { $date } kl. { $time }",
        "print-page-footer-page-counter": "Side { $page } af { $pages }",
        "print-page-footer-order-label": "Ordre { $orderId }",
        "production-export-exported-label": "Eksporteret",
        "production-package-slip-section-header-digital-slip-title": "Digital seddel",
        "production-package-slip-header-orders-count": "Følgesedler: {$orderCount} valgt",
        "production-package-slip-navigation-counter": "Følgeseddel { $current } af { $total }",

        // Production credit note
        "production-credit-note-dialog-title": "\n .dialogTitle = Opret kreditnota",
        "production-credit-note-credit-info": "\n .title = En kreditnota bruges til at tilbageføre dele af en bogført ordre.",
        "production-credit-note-debit-info": "\n .title = En tillægsordre bruges til at tilføje varer til en ordre, der allerede er bogført.",
        "production-credit-note-table-column-order-id": "Ordre-ID",
        "production-credit-note-table-column-type": "Type",
        "production-credit-note-table-column-booked": "Bogført",
        "production-credit-note-table-column-amount": "Beløb (DKK)",
        "production-credit-note-table-column-type-cell-original-order": "Oprindelig ordre",
        "production-credit-note-table-column-type-cell-credit": "Kreditnota",
        "production-credit-note-table-column-type-cell-debit": "Tillægsordre",
        "production-credit-note-button-next": "Næste",
        "production-credit-note-button-cancel": "Annuller",
        "production-credit-note-select-label": "Opret",

        // Accounting
        "accounting-header": "\n .title = Regnskab",
        "accounting-product-sales-page-header": "\n .title = Produktsalg",
        "merchant-nav-item-accounting-product-sales": "Produktsalg",
        "accounting-orders-page-header": "\n .title = Ordrer",
        "merchant-nav-item-accounting-orders": "Ordrer",
        "accounting-subscriptions-page-header": "\n .title = Abonnementer",
        "merchant-nav-item-accounting-subscriptions": "Abonnementer",
        "accounting-cash-register-page-header": "\n .title = Saldo",
        "merchant-nav-item-accounting-cash-register": "Saldo",
        "accounting-customers-page-header": "\n .title = Kunder",
        "merchant-nav-item-accounting-customers": "Kunder",
        "accounting-customer-balance-page-header": "\n .title = Brugersaldo",
        "merchant-nav-item-accounting-customer-balance": "Brugersaldo",
        "merchant-nav-item-accounting-z-report": "Z-rapport",
        "merchant-nav-item-accounting-custom-reports": "Tilpassede rapporter",
        "merchant-accounting-z-reports-table-date-range-filter": "\n .label = Datointerval",

        "accounting-product-sales-breadcrumb-title": "Produktsalg",
        "accounting-orders-breadcrumb-title": "Ordrer",
        "accounting-subscriptions-breadcrumb-title": "Abonnementer",
        "accounting-cash-register-breadcrumb-title": "Saldo",
        "accounting-customers-breadcrumb-title": "Kunder",
        "accounting-customer-balance-breadcrumb-title": "Brugersaldo",
        "accounting-customers-button-expand-all": "Udvid alle",
        "accounting-customers-button-collapse-all": "Luk alle",

        "accounting-orders-tab-transactions": "Transaktioner",
        "accounting-orders-tab-refill": "Tank-op",
        "accounting-orders-tab-meetingService": "Mødeforplejning",
        "transactions-table-list-refund-title": "Refundering",
        "transactions-table-list-refund": "\n .title = Refund\n .message = Er du sikker på, at du vil refundere ordre #{ $orderId } ({ $amount })?\n .buttonLabelSubmit = Bekræft\n .buttonLabelCancel = Annuller",
        "transactions-table-list-refund-success-dialog-title": "Ordre blev refunderet",
        "transactions-table-list-refund-error-message": "Kunne ikke refundere ordre. Prøv venligst igen.",
        "order-accounting-refund-pos-order-confirm-dialog": "\n .title = Refund \n .message = Er du sikker på, at du vil refundere ordre #{ $orderId }? \n .buttonLabelSubmit = Bekræft\n .buttonLabelCancel = Annuller",
        "order-accounting-refund-pos-order-title": "Refundering",
        "order-accounting-refund-pos-order-locked-dialog-title": "Ordre kan ikke refunderes",
        "order-accounting-refund-pos-order-locked-dialog-body": "Denne ordre kan ikke refunderes.",
        "order-accounting-refund-pos-order-already-refunded-title": "Ordre allerede refunderet",
        "order-accounting-refund-pos-order-already-refunded-body": "Denne ordre er allerede blevet refunderet.",
        "transactions-table-list-message-customer": "Besked til kunde",

        "filter-menu-title": "Filtre",
        "filter-menu-clear-all-button": "Fjern alle",
        "filter-menu-clear-button": "Fjern",

        "filter-menu-accordion-shops-title": "\n .title = Butikker",
        "filter-menu-accordion-customers-title": "\n .title = Kunder",
        "filter-menu-accordion-transactions-order-details-title": "\n .title = Ordredetaljer",
        "filter-menu-accordion-transactions-order-number": "\n .label = Ordrenummer \n .placeholder = Søg efter ordrenr...",
        "filter-menu-accordion-transactions-user": "\n .label = Bruger \n .placeholder = Indtast id eller e-mail",

        "standard-email-filter-label": "\n .label = E-mail",
        "standard-email-filter-error-message": "Ugyldig e-mailadresse",
        "standard-id-filter-order-id-label": "\n .label = Ordre ID",
        "standard-id-filter-employee-id-label": "\n .label = Medarbejder ID",
        "standard-id-filter-only-numbers-error-message": "Må kun indeholde tal",
        "standard-last-4-numbers-filter": "\n .label = Kreditkort, sidste 4 cifre",
        "standard-last-4-numbers-filter-error-message": "Kun de sidste 4 tal",
        "standard-payment-method-input-label": "Betalingsmetode",
        "standard-payment-method-item-credit-card": "Kreditkort",
        "standard-payment-method-item-contant": "Kontant",
        "standard-payment-method-item-invoicing": "Fakturering",
        "standard-payment-method-item-wallet": "Wallet",
        "standard-payment-method-item-free": "Gratis",
        "standard-merchants-filter-label": "Salgssteder",
        "standard-merchants-shops-filter-label": "Butikker",



        "standard-start-date-picker": "\n .label = Startdato",
        "standard-end-date-picker": "\n .label = Slutdato",
        "standard-period-date-picker": "Periode",

        "table-select-data-type-filter-on-label": "Filtrer på",
        "table-select-data-type-filter-on-label-label": "\n .label = Filtrer på",
        "table-select-data-type-filter-on-item-order-date": "Ordredato",
        "table-select-data-type-filter-on-item-delivery-date": "Leveringsdato",
        "table-select-data-type-filter-on-item-booked-date": "Bookingdato",

        "table-select-date-period-filter-by-label": "Periode",
        "table-select-date-period-filter-by-label-label": "\n .label = Periode",
        "table-select-date-period-filter-by-all": "Alle",
        "table-select-date-period-filter-by-today": "I dag",
        "table-select-date-period-filter-by-yesterday": "I går",
        "table-select-date-period-filter-by-tomorrow": "I morgen",
        "table-select-date-period-filter-by-this-week": "Denne uge",
        "table-select-date-period-filter-by-this-month": "Denne måned",
        "table-select-date-period-filter-by-7d": "Næste 7 dage",
        "table-select-date-period-filter-by-30d": "Næste 30 dage",

        "table-select-resource-type-filter-by-label": "Ressourcetype",
        "table-select-resource-type-filter-by-label-label": "\n .label = Ressourcetype",
        "table-select-resource-type-filter-by-all": "Alle",
        "table-select-resource-type-filter-by-room": "Lokale",
        "table-select-resource-type-filter-by-mobile-av": "Mobile av",
        "table-select-resource-type-filter-by-car": "Bil",

        "resource-dashboard-type-all": "Alle typer",
        "resource-dashboard-type-room": "Mødelokaler",
        "resource-dashboard-type-mobile-av": "AV-udstyr",
        "resource-dashboard-type-car": "Biler",

        "standard-order-type-filter-mode-all": "Alle",
        "standard-order-type-filter-mode-pos": "POS",
        "standard-order-type-filter-mode-lunch": "Kantine",
        "standard-order-type-filter-mode-meeting-service": "Mødeforplejning",
        "standard-order-type-filter-mode-resource-booking": "Ressourcebooking",
        "standard-order-type-filter-mode-internal": "Intern",
        "standard-order-type-filter-mode-external": "Ekstern",
        "standard-order-type-filter-mode-take-away": "Takeaway",

        // Accounting > Orders > Meeting service
        "accounting-orders-meeting-service-receipt": "Kvittering",
        "accounting-orders-meeting-service-table-startDate-date-picker": "\n .label = Booked start date",
        "accounting-orders-meeting-service-table-endDate-date-picker": "\n .label = Booked end date",
        "accounting-orders-meeting-service-table-number": "Ordre-id",
        "accounting-orders-meeting-service-table-ref": "Ref.",
        "accounting-orders-meeting-service-table-booked-date": "Bogføringsdato",
        "accounting-orders-meeting-service-table-delivery-date": "Leveringsdato",
        "accounting-orders-meeting-service-table-creator": "Ordregiver",
        "accounting-orders-meeting-service-table-status": "Status",
        "accounting-orders-meeting-service-table-amount": "Beløb",
        "filter-menu-accordion-booked-date-title": "\n .title = Bogføringsdato",
        "filter-menu-accordion-delivery-date-title": "\n .title = Leveringsdato",
        "filter-menu-accordion-order-details-title": "\n .title = Ordredetaljer",
        "filter-menu-accordion-meeting-service-start-date-picker": "\n .label = Startdato",
        "filter-menu-accordion-meeting-service-end-date-picker": "\n .label = Slutdato",
        "filter-menu-accordion-meeting-service-order-number": "\n .label = Ordrenummer \n .placeholder = Søg efter ordrenr...",
        "filter-menu-accordion-meeting-service-customer": "\n .label = Kunde \n .placeholder = Kundenavn...",
        "accounting-orders-meeting-service-payment-type-credit": "Kreditnota",
        "accounting-orders-meeting-service-payment-type-debit": "",

        // Accounting subscription
        "accounting-subscription-title": "Abonnement",
        "accounting-subscription-name": "Navn",
        "accounting-subscription-subscribed": "Tilmeldt",
        "accounting-subscription-unsubscribed": "Afmeldt",
        "accounting-subscription-payment-method": "Betalingsmetode",
        "accounting-subscription-amount": "Beløb",
        "accounting-subscription-cancel": "Opsig abonnement",
        "accounting-subscription-cancel-true": "Dit abonnement er blevet opsagt",

        // Accounting product sale
        "accounting-product-sale-product-code": "Produktkode",
        "accounting-product-sale-product": "Produkt",
        "accounting-product-sale-product-quantity": "Antal",
        "accounting-product-sale-product-amount": "Beløb",
        "accounting-product-sale-export-empty": "Ingen salg for denne periode.",
         "accounting-product-sale-date-range-label": "\n .label = Periode",

        // Accounting balance
        "accounting-amount": "Beløb",
        "accounting-amount-no-sales": "Intet salg i perioden",


        // Accounting debtors
        "accounting-debtors-export-items-label": "Antal",
        "accounting-debtors-export-amount-label": "Beløb",
        "accounting-debtors-export-subtotal-label": "Subtotal",
        "accounting-debtors-export-failed": "Kunne ikke eksportere debitorer",
        "accounting-debtors-export-account-total": "Kontototal",
        "accounting-debtors-export-subtotal": "Subtotal",
        "accounting-customers-export-sales-summary": "Kundens salgsoversigt",
        "accounting-customers-export-payroll": "Kundens lønfiler (ZIP-fil)",


        // Merchant > Reports > Accounting > Z-report
        "merchant-accounting-z-reports-page-header": "\n .title = Z-rapport",
        "merchant-accounting-z-reports-table-date-column": "Dato",
        "merchant-accounting-z-reports-table-pos-terminal-column": "POS enhed",
        "merchant-accounting-z-reports-table-amount-column": "Beløb",

        // Merchant > Reports > Accounting > Z-report
        "merchant-accounting-custom-reports-page-header": "\n .title = Brugerdefinerede rapporter",
        "merchant-accounting-custom-reports-table-name-column": "Navn",
        "merchant-accounting-custom-reports-table-interval-column": "Interval",
        "merchant-accounting-custom-reports-table-last-run-column": "Sidste kørsel",
        "merchant-accounting-custom-reports-table-status-column": "Status",
        "merchant-accounting-custom-reports-table-button-details": "Detaljer",
        "merchant-accounting-custom-reports-table-button-download-report": "Download rapport",
        "merchant-accounting-custom-reports-table-button-activate": "Aktiver",
        "merchant-accounting-custom-reports-table-button-deactivate": "Deaktivér",
        "merchant-accounting-custom-reports-confirm-modal-question": "Er du sikker på, at du vil { $status} '{ $itemName }'?",
        "merchant-accounting-custom-reports-run-modal-form-title": "Download rapport",
        "merchant-accounting-custom-reports-run-modal-form-subtitle-name": "Navn:",
        "merchant-accounting-custom-reports-run-modal-form-subtitle": "Løntræk",
        "merchant-accounting-custom-reports-run-modal-form-startDate-date-picker": "\n .label = Start date",
        "merchant-accounting-custom-reports-run-modal-form-endDate-date-picker": "\n .label = End date",
        "merchant-accounting-custom-reports-run-form-save-button": "Download",


        // SelectCustomer
        "select-customer": "\n .label = Kunde",
        "select-debtor": "\n .label = Virksomhed",
        "select-customer-all": "Alle",

        // SelectShop
        "select-shop": "Butik",
        "select-shop-label": "\n .label = Butik",
        "select-shop-all": "Alle",

        // SelectWeek
        "select-week": "Vælg uge",
        "select-week-week": "Uge",

        // Select Kitchen
        "control-kitchen-mode-delivery-time": "Leveringstids visning",
        "control-kitchen-mode-purchase-time": "Købstid visning",
        "control-kitchen-mode-period-report": "Perioderapport",

        // Merchant > Reports > Menu Planning
        "merchant-menu-planning-header": "\n .title = Menuplanlægning",
        "merchant-menu-planning-tab-calendar": "Kalender",
        "merchant-menu-planning-tab-menus": "Menuer",
        "merchant-menu-planning-tab-digital-signage": "Digital skiltning",
        "merchant-menu-templates-row-meta": "{ $categories } kategorier · { $dishes } retter",
        "merchant-menu-templates-row-no-channels": "Ingen kanal",
        "merchant-menu-templates-row-delete-item": "Slet",
        "merchant-menu-templates-row-edit-button": "Rediger",
        "merchant-menu-templates-create-button": "Opret ny",
        "merchant-menu-templates-empty": "Ingen skabeloner endnu. Opret din første skabelon.",
        "merchant-menu-templates-load-error": "Skabelonen kunne ikke indlæses. Prøv igen.",
        "merchant-menu-templates-list-load-error": "Skabelonerne kunne ikke indlæses. Prøv igen.",
        "merchant-menu-templates-delete-entity": "\n .typeOfEntity = menuskabelon",
        "merchant-menu-templates-channel-mobile-app": "Mobilapp",
        "merchant-menu-templates-channel-canteen-display": "Kantineskærm",
        "merchant-menu-templates-channel-digital-signs": "Digital skiltning",
        "merchant-menu-templates-channel-print": "Printark",
        "merchant-menu-templates-editor-new-title": "Ny skabelon",
        "merchant-menu-templates-editor-name-label": "Skabelonnavn",
        "merchant-menu-templates-editor-name-field": "\n .placeholder = Skabelonnavn",
        "merchant-menu-templates-editor-name-hint": "Internt navn — vises ikke til kunder.",
        "merchant-menu-templates-editor-channels-label": "Udgives til",
        "merchant-menu-templates-editor-channels-hint": "Hvor denne skabelons menu vises. En skabelon kan målrettes mod en eller flere kanaler, og forskellige skabeloner kan målrettes mod forskellige kanaler.",
        "merchant-menu-templates-editor-categories-title": "Kategorier",
        "merchant-menu-templates-editor-add-category-button": "Tilføj kategori",
        "merchant-menu-templates-editor-cancel-button": "Annuller",
        "merchant-menu-templates-editor-save-button": "Gem skabelon",
        "merchant-menu-templates-category-dish-count": "{ $count } retter",
        "merchant-menu-templates-category-edit-button": "Rediger",
        "merchant-menu-templates-category-delete-item": "Slet",
        "merchant-menu-templates-category-dialog-add-title": "\n .dialogTitle = Tilføj kategori",
        "merchant-menu-templates-category-dialog-edit-title": "\n .dialogTitle = Rediger kategori",
        "merchant-menu-templates-category-dialog-name-field": "\n .label = Kategorinavn \n .placeholder = f.eks. Varme retter",
        "merchant-menu-templates-category-dialog-cancel-button": "Annuller",
        "merchant-menu-templates-category-dialog-save-button": "Gem",
        "merchant-menu-templates-delete-category-dialog-title": "Slet kategori",
        "merchant-menu-templates-delete-category-dialog-message": "Er du sikker på, at du vil slette '{ $name }'?",
        "merchant-menu-templates-delete-category-dialog-dishes-warning": "{ $count ->\n [one] Den indeholder { $count } ret, som også bliver slettet.\n *[other] Den indeholder { $count } retter, som også bliver slettet.\n}",
        "merchant-menu-templates-delete-dish-dialog-title": "Slet ret",
        "merchant-menu-templates-delete-dish-dialog-message": "Er du sikker på, at du vil slette '{ $name }'?",
        "merchant-menu-templates-delete-dish-dialog-message-unnamed": "Er du sikker på, at du vil slette denne ret?",
        "merchant-menu-templates-add-dish-card": "Tilføj ret",
        "merchant-menu-templates-dish-remove-button": "\n .aria-label = Fjern ret",
        "merchant-menu-templates-dish-name-label": "Navn på retten",
        "merchant-menu-templates-week-day-short-monday": "Ma",
        "merchant-menu-templates-week-day-short-tuesday": "Ti",
        "merchant-menu-templates-week-day-short-wednesday": "On",
        "merchant-menu-templates-week-day-short-thursday": "To",
        "merchant-menu-templates-week-day-short-friday": "Fr",
        "merchant-menu-templates-week-day-short-saturday": "Lø",
        "merchant-menu-templates-week-day-short-sunday": "Sø",
        "merchant-menu-templates-dish-cancel-button": "Annuller",
        "merchant-menu-templates-dish-done-button": "Færdig",
        "merchant-menu-templates-availability-hint": "Hvilke ugedage denne ret vises på i ugemenuen.",
        "merchant-menu-templates-dish-fields-title": "Felter",
        "merchant-menu-templates-dish-new-title": "Ny ret",
        "merchant-menu-templates-dish-no-photo": "Intet skabelonfoto",
        "merchant-menu-templates-dish-no-mandatory-fields": "Ingen påkrævede felter",
        "merchant-menu-templates-ai-can-fill-label": "AI kan udfylde dette felt",
        "merchant-menu-templates-ai-hint-on": "AI-generering i ugemenuen kan udfylde dette felt.",
        "merchant-menu-templates-ai-hint-off": "AI-generering i ugemenuen lader dette felt stå tomt — køkkenet udfylder det.",
        "merchant-menu-templates-ai-off-label": "AI fra",
        "merchant-menu-templates-field-value-default-label": "Standardværdi (valgfri)",
        "merchant-menu-templates-field-value-locked-label": "Låst værdi · påkrævet for denne skabelon",
        "merchant-menu-templates-field-price": "Pris",
        "merchant-menu-templates-field-description": "Beskrivelse",
        "merchant-menu-templates-field-allergens": "Allergener",
        "merchant-menu-templates-field-availability": "Tilgængelighed",
        "merchant-menu-templates-field-marketing-tag": "Marketing tag",
        "merchant-menu-templates-field-image": "Billede",
        "merchant-menu-templates-field-title": "Titel",
        "merchant-menu-templates-field-ingredients": "Ingredienser",
        "merchant-menu-templates-field-nutrition": "Næringsindhold",
        "merchant-menu-templates-field-co2-footprint": "CO₂-aftryk",
        "merchant-menu-templates-title-value-field": "\n .placeholder = Titeltekst…",
        "merchant-menu-templates-ingredients-value-field": "\n .placeholder = f.eks. Tomater, basilikum, hvidløg, olivenolie…",
        "merchant-menu-templates-nutrition-value-field": "\n .placeholder = f.eks. 320 kcal · 12g P · 40g C · 8g F",
        "merchant-menu-templates-co2-unit": "kg CO₂ eq",
        "merchant-menu-templates-dish-details-title": "Detaljer",
        "merchant-menu-templates-dish-details-subtitle": "vises i en dialog i ugemenuen",
        "merchant-menu-templates-mode-locked": "Låst",
        "merchant-menu-templates-mode-mandatory": "Obligatorisk",
        "merchant-menu-templates-mode-optional": "Valgfri",
        "merchant-menu-templates-mode-hint-locked": "Låst — en startværdi er påkrævet her i skabelonen; den overføres til hver ugemenu. Køkkenet kan stadig redigere den for en given dag.",
        "merchant-menu-templates-mode-hint-mandatory": "Obligatorisk — køkkenet skal udfylde dette felt i ugemenuen. En standardværdi her er valgfri.",
        "merchant-menu-templates-mode-hint-optional": "Valgfri — køkkenet kan udfylde dette felt i ugemenuen. En standardværdi her er valgfri.",
        "merchant-menu-templates-field-show-toggle": "Vis",
        "merchant-menu-templates-field-hidden-hint": "Skjult i ugemenuen",
        "merchant-menu-templates-price-value-field": "\n .label = Pris",
        "merchant-menu-templates-price-same-week-checkbox": "Samme pris hele ugen",
        "merchant-menu-templates-description-value-field": "\n .placeholder = Beskrivelsestekst…",
        "merchant-menu-templates-marketing-tag-value-field": "\n .label = Marketing tag \n .helperText = Eksempelvis: Dagens tilbud, Discount",
        "merchant-menu-templates-image-upload": "\n .label = Upload billede",
        "merchant-menu-templates-validation-required": "Dette felt er påkrævet",
        "merchant-menu-templates-validation-number": "Skal være et tal",
        "merchant-menu-planning-tab-week-menu": "Ugens menu",
        "merchant-week-menu-cell-title-field": "\n .placeholder = Skriv navn på retten…",
        "merchant-week-menu-cell-recent-dishes-title": "Tidligere menuer",
        "merchant-week-menu-cell-description-field": "\n .placeholder = Tilføj beskrivelse…",
        "merchant-week-menu-cell-description-expand-tooltip": "\n .title = Åbn hele beskrivelsen",
        "merchant-week-menu-cell-add-allergen-label": "Allergen",
        "merchant-week-menu-cell-price-field": "\n .placeholder = 0",
        "merchant-week-menu-cell-price-locked-all-week": "{ $price } DKK · hele ugen",
        "merchant-week-menu-cell-price-locked": "{ $price } DKK",
        "merchant-week-menu-currency-label": "DKK",
        "merchant-week-menu-cell-marketing-field": "\n .placeholder = Marketingtag (valgfrit)",
        "merchant-week-menu-cell-add-image-label": "Foto",
        "merchant-week-menu-cell-image-from-template-label": "Billede fra skabelonen",
        "merchant-week-menu-cell-image-delete-button": "\n .aria-label = Slet",
        "merchant-week-menu-cell-menu-button": "\n .aria-label = Handlinger for retten",
        "merchant-week-menu-cell-copy-tooltip": "\n .title = Kopiér til andre dage…",
        "merchant-week-menu-cell-clear-tooltip": "\n .title = Ryd retten",
        "merchant-week-menu-cell-details-tooltip": "\n .title = Detaljer om retten",
        "merchant-week-menu-details-dialog": "\n .dialogTitle = Detaljer om retten",
        "merchant-week-menu-details-ingredients-label": "Ingredienser",
        "merchant-week-menu-details-nutrition-label": "Næringsindhold",
        "merchant-week-menu-details-co2-label": "CO₂-aftryk (kg CO₂ eq)",
        "merchant-week-menu-details-dialog-close-button": "Luk",
        "merchant-week-menu-details-dialog-save-button": "Gem",
        "merchant-week-menu-cell-unavailable": "Ikke tilgængelig",
        "merchant-week-menu-cell-drag-tooltip": "\n .title = Træk til en anden dag",
        "merchant-week-menu-cell-status-ready": "Klar",
        "merchant-week-menu-cell-status-missing": "Mangler",
        "merchant-week-menu-missing-tooltip-title": "Mangler stadig",
        "merchant-week-menu-missing-field-name": "Navn",
        "merchant-week-menu-missing-field-description": "Beskrivelse",
        "merchant-week-menu-missing-field-price": "Pris",
        "merchant-week-menu-missing-field-photo": "Foto",
        "merchant-week-menu-missing-field-allergens": "Allergener",
        "merchant-week-menu-missing-field-marketing-tag": "Marketing tag",
        "merchant-week-menu-cell-status-optional": "Valgfri",
        "merchant-week-menu-cell-ai-regen-tooltip": "\n .title = Generer igen med AI",
        "merchant-week-menu-description-dialog": "\n .dialogTitle = Rediger beskrivelse",
        "merchant-week-menu-description-dialog-field-label": "Beskrivelse",
        "merchant-week-menu-description-dialog-field": "\n .placeholder = Skriv en længere og mere detaljeret beskrivelse her…",
        "merchant-week-menu-description-dialog-close-button": "Luk",
        "merchant-week-menu-description-dialog-save-button": "Gem",
        "merchant-week-menu-copy-dish-dialog": "\n .dialogTitle = Kopiér retten til andre dage",
        "merchant-week-menu-copy-week-to-label": "\n .label = Kopiér til",
        "merchant-week-menu-copy-overwrite-label": "Overskriv udfyldte retter",
        "merchant-week-menu-copy-overwrite-sublabel": "Fra — kun tomme pladser udfyldes, eksisterende retter bevares.",
        "merchant-week-menu-copy-overwrite-sublabel-on": "Til — eksisterende retter overskrives også.",
        "merchant-week-menu-copy-dish-cancel-button": "Annuller",
        "merchant-week-menu-copy-dish-confirm-button": "Kopiér",
        "merchant-week-menu-week-label": "Uge { $week } · { $period }",
        "merchant-week-menu-prev-week-button": "\n .aria-label = Forrige uge",
        "merchant-week-menu-next-week-button": "\n .aria-label = Næste uge",
        "merchant-week-menu-days-ready-label": "{ $ready }/{ $total } dage klar",
        "merchant-week-menu-dish-column-label": "Ret",
        "merchant-week-menu-clear-week-snackbar": "Ugen er ryddet",
        "merchant-week-menu-clear-week-dialog": "\n .title = Ryd uge\n .buttonLabelSubmit = Ryd",
        "merchant-week-menu-clear-week-dialog-message": "Dette fjerner alle retter, der er indtastet for denne uge. Handlingen kan ikke fortrydes.",
        "merchant-week-menu-close-day-dialog": "\n .title = Luk denne dag\n .buttonLabelSubmit = Luk dagen",
        "merchant-week-menu-close-day-dialog-message": "{ $count } udfyldte retter på denne dag udgives ikke, mens dagen er lukket.",
        "merchant-week-menu-remove-theme-dialog": "\n .title = Skift tilbage til skabelonen\n .buttonLabelSubmit = Skift tilbage",
        "merchant-week-menu-remove-theme-dialog-message": "Kassér { $count } temaretter på denne dag, og skift tilbage til skabelonen?",
        "merchant-week-menu-publish-button": "Udgiv klare dage",
        "merchant-week-menu-autosaved-label": "Gemt automatisk",
        "merchant-week-menu-day-publish-tooltip": "\n .title = Udgiv denne dag til kunder",
        "merchant-week-menu-day-status-draft": "Kladde",
        "merchant-week-menu-day-status-published": "Udgivet",
        "merchant-week-menu-day-status-updated": "Opdateret",
        "merchant-week-menu-day-menu-button": "\n .aria-label = Handlinger for dagen",
        "merchant-week-menu-day-menu-theme-item": "Gør denne dag til en temadag",
        "merchant-week-menu-day-menu-rename-theme-item": "Rediger temaets navn…",
        "merchant-week-menu-day-menu-remove-theme-item": "Skift tilbage til skabelonen",
        "merchant-week-menu-day-menu-close-item": "Markér dagen som lukket",
        "merchant-week-menu-theme-dialog-add-title": "\n .dialogTitle = Gør { $day } til en temadag",
        "merchant-week-menu-theme-dialog-rename-title": "\n .dialogTitle = Rediger temaets navn",
        "merchant-week-menu-theme-dialog-name-label": "Navn på temaet",
        "merchant-week-menu-theme-dialog-name-field": "\n .placeholder = Skriv tema...",
        "merchant-week-menu-theme-dialog-hint": "Giv temaet et kort navn som \"Spansk dag\" eller \"Jul\".",
        "merchant-week-menu-theme-dialog-close-button": "Luk",
        "merchant-week-menu-theme-dialog-save-button": "Gem",
        "merchant-week-menu-theme-add-dish-button": "Tilføj ret",
        "merchant-week-menu-closed-panel-title": "Lukket",
        "merchant-week-menu-closed-panel-message": "Ingen menu denne dag. Kunderne ser dagen som lukket.",
        "merchant-week-menu-closed-reopen-button": "Genåbn dagen",
        "merchant-week-menu-copy-week-dialog": "\n .dialogTitle = Kopiér ugen til andre uger",
        "merchant-week-menu-copy-week-cancel-button": "Annuller",
        "merchant-week-menu-copy-week-confirm-button": "Kopiér",
        "merchant-week-menu-ai-button": "AI",
        "merchant-week-menu-ai-menu-quick-title": "Hurtig menu",
        "merchant-week-menu-ai-menu-quick-subtitle": "Generér hele ugen automatisk",
        "merchant-week-menu-ai-menu-customize-title": "Tilpas menu",
        "merchant-week-menu-ai-menu-customize-subtitle": "Vælg temaer og regler pr. dag, og generér derefter",
        "merchant-week-menu-ai-banner-title": "AI har genereret denne menu",
        "merchant-week-menu-ai-banner-subtitle": "Gennemgå retterne, før du udgiver.",
        "merchant-week-menu-ai-banner-regenerate-button": "Generér igen",
        "merchant-week-menu-ai-banner-undo-button": "Fortryd",
        "merchant-week-menu-ai-banner-close-button": "\n .aria-label = Luk",
        "merchant-week-menu-ai-dialog": "\n .dialogTitle = Tilpas menugenerering",
        "merchant-week-menu-ai-dialog-subtitle": "Vælg et tema og regler, og lad AI udfylde ugen",
        "merchant-week-menu-ai-theme-label": "Tema",
        "merchant-week-menu-ai-inspiration-label": "Inspiration",
        "merchant-week-menu-ai-dialog-notes-field": "\n .placeholder = Tilføj dine egne idéer eller regler, f.eks. bestemte krav",
        "merchant-week-menu-ai-overwrite-label": "Overskriv eksisterende retter",
        "merchant-week-menu-ai-overwrite-helper": "Fra = AI udfylder kun tomme felter",
        "merchant-week-menu-ai-overwrite-dialog": "\n .dialogTitle = Denne menu har allerede retter",
        "merchant-week-menu-ai-overwrite-subtitle": "Hvordan skal AI håndtere de dage, der allerede er udfyldt?",
        "merchant-week-menu-ai-overwrite-fill-title": "Udfyld kun tomme felter",
        "merchant-week-menu-ai-overwrite-fill-subtitle": "Behold de retter, du allerede har skrevet",
        "merchant-week-menu-ai-overwrite-replace-title": "Erstat alle retter",
        "merchant-week-menu-ai-overwrite-replace-subtitle": "Overskriv hele ugen",
        "merchant-week-menu-ai-overwrite-choose-button": "Vælg",
        "merchant-week-menu-ai-overwrite-cancel-button": "Annuller",
        "merchant-week-menu-ai-dialog-cancel-button": "Annuller",
        "merchant-week-menu-ai-dialog-generate-button": "Generér",
        "merchant-week-menu-ai-theme-surprise": "Overrask mig",
        "merchant-week-menu-no-templates-title": "Ingen menuskabeloner endnu",
        "merchant-week-menu-no-templates-message": "For at planlægge en ugemenu skal du først oprette en skabelon med dine kategorier og retter.",
        "merchant-week-menu-create-template-button": "Opret skabelon",
        "merchant-week-menu-load-error": "Ugemenuen kunne ikke indlæses. Prøv igen.",
        "merchant-week-menu-legend-empty": "Tom",
        "merchant-week-menu-legend-filled": "Udfyldt (komplet)",
        "merchant-week-menu-legend-needs-fill": "Påbegyndt, obligatorisk felt mangler",
        "merchant-week-menu-legend-default": "Skabelonens standard — kan redigeres, ikke redigeret endnu",
        "merchant-week-menu-legend-ai-mode": "AI-tilstand",
        "merchant-week-menu-cell-description-field-optional": "\n .placeholder = Tilføj beskrivelse (valgfrit)…",
        "merchant-week-menu-cell-add-allergen-label-optional": "Allergen (valgfrit)",
        "merchant-week-menu-copy-dish-dialog-sub": "Kopierer denne ret til samme række på de dage, du vælger.",
        "merchant-week-menu-copy-dish-select-all": "Vælg alle",
        "merchant-week-menu-theme-dish-remove-button": "\n .aria-label = Fjern temaret",
        "merchant-week-menu-copy-dish-clear": "Ryd",
        "merchant-week-menu-copy-dish-source-suffix": "(kilde)",
        "merchant-week-menu-copy-dish-warning": "Nogle valgte dage har allerede en ret. De springes over, medmindre du slår overskriv til.",
        "merchant-week-menu-copy-dish-snackbar": "Retten er kopieret til { $count } dage.",
        "merchant-week-menu-copy-dish-skipped-snackbar": "Retten er kopieret til { $count } dage · { $skipped } sprunget over (allerede udfyldt).",
        "merchant-week-menu-copy-week-source-subtitle": "Hele ugens menu · { $period }",
        "merchant-week-menu-copy-week-next-prefix": "Næste uge ({ $label })",
        "merchant-week-menu-copy-week-snackbar": "Ugemenuen er kopieret til { $week }.",
        "merchant-week-menu-swap-snackbar": "Byttede { $dish } mellem { $dayA } og { $dayB }.",
        "merchant-week-menu-theme-created-snackbar": "Temadag oprettet: { $name }.",
        "merchant-week-menu-theme-reverted-snackbar": "Dagen er skiftet tilbage til skabelonen.",
        "merchant-week-menu-day-closed-snackbar": "{ $day } er markeret som lukket.",
        "merchant-week-menu-day-reopened-snackbar": "{ $day } er genåbnet.",
        "merchant-week-menu-publish-count-snackbar": "{ $count } dage er udgivet til kunder.",
        "merchant-week-menu-publish-none-snackbar": "Ingen dage er slået til at blive udgivet.",
        "merchant-week-menu-ai-ready-snackbar": "AI-menuen er klar — gennemgå og behold.",
        "merchant-week-menu-ai-regenerated-snackbar": "Retten er genereret igen.",
        "merchant-week-menu-ai-reverted-snackbar": "Gendannet til den forrige menu.",
        "merchant-week-menu-ai-no-open-days-snackbar": "Der er ingen åbne dage at generere for i denne uge.",
        "merchant-week-menu-ai-banner-working-title": "Genererer menu…",
        "merchant-week-menu-ai-banner-working-subtitle": "Opretter retter til { $template }",
        "merchant-week-menu-theme-dialog-create-button": "Gem",
        "merchant-week-menu-theme-dialog-warning": "{ $day } har { $count } udfyldte felter fra skabelonen. Skifter du til en temadag, kasseres de.",
        "merchant-week-menu-theme-panel-edit-tooltip": "\n .title = Rediger temaets navn",
        "merchant-week-menu-theme-panel-revert-tooltip": "\n .title = Skift tilbage til skabelonen",
        "merchant-week-menu-recent-dishes-matching-title": "Tidligere menuer · matcher \"{ $query }\"",
        "merchant-week-menu-recent-dishes-meta": "Denne uge",
        "merchant-week-menu-recent-dish-price": "· { $price } DKK",
        "merchant-week-menu-details-title-label": "Titel",
        "merchant-week-menu-details-description-label": "Beskrivelse",
        "merchant-week-menu-details-price-label": "Pris",
        "merchant-week-menu-details-allergens-label": "Allergener",
        "merchant-week-menu-details-marketing-label": "Marketingtag",
        "merchant-week-menu-details-image-label": "Billede",
        "merchant-week-menu-details-accordion-title": "Næring og miljø",
        "merchant-week-menu-details-co2-unit": "kg CO₂-ækv.",
        "merchant-week-menu-ai-theme-asian": "Asiatisk",
        "merchant-week-menu-ai-theme-mediterranean": "Middelhavs",
        "merchant-week-menu-ai-theme-nordic": "Nordisk",
        "merchant-week-menu-ai-theme-italian": "Italiensk",
        "merchant-week-menu-ai-theme-mexican": "Mexicansk",
        "merchant-week-menu-ai-theme-indian": "Indisk",
        "merchant-week-menu-ai-theme-middle-eastern": "Mellemøstlig",
        "merchant-week-menu-ai-spice-label": "Styrke",
        "merchant-week-menu-ai-spice-low": "Mild",
        "merchant-week-menu-ai-spice-medium": "Middel",
        "merchant-week-menu-ai-spice-spicy": "Stærk",
        "merchant-week-menu-ai-health-label": "Sundhed",
        "merchant-week-menu-ai-health-healthy": "Sund",
        "merchant-week-menu-ai-health-balanced": "Balanceret",
        "merchant-week-menu-ai-health-comfort": "Comfort",
        "merchant-week-menu-ai-style-label": "Stil",
        "merchant-week-menu-ai-style-normal": "Normal",
        "merchant-week-menu-ai-style-gourmet": "Gourmet",
        "merchant-week-menu-ai-style-fun": "Sjov",
        "merchant-week-menu-ai-style-party": "Fest",
        "merchant-week-menu-ai-style-celebration": "Fejring",
        "merchant-week-menu-ai-ingredients-label": "Ingredienser der skal med",
        "merchant-week-menu-ai-ingredients-input": "\n .placeholder = Skriv og tryk Enter…",
        "merchant-week-menu-ai-mode-all": "Alle dage ens",
        "merchant-week-menu-ai-mode-per-day": "Tilpas hver dag",
        "merchant-week-menu-marketing-popover-title": "Foreslåede tags",
        "merchant-week-menu-marketing-add-custom-tag": "Tilføj eget tag",
        "merchant-week-menu-overflow-button": "\n .aria-label = Flere handlinger",
        "merchant-week-menu-overflow-manage-templates-item": "Administrer skabeloner",
        "merchant-week-menu-overflow-customer-preview-item": "Kundevisning",
        "merchant-week-menu-overflow-copy-week-item": "Kopiér uge",
        "merchant-week-menu-overflow-clear-week-item": "Ryd uge",
        "merchant-week-menu-overflow-export-pdf-item": "Eksportér til PDF",
        "merchant-week-menu-overflow-print-item": "Print køkkenseddel",
        "merchant-week-menu-customer-view-button": "Kundevisning",
        "merchant-week-menu-feature-not-ready-snackbar": "Ikke tilgængelig endnu",
        "merchant-week-menu-autosaved-just-now": "Gemt automatisk lige nu",
        "merchant-week-menu-autosaved-minutes": "Gemt automatisk · for { $minutes } min. siden",
        "merchant-week-menu-row-ready-label": "{ $filled }/{ $total } klar",
        "merchant-week-menu-row-template-default-chip": "Skabelonens standard",
        "merchant-menu-planning-table-startDate-date-picker": "\n .label = Startdato",
        "merchant-menu-planning-table-endDate-date-picker": "\n .label = Slutdato",
        "merchant-menu-planning-table-week-select": "\n .label = Uge",
        "merchant-menu-planning-table-week-select-option": "Uge { $countOfWeek } ({ $startDate } - { $endDate })",
        "merchant-menu-planning-table-date-column": "Dato",
        "merchant-menu-planning-table-dish": "Ret { $counter }:",
        "merchant-menu-planning-table-price": "Pris: { $price }",
        "merchant-menu-planning-table-allergens": "Allergener: { $allergens }",
        "merchant-menu-planning-table-type-mode-digital-signage": "Digital skiltning",
        "merchant-menu-planning-table-type-mode-web-menu": "Webmenu",
        "merchant-menu-planning-table-type-recurring": "Gentagende",
        "merchant-menu-planning-table-status-column": "Status",
        "merchant-menu-planning-table-active-column-active": "Aktiv",
        "merchant-menu-planning-table-active-column-inactive": "Inaktiv",
        "merchant-menu-planning-table-active-column-active-filter-yes": "Aktiv",
        "merchant-menu-planning-table-active-column-inactive-filter-no": "Inaktiv",
        "merchant-menu-planning-table-dishes-count": "Antal retter",
        "merchant-menu-planning-table-recurrence": "Gentagelse",
        "merchant-menu-planning-table-create-button": "Opret ny",
        "merchant-menu-planning-table-week-menu-rss-button": "Ugemenu som RSS",
        "merchant-menu-planning-table-week-menu-atom-button": "Ugemenu som Atom",
        "merchant-menu-planning-table-week-menu-page-button": "Ugemenu som webside",
        "public-canteen-week-menu-title": "Kantinemenu",
        "public-canteen-week-menu-week-label": "Uge { $weekNumber }",
        "public-canteen-week-menu-allergens-label": "Allergener:",
        "public-canteen-week-menu-empty": "Desværre er der ikke blevet oprettet nogen menuer denne uge.",
        "public-canteen-week-menu-load-error": "Vi kunne ikke indlæse menuen på grund af en fejl.\n    Kontakt venligst support for at få hjælp.",
        "public-menu-display-status-offline": "Ingen Internet forbindelse",
        "public-menu-display-status-server-down": "Kunne ikke forbinde til server",
        "public-menu-display-status-refresh-failed": "Menuen kunne ikke opdateres",
        "public-menu-display-header-title": "Dagens menu",
        "public-menu-display-empty-message": "Der er ikke offentliggjort nogen menu i dag",
        "public-menu-display-unavailable-message": "Menuen kunne ikke hentes",
        "public-menu-display-pagination-label": "{$current} af {$total} menuer",
        "public-menu-display-allergens-contains-label": "Indeholder",
        "public-menu-display-scan-qr-text": "Scan for ugemenu",
        "merchant-menu-planning-table-menu-item-edit": "Rediger",
        "merchant-menu-planning-table-menu-item-set-inactive": "Deaktiver",
        "merchant-menu-planning-table-menu-item-set-active": "Aktiver",
        "merchant-menu-planning-table-menu-item-delete": "Slet",
        "merchant-menu-planning-confirm-delete-shop-dialog": "\n .typeOfEntity = menu",
        "merchant-menu-planning-dialog-create-title": "Opret menu",
        "merchant-menu-planning-dialog-edit-title": "Tilret menu",
        "merchant-menu-planning-dialog-max-dishes": "Tilgængelige retskilte: { $countOfDishes }",
        "merchant-menu-planning-dialog-add-marketing-details-button": "\n .title = + Tilføj marketing detaljer",
        "merchant-menu-planning-dialog-add-dish-button": "Tilføj ret",
        "merchant-menu-planning-dialog-add-recurrence-button": "\n .title = + Tilføj gentagelse",
        "merchant-menu-planning-dialog-remove-recurrence-button": "\n .title = Fjern gentagelse",
        "merchant-menu-planning-dialog-create-submit-button": "Opret",
        "merchant-menu-planning-dialog-save-submit-button": "Gem",
        "merchant-menu-planning-dialog-dish": "Ret { $countOfDish }",
        "merchant-menu-planning-dialog-publishDate-date-picker": "\n .label = Publish date",
        "merchant-menu-planning-dialog-recurrence": "Gentagelse",
        "merchant-menu-planning-dialog-name-of-dish-field": "\n .label = Navn på retten",
        "merchant-menu-planning-dialog-brief-field": "\n .label = Kort beskrivelse \n .placeholder = Short description, max. 80 characters including space.",
        "merchant-menu-planning-dialog-marketing-tag-field": "\n .label = Marketing tag \n .helperText = Eksempelvis: Dagens tilbud, Discount",
        "merchant-menu-planning-dialog-from-date-picker": "\n .label = Fra dato",
        "merchant-menu-planning-dialog-to-date-picker": "\n .label = Til dato",
        "merchant-menu-planning-dialog-currency-field": "\n .label = Valuta",
        "merchant-menu-planning-dialog-price-field": "\n .label = Pris",
        "merchant-menu-planning-dialog-upload-image": "\n .label = Upload billede",
        "merchant-menu-planning-week-day-monday": "Mandag",
        "merchant-menu-planning-week-day-tuesday": "Tirsdag",
        "merchant-menu-planning-week-day-wednesday": "Onsdag",
        "merchant-menu-planning-week-day-thursday": "Torsdag",
        "merchant-menu-planning-week-day-friday": "Fredag",
        "merchant-menu-planning-week-day-saturday": "Lørdag",
        "merchant-menu-planning-week-day-sunday": "Søndag",
        "merchant-menu-planning-dialog-signageTypes-label": "Publicér til:",
        "merchant-menu-planning-dialog-signageTypes-mode-web-menu": "Web menu",
        "merchant-menu-planning-dialog-signageTypes-mode-buffet-sign": "Buffet skilt",
        "merchant-menu-planning-dialog-signageTypes-mode-day-menu-sign": "Dagens menu skilt",
        "merchant-menu-planning-dialog-signageTypes-min-error": "Please select at least one signage type",
        "merchant-menu-planning-digital-signage-card-serial-no": "Serienr.:",
        "merchant-menu-planning-digital-signage-card-device-id": "Enheds-ID:",
        "merchant-menu-planning-digital-signage-card-device-name": "Enhedsnavn:",
        "merchant-menu-planning-digital-signage-card-last-update": "Sidst opdateret:",
        "merchant-menu-planning-digital-signage-card-battery-status": "Batteristatus:",
        "merchant-menu-planning-digital-signage-card-battery-status-0": "Udefineret",
        "merchant-menu-planning-digital-signage-card-battery-status-1": "Ukendt",
        "merchant-menu-planning-digital-signage-card-battery-status-2": "God",
        "merchant-menu-planning-digital-signage-card-battery-status-3": "Ringe",
        "merchant-menu-planning-digital-signage-card-battery-status-4": "Dårlig køler",
        "merchant-menu-planning-digital-signage-card-battery-status-5": "Udskift",
        "merchant-menu-planning-digital-signage-card-battery-status-6": "Udskift køler",
        "merchant-menu-planning-digital-signage-card-status-code": "Statuskode:",
        "merchant-menu-planning-digital-signage-card-status-code--99": "Ukendt",
        "merchant-menu-planning-digital-signage-card-status-code--10": "Rengøring mislykkedes",
        "merchant-menu-planning-digital-signage-card-status-code--2": "Systemkonfiguration mislykkedes",
        "merchant-menu-planning-digital-signage-card-status-code--1": "Netværkskonfiguration mislykkedes",
        "merchant-menu-planning-digital-signage-card-status-code-0": "Ikke konfigureret",
        "merchant-menu-planning-digital-signage-card-status-code-1": "Netværk konfigureret",
        "merchant-menu-planning-digital-signage-card-status-code-2": "Kommunikation mislykkedes",
        "merchant-menu-planning-digital-signage-card-status-code-3": "Lavt batteri",
        "merchant-menu-planning-digital-signage-card-status-code-4": "Aktuel sidedesign ikke fundet",
        "merchant-menu-planning-digital-signage-card-status-code-5": "Aktuel sideprodukt ikke fundet",
        "merchant-menu-planning-digital-signage-card-status-code-6": "Aktuel sideopdatering mislykkedes",
        "merchant-menu-planning-digital-signage-card-status-code-7": "Alternativt sidedesign ikke fundet",
        "merchant-menu-planning-digital-signage-card-status-code-8": "Alternativt sideprodukt ikke fundet",
        "merchant-menu-planning-digital-signage-card-status-code-9": "Alternativ sideopdatering mislykkedes",
        "merchant-menu-planning-digital-signage-card-status-code-10": "Ok",
        "merchant-menu-planning-digital-signage-card-status-code-11": "Sundhedstjek mislykkedes",
        "merchant-menu-planning-digital-signage-card-status-code-12": "Lav temperatur",
        "merchant-menu-planning-digital-signage-card-status-code-20": "Billede overskrevet",
        "merchant-menu-planning-digital-signage-card-status-code-50": "Forkonfigureret",
        "merchant-menu-planning-digital-signage-card-status-code-99": "I kø",
        "merchant-menu-planning-digital-signage-empty": "Ingen digitale skilte-enheder fundet",
        "merchant-menu-planning-digital-signage-dialog-title": "Digitalt skilt",
        "merchant-menu-planning-digital-signage-menu-details": "Detaljer",
        "merchant-menu-planning-digital-signage-menu-clear-sign": "Ryd skilt",
        "merchant-menu-planning-color-field-label": "\n .label = Farve",

        // --- Merchant ---

        // Navigation
        "merchant-nav-item-home": "Hjem",

        //  - reporting
        "merchant-nav-item-production": "\n .title = Produktion",
        "merchant-nav-item-menu-planning": "Menuplanlægning",
        "merchant-nav-item-group-menu-planning": "\n .title = Menuplanlægning",
        "merchant-nav-item-menu-planning-header": "Menuplanlægning",
        "merchant-nav-item-menu-planning-v2": "Menuplanlægning v2",
        "merchant-nav-item-group-id-cards": "\n .title = ID-kort",
        "merchant-nav-item-id-cards-header": "ID-kort",
        "merchant-admin-menu-planning-header": "\n .title = Menuplanlægning",
        "merchant-nav-item-purchase-control": "Købskontrol",
        "merchant-nav-item-survey": "Brugertilfredshed",
        "merchant-nav-item-accounting": "Regnskab",
        "merchant-nav-item-accounting-page-header": "\n .title = Regnskab",
        "merchant-nav-item-production-planning": "Planlægning",
        "merchant-nav-item-production-takeaway": "Takeaway",
        "merchant-nav-item-production-meeting-service": "Mødeforplejning",
        "merchant-nav-item-production-meeting-service-view": "Produktionsvisning",
        "merchant-nav-item-production-pos-purchases": "POS køb",

        //  - admin
        "merchant-nav-item-settings-page-header": "\n .title = Indstillinger",
        "merchant-nav-item-settings-header": "Indstillinger",
        "merchant-nav-item-customer-access": "Kundeadgang",
        "merchant-nav-item-id-cards": "ID-kort",
        "merchant-nav-item-custom-jobs":"Tilpassede jobs",
        "merchant-nav-item-merchant-news": "Kundenyheder",
        "merchant-nav-item-messaging": "Push-beskeder",
        "merchant-nav-item-news": "Kundenyheder",
        "merchant-nav-item-info-displays": "Integrationsfeeds",
        "merchant-info-displays-header": "\n .title = Integrationsfeeds",
        "merchant-info-displays-page-subtitle":
            "Skærme udgivet fra Facilitynet. Forhåndsvis en skærm, del den som link eller indlejring, eller nulstil dens link for at fjerne adgangen.",
        "merchant-info-displays-filter-all": "Alle skærme",
        "merchant-info-displays-filter-menu": "Menu",
        "merchant-info-displays-filter-production": "Produktion",
        "merchant-info-displays-count-label": "{ $count } skærme",
        "merchant-info-displays-card-thumbnail-label": "forhåndsvisning af skærm",
        "merchant-info-displays-card-status-live": "\n .label = Live",
        "merchant-info-displays-card-status-inactive": "\n .label = Inaktiv",
        "merchant-info-displays-card-menu-simple-name": "Ugemenu — Simpel (iFrame)",
        "merchant-info-displays-card-menu-simple-description": "Bruges til at vise menuen på hjemmeside / intranet.",
        "merchant-info-displays-card-menu-layout-name": "Dagens menu — Layout 1",
        "merchant-info-displays-card-menu-layout-description": "Bruges til visning på skærm i kantinen.",
        "merchant-info-displays-card-production-name": "Produktionsskærm",
        "merchant-info-displays-card-production-description":
            "Bruges til visning på skærm i produktionsområderne til at styre kommende ordrer.",
        "merchant-info-displays-menu-preview-item": "Forhåndsvisning",
        "merchant-info-displays-menu-link-item": "Permalink / indlejring",
        "merchant-info-displays-menu-permalink-item": "Permalink",
        "merchant-info-displays-menu-reset-item": "Nulstil",
        "merchant-info-displays-menu-inactivate-item": "Deaktiver",
        "merchant-info-displays-menu-activate-item": "Aktiver",
        "merchant-info-displays-link-dialog-embed": "\n .dialogTitle = Permalink / indlejring\n .subtitle = { $name } — alle med dette link kan se skærmen.",
        "merchant-info-displays-link-dialog-permalink": "\n .dialogTitle = Permalink\n .subtitle = { $name } — alle med dette link kan se skærmen.",
        "merchant-info-displays-link-dialog-permalink-login-required": "\n .dialogTitle = Permalink\n .subtitle = { $name } — kræver login i Facilitynet; åbner skærmen i fuld skærm.",
        "merchant-info-displays-link-dialog-permalink-label": "Permalink",
        "merchant-info-displays-link-dialog-embed-label": "Indlejringskode",
        "merchant-info-displays-copy-tooltip": "\n .title = Kopier",
        "merchant-info-displays-link-dialog-reset-button": "Nulstil link",
        "merchant-info-displays-link-dialog-done-button": "Færdig",
        "merchant-info-displays-copy-success": "Kopieret til udklipsholderen",
        "merchant-info-displays-reset-dialog":
            "\n .title = Nulstil link?\n .message = Der genereres et nyt link til { $name }. Det nuværende link og alle indlejringer, der bruger det, holder op med at virke med det samme.\n .buttonLabelSubmit = Nulstil link",
        "merchant-nav-item-users": "Administratorer",
        "merchant-nav-item-shops": "Butikker",
        "merchant-nav-item-payment-links": "Betalingslinks",
        "merchant-nav-item-products": "Produkter",
        "merchant-nav-item-product-create": "Opret produkt",
        "merchant-nav-item-extra-service-create": "Opret ekstra service",
        "merchant-nav-item-extra-service-edit": "Ret ekstra service",
        "merchant-nav-item-product-update": "Ret produkt",
        "merchant-nav-item-product-groups": "Produktgrupper",
        "merchant-nav-item-extra-services": "Ekstra services",
        "merchant-nav-item-product-group-create": "Opret produktgruppe",
        "merchant-nav-item-product-group-update": "Ret produktgruppe",
        "merchant-nav-item-price-lists": "Prislister",
        "merchant-nav-item-price-list-create": "Opret prisliste",
        "merchant-nav-item-price-list-edit": "Ret prisliste",
        "merchant-nav-item-surveys": "Brugerundersøgelser",
        "merchant-nav-item-devices": "Hardware enheder",
        "merchant-nav-item-communication-page-header":"\n .title = Kommunikation",
        "merchant-nav-item-communication-header":"Kommunikation",
        "merchant-nav-item-group-products":"\n .title = Produkter",
        "merchant-nav-item-products-header":"Produkter",
        "merchant-nav-item-group-shops":"\n .title = Butikker",
        "merchant-nav-item-offers":"Tilbud",
        "merchant-nav-item-vat-codes":"Momskoder",
        "merchant-nav-item-create-vat-code":"Opret momskode",
        "merchant-nav-item-edit-vat-code":"Ret momskode",
        "merchant-nav-item-group-organization":"\n .title = Organisation",
        "merchant-nav-item-group-account":"\n .title = Konto",
        "merchant-nav-item-billing":"Regninger",
        "merchant-nav-item-account":"Konto",
        "merchant-nav-item-merchant-account":"Virksomhedskonto",
        "merchant-nav-item-delivery-locations":"Leveringslokationer",
        "merchant-nav-item-sales-accounts": "Salgskonti",
        "merchant-nav-item-live-dashboard": "Live dashboard",

        // Admin home
        "merchant-admin-home-products-group": "\n .title = Produkter",
        "merchant-admin-home-communication-group": "\n .title = Kommunikation",
        "merchant-admin-home-customers-group": "\n .title = Kunder",
        "merchant-admin-home-settings-group": "\n .title = Indstillinger",
        "merchant-admin-home-shop": "\n .title = Shops\n .description = Sælg dine produkter i shops med individuel branding.",
        "merchant-admin-home-payment-links": "\n .title = Betalingslinks \n .description = Opret et unikt betalinhslink til gæster eller kursister.",
        "merchant-admin-home-customers-card": "\n .title = Kundeadgang\n .description = Administrer dine kunders adgang til systemet",
        "merchant-admin-home-merchant-news-card": "\n .title = Kundenyheder\n .description = Publicer nyheder for salgsstedet til dine kunder.",
        "merchant-admin-home-admin-card": "\n .title = Administratorer\n .description = Styr administratorer for dit salgssted.",
        "merchant-admin-home-products": "\n .title = Produkter\n .description = Tilføj og vedligehold produkter for dine shops.",
        "merchant-admin-home-product-groups": "\n .title = Produktgrupper\n .description = Inddel dine produkter i grupper og styr synligheden af grupper i løbet af dagen.",
        "merchant-admin-home-extra-services": "\n .title = Ekstra services\n .description = Tilføj og vedligehold ekstra services til dine shops.",
        "merchant-admin-home-price-list": "\n .title = Prislister\n .description = Brug prislister til at udbyde differentierede produkter og priser til dine kunder.",
        "merchant-admin-home-merchant-surveys": "\n .title = Brugerundersøgelser\n .description = Hold øje med kundetilfredshed ved at oprette brugerundersøgelser.",
        "merchant-admin-home-push-messages-card": "\n .title = Push-beskeder\n .description = Send og vedligehold push-beskeder til dine kunder",
        "merchant-admin-home-info-displays-card":
            "\n .title = Integrationsfeeds\n .description = Forhåndsvis og del dine integrationsfeeds.",
        "merchant-admin-home-devices-card": "\n .title = Hardware enheder\n .description = Vis hardware enheder, såsom skærme, printere og kreditkort terminaler.",
        "merchant-admin-home-offers-card": "\n .title = Tilbud\n .description = Administrer dine tilbud",
        "merchant-admin-home-vat-codes-card": "\n .title = Momskoder\n .description = Administrer momskoder",
        "merchant-admin-home-id-cards-card": "\n .title = ID-kort\n .description = Vis dine kunders ID-kort til POS betaling.",
        "merchant-admin-home-id-cards-group": "\n .title = ID-kort",
        "merchant-admin-home-menu-planning-card": "\n .title = Menuplanlægning\n .description = Opret og administrer menuskabeloner.",
        "merchant-admin-home-custom-jobs-card": "\n .title = Tilpassede jobs\n .description = Se og kør tilpassede jobs for dit salgssted.",
        "merchant-admin-home-account-group": "\n .title = Konto",
        "merchant-admin-home-merchant-account-card": "\n .title = Virksomhedskonto\n .description = Opdater din virksomheds stamoplysninger\n .buttonText = Vis",
        "merchant-admin-home-delivery-locations-card": "\n .title = Leveringslokationer\n .description = Administrer leveringslokationer, hvor kunder kan hente ordrer.",


        // Merchant > Admin > Settings > Custom jobs
        "merchant-admin-settings-custom-jobs-title":" \n .title = Tilpassede jobs",
        "merchant-admin-settings-custom-jobs-table-name":"Navn",
        "merchant-admin-settings-custom-jobs-table-interval":"Interval",
        "merchant-admin-settings-custom-jobs-table-last-run":"Sidste kørsel",
        "merchant-admin-settings-custom-jobs-table-status":"Status",
        "merchant-admin-settings-custom-jobs-table-action-details":"Detaljer",
        "merchant-admin-settings-custom-jobs-table-action-run-job":"Kør job",
        "merchant-admin-settings-custom-jobs-table-action-activate":"Aktiver",
        "merchant-admin-settings-custom-jobs-table-action-inactivate":"Deaktiver",

        // Messages
        "messages-list-header": "\n .title = Push-beskeder",
        "messages-list-create-button": "Opret ny",
        "merchant-nav-item-messages": "Push-beskeder",
        "messages-table-subject-column" : "Emne",
        "messages-table-publish-time-column": "Udgivelsesdato",
        "messages-table-expire-time-column": "Udløbsdato",
        "messages-table-publish-type-filter-label": "Publiceringstype",
        "messages-table-publish-type-filter-label-label": "\n .label = Publiceringstype",
        "messages-table-publish-type-filter-item-published": "Publiceret",
        "messages-table-publish-type-filter-item-upcoming": "Kommende",
        "messages-table-publish-type-filter-item-expired": "Udløbet",
        "messages-table-edit-button": "Rediger",
        "messages-table-delete-button": "Slet",
        "messages-table-delete-modal-title": "besked",
        "messages-table-delete-success-message": "Besked slettet",
        "messages-table-update-delete-dialog-title": "Besked kan ikke opdateres eller slettes",
        "messages-table-update-delete-dialog-description": "Besked kan ikke opdateres eller slettes fordi den er blevet publiceret.",
        "messages-table-update-delete-dialog-button": "Luk",

        // create / edit messages
        "create-message-header": "\n .title = Opret besked",
        "edit-message-header": "\n .title = Ret besked",
        "nav-item-create-message-header": "Opret besked",
        "nav-item-edit-message-header": "Ret besked",
        "create-message-save-button": "Opret",
        "edit-message-save-button": "Gem",
        "create-or-edit-message-info": "\n .title = Send korte vigtige beskeder til brugerne, f.eks. om lukkedage, arrangementer eller lignende. Beskeder vil være synlige for alle brugere, der er forbundet til dine shops.",
        "create-or-edit-message-field-subject": "\n .label = Overskrift \n .placeholder = Tilføj et fængende emne, som brugerne har lyst til at læse * \n .helperText = Tilføj et fængende emne, som brugerne har lyst til at læse",
        "create-or-edit-message-dialog-field-subject-label": "Overskrift:",
        "create-or-edit-message-field-title-page": "\n .label = Overskrift\n .placeholder = Overskrift\n .helperText =Tilføj et fængende emne, som brugerne har lyst til at læse",
        "create-or-edit-message-dialog-field-message-label": "Besked:",
        "create-or-edit-message-field-message": "\n .label = Besked\n .placeholder = Indtast en besked *\n .helperText = Resterende tegn: { $charsRemaining }",
        "create-or-edit-message-settings": "\n .title = Indstillinger",
        "create-or-edit-message-field-publishDate": "\n .label = Publicering:",
        "create-or-edit-message-field-publish-title": "Publicering:",
        "create-or-edit-message-accordion-title": "Indstillinger",
        "create-or-edit-message-field-publishDate-page": "\n .label = Publicering",
        "create-or-edit-message-field-publishDate-helperText": "Bestemmer hvornår beskeden bliver synlig for brugerne.",
        "create-or-edit-message-field-expirationDate-info": "\n .title = Udløbstiden gælder kun for beskeder på infoskærme og møderumsskærme.",
        "create-or-edit-message-field-expirationDate-title": "Udløb:",
        "create-or-edit-message-field-expirationDate": "\n .label = Udløb:",
        "create-or-edit-message-field-expirationDate-page": "\n .label = Udløb",
        "create-or-edit-message-field-title-required": "Overskrift er påkrævet",
        "create-or-edit-message-field-body-required": "Besked er påkrævet",
        "create-or-edit-message-field-body-too-long": `Du har overskredet maks. antal tegn: { $charsLimit }`,
        "create-or-edit-message-field-channels-required": "Vælg mindst én kanal",
        "create-or-edit-message-field-channel-type-mode-in-app": "App besked",
        "create-or-edit-message-field-channel-type-description-mode-in-app": "Send som besked på web og i app",
        "create-or-edit-message-field-channel-type-mode-push": "Push notifikation",
        "create-or-edit-message-field-channel-type-description-mode-push": "Send som mobil push notifikation",
        "create-or-edit-message-field-channel-type-mode-sms": "SMS besked",
        "create-or-edit-message-field-channel-type-description-mode-sms": "Send som SMS besked",
        "create-or-edit-message-field-channel-type-mode-email": "E-mail",
        "create-or-edit-message-field-channel-type-description-mode-email": "Send som e-mail",
        "create-or-edit-message-field-channel-type-mode-in-app-card": "App kort",
        "create-or-edit-message-field-channel-type-description-mode-in-app-card": "Vises som kort i GoPay appen",
        "create-or-edit-message-field-channel-type-mode-info-display": "Infoskærme",
        "create-or-edit-message-field-channel-type-description-mode-info-display": "Vis på mødevisningsskærme og infoskærme",
        "create-or-edit-message-field-channel-type-mode-room-display": "Møderumsskærme",
        "create-or-edit-message-field-channel-type-description-mode-room-display": "Vis på møderumsskærme",
        "create-or-edit-message-field-tag": "\n .label = Emne: \n .placeholder = Vælg et emne",
        "create-or-edit-message-dialog-topic-label": "Emne:",
        "create-or-edit-message-dialog-topic-placeholder": "Vælg et emne *",
        "create-or-edit-message-field-tag-page": "\n .label = Emne",
        "create-or-edit-message-field-tag-mode-info": "Info",
        "create-or-edit-message-field-tag-description-mode-info": "Til generelle oplysninger om kantinen, åbningstider, madudvalg, eller procedurer.",
        "create-or-edit-message-field-tag-mode-important": "Vigtigt",
        "create-or-edit-message-field-tag-description-mode-important": "For kritiske beskeder, som f.eks. ændringer i åbningstider, sundheds- og sikkerhedsoplysninger eller andre presserende meddelelser.",
        "create-or-edit-message-field-tag-mode-offer": "Tilbud",
        "create-or-edit-message-field-tag-description-mode-offer": "For tilbud, rabatter, kampagner eller særlige arrangementer.",
        "create-or-edit-message-field-tag-mode-menu-change": "Menu",
        "create-or-edit-message-field-tag-description-mode-menu-change": "For at informere brugerne om ændringer i dagens menu, nye retter eller sæsonbestemte tilbud.",
        "create-or-edit-message-field-tag-mode-event": "Arrangement",
        "create-or-edit-message-field-tag-description-mode-event": "For kommende begivenheder, såsom temadage, madfestivaler eller specielle begivenheder i kantinen.",
        "create-or-edit-message-field-tag-mode-reminder": "Påmindelse",
        "create-or-edit-message-field-tag-description-mode-reminder": "For at minde brugerne om vigtige datoer eller frister, f.eks. tilmelding til arrangementer eller til at bestille mad i forvejen.",
        "create-or-edit-message-field-tag-mode-feedback": "Feedback",
        "create-or-edit-message-field-tag-description-mode-feedback": "For opfordringer til at give feedback på mad og service, eller undersøgelser om brugertilfredshed.",
        "create-or-edit-message-field-tag-mode-news": "Nyhed",
        "create-or-edit-message-field-tag-description-mode-news": "For opdateringer om kantinens aktiviteter, tiltag eller ændringer i drift, som kan være af interesse for brugerne.",
        "create-or-edit-message-field-tag-mode-health": "Sundhed",
        "create-or-edit-message-field-tag-description-mode-health": "For oplysninger om sunde valg, ernæringstips eller allergeninformationer relateret til menuen.",
        "create-or-edit-message-field-tag-mode-social": "Fællesskab",
        "create-or-edit-message-field-tag-description-mode-social": "For at fremme fællesskabsinitiativer, temadage, sociale arrangementer.",
        "create-or-edit-message-field-tag-required": "Emne er påkrævet",
        "create-message-success-dialog-title": "Beskeden er oprettet",
        "create-message-success-dialog-view-archive": "Se meddelelsesarkiv",
        "create-message-success-dialog-close-button": "Luk",
        "create-message-success-dialog-view-list-button": "Gå til beskeder",

        // Customer access
        "merchant-customer-access-header": "\n .title = Kundeadgang",
        "merchant-customer-access-customers-table-name-column": "Navn",
        "merchant-customer-access-customers-table-active-column": "Status",
        "merchant-customer-access-customers-table-domains-column": "Domæner",
        "merchant-customer-access-customers-table-active-filter-yes": "Aktive",
        "merchant-customer-access-customers-table-active-filter-no": "Inaktive",
        "merchant-customer-access-customers-table-active-column-active": "Aktiv",
        "merchant-customer-access-customers-table-active-column-inactive": "Inaktiv",

        // Merchant account > Swift dialog
        "merchant-account-swift-dialog-title":"Skift salgssted",
        "merchant-account-swift-dialog-subtitle":"Du har adgang til følgende salgssteder. Vælg et for at skifte.",
        "merchant-account-swift-dialog-empty-title":"Du har ikke adgang til andre salgssteder.",

        // Merchant home
        "merchant-home-today-card-group": "\n .title = POS salg \n .subtitle = i dag",
        "merchant-home-todays-control-code": "\n .title = Dagens kontrolkode",
        "merchant-home-todays-control-code-title": "Dagens kontrolkode",
        "merchant-home-todays-offers": "Dagens tilbud\n .title = Dagens tilbud",
        "merchant-product-tour-step-welcome": "Velkommen til Facilitynet. Dette er en kort introduktion til, hvordan du bruger den.",
        "merchant-product-tour-step-order-notifications-button": "Klik her for at åbne et overblik over dagens ordrer og aktiviteter.",
        "merchant-product-tour-step-order-notifications": "Her kan du få et overblik over ordrer og aktiviteter, som kræver din opmærksomhed.",
        "merchant-product-tour-step-new-button": "Klik her for at åbne genveje til at oprette beskeder og ordrer.",
        "merchant-product-tour-step-new": "Du kan klikke på Ny knappen for at oprette push-beskeder, bestille mødeforplejning på vegne af brugerne og nem adgang til genveje.",
        "merchant-product-tour-step-environment-button": "Klik her for at åbne menuen til at skifte mellem miljøer.",
        "merchant-product-tour-step-environment": "Portalen er opdelt i 3 miljøer, der hver fokuserer på et bestemt emne. Du skifter miljø her.",
        "merchant-product-tour-step-nav-production": "I Produktion kan du planlægge og administrere ordrer.",
        "merchant-product-tour-step-nav-menu-planning": "I Menuplanlægning kan du oprette ugens menuer for at holde kantinebrugerne informeret.",
        "merchant-product-tour-step-nav-purchase-control": "Brug Købskontrol til at sikre, at alle betaler for deres mad.",
        "merchant-product-tour-step-nav-survey": "Få vist resultatet af bruger feedback og holde øje med kundetilfredshed.",
        "merchant-product-tour-locale-back": "Tilbage",
        "merchant-product-tour-locale-next": "Næste",
        "merchant-product-tour-locale-last": "Færdig",
        "merchant-product-tour-locale-skip": "Spring over",
        "merchant-product-tour-locale-close": "Luk",
        "takeaway-announcement-tour-step-intro": "Vi har lanceret en dedikeret side til takeaway.",
        "takeaway-announcement-tour-step-nav-takeaway": "Fra nu af finder du takeaway-ordrer her.",
        "merchant-home-number-of-orders": "\n .title = Ordrer \n .titleTooltip = Antal POS ordrer i dag",
        "merchant-home-turnover": "\n .title = Omsætning \n .titleTooltip = Dagens totalbeløb for POS salg",
        "merchant-home-avg-amount": "\n .title = Gns. beløb \n .titleTooltip = Gennemsnitligt ordrerbeløb for dagens ordrer\n .subtitle = DKK",
        "merchant-home-subscriptions": "\n .title = Abonnementer \n .titleTooltip = Dagens aktive frokostabonnementer",
        "merchant-home-takeaway-card-group": "\n .title = Takeaway \n .subtitle = i dag",
        "merchant-home-takeaway-number-of-orders": "\n .title = Ordrer \n .titleTooltip = Antal takeaway-ordrer i dag",
        "merchant-home-takeaway-turnover": "\n .title = Omsætning \n .titleTooltip = Dagens totalbeløb for takeaway-salg",
        "merchant-home-takeaway-avg-amount": "\n .title = Gns. beløb \n .titleTooltip = Gennemsnitligt ordrerbeløb for dagens takeaway-ordrer\n .subtitle = DKK",
        "merchant-home-statistics-card-group": "\n .title = Statistik",
        "merchant-home-checkin-card": "\n .title = Check-in skærm\n .titleTooltip = Viser hvor mange kunder, der husker at scanne deres købsbevis på tjek-ind skærmen i forhold til hvor mange, der glemmer det",
        "merchant-home-checkin-card-participants": "Tjekket ind ({ $checkedIn })",
        "merchant-home-checkin-card-none-participants": "Ikke tjekket ind ({ $notCheckedIn })",
        "merchant-home-checkin-card-participation-percentage": "Procent",
        "merchant-home-survey-card-empty": "\n .title = Tilfredshed",
        "merchant-home-meeting-service-card-group": "\n .title = Mødeforplejning\n .subtitle = i dag",
        "merchant-home-meeting-service-number-of-orders-card": "\n .title = Ordrer\n .titleTooltip = Antal mødeforplejningsordrer for i dag",
        "merchant-home-meeting-service-awaiting-approval-card": "\n .title = Til godkendelse\n .titleTooltip = Totalt antal mødeforplejningsordrer, der afventer godkendelse",
        "merchant-home-meeting-service-ready-for-invoicing-card": "\n .title = Til fakturering\n .titleTooltip = Totalt antal mødeforplejningsordrer, der afventer at blive bogført",
        "merchant-home-meeting-service-ready-for-invoicing-card-description": "&gt; {$overdueDays} dage siden",
        "merchant-home-meeting-service-delivery-planning-card": "\n .title = Leveringsplanlægning\n .titleTooltip = Viser fordelingen af mødeforplejningsordrer i løbet af dagen",
        "merchant-home-meeting-service-delivery-planning-delivery": "Levering",
        "merchant-home-meeting-service-delivery-planning-picked-up": "Afhentntes",
        "merchant-home-meeting-service-delivery-planning-eating-in-canteen": "Spiser i kantinen",
        "merchant-home-meeting-service-next-deliveries-card": "\n .title = {$numberOfOrders} næste leveringer\n .titleTooltip = De næste 5 leveringer for i dag",
        "merchant-home-meeting-service-table-name-column": "Kunde",
        "merchant-home-meeting-service-table-meeting-column": "Møde",
        "merchant-home-meeting-service-table-delivery-column": "Levering",
        "merchant-home-meeting-service-no-upcoming-deliveries": "Der er ingen kommende leveringer.",
        "merchant-home-views-button": "Live Dashboards",
        "merchant-home-views-dialog-title": "Live Dashboards",
        "merchant-home-views-dialog-subtitle": "Vælg et dashboard nedenfor:",
        "merchant-home-views-dialog-conference": "Messe",
        "merchant-home-views-dialog-conference-live-sales-part-1": "Live",
        "merchant-home-views-dialog-conference-live-sales-part-2": "salg",
        "merchant-home-views-dialog-conference-orders": "Ordrer",
        "merchant-home-views-dialog-conference-turnover": "Omsætning",
        "merchant-home-views-dialog-conference-avg-price": "Gns. pris",
        "merchant-home-views-dialog-conference-free-riders": "Gratister",
        "merchant-home-views-dialog-conference-satisfaction": "Tilfredshed",
        "merchant-home-statistics-pos-turnover-card": "\n .title = POS omsætning \n .titleTooltip = Viser POS salg for den valgte periode op mod salget for forrige periode",
        "merchant-home-statistics-pos-orders-card": "\n .title = POS ordrer \n .titleTooltip = Viser antal POS ordrer for den valgte periode op mod ordrer for forrige periode",
        "merchant-home-statistics-number-of-users-card": "\n .title = Brugere \n .titleTooltip = Viser antallet af nye brugere for valgte periode op mod nye brugere for forrige periode",
        "merchant-home-statistics-period-base-3": "Sidste 3 dage",
        "merchant-home-statistics-period-base-14": "Sidste 14 dage",
        "merchant-home-statistics-period-base-30": "Sidste 30 dage",
        "merchant-home-statistics-period-base-60": "Sidste 60 dage",
        "merchant-home-statistics-period-base-180": "Sidste 180 dage",
        "merchant-home-statistics-compared-to-last-period": "i forhold til sidste periode",

        // Merchant home tooltips
        "merchant-home-todays-control-code-tooltip": "\n .title = Koden vises på købsbeviset (app) og på den udskrevne kvittering",
        "merchant-home-todays-offers-tooltip": "\n .title = Antal tilbud der er aktive for i dag",

        // Merchant Account
        "merchant-update-account-page-header": "\n .title = Konto for salgssted",
        "merchant-update-account-save-button": "Gem",
        "merchant-update-account-opening-hours-title":"\n .title = Åbningstider",
        "merchant-update-account-opening-hours-action-button-add":"Tilføj",
        "merchant-update-account-opening-hours-action-button-edit":"Ret",
        "merchant-update-account-opening-hours-empty-text":"Åbningstider ikke sat",
        "merchant-update-account-opening-hours-dialog-title":"Åbningstider",
        "merchant-update-account-opening-hours-dialog-save-button":"Gem",
        "merchant-update-account-opening-hours-dialog-before-start-error":"Lukketid før åbningstid",
        "merchant-update-account-opening-hours-dialog-closed-time-select-from":"\n .label = Fra",
        "merchant-update-account-opening-hours-dialog-time-select-to":"\n .label = Til",
        "merchant-update-account-opening-hours-dialog-closed":"Lukket",
        "merchant-update-account-opening-hours-day-monday": "Mandag",
        "merchant-update-account-opening-hours-day-tuesday": "Tirsdag",
        "merchant-update-account-opening-hours-day-wednesday": "Onsdag",
        "merchant-update-account-opening-hours-day-thursday": "Torsdag",
        "merchant-update-account-opening-hours-day-friday": "Fredag",
        "merchant-update-account-opening-hours-day-saturday": "Lørdag",
        "merchant-update-account-opening-hours-day-sunday": "Søndag",



        //Merchant reports
        "merchant-reports-id-cards-title": "\n .title = ID-kort",
        "merchant-reports-id-cards-nav-item-home": "Hjem",
        "merchant-reports-id-cards-nav-item-id-cars": "ID-kort",

        // Merchant ID table
        "merchant-id-cards-table-card-number": "Kortnummer",
        "merchant-id-cards-table-card-type": "Kort type",
        "merchant-id-cards-table-user": "Bruger",
        "merchant-id-cards-table-company": "Firma",
        "merchant-id-cards-table-status": "Status",
        "merchant-id-cards-table-card-type-select-label": "\n .label = Kort type",
        "merchant-id-cards-table-company-select-label": "\n .label = Firma",
        "merchant-id-cards-table-card-type-select-item-wallet":"Wallet",
        "merchant-id-cards-table-card-type-select-item-company-credit":"Firmakredit",
        "merchant-id-cards-table-card-type-select-item-tickets":"Klippekort",
        "merchant-id-cards-table-card-type-select-item-unlimited-tickets":"Ubegrænset klippekort",
        "merchant-id-cards-table-card-type-select-item-tickets-unlimited":"Ubegrænsede klip",
        "merchant-id-cards-table-card-type-select-item-top-up": "Optankning",
        "merchant-id-cards-table-card-type-select-item-payroll-deduction": "Løntræk",


        // Merchant ID Cards Dialog
        "merchant-id-cards-dialog-title": "ID-kort detaljer",
        "merchant-id-cards-dialog-status": "Status:",
        "merchant-id-cards-dialog-card-name": "Kort navn:",
        "merchant-id-cards-dialog-card-type": "Kort type:",
        "merchant-id-cards-dialog-card-type-top-up": "Wallet",
        "merchant-id-cards-dialog-card-type-wallet": "Wallet",
        "merchant-id-cards-dialog-card-type-company-credit": "Firmakredit",
        "merchant-id-cards-dialog-card-type-tickets": "Klippekort",
        "merchant-id-cards-dialog-card-type-tickets-unlimited": "Ubegrænset klippekort",
        "merchant-id-cards-dialog-card-type-payroll-deduction": "Løntræk",
        "merchant-id-cards-dialog-validated": "Valideret:",
        "merchant-id-cards-dialog-expiry": "Udløb:",
        "merchant-id-cards-dialog-payment-method": "Betalingsmetode:",
        "merchant-id-cards-dialog-user-id": "Bruger ID:",
        "merchant-id-cards-dialog-employee-id": "Medarbejder ID:",
        "merchant-id-cards-dialog-name": "Navn:",
        "merchant-id-cards-dialog-email": "E-mail:",
        "merchant-id-cards-dialog-mobile": "Mobil:",
        "merchant-id-cards-dialog-phone": "Telefon:",

        "id-cars-table-button-details": "Detaljer",
        "id-cars-filter-card-title":"\n .title = Kort",
        "id-cars-filter-debtor-title":"\n .title = Debitor",
        "id-cars-filter-end-user-title":"\n .title = Slutbruger",
        "id-cars-filter-card-number-label":"\n .label = Kortnummer\n .placeholder = Søg på kortnummer",
        "id-cars-filter-switch-label":"\n .label = Inkluder inaktive kort",
        "id-cars-filter-debtor-label":"\n .label = Debitor",
        "id-cars-filter-email-label":"\n .label = E-mail",
        "id-cars-filter-employee-id-label":"\n .label = Medarbejder ID",

        "merchant-production": "Produktion",

        // Merchant > Admin > Shops > Products
        "products-page-header": "\n .title = Produkter",
        "products-tab-all-products": "Alle produkter",
        "products-tab-sort-products": "Sorter produkter",
        "products-table-info-box": "Vælg en shop for at fortsætte",
        "products-table-show-inactive": "\n .label = Vis deaktiverede",
        "products-move-availability-dialog":
            "\n .title = Indsnævre produktets tilgængelighed?\n .message = “{ $productName }” er tilgængelig uden for dagene eller tidsrummet for “{ $groupName }”. Efter flytningen vil det være tilgængeligt: { $days }, { $hours }.\n .buttonLabelSubmit = Flyt og indsnævr\n .buttonLabelCancel = Annuller",
        "products-move-availability-dialog-no-overlap-alert":
            "\n .title = Produktet har ingen dage eller klokkeslæt til fælles med gruppen, så dets egne dage og klokkeslæt erstattes af gruppens.",
        "products-move-availability-dialog-every-day-label": "alle dage",
        "products-move-availability-dialog-all-day-label": "hele dagen",
        "products-page-table-price-list-label": "\n .label = Prisliste",
        "products-no-price-list-tab": "Ingen prisliste",
        "products-action-bar-move-to-price-list": "Flyt til prisliste",
        "products-action-bar-copy-to-price-list": "Kopier til prisliste",
        "products-action-bar-status": "\n .title = Status",
        "products-action-bar-set-active": "\n .title = Aktiv",
        "products-action-bar-set-inactive": "\n .title = Inaktiv",
        "products-select-price-list-label": "Vælg prisliste:",
        "products-move-to-price-list-dialog-title": "Flyt til prisliste",
        "products-copy-to-price-list-dialog-title": "Kopier til prisliste",
        "products-price-list-dialog-accordion-title": "Produkter ({ $count })",
        "products-name-column": "Navn",
        "products-price-column": "Pris",
        "products-status-column": "Status",
        "products-create-product-button": "Opret ny",
        "merchant-admin-enable-product-sort-button": "Aktivér produktsortering",
        "merchant-admin-enable-product-sort-info": "\n .title = Når du aktiverer produktsortering første gang, sorterer vi produkterne og produktgrupperne i en standardrækkefølge. Derfra kan du flytte rundt på dem, som du ønsker.",
        "products-edit-product-menu-item": "Rediger",
        "products-delete-product-menu-item": "Slet",
        "products-confirm-delete-product-dialog": "\n .typeOfEntity = produkt",
        "products-export-id": "Produkt-ID",
        "products-export-product-number": "Produktnummer",
        "products-export-group": "Produktgruppe",
        "products-export-name": "Produktnavn",
        "products-export-price": "Pris",
        "products-export-status": "Status",
        "products-export-stock-total": "Lagerbeholdning",
        "products-export-items-for-sale-per-day": "Varer til salg pr. dag",
        "products-export-items-left-today": "Resterende i dag",
        "product-offer-chip": "\n .label = Tilbud",

        // Merchant > Admin > Products > Info icons
        "product-info-icon-deadline-label": "Deadline",
        "product-info-icon-deadline-value": "{ $daysBefore } dage før, kl. { $timeOfDay }",
        "product-info-icon-availability-label": "Tilgængelighed",
        "product-info-icon-offer-label": "Tilbud",
        "product-info-icon-offer-percentage-value": "-{ $percentage }%",
        "product-info-icon-offer-discount-price-value": "Nedsat pris",
        "product-info-icon-marketing-tag-label": "Markedsføringstag",
        "product-info-icon-allergens-label": "Allergener",
        "product-info-icon-allow-pre-order-label": "Tillad forudbestilling",
        "product-info-icon-description-label": "Beskrivelse",
        "product-info-icon-pin-code-label": "PIN-kode",
        "product-info-icon-pin-code-value": "Påkrævet",
        "products-edit-product-group-menu-item": "Rediger",
        "products-delete-product-group-menu-item": "Slet",

        // Merchant > Admin > Shops > Price list dropdown selector
        "price-list-dropdown-selector-field-label": "Prisliste",
        "price-list-dropdown-selector-placeholder": "Vælg prisliste",
        "price-list-dropdown-selector-active-only-checkbox": "\n .label = Kun aktive",
        "price-list-dropdown-selector-inactive-chip": "\n .label = Inaktiv",
        "price-list-dropdown-selector-internal-note-label": "Intern note",
        "price-list-dropdown-selector-message-to-customers-label": "Besked til kunder",
        "price-list-dropdown-selector-no-info": "Ingen yderligere info",
        "price-list-dropdown-selector-vat-inclusive": "Pris inkl. moms",
        "price-list-dropdown-selector-vat-exclusive": "Pris ekskl. moms",

        // Merchant > Admin > Products > Stock
        "product-stock-chip-label": "Lager: { $count }",
        "product-stock-daily-sales": "Solgt i dag: { $sold }/{ $total }",
        "product-stock-on-sale-per-day-label": "Til salg pr. dag:",
        "product-stock-on-sale-per-day-info": "\n .title = Ved hjælp af dette kan du begrænse antallet af varer til salg hver dag.\n .description = Ved hjælp af dette kan du begrænse antallet af varer til salg hver dag.",
        "product-stock-on-sale-per-day-required-error": "Til salg pr. dag er påkrævet",
        "product-stock-on-sale-per-day-min-error": "Til salg pr. dag skal være mindst 1",
        "product-stock-total-stock-label": "Samlet lager:",
        "product-stock-total-stock-items": "{ $count } varer",
        "product-stock-current-stock-label": "Aktuel lagerbeholdning:",
        "product-stock-tab-inventory": "Lagerregulering",
        "product-stock-tab-daily": "Til salg pr. dag",
        "product-stock-type-label": "\n .label = Type:",
        "product-stock-type-option-inbound": "Tilføj til lager",
        "product-stock-type-option-outbound": "Fjern fra lager",
        "product-stock-adjustment-amount-label": "Antal:",
        "product-stock-adjustment-amount-tooltip": "\n .title = Indtast mængden der skal reguleres",
        "product-stock-reason-label": "Årsag:",
        "product-stock-reason-tooltip": "\n .title = Vælg årsagen til denne lagerregulering",
        // Outbound reasons
        "product-stock-reason-option-sold": "Solgt",
        "product-stock-reason-tooltip-sold": "\n .title = Varer solgt til en kunde.",
        "product-stock-reason-option-reserved": "Reserveret",
        "product-stock-reason-tooltip-reserved": "\n .title = Varer lagt til side til en specifik ordre.",
        "product-stock-reason-option-shipped": "Afsendt",
        "product-stock-reason-tooltip-shipped": "\n .title = Varer har forladt lageret.",
        "product-stock-reason-option-returned-to-vendor": "Retur til leverandør",
        "product-stock-reason-tooltip-returned-to-vendor": "\n .title = Varer sendt retur til leverandøren.",
        "product-stock-reason-option-consumed-in-production": "Forbrugt i produktion",
        "product-stock-reason-tooltip-consumed-in-production": "\n .title = Ingredienser brugt under madlavning/produktion.",
        "product-stock-reason-option-scrapped": "Kasseret",
        "product-stock-reason-tooltip-scrapped": "\n .title = Varer kasseret som ubrugelige.",
        "product-stock-reason-option-lost": "Mistet",
        "product-stock-reason-tooltip-lost": "\n .title = Varen kan ikke findes.",
        "product-stock-reason-option-stolen": "Stjålet",
        "product-stock-reason-tooltip-stolen": "\n .title = Varer fjernet ved tyveri.",
        "product-stock-reason-option-sample-given": "Udleveret vareprøve",
        "product-stock-reason-tooltip-sample-given": "\n .title = Varer givet ud til smagsprøve eller test.",
        // Inbound reasons
        "product-stock-reason-option-purchased": "Indkøbt",
        "product-stock-reason-tooltip-purchased": "\n .title = Nye varer modtaget fra en leverandør.",
        "product-stock-reason-option-returned-from-customer": "Kunderetur",
        "product-stock-reason-tooltip-returned-from-customer": "\n .title = Varer returneret til lageret fra en kunde.",
        "product-stock-reason-option-produced": "Produceret",
        "product-stock-reason-tooltip-produced": "\n .title = Færdigvarer tilføjet efter tilberedning.",
        "product-stock-reason-option-found-during-count": "Fundet ved optælling",
        "product-stock-reason-tooltip-found-during-count": "\n .title = Ekstra varer fundet under lageroptælling.",
        "product-stock-reason-option-transferred-in": "Overført (ind)",
        "product-stock-reason-tooltip-transferred-in": "\n .title = Varer flyttet fra en anden lokation.",
        "product-stock-items-per-day-label": "Varer til salg pr. dag",
        "product-stock-items-per-day-tooltip": "\n .title = Antal varer tilgængelige til salg pr. dag",
        "product-stock-note-label": "Note:",
        "product-stock-note-placeholder": "\n .placeholder = Valgfri ekstra info om regulering",
        "product-stock-confirm-button": "Bekræft",
        "product-stock-cancel-button": "Annuller",
        "product-stock-adjustment-button": "Lagerregulering",
        "product-stock-update-success": "Lager opdateret",
        "product-create-stock-switch-label": "Lagerstyring:",
        "product-create-stock-total-field": "\n .label = Total lager",
        "product-create-stock-items-per-day-field": "\n .label = Varer pr. dag",
        "product-create-stock-info": "Indstil den totale lagerbeholdning og hvor mange varer der kan sælges pr. dag.",

        // Merchant > Admin > Extra Services
        "extra-services-page-header": "\n .title = Ekstra services",
        "extra-services-edit-submit-button": "Gem",
        "extra-services-create-service-button": "Opret ny",
        "extra-services-services-column": "Tjenester",
        "extra-services-service-type-column": "Servicetype",
        "extra-services-price-type-column": "Pristype",
        "extra-services-status-column": "Status",
        "extra-services-price-subline-fixed": "Fast pris",
        "extra-services-price-subline-per-seat": "Pris pr. kuvert",
        "extra-services-price-subline-min": "Min pris",
        "extra-services-price-subline-max": "Maks pris",

        // Merchant > Admin > Extra Services > Create / Edit
        "extra-services-create-page-header": "\n .title = Opret ekstra service",
        "extra-services-edit-page-header": "\n .title = Ret ekstra service",
        "extra-services-create-active-switch": "Aktiv:",
        "extra-services-create-mandatory": "Tilføj altid til ordre",
        "extra-services-create-mandatory-without-pickup": "Tilføj ved afhentning",
        "extra-services-create-meeting-location-required-switch": "Kræv mødested",
        "extra-services-create-meeting-time-required-switch": "Kræv mødetid",
        "extra-services-create-service-time-weekdays-min-error": "Vælg venligst mindst én dag",
        "extra-services-create-price-field-label": "\n .label = Pris",
        "extra-services-create-min-price-field-label": "\n .label = Min. pris",
        "extra-services-create-max-price-field-label": "\n .label = Maks. pris",
        "extra-services-create-price-per-seat-field-label": "\n .label = Pris pr. kuvert",
        "extra-services-create-currency-field-label": "\n .label = Valuta",
        "extra-services-create-service-description-field":  "\n .label = Beskrivelse",
        "extra-services-create-service-description-field-max-length": "Beskrivelse kan ikke overstige { $maxLength } tegn",
        "extra-services-create-service-name-field":  "\n .label = Navn",
        "extra-services-create-service-type-field":  "\n .label = Servicetype",
        "extra-services-create-service-pricing-type-field":  "\n .label = Pris type",
        "extra-services-create-panel-pricing": "\n .label = Prissætning",
        "extra-services-create-settings-panel": "\n .title = Indstillinger",
        "extra-services-create-service-time-panel": "\n .title = Tilgængelige tider",
        "extra-services-create-form-type-dropdown-item-pickup-fee": "Afhentningsgebyr",
        "extra-services-create-form-type-dropdown-item-eat-in-canteen-fee": "Gebyr for spisning i kantine",
        "extra-services-create-form-type-dropdown-item-delivery-fee": "Leveringsgebyr",
        "extra-services-create-form-type-dropdown-item-table-setting-fee": "Bordopstillingsgebyr",
        "extra-services-create-form-type-dropdown-item-cleanup-fee": "Afrydningsgebyr",
        "extra-services-create-form-type-dropdown-item-out-of-opening-hours-fee": "Uden for åbningstid gebyr",
        "extra-services-create-form-type-dropdown-item-other": "Andet",
        "extra-services-create-form-pricing-type-dropdown-item-per-seat": "Pr. kuvert",
        "extra-services-create-form-pricing-type-dropdown-item-flat-fee": "Fast gebyr",
        "extra-services-create-when-add-to-order-field": "\n .label = Handling",
        "extra-services-create-when-add-to-order-no-action": "Ingen handlinger valgt",
        "extra-services-create-form-action-dropdown-item-add-always": "Tilføj altid",
        "extra-services-create-form-action-dropdown-item-add-when-pick-up": "Tilføj ved afhentning",
        "extra-services-create-form-action-dropdown-item-add-when-delivered": "Tilføj ved levering",

        // Merchant > Admin > Shops > Products > Create / Edit
        "product-create-page-header": "\n .title = Opret produkt",
        "product-create-submit-button": "Opret",
        "product-edit-page-header": "\n .title = Ret produkt",
        "product-edit-submit-button": "Gem\n .loadingLabel = Gemme...",
        "product-create-shops-field-label": "\n .label = Shops",
        "product-create-group-field-label": "\n .label = Produktgruppe",
        "product-create-number-field-label": "\n .label = Produktnummer",
        "product-create-name-field-label": "\n .label = Navn",
        "product-create-price-field-label": "\n .label = Pris",
        "product-create-price-field-title": "Pris",
        "product-create-price-field-vat-included-badge": "\n .label = Inkl. moms",
        "product-create-price-field-vat-excluded-badge": "\n .label = Ekskl. moms",
        "product-create-price-field-no-price-list-badge": "\n .label = Vælg prisliste",
        "product-create-price-field-no-price-list-placeholder": "Vælg prisliste først",
        "product-create-currency-field-label": "\n .label = Valuta",
        "product-create-description-field-label": "\n .label = Beskrivelse",
        "product-create-panel-access": "\n .title = Adgang",
        "product-create-panel-access-shop-alert-title": "\n .title = En shop repræsenterer et virtuelt eller fysisk salgssted, såsom webshops i GoPay appen eller shoppen knyttet til POS skærme i en kantine. En bruger som IKKE er tilknyttet en prisliste vil se produkter, der er direkte tilknyttet shops her.",
        "product-create-panel-access-price-list-alert-title": "\n .title = Prislister kan bruges til at tilbyde differentiet produktudvalg eller priser til forskellige brugergrupper. Flere prislister kan tilknyttes samme shop for at kunne tilbyde forskelligt udvalg. En bruger vil altid se én prisliste - eller - produkterne direkte tilknyttet shoppen. Hvilken prisliste der vises, afhænger af brugergruppen eller - i tilfælde af POS skærmen - ID-kort abonnementet.",
        "product-create-panel-description": "\n .title = Beskrivelse",
        "product-create-image-field-label": "\n .label = Billede",
        "create-image-file-support": "Understøttede filtyper: { $supportedFileTypes }. Maksimum størrelse: { $maxSize }",
        "product-create-general-panel": "\n .title = Generelt",
        "product-create-active-switch": "Aktiv:",
        "product-create-admin-only-switch": "Kun for personale:",
        "product-create-product-description-panel": "\n .title = Produktbeskrivelse",
        "product-create-product-description-marketing-tag-field": "\n .label = Marketing tag\n .helperText = Eksempler: 'Tilbud', 'CO2', 'Varm ret', 'Vegetarisk'",
        "product-create-product-description-allergens-field": "\n .label = Allergener",
        "product-create-availability-panel": "\n .title = Tilgængelighed\n .description = Begræns til bestemte dage og tidspunkter",
        "product-create-availability-from-date-picker": "\n .label = Fra dato",
        "product-create-availability-to-date-picker": "\n .label = Til dato",
        "product-create-availability-preorder-switch": "Tillad ikke forudbestilling:",
        "product-create-availability-info": "Kunder kan forudbestille produkter ud i fremtiden i GoPay app'en, medmindre du slår det fra her.",
        "product-create-availability-date-error": "Slutdato kan ikke være før startdato",
        "product-create-availability-week-days-label": "Tilgængelig på:",
        "product-create-availability-week-days-helper-text": "Lad alle dage være fravalgt for at sælge produktet alle dage.",
        "product-create-availability-week-days-group-helper-text": "Kun produktgruppens dage kan vælges. Lad alle dage være fravalgt for at sælge produktet på dem alle.",
        "product-create-availability-week-days-group-error": "Vælg kun dage, hvor produktgruppen er tilgængelig",
        "product-create-availability-from-time-picker": "\n .label = Fra klokken",
        "product-create-availability-to-time-picker": "\n .label = Til klokken",
        "product-create-availability-time-helper-text": "Lad begge klokkeslæt være tomme for at sælge produktet hele dagen.",
        "product-create-availability-time-group-helper-text": "Skal ligge inden for produktgruppens tidsrum, { $start } – { $end }. Lad begge klokkeslæt være tomme for at bruge produktgruppens tidsrum.",
        "product-create-availability-time-incomplete-error": "Angiv både 'Fra klokken' og 'Til klokken'",
        "product-create-availability-time-error": "'Til klokken' skal være større end 'Fra klokken'",
        "product-create-availability-time-group-error": "Klokkeslættene skal ligge inden for produktgruppens tidsrum",
        "product-create-deadline-panel": "\n .title = Frist\n .description = Hvor længe før levering der skal bestilles",
        "product-create-deadline-purchases-subtitle": "Køb:",
        "product-create-deadline-cancellation-subtitle": "Afbestilling:",
        "product-create-deadline-day-field": "\n .label = Dag",
        "product-create-deadline-day-limit-day-before": "Dagen før",
        "product-create-deadline-day-limit-x-days-before": "{ $daysBefore } dage før",
        "product-create-deadline-time-picker": "\n .label = Tid",
        "product-create-barcode-panel": "\n .title = ERP numre",
        "product-create-barcode-field-label": "\n .label = Stregkode",
        "product-create-sales-rules-panel": "\n .title = Salgsregler",
        "product-create-offer-panel": "\n .title = Tilbud\n .description = Midlertidig nedsat pris i en periode",
        "product-create-offer-discount-percentage": "Procentrabat:",
        "product-create-offer-discount-price": "Ny pris:",
        "product-create-offer-items-in-stock": "Antal varer på lager:",
        "product-create-offer-available-from": "Tilgængeligt fra:",
        "product-create-offer-available-to": "Tilgængeligt til:",
        "product-create-offer-edit-button": "Ret",
        "product-create-offer-create-button": "Opret",
        "product-create-offer-dialog-create-title": "Opret tilbud",
        "product-create-offer-dialog-edit-title": "Ret tilbud",
        "product-create-offer-dialog-normal-price": "Oprindelig pris:",
        "product-create-offer-dialog-price-adjustment-field": "\n .label = Prisjustering",
        "product-create-offer-dialog-price-adjustment-option-none": "Ingen",
        "product-create-offer-dialog-price-adjustment-option-discount-price": "Nedsat pris",
        "product-create-offer-dialog-price-adjustment-option-discount-percentage": "Rabatprocent",
        "product-create-offer-dialog-adjust-price-field": "\n .label = Ny pris",
        "product-create-offer-dialog-items-field": "Antal varer udbudt pr. dag:",
        "product-create-offer-dialog-percentage-field": "\n .label = Procentsats",
        "product-create-offer-dialog-available-offer-period": "Tilbudsperiode",
        "product-create-offer-dialog-available-from-date-picker": "\n .label = Tilgængeligt fra",
        "product-create-offer-dialog-available-to-date-picker": "\n .label = Tilgængeligt til",
        "product-create-offer-dialog-marketing-tag-label": "Marketingtag:",
        "product-create-offer-dialog-marketing-tag-mode-old-new-price-new": "25,00 kr",
        "product-create-offer-dialog-marketing-tag-mode-old-new-price-old": "35,00 kr",
        "product-create-offer-dialog-marketing-tag-mode-old-new-price": "25,00 kr 35,00 kr",
        "product-create-offer-dialog-marketing-tag-mode-save-x": "Spar [x] %",
        "product-create-offer-dialog-marketing-tag-mode-limited-on-sale": "Spar [x] kr",
        "product-create-offer-dialog-marketing-tag-mode-great-offer": "Godt tilbud",
        "product-create-offer-dialog-marketing-tag-mode-buy-now": "Køb nu",
        "product-create-offer-dialog-marketing-tag-mode-good-price": "God pris",
        "product-create-offer-dialog-marketing-tag-mode-discount": "Nedsat pris",
        "product-create-offer-dialog-marketing-tag-mode-week-offer": "Ugens tilbud",
        "product-create-offer-dialog-marketing-tag-mode-day-offer": "Dagens tilbud",
        "product-create-offer-dialog-save-button": "Gem",
        "product-create-add-price-list-button": "Tilføj til prisliste",
        "product-create-add-to-price-list": "Tilføj til prisliste",
        "product-create-price-list-step-one": "Vælg prisliste",
        "product-create-price-list-step-two": "Sæt pris",
        "product-create-price-list-table-name-column": "Navn",
        "product-create-price-list-table-status-column": "Status",
        "product-create-price-list-table-active-column-active": "Aktiv",
        "product-create-price-list-table-active-column-inactive": "Inaktiv",
        "product-create-price-list-table-active-column-active-filter-yes": "Aktiv",
        "product-create-price-list-table-active-column-inactive-filter-no": "Inaktiv",
        "product-create-price-list-table-currency": "Valuta:",
        "product-create-price-list-table-vat": "Moms:",
        "product-create-price-list-table-connected-shops": "Tilknyttede shops:",
        "product-create-price-list-table-connected-customers": "Tilknyttede kunder:",
        "product-create-price-list-table-vat-code": "Momskode:",
        "product-create-price-list-table-select-button": "Vælg",
        "product-create-price-list-selected-price-list": "Valgt prisliste:",
        "product-create-price-list-price-field-label": "\n .label = Pris",
        "product-create-price-list-add-button": "Tilføj",
        "product-create-payment-panel": "\n .title = Betaling",
        "product-create-pos-panel": "\n .title = POS",
        "product-create-payment-price-switch": "Skjul pris:",
        "product-create-variable-price-switch": "Aktivér variabel pris:",
        "product-create-require-staff-pin-switch": "Kræv personale-PIN:",
        "product-create-price-disabled-tooltip": "\n .title = Pris er deaktiveret, fordi variabel pris er aktiv",
        "product-create-delivery-panel": "\n .title = Levering",
        "product-create-delivery-deliveryDetails-field": "\n .label = Afhentningssted",
        "product-create-order-limits-panel": "\n .title = Ordrebegrænsning",
        "product-create-price-lists-field-label": "\n .label = Prislister",
        "product-create-price-list-field-label": "\n .label = Prisliste",
        "products-no-price-lists-message": "Du har endnu ingen prisliste. Du skal oprette en prisliste, før du kan oprette produkter.",
        "products-go-to-price-lists-button": "Gå til prislister",
        "product-create-item-limits-panel": "\n .title = Begrænsning på antal varer",
        "product-create-item-limits-max-field": "Maks. dagligt antal varer pr. person:",
        "product-create-item-limits-max-info": "Dette bestemmer, hvor mange varer af denne type, en kunde kan bestille pr. dag.",
        "product-create-item-limits-min-field": "Min. antal varer pr. ordre:",
        "product-create-item-limits-min-info": "Dette bestemmer, hvor minimum antal varer af denne type, en kunde skal tilføje til en ordre.",
        "product-create-item-limits-error": "Enten maks. dagligt antal varer eller min. antal varer pr. ordre skal udfyldes",
        "product-create-item-limits-min-error": "Min. antal produkter pr. ordre skal være tom eller >= 2",
        "product-create-item-limits-max-error": "Maks. antal daglige produkter skal være tom eller >= 1",


        // Product groups
        "product-groups-page-header-title": "\n .title = Produktgrupper",
        "product-groups-create-button": "Opret ny",
        "product-groups-no-price-lists-message": "Du har endnu ingen prisliste. Du skal oprette en prisliste, før du kan oprette produktgrupper.",
        "create-product-group-create-button": "Opret",
        "create-product-group-save-button": "Gem",
        "product-group-page-title-create": "\n .title = Opret produktgruppe",
        "product-group-page-title-update": "\n .title = Ret produktgruppe",
        "product-group-edit-products-outside-availability-dialog":
            "\n .title = Indsnævre produkternes tilgængelighed?\n .message = Disse produkter har egne dage eller klokkeslæt uden for gruppens nye tilgængelighed. De bliver indsnævret til gruppens dage og tidsrum.\n .buttonLabelSubmit = Gem og indsnævr\n .buttonLabelCancel = Annuller",
        "product-group-edit-products-outside-availability-dialog-no-overlap-description":
            "Ingen dage eller klokkeslæt til fælles med gruppen, så det følger gruppens tilgængelighed.",
        "product-group-delete": "produktgruppe",
        "product-group-delete-success-message": "Produktgruppen er slettet",
        "product-group-code-column-header": "ERP-nr.",
        "product-group-name-column-header": "Navn",
        "product-group-status-column-header": "Status",

        // Merchant > Shops > Product groups > Create / Edit
        "product-group-form-name-field": "\n .label = Navn",
        "product-group-form-code-field": "\n .label = ERP-nummer",
        "product-group-form-code-field-helper-text": "ERP-numre bruges i forbindelse med integration til et regnskabssystem. De vedligeholdes på leverandørniveau.",
        "product-group-form-code-field-helper-text-no-items": "Ingen tilgængelige produktgruppekoder for leverandør",
        "product-group-form-settings-panel": "\n .title = Indstillinger",
        "product-group-form-active-switch": "Aktiv:",
        "product-group-form-pin-code-required-switch": "Kræver PIN-kode:",
        "product-group-form-pin-code-required-explanation": "Det kræver en personale PIN-kode for at købe produkter i denne gruppe. PIN-koden er tilgængelig i detaljer for hardware enheden.",
        "product-group-form-limited-availability-panel-title": "\n .title = Tilgængelig i tidsrum \n .offContent = Produkter i denne grupper er altid tilgængelige for køb",
        "product-group-form-start-time-picker": "\n .label = Fra klokken",
        "product-group-form-end-time-picker": "\n .label = Til klokken",
        "product-group-form-week-day-monday": "Mandag",
        "product-group-form-week-day-tuesday": "Tirsdag",
        "product-group-form-week-day-wednesday": "Onsdag",
        "product-group-form-week-day-thursday": "Torsdag",
        "product-group-form-week-day-friday": "Fredag",
        "product-group-form-week-day-saturday": "Lørdag",
        "product-group-form-week-day-sunday": "Søndag",
        "product-group-form-end-time-picker-min-error-label": "Skal være større end 'Fra klokken'",


        // Merchant > Admin > Shops > Price lists
        "price-lists-header": "\n .title = Prislister",
        "price-lists-create-button": "Opret ny",
        "price-list-vat-code": "Momskode:",
        "price-list-currency": "Valuta:",
        "price-list-shops": "Tilkoblede shops:",
        "price-list-company": "Tilkoblede firmaer:",
        "price-list-no-result": "Der er ingen prislister. Opret din første prisliste",
        "price-list-delete": "prisliste",
        "price-list-delete-success-message": "Prisliste slettet",

        // Merchant > Admin > Price lists > Adjust prices
        "price-lists-adjust-prices-action": "Justér priser",
        "adjust-price-list-page-header": "\n .title = Justér priser",
        "adjust-price-list-breadcrumb": "Justér priser",
        "adjust-price-list-page-subtitle": "{ $priceList } · { $count } varer",
        "adjust-price-list-cancel-button": "Annuller",
        "adjust-price-list-scope-select-all": "Vælg alle",
        "adjust-price-list-scope-deselect-all": "Fravælg alle",
        "adjust-price-list-preview-summary": "{ $count ->\n [one] { $count } vare\n *[other] { $count } varer\n } ændres · f.eks. { $from } → { $to }",
        "adjust-price-list-preview-show": "Vis priser",
        "adjust-price-list-preview-hide": "Skjul",
        "adjust-price-list-preview-showing": "Viser { $shown } af { $total } varer.",
        "adjust-price-list-preview-show-all": "Vis alle",
        "adjust-price-list-summary-change": "Ændring",
        "adjust-price-list-summary-change-value": "{ $sign }{ $value }",
        "adjust-price-list-summary-rounding": "Afrunding",
        "adjust-price-list-summary-rounding-none": "Ingen",
        "adjust-price-list-summary-rounding-quarter": "{ $step }",
        "adjust-price-list-summary-rounding-half": "{ $step }",
        "adjust-price-list-summary-rounding-whole": "Hele { $currency }",
        "adjust-price-list-submit-button": "Godkend",
        "adjust-price-list-adjustment-panel": "\n .title = Justering",
        "adjust-price-list-banner": "\n .title = En prisjustering opretter en ny prisliste\n .description = Den nuværende liste ændres ikke. Du bestemmer, hvornår den nye liste træder i kraft, og hvilken liste den overtager fra — den gamle deaktiveres automatisk på den dato.",
        "adjust-price-list-base-list-field": "\n .label = Overtag priser fra\n .helperText = Valgt, da du åbnede justeringen.",
        "adjust-price-list-scope-subtitle-empty": "Vælg mindst én produktgruppe.",
        "adjust-price-list-preview-showing-all": "Viser alle { $total } varer.",
        "adjust-price-list-direction-increase": "Hæv priser",
        "adjust-price-list-direction-reduction": "Sænk priser",
        "adjust-price-list-value-field": "\n .label = Hvor meget?",
        "adjust-price-list-value-max-value": "Værdien kan ikke overstige { $max } { $unit }",
        "adjust-price-list-value-negative-price": "Ændringen ville gøre mindst én pris negativ. Vælg en mindre værdi.",
        "adjust-price-list-value-no-change": "Justeringen ændrer ingen priser. Vælg en større værdi eller andre produktgrupper.",
        "adjust-price-list-value-field-name": "Værdi",
        "adjust-price-list-no-prices": "Denne prisliste har ingen priser at justere.",
        "adjust-price-list-unit-percentage": "%",
        "adjust-price-list-unit-amount": "{ $currency }",
        "adjust-price-list-rounding-field": "\n .label = Afrunding",
        "adjust-price-list-rounding-hint-none": "Priserne kan ende som f.eks. { $example0 }.",
        "adjust-price-list-rounding-hint-quarter": "F.eks. { $example0 } eller { $example1 }.",
        "adjust-price-list-rounding-hint-half": "F.eks. { $example0 } eller { $example1 }.",
        "adjust-price-list-rounding-hint-whole": "F.eks. { $example0 } eller { $example1 }.",
        "adjust-price-list-rounding-none": "Ingen afrunding",
        "adjust-price-list-rounding-quarter": "Nærmeste { $step }",
        "adjust-price-list-rounding-half": "Nærmeste { $step }",
        "adjust-price-list-rounding-whole": "Nærmeste hele { $currency }",
        "adjust-price-list-summary-empty": "Vælg hvor meget priserne skal ændres, og fra hvilken dato.",
        "adjust-price-list-summary-raises": "Hæver { $count } varer med { $value } fra { $date }.",
        "adjust-price-list-summary-lowers": "Sænker { $count } varer med { $value } fra { $date }.",
        "adjust-price-list-effective-from-field": "\n .label = Gælder fra",
        "adjust-price-list-customers-notice": "\n .title = Kunderne ser ændringen\n .description = Priserne opdateres i { $shops ->\n [one] { $shops } butik\n *[other] { $shops } butikker\n } for { $customers } kunder.",
        "adjust-price-list-effective-from-invalid": "Vælg i dag eller en senere dato",
        "adjust-price-list-existing-orders-note-kept": "Ikke-bogførte ordrer beholder deres nuværende priser.",
        "adjust-price-list-existing-orders-note-updated": "Ikke-bogførte ordrer med levering fra { $date } får de nye priser.",
        "adjust-price-list-existing-orders-checkbox": "Opdatér også disse ordrer",
        "adjust-price-list-existing-orders-title": "Ikke-bogførte ordrer",
        "adjust-price-list-scope-panel": "\n .title = Omfang",
        "adjust-price-list-scope-subtitle-all": "Alle produktgrupper · { $items } varer",
        "adjust-price-list-scope-subtitle-some": "{ $groups } af { $total } grupper · { $items } varer",
        "adjust-price-list-scope-required": "Vælg mindst én produktgruppe",
        "adjust-price-list-preview-panel": "\n .title = Forhåndsvisning",
        "adjust-price-list-preview-empty": "Angiv en procent, og vælg mindst én produktgruppe for at se de nye priser.",
        "adjust-price-list-preview-column-item": "Vare",
        "adjust-price-list-preview-column-now": "Nu",
        "adjust-price-list-preview-column-new": "Ny pris",
        "adjust-price-list-preview-column-change": "Ændring",
        "adjust-price-list-summary-panel": "\n .title = Sådan ser det ud",
        "adjust-price-list-summary-items": "Berørte varer",

        // Merchant > Admin > Shops > Price lists > Create / Edit
        "create-price-list-page-header": "\n .title = Opret prisliste",
        "edit-price-list-page-header":"\n .title = Ret prisliste",
        "create-price-list-save-button": "Gem",
        "create-price-list-create-button": "Opret",
        "create-price-list-tab-general": "Generelt",
        "create-price-list-tab-customers": "Kunder",
        "create-price-list-tab-products": "Produkter",
        "create-price-list-tab-pos": "POS",
        "create-price-list-required-name": "Navn er påkrævet",
        "create-price-list-required-shops": "Du skal knytte prislisten til en eller flere shops",
        "create-price-list-required-price-adjustment": "Prisjustering er påkrævet",
        "create-price-list-required-currency-code": "Valuta er påkrævet",
        "create-price-list-required-percentage": "Procentsats er påkrævet",
        "create-price-list-max-percentage":"Procentssats kan ikke være mere end 100",
        "create-or-edit-price-list-field-name":"\n .label = Navn",
        "create-or-edit-price-list-field-shops":"\n .label = Butikker",
        "create-or-edit-price-list-field-aside-settings": "\n .title = Indstillinger",
        "create-or-edit-price-list-field-active":"Aktiv:",
        "create-or-edit-price-list-field-message-to-customers":"\n .label = Besked til kunder",
        "create-or-edit-price-list-aside-pricing":"\n .title = Prissætning",
        "create-or-edit-price-list-field-price-includes-vat":"Prisliste inkl. moms:",
        "create-or-edit-price-list-field-vat-code":"\n .label = Momskode",
        "create-or-edit-price-list-field-currency-code":"\n .label = Valuta",
        "create-or-edit-price-list-field-dropdown-dkk":"DKK",
        "create-or-edit-price-list-field-price-adjustment":"\n .label = Prisjustering",
        "create-or-edit-price-list-field-dropdown-none":"Ingen",
        "create-or-edit-price-list-field-dropdown-discount": "Rabat",
        "create-or-edit-price-list-field-dropdown-increase": "Prisstigning",
        "create-or-edit-price-list-field-internal-note":"\n .placeholder = Internt notat",
        "create-or-edit-price-list-field-percentage":"Procentsats (%):",
        "create-or-edit-price-list-customer-table-header-name":"Navn",
        "create-or-edit-price-list-customer-table-header-user-group":"Brugergruppe",
        "create-or-edit-price-list-customer-table-button-remove":"Fjern",
        "create-or-edit-price-list-customer-table-button-details":"Detaljer",
        "create-or-edit-price-list-customer-subtitle":"Hvis ingen kunder er tilføjet her, har alle kunder adgang til prislisten.",
        "create-or-edit-price-list-customer-table-title":"Kunder med adgang",
        "create-or-edit-price-list-customer-button-add-customer":"Tilføj kunde",
        "create-or-edit-price-list-customer-table-empty-state":"Alle kunder har adgang",
        "create-or-edit-price-list-general-tab-error":"Der er valideringsfejl under fanebladet Generelt",
        "create-or-edit-price-list-customer-tab-error":"Der er valideringsfejl under fanebladet Kunder",
        "create-or-edit-price-list-products-tab-error":"Der er valideringsfejl under fanebladet Produkter",
        "create-or-edit-price-list-pos-tab-error":"Der er valideringsfejl under fanebladet POS",
        "create-or-edit-price-list-customer-table-add-customers-title":"Tilføj kunder",
        "create-or-edit-price-list-customer-table-add-button":"Tilføj",
        "create-or-edit-price-list-products-table-title":"Produkter",
        "create-or-edit-price-list-products-table-header-name":"Navn",
        "create-or-edit-price-list-products-table-header-product-no":"Produktnr.",
        "create-or-edit-price-list-products-table-header-normal-price":"Normalpris",
        "create-or-edit-price-list-products-table-header-adjusted-price":"Tilpasset pris",
        "create-or-edit-price-list-products-table-header-status":"Status",
        "create-or-edit-price-list-products-table-status-active":"Aktiv",
        "create-or-edit-price-list-products-table-status-inactive":"Inaktiv",
        "create-or-edit-price-list-pos-table-title":"ID kort abonnementer",
        "create-or-edit-price-list-pos-info-description":"\n .description = Der skal altid være en standard prisliste for POS systemet. Standard prislisten vil blive vist, hvis et ID-kort scannes, som ikke er tildelt en anden prisliste.",
        "create-or-edit-price-list-pos-is-default-price-list":"Standard prisliste",
        "create-or-edit-price-list-pos-table-type":"Type",
        "create-or-edit-price-list-pos-table-description":"Beskrivelse",

        // Merchant > Admin > Shops > Shops
        "shops-page-header": "\n .title = Butikker",
        "shops-table-case-column": "Sagsnr.",
        "shops-table-name-column": "Navn",
        "shops-table-type-column": "Type",
        "shops-table-status-column": "Status",
        "shops-table-status-column-active": "Aktiv",
        "shops-table-status-column-inactive": "Inaktiv",
        "shops-table-status-column-demo": "Demo",
        "shops-table-status-column-active-filter-active": "Aktiv",
        "shops-table-status-column-inactive-filter-inactive": "Inaktiv",
        "shops-table-status-column-demo-filter-demo": "Demo",
        "shops-table-create-button": "Opret ny",
        "shops-table-menu-item-edit": "Rediger",
        "shops-table-menu-item-delete": "Slet",
        "shops-confirm-delete-shop-dialog": "\n .typeOfEntity = butik",

        // Merchant > Admin > Shops > Shops > Create - Edit shop
        "merchant-shop-create-header": "\n .title = Opret shop",
        "merchant-shop-edit-header": "\n .title = Ret shop",
        "merchant-shop-create-breadcrumb": "Opret shop",
        "merchant-shop-edit-breadcrumb": "Ret shop",
        "merchant-shop-create-button": "Opret",
        "merchant-shop-save-button": "Gem",
        "merchant-create-edit-shop-tab-general": "Generelt",
        "merchant-create-edit-shop-tab-settings": "Indstillinger",
        "merchant-shop-form-field-name": "\n .label = Navn \n .helperText = Shoppens navn vil være synlig for dine kunder.",
        "merchant-shop-form-field-type": "\n .label = Type",
        "merchant-shop-form-field-type-helperText": "Vælg typen af shop.",
        "merchant-shop-form-field-type-mode-meeting-service": "Mødeforplejning",
        "merchant-shop-form-field-type-mode-take-away": "Takeaway",
        "merchant-shop-form-field-type-mode-lunch": "GoPay",
        "merchant-shop-form-field-type-mode-pos": "POS",
        "merchant-shop-form-field-type-mode-subscription": "Abonnement",
        "merchant-shop-form-hardware-packages": "Vælg hardware pakker",
        "merchant-shop-form-hardware-packages-info": "\n .description = Dit valg af produkter nedenfor vil ikke resultere i et køb. Du vil efterfølgende modtage et tilbud, som du kan redigere.",
        "merchant-shop-form-hardware-packages-tablet-size": "Tablet størrelse:",
        "merchant-shop-form-hardware-packages-color": "Farve:",
        "merchant-shop-form-payment-methods": "Tilgængelige betalingsmetoder",
        "merchant-shop-form-make-shop-public": "\n .title = Offentlig shop \n .offContent = Denne shop er kun tilgængelig for inviterede firmaer.",
        "merchant-shop-form-make-shop-public-info": "\n .description = En offentlig shop er tilgængelig for alle.",
        "merchant-shop-form-make-shop-public-title": "Del følgende med dine kunder",
        "merchant-shop-form-make-shop-public-description": "For at betale som gæst, skal man enten skanne en QR kode eller indtaste shopnummer for at tilgå shoppen. Læs mere om offentlige shops <externalLink>her</externalLink>.",
        "merchant-shop-form-make-shop-public-number": "Shopnummer:",
        "merchant-shop-form-make-shop-public-url": "Direkte offentligt URL:",
        "merchant-shop-form-make-shop-public-qr-code": "- eller brugerne kan skanne denne QR kode på deres mobil",
        "merchant-shop-form-make-shop-public-offContent": "Gem for at se deleoplysninger.",
        "merchant-shop-form-field-isVisibleForAppUsers": "\n .label = Gør shoppen synlig for interne brugere i GoPay mobilappen",
        "merchant-shop-form-general": "\n .title = Generelt",
        "merchant-shop-form-field-active": "Aktiv:",
        "merchant-shop-form-field-demo": "Demo:",
        "merchant-shop-form-erp": "\n .title = ERP",
        "merchant-shop-form-field-case-number": "\n .label = Sagsnummer \n .helperText = Sagsnummeret bruges til at importere salgstal i din organisations ERP-system.",
        "merchant-shop-form-internal-note": "\n .title = Intern note",
        "merchant-shop-form-field-internal-note": "\n .label = Intern note:",
        "merchant-shop-form-posDetails-defaultLanguage-field-label": "\n .label = Default sprog",
        "merchant-shop-form-posDetails-defaultLanguage-lang-en": "Engelsk",
        "merchant-shop-form-posDetails-defaultLanguage-lang-da": "Dansk",
        "merchant-shop-form-check-in": "Tjek ind",
        "merchant-shop-form-check-in-qr-code-on-receipt": "Vis tjek-ind QR kode på kvittering",
        "merchant-shop-form-accept-multiple-check-ins": "Tillad flere tjek-ind",
        "merchant-shop-form-deadline": "\n .title = Deadline \n .offContent = Deadline er ikke aktiveret",
        "merchant-shop-form-purchases": "Køb:",
        "merchant-shop-form-cancellation": "Afbestilling:",
        "merchant-shop-form-deadline-day-field": "\n .label = Dag",
        "merchant-shop-form-deadline-day-limit-day-before": "Dagen før",
        "merchant-shop-form-deadline-day-limit-x-days-before": "{ $daysBefore } dage før",
        "merchant-shop-form-deadline-time-picker": "\n .label = Tid",
        "merchant-shop-form-posDetails-configuration-for-supporters": "\n .title = Indstillinger for supportere",
        "merchant-shop-form-posDetails-configuration-for-supporters-returnToHomeScreenDelay-field-label": "\n .label = Vend tilbage til Hjem ventetid",
        "merchant-shop-form-posDetails-configuration-for-supporters-returnToHomeAfterPurchase-field-label": "\n .label = Vend tilbage til Hjem efter køb",
        "merchant-shop-form-posDetails-configuration-for-supporters-ms": "ms",

        // Merchant > Admin > Shops > Offers
        "offers-page-header": "\n .title = Tilbud",
        "offers-table-name-column": "Produktnavn",
        "offers-table-price-column": "Ny pris",
        "offers-table-original-price-column": "Oprindelig pris",
        "offers-table-valid-from-column": "Gyldig fra",
        "offers-table-expires-column": "Udløber",
        "offers-table-status-column": "Status",
        "offers-table-edit-menu-item": "Rediger",
        "offers-table-remove-offer-menu-item": "Fjern tilbud",
        "offers-table-remove-offer-confirm-dialog": "\n .typeOfEntity = tilbud",
        "offers-table-remove-offer-success": "Tilbud fjernet",

        // Merchant > Admin > Shops > VAT Codes
        "merchant-vat-codes-header": "\n .title = VAT-koder",
        "merchant-vat-codes-list-create-button": "Opret ny",
        "merchant-vat-codes-create-button": "Opret",
        "merchant-vat-codes-save-button": "Gem",
        "merchant-vat-codes-delete-entity-dialog": "\n .typeOfEntity = momskode",
        "merchant-vat-codes-table-header-vat-code":"VAT-kode",
        "merchant-vat-codes-table-header-name":"Navn",
        "merchant-vat-codes-table-header-percentage":"Procentdel",
        "merchant-vat-codes-table-button-edit":"Rediger",
        "merchant-vat-codes-table-button-delete":"Slet",

        // Merchant > Admin > Shops > Create/Edit VAT Codes
        "merchant-vat-codes-create-header": "\n .title = Opret VAT-kode",
        "merchant-vat-codes-edit-header": "\n .title = Rediger VAT-kode",
        "merchant-vat-codes-create-edit-field-code":"\n .label = Kode",
        "merchant-vat-codes-create-edit-field-name":"\n .label = Navn",
        "merchant-vat-codes-create-edit-vat-percentage-amount":"\n .label = VAT-procent",
        "merchant-vat-codes-create-edit-required-name": "Navn er påkrævet",
        "merchant-vat-codes-create-edit-required-code": "Kode er påkrævet",
        "merchant-vat-codes-create-edit-required-vat-percentage-amount": "VAT-procent er påkrævet",

        // Merchant > Admin > Shops > Delivery locations
        "merchant-delivery-locations-header": "\n .title = Leveringslokationer",
        "merchant-delivery-locations-create-button-link": "Opret ny",
        "merchant-delivery-locations-delete-entity-dialog": "\n .typeOfEntity = leveringslokation",
        "merchant-delivery-locations-table-header-name": "Navn",
        "merchant-delivery-locations-table-header-webshop": "Webshop",
        "merchant-delivery-locations-table-header-status": "Status",
        "merchant-delivery-locations-table-active-column-active": "Aktiv",
        "merchant-delivery-locations-table-active-column-inactive": "Inaktiv",
        "merchant-delivery-locations-table-active-column-active-filter-yes": "Aktiv",
        "merchant-delivery-locations-table-active-column-inactive-filter-no": "Inaktiv",
        "merchant-delivery-locations-table-button-edit": "Rediger",
        "merchant-delivery-locations-table-button-delete": "Slet",

        // Merchant > Admin > Shops > Delivery locations
        "merchant-delivery-location-create-header": "\n .title = Opret leveringslokation",
        "merchant-delivery-location-edit-header": "\n .title = Rediger leveringslokation",
        "merchant-delivery-location-create-breadcrumb": "Opret leveringslokation",
        "merchant-delivery-location-edit-breadcrumb": "Rediger leveringslokation",
        "merchant-delivery-location-form-field-name": "\n .label = Navn",
        "merchant-delivery-location-form-pickup-details-title": "Afhentningsdetaljer:",
        "merchant-delivery-location-form-field-description": "\n .label = Beskrivelse",
        "merchant-delivery-location-form-pickup-time-helper": "Vælg afhentningstidspunktet, så kunden ved, hvornår ordren kan afhentes:",
        "merchant-delivery-location-form-field-webshop": "\n .label = Webshop",
        "merchant-delivery-location-form-start-time-picker": "\n .label = Fra:",
        "merchant-delivery-location-form-end-time-picker": "\n .label = Til:",
        "merchant-delivery-location-form-end-time-picker-min-error-label": "Skal være større end 'Fra klokken'",
        "merchant-delivery-location-form-settings": "\n .title = Indstillinger",
        "merchant-delivery-location-form-field-active": "Aktiv:",
        "merchant-delivery-locations-create-button": "Opret",
        "merchant-delivery-locations-save-button": "Gem",

        // Merchant > Admin > Shops > Payment links
        "payment-links-page-header": "\n .title = Betalingslinks",
        "payment-links-table-name-column": "Navn",
        "payment-links-table-shop-column": "Butik",
        "payment-links-table-valid-from-column": "Gældende fra",
        "payment-links-table-valid-to-column": "Gælder til",
        "payment-links-table-create-button": "Opret ny",
        "payment-links-table-menu-item-edit": "Rediger",
        "payment-links-table-menu-item-delete": "Slet",
        "payment-links-confirm-delete-dialog": "\n .typeOfEntity = betalingslinks",

        // Merchant > Admin > Shops > Payment links > Create / Edit
        "payment-links-create-page-header": "\n .title = Opret betalingslink",
        "payment-links-create-page": "Opret betalingslink",
        "payment-links-form-create-submit-button": "Opret",
        "payment-links-edit-page-header": "\n .title = Rediger betalingslink",
        "payment-links-edit-page": "Rediger betalingslink",
        "payment-links-form-edit-submit-button": "Gem",
        "payment-links-form-public-title-label": "\n .label = Titel",
        "payment-links-form-description-label": "\n .label = Beskrivelse",
        "payment-links-form-public-shop-field-label": "\n .label = Offentlig shop",
        "payment-links-form-sales-account-field-label": "\n .label = Salgskonto",
        "payment-links-form-hasPasswordProtection-switch": "Password protected",
        "payment-links-form-password-field-label": "\n .label = Adgangskode \n .helperText = Beskyt dit link med en adgangskode, hvis shoppen understøtter fakturering som betalingsmetode.",
        "payment-links-form-general-panel": "\n .title = Generelt",
        "payment-links-form-active-switch": "Aktiv:",
        "payment-links-form-availability-panel": "\n .title = Gyldighedsperiode \n .offContent = Gyldig på ubestemt tid",
        "payment-links-form-availability-from-date-picker": "\n .label = Startdato",
        "payment-links-form-availability-to-date-picker": "\n .label = Slutdato",
        "payment-links-form-availability-error-picker": "Startdato og slutdato skal udfyldes",

        // Merchant > Admin > Setting > Sales accounts
        "sales-accounts-page-header": "\n .title = Salgskonti",
        "sales-accounts-table-name-column": "Navn",
        "sales-accounts-table-number-column": "Nummer",
        "sales-accounts-table-create-button": "Opret ny",
        "sales-accounts-table-menu-item-edit": "Rediger",
        "sales-accounts-table-menu-item-delete": "Slet",
        "sales-accounts-confirm-delete-dialog": "\n .typeOfEntity = salgskonti",

        // Merchant > Admin > Setting > Sales accounts > Create / Edit
        "sales-accounts-create-page-header": "\n .title = Opret salgskonto",
        "sales-accounts-create-page": "Opret salgskonto",
        "sales-accounts-form-create-submit-button": "Opret",
        "sales-accounts-edit-page-header": "\n .title = Rediger salgskonto",
        "sales-accounts-edit-page": "Rediger salgskonto",
        "sales-accounts-form-edit-submit-button": "Gem",
        "sales-accounts-form-public-name-label": "\n .label = Navn \n .placeholder = Enter a name for the sales account",
        "sales-accounts-form-number-label": "\n .label = Nummer \n .placeholder = Enter account number from ERP system",
        "sales-accounts-form-general-panel": "\n .title = Generelt",
        "sales-accounts-form-active-switch": "Aktiv:",

        // ADMIN DEVICES
        "merchant-admin-devices-page-header": "\n .title = Enheder",


        // Merchant users
        "merchant-admin-users-create-admin-button": "Opret ny",
        "merchant-admin-users-page-title": "\n .title = Administratorer",


        // --- Supplier ---

        // Supplier > Navigation
        "supplier-nav-item-home": "Hjem",
        "supplier-nav-item-accounting-title": "\n .title = Regnskab",
        "supplier-nav-item-accounting": "Regnskab",
        "supplier-nav-item-pos": "POS",
        "supplier-nav-item-meeting-service": "Mødeforplejning",
        "supplier-nav-item-subscriptions": "Abonnementer",
        "supplier-nav-item-z-reports": "Z-rapport",
        "supplier-nav-item-merchant-sales": "Salgssted salg",
        "supplier-nav-item-customer-sales": "Kundesalg",
        "supplier-nav-item-balance": "Saldo",

        // Supplier > Navigation > Reports
        "supplier-nav-item-merchant-access": "Salgssteder",

        // Supplier > Navigation > Admin
        "supplier-nav-item-merchants-page-header":"\n .title = Salgssteder",
        "supplier-nav-item-settings-page-header":"\n .title = Indstillinger",
        "supplier-nav-item-account-page-header":"\n .title = Konto",
        "supplier-nav-item-erp-page-header":"\n .title = ERP",
        "supplier-nav-item-acquiring-reports-page-header":"\n .title = Afstemning",
        "supplier-admin-nav-item-merchants": "Salgssteder",
        "supplier-admin-nav-item-merchants-create": "Opret salgssted",
        "supplier-admin-nav-item-merchants-edit": "Rediger salgssted",
        "supplier-admin-nav-item-administrators": "Administratorer",
        "supplier-admin-nav-item-admins": "Administratorer",
        "supplier-admin-nav-item-devices": "Enheder",
        "supplier-admin-nav-item-settings": "Indstillinger",
        "supplier-admin-nav-item-acquiring": "Kortindløsning",
        "supplier-admin-nav-item-terms-and-conditions": "Handelsbetingelser",
        "supplier-admin-nav-item-pos-settings":"POS instillinger",
        "supplier-admin-nav-item-pos-settings-template-create": "Opret skabelon",
        "supplier-admin-nav-item-pos-settings-template-edit": "Rediger skabelon",
        "supplier-admin-nav-item-company-account":"Virksomhedskonto",
        "supplier-admin-nav-item-account-gdpr":"GDPR",
        "supplier-admin-nav-item-erp":"ERP",
        "supplier-admin-nav-item-acquiring-fees": "Indløsningsgebyrer",
        "supplier-admin-nav-item-bank-transfers":"Bankoverførsler",
        "supplier-admin-nav-item-product-numbers":"Produktnumre",
        "supplier-admin-nav-item-create-product-group-number":"Opret produktnummer",
        "supplier-admin-nav-item-update-product-group-number":"Ret produktnummer",
        "supplier-admin-nav-item-create-terms-and-conditions": "Opret handelsbetingelser",
        "supplier-admin-nav-item-update-terms-and-conditions": "Rediger handelsbetingelser",

        // Supplier > Reports > Home

        // Supplier > Reports > Home > Accounting > Meeting Service
        "supplier-meeting-service-header": "\n .title = Mødeforplejning",
        "supplier-meeting-service-table-merchant": "Salgssted",
        "supplier-meeting-service-table-order-id-column": "Ordre ID",
        "supplier-meeting-service-order-id-label": "\n .label = Ordre ID",
        "supplier-meeting-service-table-booked-date-column": "Bogføringsdato",
        "supplier-meeting-service-table-delivery-time-column": "Leveringstid",
        "supplier-meeting-service-table-employee-column": "Salgsted",
        "supplier-meeting-service-table-status":"Status",
        "supplier-meeting-service-table-status-confirmed":"Bekræftet",
        "supplier-meeting-service-table-status-canceled":"Annulleret",
        "supplier-meeting-service-table-amount-column": "Beløb (DKK)",
        "supplier-meeting-service-table-show-receipt": "Vis kvittering",
        "supplier-meeting-service-table-floating-action-bar-receipts": "\n .title = Kvitteringer",
        "supplier-meeting-service-table-floating-action-bar-export": "\n .title = Eksport",
        "supplier-meeting-service-order-title":"\n .title = Ordre",
        "supplier-meeting-service-drawer-pending-approval-label":"\n .label = Afventer godkendelse",
        "supplier-meeting-service-invoicing-title":"\n .title = Fakturering",
        "supplier-meeting-service-drawer-invoice-status-label":" Fakturastatus",
        "supplier-meeting-service-drawer-invoice-status-all-label":"Alle",
        "supplier-meeting-service-drawer-invoice-status-sent-label":"Sendt",
        "supplier-meeting-service-drawer-invoice-status-not-sent-label":"Ikke sendt",
        "supplier-meeting-service-drawer-booked-label":"Bogført",
        "supplier-meeting-service-drawer-booked-all-label":"Alle",
        "supplier-meeting-service-drawer-booked-booked-label":"Bogført",
        "supplier-meeting-service-drawer-booked-not-booked-label":"Ikke bogført",
        "supplier-meeting-service-booked-date-title":"\n .title = Bogføringsdato",
        "supplier-meeting-service-delivery-date-title":"\n .title = Leveringsdato",
        "supplier-meeting-service-merchant-title":"\n .title = Salgssted",
        "supplier-meeting-service-debtor-title":"\n .title = Debitor",
        "supplier-meeting-service-end-user-title":"\n .title = Slutbruger",
        "supplier-meeting-service-payment-title":"\n .title = Betaling",
        "supplier-meeting-service-drawer-from-date-label":"\n .label = Fra dato",
        "supplier-meeting-service-drawer-to-date-label":"\n .label = Til dato",
        "supplier-meeting-service-drawer-bill-receivers-label":"Faktureringsmodtagere",
        "supplier-meeting-service-drawer-bill-receivers-select-company-helper-text":"Vælg venligst en virksomhed først for at filtrere på faktureringsmodtager",
        "supplier-meeting-service-drawer-satellites-label":"Satellitter",
        "supplier-meeting-service-drawer-to-date-info-label": "\n .title = Brug ikke leveringsdato til fakturering. Brug i stedet bogføringsdato.",

        // Supplier > Reports > Home > Accounting > POS
        "supplier-pos-table-header-title": "\n .title = POS",
        "supplier-pos-table-header-order-id": "Ordre ID",
        "supplier-pos-table-header-transaction-time": "Transaktionstid",
        "supplier-pos-table-header-merchant-name": "Forhandlernavn",
        "supplier-pos-table-header-employee": "Ordreafgiver",
        "supplier-pos-table-header-payment": "Betalingsmetode",
        "supplier-pos-table-header-payment-channel": "Kanal",
        "supplier-pos-table-header-amount": "Beløb (DKK)",
        "supplier-pos-table-table-button-show-receipt": "Vis kvittering",
        "supplier-pos-table-filters-order-title":"\n .title = Ordre",
        "supplier-pos-table-filters-period-title":"\n .title = Periode",
        "supplier-pos-table-filters-merchant-title":"\n .title = Salgssted",
        "supplier-pos-table-filters-debtor-title":"\n .title = Debitor",
        "supplier-pos-table-filters-end-user-title":"\n .title = Slutbruger",
        "supplier-pos-table-filters-payment-title":"\n .title = Betaling",
        "supplier-pos-table-filters-from-date-label":"\n .label = Transaktion fra dato",
        "supplier-pos-table-filters-to-date-label":"\n .label = Transaktion til dato",


        // Supplier > Reports > Home > Accounting > Subscriptions
        "supplier-subscriptions-header": "\n .title = Abonnementer",
        "supplier-subscriptions-table-order-id-column": "Ordre ID",
        "supplier-subscriptions-table-employee-column": "Medarbejder",
        "supplier-subscriptions-table-subscribed-column": "Tilmeldt",
        "supplier-subscriptions-table-unsubscribed-column": "Frameldt",
        "supplier-subscriptions-table-payment-column": "Betalingsmetode",
        "supplier-subscriptions-table-amount-column": "Beløb",
        "supplier-subscriptions-table-cancel-subscription": "Opsig abonnement",
        "supplier-subscriptions-table-details": "Detaljer",
        "supplier-subscriptions-table-filters-order-title":"\n .title = Ordre",
        "supplier-subscriptions-table-filters-period-title":"\n .title = Periode",
        "supplier-subscriptions-table-filters-from-date-label":"\n .label = Gyldig fra dato",
        "supplier-subscriptions-table-filters-to-date-label":"\n .label = Gyldig til dato",
        "supplier-subscriptions-table-filters-merchant-title":"\n .title = Salgssted",
        "supplier-subscriptions-table-filters-debtor-title":"\n .title = Debitor",
        "supplier-subscriptions-table-filters-end-user-title":"\n .title = Slutbruger",
        "supplier-subscriptions-table-filters-payment-title":"\n .title = Betaling",
        "supplier-subscriptions-drawer-subscription-label":"Abonnement",

        // Supplier > Reports > Home > Accounting > Z-reports
        "supplier-accounting-z-reports-page-header":" \n .title = Z-rapport",
        "supplier-accounting-z-reports-table-date-column":"Dato",
        "supplier-accounting-z-reports-table-pos-terminal-column":"POS enhed",
        "supplier-accounting-z-reports-table-amount-column":"Beløb",


        // Supplier > Reports > Home > Accounting > Merchant Sales
        "supplier-merchant-sales-header": "\n .title = Salgssted salg",
        "supplier-merchant-sales-table-shop-type": "\n .label = Butikstype",
        "supplier-merchant-sales-table-red-no-column": "Reg. nr.",
        "supplier-merchant-sales-table-name-column": "Navn",
        "supplier-merchant-sales-table-upcoming-sales-column": "Kommende salg ({ $currencyCode })",
        "supplier-merchant-sales-table-booked-sales-column": "Bogført salg ({ $currencyCode })",
        "supplier-merchant-sales-table-floating-action-bar-export": "\n .title = Eksport",
        "supplier-merchant-sales-table-shop-type-input-label": "Butikstype",
        "supplier-merchant-sales-table-shop-type-item-pos": "POS",
        "supplier-merchant-sales-table-shop-type-item-meeting-service": "Mødeforplejning",
        "supplier-merchant-sales-table-shop-type-item-subscription": "Abonnement",
        "supplier-merchant-sales-detailed-table-total-footer-column": "I alt",
        "supplier-merchant-sales-detailed-table-sales-column": "Salg (DKK)",


        // Supplier > Reports > Home > Accounting > Customer Sales
        "supplier-customer-sales-header": "\n .title = Kundesalg",
        "supplier-customer-sales-table-name-column": "Navn",
        "supplier-customer-sales-table-upcoming-sales-column": "Kommende salg ({ $currencyCode })",
        "supplier-customer-sales-table-booked-sales-column": "Bogført salg ({ $currencyCode })",
        "supplier-customer-sales-table-floating-action-bar-export": "\n .title = Eksport",
        "supplier-customer-sales-detailed-table-total-footer-column": "I alt",
        "supplier-customer-sales-detailed-table-sales-column": "Salg (DKK)",



        // Supplier > Admin > Home
        "supplier-admin-home-merchants-group": "\n .title = Salgssteder",
        "supplier-admin-home-merchant-card": "\n .title = Salgssteder\n .description = Håndter salgssteder, som er fysiske salgslokationer, f.eks. kantiner.",
        "supplier-admin-home-administrators-card": "\n .title = Administratorer\n .description = Styring af administratorer",
        "supplier-admin-home-devices-card": "\n .title = Enheder\n .description = Styr jeres hardware enheder, såsom POS tablets, check-in skærme og printere.",
        "supplier-admin-home-settings-group": "\n .title = Indstillinger",
        "supplier-admin-home-payment-acquiring-card": "\n .title = Kortindløsning\n .description = Styr og check status på kreditkort indløsningsaftaler.\n .buttonText = Vis",
        "supplier-admin-home-terms-and-conditions-card": "\n .title = Handelsbetingelser\n .description = Administrer jeres handelsbetingelser, som vises for kunderne.",
        "supplier-admin-home-pos-settings-card": "\n .title = POS indstillinger \n .description = Styr POS indstillinger.",
        "supplier-admin-home-account-group":  "\n .title = Konto",
        "supplier-admin-home-company-account-card":  "\n .title = Firmakonto\n .description = Administrer jeres firmakonto.\n .buttonText = Vis",
        "supplier-admin-home-erp-group":  "\n .title = ERP",
        "supplier-admin-home-product-numbers-card":  "\n .title = Produktnumre\n .description = Administrer produktnumre for ERP integration.",
        "supplier-admin-home-account-gdpr-card":  "\n .title = GDPR\n .description = Databeskyttelsesforordningen\n .buttonText = Show",
        "supplier-admin-home-acquiring-reports-group":  "\n .title = Afstemning",
        "supplier-admin-home-bank-transfers-card":  "\n .title = Bankoverførsler\n .description = Rapport over overførsler mellem jeres indløser-konti og bankkonti.\n .buttonText = Vis",
        "supplier-admin-home-acquiring-fees":  "\n .title = Indløsningsgebyrer\n .description = Rapport over indløsningsgebyrer. Brugbart til afstemning.\n .buttonText = Vis",
        "supplier-admin-home-balance":  "\n .title = Balance\n .description = Rapport, der viser totaler for salg, gebyrer og bankoverførsler for en periode.\n .buttonText = Vis",


        // SUPPLIER ADMIN DEVICES
        "supplier-admin-devices-page-header": "\n .title = Enheder",

        // Supplier > Admin > ERP > Product Group Numbers
        "supplier-admin-erp-product-group-numbers-header": "\n .title = Produktnumre",
        "supplier-admin-erp-product-group-numbers-create-new-button":"Opret ny",
        "supplier-admin-erp-product-group-numbers-save-button":"Gem",
        "supplier-admin-erp-product-group-numbers-table-header-erp-number":"ERP nr.",
        "supplier-admin-erp-product-group-numbers-table-header-name":"Navn",
        "supplier-admin-erp-product-group-numbers-table-header-status":"Status",
        "supplier-admin-erp-product-group-numbers-table-active-column-active":"Aktiv",
        "supplier-admin-erp-product-group-numbers-table-active-column-inactive":"Inaktiv",
        "supplier-admin-erp-product-group-numbers-table-active-filter-yes":"Aktiv",
        "supplier-admin-erp-product-group-numbers-table-active-filter-no":"Inaktiv",
        "supplier-admin-erp-product-group-numbers-table-button-edit":"Rediger",
        "supplier-admin-erp-product-group-numbers-table-button-delete":"Slet",
        "supplier-admin-erp-product-group-numbers-delete-entity-dialog":"\n .typeOfEntity = Produktnumre",

        // Supplier > Admin > ERP > Product Group Numbers > Create/Update
        "supplier-admin-erp-product-group-numbers-create-header": "\n .title = Opret produktnummer",
        "supplier-admin-erp-product-group-numbers-update-header": "\n .title = Ret produktnummer",
        "supplier-admin-erp-product-group-numbers-create-button":"Opret",
        "supplier-admin-erp-product-group-numbers-field-code":"\n .label = ERP-nummer",
        "supplier-admin-erp-product-group-numbers-field-name":"\n .label = Navn",
        "supplier-admin-erp-product-group-numbers-description":"\n .label = Beskrivelse\n .placeholder = Her kan du forklare den tilsigtede brug af dette produktnummer.",
        "supplier-admin-erp-product-group-numbers-required-code":"ERP-nummer er påkrævet",
        "supplier-admin-erp-product-group-numbers-required-name":"Navn er påkrævet",
        "supplier-admin-erp-product-group-numbers-aside-settings":"\n .title = Indstillinger",
        "supplier-admin-erp-product-group-numbers-active":"Aktiv:",
        "supplier-admin-erp-product-group-numbers-history":"\n .title = Historik",
        "supplier-admin-erp-product-group-numbers-aside-created":"Oprettet:",
        "supplier-admin-erp-product-group-numbers-aside-updated":"Ændret:",

        // DEVICE TABLE GENERAL
        "devices-table-header-name": "Navn",
        "devices-table-header-group": "Gruppe",
        "devices-table-header-type": "Type",
        "devices-table-header-status": "Status",
        "devices-table-button-details": "Detaljer",
        "devices-table-button-edit": "Rediger",
        "devices-table-status-column-online": "Online",
        "devices-table-status-column-offline": "Offline",
        "devices-table-header-reg": "Reg. nr.",
        "devices-table-header-merchant": "Salgssted",

        // DEVICE DETAILS
        "device-details-title": "Enhedsdetaljer",
        "device-details-type-info-shop": "\n .label = Butik:",
        "device-details-type-info-device-number": "\n .label = Enhedsnummer:",
        "device-details-type-info-serial-number": "\n .label = Serienummer:",
        "device-details-type-info-hardware-id": "\n .label = Hardware-ID:",
        "device-details-type-info-language": "\n .label = Sprog:",
        "device-details-type-info-pos-mode": "\n .label = POS tilstand:",
        "device-details-type-info-card-terminal-acquirer-name": "\n .label = Kreditkort terminal indløser name:",
        "device-details-status-info-title": "\n .title = Status",
        "device-details-status-info-diagnostics-title": "\n .title = Vis diagnostics",
        "device-details-status-info-diagnostics-subject": "Emne",
        "device-details-status-info-diagnostics-message": "Besked",
        "device-details-pin-code-info-title": "\n .title = PIN kode",
        "device-details-pin-code-info-helper": "\n .title = PIN kode: \n .description = PIN koden bruges til at opnå adgang til administrationsmenuer på enheden.",
        "device-details-group-info-title": "\n .title = Gruppe",
        "device-details-group-info-name": "\n .label = Navn:",
        "device-details-group-info-connected-devices": "\n .label = Forbundne enheder:",
        "device-details-group-table-header-name": "Navn",
        "device-details-group-table-header-type": "Type",
        "device-details-group-table-header-status": "Status",
        "device-details-device-info-title": "\n .title = Enhed",
        "device-details-device-info-name": "\n .label = Navn:",
        "device-details-device-info-shop": "\n .label = Butik:",
        "device-details-device-info-device-number": "\n .label = Enhedsnummer:",
        "device-details-identification-info-title": "\n .title = Identifikation",
        "device-details-identification-info-serial-number": "\n .label = Serienummer:",
        "device-details-identification-info-hardware-id": "\n .label = Hardware-ID:",
        "device-details-identification-info-acquirer": "\n .label = Kortterminal indløsernavn:",
        "device-details-settings-info-title": "\n .title = Indstillinger",
        "device-details-settings-info-language": "\n .label = Sprog:",
        "device-details-settings-info-pos-mode": "\n .label = POS tilstand:",
        "device-details-settings-info-pin-code-info": "PIN-koden bruges til at få adgang til beskyttede områder i appen.",
        "device-details-history-info-title": "\n .title = Historik",
        "device-details-history-info-created": "\n .label = Oprettet:",
        "device-details-history-info-edited": "\n .label = Redigeret:",
        "device-details-type-mode-cloud-pos": "GoPay CloudPOS",
        "device-details-type-mode-soft-pos": "GoPay SoftPOS",
        "device-details-type-mode-display": "Display",
        "device-details-type-mode-cloud-credit-card-reader": "Cloud-printer",
        "device-details-type-mode-star-cloud-printer": "Cloud-kreditkortlæser",
        "device-details-type-mode-receipt-control": "Kvitteringskontrol",
        "device-details-type-mode-room-display": "Lokaledisplay",
        "device-details-type-mode-meeting-display": "Mødedisplay",
        "device-details-type-mode-guest-check-in": "Gæste-check-in",
        "device-details-group-table-device-type-filter-label": "Enhedstype",
        "device-details-group-table-device-type-filter-placeholder": "Alle",
        "device-details-group-table-device-type-filter-label-label": "\n .label = Enhedstype",
         "devices-table-select-filter-on-item-room-display": "Lokaledisplay",
        "devices-table-select-filter-on-item-meeting-display": "Mødedisplay",
        "devices-table-select-filter-on-item-guest-check-in": "Gæste-check-in",

        // Create or edit device
        "service-center-admin-organization-create-devices-title": "\n .title = Opret display",
        "service-center-admin-organization-edit-devices-title": "\n .title = Rediger display",
        "devices-create-device-form": "Opret",
        "devices-edit-device-form": "Gem",
        "devices-edit-breadcrumb": "Rediger display",
        "devices-create-breadcrumb": "Opret display",
        "devices-create-or-edit-form-select-template-label": "\n .label = Skabelon",
        "devices-create-or-edit-form-select-field-name": "\n .label = Navn",
        "devices-create-or-edit-form-select-field-device-number": "\n .label = Enhedsnummer",
        "devices-create-or-edit-form-floor-label": "\n .label = Sal",
        "devices-create-or-edit-form-select-field-room": "\n .label = Lokale",
        "devices-create-or-edit-form-select-field-serial-number": "\n .label = Serienummer",
        "devices-create-or-edit-form-select-display-type": "\n .label = Displaytype",
        "devices-create-or-edit-form-type-room-details-info": "\n .title = Lokaledisplays sættes op foran mødelokaler for at vise, om lokalet i øjeblikket er ledigt eller optaget. Det giver også en nem måde at booke lokalet på.",
        "devices-create-or-edit-form-type-meeting-details-info": "\n .title = Mødedisplays sættes typisk op på hver etage og er designet til at lade folk vide, hvor de skal gå hen til deres møde.",


        "devices-create-or-edit-form-display-type-dropdown-item-room-display": "Lokaledisplay",
        "devices-create-or-edit-form-display-type-dropdown-item-meeting-display": "Mødedisplay",
        "devices-create-or-edit-form-display-type-dropdown-item-guest-check-in": "Gæste-check-in",

        // Display types
        "display-types-dropdown-select-item-room-display": "Lokaledisplay",

        // Supplier > Admin > POS settings
        "supplier-admin-pos-settings-page-header": "\n .title = POS indstillinger",
        "supplier-admin-pos-settings-tab-templates": "Skabeloner",
        "supplier-admin-pos-settings-tab-general": "Generelt",
        "supplier-admin-pos-settings-create-button": "Opret ny",
        "supplier-admin-pos-settings-templates-table-header-name": "Navn",
        "supplier-admin-pos-settings-templates-table-header-language": "Sprog",
        "supplier-admin-pos-settings-templates-table-header-status": "Status",
        "supplier-admin-pos-settings-templates-table-edit-button": "Rediger",
        "supplier-admin-pos-settings-templates-table-duplicate-button": "Dupliker",
        "supplier-admin-pos-settings-templates-table-delete-button": "Slet",
        "supplier-admin-pos-settings-templates-table-status-column-active":"I brug",
        "supplier-admin-pos-settings-templates-table-status-column-inactive":"Ikke i brug",
        "supplier-admin-pos-settings-templates-table-status-column-active-filter-yes": "I brug",
        "supplier-admin-pos-settings-templates-table-status-column-inactive-filter-no": "Ikke i brug",

        // Supplier > Admin > POS settings > Templates > Create / Edit
        "supplier-admin-pos-settings-create-template-page-header": "\n .title = Opret skabelon",
        "supplier-admin-pos-settings-edit-template-page-header": "\n .title = Rediger skabelon",
        "supplier-admin-pos-settings-create-submit-button": "Opret",
        "supplier-admin-pos-settings-edit-submit-button": "Gem",
        "supplier-admin-pos-settings-template-shortcuts": "\n .title = Genveje",
        "supplier-admin-pos-settings-template-name-field-label": "\n .label = Skabelonnavn",
        "supplier-admin-pos-settings-template-languageCode-field-label": "\n .label = Language",
        "supplier-admin-pos-settings-lang-en": "Engelsk",
        "supplier-admin-pos-settings-lang-da": "Dansk",
        "supplier-admin-pos-settings-template-button-field-label": "\n .label = Knaptekst \n .helperText = Tilpas teksten på knappen for at starte køb.",
        "supplier-admin-pos-settings-template-title-field-label": "\n .label = Titel",
        "supplier-admin-pos-settings-template-subtitle-field-label": "\n .label = Undertitel",
        "supplier-admin-pos-settings-template-companyLogo-field-label": "\n .label = Upload company logo:",
        "supplier-admin-pos-settings-template-companyLogo-info": "Image hints: background should be transparent. We recommend using a 180x180 px image with logo centered inside.",
        "supplier-admin-pos-settings-template-shortcuts-help-field": "Hjælp / vilkår og betingelser:",
        "supplier-admin-pos-settings-template-shortcuts-downloadApp-field": "Download GoPay app:",
        "supplier-admin-pos-settings-template-frontpage-layout": "Forsidelayout",
        "supplier-admin-pos-settings-template-select-theme-style": "Vælg temastil:",

        // Supplier > Admin > POS settings > General
        "supplier-admin-pos-settings-general-submit-button": "Gem",
        "supplier-admin-pos-settings-general-defaultLanguage-field-label": "\n .label = Default language \n .helperText = Can be adjusted on each device.",
        "supplier-admin-pos-settings-general-posPrintingMode-field-label": "\n .label = Receipt print mode",
        "supplier-admin-pos-settings-general-posPrintingMode-option-qr-only": "QR code only",
        "supplier-admin-pos-settings-general-posPrintingMode-option-auto": "Automatic print",
        "supplier-admin-pos-settings-general-posPrintingMode-option-manually": "Manual print",
        "supplier-admin-pos-settings-general-info": "Udskrivningstilstanden styrer, hvordan kvitteringen gøres tilgængelig for kunden. “Automatisk udskrivning” udskriver automatisk en papirkvittering, mens “Manuel udskrivning” giver brugeren mulighed for at udskrive en papirkvittering eller scanne en QR-kode for at få en digital kvittering. Vælg “Kun QR-kode”, hvis du ønsker et papirløst POS-system.",
        "supplier-admin-pos-settings-general-configuration-for-supporters": "Konfiguration for supportere",
        "supplier-admin-pos-settings-general-configuration-for-supporters-returnToHomeScreenDelay-field-label": "\n .label = Return to home screen delay",
        "supplier-admin-pos-settings-general-configuration-for-supporters-returnToHomeAfterPurchase-field-label": "\n .label = Return to home after purchase",
        "supplier-admin-pos-settings-general-configuration-for-supporters-ms": "ms",

        // Merchant Access
        "supplier-merchant-access-page-header": "\n .title = Salgssteder",
        "supplier-merchant-access-table-header-case-no": "Sagsnr.",
        "supplier-merchant-access-table-header-name": "Navn",
        "supplier-merchant-access-table-header-address": "Adresse",
        "supplier-merchant-access-table-details-no-companies": "Der er ingen tilknyttede virksomheder",
        "supplier-merchant-access-table-details-customers-title":"Kunder:",

        // Supplier > Admin > Acquiring
        "supplier-admin-pos-acquirer-page-header": "\n .title = Kreditkort indløsningsaftale",
        "supplier-admin-pos-acquirer-adyen-question": "Hvem er Adyen?",
        "supplier-admin-pos-acquirer-adyen-answer": "Adyen er vores indløser med status af indløsende bank, som giver dig mulighed for at modtage kreditkort betalinger. Adyen er ansvarlig for behandling af betalinger for dit firma. Før du kan modtage betaling med kreditkort, skal du ansøge om en indløsningsaftale hos Adyen.",
        "supplier-admin-pos-acquirer-adyen-read-more": "Læs mere: <externalLink>{ $adyenWebsite }</externalLink>",
        "supplier-admin-pos-acquirer-status-title":"Status:",
        "supplier-admin-pos-acquirer-status-create-business-lines": "Ingen industrikoder",
        "supplier-admin-pos-acquirer-status-info-create-business-lines": "Du skal oplyse dine forretningsområder, før du kan ansøge.",
        "supplier-admin-pos-acquirer-status-action-create-business-lines": "Tilføj venligst en eller flere industrikoder nedenfor.",
        "supplier-admin-pos-acquirer-status-start": "Start ansøgning",
        "supplier-admin-pos-acquirer-status-info-start": "Du er nu klar til at påbegynde ansøgning hos indløser.",
        "supplier-admin-pos-acquirer-status-action-start": "Start ansøgningen hos indløseren nedenfor.",
        "supplier-admin-pos-acquirer-status-pending": "Under behandling",
        "supplier-admin-pos-acquirer-status-info-pending": "Din ansøgning behandles af indløseren.",
        "supplier-admin-pos-acquirer-status-action-pending": "Afvent venligst godkendelse.",
        "supplier-admin-pos-acquirer-status-invalid": "Fejl i ansøgning",
        "supplier-admin-pos-acquirer-status-info-invalid": "Der er fejl i de oplyste informationer.",
        "supplier-admin-pos-acquirer-status-action-invalid": "Ret venligst din ansøgning.",
        "supplier-admin-pos-acquirer-status-valid": "Godkendt",
        "supplier-admin-pos-acquirer-status-info-valid": "Din ansøgning er blevet godkendt.",
        "supplier-admin-pos-acquirer-status-check-valid":"Du er nu klar til at sætte kreditkortbetalinger op for dine salgssteder.",
        "supplier-admin-pos-acquirer-status-rejected": "Afvist",
        "supplier-admin-pos-acquirer-status-info-rejected": "Indløseren har verificeret oplysningerne, men har fundet grund til ikke at indgå samarbejde med jeres organisation.",
        "supplier-admin-pos-acquirer-start-application-button": "Start ansøgning hos Adyen",
        "supplier-admin-pos-acquirer-continue-application-button": "Fortsæt ansøgning hos Adyen",
        "supplier-admin-pos-acquirer-status-no-payment-title": "Du har ingen indløsningsaftale for kreditkort.",
        "supplier-admin-pos-acquirer-status-no-payment-error": "Ingen tilgængelige indløsere",
        "supplier-admin-acquiring-terms-and-conditions-title": "Krav til salgsbetingelser",
        "supplier-admin-acquiring-terms-and-conditions-explanation": "For at fortsætte, skal du acceptere indløserens krav til jeres <requirementsLink>salgsbetingelser</requirementsLink>. Disse salgsbetingelser skal fremgå tydeligt for jeres kunder på jeres hjemmeside.",
        "supplier-admin-acquiring-terms-and-conditions-template-text": "Du kan hente vores skabelon for salgsbetingelser <templateLink>her</templateLink>.",
        "supplier-admin-acquiring-terms-and-conditions-label": "\n .label = Jeg accepterer at opfylde disse krav.",
        "supplier-admin-acquiring-accept-terms-dialog-title": "Accepter salgsbetingelser",
        "supplier-admin-acquiring-accept-terms-dialog-description": "Er du sikker på, at du vil acceptere at opfylde disse krav til salgsbetingelser?",
        "supplier-admin-acquiring-accept-terms-dialog-button": "Accepter",
        "supplier-acquiring-industry-codes-accordion-industry-codes-title": "Industrikoder",
        "supplier-acquiring-industry-codes-accordion-industry-codes-info-box": "\n .description = Hvis du ansøger om en kantine, skal du vælge branchekode 722514 - cafeterier, grillbuffeter.",
        "supplier-acquiring-industry-codes-table-industry-code-column": "Industrikode",
        "supplier-acquiring-industry-codes-table-description-column": "Beskrivelse",
        "supplier-acquiring-industry-codes-table-remove-action": "Fjern",
        "supplier-acquiring-industry-codes-add-industry-code": "Tilføj ny industrikode",
        "supplier-acquiring-industry-codes-info-text": "Industrikoder beskriver jeres forretningsområder og dermed hvilke typer varer, I må sælge i jeres shops. Nogle industrikoder kræver godkendelse af indløseren. Se alle industrikoder <industryCodesLink>her</industryCodesLink>.",
        "supplier-acquiring-industry-codes-confirm-delete-dialog": "\n .title = Fjern industrikode\n .message = Ønsker du at fjerne industrikoden { $industryCode }?\n .buttonLabelSubmit = Fjern",
        "supplier-acquiring-bank-accounts-accordion-bank-accounts-title": "Bankkonti",
        "supplier-acquiring-bank-accounts-table-bank-name-column": "Bank",
        "supplier-acquiring-bank-accounts-table-account-column": "Konto",
        "supplier-acquiring-bank-accounts-table-merchant-caseno-column": "Sagsnr.",
        "supplier-acquiring-bank-accounts-table-merchant-column": "Salgssted",
        "supplier-acquiring-bank-accounts-table-status-column": "Status",
        "supplier-acquiring-bank-accounts-table-remove-action": "Fjern",
        "supplier-acquiring-bank-accounts-add-bank-account": "Tilføj ny bankkonto",
        "supplier-acquiring-bank-accounts-info-text": "Hvis du ønsker salg overført til en separat bankkonto pr. salgssted, kan du tilføje ekstra bankkonti her. Se <guideLink>guide</guideLink> om, hvordan du tilføjer en ny bankkonto hos indløseren og efterfølgende forbinder den med et salgssted.",
        "supplier-acquiring-bank-accounts-status-pending": "Under behandling",
        "supplier-acquiring-bank-accounts-status-invalid": "Ugyldige oplysninger",
        "supplier-acquiring-bank-accounts-status-valid": "Valideret",
        "supplier-acquiring-bank-accounts-status-rejected": "Afvist",
        "supplier-acquiring-bank-accounts-confirm-delete-dialog": "\n .title = Fjern bankkonto\n .message = Ønsker du at fjerne bankkontoen { $accountIdentifier }?\n .buttonLabelSubmit = Fjern",
        "supplier-acquiring-industry-codes-button-add": "Tilføj",
        "supplier-acquiring-industry-codes-button-save": "Gem",
        "supplier-acquiring-industry-codes-alert-title": " Tilføjelse af nye branchekoder kan ændre status for din betalingsacquiring-aftale til afventende, hvis acquireren skal verificere.",

        // Supplier > Admin > Reconciliation
       "supplier-acquiring-reports": "Afstemning",
       "supplier-acquiring-reports-table-booked-time-column": "Bogført tid",
       "supplier-acquiring-reports-table-merchant-label": "\n .label = Salgssted",
       "supplier-acquiring-reports-table-adyen-account-label": "\n .label = Adyen konto",
       "supplier-acquiring-reports-table-merchant-column": "Salgssted",
       "supplier-acquiring-reports-table-amount-column": "Beløb",

       // Supplier > Admin > Reconciliation > Fees
       "supplier-acquiring-fees-header": "\n .title = Indløsningsgebyrer",
       "supplier-acquiring-fees": "Indløsningsgebyrer",
       "supplier-acquiring-fees-table-order-id-column": "Ordre ID",
       "supplier-acquiring-fees-table-psp-reference-column": "PSP reference",
       "supplier-acquiring-fees-table-available-date-column": "Tilgængelig dato",
       "supplier-acquiring-fees-table-type-column": "Type",
        "supplier-acquiring-fees-table-select-filter-on-label": "Filtrer på",
        "supplier-acquiring-fees-table-select-filter-on-label-label": "\n .label = Filtrer på",
        "supplier-acquiring-fees-table-select-filter-on-item-booking-date": "Bogføringsdato",
        "supplier-acquiring-fees-table-select-filter-on-item-value-date": "Tilgængelig dato",
       "supplier-acquiring-fees-table-type-mode-payment": "Betaling",
       "supplier-acquiring-fees-table-type-mode-transfer": "Overførsel",
       "supplier-acquiring-fees-table-type-mode-refund": "Refundering",
       "supplier-acquiring-fees-table-number-of-transactions": "\n .title = Antal transaktioner",
        "supplier-acquiring-fees-table-info-banner": "\n .description = Data for denne rapport bliver tilgængelig dagen efter, så du kan ikke se transaktioner for i dag.",

       // Supplier > Admin > Reconciliation > Bank transfers
       "supplier-acquiring-bank-transfers-header": "\n .title = Bankoverførsler",
       "supplier-acquiring-bank-transfers": "Bankoverførsler",
       "supplier-acquiring-bank-transfers-table-transfer-id-column": "Overførsels-ID",
       "supplier-acquiring-bank-transfers-table-available-time-column": "Tilgængelig tid",
       "supplier-acquiring-bank-transfers-table-bank-account-column": "Bankkonto",
        "supplier-acquiring-bank-transfers-table-details-menu-item": "Detaljer",
       "supplier-acquiring-bank-transfers-table-number-of-transfers": "\n .title = Antal overførsler",
       "supplier-acquiring-bank-transfers-table-info-banner": "\n .description = Data for denne rapport bliver tilgængelig dagen efter, så du kan ikke se bankoverførsler for i dag eller kommende overførsler.",
        "supplier-acquiring-bank-transfers-table-details-table-order-id-column": "Ordre ID",
        "supplier-acquiring-bank-transfers-table-details-table-psp-reference-column": "PSP reference",
        "supplier-acquiring-bank-transfers-table-details-table-booked-column": "Bogført",
        "supplier-acquiring-bank-transfers-table-details-table-available-column": "Tilgængelig",
        "supplier-acquiring-bank-transfers-table-details-table-gross-column": "Brutto",
        "supplier-acquiring-bank-transfers-table-details-table-net-column": "Netto",
        "supplier-acquiring-bank-transfers-table-details-table-fee-column": "Gebyr",
        "supplier-acquiring-bank-transfers-details-dialog-title": "\n .dialogTitle = Overførselsdetaljer\n .subtitle = Periode: { $periodStart} - { $periodEnd }",
        "supplier-acquiring-bank-transfers-details-dialog-title-no-start-date": "Aftalestart",
        "supplier-acquiring-bank-transfers-details-dialog-number-of-orders": "\n .title = Antal ordrer",
        "supplier-acquiring-bank-transfers-details-dialog-table-gross-total": "\n .title = Bruttototal",
        "supplier-acquiring-bank-transfers-details-dialog-table-fee-total": "\n .title = Gebyr total",
        "supplier-acquiring-bank-transfers-details-dialog-table-net-total": "\n .title = Netto total",

       // Supplier > Admin > Reconciliation > Balance
       "supplier-overview-header": "\n .title = Saldo",
       "supplier-overview-table-amount": "Beløb",
       "supplier-overview-table-account": "Konto",
       "supplier-overview-table-view-details": "Vis detaljer",
       "supplier-overview-balance-details-dialog": "\n .dialogTitle = Balance detaljer\n .subtitle = Periode: { $periodStart} - { $periodEnd }",
       "supplier-overview-balance-details-dialog-select-order": "Vis ordrer",
       "supplier-overview-balance-details-dialog-select-order-label": "\n .label = Vis ordrer",
       "supplier-overview-balance-details-dialog-select-order-mode-net-sales": "Netto omsætning",
       "supplier-overview-balance-details-dialog-select-order-mode-bank-transfers": "Bankoverførsler",
       "supplier-overview-balance-details-dialog-select-order-mode-balance": "Saldo",
       "supplier-overview-balance-details-dialog-compact-view-label": "Vis brutto omsætning og gebyrer",
       "supplier-overview-balance-details-dialog-table-order-id-column": "Ordre ID",
       "supplier-overview-balance-details-dialog-table-rsp-reference-column": "PSP reference",
       "supplier-overview-balance-details-dialog-table-booked-column": "Bogført",
       "supplier-overview-balance-details-dialog-table-available-column": "Tilgængelig",
       "supplier-overview-balance-details-dialog-table-gross-column": "Brutto",
       "supplier-overview-balance-details-dialog-table-fee-column": "Gebyr",
       "supplier-overview-balance-details-dialog-table-net-column": "Netto",
       "supplier-overview-balance-details-dialog-table-effective-column": "Effektivt beløb",
       "supplier-overview-balance-details-dialog-table-type-column": "Type",
       "supplier-overview-balance-details-dialog-table-payment-type-bank-transfer": "Bankpostering",
       "supplier-overview-balance-details-dialog-table-payment-type-previous-revenue": "Tidligere indbetalt",
       "supplier-overview-balance-details-dialog-table-payment-type-deferred-revenue": "Forskudt gebyr",
       "supplier-overview-balance-details-dialog-table-payment-type-normal-revenue": "Bankpostering",
       "supplier-overview-balance-details-dialog-table-payment-type-accrued-revenue": "Tilgodehavende",
       "supplier-overview-balance-details-dialog-number-of-orders": "\n .title = Antal ordrer",
       "supplier-overview-balance-details-dialog-table-effective-total": "\n .title = Total effektivt beløb",
       "supplier-overview-balance-details-dialog-table-gross-total": "\n .title = Brutto total",
       "supplier-overview-balance-details-dialog-table-fee-total": "\n .title = Gebyr total",
       "supplier-overview-balance-details-dialog-table-net-total": "\n .title = Netto total",

        // Supplier > Admin > Merchants
        "supplier-admin-merchants-header": "\n .title = Salgssteder",
        "supplier-admin-merchants-create-button": "Opret ny",
        "supplier-admin-merchants-table-edit-button": "Rediger",
        "supplier-admin-merchants-table-delete-button": "Slet",
        "supplier-admin-merchants-table-delete-modal-title": "salgssted",
        "supplier-admin-merchants-table-reg-no-column": "Reg. nr.",
        "supplier-admin-merchants-table-merchant-column": "Salgssted",
        "supplier-admin-merchants-table-connected-shops": "Butikker:",
        "supplier-admin-merchants-table-connected-customers": "Kunder:",
        "supplier-admin-merchants-table-connected-devices": "Hardware enheder:",
        "supplier-admin-merchant-create-title": "\n .title = Opret salgssted",
        "supplier-admin-merchant-edit-title": "\n .title = Ret salgssted",
        "supplier-admin-merchants-save-button": "Gem",
        "create-or-edit-supplier-admin-merchant-field-caseNumber": "\n .label = Reg no.\n .placeholder = Enter a Reg no.\n .helperText = Jeres interne reference nummer for dette salgssted",
        "create-or-edit-supplier-admin-merchant-field-name": "\n .label = Navn\n .placeholder = Indtast forhandlernavn",
        "create-or-edit-supplier-admin-merchant-field-street": "\n .label = Vej\n .placeholder = Indtast vej",
        "create-or-edit-supplier-admin-merchant-field-streetNumber": "\n .label = Street no\n .placeholder = Enter street no",
        "create-or-edit-supplier-admin-merchant-field-postalCode": "\n .label = Postal code\n .placeholder = Enter postal code",
        "create-or-edit-supplier-admin-merchant-field-city": "\n .label = By\n .placeholder = Indtast by",
        "create-or-edit-supplier-admin-merchant-field-country": "\n .label = Land",
        "create-or-edit-supplier-admin-merchant-contact-details-title": "\n .title = Kontaktoplysninger",
        "create-or-edit-supplier-admin-merchant-country-denmark-item": "Danmark",
        "create-or-edit-supplier-admin-merchant-contact-details-info": "Kontaktoplysninger vil være offentlige for kunderne.",
        "create-or-edit-supplier-admin-merchant-field-contact-details-name": "\n .label = Navn\n .placeholder = Indtast navn",
        "create-or-edit-supplier-admin-merchant-field-contact-details-email": "\n .label = E-mail\n .placeholder = Indtast e-mail",
        "create-or-edit-supplier-admin-merchant-field-contact-details-phone": "\n .label = Telefonnummer\n .placeholder = Indtast telefonnummer",
        "create-or-edit-supplier-admin-merchant-field-is-required": "Feltet er påkrævet",
        "create-or-edit-supplier-admin-merchant-credit-card-payments-title": "\n .title = Kreditkortbetalinger",
        "create-or-edit-supplier-admin-merchant-status-approved": "Aktiv",
        "create-or-edit-supplier-admin-merchant-status-no-registered-bank-account": "Ingen registreret bankkonto",
        "create-or-edit-supplier-admin-merchant-status-no-registered-bank-account-description": "Registrer en bankkonto for din indløsningsaftale <retryLink>her.</retryLink>",
        "create-or-edit-supplier-admin-merchant-status-no-registered-bank-account-description-readonly": "Registrer en bankkonto for din indløsningsaftale.",
        "create-or-edit-supplier-admin-merchant-status-invalid": "Aftale ugyldig",
        "create-or-edit-supplier-admin-merchant-status-invalid-description": "Ret din ansøgning om indløsningsaftale <retryLink>her.</retryLink>",
        "create-or-edit-supplier-admin-merchant-status-invalid-description-readonly": "Ret din ansøgning om indløsningsaftale.",
        "create-or-edit-supplier-admin-merchant-status-pending": "Aftale afventer",
        "create-or-edit-supplier-admin-merchant-status-pending-description": "Vent på, at indløseren færdiggør behandlingen af din ansøgning om indløsningsaftale.",
        "create-or-edit-supplier-admin-merchant-status-no-payment-setup": "Ingen betalingsopsætning",
        "create-or-edit-supplier-admin-merchant-status-no-payment-setup-description": "Opsæt kreditkortbetalinger for denne forhandler for at begynde at modtage betalinger.",
        "create-or-edit-supplier-admin-merchant-status-bank-account-pending": "Bankkonto afventer",
        "create-or-edit-supplier-admin-merchant-status-bank-account-pending-description": "Vent på, at indløseren færdiggør verificeringen af din bankkonto.",
        "create-or-edit-supplier-admin-merchant-acquirer": "Acquirer:",
        "create-or-edit-supplier-admin-merchant-acquirer-type-adyen-pos": "Adyen",
        "create-or-edit-supplier-admin-merchant-acquirer-type-adyen": "Adyen",
        "create-or-edit-supplier-admin-merchant-bank-details": "Bankoplysninger:",
        "create-or-edit-supplier-admin-merchant-industry-codes": "Branchekoder:",
        "create-or-edit-supplier-admin-merchant-status-action-button-setup": "Opsætning",
        "create-or-edit-supplier-admin-merchant-status-action-button-edit": "Rediger",
        "create-or-edit-supplier-admin-merchant-dialog-title": "Opsætning af kreditkortbetaling",
        "create-or-edit-supplier-admin-merchant-dialog-field-acquiring-agreement": "\n .label = Indløsningsaftale",
        "create-or-edit-supplier-admin-merchant-dialog-field-sales-channels": "\n .label = Salgskanal",
        "create-or-edit-supplier-admin-merchant-dialog-field-bank-account": "\n .label = Bankkonto",
        "create-or-edit-supplier-admin-merchant-dialog-field-bank-account-helper": "Vælg den bankkonto, hvortil salget skal overføres. Du vil kun se bankkonti, som er oprettet i Adyen-platformen. For at tilføje en ny bankkonto se <retryLink>vejledning.</retryLink>",
        "create-or-edit-supplier-admin-merchant-dialog-field-industry-codes": "\n .label = Branchekoder",
        "create-or-edit-supplier-admin-merchant-dialog-field-default-currency": "\n .label = Standardvaluta",
        "create-or-edit-supplier-admin-merchant-dialog-save-button": "Gem",

        // Supplier > Admin > T&C
        "supplier-admin-settings-terms-and-conditions": "\n .title = Vilkår og betingelser",
        "supplier-admin-settings-terms-and-conditions-list-create-button": "Opret ny",
        "supplier-admin-settings-terms-and-conditions-create-button": "Opret",
        "supplier-admin-settings-terms-and-conditions-update-button": "Opdater",

        // TERMS AND CONDITIONS CREATE
        "supplier-terms-and-conditions-alert-title": "Handelsbetingelser",
        "supplier-terms-and-conditions-alert-subtitle1": "Det er dit eget ansvar at sikre, at vilkår og betingelser overholder de gældende krav.",
        "supplier-terms-and-conditions-alert-subtitle2": "Læs om Adyens påkrævede T&C, som du skal overholde <externalLink>her</externalLink>.",
        "supplier-terms-and-conditions-alert-subtitle3": "Download vores T&C-skabelon: <externalLinkDA>Dansk</externalLinkDA> | <externalLinkEN>Engelsk</externalLinkEN>.",
        "supplier-terms-and-conditions-dropdown-english": "Engelsk",
        "supplier-terms-and-conditions-dropdown-danish": "Dansk",
        "supplier-terms-and-conditions-name-label": "\n .label = Navn",
        "supplier-terms-and-conditions-language-label": "\n .label = Sprog",
        "supplier-terms-and-conditions-type-label": "\n .label = Type",
        "supplier-terms-and-conditions-dropdown-pos": "POS",
        "supplier-terms-and-conditions-type-ecom": "E-Commerce",
        "supplier-terms-and-conditions-aside-settings": "\n .title = Indstillinger",
        "supplier-terms-and-conditions-aside-active": "Aktiv: ",
        "supplier-terms-and-conditions-aside-history": "\n .title = Historik",
        "supplier-terms-and-conditions-aside-version": "Version: ",
        "supplier-terms-and-conditions-aside-created": "Oprettet: ",
        "supplier-terms-and-conditions-aside-updated": "Opdateret: ",
        "terms-and-conditions-error-label-name": "Navn",
        "terms-and-conditions-error-label-type": "Type",
        "terms-and-conditions-error-label-language": "Sprog",
        "terms-and-conditions-error-label-text": "Tekst",

        // TERMS AND CONDITIONS TABLE GENERAL
        "terms-and-conditions-table-header-name": "Navn",
        "terms-and-conditions-table-header-language": "Sprog",
        "terms-and-conditions-table-header-name-type": "Type",
        "terms-and-conditions-table-header-name-status": "Status",
        "terms-and-conditions-table-button-edit":"Rediger",
        "terms-and-conditions-table-button-delete":"Slet",
        "terms-and-conditions-table-button-approval":"Godkendelse",
        "terms-and-conditions-table-status-active":"Aktiv",
        "terms-and-conditions-table-status-inactive":"Inaktiv",
        "terms-and-conditions-table-status-pending":"Under behandling",

        "terms-and-conditions-modal-button-delete-label": "Slet",
        "terms-and-conditions-modal-question": "Er du sikker på, at du vil slette",
        "terms-and-conditions-modal-title": "Handelsbetingelser",

        // Supplier > Admin > Administrators
        "supplier-users-page-header": "\n .title = Administratorer",
        "supplier-users-suppliers-tab-title": "Leverandør administratorer",
        "supplier-users-merchants-tab-title": "Salgssted administratorer",
        "supplier-users-table-merchant-column": "Salgssted",
        "supplier-users-create-admin-button": "Opret ny",

        // Supplier > Admin > Account > Company Account
        "supplier-update-account-title":"\n .title = Leverandørkonto",
        "supplier-update-account-update-button":"Opdater",
        "supplier-update-account-nav-item-home":"Hjem",
        "supplier-update-account-nav-item-account":"Konto",
        "supplier-update-account-registration-number-label":"\n .label = Registreringsnummer",
        "supplier-update-account-error-label-registration-number":"Registreringsnummer",


        // Supplier > Admin > Account > GDPR
        "supplier-account-gdpr-title":"\n .title = GDPR",
        "supplier-account-gdpr-tab-documents":"Dokumenter",
        "supplier-account-gdpr-tab-export":"Eksport",
        "supplier-account-gdpr-export-title":"Brugereksport",
        "supplier-account-gdpr-export-info":"\n .description = Denne funktion gør det muligt at eksportere administratorer og/eller brugere fra alle administrative enheder, herunder leverandør, salgssted, virksomhed, lejer og servicecenter. For at downloade brugere fra andre administrative enheder skal du registrere et eller flere e-maildomæner, der er tilknyttet din virksomhed. Disse domæner vil blive brugt til at identificere din virksomheds brugere. Hvis din virksomhed ikke har nogen verificerede domæner, vil du ikke kunne downloade brugere fra andre enheder. For hjælp med domæneverifikation, kontakt venligst vores supportteam.",
        "supplier-account-gdpr-export-user-types-select-item-user": "Bestillere",
        "supplier-account-gdpr-export-user-types-select-item-administrator": "Administratorer",
        "supplier-account-gdpr-export-user-types-select-label":"\n .label = Brugertyper",
        "supplier-account-gdpr-export-user-types-select-input-label":"Brugertyper",
        "supplier-account-gdpr-export-user-deletion-period-select-input-label":"Periode for sletning af brugere",
        "supplier-account-gdpr-export-user-deletion-period-select-label":"\n .label = Periode for sletning af brugere",
        "supplier-account-gdpr-export-user-deletion-period-select-item-days-180":"180 dage",
        "supplier-account-gdpr-export-user-deletion-period-select-item-days-90":"90 dage",
        "supplier-account-gdpr-export-user-deletion-period-select-item-days-30":"30 dage",
        "supplier-account-gdpr-export-user-deletion-period-select-item-days-7":"7 dage",
        "supplier-account-gdpr-export-include-deleted-switch-label":" \n .label = Inkluder slettede",
        "supplier-account-gdpr-export-exported-domains-subtitle":"Domæner til eksport",
        "supplier-account-gdpr-export-no-domains-registered":"Ingen verificerede domæner for virksomheden er blevet registreret.",
        "supplier-account-gdpr-export-export-button":"Eksportér til CSV",

        // --- Support ---

        // Support > Admin > Features
        "support-admin-features-header": "\n .title = Funktioner",
        "support-admin-features-table-header-name": "Navn",
        "support-admin-features-table-header-plan": "Plan",
        "support-admin-features-table-plan-none": "Ingen",
        "support-admin-features-table-plan-professional": "Professional",
        "support-admin-features-table-plan-enterprise": "Enterprise",
        "support-admin-features-table-header-status": "Status",
        "support-admin-features-table-header-enabled": "Aktiveret",
        "support-admin-features-table-action-edit": "Rediger",
        "support-admin-features-status-label-new": "\n .label = NEW",
        "support-admin-features-status-label-beta": "\n .label = BETA",
        "support-admin-features-status-new": "NEW",
        "support-admin-features-status-beta": "BETA",


        // Support > Admin > Features > Edit
        "support-admin-feature-edit-header": "\n .title = Rediger funktion",
        "support-admin-feature-edit-save-button": "Gem",
        "support-admin-feature-edit-nav-item-feature": "Rediger funktion",
        "support-admin-feature-edit-programmatic-id-label": "\n .label = Programmatisk ID",
        "support-admin-feature-edit-name-label": "\n .label = Navn",
        "support-admin-feature-edit-plan-label": "\n .label = Plan",
        "support-admin-feature-edit-status-label": "\n .label = Status",
        "support-admin-feature-edit-enabled-label": "Aktiveret:",
        "support-admin-feature-edit-settings-title": "\n .title = Indstillinger",

        // Support > Admin > GDPR
        "support-nav-item-gdpr": "GDPR",
        "support-admin-gdpr-page-header": "\n .title = GDPR",
        "support-admin-gdpr-breadcrumb": "GDPR",
        "support-admin-gdpr-administrators-title": "Administratorer",
        "support-admin-gdpr-user-type-label": "\n .label = Brugertype",
        "support-admin-gdpr-user-type-select-item-merchant-admins": "Merchant administratorer",
        "support-admin-gdpr-user-type-select-item-supplier-admins": "Supplier administratorer",
        "support-admin-gdpr-user-type-select-item-company-admins": "Company administratorer",
        "support-admin-gdpr-user-type-select-item-company-agreement-owners": "Company agreement ejere",
        "support-admin-gdpr-include-active-users": "Inkluder aktive brugere",
        "support-admin-gdpr-include-inactive-users": "Inkluder inaktive brugere",
        "support-admin-gdpr-export-button": "Eksporter kontaktliste",
        "support-admin-gdpr-export-button-label": "Eksporter kontaktliste",
        "support-admin-gdpr-export-button-exporting": "Eksporterer...",

        // Support > Reports > Entities
        "support-entity-header-title" : "\n .title = Entiteter",
        "support-entity-header-menu-button-create": "Opret",
        "support-entity-header-menu-button-create-supplier": "Opret leverandør",
        "support-entity-header-menu-button-create-merchant": "Opret forhandler",
        "support-entity-header-menu-button-create-company": "Opret virksomhed",
        "support-entity-header-menu-button-create-tenant": "Opret lejer",
        "support-entity-header-nav-item-home" : "Hjem",
        "support-entity-header-nav-item-entities" : "Entiteter",
        "support-entity-table-header-id": "ID",
        "support-entity-table-header-name": "Navn",
        "support-entity-table-header-address": "Adresse",
        "support-entity-table-header-type": "Type",
        "support-entity-table-header-status": "Status",
        "support-entity-table-button-details": "Detaljer",
        "support-entity-table-button-edit": "Rediger",
        "support-entity-table-button-delete": "Slet",
        "support-entity-table-status-active": "Aktiv",
        "support-entity-table-status-inactive": "Inaktiv",
        "support-entity-confirm-delete-entity-dialog": "\n .typeOfEntity = entitet",
        "support-entity-table-cell-name-agreement-owner": "Aftaleejer",
        "support-entity-table-cell-name-reg-no": "Reg.nr.:",
        "support-entity-table-type-supplier": "\n .label = Leverandør",
        "support-entity-table-show-inactive": "\n .label = Vis deaktiverede",
        "support-entity-table-type-merchant": "\n .label = Salgssted",
        "support-entity-table-type-company": "\n .label = Virksomhed",
        "support-entity-table-type-tenant": "\n .label = Lejer",
        "support-entity-table-type-service-center": "\n .label = Servicecenter",
        "support-entity-table-type-user": "\n .label = Bruger",
        "support-entity-details-connected-merchants": "\n .title = Tilknyttede forhandlere",
        "support-entity-details-connected-companies": "\n .title = Tilknyttede virksomheder",
        "support-entity-details-connected-suppliers": "\n .title = Tilknyttede leverandører",
        "support-entity-details-connected-devices": "\n .title = Forbundne enheder",
        "support-entity-details-id": "ID: { $id }",
        "support-entity-table-entity-type-label":"Entitetstype",
        "support-entity-table-entity-type-select-item-all":"Alle",
        "support-entity-table-entity-type-select-item-supplier":"Kantineforpagter",
        "support-entity-table-entity-type-select-item-merchant":"Salgssted",
        "support-entity-table-entity-type-select-item-company":"Firma",
        "support-entity-table-entity-type-select-item-service-center":"Servicecenter",
        "support-create-entity-error-label-company-invalid-type":"Ugyldig type",
        "support-create-entity-error-label-company-type":"Type",
        "support-create-entity-error-label-system-owner":"Aftaleejer",
        "support-create-entity-error-label-company-number":"Virksomhedsnummer",
        "support-create-entity-error-label-ean-number":"EAN-nummer",
        "support-create-entity-error-label-invoice-type":"Fakturatype",
        "support-create-entity-error-label-invoice-email":"Email",
        "support-create-entity-error-label-attention":"Att.",
        "support-create-entity-error-label-debitot-no":"Debitornummer",
        "support-create-entity-error-label-reminder-email":"Email",
        "support-create-entity-error-label-po-number":"Indkøbsordrenummer",
        "support-create-entity-error-label-company-name":"Firmanavn",
        "support-create-entity-error-label-address":"Adresse",
        "support-create-entity-error-label-country":"Land",
        "support-create-entity-error-label-postal-code":"Postnummer",
        "support-create-entity-error-label-city":"By",
        "support-create-entity-error-label-contact-person":"Kontaktperson",
        "support-create-entity-error-label-email":"Email",
        "support-create-entity-error-label-telephone":"Telefon",
        "support-create-entity-agreement-owner-subtitle":"Aftaleejer",
        "support-create-entity-ean-number-label":"\n .label = EAN-nummer",
        "support-create-entity-address1-label":"\n .label = Adresselinje 1\n .placeholder = Vejnavn og husnummer",
        "support-create-entity-address2-label":"\n .label = Adresselinje 2\n .placeholder = Etage, lejlighed nr., osv.",
        "support-create-entity-postal-code-label":"\n .label = Postnummer",
        "support-create-entity-city-label":"\n .label = By",
        "support-create-entity-contact-person-label":"\n .label = Kontaktperson",
        "support-create-entity-email-label":"\n .label = E-mail",
        "support-create-entity-telephone-label": "\n .label = Telefon",
        "support-create-entity-type-choose-label":"\n .label = Choose",
        "support-create-entity-dropdown-choose-yes":"Ja",
        "support-create-entity-dropdown-choose-no":"Nej",
        "support-create-entity-alert-title":"\n .title = En aftaleejer ejer aftalen med FacilityNet og modtager tilhørende fakturaer. Af denne grund har vi brug for faktureringsoplysninger for aftaleejere.",
        "support-create-entity-subscription-details-subtitle": "Abonnementsoplysninger",
        "support-create-entity-subscription-details-field-implementationDeadline": "\n .label = Deadline for implementation",
        "support-create-entity-subscription-details-alert-title": "\n .title = Dette er datoen, hvor kunden ønsker, at systemet skal gå i produktion. Det betyder, at onboarding, intern test og en eventuel prøveperiode skal være afsluttet før denne dato.",
        "support-create-entity-contact-details-subtitle":"Kontaktoplysninger",
        "support-create-entity-invoice-details-subtitle":"Faktureringsoplysninger",
        "support-create-entity-send-invoice-to-label":"\n .label = Send faktura til",
        "support-create-entity-dropdown-ean-number":"EAN-nummer",
        "support-create-entity-dropdown-email":"Email",
        "support-create-entity-debitor-number-label":"\n .label = Debitornummer\n .helperText = Dette identificerer debitor i FacilityNets regnskabssystem.",
        "support-create-entity-invoice-email-label":"\n .label = E-mail",
        "support-create-entity-attention-label":"\n .label = Att.",
        "support-create-entity-reminder-email-label":"\n .label = E-mail til påmindelser / kontoudtog",
        "support-create-entity-po-number-label":"\n .label = Indkøbsordrenummer",
        "support-create-entity-type-label":"\n .label = Type",
        "support-create-entity-country-label":"\n .label = Land",
        "support-create-entity-dropdown-country-denmark":"Danmark",
        "support-create-entity-dropdown-private-company":"Privat virksomhed",
        "support-create-entity-dropdown-private-person":"Privatperson",
        "support-create-entity-dropdown-public-limited-company":"Aktieselskab",
        "support-create-entity-aside-history": "\n .title = Historik",
        "support-create-entity-aside-version": "Version:",
        "support-create-entity-aside-created": "Oprettet:",
        "support-create-entity-aside-updated": "Ændret:",

        // Invoicing
        "support-reports-basis-for-invoicing-page-header": "\n .title = Faktureringsgrundlag",
        "support-reports-invoicing-header-nav-item": "Fakturering",
        "support-reports-invoicing-header-nav-item-basis-for-invoicing": "Faktureringsgrundlag",
        "support-reports-invoicing-table-debtor-label": "\n .label = Debitor",
        "support-reports-invoicing-table-header-product-no": "Produktnr.",
        "support-reports-invoicing-table-header-name": "Navn",
        "support-reports-invoicing-table-header-price": "Pris",
        "support-reports-invoicing-table-header-items": "Antal",
        "support-reports-invoicing-table-header-total": "I alt",
        "support-reports-invoicing-table-bottom-transactions": "Transaktioner",
        "support-reports-invoicing-table-bottom-subscriptions": "Abonnementer",
        "support-reports-invoicing-table-bottom-total": "I alt",

        // Support > Reports > Health > Server Memory
        "support-reports-health-server-memory-page-header": "\n .title = Serverhukommelse",
        "support-reports-health-server-memory-table-header-memory-type": "Hukommelsestype",
        "support-reports-health-server-memory-table-header-used": "Brugt",
        "support-reports-health-server-memory-table-header-commited": "Commited",
        "support-reports-health-server-memory-table-header-max": "Maks.",

        // Support > Reports > Health > Scheduler
        "support-reports-health-scheduler-page-header": "\n .title = Planlægger",
        "support-reports-health-scheduler-page-subtitle-main-job": "Hovedjob:",
        "support-reports-health-scheduler-page-subtitle-load-in-seconds": "Belastning i sekunder:",
        "support-reports-health-scheduler-table-header-name": "Navn",
        "support-reports-health-scheduler-table-header-cron": "Cron",
        "support-reports-health-scheduler-table-header-last-run": "Sidste kørsel",
        "support-reports-health-scheduler-table-header-next-run": "Næste kørsel",
        "support-reports-health-scheduler-table-header-status": "Status",
        "support-reports-health-scheduler-table-status-active": "Aktiv",
        "support-reports-health-scheduler-table-status-inactive": "Inaktiv",
        "support-reports-health-scheduler-table-status-paused": "Sat på pause",
        "support-reports-health-scheduler-table-action-edit": "Rediger",
        "support-reports-health-scheduler-table-action-pause": "Pause",
        "support-reports-health-scheduler-table-action-start": "Start",
        "support-reports-health-scheduler-table-action-stop": "Stop",

        // Support > Reports > Health > Scheduler > Edit Job
        "support-reports-health-schedule-edit-page-header": "\n .title = Rediger planlæggerjob",
        "support-reports-health-schedule-edit-page-nav-item-edit-job":"Rediger job",
        "support-reports-health-schedule-edit-page-edit-button":"Rediger",
        "support-reports-health-schedule-edit-page-start-time-label":"\n .label = Starttid",
        "support-reports-health-schedule-edit-page-cron-expression-label":"\n .label = Cron-udtryk",
        "support-reports-health-schedule-edit-page-settings-title":"\n .title = Indstillinger",
        "support-reports-health-schedule-edit-page-settings-active-label":"Aktiv:",
        "support-reports-health-schedule-edit-page-information-title":"\n .title = Information",
        "support-reports-health-schedule-edit-page-information-id":"ID:",
        "support-reports-health-schedule-edit-page-information-name":"Navn:",
        "support-reports-health-schedule-edit-page-information-last-run":"Sidste kørsel:",

        // Support > Reports > Health > Database health
        "support-reports-health-database-page-header": "\n .title = Databasesundhed",

        // Support > Reports > Health > Adyen
        "support-reports-health-adyen-page-header": "\n .title = Adyen",
        "support-reports-health-adyen-tab-summary": "Oversigt",
        "support-reports-health-adyen-tab-account-holders": "Kontoindehavere",
        'support-reports-health-adyen-run-button':"Run",
        'support-reports-health-adyen-results':"Results:",
        'support-reports-health-adyen-api-status-unknown':"Unknown",
        'support-reports-health-adyen-api-status-ok':"Ok",
        'support-reports-health-adyen-api-status-failed':"Failed",
        'support-reports-health-adyen-summary-aside-title':"API connection test",
        'support-reports-health-adyen-summary-last-run':"Last run: {$lastRun}",
        'support-reports-health-adyen-summary-legal-entity-management':"Legal Entity Management:",
        'support-reports-health-adyen-summary-balance-platform':"Balance Platform:",
        'support-reports-health-adyen-summary-psp-platform':"PSP Platform:",
        'support-reports-health-adyen-summary-main-title':"Terminal cheatsheet",
        'support-reports-health-adyen-summary-terminal-key':"Key",
        'support-reports-health-adyen-summary-terminal-function':"Function",
        'support-reports-health-adyen-summary-terminal-key-cancel':"Cancel",
        'support-reports-health-adyen-summary-terminal-key-clear':"Clear",
        'support-reports-health-adyen-summary-terminal-key-confirm':"Confirm",
        'support-reports-health-adyen-summary-terminal-press-1':"Press 1 +",
        'support-reports-health-adyen-summary-terminal-press-5':"Press 5 +",
        'support-reports-health-adyen-summary-terminal-press-8':"Press 8 +",
        'support-reports-health-adyen-summary-terminal-press-9':"Press 9 +",
        'support-reports-health-adyen-summary-terminal-function-custom-menu':"Custom menu",
        'support-reports-health-adyen-summary-terminal-function-informational-menu':"Informational menu",
        'support-reports-health-adyen-summary-terminal-function-payments-menu':"Payments menu",
        'support-reports-health-adyen-summary-terminal-function-admin-menu':"Admin menu",


        // Support > Reports > Health > Adyen > Account Holders
        "adyen-account-holders-table-header-id": "ID",
        "adyen-account-holders-table-cell-entity-id": "Juridisk enheds-ID: {$entityId}",
        "adyen-account-holders-table-cell-entity-liable": "Ansvarlig",
        "adyen-account-holders-table-details-balance-accounts": "Saldokonti:",
        "adyen-account-holders-table-details-stores": "Butikker:",
        "adyen-account-holders-table-header-supplier": "Kantineforpagter",
        "adyen-account-holders-table-header-status": "Status",
        "adyen-account-holders-table-header-status-valid": "Valideret",
        "adyen-account-holders-table-header-status-invalid": "Fejl i ansøgning",
        "adyen-account-holders-table-header-status-pending": "Under behandling",
        "adyen-account-holders-table-header-updated": "Opdateret",

        // Support > TopBar > Awaiting approval
        "awaiting-approval-popover-not-approved-item": "\n .title = Til godkendelse\n .description = Ordrer, der skal godkendes",
        "awaiting-approval-popover-to-be-booked-item": "\n .title = Til fakturering\n .description = Mødeforplejningsordrer, der har været fakturerbare i 3+ dage",
        "awaiting-approval-popover-tooltip": "\n .title = Ordrenotifikationer",
        "awaiting-approval-popover-section-meeting-service-title": "\n .title = Mødeforplejning",
        "awaiting-approval-popover-section-takeaway-title": "\n .title = Takeaway",
        "awaiting-approval-popover-todays-orders-item": "\n .title = Dagens ordrer\n .description = Mødeforplejningsordrer til levering i dag",
        "awaiting-approval-popover-todays-takeaway-orders-item": "\n .title = Dagens ordrer\n .description = Takeaway ordrer for i dag",

        // Support > TopBar > Instructions Dialog
        "support-instructions-dialog-title": "Instruktioner",
        "support-instructions-button": "Instruktioner",

        // Non Admin User > TopBar > Create new

        // TopBar > New button > menu
        "top-bar-new-button": "Ny",
        "top-bar-new-menu-resource-booking-title": "Ressourcebooking",
        "top-bar-new-menu-resource-booking-description": "Book lokaler og andre ressourcer",
        "top-bar-new-menu-meeting-service-title": "Mødeforplejning",
        "top-bar-new-menu-meeting-service-description": "Bestil mødeforplejning",
        "top-bar-new-menu-take-away-title": "Takeaway",
        "top-bar-new-menu-take-away-description": "Køb takeaway og andre varer",
        // Takeaway
        "takeaway-kitchen-selector-title": "Vælg butik",
        "takeaway-show-order-button": "Vis ordre: { $price }",
        "create-order-take-away-title": "Takeaway",
        "create-order-take-away-title-with-kitchen": "Takeaway - { $kitchenName }",
        "takeaway-no-shops-empty": "\n .title = Ingen takeaway-butikker tilgængelige",

        // Takeaway > Date bar
        "takeaway-date-bar-or": "ELLER",
        "takeaway-date-bar-view-store-details": "Se butiksoplysninger",

        // Takeaway > Menu
        "takeaway-menu-no-products-for-date": "Ingen produkter tilgængelige for { $date }",
        "takeaway-menu-no-products-for-date-empty": "\n .title = Ingen produkter tilgængelige\n .description = Der er ingen produkter tilgængelige på nuværende tidspunkt",
        "takeaway-menu-no-favorites-empty": "\n .title = Ingen favoritter endnu\n .description = Tryk på hjerteikonet på et produkt for at tilføje det som favorit",
        "takeaway-menu-no-search-results-empty": "\n .title = Ingen resultater\n .description = Prøv at justere din søgning",
        "takeaway-order-is-empty-button": "Ingen ordre",
        "takeaway-checkout-discount-label": "Spar -{ $percentage }%",
        "takeaway-product-sold-out-snackbar": "Varen er udsolgt",

        // Takeaway > Store details dialog
        "takeaway-store-details-title": "Butiksoplysninger",
        "takeaway-store-details-contact": "Kontakt",
        "takeaway-store-details-address": "Adresse",
        "takeaway-store-details-show-on-map": "Vis på kort",
        "takeaway-store-details-close-button": "Luk",
        "takeaway-store-details-opening-hours-banner": "\n .title = Åbningstider: { $hours }",

        // Takeaway > Basket drawer
        "takeaway-basket-date-card-delivery-date-label": "Leveringsdato:",
        "takeaway-checkout-total-label": "I alt",
        "takeaway-checkout-vat-label": "Moms (25%)",
        "takeaway-checkout-confirm-button": "Gennemfør betaling",
        "takeaway-checkout-confirm-button-with-price": "Gennemfør betaling: { $price }",
        "takeaway-checkout-opening-hours-banner": "\n .title = { $kitchenName } er åben { $hours }",

        // Takeaway > Checkout dialog
        "takeaway-confirm-order-dialog-title": "Bekræft ordre",
        "takeaway-confirm-order-dialog-go-back-button": "Gå tilbage",
        "takeaway-checkout-order-summary-title": "Ordreoversigt",
        "takeaway-checkout-private-section": "Privat",
        "takeaway-checkout-payment-hint-by-method": "via { $method }",
        "takeaway-confirm-order-payment-method-title": "Betalingsmetode",
        "takeaway-confirm-order-accounting-title": "Kontering",
        "takeaway-confirm-order-correct-order": "Ret ordre",
        "takeaway-checkout-order-summary-delivery-date": "Levering: { $date }",
        "takeaway-checkout-order-summary-delivery-label": "Levering:",
        "takeaway-confirm-order-items-column": "VARER",
        "takeaway-confirm-order-qty-column": "ANT.",
        "takeaway-confirm-order-amount-column": "BELØB",
        "takeaway-confirm-order-company-section": "Firma",
        "takeaway-confirm-order-wallet-balance": "Saldo: { $balance }",
        "takeaway-confirm-order-wallet-name-with-balance": "{ $name } ({ $balance })",
        "takeaway-confirm-order-pay-using-card": "Betal med { $card }",
        "takeaway-confirm-order-card-expires": "Udløber { $date }",
        "takeaway-confirm-order-comment-title": "Ordrekommentar:",
        "takeaway-confirm-order-comment-placeholder": "\n .label = Skriv en kommentar (valgfrit)\n .helperText = Resterende tegn: { $charsRemaining }",
        "takeaway-confirm-order-guest-name-label": "\n .label = Fulde navn\n .placeholder = Dit fulde navn:",
        "takeaway-confirm-order-guest-email-label": "\n .label = E-mail\n .placeholder = Din e-mail:",
        "takeaway-confirm-order-guest-phone-label": "\n .label = Telefonnr (valgfrit)\n .placeholder = Dit telefonnr:",
        "takeaway-confirm-order-personal-info-title": "Personlige oplysninger",
        "takeaway-confirm-order-personal-info-name-label": "Navn:",
        "takeaway-confirm-order-personal-info-email-label": "E-mail:",
        "takeaway-confirm-order-personal-info-phone-label": "Telefonnr:",
        "takeaway-confirm-order-personal-info-edit-email-field": "\n .label = E-mail",
        "takeaway-confirm-order-personal-info-edit-phone-field": "\n .label = Telefonnr",
        "takeaway-confirm-order-personal-info-edit-save-button": "Gem",
        "takeaway-confirm-order-personal-info-edit-email-invalid": "Indtast venligst en gyldig e-mailadresse",
        "takeaway-confirm-order-personal-info-edit-phone-invalid": "Telefonnummer må kun indeholde cifre samt tegnene + - ( ) og mellemrum",
        "takeaway-confirm-order-delivery-section-title": "Levering",
        "takeaway-confirm-order-delivery-pickup-label": "Afhentning { $hours }",
        "takeaway-checkout-delivery-location-pickup-label": "Afhent:",
        "takeaway-checkout-delivery-location-pickup-time": "{ $start } - { $end }",
        "takeaway-checkout-delivery-location-show-more-button": "Vis mere",
        "takeaway-payment-mobilepay-notice": "Du skal bruge MobilePay-appen på din telefon for at gennemføre betalingen. Du skal godkende betalingen i MobilePay inden for 5 minutter og vende tilbage her.",
        "takeaway-checkout-terms-accepted-label": "Jeg accepterer <conditionsLink>handelsbetingelserne</conditionsLink>",
        "takeaway-checkout-terms-not-accepted": "Du skal acceptere handelsbetingelserne",
        "takeaway-checkout-payment-method-required": "Vælg venligst en betalingsmetode",
        "takeaway-checkout-comment-max-length": "Kommentaren må højst være { $max } tegn",
        "takeaway-payment-poll-title": "Behandler betaling",
        "takeaway-payment-poll-description": "Vent venligst mens vi behandler din betaling. Dette kan tage et øjeblik.",
        "takeaway-payment-failed": "\n .title = Betaling mislykkedes\n .description = Betalingen kunne ikke gennemføres på grund af en uventet fejl. Prøv venligst at gennemføre en ny betaling senere.",
        "takeaway-payment-canceled": "\n .title = Køb annulleret\n .description = Du annullerede betalingen af dit køb.",
        "takeaway-payment-timeout": "\n .title = Betaling udløbet\n .description = Vi har endnu ikke modtaget en bekræftelse fra din betalingsudbyder. Venligst tjek din netbank for at sikre, at betalingen er gennemført.",
        "takeaway-payment-back-to-dashboard-button": "Tilbage til oversigt",
        "takeaway-order-confirmed-dialog-title": "Ordre gennemført!",
        "takeaway-order-confirmed-dialog-order-id": "Ordre-id: { $orderId }",
        "takeaway-order-confirmed-dialog-pickup-hours-label": "Afhent:",
        "takeaway-order-confirmed-dialog-pickup-location-value": "{ $name } mellem { $start } og { $end }",
        "takeaway-order-confirmed-dialog-delivery-date-label": "Leveringsdato:",
        "takeaway-order-confirmed-dialog-amount-label": "Beløb:",
        "takeaway-order-confirmed-dialog-total-amount-label": "Samlet beløb:",
        "takeaway-order-confirmed-dialog-go-to-dashboard-button": "Gå til oversigt",
        "takeaway-order-confirmed-dialog-show-receipt-button": "Vis kvittering",
        "takeaway-order-confirmed-dialog-show-receipts-button": "Vis { $count } kvitteringer",
        "takeaway-receipt-send-button": "Send kvittering",
        "top-bar-new-menu-make-purchase-title": "Foretag et køb",
        "top-bar-new-menu-make-purchase-description": "Bestil frokost i kantinen",
        "top-bar-new-menu-refill-wallet-title": "Genopfyld wallet",
        "top-bar-new-menu-refill-wallet-description": "Fyld penge på din digitale wallet",
        "top-bar-new-menu-section-booking-title": "Booking",
        "top-bar-new-menu-section-purchase-title": "Køb",
        "top-bar-new-menu-book-for-another-user-button": "Book for en anden bruger",
        "top-bar-new-menu-push-message-title": "Push-besked",
        "top-bar-new-menu-push-message-dialog-title": "Ny push-besked",
        "top-bar-new-menu-push-message-description": 'Send beskeder til dine kunder',
        "top-bar-new-menu-shortcuts-title": "Genveje",
        "top-bar-new-menu-shortcut-accounting": "Regnskab",
        "top-bar-new-menu-shortcut-manage-products": "Vedligehold produkter",
        "top-bar-new-menu-shortcut-manage-push-messages": "Vedligehold push-beskeder",


        // ---  Support Reports --- Messages > Email
        "support-messages-email-title": "\n .title = Email",
        "support-messages-email-subject-label":"\n .label = E-mailemne",
        "support-messages-email-receiver-label":"\n .label = Modtager \n .placeholder = Indtast e-mail eller bruger-id",
        "support-messages-email-table-header-receiver":"Modtager",
        "support-messages-email-table-header-subject":"Emne",
        "support-messages-email-table-header-sent-time":"Afsendt tidspunkt",
        "support-messages-email-table-header-status":"Status",
        "support-messages-email-table-status-sent":"Sendt",
        "support-messages-email-table-status-not-sent":"Ikke sendt",
        "support-messages-email-table-cell-subject-created":"Oprettet: { $time }",
        "support-messages-email-resend-button":"Send igen",
        "support-messages-email-export-button":"Eksport",
        "support-messages-email-details-status-label":"Status:",
        "support-messages-email-details-created-label":"Oprettet:",
        "support-messages-email-details-sent-time-label":"Afsendt tidspunkt:",
        "support-messages-email-details-error-message-label":"Fejlmeddelelse:",
        "support-messages-email-details-from-label":"Fra:",
        "support-messages-email-details-subject-label":"Overskrift:",
        "support-messages-email-details-to-label":"Til:",
        "support-messages-email-details-cc-label":"CC:",
        "support-messages-email-details-bcc-label":"BCC:",
        "support-messages-email-details-resend-email-button":"Send e-mail igen",
        "support-messages-email-details-resend-email-title":"Send e-mail igen",
        "support-messages-email-details-sent-button":"Sendt",
        "support-messages-email-resent-dialog-title":"Bekræft afsendelse af e-mails igen",
        "support-messages-email-resent-dialog-subtitle":"Er du sikker på, at du vil sende { $itemsAmount } e-mails igen?",
        "support-messages-email-resent-dialog-cancel-button":"Nej",
        "support-messages-email-resent-dialog-submit-button":"Ja",


        // ---  Support Reports --- Messages > SMS
        "support-messages-sms-title": "\n .title = SMS",
        "support-messages-sms-receiver-label":"\n .label = Modtager",
        "support-messages-sms-text-body-label":"\n .label = Tekstindhold",
        "support-messages-sms-table-header-receiver":"Modtager",
        "support-messages-sms-table-header-created":"Oprettet",
        "support-messages-sms-table-header-sent":"Sendt",
        "support-messages-sms-table-header-status":"Status",
        "support-messages-sms-table-status-sent":"Sendt",
        "support-messages-sms-table-status-not-sent":"Ikke sendt",
        "support-messages-sms-export-button":"Eksport",
        "support-messages-sms-details-status-label":"Status:",
        "support-messages-sms-details-id-label":"id:",
        "support-messages-sms-details-created-label":"Oprettet:",
        "support-messages-sms-details-sent-time-label":"Afsendt tidspunkt:",
        "support-messages-sms-details-error-message-label":"Fejlmeddelelse:",
        "support-messages-sms-details-text-message-label":"Tekstbesked:",
        "support-messages-sms-details-from-label":"Fra:",
        "support-messages-sms-details-to-label":"Til:",



         // ---  Support Reports --- Accounting > Subscriptions
        "support-subscriptions-header": "\n .title = Abonnementer",
        "support-subscriptions-table-order-id-column": "Ordre ID",
        "support-subscriptions-table-employee-column": "Medarbejder",
        "support-subscriptions-table-subscribed-column": "Tilmeldt",
        "support-subscriptions-table-unsubscribed-column": "Frameldt",
        "support-subscriptions-table-payment-column": "Betaling",
        "support-subscriptions-table-amount-column": "Beløb",
        "support-subscriptions-table-cancel-subscription": "Opsig abonnement",
        "support-subscriptions-table-details": "Detaljer",
        "support-subscriptions-table-filters-merchant-title":"\n .title = Salgssted",
        "support-subscriptions-table-filters-customer-title":"\n .title = Kunde",
        "support-subscriptions-table-filters-payment-title":"\n .title = Betaling",

        // ---  Support Reports --- Accounting > Meeting Service
        "support-accounting-meeting-service-header": "\n .title = Mødeforplejning",
        "support-accounting-meeting-service-table-order-id-column": "Ordre ID",
        "support-accounting-meeting-service-table-booked-date-column": "Bogføringsdato",
        "support-accounting-meeting-service-table-delivery-time-column": "Leveringstid",
        "support-accounting-meeting-service-table-employee-column": "Bestiller",
        "support-accounting-meeting-service-table-status":"Status",
        "support-accounting-meeting-service-table-amount-column": "Beløb (DKK)",
        "support-accounting-meeting-service-table-show-receipt": "Vis kvittering",
        "support-accounting-meeting-service-table-floating-action-bar-export": "\n .title = Eksport",

        // ---  Support Reports --> Printer Queue
        "support-printer-queue-title": "\n .title = Printerkø",
        "support-printer-queue-merchant-label":"\n .label = Salgssted",
        "support-printer-queue-order-id-label":"\n .label = Ordre ID",
        "support-printer-queue-table-header-id":"Id",
        "support-printer-queue-table-header-created":"Oprettet",
        "support-printer-queue-table-header-print-at":"Printes kl.",
        "support-printer-queue-table-header-device-name":"Enhedsnavn",
        "support-printer-queue-table-header-order-id":"Ordre ID",
        "support-printer-queue-table-header-status":"Status",
        "support-printer-queue-table-device-group":" Gruppe: ",
        "support-printer-queue-table-status-printed":"Printet",
        "support-printer-queue-table-status-queue":"Kø",
        "support-printer-queue-table-raw-receipt-action":"Rå kvittering",
        "support-printer-details-status-label":"Status:",
        "support-printer-details-created-label":"Oprettet:",
        "support-printer-details-printed-at-label":"Printet kl.:",
        "support-printer-details-device-group-subtitle":"Enhedsgruppe:",
        "support-printer-details-device-subtitle":"Enhed:",
        "support-printer-details-id-label":"ID:",
        "support-printer-details-name-label":"Navn:",
        "support-printer-details-mime-type-label":"Mime-type:",
        "support-printer-details-priority-label":"Prioritet:",
        "support-printer-details-job-token-label":"Job-token:",

        // ---  Support Reports --- Orders > POS
        "support-orders-pos-title": "\n .title = POS",
        "support-orders-pos-order-id-label":"\n .label = Ordre ID",
        "support-orders-pos-email-label":"\n .label = Email",
        "support-orders-pos-table-header-order-id":"Ordre ID",
        "support-orders-pos-table-header-transaction-time":"Transaktionstid",
        "support-orders-pos-table-header-customer":"Kunde",
        "support-orders-pos-table-header-merchant":"Salgssted",
        "support-orders-pos-table-header-amount":"Beløb",
        "support-orders-pos-table-action-show-receipt":"Vis kvittering",
        "support-orders-pos-table-action-show-order-details":"Vis ordredetaljer",


        // --- Support entity---
        "support-create-supplier-title": "\n .title = Opret leverandør",
        "support-update-supplier-title": "\n .title = Opdater leverandør",
        "support-create-supplier-create-button": "Opret",
        "support-create-supplier-update-button": "Opdater",
        "support-create-supplier-nav-item-home": "Hjem",
        "support-create-supplier-nav-item-entities": "Entiteter",
        "support-create-supplier-nav-item-create-supplier": "Opret leverandør",
        "support-create-supplier-nav-item-update-supplier": "Opdater leverandør",
        "support-create-supplier-aside-settings": "\n .title = Indstillinger",
        "support-create-supplier-aside-active": "Aktiv:",
        "support-create-supplier-company-number-label":"\n .label = Virksomhedsnummer",
        "support-create-supplier-company-name-label":"\n .label = Virksomhedsnavn",
        "support-create-subscription-status-title": "\n .title = Abonnementsstatus",
        "support-create-supplier-subscription-status": "Status",
        "support-create-supplier-subscription-status-mode-creating": "Opretter",
        "support-create-supplier-subscription-status-mode-onboarding": "Onboarding",
        "support-create-supplier-subscription-status-mode-trial": "Prøveperiode",
        "support-create-supplier-subscription-status-mode-live": "LIVE",
        "support-create-supplier-subscription-status-mode-unsubscribing": "Afmelder",
        "support-create-supplier-subscription-status-mode-unsubscribed": "Frameldt",
        "support-create-supplier-subscription-status-created": "Oprettet",
        "support-create-supplier-subscription-status-implementation-deadline": "Implementeringsfrist",
        "support-create-supplier-subscription-status-onboarding-email-sent": "Onboarding-e-mail sendt",
        "support-create-supplier-subscription-status-trial-started": "Prøveperiode startet",
        "support-create-supplier-subscription-status-subscription-started": "Abonnement startet",
        "support-create-supplier-subscription-status-subscription-ending": "Abonnement afsluttes",
        "support-create-supplier-subscription-status-button-mode-creating": "Send onboarding-artikler",
        "support-create-supplier-subscription-status-button-mode-onboarding": "Fuldfør onboarding",
        "support-create-supplier-subscription-status-button-mode-trial": "Gå live",
        "support-create-supplier-subscription-status-button-mode-live": "Afslut abonnement",
        "support-create-supplier-subscription-status-button-mode-unsubscribing": "Rediger",
        "support-create-supplier-subscription-status-button-mode-unsubscribed": "Rediger",
        "support-create-supplier-subscription-status-begin-onboarding-dialog": "Begynd onboarding",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-articles-to-send": "Artikler der skal sendes",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-destination": "Destination",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-button-next": "Næste",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-existing-administrators": "Eksisterende administratorer",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-extra-receivers": "Ekstra modtagere",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-button-begin": "Begynd",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-supplier-admin": "Leverandøradministrator: {$adminDetails}",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-kitchen-admin": "Køkkenadministrator: {$adminDetails}",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-label-email": "\n .label = E-mail \n .placeholder = Modtagerens e-mail",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-button-add": "Tilføj",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-email-error": "Ugyldig e-mailadresse",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-administrators-error": "Mindst én administrator skal vælges",


        // --- Support company ---
        "support-create-company-title": "\n .title = Opret virksomhed",
        "support-update-company-title": "\n .title = Opdater virksomhed",
        "support-create-company-create-button": "Opret",
        "support-create-company-update-button": "Opdater",
        "support-create-company-nav-item-home": "Hjem",
        "support-create-company-nav-item-entities": "Entiteter",
        "support-create-company-nav-item-create-company": "Opret virksomhed",
        "support-create-company-nav-item-update-company": "Opdater virksomhed",
        "support-create-company-aside-settings": "\n .title = Indstillinger",
        "support-create-company-aside-active": "Aktiv:",
        "support-create-company-office-hotel-label":"Kontorhotel:",
        "support-create-company-office-hotel-helper-text":"Hjælpetekst",
        "support-create-company-company-number-label":"\n .label = Virksomhedsnummer",
        "support-create-company-main-ean-number-label":"\n .label = Primært EAN-nummer",
        "support-create-company-company-name-label":"\n .label = Virksomhedsnavn",
        "support-create-company-error-label-main-ean-number":"Primært EAN-nummer",
        "support-create-company-error-label-url-identifier":"URL-identifikator",
        "support-create-company-aside-is-self-sign-up":"\n .title = Selvtilmelding",
        "support-create-company-url-identifier-label":"\n .label = Tilmeldings-URL-identifikator\n .helperText = Dette bruges til at generere brugerens tilmeldings-URL.",
        "support-create-company-signup-link-subtitle":"Tilmeldingslink:",

        // Navigation
        "support-nav-item-devices": "Hardware enheder",

        // Support ADMIN DEVICES
        "support-admin-nav-item-devices": "Hardware enheder",
        "support-admin-entities-card-group": "\n .title = Entiteter",
        "support-admin-entities-card": "\n .title = Entities\n .description = Administrer entiteter i systemet, såsom leverandører, salgssteder og firmaer.",
        "support-admin-devices-page-header": "\n .title = Enheder",
        "support-table-header-supplier": "Kantineforpagter",
        "support-table-header-merchant": "Salgssted",

        // Access
        "support-nav-item-home": "Hjem",
        "support-nav-item-supplier-access": "Kantineforpagtere",
        "support-nav-item-merchant-access": "Kantiner",
        "support-nav-item-entities-access": "Entiteter",
        "support-nav-item-payments": "Betalinger",
        "support-nav-item-features": "Funktioner",
        "support-nav-item-invoicing": "\n .title = Fakturering",
        "support-nav-item-invoicing-basis-for-invoicing": "Faktureringsgrundlag",
        "support-nav-item-health-title": "\n .title = Sundhed",
        "support-nav-item-health": "Sundhed",
        "support-nav-item-health-database": "Databasesundhed",
        "support-nav-item-health-server-memory": "Serverhukommelse",
        "support-nav-item-health-scheduler": "Planlægger",
        "support-nav-item-health-adyen": "Adyen",

        "support-supplier-access-page-header": "\n .title = Kantineforpagtere",
        "support-merchant-access-page-header": "\n .title = Kantiner",
        "support-nav-item-messages": "\n .title = Messages",
        "support-nav-item-orders-title": "\n .title = Ordrer",
        "support-nav-item-orders": "Ordrer",
        "support-nav-item-orders-pos": "POS",
        "support-nav-item-accounting-title": "\n .title = Regnskab",
        "support-nav-item-accounting": "Regnskab",
        "support-nav-item-subscriptions": "Abonnementer",
        "support-nav-item-accounting-meeting-service": "Mødeforplejning",
        "support-nav-item-email": "Email",
        "support-nav-item-sms": "SMS",
        "support-nav-item-printer-queue": "Printerkø",


        // Page header
        "page-header-help-tooltip": "\n .title = Klik her for mere info",
        "page-header-help-text": "Hjælpeguides",
        "page-header-help-status-mode-new": "Ny",
        "page-header-help-status-mode-beta": "Beta",
        "page-header-help-maintenance": "Beklager, siden er i øjeblikket utilgængelig, da den er under vedligeholdelse.",


        // YUP validation
        "validation-title-required": "Titel er påkrævet",
        "validation-body-required": "Skal udfyldes",
        "validation-type-required": "Type er påkrævet",

        // Field validation
        "validation-date-must-be-in-past": "Datoen skal være i fortiden",
        "validation-date-must-be-today-or-past": "Datoen skal være i dag eller tidligere",
        "validation-date-must-be-in-future": "Datoen skal være i fremtiden",
        "validation-date-must-be-today-or-future": "Datoen skal være i dag eller senere",
        "validation-datetime-must-be-in-past": "Dato og tid skal være i fortiden",
        "validation-datetime-must-be-in-future": "Dato og tid skal være i fremtiden",
        "validation-number-exceeds-max": "Værdien skal være højst { $max }",
        "validation-number-below-min": "Værdien skal være mindst { $min }",

        // Common
        "employee-id": "Medarbejderid",
        "id": "id",
        "name": "Navn",
        "price": "Pris",
        "email": "Email",
        "amount": "Beløb",
        "for": "for",
        "yes": "Ja",
        "no": "nej",
        "status": "Status",
        "active": "Aktiv",
        "inactive": "Inaktiv",
        "edit": "Rediger",
        "delete": "Slet",
        "create": "Opret",
        "save": "Gem",
        "required-field": "Dette felt er påkrævet",
        "invalid-email": "Ugyldig e-mailadresse",

        // History block
        "history-card": "\n .title = Historik",
        "history-created": "Oprettet:",
        "history-edited": "Sidst ændret:",

        // Production order
        "production-order-status-received": "Modtaget",
        "production-order-status-confirmed": "Bekræftet",
        "production-order-status-cancelled": "Annulleret",
        "production-order-status-ready": "Klar",
        "production-order-number": "ID",
        "production-order-status": "Status",
        "production-order-payment-status": "Betalingsmetode",
        "production-order-payment-channel": "Kanal",
        "production-order-time": "Tid",
        "production-order-delivery-time": "Leveringstid",
        "production-order-placeholder-comment": "Kommentar til kunden",
        "production-order-show-cancelled": "Vis annulleret",

        // Pos order
        "pos-order-delivery-date-title": "Leveringsliste - takeaway",
        "pos-order-delivery-date": "\n .label =  Leveringsdato:",
        "pos-order-purchase-time": "\n .label =  Købstid:",
        "pos-order-customer": "\n .label =  Kunde:",

        // Merchant > Reports > Production > Meeting service
        "meeting-service-table-approved-orders": "Godkendte ordrer",
        "meeting-service-table-unapproved-orders": "\n .label = Ikke-godkendte ordrer",
        "meeting-service-table-time": "Tid",
        "meeting-service-table-start-date": "Startdato",
        "meeting-service-table-end-date": "Slutdato",
        "meeting-service-table-delivery-type": "Leveringstype",
        "delivery-type-filter-all": "Alle",
        "delivery-type-filter-delivery": "Levering",
        "delivery-type-filter-pick-up": "Afhentning",
        "delivery-type-filter-eating-in-canteen": "Spiser i kantinen",
        "meeting-service-table-order-id-column": "Ordre ID",
        "meeting-service-table-delivery-time-column": "Leveringstid",
        "meeting-service-table-delivery-location-column": "Møde",
        "meeting-service-table-meeting-name-column": "Mødenavn",
        "meeting-service-table-location-column": "Lokation",
        "meeting-service-table-amount-column": "Beløb",
        "meeting-service-table-changes-column": "Ændringer",
        "meeting-service-table-changes-column-tooltip-changed": "\n .title = Ordren er blevet ændret den {$date}",
        "meeting-service-table-changes-column-tooltip-unchanged": "\n .title = Ordren er ikke blevet ændret",
        "meeting-service-table-changes-column-active-filter-yes": "Aktiv",
        "meeting-service-table-changes-column-inactive-filter-no": "Inaktiv",
        "meeting-service-table-lock-column": "Lås",
        "meeting-service-table-lock-column-tooltip-open": "\n .title = Ordren er åben for ændringer",
        "meeting-service-table-lock-column-tooltip-closed": "\n .title = Ordren er låst for ændringer",
        "meeting-service-table-lock-column-lock-tooltip": "\n .title = Blokér for at bestiller kan ændre denne ordre",
        "meeting-service-table-lock-column-unlock-tooltip": "\n .title = Tillad bestiller at ændre denne ordre",
        "meeting-service-table-lock-column-active-filter-yes": "Aktiv",
        "meeting-service-table-lock-column-inactive-filter-no": "Inaktiv",
        "meeting-service-table-meeting": "Levering: {$locationName}",
        "meeting-service-table-production-slip-button": "Følgeseddel",
        "meeting-service-table-credit-note-button": "Kreditnota",
        "meeting-service-table-receipt-button": "Kvittering",
        "meeting-service-table-update-button": "Rediger",
        "meeting-service-table-duplicate-button": "Duplikér",
        "meeting-service-table-book-button": "Bogfør",
        "meeting-service-table-send-message-button": "Send besked",
        "meeting-service-table-delete-button": "Slet",
        "meeting-service-table-date-range-filter": "Datointerval",
        "meeting-service-table-floating-action-bar-read": "\n .title = Læst",
        "meeting-service-table-floating-action-bar-lock-unlock": "\n .title = Lås/oplås",
        "meeting-service-table-floating-action-bar-lock": "\n .title = Lås",
        "meeting-service-table-floating-action-bar-lock-tooltip": "\n .title = Blokér for at bestiller kan ændre valgte ordrer",
        "meeting-service-table-floating-action-bar-unlock": "\n .title = Oplås",
        "meeting-service-table-floating-action-bar-unlock-tooltip": "\n .title = Tillad bestiller at ændre valgte ordrer",
        "meeting-service-table-floating-action-bar-book": "\n .title = Bogfør",
        "meeting-service-table-floating-action-bar-status": "\n .title = Status",
        "meeting-service-table-floating-action-bar-delete": "\n .title = Slet",
        "meeting-service-table-floating-action-bar-print": "\n .title = Udskriv",
        "meeting-service-table-floating-action-bar-production-slip": "\n .title = Følgeseddel",
        "meeting-service-table-floating-action-bar-delivery-list": "\n .title = Leveringsliste",
        "meeting-service-table-floating-action-bar-receipt": "\n .title = Kvittering",
        "meeting-service-table-floating-action-bar-export": "\n .title = Eksporter valgte",
        "calendar-button-show-calendar": "\n .title = Vis kalender\n .aria-label = Vis kalender",
        "meeting-service-delete-orders-title": "Slet ordrer",
        "meeting-service-delete-order-title": "Slet ordre",
        "meeting-service-delete-orders-checkbox-label-meeting-service": "\n .label = Mødeforplejning",
        "meeting-service-delete-orders-checkbox-label-booking": "\n .label = Annuller ressourcebooking",
        "meeting-service-delete-orders-checkbox-label-booking-lock": "Annuller ressourcebooking",
        "meeting-service-delete-orders-checkbox-label-meeting-service-cancel": "\n .label = Annuller mødeservice",
        "meeting-service-delete-orders-checkbox-label-meeting-service-cancel-lock": "Annuller mødeservice",
        "meeting-service-delete-orders-helper-merchant-cancellation-field": "\n .label = Annulleringsbesked \n .placeholder = Skriv en begrundelse for annulleringen. Denne besked sendes til kunden. \n .helperText = Resterende tegn: { $charsRemaining }",
        "meeting-service-delete-orders-helper-merchant": "Bemærk: Hvis en ressourcebooking er knyttet til mødeserviceordren, vil den ikke blive annulleret.",
        "meeting-service-delete-orders-helper-line-one": "OBS: Hvis en ressourcebooking er knyttet til mødeserviceordren, kan du annullere ressourcebookingen på vegne af opretteren.",
        "meeting-service-delete-orders-helper-line-two": "Vær opmærksom på, at hvis du annullerer ressourcebookingen, vil en eventuel reservation af lokaler og tilhørende AV-udstyr også blive annulleret og frigivet til andre brugere.",
        "meeting-service-table-order-name-column": "Ordrenavn",
        "meeting-service-book-orders-title": "Book ordrer",
        "meeting-service-book-orders-description": "Ordrer mærket 'Fremtidig' kan ikke behandles, da leveringsdatoen er sat til en fremtidig dato. For ordrer mærket 'Kontant' skal du sikre, at en betalingsdato er angivet for dagen for modtagelse af betaling.",
        "meeting-service-table-status-column": "Status",
        "meeting-service-table-cash-payment-received-column": "Kontant betaling modtaget",
        "meeting-service-book-orders-subtotal": "Subtotal",
        "meeting-service-book-orders-button": "Bogfør",
        "meeting-service-delete-orders-button": "Slet",
        "meeting-service-delete-single-order-id-label": "Ordre ID:",
        "meeting-service-delete-single-order-delivery-date-label": "Leveringsdato:",
        "meeting-service-delete-single-order-meeting-name-label": "Mødenavn:",
        "meeting-service-delete-single-order-responsible-label": "Ansvarlig:",
        "meeting-service-delete-single-order-amount-label": "Beløb:",
        "merchant-home-meeting-service-awaiting-approval-title": "Til godkendelse",
        "filter-menu-accordion-order-status-title": "\n .title = Ordrestatus",
        "filter-menu-accordion-companies-title": "\n .title = Virksomheder",
        "filter-menu-accordion-checkbox-awaiting-approval": "\n .optionLabel = Til godkendelse",
        "filter-menu-accordion-checkbox-to-be-invoiced": "\n .optionLabel = Skal faktureres",
        "meeting-service-table-header-date-range-button": "Datointerval",
        "meeting-service-table-header-period-picker-button": "Periodevælger",
        "meeting-service-table-lock-column-locked":"\n .title = Ordren er blevet låst af forhandleren. Kontakt forhandleren for opdateringer.",
        "meeting-service-snackbar-undo": "UNDO",
        "meeting-service-snackbar-undo-message": "{ $amount ->\n  [one] { $amount } ordre er blevet \n *[other] { $amount } ordrer er blevet \n}",
        "meeting-service-delivery-list": "Leveringsliste",
        "meeting-service-delivery-list-period": "Periode:<dateRange>{$startLabel} - {$endLabel}</dateRange><icon />",
        "meeting-service-delivery-list-period-all": "Periode:<all>Alle</all><icon />",
        "meeting-service-delivery-list-header-period": "Periode: {$startLabel} - {$endLabel}",
        "meeting-service-delivery-list-header-period-all": "Periode: Alle",
        "meeting-service-delivery-list-orders-selected": "Ordrer: {$ordersLength} valgt",
         "meeting-service-delivery-list-group-by-label": "Gruppér efter:",
        "meeting-service-delivery-list-group-by-location": "Leveringssted",
        "meeting-service-delivery-list-group-by-time": "Leveringstid",
        "meeting-service-delivery-list-group-by-item": "Gruppér efter: levering {$value}",
        "meeting-service-delivery-list-delivery": "Leveringstype:<value>{$value}</value>",
        "meeting-service-delivery-list-filter-all": "Alle",
        "meeting-service-delivery-list-empty": "Ingen leveringsordrer for de valgte kriterier",
        "meeting-service-delivery-list-delivery-details-meeting-time": "\n .label = Mødetid:",
        "meeting-service-delivery-list-delivery-details-location": "\n .label = Leveringssted:",
        "meeting-service-delivery-list-delivery-details-sittings": "\n .label = Siddepladser:",
        "meeting-service-delivery-list-contact-details-meeting-creator": "\n .label = Oprettet af:",
        "meeting-service-delivery-list-contact-details-meeting-host": "\n .label = Mødeansvarlig:",
        "meeting-service-delivery-list-table-column-items": "Antal",
        "meeting-service-delivery-list-table-column-products": "Produkter",
        "meeting-service-delivery-list-table-column-delivery-time": "Leveringstid",

        // Batch modal
        "meeting-service-batch-modal-title": "\n .dialogTitle = Skift status",
        "meeting-service-batch-modal-button-change-label": "Bekræft",
        "meeting-service-batch-modal-button-close-label": "Luk",
        "meeting-service-batch-modal-button-close-tooltip-label": "\n .title = Ingen ordrer kan skifte status",
        "meeting-service-batch-modal-warning-message": "Kunne ikke skifte status for ordrer med dette ikon",
        "meeting-service-batch-modal-cancellation-reason-message": "Skriv en årsag til annulleringen. Denne besked sendes ud til alle på listen.",
        "meeting-service-batch-modal-customer-message": "Besked til kunde",
        "meeting-service-batch-modal-order-id": "Ordre ID",
        "meeting-service-batch-modal-delivery-time": "Leveringstid",
        "meeting-service-batch-modal-order-details": "Ordredetaljer",
        "meeting-service-batch-modal-from": "Fra",
        "meeting-service-batch-modal-to": "Til",
        "meeting-service-batch-modal-batch-error": "{ $ordersCount ->\n  [one] Kunne ikke skifte status for { $ordersCount } ordre\n *[other] Kunne ikke skifte status for { $ordersCount } ordrer\n}",

        // Package slip handle PDF open
        "meeting-service-handle-pdf-open-error": "Kunne ikke åbne pdf",

        // Merchant > Reports > Production > Calendar
        "orders-for-calendar-multi-select": "\n .label = Shoptype",
        "orders-for-calendar-search": "\n .label = Søg \n .placeholder = Søg efter ordre-id eller ordrenavn",
        "expandable-search-search-button": "Søg",
        "expandable-search-clear-button": "Ryd søgning",
        "production-slip-dialog-title": "Følgeseddel",
        "production-slip-dialog-table-header-items": "Antal",
        "production-slip-dialog-table-header-products": "Produkter",
        "production-slip-dialog-table-header-delivery-time": "Leveringstid",
        "production-slip-dialog-note": "Ordrenotat",
        "production-slip-dialog-order-id": "Ordre-ID: { $orderId }",
        "production-slip-dialog-delivery-details": "Leveringsdetaljer",
        "production-slip-dialog-delivery-type": "Leveringstype:",
        "production-slip-dialog-delivery-time": "Leveringstidspunkt:",
        "production-slip-dialog-delivery-meeting-time": "Mødetidspunkt:",
        "production-slip-dialog-delivery-delivery-location": "Leveringssted:",
        "production-slip-dialog-delivery-sittings": "Kuverter:",
        "production-slip-dialog-delivery-shop": "Butik:",
        "production-slip-dialog-contact-details": "Kontaktoplysninger",
        "production-slip-dialog-contact-details-creator": "Bestiller:",
        "production-slip-dialog-contact-details-meeting-host": "Mødevært:",
        "production-slip-dialog-scan": "Se følgeseddel på mobilenhed",

        // Accounting customer
        "customer-accounting-show-customers-with-sales-only": "Vis kun kunder med salg",


        // FloatingActionButton
        "floating-action-button": "Luk",
        "floating-action-button-picked": "Valgte emner",
        "floating-action-button-order-status": "\n .title = Status",
        "floating-action-button-order-status-menu-item": "Skift ordrestatus",
        "floating-action-button-receipt": "Kvittering",
        "floating-action-button-print": "\n .title = Udskriv",
        "floating-action-button-print-receipt": "\n .title = Udskriv kvittering",
        "floating-action-button-print-label": "\n .title = Udskriv label",
        "print-label-copies-modal": "\n .title = Udskriv label\n .message = Hvor mange kopier vil du udskrive?\n .buttonLabelSubmit = Udskriv\n .buttonLabelCancel = Annuller",
        "floating-action-button-export": "\n .title = Eksport",

        //ChangeOrderStatusModal
        "change-order-status": "Skift ordrestatus",
        "change-order-status-received": "Modtaget",
        "change-order-status-confirmed": "Bekræftet",
        "change-order-status-ready": "Klar",
        "change-order-status-cancelled": "Annulleret",
        "change-order-status-title": "Resultat",

        "change-order-status-received-info-text": "En ordre får automatisk tildelt status Modtaget, når den oprettes. Hvis du ønsker at ændre status fra Bekræftet til Modtaget, så vil bestiller modtage en notifikation. Rul kun status tilbage fra Bekræftet til Modtaget, hvis du ved en fejl har sat status til Bekræftet.",
        "change-order-status-confirmed-info-text": "Når en ordre sættes til Bekræftet, så modtager bestiller en notifikation at ordren behandles. Bestiller kan forvente at modtage sin ordre.",
        "change-order-status-ready-info-text": "Når en ordre sættes til Klar, så modtager bestiller en notifikation at ordren kan hentes.",
        "change-order-status-cancelled-info-text": "Når en ordre sættes til Annulleret, så modtager bestiller en notifikation at ordren ikke leveres. Du kan skrive en kommentar til bestilleren, hvorfor den annulleres.",


        //ChangeOrderStatusResponseModal
        "change-order-status-response-modal-title": "Resultat",
        "change-order-status-response-modal-order-id": "Ordre-id",
        "change-order-status-response-modal-order-delivery": "Leveringsdato",
        "change-order-status-response-modal-order-message": "Besked",
        "change-order-status-response-modal-error": "fejlede",
        "change-order-status-response-modal-error-aciton": "handling",
        "change-order-status-response-modal-error-acitons": "handlinger",


        // --- Surveys List ---
        "surveys-list-header": "\n .title = Brugerundersøgelser",
        "surveys-list-create-button": "Opret ny",
        "surveys-list-survey-table-name-column": "Navn",
        "surveys-list-survey-table-start-date-column": "Startdato",
        "surveys-list-survey-table-end-date-column": "Slutdato",
        "surveys-list-survey-table-active-column-active":"Aktiv",
        "surveys-list-survey-table-active-column-inactive":"Inaktiv",
        "surveys-list-survey-table-active-column-active-filter-yes": "Aktiv",
        "surveys-list-survey-table-active-column-inactive-filter-no": "Inaktiv",
        "surveys-table-list-delete-modal-title": "brugerundersøgelse",
        "surveys-table-list-show-ratings": "Vis bedømmelser",
        "surveys-table-list-delete-success-message": "Brugerundersøgelsen blev slettet",

        // Create / edit survey
        "create-survey-header": "\n .title = Opret brugerundersøgelse",
        "edit-survey-header": "\n .title = Rediger brugerundersøgelse",
        "nav-item-create-survey-header": "Opret brugerundersøgelse",
        "nav-item-edit-survey-header": "Rediger brugerundersøgelse",
        "create-merchant-survey-save-button": "Opret",
        "edit-merchant-survey-save-button": "Gem",
        "create-or-edit-merchant-survey-field-name": "\n .label = Navn\n .placeholder = Indtast et navn til brugerundersøgelsen\n .helperText = Beskrivelsen vises ikke for brugeren",
        "create-or-edit-merchant-survey-field-name-required": "Navn er påkrævet",
        "create-or-edit-merchant-survey-field-description":
            "\n .label = Beskrivelse\n .placeholder = Indtast en valgfri beskrivelse til eget brug\n .helperText = Beskrivelsen vises ikke for brugeren",
        "create-or-edit-merchant-survey-questions": "Dine spørgsmål:",
        "create-or-edit-merchant-survey-questions-empty": "Du har ikke oprettet nogen spørgsmål endnu.",
        "create-or-edit-merchant-survey-field-questions-minError":"You need at least one question",
        "create-or-edit-merchant-survey-add-questions-button": "Tilføj spørgsmål",
        "create-or-edit-merchant-survey-title-general": "\n .title = Generelt",
        "create-or-edit-merchant-survey-field-active": "Aktiv:",
        "create-or-edit-merchant-survey-field-start-date": "Startdato",
        "create-or-edit-merchant-survey-field-end-date": "Slutdato",
        "create-or-edit-merchant-survey-title-user-visibility": "\n .title = Brugersynlighed",
        "create-or-edit-merchant-survey-field-timeOfDay": "\n .label = Time of day",
        "create-or-edit-merchant-survey-field-timeOfDay-helperText": "Determines the time of day rating card for this survey will be shown.",
        "create-or-edit-merchant-survey-field-expirationDays": "\n .label = Expiration days\n .helperText = Days until an unanswered rating card is hidden.",
        "edit-merchant-survey-success-save-message": "Brugerundersøgelsen blev opdateret",
        "create-merchant-survey-success-save-message": "Brugerundersøgelse oprettet",
        "create-or-edit-merchant-survey-dialog-save-button": "Gem",
        "create-or-edit-merchant-survey-dialog-title": "Tilføj spørgsmål",
        "create-or-edit-merchant-survey-dialog-field-question": "\n .label = Spørgsmål",
        "create-or-edit-merchant-survey-dialog-topics-title": "Vælg emner:",
        "create-or-edit-merchant-survey-dialog-topics-good": "\n .label = Gode emner",
        "create-or-edit-merchant-survey-dialog-topics-bad": "\n .label = Dårlige emner",
        "create-or-edit-merchant-survey-dialog-topics-info": "Gode emner kan bruges af deltageren til at vælge, hvad de fandt særligt godt. Dårlige emner kan bruges til at angive, hvad de gerne vil se forbedret.",


        // --- Company ---

        // Company > Reports > Home
        "company-home-purchases-card-group": "\n .title = Køb",
        "company-home-purchases-period-base-3": "Sidste 3 dage",
        "company-home-purchases-period-base-14": "Sidste 14 dage",
        "company-home-purchases-period-base-30": "Sidste 30 dage",
        "company-home-purchases-period-base-60": "Sidste 60 dage",
        "company-home-purchases-period-base-180": "Sidste 180 dage",
        "company-home-purchases-pos-purchases-title": " \n .title = POS-køb",
        "company-home-purchases-pos-orders-title": " \n .title = POS-ordrer",
        "company-home-purchases-meeting-service-purchases-title": " \n .title = Mødeservicekøb",
        "company-home-purchases-meeting-service-orders-title": " \n .title = Mødeserviceordrer",
        "company-home-purchases-users-title": " \n .title = Brugere",
        "company-home-purchases-check-in-title": " \n .title = Check-ins",


        // Company > Admin > Home
        "company-admin-home-organization-users-card":  "\n .title = Brugere \n .description = Administrer brugere.",
        "company-admin-home-organization-bill-receivers-card":  "\n .title = Regningsmodtagere \n .description = Administrer regningsmodtagere.",
        "company-admin-home-organization-user-group-card":  "\n .title = Brugergrupper \n .description = Administrer brugergrupper.",
        "company-admin-home-organization-departments-card":  "\n .title = Afdelinger \n .description = Administrer afdelinger.",
        "company-admin-home-organization-workgroups-card":  "\n .title = Arbejdsgrupper \n .description = Administrer arbejdsgrupper.",
        "company-admin-home-organization-locations-card":  "\n .title = Lokationer \n .description = Administrer lokationer.",
        "company-admin-home-account-gdpr-card":  "\n .title = GDPR \n .description = Databeskyttelsesforordningen \n .buttonText = Show",
        "company-admin-home-account-administrator-card":  "\n .title = Administratorer \n .description = Administrer administratorer.",

        // Navigation
        "company-nav-item-home": "Hjem",
        "company-home-coming-soon-placeholder": "\n .title = Kommer snart",
        "company-home-coming-soon-placeholder-body": "Du er logget ind som virksomhedsadministrator. Vi arbejder på at levere denne funktion til dig. For nu, benyt <externalLink>bestil-nu.net</externalLink>.",
        "company-nav-item-accounting": "\n .title = Regnskab",
        "company-nav-item-pos": "POS",
        "company-nav-item-meeting-service": "Mødeforplejning",
        "company-nav-item-subscriptions": "Abonnementer",
        "company-nav-item-organization": "\n .title = Organisation",
        "company-nav-item-users": "Brugere",
        "company-nav-item-admins":"Administratorer",
        "company-nav-item-user-groups": "Brugergrupper",
        "company-nav-item-departments": "Afdelinger",
        "company-nav-item-workgroups": "Arbejdsgrupper",
        "company-nav-item-locations": "Lokationer",
        "company-nav-item-bill-receivers": "Regningsmodtagere",
        "company-nav-item-account-dimensions": "Kontodimensioner",
        "company-nav-item-settings": "Indstillinger",
        "company-nav-item-account-title": "\n .title = Konto",
        "company-nav-item-account": "Konto",
        "company-nav-item-gdpr": "GDPR",
        "company-nav-item-data-import-title": "\n .title = Dataimport",
        "company-nav-item-data-import": "Dataimport",
        "company-nav-item-id-cards": "ID-kort",
        "company-nav-item-account-numbers": "Kontonumre",
        "company-nav-item-import-users": "Brugere",
        "company-nav-item-import-bill-receivers": "Regningsmodtagere",
        "company-nav-item-settings-title": "\n .title = Indstillinger",
        "company-nav-item-custom-jobs": "Tilpassede jobs",

        // Company > Admin > Organization > Departments
        "company-organization-title": "\n .title = Organisation",
        "company-organization-departments-title": "Afdelinger",
        "company-organization-departments-header": "\n .title = Afdelinger",
        "company-organization-departments-create-button": "Opret ny",
        "company-organization-departments-table-department-no-column": "Afdelingsnr.",
        "company-organization-departments-table-name-column": "Navn",
        "company-organization-departments-table-status-column": "Status",
        "company-organization-departments-table-active-column-active": "Aktiv",
        "company-organization-departments-table-active-column-inactive": "Inaktiv",
        "company-organization-departments-table-active-column-active-filter-yes": "Aktiv",
        "company-organization-departments-table-active-column-inactive-filter-no": "Inaktiv",
        "company-organization-departments-table-edit": "Rediger",
        "company-organization-departments-table-delete": "Slet",
        "company-organization-departments-table-delete-modal-title": "afdeling",
        "company-organization-departments-edit-title": "Rediger afdeling",
        "company-organization-departments-create-title": "Opret afdeling",
        "create-department-header": "\n .title = Opret afdeling",
        "edit-department-header": "\n .title = Rediger afdeling",
        "edit-department-save-button": "Gem",
        "create-department-save-button": "Opret",
        "create-or-edit-company-department-field-departmentNo": "\n .label = Department no.\n .placeholder = Enter department no.",
        "create-or-edit-company-department-field-name": "\n .label = Navn\n .placeholder = Indtast navn",
        "create-or-edit-company-department-field-is-required": "Feltet er påkrævet",
        "create-or-edit-company-department-field-active": "Aktiv",
        "create-or-edit-company-department-settings": "\n .title = Indstillinger",
        "create-or-edit-company-department-history": "\n .title = Historik",

        // Company > Admin > Organization > Workgroups
        "company-organization-workgroups-title": "Arbejdsgrupper",
        "company-organization-workgroups-header": "\n .title = Arbejdsgrupper",
        "company-organization-workgroups-create-button": "Opret ny",
        "company-organization-workgroups-table-name-column": "Navn",
        "company-organization-workgroups-table-calendar-column": "Kalender-e-mailadresse",
        "company-organization-workgroups-table-members-column": "Medlemmer",
        "company-organization-workgroups-table-status-column": "Status",
        "company-organization-workgroups-table-edit": "Rediger",
        "company-organization-workgroups-table-delete": "Slet",
        "company-organization-workgroups-table-delete-modal-title": "arbejdsgruppe",
        "company-organization-workgroups-edit-title": "Rediger arbejdsgruppe",
        "company-organization-workgroups-create-title": "Opret arbejdsgruppe",
        "create-workgroup-header": "\n .title = Opret arbejdsgruppe",
        "edit-workgroup-header": "\n .title = Rediger arbejdsgruppe",
        "edit-workgroup-save-button": "Gem",
        "create-workgroup-save-button": "Opret",
        "create-or-edit-company-workgroup-field-name": "\n .label = Navn\n .placeholder = Indtast navn",
        "create-or-edit-company-workgroup-field-description": "\n .label = Beskrivelse til brugere\n .placeholder = Indtast beskrivelse til brugere",
        "create-or-edit-company-workgroup-field-description-info": "\n .title = Vises for brugerne, når de vælger en arbejdsgruppe, så beskriv hvem gruppen er til.",
        "create-or-edit-company-workgroup-field-calendar-email": "\n .label = Kalender-e-mailadresse\n .placeholder = Indtast kalender-e-mailadresse",
        "create-or-edit-company-workgroup-field-calendar-email-info": "\n .title = Den delte postkasse eller kalenderadresse for denne arbejdsgruppe. Bookinger og mødeserviceordrer fra medlemmerne samles her, så medlemmerne kan se hinandens aftaler.",
        "create-or-edit-company-workgroup-field-is-required": "Feltet er påkrævet",
        "create-or-edit-company-workgroup-field-invalid-email": "Indtast en gyldig e-mailadresse",
        "create-or-edit-company-workgroup-field-name-max-length": "Navnet må højst være { $maxLength } tegn",
        "create-or-edit-company-workgroup-field-calendar-email-max-length": "Kalender-e-mailadressen må højst være { $maxLength } tegn",
        "create-or-edit-company-workgroup-field-description-max-length": "Beskrivelsen må højst være { $maxLength } tegn",
        "create-or-edit-company-workgroup-field-active": "Aktiv",
        "create-or-edit-company-workgroup-settings": "\n .title = Indstillinger",
        "create-or-edit-company-workgroup-history": "\n .title = Historik",
        "create-or-edit-company-workgroup-members": "\n .title = Medlemmer",
        "create-or-edit-company-workgroup-members-empty": "\n .title = Ingen medlemmer endnu\n .description = Tilføj de personer, der skal dele postkassen og kunne se hinandens bookinger og bestillinger af mødeforplejning.",
        "create-or-edit-company-workgroup-members-remove": "Fjern fra gruppen",
        "create-or-edit-company-workgroup-members-add-field": "\n .label = Tilføj medlem\n .placeholder = Søg på navn, mindst 3 tegn",
        "create-or-edit-company-workgroup-members-table-header-user-id": "Bruger-id",
        "create-or-edit-company-workgroup-members-table-header-name": "Navn",
        "create-or-edit-company-workgroup-members-table-header-email": "E-mail",
        "create-or-edit-company-workgroup-members-table-header-status": "Status",
        "create-or-edit-company-workgroup-members-department-filter-label": "Afdeling",
        "create-or-edit-company-workgroup-members-department-filter": "\n .label = Afdeling",
        "create-or-edit-company-workgroup-members-department-filter-all": "Alle afdelinger",
        "create-or-edit-company-workgroup-members-department-filter-none": "Ingen afdeling",
        "create-or-edit-company-workgroup-members-details-button": "Detaljer",
        "create-or-edit-company-workgroup-members-removed": "{ $count ->\n [one] { $count } medlem fjernet fra gruppen\n *[other] { $count } medlemmer fjernet fra gruppen\n}",
        "create-or-edit-company-workgroup-members-undo-button": "Fortryd",
        "create-or-edit-company-workgroup-members-bulk-remove": "\n .title = Fjern fra gruppen",
        "create-or-edit-company-workgroup-members-remove-dialog-title": "{ $count ->\n [one] Fjern { $count } medlem fra gruppen?\n *[other] Fjern { $count } medlemmer fra gruppen?\n}",
        "create-or-edit-company-workgroup-members-remove-dialog-message": "{ $names }{ $hidden ->\n [0] {\"\"}\n [one] {\" \"}og { $hidden } anden\n *[other] {\" \"}og { $hidden } andre\n} fjernes fra { $workgroup } og kan ikke længere se gruppens aftaler. Brugerne bliver ikke slettet.",
        "create-or-edit-company-workgroup-members-remove-dialog-message-unnamed": "{ $names }{ $hidden ->\n [0] {\"\"}\n [one] {\" \"}og { $hidden } anden\n *[other] {\" \"}og { $hidden } andre\n} fjernes fra denne gruppe og kan ikke længere se gruppens aftaler. Brugerne bliver ikke slettet.",
        "create-or-edit-company-workgroup-members-remove-dialog": "\n .buttonLabelSubmit = { $count ->\n [one] Fjern { $count } medlem\n *[other] Fjern { $count } medlemmer\n }\n .buttonLabelCancel = Annuller",
        "company-user-workgroups-panel": "\n .title = Arbejdsgrupper",
        "company-user-workgroups-panel-empty": "Denne bruger er endnu ikke medlem af nogen arbejdsgrupper.",
        "company-user-workgroups-panel-add-button": "Tilføj",
        "company-user-workgroups-panel-remove": "Fjern",
        "company-user-workgroups-panel-add-dialog-title": "Tilføj til arbejdsgruppe",
        "company-user-workgroups-panel-add-dialog-empty": "Der er ikke flere arbejdsgrupper at tilføje.",

        // Company Admin Organization > Users (create/edit form)
        "company-user-create-page-title": "\n .title = Opret bruger",
        "company-user-edit-page-title": "\n .title = Rediger bruger",
        "company-user-create-submit": "Opret",
        "company-user-edit-submit": "Gem",
        "company-user-create-breadcrumb": "Opret bruger",
        "company-user-edit-breadcrumb": "Rediger bruger",
        "company-user-tab-details": "Brugerdetaljer",
        "company-user-tab-workgroups": "Arbejdsgrupper",
        "company-user-tab-approvals": "Brugergodkendelser",
        "company-user-tab-catalog": "Kantineadgang",
        "company-user-tab-guest-checkin": "Gæste-check-in",
        "company-user-workgroups-tab-description":
            "Vælg en eller flere arbejdsgrupper for brugeren. I en arbejdsgruppe kan medlemmerne arbejde sammen — for eksempel se hinandens bookinger og mødeserviceordrer via en delt kalender.",
        "company-user-workgroups-calendar-email-label": "Kalender-e-mail:",
        "company-user-workgroups-empty": "Ingen arbejdsgrupper tilgængelige.",
        "company-user-sync-warning":
            "Denne bruger holdes i katalogsynkronisering — navn, e-mail og afdeling kan blive overskrevet ved næste synkronisering. Deaktiver brugersynkronisering for at redigere dem permanent.",
        "company-user-field-user-group": "Brugergruppe",
        "company-user-field-user-group-placeholder": "Vælg brugergruppe...",
        "company-user-field-department": "Afdeling",
        "company-user-field-department-placeholder": "Vælg afdeling...",
        "company-user-field-employee-id": "Medarbejder-id",
        "company-user-field-employee-id-placeholder": "f.eks. 10062",
        "company-user-field-name": "Navn",
        "company-user-field-name-placeholder": "Fulde navn",
        "company-user-field-initials": "Initialer",
        "company-user-field-initials-placeholder": "Udfyldes automatisk fra navn",
        "company-user-field-username": "Brugernavn",
        "company-user-field-username-placeholder": "Genereres automatisk hvis tom",
        "company-user-field-email": "E-mail",
        "company-user-field-email-placeholder": "navn@firma.dk",
        "company-user-field-mobile": "Mobil",
        "company-user-field-mobile-placeholder": "12 34 56 78",
        "company-user-field-phone": "Telefonnr.",
        "company-user-field-phone-placeholder": "12 34 56 78",
        "company-user-field-language": "Sprog",
        "company-user-field-select-placeholder": "Ikke valgt",
        "company-user-language-option-danish": "Dansk",
        "company-user-language-option-english": "Engelsk",
        "company-user-approvals-description": "Vælg de brugergrupper, som denne bruger godkender, når medlemmerne selv tilmelder sig.",
        "company-user-approvals-heading": "Godkend brugergrupper",
        "company-user-catalog-description": "En bruger kan få adgang til en eller flere kantiner; udvid en kantine for at vælge dens prislister.",
        "company-user-catalog-heading": "Delegerede kantiner / prislister",
        "company-user-catalog-summary-empty": "Ingen kantiner / prislister valgt",
        "company-user-catalog-summary-counts": "{ $count } prislister på tværs af { $canteens } kantiner",
        "company-user-catalog-search-placeholder": "Søg kantiner...",
        "company-user-catalog-empty": "Ingen kantiner fundet.",
        "company-user-guest-checkin-description": "Vælg om denne bruger notificeres, når en gæst tjekker ind.",
        "company-user-guest-checkin-toggle": "Notificer ved gæste-check-in",
        "company-user-details-account-user-id": "Bruger-id",
        "company-user-details-account-username": "Brugernavn",
        "company-user-details-account-employee-id": "Medarbejder-id",
        "company-user-details-account-user-group": "Brugergruppe",
        "company-user-details-account-department": "Afdeling",
        "company-user-details-account-phone": "Telefon",
        "company-user-details-account-language": "Sprog",
        "company-user-details-section-idcard": "ID-kort",
        "company-user-details-idcard-empty": "Intet ID-kort tilknyttet.",
        "company-user-details-last-signin": "Seneste login",
        "company-user-details-never": "Aldrig",
        "company-user-details-section-tracking": "Sporing",
        "company-user-details-sync-status": "Brugersynkronisering",
        "company-user-details-sync-source": "Synkroniseringskilde",
        "company-user-details-sync-last-synced": "Senest synkroniseret",
        "company-user-details-sync-none": "Ikke synkroniseret",
        "company-user-details-section-roles": "Roller",
        "company-user-details-roles-empty": "Ingen roller tildelt.",
        "company-user-details-role-secretary": "Sekretær",
        "company-user-details-edit-button": "Rediger bruger",
        "company-user-details-impersonate-button": "Log ind som",
        "company-user-details-error-title": "Kunne ikke indlæse brugeren",
        "company-user-details-error-message": "Noget gik galt under indlæsning af denne bruger. Prøv igen.",
        "company-user-settings-panel-title": "\n .title = Indstillinger",
        "company-user-settings-active": "Aktiv",
        "company-user-settings-send-invitation": "Send e-mailinvitation",
        "company-user-settings-send-invitation-helper": "Brugeren modtager et login-link via e-mail.",
        "company-user-settings-disable-sync": "Deaktiver brugersynkronisering",
        "company-user-settings-disable-sync-helper": "Når deaktiveret, ignoreres denne bruger af brugersynkroniseringsjobbet.",
        "company-user-settings-secretary": "Sekretær",
        "company-user-settings-secretary-helper": "Får adgang til sekretærværktøjer til at booke og administrere ordrer på vegne af andre brugere.",
        "company-user-validation-required": "Dette felt er påkrævet",
        "company-user-validation-invalid-email": "Indtast en gyldig e-mailadresse",
        "company-user-validation-invalid-phone": "Indtast et gyldigt telefonnummer",

        // Company Admin Organization > Users (list & bulk actions)
        "company-users-status-filter-all": "Alle",
        "company-users-status-filter-active": "Aktive",
        "company-users-status-filter-inactive": "Inaktive",
        "company-users-status-active": "Aktiv",
        "company-users-status-inactive": "Inaktiv",
        "company-users-cell-internal-id": "Internt id: { $id }",
        "company-users-cell-sync-badge": "Sync",
        "company-users-cell-rights": "{ $count -> \n *[other] { $count } rettigheder \n [one] { $count } rettighed \n }",
        "company-users-delete-entity": "bruger",
        "company-users-bulk-status": "\n .title = Status",
        "company-users-bulk-set-active": "\n .title = Aktiv",
        "company-users-bulk-set-inactive": "\n .title = Inaktiv",
        "company-users-bulk-resend-invite": "\n .title = Send invitation igen",
        "company-users-bulk-move-group": "\n .title = Flyt til gruppe",
        "company-users-bulk-export": "\n .title = Eksportér",
        "company-users-bulk-success": "{ $count } brugere opdateret",
        "company-users-export-header-name": "Navn",
        "company-users-export-header-first-name": "Fornavn",
        "company-users-export-header-last-name": "Efternavn",
        "company-users-export-header-username": "Brugernavn",
        "company-users-export-header-email": "E-mail",
        "company-users-export-header-mobile": "Mobil",
        "company-users-export-header-phone": "Telefon",
        "company-users-export-header-employee-id": "Medarbejder-id",
        "company-users-export-header-user-group": "Brugergruppe",
        "company-users-export-header-department": "Afdeling",
        "company-users-export-header-language": "Sprog",
        "company-users-export-header-roles": "Roller",
        "company-users-export-header-user-sync": "Brugersynkronisering",
        "company-users-export-header-last-signin": "Seneste login",
        "company-users-export-header-status": "Status",

        // Company Admin Organization > User Groups
        "company-organization-user-groups-title": "Brugergrupper",
        "company-organization-user-groups-header": "\n .title = Brugergrupper",
        "company-organization-user-groups-create-button": "Opret ny",
        "company-organization-user-groups-table-name-column": "Navn",
        "company-organization-user-groups-table-domain-column": "Domæne",
        "company-organization-user-groups-table-status-column": "Status",
        "company-organization-user-groups-table-active-column-active": "Aktiv",
        "company-organization-user-groups-table-active-column-inactive": "Inaktiv",
        "company-organization-user-groups-table-active-column-active-filter-yes": "Aktiv",
        "company-organization-user-groups-table-active-column-inactive-filter-no": "Inaktiv",
        "company-organization-user-groups-table-edit": "Rediger",
        "company-organization-user-groups-table-delete": "Slet",
        "company-organization-user-groups-table-delete-modal-title": "\n .typeOfEntity = brugergruppe",
        "company-organization-user-group-edit-title": "Rediger brugergruppe",
        "company-organization-user-group-create-title": "Opret brugergruppe",
        "create-user-group-header": "\n .title = Opret brugergruppe",
        "edit-user-group-header": "\n .title = Rediger brugergruppe",
        "edit-user-group-save-button": "Gem",
        "create-user-group-save-button": "Opret",
        "create-or-edit-company-user-group-field-name": "\n .label = Navn\n .placeholder = Indtast navn",
        "create-or-edit-company-user-group-field-active": "Aktiv",
        "create-or-edit-company-user-group-settings": "\n .title = Indstillinger",
        "create-or-edit-company-user-group-history": "\n .title = Historik",
        "create-or-edit-company-user-group-connected-domains": "Tilknyttede domæner",
        "create-or-edit-company-user-group-connected-domains-empty": "Du har ikke oprettet nogen domæner endnu.",
        "create-or-edit-company-user-group-connected-domains-add-button": "\n .title = Tilføj domæne",
        "create-or-edit-company-user-group-connected-domains-table-domain": "Domæne",
        "create-or-edit-company-user-group-connected-domains-table-status": "Status",
        "create-or-edit-company-user-group-connected-domains-table-status-active": "Aktiv",
        "create-or-edit-company-user-group-connected-domains-table-status-pending": "Afventer / Invitation sendt",
        "create-or-edit-company-user-group-connected-domains-table-resend-invitation": "Send invitation igen",
        "create-or-edit-company-user-group-connected-domains-table-delete": "Slet",
        "company-organization-user-groups-table-delete-modal-domain": "\n .typeOfEntity = domæne",
        "create-or-edit-company-user-group-connected-domains-modal-add-domain": "Tilføj domæne",
        "create-or-edit-company-user-group-connected-domains-modal-resend-invitation": "Send invitation igen for domæne",
        "create-or-edit-company-user-group-connected-domains-modal-field-domain": "\n .label = Domæne\n .placeholder = Indtast domæne",
        "create-or-edit-company-user-group-connected-domains-modal-field-username": "\n .label = Brugernavn\n .placeholder = Indtast brugernavn",
        "create-or-edit-company-user-group-connected-domains-modal-send-invitation": "Send invitation",
        "create-or-edit-company-user-group-connected-bill-receiver": "Fakturamodtager",
        "create-or-edit-company-user-group-connected-bill-receiver-empty": "Du har ikke oprettet en fakturamodtager endnu.",
        "create-or-edit-company-user-group-connected-bill-receiver-add-button": "\n .title = Tilføj fakturamodtager",
        "create-or-edit-company-user-group-connected-bill-receiver-table-name": "Navn",
        "create-or-edit-company-user-group-connected-bill-receiver-table-address": "Adresse",
        "create-or-edit-company-user-group-connected-bill-receiver-table-end-point": "Slutpunkt",
        "create-or-edit-company-user-group-connected-bill-receiver-table-remove": "Fjern",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-add-bill-receiver": "\n .title = Tilføj fakturamodtager",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-update-bill-receiver": "\n .title = Fandt lignende fakturamodtagere. Er du sikker på, at du vil oprette en ny?",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-field-search": "\n .label = Søg\n .placeholder = Søg efter navn, CVR, EAN, e-mail eller adresse",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-info-text": "Begynd at skrive for at vise søgeresultater",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-info-warning": "Du bør kun oprette en ny fakturamodtager med samme identifikator (CVR, EAN, e-mail), hvis kontaktoplysningerne afviger. For eksempel kan dette være nødvendigt, hvis fakturaen skal sendes til en anden person.",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-empty": "Ingen søgeresultater fundet",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-cvr": "CVR:",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-ean": "EAN:",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-email": "Email:",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-address": "Adresse:",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-or": "Eller",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-submit-button": "Vælg valgt fakturamodtager",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-submit-update-button": "Opdater valgt fakturamodtager",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-create-button": "Create new bill receiver",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-bill-found": "{ $count } fakturamodtager(e) findes allerede med samme identifikator.",

        // Company > Admin > Account > GDPR
        "company-account-gdpr-title":"\n .title = GDPR",

        // Company > Admin > Data import
        "data-import-csv-field-update-key": "\n .label = Opdateringsnøgle",
        "data-import-csv-settings": "\n .title = Indstillinger",
        "data-import-csv-field-update-identical": "Opdater identiske",
        "data-import-csv-field-delete-existing": "Slet eksisterende",

        // Company > Admin > Data import > ID cards
        "company-data-import-id-cards-title": "\n .title = Importér ID-kort",
        "create-or-edit-company-id-cards-field-user-group": "\n .label = Brugergruppe",
        "create-or-edit-company-id-cards-select-item-all": "Alle",
        "create-or-edit-company-id-cards-update-key-mode-initials": "Initialer",
        "create-or-edit-company-id-cards-update-key-mode-email": "Email",
        "create-or-edit-company-id-cards-update-key-mode-employee-number": "Medarbejdernummer",


        // Company > Admin > Data import > Account number
        "company-data-import-account-numbers-title": "\n .title = Importér kontonumre",
        "create-or-edit-company-account-numbers-field-accounting-dimension": "\n .label = Regnskabsdimension",
        "create-or-edit-company-account-numbers-select-item-all": "Alle",
        "create-or-edit-company-account-numbers-update-key-mode-account-number": "Kontonummer",
        "create-or-edit-company-account-numbers-update-key-mode-account-name": "Kontonavn",

        // Company > Admin > Data import > Users
        "company-data-import-users-title": "\n .title = Importér brugere",
        "company-data-import-users-field-user-group": "\n .label = Brugergruppe",
        "company-data-import-users-select-item-from-file": "Fra fil",

        // Company > Admin > Data import > Bill receivers
        "company-data-import-bill-receivers-title": "\n .title = Importér regningsmodtagere",
        "company-data-import-bill-receivers-receiver-type": "\n .label = Modtagertype",
        "company-data-import-bill-receivers-receiver-type-mode-private-person": "Privatperson / forening",
        "company-data-import-bill-receivers-receiver-type-mode-public-institution": "Offentlig institution",
        "company-data-import-bill-receivers-receiver-type-mode-private-company": "Privat virksomhed",
        "company-data-import-bill-receivers-receiver-type-mode-from-file": "Fra fil",

        // Company > Admin > Settings > Custom jobs
        "company-admin-settings-custom-jobs-title":" \n .title = Tilpassede jobs",
        "company-admin-settings-custom-jobs-table-name":"Navn",
        "company-admin-settings-custom-jobs-table-interval":"Interval",
        "company-admin-settings-custom-jobs-table-last-run":"Sidste kørsel",
        "company-admin-settings-custom-jobs-table-status":"Status",
        "company-admin-settings-custom-jobs-table-action-details":"Detaljer",
        "company-admin-settings-custom-jobs-table-action-run-job":"Kør job",
        "company-admin-settings-custom-jobs-table-action-activate":"Aktiver",
        "company-admin-settings-custom-jobs-table-action-inactivate":"Deaktiver",

        // Import result
        "import-result-title": "\n .title = Importresultat",
        "import-result-breadcrumb": "Resultat",
        "import-result-succeeded": "Import lykkedes",
        "import-result-results": "Resultater:",
        "import-result-created": "Oprettet:",
        "import-result-updated": "Ændret:",
        "import-result-deleted": "Slettet:",

        // Company Meeting Service
        "company-meeting-service-title": "Mødeforplejning",
        "company-meeting-service-header": "\n .title = Mødeforplejning",
        "company-meeting-service-table-booked-start-date": "Bogført fra",
        "company-meeting-service-table-booked-end-date": "Bogført til",
        "company-meeting-service-table-merchant": "Salgssted",
        "company-meeting-service-table-order-id-column": "Ordre ID",
        "company-meeting-service-table-booked-date-column": "Bogføringsdato",
        "company-meeting-service-table-delivery-time-column": "Leveringstid",
        "company-meeting-service-table-employee-column": "Medarbejder",
        "company-meeting-service-table-amount-column": "Beløb (DKK)",
        "company-meeting-service-table-show-receipt": "Vis kvittering",
        "company-meeting-service-table-floating-action-bar-receipts": "\n .title = Kvitteringer",
        "company-meeting-service-table-floating-action-bar-export": "\n .title = Eksport",

        // Company Subscriptions
        "company-subscriptions-title": "Abonnementer",
        "company-subscriptions-header": "\n .title = Abonnementer",
        "company-subscriptions-table-subscription-column": "Abonnement",
        "company-subscriptions-table-order-id-column": "Ordre ID",
        "company-subscriptions-table-employee-column": "Medarbejder",
        "company-subscriptions-table-subscribed-column": "Tilmeldt",
        "company-subscriptions-table-unsubscribed-column": "Frameldt",
        "company-subscriptions-table-payment-column": "Betaling",
        "company-subscriptions-table-amount-column": "Beløb",
        "company-subscriptions-table-cancel-subscription": "Opsig abonnement",
        "company-subscriptions-table-details": "Detaljer",

        // Accounting - POS Purchases
        "accounting-pos-table-header-title": "\n .title = POS",
        "accounting-pos-table-header-nav-item-home": "Hjem",
        "accounting-pos-table-header-nav-item-accounting": "Regnskab",
        "accounting-pos-table-header-nav-item-pos": "POS",
        "accounting-pos-table-header-order-id": "Ordre ID",
        "accounting-pos-table-header-transaction-time": "Transaktionstid",
        "accounting-pos-table-header-employee": "Medarbejder",
        "accounting-pos-table-header-payment": "Betaling",
        "accounting-pos-table-header-amount": "Beløb (DKK)",
        "support-entity-table-button-show-receipt": "Vis kvittering",
        "accounting-pos-table-header-merchant-label":"\n .label = Salgssted",
        "accounting-pos-table-footer-total-in-period":"Total i denne periode (DKK)",

                // Organization - Users
        "company-organization-users-page-header": "\n .title = Brugere",
        "company-organization-users-table-header-user-group":"Brugergruppe",
        "company-organization-users-table-header-name":"Navn",
        "company-organization-users-table-header-employee-id":"Medarbejder-id",
        "company-organization-users-table-header-email":"Email",
        "company-organization-users-table-header-status":"Status",
        "company-organization-users-table-status-active":"Aktiv",
        "company-organization-users-table-status-inactive": "Inaktiv",
        "company-organization-users-table-button-details": "Detaljer",
        "company-organization-users-table-button-edit": "Rediger",
        "company-organization-users-table-button-delete": "Slet",
        "company-organization-users-table-button-impersonate": "Log ind som",
        "company-organization-users-button-create": "Opret ny",
        "company-organization-users-tooltip-export": "\n .title = Eksport",
        "company-admin-nav-item-organization": "Organisation",
        "company-admin-nav-item-users": "Brugere",
        "company-organization-users-table-header-select-label-user-group": "Brugergruppe",
        "company-organization-users-table-header-select-user-group-field": "\n .label = Brugergruppe",
        "company-organization-users-table-header-select-label-workgroup": "Arbejdsgruppe",
        "company-organization-users-table-header-select-workgroup-field": "\n .label = Arbejdsgruppe",
        "company-organization-users-table-header-select-item-all": "Alle",


        // Organization - Admins
        "company-organization-admins-page-header": "\n .title = Administratorer",
        "company-organization-admins-table-header-name":"Navn",
        "company-organization-admins-table-header-email":"Email",
        "company-organization-admins-table-header-status":"Status",
        "company-organization-admins-table-status-active":"Aktiv",
        "company-organization-admins-table-status-inactive": "Inaktiv",
        "company-organization-admins-table-button-details": "Vis detaljer",
        "company-organization-admins-table-button-edit": "Ret bruger",
        "company-organization-admins-table-button-delete": "Slet bruger",
        "company-organization-admins-table-button-impersonate": "Log ind som",
        "merchant-admin-users-table-button-impersonate": "Log ind som",
        "supplier-admin-account-admins-table-button-impersonate": "Log ind som",
        "service-center-admin-account-admins-table-button-impersonate": "Log ind som",
        "supplier-admin-merchant-admins-table-button-impersonate": "Log ind som",
        "office-manager-admins-table-button-impersonate": "Log ind som",
        "company-organization-admins-button-create": "Opret ny",
        "company-admin-nav-item-admins": "Administratorer",
        "impersonation-confirm-dialog":
            "\n .title = Log ind som { $name }?\n .buttonLabelSubmit = Log ind som { $firstName }\n .buttonLabelCancel = Annuller",
        "impersonation-confirm-dialog-message":
            "Du ser portalen præcis, som { $firstName } ser den. Alt, hvad du gør, registreres i { $firstName }s historik under dit eget navn.",

        // Company Admin Organization Locations
        "company-organization-locations-title": "Lokationer",
        "company-organization-locations-header": "\n .title = Lokationer",
        "company-organization-locations-create-button": "Opret ny",
        "company-organization-locations-table-name-column": "Navn",
        "company-organization-locations-table-status-column": "Status",
        "company-organization-locations-table-active-column-active": "Aktiv",
        "company-organization-locations-table-active-column-inactive": "Inaktiv",
        "company-organization-locations-table-active-column-active-filter-yes": "Aktiv",
        "company-organization-locations-table-active-column-inactive-filter-no": "Inaktiv",
        "company-organization-locations-table-edit": "Rediger",
        "company-organization-locations-table-delete": "Slet",
        "company-organization-locations-table-delete-modal-title": "lokation",
        "company-organization-locations-edit-title": "Rediger lokation",
        "company-organization-locations-create-title": "Opret lokation",
        "create-location-header": "\n .title = Opret lokation",
        "edit-location-header": "\n .title = Rediger lokation",
        "edit-location-save-button": "Gem",
        "create-location-save-button": "Opret",
        "create-or-edit-company-location-field-name": "\n .label = Navn\n .placeholder = Indtast navn",
        "create-or-edit-company-location-field-is-required": "Feltet er påkrævet",
        "create-or-edit-company-location-field-active": "Aktiv",
        "create-or-edit-company-location-settings": "\n .title = Indstillinger",
        "create-or-edit-company-location-history": "\n .title = Historik",
        "create-or-edit-company-location-field-street": "\n .label = Gade\n .placeholder = Indtast gade",
        "create-or-edit-company-location-field-streetNumber": "\n .label = Street no\n .placeholder = Enter street no",
        "create-or-edit-company-location-field-postalCode": "\n .label = Postal code\n .placeholder = Enter postal code",
        "create-or-edit-company-location-field-city": "\n .label = By\n .placeholder = Indtast by",
        "create-or-edit-company-location-field-country": "\n .label = Land",
        "create-or-edit-company-location-field-country-denmark-item": "Danmark",
        "create-or-edit-company-location-field-shops": "\n .label = Tilknyttede butikker",

        // Accounting - Bill receivers
        "company-accounting-bill-receivers-table-header-title": "\n .title = Regningsmodtagere",
        "company-accounting-bill-receivers-table-header-name":"Navn",
        "company-accounting-bill-receivers-table-header-endpoint":"Endepunkt",
        "company-accounting-bill-receivers-table-header-debitor-id":"Debitor-id",
        "company-accounting-bill-receivers-table-header-status":"Status",
        "company-accounting-bill-receivers-table-status-active":"Aktiv",
        "company-accounting-bill-receivers-table-status-inactive": "Inaktiv",
        "company-accounting-bill-receivers-table-button-edit": "Rediger",
        "company-accounting-bill-receivers-table-button-delete": "Slet",
        "company-accounting-bill-receivers-button-create": "Opret ny",
        "company-accounting-bill-receivers-table-header-nav-item-home": "Hjem",
        "company-accounting-bill-receivers-table-header-nav-item-accounting": "Regnskab",
        "company-accounting-bill-receivers-table-header-nav-item-bill-receivers": "Regningsmodtagere",

        // Accounting - Bill receivers - Create Dialog
        "bill-receivers-create-dialog-title": "Opret fakturamodtager",
        "bill-receivers-create-dialog-customer-type": "Kundetype:",
        "bill-receivers-create-dialog-select-bill-receiver": "Vælg eksisterende fakturamodtager:",
        "bill-receivers-create-dialog-country": "Land:",
        "bill-receivers-create-dialog-button-create": "Opret",
        "bill-receivers-create-dialog-button-save": "Gem",
        "bill-receivers-form-error-label-country":"Land",
        "bill-receivers-form-error-label-debtor-number":"Debitornummer",
        "bill-receivers-form-error-label-address-line-1":"Adresselinje 1",
        "bill-receivers-form-error-label-address-line-2":"Adresselinje 2",
        "bill-receivers-form-error-label-postal-code":"Postnummer",
        "bill-receivers-form-error-label-city":"By",
        "bill-receivers-form-error-label-telephone":"Telefon",
        "bill-receivers-form-error-label-name":"Navn",
        "bill-receivers-form-error-label-institution-name":"Institutionsnavn",
        "bill-receivers-form-error-label-email":"E-mail",
        "bill-receivers-form-error-label-contact-person":"Kontaktperson",
        "bill-receivers-form-error-label-company-name":"Firmanavn",
        "bill-receivers-validation-ean-13-digits": "EAN-nummer skal være 13 cifre",
        "bill-receivers-validation-cvr-8-digits": "CVR-nummer skal være 8 cifre",
        "bill-receivers-validation-postal-code-4-digits": "Postnummer skal være 4 cifre",
        "bill-receivers-validation-email-invalid": "Indtast venligst en gyldig e-mailadresse",
        "bill-receivers-validation-telephone-invalid": "Telefon må kun indeholde cifre samt tegnene + - ( ) og mellemrum",
        "bill-receivers-validation-max-length": "{ $label } må højst være { $max } tegn",
        "bill-receivers-select-type":"Vælg type:",
        "bill-receivers-select-label":"Vælg modtager:",
        "bill-receivers-select-list-label": "Vælg fakturamodtager",
        "bill-receivers-select-private-person":"Privatperson / forening",
        "bill-receivers-select-email":"E-mail",
        "bill-receivers-select-public-institution":"Offentlig institution",
        "bill-receivers-select-ean-number":"EAN-nummer",
        "bill-receivers-select-private-company":"Privat virksomhed",
        "bill-receivers-select-cvr-number":"CVR-nummer",
        "bill-receivers-company-number":"Indtast CVR-nummer:",
        "bill-receivers-input-search-label-number-cvr":"\n .label = CVR-nummer",
        "bill-receivers-button-continue":"Fortsæt",
        "bill-receivers-send-invoice":"Send faktura til:",
        "bill-receivers-select-label-input-type":"Type",
        "bill-receivers-dropdown-type":"\n .label = Type",
        "bill-receivers-select-item-email":"E-mail",
        "bill-receivers-select-item-ean-number":"EAN-nummer",
        "bill-receivers-form-label-address-1":"\n .label = Adresselinje 1\n .placeholder = Vejnavn og husnummer",
        "bill-receivers-form-label-address-2":"\n .label = Adresselinje 2\n .placeholder = Etage, lejlighed nr., osv.",
        "bill-receivers-form-label-postal-code":"\n .label = Postnummer",
        "bill-receivers-form-label-city":"\n .label = By",
        "bill-receivers-form-label-country":"\n .label = Land",
        "bill-receivers-form-country-select-da": "Danmark",
        "bill-receivers-form-contact-person":"Kontaktperson",
        "bill-receivers-form-label-contact-person":"\n .label = Kontaktperson",
        "bill-receivers-form-label-email":"\n .label = E-mail",
        "bill-receivers-form-label-telephone":"\n .label = Telefon",
        "bill-receivers-form-label-name":"\n .label = Navn",
        "bill-receivers-form-label-institution-name":"\n .label = Institutionsnavn",
        "bill-receivers-form-label-debtor-number":"\n .label = Debitornummer\n .placeholder = Identifikator for debitor i dit regnskabssystem",
        "bill-receivers-form-label-company-name":"\n .label = Firmanavn",
        "bill-receivers-form-label-company-number":"\n .label = CVR-nummer",
        "bill-receivers-input-search-label-email":"\n .label = E-mail",
        "bill-receivers-input-search-label-ean-number":"\n .label = EAN-nummer",

        // --- Service center --
        "service-center-home-coming-soon-placeholder": "\n .title = Kommer snart\n .body = Vi arbejder på at levere den nye service center portal til dig. Benyt venligst https://bestil-nu.net for nu.",

        // Navigation
        "service-center-nav-item-home": "Hjem",

        // Navigation > Admin
        "service-center-admin-nav-item-organization-page-header": "\n .title = Organisation",
        "service-center-admin-nav-item-organization": "Organisation",
        "service-center-admin-nav-item-organization-resources": "Ressourcer",
        "service-center-admin-nav-item-organization-devices": "Hardware enheder",
        "service-center-admin-nav-item-organization-devices-create": "Opret enheder",
        "service-center-admin-nav-item-organization-devices-edit": "Rediger enheder",
        "service-center-admin-nav-item-organization-manage-bookings": "Administrer bookinger for bruger",
        "service-center-admin-nav-item-account-page-header": "\n .title = Konto",
        "service-center-admin-nav-item-reports-page-header": "\n .title = Rapporter",
        "service-center-admin-nav-item-statistics": "Statistik",
        "service-center-admin-home-reports-statistics-card": "\n .title = Statistik \n .description = Se forbrug, belægning og gæstestatistik for dit servicecenter.",
        "service-center-admin-nav-item-account-administrators": "Administratorer",
        "service-center-admin-nav-item-organization-resource-crate-room": "Opret lokale",
        "service-center-admin-nav-item-organization-resource-update-room": "Opdater lokale",
        "service-center-admin-nav-item-organization-resource-crate-car": "Opret bil",
        "service-center-admin-nav-item-organization-resource-update-car": "Opdater bil",
        "service-center-admin-nav-item-organization-resource-crate-mobile-av": "Opret Mobile AV",
        "service-center-admin-nav-item-organization-resource-update-mobile-av": "Opdater Mobile AV",
        "service-center-admin-nav-item-communication": "Kommunikation",
        "service-center-admin-nav-item-communication-page-header": "\n .title = Kommunikation",
        "service-center-admin-nav-item-communication-messages": "Beskeder",
        "service-center-admin-nav-item-communication-reminders": "Påmindelser",
        "service-center-nav-item-messages": "Beskeder",
        "service-center-messages-list-header": "\n .title = Beskeder",
        "service-center-reminders-page-header": "\n .title = Påmindelser",
        "service-center-reminders-create-button": "Opret ny",
        "service-center-reminders-table-confirmation-content": "Bekræftelse af booking",

        // Service center > Admin > Home >
        "service-center-admin-home-organization-resources-card": "\n .title = Ressourcer \n .description = Opret og administrer de ressourcer, der kan bookes i dit servicecenter.",
        "service-center-admin-home-organization-devices-card": "\n .title = Enheder \n .description = Administrer dine hardwareenheder såsom lokaledisplays og infoskærme.",
        "service-center-admin-home-organization-manage-bookings-card": "\n .title = Administrer ordrer \n .description = Administrer ordrer ejet af en bruger. \n .buttonText = Administrer",
        "service-center-admin-home-account-administrators-card": "\n .title = Administratorer \n .description = Administrer administratorerne for din forhandler.",
        "service-center-admin-home-communication-messages-card": "\n .title = Push-beskeder \n .description = Send og administrer push-beskeder.",
        "service-center-admin-home-communication-reminders-card": "\n .title = Påmindelser \n .description = Administrer påmindelser, der deles på tværs af ressourcer.",

        // --- User --

        // Navigation
        "user-nav-item-home": "Hjem",
        "user-nav-item-archive-title": "\n .title = Arkiv" ,
        "user-nav-item-archive": "Arkiv",
        "user-nav-item-settings": "Indstillinger",
        "user-nav-item-wallets-title": "\n .title = Wallets" ,
        "user-nav-item-wallets": "Wallets",
        "user-nav-item-wallets-refill": "Tank-op",
        "user-nav-item-home-label": "\n .title = Gå til hjem-dashboard" ,
        "user-nav-item-calendar-label": "\n .title = Vis kalender med ordrer" ,
        "user-nav-item-archive-label": "\n .title = Vis arkiverede ordrer" ,
        "user-nav-item-settings-label": "\n .title = Indstillinger",
        "user-nav-bottom-bar-home-label": "Hjem",
        "user-nav-bottom-bar-calendar-label": "Kalender",
        "user-nav-bottom-bar-archive-label": "Arkiv",
        "user-nav-bottom-bar-settings-label": "Indstillinger",


        // User > Home > Top bar
        "user-home-top-bar-tab-switcher-overview": "Oversigt",
        "user-home-top-bar-tab-switcher-upcoming": "Kommende",

        // User > Home > Top bar > News drawer
        "user-home-top-bar-news-title": "\n .title = Facilitynet nyheder",
        "user-home-top-bar-news-no-notifications": "\n .title = Ingen beskeder lige nu\n .description = Her kan du læse beskeder fra salgsstedet og servicecentret.",
        "user-home-top-bar-news-notification-time-type-news": "Nyhed",
        "user-home-top-bar-news-notification-time-type-info": "Information",
        "user-home-top-bar-news-notification-time-type-important": "Vigtigt",
        "user-home-top-bar-news-notification-time-type-offer": "Tilbud",
        "user-home-top-bar-news-notification-time-type-event": "Arrangement",
        "user-home-top-bar-news-notification-time-type-reminder": "Påmindelse",
        "user-home-top-bar-news-notification-time-type-menu-change": "Menu",
        "user-home-top-bar-news-notification-time-type-feedback": "Feedback",
        "user-home-top-bar-news-notification-time-type-health": "Sundhed",
        "user-home-top-bar-news-notification-sender-type-merchant": "Salgssted",
        "user-home-top-bar-news-notification-sender-type-service-center": "Service",
        "user-home-top-bar-news-notification-menu-title": "Beskeder",


        // User > Home > Week menus
        "user-home-week-menu-title": "Ugens menu",
        "user-home-week-menu-no-menus-title": "Ingen menu tilgængelig",
        "user-home-week-menu-no-menus": "Desværre er der ikke blevet oprettet nogen menuer denne uge.",
        "user-home-week-menu-no-menus-today": "Ingen menu for denne dag",
        "user-home-top-bar-location-button-empty": "Vælg lokation",
        "user-home-week-menu-select-location-dialog-title": "Skift lokation",
        "user-home-week-menu-select-location-dialog-title-first-time": "Vælg lokation",
        "user-home-week-menu-select-location-search-filter": "\n .placeholder = Søg på navn, adresse, butiksnummer...",
        "user-home-week-menu-select-location-dialog-kitchen-item-button": "Vælg",
        "user-home-week-menu-dialog-title": "Dagens menu",
        "user-home-week-menu-dialog-allergens": "Allergener:",


        // User > Home >Dashboard
        "user-home-upcoming-orders": "Kommende ordrer",
        "user-home-reminders-check-out-title": "Tjek gæster ud ({ $count })",
        "user-home-reminders-check-out-button": "Tjek ud",
        "user-home-reminders-check-in-title": "Tjek ind i { $roomName } før { $deadline }",
        "user-home-reminders-check-in-button": "Tjek ind",
        "user-home-reminders-check-out-dialog": "\n .title = Tjek gæster ud\n .message = Vælg de gæster, der går.\n .buttonLabelSubmit = { $count ->\n [0] Tjek ud\n *[other] Tjek ud ({ $count })\n }\n .buttonLabelCancel = Annuller",
        "user-home-reminders-check-out-dialog-guests-title": "Gæster ({ $count })",
        "user-home-reminders-check-out-dialog-select-all-checkbox": "\n .label = Vælg alle",
        "user-home-reminders-check-out-dialog-guest-checked-in": "Tjekket ind { $time }",
        "user-home-reminders-check-out-dialog-success": "{ $count ->\n [one] Gæst tjekket ud\n *[other] { $count } gæster tjekket ud\n}",
        "user-home-reminders-check-in-dialog": "\n .title = Tjek ind i mødelokale\n .message = Bekræft, at dit møde er startet.\n .buttonLabelSubmit = Tjek ind\n .buttonLabelCancel = Annuller",
        "user-home-reminders-check-in-dialog-deadline-label": "Før",
        "user-home-reminders-check-in-dialog-note": "Hvis ingen tjekker ind før { $deadline }, frigives lokalet og bliver tilgængeligt for andre.",
        "user-home-reminders-check-in-dialog-success": "Du er tjekket ind",
        "user-home-canteen": "Kantine",
        "user-home-canteen-offers": "Tilbud",
        "user-home-canteen-today-menu": "Dagens menu",
        "user-home-canteen-today-menu-show-menu": " Vis menu skilt...",
        "user-home-canteen-news": "Nyheder",
        "user-home-upcoming-meetings": "Møder",
        "user-home-upcoming-meetings-modal-title": "\n    .title = Møder",
        "user-home-upcoming-takeaway-modal-title": "\n    .title = Takeaway",
        "user-home-upcoming-canteen-purchases-modal-title": "\n    .title = Kantinekøb",
        "user-home-upcoming-meetings-no-meetings": "Ingen møder i perioden\n    .title = Ingen møder i perioden",
        "user-home-meeting-day-today": "I dag",
        "user-home-meeting-day-tomorrow": "I morgen",
        "user-home-meeting-day-unknown": "Uden dato",
        "user-home-upcoming-meeting-min-left":
            "{ $hours ->\n    [0] { $minutes } min tilbage\n   *[other] { $minutes ->\n        [0] { $hours } t tilbage\n       *[other] { $hours } t { $minutes } min tilbage\n    }\n}",
        "user-home-upcoming-meeting-service-sub-title": "Mødeforplejning",
        "user-home-meetings-collapse": "Skjul møder",
        "user-home-meetings-expand": "Vis møder",
        "user-home-meetings-panel-actions": "\n .collapseAriaLabel = { user-home-meetings-collapse }\n .expandAriaLabel = { user-home-meetings-expand }",
        "user-home-panel-action-show-all": "\n    .title = Vis alle",
        "user-home-empty-offers-text": "Du har ingen tilbud lige nu",
        "user-home-upcoming-purchases": "Køb",
        "user-home-upcoming-purchases-load-error": "Kunne ikke indlæse køb",
        "user-home-wallet-my-wallet": "Min wallet",
        "user-home-wallets-section-title": "Wallets",
        "user-home-subscriptions-section-title": "Abonnementer",
        "user-home-subscription-card-used-count": "{ $used } af { $total }",
        "user-home-subscription-card-used-this-week": "brugt denne uge",
        "user-home-subscription-card-used-this-month": "brugt denne måned",
        "user-home-subscription-card-active-from": "Aktiv fra: { $date }",
        "user-home-subscription-card-expires": "Udløber: { $date }",
        "user-home-upcoming-purchase-card-title-lunch": "Frokostordre",
        "user-home-upcoming-purchase-card-title-take-away": "Takeaway",
        "user-home-upcoming-purchase-card-title-pos": "Frokostordre",
        "user-home-upcoming-purchase-card-title-lunch-subscription": "Frokostabonnement",
        "user-home-upcoming-purchases-no-purchases": "Ingen kommende køb",
        "user-home-upcoming-canteen-purchases": "Kantinekøb",
        "user-home-upcoming-canteen-purchases-no-purchases": "Ingen kantinekøb i perioden\n    .title = Ingen kantinekøb i perioden",
        "user-home-canteen-purchases-collapse": "Skjul kantinekøb",
        "user-home-canteen-purchases-expand": "Vis kantinekøb",
        "user-home-upcoming-takeaway": "Takeaway",
        "user-home-upcoming-takeaway-no-orders": "Ingen take away i perioden\n    .title = Ingen take away i perioden",
        "user-home-takeaway-collapse": "Skjul take away",
        "user-home-takeaway-expand": "Vis take away",
        "user-home-upcoming-meeting-service-approved": "\n .label = Godkendt",
        "user-home-upcoming-meeting-service-approved-tooltip":  "\n .label = Ordren er blevet godkendt af salgsstedet.",
        "user-home-upcoming-meeting-service-sittings": "{ $sittings } kuverter",
        "user-home-upcoming-meeting-service-attendees": "{ $attendees } deltagere",
        "user-home-upcoming-meeting-service-locked": "Låst",
        "user-home-upcoming-purchases-check-in-reminder": "Check-in påmindelse",
        "user-home-upcoming-purchases-learn-more": "Se mere",
        "user-home-upcoming-purchases-check-in-subtitle": "Husk at checke ind i kantinen i dag.",
        "user-home-canteen-contact-canteen": "Kontakt kantine",
        "user-dashboard-error-offers-unavailable": "Tilbuddet er midlertidigt utilgængeligt.",
        "user-dashboard-error-week-menu-unavailable": "Ugentlig menu er midlertidigt utilgængelig.",
        "user-dashboard-error-news-menu-unavailable": "Nyhedsmenu er midlertidigt utilgængelig.",
        "user-dashboard-error-merchant-contact-unavailable": "Kontaktoplysninger til forhandler er midlertidigt utilgængelige.",
        "user-home-canteen-news-category-company": "\n .label = Virksomhed",
        "user-home-canteen-news-category-service-center": "\n .label = Servicecenter",
        "user-home-canteen-news-category-kitchen": "\n .label = Køkken",
        "user-home-canteen-news-category-no-actions":  "Ingen handlinger tilgængelige for ordre #{ $orderId }",
        "user-home-canteen-upcoming-orders-dialog-ok-button": "Ok",
        "user-home-canteen-upcoming-orders-cancel-order-item": "Annuller ordre",
        "user-home-canteen-upcoming-orders-cancel-booking-item": "Annuller booking",
        "user-home-canteen-upcoming-orders-delete-order": "Slet ordre",
        "user-home-canteen-upcoming-orders-delete-order-restriction-message": "Du har ikke tilladelse til at slette denne ordre",
        "user-home-canteen-upcoming-orders-refund-order": "Refunder ordre",
        "user-home-canteen-upcoming-orders-refund-order-restriction-message": "Du har ikke tilladelse til at refundere denne ordre",
        "user-home-canteen-upcoming-orders-receipt-item": "Kvittering",
        "user-home-canteen-upcoming-orders-edit-item": "Rediger",
        "user-home-canteen-upcoming-orders-update-booking-restriction-message": "Du har ikke tilladelse til at opdatere booking",
        "user-home-canteen-upcoming-orders-extend-booking-item": "Forlæng booking",
        "user-home-canteen-upcoming-orders-extend-booking-restriction-message": "Du har ikke tilladelse til at forlænge booking",
        "user-home-canteen-upcoming-orders-end-booking-restriction-message": "Du har ikke tilladelse til at afslutte booking",
        "user-home-canteen-upcoming-orders-update-meeting-service-item-meeting-service": "Opdater",
        "user-home-canteen-upcoming-orders-update": "Rediger",
        "user-home-canteen-upcoming-orders-update-meeting-restriction-message": "Du har ikke tilladelse til at opdatere denne ordre",
        "user-home-canteen-upcoming-orders-duplicate-meeting-service-item-meeting-service": "Dupliker",
        "user-home-canteen-upcoming-orders-duplicate-meeting-service-item-resource-booking": "Dupliker mødeforplejning",
        "user-home-canteen-upcoming-orders-duplicate-meeting-service-restriction-message": "Du har ikke tilladelse til at duplikere denne ordre",
        "user-home-canteen-upcoming-orders-end-modal-confirm": "Bekræft",
        "user-home-canteen-upcoming-orders-cancel-modal-confirm": "Annuller",
        "user-home-canteen-upcoming-orders-extend-modal-title": "Forlæng booking",
        "user-home-canteen-upcoming-orders-extend-modal-subtitle": "Forlæng booking { $meetingName } til { $meetingTime }?",
        "user-home-canteen-upcoming-orders-extend-modal-max-error": "Den maksimalt tilgængelige tid er { $maxAvailableMinutes } minutter.",
        "user-home-canteen-upcoming-orders-extend-input-custom-time": "\n .label =  Select end time:",
        "user-home-canteen-upcoming-orders-extend-other-button": "Andet",
        "user-home-canteen-upcoming-orders-delete-modal-error": "Kunne ikke slette ordre",
        "user-home-canteen-upcoming-orders-delete-modal-booking-label": "\n .label = Annuller booking",
        "user-home-canteen-upcoming-orders-delete-modal-meeting-label": "\n .label = Annuller mødeforplejning",
        "user-home-canteen-upcoming-orders-cancel-modal":
            "\n .title = Annuller { $itemType ->\n [order] ordre\n *[booking] booking\n }\n .message = Er du sikker på, at du vil annullere { $itemType ->\n [order] ordren\n *[booking] bookingen\n } '{ $itemName }'?\n .buttonLabelSubmit = Annuller { $itemType ->\n [order] ordre\n *[booking] booking\n }\n .buttonLabelCancel = Tilbage",
        "user-home-canteen-upcoming-orders-cancel-started-modal":
            "\n .title = Annuller booking\n .message = Mødet #{ $orderId }, { $meetingName } er allerede startet, så bookingen afsluttes nu i stedet for at blive slettet. Vil du fortsætte?\n .buttonLabelSubmit = Annuller booking\n .buttonLabelCancel = Tilbage",
        "user-home-canteen-upcoming-orders-cancel-ended-booking-message": "Mødet er allerede afsluttet, så bookingen kan ikke længere annulleres.",
        "user-home-meeting-service-action-update-booking": "Opdater booking",
        "user-home-meeting-service-action-edit": "Rediger ordre",
        "user-home-meeting-service-action-update-meeting-service": "Opdater mødeforplejning",
        "user-home-meeting-service-action-duplicate-meeting-service": "Dupliker ordre",
        "user-home-meeting-service-description-update-booking": "Er du sikker på, at du vil opdatere booking #{ $orderId }, { $meetingName }?",
        "user-home-meeting-service-description-update-meeting-service-catering": "Vil du opdatere ordre #{ $orderId }, { $meetingName } med levering den { $deliveryDate }?",
        "user-home-meeting-service-description-update-meeting-service": "Vil du opdatere ordre #{ $orderId }, { $meetingName } til møde den { $deliveryDate }?",
        "user-home-meeting-service-description-duplicate-meeting-service": "Vil du duplikere ordre #{ $orderId }, { $meetingName } med levering den { $deliveryDate }?",
        "user-home-meeting-service-action-confirm-modal-meeting-name": "Mødenavn:",
        "user-home-meeting-service-action-confirm-modal-delivery-date-name": "Leveringsdato:",
        "user-home-meeting-service-action-confirm-modal-order-id": "Ordre ID:",
        "user-home-canteen-upcoming-orders-extend-success-dialog-title": "Booking blev forlænget",
        "user-home-canteen-upcoming-orders-delete-success-dialog-title": "Booking blev annulleret",
        "user-home-canteen-upcoming-orders-delete-order-success-dialog-title":
            "{ $ordersCount ->\n *[one] Ordre blev slettet\n [other] Ordrer blev slettet\n }",
        "user-home-canteen-upcoming-orders-end-success-dialog-title": "Booking blev afsluttet",

        // User > Home > Offers
        "user-home-offers-title": "Tilbud",

        // User > Home > Offers
        "user-home-news-from-kitchen": "Nyheder fra køkkenet",

        // User > Home > Opening hours
        "user-home-opening-hours-title": "Åbningstider",
        "user-home-opening-day-1": "Man:",
        "user-home-opening-day-2": "Tir:",
        "user-home-opening-day-3": "Ons:",
        "user-home-opening-day-4": "Tor:",
        "user-home-opening-day-5": "Fre:",

         // User > Home > Room finder
        "user-homeroom-finder-title": "Rumfinder",
        "user-home-room-finder-resource-type-dropdown": "\n .label = Ressourcetype",
        "user-home-room-finder-resource-date": "\n .label = Dato:",
        "user-home-room-finder-resource-duration": "\n .label = Varighed:",
        "user-home-room-finder-resource-seats": "Pladser:",
        "user-home-room-finder-resource-time": "Tid:",
        "user-home-room-finder-resource-book-button": "Book ({ $amount })",
        "user-home-room-finder-resource-results-amount": "{ $amount } resultater",
        "user-home-room-finder-resource-select-button": "Vælg",
        "user-home-room-finder-resource-unselect-button": "Fjern",
        "user-home-room-finder-go-to-timeline-button": "Gå til tidslinje",
        "user-home-room-finder-subtitle": "Din intelligente følgesvend til at finde ressourcer.",
        "user-home-room-finder-find-a-room-button": "Find et rum",
        "user-home-room-finder-available-rooms": "tilgængelige rum",
        "user-home-room-finder-available-time-slot": "fra { $timeSlot }",


        // User > Upcoming orders > Meeting service
        "user-upcoming-orders-meeting-service-title": "\n .title = Mødeforplejning",

        // User > Upcoming orders > Resource bookings
        "user-upcoming-orders-resource-booking-table-id": "Ordre ID",
        "user-upcoming-orders-resource-booking-table-time": "Tid",
        "user-upcoming-orders-resource-booking-table-meeting": "Møde",
        "user-upcoming-orders-resource-booking-table-visibility": "Synlighed",
        "user-upcoming-orders-resource-booking-table-visibility-public": "Offentlig",
        "user-upcoming-orders-resource-booking-table-visibility-public-tooltip": "Bookingen er offentlig, hvilket betyder, at mødenavnet og deltagernes navne er synlige for kolleger.",
        "user-upcoming-orders-resource-booking-table-visibility-private": "Privat",
        "user-upcoming-orders-resource-booking-table-visibility-private-tooltip": "Bookingen er privat, hvilket betyder, at mødenavnet og deltagernes navne ikke er synlige for nogen.",
        "user-upcoming-orders-resource-booking-table-action-delete": "Slet",
        "user-upcoming-orders-resource-booking-table-remove-dialog": "\n .title = Fjern booking\n .message = Er du sikker på, at du vil fjerne booking?\n .buttonLabelSubmit = Fjern",


        // User > Settings
        "user-settings-page-title": "\n .title = Indstillinger",
        "user-settings-tab-bill-receivers": "Regningsmodtagere",
        "user-settings-tab-guest-reception": "Gæstemodtagelse",
        "user-settings-tab-calendar-sharing": "Kalenderdeling",
        "user-settings-tab-access-control": "Adgangskontrol",
        "user-settings-table-header-name": "Navn",
        "user-settings-table-header-address": "Adresse",
        "user-settings-table-header-endpoint": "Endepunkt",
        "user-settings-table-header-status": "Status",
        "user-settings-status-active": "Aktiv",
        "user-settings-status-inactive": "Inaktiv",
        "user-settings-status-pending": "Afventer",
        "user-settings-action-edit": "Rediger",
        "user-settings-action-delete": "Slet",
        "user-settings-action-activate": "Aktivér",
        "user-settings-action-deactivate": "Deaktivér",
        "user-settings-coming-soon": "Kommer snart",
        "user-settings-bill-receivers-info": "\n .title = Her er dine personlige regningsmodtagere, som du kan vælge, når du bestiller mødeforplejning. Du har mulighed for at oprette en ny regningsmodtagere under bestillingsprocessen, hvis den valgte kantine tillader det.",
        "user-settings-delete-bill-receiver-dialog": "\n .typeOfEntity = regningsmodtagere",
        "user-settings-edit-bill-receiver-dialog-title": "Rediger regningsmodtager",
        "user-settings-edit-bill-receiver-page-header": "\n .title = Rediger regningsmodtager",
        "user-settings-edit-bill-receiver-name-field": "\n .label = Navn",
        "user-settings-edit-bill-receiver-vatnumber-field": "\n .label = CVR-nummer",
        "user-settings-edit-bill-receiver-address-panel": "\n .title = Adresse",
        "user-settings-edit-bill-receiver-endpoint-panel": "\n .title = Fakturamodtager",
        "user-settings-edit-bill-receiver-endpoint-type-field": "\n .label = Type",
        "user-settings-edit-bill-receiver-endpoint-value-field": "\n .label = Værdi",
        "user-settings-edit-bill-receiver-contact-panel": "\n .title = Kontaktperson",
        "user-settings-edit-bill-receiver-settings-panel": "\n .title = Indstillinger",
        "user-settings-edit-bill-receiver-active-switch": "Aktiv",
        "user-settings-edit-bill-receiver-save-button": "Gem",
        "user-nav-item-edit-bill-receiver": "Rediger regningsmodtager",

        // User > Settings > Wallets
        "user-settings-wallets-title": "\n .title = Wallets",

        // User > Wallets > Refill
        "user-wallets-refill-title": "\n .title = Optank wallet",
        "user-wallets-refill-manual-top-up-nav-tab": "Manuel optankning",
        "user-wallets-refill-automatic-top-up-nav-tab": "Automatisk optankning",
        "user-wallets-refill-manual-type": "\n .statusLabel = Manuel",
        "user-wallets-refill-automatic-type": "\n .statusLabel = Automatisk",
        "user-wallets-refill-payment-success": "Ordre behandlet",
        "user-wallets-refill-payment-unexpected-error": "Der opstod en uventet fejl",
        "user-wallets-refill-payment-timeout": "Betaling fik timeout",
        "user-wallets-refill-payment-wait-label": "Behandler betaling",
        "user-wallets-refill-payment-wait-description":  "Vent venligst mens vi behandler din betaling. Dette kan tage et øjeblik.",
        "user-wallets-refill-payment-back-action-button-label": "Tilbage til dashboard",
        "user-wallets-refill-payment-timeout-label": "Betaling fik timeout",
        "user-wallets-refill-payment-timeout-description": "Vi har ikke modtaget bekræftelse fra din betalingsudbyder. Tjek venligst din netbank for at være sikker på, at betalingen blev gennemført.",
        "user-wallets-refill-payment-canceled-label":  "Betaling annulleret",
        "user-wallets-refill-payment-canceled-description":  "Du har annulleret betalingsprocessen. Der er ikke trukket noget fra din konto.",
        "user-wallets-refill-payment-failed-label": "Betaling mislykkedes.",
        "user-wallets-refill-payment-failed-description": "Din betaling kunne ikke gennemføres. Bekræft venligst dine oplysninger, og prøv igen.",

        // User > Wallets > Refill > Manual tab
        "user-wallets-refill-manual-main-amount-label": "\n .label = Beløb",
        "user-wallets-refill-manual-main-amount-error":"Din wallet kan ikke overstige { $maxBalance}. Du kan maksimalt optanke { $maxRefillAmount }",
        "user-wallets-refill-manual-main-amount-max-error":"Det maksimale beløb at optanke er { $maxRefillAmount }",
        "user-wallets-refill-manual-main-amount-zero-error":"Beløbet skal være større end 0",
        "user-wallets-refill-auto-amount-max-threshold-error":"Den maksimale grænse er { $maxThreshold }",
        "user-wallets-refill-payment-method-error":"Betalingsmetode er påkrævet",
        "user-wallets-refill-manual-main-custom-amount-label": "\n .label = Indtast beløb:",
        "user-wallets-refill-manual-main-amount-amount-100": "100,00 kr",
        "user-wallets-refill-manual-main-amount-amount-300": "300,00 kr",
        "user-wallets-refill-manual-main-amount-amount-500": "500,00 kr",
        "user-wallets-refill-manual-main-amount-amount-other": "Andet",
        "user-wallets-refill-manual-main-payment-method": "Betalingsmetoder:",
        "user-wallets-refill-manual-main-select-payment-method": "Vælg betalingsmetode",
        "user-wallets-refill-manual-main-perform-refill-button": "Bekræft betaling",
        "user-wallets-refill-select-card-dialog-title": "Vælg wallet",
        "user-wallets-refill-select-card-dialog-no-wallets": " Forhandleren tilbyder ikke digitale wallets til din virksomhed.",
        "user-wallets-refill-select-card-balance": "Saldo:",


        // User > Wallets > Refill > Auto tab
        "user-wallets-refill-auto-activate-card-title": "Aktivér automatisk optankning",
        "user-wallets-refill-auto-activate-modal-title": "Aktivér automatisk optankning",
        "user-wallets-refill-auto-activate-modal-threshold-placeholder": "\n .label = Beløb (DKK)",
        "user-wallets-refill-auto-activate-modal-threshold-subtitle": "Når saldoen falder under:",
        "user-wallets-refill-auto-activate-modal-refill-subtitle": "Optank med beløb:",
        "user-wallets-refill-auto-activate-modal-submit-button": "Aktivér automatisk optankning",
        "user-wallets-refill-auto-activate-modal-update-button": "Opdater automatisk optankning",
        "user-wallets-refill-auto-activate-modal-delete-button": "Slet automatisk optankning",
        "user-wallets-refill-auto-activate-success-modal-subtitle": "Automatisk optankning aktiveret",


        // User > Archive > Drawer
        "user-archive-drawer-resource-booking": "Ressourcebooking",
        "user-archive-drawer-meeting-service": "Mødeforplejning",
        "user-archive-drawer-daily-purchases": "Daglige køb",
        "user-archive-drawer-refill-wallet": "Tank-op",


        // User > Archive > Drawer > Transactions
        "user-archive-transactions-table-id": "Ordre ID",
        "user-archive-transactions-table-transaction-time": "Transaktionstid",
        "user-archive-transactions-table-delivery-time": "Leveringstid",

        // User > Archive > Meeting service
        "user-archive-meeting-service-title": "\n .title = Mødeforplejning",
        "user-archive-meeting-service-info-box": "I arkivet kan du kun se mødeforplejningsordrer, som er bogført af salgsstedet.",
        "user-archive-meeting-service-table-id": "Ordre ID",
        "user-archive-meeting-service-table-booked-date": "Bogføringsdato",
        "user-archive-meeting-service-table-delivery-time": "Leveringstid",
        "user-archive-meeting-service-table-meeting": "Møde",
        "user-archive-meeting-service-table-amount": "Beløb",
        "user-archive-meeting-service-table-action-receipt": "Kvittering",
        "user-archive-meeting-service-table-action-duplicate": "Dupliker",
        "user-archive-meeting-service-table-action-send-message": "Send besked",
        "user-archive-meeting-service-table-filter-start-date": "Startdato",
        "user-archive-meeting-service-table-filter-end-date": "Slutdato",

        // Standard components

        // Standard components > Filter button
        "table-filters-button": "\n .title = Filtre\n .aria-label = Filtre",

        // Create order
        "create-order-access-denied-on-behalf-of": "Du har ikke adgang til at bestille på vegne af den valgte bruger.",
        "create-order-confirm-order-button": "Næste",
        "create-order-meeting-service-mobile-bar-continue-button": "Fortsæt",
        "create-order-meeting-service-mobile-back-to-products-button": "Tilbage til produkter",
        "create-order-book-button": "Reservér",
        "create-order-update-button": "Opdater",
        "create-order-undo-button": "\n .title = Fortryd alt",
        "create-order-wish": "\n .title = Ønske",
        "create-order-wish-dialog-title": "\n .dialogTitle = Tilføj produktønske",
        "create-order-order-line-dialog-title": "\n .dialogTitle = Tilføj produkt",
        "create-order-wish-dialog-edit-price-title": "\n .dialogTitle = Angiv pris",
        "create-order-wish-dialog-message": "Hvis du tilføjer et produktønske, skal din ordre godkendes manuelt af shopejeren.",
        "create-order-wish-dialog-product-name-field": "\n .label =Produktnavn \n .placeholder =Indtast produktnavn:",
        "create-order-wish-dialog-product-items-field": "\n .label =Antal \n .placeholder =Indtast antal:",
        "create-order-wish-dialog-product-price-field": "\n .label =Produktpris \n .placeholder =Indtast pris (DKK):",
        "create-order-wish-dialog-submit-button": "Bekræft",
        "create-order-wish-dialog-product-name-max-length": "Produktnavnet må ikke overstige { $maxLength } tegn",
        "create-order-wish-dialog-quantity-min-value": "Antal skal være mindst 1",
        "create-order-wish-dialog-quantity-max-value": "Antal kan ikke overstige { $max }",
        "create-order-wish-dialog-price-min-value": "Prisen skal være større end 0",
        "create-order-wish-dialog-price-max-value": "Prisen kan ikke overstige { $max }",
        "create-order-favorite": "\n .title = Se mine favoritprodukter",
        "create-order-favorite-show-all-products": "\n .title = Vis alle produkter",
        "create-order-list": "\n .title = Vis en liste over produkter",
        "create-order-grid": "\n .title = Vis et gitter med produkter",
        "create-order-products-empty": "Ingen resultater",
        "create-order-product-staff-only-tag": "Kun for personale",
        "create-order-product-sale-text": "Kun 10 tilbage",
        "offer-tag-good-price": "Skarp pris",
        "offer-tag-great-offer": "Godt tilbud",
        "offer-tag-buy-now": "Slå til nu",
        "offer-tag-discount": "Tilbud",
        "offer-tag-week-offer": "Ugens tilbud",
        "offer-tag-day-offer": "Dagens tilbud",
        "offer-tag-save-x-percentage": "Spar { $amount }",
        "offer-tag-save-x-price": "Spar { $amount } kr",
        "offer-tag-limited-on-sale": "{ $amount } tilbage",
        "offer-tag-available-from": "Tilgængeligt fra: { $date }",
        "create-order-tooltip-order-summary-button": "\n .title = Vis ordreoversigt",
        "create-order-order-summary-no-items": "Ordreoversigten er tom. Tilføj varer til din ordre for at se detaljerne.",
        "create-order-order-summary": "Ordreoversigt",
        "create-order-order-summary-resources": "\n .title = Ressourcer",
        "create-order-order-summary-resources-booking-time": "Booking",
        "create-order-order-summary-meeting-services": "\n .title = Mødeforplejning",
        "create-order-order-summary-meeting-services-delivery-time": "Levering { $number }",
        "create-order-order-summary-meeting-services-total": "I alt",
        "create-order-order-summary-meeting-services-empty": "Ingen varer tilføjet endnu",
        "create-order-order-summary-meeting-services-add-order-line-button": "+ Tilføj ordrelinje",
        "create-order-order-summary-meeting-services-wish-set-price-button": "Angiv pris",
        "create-order-order-summary-meeting-services-wish-edit-price-button": "\n .title = Rediger pris\n .aria-label = Rediger pris",
        "create-order-order-summary-meeting-services-product-item": "{$count} vare",
        "create-order-order-summary-meeting-services-product-items": "{$count} varer",
        "create-order-order-summary-meeting-services-product-warning-price-list-tooltip": "\n .title = Den valgte prisliste matcher ikke produktets prisliste — forhøjelse er ikke tilgængelig.",
        "create-order-order-summary-meeting-services-product-warning-missing-product-tooltip": "\n .title = Dette produkt er ikke tilgængeligt i den valgte prisliste",
        "create-order-order-summary-meeting-services-product-staff-only-tooltip": "\n .title = Kun forhandleren kan ændre denne vare",
        "create-order-order-summary-meeting-services-legacy-extra-service-tooltip": "\n .title = Dette er en ekstra service fra den gamle portal. Den kan ikke ændres, men den kan fjernes.",
        "create-order-order-summary-meeting-services-wish-locked-quantity-tooltip": "\n .title = Kun forhandleren kan ændre antallet i et produktønske",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog": "\n .dialogTitle = Priser opdateret",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-message": "Nogle priser er ændret, siden ordren blev oprettet. Gennemgå nedenfor for at fortsætte.",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-section-price-changed": "Pris ændret ({ $count })",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-section-missing-product": "Ikke tilgængelig i prislisten { $priceList } ({ $count })",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-section-other-price-list": "Fra en anden prisliste ({ $count })",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-section-unchanged-hint": "Prisen på disse varer forbliver, som den er i ordren.",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-submit-button": "Opdater",
        "create-order-order-summary-meeting-services-invalid-time-card-empty-title": "Levering uden varer",
        "create-order-order-summary-meeting-services-invalid-time-card-empty": "Der blev ikke tilføjet nogen varer til leveringen kl. {$time}. Tilføj venligst varer eller fjern leveringstidspunktet.",
        "create-order-order-summary-meeting-services-invalid-times-card-empty": "Der blev ikke tilføjet nogen varer til leveringen kl. {$time}. Tilføj venligst varer eller fjern leveringstidspunkterne.",
        "create-order-order-summary-meeting-services-invalid-times-card-empty-button": "Ok",
        "create-order-confirm-booking-meeting-details": "Mødedetaljer",
        "create-order-outlook-private-meeting-default-name": "Privat møde",
        "create-order-outlook-on-behalf-of-chip": "På vegne af { $name }",
        "create-order-confirm-booking-update-meeting-details": "Opdater mødedetaljer #{ $id }",
        "create-order-confirm-booking-dialog-add-attendees": "Tilføj deltagere",
        "create-order-confirm-booking-dialog-back-button": "Tilbage",
        "create-order-confirm-booking-meeting-information-tab": "Mødeinformation",
        "create-order-confirm-booking-participants-tab": "Deltagere",
        "create-order-confirm-booking-other-tab": "Andet",
        "create-order-confirm-booking-dialog-confirm-button": "Bekræft",
        "create-order-confirm-booking-dialog-submit-button": "Fuldfør booking",
        "create-order-confirm-booking-dialog-add-attendee-button": "Tilføj deltagere",
        "create-order-confirm-booking-dialog-bulk-add-attendees-button": "Kopier og indsæt",
        "create-order-confirm-booking-dialog-bulk-add-attendees-button-tooltip": "\n .title = Tilføj flere deltagere ved at indsætte en liste over navne og virksomheder",
        "create-order-confirm-booking-dialog-bulk-add-attendees-description": "Indtast ét navn og virksomhed per linje.",
        "create-order-confirm-booking-dialog-bulk-add-attendees-field": "\n .placeholder = Navn, Virksomhed",
        "create-order-confirm-booking-dialog-bulk-add-attendees-drawer-button": "Tilføj deltagere",
        "create-order-confirm-booking-selected-resources": "Valgte ressourcer ({ $count }):",
        "create-order-confirm-booking-booking-time": "Bookingstid: { $time }",
        "create-order-confirm-booking-rooms": "Lokaler:",
        "create-order-confirm-booking-equipment": "AV-udstyr:",
        "create-order-confirm-booking-cars": "Biler:",
        "create-order-confirm-booking-time-range-picker-from-field": "\n .label =Fra tid:",
        "create-order-confirm-booking-time-range-picker-to-field": "\n .label =Til tid:",
        "create-order-confirm-booking-time-range-picker-error": "Ressource er ikke tilgængelig på dette tidspunkt",
        "create-order-meeting-details-start-time-label": "Mødets starttidspunkt",
        "create-order-meeting-details-end-time-label": "Mødets sluttidspunkt",
        "create-order-meeting-details-duration-helper-text":
            "Indtast mødevarighed, så kantinen kan planlægge levering og afrydning.",
        "create-order-confirm-booking-table-setup": "Bordopsætning",
        "create-order-confirm-booking-select-setup": "Vælg opsætning",
        "create-order-confirm-booking-message-title": "Beskeder til servicecenter",
        "create-order-attendees-dialog-submit-button": "Gem",
        "create-order-attendees-dialog-title": "Deltagere",
        "create-order-note-add-button": "Tilføj",
        "create-order-note-edit-button": "Rediger",
        "create-order-note-dialog-title": "\n .dialogTitle = Ordrebesked",
        "create-order-note-dialog-alert": "\n .title = Din ordremeddelelse vil være synlig på ordrespecifikationen. Du må ikke inkludere personligt identificerbar information, såsom detaljer om dit helbred eller din religion.",
        "create-order-note-dialog-field": "\n .label = Din ordrebesked \n .helperText = Resterende tegn: { $count }",
        "create-order-note-save-button": "Gem",
        "create-order-extra-services": "Ekstra serviceydelser:",
        "create-order-extra-services-delivery": "\n .title = Levering kl. { $time }",
        "create-order-extra-services-min-max": "Min. { $min } - Maks. { $max }",
        "create-order-extra-services-add-button": "Tilføj",
        "create-order-extra-services-remove-button": "Fjern",
        "create-order-extra-services-mandatory-tooltip": "\n .title = Denne service er obligatorisk",
        "create-order-extra-services-always-added-label": "Inkluderet",
        "create-order-extra-services-auto-added-snackbar": "Et servicegebyr på { $amount } for \"{ $name }\" er blevet tilføjet til din kurv.",
        "create-order-extra-services-removed-notification": "\"{ $name }\" er ikke længere tilgængelig og er blevet fjernet fra din kurv.",
        "create-order-extra-services-seats-breakdown": "{ $count } pladser x { $price }",
        "create-order-extra-services-total": "I alt: { $amount }",
        "create-order-extra-services-min-price": "Min. pris { $price }",
        "create-order-extra-services-max-price": "Maks. pris { $price }",
        "create-order-extra-services-tooltip-price-per-seat-label": "Pris pr. plads:",
        "create-order-extra-services-tooltip-min-price-label": "Min. pris:",
        "create-order-extra-services-tooltip-max-price-label": "Maks. pris:",
        "create-order-extra-services-additional-fields-title": "Yderligere mødedetaljer:",
        "create-order-extra-services-additional-fields-intro": "\n .title = For at levere ekstra services har vi brug for yderligere mødedetaljer.",
        "create-order-extra-services-additional-fields-start-time-label": "Starttidspunkt",
        "create-order-extra-services-additional-fields-end-time-label": "Sluttidspunkt",
        "create-order-extra-services-additional-fields-location-label": "Hvor afholdes mødet?",
        "create-order-workgroup-label": "\n .label = Arbejdsgruppe",
        "create-order-participants-add-button": "+ Tilføj deltagere",
        "create-order-participants-edit-button": "Rediger deltagere",
        "create-order-share-outlook-attendees-toggle-label": "\n    .label = Tilføj deltagere fra Outlook",
        "create-order-share-outlook-attendees-toggle-helper":
            "Når dette slås til, tilføjes { $count } deltager(e) fra dit Outlook-møde.",
        "create-order-share-outlook-attendees-list-title": "Deltagere fra Outlook ({ $count }):",
        "create-order-share-outlook-attendees-show-all-button":
            "{ $count ->\n [one] +{ $count } mere\n *[other] +{ $count } flere\n}",
        "create-order-share-outlook-attendees-show-less-button": "Vis færre",
        "create-order-share-outlook-attendees-remove": "Fjern deltager",
        "create-order-participants-count-list": "{ $count } deltagere",
        "create-order-participants-count-one-item": "{ $count } deltager",
        "create-order-participants-dialog-name-column": "Navn",
        "create-order-participants-dialog-company-column": "Virksomhed",
        "create-order-participants-dialog-email-column": "E-mail",
        "create-order-participants-dialog-external-internal-column": "Ekstern",
        "create-order-participants-dialog-field-name": "\n .placeholder = Deltagernavn",
        "create-order-participants-dialog-field-company": "\n .placeholder = Virksomhed",
        "create-order-participants-dialog-field-email": "\n .placeholder = E-mailadresse",
        "create-order-add-filters-button": "Tilføj filtre",
        "create-order-add-search-input": "\n .placeholder = Søg",
        "create-order-view-timeline": "Tidslinje",
        "create-order-view-available-time": "Tilgængelighed",
        "create-order-view-room-finder": "Rumfinder",
        "create-order-view-room-finder-upcoming-tooltip": "\n .title = Kommende",
        "create-order-calendar-today-button": "I dag",
        "create-order-calendar-today-button-hint": "Gå til i dag",
        "create-order-calendar-prev-day-button": "Gå til forrige dag",
        "create-order-calendar-next-day-button": "Gå til næste dag",
        "create-order-calendar-go-to-date-button": "Gå til dato",
        "create-order-calendar-go-to-date-button-hint": "Vælg ønsket dato",
        "create-order-calendar-no-resources-message": "Der er ingen tilgængelige ressourcer. Juster venligst filtrene",
        "create-order-calendar-go-to-date-label": "\n .label = Vælg dato",
        "create-order-calendar-go-button": "Gå",
        "create-order-calendar-all-day-label": "Hele dagen",
        "create-order-calendar-week-button": "Nuværende uge",
        "create-order-calendar-prev-week-button": "Forrige uge",
        "create-order-calendar-next-week-button": "Næste uge",
        "create-order-calendar-event-tooltip": "\n .title = Klik for at booke",
        "create-order-confirm-booking-confirm-dialog": "\n .title = Bekræft booking\n .message =Din booking er ikke fuldført. Bekræft venligst din booking, før du fortsætter.\n .buttonLabelSubmit = Bekræft\n .buttonLabelCancel = Annuller",
        "create-order-confirm-booking-confirm-no-resources-dialog": "\n .title = Booking ikke fuldført\n .message =Du har endnu ikke valgt nogen ressourcer. Hvis du forlader nu, bliver din booking ikke fuldført.\n .buttonLabelSubmit = Vælg ressourcer\n .buttonLabelCancel = Forlad alligevel",
        "create-order-change-time-dialog": "\n .title = Ændre bookingtid?\n .buttonLabelSubmit = Brug ny tid\n .buttonLabelCancel = Behold oprindelig tid",
        "create-order-change-time-dialog-message-top": "Din Outlook-mødeindkaldelse er planlagt til:",
        "create-order-change-time-dialog-message-bottom": "Vil du ændre bookingtiden til:",
        "create-order-drawer-other-location": "+ Anden placering",
        "create-order-drawer-delivery-location-field": "\n .label = Leveringssted",
        "create-order-drawer-meeting-location-field": "\n .label = Mødested",
        "create-order-drawer-meeting-location-label": "Mødested",
        "create-order-drawer-repeat-order": "Gentag ordre",
        "create-order-drawer-repeat-order-every": "Gentag hver:",
        "create-order-drawer-repeat-order-every-day": "\n .label = Dag",
        "create-order-drawer-repeat-order-every-week": "\n .label = Uge",
        "create-order-drawer-repeat-order-on": "Gentag på:",
        "create-order-drawer-repeat-order-starts": "Starter:",
        "create-order-drawer-repeat-order-start-date-locked-message": "Startdatoen er ordrens første levering. Vil du ændre den, så luk denne dialog og ret datoen for første levering på ordren. Åbn derefter Gentag ordre igen.",
        "create-order-drawer-repeat-order-ends": "Slutter:",
        "create-order-drawer-repeat-order-ends-on": "\n .label = På",
        "create-order-drawer-repeat-order-ends-after": "\n .label = Efter",
        "create-order-drawer-repeat-order-ends-after-deliveries": "leveringer",
        "create-order-drawer-repeat-order-end-before-start-error": "Slutdato skal være på eller efter startdatoen",
        "create-order-drawer-repeat-order-confirm-button": "Bekræft",
        "create-order-drawer-repeat-order-summary": "Gentages hver { $interval }{ $days }, fra { $startDate }{ $repeatCount }{ $endDate }{ $exceptions }.",
        "create-order-drawer-repeat-order-summary-interval-day": "dag",
        "create-order-drawer-repeat-order-summary-interval-days": "{ $count } dage",
        "create-order-drawer-repeat-order-summary-interval-week": "uge",
        "create-order-drawer-repeat-order-summary-interval-weeks": "{ $count } uger",
        "create-order-drawer-repeat-order-summary-days-suffix": " på { $days }",
        "create-order-drawer-repeat-order-summary-repeat-count-suffix": ", { $count } gange",
        "create-order-drawer-repeat-order-summary-end-date-suffix": ", slutter den { $date }",
        "create-order-drawer-repeat-order-summary-exceptions-suffix": "{ $count ->\n [one] ({ $count } undtagelse)\n *[other] ({ $count } undtagelser)\n}",
        "create-order-drawer-repeat-order-delete-confirm-dialog": "\n .title = Slet gentagelse \n .buttonLabelSubmit = Slet",
        "create-order-drawer-repeat-order-delete-confirm-dialog-message": "Gentagelsen og eventuelle fravalgte dage fjernes. Selve ordren bevares.",
        "create-order-drawer-repeat-order-applies-to": "Gælder:",
        "create-order-drawer-repeat-order-applies-to-weekdays": "\n .label = Hverdage (man–fre)",
        "create-order-drawer-repeat-order-applies-to-every-day": "\n .label = Alle dage",
        "create-order-drawer-repeat-order-start-date-help": "Ordrens leveringsdato – kan ikke ændres",
        "create-order-drawer-repeat-order-start-date-missing-error": "Ordren mangler en leveringsdato.",
        "create-order-drawer-repeat-order-end-date-missing-error": "Vælg en slutdato.",
        "create-order-drawer-repeat-order-span-error": "En gentagelse kan højst strække sig over et år.",
        "create-order-drawer-repeat-order-count-missing-error": "Angiv hvor mange leveringer der skal oprettes.",
        "create-order-drawer-repeat-order-no-deliveries-error": "Denne gentagelse har ingen leveringsdage. Ret gentagelsen, eller fjern den.",
        "create-order-drawer-repeat-order-delivery-days": "Leveringsdage:",
        "create-order-drawer-repeat-order-delivery-days-hint": "Fjern fluebenet ved de dage, der ikke skal leveres.",
        "create-order-drawer-repeat-order-delivery-days-reset-button": "Nulstil fravalg",
        "create-order-drawer-repeat-order-delivery-days-show-button": "Se og fravælg dage ({ $count })",
        "create-order-drawer-repeat-order-delivery-days-hide-button": "Skjul dage",
        "create-order-drawer-repeat-order-delivery-days-none-selected": "Ingen dage valgt",
        "create-order-drawer-repeat-order-delivery-days-all-selected": "Alle dage i perioden er valgt",
        "create-order-drawer-repeat-order-delivery-days-deselected": "{ $count ->\n [one] { $count } dag fravalgt\n *[other] { $count } dage fravalgt\n}",
        "create-order-drawer-repeat-order-delivery-days-month-count": "{ $count ->\n [one] { $count } levering\n *[other] { $count } leveringer\n}",
        "create-order-drawer-repeat-order-delivery-days-month-deselected": "· { $count } fravalgt",
        "create-order-drawer-repeat-order-delivery-days-start-day": "Startdato",
        "create-order-drawer-repeat-order-confirm-orders-button": "{ $count ->\n [one] Bekræft { $count } ordre\n *[other] Bekræft { $count } ordrer\n}",
        "create-order-drawer-repeat-order-summary-weekdays-suffix": "på hverdage",
        "create-order-tooltip-resource-info-button": "\n .title = Vis ressourceoplysninger",
        "create-order-tooltip-resource-lock-button-has-access": "\n .title = Kan kun bookes af valgte brugere. Du har adgang til at booke.",
        "create-order-tooltip-resource-lock-button-no-access": "\n .title = Kan kun bookes af valgte brugere. Du har ikke adgang.",
        "create-order-tooltip-resource-image-button": "\n .title = Vis plantegning",
        "create-order-hover-local-event-start": "Starttid: { $start }",
        "create-order-hover-local-event-end": "Sluttid: { $end }",
        "create-order-hover-local-event-host": "Vært: { $host }",
        "create-order-tabs-error": "Du kan ikke afgive en ordre",
        "create-order-tabs-error-body": "Du kan ikke afgive en ordre, fordi din konto ikke har den nødvendige adgang. Kontakt venligst support, hvis du har brug for flere oplysninger.",
        "create-order-invalid-user-permissions-merchant-meeting-service-dialog-body": "Du forsøger at oprette en mødeforplejningsordre på vegne af <displayName>{ $displayName }</displayName>. Dog har brugeren ikke adgang til din mødeforplejningsshop. Kontakt venligst support for assistance.",
        "create-order-invalid-user-permissions-merchant-resource-booking-dialog-body": "Du forsøger at oprette en ressourcebooking på vegne af <displayName>{ $displayName }</displayName>. Kontakt venligst support for assistance.",
        "create-order-invalid-user-permissions-non-create-dialog-title": "Adgangsbegrænsning",
        "create-order-invalid-user-permissions-non-create-dialog-body": "Du har ikke adgang til at udføre denne handling på vegne af <displayName>{ $displayName }</displayName>. Kontakt venligst support for assistance.",
        "create-order-tabs-error-dialog-close-button": "Gå tilbage",
        "create-order-tabs-error-dialog-confirm-button": "Vælg en anden bruger",
        "create-order-price-list-confirm-dialog": "\n .title = Fjern produkter\n .buttonLabelSubmit = Fjern",
        "create-order-price-list-confirm-dialog-message": "Er du sikker på, at du vil fjerne alle produkter fra alle leveringstidspunkter?",
        "create-order-close-confirm-dialog": "\n .title = Kassér ændringer \n .buttonLabelSubmit = Kassér",
        "create-order-close-confirm-dialog-message": "Hvis du klikker på Kassér, går alle indtastede oplysninger tabt.",
        "create-order-drawer-messages-dialog-title": "\n .dialogTitle = Beskeder fra shopejeren",
        "create-order-drawer-message-read-more": "...Læs mere",
        "expandable-text-read-more": "Læs mere",
        "expandable-text-read-less": "Vis mindre",
        "create-order-book-period-message-dialog-title": "\n .dialogTitle = Du kan ikke klikke på tidslinjen, mens du bruger tilstanden `Reservér periode`",
        "create-order-book-period-message-dialog-note": "For at booke ressourcer skal du klikke på ressourcerne i venstre panel",
        "create-order-book-period-filter-intro": "Reserver periode bruges til at booke over flere dage. Når du har valgt start- og sluttidspunkt, skal du blot klikke på den ønskede ressource i venstre kolonne",
        "create-order-book-period-filter-intro-recurring":
            "Dette er et gentagende møde — klik blot på den ønskede ressource i venstre kolonne for at booke den til alle forekomster.",
        "create-order-book-period-busy-message": "Den valgte ressource er ikke tilgængelig for hele perioden",
        "create-order-book-period-busy-error": "Kunne ikke tjekke ressourcetilgængelighed",
        "create-order-book-period-confirm-cancel-changes-dialog": "\n .title = Fjern det nuværende valg\n .buttonLabelSubmit = Bekræft\n .buttonLabelCancel = Annuller",
        "create-order-book-period-confirm-cancel-changes-dialog-message": "Ændring af perioden vil rydde dit nuværende valg. Vil du fortsætte?",
        "create-order-past-booking-attempt-message": "Du kan ikke booke tilbage i tiden. Starttidspunktet for bookingen skal være lig med eller senere end det aktuelle tidspunkt",
        "create-order-book-period-past-booking": "Kan ikke vælge en periode i fortiden",
        "create-order-change-current-event-dialog": "\n .title = Du er i gang med at opdatere booking { $currentBooking }\n .message = Vil du nulstille dine ændringer og skifte til { $targetBooking }?\n .buttonLabelSubmit = Bekræft\n .buttonLabelCancel = Annuller",
        "create-order-change-current-event-create-dialog": "\n .title = Du er i gang med at oprette en booking\n .message = Vil du nulstille dine ændringer og skifte til { $targetBooking }?\n .buttonLabelSubmit = Bekræft\n .buttonLabelCancel = Annuller",
        "create-order-timeline-permission-error": "Du har ikke rettigheder til at opdatere denne booking, da den tilhører en anden bruger",
        "create-order-timeline-error-select": "Dette tidsrum er ikke tilgængeligt for de valgte ressourcer",
        "create-order-timeline-error-busy-or-overlap": "Denne ressource er allerede optaget på det valgte tidspunkt, eller der er registreret overlap med buffer!",
        "create-order-timeline-slot-taken-message": "Nogen har booket dette tidspunkt, mens du valgte. Tidslinjen er opdateret — vælg venligst et andet tidspunkt eller en anden ressource.",
        "create-order-resource-row-events-loading-tooltip": "Kalenderbegivenheder indlæses stadig. Vent venligst, før du vælger en ressource.",

        "create-order-select-price-list-dialog": "Vælg prisliste",
        "create-order-empty-price-list-dialog": "Ingen prisliste tilgængelig",
        "create-order-empty-price-list-dialog-body": "Der er i øjeblikket ingen prislister tilgængelige",
        "create-order-empty-price-list-dialog-body-message": "Kontakt venligst shopejeren for at anmode om adgang til dem",
        "create-order-select-price-list-no-price-lists-title": "Der er i øjeblikket ingen prislister tilgængelige. Kontakt venligst shopejeren for at anmode om adgang til dem.",
        "create-order-select-price-list-no-search-results": "Din søging gav ingen resultater",
        "create-order-select-price-list-no-search-results-description": "Prøv et andet søgeord",
        "create-order-select-price-list-favorites-section": "Mine favoritter ({ $count })",
        "create-order-select-price-list-favorites-view-all": "Vis alle ({ $count })",
        "create-order-select-price-list-favorites-toggle-label": "Favoritter",
        "create-order-select-price-list-nearby-note": "Viser prislister i nærheden af dit bookede lokale.",
        "create-order-select-price-list-nearby-see-all-button": "Se alle kantiner",
        "create-order-select-price-list-nearby-only-button": "Vis kun kantiner nær dit bookede lokale",
        "create-order-select-price-list-other-canteens-section": "Andre kantiner",
        "create-order-products-empty-favorites-title": "Du har ingen favoritvarer",
        "create-order-no-products-dialog-title": "\n .dialogTitle = Prislisten indeholder ingen produkter",
        "create-order-no-products-dialog-message": "Kontakt venligst shopejeren for at få adgang til produkterne",
        "create-order-no-longer-available-dialog-title": "\n .dialogTitle = Prislisten er ikke længere tilgængelig",
        "create-order-no-longer-available-dialog-message": "Prislisten, der blev brugt til denne ordre, er ikke længere tilgængelig. Vælg venligst en anden prisliste for at fortsætte.",
        "create-order-no-products-dialog-button-label-cancel": "Gå til forsiden",
        "create-order-no-products-dialog-button-label-submit": "Vælg en anden prisliste",
        "create-order-products-empty-favorites-description": "Du kan tilføje favoritvarer, så du kan gennemføre en ordre hurtigere. Tilføj en favoritvare ved at klikke på hjerteikonet på produktkortet",
        "create-order-credit-note-overlay-title": "Kreditnota",
        "create-order-credit-note-overlay-intro-with-order-id": "Du er ved at oprette en kreditnota for ordre-ID <orderIdLink>#{ $orderId }</orderIdLink>.",
        "create-order-credit-note-overlay-callout-title": "Sådan opretter du en kreditnota:",
        "create-order-credit-note-overlay-callout-body": "Juster produkterne i kurven. De varer, der er i kurven, krediteres. Du kan tilføje din egen ordrelinje, hvis det er nødvendigt.",
        "create-order-select-price-list-dialog-subtitle": "Mødeforplejning",
        "create-order-select-price-list-search-placeholder": "\n .placeholder = Søg prisliste eller kantine",
        "create-order-select-price-list-close-button": "Luk",
        "create-order-select-price-list-footer-empty": "Vælg en prisliste",
        "create-order-select-price-list-footer-selected": "{ $priceList } · { $merchant }",
        "create-order-select-price-list-continue-button": "Fortsæt",
        "create-order-select-price-list-selected-badge": "Valgt",
        "create-order-select-price-list-address-map-link": "Åbn i Google Maps",
        "create-order-select-price-list-address-show-map": "Vis kort",
        "create-order-select-price-list-address-hide-map": "Skjul kort",
        "create-order-select-price-list-info-button-tooltip": "Vis detaljer",
        "create-order-select-price-list-info-close-button": "Luk detaljer",
        "create-order-select-price-list-favorite-add-button-tooltip": "Tilføj til favoritter",
        "create-order-select-price-list-favorite-remove-button-tooltip": "Fjern fra favoritter",
        "create-order-on-behalf-of-dialog": "Bestil på vegne af",
        "create-order-on-behalf-of-dialog-description": "For at oprette en ordre som administrator skal du først vælge den bruger, du opretter ordren for.",
        "create-order-on-behalf-of-dialog-user-description": "Vælg, hvem du bestiller for. Personen bliver arrangør og kan opdatere ordren fra sit dashboard.",
        "create-order-on-behalf-of-dialog-select-company-field": "\n .label = Vælg firma",
        "create-order-on-behalf-of-dialog-select-user-field": "\n .label = Vælg bruger\n .placeholder = Indtast brugernavn:",
        "create-order-on-behalf-of-dialog-user-organizer-field": "\n .label = Arrangør:\n .placeholder = Arrangørens navn",
        "create-order-on-behalf-of-dialog-select-user-field-no-results": "Ingen resultater",
        "create-order-on-behalf-of-dialog-select-company-host-field": "\n .label = Værtens firma",
        "create-order-on-behalf-of-dialog-select-host-field": "\n .label = Værtens navn\n .placeholder = Indtast værtsnavn:",
        "create-order-on-behalf-of-dialog-button": "Fortsæt",
        "create-order-bill-receiver-ean": "EAN:",
        "create-order-bill-receiver-email": "E-mail:",
        "create-order-bill-receiver-contact": "Kontakt:",
        "create-order-bill-receiver-add-button": "+ Tilføj fakturamodtager",
        "create-order-bill-receiver-autocomplete-no-options": "Ingen fakturamodtagere fundet. Kontakt din administrator for at tilføje en.",
        "create-order-vat-included": "(inkl. moms)",
        "create-order-vat-excl": "(ekskl. moms)",


        "create-order-recurrence-outlook-managed": "Dette møde gentages (styres i Outlook)",
        "create-order-busy-resource-dates-dialog-title": "Nogle datoer kunne ikke bookes",
        "create-order-busy-resource-dates-dialog-message":
            "De valgte ressourcer var allerede booket på følgende datoer, så disse forekomster blev ikke booket:",
        "create-order-busy-resource-dates-dialog-copy-button": "Kopiér liste",
        "create-order-busy-resource-dates-dialog-copied-button": "Kopieret",
        "create-order-busy-resource-dates-dialog-continue-button": "Fortsæt",
        "create-order-success-dialog-resource-booking-title": "Booking oprettet!",
        "create-order-success-dialog-resource-booking-title-with-order-id": "Booking #{ $orderId } oprettet!",
        "create-order-success-dialog-resource-booking-title-updated-with-order-id":
            "Booking #{ $orderId } er opdateret!",
        "create-order-success-dialog-meeting-service-title": "Ordre oprettet!",
        "create-order-success-dialog-meeting-service-title-with-order-id": "Ordre #{ $orderId } oprettet!",
        "create-order-success-dialog-meeting-service-title-updated-with-order-id":
            "Ordre #{ $orderId } er opdateret!",
        "create-order-success-dialog-series-orders-title": "{ $count } ordrer er blevet oprettet!",
        "create-order-success-dialog-description": "Hvad vil du gøre nu?",
        "create-order-success-dialog-outlook-cancel-note":
            "Skal mødet aflyses? Annuller ordren i Facilitynet, før du sletter mødet i Outlook.",
        "create-order-success-dialog-action-meeting-service": "Tilføj mødeforplejning til ordren",
        "create-order-success-dialog-action-meeting-service-update": "Opdater mødeforplejning",
        "create-order-success-dialog-action-add-resource-booking": "Tilføj ressourcebooking",
        "create-order-success-dialog-action-update-resource-booking": "Opdater ressourcebooking",
        "create-order-success-dialog-action-create-booking": "Opret en ny booking",
        "create-order-success-dialog-action-create-meeting-service": "Opret ny mødeforplejning",
        "create-order-success-dialog-action-finish": "Jeg er færdig",
        "create-order-success-dialog-action-calendar": "Tilføj møde til kalenderen",

        "create-order-outlook-finish-step": "Du kan nu vende tilbage til Outlook",

        // Confirm order dialog
        "confirm-order-dialog-order-error": "Kunne ikke indlæse kvittering med id #{ $orderId }",
        "confirm-order-dialog-order-error-description": "Denne ordre kunne ikke behandles på grund af manglende eller ugyldige data.",
        "confirm-order-dialog-title": "Bekræft ordre",
        "confirm-order-dialog-title-update-order": "Opdater ordre #{ $id }",
        "confirm-order-dialog-title-credit-note-order": "Opret kreditnota",
        "confirm-order-dialog-title-supplementary-order": "Opret tillægsordre",
        "confirm-order-dialog-meeting-details": "Mødedetaljer",
        "confirm-order-dialog-meeting-time": "Mødetidspunkt:",
        "confirm-order-dialog-delivery-date": "Leveringsdato:",
        "confirm-order-dialog-delivery-location": "Leveringssted:",
        "confirm-order-dialog-delivery-location-mode-eating-in-canteen": "Spiser i kantinen",
        "confirm-order-dialog-delivery-location-mode-pick-up": "Afhentning",
        "confirm-order-dialog-seats": "Pladser:",
        "confirm-order-dialog-merchant": "Shopejer:",
        "confirm-order-dialog-workgroup": "Arbejdsgruppe:",
        "confirm-order-dialog-workgroup-members-title": "Medlemmer af arbejdsgruppen",
        "confirm-order-dialog-workgroup-members-empty": "Ingen medlemmer at vise",
        "confirm-order-dialog-workgroup-members-error": "Vi kan ikke vise medlemmerne lige nu",
        "confirm-order-dialog-workgroup-members-no-access": "Du har ikke adgang til at se gruppens medlemmer",
        "confirm-order-timestamp-created": "Oprettet:",
        "confirm-order-timestamp-updated": "Opdateret:",
        "confirm-order-dialog-contact": "Kontakt",
        "confirm-order-dialog-host": "Vært:",
        "confirm-order-dialog-ordered-by": "Bestilt af:",
        "confirm-order-dialog-bill-receiver": "Fakturamodtager",
        "confirm-order-dialog-bill-receiver-contact": "Kontakt:",
        "confirm-order-dialog-bill-receiver-contact-email": "E-mail:",
        "confirm-order-dialog-bill-receiver-cost-centers": "Omkostningssteder:",
        "confirm-order-dialog-bill-receiver-meeting-type": "Mødetype:",
        "confirm-order-dialog-bill-receiver-department": "Afdeling:",
        "confirm-order-dialog-order-summary": "Ordreoversigt",
        "confirm-order-dialog-order-summary-delivery-date": "Levering: { $date }",
        "confirm-order-dialog-order-summary-delivery-date-time": "Levering: { $date }, { $time }",
        "confirm-order-dialog-order-summary-table-meeting-service": "Mødeforplejning",
        "confirm-order-dialog-order-summary-table-items": "Antal",
        "confirm-order-dialog-order-summary-table-amount": "Beløb",
        "confirm-order-dialog-order-summary-table-amount-no-vat": "Beløb",
        "confirm-order-dialog-order-summary-table-meeting-services-total": "I alt",
        "confirm-order-dialog-order-summary-table-meeting-services-total-no-vat": "I alt",
        "confirm-order-dialog-order-summary-table-meeting-services-vat": "Moms udgør ({ $percentage }%)",
        "confirm-order-dialog-order-summary-table-meeting-services-total-include-vat": "Samlet beløb inkl. moms",
        "confirm-order-dialog-repeat-order": "\n .title = Gentag ordre",
        "confirm-order-dialog-repeat-order-text": "Gentag ordre",
        "confirm-order-dialog-repeat-order-summary-weekdays": "Hverdage",
        "confirm-order-dialog-repeat-order-summary-every-day": "Alle dage",
        "confirm-order-dialog-repeat-order-summary-rule": "Hver { $interval }{ $days }",
        "confirm-order-dialog-repeat-order-summary-deliveries": "{ $count ->\n [one] { $count } levering\n *[other] { $count } leveringer\n}",
        "confirm-order-dialog-repeat-order-summary-deselected": "({ $count } fravalgt)",
        "confirm-order-dialog-repeat-order-day-deselected": "fravalgt",
        "confirm-order-dialog-attendees": "\n .title = Deltagere",
        "confirm-order-dialog-attendees-subtitle": "{ $internalCount } { $internalCount ->\n  [one] intern\n *[other] interne\n}, { $externalCount } { $externalCount ->\n  [one] ekstern\n *[other] eksterne\n}",
        "confirm-order-dialog-attendees-internal": "\n .title = Interne deltagere:",
        "confirm-order-dialog-attendees-external": "\n .title = Eksterne deltagere:",
        "confirm-order-dialog-resources": "\n .title = Ressourcer",
        "confirm-order-dialog-back-button": "Fortsæt redigering",
        "confirm-order-dialog-next-button": "Bekræft ordre",
        "confirm-order-dialog-booking-time": "Bookingtid: { $timeRange }",

        "user-order-receipt-page-share-button": "Del",
        "user-order-receipt-page-not-loaded-message": "  Ordre-id { $orderId } kunne ikke læses. Kontakt venligst support.",
        "user-order-receipt-page-not-found-public-message": "Beklager, ordren blev ikke fundet. Kontakt venligst support på <link>{ $supportEmail }</link>, hvis du har brug for hjælp.",
        "user-order-receipt-page-loading": "Indlæser ordre...",
        "user-order-receipt-page-share-modal-title": "Del kvittering",
        "user-order-receipt-page-share-modal-subtitle": "Del dette link for at lade andre se kvitteringen.",
        "user-order-receipt-page-print-button": "Udskriv",
        "user-order-receipt-page-header-orders-count": "Ordrer: {$orderCount} valgt",
        "user-pos-order-receipt-page-header-orders-count": "Kvitteringer: {$orderCount} valgt",
        "user-order-receipt-page-navigation-counter": "Ordre { $current } af { $total }",
        "user-pos-order-receipt-page-navigation-counter": "Kvittering { $current } af { $total }",
        "receipt-order-navigation-previous-button": "Forrige",
        "receipt-order-navigation-next-button": "Næste",
        "merchant-receipt-dropdown-search-label": "\n .placeholder = Søg efter ordrenr., navn eller e-mail",
        "merchant-receipt-dropdown-group-today-label": "I dag · { $date }",
        "merchant-receipt-dropdown-orders-count": "{ $count ->\n [one] { $count } ordre\n *[other] { $count } ordrer\n}",

        "create-order-delivery-times-add-button": "Tilføj leveringstidspunkter",
        "create-order-delivery-times-add-btn": "Tilføj",
        "create-order-delivery-times-add-delivery-time-title": "Leveringstider",
        "create-order-delivery-times-update-delivery-time": "Opdater leveringstider",
        "create-order-delivery-times-add-delivery-time": "Tilføj leveringstider:",
        "create-order-delivery-times-dialog-title-add": "Tilføj leveringstidspunkter",
        "create-order-delivery-times-dialog-title-edit": "Rediger leveringstidspunkter",
        "create-order-delivery-times-dialog-subtitle": "Du skal vælge en dato for leveringen.",
        "create-order-delivery-times-dialog-subtitle-example": "Du kan angive flere leveringstidspunkter til heldagsmøder, f.eks. levering kl. 10:00 og kl. 13:00.",
        "create-order-delivery-times-dialog-booking-date-mismatch": "Din booking er den { $bookingDate } kl. { $bookingTime }, men mødeforplejningen er den { $deliveryDate }.",
        "create-order-delivery-times-dialog-delivery-date": "Leveringsdato",
        "create-order-delivery-times-dialog-delivery-date-details": "Leveringsdato:",
        "create-order-delivery-times-dialog-delivery-time-event-start": "Dit møde starter kl. { $bookingTime }, men shopejeren leverer kun mellem { $minTime } og { $maxTime }. Vælg venligst et leveringstidspunkt inden for dette tidsrum.",
        "create-order-delivery-times-dialog-delivery-time-event-start-today": "Desværre kan du ikke oprette en mødeforplejningsordre i dag, fordi shopejeren ikke leverer senere end { $time }",
        "create-order-delivery-times-dialog-delivery-date-close-tooltip": "Salgssted er lukket på denne dato",
        "create-order-delivery-times-dialog-delivery-date-kept-tooltip":
            "Salgssted er lukket på denne dato — bevaret fra den oprindelige ordre",
        "create-order-closed-delivery-date-warning-admin":
            "Bemærk: Kantinen er lukket { $date }. Almindelige kantinebrugere kan ikke placere ordrer på denne dato, men som kantineadministrator kan du oprette bestillingen.",
        "create-order-closed-delivery-date-warning-editing":
            "Bemærk: Kantinen er lukket { $date }. Denne ordre blev oprettet til den dato og kan stadig gemmes.",
        "create-order-closed-delivery-date-banner-admin":
            "\n .title = Bemærk: Kantinen er lukket { $date }. Almindelige kantinebrugere kan ikke placere ordrer på denne dato, men som kantineadministrator kan du oprette bestillingen.",
        "create-order-closed-delivery-date-banner-editing":
            "\n .title = Bemærk: Kantinen er lukket { $date }. Denne ordre blev oprettet til den dato og kan stadig gemmes.",
        "create-order-delivery-times-dialog-delivery-times": "Leveringstidspunkter",
        "create-order-delivery-times-dialog-delivery-field": "\n .label = Levering { $count }",
        "create-order-delivery-times-dialog-add-delivery-button": "+ Tilføj levering",
        "create-order-delivery-times-dialog-submit-button": "Bekræft",
        "create-order-delivery-times-dialog-close-button": "Ok",
        "create-order-delivery-times-empty-error": "Ingen aktiv leveringstid valgt",
        "create-order-cost-centers-missing-dialog-title": "Omkostningssteder er ikke tilgængelige",
        "create-order-cost-centers-missing-message": "Der er ingen omkostningssteder tilgængelige for \"{ $dimensionName }\". Kontakt venligst din administrator for at få oprettet omkostningssteder.",
        "create-order-delivery-location-required": "Vælg venligst en leveringsadresse",
        "create-order-meeting-location-required": "Mødested er påkrævet, når en ekstra service kræver det",
        "create-order-meeting-time-required": "Mødetid er påkrævet, når en ekstra service kræver det",
        "create-order-multiple-deliveries-date-and-time-required": "Du skal vælge en leveringsdato og mindst ét leveringstidspunkt",
        "create-order-validation-date-invalid": "{ $label } skal være en gyldig dato",
        "create-order-validation-must-be-checked": "{ $label } skal være markeret",
        "create-order-validation-required": "{ $label } er påkrævet",
        "create-order-validation-min": "{ $label } skal være mindst { $min }",
        "create-order-validation-max": "{ $label } skal være højst { $max }",
        "create-order-validation-must-be-true": "{ $label } skal være sand",
        "create-order-validation-email-invalid": "{ $label } skal være en gyldig e-mailadresse",
        "create-order-validation-format-invalid": "{ $label } har ikke korrekt format",
        "create-order-delivery-times-same-time-error": "Det samme tidspunkt kan ikke tilføjes to gange",
        "create-order-delivery-times-opening-hours-error": "Det valgte tidspunkt ligger ikke inden for åbningstiderne for denne dato",
        "create-order-delivery-times-past-time-error": "Leveringstidspunktet kan ikke ligge i fortiden",
        "create-order-refund-amount-exceeds-initial-error": "Kreditnotaen må ikke overstige det oprindelige beløb.",
        "create-order-refund-quantity-exceeds-initial-error": "Den krediterede mængde må ikke overstige den oprindelige mængde for dette produkt.",
        "create-order-delivery-deadline-message-dialog-title": "\n .title = Deadline er overskredet \n .buttonLabelSubmit = Afgiv ordre \n .buttonLabelCancel = Annuller ordre",
        "create-order-delivery-deadline-message-dialog-description": "Du kan stadig afgive ordren, men den skal godkendes af personalet, hvilket betyder, at du ikke kan forvente, at ordren bliver leveret.",
        "create-order-delivery-deadline-message-dialog-product-wish-staff-description": "Der er et vareønske på denne ordre. Du skal angive en pris og godkende ordren, hvis du vil imødekomme ønsket.",
        "create-order-add-product-deadline-dialog-title": "\n .title = Deadline er overskredet \n .buttonLabelSubmit = OK",

        "create-order-timeline-booked-period": "Reservér periode",
        "create-order-timeline-booked-period-tooltip": "Vælg start- og sluttidspunkt for at booke ressourcer i en længere periode",
        "create-order-timeline-booked-period-selected-tooltip": "Klik på en ressource i venstre kolonne for at booke den i denne periode. Du kan ikke klikke på tidslinjen i denne tilstand",
        "create-order-timeline-booked-period-recurring-tooltip": "Perioden er fastsat af mødeserien. Klik på en ressource i venstre kolonne for at booke den til alle forekomster",
        "create-order-timeline-booked-period-start-date-time-label": "\n .label = Starttid",
        "create-order-timeline-booked-period-end-date-time-label": "\n .label = Sluttid",
        "create-order-timeline-meeting-availability-hidden-count": "{ $count } ressourcer skjult",
        "create-order-timeline-meeting-availability-show-all-button": "Vis alle",
        "create-order-timeline-meeting-fit-banner-title-fallback": "Dit møde",
        "create-order-timeline-meeting-fit-banner-summary":
            "{ $date }, { $time } · { $count ->\n [one] { $count } deltager\n *[other] { $count } deltagere\n}",
        "create-order-timeline-meeting-fit-banner-summary-no-attendees": "{ $date }, { $time }",
        "create-order-timeline-meeting-fit-banner-summary-attendees-only":
            "{ $count ->\n [one] { $count } deltager\n *[other] { $count } deltagere\n}",
        "create-order-timeline-meeting-fit-banner-fits-segment": "Passer til dit møde",
        "create-order-timeline-meeting-fit-banner-all-segment": "Alle ressourcer",
        "create-order-timeline-meeting-fit-banner-fits-segment-tooltip-seats-and-availability":
            "Viser kun ressourcer med plads nok, som er ledige i mødetidsrummet",
        "create-order-timeline-meeting-fit-banner-fits-segment-tooltip-availability":
            "Viser kun ressourcer, som er ledige i mødetidsrummet",
        "create-order-timeline-meeting-fit-banner-fits-segment-tooltip-seats":
            "Viser kun ressourcer med plads nok til deltagerne",
        "create-order-timeline-meeting-fit-banner-all-segment-tooltip":
            "Viser alle ressourcer, også dem der ikke passer til mødet",
        "create-order-timeline-meeting-fit-banner-go-to-meeting-button": "Gå til mødet",

        "resource-booking-chip-filter-select-booking-duration-hours": "timer",
        "resource-booking-chip-filter-select-booking-duration-minutes": "minutter",
        "resource-booking-chip-filter-select-meeting-type-title-internal-meeting": "Internt møde",
        "resource-booking-chip-filter-select-meeting-type-title-internal-meeting-description": "Mødet er kun med kolleger, ingen eksterne gæster.",
        "resource-booking-chip-filter-select-meeting-type-title-external-meeting": "Eksternt møde",
        "resource-booking-chip-filter-select-meeting-type-title-external-meeting-description": "Mødet har eksterne gæster.",
        "resource-booking-chip-filter-select-title-floors": "Vælg sal",
        "resource-booking-chip-filter-select-title-fixedavids": "Vælg fast AV-udstyr",
        "resource-booking-chip-filter-select-title-meetingtype": "Vælg mødetype",
        "resource-booking-chip-filter-select-title-sittings": "Antal pladser",
        "resource-booking-chip-filter-select-title-tablesetupids": "Vælg bordopstillinger",
        "resource-booking-chip-filter-select-title-deliverytype": "Vælg leveringstype",
        "resource-booking-chip-filter-select-title-mobileav": "Mobilt AV",
        "resource-booking-chip-filter-select-title-settables": "Opdækning",
        "resource-booking-chip-filter-select-title-cleanup": "Afrydning",
        "resource-booking-chip-filter-select-title-resourcetypeids": "Vælg ressourcetype",
        "resource-booking-chip-filter-select-title-servicecenterids": "Vælg servicecentre",
        "resource-booking-chip-filter-select-title-satelliteids": "Vælg satellitter",
        "resource-booking-chip-filter-select-title-meetingduration": "Bookingsvarighed",
        "resource-booking-chip-filter-tooltip-resourcetypeids": "Viser kun ressourcer af de valgte typer",
        "resource-booking-chip-filter-tooltip-sittings": "{ $count ->\n [one] Viser lokaler med mindst { $count } plads\n *[other] Viser lokaler med mindst { $count } pladser\n}",
        "resource-booking-chip-filter-tooltip-servicecenterids": "Viser kun ressourcer i de valgte servicecentre",
        "resource-booking-chip-filter-tooltip-floors": "Viser kun ressourcer på de valgte sale",
        "resource-booking-chip-filter-tooltip-fixedavids": "Viser kun lokaler med alt det valgte faste AV-udstyr",
        "resource-booking-chip-filter-tooltip-tablesetupids": "Viser kun lokaler med mindst én af de valgte bordopstillinger",
        "resource-booking-chip-filter-rooms": "Lokaler",
        "resource-booking-chip-filter-equipment": "AV-udstyr",
        "resource-booking-chip-filter-cars": "Biler",

        // Resource filter API keys (groups and elements)
        "key_group_1": "Ressourcetyper",
        "key_group_2": "Mødevarighed",
        "key_group_3": "Mødetid",
        "key_group_4": "Deltagere",
        "key_group_5": "Udvidet søgning",
        "key_1": "Ressourcetyper",
        "key_2": "Mødevarighed",
        "key_3": "Mødetid",
        "key_4": "Pladser",
        "key_5": "Servicecenter",
        "key_6": "Sal",
        "key_7": "Bordopstillinger",
        "key_8": "AV-udstyr",

        // Resource details dialog
        "resource-details-dialog-service-center": "Servicecenter",
        "resource-details-dialog-floor": "Sal",
        "resource-details-dialog-description": "Beskrivelse",
        "resource-details-dialog-empty": "\n .title = Ingen oplysninger tilgængelige\n .description = Oplysningerne om denne ressource kunne ikke findes.",
        "resource-details-dialog-square-meters": "Kvadratmeter",
        "resource-details-dialog-walk-direction":"Vejvisning",
        "resource-details-dialog-capacity": "Kapacitet",
        "resource-details-dialog-capacity-quantity": "{ $quantity } personer",
        "resource-details-dialog-table-arrangement": "Bordopstilling",


        // Service center > Navigation
        "service-center-top-bar-info-screens-online": "Infoskærme online",
        "service-center-top-bar-info-screens-offline": "{ $count ->\n [one] { $count } skærm offline\n *[other] { $count } skærme offline\n}",
        "service-center-nav-item-user-label": "\n .title = Hjem" ,
        "service-center-nav-item-canteen-label": "\n .title = Kommende møder" ,
        "service-center-nav-item-guests-label": "\n .title = Gæsteliste",
        "service-center-nav-item-meeting-rooms-label": "\n .title = Mødelokaler" ,
        "service-center-nav-item-settings-label": "\n .title = Administration" ,
        "service-center-nav-bottom-bar-home-label": "Hjem",
        "service-center-nav-bottom-bar-canteen-label": "Møder",
        "service-center-nav-bottom-bar-meeting-rooms-label": "Mødelokaler",
        "service-center-nav-bottom-bar-guests-label": "Gæster",
        "service-center-nav-bottom-bar-settings-label": "Administration",

        // Service center > Reports > Dashboard
        "service-center-reports-dashboard-check-in-button": "Tjek ind",
        "service-center-reports-dashboard-checked-id": "Tjekket ind",
        "service-center-reports-dashboard-check-in-guests-button": "Gæste tjek-ind",
        "service-center-reports-dashboard-guests-overview-in-house-title": "Gæster i huset",
        "service-center-reports-dashboard-guests-overview-in-house-unit": "i huset",
        "service-center-reports-dashboard-guests-overview-print-guest-list": "Udskriv gæsteliste",
        "service-center-reports-dashboard-guests-overview-export-guest-list": "Eksportér til Excel",
        "service-center-reports-dashboard-guests-overview-chart-title": "I dag",
        "service-center-reports-dashboard-guests-overview-chart-empty": "Ingen møder i dag",
        "service-center-reports-dashboard-guests-overview-chart-legend-meetings": "Møder",
        "service-center-reports-dashboard-guests-overview-chart-legend-guests": "Gæster",
        "service-center-reports-dashboard-guests-overview-chart-slot-tooltip": "{ $from }–{ $to }: { $meetings } møder, { $guests } gæster",
        "service-center-reports-dashboard-guests-overview-group-label": "Gruppe på { $count }",
        "service-center-reports-dashboard-guests-overview-print-title": "Gæster i huset · { $date }",
        "service-center-reports-dashboard-guests-overview-print-empty": "Ingen gæster i huset",
        "service-center-reports-dashboard-guests-overview-csv-name-header": "Navn",
        "service-center-reports-dashboard-guests-overview-csv-company-header": "Firma",
        "service-center-reports-dashboard-guests-overview-csv-meeting-header": "Møde",
        "service-center-reports-dashboard-guests-overview-csv-host-header": "Vært",
        "service-center-reports-dashboard-guests-overview-csv-room-header": "Lokale",
        "service-center-reports-dashboard-guests-overview-csv-time-header": "Tidspunkt",
        "service-center-reports-dashboard-bookings-title": "Bookinger",
        "service-center-reports-dashboard-bookings-print-title": "Bookinger – { $tab } · { $date }",
        "service-center-reports-dashboard-bookings-tab-room": "Møder",
        "service-center-reports-dashboard-bookings-tab-car": "Biler",
        "service-center-reports-dashboard-bookings-tab-mobile-av": "AV",
        "service-center-reports-dashboard-bookings-empty-room": "Ingen møder denne dag",
        "service-center-reports-dashboard-bookings-empty-car": "Ingen bilbookinger denne dag",
        "service-center-reports-dashboard-bookings-empty-mobile-av": "Ingen AV-bookinger denne dag",
        "service-center-reports-dashboard-bookings-export-menu-csv": "Eksportér til CSV",
        "service-center-reports-dashboard-meeting-audience-filter-label": "Vis møder",
        "service-center-reports-dashboard-meetings-list-row-audience-internal": "Intern",
        "service-center-reports-dashboard-meetings-list-row-audience-external": "Ekstern",
        "service-center-reports-dashboard-meetings-csv-start-header": "Start",
        "service-center-reports-dashboard-meetings-csv-end-header": "Slut",
        "service-center-reports-dashboard-meetings-csv-title-header": "Titel",
        "service-center-reports-dashboard-meetings-csv-type-header": "Type",
        "service-center-reports-dashboard-meetings-csv-host-header": "Vært",
        "service-center-reports-dashboard-meetings-csv-company-header": "Virksomhed",
        "service-center-reports-dashboard-meetings-csv-location-header": "Lokale",
        "service-center-reports-dashboard-search-label": "\n .placeholder = Søg",
        "service-center-reports-dashboard-meeting-pagination": "Resultater pr side",
        "service-center-reports-dashboard-check-in-title": "Tjek-ind kø",
        "service-center-reports-dashboard-guest-check-in-title": "Gæste tjek-ind",
        "service-center-reports-dashboard-no-guests":"Ingen gæster i tjek-ind køen",
        "service-center-reports-dashboard-news-title": "Nyheder",
        "service-center-reports-dashboard-no-news":"Ingen nyheder",
        "service-center-reports-dashboard-no-meeting-selected":"Ingen møde valgt",
        "service-center-reports-dashboard-no-meetings":"Ingen kommende møder i dag.",

        // Service center > Reports > Upcoming meetings
        "service-center-reports-upcoming-meetings-title": "\n .title = Kommende møder",
        "service-center-reports-upcoming-meetings-empty": "\n .title = Intet planlagt i perioden",
        "service-center-reports-upcoming-meetings-period-today": "I dag",
        "service-center-reports-upcoming-meetings-period-tomorrow": "I morgen",
        "service-center-reports-upcoming-meetings-period-this-week": "Denne uge",
        "service-center-reports-upcoming-meetings-period-next-7-days": "Næste 7 dage",
        "service-center-reports-upcoming-meetings-period-next-30-days": "Næste 30 dage",
        "service-center-reports-upcoming-meetings-period-all": "Alle kommende",
        "service-center-reports-upcoming-meetings-date-filter-hint-start": "Vælg en startdato i kalenderen",
        "service-center-reports-upcoming-meetings-date-filter-hint-end": "Vælg nu slutdatoen i kalenderen",
        "service-center-reports-upcoming-meetings-date-filter-apply-button": "Anvend",
        "service-center-reports-upcoming-meetings-search-input": "\n .placeholder = Søg møde, nr. eller lokale",
        "service-center-reports-upcoming-meetings-export-menu-csv": "Eksportér til CSV",
        "service-center-reports-upcoming-meetings-audience-filter-label": "Vis",
        "service-center-reports-upcoming-meetings-resource-type-tab-all": "Alle typer",
        "service-center-reports-upcoming-meetings-resource-type-tab-room": "Mødelokaler",
        "service-center-reports-upcoming-meetings-resource-type-tab-mobile-av": "AV",
        "service-center-reports-upcoming-meetings-resource-type-tab-car": "Biler",
        "service-center-reports-upcoming-meetings-row-tag-room": "Lokale",
        "service-center-reports-upcoming-meetings-row-tag-mobile-av": "AV",
        "service-center-reports-upcoming-meetings-row-tag-car": "Bil",
        "service-center-reports-upcoming-meetings-row-tag-meeting-service": "Mødeforplejning",
        "service-center-reports-upcoming-meetings-group-bookings-count": "{ $count ->\n [one] { $count } booking\n *[other] { $count } bookinger\n}",
        "service-center-reports-upcoming-meetings-group-orders-count": "{ $count ->\n [one] { $count } bestilling\n *[other] { $count } bestillinger\n}",
        "service-center-reports-upcoming-meetings-csv-date-header": "Dato",
        "service-center-reports-upcoming-meetings-csv-number-header": "Nr.",
        "service-center-reports-upcoming-meetings-csv-start-header": "Start",
        "service-center-reports-upcoming-meetings-csv-end-header": "Slut",
        "service-center-reports-upcoming-meetings-csv-title-header": "Titel",
        "service-center-reports-upcoming-meetings-csv-type-header": "Type",
        "service-center-reports-upcoming-meetings-csv-location-header": "Lokale/levering",
        "service-center-reports-upcoming-meetings-csv-price-header": "Pris",

        // Service center > Reports > Dashboard > Check in modal
        "service-center-reports-dashboard-check-in-modal-title": "Gæste tjek-ind",
        "service-center-reports-dashboard-print-labels-modal-title": "Udskriv gæstekort",
        "service-center-reports-dashboard-printing-labels-modal-title": "Udskriver gæstekort",
        "service-center-reports-dashboard-printing-labels-modal-subtitle": "Gæstekort at udskrive ({ $amount})",
        "service-center-reports-dashboard-printing-labels-of": "af",
        "service-center-reports-dashboard-printing-labels-cancel": "Annuller",
        "service-center-reports-dashboard-printing-labels-print": "Udskriv",

        // Label printer errors
        "label-printer-error-no-labels": "Ingen etiketter at udskrive",
        "label-printer-error-cancelled": "Udskrivning annulleret af bruger",
        "label-printer-error-required-fields": "Udfyld venligst alle påkrævede felter og sørg for, at gruppestørrelsen er mindst 1",
        "label-printer-error-failed-guest-label": "Kunne ikke udskrive gæsteetiket",
        "label-printer-error-unknown-guest-label": "Ukendt fejl ved udskrivning af gæsteetiket",
        "label-printer-error-failed-label-for": "Kunne ikke udskrive etiket for { $name }",
        "label-printer-error-printing-label-for": "Fejl ved udskrivning af etiket for { $name }",
        "label-printer-error-failed-group-labels": "Kunne ikke udskrive gruppeetiketter",
        "label-printer-error-unknown-group-labels": "Ukendt fejl ved udskrivning af gruppeetiketter",
        "label-printer-error-failed-takeaway-labels": "Kunne ikke udskrive takeaway-etiketter",
        "label-printer-error-unknown-takeaway-labels": "Ukendt fejl ved udskrivning af takeaway-etiketter",
        "label-printer-error-printer-not-found": "Ingen printer blev fundet. Tilslut venligst labelprinteren.",
        "label-printer-error-failed-labels-summary": "Kunne ikke udskrive { $failed } af { $total } etiketter",
        "label-printer-success-labels-printed": "Etiketter udskrevet",
        "label-printer-dialog-not-installed-title": "Printer-udvidelse påkrævet",
        "label-printer-dialog-install-chrome-button": "Installer til Chrome",
        "label-printer-dialog-install-edge-button": "Installer til Edge",
        "label-printer-dialog-install-tooltip": "Tilføj Brother b-PAC-udvidelsen til din browser.",
        "label-printer-dialog-refresh-after-install": "Efter installation opdater siden ved at <refreshLink>klikke her</refreshLink> eller tryk F5.",
        "label-printer-dialog-need-help": "Brug for hjælp?",
        "label-printer-dialog-printer-guide-link": "Printerguide",
        "label-printer-dialog-order-printer-link": "Bestil en Brother-labelprinter",
        "label-printer-dialog-not-found-title": "Ingen printer fundet",
        "label-printer-dialog-not-found-message": "Ingen printer blev fundet. Har du tilsluttet labelprinteren?",
        "label-printer-dialog-try-again-button": "Prøv igen",

        "service-center-reports-check-in-modal-guest-details": "Gæstedetaljer",
        "service-center-reports-check-success-title": "Gæst tjekket ind",
        "service-center-reports-check-group-success-title": "Gruppe tjekket ind",
        "service-center-reports-check-in-modal-guest-name-min": "Gæstens navn skal være mindst { $min } tegn",
        "service-center-reports-check-in-modal-guest-name-max": "Gæstens navn må højst være { $max } tegn",
        "service-center-reports-check-in-modal-guest-company-max": "Gæstens firma må højst være { $max } tegn",
        "service-center-reports-check-in-modal-number-of-guests-min": "Antal gæster skal være mindst { $min }",
        "service-center-reports-check-in-modal-number-of-guests-max": "Antal gæster skal være højst { $max }",
        "service-center-reports-check-in-modal-message-max": "Beskeden må højst være { $max } tegn",
        "service-center-reports-check-in-modal-single": "Individ",
        "service-center-reports-check-in-modal-group": "Gruppe",
        "service-center-reports-check-in-modal-host-name": "\n .label = Værtsnavn",
        "service-center-reports-check-in-modal-host-company": "\n .label = Værtsfirma",
        "service-center-reports-check-in-modal-guest-name": "\n .label = Gæstens navn",
        "service-center-reports-check-in-modal-number-of-guests": "\n .label = Antal gæster",
        "service-center-reports-check-in-modal-guest-company": "\n .label = Gæstens firma",
        "service-center-reports-check-in-modal-guests-company": "\n .label = Gæstefirma",
        "service-center-reports-check-in-modal-print-guest-card": "\n .label = Udskriv gæstekort",
        "service-center-reports-check-in-modal-send-host-notification": "\n .label = Adviser vært",
        "service-center-reports-check-in-modal-send-host-notification-tooltip": "\n .title = Vært vil modtage en notifikation om at gæsten er tjekket ind.",
        "service-center-reports-check-in-modal-write-message-to-host": "\n .label = Skriv besked til vært",
        "service-center-reports-check-in-modal-settings": "Indstillinger",
        "service-center-reports-check-in-modal-check-in-button": "Tjek ind",
        "service-center-reports-check-in-modal-guest-check-in-title": "Gæste tjek-ind",
        "service-center-reports-check-in-modal-guest-check-in-subtitle": "Gæster at tjekke ind ({ $amount})",


        "service-center-check-in-error-generic": "Der opstod en fejl ved tjek-ind af gæsten. Prøv venligst igen.",
        "service-center-check-in-error-not-found": "Gæsten eller værten kunne ikke findes. Bekræft venligst oplysningerne og prøv igen.",
        "service-center-check-in-error-invalid-data": "Ugyldige tjek-ind data. Bekræft venligst oplysningerne og prøv igen.",
        "service-center-check-in-print-failed-snackbar": "Gæsten er tjekket ind, men gæstekortet kunne ikke udskrives.",
        "service-center-check-in-host-contact-link": "Vis værtens kontaktoplysninger",

        // Service center > Reports > Dashboard > Meetings drawer
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-title": "Værtens kontaktoplysninger",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-name": "Navn:",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-company-name": "Virksomhed: ",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-department-name": "Afdeling: ",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-email": "E-mail: ",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-business-phone": "Telefonnummer: ",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-mobile-phone": "Mobilnummer: ",
        "service-center-reports-dashboard-meetings-drawer-meeting-time": "Mødetidspunkt: ",
        "service-center-reports-dashboard-meetings-drawer-host": "Vært: ",
        "service-center-reports-dashboard-meetings-drawer-host-company": "Virksomhed: ",
        "service-center-reports-dashboard-meetings-drawer-location": "Lokation: ",
        "service-center-reports-dashboard-meetings-drawer-select-all": "\n .label = Vælg alle",
        "service-center-reports-dashboard-meetings-drawer-guests-title": "Gæster",
        "service-center-reports-dashboard-meetings-drawer-guests-empty": "Ingen deltagere registreret.",
        "service-center-reports-dashboard-meetings-drawer-guests-list-checked-title": "\n .title = Tjekket ind",
        "service-center-reports-dashboard-meetings-drawer-guests-list-not-checked-title": "\n .title = Ikke tjekket ind",
        "service-center-reports-dashboard-meetings-drawer-guests-list-floating-check-action": "\n .title = Tjek ind",
        "service-center-reports-dashboard-meetings-drawer-guests-list-floating-check-out-action": "\n .title = Tjek ud",
        "service-center-reports-dashboard-meetings-drawer-check-out-done": "\n .title = Færdig",
        "service-center-reports-dashboard-meetings-drawer-check-out-success": "Gæster tjekket ud",
        "service-center-reports-dashboard-meetings-drawer-guests-list-floating-print-guest-action": "Udskriv gæstekort",
        "service-center-reports-dashboard-meetings-drawer-guests-list-floating-other-action":"\n .title = Andet",
        "service-center-reports-dashboard-meetings-drawer-selected-guests": "Valgte gæster",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-dropdown-item-manage-meeting-display": "Rediger mødeskærm",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-name-field-required-error": "Navn er påkrævet",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-success-message": "Mødedisplay blev opdateret",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-title": "Administrer møde på displays",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-meeting-name-label": "\n .label = Nyt mødenavn på displays \n .placeholder = Indtast nyt mødenavn",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-switch-label": "Vis som annulleret",
         "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-show-on-screens-switch-label": "Vis på skærme",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-submit-button": "Gem",
        "service-center-reports-dashboard-meetings-list-row-shown-on-displays-tooltip": "\n .title = Vises på mødeskærme",
        "service-center-reports-dashboard-meetings-list-row-arrivals-tooltip": "\n .title = Tjekket ind",

        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-alert-change-name-label": "Ændr mødenavn:",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-alert-change-name-description": " Hvis mødenavnet ikke er passende til visning på mødedisplays, kan du redigere det her. Denne ændring påvirker kun navnet, der vises på displaysene.",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-alert-cancel-meeting-label": "Aflys møde:",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-alert-cancel-meeting-description": " Hvis du har brug for at aflyse et møde, men stadig vil have det synligt, kan du blot markere det som aflyst.",

        // Service center > Reports > Dashboard > Statistics
        "service-center-reports-statistics-page-header": "\n .title = Statistik",
        "service-center-reports-statistics-occupancy-tab-title": "Belægning",
        "service-center-reports-statistic-occupancy-table-date-range-filter": "\n .label = Datointerval",
        "service-center-reports-statistic-occupancy-table-resource-title": "Ressource",
        "service-center-reports-statistic-occupancy-table-occupancy-rate-title": "Belægningsrate",
        "service-center-reports-statistic-occupancy-table-status-title": "Status",
        "service-center-reports-occupancy-dashboard-chart-title": "Belægning pr. ressource",
        "service-center-reports-occupancy-dashboard-hero-overall-occupancy-label": "Samlet belægning",
        "service-center-reports-occupancy-dashboard-hero-resources-tracked-label": "Registrerede ressourcer",
        "service-center-reports-occupancy-dashboard-chart-empty": "Ingen belægningsdata for denne periode.",
        "service-center-reports-occupancy-dashboard-empty": "Ingen ressourcer fundet for dette servicecenter.",

        "service-center-reports-statistics-cancellations-tab-title": "Annulleringer",
        "service-center-reports-statistic-cancellations-table-cancellation-rate-title": "Annulleringsrate",

        "service-center-reports-statistics-booking-duration-tab-title": "Bookingvarighed",
        "service-center-reports-statistic-booking-duration-table-number-of-bookings-title": "Antal bookinger",
        "service-center-reports-statistic-booking-duration-table-average-duration-title":  "Gns. varighed",
        "service-center-reports-bookings-dashboard-chart-title": "Gennemsnitlig varighed pr. ressource",
        "service-center-reports-bookings-dashboard-hero-total-bookings-label": "Bookinger i alt",
        "service-center-reports-bookings-dashboard-hero-average-duration-label": "Gennemsnitlig bookingvarighed",
        "service-center-reports-bookings-dashboard-chart-empty": "Ingen bookinger for denne periode.",
        "service-center-reports-bookings-dashboard-empty": "Ingen ressourcer fundet for dette servicecenter.",

        "service-center-reports-statistics-guests-tab-title": "Gæster",
        "service-center-reports-statistic-guests-table-date-title": "Dato",
        "service-center-reports-statistic-guests-table-guests-title": "Gæster",

        "service-center-reports-statistics-peak-hours-tab-title": "Spidsbelastningstimer",
        "service-center-reports-statistics-peak-hours-heat-map-title": "Spidsbelastningstimer",

        "service-center-reports-statistics-customer-usage-tab-title": "Lejeranvendelse",

        // Service center > Statistics > Tenant usage (redesign)
        "service-center-usage-per-tenant-header-title": "Anvendelse pr. lejer",
        "service-center-usage-per-tenant-header-subtitle": "Hvordan hver lejer trækker på delte ressourcer i dit servicecenter.",
        "service-center-usage-per-tenant-filter-date-range": "\n .label = Datointerval",
        "service-center-usage-per-tenant-filter-tenant-label": "\n .label = Lejer",
        "service-center-usage-per-tenant-resource-type-all": "Alle typer",
        "service-center-usage-per-tenant-tenant-all": "Alle lejere",
        "service-center-usage-per-tenant-summary-center-caption": "booket i perioden",
        "service-center-usage-per-tenant-summary-hours": "{ $hours }t",
        "service-center-usage-per-tenant-summary-resources-tracked": "Ressourcer sporet",
        "service-center-usage-per-tenant-summary-tenants-active": "Aktive lejere",
        "service-center-usage-per-tenant-summary-legend-other": "Andre ({ $count } lejere)",
        "service-center-usage-per-tenant-detail-other-tenants": "{ $count } andre lejere",
        "service-center-usage-per-tenant-section-title-room": "Mødelokaler",
        "service-center-usage-per-tenant-section-title-mobile-av": "AV-udstyr",
        "service-center-usage-per-tenant-section-title-car": "Biler",
        "service-center-usage-per-tenant-section-title-unknown": "Andre ressourcer",
        "service-center-usage-per-tenant-empty-resources": "Ingen ressourceanvendelse for de valgte filtre.",
        "service-center-usage-per-tenant-empty-tenants": "Ingen lejeraktivitet for de valgte filtre.",

        // Service center > Reports > Meeting rooms
        "service-center-meeting-rooms-page-header": "\n .title = Mødelokalers belægning",
        "service-center-meeting-rooms-status-filter-all": "Alle",
        "service-center-meeting-rooms-status-filter-booked": "Bookede",
        "service-center-meeting-rooms-status-filter-available": "Ledige",
        "service-center-meeting-rooms-floor-filter-all": "Alle etager",
        "service-center-meeting-rooms-search-input": "\n .placeholder = Søg lokale eller mødeejer",
        "service-center-meeting-rooms-occupancy-by-hour-title": "Belægning i dag",
        "service-center-meeting-rooms-occupancy-by-day-title": "Belægning",
        "service-center-meeting-rooms-table-room-header": "Lokale",
        "service-center-meeting-rooms-table-booking-header": "Booking",
        "service-center-meeting-rooms-table-time-header": "Tidsrum",
        "service-center-meeting-rooms-table-status-header": "Status",
        "service-center-meeting-rooms-table-room-seats": "{ $floor } · { $seats ->\n [one] { $seats } plads\n *[other] { $seats } pladser\n}",
        "service-center-meeting-rooms-table-no-booking": "Ingen booking",
        "service-center-meeting-rooms-table-occupied-without-booking": "Optaget, ingen detaljer",
        "service-center-meeting-rooms-table-footer-count": "Viser { $shown } af { $total } lokaler",
        "service-center-meeting-rooms-table-free-until": "Ledigt til { $time }",
        "service-center-meeting-rooms-table-free-rest-of-day": "Ledigt resten af dagen",
        "service-center-meeting-rooms-view-status": "Status",
        "service-center-meeting-rooms-view-by-hour": "Pr. time",
        "service-center-meeting-rooms-view-by-room": "Pr. lokale",
        "service-center-meeting-rooms-previous-day-button": "\n .aria-label = Forrige dag",
        "service-center-meeting-rooms-next-day-button": "\n .aria-label = Næste dag",
        "service-center-meeting-rooms-print-button": "\n .title = Udskriv\n .aria-label = Udskriv",
        "service-center-meeting-rooms-occupancy-peak-button": "Travlest { $hour } · { $peak } af { $total } lokaler booket <action>Vis</action>",
        "service-center-meeting-rooms-occupancy-hide-chart-button": "Skjul graf",
        "service-center-meeting-rooms-occupancy-show-chart-button": "Vis graf",
        "service-center-meeting-rooms-occupancy-hint": "Klik en time for at filtrere",
        "service-center-meeting-rooms-occupancy-peak-tooltip": "\n .title = Vis { $hour } i tabellen",
        "service-center-meeting-rooms-status-live-tooltip": "\n .title = Møde i gang nu: { $meeting } ({ $time })",
        "service-center-meeting-rooms-occupancy-now-badge": "Nu",
        "service-center-meeting-rooms-booking-state-in-progress": "I gang",
        "service-center-meeting-rooms-booking-state-finished": "Afsluttet",
        "service-center-meeting-rooms-booking-state-upcoming": "Kommende",
        "service-center-meeting-rooms-group-hour-meta": "{ $count } af { $total } lokaler",
        "service-center-meeting-rooms-group-hour-empty": "Ingen bookinger i denne time",
        "service-center-meeting-rooms-group-room-empty": "Ingen bookinger i dag",
        "service-center-meeting-rooms-drawer-room-section": "Om lokalet",
        "service-center-meeting-rooms-drawer-equipment-label": "Udstyr",
        "service-center-meeting-rooms-drawer-department-label": "Afdeling",
        "service-center-meeting-rooms-drawer-phone-label": "Telefon",
        "service-center-meeting-rooms-drawer-email-label": "E-mail",
        "service-center-meeting-rooms-drawer-receipt-button": "Vis kvittering",
        "service-center-meeting-rooms-drawer-status-occupied": "Optaget til kl. { $time }",
        "service-center-meeting-rooms-drawer-status-occupied-next": "Optaget til kl. { $time } · næste { $nextTime } { $meeting }",
        "service-center-meeting-rooms-drawer-status-free-next": "Ledigt nu · næste { $nextTime } { $meeting }",
        "service-center-meeting-rooms-drawer-status-free-rest-of-day": "Ledigt resten af dagen",
        "service-center-meeting-rooms-drawer-floor-label": "Etage",
        "service-center-meeting-rooms-drawer-capacity-label": "Kapacitet",
        "service-center-meeting-rooms-drawer-capacity-value": "{ $seats ->\n [one] { $seats } person\n *[other] { $seats } personer\n}",
        "service-center-meeting-rooms-drawer-booking-id-label": "Booking-id",
        "service-center-meeting-rooms-drawer-owner-subheading": "Mødeejer",
        "service-center-meeting-rooms-drawer-name-label": "Navn",
        "service-center-meeting-rooms-drawer-activity-section": "Aktivitet",
        "service-center-meeting-rooms-drawer-activity-status-label": "Status { $time }",
        "service-center-meeting-rooms-drawer-activity-status-in-use": "I brug",
        "service-center-meeting-rooms-drawer-activity-status-free": "Ledigt",
        "service-center-meeting-rooms-drawer-next-booking-label": "Næste booking",
        "service-center-meeting-rooms-drawer-next-booking-none": "Ingen i dag",
        "service-center-meeting-rooms-drawer-next-booking-value": "{ $time } · { $meeting }",
        "service-center-meeting-rooms-drawer-bookings-today-label": "Bookinger i dag",
        "service-center-meeting-rooms-drawer-bookings-today-value": "{ $count ->\n [one] { $count } booking\n *[other] { $count } bookinger\n}",
        "service-center-meeting-rooms-drawer-timeline-hint-from-now": "{ $count ->\n [one] { $count } booking\n *[other] { $count } bookinger\n} · Fra nu og frem · vælg et møde for detaljer",
        "service-center-meeting-rooms-drawer-timeline-hint-whole-day": "{ $count ->\n [one] { $count } booking\n *[other] { $count } bookinger\n} · Hele dagen · vælg et møde for detaljer",
        "service-center-meeting-rooms-drawer-timeline-title": "Dagens forløb",
        "service-center-meeting-rooms-drawer-timeline-mode-from-now": "Fra nu",
        "service-center-meeting-rooms-drawer-timeline-mode-whole-day": "Hele dagen",
        "service-center-meeting-rooms-drawer-timeline-free": "Ledigt",
        "service-center-meeting-rooms-drawer-timeline-occupied": "Optaget",
        "service-center-meeting-rooms-table-free-from": "Ledigt fra { $time }",
        "service-center-meeting-rooms-table-free-between": "Ledigt { $timeRange }",
        "service-center-meeting-rooms-table-free-later": "derefter { $windows }{ $hidden ->\n [0] {\"\"}\n *[other] {\" \"}+{ $hidden }\n}",
        "service-center-meeting-rooms-table-booked-rest-of-day": "Optaget resten af dagen",
        "service-center-meeting-rooms-table-no-free-time-today": "Ingen ledig tid i dag",
        "service-center-meeting-rooms-table-action-view-details": "Vis detaljer",
        "service-center-meeting-rooms-table-action-book": "Book { $hour }",
        "service-center-meeting-rooms-status-booked": "Booket { $hour }",
        "service-center-meeting-rooms-status-available": "Ledigt { $hour }",
        "service-center-meeting-rooms-status-not-checked-in": "Ikke tjekket ind",
        "service-center-meeting-rooms-status-out-of-service": "Ude af drift",
        "service-center-meeting-rooms-reset-filters-button": "Nulstil",
        "service-center-meeting-rooms-group-hour-free-label": "Ledigt",
        "service-center-meeting-rooms-group-hour-free-seats": "{ $seats ->\n [one] { $seats } plads\n *[other] { $seats } pladser\n}",
        "service-center-meeting-rooms-group-hour-free-empty": "Ingen ledige lokaler",
        "service-center-meeting-rooms-group-room-column-room": "Lokale",
        "service-center-meeting-rooms-group-room-column-time": "Tidsrum",
        "service-center-meeting-rooms-group-room-column-meeting": "Møde",
        "service-center-meeting-rooms-group-room-column-duration": "Varighed",
        "service-center-meeting-rooms-group-room-column-attendees": "Deltagere",
        "service-center-meeting-rooms-occupancy-hour-tooltip": "\n .title = { $hour }: { $booked } af { $total } lokaler booket",
        "service-center-meeting-rooms-occupancy-hour-tooltip-jump-to-now": "\n .title = { $hour }: { $booked } af { $total } lokaler booket · klik for at gå til nu",
        "service-center-meeting-rooms-table-no-match": "Ingen lokaler matcher filtrene — nulstil status, etage eller søgning.",
        "service-center-meeting-rooms-table-footer-no-match": "Ingen lokaler matcher filtrene",
        "service-center-meeting-rooms-booking-participants": "{ $participants } pers.",
        "service-center-meeting-rooms-booking-participants-of-seats": "{ $participants } af { $seats ->\n [one] { $seats } plads\n *[other] { $seats } pladser\n}",
        "service-center-meeting-rooms-booking-catering-chip": "Mødeforplejning",
        "service-center-meeting-rooms-booking-over-capacity-chip": "Over kapacitet",
        "service-center-meeting-rooms-drawer-participants-label": "Deltagere",
        "service-center-meeting-rooms-drawer-table-setup-label": "Bordopstilling",
        "service-center-meeting-rooms-drawer-catering-label": "Mødeforplejning",
        "service-center-meeting-rooms-drawer-catering-ordered": "Bestilt",
        "service-center-meeting-rooms-drawer-catering-not-ordered": "Ikke bestilt",

        // Service center > Reports > Dashboard > Guests
        "service-center-reports-dashboard-guests-page-header": "\n .title = Gæster",
        "service-center-reports-dashboard-guests-table-guest-title": "Gæst",
        "service-center-reports-dashboard-guests-table-host-title": "Vært",
        "service-center-reports-dashboard-guests-table-check-in-time-title": "Check-ind",
        "service-center-reports-dashboard-guests-table-check-in-time-tooltip": "Mødestart",
        "service-center-reports-dashboard-guests-table-check-out-time-title": "Check-ud",
        "service-center-reports-dashboard-guests-table-host-company-title": "Værtsfirma",
        "service-center-reports-dashboard-guests-table-host-company-status": "Status",
        "service-center-reports-dashboard-guests-table-host-company-status-checked-in": "Tjekket ind",
        "service-center-reports-dashboard-guests-table-host-company-status-checked-out": "Tjekket ud",
        "service-center-reports-dashboard-guests-table-host-company-status-expected": "Forventet",
        "service-center-reports-dashboard-guests-table-host-company-status-pending": "Venter i kø",
        "service-center-reports-dashboard-guests-table-host-company-status-checked-in-hover-tooltip": "Gæsten er blevet tjekket ind.",
        "service-center-reports-dashboard-guests-table-host-company-status-checked-out-hover-tooltip": "Gæsten er blevet tjekket ud.",
        "service-center-reports-dashboard-guests-table-host-company-status-expected-hover-tooltip": "Gæsten er blevet inviteret, men har ikke tjekket ind endnu.",
        "service-center-reports-dashboard-guests-table-host-company-status-pending-hover-tooltip": "Gæsten har gennemført selv-check-in; receptionsteamet bør dog byde varmt velkommen og udlevere et gæstekort.",
        "service-center-reports-dashboard-guests-table-floating-action-bar-guest-card": "\n .title = Gæstekort",
        "service-center-reports-dashboard-guests-table-date-range-filter": "\n .label = Mødeperiode",

        // Service center > Admin > Organization > DEVICES
        "service-center-admin-organization-devices-title": "\n .title = Enheder",
        "service-center-admin-organization-devices-button-title": "Opret enhed",

        // Service center > Admin > Organization > Resources
        "service-center-admin-organization-resources-title": "\n .title = Ressourcer",
         "service-center-admin-organization-resources-create-button": "Opret ny",
        "service-center-admin-organization-resources-rooms-tab": "Lokaler",
        "service-center-admin-organization-resources-mobile-av-equipment-tab": "AV-udstyr",
        "service-center-admin-organization-resources-cars-tab": "Biler",
        "service-center-admin-organization-resources-table-header-name": "Navn",
        "service-center-admin-organization-resources-table-room-header-id": "Lokalenr.",
        "service-center-admin-organization-resources-table-mobile-av-header-id": "Serienr.",
        "service-center-admin-organization-resources-table-cars-header-id": "Reg.nr.",
        "service-center-admin-organization-resources-table-header-status": "Status",
        "service-center-admin-organization-resources-table-edit-item": "Rediger",
        "service-center-admin-organization-resources-table-delete-item": "Slet",
        "service-center-admin-organization-resources-table-room-delete-modal-title": "lokale",
        "service-center-admin-organization-resources-table-mobile-av-equipment-delete-modal-title": "mobilt AV-udstyr",
        "service-center-admin-organization-resources-table-car-delete-modal-title": "bil",

        "service-center-admin-organization-resources-create-room": "Lokale",
        "service-center-admin-organization-resources-create-car": "Bil",
        "service-center-admin-organization-resources-status-not-approved": "Ikke godkendt",
        "service-center-admin-organization-resources-status-approved": "Godkendt",
        "service-center-admin-organization-resources-status-rejected": "Afvist",
        "service-center-admin-organization-resources-status-locked": "Låst",
        "service-center-admin-organization-resources-status-preparing": "Forbereder",
        "service-center-admin-organization-resources-status-delivered": "Leveret",
        "service-center-admin-organization-resources-status-to-be-booked": "Skal bookes",
        "service-center-admin-organization-resources-status-booked": "Bogført",
        "service-center-admin-organization-resources-status-completed": "Udført",

        "service-center-admin-organization-resources-status-menu-not-approved": "Forkast godkendelse",
        "service-center-admin-organization-resources-status-menu-approved": "Godkend",
        "service-center-admin-organization-resources-status-menu-rejected": "Afvis",
        "service-center-admin-organization-resources-status-menu-locked": "Lås",
        "service-center-admin-organization-resources-status-menu-preparing": "Forbered",
        "service-center-admin-organization-resources-status-menu-delivered": "Leveret",
        "service-center-admin-organization-resources-status-menu-booked": "Bogfør",
        "service-center-admin-organization-resources-status-menu-ready": "Klar",
        "service-center-admin-organization-resources-status-menu-completed": "Fuldfør",
        "service-center-admin-organization-resources-status-menu-default": "Ingen status",

        // Service center > Admin > Organization > Resources > Create Mobile AV
        "service-center-admin-organization-resources-create-mobile-av-title": "\n .title = Opret Mobile AV",
        "service-center-admin-organization-resources-update-mobile-av-title": "\n .title = Opdater Mobile AV",
        "resources-create-edit-mobile-av-general-tab-error": "Fanen Generelt har valideringsfejl",

        // Service center > Admin > Organization > Resources > Create car
        "service-center-admin-organization-resources-create-car-title": "\n .title = Opret bil",
        "service-center-admin-organization-resources-update-car-title": "\n .title = Opdater bil",
        "resources-create-edit-car-general-tab-error": "Fanen Generelt har valideringsfejl",

        // Service center > Admin > Organization > Resources > Create car > General
        "resources-create-edit-car-general-tab-general": "Stamdata",
        "resources-create-car-tab-general-registration-number-label": "\n .label = Registreringsnummer",
        "resources-create-car-tab-general-name-label": "\n .label = Betegnelse",
        "resources-create-car-tab-general-description-label": "\n .label = Beskrivelse",
        "resources-create-car-tab-general-car-type-label": "\n .label = Biltype",
        "resources-create-car-tab-general-location-of-keys-label": "\n .label = Nøglelokation",
        "resources-create-car-tab-general-parking-location-label": "\n .label = Standard parkeringslokation",
        "resources-create-car-tab-general-active-label": "Aktiv:",
        "resources-create-car-tab-general-in-service-label": "I drift:",
        "resources-create-car-tab-general-side-settings": "\n .title = Indstillinger",

        // Service center > Admin > Organization > Resources > Create Mobile AV > General
        "resources-create-edit-mobile-av-general-tab-general": "Generelt",
        "resources-create-mobile-av-tab-general-serial-number-label": "\n .label = Serienr",
        "resources-create-mobile-av-tab-general-name-label": "\n .label = Betegnelse",
        "resources-create-mobile-av-tab-general-floor-label": "\n .label = Sal",
        "resources-create-mobile-av-tab-general-description-label": "\n .label = Beskrivelse",
        "resources-create-mobile-av-tab-general-storage-location-label": "\n .label = Opbevaringssted",
        "resources-create-mobile-av-tab-general-cleanup-buffer-label": "\n .label = Afrydningsbuffer",
        "resources-create-mobile-av-tab-general-color-code-label": "\n .label = Farvekode",
        "resources-create-mobile-av-tab-general-active-label": "Aktiv:",
        "resources-create-mobile-av-tab-general-side-settings": "\n .title = Indstillinger",

        // Service center > Admin > Organization > Resources > Create room
        "service-center-admin-organization-resources-create-room-title": "\n .title = Opret lokale",
        "resources-create-edit-room-general-tab-error": "Fanen Generelt har valideringsfejl",

        // Service center > Admin > Organization > Resources > Create room > General
        "resources-create-edit-room-general-tab-general": "Generelt",
        "resources-create-room-tab-general-room-number-label": "\n .label = Lokalenummer",
        "resources-create-room-tab-general-name-label": "\n .label = Navn",
        "resources-create-room-tab-general-description-label": "\n .label = Beskrivelse",
        "resources-create-room-tab-general-seats-label": "\n .label = Pladser",
        "resources-create-room-tab-general-active-label": "Aktiv:",
        "resources-create-room-tab-general-other-location-description": `\n .title = Marking a room as "Other location" will allow the user to type an ad-hoc location to hold the meeting such as their office.`,
        "resources-create-room-tab-general-other-location-label": "Anden lokation:",
        "resources-create-room-tab-general-side-settings": "\n .title = Indstillinger",
        "resources-create-room-tab-general-floor-label": "\n .label = Sal",
        "resources-create-room-tab-general-walk-direction-label": "\n .label = Gangretning",
        "resources-create-room-tab-general-walk-direction-north": "Nord",
        "resources-create-room-tab-general-walk-direction-east": "Øst",
        "resources-create-room-tab-general-walk-direction-south": "Syd",
        "resources-create-room-tab-general-walk-direction-west": "Vest",
        "resources-create-room-tab-general-color-red": "Rød",
        "resources-create-room-tab-general-color-green": "Grøn",
        "resources-create-room-tab-general-color-blue": "Blå",
        "resources-create-room-tab-general-color-black": "Sort",
        "resources-create-room-tab-general-color-lightblue": "Lyseblå",
        "resources-create-room-tab-general-tags-label":  "\n .label = Tags",
        "resources-create-room-tab-general-tags-info-description":  `\n .label = Create one or more tags to be used for filtering resources. For example "External meeting room", "Guest meeting room", "Conference room", "Call room" etc.`,
        "resources-create-room-tab-general-fixed-av-equipment-label":  "\n .label = Fast AV-udstyr",
        "resources-create-room-tab-general-side-filter-details": "\n .title = Filterdetaljer",
        "resources-create-room-tab-general-area-label": "\n .label = Areal (m²) \n .placeholder = Lokalets areal i m²",
        "resources-create-room-tab-general-cleanup-buffer-label": "\n .label = Afrydningsbuffer",
        "resources-create-room-tab-general-color-code-label": "\n .label = Farvekode",
        "resources-create-room-tab-general-email-address-label": "\n .label = E-mailadresse",
        "resources-create-room-tab-general-side-integrations": "\n .title = Kalenderintegration",
        "resources-create-room-tab-general-side-integrations-meeting-invite": "\n .description = Bruges til integration med Exchange eller andre kalendersystemer. E-mailadressen tilføjes til mødeindkaldelsen af FacilityNet Outlook Add-in, når lokalet bookes.",
        "resources-create-room-tab-general-side-integrations-starleaf": "\n .description =Bruges til integration med StarLeaf-udstyr, der leveres med en dedikeret e-mailadresse til integration.",
        "resources-create-room-tab-general-side-integrations-ews": "\n .description = Bruges til integration med udstyr, der læser fra en kalender. Postkassens kalender bookes ved hjælp af en EWS-servicekonto, når lokalet bookes.",

        "resources-create-room-tab-general-book-using-ews": "Book med EWS",

        // Service center > Admin > Organization > Resources > Create room > Table arrangements
        "resources-create-edit-room-general-tab-table-arrangements": "Bordopstillinger",
        "service-center-reports-dashboard-meeting-filter-mobile-av": "Mobilt AV",
        "service-center-reports-dashboard-meeting-filter-set-tables": "Opdækning",
        "service-center-reports-dashboard-meeting-filter-cleanup": "Afrydning",
        "tab-table-arrangements-standard": "Standard",
        "tab-table-arrangements-optional-chip": "Valgfri",
        "tab-table-arrangements-make-standard-button": "Gør til standard",
        "tab-table-arrangements-add-new-card": "Tilføj ny bordopstilling",
        "tab-table-arrangements-label-meeting-room": "Mødelokale",
        "tab-table-arrangements-label-cinema": "Biograf",
        "tab-table-arrangements-label-u-form": "U-form",
        "tab-table-arrangements-label-school": "Skole",
        "tab-table-arrangements-label-group": "Gruppe",
        "tab-table-arrangements-label-negotiation": "Forhandling",
        "tab-table-arrangements-label-cafe": "Café",
        "tab-table-arrangements-label-conference": "Konference",
        "tab-table-arrangements-label-herringbone": "Sildeben",
        "tab-table-arrangements-create-dialog-title": "Ny bordopstilling",
        "tab-table-arrangements-create-dialog-name-label": "\n .label = Navn",
        "tab-table-arrangements-create-dialog-image-label": "Billede",
        "tab-table-arrangements-create-dialog-submit-button": "Opret",
        "tab-table-arrangements-create-dialog-name-required-error": "Navn er påkrævet",
        "tab-table-arrangements-create-dialog-image-required-error": "Billede er påkrævet",

        // Service center > Admin > Organization > Resources > Create room > Notifiations
        "resources-create-edit-room-general-tab-table-header-type": "Type",
        "resources-create-edit-room-general-tab-table-header-sent": "Sendt",
        "resources-create-edit-room-general-tab-table-header-content": "Indhold",

        // Service center > Admin > Organization > Resources > Create room > Availability
        "resources-create-edit-room-general-tab-availability": "Tilgængelighed",
        "tab-availability-closed-periods-title": "Utilgængelig periode",
        "tab-availability-table-start-header": "Start",
        "tab-availability-table-end-header": "Slut",
        "tab-availability-table-reason-header": "Årsag",
        "tab-availability-table-edit-action": "Rediger",
        "tab-availability-table-delete-action": "Slet",
        "tab-availability-add-closed-period-action": "Tilføj utilgængelig periode",
        "tab-availability-side-daily-closing-times-title": "\n .title = Daglige lukketider",
        "tab-availability-side-daily-booking-times-title": "\n .title = Daglige bookingtimer",
        "tab-availability-booking-time-option-all-day": "\n .label = Tilgængelig hele dagen",
        "tab-availability-booking-time-option-specific-hours": "\n .label = Kun tilgængelig i bestemte timer",
        "tab-availability-booking-time-option-daily-break": "\n .label = Utilgængelig under en daglig pause",
        "tab-availability-booking-time-from-label": "\n .label = Fra",
        "tab-availability-booking-time-to-label": "\n .label = Til",
        "tab-availability-side-start-time-label": "\n .label = Starttid",
        "tab-availability-side-end-time-label": "\n .label = Sluttid",
        "tab-availability-modal-reason-label": "\n .label = Årsag",
        "tab-availability-modal-reason-max": "Årsag må højst være { $max } tegn",
        "tab-availability-modal-title": "Tilføj lukket periode",
        "tab-availability-modal-add-button": "Tilføj",

        "tab-availability-add-reminder-dialog-title": "Tilføj påmindelse",
        "tab-availability-add-reminder-edit-dialog-title": "Rediger påmindelse",
        "tab-availability-add-reminder-dialog-field-type-label": "\n .label = Type",
        "tab-availability-add-reminder-dialog-field-time-label": "\n .label = Sendt",
        "tab-availability-add-reminder-dialog-field-text-label": "\n .label = Tekst",
        "tab-availability-add-reminder-dialog-text-max": "Teksten må højst være { $max } tegn",
        "tab-availability-add-reminder-dialog-submit-button-label": "Tilføj",

        "tab-availability-add-reminder-dialog-form-time-suffix-hours-before": "timer før mødestart",
        "tab-availability-add-reminder-dialog-form-time-suffix-minutes-before": "minutter før mødestart",
        "tab-availability-add-reminder-dialog-form-time-suffix-hours-after": "timer efter mødeslut",
        "tab-availability-add-reminder-dialog-form-time-suffix-minutes-after": "minutter efter mødeslut",

        "reminder-type-option-meeting-start": "Påmindelse om mødestart",
        "reminder-type-option-first-reminder": "Første påmindelse",
        "reminder-type-option-preparation": "Forberedelse",
        "reminder-type-option-cleanup": "Oprydning",
        "reminder-type-option-custom-reminder": "Tilpasset påmindelse",
        "reminder-type-option-meeting-confirmation": "Mødebekræftelse",

        "integration-type-option-none": "Ingen",
        "integration-type-option-meeting-invite": "Mødeinvitation",
        "integration-type-option-ews": "EWS",
        "integration-type-option-starleaf": "Starleaf",

        // Service center > Admin > Organization > Resources > Create room > Access control
        "resources-create-edit-room-general-tab-access-control": "Adgangskontrol",
        "tab-access-control-restricted-access-title": "\n .title =Begrænset adgang",
        "tab-access-control-visible-everyone-switch":'Visible for everyone',
        "tab-access-control-reserved-for-company-title":"Reserveret til virksomhed:",
        "tab-access-control-bookable-by-departments-title":"Kan bookes af afdelinger:",
        "tab-access-control-select-department-select-item":"Vælg en afdeling",
        "tab-access-control-add-button":"Tilføj",


        // Service center > Admin > Account > Admins
        "service-center-admin-account-admins-page-header": "\n .title = Administratorer",
        "service-center-admin-account-admins-table-header-name":"Navn",
        "service-center-admin-account-admins-table-header-email":"Email",
        "service-center-admin-account-admins-table-header-status":"Status",
        "service-center-admin-account-admins-table-status-active":"Aktiv",
        "service-center-admin-account-admins-table-status-inactive": "Inaktiv",
        "service-center-admin-account-admins-table-button-details": "Vis detaljer",
        "service-center-admin-account-admins-table-button-edit": "Ret bruger",
        "service-center-admin-account-admins-table-button-delete": "Slet bruger",
        "service-center-admin-account-admins-delete-dialog-entity-type": "bruger",
        "service-center-admin-account-admins-button-create": "Opret ny",

        // Service center > Admin > Organization > Manage bookings
        "service-center-admin-organization-manage-bookings-page-header": "\n .title = Administrer ordrer",
        "service-center-admin-organization-manage-bookings-breadcrumb": "Administrer ordrer",
        "service-center-admin-organization-manage-bookings-confirm-button": "Fortsæt",
        "service-center-admin-organization-manage-bookings-action-move": "Flyt til ny ejer",
        "service-center-admin-organization-manage-bookings-action-delete": "Slet",
        "service-center-admin-organization-manage-bookings-select-action": "\n .label = Vælg handling:",
        "service-center-admin-organization-manage-bookings-select-action-placeholder": "Vælg",
        "service-center-admin-organization-manage-bookings-select-company": "\n .label = Vælg virksomhed:",
        "service-center-admin-organization-manage-bookings-select-user": "\n .label = Vælg bruger:",
        "service-center-admin-organization-manage-bookings-select-new-owner": "\n .label = Vælg ny ejer:",
        "service-center-admin-organization-manage-bookings-what-to-move-label": "Hvad skal flyttes:",
        "service-center-admin-organization-manage-bookings-what-to-delete-label": "Hvad skal slettes:",
        "service-center-admin-organization-manage-bookings-current-owner-title": "Nuværende ejer",
        "service-center-admin-organization-manage-bookings-new-owner-title": "Ny ejer",
        "service-center-admin-organization-manage-bookings-checkbox-bookings": "Bookinger",
        "service-center-admin-organization-manage-bookings-checkbox-meeting-service": "Mødeforplejningsordrer",
        "service-center-admin-organization-manage-bookings-error-company-required": "Virksomhed er påkrævet",
        "service-center-admin-organization-manage-bookings-error-user-required": "Bruger er påkrævet",
        "service-center-admin-organization-manage-bookings-error-action-required": "Handling er påkrævet",
        "service-center-admin-organization-manage-bookings-error-new-owner-required": "Ny bookingejer er påkrævet",
        "service-center-admin-organization-manage-bookings-error-at-least-one-option": "Vælg mindst én mulighed",
        "service-center-admin-organization-manage-bookings-alert-move": "\n .title = Ordrer flyttes til ny ejer, som du vælger nedenfor.",
        "service-center-admin-organization-manage-bookings-alert-delete": "\n .title = Alle fremtidige bookinger for denne bruger vil blive annulleret.",
        "service-center-admin-organization-manage-bookings-confirm-modal-move-title": "Flyt ordrer",
        "service-center-admin-organization-manage-bookings-confirm-modal-delete-title": "Slet ordrer",
        "service-center-admin-organization-manage-bookings-confirm-modal-move-message": "Bekræft venligst, at du vil flytte { $count } ordrer.",
        "service-center-admin-organization-manage-bookings-confirm-modal-delete-message": "Bekræft venligst, at du vil slette { $count } ordrer.",
        "service-center-admin-organization-manage-bookings-confirm-modal-move-no-orders": "Der er ingen ordrer at flytte.",
        "service-center-admin-organization-manage-bookings-confirm-modal-delete-no-orders": "Der er ingen ordrer at slette.",
        "service-center-admin-organization-manage-bookings-confirm-modal-from": "Fra: { $name }",
        "service-center-admin-organization-manage-bookings-confirm-modal-user": "Bruger: { $name }",
        "service-center-admin-organization-manage-bookings-confirm-modal-to": "Til: { $name }",
        "service-center-admin-organization-manage-bookings-confirm-modal-user-id-tooltip": "\n .title = Internt bruger-ID",
        "service-center-admin-organization-manage-bookings-confirm-modal-submit-button": "Bekræft",
        "service-center-admin-organization-manage-bookings-confirm-modal-cancel-button": "Annuller",
        "service-center-admin-organization-manage-bookings-confirm-modal-close-button": "Luk",
        "service-center-admin-organization-manage-bookings-confirm-modal-excluded-orders": "\n .title = { $count } ordrer ekskluderet: { $reason }",
        "service-center-admin-organization-manage-bookings-success-modal-move-title": "Ordrer flyttet",
        "service-center-admin-organization-manage-bookings-success-modal-delete-title": "Ordrer slettet",
        "service-center-admin-organization-manage-bookings-submit-missing-data-error": "Manglende påkrævede data, prøv venligst igen",
        "service-center-admin-organization-manage-bookings-user-no-results": "Ingen brugere fundet",
        "service-center-admin-organization-manage-bookings-select-placeholder": "Vælg",

        // Product availability
        "product-unavailable-dialog-close": "Luk",
        "product-unavailable-snackbar": "Dette produkt er ikke tilgængeligt i øjeblikket",
        "product-daily-limit-exceeded-snackbar": "Daglig købsgrænse nået for dette produkt",
        "product-stock-limit-exceeded-snackbar": "Ikke nok varer på lager",
        "product-stock-negative-error": "Lagerbeholdning kan ikke være negativ",

        // Order chat
        "order-chat-drawer-title-customer": "Chat med kantinen",
        "order-chat-drawer-title-merchant": "Chat med kunden",
        "order-chat-disclaimer-text": "Denne chat bruges til at kommunikere om ordren. Beskeder vil ikke fremgå på ordrespecifikationen.",
        "order-chat-disclaimer-warning": "OBS: Undgå at indtaste personfølsomme oplysninger, f.eks. om du er vegetar, har allergier.",
        "order-chat-disclaimer-link": "Læs mere <a>her</a>.",
        "order-chat-disclaimer-accept": "Forstået",
        "order-chat-placeholder-merchant": "Besked til kunde...",
        "order-chat-placeholder-customer": "Besked til kantinen...",
        "order-chat-empty": "\n .title = Ingen beskeder endnu\n .description = Start samtalen!",
        "order-chat-exceeded-characters": "Maksimalt { $limit } tegn overskredet",
        "order-chat-menu-item-customer": "Chat med kantinen",
        "order-chat-menu-item-merchant": "Chat med kunden",
        "order-chat-tooltip-needs-response": "Ny besked - kræver svar",
        "order-chat-tooltip-responded": "Chat",
        "order-chat-history-print-with-button": "Udskriv med chathistorik",
        "order-chat-history-print-without-button": "Udskriv",
        "meeting-service-print-view-order-menu-print-button": "Udskriv (med ordrenote)",
        "meeting-service-print-view-order-menu-print-with-chat-button": "Udskriv (med ordrenote og chat)",
        "meeting-service-print-view-order-menu-print-section-title": "Udskriv ordre",
        "order-chat-history-print-title": "Chathistorik",
        "order-chat-status-card-messages-badge": "\n .label = { $count -> \n [one] { $count } besked \n *[other] { $count } beskeder \n }",
        "order-chat-status-card-reply-own": "Du svarede den { $date } kl. { $time }: <quote>“{ $message }”</quote>",
        "order-chat-status-card-reply-user": "Kunden svarede den { $date } kl. { $time }: <quote>“{ $message }”</quote>",
        "order-chat-status-card-reply-merchant": "Kantinen svarede den { $date } kl. { $time }: <quote>“{ $message }”</quote>",
    },
    "nb-NO": {
        // Preferred hour cycle for locale
        // NOTE: Only necessary to specify if default for country/region from CLDR supplementary data used by browser Intl API is incorrect
        // See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle
        // See: https://github.com/unicode-org/cldr/blob/master/common/supplemental/supplementalData.xml#L4768
        "date-time-hour-cycle": "h23",

        // Date and time formats as Luxon format strings
        // See: https://moment.github.io/luxon/docs/manual/formatting.html#table-of-tokens
        "date-time-format-date": "dd.MM.yyyy",
        "date-time-format-long-date": "d. MMMM yyyy",
        "date-time-format-month-day": "d. MMM",
        "date-time-format-weekday-long-date": "EEEE d. MMMM yyyy",
        "date-time-format-day-and-date": "EEEE dd.MM",
        "date-time-format-time": "HH:mm",
        "date-time-format-time-hms": "HH:mm:ss",
        "date-time-format-date-and-time": "dd.MM.yyyy HH:mm",
        "date-time-format-duration-hours-minutes": "h't.' m'min.'",
        "date-time-format-duration-minutes": "m'min.'",
        "date-time-format-duration-seconds": "s's'",
        "date-time-compact-period-start": "d.M-yy 'kl.' HH:mm",
        "date-time-short-relative-units": "s|m|t|d|u|mnd|år",
        "date-time-invalid-date": "I/T",

        // Money formats
        "money-amount-unit-month": "mnd.",
        "money-amount-unit-year": "år",

        // Numeric field validation
        "numeric-field-invalid-error": "{ $label } må være et tall",
        "numeric-field-integer-error": "{ $label } må være et heltall",
        "numeric-field-positive-error": "{ $label } må være større enn 0",
        "numeric-field-non-negative-error": "{ $label } må være 0 eller høyere",
        "numeric-field-negative-error": "{ $label } må være mindre enn 0",
        "numeric-field-non-positive-error": "{ $label } må være 0 eller lavere",
        "vat-code-vat-percentage-field-name": "MVA-prosent",
        "price-list-percentage-field-name": "Prosentsats",

        // User types
        "-user-type-support": "Support",
        "-user-type-supplier": "Kantineoperatør",
        "-user-type-merchant": "Butikkeier",
        "-user-type-company": "Firmaadministrator",
        "-user-type-office-manager": "Kontorleder",
        "-user-type-user": "Bruker",
        "-user-type-service-center": "Servicesenter",


        // Shared components
        "error-boundary-modal": "\n .title = Noe gikk galt\n .message = Feilkode: { $errorCode }\n .buttonLabel = Lukk vinduet",
        "query-error-boundary": "\n .title = Noe gikk galt\n .message = Feilkode: { $errorCode }\n .buttonLabel = Prøv igjen",
        "confirmation-dialog-cancel": "Avbryt",
        "confirmation-dialog-approve": "Godkjenn",
        "coming-soon-dialog-title": "Kommer snart",
        "coming-soon-dialog-message": "Vi jobber med å levere denne funksjonen til deg.",
        "coming-soon-dialog-ok-button": "OK",
        "meeting-time-label-today": "I dag kl. { $period }",
        "meeting-time-label-tomorrow": "I morgen kl. { $period }",
        "meeting-time-label-yesterday": "I går kl. { $period }",
        "meeting-time-label-date": "{ $date } kl. { $period }",
        "error-dialog-show-details-label": "Vis detaljer",
        "error-dialog-close-button": "Lukk",
        "error-dialog-support-request": "Kontakt <supportMessage>support@facilitynet.dk</supportMessage> hvis problemet vedvarer.",
        "error-route": "\n .title = Noe gikk galt \n .message Denne siden kan ikke vises på grunn av en ukjent feil \n .buttonLabel = Gå til forsiden",
        "time-or-date-picker-time-label": "Tid",
        "api-call-timeout-message": "Forespørselen tar lengre tid enn forventet",
        "api-call-generic-success": "Handlingen ble gjennomført",

        // authenticate common texts
        "-authenticate-submit-button": "Neste",

        // --- Error boundaries ---
        "app-error-boundary": "\n .title = Noe gikk galt\n .buttonLabel = Lukk vinduet",
        "app-error-boundary-title": "Noe gikk galt",
        "app-error-boundary-button": "Lukk vinduet",
        "route-error-boundary": "\n .title = Noe gikk galt\n .buttonLabel = Gå til Hjem",
        "inline-error-boundary-message": "Kunne ikke gjengi komponenten",
        "inline-error-boundary-calendar-event-message": "Kunne ikke tolke hendelsen",
        "query-error-boundary-message": "Feil ved innlasting av data.",
        "query-error-boundary-no-data-message": "Ingen data.",
        "query-error-boundary-retry-button": "Prøv igjen",


        // --- Language selector ---
        "language-selector-lang-en-us": "Engelsk",
        "language-selector-lang-da-dk": "Dansk",
        "language-selector-lang-nb-no": "Norsk",
        "language-selector-lang-sv-se": "Svensk",


        // --- Footer ---
        "footer-read-more": "Les mer på <linkElem>{ $linkName }</linkElem>",


        // --- Avatar menu ---
        "avatar-menu-menu-item-help": "Hjelp",
        "avatar-menu-menu-item-merchant-tour": "Omvisning",
        "avatar-menu-menu-item-news": "Facilitynet-nyheter",
        "avatar-menu-menu-item-profile": "Brukerkonto",
        "avatar-menu-menu-item-archive": "Arkiv",
        "avatar-menu-menu-item-change-user-account": "Bytt brukerkonto",
        "avatar-menu-menu-item-swift-merchant": "Bytt salgssted",
        "avatar-menu-menu-item-settings": "Innstillinger",
        "avatar-menu-menu-item-logout": "Logg ut",
        "avatar-menu-menu-item-system-status": "Systemstatus",
        "avatar-menu-tooltip-profile": "\n .title = Vis brukerkontoen din",
        "avatar-menu-tooltip-settings": "\n .title = Endre innstillinger for brukerkontoen din",
        "avatar-menu-tooltip-change-user-account": "\n .title = Hvis du har flere brukerkontoer, kan du bytte mellom dem her",
        "avatar-menu-tooltip-switch-merchant": "\n .title = Hvis du har tilgang til flere salgssteder, kan du bytte mellom dem her",
        "avatar-menu-tooltip-news": "\n .title = Les nyheter fra Facilitynet",
        "avatar-menu-tooltip-help": "\n .title = Få hjelp til å bruke systemet",
        "avatar-menu-tooltip-merchant-tour": "\n .title = Start omvisningen",
        "avatar-menu-tooltip-system-status": "\n .title = Vis og abonner på viktige meldinger om systemet",
        "avatar-menu-tooltip-logout": "\n .title = Logg ut av systemet",


        // --- Confirm dialogs ---
        "confirm-modal-confirm-label": "Er du sikker?",
        "delete-confirm-modal-title": "Slett { $itemType }",
        "delete-confirm-modal-question": "Er du sikker på at du vil slette '{ $itemName }'?",
        "delete-confirm-modal-button-delete": "Slett",
        "delete-confirm-modal-button-cancel": "Avbryt",
        "delete-confirm-modal-button-submit": "Send",
        "cancel-subscription-modal-title": "Si opp abonnement",
        "cancel-subscription-modal-message": "Er du sikker på at du vil si opp abonnementet '{ $subscriptionName }' for { $customerName }?",
        "cancel-subscription-modal-label-ignore-terms": "\n .label = Med umiddelbar virkning",
        "cancel-subscription-modal-helper-text-ignore-terms": "Dette setter abonnementsvilkårene til side.",
        "cancel-subscription-modal-button-delete": "Si opp",


        // --- Not found ---
        "not-found-title": "Ikke funnet",
        "not-found-explanation": "Siden du leter etter finnes ikke.",
        "not-found-path-label": "Sti:",
        "not-found-go-home-button": "Gå til forsiden",


        // --- Access denied ---
        "access-denied-title": "Ingen tilgang",
        "access-denied-explanation": "Brukerprofilen din har ikke tilgang til denne siden.",
        "access-denied-required-usertype-label": "Påkrevd brukertype:",
        "access-denied-actual-usertype-label": "Din brukertype:",
        "access-denied-path-label": "Sti:",
        "access-denied-go-home-button": "Gå til forsiden",
        "access-denied-logout-button": "Logg ut",

        "access-denied-usertype-support": "{ -user-type-support }",
        "access-denied-usertype-supplier": "{ -user-type-supplier }",
        "access-denied-usertype-merchant": "{ -user-type-merchant }",
        "access-denied-usertype-company": "{ -user-type-company }",
        "access-denied-usertype-office-manager": "{ -user-type-office-manager }",
        "access-denied-usertype-unknown": "Ukjent",


        "login-email-label": "Logg inn",
        "login-password-label": "Skriv inn passordet ditt",
        "login-email-field-label": "\n .label = E-post",
        "test": "Test",
        "bottom-menu-item-home": "\n .label = Hjem",
        "bottom-menu-item-profile": "\n .label = Profil",

        "confirm-email-button": "Bekreft\n .loadingLabel = Bekrefter...",
        "confirm-email-description": "Følgende brukerkontoer er alle registrert med e-postadressen <email>{ $email }</email> og kan bytte konto. Pass på at de alle tilhører deg:",
        "confirm-email-title": "Bekreft kontotilgang",
        "confirm-email-success-message": "Du kan nå bytte mellom brukerkontoene dine",
        "confirm-email-error-message": "Vi kunne ikke bekrefte e-postadressen din",
        "confirm-email-missing-userid-or-otp": "Mangler bruker-ID eller otp",

        "purchases-payment-method-free": "Gratis",
        "purchases-payment-method-credit-card": "Kredittkort",
        "purchases-payment-method-one-click-payment": "Kredittkort",
        "purchases-payment-method-mobile-pay": "MobilePay",
        "purchases-payment-method-payroll-deduction": "Lønnstrekk",
        "purchases-payment-method-lunch-registration": "Lunsjordning",
        "purchases-payment-method-gopay-wallet": "GoPay Wallet",
        "purchases-payment-method-invoice": "Faktura",
        "purchases-payment-method-cash": "Kontant",
        "purchases-payment-method-gopay-account": "GoPay Wallet",
        "purchases-payment-method-refund": "Refundert",
        "purchases-payment-method-subscribe-payment-card": "Registrer betalingskort",
        "purchases-payment-method-id-card": "ID-kort",

        // --- Error handling ---
        "api-call-error-title-unknown-error": "Ukjent feil",
        "api-call-error-title-network-error": "Nettverksfeil",
        "api-call-error-title-bad-request": "Forespørsel avvist",
        "api-call-error-title-unauthorized": "Ugyldig innlogging",
        "api-call-error-title-forbidden": "Ingen tilgang",
        "api-call-error-title-not-found": "Ikke funnet",
        "api-call-error-title-conflict": "Konflikt",
        "api-call-error-title-too-many-requests": "For mange forespørsler",
        "api-call-error-title-internal-server-error": "Intern serverfeil",
        "api-call-error-title-service-unavailable": "Tjenesten er utilgjengelig",
        "api-call-error-title-request-failed": "Forespørselen mislyktes",
        "api-call-error-unknown-error": "Ukjent feil",
        "api-call-error-no-internet-connection": "Ingen internettforbindelse",
        "api-call-error-could-not-reach-server": "Kunne ikke nå serveren",
        "api-call-error-protocol-error": "Serverfeil: { $responseCode } { $responseStatus }",
        "api-call-error-api-returned-error": "Uventet serverfeil",
        "api-call-error-response-not-json": "Uventet svar fra serveren",
        "api-call-error-retry-button": "Prøv igjen",


        // --- Receipts ---

        // Page
        "receipt-title": "Kvittering",

        // Payment methods
        "receipt-payment-method-free": "Gratis",
        "receipt-payment-method-credit-card": "Kredittkort",
        "receipt-payment-method-one-click-payment": "Kredittkort",
        "receipt-payment-method-mobile-pay": "MobilePay",
        "receipt-payment-method-payroll-deduction": "Lønnstrekk",
        "receipt-payment-method-lunch-registration": "Lunsjordning",
        "receipt-payment-method-gopay-account": "GoPay Wallet",
        "receipt-payment-method-gopay-wallet": "GoPay Wallet",
        "receipt-payment-method-invoice": "Faktura",
        "receipt-payment-method-cash": "Kontant",
        "receipt-payment-method-id-card": "ID-kort",

        // Purchase section
        "receipt-purchase-details-section": "\n .heading = Kjøpsdetaljer",
        "receipt-purchase-payment-status-paid": "BETALT",
        "receipt-purchase-payment-status-unpaid": "IKKE BETALT",
        "receipt-purchase-payment-status-invoiced": "FAKTURERT",
        "receipt-purchase-payment-status-refunded": "REFUNDERT",
        "receipt-purchase-payment-status-cancelled": "REFUNDERT",
        "receipt-purchase-payment-status-failed": "FEILET",
        "receipt-purchase-address-item": "\n .label = Kjøpssted:",
        "receipt-purchase-seller-vat-number": "Org.nr.:\u00A0{ $vatNumber }",
        "receipt-purchase-customer-item": "\n .label = Kunde:",
        "receipt-purchase-employee-id-item": "\n .label = Ansatt-ID:",
        "receipt-purchase-company-item": "\n .label = Firma:",
        "receipt-purchase-time-item": "\n .label = Kjøpstidspunkt:",
        "receipt-purchase-payment-method-item": "\n .label = Betalingsmåte:",
        "receipt-purchase-order-id-item": "\n .label = Ordre-ID:",
        "receipt-purchase-shop-channel-item": "\n .label = Via:",
        "receipt-purchase-receipt-error": "Kunne ikke laste inn ordre med ID #{ $orderId }",
        "receipt-purchase-receipt-error-description": "Denne ordren kunne ikke behandles på grunn av manglende eller ugyldige data.",

        // Delivery section
        "receipt-delivery-details-section": "\n .heading = Levering",
        "receipt-delivery-order-type-item": "\n .label = Ordretype:",
        "receipt-order-type-catering": "Møteservering",
        "receipt-order-type-lunch": "Lunsj",
        "receipt-order-type-takeaway": "Takeaway",
        "receipt-order-type-take-away": "Takeaway",
        "receipt-order-type-refill-account": "Wallet-påfyll",
        "receipt-order-type-auto-refill-account": "Automatisk påfyll-abonnement",
        "receipt-order-type-lunch-subscription": "Abonnement",
        "receipt-order-type-subscribe-payment-card": "Registrering av betalingskort",
        "receipt-order-type-meeting": "Møte",
        "receipt-order-type-refund": "Refusjon",
        "receipt-delivery-type-item": "\n .label = Leveringstype:",
        "receipt-delivery-type-pick-up": "Henting",
        "receipt-delivery-type-take-away": "Takeaway",
        "receipt-delivery-location-item": "\n .label = Leveringssted:",
        "receipt-delivery-pickup-location-item": "\n .label = Hentested:",
        "receipt-delivery-time-item": "\n .label = Leveringstid:",
        "receipt-delivery-pickup-time-item": "\n .label = Hentetidspunkt:",
        "receipt-delivery-comment-item": "\n .label = Kommentar:",

        // Order details section
        "receipt-order-details-buyerparty-private": "Privatkjøp",
        "receipt-order-details-buyerparty-company": "Firmakjøp",
        "receipt-order-details-payment-method-item": "\n .label = Betalingsmåte:",
        "receipt-order-details-total": "\n .label = Totalt:",
        "receipt-order-details-vat-total": "\n .label = MVA utgjør (25%):",

        // Subscription details section
        "receipt-subscription-details-section": "\n .heading = Abonnement",
        "receipt-subscription-details-subscription-id": "\n .label = Abonnements-ID:",
        "receipt-subscription-details-subscription-name": "\n .label = Abonnementsnavn:",
        "receipt-subscription-details-subscription-valid-from": "\n .label = Gyldig fra:",
        "receipt-subscription-details-subscription-valid-to": "\n .label = Gyldig til:",
        "receipt-subscription-details-subscription-price": "\n .label = Abonnementspris:",

        // Actions section
        "receipt-actions-forward-receipt-button": "Send kvittering",
        "receipt-actions-cancel-order-button": "Refunder bestilling",
        "receipt-actions-confirm-cancel-dialog": "\n .description = Du er i ferd med å refundere denne bestillingen. Er du sikker?\n .confirmLabel = Ja\n .cancelLabel = Nei\n .loadingDescription = Refunderer bestilling...",
        "receipt-actions-cancel-disabled-dialog": "\n .title = Refusjon er ikke tilgjengelig\n .message = Denne funksjonen er ikke klar ennå. Den kommer senere.\n .buttonLabel = Forstått",
        "receipt-actions-cancel-unavailable-dialog": "\n .buttonLabel = Forstått",

        "receipt-order-label": "Kvittering #{ $orderId }, { $orderDate }",

        // Forward receipt
        "receipt-forward-receipt-dialog": "\n .title = { $receipts -> \n *[one] Send kvittering \n [other] Send kvitteringer \n } \n .cancelButtonLabel = Avbryt\n .submitButtonLabel = Send\n .submitButtonLoadingLabel = Sender...",
        "receipt-forward-receipt-email-field": "\n .label = E-postadresse",
        "receipt-forward-receipt-email-field-is-required": "E-postadresse må fylles ut",
        "receipt-forward-receipt-email-field-must-be-valid": "Ugyldig e-postadresse",


        // --- Login domain ---

        // login auth flow hook
        "auth-flow-authentication-result-server-error": "Klienten forventet at autentiseringen var fullført, men serveren svarte: { $action }.",
        "auth-flow-authentication-unexpected-server-error":  "Uventet autentiseringshandling { $action } i API-svaret",

        // Create password page
        "create-password-required": "Feltet er påkrevd",
        "create-password-password-invalid-for-policy": "Passordet følger ikke passordpolicyen",
        "create-password-new-required": "Feltet er påkrevd",
        "create-password-matching": "Passordene stemmer ikke overens",
        "create-password-title": "Nytt passord",
        "create-password-new-password-field": "\n .label = Nytt passord",
        "create-password-submit-button": "Tilbakestill passord",
        "create-password-confirm-password-field": "\n .label = Bekreft passord",
        "create-password-missing-token-title": "Feil",
        "create-password-missing-token-description": "Nødvendig token for å opprette passord er ikke oppgitt.",


        // Forgot password page
        "forgot-password-username-required": "Brukernavn er påkrevd",
        "forgot-password-username-title": "Glemt passord",
        "forgot-password-username-invalid": "Brukernavnet er ikke gyldig",
        "forgot-password-button-label": "Neste",
        "forgot-password-enter-username-field": "\n .label = Skriv inn e-postadressen eller brukernavnet ditt:",

        // SignInWithActivationCode page
        "sign-in-with-activation-code-min-length": "Aktiveringskoden må være minst 6 tegn lang",
        "sign-in-with-activation-code-required": "Aktiveringskode er påkrevd",
        "sign-in-with-activation-code-title": "Skriv inn aktiveringskoden din",
        "sign-in-with-activation-code-field-label": "\n .label = Aktiveringskode",
        "sign-in-with-activation-code-submit-button": "Neste",

        // SignInWithPassword page
        "sign-in-with-password-required": "Passord er påkrevd",
        "sign-in-with-password-title": "Skriv inn passordet ditt",
        "sign-in-with-password-field-label": "\n .label = Passord",
        "sign-in-with-password-submit-button": "Logg inn",
        "sign-in-with-password-reset-password-link": "Glemt passord",

        // SignInWithUsername page
        "sign-in-with-username-min-length": "Brukernavnet må være minst 3 tegn",
        "sign-in-with-username-required": "Brukernavn er påkrevd",
        "sign-in-with-username-title": "Logg inn",
        "sign-in-with-username-subtitle": " Velkommen til Facilitynet",
        "sign-in-with-username-field-label": "\n .label = Brukernavn\n .placeholder = Skriv inn brukernavnet ditt",
        "sign-in-with-username-remember-me": "Husk meg",
        "sign-in-with-username-submit-button": "Neste",
        "sign-in-with-username-reset-password-link": "Glemt passord?",

        // StartPageLayout
        "start-page-layout-title": "Din portal til møteplanlegging og kantinetjenester",
        "start-page-layout-sub-title-1": "Ta imot betalinger med POS og mobiltelefon",
        "start-page-layout-sub-title-2": "Få innsikt i salgstall med Facilitynet Manager",
        "start-page-layout-sub-title-3": "Bedre kommunikasjon mellom kjøkken og kunder",
        "start-page-layout-login-button-label": "Logg inn",

        // Login Layout
        "login-layout-card-title": "Facilitynet Manager",
        "login-layout-card-subtitle": "Kantineadministrasjon gjort enkelt",
        "auto-login-title":"Logger deg inn...",
        "auto-login-description":"Vent mens vi automatisk logger deg inn.",
        "auto-login-error-title":" otp-token ikke funnet",
        "auto-login-error-description":"  Du har mottatt en ugyldig lenke. Kontakt support.",

        // Invitation
        "invitation-title": "Opprett passordene dine til Facilitynet",
        "invitation-username-rules": "Brukernavnet må være minst 3 tegn langt.",
        "invitation-password-rules": "Passordet må være minst 8 tegn langt og inneholde en liten bokstav, en stor bokstav og et tall.",
        "invitation-usertype-support": "{ -user-type-support }",
        "invitation-usertype-supplier": "{ -user-type-supplier }",
        "invitation-usertype-merchant": "{ -user-type-merchant }",
        "invitation-usertype-company": "{ -user-type-company }",
        "invitation-usertype-office-manager": "{ -user-type-office-manager }",
        "invitation-usertype-unknown": "Ukjent brukertype",
        "invitation-field-username": "\n .label = Brukernavn",
        "invitation-field-password": "\n .label = Passord",
        "invitation-field-repeat-password": "\n .label = Gjenta passord",
        "invitation-submit-button": "Aktiver konto\n .loadingLabel = Aktiverer...",
        "invitation-field-username-required": "Brukernavn må fylles ut",
        "invitation-field-username-min-chars": "Brukernavnet må være minst { $minChars } tegn",
        "invitation-field-password-required": "Passord må fylles ut",
        "invitation-field-password-invalid-for-policy": "Passordet følger ikke passordpolicyen",
        "invitation-field-password-min-chars": "Passordet må være minst { $minChars } tegn",
        "invitation-field-password-contain-lowercase": "Passordet må inneholde en liten bokstav",
        "invitation-field-password-contain-uppercase": "Passordet må inneholde en stor bokstav",
        "invitation-field-password-contain-number": "Passordet må inneholde et tall",
        "invitation-field-repeatPassword-required": "Feltet må fylles ut",
        "invitation-field-repeatPassword-match-password": "Passordene stemmer ikke overens",

        // Confirm account change
        "confirm-account-change-confirming-email-message": "Bekrefter e-postadresse...",
        "confirm-account-change-login-button": "Logg inn",
        "confirm-account-change-failure-message": "E-postadressen kunne ikke bekreftes",

        // Id Card Signup
        "id-card-signup-title": "Fullfør registreringen",
        "id-card-signup-description": "Fullfør registreringsprosessen. Når du har registrert ID-kortet ditt, kan du bruke det til å kjøpe mat i kantinen ved å skanne det på POS-skjermen.",
        "id-card-signup-subscription": "Velg abonnement",
        "id-card-signup-next-button": "Neste",
        "id-card-signup-back-button": "Tilbake",
        "id-card-signup-field-company": "\n .label = Din virksomhet:\n .placeholder = Velg virksomheten du jobber for",
        "id-card-signup-field-user-group": "\n .label = Din brukergruppe:\n .placeholder = Velg brukergruppe",
        "id-card-signup-field-name": "\n .label = Navnet ditt:\n .placeholder = Skriv inn fullt navn",
        "id-card-signup-field-mobile-number": "\n .label = Telefonen din:\n .placeholder = Skriv inn mobilnummeret ditt (valgfritt)",
        "id-card-signup-field-mobile-number-invalid": "Ugyldig mobilnummer",
        "id-card-signup-field-name-max-length": "Navnet kan ikke overstige 50 tegn",
        "id-card-signup-companies-error": "Kunne ikke laste inn virksomheter. Prøv igjen.",
        "id-card-activation-generic-error": "Kunne ikke laste inn virksomheter. Prøv igjen.",
        "id-card-signup-no-subscriptions": "Det oppstod en feil under aktivering av kortet ditt. Prøv igjen.",
        "id-card-signup-using-company": "Din virksomhet: ",
        "id-card-signup-using-user-group": "Din brukergruppe: ",
        "id-card-signup-using-user-name": "Brukernavn: ",
        "id-card-signup-complete": "Gratulerer",
        "id-card-signup-complete-description": "Kortet ditt er nå registrert, og du kan begynne å bruke det.",
        "id-card-signup-complete-learn-more": "Les mer:",
        "id-card-signup-complete-learn-more-link": "Hvordan bruker jeg Facilitynets betalingsløsning?",

        // Activate account
        "activation-account-username-title": "Aktiver konto",
        "activation-account-username-subtitle": "For å bruke Facilitynet må du aktivere kontoen din nedenfor",
        "activation-account-username-button": "Aktiver",
        "activation-account-username-field": "\n .label = Skriv inn e-postadressen din:",
        "activation-account-username-email-required": "E-postadresse er påkrevd",
        "activation-account-username-email-invalid": "Skriv inn en gyldig e-postadresse",
        "activation-account-password-title": "Opprett passord",
        "activation-account-password-new-password-field": "\n .label = Skriv inn passord",
        "activation-account-password-button": "Opprett passord",

        // select company
        "authenticate-select-company-header-reason-multiple-companies-for-domain": "Velg firma",
        "authenticate-select-company-header-reason-multiple-accounts-for-username": "Velg brukerkonto",
        "authenticate-select-company-reason-message-multiple-companies-for-domain": "Vi kunne ikke bestemme firmaet ditt automatisk fordi e-postdomenet ditt <duplicateValue>{ $duplicateValue }</duplicateValue> forekommer flere steder i systemet vårt.",
        "authenticate-select-company-reason-message-multiple-accounts-for-username": "Vi fant flere kontoer i systemet vårt med e-postadressen <duplicateValue>{ $duplicateValue }</duplicateValue>.",
        "authenticate-select-company-action-message-multiple-companies-for-domain": "Velg lokasjonen (firmaet) du vil opprette kontoen din under:",
        "authenticate-select-company-action-message-multiple-accounts-for-username": "Velg brukerkontoen du vil logge inn med.",
        "authenticate-select-company-show-list-button": "Vis alternativer",
        "authenticate-select-company-submit-button": "{ -authenticate-submit-button }\n .loadingLabel = Lagrer...",
        "authenticate-select-company-form-error-message": "Velg en virksomhet",
        "authenticate-select-company-company-group-unknown-uid": "Ukjent virksomhets-UID",
        "authenticate-select-company-company-group-unknown-name": "Ukjent navn",
        "authenticate-select-company-company-group-unknown-address": "Ukjent adresse",
        "authenticate-select-company-no-companies-available": "Ingen firmaer tilgjengelige",
        "authenticate-select-company-account-role-support": "{ -user-type-support }",
        "authenticate-select-company-account-role-supplier": "{ -user-type-supplier }",
        "authenticate-select-company-account-role-merchant": "{ -user-type-merchant }",
        "authenticate-select-company-account-role-company": "{ -user-type-company }",
        "authenticate-select-company-account-role-office-manager": "{ -user-type-office-manager }",
        "authenticate-select-company-account-role-user": "{ -user-type-user }",
        "authenticate-select-company-account-role-service-center": "{ -user-type-service-center }",

        // Public > Self Sign Up
        "self-sign-up-title": "Registrer deg",
        "self-sign-up-description": "Fullfør registreringsprosessen. Når du er ferdig med registreringen, kan du bruke kontoen",
        "self-sign-up-field-company": "\n .label = Din virksomhet:\n .placeholder = Velg virksomheten du jobber for",
        "self-sign-up-field-user-group": "\n .label = Din brukergruppe:\n .placeholder = Velg brukergruppe",
        "self-sign-up-field-department": "\n .label = Avdeling:\n .placeholder = Velg avdelingen din",
        "self-sign-up-department-missing-notice": "Kontakt firmaadministratoren din hvis avdelingen din mangler i listen.",
        "self-sign-up-field-name": "\n .label = Navn:\n .placeholder = Skriv inn fullt navn",
        "self-sign-up-field-email": "\n .label = E-post:\n .placeholder = Skriv inn e-postadressen din",
        "self-sign-up-field-mobile-number": "\n .label = Telefon:\n .placeholder = Skriv inn mobilnummeret ditt (valgfritt)",
        "self-sign-up-complete-button": "Registrer deg",
        "self-sign-up-field-email-invalid": "Ugyldig e-postadresse",
        "self-sign-up-email-domain-hint": "Bruk en e-postadresse fra et godkjent domene: { $domains }",
        "self-sign-up-field-email-domain-not-allowed": "E-postadressen må bruke et godkjent domene: { $domains }",
        "self-sign-up-congratulation-title": "Gratulerer",
        "self-sign-up-congratulation-message": "Vi har sendt en aktiveringslenke til e-postadressen din.",
        "self-sign-up-error-message": "Noe gikk galt. Prøv igjen.",
        "self-sign-up-confirm-dialog": "\n .title = Bekreft detaljer\n .message = Er du sikker på at du vil opprette kontoen din med den oppgitte informasjonen?\n .buttonLabelSubmit = Bekreft\n .buttonLabelCancel = Avbryt",
        "self-sign-up-confirm-company": "\n .label = Firma:",
        "self-sign-up-confirm-user-group": "\n .label = Brukergruppe:",
        "self-sign-up-confirm-department": "\n .label = Avdeling:",
        "self-sign-up-confirm-name": "\n .label = Navn:",
        "self-sign-up-confirm-email": "\n .label = E-post:",
        "self-sign-up-confirm-mobile-number": "\n .label = Telefon:",

        // Booking > Confirm Booking
        'confirm-booking-complete': "Gratulerer",
        'confirm-booking-failed': "Mislyktes",
        'confirm-booking-loading': "Laster inn...",

        // ExportButton
        "export-button-export-text": "\n .title = Eksport\n .aria-label = Eksport",
        "export-button-export-all": "Eksporter alle",
        "export-button-export-all-with-filter": "Eksporter alle med filter",
        "export-button-export-selected": "Eksporter valgte",
        "export-button-export-selected-rows": "Eksporter valgte rader",
        "export-button-export-as-csv-title": "\n .title = Last ned som CSV-fil",
        "export-button-export-as-pdf-title": "\n .title = Last ned som PDF-fil",
        "export-button-print": "Skriv ut",
        "export-button-remove-print-title": "\n .title = Fjern fra utskriftskøen",

        // Export
        "export-period": "Periode",

        // print
        "print-queued": "Forespørselen din er i kø",


        // --- ContextDisplay ---
        "context-display-org-unit-supplier": "\n .label = Kantineoperatør:",
        "context-display-org-unit-merchant": "\n .label = Salgssted:",
        "context-display-org-unit-tenant": "\n .label = Leietaker:",
        "context-display-org-unit-company": "\n .label = Firma:",
        "context-display-org-unit-user": "\n .label = Bruker:",
        "context-display-org-unit-service-center": "\n .label = Servicesenter:",


        // --- Environment dropdown ---
        "env-dropdown-menu-header": "Bytt miljø til:",
        "env-dropdown-title-admin-support":"Administrasjon",
        "env-dropdown-title-reports-support":"Dashboard",
        "env-dropdown-title-admin-supplier":"Administrasjon",
        "env-dropdown-title-reports-supplier":"Dashboard",
        "env-dropdown-title-admin-merchant":"Administrasjon",
        "env-dropdown-title-reports-merchant":"Produksjon",
        "env-dropdown-title-accounting-merchant":"Regnskap",
        "env-dropdown-title-admin-company":"Administrasjon",
        "env-dropdown-title-reports-company":"Dashboard",
        "env-dropdown-title-admin-office-manager":"Administrasjon",
        "env-dropdown-title-reports-office-manager":"Dashboard",
        "env-dropdown-title-reports-service-center":"Dashboard",
        "env-dropdown-title-admin-service-center":"Administrasjon",
        "env-dropdown-subtitle-admin-support":"Administrer enheter og brukere.",
        "env-dropdown-subtitle-reports-support":"Se systemrapporter.",
        "env-dropdown-subtitle-admin-supplier":"Administrer salgssteder og globale innstillinger.",
        "env-dropdown-subtitle-reports-supplier":"Se tverrgående rapporter over regnskapstall.",
        "env-dropdown-subtitle-admin-merchant":"Administrer produkter, butikker og kundekommunikasjon.",
        "env-dropdown-subtitle-reports-merchant":"Se driftsoversikt og produksjonstall.",
        "env-dropdown-subtitle-admin-company":"Administrer organisasjonsdata, brukere og administratorer.",
        "env-dropdown-subtitle-reports-company":"Se regnskapstall.",
        "env-dropdown-subtitle-admin-office-manager":"Administrer brukere og administratorer.",
        "env-dropdown-subtitle-reports-office-manager":"Se regnskapstall.",
        "env-dropdown-subtitle-reports-service-center":"Servicesenter-rapporter",
        "env-dropdown-subtitle-admin-service-center":"Servicesenter-administrasjon",
        "env-dropdown-subtitle-accounting-merchant":"Se regnskapsrapporter.",


        // --- API components ---
        "api-query-table-fetch-error-message": "Feil ved innlasting av data",
        "api-query-autocomplete": "\n .loadingText = Laster inn data...",
        "api-query-autocomplete-fetch-error-message": "Feil ved innlasting av data. <retryLink>Prøv igjen</retryLink>",

        // Top Bar
        "help-tooltip-text": "\n .title = Vis hjelp",
        "notifications-tooltip-text": "\n .title = Vis meldinger",
        "new-order-tooltip-text": "\n .title = Opprett ny ordre",
        "qa-env-warning-part-one": "Du er i QA-miljøet. Dette er ikke ment for kunder. Bruk",
        "qa-env-warning-part-two": "i stedet.",

        // Top Bar > Help
        "help-dialog-search-title": "Hei, hvordan kan vi hjelpe deg?",
        "help-dialog-search":"\n .placeholder = Søk etter artikler...",
        "help-dialog-support": "\n .title = Support",
        "help-dialog-email-support": "\n .title = E-poststøtte \n .description = Hvis du fortsatt trenger hjelp, kan du sende oss en e-post her.",
        "help-dialog-chat-support": "\n .title = Chatstøtte \n .description = Har du raske spørsmål, kan du chatte med kundeserviceteamet vårt.",
        "help-dialog-troubleshooting": "\n .title = Feilsøking",
        "help-dialog-troubleshooting-pos-screen": "\n .title = POS-skjerm \n .description = Få hjelp med POS-skjermen, kvitteringsskriveren og betalingsterminalen.",
        "help-dialog-troubleshooting-check-in-screen": "\n .title = Innsjekkingsskjerm \n .description = Få hjelp med innsjekkingsskjermen og kvitteringsskriveren.",
        "help-breadcrumb": "Hjelp",
        "help-dialog-troubleshooting-breadcrumb": "Feilsøking",
        "help-dialog-troubleshooting-printer-not-working": "\n .title = Skriveren fungerer ikke",
        "help-dialog-troubleshooting-credit-card-terminal-not-working": "\n .title = Betalingsterminalen fungerer ikke",
        "help-dialog-troubleshooting-pos-screen-not-working": "\n .title = POS-skjermen fungerer ikke",
        "help-dialog-troubleshooting-check-in-screen-not-working": "\n .title = Innsjekkingsskjermen fungerer ikke",
        "help-dialog-troubleshooting-start-up-backup-terminal": "\n .title = Start opp backup-terminalen",
        "help-dialog-training": "\n .title = Opplæring",
        "help-dialog-training-education-center": "\n .title = Opplæringssenter \n .description = I opplæringssenteret kan du se kom i gang-guider og annet opplæringsmateriell.",
        "help-dialog-training-guide-button": "Se guide",
        "consent-dialog": "\n .title = Tillat chat \n .message = Vi bruker Intercom til chatstøtten vår. Hvis du samtykker, deler vi opplysningene nedenfor med Intercom. \n .skipLabel = Ikke nå \n .consentLabel = Tillat",
        "consent-dialog-personal-information": "Personopplysninger",
        "consent-dialog-pii-category-contact-info": "Kontaktinformasjon",
        "consent-dialog-pii-category-identifiers": "Identifikatorer",
        "consent-dialog-pii-category-purchases": "Kjøp",
        "consent-dialog-pii-category-user-content": "Brukerinnhold",
        "consent-dialog-privacy-policy": "Personvern",
        "consent-dialog-view-company-privacy-policy": "Se firmaets personvernerklæring",
        "consent-dialog-pii-item-name": "Navn",
        "consent-dialog-pii-item-email-address": "E-post",
        "consent-dialog-pii-item-phone-number": "Telefonnummer",
        "consent-dialog-pii-item-user-id": "Bruker-ID",
        "consent-dialog-pii-item-device-id": "Enhets-ID",
        "consent-dialog-pii-item-customer-support": "Kundeservice",
        "consent-dialog-pii-item-purchase-history": "Kjøpshistorikk",
        "intercom-error-dialog": "\n .title = Chat mislyktes\n .message = Noe gikk galt under innlasting av chatten. Du kan sende en e-post til support i stedet.\n .buttonLabel = Forstått",
        "intercom-loading-dialog": "\n .description = Chatten lastes inn...",
        "intercom-unavailable-snackbar": "Chatstøtte er for øyeblikket ikke tilgjengelig. Send oss i stedet en e-post på support@facilitynet.dk.",

        //ControlKitchen page
        "control-kitchen-checked-in-yes-chip": "Ja",
        "control-kitchen-checked-in-no-chip": "Nei",
        "control-kitchen-column-check-in-time": "Innsjekkingstid",
        "control-kitchen-column-id": "Ansatt-ID",
        "control-kitchen-column-name": "Navn",
        "control-kitchen-column-items": "Antall",
        "control-kitchen-column-order-details": "Ordre",
        "control-kitchen-checked-in": "Sjekket inn",
        "control-kitchen-checked-in-sub-title": "Dagens kontrollkode:",
        "control-kitchen-last-updated": "Sist oppdatert: {$lastUpdated}",
        "control-kitchen-refresh": "Oppdater siden",
        "control-kitchen-receipt": "Kvittering",
        "control-kitchen-date-label": "Kjøpsdato",
        "control-kitchen-date-delivery-label": "Leveringsdato",
        "control-kitchen-datetime-from-label": "Fra",
        "control-kitchen-datetime-to-label": "Til",
        "control-kitchen-period-label": "Periode",
        "control-kitchen-check-in-type": "Type",
        "control-kitchen-checked-in-filter-all": "Alle",
        "control-kitchen-checked-in-filter-checked-in": "Sjekket inn",
        "control-kitchen-checked-in-filter-not-checked-in": "Ikke sjekket inn",
        "control-kitchen-control-code-not-ready": "Ikke klar",

        // News folder
        "news-published": "Publiseres: {$date}",
        "news-implemented": "Implementert: {$date}",
        "news-created": "Opprettet: {$date}",
        "news-updated": "Oppdatert: {$date}",
        "news-gopay": "Facilitynet-nyheter",
        "news-roadmap": "Veikart",
        "news-new-features": "Nye funksjoner",
        "news-new-load-error": "Feil ved innlasting av veikartfunksjoner",
        "news-start-date": "Startdato",
        "news-end-date": "Sluttdato",
        "news-type": "Type",
        "news-bug-fix": "Feilretting",
        "news-new-feature": "Ny funksjon",
        "news-upcoming": "Kommende",
        "news-all": "Alle",
        "news-roadmap-type-filter-bugfix": "Feilretting",
        "news-roadmap-type-filter-feature": "Ny funksjon",
        "news-roadmap-type-filter-upcoming": "Kommende",
        "news-implemented-feature": "Implementert funksjon",
        "news-upcoming-feature": "Kommende funksjon",
        "news-current-news": "Aktuelle nyheter",
        "news-archive-news": "Arkiv",
        "news-create-new-button": "Opprett ny",
        "news-draft-type": "Utkast",
        "news-published-type": "Publisert",
        "news-schedule-type": "Planlagt",
        "news-expired-type": "Utløpt",
        "news-edit": "Rediger",
        "news-delete": "Slett",
        "news-default-error-message": "Noe gikk galt",
        "news-archive-title": "Tittel",
        "news-archive-expiration-date": "Utløpsdato",
        "news-archive-active-status": "Status",
        "merchant-news-header": "\n .title = Kundenyheter",
        "news-no-news-title": "Ingen nyheter",
        "news-no-roadmap-title": "Ingen veikart",
        "news-no-news-body": "Opprett din første nyhet ",
        "news-no-news-here-link": "her",
        "news-gopay-read-more": "Les mer",
        "news-table-delete-success-message": "Artikkelen er slettet",
        "create-news-header": "\n .title = Opprett nyhet",
        "edit-news-header": "\n .title = Rediger nyhet",
        "nav-item-create-news-header": "Opprett nyhet",
        "nav-item-edit-news-header": "Rediger nyhet",
        "create-news-save-button": "Opprett",
        "edit-news-save-button": "Lagre",


        // Office folder
        "office-period-total": "Totalt for perioden: {$periodTotal}",
        "office-transation-period-total": "Totalt antall transaksjoner for perioden: {$transactionPeriodTotal}",
        "office-purchase-time": "Tid",
        "office-purchase-name": "Navn",
        "office-purchase-payment-details": "Betalingsmåte",
        "office-purchase-payment-channel": "Kanal",
        "office-purchase-amount": "Beløp",
        "office-purchase-receipt": "Kvittering",
        "upcoming-orders-purchases-table-order-type": "Ordretype",
        "upcoming-orders-purchases-table-delivery-status": "Leveringsstatus",
        "upcoming-orders-purchases-table-order-type-pos": "POS",
        "upcoming-orders-purchases-table-order-type-takeaway": "Takeaway",
        "order-action-menu-refund": "Refunder",
        "order-action-menu-print-label": "Skriv ut etikett",
        "standard-refresh-button-last-updated-label": "Oppdatert { $relativeTime }",
        "standard-refresh-button-last-updated-just-now-label": "Oppdatert akkurat nå",
        "standard-refresh-button-tooltip-hint": "Klikk for å oppdatere",
        "standard-refresh-button-error-tooltip": "Oppdatering mislyktes · klikk for å prøve igjen",
        "standard-refresh-button-aria-label": "Oppdater",
        "standard-new-items-pill-label": "{ $count ->\n [one] { $count } ny ordre\n *[other] { $count } nye ordrer\n}",
        "standard-new-items-pill-show-button": "Vis",

        "office-meeting-service-title": "Møteservering",
        "office-meeting-service-header": "\n .title = Møteservering",
        "office-meeting-service-table-booked-start-date": "Booket startdato",
        "office-meeting-service-table-booked-end-date": "Booket sluttdato",
        "office-meeting-service-table-merchant": "Salgssted",
        "office-meeting-service-table-order-id-column": "Ordre-ID",
        "office-meeting-service-table-booked-date-column": "Bokføringsdato",
        "office-meeting-service-table-delivery-time-column": "Leveringstid",
        "office-meeting-service-table-creator-column": "Bestiller",
        "office-meeting-service-table-amount-column": "Beløp (DKK)",
        "office-meeting-service-table-show-receipt": "Vis kvittering",
        "office-meeting-service-table-floating-action-bar-receipts": "\n .title = Kvitteringer",
        "office-meeting-service-table-floating-action-bar-export": "\n .title = Eksport",


        // --- Profile page ---
        "profile-user-account-id": "ID:",
        "profile-administrator-for": "Administrator for",
        "profile-hosted-by": "Utleid av",
        "profile-hosted-by-office-hotel": "Kontorhotell",
        "profile-actions": "Snarveier",
        "profile-settings-card": "Innstillinger",
        "profile-password-card": "Passord",
        "profile-actions-change-password": "Endre passord",
        "profile-actions-edit-profile": "Rediger profil",
        "profile-actions-delete-account": "Slett brukerkonto",
        "profile-security": "Sikkerhet",
        "profile-security-manage-admins": "Kan administrere andre administratorer:",
        "profile-security-manage-admins-yes": "Ja",
        "profile-security-manage-admins-no": "Nei",
        "profile-security-ip-address-allowlist": "Tillatte IP-adresser:",
        "profile-roles": "Dine roller",
        "profile-user-info": "Brukerkonto",
        "profile-user-type": "Brukertype",
        "profile-username": "Brukernavn:",
        "profile-email": "E-post:",
        "profile-phone-number": "Telefonnummer:",
        "profile-mobil-number": "Mobilnummer:",
        "profile-name": "Navn:",
        "profile-page-header": "\n .title = Brukerkonto",
        "profile-nav-item-home": "Hjem",
        "profile-user-type-info-mode-supplier": "Som kantineoperatøradministrator kan du få tilgang til og administrere salgssteder og administratorer på vegne av virksomheten din. For hvert salgssted kan du gjøre alt en salgsstedsadministrator kan gjøre. I tillegg kan du administrere delte innstillinger og se rapporter på tvers av salgssteder.",
        "profile-user-type-info-mode-merchant": "Som salgsstedsadministrator kan du administrere butikker og produkter under salgsstedet ditt. Du har også tilgang til detaljerte regnskapsrapporter og produksjonsoversikter, der du kan administrere og oppfylle kundeordrer.",
        "profile-user-type-info-mode-company": "Som firmaadministrator kan du administrere brukere og integrasjoner for firmaet ditt. Du kan også se regnskapsrapporter for ordrer lagt inn av firmaets ansatte.",
        "profile-user-type-info-mode-office-manager": "Som kontorleder kan du administrere brukere og integrasjoner for organisasjonen din. Du kan også se regnskapsrapporter for ordrer lagt inn av firmaets ansatte.",
        "profile-user-type-info-mode-support": "Som supportmedarbeider kan du administrere brukere, maskinvareenheter og entiteter for hele systemet. Du kan også slå opp nødvendig informasjon om ordrer, brukere og entiteter for å håndtere supportsaker.",
        "profile-user-type-info-mode-user": "Som bruker kan du legge inn ordrer i systemet og se dine tidligere ordrer.",
        "profile-roles-mode-agreement-owner": "Avtaleeier",
        "profile-roles-mode-bookkeeper": "Bokholder",
        "profile-roles-mode-dpo": "DPO",
        "profile-roles-mode-it-administrator": "IT-administrator",
        "profile-roles-mode-news-subscriber": "Nyhetsabonnent",
        "profile-roles-mode-system-operation-subscriber": "Abonnent på systemdrift",
        "profile-roles-read-more": "Les om administratorroller",
        "profile-roles-no-roles": "Du har ingen roller",
        "profile-tab-profile": "Generelt",
        "profile-tab-gdpr": "GDPR",
        "profile-gdpr-info-box": "\n .description = Her kan du laste ned en kopi av dine egne personopplysninger som vi har registrert i Facilitynet.",
        "profile-gdpr-export-button": "Eksporter dataene mine",
        "profile-gdpr-correction-info-box": "\n .description = Her kan du be om retting av personopplysningene dine.",
        "profile-gdpr-correction-button": "Be om retting av dataene mine",

        // --- Profile page > Change password ---
        "profile-change-password-page-header": "\n .title = Endre passord",
        "profile-change-password": "Endre passord",
        "profile-change-password-profile": "Profil",
        "profile-change-password-profile-currentPassword": "\n .label = Nåværende passord",
        "profile-change-password-profile-newPassword": "\n .label = Nytt passord",
        "profile-change-password-profile-confirmPassword": "\n .label = Bekreft passord",
        "profile-change-password-profile-match-password": "Passordene stemmer ikke overens",
        "profile-change-password-password-policy": "\n .title = Passordpolicy",
        "profile-change-password-default-policy": "Facilitynet standardpolicy",
        "profile-change-password-info": "Kontakt support for å definere eller endre passordpolicyen for firmaet ditt.",
        "profile-change-password-submit-button": "Oppdater passord",

        // --- Change User Account > Dialog ---
        "change-user-account-dialog-title": "Bytt brukerkonto",
        "change-user-account-dialog-pending-state-email-has-been-sent": "En e-post er sendt. Sjekk innboksen din.",
        "change-user-account-dialog-pending-state-pending-approval":
            "Venter på godkjenning...\n .loadingLabel = Venter på godkjenning...",
        "change-user-account-dialog-confirm-email-subtitle": "Før du kan bytte mellom brukerkontoer, må du bekrefte at du eier e-postkontoen <element>{ $email }</element>.",
        "change-user-account-dialog-click-below-subtitle": "Klikk på knappen nedenfor for å sende meg en bekreftelseslenke:",
        "change-user-account-dialog-send-confirmation-button": "Send bekreftelseslenke",
        "change-user-account-dialog-empty-content-subtitle": "Fant ingen andre kontoer med e-postadressen <email>{ $email }</email>.",
        "change-user-account-dialog-users-list-available-accounts-subtitle": "Du har { $totalUserAccounts } andre brukerkontoer med e-posten: { $email }",
        "change-user-account-dialog-users-list-swift-to-another-account": "Bytt til en annen konto nedenfor:",
        "change-user-account-dialog-error-message": "Vi kunne ikke laste inn kontoene dine. Det er mulig at kontobytte ikke er tilgjengelig for denne kontotypen.",

        // User Types
        "profile-usertype-support": "{ -user-type-support }",
        "profile-usertype-supplier": "{ -user-type-supplier }",
        "profile-usertype-merchant": "{ -user-type-merchant }",
        "profile-usertype-company": "{ -user-type-company }",
        "profile-usertype-office-manager": "{ -user-type-office-manager }",
        "profile-usertype-user": "{ -user-type-user }",
        "profile-usertype-service-center": "{ -user-type-service-center }",


        // --- Settings page ---
        "settings-page-header": "\n .title = Innstillinger",
        "settings-title": "Innstillinger",
        "settings-nav-item-home": "Hjem",
        "settings-language-setting": "Språk",
        "settings-social-media-label": "Sosiale medier",
        "settings-social-media-text": "Følg oss på LinkedIn",
        "settings-notifications-label": "Varsler",
        "settings-sms-notifications": "SMS-varsler",
        "settings-receipts-meeting-service": "Kvitteringer for møteservice",
        "settings-receipts-canteen": "Kvitteringer for kantine",


        // --- Admin home card ---
        "admin-home-card-show-all-button": "Vis alle",


        // Back Button
        "back-button-label": "Tilbake",

        //AvatarMenu
        "avatar-menu-tooltip": "Åpne innstillinger",


        // ArticleSettingsPanel
        "article-settings-panel-settings-title": "\n .title = Synlighet",
        "article-settings-panel-published": "\n .label = Publisert",
        "article-settings-panel-schedule-for": "\n .label = Publiseringsdato",
        "article-settings-panel-expires": "\n .label = Utløpsdato",



        // ImageUploader
        "image-uploader-button-label": "Last opp bilde",
        "image-uploader-drag-and-drop": "Dra og slipp eller bla gjennom",
        "image-uploader-max-file-size-exceeded": "Filstørrelsen overskrider grensen på { $maxFileSize }.",
        "image-previewer-button-label": "Last opp nytt bilde",
        "image-previewer-button-delete": "Slett",

        // CreateOrEditMerchantArticle
        "create-or-edit-merchant-article-mode-normal-article": "Vanlig artikkel",
        "create-or-edit-merchant-article-mode-external-article": "Ekstern artikkel",
        "create-or-edit-merchant-article-mode-product-news": "Produktnyheter",
        "create-or-edit-merchant-article-title": "\n .label = Tittel",
        "create-or-edit-merchant-article-body": "\n .placeholder = Beskrivelse\n .helperText = Gjenstående tegn: { $charsRemaining }",
        "create-or-edit-merchant-article-body-too-long": "Du har overskredet maksimalt antall tegn: { $charsLimit }",
        "create-or-edit-merchant-article-product-id": "\n .label = Produkt-ID",
        "create-or-edit-merchant-article-info-label-draft": "\n .label = Artikkelen er et utkast. Den vil ikke være synlig for brukerne før du publiserer den.",
        "create-or-edit-merchant-article-info-label-schedule": "\n .label = Artikkelen er planlagt for publisering den: ",
        "create-or-edit-merchant-article-type": "\n .label = Artikkeltype",
        "create-or-edit-merchant-article-delete": "artikkel",
        "news-create-image-field-label": "\n .label = Last opp bilde",

        // CreateAndPublishSplitButton
        "create-and-publish-split-button-create-draft": "Utkast",
        "create-and-publish-split-button-publish": "Publiser",
        "create-and-publish-split-button-save": "Lagre",
        "create-and-publish-split-button-unpublish": "Avpubliser",
        "create-and-publish-split-button-cancel-publication": "Avbryt publisering",
        "create-and-publish-split-button-republish": "Publiser på nytt",


        "table-summary-box-total-period": "\n .title = Totalt i denne perioden",
        "table-summary-box-number-of-orders": "\n .title = Antall ordrer",
        "table-summary-box-number-of-subscriptions": "\n .title = Antall abonnementer",

        // --- Office manager ---

        // Navigation
        "tenant-nav-item-home": "Hjem",

        // - reporting
        "tenant-nav-item-accounting": "\n .title = Regnskap",
        "tenant-nav-item-accounting-header": "Regnskap",
        "tenant-nav-item-pos": "POS",
        "tenant-nav-item-meeting-service": "Møteservering",
        "tenant-nav-item-subscriptions": "Abonnementer",

        // - admin
        "tenant-nav-item-users": "Brukere",
        "tenant-nav-item-organization-page-header":"\n .title = Organisasjon",
        "tenant-nav-item-organization-header":"Organisasjon",
        "tenant-nav-item-administrators": "Administratorer",

        // Reports

        // Home
        "tenant-reports-home-placeholder": "\n .title = Kontorlederdashboard kommer snart\n .body = Dashboardet ditt vil vise en oversikt over viktige nøkkeltall, slik at du alltid har god oversikt over de ansattes kjøp.",

        // Purchases
        "tenant-purchases-header": "\n .title = POS",
        "tenant-subscriptions-header": "\n .title = Abonnementer",

        // Admin

        // Home page
        "office-manager-home-user-card-group": "\n .title = Brukere",
        "office-manager-home-user-admin-placeholder": "Kommer snart. Her vil du kunne administrere brukerne og kontorlederne dine.",
        "office-manager-home-user-card": "  \n .title = Brukere\n .description = Administrer brukere for organisasjonen din",
        "office-manager-home-admin-card": "  \n .title = Administratorer\n .description = Administrer administratorer",
        "office-manager-home-card-show-all": "Vis alle",
        "office-manager-users-header": "\n .title = Brukere",
        "office-manager-users-tab-users": "Brukere",
        "office-manager-users-tab-admins": "Administratorer",
        "office-manager-users-table-id-column": "Bruker-ID",
        "office-manager-users-table-name-column": "Navn",
        "office-manager-users-table-email-column": "E-post",
        "office-manager-users-table-status-column": "Status",
        "office-manager-users-table-status-column-active": "Aktiv",
        "office-manager-users-table-status-column-inactive": "Inaktiv",
        "office-manager-user-show-details": "Vis detaljer",
        "office-manager-user-edit": "Rediger bruker",
        "office-manager-user-delete": "Slett bruker",
        "office-manager-user-delete-title": "bruker",
        "office-manager-users-create-user-button": "Opprett ny",
        "office-manager-users-create-admin-button": "Opprett ny",
        "office-manager-user-details-dialog-title": "Brukerdetaljer",
        "office-manager-settings-panel": "\n .title = Innstillinger",
        "office-manager-settings-send-invitation": "Send e-postinvitasjon",
        "office-manager-settings-disable-sync": "Deaktiver synkronisering",
        "office-manager-settings-disable-sync-text": "Når dette er deaktivert, ignoreres denne brukeren av brukersynkroniseringsjobber",

        // show user details dialog
        "user-details-user-id": "Bruker-ID:",
        "user-details-employee-id": "Ansatt-ID:",
        "user-details-user-group": "Brukergruppe:",
        "user-details-department": "Avdeling:",
        "user-details-workgroups-title": "Arbeidsgrupper",
        "user-details-name": "Navn:",
        "user-details-role-type-news-subscriber" : "Abonnent",
        "user-details-role-type-system-operation-subscriber" : "Abonnent på systemstatus",
        "user-details-email": "E-post:",
        "user-details-mobile": "Mobil:",
        "user-details-phone": "Telefon:",
        "user-details-language": "Språk:",
        "user-details-role": "Brukerroller:",
        "user-details-sync-jobs": "Frakoblede synkroniseringsjobber:",
        "user-details-sync-jobs-ignored": "JA",
        "user-details-sync-jobs-included": "NEI",
        "user-details-security-title": "Sikkerhet",
        "user-details-settings-title": "Innstillinger",
        "user-details-security-settings-yes": "JA",
        "user-details-security-settings-no": "NEI",
        "user-details-security-manage-admins": "Kan administrere andre administratorer:",
        "user-details-security-ip-address": "Tillatte IP-adresser:",
        "user-details-history-title": "Historikk",
        "user-details-history-created": "Opprettet:",
        "user-details-history-edited": "Sist endret:",

        // Create or edit user page
        "office-manager-create-user-form": "Opprett",
        "office-manager-edit-user-form": "Lagre",
        "office-manager-create-user-form-title": "\n .title = Opprett bruker",
        "office-manager-edit-user-form-title": "\n .title = Rediger bruker",
        "office-manager-create-user-home-breadcrumb": "Hjem",
        "office-manager-create-user-users-breadcrumb": "Konto",
        "office-manager-create-user-create-breadcrumb": "Opprett bruker",
        "office-manager-create-user-edit-breadcrumb": "Rediger bruker",
        "office-manager-create-user-missing-context-error":
            "Kunne ikke finne ut hvilken konto denne brukeren tilhører. Last siden på nytt og prøv igjen.",
        "office-manager-create-admin-missing-context-error":
            "Kunne ikke finne ut hvilken konto denne administratoren tilhører. Last siden på nytt og prøv igjen.",
        // Create/edit administrator pages (shared across all portals)
        "administrators-create-page-title": "\n .title = Opprett administrator",
        "administrators-create-page-save-button": "Opprett",
        "administrators-create-breadcrumb": "Opprett administrator",
        "administrators-edit-page-title": "\n .title = Rediger administrator",
        "administrators-edit-page-save-button": "Lagre",
        "administrators-edit-breadcrumb": "Rediger administrator",
        "office-manager-create-user-field-id": "\n .label = Ansatt-ID",
        "office-manager-create-user-field-username": "\n .label = Brukernavn",
        "office-manager-create-user-field-name": "\n .label = Navn",
        "office-manager-create-user-field-email": "\n .label = E-post",
        "office-manager-create-user-field-mobile": "\n .label = Mobil",
        "office-manager-create-user-field-phone": "\n .label = Telefonnr.",
        "office-manager-create-user-field-active": "Aktiv",
        "office-manager-settings-resend-invitation": "Send invitasjon på nytt",
        "office-manager-security-panel": "\n .title = Sikkerhet",
        "office-manager-security-manage-admins": "Kan administrere andre administratorer",
        "office-manager-security-pin-field": "\n .label = PIN-kode",
        "office-manager-security-pin-info": "\n .title = PIN-koden brukes av ansatte for å logge inn på POS-skjermen.",
        "office-manager-security-pin-invalid": "PIN-koden må være 4 sifre",
        "office-manager-create-user-required-field-empty": "Dette feltet er påkrevd",
        "office-manager-create-user-invalid-email-address": "Ugyldig e-postadresse",
        "office-manager-create-user-invalid-phone-number": "Ugyldig telefonnummer",

        // Create or edit room
        "resource-room-create-form-title": "\n .title = Opprett rom",
        "resource-room-edit-form-title": "\n .title = Rediger rom",
        "resource-room-create-required-field-empty": "Dette feltet er påkrevd",
        "resource-room-create-user-home-breadcrumb": "Hjem",
        "resource-room-create-user-users-breadcrumb": "Brukere",
        "resource-room-create-room-breadcrumb":"Opprett rom",
        "resource-room-edit-room-breadcrumb":"Rediger rom",

        // Purchases page
        "tenant-pos-title": "POS",
        "tenant-purchases-tab-orders":"\n .title = Ordrer",
        "tenant-purchases-tab-subscriptions-details":"Detaljer",
        "tenant-purchases-tab-subscriptions-cancel": "Si opp",

        //Admin roles field
        "tenant-admin-roles-field-label": "Tildel roller",
        "tenant-admin-role-agreement-owner": "Systemeier",
        "tenant-admin-role-dpo": "GDPR-ansvarlig",
        "tenant-admin-role-it-administrator": "IT-administrator",
        "tenant-admin-role-bookkeeper": "Bokholder",
        "tenant-admin-role-news-subscriber": "Nyhetsabonnent",
        "tenant-admin-role-system-operation-subscriber": "Abonnent på systemdrift",


        // Survey Page
        "survey-header": "\n .title = Brukerundersøkelse",
        "survey-tab-overview": "Oversikt",
        "survey-tab-ratings": "Alle vurderinger",
        "survey-tab-ratings-no-survey-data": "Ingen data tilgjengelig.",
        "survey-tab-overview-no-surveys": "Ingen undersøkelser definert ennå.",
        "survey-tab-overview-no-questions": "Ingen spørsmål definert for denne undersøkelsen.",
        "survey-tab-ratings-good-topics-card": "\n .title = Fornøyde med\n .datasetLabel = Stemmer",
        "survey-tab-ratings-bad-topics-card": "\n .title = Misfornøyde med\n .datasetLabel = Stemmer",
        "survey-tab-overview-trend-card": "\n .title = Utvikling i tilfredshet\n .scoreLabel = Gjennomsnittlig score\n .votesLabel = Antall vurderinger",
        "survey-tab-comment": "Kommentarer",
        "survey-tab-surveys": "Undersøkelser",
        "survey-period-select": "\n .label = Periode",
        "survey-period-today": "I dag",
        "survey-period-last-day": "Siste døgn",
        "survey-period-last-week": "Siste uke",
        "survey-period-last-month": "Siste måned",
        "survey-period-last-quarter": "Siste kvartal",
        "survey-period-last-year": "Siste år",

        // All rating
        "all-rating-time": "Tid",
        "all-rating-question": "Spørsmål",
        "all-rating-score": "Score",
        "all-rating-topics": "Emner",
        "all-rating-comment": "Kommentar",

        // SelectSurvey
        "select-survey": "\n .label = Undersøkelse",

        // --- Smiley summary card ---
        "survey-smiley-summary-card": "\n .title = Samlet score",
        "survey-smiley-summary-card-overall-score-label": "Score: { $averageScore }",

        // --- Survey participation card ---
        "survey-participation-card": "\n .title = Deltakelse",
        "survey-participation-card-participants-label": "Deltakere",
        "survey-participation-card-non-participants-label": "Ikke-deltakere",
        "survey-participation-card-participation-label": "Prosent",
        "survey-participation-card-participation-breakdown": "{ $ratings } svar av { $orders } kjøp",

        // --- Survey smiley distribution card ---
        "survey-smiley-distribution-card": "\n .title = Tilfredshet",
        "survey-smiley-distribution-card-votes-label": "Stemmer",
        "smiley-label-bad": "Svært dårlig",
        "smiley-label-poor": "Dårlig",
        "smiley-label-medium": "Middels",
        "smiley-label-good": "Bra",
        "smiley-label-excellent": "Utmerket",


        // Production
        "production-meeting-service-breadcrumb": "Møteservering",
        "production-planning-breadcrumb": "Planlegging",
        "production-pos-purchases-breadcrumb": "POS-kjøp",
        "production-takeaway-page-header": "\n .title = Takeaway",
        "production-takeaway-breadcrumb": "Takeaway",
        "production-transactions-print-label": "Skriv ut etikett",
        "production-table-toolbar-banner-unprinted-receipts-message": "Kvitteringer er ikke skrevet ut på skyprinteren.",
        "production-table-toolbar-banner-show-button": "Vis",
        "production-table-toolbar-banner-showing-unprinted-message": "Viser ikke utskrevne ordrer.",
        "production-table-toolbar-banner-clear-filter-button": "Fjern filter",
        "production-planning-page-header": "\n .title = Planlegging",
        "production-meeting-service-page-header": "\n .title = Møteservering",
        "meeting-service-production-view-fullscreen-link": "Fullskjermmodus",
        "meeting-service-production-view-tab-delivery-time": "Leveringstid",
        "meeting-service-production-view-tab-delivery-location": "Leveringssted",
        "meeting-service-production-view-not-approved-toggle": "Ikke godkjent",
        "meeting-service-production-view-sittings-label": "\n .title = Sitteplasser:",
        "meeting-service-production-view-host-label": "\n .title = Møteansvarlig:",
        "meeting-service-production-view-meeting-time-label": "\n .title = Møtetid:",
        "meeting-service-production-view-users-dialog-title": "Kontaktopplysninger",
        "meeting-service-production-view-users-dialog-name-label": "Navn:",
        "meeting-service-production-view-users-dialog-email-label": "E-post:",
        "meeting-service-production-view-users-dialog-phone-label": "Telefon:",
        "meeting-service-production-view-select-all-orders": "\n .label = Velg alle",
        "meeting-service-production-view-organizer-type-creator": "Oppretter",
        "meeting-service-production-view-organizer-type-organizer": "Arrangør",
        "meeting-service-production-view-organizer-type-responsible": "Ansvarlig",
        "meeting-service-production-view-hour-group-orders-count": "{ $count -> \n *[other] { $count } ordrer \n [one] { $count } ordre \n }",
        "meeting-service-production-view-ready-count": "{ $ready }/{ $total } klare",
        "meeting-service-production-view-card-menu-button": "\n .aria-label = Mer",
        "meeting-service-production-view-card-full-edit": "Full redigering",
        "meeting-service-production-view-card-delete-button": "Slett",
        "meeting-service-production-view-edit-items-button": "Rediger",
        "meeting-service-production-view-saved-dialog-title": "Ordre oppdatert",
        "meeting-service-production-view-print-menu": "Skriv ut",
        "meeting-service-production-view-print-menu-tooltip": "\n .title = Skriv ut",
        "meeting-service-production-view-location-unknown": "Ukjent sted",
        "meeting-service-production-view-filter-button": "Filtre",
        "meeting-service-production-view-search-input": "\n .placeholder = Søk etter ordre-ID, møtenavn, sted eller person.\n .title = Søk etter ordre-ID, møtenavn, sted eller person.",
        "meeting-service-production-view-date-button": "Velg dato",
        "meeting-service-production-view-time-left": "{ $minutes } min igjen",
        "meeting-service-production-view-order-comment-read-more": "Les mer",
        "meeting-service-production-view-order-comment-dialog-title": "Ordrekommentar",
        "meeting-service-production-filter-delivery-title": "\n .title = Levering",
        "meeting-service-production-filter-locked-label": "Låst",
        "meeting-service-production-filter-locked-all": "Alle",
        "meeting-service-production-filter-locked-locked": "Låst",
        "meeting-service-production-filter-locked-unlocked": "Ulåst",
        "meeting-service-production-view-add-menu-button": "Legg til produkt",
        "meeting-service-production-view-add-menu-catalog": "Vare fra katalog",
        "meeting-service-production-view-add-menu-wish": "Fritekstønske",
        "meeting-service-production-view-add-menu-extra-service": "Tjeneste",
        "meeting-service-order-drawer-order-number": "Ordre #{ $number }",
        "meeting-service-order-drawer-delivery-tab": "LEVERING { $index }",
        "meeting-service-order-drawer-order-lines-title": "Ordrelinjer",
        "meeting-service-order-drawer-total-label": "TOTALT",
        "meeting-service-order-drawer-status": "Status",
        "meeting-service-order-drawer-delivery-time": "Leveringstid",
        "meeting-service-order-drawer-contact": "Kontakt",
        "meeting-service-order-drawer-contact-info-button": "\n .title = Vis kontaktopplysninger",
        "meeting-service-order-drawer-contact-dialog-title": "Kontaktopplysninger",
        "meeting-service-contact-info-disclaimer": "\n .title = Kundens kontaktopplysninger. Behandle dem fortrolig.",
        "meeting-service-contact-info-print-footer": "Konfidensielt: inneholder kundens kontaktopplysninger",
        "meeting-service-order-drawer-covers": "Kuverter",
        "meeting-service-order-drawer-covers-value": "{ $count } personer",
        "meeting-service-order-drawer-delivery-type": "Leveringstype",
        "meeting-service-order-drawer-location": "Leveringssted",
        "meeting-service-order-drawer-order-note": "Ordrenotat",
        "meeting-service-order-drawer-chat-customer": "Chat med kantinen",
        "meeting-service-recurrence-series-button-tooltip": "Vis alle ordrer i serien",
        "meeting-service-recurrence-series-drawer-subtitle": "Gjentakende serie · { $count ->\n [one] { $count } ordre\n *[other] { $count } ordrer\n}",
        "meeting-service-recurrence-series-drawer-recurrence": "Gjentakelse",
        "meeting-service-recurrence-series-drawer-period": "Periode",
        "meeting-service-recurrence-series-drawer-contact": "Kontakt",
        "meeting-service-recurrence-series-drawer-covers": "Kuverter",
        "meeting-service-recurrence-series-drawer-covers-value": "{ $count } personer",
        "meeting-service-recurrence-series-drawer-delivery-type": "Leveringstype",
        "meeting-service-recurrence-series-drawer-location": "Leveringssted",
        "meeting-service-recurrence-series-drawer-orders-title": "Ordrer i serien",
        "meeting-service-recurrence-series-drawer-orders-id-column": "Ordre-ID",
        "meeting-service-recurrence-series-drawer-orders-date-column": "Leveringsdato",
        "meeting-service-recurrence-series-drawer-current-order": "Denne ordren",
        "meeting-service-recurrence-series-drawer-locked": "Låst",
        "meeting-service-recurrence-series-drawer-orders-empty": "Ingen ordrer funnet i denne serien",
        "meeting-service-recurrence-series-drawer-close-button": "Lukk",
        "meeting-service-recurrence-series-drawer-subtitle-no-count": "Gjentakende serie",
        "meeting-service-recurrence-series-drawer-order-menu-button": "Flere handlinger for ordre { $orderId }",
        "meeting-service-recurrence-series-drawer-order-menu-view": "Vis ordre",
        "meeting-service-recurrence-series-drawer-order-menu-edit": "Rediger ordre",
        "meeting-service-recurrence-series-drawer-order-menu-copy": "Kopier ordre",
        "meeting-service-recurrence-series-drawer-order-menu-print": "Skriv ut ordre",
        "meeting-service-order-drawer-chat-merchant": "Chat med kunden",
        "meeting-service-order-drawer-replied": "Besvart",
        "meeting-service-order-drawer-quick-edit": "Hurtigredigering",
        "meeting-service-order-drawer-quick-edit-save-button": "Lagre",
        "meeting-service-order-drawer-full-edit": "Full redigering",
        "meeting-service-order-drawer-delivery-label": "Levering { $index }",
        "meeting-service-order-drawer-total": "Totalt",
        "meeting-service-order-drawer-vat": "Inkl. MVA ({ $rate }%)",
        "meeting-service-order-drawer-order-lines-count": "{ $count } ordrelinjer",
        "meeting-service-order-drawer-send": "Send",
        "meeting-service-order-drawer-add-catalog-title": "Vare fra katalog",
        "meeting-service-order-drawer-add-catalog-desc": "Søk i katalogen — prisen fylles ut automatisk",
        "meeting-service-order-drawer-add-wish-title": "Fritekstønske",
        "meeting-service-order-drawer-add-wish-desc": "Fritekst — kjøkkensjefen gjennomgår den",
        "meeting-service-order-drawer-add-service-title": "Tjeneste",
        "meeting-service-order-drawer-add-service-desc": "Dekking, servering, rydding osv.",
        "meeting-service-order-drawer-messages-empty": "Ingen meldinger ennå",
        "meeting-service-order-drawer-duplicate": "Dupliser",
        "meeting-service-order-drawer-resource-bookings": "Ressursbookinger",
        "meeting-service-order-drawer-booking-time": "Bookingtid",
        "meeting-service-order-drawer-load-error": "Kunne ikke laste inn ordren",
        "meeting-service-order-drawer-retry": "Prøv igjen",
        "meeting-service-order-drawer-saved-snackbar": "Ordren er oppdatert",
        "meeting-service-production-view-wish-badge": "\n .label = Ønske",
        "meeting-service-production-view-service-badge": "\n .label = Tjeneste",
        "meeting-service-production-view-legacy-service-tooltip": "\n .title = Dette er en eldre ekstratjeneste fra den gamle portalen. Den kan ikke endres, men den kan fjernes.",
        "meeting-service-production-view-service-already-added-snackbar": "Tjenesten er allerede lagt til i denne leveringen, så den kan ikke legges til igjen.",
        "meeting-service-production-view-only-services-snackbar": "En ordre kan ikke bare bestå av ekstratjenester. Legg til minst ett produkt.",
        "meeting-service-production-view-add-service-confirm-button": "Legg til",
        "meeting-service-production-view-add-service-required-error": "Dette feltet er påkrevd",
        "meeting-service-production-view-wish-name-field": "\n .placeholder = Produktnavn",
        "meeting-service-production-view-wish-price-field": "\n .placeholder = Pris",
        "meeting-service-production-view-add-product-autocomplete-label": "Velg produkt",
        "meeting-service-production-view-add-extra-service-autocomplete-label": "Velg ekstratjeneste",
        "meeting-service-production-view-add-picker-cancel": "Avbryt",
        "meeting-service-production-view-save-changes-button": "Ferdig",
        "meeting-service-production-view-total-with-amount": "Totalt: { $amount }",
        "meeting-service-production-view-product-search-placeholder": "Søk etter rett",
        "meeting-service-production-view-product-out-of-stock": "Utsolgt",
        "meeting-service-production-view-product-already-added-snackbar": "Produktet er allerede lagt til i denne ordren, så det kan ikke legges til igjen. Oppdater den eksisterende ordrelinjen i stedet.",
        "meeting-service-production-view-product-required": "Produkt er påkrevd",
        "meeting-service-production-view-saved-banner": "\n .title = Ordre #{ $orderNumber } er oppdatert. Totalt: { $total }",
        "meeting-service-production-view-saved-banner-no-total": "\n .title = Ordre #{ $orderNumber } er oppdatert",
        "meeting-service-production-view-cancel-button": "Avbryt",
        "meeting-service-production-view-remove-line-button": "\n .aria-label = Fjern",
        "meeting-service-production-view-product-name-dialog-title": "Produktnavn",
        "meeting-service-production-view-meeting-name-dialog-title": "Møtenavn",
        "meeting-service-production-view-empty": "Ingen ordrer å produsere",
        "production-pos-purchases-page-header": "\n .title = POS-kjøp",
        "production-tab-production-list": "Produksjonsliste",
        "production-tab-pos-transactions": "POS-transaksjoner",
        "production-tab-orders": "Produksjon {$amount}",
        "planning-tab-takeaway": "Takeaway",
        "planning-tab-calendar": "Kalender",
        "planning-tab-not-approved": "Venter på godkjenning {$amount}",
        "planning-tab-to-be-booked": "Skal bokføres {$amount}",
        "planning-tabs-placeholder": "\n .title = Kommer snart \n .body = Vi jobber med å levere denne funksjonen til deg.",
        "production-list-no-result": "Ingen resultater",
        "production-orders-action-bar-confirm-queue-remove-dialog": "\n .title = Fjern fra skriverkøen\n .message = Er du sikker på at du vil fjerne de valgte kvitteringene fra skriverkøen?\n .buttonLabelSubmit = Fjern",
        "production-orders-action-bar-confirm-print-dialog": "\n .title = Skriv ut kvitteringer\n .message = Er du sikker på at du vil skrive ut de valgte kvitteringene?\n .buttonLabelSubmit = Skriv ut",
        "production-meeting-service-shortcuts-button": "Snarveier",
        "production-meeting-service-shortcut-booked-orders": "Bokførte ordrer",
        "production-meeting-service-search-field": "\n .label = Søk etter ordre\n .placeholder = Skriv inn ordre-ID, møtenavn eller vert.",
        "production-orders-search-field": "\n .label = Søk etter ordre\n .placeholder = Skriv inn ordre-ID, navn eller e-post.",
        "accounting-orders-search-field": "\n .label = Søk etter ordre\n .placeholder = Skriv inn ordre-ID, navn eller e-post.",
        "accounting-orders-meeting-service-search-field": "\n .label = Søk etter ordre\n .placeholder = Skriv inn ordre-ID, møtenavn eller vert.",

        // Production package slip
        "production-package-slip-order-error": "Kunne ikke laste inn følgeseddel med ID #{ $orderId }",
        "production-package-slip-order-error-description": "Denne ordren kunne ikke behandles på grunn av manglende eller ugyldige data.",
        "production-package-slip-order-id-number": "Ordre-ID: {$orderId}",
        "production-package-slip-section-delivery-details-title": "Leveringsdetaljer",
        "production-package-slip-section-delivery-details-type": "Leveringstype:",
        "production-package-slip-section-delivery-details-time": "Leveringstid:",
        "production-package-slip-section-delivery-details-meeting-time": "Møtetid:",
        "production-package-slip-section-delivery-details-location": "Leveringssted:",
        "production-package-slip-section-delivery-details-sittings": "Kuverter:",
        "production-package-slip-section-delivery-details-merchant": "Leverandør:",
        "production-package-slip-section-contact-details-title": "Kontaktopplysninger",
        "production-package-slip-section-contact-details-meeting-creator": "\n .label = Oppretter:",
        "production-package-slip-section-contact-details-meeting-host": "\n .label = Møtevert:",
        "production-package-slip-table-column-items": "Antall",
        "production-package-slip-table-column-products": "Produkter",
        "production-package-slip-table-column-delivery-time": "Leveringstid",
        "production-package-slip-section-note-title": "Notat",
        "production-package-slip-section-header-slip-title": "Følgeseddel",
        "print-page-header-printed-label": "{ $title } · skrevet ut { $date } kl. { $time }",
        "print-page-footer-page-counter": "Side { $page } av { $pages }",
        "print-page-footer-order-label": "Ordre { $orderId }",
        "production-export-exported-label": "Eksportert",
        "production-package-slip-section-header-digital-slip-title": "Digital seddel",
        "production-package-slip-header-orders-count": "Følgesedler: {$orderCount} valgt",
        "production-package-slip-navigation-counter": "Følgeseddel { $current } av { $total }",

        // Production credit note
        "production-credit-note-dialog-title": "\n .dialogTitle = Opprett kreditnota",
        "production-credit-note-credit-info": "\n .title = En kreditnota brukes til å reversere deler av en bokført ordre.",
        "production-credit-note-debit-info": "\n .title = En tilleggsordre brukes til å legge til varer på en ordre som allerede er bokført.",
        "production-credit-note-table-column-order-id": "Ordre-ID",
        "production-credit-note-table-column-type": "Type",
        "production-credit-note-table-column-booked": "Bokført",
        "production-credit-note-table-column-amount": "Beløp (DKK)",
        "production-credit-note-table-column-type-cell-original-order": "Opprinnelig ordre",
        "production-credit-note-table-column-type-cell-credit": "Kreditnota",
        "production-credit-note-table-column-type-cell-debit": "Tilleggsordre",
        "production-credit-note-button-next": "Neste",
        "production-credit-note-button-cancel": "Avbryt",
        "production-credit-note-select-label": "Opprett",

        // Accounting
        "accounting-header": "\n .title = Regnskap",
        "accounting-product-sales-page-header": "\n .title = Produktsalg",
        "merchant-nav-item-accounting-product-sales": "Produktsalg",
        "accounting-orders-page-header": "\n .title = Ordrer",
        "merchant-nav-item-accounting-orders": "Ordrer",
        "accounting-subscriptions-page-header": "\n .title = Abonnementer",
        "merchant-nav-item-accounting-subscriptions": "Abonnementer",
        "accounting-cash-register-page-header": "\n .title = Saldo",
        "merchant-nav-item-accounting-cash-register": "Saldo",
        "accounting-customers-page-header": "\n .title = Kunder",
        "merchant-nav-item-accounting-customers": "Kunder",
        "accounting-customer-balance-page-header": "\n .title = Brukersaldo",
        "merchant-nav-item-accounting-customer-balance": "Brukersaldo",
        "merchant-nav-item-accounting-z-report": "Z-rapport",
        "merchant-nav-item-accounting-custom-reports": "Egendefinerte rapporter",
        "merchant-accounting-z-reports-table-date-range-filter": "\n .label = Datoperiode",

        "accounting-product-sales-breadcrumb-title": "Produktsalg",
        "accounting-orders-breadcrumb-title": "Ordrer",
        "accounting-subscriptions-breadcrumb-title": "Abonnementer",
        "accounting-cash-register-breadcrumb-title": "Saldo",
        "accounting-customers-breadcrumb-title": "Kunder",
        "accounting-customer-balance-breadcrumb-title": "Brukersaldo",
        "accounting-customers-button-expand-all": "Utvid alle",
        "accounting-customers-button-collapse-all": "Skjul alle",

        "accounting-orders-tab-transactions": "Transaksjoner",
        "accounting-orders-tab-refill": "Påfyll",
        "accounting-orders-tab-meetingService": "Møteservering",
        "transactions-table-list-refund-title": "Refusjon",
        "transactions-table-list-refund": "\n .title = Refusjon \n .message = Er du sikker på at du vil refundere ordre #{ $orderId } ({ $amount })? \n .buttonLabelSubmit = Bekreft\n .buttonLabelCancel = Avbryt",
        "transactions-table-list-refund-success-dialog-title": "Ordren ble refundert",
        "transactions-table-list-refund-error-message": "Kunne ikke refundere ordren. Prøv igjen.",
        "order-accounting-refund-pos-order-confirm-dialog": "\n .title = Refusjon \n .message = Er du sikker på at du vil refundere ordre #{ $orderId }? \n .buttonLabelSubmit = Bekreft\n .buttonLabelCancel = Avbryt",
        "order-accounting-refund-pos-order-title": "Refusjon",
        "order-accounting-refund-pos-order-locked-dialog-title": "Ordren kan ikke refunderes",
        "order-accounting-refund-pos-order-locked-dialog-body": "Denne ordren kan ikke refunderes.",
        "order-accounting-refund-pos-order-already-refunded-title": "Ordren er allerede refundert",
        "order-accounting-refund-pos-order-already-refunded-body": "Denne ordren er allerede refundert.",
        "transactions-table-list-message-customer": "Send melding til kunde",

        "filter-menu-title": "Filtre",
        "filter-menu-clear-all-button": "Fjern alle",
        "filter-menu-clear-button": "Fjern",

        "filter-menu-accordion-shops-title": "\n .title = Butikker",
        "filter-menu-accordion-customers-title": "\n .title = Kunder",
        "filter-menu-accordion-transactions-order-details-title": "\n .title = Ordredetaljer",
        "filter-menu-accordion-transactions-order-number": "\n .label = Ordrenummer \n .placeholder = Søk etter ordrenr...",
        "filter-menu-accordion-transactions-user": "\n .label = Bruker \n .placeholder = Skriv inn ID eller e-post",

        "standard-email-filter-label": "\n .label = E-post",
        "standard-email-filter-error-message": "Ugyldig e-postadresse",
        "standard-id-filter-order-id-label": "\n .label = Ordre-ID",
        "standard-id-filter-employee-id-label": "\n .label = Ansatt-ID",
        "standard-id-filter-only-numbers-error-message": "Må bare inneholde tall",
        "standard-last-4-numbers-filter": "\n .label = Kredittkort, siste 4 siffer",
        "standard-last-4-numbers-filter-error-message": "Bare de siste 4 sifrene",
        "standard-payment-method-input-label": "Betalingsmetode",
        "standard-payment-method-item-credit-card": "Kredittkort",
        "standard-payment-method-item-contant": "Kontant",
        "standard-payment-method-item-invoicing": "Fakturering",
        "standard-payment-method-item-wallet": "Wallet",
        "standard-payment-method-item-free": "Gratis",
        "standard-merchants-filter-label": "Salgssteder",
        "standard-merchants-shops-filter-label": "Butikker",

        "standard-start-date-picker": "\n .label = Startdato",
        "standard-end-date-picker": "\n .label = Sluttdato",
        "standard-period-date-picker": "Periode",

        "table-select-data-type-filter-on-label": "Filtrer på",
        "table-select-data-type-filter-on-label-label": "\n .label = Filtrer på",
        "table-select-data-type-filter-on-item-order-date": "Ordredato",
        "table-select-data-type-filter-on-item-delivery-date": "Leveringsdato",
        "table-select-data-type-filter-on-item-booked-date": "Bokføringsdato",

        "table-select-date-period-filter-by-label": "Periode",
        "table-select-date-period-filter-by-label-label": "\n .label = Periode",
        "table-select-date-period-filter-by-all": "Alle",
        "table-select-date-period-filter-by-today": "I dag",
        "table-select-date-period-filter-by-yesterday": "I går",
        "table-select-date-period-filter-by-tomorrow": "I morgen",
        "table-select-date-period-filter-by-this-week": "Denne uken",
        "table-select-date-period-filter-by-this-month": "Denne måneden",
        "table-select-date-period-filter-by-7d": "Neste 7 dager",
        "table-select-date-period-filter-by-30d": "Neste 30 dager",

        "table-select-resource-type-filter-by-label": "Ressurstype",
        "table-select-resource-type-filter-by-label-label": "\n .label = Ressurstype",
        "table-select-resource-type-filter-by-all": "Alle",
        "table-select-resource-type-filter-by-room": "Rom",
        "table-select-resource-type-filter-by-mobile-av": "Mobil AV",
        "table-select-resource-type-filter-by-car": "Bil",

        "resource-dashboard-type-all": "Alle typer",
        "resource-dashboard-type-room": "Møterom",
        "resource-dashboard-type-mobile-av": "AV-utstyr",
        "resource-dashboard-type-car": "Biler",

        "standard-order-type-filter-mode-all": "Alle",
        "standard-order-type-filter-mode-pos": "POS",
        "standard-order-type-filter-mode-lunch": "Kantine",
        "standard-order-type-filter-mode-meeting-service": "Møteservering",
        "standard-order-type-filter-mode-resource-booking": "Ressursbooking",
        "standard-order-type-filter-mode-internal": "Intern",
        "standard-order-type-filter-mode-external": "Ekstern",
        "standard-order-type-filter-mode-take-away": "Takeaway",

        // Accounting > Orders > Meeting service
        "accounting-orders-meeting-service-receipt": "Kvittering",
        "accounting-orders-meeting-service-table-startDate-date-picker": "\n .label = Bokført startdato",
        "accounting-orders-meeting-service-table-endDate-date-picker": "\n .label = Bokført sluttdato",
        "accounting-orders-meeting-service-table-number": "Ordre-ID",
        "accounting-orders-meeting-service-table-ref": "Ref.",
        "accounting-orders-meeting-service-table-booked-date": "Bokføringsdato",
        "accounting-orders-meeting-service-table-delivery-date": "Leveringsdato",
        "accounting-orders-meeting-service-table-creator": "Oppretter",
        "accounting-orders-meeting-service-table-status": "Status",
        "accounting-orders-meeting-service-table-amount": "Beløp",
        "filter-menu-accordion-booked-date-title": "\n .title = Bokføringsdato",
        "filter-menu-accordion-delivery-date-title": "\n .title = Leveringsdato",
        "filter-menu-accordion-order-details-title": "\n .title = Ordredetaljer",
        "filter-menu-accordion-meeting-service-start-date-picker": "\n .label = Startdato",
        "filter-menu-accordion-meeting-service-end-date-picker": "\n .label = Sluttdato",
        "filter-menu-accordion-meeting-service-order-number": "\n .label = Ordrenummer \n .placeholder = Søk etter ordrenr...",
        "filter-menu-accordion-meeting-service-customer": "\n .label = Kunde \n .placeholder = Kundenavn...",
        "accounting-orders-meeting-service-payment-type-credit": "Kreditnota",
        "accounting-orders-meeting-service-payment-type-debit": "",

        // Accounting subscription
        "accounting-subscription-title": "Abonnement",
        "accounting-subscription-name": "Navn",
        "accounting-subscription-subscribed": "Abonnert",
        "accounting-subscription-unsubscribed": "Avmeldt",
        "accounting-subscription-payment-method": "Betalingsmetode",
        "accounting-subscription-amount": "Beløp",
        "accounting-subscription-cancel": "Si opp abonnement",
        "accounting-subscription-cancel-true": "Abonnementet ditt er sagt opp",


        // Accounting product sale
        "accounting-product-sale-product-code": "Produktkode",
        "accounting-product-sale-product": "Produkter",
        "accounting-product-sale-product-quantity": "Antall",
        "accounting-product-sale-product-amount": "Beløp",
        "accounting-product-sale-export-empty": "Ingen salg for denne perioden.",
        "accounting-product-sale-date-range-label": "\n .label = Periode",

        // Accounting balance
        "accounting-amount": "Beløp",
        "accounting-amount-no-sales": "Ingen salg i den gitte perioden",

        // Accounting debtors
        "accounting-debtors-export-items-label": "Antall",
        "accounting-debtors-export-amount-label": "Beløp",
        "accounting-debtors-export-subtotal-label": "Delsum",
        "accounting-debtors-export-failed": "Kunne ikke eksportere debitorer",
        "accounting-debtors-export-account-total":  "Kontototal",
        "accounting-debtors-export-subtotal": "Delsum",
        "accounting-customers-export-sales-summary": "Kundens salgsoversikt",
        "accounting-customers-export-payroll": "Kundens lønnsfiler (ZIP-fil)",


        // Merchant > Reports > Accounting > Z-report
        "merchant-accounting-z-reports-page-header": "\n .title = Z-rapport",
        "merchant-accounting-z-reports-table-date-column": "Dato",
        "merchant-accounting-z-reports-table-pos-terminal-column": "POS-terminal",
        "merchant-accounting-z-reports-table-amount-column": "Beløp",

        // Merchant > Reports > Accounting > Z-report
        "merchant-accounting-custom-reports-page-header": "\n .title = Egendefinerte rapporter",
        "merchant-accounting-custom-reports-table-name-column": "Navn",
        "merchant-accounting-custom-reports-table-interval-column": "Intervall",
        "merchant-accounting-custom-reports-table-last-run-column": "Siste kjøring",
        "merchant-accounting-custom-reports-table-status-column": "Status",
        "merchant-accounting-custom-reports-table-button-details": "Detaljer",
        "merchant-accounting-custom-reports-table-button-download-report": "Last ned rapport",
        "merchant-accounting-custom-reports-table-button-activate": "Aktiver",
        "merchant-accounting-custom-reports-table-button-deactivate": "Deaktiver",
        "merchant-accounting-custom-reports-confirm-modal-question": "Er du sikker på at du vil { $status} '{ $itemName }'?",
        "merchant-accounting-custom-reports-run-modal-form-title": "Last ned rapport",
        "merchant-accounting-custom-reports-run-modal-form-subtitle-name": "Navn:",
        "merchant-accounting-custom-reports-run-modal-form-subtitle": "Lønnstrekk",
        "merchant-accounting-custom-reports-run-modal-form-startDate-date-picker": "\n .label = Startdato",
        "merchant-accounting-custom-reports-run-modal-form-endDate-date-picker": "\n .label = Sluttdato",
        "merchant-accounting-custom-reports-run-form-save-button": "Last ned",

        // SelectCustomer
        "select-customer": "\n .label = Kunde",
        "select-debtor": "\n .label = Firma",
        "select-customer-all": "Alle",

        // SelectShop
        "select-shop": "Butikk",
        "select-shop-label": "\n .label = Butikk",
        "select-shop-all": "Alle",


        // SelectWeek
        "select-week": "Velg uke",
        "select-week-week": "Uke",

        // Select Kitchen
        "control-kitchen-mode-delivery-time": "Visning etter leveringstid",
        "control-kitchen-mode-purchase-time": "Visning etter kjøpstid",
        "control-kitchen-mode-period-report": "Perioderapport",

        // Merchant > Reports > Menu Planning
        "merchant-menu-planning-header": "\n .title = Menyplanlegging",
        "merchant-menu-planning-tab-calendar": "Kalender",
        "merchant-menu-planning-tab-menus": "Menyer",
        "merchant-menu-planning-tab-digital-signage": "Digital skilting",
        "merchant-menu-templates-row-meta": "{ $categories } kategorier · { $dishes } retter",
        "merchant-menu-templates-row-no-channels": "Ingen kanal",
        "merchant-menu-templates-row-delete-item": "Slett",
        "merchant-menu-templates-row-edit-button": "Rediger",
        "merchant-menu-templates-create-button": "Opprett ny",
        "merchant-menu-templates-empty": "Ingen maler ennå. Opprett din første mal.",
        "merchant-menu-templates-load-error": "Malen kunne ikke lastes. Prøv igjen.",
        "merchant-menu-templates-list-load-error": "Malene kunne ikke lastes. Prøv igjen.",
        "merchant-menu-templates-delete-entity": "\n .typeOfEntity = menymal",
        "merchant-menu-templates-channel-mobile-app": "Mobilapp",
        "merchant-menu-templates-channel-canteen-display": "Kantineskjerm",
        "merchant-menu-templates-channel-digital-signs": "Digital skilting",
        "merchant-menu-templates-channel-print": "Utskriftsark",
        "merchant-menu-templates-editor-new-title": "Ny mal",
        "merchant-menu-templates-editor-name-label": "Malnavn",
        "merchant-menu-templates-editor-name-field": "\n .placeholder = Malnavn",
        "merchant-menu-templates-editor-name-hint": "Internt navn — vises ikke for kunder.",
        "merchant-menu-templates-editor-channels-label": "Publiseres til",
        "merchant-menu-templates-editor-channels-hint": "Hvor malens meny vises. En mal kan rettes mot én eller flere kanaler, og ulike maler kan rettes mot ulike kanaler.",
        "merchant-menu-templates-editor-categories-title": "Kategorier",
        "merchant-menu-templates-editor-add-category-button": "Legg til kategori",
        "merchant-menu-templates-editor-cancel-button": "Avbryt",
        "merchant-menu-templates-editor-save-button": "Lagre mal",
        "merchant-menu-templates-category-dish-count": "{ $count } retter",
        "merchant-menu-templates-category-edit-button": "Rediger",
        "merchant-menu-templates-category-delete-item": "Slett",
        "merchant-menu-templates-category-dialog-add-title": "\n .dialogTitle = Legg til kategori",
        "merchant-menu-templates-category-dialog-edit-title": "\n .dialogTitle = Rediger kategori",
        "merchant-menu-templates-category-dialog-name-field": "\n .label = Kategorinavn \n .placeholder = f.eks. Varme retter",
        "merchant-menu-templates-category-dialog-cancel-button": "Avbryt",
        "merchant-menu-templates-category-dialog-save-button": "Lagre",
        "merchant-menu-templates-delete-category-dialog-title": "Slett kategori",
        "merchant-menu-templates-delete-category-dialog-message": "Er du sikker på at du vil slette '{ $name }'?",
        "merchant-menu-templates-delete-category-dialog-dishes-warning": "{ $count ->\n [one] Den inneholder { $count } rett, som også blir slettet.\n *[other] Den inneholder { $count } retter, som også blir slettet.\n}",
        "merchant-menu-templates-delete-dish-dialog-title": "Slett rett",
        "merchant-menu-templates-delete-dish-dialog-message": "Er du sikker på at du vil slette '{ $name }'?",
        "merchant-menu-templates-delete-dish-dialog-message-unnamed": "Er du sikker på at du vil slette denne retten?",
        "merchant-menu-templates-add-dish-card": "Legg til rett",
        "merchant-menu-templates-dish-remove-button": "\n .aria-label = Fjern rett",
        "merchant-menu-templates-dish-name-label": "Navn på retten",
        "merchant-menu-templates-week-day-short-monday": "Ma",
        "merchant-menu-templates-week-day-short-tuesday": "Ti",
        "merchant-menu-templates-week-day-short-wednesday": "On",
        "merchant-menu-templates-week-day-short-thursday": "To",
        "merchant-menu-templates-week-day-short-friday": "Fr",
        "merchant-menu-templates-week-day-short-saturday": "Lø",
        "merchant-menu-templates-week-day-short-sunday": "Sø",
        "merchant-menu-templates-dish-cancel-button": "Avbryt",
        "merchant-menu-templates-dish-done-button": "Ferdig",
        "merchant-menu-templates-availability-hint": "Hvilke ukedager denne retten vises på i ukemenyen.",
        "merchant-menu-templates-dish-fields-title": "Felt",
        "merchant-menu-templates-dish-new-title": "Ny rett",
        "merchant-menu-templates-dish-no-photo": "Ingen malfoto",
        "merchant-menu-templates-dish-no-mandatory-fields": "Ingen obligatoriske felt",
        "merchant-menu-templates-ai-can-fill-label": "AI kan fylle ut dette feltet",
        "merchant-menu-templates-ai-hint-on": "AI-generering i ukemenyen kan fylle ut dette feltet.",
        "merchant-menu-templates-ai-hint-off": "AI-generering i ukemenyen lar dette feltet stå tomt — kjøkkenet fyller det ut.",
        "merchant-menu-templates-ai-off-label": "AI av",
        "merchant-menu-templates-field-value-default-label": "Standardverdi (valgfri)",
        "merchant-menu-templates-field-value-locked-label": "Låst verdi · påkrevd for denne malen",
        "merchant-menu-templates-field-price": "Pris",
        "merchant-menu-templates-field-description": "Beskrivelse",
        "merchant-menu-templates-field-allergens": "Allergener",
        "merchant-menu-templates-field-availability": "Tilgjengelighet",
        "merchant-menu-templates-field-marketing-tag": "Markedsføringstagg",
        "merchant-menu-templates-field-image": "Bilde",
        "merchant-menu-templates-field-title": "Tittel",
        "merchant-menu-templates-field-ingredients": "Ingredienser",
        "merchant-menu-templates-field-nutrition": "Næringsinnhold",
        "merchant-menu-templates-field-co2-footprint": "CO₂-avtrykk",
        "merchant-menu-templates-title-value-field": "\n .placeholder = Titteltekst…",
        "merchant-menu-templates-ingredients-value-field": "\n .placeholder = f.eks. Tomater, basilikum, hvitløk, olivenolje…",
        "merchant-menu-templates-nutrition-value-field": "\n .placeholder = f.eks. 320 kcal · 12g P · 40g C · 8g F",
        "merchant-menu-templates-co2-unit": "kg CO₂ eq",
        "merchant-menu-templates-dish-details-title": "Detaljer",
        "merchant-menu-templates-dish-details-subtitle": "vises i en dialog i ukemenyen",
        "merchant-menu-templates-mode-locked": "Låst",
        "merchant-menu-templates-mode-mandatory": "Obligatorisk",
        "merchant-menu-templates-mode-optional": "Valgfri",
        "merchant-menu-templates-mode-hint-locked": "Låst — en startverdi er påkrevd her i malen; den overføres til hver ukemeny. Kjøkkenet kan fortsatt redigere den for en gitt dag.",
        "merchant-menu-templates-mode-hint-mandatory": "Obligatorisk — kjøkkenet må fylle ut dette feltet i ukemenyen. En standardverdi her er valgfri.",
        "merchant-menu-templates-mode-hint-optional": "Valgfri — kjøkkenet kan fylle ut dette feltet i ukemenyen. En standardverdi her er valgfri.",
        "merchant-menu-templates-field-show-toggle": "Vis",
        "merchant-menu-templates-field-hidden-hint": "Skjult i ukemenyen",
        "merchant-menu-templates-price-value-field": "\n .label = Pris",
        "merchant-menu-templates-price-same-week-checkbox": "Samme pris hele uken",
        "merchant-menu-templates-description-value-field": "\n .placeholder = Beskrivelsestekst…",
        "merchant-menu-templates-marketing-tag-value-field": "\n .label = Markedsføringstagg \n .helperText = Eksempler: Dagens tilbud, Rabatt",
        "merchant-menu-templates-image-upload": "\n .label = Last opp bilde",
        "merchant-menu-templates-validation-required": "Dette feltet er påkrevd",
        "merchant-menu-templates-validation-number": "Må være et tall",
        "merchant-menu-planning-tab-week-menu": "Ukens meny",
        "merchant-week-menu-cell-title-field": "\n .placeholder = Skriv navn på retten…",
        "merchant-week-menu-cell-recent-dishes-title": "Tidligere menyer",
        "merchant-week-menu-cell-description-field": "\n .placeholder = Legg til beskrivelse…",
        "merchant-week-menu-cell-description-expand-tooltip": "\n .title = Åpne hele beskrivelsen",
        "merchant-week-menu-cell-add-allergen-label": "Allergen",
        "merchant-week-menu-cell-price-field": "\n .placeholder = 0",
        "merchant-week-menu-cell-price-locked-all-week": "{ $price } DKK · hele uken",
        "merchant-week-menu-cell-price-locked": "{ $price } DKK",
        "merchant-week-menu-currency-label": "DKK",
        "merchant-week-menu-cell-marketing-field": "\n .placeholder = Markedsføringstagg (valgfritt)",
        "merchant-week-menu-cell-add-image-label": "Foto",
        "merchant-week-menu-cell-image-from-template-label": "Bilde fra malen",
        "merchant-week-menu-cell-image-delete-button": "\n .aria-label = Slett",
        "merchant-week-menu-cell-menu-button": "\n .aria-label = Handlinger for retten",
        "merchant-week-menu-cell-copy-tooltip": "\n .title = Kopier til andre dager…",
        "merchant-week-menu-cell-clear-tooltip": "\n .title = Tøm retten",
        "merchant-week-menu-cell-details-tooltip": "\n .title = Detaljer om retten",
        "merchant-week-menu-details-dialog": "\n .dialogTitle = Detaljer om retten",
        "merchant-week-menu-details-ingredients-label": "Ingredienser",
        "merchant-week-menu-details-nutrition-label": "Næringsinnhold",
        "merchant-week-menu-details-co2-label": "CO₂-avtrykk (kg CO₂ eq)",
        "merchant-week-menu-details-dialog-close-button": "Lukk",
        "merchant-week-menu-details-dialog-save-button": "Lagre",
        "merchant-week-menu-cell-unavailable": "Ikke tilgjengelig",
        "merchant-week-menu-cell-drag-tooltip": "\n .title = Dra til en annen dag",
        "merchant-week-menu-cell-status-ready": "Klar",
        "merchant-week-menu-cell-status-missing": "Mangler",
        "merchant-week-menu-missing-tooltip-title": "Mangler fortsatt",
        "merchant-week-menu-missing-field-name": "Navn",
        "merchant-week-menu-missing-field-description": "Beskrivelse",
        "merchant-week-menu-missing-field-price": "Pris",
        "merchant-week-menu-missing-field-photo": "Foto",
        "merchant-week-menu-missing-field-allergens": "Allergener",
        "merchant-week-menu-missing-field-marketing-tag": "Markedsføringstagg",
        "merchant-week-menu-cell-status-optional": "Valgfri",
        "merchant-week-menu-cell-ai-regen-tooltip": "\n .title = Generer på nytt med AI",
        "merchant-week-menu-description-dialog": "\n .dialogTitle = Rediger beskrivelse",
        "merchant-week-menu-description-dialog-field-label": "Beskrivelse",
        "merchant-week-menu-description-dialog-field": "\n .placeholder = Skriv en lengre og mer detaljert beskrivelse her…",
        "merchant-week-menu-description-dialog-close-button": "Lukk",
        "merchant-week-menu-description-dialog-save-button": "Lagre",
        "merchant-week-menu-copy-dish-dialog": "\n .dialogTitle = Kopier retten til andre dager",
        "merchant-week-menu-copy-week-to-label": "\n .label = Kopier til",
        "merchant-week-menu-copy-overwrite-label": "Overskriv utfylte retter",
        "merchant-week-menu-copy-overwrite-sublabel": "Av — bare tomme plasser fylles ut, eksisterende retter beholdes.",
        "merchant-week-menu-copy-overwrite-sublabel-on": "På — eksisterende retter overskrives også.",
        "merchant-week-menu-copy-dish-cancel-button": "Avbryt",
        "merchant-week-menu-copy-dish-confirm-button": "Kopier",
        "merchant-week-menu-week-label": "Uke { $week } · { $period }",
        "merchant-week-menu-prev-week-button": "\n .aria-label = Forrige uke",
        "merchant-week-menu-next-week-button": "\n .aria-label = Neste uke",
        "merchant-week-menu-days-ready-label": "{ $ready }/{ $total } dager klare",
        "merchant-week-menu-dish-column-label": "Rett",
        "merchant-week-menu-clear-week-snackbar": "Uken er tømt",
        "merchant-week-menu-clear-week-dialog": "\n .title = Tøm uke\n .buttonLabelSubmit = Tøm",
        "merchant-week-menu-clear-week-dialog-message": "Dette fjerner alle retter som er lagt inn for denne uken. Handlingen kan ikke angres.",
        "merchant-week-menu-close-day-dialog": "\n .title = Steng denne dagen\n .buttonLabelSubmit = Steng dagen",
        "merchant-week-menu-close-day-dialog-message": "{ $count } utfylte retter på denne dagen publiseres ikke mens dagen er stengt.",
        "merchant-week-menu-remove-theme-dialog": "\n .title = Bytt tilbake til malen\n .buttonLabelSubmit = Bytt tilbake",
        "merchant-week-menu-remove-theme-dialog-message": "Vil du forkaste { $count } temaretter på denne dagen og bytte tilbake til malen?",
        "merchant-week-menu-publish-button": "Publiser klare dager",
        "merchant-week-menu-autosaved-label": "Lagret automatisk",
        "merchant-week-menu-day-publish-tooltip": "\n .title = Publiser denne dagen til kunder",
        "merchant-week-menu-day-status-draft": "Kladd",
        "merchant-week-menu-day-status-published": "Publisert",
        "merchant-week-menu-day-status-updated": "Oppdatert",
        "merchant-week-menu-day-menu-button": "\n .aria-label = Handlinger for dagen",
        "merchant-week-menu-day-menu-theme-item": "Gjør denne dagen til en temadag",
        "merchant-week-menu-day-menu-rename-theme-item": "Rediger temanavn…",
        "merchant-week-menu-day-menu-remove-theme-item": "Bytt tilbake til malen",
        "merchant-week-menu-day-menu-close-item": "Marker dagen som stengt",
        "merchant-week-menu-theme-dialog-add-title": "\n .dialogTitle = Gjør { $day } til en temadag",
        "merchant-week-menu-theme-dialog-rename-title": "\n .dialogTitle = Rediger temanavn",
        "merchant-week-menu-theme-dialog-name-label": "Navn på temaet",
        "merchant-week-menu-theme-dialog-name-field": "\n .placeholder = Skriv tema...",
        "merchant-week-menu-theme-dialog-hint": "Gi temaet et kort navn som \"Spansk dag\" eller \"Jul\".",
        "merchant-week-menu-theme-dialog-close-button": "Lukk",
        "merchant-week-menu-theme-dialog-save-button": "Lagre",
        "merchant-week-menu-theme-add-dish-button": "Legg til rett",
        "merchant-week-menu-closed-panel-title": "Stengt",
        "merchant-week-menu-closed-panel-message": "Ingen meny denne dagen. Kundene ser dagen som stengt.",
        "merchant-week-menu-closed-reopen-button": "Gjenåpne dagen",
        "merchant-week-menu-copy-week-dialog": "\n .dialogTitle = Kopier uken til andre uker",
        "merchant-week-menu-copy-week-cancel-button": "Avbryt",
        "merchant-week-menu-copy-week-confirm-button": "Kopier",
        "merchant-week-menu-ai-button": "AI",
        "merchant-week-menu-ai-menu-quick-title": "Hurtigmeny",
        "merchant-week-menu-ai-menu-quick-subtitle": "Generer hele uken automatisk",
        "merchant-week-menu-ai-menu-customize-title": "Tilpass meny",
        "merchant-week-menu-ai-menu-customize-subtitle": "Velg temaer og regler per dag, og generer deretter",
        "merchant-week-menu-ai-banner-title": "AI har generert denne menyen",
        "merchant-week-menu-ai-banner-subtitle": "Gå gjennom rettene før du publiserer.",
        "merchant-week-menu-ai-banner-regenerate-button": "Generer på nytt",
        "merchant-week-menu-ai-banner-undo-button": "Angre",
        "merchant-week-menu-ai-banner-close-button": "\n .aria-label = Lukk",
        "merchant-week-menu-ai-dialog": "\n .dialogTitle = Tilpass menygenerering",
        "merchant-week-menu-ai-dialog-subtitle": "Velg et tema og regler, og la AI fylle ut uken",
        "merchant-week-menu-ai-theme-label": "Tema",
        "merchant-week-menu-ai-inspiration-label": "Inspirasjon",
        "merchant-week-menu-ai-dialog-notes-field": "\n .placeholder = Legg til dine egne ideer eller regler, f.eks. bestemte krav",
        "merchant-week-menu-ai-overwrite-label": "Overskriv eksisterende retter",
        "merchant-week-menu-ai-overwrite-helper": "Av = AI fyller bare ut tomme felt",
        "merchant-week-menu-ai-overwrite-dialog": "\n .dialogTitle = Denne menyen har allerede retter",
        "merchant-week-menu-ai-overwrite-subtitle": "Hvordan skal AI håndtere dagene som allerede er utfylt?",
        "merchant-week-menu-ai-overwrite-fill-title": "Fyll bare ut tomme felt",
        "merchant-week-menu-ai-overwrite-fill-subtitle": "Behold rettene du allerede har skrevet",
        "merchant-week-menu-ai-overwrite-replace-title": "Erstatt alle retter",
        "merchant-week-menu-ai-overwrite-replace-subtitle": "Overskriv hele uken",
        "merchant-week-menu-ai-overwrite-choose-button": "Velg",
        "merchant-week-menu-ai-overwrite-cancel-button": "Avbryt",
        "merchant-week-menu-ai-dialog-cancel-button": "Avbryt",
        "merchant-week-menu-ai-dialog-generate-button": "Generer",
        "merchant-week-menu-ai-theme-surprise": "Overrask meg",
        "merchant-week-menu-no-templates-title": "Ingen menymaler ennå",
        "merchant-week-menu-no-templates-message": "For å planlegge en ukemeny må du først opprette en mal med kategoriene og rettene dine.",
        "merchant-week-menu-create-template-button": "Opprett mal",
        "merchant-week-menu-load-error": "Ukemenyen kunne ikke lastes. Prøv igjen.",
        "merchant-week-menu-legend-empty": "Tom",
        "merchant-week-menu-legend-filled": "Utfylt (komplett)",
        "merchant-week-menu-legend-needs-fill": "Påbegynt, obligatorisk felt mangler",
        "merchant-week-menu-legend-default": "Malens standard — kan redigeres, ikke redigert ennå",
        "merchant-week-menu-legend-ai-mode": "AI-modus",
        "merchant-week-menu-cell-description-field-optional": "\n .placeholder = Legg til beskrivelse (valgfritt)…",
        "merchant-week-menu-cell-add-allergen-label-optional": "Allergen (valgfritt)",
        "merchant-week-menu-copy-dish-dialog-sub": "Kopierer denne retten til samme rad på dagene du velger.",
        "merchant-week-menu-copy-dish-select-all": "Velg alle",
        "merchant-week-menu-theme-dish-remove-button": "\n .aria-label = Fjern temaretten",
        "merchant-week-menu-copy-dish-clear": "Tøm",
        "merchant-week-menu-copy-dish-source-suffix": "(kilde)",
        "merchant-week-menu-copy-dish-warning": "Noen av de valgte dagene har allerede en rett. De hoppes over med mindre du slår på overskriving.",
        "merchant-week-menu-copy-dish-snackbar": "Retten er kopiert til { $count } dager.",
        "merchant-week-menu-copy-dish-skipped-snackbar": "Retten er kopiert til { $count } dager · { $skipped } hoppet over (allerede utfylt).",
        "merchant-week-menu-copy-week-source-subtitle": "Hele ukens meny · { $period }",
        "merchant-week-menu-copy-week-next-prefix": "Neste uke ({ $label })",
        "merchant-week-menu-copy-week-snackbar": "Ukemenyen er kopiert til { $week }.",
        "merchant-week-menu-swap-snackbar": "Byttet { $dish } mellom { $dayA } og { $dayB }.",
        "merchant-week-menu-theme-created-snackbar": "Temadag opprettet: { $name }.",
        "merchant-week-menu-theme-reverted-snackbar": "Dagen er byttet tilbake til malen.",
        "merchant-week-menu-day-closed-snackbar": "{ $day } er markert som stengt.",
        "merchant-week-menu-day-reopened-snackbar": "{ $day } er gjenåpnet.",
        "merchant-week-menu-publish-count-snackbar": "{ $count } dager er publisert til kunder.",
        "merchant-week-menu-publish-none-snackbar": "Ingen dager er slått på for publisering.",
        "merchant-week-menu-ai-ready-snackbar": "AI-menyen er klar — gå gjennom og behold.",
        "merchant-week-menu-ai-regenerated-snackbar": "Retten er generert på nytt.",
        "merchant-week-menu-ai-reverted-snackbar": "Gjenopprettet til forrige meny.",
        "merchant-week-menu-ai-no-open-days-snackbar": "Ingen åpne dager å generere for denne uken.",
        "merchant-week-menu-ai-banner-working-title": "Genererer meny…",
        "merchant-week-menu-ai-banner-working-subtitle": "Oppretter retter til { $template }",
        "merchant-week-menu-theme-dialog-create-button": "Lagre",
        "merchant-week-menu-theme-dialog-warning": "{ $day } har { $count } utfylte felt fra malen. Hvis du bytter til en temadag, forkastes de.",
        "merchant-week-menu-theme-panel-edit-tooltip": "\n .title = Rediger temanavn",
        "merchant-week-menu-theme-panel-revert-tooltip": "\n .title = Bytt tilbake til malen",
        "merchant-week-menu-recent-dishes-matching-title": "Tidligere menyer · treff på \"{ $query }\"",
        "merchant-week-menu-recent-dishes-meta": "Denne uken",
        "merchant-week-menu-recent-dish-price": "· { $price } DKK",
        "merchant-week-menu-details-title-label": "Tittel",
        "merchant-week-menu-details-description-label": "Beskrivelse",
        "merchant-week-menu-details-price-label": "Pris",
        "merchant-week-menu-details-allergens-label": "Allergener",
        "merchant-week-menu-details-marketing-label": "Markedsføringstagg",
        "merchant-week-menu-details-image-label": "Bilde",
        "merchant-week-menu-details-accordion-title": "Næring og miljø",
        "merchant-week-menu-details-co2-unit": "kg CO₂-ekv.",
        "merchant-week-menu-ai-theme-asian": "Asiatisk",
        "merchant-week-menu-ai-theme-mediterranean": "Middelhavet",
        "merchant-week-menu-ai-theme-nordic": "Nordisk",
        "merchant-week-menu-ai-theme-italian": "Italiensk",
        "merchant-week-menu-ai-theme-mexican": "Meksikansk",
        "merchant-week-menu-ai-theme-indian": "Indisk",
        "merchant-week-menu-ai-theme-middle-eastern": "Midtøsten",
        "merchant-week-menu-ai-spice-label": "Styrke",
        "merchant-week-menu-ai-spice-low": "Mild",
        "merchant-week-menu-ai-spice-medium": "Middels",
        "merchant-week-menu-ai-spice-spicy": "Sterk",
        "merchant-week-menu-ai-health-label": "Sunnhet",
        "merchant-week-menu-ai-health-healthy": "Sunn",
        "merchant-week-menu-ai-health-balanced": "Balansert",
        "merchant-week-menu-ai-health-comfort": "Kosemat",
        "merchant-week-menu-ai-style-label": "Stil",
        "merchant-week-menu-ai-style-normal": "Normal",
        "merchant-week-menu-ai-style-gourmet": "Gourmet",
        "merchant-week-menu-ai-style-fun": "Gøy",
        "merchant-week-menu-ai-style-party": "Fest",
        "merchant-week-menu-ai-style-celebration": "Feiring",
        "merchant-week-menu-ai-ingredients-label": "Ingredienser som skal være med",
        "merchant-week-menu-ai-ingredients-input": "\n .placeholder = Skriv og trykk Enter…",
        "merchant-week-menu-ai-mode-all": "Alle dager like",
        "merchant-week-menu-ai-mode-per-day": "Tilpass hver dag",
        "merchant-week-menu-marketing-popover-title": "Foreslåtte tagger",
        "merchant-week-menu-marketing-add-custom-tag": "Legg til egen tagg",
        "merchant-week-menu-overflow-button": "\n .aria-label = Flere handlinger",
        "merchant-week-menu-overflow-manage-templates-item": "Administrer maler",
        "merchant-week-menu-overflow-customer-preview-item": "Kundevisning",
        "merchant-week-menu-overflow-copy-week-item": "Kopier uke",
        "merchant-week-menu-overflow-clear-week-item": "Tøm uke",
        "merchant-week-menu-overflow-export-pdf-item": "Eksporter til PDF",
        "merchant-week-menu-overflow-print-item": "Skriv ut kjøkkenseddel",
        "merchant-week-menu-customer-view-button": "Kundevisning",
        "merchant-week-menu-feature-not-ready-snackbar": "Ikke tilgjengelig ennå",
        "merchant-week-menu-autosaved-just-now": "Lagret automatisk akkurat nå",
        "merchant-week-menu-autosaved-minutes": "Lagret automatisk · for { $minutes } min. siden",
        "merchant-week-menu-row-ready-label": "{ $filled }/{ $total } klare",
        "merchant-week-menu-row-template-default-chip": "Malens standard",
        "merchant-menu-planning-table-startDate-date-picker": "\n .label = Startdato",
        "merchant-menu-planning-table-endDate-date-picker": "\n .label = Sluttdato",
        "merchant-menu-planning-table-week-select": "\n .label = Uke",
        "merchant-menu-planning-table-week-select-option": "Uke { $countOfWeek } ({ $startDate } - { $endDate })",
        "merchant-menu-planning-table-date-column": "Dato",
        "merchant-menu-planning-table-dish": "Rett { $counter }:",
        "merchant-menu-planning-table-price": "Pris: { $price }",
        "merchant-menu-planning-table-allergens": "Allergener: { $allergens }",
        "merchant-menu-planning-table-type-mode-digital-signage": "Digital skilting",
        "merchant-menu-planning-table-type-mode-web-menu": "Nettmeny",
        "merchant-menu-planning-table-type-recurring": "Gjentakende",
        "merchant-menu-planning-table-status-column": "Status",
        "merchant-menu-planning-table-active-column-active": "Aktiv",
        "merchant-menu-planning-table-active-column-inactive": "Inaktiv",
        "merchant-menu-planning-table-active-column-active-filter-yes": "Aktiv",
        "merchant-menu-planning-table-active-column-inactive-filter-no": "Inaktiv",
        "merchant-menu-planning-table-dishes-count": "Antall retter",
        "merchant-menu-planning-table-recurrence": "Gjentakelse",
        "merchant-menu-planning-table-create-button": "Opprett ny",
        "merchant-menu-planning-table-week-menu-rss-button": "Ukemeny som RSS",
        "merchant-menu-planning-table-week-menu-atom-button": "Ukemeny som Atom",
        "merchant-menu-planning-table-week-menu-page-button": "Ukemeny som nettside",
        "public-canteen-week-menu-title": "Kantinemeny",
        "public-canteen-week-menu-week-label": "Uke { $weekNumber }",
        "public-canteen-week-menu-allergens-label": "Allergener:",
        "public-canteen-week-menu-empty": "Dessverre er det ikke opprettet noen menyer denne uken.",
        "public-canteen-week-menu-load-error": "Vi kunne ikke laste menyen på grunn av en feil.\n    Kontakt support for å få hjelp.",
        "public-menu-display-status-offline": "Ingen internettforbindelse",
        "public-menu-display-status-server-down": "Kunne ikke koble til serveren",
        "public-menu-display-status-refresh-failed": "Menyen kunne ikke oppdateres",
        "public-menu-display-header-title": "Dagens meny",
        "public-menu-display-empty-message": "Ingen meny er publisert i dag",
        "public-menu-display-unavailable-message": "Menyen kunne ikke hentes",
        "public-menu-display-pagination-label": "{$current} av {$total} menyer",
        "public-menu-display-allergens-contains-label": "Inneholder",
        "public-menu-display-scan-qr-text": "Skann for ukemeny",
        "merchant-menu-planning-table-menu-item-edit": "Rediger",
        "merchant-menu-planning-table-menu-item-set-inactive": "Deaktiver",
        "merchant-menu-planning-table-menu-item-set-active": "Aktiver",
        "merchant-menu-planning-table-menu-item-delete": "Slett",
        "merchant-menu-planning-confirm-delete-shop-dialog": "\n .typeOfEntity = meny",
        "merchant-menu-planning-dialog-create-title": "Opprett meny",
        "merchant-menu-planning-dialog-edit-title": "Rediger meny",
        "merchant-menu-planning-dialog-max-dishes": "Tilgjengelige rettskilt: { $countOfDishes }",
        "merchant-menu-planning-dialog-add-marketing-details-button": "\n .title = + Legg til markedsføringsdetaljer",
        "merchant-menu-planning-dialog-add-dish-button": "Legg til rett",
        "merchant-menu-planning-dialog-add-recurrence-button": "\n .title = + Legg til gjentakelse",
        "merchant-menu-planning-dialog-remove-recurrence-button": "\n .title = Fjern gjentakelse",
        "merchant-menu-planning-dialog-create-submit-button": "Opprett",
        "merchant-menu-planning-dialog-save-submit-button": "Lagre",
        "merchant-menu-planning-dialog-dish": "Rett { $countOfDish }",
        "merchant-menu-planning-dialog-publishDate-date-picker": "\n .label = Publiseringsdato",
        "merchant-menu-planning-dialog-recurrence": "Gjentakelse",
        "merchant-menu-planning-dialog-name-of-dish-field": "\n .label = Navn på retten",
        "merchant-menu-planning-dialog-brief-field": "\n .label = Kort beskrivelse \n .placeholder = Kort beskrivelse, maks. 80 tegn inkludert mellomrom.",
        "merchant-menu-planning-dialog-marketing-tag-field": "\n .label = Markedsføringstagg \n .helperText = Eksempler: Dagens tilbud, Rabatt",
        "merchant-menu-planning-dialog-from-date-picker": "\n .label = Fra dato",
        "merchant-menu-planning-dialog-to-date-picker": "\n .label = Til dato",
        "merchant-menu-planning-dialog-currency-field": "\n .label = Valuta",
        "merchant-menu-planning-dialog-price-field": "\n .label = Pris",
        "merchant-menu-planning-dialog-upload-image": "\n .label = Last opp bilde",
        "merchant-menu-planning-week-day-monday": "Mandag",
        "merchant-menu-planning-week-day-tuesday": "Tirsdag",
        "merchant-menu-planning-week-day-wednesday": "Onsdag",
        "merchant-menu-planning-week-day-thursday": "Torsdag",
        "merchant-menu-planning-week-day-friday": "Fredag",
        "merchant-menu-planning-week-day-saturday": "Lørdag",
        "merchant-menu-planning-week-day-sunday": "Søndag",
        "merchant-menu-planning-dialog-signageTypes-label": "Publiser til:",
        "merchant-menu-planning-dialog-signageTypes-mode-web-menu": "Nettmeny",
        "merchant-menu-planning-dialog-signageTypes-mode-buffet-sign": "Buffetskilt",
        "merchant-menu-planning-dialog-signageTypes-mode-day-menu-sign": "Dagens meny-skilt",
        "merchant-menu-planning-dialog-signageTypes-min-error": "Velg minst én skiltetype",
        "merchant-menu-planning-digital-signage-card-serial-no": "Serienr.:",
        "merchant-menu-planning-digital-signage-card-device-id": "Enhets-ID:",
        "merchant-menu-planning-digital-signage-card-device-name": "Enhetsnavn:",
        "merchant-menu-planning-digital-signage-card-last-update": "Sist oppdatert:",
        "merchant-menu-planning-digital-signage-card-battery-status": "Batteristatus:",
        "merchant-menu-planning-digital-signage-card-battery-status-0": "Udefinert",
        "merchant-menu-planning-digital-signage-card-battery-status-1": "Ukjent",
        "merchant-menu-planning-digital-signage-card-battery-status-2": "God",
        "merchant-menu-planning-digital-signage-card-battery-status-3": "Dårlig",
        "merchant-menu-planning-digital-signage-card-battery-status-4": "Dårlig kjøler",
        "merchant-menu-planning-digital-signage-card-battery-status-5": "Skift ut",
        "merchant-menu-planning-digital-signage-card-battery-status-6": "Skift ut kjøler",
        "merchant-menu-planning-digital-signage-card-status-code": "Statuskode:",
        "merchant-menu-planning-digital-signage-card-status-code--99": "Ukjent",
        "merchant-menu-planning-digital-signage-card-status-code--10": "Rengjøring mislyktes",
        "merchant-menu-planning-digital-signage-card-status-code--2": "Systemkonfigurasjon mislyktes",
        "merchant-menu-planning-digital-signage-card-status-code--1": "Nettverkskonfigurasjon mislyktes",
        "merchant-menu-planning-digital-signage-card-status-code-0": "Ikke konfigurert",
        "merchant-menu-planning-digital-signage-card-status-code-1": "Nettverk konfigurert",
        "merchant-menu-planning-digital-signage-card-status-code-2": "Kommunikasjon mislyktes",
        "merchant-menu-planning-digital-signage-card-status-code-3": "Lavt batteri",
        "merchant-menu-planning-digital-signage-card-status-code-4": "Gjeldende sidedesign ikke funnet",
        "merchant-menu-planning-digital-signage-card-status-code-5": "Gjeldende sideprodukt ikke funnet",
        "merchant-menu-planning-digital-signage-card-status-code-6": "Oppdatering av gjeldende side mislyktes",
        "merchant-menu-planning-digital-signage-card-status-code-7": "Alternativt sidedesign ikke funnet",
        "merchant-menu-planning-digital-signage-card-status-code-8": "Alternativt sideprodukt ikke funnet",
        "merchant-menu-planning-digital-signage-card-status-code-9": "Oppdatering av alternativ side mislyktes",
        "merchant-menu-planning-digital-signage-card-status-code-10": "Ok",
        "merchant-menu-planning-digital-signage-card-status-code-11": "Helsesjekk mislyktes",
        "merchant-menu-planning-digital-signage-card-status-code-12": "Lav temperatur",
        "merchant-menu-planning-digital-signage-card-status-code-20": "Bilde overskrevet",
        "merchant-menu-planning-digital-signage-card-status-code-50": "Forhåndskonfigurert",
        "merchant-menu-planning-digital-signage-card-status-code-99": "I kø",
        "merchant-menu-planning-digital-signage-empty": "Ingen enheter for digital skilting funnet",
        "merchant-menu-planning-digital-signage-dialog-title": "Digitalt skilt",
        "merchant-menu-planning-digital-signage-menu-details": "Detaljer",
        "merchant-menu-planning-digital-signage-menu-clear-sign": "Tøm skilt",
        "merchant-menu-planning-color-field-label": "\n .label = Farge",

        // --- Merchant ---

        // Navigation
        "merchant-nav-item-home": "Hjem",

        //  - reporting
        "merchant-nav-item-production": "\n .title = Produksjon",
        "merchant-nav-item-menu-planning": "Menyplanlegging",
        "merchant-nav-item-group-menu-planning": "\n .title = Menyplanlegging",
        "merchant-nav-item-menu-planning-header": "Menyplanlegging",
        "merchant-nav-item-menu-planning-v2": "Menyplanlegging v2",
        "merchant-nav-item-group-id-cards": "\n .title = ID-kort",
        "merchant-nav-item-id-cards-header": "ID-kort",
        "merchant-admin-menu-planning-header": "\n .title = Menyplanlegging",
        "merchant-nav-item-purchase-control": "Kjøpskontroll",
        "merchant-nav-item-survey": "Brukertilfredshet",
        "merchant-nav-item-accounting": "Regnskap",
        "merchant-nav-item-accounting-page-header": "\n .title = Regnskap",
        "merchant-nav-item-production-planning": "Planlegging",
        "merchant-nav-item-production-meeting-service": "Møteservering",
        "merchant-nav-item-production-meeting-service-view": "Produksjonsvisning",
        "merchant-nav-item-production-takeaway": "Takeaway",
        "merchant-nav-item-production-pos-purchases": "POS-kjøp",

        //  - admin
        "merchant-nav-item-settings-page-header": "\n .title = Innstillinger",
        "merchant-nav-item-settings-header": "Innstillinger",
        "merchant-nav-item-customer-access": "Kundetilgang",
        "merchant-nav-item-id-cards": "ID-kort",
        "merchant-nav-item-custom-jobs":"Tilpassede jobber",
        "merchant-nav-item-merchant-news": "Kundenyheter",
        "merchant-nav-item-messaging": "Push-meldinger",
        "merchant-nav-item-news": "Kundenyheter",
        "merchant-nav-item-info-displays": "Integrasjonsfeeder",
        "merchant-info-displays-header": "\n .title = Integrasjonsfeeder",
        "merchant-info-displays-page-subtitle":
            "Skjermer publisert fra Facilitynet. Forhåndsvis en skjerm, del den som lenke eller innebygging, eller tilbakestill lenken for å fjerne tilgangen.",
        "merchant-info-displays-filter-all": "Alle skjermer",
        "merchant-info-displays-filter-menu": "Meny",
        "merchant-info-displays-filter-production": "Produksjon",
        "merchant-info-displays-count-label": "{ $count } skjermer",
        "merchant-info-displays-card-thumbnail-label": "forhåndsvisning av skjerm",
        "merchant-info-displays-card-status-live": "\n .label = Live",
        "merchant-info-displays-card-status-inactive": "\n .label = Inaktiv",
        "merchant-info-displays-card-menu-simple-name": "Ukemeny — Enkel (iFrame)",
        "merchant-info-displays-card-menu-simple-description": "Brukes til å vise menyen på nettsted / intranett.",
        "merchant-info-displays-card-menu-layout-name": "Dagens meny — Layout 1",
        "merchant-info-displays-card-menu-layout-description": "Brukes til visning på skjerm i kantinen.",
        "merchant-info-displays-card-production-name": "Produksjonsskjerm",
        "merchant-info-displays-card-production-description":
            "Brukes til visning på skjerm i produksjonsområdene for å styre kommende bestillinger.",
        "merchant-info-displays-menu-preview-item": "Forhåndsvisning",
        "merchant-info-displays-menu-link-item": "Permalink / innebygging",
        "merchant-info-displays-menu-permalink-item": "Permalink",
        "merchant-info-displays-menu-reset-item": "Tilbakestill",
        "merchant-info-displays-menu-inactivate-item": "Deaktiver",
        "merchant-info-displays-menu-activate-item": "Aktiver",
        "merchant-info-displays-link-dialog-embed": "\n .dialogTitle = Permalink / innebygging\n .subtitle = { $name } — alle med denne lenken kan se skjermen.",
        "merchant-info-displays-link-dialog-permalink": "\n .dialogTitle = Permalink\n .subtitle = { $name } — alle med denne lenken kan se skjermen.",
        "merchant-info-displays-link-dialog-permalink-login-required": "\n .dialogTitle = Permalink\n .subtitle = { $name } — krever pålogging i Facilitynet; åpner skjermen i fullskjerm.",
        "merchant-info-displays-link-dialog-permalink-label": "Permalink",
        "merchant-info-displays-link-dialog-embed-label": "Innebyggingskode",
        "merchant-info-displays-copy-tooltip": "\n .title = Kopier",
        "merchant-info-displays-link-dialog-reset-button": "Tilbakestill lenke",
        "merchant-info-displays-link-dialog-done-button": "Ferdig",
        "merchant-info-displays-copy-success": "Kopiert til utklippstavlen",
        "merchant-info-displays-reset-dialog":
            "\n .title = Tilbakestille lenke?\n .message = Det genereres en ny lenke for { $name }. Den nåværende lenken og alle innebygginger som bruker den, slutter å fungere umiddelbart.\n .buttonLabelSubmit = Tilbakestill lenke",
        "merchant-nav-item-users": "Administratorer",
        "merchant-nav-item-shops": "Butikker",
        "merchant-nav-item-payment-links": "Betalingslenker",
        "merchant-nav-item-products": "Produkter",
        "merchant-nav-item-product-create": "Opprett produkt",
        "merchant-nav-item-extra-service-create": "Opprett ekstratjeneste",
        "merchant-nav-item-extra-service-edit": "Rediger ekstratjeneste",
        "merchant-nav-item-product-update": "Rediger produkt",
        "merchant-nav-item-product-groups": "Produktgrupper",
        "merchant-nav-item-extra-services": "Ekstratjenester",
        "merchant-nav-item-product-group-create": "Opprett produktgruppe",
        "merchant-nav-item-product-group-update": "Rediger produktgruppe",
        "merchant-nav-item-price-lists": "Prislister",
        "merchant-nav-item-price-list-create": "Opprett prisliste",
        "merchant-nav-item-price-list-edit": "Rediger prisliste",
        "merchant-nav-item-surveys": "Brukerundersøkelser",
        "merchant-nav-item-devices": "Maskinvareenheter",
        "merchant-nav-item-communication-page-header":"\n .title = Kommunikasjon",
        "merchant-nav-item-communication-header":"Kommunikasjon",
        "merchant-nav-item-group-products":"\n .title = Produkter",
        "merchant-nav-item-products-header":"Produkter",
        "merchant-nav-item-group-shops":"\n .title = Butikker",
        "merchant-nav-item-offers":"Tilbud",
        "merchant-nav-item-vat-codes":"MVA-koder",
        "merchant-nav-item-create-vat-code":"Opprett MVA-kode",
        "merchant-nav-item-edit-vat-code":"Rediger MVA-kode",
        "merchant-nav-item-group-organization":"\n .title = Organisasjon",
        "merchant-nav-item-group-account":"\n .title = Konto",
        "merchant-nav-item-billing":"Fakturaer",
        "merchant-nav-item-account":"Konto",
        "merchant-nav-item-merchant-account":"Virksomhetskonto",
        "merchant-nav-item-delivery-locations": "Leveringssteder",
        "merchant-nav-item-sales-accounts": "Salgskontoer",
        "merchant-nav-item-live-dashboard": "Live dashboard",

        // Admin home
        "merchant-admin-home-products-group": "\n .title = Produkter",
        "merchant-admin-home-communication-group": "\n .title = Kommunikasjon",
        "merchant-admin-home-customers-group": "\n .title = Kunder",
        "merchant-admin-home-settings-group": "\n .title = Innstillinger",
        "merchant-admin-home-customers-card": "\n .title = Kundetilgang\n .description = Administrer kundenes tilgang til systemet",
        "merchant-admin-home-merchant-news-card": "\n .title = Kundenyheter\n .description = Publiser nyheter for salgsstedet til kundene dine.",
        "merchant-admin-home-admin-card": "\n .title = Administratorer\n .description = Administrer administratorer for salgsstedet ditt.",
        "merchant-admin-home-shop": "\n .title = Butikker\n .description = Selg produktene dine i butikker med individuell profilering.",
        "merchant-admin-home-payment-links": "\n .title = Betalingslenker \n .description = Opprett en unik betalingslenke til gjester eller kursdeltakere.",
        "merchant-admin-home-products": "\n .title = Produkter\n .description = Legg til og vedlikehold produkter for butikkene dine.",
        "merchant-admin-home-product-groups": "\n .title = Produktgrupper\n .description = Del produktene dine inn i grupper og styr synligheten til gruppene i løpet av dagen.",
        "merchant-admin-home-price-list": "\n .title = Prislister\n .description = Bruk prislister for å tilby differensierte produkter og priser til kundene dine.",
        "merchant-admin-home-extra-services": "\n .title = Ekstratjenester\n .description = Legg til og vedlikehold ekstratjenester for butikkene dine.",
        "merchant-admin-home-merchant-surveys": "\n .title = Brukerundersøkelser\n .description = Hold øye med kundetilfredsheten ved å opprette brukerundersøkelser.",
        "merchant-admin-home-push-messages-card": "\n .title = Push-meldinger\n .description = Send og administrer push-meldinger til kundene dine",
        "merchant-admin-home-info-displays-card":
            "\n .title = Integrasjonsfeeder\n .description = Forhåndsvis og del integrasjonsfeedene dine.",
        "merchant-admin-home-devices-card": "\n .title = Maskinvareenheter\n .description = Vis maskinvareenheter, som skjermer, skrivere og kredittkortterminaler.",
        "merchant-admin-home-offers-card": "\n .title = Tilbud\n .description = Administrer tilbudene dine",
        "merchant-admin-home-vat-codes-card": "\n .title = MVA-koder\n .description = Administrer MVA-koder",
        "merchant-admin-home-id-cards-card": "\n .title = ID-kort\n .description = Vis kundenes ID-kort som brukes til POS-betaling.",
        "merchant-admin-home-id-cards-group": "\n .title = ID-kort",
        "merchant-admin-home-menu-planning-card": "\n .title = Menyplanlegging\n .description = Opprett og administrer menymaler.",
        "merchant-admin-home-custom-jobs-card": "\n .title = Tilpassede jobber\n .description = Se og kjør tilpassede jobber for salgsstedet ditt.",
        "merchant-admin-home-account-group": "\n .title = Konto",
        "merchant-admin-home-merchant-account-card": "\n .title = Virksomhetskonto\n .description = Oppdater virksomhetens stamdata\n .buttonText = Vis",
        "merchant-admin-home-delivery-locations-card": "\n .title = Leveringssteder\n .description = Administrer leveringssteder der kunder kan hente bestillinger.",

        // Merchant > Admin > Settings > Custom jobs
        "merchant-admin-settings-custom-jobs-title":" \n .title = Tilpassede jobber",
        "merchant-admin-settings-custom-jobs-table-name":"Navn",
        "merchant-admin-settings-custom-jobs-table-interval":"Intervall",
        "merchant-admin-settings-custom-jobs-table-last-run":"Siste kjøring",
        "merchant-admin-settings-custom-jobs-table-status":"Status",
        "merchant-admin-settings-custom-jobs-table-action-details":"Detaljer",
        "merchant-admin-settings-custom-jobs-table-action-run-job":"Kjør jobb",
        "merchant-admin-settings-custom-jobs-table-action-activate":"Aktiver",
        "merchant-admin-settings-custom-jobs-table-action-inactivate":"Deaktiver",

        // Messages
        "messages-list-header": "\n .title = Push-meldinger",
        "messages-list-create-button": "Opprett ny",
        "merchant-nav-item-messages": "Push-meldinger",
        "messages-table-subject-column" : "Emne",
        "messages-table-publish-time-column": "Publiseringsdato",
        "messages-table-expire-time-column": "Utløpsdato",
        "messages-table-publish-type-filter-label": "Publiseringstype",
        "messages-table-publish-type-filter-label-label": "\n .label = Publiseringstype",
        "messages-table-publish-type-filter-item-published": "Publisert",
        "messages-table-publish-type-filter-item-upcoming": "Kommende",
        "messages-table-publish-type-filter-item-expired": "Utløpt",
        "messages-table-edit-button": "Rediger",
        "messages-table-delete-button": "Slett",
        "messages-table-delete-modal-title": "melding",
        "messages-table-delete-success-message": "Meldingen er slettet",
        "messages-table-update-delete-dialog-title": "Denne meldingen kan ikke oppdateres eller slettes",
        "messages-table-update-delete-dialog-description": "Meldingen kan ikke oppdateres eller slettes fordi den er publisert.",
        "messages-table-update-delete-dialog-button": "Lukk",

        // create / edit messages
        "create-message-header": "\n .title = Opprett melding",
        "edit-message-header": "\n .title = Rediger melding",
        "nav-item-create-message-header": "Opprett melding",
        "nav-item-edit-message-header": "Rediger melding",
        "create-message-save-button": "Opprett",
        "edit-message-save-button": "Lagre",
        "create-or-edit-message-info": "\n .title = Send korte, viktige meldinger til brukerne, f.eks. om stengte dager, arrangementer eller lignende. Meldinger er synlige for alle brukere som er tilknyttet butikkene dine.",
        "create-or-edit-message-field-subject":
            "\n .label = Overskrift \n .placeholder = Legg til et fengende emne som brukerne har lyst til å lese * \n .helperText = Legg til et fengende emne som brukerne har lyst til å lese",
        "create-or-edit-message-dialog-field-subject-label": "Overskrift:",
        "create-or-edit-message-field-title-page": "\n .label = Overskrift\n .placeholder = Overskrift\n .helperText = Legg til et fengende emne som brukerne har lyst til å lese",
        "create-or-edit-message-dialog-field-message-label": "Melding:",
        "create-or-edit-message-field-message": "\n .label = Melding\n .placeholder = Skriv inn en melding *\n .helperText = Gjenstående tegn: { $charsRemaining }",
        "create-or-edit-message-settings": "\n .title = Innstillinger",
        "create-or-edit-message-field-publishDate": "\n .label = Publisering:",
        "create-or-edit-message-field-publish-title": "Publisering:",
        "create-or-edit-message-accordion-title": "Innstillinger",
        "create-or-edit-message-field-publishDate-page": "\n .label = Publisering",
        "create-or-edit-message-field-publishDate-helperText": "Bestemmer når meldingen blir synlig for brukerne.",
        "create-or-edit-message-field-expirationDate-info": "\n .title = Utløpstiden gjelder kun for meldinger på infoskjermer og møteromsskjermer.",
        "create-or-edit-message-field-expirationDate-title": "Utløp:",
        "create-or-edit-message-field-expirationDate": "\n .label = Utløp:",
        "create-or-edit-message-field-expirationDate-page": "\n .label = Utløp",
        "create-or-edit-message-field-title-required": "Overskrift er påkrevd",
        "create-or-edit-message-field-body-required": "Melding er påkrevd",
        "create-or-edit-message-field-body-too-long": "Du har overskredet maks. antall tegn: { $charsLimit }",
        "create-or-edit-message-field-channels-required": "Velg minst én kanal",
        "create-or-edit-message-field-channel-type-mode-in-app": "Appmelding",
        "create-or-edit-message-field-channel-type-description-mode-in-app": "Sendes som melding på web og i app",
        "create-or-edit-message-field-channel-type-mode-push": "Push-varsel",
        "create-or-edit-message-field-channel-type-description-mode-push": "Send som mobilt push-varsel",
        "create-or-edit-message-field-channel-type-mode-sms": "SMS-melding",
        "create-or-edit-message-field-channel-type-description-mode-sms": "Send som SMS-tekstmelding",
        "create-or-edit-message-field-channel-type-mode-email": "E-post",
        "create-or-edit-message-field-channel-type-description-mode-email": "Send som e-post",
        "create-or-edit-message-field-channel-type-mode-in-app-card": "Appkort",
        "create-or-edit-message-field-channel-type-description-mode-in-app-card": "Vises som kort i GoPay-appen",
        "create-or-edit-message-field-channel-type-mode-info-display": "Infoskjermer",
        "create-or-edit-message-field-channel-type-description-mode-info-display": "Vis på møteskjermer og infoskjermer",
        "create-or-edit-message-field-channel-type-mode-room-display": "Møteromsskjermer",
        "create-or-edit-message-field-channel-type-description-mode-room-display": "Vis på møteromsskjermer",
        "create-or-edit-message-field-tag": "\n .label = Emne: \n .placeholder = Velg et emne",
        "create-or-edit-message-dialog-topic-label": "Emne:",
        "create-or-edit-message-dialog-topic-placeholder": "Velg et emne *",
        "create-or-edit-message-field-tag-page": "\n .label = Emne",
        "create-or-edit-message-field-tag-mode-info": "Info",
        "create-or-edit-message-field-tag-description-mode-info": "For generell informasjon om kantinen, åpningstider, matutvalg eller rutiner.",
        "create-or-edit-message-field-tag-mode-important": "Viktig",
        "create-or-edit-message-field-tag-description-mode-important": "For kritiske meldinger, for eksempel endringer i åpningstider, helse- og sikkerhetsinformasjon eller andre presserende meldinger.",
        "create-or-edit-message-field-tag-mode-offer": "Tilbud",
        "create-or-edit-message-field-tag-description-mode-offer": "For tilbud, rabatter, kampanjer eller spesielle arrangementer.",
        "create-or-edit-message-field-tag-mode-menu-change": "Meny",
        "create-or-edit-message-field-tag-description-mode-menu-change": "For å informere brukerne om endringer i dagens meny, nye retter eller sesongbaserte tilbud.",
        "create-or-edit-message-field-tag-mode-event": "Arrangement",
        "create-or-edit-message-field-tag-description-mode-event": "For kommende arrangementer, som temadager, matfestivaler eller spesielle arrangementer i kantinen.",
        "create-or-edit-message-field-tag-mode-reminder": "Påminnelse",
        "create-or-edit-message-field-tag-description-mode-reminder": "For å minne brukerne om viktige datoer eller frister, for eksempel påmelding til arrangementer eller frist for forhåndsbestilling av mat.",
        "create-or-edit-message-field-tag-mode-feedback": "Tilbakemelding",
        "create-or-edit-message-field-tag-description-mode-feedback": "For å be om tilbakemelding på mat og service, eller brukertilfredshetsundersøkelser.",
        "create-or-edit-message-field-tag-mode-news": "Nyhet",
        "create-or-edit-message-field-tag-description-mode-news": "For oppdateringer om kantinens aktiviteter, tiltak eller endringer i driften som kan være av interesse for brukerne.",
        "create-or-edit-message-field-tag-mode-health": "Helse",
        "create-or-edit-message-field-tag-description-mode-health": "For informasjon om sunne valg, ernæringstips eller allergiinformasjon knyttet til menyen.",
        "create-or-edit-message-field-tag-mode-social": "Fellesskap",
        "create-or-edit-message-field-tag-description-mode-social": "For å fremme fellesskapsinitiativer, temadager og sosiale arrangementer.",
        "create-or-edit-message-field-tag-required": "Emne er påkrevd",
        "create-message-success-dialog-title": "Meldingen er opprettet",
        "create-message-success-dialog-view-archive": "Se meldingsarkiv",
        "create-message-success-dialog-close-button": "Lukk",
        "create-message-success-dialog-view-list-button": "Gå til meldinger",


        // Customer access
        "merchant-customer-access-header": "\n .title = Kundetilgang",
        "merchant-customer-access-customers-table-name-column": "Navn",
        "merchant-customer-access-customers-table-active-column": "Status",
        "merchant-customer-access-customers-table-domains-column": "Domener",
        "merchant-customer-access-customers-table-active-filter-yes": "Aktive",
        "merchant-customer-access-customers-table-active-filter-no": "Inaktive",
        "merchant-customer-access-customers-table-active-column-active": "Aktiv",
        "merchant-customer-access-customers-table-active-column-inactive": "Inaktiv",

        // Merchant account > Swift dialog
        "merchant-account-swift-dialog-title":"Bytt salgssted",
        "merchant-account-swift-dialog-subtitle":"Du har tilgang til følgende salgssteder. Velg ett for å bytte.",
        "merchant-account-swift-dialog-empty-title":"Du har ikke tilgang til andre salgssteder.",

        // Merchant home
        "merchant-home-today-card-group": "\n .title = POS-salg \n .subtitle = i dag",
        "merchant-home-todays-control-code": "\n .title = Dagens kontrollkode",
        "merchant-home-todays-control-code-title": "Dagens kontrollkode",
        "merchant-home-todays-offers": "Dagens tilbud\n .title = Dagens tilbud",
        "merchant-product-tour-step-welcome": "Velkommen til Facilitynet. Dette er en kort introduksjon til hvordan du bruker den.",
        "merchant-product-tour-step-order-notifications-button": "Klikk her for å åpne en oversikt over dagens ordrer og aktiviteter.",
        "merchant-product-tour-step-order-notifications": "Her kan du få en oversikt over dagens ordrer og aktiviteter som krever din oppmerksomhet.",
        "merchant-product-tour-step-new-button": "Klikk her for å åpne snarveier for å opprette meldinger og ordrer.",
        "merchant-product-tour-step-new": "Klikk på Ny-knappen for å opprette push-meldinger, bestille møteservering på vegne av brukerne og få enkel tilgang til snarveier.",
        "merchant-product-tour-step-environment-button": "Klikk her for å åpne menyen for å bytte mellom miljøer.",
        "merchant-product-tour-step-environment": "Portalen er delt inn i 3 miljøer som hver fokuserer på et bestemt tema. Du bytter miljø her.",
        "merchant-product-tour-step-nav-production": "I Produksjon kan du planlegge og administrere ordrer.",
        "merchant-product-tour-step-nav-menu-planning": "I Menyplanlegging kan du opprette ukemenyer for å holde kantinebrukerne informert.",
        "merchant-product-tour-step-nav-purchase-control": "Bruk Kjøpskontroll for å sikre at alle betaler for maten sin.",
        "merchant-product-tour-step-nav-survey": "Se resultatene av brukertilbakemeldinger og hold oversikt over brukertilfredshet.",
        "merchant-product-tour-locale-back": "Tilbake",
        "merchant-product-tour-locale-next": "Neste",
        "merchant-product-tour-locale-last": "Ferdig",
        "merchant-product-tour-locale-skip": "Hopp over",
        "merchant-product-tour-locale-close": "Lukk",
        "takeaway-announcement-tour-step-intro": "Vi har lansert en egen side for takeaway.",
        "takeaway-announcement-tour-step-nav-takeaway": "Fra nå av finner du takeaway-ordrer her.",
        "merchant-home-number-of-orders": "\n .title = Ordrer \n .titleTooltip = Antall POS-ordrer i dag",
        "merchant-home-turnover": "\n .title = Omsetning \n .titleTooltip = Dagens totalbeløp for POS-salg",
        "merchant-home-avg-amount": "\n .title = Snittbeløp \n .titleTooltip = Gjennomsnittlig ordrebeløp for dagens ordrer\n .subtitle = DKK",
        "merchant-home-subscriptions": "\n .title = Abonnementer \n .titleTooltip = Dagens aktive lunsjabonnementer",
        "merchant-home-takeaway-card-group": "\n .title = Takeaway \n .subtitle = i dag",
        "merchant-home-takeaway-number-of-orders": "\n .title = Ordrer \n .titleTooltip = Antall takeaway-ordrer i dag",
        "merchant-home-takeaway-turnover": "\n .title = Omsetning \n .titleTooltip = Dagens totalbeløp for takeaway-salg",
        "merchant-home-takeaway-avg-amount": "\n .title = Snittbeløp \n .titleTooltip = Gjennomsnittlig ordrebeløp for dagens takeaway-ordrer\n .subtitle = DKK",
        "merchant-home-statistics-card-group": "\n .title = Statistikk",
        "merchant-home-checkin-card": "\n .title = Innsjekkingsskjerm\n .titleTooltip = Viser hvor mange kunder som husker å skanne kjøpsbeviset sitt på innsjekkingsskjermen, sammenlignet med hvor mange som glemmer det",
        "merchant-home-checkin-card-participants": "Sjekket inn ({ $checkedIn })",
        "merchant-home-checkin-card-none-participants": "Ikke sjekket inn ({ $notCheckedIn })",
        "merchant-home-checkin-card-participation-percentage": "Prosent",
        "merchant-home-survey-card-empty": "\n .title = Tilfredshet",
        "merchant-home-meeting-service-card-group": "\n .title = Møteservering\n .subtitle = I dag",
        "merchant-home-meeting-service-number-of-orders-card": "\n .title = Ordrer\n .titleTooltip = Antall møteserveringsordrer i dag",
        "merchant-home-meeting-service-awaiting-approval-card": "\n .title = Venter på godkjenning\n .titleTooltip = Totalt antall møteserveringsordrer som venter på godkjenning",
        "merchant-home-meeting-service-ready-for-invoicing-card": "\n .title = Klar for fakturering\n .titleTooltip = Totalt antall møteserveringsordrer som venter på å bokføres",
        "merchant-home-meeting-service-ready-for-invoicing-card-description": "&gt; {$overdueDays} dager siden",
        "merchant-home-meeting-service-delivery-planning-card": "\n .title = Leveringsplanlegging\n .titleTooltip = Viser fordelingen av møteserveringsordrer i løpet av dagen",
        "merchant-home-meeting-service-delivery-planning-delivery": "Levering",
        "merchant-home-meeting-service-delivery-planning-picked-up": "Hentes",
        "merchant-home-meeting-service-delivery-planning-eating-in-canteen": "Spiser i kantinen",
        "merchant-home-meeting-service-next-deliveries-card": "\n .title = Neste {$numberOfOrders} leveringer\n .titleTooltip = De neste 5 leveringene i dag",
        "merchant-home-meeting-service-table-name-column": "Kunde",
        "merchant-home-meeting-service-table-meeting-column": "Møte",
        "merchant-home-meeting-service-table-delivery-column": "Levering",
        "merchant-home-meeting-service-no-upcoming-deliveries": "Det er ingen kommende leveringer.",
        "merchant-home-views-button": "Live Dashboards",
        "merchant-home-views-dialog-title": "Live Dashboards",
        "merchant-home-views-dialog-subtitle": "Velg et dashboard nedenfor:",
        "merchant-home-views-dialog-conference": "Messe",
        "merchant-home-views-dialog-conference-live-sales-part-1": "Live",
        "merchant-home-views-dialog-conference-live-sales-part-2": "salg",
        "merchant-home-views-dialog-conference-orders": "Ordrer",
        "merchant-home-views-dialog-conference-turnover": "Omsetning",
        "merchant-home-views-dialog-conference-avg-price": "Snittpris",
        "merchant-home-views-dialog-conference-free-riders": "Gratispassasjerer",
        "merchant-home-views-dialog-conference-satisfaction": "Tilfredshet",
        "merchant-home-statistics-pos-turnover-card": "\n .title = POS-omsetning \n .titleTooltip = Viser POS-salg for valgt periode sammenlignet med salget for forrige periode",
        "merchant-home-statistics-pos-orders-card": "\n .title = POS-ordrer \n .titleTooltip = Viser antall POS-ordrer for valgt periode sammenlignet med ordrer for forrige periode",
        "merchant-home-statistics-number-of-users-card": "\n .title = Brukere \n .titleTooltip = Viser antall nye brukere for valgt periode sammenlignet med nye brukere for forrige periode",
        "merchant-home-statistics-period-base-3": "Siste 3 dager",
        "merchant-home-statistics-period-base-14": "Siste 14 dager",
        "merchant-home-statistics-period-base-30": "Siste 30 dager",
        "merchant-home-statistics-period-base-60": "Siste 60 dager",
        "merchant-home-statistics-period-base-180": "Siste 180 dager",
        "merchant-home-statistics-compared-to-last-period": "sammenlignet med forrige periode",

        // Merchant home tooltips
        "merchant-home-todays-control-code-tooltip": "\n .title = Koden vises på kjøpsbeviset (app) og på den utskrevne kvitteringen",
        "merchant-home-todays-offers-tooltip": "\n .title = Antall tilbud som er aktive i dag",

        // Merchant Account
        "merchant-update-account-page-header": "\n .title = Konto for salgssted",
        "merchant-update-account-save-button": "Lagre",
        "merchant-update-account-opening-hours-title":"\n .title = Åpningstider",
        "merchant-update-account-opening-hours-action-button-add":"Legg til",
        "merchant-update-account-opening-hours-action-button-edit":"Rediger",
        "merchant-update-account-opening-hours-empty-text":"Åpningstider er ikke angitt",
        "merchant-update-account-opening-hours-dialog-title":"Åpningstider",
        "merchant-update-account-opening-hours-dialog-save-button":"Lagre",
        "merchant-update-account-opening-hours-dialog-before-start-error":"Stengetid før åpningstid",
        "merchant-update-account-opening-hours-dialog-closed-time-select-from":"\n .label = Fra",
        "merchant-update-account-opening-hours-dialog-time-select-to":"\n .label = Til",
        "merchant-update-account-opening-hours-dialog-closed":"Stengt",
        "merchant-update-account-opening-hours-day-monday": "Mandag",
        "merchant-update-account-opening-hours-day-tuesday": "Tirsdag",
        "merchant-update-account-opening-hours-day-wednesday": "Onsdag",
        "merchant-update-account-opening-hours-day-thursday": "Torsdag",
        "merchant-update-account-opening-hours-day-friday": "Fredag",
        "merchant-update-account-opening-hours-day-saturday": "Lørdag",
        "merchant-update-account-opening-hours-day-sunday": "Søndag",



        //Merchant reports
        "merchant-reports-id-cards-title": "\n .title = ID-kort",
        "merchant-reports-id-cards-nav-item-home": "Hjem",
        "merchant-reports-id-cards-nav-item-id-cars": "ID-kort",

        // Merchant ID table
        "merchant-id-cards-table-card-number": "Kortnummer",
        "merchant-id-cards-table-card-type": "Korttype",
        "merchant-id-cards-table-user": "Bruker",
        "merchant-id-cards-table-company": "Firma",
        "merchant-id-cards-table-status": "Status",
        "merchant-id-cards-table-card-type-select-label": "\n .label = Korttype",
        "merchant-id-cards-table-company-select-label": "\n .label = Firma",
        "merchant-id-cards-table-card-type-select-item-wallet":"Wallet",
        "merchant-id-cards-table-card-type-select-item-company-credit":"Firmakreditt",
        "merchant-id-cards-table-card-type-select-item-tickets":"Klippekort",
        "merchant-id-cards-table-card-type-select-item-unlimited-tickets":"Ubegrenset klippekort",
        "merchant-id-cards-table-card-type-select-item-tickets-unlimited":"Ubegrensede klipp",
        "merchant-id-cards-table-card-type-select-item-top-up": "Påfyll",
        "merchant-id-cards-table-card-type-select-item-payroll-deduction": "Lønnstrekk",


        // Merchant ID Cards Dialog
        "merchant-id-cards-dialog-title": "ID-kortdetaljer",
        "merchant-id-cards-dialog-status": "Status:",
        "merchant-id-cards-dialog-card-name": "Kortnavn:",
        "merchant-id-cards-dialog-card-type": "Korttype:",
        "merchant-id-cards-dialog-card-type-top-up": "Påfyll",
        "merchant-id-cards-dialog-card-type-wallet": "Wallet",
        "merchant-id-cards-dialog-card-type-company-credit": "Firmakreditt",
        "merchant-id-cards-dialog-card-type-tickets": "Klippekort",
        "merchant-id-cards-dialog-card-type-tickets-unlimited": "Ubegrenset klippekort",
        "merchant-id-cards-dialog-card-type-payroll-deduction": "Lønnstrekk",
        "merchant-id-cards-dialog-validated": "Validert:",
        "merchant-id-cards-dialog-expiry": "Utløp:",
        "merchant-id-cards-dialog-payment-method": "Betalingsmetode:",
        "merchant-id-cards-dialog-user-id": "Bruker-ID:",
        "merchant-id-cards-dialog-employee-id": "Ansatt-ID:",
        "merchant-id-cards-dialog-name": "Navn:",
        "merchant-id-cards-dialog-email": "E-post:",
        "merchant-id-cards-dialog-mobile": "Mobil:",
        "merchant-id-cards-dialog-phone": "Telefon:",

        "id-cars-table-button-details": "Detaljer",
        "id-cars-filter-card-title":"\n .title = Kort",
        "id-cars-filter-debtor-title":"\n .title = Debitor",
        "id-cars-filter-end-user-title":"\n .title = Sluttbruker",
        "id-cars-filter-card-number-label":"\n .label = Kortnummer\n .placeholder = Søk på kortnummer",
        "id-cars-filter-switch-label":"\n .label = Inkluder inaktive kort",
        "id-cars-filter-debtor-label":"\n .label = Debitor",
        "id-cars-filter-email-label":"\n .label = E-post",
        "id-cars-filter-employee-id-label":"\n .label = Ansatt-ID",

        "merchant-production": "Produksjon",

        // Merchant > Admin > Shops > Products
        "products-page-header": "\n .title = Produkter",
        "products-tab-all-products": "Alle produkter",
        "products-tab-sort-products": "Sorter produkter",
        "products-table-info-box": "Velg en butikk for å fortsette",
        "products-table-show-inactive": "\n .label = Vis deaktiverte",
        "products-move-availability-dialog":
            "\n .title = Begrense produktets tilgjengelighet?\n .message = “{ $productName }” er tilgjengelig utenfor dagene eller tidsrommet for “{ $groupName }”. Etter flyttingen vil det være tilgjengelig: { $days }, { $hours }.\n .buttonLabelSubmit = Flytt og begrens\n .buttonLabelCancel = Avbryt",
        "products-move-availability-dialog-no-overlap-alert":
            "\n .title = Produktet har ingen dager eller klokkeslett til felles med gruppen, så dets egne dager og klokkeslett erstattes av gruppens.",
        "products-move-availability-dialog-every-day-label": "alle dager",
        "products-move-availability-dialog-all-day-label": "hele dagen",
        "products-page-table-price-list-label": "\n .label = Prisliste",
        "products-no-price-list-tab": "Ingen prisliste",
        "products-action-bar-move-to-price-list": "Flytt til prisliste",
        "products-action-bar-copy-to-price-list": "Kopier til prisliste",
        "products-action-bar-status": "\n .title = Status",
        "products-action-bar-set-active": "\n .title = Aktiv",
        "products-action-bar-set-inactive": "\n .title = Inaktiv",
        "products-select-price-list-label": "Velg prisliste:",
        "products-move-to-price-list-dialog-title": "Flytt til prisliste",
        "products-copy-to-price-list-dialog-title": "Kopier til prisliste",
        "products-price-list-dialog-accordion-title": "Produkter ({ $count })",
        "products-name-column": "Navn",
        "products-price-column": "Pris",
        "products-status-column": "Status",
        "products-create-product-button": "Opprett ny",
        "merchant-admin-enable-product-sort-button": "Aktiver produktsortering",
        "merchant-admin-enable-product-sort-info": "\n .title = Når du aktiverer produktsortering for første gang, sorterer vi produktene og produktgruppene i en standardrekkefølge. Derfra kan du flytte dem rundt som du ønsker.",
        "products-edit-product-menu-item": "Rediger",
        "products-delete-product-menu-item": "Slett",
        "products-confirm-delete-product-dialog": "\n .typeOfEntity = produkt",
        "products-export-id": "Produkt-ID",
        "products-export-product-number": "Produktnummer",
        "products-export-group": "Produktgruppe",
        "products-export-name": "Produktnavn",
        "products-export-price": "Pris",
        "products-export-status": "Status",
        "products-export-stock-total": "Lagerbeholdning",
        "products-export-items-for-sale-per-day": "Varer til salgs per dag",
        "products-export-items-left-today": "Gjenstår i dag",
        "product-offer-chip": "\n .label = Tilbud",

        // Merchant > Admin > Products > Info icons
        "product-info-icon-deadline-label": "Frist",
        "product-info-icon-deadline-value": "{ $daysBefore } dager før, kl. { $timeOfDay }",
        "product-info-icon-availability-label": "Tilgjengelighet",
        "product-info-icon-offer-label": "Tilbud",
        "product-info-icon-offer-percentage-value": "-{ $percentage }%",
        "product-info-icon-offer-discount-price-value": "Nedsatt pris",
        "product-info-icon-marketing-tag-label": "Markedsføringstagg",
        "product-info-icon-allergens-label": "Allergener",
        "product-info-icon-allow-pre-order-label": "Tillat forhåndsbestilling",
        "product-info-icon-description-label": "Beskrivelse",
        "product-info-icon-pin-code-label": "PIN-kode",
        "product-info-icon-pin-code-value": "Påkrevd",
        "products-edit-product-group-menu-item": "Rediger",
        "products-delete-product-group-menu-item": "Slett",

        // Merchant > Admin > Shops > Price list dropdown selector
        "price-list-dropdown-selector-field-label": "Prisliste",
        "price-list-dropdown-selector-placeholder": "Velg prisliste",
        "price-list-dropdown-selector-active-only-checkbox": "\n .label = Kun aktive",
        "price-list-dropdown-selector-inactive-chip": "\n .label = Inaktiv",
        "price-list-dropdown-selector-internal-note-label": "Internt notat",
        "price-list-dropdown-selector-message-to-customers-label": "Melding til kunder",
        "price-list-dropdown-selector-no-info": "Ingen ytterligere info",
        "price-list-dropdown-selector-vat-inclusive": "Pris inkl. MVA",
        "price-list-dropdown-selector-vat-exclusive": "Pris ekskl. MVA",

        // Merchant > Admin > Products > Stock
        "product-stock-chip-label": "Lager: { $count }",
        "product-stock-daily-sales": "Solgt i dag: { $sold }/{ $total }",
        "product-stock-on-sale-per-day-label": "Til salgs per dag:",
        "product-stock-on-sale-per-day-info": "\n .title = Med dette kan du begrense antall varer som er til salgs hver dag.\n .description = Med dette kan du begrense antall varer som er til salgs hver dag.",
        "product-stock-on-sale-per-day-required-error": "Til salgs per dag er påkrevd",
        "product-stock-on-sale-per-day-min-error": "Til salgs per dag må være minst 1",
        "product-stock-total-stock-label": "Samlet lager:",
        "product-stock-total-stock-items": "{ $count } varer",
        "product-stock-current-stock-label": "Aktuell lagerbeholdning:",
        "product-stock-tab-inventory": "Lagerregulering",
        "product-stock-tab-daily": "Til salgs per dag",
        "product-stock-type-label": "\n .label = Type:",
        "product-stock-type-option-inbound": "Legg til i lager",
        "product-stock-type-option-outbound": "Fjern fra lager",
        "product-stock-adjustment-amount-label": "Antall:",
        "product-stock-adjustment-amount-tooltip": "\n .title = Angi mengden som skal reguleres",
        "product-stock-reason-label": "Årsak:",
        "product-stock-reason-tooltip": "\n .title = Velg årsaken til denne lagerreguleringen",
        // Outbound reasons
        "product-stock-reason-option-sold": "Solgt",
        "product-stock-reason-tooltip-sold": "\n .title = Varer solgt til en kunde.",
        "product-stock-reason-option-reserved": "Reservert",
        "product-stock-reason-tooltip-reserved": "\n .title = Varer lagt til side for en bestemt ordre.",
        "product-stock-reason-option-shipped": "Sendt",
        "product-stock-reason-tooltip-shipped": "\n .title = Varer har forlatt lageret.",
        "product-stock-reason-option-returned-to-vendor": "Returnert til leverandør",
        "product-stock-reason-tooltip-returned-to-vendor": "\n .title = Varer sendt tilbake til leverandøren.",
        "product-stock-reason-option-consumed-in-production": "Forbrukt i produksjon",
        "product-stock-reason-tooltip-consumed-in-production": "\n .title = Ingredienser brukt under matlaging/produksjon.",
        "product-stock-reason-option-scrapped": "Kassert",
        "product-stock-reason-tooltip-scrapped": "\n .title = Varer kassert som ubrukelige.",
        "product-stock-reason-option-lost": "Tapt",
        "product-stock-reason-tooltip-lost": "\n .title = Varen er ikke å finne.",
        "product-stock-reason-option-stolen": "Stjålet",
        "product-stock-reason-tooltip-stolen": "\n .title = Varer fjernet ved tyveri.",
        "product-stock-reason-option-sample-given": "Utlevert vareprøve",
        "product-stock-reason-tooltip-sample-given": "\n .title = Varer gitt bort til smaksprøve eller test.",
        // Inbound reasons
        "product-stock-reason-option-purchased": "Innkjøpt",
        "product-stock-reason-tooltip-purchased": "\n .title = Nye varer mottatt fra en leverandør.",
        "product-stock-reason-option-returned-from-customer": "Returnert av kunde",
        "product-stock-reason-tooltip-returned-from-customer": "\n .title = Varer returnert til lageret av en kunde.",
        "product-stock-reason-option-produced": "Produsert",
        "product-stock-reason-tooltip-produced": "\n .title = Ferdigvarer lagt til etter tilberedning.",
        "product-stock-reason-option-found-during-count": "Funnet ved telling",
        "product-stock-reason-tooltip-found-during-count": "\n .title = Ekstra varer funnet under lagertelling.",
        "product-stock-reason-option-transferred-in": "Overført (inn)",
        "product-stock-reason-tooltip-transferred-in": "\n .title = Varer flyttet fra en annen lokasjon.",
        "product-stock-items-per-day-label": "Varer til salgs per dag",
        "product-stock-items-per-day-tooltip": "\n .title = Antall varer tilgjengelige for salg per dag",
        "product-stock-note-label": "Notat:",
        "product-stock-note-placeholder": "\n .placeholder = Valgfri ekstra info om reguleringen",
        "product-stock-confirm-button": "Bekreft",
        "product-stock-cancel-button": "Avbryt",
        "product-stock-adjustment-button": "Lagerregulering",
        "product-stock-update-success": "Lager oppdatert",
        "product-create-stock-switch-label": "Lagerstyring:",
        "product-create-stock-total-field": "\n .label = Totalt lager",
        "product-create-stock-items-per-day-field": "\n .label = Varer per dag",
        "product-create-stock-info": "Angi total lagerbeholdning og hvor mange varer som kan selges per dag.",

        // Merchant > Admin > Extra Services
        "extra-services-page-header": "\n .title = Ekstratjenester",
        "extra-services-edit-submit-button": "Lagre",
        "extra-services-create-service-button": "Opprett ny",
        "extra-services-services-column": "Tjenester",
        "extra-services-service-type-column": "Tjenestetype",
        "extra-services-price-type-column": "Pristype",
        "extra-services-status-column": "Status",
        "extra-services-price-subline-fixed": "Fast pris",
        "extra-services-price-subline-per-seat": "Pris per kuvert",
        "extra-services-price-subline-min": "Min. pris",
        "extra-services-price-subline-max": "Maks. pris",

        // Merchant > Admin > Extra Services > Create / Edit
        "extra-services-create-page-header": "\n .title = Opprett ekstratjeneste",
        "extra-services-edit-page-header": "\n .title = Rediger ekstratjeneste",
        "extra-services-create-active-switch": "Aktiv:",
        "extra-services-create-mandatory": "Legg alltid til i ordren",
        "extra-services-create-mandatory-without-pickup": "Legg til ved henting",
        "extra-services-create-meeting-location-required-switch": "Krev møtested",
        "extra-services-create-meeting-time-required-switch": "Krev møtetid",
        "extra-services-create-service-time-weekdays-min-error": "Velg minst én dag",
        "extra-services-create-price-field-label": "\n .label = Pris",
        "extra-services-create-min-price-field-label": "\n .label = Min. pris",
        "extra-services-create-max-price-field-label": "\n .label = Maks. pris",
        "extra-services-create-price-per-seat-field-label": "\n .label = Pris per kuvert",
        "extra-services-create-currency-field-label": "\n .label = Valuta",
        "extra-services-create-service-description-field":  "\n .label = Beskrivelse",
        "extra-services-create-service-description-field-max-length": "Beskrivelsen kan ikke overstige { $maxLength } tegn",
        "extra-services-create-service-name-field":  "\n .label = Navn",
        "extra-services-create-service-type-field":  "\n .label = Tjenestetype",
        "extra-services-create-service-pricing-type-field":  "\n .label = Pristype",
        "extra-services-create-panel-pricing": "\n .label = Prissetting",
        "extra-services-create-settings-panel": "\n .title = Innstillinger",
        "extra-services-create-service-time-panel": "\n .title = Tilgjengelige tider",
        "extra-services-create-form-type-dropdown-item-pickup-fee": "Hentegebyr",
        "extra-services-create-form-type-dropdown-item-eat-in-canteen-fee": "Gebyr for spising i kantinen",
        "extra-services-create-form-type-dropdown-item-delivery-fee": "Leveringsgebyr",
        "extra-services-create-form-type-dropdown-item-table-setting-fee": "Gebyr for bordoppdekking",
        "extra-services-create-form-type-dropdown-item-cleanup-fee": "Gebyr for rydding",
        "extra-services-create-form-type-dropdown-item-out-of-opening-hours-fee": "Gebyr utenfor åpningstid",
        "extra-services-create-form-type-dropdown-item-other": "Annet",
        "extra-services-create-form-pricing-type-dropdown-item-per-seat": "Per kuvert",
        "extra-services-create-form-pricing-type-dropdown-item-flat-fee": "Fast gebyr",
        "extra-services-create-when-add-to-order-field": "\n .label = Handling",
        "extra-services-create-when-add-to-order-no-action": "Ingen handlinger valgt",
        "extra-services-create-form-action-dropdown-item-add-always": "Legg alltid til",
        "extra-services-create-form-action-dropdown-item-add-when-pick-up": "Legg til ved henting",
        "extra-services-create-form-action-dropdown-item-add-when-delivered": "Legg til ved levering",

        // Merchant > Admin > Shops > Products > Create / Edit
        "product-create-page-header": "\n .title = Opprett produkt",
        "product-create-submit-button": "Opprett",
        "product-edit-page-header": "\n .title = Rediger produkt",
        "product-edit-submit-button": "Lagre\n .loadingLabel = Lagrer...",
        "product-create-shops-field-label": "Butikker",
        "product-create-group-field-label": "\n .label = Produktgruppe",
        "product-create-number-field-label": "\n .label = Produktnummer",
        "product-create-name-field-label": "\n .label = Produktnavn",
        "product-create-price-field-label": "\n .label = Pris",
        "product-create-price-field-title": "Pris",
        "product-create-price-field-vat-included-badge": "\n .label = Inkl. MVA",
        "product-create-price-field-vat-excluded-badge": "\n .label = Ekskl. MVA",
        "product-create-price-field-no-price-list-badge": "\n .label = Velg prisliste",
        "product-create-price-field-no-price-list-placeholder": "Velg prisliste først",
        "product-create-currency-field-label": "\n .label = Valuta",
        "product-create-description-field-label": "\n .label = Beskrivelse",
        "product-create-panel-access": "\n .title = Tilgang",
        "product-create-panel-access-shop-alert-title": "\n .title = En butikk representerer et virtuelt eller fysisk salgssted, for eksempel nettbutikker i GoPay-appen eller butikken som er knyttet til POS-terminaler i en kantine. En bruker som IKKE er knyttet til en prisliste, vil her se produktene som er direkte tilordnet butikker. ",
        "product-create-panel-access-price-list-alert-title": "\n .title = Prislister kan brukes til å tilby ulike produktutvalg eller priser til ulike brukergrupper. Flere prislister kan knyttes til samme butikk for å kunne tilby ulike utvalg. En bruker vil alltid se én prisliste, eller standardutvalget. Hvilken prisliste som vises, avhenger av brukergruppen eller, for POS, brukerens abonnementstype.",
        "product-create-panel-description": "\n .title = Beskrivelse",
        "product-create-image-field-label": "\n .label = Bilde",
        "create-image-file-support": "Støttede filtyper: { $supportedFileTypes }. Maks. størrelse: { $maxSize }",
        "product-create-general-panel": "\n .title = Generelt",
        "product-create-active-switch": "Aktiv:",
        "product-create-admin-only-switch": "Kun for personale:",
        "product-create-product-description-panel": "\n .title = Produktbeskrivelse",
        "product-create-product-description-marketing-tag-field": "\n .label = Markedsføringstagg\n .helperText = Eksempler: 'Tilbud', 'CO2', 'Varm rett', 'Vegetar'",
        "product-create-product-description-allergens-field": "\n .label = Allergener",
        "product-create-availability-panel": "\n .title = Tilgjengelighet\n .description = Begrens til bestemte dager og tidspunkter",
        "product-create-availability-from-date-picker": "\n .label = Fra dato",
        "product-create-availability-to-date-picker": "\n .label = Til dato",
        "product-create-availability-preorder-switch": "Ikke tillat forhåndsbestilling:",
        "product-create-availability-info": "Kunder kan forhåndsbestille produkter for fremtidige datoer i GoPay-appen, med mindre du slår det av her.",
        "product-create-availability-date-error": "Sluttdato kan ikke være før startdato",
        "product-create-availability-week-days-label": "Tilgjengelig på:",
        "product-create-availability-week-days-helper-text": "La alle dager være umarkert for å selge produktet alle dager.",
        "product-create-availability-week-days-group-helper-text": "Bare produktgruppens dager kan velges. La alle dager være umarkert for å selge produktet på dem alle.",
        "product-create-availability-week-days-group-error": "Velg bare dager da produktgruppen er tilgjengelig",
        "product-create-availability-from-time-picker": "\n .label = Fra klokkeslett",
        "product-create-availability-to-time-picker": "\n .label = Til klokkeslett",
        "product-create-availability-time-helper-text": "La begge klokkeslett stå tomme for å selge produktet hele dagen.",
        "product-create-availability-time-group-helper-text": "Må ligge innenfor produktgruppens tidsrom, { $start } – { $end }. La begge klokkeslett stå tomme for å bruke produktgruppens tidsrom.",
        "product-create-availability-time-incomplete-error": "Angi både 'Fra klokkeslett' og 'Til klokkeslett'",
        "product-create-availability-time-error": "'Til klokkeslett' må være senere enn 'Fra klokkeslett'",
        "product-create-availability-time-group-error": "Klokkeslettene må ligge innenfor produktgruppens tidsrom",
        "product-create-deadline-panel": "\n .title = Frist\n .description = Hvor lenge før levering det må bestilles",
        "product-create-deadline-purchases-subtitle": "Kjøp:",
        "product-create-deadline-cancellation-subtitle": "Avbestilling:",
        "product-create-deadline-day-field": "\n .label = Dag",
        "product-create-deadline-day-limit-day-before": "Dagen før",
        "product-create-deadline-day-limit-x-days-before": "{ $daysBefore } dager før",
        "product-create-deadline-time-picker": "\n .label = Tid",
        "product-create-barcode-panel": "\n .title = ERP-numre",
        "product-create-barcode-field-label": "\n .label = Strekkode",
        "product-create-sales-rules-panel": "\n .title = Salgsregler",
        "product-create-offer-panel": "\n .title = Tilbud\n .description = Midlertidig redusert pris i en periode",
        "product-create-offer-discount-percentage": "Rabattprosent:",
        "product-create-offer-discount-price": "Ny pris:",
        "product-create-offer-items-in-stock": "Antall varer på lager:",
        "product-create-offer-available-from": "Tilgjengelig fra:",
        "product-create-offer-available-to": "Tilgjengelig til:",
        "product-create-offer-edit-button": "Rediger",
        "product-create-offer-create-button": "Opprett",
        "product-create-offer-dialog-create-title": "Opprett tilbud",
        "product-create-offer-dialog-edit-title": "Rediger tilbud",
        "product-create-offer-dialog-normal-price": "Opprinnelig pris:",
        "product-create-offer-dialog-price-adjustment-field": "\n .label = Prisjustering",
        "product-create-offer-dialog-price-adjustment-option-none": "Ingen",
        "product-create-offer-dialog-price-adjustment-option-discount-price": "Nedsatt pris",
        "product-create-offer-dialog-price-adjustment-option-discount-percentage": "Rabattprosent",
        "product-create-offer-dialog-adjust-price-field": "\n .label = Ny pris",
        "product-create-offer-dialog-items-field": "Antall varer tilbudt per dag:",
        "product-create-offer-dialog-percentage-field": "\n .label = Prosentsats",
        "product-create-offer-dialog-available-offer-period": "Tilbudsperiode",
        "product-create-offer-dialog-available-from-date-picker": "\n .label = Tilgjengelig fra",
        "product-create-offer-dialog-available-to-date-picker": "\n .label = Tilgjengelig til",
        "product-create-offer-dialog-marketing-tag-label": "Markedsføringstagg:",
        "product-create-offer-dialog-marketing-tag-mode-old-new-price-new": "25,00 kr",
        "product-create-offer-dialog-marketing-tag-mode-old-new-price-old": "35,00 kr",
        "product-create-offer-dialog-marketing-tag-mode-old-new-price": "25,00 kr 35,00 kr",
        "product-create-offer-dialog-marketing-tag-mode-save-x": "Spar [x] %",
        "product-create-offer-dialog-marketing-tag-mode-limited-on-sale": "Spar [x] kr",
        "product-create-offer-dialog-marketing-tag-mode-great-offer": "Godt tilbud",
        "product-create-offer-dialog-marketing-tag-mode-buy-now": "Kjøp nå",
        "product-create-offer-dialog-marketing-tag-mode-good-price": "God pris",
        "product-create-offer-dialog-marketing-tag-mode-discount": "Nedsatt pris",
        "product-create-offer-dialog-marketing-tag-mode-week-offer": "Ukens tilbud",
        "product-create-offer-dialog-marketing-tag-mode-day-offer": "Dagens tilbud",
        "product-create-offer-dialog-save-button": "Lagre",
        "product-create-add-price-list-button": "Legg til i prisliste",
        "product-create-add-to-price-list": "Legg til i prisliste",
        "product-create-price-list-step-one": "Velg prisliste",
        "product-create-price-list-step-two": "Angi pris",
        "product-create-price-list-table-name-column": "Navn",
        "product-create-price-list-table-status-column": "Status",
        "product-create-price-list-table-active-column-active": "Aktiv",
        "product-create-price-list-table-active-column-inactive": "Inaktiv",
        "product-create-price-list-table-active-column-active-filter-yes": "Aktiv",
        "product-create-price-list-table-active-column-inactive-filter-no": "Inaktiv",
        "product-create-price-list-table-currency": "Valuta:",
        "product-create-price-list-table-vat": "MVA:",
        "product-create-price-list-table-connected-shops": "Tilknyttede butikker:",
        "product-create-price-list-table-connected-customers": "Tilknyttede kunder:",
        "product-create-price-list-table-vat-code": "MVA-kode:",
        "product-create-price-list-table-select-button": "Velg",
        "product-create-price-list-selected-price-list": "Valgt prisliste:",
        "product-create-price-list-price-field-label": "\n .label = Pris",
        "product-create-price-list-add-button": "Legg til",
        "product-create-payment-panel": "\n .title = Betaling",
        "product-create-pos-panel": "\n .title = POS",
        "product-create-payment-price-switch": "Skjul pris:",
        "product-create-variable-price-switch": "Aktiver variabel pris:",
        "product-create-require-staff-pin-switch": "Krev PIN-kode for personale:",
        "product-create-price-disabled-tooltip": "\n .title = Pris er deaktivert fordi variabel pris er aktiv",
        "product-create-delivery-panel": "\n .title = Levering",
        "product-create-delivery-deliveryDetails-field": "\n .label = Hentested",
        "product-create-order-limits-panel": "\n .title = Ordrebegrensninger",
        "product-create-price-lists-field-label": "\n .label = Prislister",
        "product-create-price-list-field-label": "\n .label = Prisliste",
        "products-no-price-lists-message": "Du har ingen prisliste ennå. Du må opprette en prisliste før du kan opprette produkter.",
        "products-go-to-price-lists-button": "Gå til prislister",
        "product-create-item-limits-panel": "\n .title = Begrensning på antall varer",
        "product-create-item-limits-max-field": "Maks. antall varer per dag per person:",
        "product-create-item-limits-max-info": "Dette bestemmer hvor mange varer av denne typen en kunde kan bestille per dag totalt.",
        "product-create-item-limits-min-field": "Min. antall varer per ordre:",
        "product-create-item-limits-min-info": "Dette bestemmer minimum antall varer av denne typen en kunde må legge til i en ordre.",
        "product-create-item-limits-error": "Enten maks. antall varer per dag eller min. antall varer per ordre må fylles ut",
        "product-create-item-limits-min-error": "Min. antall varer per ordre må være tomt eller >= 2",
        "product-create-item-limits-max-error": "Maks. antall varer per dag må være tomt eller >= 1",


        // Merchant > Admin > Shops > Product groups
        "product-groups-page-header-title": "\n .title = Produktgrupper",
        "product-groups-create-button": "Opprett ny",
        "product-groups-no-price-lists-message": "Du har ingen prisliste ennå. Du må opprette en prisliste før du kan opprette produktgrupper.",
        "create-product-group-create-button": "Opprett",
        "create-product-group-save-button": "Lagre",
        "product-group-page-title-create": "\n .title = Opprett produktgruppe",
        "product-group-page-title-update": "\n .title = Rediger produktgruppe",
        "product-group-edit-products-outside-availability-dialog":
            "\n .title = Begrense produktenes tilgjengelighet?\n .message = Disse produktene har egne dager eller klokkeslett utenfor gruppens nye tilgjengelighet. De blir begrenset til gruppens dager og tidsrom.\n .buttonLabelSubmit = Lagre og begrens\n .buttonLabelCancel = Avbryt",
        "product-group-edit-products-outside-availability-dialog-no-overlap-description":
            "Ingen dager eller klokkeslett til felles med gruppen, så den følger gruppens tilgjengelighet.",
        "product-group-delete": "produktgruppe",
        "product-group-delete-success-message": "Produktgruppen er slettet",
        "product-group-code-column-header": "ERP-nr.",
        "product-group-name-column-header": "Navn",
        "product-group-status-column-header": "Status",

        // Merchant > Admin > Shops > Product groups > Create / Edit
        "product-group-form-name-field": "\n .label = Navn",
        "product-group-form-code-field": "\n .label = ERP-nummer",
        "product-group-form-code-field-helper-text": "ERP-numre brukes ved integrasjon med et regnskapssystem. De vedlikeholdes på leverandørnivå.",
        "product-group-form-code-field-helper-text-no-items": "Ingen tilgjengelige produktgruppekoder for leverandør",
        "product-group-form-settings-panel": "\n .title = Innstillinger",
        "product-group-form-active-switch": "Aktiv:",
        "product-group-form-pin-code-required-switch": "PIN-kode kreves:",
        "product-group-form-pin-code-required-explanation": "Det kreves en PIN-kode for personale for å kjøpe produkter i denne gruppen. PIN-koden finnes i enhetsdetaljene.",
        "product-group-form-limited-availability-panel-title": "\n .title = Begrenset tilgjengelighet \n .offContent = Produkter i denne gruppen er alltid tilgjengelige for kjøp",
        "product-group-form-start-time-picker": "\n .label = Fra klokkeslett",
        "product-group-form-end-time-picker": "\n .label = Til klokkeslett",
        "product-group-form-week-day-monday": "Mandag",
        "product-group-form-week-day-tuesday": "Tirsdag",
        "product-group-form-week-day-wednesday": "Onsdag",
        "product-group-form-week-day-thursday": "Torsdag",
        "product-group-form-week-day-friday": "Fredag",
        "product-group-form-week-day-saturday": "Lørdag",
        "product-group-form-week-day-sunday": "Søndag",
        "product-group-form-end-time-picker-min-error-label": "Må være senere enn 'Fra klokkeslett'",


        // Merchant > Admin > Shops > Price lists
        "price-lists-header": "\n .title = Prislister",
        "price-lists-create-button": "Opprett ny",
        "price-list-vat-code": "MVA-kode:",
        "price-list-currency": "Valuta:",
        "price-list-shops": "Tilknyttede butikker:",
        "price-list-company": "Tilknyttede firmaer:",
        "price-list-no-result": "Det finnes ingen prislister. Opprett din første prisliste",
        "price-list-delete": "prisliste",
        "price-list-delete-success-message": "Prisliste slettet",

        // Merchant > Admin > Price lists > Adjust prices
        "price-lists-adjust-prices-action": "Juster priser",
        "adjust-price-list-page-header": "\n .title = Juster priser",
        "adjust-price-list-breadcrumb": "Juster priser",
        "adjust-price-list-page-subtitle": "{ $priceList } · { $count } varer",
        "adjust-price-list-cancel-button": "Avbryt",
        "adjust-price-list-scope-select-all": "Velg alle",
        "adjust-price-list-scope-deselect-all": "Fravelg alle",
        "adjust-price-list-preview-summary": "{ $count ->\n [one] { $count } vare\n *[other] { $count } varer\n } endres · f.eks. { $from } → { $to }",
        "adjust-price-list-preview-show": "Vis priser",
        "adjust-price-list-preview-hide": "Skjul",
        "adjust-price-list-preview-showing": "Viser { $shown } av { $total } varer.",
        "adjust-price-list-preview-show-all": "Vis alle",
        "adjust-price-list-summary-change": "Endring",
        "adjust-price-list-summary-change-value": "{ $sign }{ $value }",
        "adjust-price-list-summary-rounding": "Avrunding",
        "adjust-price-list-summary-rounding-none": "Ingen",
        "adjust-price-list-summary-rounding-quarter": "{ $step }",
        "adjust-price-list-summary-rounding-half": "{ $step }",
        "adjust-price-list-summary-rounding-whole": "Hele { $currency }",
        "adjust-price-list-submit-button": "Godkjenn",
        "adjust-price-list-adjustment-panel": "\n .title = Justering",
        "adjust-price-list-banner": "\n .title = En prisjustering oppretter en ny prisliste\n .description = Den nåværende listen endres ikke. Du bestemmer når den nye listen trer i kraft og hvilken liste den overtar fra — den gamle deaktiveres automatisk på den datoen.",
        "adjust-price-list-base-list-field": "\n .label = Overta priser fra\n .helperText = Valgt da du åpnet justeringen.",
        "adjust-price-list-scope-subtitle-empty": "Velg minst én produktgruppe.",
        "adjust-price-list-preview-showing-all": "Viser alle { $total } varer.",
        "adjust-price-list-direction-increase": "Øk priser",
        "adjust-price-list-direction-reduction": "Senk priser",
        "adjust-price-list-value-field": "\n .label = Hvor mye?",
        "adjust-price-list-value-max-value": "Verdien kan ikke overstige { $max } { $unit }",
        "adjust-price-list-value-negative-price": "Endringen ville gjort minst én pris negativ. Velg en mindre verdi.",
        "adjust-price-list-value-no-change": "Justeringen endrer ingen priser. Velg en større verdi eller andre produktgrupper.",
        "adjust-price-list-value-field-name": "Verdi",
        "adjust-price-list-no-prices": "Denne prislisten har ingen priser å justere.",
        "adjust-price-list-unit-percentage": "%",
        "adjust-price-list-unit-amount": "{ $currency }",
        "adjust-price-list-rounding-field": "\n .label = Avrunding",
        "adjust-price-list-rounding-hint-none": "Prisene kan ende opp som f.eks. { $example0 }.",
        "adjust-price-list-rounding-hint-quarter": "F.eks. { $example0 } eller { $example1 }.",
        "adjust-price-list-rounding-hint-half": "F.eks. { $example0 } eller { $example1 }.",
        "adjust-price-list-rounding-hint-whole": "F.eks. { $example0 } eller { $example1 }.",
        "adjust-price-list-rounding-none": "Ingen avrunding",
        "adjust-price-list-rounding-quarter": "Nærmeste { $step }",
        "adjust-price-list-rounding-half": "Nærmeste { $step }",
        "adjust-price-list-rounding-whole": "Nærmeste hele { $currency }",
        "adjust-price-list-summary-empty": "Velg hvor mye prisene skal endres, og fra hvilken dato.",
        "adjust-price-list-summary-raises": "Øker prisen på { $count } varer med { $value } fra { $date }.",
        "adjust-price-list-summary-lowers": "Senker prisen på { $count } varer med { $value } fra { $date }.",
        "adjust-price-list-effective-from-field": "\n .label = Gjelder fra",
        "adjust-price-list-customers-notice": "\n .title = Kundene ser endringen\n .description = Prisene oppdateres i { $shops ->\n [one] { $shops } butikk\n *[other] { $shops } butikker\n } for { $customers } kunder.",
        "adjust-price-list-effective-from-invalid": "Velg i dag eller en senere dato",
        "adjust-price-list-existing-orders-note-kept": "Ubokførte ordrer beholder sine nåværende priser.",
        "adjust-price-list-existing-orders-note-updated": "Ubokførte ordrer med levering fra { $date } får de nye prisene.",
        "adjust-price-list-existing-orders-checkbox": "Oppdater disse ordrene også",
        "adjust-price-list-existing-orders-title": "Ubokførte ordrer",
        "adjust-price-list-scope-panel": "\n .title = Omfang",
        "adjust-price-list-scope-subtitle-all": "Alle produktgrupper · { $items } varer",
        "adjust-price-list-scope-subtitle-some": "{ $groups } av { $total } grupper · { $items } varer",
        "adjust-price-list-scope-required": "Velg minst én produktgruppe",
        "adjust-price-list-preview-panel": "\n .title = Forhåndsvisning",
        "adjust-price-list-preview-empty": "Angi en prosent og velg minst én produktgruppe for å se de nye prisene.",
        "adjust-price-list-preview-column-item": "Vare",
        "adjust-price-list-preview-column-now": "Nå",
        "adjust-price-list-preview-column-new": "Ny pris",
        "adjust-price-list-preview-column-change": "Endring",
        "adjust-price-list-summary-panel": "\n .title = Slik ser det ut",
        "adjust-price-list-summary-items": "Berørte varer",

        // Merchant > Admin > Shops > Price lists > Create / Edit
        "create-price-list-page-header": "\n .title = Opprett prisliste",
        "edit-price-list-page-header":"\n .title = Rediger prisliste",
        "create-price-list-save-button": "Lagre",
        "create-price-list-create-button": "Opprett",
        "create-price-list-tab-general": "Generelt",
        "create-price-list-tab-customers": "Kunder",
        "create-price-list-tab-products": "Produkter",
        "create-price-list-tab-pos": "POS",
        "create-price-list-required-name": "Navn er påkrevd",
        "create-price-list-required-shops": "Du må knytte prislisten til en eller flere butikker",
        "create-price-list-required-price-adjustment": "Prisjustering er påkrevd",
        "create-price-list-required-currency-code": "Valuta er påkrevd",
        "create-price-list-required-percentage": "Prosentsats er påkrevd",
        "create-price-list-max-percentage":"Prosentsats kan ikke være mer enn 100",
        "create-or-edit-price-list-field-name":"\n .label = Navn",
        "create-or-edit-price-list-field-shops":"\n .label = Butikker",
        "create-or-edit-price-list-field-aside-settings":"\n .title = Innstillinger",
        "create-or-edit-price-list-field-active":"Aktiv:",
        "create-or-edit-price-list-field-message-to-customers":"\n .label = Melding til kunder",
        "create-or-edit-price-list-aside-pricing":"\n .title = Prissetting",
        "create-or-edit-price-list-field-price-includes-vat":"Prisliste inkl. MVA:",
        "create-or-edit-price-list-field-vat-code":"\n .label = MVA-kode",
        "create-or-edit-price-list-field-currency-code":"\n .label = Valuta",
        "create-or-edit-price-list-field-dropdown-dkk":"DKK",
        "create-or-edit-price-list-field-price-adjustment":"\n .label = Prisjustering",
        "create-or-edit-price-list-field-dropdown-none":"Ingen",
        "create-or-edit-price-list-field-dropdown-discount": "Rabatt",
        "create-or-edit-price-list-field-dropdown-increase": "Prisøkning",
        "create-or-edit-price-list-field-internal-note":"\n .placeholder = Internt notat",
        "create-or-edit-price-list-field-percentage":"Prosentsats (%):",
        "create-or-edit-price-list-customer-table-header-name":"Navn",
        "create-or-edit-price-list-customer-table-header-user-group":"Brukergruppe",
        "create-or-edit-price-list-customer-table-button-remove":"Fjern",
        "create-or-edit-price-list-customer-table-button-details":"Detaljer",
        "create-or-edit-price-list-customer-subtitle":"Hvis ingen kunder er lagt til her, har alle kunder tilgang til prislisten.",
        "create-or-edit-price-list-customer-table-title":"Kunder med tilgang",
        "create-or-edit-price-list-customer-button-add-customer":"Legg til kunde",
        "create-or-edit-price-list-customer-table-empty-state":"Alle kunder har tilgang",
        "create-or-edit-price-list-general-tab-error":"Det er valideringsfeil under fanen Generelt",
        "create-or-edit-price-list-customer-tab-error":"Det er valideringsfeil under fanen Kunder",
        "create-or-edit-price-list-products-tab-error":"Det er valideringsfeil under fanen Produkter",
        "create-or-edit-price-list-pos-tab-error":"Det er valideringsfeil under fanen POS",
        "create-or-edit-price-list-customer-table-add-customers-title":"Legg til kunder",
        "create-or-edit-price-list-customer-table-add-button":"Legg til",
        "create-or-edit-price-list-products-table-title":"Produkter",
        "create-or-edit-price-list-products-table-header-name":"Navn",
        "create-or-edit-price-list-products-table-header-product-no":"Produktnr.",
        "create-or-edit-price-list-products-table-header-normal-price":"Normalpris",
        "create-or-edit-price-list-products-table-header-adjusted-price":"Justert pris",
        "create-or-edit-price-list-products-table-header-status":"Status",
        "create-or-edit-price-list-products-table-status-active":"Aktiv",
        "create-or-edit-price-list-products-table-status-inactive":"Inaktiv",
        "create-or-edit-price-list-pos-table-title":"ID-kortabonnementer",
        "create-or-edit-price-list-pos-info-description":"\n .description = Én prisliste må alltid være standard for POS-systemet. Hvis et ID-kort skannes og abonnementstypen ikke er tildelt en prisliste, vises standardprislisten.",
        "create-or-edit-price-list-pos-is-default-price-list":"Standardprisliste",
        "create-or-edit-price-list-pos-table-type":"Type",
        "create-or-edit-price-list-pos-table-description":"Beskrivelse",

        // Merchant > Admin > Shops > Shops
        "shops-page-header": "\n .title = Butikker",
        "shops-table-case-column": "Saksnr.",
        "shops-table-name-column": "Navn",
        "shops-table-type-column": "Type",
        "shops-table-status-column": "Status",
        "shops-table-status-column-active": "Aktiv",
        "shops-table-status-column-inactive": "Inaktiv",
        "shops-table-status-column-demo": "Demo",
        "shops-table-status-column-active-filter-active": "Aktiv",
        "shops-table-status-column-inactive-filter-inactive": "Inaktiv",
        "shops-table-status-column-demo-filter-demo": "Demo",
        "shops-table-create-button": "Opprett ny",
        "shops-table-menu-item-edit": "Rediger",
        "shops-table-menu-item-delete": "Slett",
        "shops-confirm-delete-shop-dialog": "\n .typeOfEntity = butikk",

        // Merchant > Admin > Shops > Shops > Create - Edit shop
        "merchant-shop-create-header": "\n .title = Opprett butikk",
        "merchant-shop-edit-header": "\n .title = Rediger butikk",
        "merchant-shop-create-breadcrumb": "Opprett butikk",
        "merchant-shop-edit-breadcrumb": "Rediger butikk",
        "merchant-shop-create-button": "Opprett",
        "merchant-shop-save-button": "Lagre",
        "merchant-create-edit-shop-tab-general": "Generelt",
        "merchant-create-edit-shop-tab-settings": "Innstillinger",
        "merchant-shop-form-field-name": "\n .label = Navn \n .helperText = Butikkens navn vil være synlig for kundene dine.",
        "merchant-shop-form-field-type": "\n .label = Type",
        "merchant-shop-form-field-type-helperText": "Velg butikktype.",
        "merchant-shop-form-field-type-mode-meeting-service": "Møteservering",
        "merchant-shop-form-field-type-mode-take-away": "Takeaway",
        "merchant-shop-form-field-type-mode-lunch": "GoPay",
        "merchant-shop-form-field-type-mode-pos": "POS",
        "merchant-shop-form-field-type-mode-subscription": "Abonnement",
        "merchant-shop-form-hardware-packages": "Velg maskinvarepakker",
        "merchant-shop-form-hardware-packages-info": "\n .description = Valg av produkter nedenfor fører ikke til et kjøp. Du vil deretter motta et tilbud på maskinvare, som du kan godkjenne.",
        "merchant-shop-form-hardware-packages-tablet-size": "Nettbrettstørrelse:",
        "merchant-shop-form-hardware-packages-color": "Farge:",
        "merchant-shop-form-payment-methods": "Tilgjengelige betalingsmetoder",
        "merchant-shop-form-make-shop-public": "\n .title = Offentlig butikk \n .offContent = Denne butikken er kun tilgjengelig for inviterte firmaer.",
        "merchant-shop-form-make-shop-public-info": "\n .description = En offentlig butikk er tilgjengelig for alle.",
        "merchant-shop-form-make-shop-public-title": "Del følgende med kundene dine",
        "merchant-shop-form-make-shop-public-description": "For å betale som gjest må du enten skanne en QR-kode eller oppgi butikknummeret for å få tilgang til butikken. Les mer om offentlige butikker <externalLink>her</externalLink>.",
        "merchant-shop-form-make-shop-public-number": "Butikknummer:",
        "merchant-shop-form-make-shop-public-url": "Direkte offentlig URL:",
        "merchant-shop-form-make-shop-public-qr-code": "- eller brukerne kan skanne denne QR-koden med mobilen",
        "merchant-shop-form-make-shop-public-offContent": "Lagre for å se delingsdetaljer.",
        "merchant-shop-form-field-isVisibleForAppUsers": "\n .label = Gjør butikken synlig for interne brukere i GoPay-mobilappen",
        "merchant-shop-form-general": "\n .title = Generelt",
        "merchant-shop-form-field-active": "Aktiv:",
        "merchant-shop-form-field-demo": "Demo:",
        "merchant-shop-form-erp": "\n .title = ERP",
        "merchant-shop-form-field-case-number": "\n .label = Saksnummer \n .helperText = Saksnummeret brukes til å importere salgsdata til organisasjonens ERP-system.",
        "merchant-shop-form-internal-note": "\n .title = Internt notat",
        "merchant-shop-form-field-internal-note": "\n .label = Internt notat:",
        "merchant-shop-form-posDetails-defaultLanguage-field-label": "\n .label = Standardspråk",
        "merchant-shop-form-posDetails-defaultLanguage-lang-en": "Engelsk",
        "merchant-shop-form-posDetails-defaultLanguage-lang-da": "Dansk",
        "merchant-shop-form-check-in": "Sjekk inn",
        "merchant-shop-form-check-in-qr-code-on-receipt": "Vis QR-kode for innsjekking på kvittering",
        "merchant-shop-form-accept-multiple-check-ins": "Tillat flere innsjekkinger",
        "merchant-shop-form-deadline": "\n .title = Frist \n .offContent = Frist er ikke aktivert",
        "merchant-shop-form-purchases": "Kjøp:",
        "merchant-shop-form-cancellation": "Avbestilling:",
        "merchant-shop-form-deadline-day-field": "\n .label = Dag",
        "merchant-shop-form-deadline-day-limit-day-before": "Dagen før",
        "merchant-shop-form-deadline-day-limit-x-days-before": "{ $daysBefore } dager før",
        "merchant-shop-form-deadline-time-picker": "\n .label = Tid",
        "merchant-shop-form-posDetails-configuration-for-supporters": "\n .title = Innstillinger for supportmedarbeidere",
        "merchant-shop-form-posDetails-configuration-for-supporters-returnToHomeScreenDelay-field-label": "\n .label = Ventetid før retur til startskjermen",
        "merchant-shop-form-posDetails-configuration-for-supporters-returnToHomeAfterPurchase-field-label": "\n .label = Gå tilbake til start etter kjøp",
        "merchant-shop-form-posDetails-configuration-for-supporters-ms": "ms",

        // Merchant > Admin > Shops > Offers
        "offers-page-header": "\n .title = Tilbud",
        "offers-table-name-column": "Produktnavn",
        "offers-table-price-column": "Ny pris",
        "offers-table-original-price-column": "Opprinnelig pris",
        "offers-table-valid-from-column": "Gyldig fra",
        "offers-table-expires-column": "Utløper",
        "offers-table-status-column": "Status",
        "offers-table-edit-menu-item": "Rediger",
        "offers-table-remove-offer-menu-item": "Fjern tilbud",
        "offers-table-remove-offer-confirm-dialog": "\n .typeOfEntity = tilbud",
        "offers-table-remove-offer-success": "Tilbud fjernet",


        // Merchant > Admin > Shops > VAT Codes
        "merchant-vat-codes-header": "\n .title = MVA-koder",
        "merchant-vat-codes-list-create-button": "Opprett ny",
        "merchant-vat-codes-create-button": "Opprett",
        "merchant-vat-codes-save-button": "Lagre",
        "merchant-vat-codes-delete-entity-dialog": "\n .typeOfEntity = MVA-kode",
        "merchant-vat-codes-table-header-vat-code":"MVA-kode",
        "merchant-vat-codes-table-header-name":"Navn",
        "merchant-vat-codes-table-header-percentage":"Prosent",
        "merchant-vat-codes-table-button-edit":"Rediger",
        "merchant-vat-codes-table-button-delete":"Slett",

        // Merchant > Admin > Shops > Create/Edit VAT Codes
        "merchant-vat-codes-create-header": "\n .title = Opprett MVA-kode",
        "merchant-vat-codes-edit-header": "\n .title = Rediger MVA-kode",
        "merchant-vat-codes-create-edit-field-code":"\n .label = Kode",
        "merchant-vat-codes-create-edit-field-name":"\n .label = Navn",
        "merchant-vat-codes-create-edit-vat-percentage-amount":"\n .label = MVA-prosent",
        "merchant-vat-codes-create-edit-required-name": "Navn er påkrevd",
        "merchant-vat-codes-create-edit-required-code": "Kode er påkrevd",
        "merchant-vat-codes-create-edit-required-vat-percentage-amount": "MVA-prosent er påkrevd",

        // Merchant > Admin > Shops > Delivery locations
        "merchant-delivery-locations-header": "\n .title = Leveringssteder",
        "merchant-delivery-locations-create-button-link": "Opprett ny",
        "merchant-delivery-locations-delete-entity-dialog": "\n .typeOfEntity = leveringssted",
        "merchant-delivery-locations-table-header-name": "Navn",
        "merchant-delivery-locations-table-header-webshop": "Webshop",
        "merchant-delivery-locations-table-header-status": "Status",
        "merchant-delivery-locations-table-active-column-active": "Aktiv",
        "merchant-delivery-locations-table-active-column-inactive": "Inaktiv",
        "merchant-delivery-locations-table-active-column-active-filter-yes": "Aktiv",
        "merchant-delivery-locations-table-active-column-inactive-filter-no": "Inaktiv",
        "merchant-delivery-locations-table-button-edit": "Rediger",
        "merchant-delivery-locations-table-button-delete": "Slett",

        // Merchant > Admin > Shops > Delivery locations
        "merchant-delivery-location-create-header": "\n .title = Opprett leveringssted",
        "merchant-delivery-location-edit-header": "\n .title = Rediger leveringssted",
        "merchant-delivery-location-create-breadcrumb": "Opprett leveringssted",
        "merchant-delivery-location-edit-breadcrumb": "Rediger leveringssted",
        "merchant-delivery-location-form-field-name": "\n .label = Navn",
        "merchant-delivery-location-form-pickup-details-title": "Henteinformasjon:",
        "merchant-delivery-location-form-field-description": "\n .label = Beskrivelse",
        "merchant-delivery-location-form-pickup-time-helper": "Velg hentetidspunkt, slik at kunden vet når bestillingen kan hentes:",
        "merchant-delivery-location-form-field-webshop": "\n .label = Webshop",
        "merchant-delivery-location-form-start-time-picker": "\n .label = Fra:",
        "merchant-delivery-location-form-end-time-picker": "\n .label = Til:",
        "merchant-delivery-location-form-end-time-picker-min-error-label": "Må være senere enn 'Fra klokkeslett'",
        "merchant-delivery-location-form-settings": "\n .title = Innstillinger",
        "merchant-delivery-location-form-field-active": "Aktiv:",
        "merchant-delivery-locations-create-button": "Opprett",
        "merchant-delivery-locations-save-button": "Lagre",

        // Merchant > Admin > Shops > Payment links
        "payment-links-page-header": "\n .title = Betalingslenker",
        "payment-links-table-name-column": "Navn",
        "payment-links-table-shop-column": "Butikk",
        "payment-links-table-valid-from-column": "Gyldig fra",
        "payment-links-table-valid-to-column": "Gyldig til",
        "payment-links-table-create-button": "Opprett ny",
        "payment-links-table-menu-item-edit": "Rediger",
        "payment-links-table-menu-item-delete": "Slett",
        "payment-links-confirm-delete-dialog": "\n .typeOfEntity = betalingslenker",

        // Merchant > Admin > Shops > Payment links > Create / Edit
        "payment-links-create-page-header": "\n .title = Opprett betalingslenke",
        "payment-links-create-page": "Opprett betalingslenke",
        "payment-links-form-create-submit-button": "Opprett",
        "payment-links-edit-page-header": "\n .title = Rediger betalingslenke",
        "payment-links-edit-page": "Rediger betalingslenke",
        "payment-links-form-edit-submit-button": "Lagre",
        "payment-links-form-public-title-label": "\n .label = Tittel",
        "payment-links-form-description-label": "\n .label = Beskrivelse",
        "payment-links-form-public-shop-field-label": "\n .label = Offentlig butikk",
        "payment-links-form-sales-account-field-label": "\n .label = Salgskonto",
        "payment-links-form-hasPasswordProtection-switch": "Passordbeskyttet",
        "payment-links-form-password-field-label": "\n .label = Passord \n .helperText = Beskytt lenken din med passord hvis butikken støtter fakturering som betalingsmetode.",
        "payment-links-form-general-panel": "\n .title = Generelt",
        "payment-links-form-active-switch": "Aktiv:",
        "payment-links-form-availability-panel": "\n .title = Gyldighetsperiode \n .offContent = Gyldig på ubestemt tid",
        "payment-links-form-availability-from-date-picker": "\n .label = Startdato",
        "payment-links-form-availability-to-date-picker": "\n .label = Sluttdato",
        "payment-links-form-availability-error-picker": "Startdato og sluttdato må fylles ut",

        // Merchant > Admin > Setting > Sales accounts
        "sales-accounts-page-header": "\n .title = Salgskontoer",
        "sales-accounts-table-name-column": "Navn",
        "sales-accounts-table-number-column": "Nummer",
        "sales-accounts-table-create-button": "Opprett ny",
        "sales-accounts-table-menu-item-edit": "Rediger",
        "sales-accounts-table-menu-item-delete": "Slett",
        "sales-accounts-confirm-delete-dialog": "\n .typeOfEntity = salgskontoer",

        // Merchant > Admin > Setting > Sales accounts > Create / Edit
        "sales-accounts-create-page-header": "\n .title = Opprett salgskonto",
        "sales-accounts-create-page": "Opprett salgskonto",
        "sales-accounts-form-create-submit-button": "Opprett",
        "sales-accounts-edit-page-header": "\n .title = Rediger salgskonto",
        "sales-accounts-edit-page": "Rediger salgskonto",
        "sales-accounts-form-edit-submit-button": "Lagre",
        "sales-accounts-form-public-name-label": "\n .label = Navn \n .placeholder = Skriv inn et navn for salgskontoen",
        "sales-accounts-form-number-label": "\n .label = Nummer \n .placeholder = Skriv inn kontonummer fra ERP-systemet",
        "sales-accounts-form-general-panel": "\n .title = Generelt",
        "sales-accounts-form-active-switch": "Aktiv:",

        // ADMIN DEVICES
        "merchant-admin-devices-page-header": "\n .title = Enheter",
        // Merchant users
        "merchant-admin-users-create-admin-button": "Opprett ny",
        "merchant-admin-users-page-title": "\n .title = Administratorer",


        // --- Supplier ---

        // Supplier > Navigation
        "supplier-nav-item-home": "Hjem",
        "supplier-nav-item-accounting-title": "\n .title = Regnskap",
        "supplier-nav-item-accounting": "Regnskap",
        "supplier-nav-item-pos": "POS",
        "supplier-nav-item-meeting-service": "Møteservering",
        "supplier-nav-item-subscriptions": "Abonnementer",
        "supplier-nav-item-z-reports": "Z-rapporter",
        "supplier-nav-item-merchant-sales": "Salg per salgssted",
        "supplier-nav-item-customer-sales": "Kundesalg",
        "supplier-nav-item-balance": "Saldo",

        // Supplier > Navigation > Reports
        "supplier-nav-item-merchant-access": "Salgssteder",

        // Supplier > Navigation > Admin
        "supplier-nav-item-merchants-page-header":"\n .title = Salgssteder",
        "supplier-nav-item-settings-page-header":"\n .title = Innstillinger",
        "supplier-nav-item-account-page-header":"\n .title = Konto",
        "supplier-nav-item-erp-page-header":"\n .title = ERP",
        "supplier-nav-item-acquiring-reports-page-header":"\n .title = Avstemming",
        "supplier-admin-nav-item-merchants": "Salgssteder",
        "supplier-admin-nav-item-merchants-create": "Opprett salgssted",
        "supplier-admin-nav-item-merchants-edit": "Rediger salgssted",
        "supplier-admin-nav-item-administrators": "Administratorer",
        "supplier-admin-nav-item-admins": "Administratorer",
        "supplier-admin-nav-item-devices": "Enheter",
        "supplier-admin-nav-item-settings": "Innstillinger",
        "supplier-admin-nav-item-acquiring": "Kortinnløsning",
        "supplier-admin-nav-item-terms-and-conditions": "Handelsbetingelser",
        "supplier-admin-nav-item-pos-settings":"POS-innstillinger",
        "supplier-admin-nav-item-pos-settings-template-create": "Opprett mal",
        "supplier-admin-nav-item-pos-settings-template-edit": "Rediger mal",
        "supplier-admin-nav-item-company-account":"Firmakonto",
        "supplier-admin-nav-item-account-gdpr":"GDPR",
        "supplier-admin-nav-item-erp":"ERP",
        "supplier-admin-nav-item-acquiring-fees": "Innløsningsgebyrer",
        "supplier-admin-nav-item-bank-transfers":"Bankoverføringer",
        "supplier-admin-nav-item-product-numbers":"Produktnumre",
        "supplier-admin-nav-item-create-product-group-number":"Opprett produktnummer",
        "supplier-admin-nav-item-update-product-group-number":"Oppdater produktnummer",
        "supplier-admin-nav-item-create-terms-and-conditions": "Opprett handelsbetingelser",
        "supplier-admin-nav-item-update-terms-and-conditions": "Oppdater handelsbetingelser",

        // Supplier > Reports > Home

        // Supplier > Reports > Home > Accounting > Meeting Service
        "supplier-meeting-service-header": "\n .title = Møteservering",
        "supplier-meeting-service-table-merchant": "Salgssted",
        "supplier-meeting-service-table-order-id-column": "Ordre-ID",
        "supplier-meeting-service-order-id-label": "\n .label = Ordre-ID",
        "supplier-meeting-service-table-booked-date-column": "Bokføringsdato",
        "supplier-meeting-service-table-delivery-time-column": "Leveringstid",
        "supplier-meeting-service-table-employee-column": "Salgssted",
        "supplier-meeting-service-table-status":"Status",
        "supplier-meeting-service-table-status-confirmed":"Bekreftet",
        "supplier-meeting-service-table-status-canceled":"Kansellert",
        "supplier-meeting-service-table-amount-column": "Beløp (DKK)",
        "supplier-meeting-service-table-show-receipt": "Vis kvittering",
        "supplier-meeting-service-table-floating-action-bar-receipts": "\n .title = Kvitteringer",
        "supplier-meeting-service-table-floating-action-bar-export": "\n .title = Eksporter",
        "supplier-meeting-service-order-title":"\n .title = Ordre",
        "supplier-meeting-service-drawer-pending-approval-label":"\n .label = Venter på godkjenning",
        "supplier-meeting-service-invoicing-title":"\n .title = Fakturering",
        "supplier-meeting-service-drawer-invoice-status-label":" Fakturastatus",
        "supplier-meeting-service-drawer-invoice-status-all-label":"Alle",
        "supplier-meeting-service-drawer-invoice-status-sent-label":"Sendt",
        "supplier-meeting-service-drawer-invoice-status-not-sent-label":"Ikke sendt",
        "supplier-meeting-service-drawer-booked-label":"Bokført",
        "supplier-meeting-service-drawer-booked-all-label":"Alle",
        "supplier-meeting-service-drawer-booked-booked-label":"Bokført",
        "supplier-meeting-service-drawer-booked-not-booked-label":"Ikke bokført",
        "supplier-meeting-service-booked-date-title":"\n .title = Bokføringsdato",
        "supplier-meeting-service-delivery-date-title":"\n .title = Leveringsdato",
        "supplier-meeting-service-merchant-title":"\n .title = Salgssted",
        "supplier-meeting-service-debtor-title":"\n .title = Debitor",
        "supplier-meeting-service-end-user-title":"\n .title = Sluttbruker",
        "supplier-meeting-service-payment-title":"\n .title = Betaling",
        "supplier-meeting-service-drawer-from-date-label":"\n .label = Fra dato",
        "supplier-meeting-service-drawer-to-date-label":"\n .label = Til dato",
        "supplier-meeting-service-drawer-bill-receivers-label":"Fakturamottakere",
        "supplier-meeting-service-drawer-bill-receivers-select-company-helper-text":"Velg først et firma for å filtrere på fakturamottaker",
        "supplier-meeting-service-drawer-satellites-label":"Satellitter",
        "supplier-meeting-service-drawer-to-date-info-label":"\n .title = Ikke bruk leveringsdato til fakturering. Bruk bokføringsdato i stedet.",

        // Supplier > Reports > Home > Accounting > POS
        "supplier-pos-table-header-title": "\n .title = POS",
        "supplier-pos-table-header-order-id": "Ordre-ID",
        "supplier-pos-table-header-transaction-time": "Transaksjonstid",
        "supplier-pos-table-header-merchant-name": "Salgsstedsnavn",
        "supplier-pos-table-header-employee": "Opprettet av",
        "supplier-pos-table-header-payment": "Betalingsmetode",
        "supplier-pos-table-header-payment-channel": "Kanal",
        "supplier-pos-table-header-amount": "Beløp (DKK)",
        "supplier-pos-table-table-button-show-receipt": "Vis kvittering",
        "supplier-pos-table-filters-order-title":"\n .title = Ordre",
        "supplier-pos-table-filters-period-title":"\n .title = Periode",
        "supplier-pos-table-filters-merchant-title":"\n .title = Salgssted",
        "supplier-pos-table-filters-debtor-title":"\n .title = Debitor",
        "supplier-pos-table-filters-end-user-title":"\n .title = Sluttbruker",
        "supplier-pos-table-filters-payment-title":"\n .title = Betaling",
        "supplier-pos-table-filters-from-date-label":"\n .label = Transaksjon fra dato",
        "supplier-pos-table-filters-to-date-label":"\n .label = Transaksjon til dato",

        // Supplier > Reports > Home > Accounting > Subscriptions
        "supplier-subscriptions-header": "\n .title = Abonnementer",
        "supplier-subscriptions-table-order-id-column": "Ordre-ID",
        "supplier-subscriptions-table-employee-column": "Ansatt",
        "supplier-subscriptions-table-subscribed-column": "Påmeldt",
        "supplier-subscriptions-table-unsubscribed-column": "Avmeldt",
        "supplier-subscriptions-table-payment-column": "Betalingsmetode",
        "supplier-subscriptions-table-amount-column": "Beløp",
        "supplier-subscriptions-table-cancel-subscription": "Si opp abonnement",
        "supplier-subscriptions-table-details": "Detaljer",
        "supplier-subscriptions-table-filters-order-title":"\n .title = Ordre",
        "supplier-subscriptions-table-filters-period-title":"\n .title = Periode",
        "supplier-subscriptions-table-filters-from-date-label":"\n .label = Gyldig fra dato",
        "supplier-subscriptions-table-filters-to-date-label":"\n .label = Gyldig til dato",
        "supplier-subscriptions-table-filters-merchant-title":"\n .title = Salgssted",
        "supplier-subscriptions-table-filters-debtor-title":"\n .title = Debitor",
        "supplier-subscriptions-table-filters-end-user-title":"\n .title = Sluttbruker",
        "supplier-subscriptions-table-filters-payment-title":"\n .title = Betaling",
        "supplier-subscriptions-drawer-subscription-label":"Abonnement",


        // Supplier > Reports > Home > Accounting > Z-reports
        "supplier-accounting-z-reports-page-header":" \n .title = Z-rapporter",
        "supplier-accounting-z-reports-table-date-column":"Dato",
        "supplier-accounting-z-reports-table-pos-terminal-column":"POS-enhet",
        "supplier-accounting-z-reports-table-amount-column":"Beløp",

        // Supplier > Reports > Home > Accounting > Merchant Sales
        "supplier-merchant-sales-header": "\n .title = Salg per salgssted",
        "supplier-merchant-sales-table-shop-type": "\n .label = Butikktype",
        "supplier-merchant-sales-table-red-no-column": "Reg.nr.",
        "supplier-merchant-sales-table-name-column": "Navn",
        "supplier-merchant-sales-table-upcoming-sales-column": "Kommende salg ({ $currencyCode })",
        "supplier-merchant-sales-table-booked-sales-column": "Bokført salg ({ $currencyCode })",
        "supplier-merchant-sales-table-floating-action-bar-export": "\n .title = Eksporter",
        "supplier-merchant-sales-table-shop-type-input-label": "Butikktype",
        "supplier-merchant-sales-table-shop-type-item-pos": "POS",
        "supplier-merchant-sales-table-shop-type-item-meeting-service": "Møteservering",
        "supplier-merchant-sales-table-shop-type-item-subscription": "Abonnement",
        "supplier-merchant-sales-detailed-table-total-footer-column": "Totalt",
        "supplier-merchant-sales-detailed-table-sales-column": "Salg (DKK)",

        // Supplier > Reports > Home > Accounting > Customer Sales
        "supplier-customer-sales-header": "\n .title = Kundesalg",
        "supplier-customer-sales-table-name-column": "Navn",
        "supplier-customer-sales-table-upcoming-sales-column": "Kommende salg ({ $currencyCode })",
        "supplier-customer-sales-table-booked-sales-column": "Bokført salg ({ $currencyCode })",
        "supplier-customer-sales-table-floating-action-bar-export": "\n .title = Eksporter",
        "supplier-customer-sales-detailed-table-total-footer-column": "Totalt",
        "supplier-customer-sales-detailed-table-sales-column": "Salg (DKK)",


        // Supplier > Admin > Home
        "supplier-admin-home-merchants-group": "\n .title = Salgssteder",
        "supplier-admin-home-merchant-card": "\n .title = Salgssteder\n .description = Administrer salgssteder, som er fysiske salgslokasjoner, f.eks. kantiner.",
        "supplier-admin-home-administrators-card": "\n .title = Administratorer\n .description = Administrer leverandør- og salgsstedsadministratorer.",
        "supplier-admin-home-devices-card": "\n .title = Enheter\n .description = Administrer enheter, som POS-nettbrett, innsjekkingsskjermer og skrivere.",
        "supplier-admin-home-settings-group": "\n .title = Innstillinger",
        "supplier-admin-home-payment-acquiring-card": "\n .title = Kortinnløsning\n .description = Administrer og sjekk status på avtaler om kredittkortinnløsning.\n .buttonText = Vis",
        "supplier-admin-home-terms-and-conditions-card": "\n .title = Handelsbetingelser\n .description = Administrer handelsbetingelsene som vises for kundene dine.",
        "supplier-admin-home-pos-settings-card": "\n .title = POS-innstillinger \n .description = Administrer POS-innstillinger.",
        "supplier-admin-home-account-group":  "\n .title = Konto",
        "supplier-admin-home-company-account-card":  "\n .title = Firmakonto\n .description = Administrer firmakontoen din.\n .buttonText = Vis",
        "supplier-admin-home-erp-group":  "\n .title = ERP",
        "supplier-admin-home-product-numbers-card":  "\n .title = Produktnumre\n .description = Administrer produktnumre for ERP-integrasjon.",
        "supplier-admin-home-account-gdpr-card":  "\n .title = GDPR \n .description = Personvernforordningen \n .buttonText = Vis",
        "supplier-admin-home-acquiring-reports-group":  "\n .title = Avstemming",
        "supplier-admin-home-bank-transfers-card":  "\n .title = Bankoverføringer\n .description = Rapport over overføringer mellom innløsningskontoene og bankkontoene dine.\n .buttonText = Vis",
        "supplier-admin-home-acquiring-fees":  "\n .title = Innløsningsgebyrer\n .description = Rapport over innløsningsgebyrer. Nyttig for avstemming.\n .buttonText = Vis",
        "supplier-admin-home-balance":  "\n .title = Saldo\n .description = Rapport som viser totalt salg, gebyrer og overføringer for en periode.\n .buttonText = Vis",

        // Supplier > Admin > Devices
        "supplier-admin-devices-page-header": "\n .title = Enheter",

        // Supplier > Admin > ERP > Product Group Numbers
        "supplier-admin-erp-product-group-numbers-header": "\n .title = Produktnumre",
        "supplier-admin-erp-product-group-numbers-create-new-button":"Opprett ny",
        "supplier-admin-erp-product-group-numbers-save-button":"Lagre",
        "supplier-admin-erp-product-group-numbers-table-header-erp-number":"ERP-nr.",
        "supplier-admin-erp-product-group-numbers-table-header-name":"Navn",
        "supplier-admin-erp-product-group-numbers-table-header-status":"Status",
        "supplier-admin-erp-product-group-numbers-table-active-column-active":"Aktiv",
        "supplier-admin-erp-product-group-numbers-table-active-column-inactive":"Inaktiv",
        "supplier-admin-erp-product-group-numbers-table-active-filter-yes":"Aktiv",
        "supplier-admin-erp-product-group-numbers-table-active-filter-no":"Inaktiv",
        "supplier-admin-erp-product-group-numbers-table-button-edit":"Rediger",
        "supplier-admin-erp-product-group-numbers-table-button-delete":"Slett",
        "supplier-admin-erp-product-group-numbers-delete-entity-dialog":"\n .typeOfEntity = produktnumre",

        // Supplier > Admin > ERP > Product Group Numbers > Create/Update
        "supplier-admin-erp-product-group-numbers-create-header": "\n .title = Opprett produktnummer",
        "supplier-admin-erp-product-group-numbers-update-header": "\n .title = Rediger produktnummer",
        "supplier-admin-erp-product-group-numbers-create-button":"Opprett",
        "supplier-admin-erp-product-group-numbers-field-code":"\n .label = ERP-nummer",
        "supplier-admin-erp-product-group-numbers-field-name":"\n .label = Navn",
        "supplier-admin-erp-product-group-numbers-description":"\n .label = Beskrivelse\n .placeholder = Her kan du forklare tiltenkt bruk av dette produktnummeret",
        "supplier-admin-erp-product-group-numbers-required-code":"ERP-nummer er påkrevd",
        "supplier-admin-erp-product-group-numbers-required-name":"Navn er påkrevd",
        "supplier-admin-erp-product-group-numbers-aside-settings":"\n .title = Innstillinger",
        "supplier-admin-erp-product-group-numbers-active":"Aktiv:",
        "supplier-admin-erp-product-group-numbers-history":"\n .title = Historikk",
        "supplier-admin-erp-product-group-numbers-aside-created":"Opprettet:",
        "supplier-admin-erp-product-group-numbers-aside-updated":"Oppdatert:",

        // DEVICE TABLE GENERAL
        "devices-table-header-name": "Navn",
        "devices-table-header-group": "Gruppe",
        "devices-table-header-type": "Type",
        "devices-table-header-status": "Status",
        "devices-table-button-details": "Detaljer",
        "devices-table-button-edit": "Rediger",
        "devices-table-status-column-online": "Online",
        "devices-table-status-column-offline": "Offline",
        "devices-table-header-reg": "Reg.nr.",
        "devices-table-header-merchant": "Salgssted",

        // DEVICE DETAILS
        "device-details-title": "Enhetsdetaljer",
        "device-details-type-info-shop": "\n .label = Butikk:",
        "device-details-type-info-device-number": "\n .label = Enhetsnummer:",
        "device-details-type-info-serial-number": "\n .label = Serienummer:",
        "device-details-type-info-hardware-id": "\n .label = Hardware-ID:",
        "device-details-type-info-language": "\n .label = Språk:",
        "device-details-type-info-pos-mode": "\n .label = POS-modus:",
        "device-details-type-info-card-terminal-acquirer-name": "\n .label = Navn på kortterminalens innløser:",
        "device-details-status-info-title": "\n .title = Status",
        "device-details-status-info-diagnostics-title": "\n .title = Vis diagnostikk",
        "device-details-status-info-diagnostics-subject": "Emne",
        "device-details-status-info-diagnostics-message": "Melding",
        "device-details-pin-code-info-title": "\n .title = PIN-kode",
        "device-details-pin-code-info-helper": "\n .title = PIN-kode: \n .description = PIN-koden brukes for å få tilgang til administrasjonsmenyer på enheten.",
        "device-details-group-info-title": "\n .title = Gruppe",
        "device-details-group-info-name": "\n .label = Navn:",
        "device-details-group-info-connected-devices": "\n .label = Tilknyttede enheter:",
        "device-details-group-table-header-name": "Navn",
        "device-details-group-table-header-type": "Type",
        "device-details-group-table-header-status": "Status",
        "device-details-device-info-title": "\n .title = Enhet",
        "device-details-device-info-name": "\n .label = Navn:",
        "device-details-device-info-shop": "\n .label = Butikk:",
        "device-details-device-info-device-number": "\n .label = Enhetsnummer:",
        "device-details-identification-info-title": "\n .title = Identifikasjon",
        "device-details-identification-info-serial-number": "\n .label = Serienummer:",
        "device-details-identification-info-hardware-id": "\n .label = Hardware-ID:",
        "device-details-identification-info-acquirer": "\n .label = Navn på kortterminalens innløser:",
        "device-details-settings-info-title": "\n .title = Innstillinger",
        "device-details-settings-info-language": "\n .label = Språk:",
        "device-details-settings-info-pos-mode": "\n .label = POS-modus:",
        "device-details-settings-info-pin-code-info": "PIN-koden brukes for å få tilgang til beskyttede områder i appen.",
        "device-details-history-info-title": "\n .title = Historikk",
        "device-details-history-info-created": "\n .label = Opprettet:",
        "device-details-history-info-edited": "\n .label = Redigert:",
        "device-details-type-mode-cloud-pos": "GoPay CloudPOS",
        "device-details-type-mode-soft-pos": "GoPay SoftPOS",
        "device-details-type-mode-display": "Display",
        "device-details-type-mode-cloud-credit-card-reader": "Cloud-skriver",
        "device-details-type-mode-star-cloud-printer": "Cloud-kredittkortleser",
        "device-details-type-mode-receipt-control": "Kvitteringskontroll",
        "device-details-type-mode-room-display": "Romdisplay",
        "device-details-type-mode-meeting-display": "Møtedisplay",
        "device-details-type-mode-guest-check-in": "Gjesteinnsjekking",
        "device-details-group-table-device-type-filter-label": "Enhetstype",
        "device-details-group-table-device-type-filter-placeholder": "Alle",
        "device-details-group-table-device-type-filter-label-label": "\n .label = Enhetstype",
        "devices-table-select-filter-on-item-room-display": "Romdisplay",
        "devices-table-select-filter-on-item-meeting-display": "Møtedisplay",
        "devices-table-select-filter-on-item-guest-check-in": "Gjesteinnsjekking",


        // Create or edit device
        "service-center-admin-organization-create-devices-title": "\n .title = Opprett display",
        "service-center-admin-organization-edit-devices-title": "\n .title = Rediger display",
        "devices-create-device-form": "Opprett",
        "devices-edit-device-form": "Lagre",
        "devices-edit-breadcrumb": "Rediger display",
        "devices-create-breadcrumb": "Opprett display",
        "devices-create-or-edit-form-select-template-label": "\n .label = Mal",
        "devices-create-or-edit-form-select-field-name": "\n .label = Navn",
        "devices-create-or-edit-form-select-field-device-number": "\n .label = Enhetsnummer",
        "devices-create-or-edit-form-floor-label": "\n .label = Etasje",
        "devices-create-or-edit-form-select-field-room": "\n .label = Rom",
        "devices-create-or-edit-form-select-field-serial-number": "\n .label = Serienummer",
        "devices-create-or-edit-form-select-display-type": "\n .label = Displaytype",
        "devices-create-or-edit-form-type-room-details-info": "\n .title = Romdisplayer settes opp foran møterom for å vise om rommet er ledig eller opptatt. De gir også en enkel måte å booke rommet på.",
        "devices-create-or-edit-form-type-meeting-details-info": "\n .title = Møtedisplayer settes vanligvis opp i hver etasje og er laget for å vise folk hvor de skal gå til møtet sitt.",

        "devices-create-or-edit-form-display-type-dropdown-item-room-display": "Romdisplay",
        "devices-create-or-edit-form-display-type-dropdown-item-meeting-display": "Møtedisplay",
        "devices-create-or-edit-form-display-type-dropdown-item-guest-check-in": "Gjesteinnsjekking",

        // Display types
        "display-types-dropdown-select-item-room-display": "Romdisplay",

        // Supplier > Admin > POS settings
        "supplier-admin-pos-settings-page-header": "\n .title = POS-innstillinger",
        "supplier-admin-pos-settings-tab-templates": "Maler",
        "supplier-admin-pos-settings-tab-general": "Generelt",
        "supplier-admin-pos-settings-create-button": "Opprett ny",
        "supplier-admin-pos-settings-templates-table-header-name": "Navn",
        "supplier-admin-pos-settings-templates-table-header-language": "Språk",
        "supplier-admin-pos-settings-templates-table-header-status": "Status",
        "supplier-admin-pos-settings-templates-table-edit-button": "Rediger",
        "supplier-admin-pos-settings-templates-table-duplicate-button": "Dupliser",
        "supplier-admin-pos-settings-templates-table-delete-button": "Slett",
        "supplier-admin-pos-settings-templates-table-status-column-active":"I bruk",
        "supplier-admin-pos-settings-templates-table-status-column-inactive":"Ikke i bruk",
        "supplier-admin-pos-settings-templates-table-status-column-active-filter-yes": "I bruk",
        "supplier-admin-pos-settings-templates-table-status-column-inactive-filter-no": "Ikke i bruk",

        // Supplier > Admin > POS settings > Templates > Create / Edit
        "supplier-admin-pos-settings-create-template-page-header": "\n .title = Opprett mal",
        "supplier-admin-pos-settings-edit-template-page-header": "\n .title = Rediger mal",
        "supplier-admin-pos-settings-create-submit-button": "Opprett",
        "supplier-admin-pos-settings-edit-submit-button": "Lagre",
        "supplier-admin-pos-settings-template-shortcuts": "\n .title = Snarveier",
        "supplier-admin-pos-settings-template-name-field-label": "\n .label = Malnavn",
        "supplier-admin-pos-settings-template-languageCode-field-label": "\n .label = Språk",
        "supplier-admin-pos-settings-lang-en": "Engelsk",
        "supplier-admin-pos-settings-lang-da": "Dansk",
        "supplier-admin-pos-settings-template-button-field-label": "\n .label = Knappetekst \n .helperText = Tilpass teksten på knappen for å starte kjøp.",
        "supplier-admin-pos-settings-template-title-field-label": "\n .label = Tittel",
        "supplier-admin-pos-settings-template-subtitle-field-label": "\n .label = Undertittel",
        "supplier-admin-pos-settings-template-companyLogo-field-label": "\n .label = Last opp firmalogo:",
        "supplier-admin-pos-settings-template-companyLogo-info": "Bildetips: bakgrunnen bør være gjennomsiktig. Vi anbefaler et bilde på 180x180 px med logoen sentrert.",
        "supplier-admin-pos-settings-template-shortcuts-help-field": "Hjelp / vilkår og betingelser:",
        "supplier-admin-pos-settings-template-shortcuts-downloadApp-field": "Last ned GoPay-appen:",
        "supplier-admin-pos-settings-template-frontpage-layout": "Forsidelayout",
        "supplier-admin-pos-settings-template-select-theme-style": "Velg temastil:",

        // Supplier > Admin > POS settings > General
        "supplier-admin-pos-settings-general-submit-button": "Lagre",
        "supplier-admin-pos-settings-general-defaultLanguage-field-label": "\n .label = Standardspråk \n .helperText = Kan justeres på hver enhet.",
        "supplier-admin-pos-settings-general-posPrintingMode-field-label": "\n .label = Utskriftsmodus for kvittering",
        "supplier-admin-pos-settings-general-posPrintingMode-option-qr-only": "Kun QR-kode",
        "supplier-admin-pos-settings-general-posPrintingMode-option-auto": "Automatisk utskrift",
        "supplier-admin-pos-settings-general-posPrintingMode-option-manually": "Manuell utskrift",
        "supplier-admin-pos-settings-general-info": "Utskriftsmodus styrer hvordan kvitteringen gjøres tilgjengelig for kunden. “Automatisk utskrift” skriver automatisk ut en papirkvittering, mens “Manuell utskrift” lar brukeren skrive ut en papirkvittering eller skanne en QR-kode for å få en digital kvittering. Velg “Kun QR-kode” hvis du ønsker et papirløst POS-system.",
        "supplier-admin-pos-settings-general-configuration-for-supporters": "Innstillinger for supportmedarbeidere",
        "supplier-admin-pos-settings-general-configuration-for-supporters-returnToHomeScreenDelay-field-label": "\n .label = Ventetid før retur til startskjermen",
        "supplier-admin-pos-settings-general-configuration-for-supporters-returnToHomeAfterPurchase-field-label": "\n .label = Gå tilbake til start etter kjøp",
        "supplier-admin-pos-settings-general-configuration-for-supporters-ms": "ms",

        // Supplier > Admin > Merchant Access
        "supplier-merchant-access-page-header": "\n .title = Salgssteder",
        "supplier-merchant-access-table-header-case-no": "Saksnr.",
        "supplier-merchant-access-table-header-name": "Navn",
        "supplier-merchant-access-table-header-address": "Adresse",
        "supplier-merchant-access-table-details-no-companies": "Det er ingen tilknyttede firmaer",
        "supplier-merchant-access-table-details-customers-title":"Kunder:",

        // Supplier > Admin > Acquiring
        "supplier-admin-pos-acquirer-page-header": "\n .title = Avtale om kortinnløsning",
        "supplier-admin-pos-acquirer-adyen-question":"Hvem er Adyen?",
        "supplier-admin-pos-acquirer-adyen-answer":"Adyen er vårt betalingsselskap for kredittkort med status som innløsende bank, som lar deg ta imot kredittkortbetalinger. Adyen er ansvarlig for å behandle betalinger for firmaet ditt. Før du kan ta imot betalingskort, må du søke om en avtale med Adyen.",
        "supplier-admin-pos-acquirer-adyen-read-more":"Les mer: <externalLink>{ $adyenWebsite }</externalLink>",
        "supplier-admin-pos-acquirer-status-title":"Status:",
        "supplier-admin-pos-acquirer-status-create-business-lines": "Ingen bransjekoder",
        "supplier-admin-pos-acquirer-status-info-create-business-lines": "Du må velge bransjene dine før du kan søke.",
        "supplier-admin-pos-acquirer-status-action-create-business-lines": "Legg til én eller flere bransjekoder nedenfor.",
        "supplier-admin-pos-acquirer-status-start": "Start søknad",
        "supplier-admin-pos-acquirer-status-info-start": "Du er nå klar til å starte søknaden hos innløseren.",
        "supplier-admin-pos-acquirer-status-action-start": "Start søknaden nedenfor.",
        "supplier-admin-pos-acquirer-status-pending": "Under behandling",
        "supplier-admin-pos-acquirer-status-info-pending": "Verifisering pågår.",
        "supplier-admin-pos-acquirer-status-action-pending": "Vent på at innløseren verifiserer søknaden din.",
        "supplier-admin-pos-acquirer-status-invalid": "Ugyldig",
        "supplier-admin-pos-acquirer-status-info-invalid": "Det er feil i opplysningene som er oppgitt.",
        "supplier-admin-pos-acquirer-status-action-invalid": "Rett opp søknaden din.",
        "supplier-admin-pos-acquirer-status-valid": "Godkjent",
        "supplier-admin-pos-acquirer-status-info-valid": "Søknaden din er godkjent.",
        "supplier-admin-pos-acquirer-status-check-valid":"Du er nå klar til å sette opp kredittkortbetalinger for salgsstedene dine.",
        "supplier-admin-pos-acquirer-status-rejected": "Avvist",
        "supplier-admin-pos-acquirer-status-info-rejected": "Innløseren har verifisert opplysningene, men har funnet grunn til ikke å samarbeide med organisasjonen din.",
        "supplier-admin-pos-acquirer-start-application-button": "Start søknad hos Adyen",
        "supplier-admin-pos-acquirer-continue-application-button": "Fortsett søknaden hos Adyen",
        "supplier-admin-pos-acquirer-status-no-payment-title": "Du har ingen avtale om kortinnløsning.",
        "supplier-admin-pos-acquirer-status-no-payment-error": "Ingen tilgjengelige innløsere",
        "supplier-admin-acquiring-terms-and-conditions-title": "Krav til handelsbetingelser",
        "supplier-admin-acquiring-terms-and-conditions-explanation": "For å fortsette må du godta innløserens krav til <requirementsLink>handelsbetingelsene</requirementsLink> dine. Disse betingelsene må være tydelig synlige for kundene dine på nettstedet ditt.",
        "supplier-admin-acquiring-terms-and-conditions-template-text": "Du kan laste ned malen vår for handelsbetingelser <templateLink>her</templateLink>.",
        "supplier-admin-acquiring-terms-and-conditions-label": "\n .label = Jeg godtar å oppfylle disse kravene.",
        "supplier-admin-acquiring-accept-terms-dialog-title": "Godta krav til handelsbetingelser",
        "supplier-admin-acquiring-accept-terms-dialog-description": "Er du sikker på at du vil godta å oppfylle kravene til handelsbetingelser?",
        "supplier-admin-acquiring-accept-terms-dialog-button": "Godta",
        "supplier-acquiring-industry-codes-accordion-industry-codes-title": "Bransjekoder",
        "supplier-acquiring-industry-codes-accordion-industry-codes-info-box": "\n .description = Hvis du søker for en kantine, velg bransjekode 722514 - kafeterier, grillbuffeter.",
        "supplier-acquiring-industry-codes-table-industry-code-column": "Bransjekode",
        "supplier-acquiring-industry-codes-table-description-column": "Beskrivelse",
        "supplier-acquiring-industry-codes-table-remove-action": "Fjern",
        "supplier-acquiring-industry-codes-add-industry-code": "Legg til ny bransjekode",
        "supplier-acquiring-industry-codes-info-text": "Bransjekoder beskriver virksomhetsområdene dine og avgjør hvilke typer varer du kan selge i butikkene dine. Noen bransjekoder krever godkjenning fra innløseren. Se alle bransjekoder <industryCodesLink>her</industryCodesLink>.",
        "supplier-acquiring-industry-codes-confirm-delete-dialog": "\n .title = Fjern bransjekode\n .message = Ønsker du å fjerne bransjekoden { $industryCode }?\n .buttonLabelSubmit = Fjern",
        "supplier-acquiring-bank-accounts-accordion-bank-accounts-title": "Bankkontoer",
        "supplier-acquiring-bank-accounts-table-bank-name-column": "Bank",
        "supplier-acquiring-bank-accounts-table-account-column": "Konto",
        "supplier-acquiring-bank-accounts-table-merchant-caseno-column": "Saksnr.",
        "supplier-acquiring-bank-accounts-table-merchant-column": "Salgssted",
        "supplier-acquiring-bank-accounts-table-status-column": "Status",
        "supplier-acquiring-bank-accounts-table-remove-action": "Fjern",
        "supplier-acquiring-bank-accounts-add-bank-account": "Legg til ny bankkonto",
        "supplier-acquiring-bank-accounts-info-text": "Hvis du vil at salg skal overføres til en egen bankkonto per salgssted, kan du legge til bankkontoen her. Se <guideLink>veiledningen</guideLink> for hvordan du legger til en ny bankkonto på Adyen-plattformen og deretter kobler bankkontoen til salgsstedet ditt.",
        "supplier-acquiring-bank-accounts-status-pending": "Under behandling",
        "supplier-acquiring-bank-accounts-status-invalid": "Ugyldig",
        "supplier-acquiring-bank-accounts-status-valid": "Gyldig",
        "supplier-acquiring-bank-accounts-status-rejected": "Avvist",
        "supplier-acquiring-bank-accounts-confirm-delete-dialog": "\n .title = Fjern bankkonto\n .message = Ønsker du å fjerne bankkontoen { $accountIdentifier }?\n .buttonLabelSubmit = Fjern",
        "supplier-acquiring-industry-codes-button-add": "Legg til",
        "supplier-acquiring-industry-codes-button-save": "Lagre",
        "supplier-acquiring-industry-codes-alert-title": " Hvis du legger til nye bransjekoder, kan status for avtalen din om kortinnløsning endres til under behandling dersom innløseren må verifisere.",

       // Supplier > Admin > Reconciliation
       "supplier-acquiring-reports": "Avstemming",
       "supplier-acquiring-reports-table-booked-time-column": "Bokført tid",
       "supplier-acquiring-reports-table-merchant-label": "\n .label = Salgssted",
       "supplier-acquiring-reports-table-adyen-account-label": "\n .label = Adyen-konto",
       "supplier-acquiring-reports-table-merchant-column": "Salgssted",
       "supplier-acquiring-reports-table-amount-column": "Beløp",

       // Supplier > Admin > Reconciliation > Fees
       "supplier-acquiring-fees-header": "\n .title = Innløsningsgebyrer",
       "supplier-acquiring-fees": "Innløsningsgebyrer",
       "supplier-acquiring-fees-table-order-id-column": "Ordre-ID",
       "supplier-acquiring-fees-table-psp-reference-column": "PSP-referanse",
       "supplier-acquiring-fees-table-available-date-column": "Tilgjengelig dato",
       "supplier-acquiring-fees-table-type-column": "Type",
       "supplier-acquiring-fees-table-select-filter-on-label": "Filtrer på",
       "supplier-acquiring-fees-table-select-filter-on-label-label": "\n .label = Filtrer på",
        "supplier-acquiring-fees-table-select-filter-on-item-booking-date": "Bokføringsdato",
        "supplier-acquiring-fees-table-select-filter-on-item-value-date": "Tilgjengelig dato",
       "supplier-acquiring-fees-table-type-mode-payment": "Betaling",
       "supplier-acquiring-fees-table-type-mode-transfer": "Overføring",
       "supplier-acquiring-fees-table-type-mode-refund": "Refusjon",
       "supplier-acquiring-fees-table-number-of-transactions": "\n .title = Antall transaksjoner",
       "supplier-acquiring-fees-table-info-banner": "\n .description = Data for denne rapporten blir tilgjengelig dagen etter, så du kan ikke se transaksjoner for i dag.",

       // Supplier > Admin > Reconciliation > Bank transfers
       "supplier-acquiring-bank-transfers-header": "\n .title = Bankoverføringer",
       "supplier-acquiring-bank-transfers": "Bankoverføringer",
       "supplier-acquiring-bank-transfers-table-transfer-id-column": "Overførings-ID",
       "supplier-acquiring-bank-transfers-table-available-time-column": "Tilgjengelig tid",
       "supplier-acquiring-bank-transfers-table-bank-account-column": "Bankkonto",
       "supplier-acquiring-bank-transfers-table-details-menu-item": "Detaljer",
       "supplier-acquiring-bank-transfers-table-number-of-transfers": "\n .title = Antall overføringer",
       "supplier-acquiring-bank-transfers-table-info-banner": "\n .description = Data for denne rapporten blir tilgjengelig dagen etter, så du kan ikke se bankoverføringer for i dag eller kommende overføringer.",
        "supplier-acquiring-bank-transfers-table-details-table-order-id-column": "Ordre-ID",
        "supplier-acquiring-bank-transfers-table-details-table-psp-reference-column": "PSP-referanse",
        "supplier-acquiring-bank-transfers-table-details-table-booked-column": "Bokført",
        "supplier-acquiring-bank-transfers-table-details-table-available-column": "Tilgjengelig",
        "supplier-acquiring-bank-transfers-table-details-table-gross-column": "Brutto",
        "supplier-acquiring-bank-transfers-table-details-table-net-column": "Netto",
        "supplier-acquiring-bank-transfers-table-details-table-fee-column": "Gebyr",
        "supplier-acquiring-bank-transfers-details-dialog-title": "\n .dialogTitle = Overføringsdetaljer\n .subtitle = Periode: { $periodStart} - { $periodEnd }",
        "supplier-acquiring-bank-transfers-details-dialog-title-no-start-date": "Avtalestart",
        "supplier-acquiring-bank-transfers-details-dialog-number-of-orders": "\n .title = Antall ordrer",
        "supplier-acquiring-bank-transfers-details-dialog-table-gross-total": "\n .title = Brutto totalt",
        "supplier-acquiring-bank-transfers-details-dialog-table-fee-total": "\n .title = Gebyr totalt",
        "supplier-acquiring-bank-transfers-details-dialog-table-net-total": "\n .title = Netto totalt",

       // Supplier > Admin > Reconciliation > Balance
       "supplier-overview-header": "\n .title = Saldo",
       "supplier-overview-table-amount": "Beløp",
       "supplier-overview-table-account": "Konto",
       "supplier-overview-table-view-details": "Vis detaljer",
       "supplier-overview-balance-details-dialog": "\n .dialogTitle = Saldodetaljer\n .subtitle = Periode: { $periodStart} - { $periodEnd }",
       "supplier-overview-balance-details-dialog-select-order": "Vis ordrer",
       "supplier-overview-balance-details-dialog-select-order-label": "\n .label = Vis ordrer",
       "supplier-overview-balance-details-dialog-select-order-mode-net-sales": "Nettoomsetning",
       "supplier-overview-balance-details-dialog-select-order-mode-bank-transfers": "Bankoverføringer",
       "supplier-overview-balance-details-dialog-select-order-mode-balance": "Saldo",
       "supplier-overview-balance-details-dialog-compact-view-label": "Vis bruttoomsetning og gebyrer",
       "supplier-overview-balance-details-dialog-table-order-id-column": "Ordre-ID",
       "supplier-overview-balance-details-dialog-table-rsp-reference-column": "PSP-referanse",
       "supplier-overview-balance-details-dialog-table-booked-column": "Bokført",
       "supplier-overview-balance-details-dialog-table-available-column": "Tilgjengelig",
       "supplier-overview-balance-details-dialog-table-gross-column": "Brutto",
       "supplier-overview-balance-details-dialog-table-fee-column": "Gebyr",
       "supplier-overview-balance-details-dialog-table-net-column": "Netto",
       "supplier-overview-balance-details-dialog-table-effective-column": "Effektivt beløp",
       "supplier-overview-balance-details-dialog-table-type-column": "Type",
       "supplier-overview-balance-details-dialog-table-payment-type-bank-transfer": "Utbetaling",
       "supplier-overview-balance-details-dialog-table-payment-type-previous-revenue": "Tidligere innbetalt",
       "supplier-overview-balance-details-dialog-table-payment-type-deferred-revenue": "Forskuttert gebyr",
       "supplier-overview-balance-details-dialog-table-payment-type-normal-revenue": "Inntekt",
       "supplier-overview-balance-details-dialog-table-payment-type-accrued-revenue": "Opptjent",
       "supplier-overview-balance-details-dialog-number-of-orders": "\n .title = Antall ordrer",
       "supplier-overview-balance-details-dialog-table-effective-total": "\n .title = Totalt effektivt beløp",
       "supplier-overview-balance-details-dialog-table-gross-total": "\n .title = Brutto totalt",
       "supplier-overview-balance-details-dialog-table-fee-total": "\n .title = Gebyr totalt",
       "supplier-overview-balance-details-dialog-table-net-total": "\n .title = Netto totalt",

        // Supplier > Admin > Merchants
        "supplier-admin-merchants-header": "\n .title = Salgssteder",
        "supplier-admin-merchants-create-button": "Opprett ny",
        "supplier-admin-merchants-table-edit-button": "Rediger",
        "supplier-admin-merchants-table-delete-button": "Slett",
        "supplier-admin-merchants-table-delete-modal-title": "salgssted",
        "supplier-admin-merchants-table-reg-no-column": "Reg.nr.",
        "supplier-admin-merchants-table-merchant-column": "Salgssted",
        "supplier-admin-merchants-table-connected-shops": "Butikker:",
        "supplier-admin-merchants-table-connected-customers": "Kunder:",
        "supplier-admin-merchants-table-connected-devices": "Enheter:",
        "supplier-admin-merchant-create-title": "\n .title = Opprett salgssted",
        "supplier-admin-merchant-edit-title": "\n .title = Rediger salgssted",
        "supplier-admin-merchants-save-button": "Lagre",
        "create-or-edit-supplier-admin-merchant-field-caseNumber": "\n .label = Reg.nr.\n .placeholder = Skriv inn reg.nr.\n .helperText = Ditt interne referansenummer for dette salgsstedet",
        "create-or-edit-supplier-admin-merchant-field-name": "\n .label = Navn\n .placeholder = Skriv inn navn på salgssted",
        "create-or-edit-supplier-admin-merchant-field-street": "\n .label = Gate\n .placeholder = Skriv inn gate",
        "create-or-edit-supplier-admin-merchant-field-streetNumber": "\n .label = Gatenummer\n .placeholder = Skriv inn gatenummer",
        "create-or-edit-supplier-admin-merchant-field-postalCode": "\n .label = Postnummer\n .placeholder = Skriv inn postnummer",
        "create-or-edit-supplier-admin-merchant-field-city": "\n .label = By\n .placeholder = Skriv inn by",
        "create-or-edit-supplier-admin-merchant-field-country": "\n .label = Land",
        "create-or-edit-supplier-admin-merchant-contact-details-title": "\n .title = Kontaktopplysninger",
        "create-or-edit-supplier-admin-merchant-country-denmark-item": "Danmark",
        "create-or-edit-supplier-admin-merchant-contact-details-info": "Kontaktopplysninger vil være offentlige for kundene.",
        "create-or-edit-supplier-admin-merchant-field-contact-details-name": "\n .label = Navn\n .placeholder = Skriv inn navn",
        "create-or-edit-supplier-admin-merchant-field-contact-details-email": "\n .label = E-post\n .placeholder = Skriv inn e-post",
        "create-or-edit-supplier-admin-merchant-field-contact-details-phone": "\n .label = Telefonnummer\n .placeholder = Skriv inn telefonnummer",
        "create-or-edit-supplier-admin-merchant-field-is-required": "Feltet er påkrevd",
        "create-or-edit-supplier-admin-merchant-credit-card-payments-title": "\n .title = Kredittkortbetalinger",
        "create-or-edit-supplier-admin-merchant-status-approved": "Aktiv",
        "create-or-edit-supplier-admin-merchant-status-no-registered-bank-account": "Ingen registrert bankkonto",
        "create-or-edit-supplier-admin-merchant-status-no-registered-bank-account-description": "Registrer en bankkonto for innløsningsavtalen din <retryLink>her.</retryLink>",
        "create-or-edit-supplier-admin-merchant-status-no-registered-bank-account-description-readonly": "Registrer en bankkonto for innløsningsavtalen din.",
        "create-or-edit-supplier-admin-merchant-status-invalid": "Avtalen er ugyldig",
        "create-or-edit-supplier-admin-merchant-status-invalid-description": "Rett opp søknaden din om innløsningsavtale <retryLink>her.</retryLink>",
        "create-or-edit-supplier-admin-merchant-status-invalid-description-readonly": "Rett opp søknaden din om innløsningsavtale.",
        "create-or-edit-supplier-admin-merchant-status-pending": "Avtale under behandling",
        "create-or-edit-supplier-admin-merchant-status-pending-description": "Vent til innløseren er ferdig med å behandle søknaden din om innløsningsavtale.",
        "create-or-edit-supplier-admin-merchant-status-no-payment-setup": "Ingen betalingsoppsett",
        "create-or-edit-supplier-admin-merchant-status-no-payment-setup-description": "Sett opp kredittkortbetalinger for dette salgsstedet for å begynne å motta betalinger.",
        "create-or-edit-supplier-admin-merchant-status-bank-account-pending": "Bankkonto under behandling",
        "create-or-edit-supplier-admin-merchant-status-bank-account-pending-description": "Vent til innløseren er ferdig med å verifisere bankkontoen din.",
        "create-or-edit-supplier-admin-merchant-acquirer": "Innløser:",
        "create-or-edit-supplier-admin-merchant-acquirer-type-adyen-pos": "Adyen",
        "create-or-edit-supplier-admin-merchant-acquirer-type-adyen": "Adyen",
        "create-or-edit-supplier-admin-merchant-bank-details": "Bankopplysninger:",
        "create-or-edit-supplier-admin-merchant-industry-codes": "Bransjekoder:",
        "create-or-edit-supplier-admin-merchant-status-action-button-setup": "Oppsett",
        "create-or-edit-supplier-admin-merchant-status-action-button-edit": "Rediger",
        "create-or-edit-supplier-admin-merchant-dialog-title": "Oppsett av kredittkortbetaling",
        "create-or-edit-supplier-admin-merchant-dialog-field-acquiring-agreement": "\n .label = Innløsningsavtale",
        "create-or-edit-supplier-admin-merchant-dialog-field-sales-channels": "\n .label = Salgskanal",
        "create-or-edit-supplier-admin-merchant-dialog-field-bank-account": "\n .label = Bankkonto",
        "create-or-edit-supplier-admin-merchant-dialog-field-bank-account-helper": "Velg bankkontoen som salget skal overføres til. Du vil bare se bankkontoer som er opprettet i Adyen-plattformen. For å legge til en ny bankkonto, se <retryLink>veiledning.</retryLink>",
        "create-or-edit-supplier-admin-merchant-dialog-field-industry-codes": "\n .label = Bransjekoder",
        "create-or-edit-supplier-admin-merchant-dialog-field-default-currency": "\n .label = Standardvaluta",
        "create-or-edit-supplier-admin-merchant-dialog-save-button": "Lagre",

        //Supplier > Admin > T&C
        "supplier-admin-settings-terms-and-conditions": "\n .title = Vilkår og betingelser",
        "supplier-admin-settings-terms-and-conditions-list-create-button": "Opprett ny",
        "supplier-admin-settings-terms-and-conditions-create-button": "Opprett",
        "supplier-admin-settings-terms-and-conditions-update-button": "Oppdater",


        // TERMS AND CONDITIONS CREATE
        "supplier-terms-and-conditions-alert-title": "Vilkår og betingelser",
        "supplier-terms-and-conditions-alert-subtitle1": "Det er ditt eget ansvar å sørge for at vilkårene og betingelsene oppfyller gjeldende krav.",
        "supplier-terms-and-conditions-alert-subtitle2": "Les om Adyens påkrevde T&C, som du må overholde, <externalLink>her</externalLink>.",
        "supplier-terms-and-conditions-alert-subtitle3": "Last ned vår T&C-mal: <externalLinkDA>Dansk</externalLinkDA> | <externalLinkEN>Engelsk</externalLinkEN>.",
        "supplier-terms-and-conditions-dropdown-english": "Engelsk",
        "supplier-terms-and-conditions-dropdown-danish": "Dansk",
        "supplier-terms-and-conditions-name-label": "\n .label = Navn",
        "supplier-terms-and-conditions-language-label": "\n .label = Språk",
        "supplier-terms-and-conditions-type-label": "\n .label = Type",
        "supplier-terms-and-conditions-dropdown-pos": "POS",
        "supplier-terms-and-conditions-type-ecom": "E-handel",
        "supplier-terms-and-conditions-aside-settings": "\n .title = Innstillinger",
        "supplier-terms-and-conditions-aside-active": "Aktiv: ",
        "supplier-terms-and-conditions-aside-history": "\n .title = Historikk",
        "supplier-terms-and-conditions-aside-version": "Versjon: ",
        "supplier-terms-and-conditions-aside-created": "Opprettet: ",
        "supplier-terms-and-conditions-aside-updated": "Oppdatert: ",
        "terms-and-conditions-error-label-name": "Navn",
        "terms-and-conditions-error-label-type": "Type",
        "terms-and-conditions-error-label-language": "Språk",
        "terms-and-conditions-error-label-text": "Tekst",


        // TERMS AND CONDITIONS TABLE GENERAL
        "terms-and-conditions-table-header-name": "Navn",
        "terms-and-conditions-table-header-language": "Språk",
        "terms-and-conditions-table-header-name-type": "Type",
        "terms-and-conditions-table-header-name-status": "Status",
        "terms-and-conditions-table-button-edit":"Rediger",
        "terms-and-conditions-table-button-delete":"Slett",
        "terms-and-conditions-table-button-approval":"Godkjenning",
        "terms-and-conditions-table-status-active":"Aktiv",
        "terms-and-conditions-table-status-inactive":"Inaktiv",
        "terms-and-conditions-table-status-pending":"Under behandling",


        "terms-and-conditions-modal-button-delete-label": "Slett",
        "terms-and-conditions-modal-question": "Er du sikker på at du vil slette",
        "terms-and-conditions-modal-title": "Vilkår og betingelser",


        // Supplier > Admin > Administrators
        "supplier-users-page-header": "\n .title = Administratorer",
        "supplier-users-suppliers-tab-title": "Leverandøradministratorer",
        "supplier-users-merchants-tab-title": "Salgsstedsadministratorer",
        "supplier-users-table-merchant-column": "Salgssted",
        "supplier-users-create-admin-button": "Opprett ny",


        // Supplier > Admin > Account > Company Account
        "supplier-update-account-title":"\n .title = Leverandørkonto",
        "supplier-update-account-update-button":"Oppdater",
        "supplier-update-account-nav-item-home":"Hjem",
        "supplier-update-account-nav-item-account":"Konto",
        "supplier-update-account-registration-number-label":"\n .label = Registreringsnummer",
        "supplier-update-account-error-label-registration-number":"Registreringsnummer",

        // Supplier > Admin > Account > GDPR
        "supplier-account-gdpr-title":"\n .title = GDPR",
        "supplier-account-gdpr-tab-documents":"Dokumenter",
        "supplier-account-gdpr-tab-export":"Eksport",
        "supplier-account-gdpr-export-title":"Brukereksport",
        "supplier-account-gdpr-export-info":"\n .description = Denne funksjonen lar deg eksportere administratorer og/eller brukere fra alle administrative enheter, inkludert leverandør, salgssted, virksomhet, leietaker og servicesenter. For å laste ned brukere fra andre administrative enheter må du registrere ett eller flere e-postdomener som er knyttet til virksomheten din. Disse domenene brukes til å identifisere virksomhetens brukere. Hvis virksomheten din ikke har noen verifiserte domener, kan du ikke laste ned brukere fra andre enheter. For hjelp med domeneverifisering, ta kontakt med supportteamet vårt.",
        "supplier-account-gdpr-export-user-types-select-item-user": "Brukere",
        "supplier-account-gdpr-export-user-types-select-item-administrator": "Administratorer",

        "supplier-account-gdpr-export-user-types-select-label":"\n .label = Brukertyper",
        "supplier-account-gdpr-export-user-types-select-input-label":"Brukertyper",
        "supplier-account-gdpr-export-user-deletion-period-select-input-label":"Periode for sletting av brukere",
        "supplier-account-gdpr-export-user-deletion-period-select-label":"\n .label = Periode for sletting av brukere",
        "supplier-account-gdpr-export-user-deletion-period-select-item-days-180":"180 dager",
        "supplier-account-gdpr-export-user-deletion-period-select-item-days-90":"90 dager",
        "supplier-account-gdpr-export-user-deletion-period-select-item-days-30":"30 dager",
        "supplier-account-gdpr-export-user-deletion-period-select-item-days-7":"7 dager",
        "supplier-account-gdpr-export-include-deleted-switch-label":"\n .label = Inkluder slettede brukere",
        "supplier-account-gdpr-export-exported-domains-subtitle":"Verifiserte domener som eksporteres:",
        "supplier-account-gdpr-export-no-domains-registered":"Ingen verifiserte virksomhetsdomener er registrert.",
        "supplier-account-gdpr-export-export-button":"Eksporter til CSV",



        // --- Support ---

        // Support > Admin > Features
        "support-admin-features-header": "\n .title = Funksjoner",
        "support-admin-features-table-header-name": "Navn",
        "support-admin-features-table-header-plan": "Plan",
        "support-admin-features-table-plan-none": "Ingen",
        "support-admin-features-table-plan-professional": "Professional",
        "support-admin-features-table-plan-enterprise": "Enterprise",
        "support-admin-features-table-header-status": "Status",
        "support-admin-features-table-header-enabled": "Aktivert",
        "support-admin-features-table-action-edit": "Rediger",
        "support-admin-features-status-label-new": "\n .label = NY",
        "support-admin-features-status-label-beta": "\n .label = BETA",
        "support-admin-features-status-new": "NY",
        "support-admin-features-status-beta": "BETA",

         // Support > Admin > Features > Edit
        "support-admin-feature-edit-header": "\n .title = Rediger funksjon",
        "support-admin-feature-edit-save-button": "Lagre",
        "support-admin-feature-edit-nav-item-feature": "Rediger funksjon",
        "support-admin-feature-edit-programmatic-id-label": "\n .label = Programmatisk ID",
        "support-admin-feature-edit-name-label": "\n .label = Navn",
        "support-admin-feature-edit-plan-label": "\n .label = Plan",
        "support-admin-feature-edit-status-label": "\n .label = Status",
        "support-admin-feature-edit-enabled-label": "Aktivert:",
        "support-admin-feature-edit-settings-title": "\n .title = Innstillinger",

        // Support > Admin > GDPR
        "support-nav-item-gdpr": "GDPR",
        "support-admin-gdpr-page-header": "\n .title = GDPR",
        "support-admin-gdpr-breadcrumb": "GDPR",
        "support-admin-gdpr-administrators-title": "Administratorer",
        "support-admin-gdpr-user-type-label": "\n .label = Brukertype",
        "support-admin-gdpr-user-type-select-item-merchant-admins": "Salgsstedsadministratorer",
        "support-admin-gdpr-user-type-select-item-supplier-admins": "Leverandøradministratorer",
        "support-admin-gdpr-user-type-select-item-company-admins": "Firmaadministratorer",
        "support-admin-gdpr-user-type-select-item-company-agreement-owners": "Avtaleeiere for virksomheter",
        "support-admin-gdpr-include-active-users": "Inkluder aktive brukere",
        "support-admin-gdpr-include-inactive-users": "Inkluder inaktive brukere",
        "support-admin-gdpr-export-button": "Eksporter kontaktliste",
        "support-admin-gdpr-export-button-label": "Eksporter kontaktliste",
        "support-admin-gdpr-export-button-exporting": "Eksporterer...",

        // Support > Reports > Entities
        "support-entity-header-title" : "\n .title = Entiteter",
        "support-entity-header-menu-button-create": "Opprett",
        "support-entity-header-menu-button-create-supplier": "Opprett leverandør",
        "support-entity-header-menu-button-create-merchant": "Opprett salgssted",
        "support-entity-header-menu-button-create-company": "Opprett virksomhet",
        "support-entity-header-menu-button-create-tenant": "Opprett leietaker",
        "support-entity-header-nav-item-home" : "Hjem",
        "support-entity-header-nav-item-entities" : "Entiteter",
        "support-entity-table-header-id": "ID",
        "support-entity-table-header-name": "Navn",
        "support-entity-table-header-address": "Adresse",
        "support-entity-table-header-type": "Type",
        "support-entity-table-header-status": "Status",
        "support-entity-table-button-details": "Detaljer",
        "support-entity-table-button-edit": "Rediger",
        "support-entity-table-button-delete": "Slett",
        "support-entity-table-status-active": "Aktiv",
        "support-entity-table-status-inactive": "Inaktiv",
        "support-entity-confirm-delete-entity-dialog": "\n .typeOfEntity = entitet",
        "support-entity-table-cell-name-agreement-owner": "Avtaleeier",
        "support-entity-table-cell-name-reg-no": "Reg.nr.:",
        "support-entity-table-type-supplier": "\n .label = Leverandør",
        "support-entity-table-show-inactive": "\n .label = Vis inaktive",
        "support-entity-table-type-merchant": "\n .label = Salgssted",
        "support-entity-table-type-company": "\n .label = Virksomhet",
        "support-entity-table-type-tenant": "\n .label = Leietaker",
        "support-entity-table-type-service-center": "\n .label = Servicesenter",
        "support-entity-table-type-user": "\n .label = Bruker",
        "support-entity-details-connected-merchants": "\n .title = Tilknyttede salgssteder",
        "support-entity-details-connected-companies": "\n .title = Tilknyttede virksomheter",
        "support-entity-details-connected-suppliers": "\n .title = Tilknyttede leverandører",
        "support-entity-details-connected-devices": "\n .title = Tilkoblede enheter",
        "support-entity-details-id": "ID: { $id }",
        "support-entity-table-entity-type-label":"Entitetstype",
        "support-entity-table-entity-type-select-item-all":"Alle",
        "support-entity-table-entity-type-select-item-supplier":"Kantineoperatør",
        "support-entity-table-entity-type-select-item-merchant":"Salgssted",
        "support-entity-table-entity-type-select-item-company":"Virksomhet",
        "support-entity-table-entity-type-select-item-service-center":"Servicesenter",
        "support-create-entity-error-label-company-invalid-type":"Ugyldig type",
        "support-create-entity-error-label-company-type":"Type",
        "support-create-entity-error-label-system-owner":"Avtaleeier",
        "support-create-entity-error-label-company-number":"Virksomhetsnummer",
        "support-create-entity-error-label-ean-number":"EAN-nummer",
        "support-create-entity-error-label-invoice-type":"Fakturatype",
        "support-create-entity-error-label-invoice-email":"E-post",
        "support-create-entity-error-label-attention":"Att.",
        "support-create-entity-error-label-debitot-no":"Debitornummer",
        "support-create-entity-error-label-reminder-email":"E-post",
        "support-create-entity-error-label-po-number":"Innkjøpsordrenummer",
        "support-create-entity-error-label-company-name":"Firmanavn",
        "support-create-entity-error-label-address":"Adresse",
        "support-create-entity-error-label-country":"Land",
        "support-create-entity-error-label-postal-code":"Postnummer",
        "support-create-entity-error-label-city":"By",
        "support-create-entity-error-label-contact-person":"Kontaktperson",
        "support-create-entity-error-label-email":"E-post",
        "support-create-entity-error-label-telephone":"Telefon",
        "support-create-entity-agreement-owner-subtitle":"Avtaleeier",
        "support-create-entity-ean-number-label":"\n .label = EAN-nummer",
        "support-create-entity-address1-label":"\n .label = Adresselinje 1\n .placeholder = Gatenavn og husnummer",
        "support-create-entity-address2-label":"\n .label = Adresselinje 2\n .placeholder = Etasje, leilighetsnr. osv.",
        "support-create-entity-postal-code-label":"\n .label = Postnummer",
        "support-create-entity-city-label":"\n .label = By",
        "support-create-entity-contact-person-label":"\n .label = Kontaktperson",
        "support-create-entity-email-label":"\n .label = E-post",
        "support-create-entity-telephone-label": "\n .label = Telefon",
        "support-create-entity-type-choose-label":"\n .label = Velg",
        "support-create-entity-dropdown-choose-yes":"Ja",
        "support-create-entity-dropdown-choose-no":"Nei",
        "support-create-entity-alert-title":"\n .title = En avtaleeier eier avtalen med FacilityNet og mottar tilhørende fakturaer. Av denne grunn trenger vi fakturaopplysninger for avtaleeiere.",
        "support-create-entity-subscription-details-subtitle": "Abonnementsopplysninger",
        "support-create-entity-subscription-details-field-implementationDeadline": "\n .label = Frist for implementering",
        "support-create-entity-subscription-details-alert-title": "\n .title = Dette er datoen kunden ønsker at systemet skal settes i produksjon. Det betyr at onboarding, intern testing og en eventuell prøveperiode må være avsluttet før denne datoen.",
        "support-create-entity-contact-details-subtitle":"Kontaktopplysninger",
        "support-create-entity-invoice-details-subtitle":"Fakturaopplysninger",
        "support-create-entity-send-invoice-to-label":"\n .label = Send faktura til",
        "support-create-entity-dropdown-ean-number":"EAN-nummer",
        "support-create-entity-dropdown-email":"E-post",
        "support-create-entity-debitor-number-label":"\n .label = Debitornummer\n .helperText = Dette identifiserer debitor i FacilityNets regnskapssystem.",
        "support-create-entity-invoice-email-label":"\n .label = E-post",
        "support-create-entity-attention-label":"\n .label = Att.",
        "support-create-entity-reminder-email-label":"\n .label = E-post for påminnelser / kontoutskrifter",
        "support-create-entity-po-number-label":"\n .label = Innkjøpsordrenummer",
        "support-create-entity-type-label":"\n .label = Type",
        "support-create-entity-country-label":"\n .label = Land",
        "support-create-entity-dropdown-country-denmark":"Danmark",
        "support-create-entity-dropdown-private-company":"Privat virksomhet",
        "support-create-entity-dropdown-private-person":"Privatperson",
        "support-create-entity-dropdown-public-limited-company":"Aksjeselskap",
        "support-create-entity-aside-history": "\n .title = Historikk",
        "support-create-entity-aside-version": "Versjon:",
        "support-create-entity-aside-created": "Opprettet:",
        "support-create-entity-aside-updated": "Oppdatert:",

        // ---  Support Reports --- Messages > Email
        "support-messages-email-title": "\n .title = E-post",
        "support-messages-email-subject-label":"\n .label = E-postemne",
        "support-messages-email-receiver-label":"\n .label = Mottaker \n .placeholder = Skriv inn e-post eller bruker-ID",
        "support-messages-email-table-header-receiver":"Mottaker",
        "support-messages-email-table-header-subject":"Emne",
        "support-messages-email-table-header-sent-time":"Sendt tidspunkt",
        "support-messages-email-table-header-status":"Status",
        "support-messages-email-table-status-sent":"Sendt",
        "support-messages-email-table-status-not-sent":"Ikke sendt",
        "support-messages-email-table-cell-subject-created":"Opprettet: { $time }",
        "support-messages-email-resend-button":"Send på nytt",
        "support-messages-email-export-button":"Eksporter",
        "support-messages-email-details-status-label":"Status:",
        "support-messages-email-details-created-label":"Opprettet:",
        "support-messages-email-details-sent-time-label":"Sendt tidspunkt:",
        "support-messages-email-details-error-message-label":"Feilmelding:",
        "support-messages-email-details-from-label":"Fra:",
        "support-messages-email-details-subject-label":"Emne:",
        "support-messages-email-details-to-label":"Til:",
        "support-messages-email-details-cc-label":"Kopi:",
        "support-messages-email-details-bcc-label":"Blindkopi:",
        "support-messages-email-details-resend-email-button":"Send e-post på nytt",
        "support-messages-email-details-resend-email-title":"Send e-post på nytt",
        "support-messages-email-details-sent-button":"Sendt",
        "support-messages-email-resent-dialog-title":"Bekreft ny sending av e-poster",
        "support-messages-email-resent-dialog-subtitle":"Er du sikker på at du vil sende { $itemsAmount } e-poster på nytt?",
        "support-messages-email-resent-dialog-cancel-button":"Nei",
        "support-messages-email-resent-dialog-submit-button":"Ja",

        // ---  Support Reports --- Messages > SMS
        "support-messages-sms-title": "\n .title = SMS",
        "support-messages-sms-receiver-label":"\n .label = Mottaker",
        "support-messages-sms-text-body-label":"\n .label = Tekstinnhold",
        "support-messages-sms-table-header-receiver":"Mottaker",
        "support-messages-sms-table-header-created":"Opprettet",
        "support-messages-sms-table-header-sent":"Sendt",
        "support-messages-sms-table-header-status":"Status",
        "support-messages-sms-table-status-sent":"Sendt",
        "support-messages-sms-table-status-not-sent":"Ikke sendt",
        "support-messages-sms-export-button":"Eksporter",
        "support-messages-sms-details-status-label":"Status:",
        "support-messages-sms-details-id-label":"id:",
        "support-messages-sms-details-created-label":"Opprettet:",
        "support-messages-sms-details-sent-time-label":"Sendt tidspunkt:",
        "support-messages-sms-details-error-message-label":"Feilmelding:",
        "support-messages-sms-details-text-message-label":"Tekstmelding:",
        "support-messages-sms-details-from-label":"Fra:",
        "support-messages-sms-details-to-label":"Til:",


        // ---  Support Reports --- Accounting > Subscriptions
        "support-subscriptions-header": "\n .title = Abonnementer",
        "support-subscriptions-table-order-id-column": "Ordre-ID",
        "support-subscriptions-table-employee-column": "Ansatt",
        "support-subscriptions-table-subscribed-column": "Påmeldt",
        "support-subscriptions-table-unsubscribed-column": "Avmeldt",
        "support-subscriptions-table-payment-column": "Betaling",
        "support-subscriptions-table-amount-column": "Beløp",
        "support-subscriptions-table-cancel-subscription": "Si opp abonnement",
        "support-subscriptions-table-details": "Detaljer",
        "support-subscriptions-table-filters-merchant-title":"\n .title = Salgssted",
        "support-subscriptions-table-filters-customer-title":"\n .title = Kunde",
        "support-subscriptions-table-filters-payment-title":"\n .title = Betaling",

        // ---  Support Reports --- Accounting > Meeting Service
        "support-accounting-meeting-service-header": "\n .title = Møteservering",
        "support-accounting-meeting-service-table-order-id-column": "Ordre-ID",
        "support-accounting-meeting-service-table-booked-date-column": "Bokføringsdato",
        "support-accounting-meeting-service-table-delivery-time-column": "Leveringstid",
        "support-accounting-meeting-service-table-employee-column": "Bestiller",
        "support-accounting-meeting-service-table-status":"Status",
        "support-accounting-meeting-service-table-amount-column": "Beløp (DKK)",
        "support-accounting-meeting-service-table-show-receipt": "Vis kvittering",
        "support-accounting-meeting-service-table-floating-action-bar-export": "\n .title = Eksporter",


        // ---  Support Reports --> Printer Queue
        "support-printer-queue-title": "\n .title = Skriverkø",
        "support-printer-queue-merchant-label":"\n .label = Salgssted",
        "support-printer-queue-order-id-label":"\n .label = Ordre-ID",
        "support-printer-queue-table-header-id":"Id",
        "support-printer-queue-table-header-created":"Opprettet",
        "support-printer-queue-table-header-print-at":"Skrives ut kl.",
        "support-printer-queue-table-header-device-name":"Enhetsnavn",
        "support-printer-queue-table-header-order-id":"Ordre-ID",
        "support-printer-queue-table-header-status":"Status",
        "support-printer-queue-table-device-group":" Gruppe: ",
        "support-printer-queue-table-status-printed":"Skrevet ut",
        "support-printer-queue-table-status-queue":"Kø",
        "support-printer-queue-table-raw-receipt-action":"Rå kvittering",
        "support-printer-details-status-label":"Status:",
        "support-printer-details-created-label":"Opprettet:",
        "support-printer-details-printed-at-label":"Skrevet ut kl.:",
        "support-printer-details-device-group-subtitle":"Enhetsgruppe:",
        "support-printer-details-device-subtitle":"Enhet:",
        "support-printer-details-id-label":"ID:",
        "support-printer-details-name-label":"Navn:",
        "support-printer-details-mime-type-label":"Mime-type:",
        "support-printer-details-priority-label":"Prioritet:",
        "support-printer-details-job-token-label":"Jobbtoken:",


         // ---  Support Reports --- Orders > POS
        "support-orders-pos-title": "\n .title = POS",
        "support-orders-pos-order-id-label":"\n .label = Ordre-ID",
        "support-orders-pos-email-label":"\n .label = E-post",
        "support-orders-pos-table-header-order-id":"Ordre-ID",
        "support-orders-pos-table-header-transaction-time":"Transaksjonstid",
        "support-orders-pos-table-header-customer":"Kunde",
        "support-orders-pos-table-header-merchant":"Salgssted",
        "support-orders-pos-table-header-amount":"Beløp",
        "support-orders-pos-table-action-show-receipt":"Vis kvittering",
        "support-orders-pos-table-action-show-order-details":"Vis ordredetaljer",



        // --- Support entity---
        "support-create-supplier-title": "\n .title = Opprett leverandør",
        "support-update-supplier-title": "\n .title = Oppdater leverandør",
        "support-create-supplier-create-button": "Opprett",
        "support-create-supplier-update-button": "Oppdater",
        "support-create-supplier-nav-item-home": "Hjem",
        "support-create-supplier-nav-item-entities": "Entiteter",
        "support-create-supplier-nav-item-create-supplier": "Opprett leverandør",
        "support-create-supplier-nav-item-update-supplier": "Oppdater leverandør",
        "support-create-supplier-aside-settings": "\n .title = Innstillinger",
        "support-create-supplier-aside-active": "Aktiv:",
        "support-create-supplier-company-number-label":"\n .label = Virksomhetsnummer",
        "support-create-supplier-company-name-label":"\n .label = Firmanavn",
        "support-create-subscription-status-title": "\n .title = Abonnementsstatus",
        "support-create-supplier-subscription-status": "Status",
        "support-create-supplier-subscription-status-mode-creating": "Opprettes",
        "support-create-supplier-subscription-status-mode-onboarding": "Onboarding",
        "support-create-supplier-subscription-status-mode-trial": "Prøveperiode",
        "support-create-supplier-subscription-status-mode-live": "LIVE",
        "support-create-supplier-subscription-status-mode-unsubscribing": "Avmeldes",
        "support-create-supplier-subscription-status-mode-unsubscribed": "Avmeldt",
        "support-create-supplier-subscription-status-created": "Opprettet",
        "support-create-supplier-subscription-status-implementation-deadline": "Implementeringsfrist",
        "support-create-supplier-subscription-status-onboarding-email-sent": "Onboarding-e-post sendt",
        "support-create-supplier-subscription-status-trial-started": "Prøveperiode startet",
        "support-create-supplier-subscription-status-subscription-started": "Abonnement startet",
        "support-create-supplier-subscription-status-subscription-ending": "Abonnement avsluttes",
        "support-create-supplier-subscription-status-button-mode-creating": "Send onboarding-artikler",
        "support-create-supplier-subscription-status-button-mode-onboarding": "Fullfør onboarding",
        "support-create-supplier-subscription-status-button-mode-trial": "Gå live",
        "support-create-supplier-subscription-status-button-mode-live": "Avslutt abonnement",
        "support-create-supplier-subscription-status-button-mode-unsubscribing": "Rediger",
        "support-create-supplier-subscription-status-button-mode-unsubscribed": "Rediger",
        "support-create-supplier-subscription-status-begin-onboarding-dialog": "Start onboarding",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-articles-to-send": "Artikler som skal sendes",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-destination": "Destinasjon",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-button-next": "Neste",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-existing-administrators": "Eksisterende administratorer",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-extra-receivers": "Ekstra mottakere",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-button-begin": "Start",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-supplier-admin": "Leverandøradministrator: {$adminDetails}",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-kitchen-admin": "Kjøkkenadministrator: {$adminDetails}",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-label-email": "\n .label = E-post \n .placeholder = Mottakerens e-post",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-button-add": "Legg til",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-email-error": "Ugyldig e-postadresse",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-administrators-error": "Minst én administrator må velges",


        // --- Support company ---
        "support-create-company-title": "\n .title = Opprett virksomhet",
        "support-update-company-title": "\n .title = Oppdater virksomhet",
        "support-create-company-create-button": "Opprett",
        "support-create-company-update-button": "Oppdater",
        "support-create-company-nav-item-home": "Hjem",
        "support-create-company-nav-item-entities": "Entiteter",
        "support-create-company-nav-item-create-company": "Opprett virksomhet",
        "support-create-company-nav-item-update-company": "Oppdater virksomhet",
        "support-create-company-aside-settings": "\n .title = Innstillinger",
        "support-create-company-aside-active": "Aktiv:",
        "support-create-company-office-hotel-label":"Kontorhotell:",
        "support-create-company-office-hotel-helper-text":"Hjelpetekst",
        "support-create-company-company-number-label":"\n .label = Virksomhetsnummer",
        "support-create-company-main-ean-number-label":"\n .label = Primært EAN-nummer",
        "support-create-company-company-name-label":"\n .label = Firmanavn",
        "support-create-company-error-label-main-ean-number":"Primært EAN-nummer",
        "support-create-company-error-label-url-identifier":"URL-identifikator",
        "support-create-company-aside-is-self-sign-up":"\n .title = Selvregistrering",
        "support-create-company-url-identifier-label":"\n .label = Registrerings-URL-identifikator\n .helperText = Dette brukes til å generere brukerens registrerings-URL.",
        "support-create-company-signup-link-subtitle":"Registreringslenke:",

        // Invoicing
        "support-reports-basis-for-invoicing-page-header": "\n .title = Fakturagrunnlag",
        "support-reports-invoicing-header-nav-item": "Fakturering",
        "support-reports-invoicing-header-nav-item-basis-for-invoicing": "Fakturagrunnlag",
        "support-reports-invoicing-table-debtor-label": "\n .label = Debitor",
        "support-reports-invoicing-table-header-product-no": "Produktnr.",
        "support-reports-invoicing-table-header-name": "Navn",
        "support-reports-invoicing-table-header-price": "Pris",
        "support-reports-invoicing-table-header-items": "Antall",
        "support-reports-invoicing-table-header-total": "Totalt",
        "support-reports-invoicing-table-bottom-transactions": "Transaksjoner",
        "support-reports-invoicing-table-bottom-subscriptions": "Abonnementer",
        "support-reports-invoicing-table-bottom-total": "Totalt",

        // Support > Reports > Health > Server Memory
        "support-reports-health-server-memory-page-header": "\n .title = Serverminne",
        "support-reports-health-server-memory-table-header-memory-type": "Minnetype",
        "support-reports-health-server-memory-table-header-used": "Brukt",
        "support-reports-health-server-memory-table-header-commited": "Allokert",
        "support-reports-health-server-memory-table-header-max": "Maks.",


        // Support > Reports > Health > Database health
        "support-reports-health-database-page-header": "\n .title = Databasehelse",


        // Support > Reports > Health > Adyen
        "support-reports-health-adyen-page-header": "\n .title = Adyen",
        "support-reports-health-adyen-tab-summary": "Oversikt",
        "support-reports-health-adyen-tab-account-holders": "Kontoinnehavere",
        'support-reports-health-adyen-run-button':"Kjør",
        'support-reports-health-adyen-results':"Resultater:",
        'support-reports-health-adyen-api-status-unknown':"Ukjent",
        'support-reports-health-adyen-api-status-ok':"Ok",
        'support-reports-health-adyen-api-status-failed':"Mislyktes",
        'support-reports-health-adyen-summary-aside-title':"Test av API-tilkobling",
        'support-reports-health-adyen-summary-last-run':"Siste kjøring: {$lastRun}",
        'support-reports-health-adyen-summary-legal-entity-management':"Juridisk enhetsadministrasjon:",
        'support-reports-health-adyen-summary-balance-platform':"Saldoplattform:",
        'support-reports-health-adyen-summary-psp-platform':"PSP-plattform:",
        'support-reports-health-adyen-summary-main-title':"Terminal-jukselapp",
        'support-reports-health-adyen-summary-terminal-key':"Tast",
        'support-reports-health-adyen-summary-terminal-function':"Funksjon",
        'support-reports-health-adyen-summary-terminal-key-cancel':"Avbryt",
        'support-reports-health-adyen-summary-terminal-key-clear':"Tøm",
        'support-reports-health-adyen-summary-terminal-key-confirm':"Bekreft",
        'support-reports-health-adyen-summary-terminal-press-1':"Trykk 1 +",
        'support-reports-health-adyen-summary-terminal-press-5':"Trykk 5 +",
        'support-reports-health-adyen-summary-terminal-press-8':"Trykk 8 +",
        'support-reports-health-adyen-summary-terminal-press-9':"Trykk 9 +",
        'support-reports-health-adyen-summary-terminal-function-custom-menu':"Egendefinert meny",
        'support-reports-health-adyen-summary-terminal-function-informational-menu':"Informasjonsmeny",
        'support-reports-health-adyen-summary-terminal-function-payments-menu':"Betalingsmeny",
        'support-reports-health-adyen-summary-terminal-function-admin-menu':"Administratormeny",


        // Support > Reports > Health > Adyen > Account Holders
        "adyen-account-holders-table-header-id": "ID",
        "adyen-account-holders-table-cell-entity-id": "Juridisk enhets-ID: {$entityId}",
        "adyen-account-holders-table-cell-entity-liable": "Ansvarlig",
        "adyen-account-holders-table-details-balance-accounts": "Saldokontoer:",
        "adyen-account-holders-table-details-stores": "Butikker:",
        "adyen-account-holders-table-header-supplier": "Kantineoperatør",
        "adyen-account-holders-table-header-status": "Status",
        "adyen-account-holders-table-header-status-valid": "Gyldig",
        "adyen-account-holders-table-header-status-invalid": "Feil i søknad",
        "adyen-account-holders-table-header-status-pending": "Under behandling",
        "adyen-account-holders-table-header-updated": "Oppdatert",


        // Support > Reports > Health > Scheduler
        "support-reports-health-scheduler-page-header": "\n .title = Planlegger",
        "support-reports-health-scheduler-page-subtitle-main-job": "Hovedjobb:",
        "support-reports-health-scheduler-page-subtitle-load-in-seconds": "Belastning i sekunder:",
        "support-reports-health-scheduler-table-header-name": "Navn",
        "support-reports-health-scheduler-table-header-cron": "Cron",
        "support-reports-health-scheduler-table-header-last-run": "Siste kjøring",
        "support-reports-health-scheduler-table-header-next-run": "Neste kjøring",
        "support-reports-health-scheduler-table-header-status": "Status",
        "support-reports-health-scheduler-table-status-active": "Aktiv",
        "support-reports-health-scheduler-table-status-inactive": "Inaktiv",
        "support-reports-health-scheduler-table-status-paused": "Satt på pause",
        "support-reports-health-scheduler-table-action-edit": "Rediger",
        "support-reports-health-scheduler-table-action-pause": "Pause",
        "support-reports-health-scheduler-table-action-start": "Start",
        "support-reports-health-scheduler-table-action-stop": "Stopp",


        // Support > Reports > Health > Scheduler > Edit Job
        "support-reports-health-schedule-edit-page-header": "\n .title = Rediger planleggerjobb",
        "support-reports-health-schedule-edit-page-nav-item-edit-job":"Rediger jobb",
        "support-reports-health-schedule-edit-page-edit-button":"Rediger",
        "support-reports-health-schedule-edit-page-start-time-label":"\n .label = Starttid",
        "support-reports-health-schedule-edit-page-cron-expression-label":"\n .label = Cron-uttrykk",
        "support-reports-health-schedule-edit-page-settings-title":"\n .title = Innstillinger",
        "support-reports-health-schedule-edit-page-settings-active-label":"Aktiv:",
        "support-reports-health-schedule-edit-page-information-title":"\n .title = Informasjon",
        "support-reports-health-schedule-edit-page-information-id":"ID:",
        "support-reports-health-schedule-edit-page-information-name":"Navn:",
        "support-reports-health-schedule-edit-page-information-last-run":"Siste kjøring:",

        // Support > TopBar > Awaiting approval
        "awaiting-approval-popover-not-approved-item": "\n .title = Venter på godkjenning\n .description = Ordrer som må godkjennes",
        "awaiting-approval-popover-to-be-booked-item": "\n .title = Skal faktureres\n .description = Møteserveringsordrer som har vært fakturerbare i 3+ dager",
        "awaiting-approval-popover-tooltip": "\n .title = Ordrevarsler",
        "awaiting-approval-popover-section-meeting-service-title": "\n .title = Møteservering",
        "awaiting-approval-popover-section-takeaway-title": "\n .title = Takeaway",
        "awaiting-approval-popover-todays-orders-item": "\n .title = Dagens ordrer\n .description = Møteserveringsordrer til levering i dag",
        "awaiting-approval-popover-todays-takeaway-orders-item": "\n .title = Dagens ordrer\n .description = Takeaway-ordrer for i dag",

        // Support > TopBar > Instructions Dialog
        "support-instructions-dialog-title": "Instruksjoner",
        "support-instructions-button": "Instruksjoner",

        // Non Admin User > TopBar > Create new

        // TopBar > New button > menu
        "top-bar-new-button": "Ny",
        "top-bar-new-menu-resource-booking-title": "Ressursbooking",
        "top-bar-new-menu-resource-booking-description": "Book rom og andre ressurser",
        "top-bar-new-menu-meeting-service-title": "Møteservering",
        "top-bar-new-menu-meeting-service-description": "Bestill møteservering",
        "top-bar-new-menu-take-away-title": "Takeaway",
        "top-bar-new-menu-take-away-description": "Kjøp takeaway og andre varer",
        // Takeaway
        "takeaway-kitchen-selector-title": "Velg butikk",
        "takeaway-show-order-button": "Vis ordre: { $price }",
        "create-order-take-away-title": "Takeaway",
        "create-order-take-away-title-with-kitchen": "Takeaway - { $kitchenName }",
        "takeaway-no-shops-empty": "\n .title = Ingen takeaway-butikker tilgjengelig",

        // Takeaway > Date bar
        "takeaway-date-bar-or": "ELLER",
        "takeaway-date-bar-view-store-details": "Se butikkopplysninger",

        // Takeaway > Menu
        "takeaway-menu-no-products-for-date": "Ingen produkter tilgjengelig for { $date }",
        "takeaway-menu-no-products-for-date-empty": "\n .title = Ingen produkter tilgjengelig\n .description = Det er ingen produkter tilgjengelig for øyeblikket",
        "takeaway-menu-no-favorites-empty": "\n .title = Ingen favoritter ennå\n .description = Trykk på hjerteikonet på et produkt for å legge det til som favoritt",
        "takeaway-menu-no-search-results-empty": "\n .title = Ingen resultater\n .description = Prøv å justere søket",
        "takeaway-order-is-empty-button": "Ingen ordre",
        "takeaway-checkout-discount-label": "Spar -{ $percentage }%",
        "takeaway-product-sold-out-snackbar": "Varen er utsolgt",

        // Takeaway > Store details dialog
        "takeaway-store-details-title": "Butikkopplysninger",
        "takeaway-store-details-contact": "Kontakt",
        "takeaway-store-details-address": "Adresse",
        "takeaway-store-details-show-on-map": "Vis på kart",
        "takeaway-store-details-close-button": "Lukk",
        "takeaway-store-details-opening-hours-banner": "\n .title = Åpningstider: { $hours }",

        // Takeaway > Basket drawer
        "takeaway-basket-date-card-delivery-date-label": "Leveringsdato:",
        "takeaway-checkout-total-label": "Totalt",
        "takeaway-checkout-vat-label": "MVA (25%)",
        "takeaway-checkout-confirm-button": "Fullfør betaling",
        "takeaway-checkout-confirm-button-with-price": "Fullfør betaling: { $price }",
        "takeaway-checkout-opening-hours-banner": "\n .title = { $kitchenName } er åpen { $hours }",

        // Takeaway > Checkout dialog
        "takeaway-confirm-order-dialog-title": "Bekreft ordre",
        "takeaway-confirm-order-dialog-go-back-button": "Gå tilbake",
        "takeaway-checkout-order-summary-title": "Ordreoversikt",
        "takeaway-checkout-private-section": "Privat",
        "takeaway-checkout-payment-hint-by-method": "via { $method }",
        "takeaway-confirm-order-payment-method-title": "Betalingsmetode",
        "takeaway-confirm-order-accounting-title": "Kontering",
        "takeaway-confirm-order-correct-order": "Korriger ordre",
        "takeaway-checkout-order-summary-delivery-date": "Levering: { $date }",
        "takeaway-checkout-order-summary-delivery-label": "Levering:",
        "takeaway-confirm-order-items-column": "VARER",
        "takeaway-confirm-order-qty-column": "ANT.",
        "takeaway-confirm-order-amount-column": "BELØP",
        "takeaway-confirm-order-company-section": "Firma",
        "takeaway-confirm-order-wallet-balance": "Saldo: { $balance }",
        "takeaway-confirm-order-wallet-name-with-balance": "{ $name } ({ $balance })",
        "takeaway-confirm-order-pay-using-card": "Betal med { $card }",
        "takeaway-confirm-order-card-expires": "Utløper { $date }",
        "takeaway-confirm-order-comment-title": "Ordrekommentar:",
        "takeaway-confirm-order-comment-placeholder": "\n .label = Skriv en kommentar (valgfritt)\n .helperText = Gjenstående tegn: { $charsRemaining }",
        "takeaway-confirm-order-guest-name-label": "\n .label = Fullt navn\n .placeholder = Ditt fulle navn:",
        "takeaway-confirm-order-guest-email-label": "\n .label = E-post\n .placeholder = Din e-post:",
        "takeaway-confirm-order-guest-phone-label": "\n .label = Telefonnr (valgfritt)\n .placeholder = Ditt telefonnr:",
        "takeaway-confirm-order-personal-info-title": "Personopplysninger",
        "takeaway-confirm-order-personal-info-name-label": "Navn:",
        "takeaway-confirm-order-personal-info-email-label": "E-post:",
        "takeaway-confirm-order-personal-info-phone-label": "Telefonnr:",
        "takeaway-confirm-order-personal-info-edit-email-field": "\n .label = E-post",
        "takeaway-confirm-order-personal-info-edit-phone-field": "\n .label = Telefonnr",
        "takeaway-confirm-order-personal-info-edit-save-button": "Lagre",
        "takeaway-confirm-order-personal-info-edit-email-invalid": "Skriv inn en gyldig e-postadresse",
        "takeaway-confirm-order-personal-info-edit-phone-invalid": "Telefonnummer kan bare inneholde sifre og tegnene + - ( ) og mellomrom",
        "takeaway-confirm-order-delivery-section-title": "Levering",
        "takeaway-confirm-order-delivery-pickup-label": "Henting { $hours }",
        "takeaway-checkout-delivery-location-pickup-label": "Henting:",
        "takeaway-checkout-delivery-location-pickup-time": "{ $start } - { $end }",
        "takeaway-checkout-delivery-location-show-more-button": "Vis mer",
        "takeaway-payment-mobilepay-notice": "Du må bruke MobilePay-appen på telefonen din for å fullføre betalingen. Du må godkjenne betalingen i MobilePay innen 5 minutter og komme tilbake hit.",
        "takeaway-checkout-terms-accepted-label": "Jeg godtar <conditionsLink>vilkårene</conditionsLink>",
        "takeaway-checkout-terms-not-accepted": "Du må godta vilkårene",
        "takeaway-checkout-payment-method-required": "Velg en betalingsmetode",
        "takeaway-checkout-comment-max-length": "Kommentaren kan være maks { $max } tegn",
        "takeaway-payment-poll-title": "Behandler betaling",
        "takeaway-payment-poll-description": "Vent mens vi behandler betalingen din. Dette kan ta et øyeblikk.",
        "takeaway-payment-failed": "\n .title = Betalingen mislyktes\n .description = Betalingen kunne ikke gjennomføres på grunn av en uventet feil. Prøv igjen senere.",
        "takeaway-payment-canceled": "\n .title = Kjøp avbrutt\n .description = Du avbrøt betalingen av kjøpet ditt.",
        "takeaway-payment-timeout": "\n .title = Betalingen utløp\n .description = Vi har ennå ikke mottatt bekreftelse fra betalingsleverandøren din. Sjekk nettbanken din for å forsikre deg om at betalingen er gjennomført.",
        "takeaway-payment-back-to-dashboard-button": "Tilbake til oversikt",
        "takeaway-order-confirmed-dialog-title": "Ordre fullført!",
        "takeaway-order-confirmed-dialog-order-id": "Ordre-ID: { $orderId }",
        "takeaway-order-confirmed-dialog-pickup-hours-label": "Henting:",
        "takeaway-order-confirmed-dialog-pickup-location-value": "{ $name } mellom { $start } og { $end }",
        "takeaway-order-confirmed-dialog-delivery-date-label": "Leveringsdato:",
        "takeaway-order-confirmed-dialog-amount-label": "Beløp:",
        "takeaway-order-confirmed-dialog-total-amount-label": "Totalbeløp:",
        "takeaway-order-confirmed-dialog-go-to-dashboard-button": "Gå til oversikt",
        "takeaway-order-confirmed-dialog-show-receipt-button": "Vis kvittering",
        "takeaway-order-confirmed-dialog-show-receipts-button": "Vis { $count } kvitteringer",
        "takeaway-receipt-send-button": "Send kvittering",
        "top-bar-new-menu-make-purchase-title": "Foreta et kjøp",
        "top-bar-new-menu-make-purchase-description": "Bestill lunsj i kantinen",
        "top-bar-new-menu-refill-wallet-title": "Fyll på wallet",
        "top-bar-new-menu-refill-wallet-description": "Fyll på penger i din digitale wallet",
        "top-bar-new-menu-section-booking-title": "Booking",
        "top-bar-new-menu-section-purchase-title": "Kjøp",
        "top-bar-new-menu-book-for-another-user-button": "Book for en annen bruker",
        "top-bar-new-menu-push-message-title": "Push-melding",
        "top-bar-new-menu-push-message-dialog-title": "Ny push-melding",
        "top-bar-new-menu-push-message-description": "Send meldinger til kundene dine",
        "top-bar-new-menu-shortcuts-title": "Snarveier:",
        "top-bar-new-menu-shortcut-accounting": "Regnskap",
        "top-bar-new-menu-shortcut-manage-products": "Administrer produkter",
        "top-bar-new-menu-shortcut-manage-push-messages": "Administrer push-meldinger",

        // Navigation
        "support-nav-item-home": "Hjem",
        "support-nav-item-devices": "Enheter",
        "support-nav-item-messages": "\n .title = Meldinger",
        "support-nav-item-orders-title": "\n .title = Ordrer",
        "support-nav-item-orders": "Ordrer",
        "support-nav-item-orders-pos": "POS",
        "support-nav-item-accounting-title": "\n .title = Regnskap",
        "support-nav-item-accounting": "Regnskap",
        "support-nav-item-subscriptions": "Abonnementer",
        "support-nav-item-accounting-meeting-service": "Møteservering",
        "support-nav-item-email": "E-post",
        "support-nav-item-sms": "SMS",
        "support-nav-item-printer-queue": "Skriverkø",

        // Support ADMIN DEVICES
        "support-admin-nav-item-devices": "Enheter",
        "support-admin-entities-card-group": "\n .title = Entiteter",
        "support-admin-entities-card": "\n .title = Entiteter\n .description = Administrer entiteter i systemet, som leverandører, salgssteder og firmaer.",
        "support-admin-devices-page-header": "\n .title = Enheter",
        "support-table-header-supplier": "Kantineoperatør",
        "support-table-header-merchant": "Salgssted",

        // - reporting

        // - admin
        "support-nav-item-supplier-access": "Kantineoperatører",
        "support-nav-item-merchant-access": "Kantiner",
        "support-nav-item-entities-access": "Entiteter",
        "support-nav-item-payments": "Betalinger",
        "support-nav-item-features": "Funksjoner",
        "support-nav-item-invoicing": "\n .title = Fakturering",
        "support-nav-item-invoicing-basis-for-invoicing": "Fakturagrunnlag",
        "support-nav-item-health-title": "\n .title = Helse",
        "support-nav-item-health": "Helse",
        "support-nav-item-health-database": "Databasehelse",
        "support-nav-item-health-server-memory": "Serverminne",
        "support-nav-item-health-scheduler": "Planlegger",
        "support-nav-item-health-adyen": "Adyen",

        // Access
        "support-supplier-access-page-header": "\n .title = Kantineoperatører",
        "support-merchant-access-page-header": "\n .title = Kantiner",


        // Page header
        "page-header-help-tooltip": "\n .title = Klikk her for mer info",
        "page-header-help-text": "Hjelpeguider",
        "page-header-help-status-mode-new": "Ny",
        "page-header-help-status-mode-beta": "Beta",
        "page-header-help-maintenance": "Beklager, siden er for øyeblikket utilgjengelig fordi den er under vedlikehold.",

        // YUP validation
        "validation-title-required": "Tittel er påkrevd",
        "validation-body-required": "Må fylles ut",
        "validation-type-required": "Type er påkrevd",

        // Field validation
        "validation-date-must-be-in-past": "Datoen må være i fortiden",
        "validation-date-must-be-today-or-past": "Datoen må være i dag eller tidligere",
        "validation-date-must-be-in-future": "Datoen må være i fremtiden",
        "validation-date-must-be-today-or-future": "Datoen må være i dag eller senere",
        "validation-datetime-must-be-in-past": "Dato og tid må være i fortiden",
        "validation-datetime-must-be-in-future": "Dato og tid må være i fremtiden",
        "validation-number-exceeds-max": "Verdien må være maks { $max }",
        "validation-number-below-min": "Verdien må være minst { $min }",

        // Common
        "employee-id": "Ansatt-ID",
        "id": "id",
        "name": "Navn",
        "price": "Pris",
        "email": "E-post",
        "amount": "Beløp",
        "for": "for",
        "yes": "Ja",
        "no": "Nei",
        "status": "Status",
        "active": "Aktiv",
        "inactive": "Inaktiv",
        "edit": "Rediger",
        "delete": "Slett",

        "create": "Opprett",
        "save": "Lagre",
        "required-field": "Dette feltet er påkrevd",
        "invalid-email": "Ugyldig e-postadresse",

        // History block
        "history-card": "\n .title = Historikk",
        "history-created": "Opprettet:",
        "history-edited": "Sist endret:",


        // Production order
        "production-order-status-received": "Mottatt",
        "production-order-status-confirmed": "Bekreftet",
        "production-order-status-cancelled": "Kansellert",
        "production-order-status-ready": "Klar",
        "production-order-number": "ID",
        "production-order-status": "Status",
        "production-order-payment-status": "Betalingsmetode",
        "production-order-payment-channel": "Kanal",
        "production-order-time": "Tid",
        "production-order-delivery-time": "Leveringstid",
        "production-order-placeholder-comment": "Kommentar til kunden",
        "production-order-show-cancelled": "Vis kansellerte",

        // Pos order
        "pos-order-delivery-date-title": "Leveringsliste - takeaway",
        "pos-order-delivery-date": "\n .label =  Leveringsdato:",
        "pos-order-purchase-time": "\n .label =  Kjøpstid:",
        "pos-order-customer": "\n .label =  Kunde:",

        // Merchant > Reports > Production > Meeting service
        "meeting-service-table-approved-orders": "Godkjente ordrer",
        "meeting-service-table-unapproved-orders": "\n .label = Ikke-godkjente ordrer",
        "meeting-service-table-time": "Tid",
        "meeting-service-table-start-date": "Startdato",
        "meeting-service-table-end-date": "Sluttdato",
        "meeting-service-table-delivery-type": "Leveringstype",
        "delivery-type-filter-all": "Alle",
        "delivery-type-filter-delivery": "Levering",
        "delivery-type-filter-pick-up": "Henting",
        "delivery-type-filter-eating-in-canteen": "Spiser i kantinen",
        "meeting-service-table-order-id-column": "Ordre-ID",
        "meeting-service-table-delivery-time-column": "Leveringstid",
        "meeting-service-table-delivery-location-column": "Møte",
        "meeting-service-table-meeting-name-column": "Møtenavn",
        "meeting-service-table-location-column": "Lokasjon",
        "meeting-service-table-amount-column": "Beløp",
        "meeting-service-table-changes-column": "Endringer",
        "meeting-service-table-changes-column-tooltip-changed": "\n .title = Ordren ble endret {$date}",
        "meeting-service-table-changes-column-tooltip-unchanged": "\n .title = Ordren er ikke endret",
        "meeting-service-table-changes-column-active-filter-yes": "Aktiv",
        "meeting-service-table-changes-column-inactive-filter-no": "Inaktiv",
        "meeting-service-table-lock-column": "Lås",
        "meeting-service-table-lock-column-tooltip-open": "\n .title = Ordren er åpen for endringer",
        "meeting-service-table-lock-column-tooltip-closed": "\n .title = Ordren er låst for endringer",
        "meeting-service-table-lock-column-lock-tooltip": "\n .title = Hindre bestiller i å endre denne ordren",
        "meeting-service-table-lock-column-unlock-tooltip": "\n .title = La bestiller endre denne ordren",
        "meeting-service-table-lock-column-active-filter-yes": "Aktiv",
        "meeting-service-table-lock-column-inactive-filter-no": "Inaktiv",
        "meeting-service-table-meeting": "Levering: {$locationName}",
        "meeting-service-table-production-slip-button": "Følgeseddel",
        "meeting-service-table-credit-note-button": "Kreditnota",
        "meeting-service-table-receipt-button": "Kvittering",
        "meeting-service-table-update-button": "Rediger",
        "meeting-service-table-duplicate-button": "Dupliser",
        "meeting-service-table-book-button": "Bokfør",
        "meeting-service-table-send-message-button": "Send melding",
        "meeting-service-table-delete-button": "Slett",
        "meeting-service-table-date-range-filter": "Datointervall",
        "meeting-service-table-floating-action-bar-read": "\n .title = Lest",
        "meeting-service-table-floating-action-bar-lock-unlock": "\n .title = Lås/lås opp",
        "meeting-service-table-floating-action-bar-lock": "\n .title = Lås",
        "meeting-service-table-floating-action-bar-lock-tooltip": "\n .title = Hindre bestiller i å endre valgte ordrer",
        "meeting-service-table-floating-action-bar-unlock": "\n .title = Lås opp",
        "meeting-service-table-floating-action-bar-unlock-tooltip": "\n .title = La bestiller endre valgte ordrer",
        "meeting-service-table-floating-action-bar-book": "\n .title = Bokfør",
        "meeting-service-table-floating-action-bar-status": "\n .title = Status",
        "meeting-service-table-floating-action-bar-delete": "\n .title = Slett",
        "meeting-service-table-floating-action-bar-print": "\n .title = Skriv ut",
        "meeting-service-table-floating-action-bar-production-slip": "\n .title = Følgeseddel",
        "meeting-service-table-floating-action-bar-delivery-list": "\n .title = Leveringsliste",
        "meeting-service-table-floating-action-bar-receipt": "\n .title = Kvittering",
        "meeting-service-table-floating-action-bar-export": "\n .title = Eksporter valgte",
        "calendar-button-show-calendar": "\n .title = Vis kalender\n .aria-label = Vis kalender",
        "meeting-service-delete-orders-title": "Slett ordrer",
        "meeting-service-delete-order-title": "Slett ordre",
        "meeting-service-delete-orders-checkbox-label-meeting-service": "\n .label = Møteservering",
        "meeting-service-delete-orders-checkbox-label-booking": "\n .label = Avbestill ressursbooking",
        "meeting-service-delete-orders-checkbox-label-booking-lock": "Avbestill ressursbooking",
        "meeting-service-delete-orders-checkbox-label-meeting-service-cancel": "\n .label = Avbestill møteservering",
        "meeting-service-delete-orders-checkbox-label-meeting-service-cancel-lock": "Avbestill møteservering",
        "meeting-service-delete-orders-helper-merchant-cancellation-field": ".label = Avbestillingsmelding \n .placeholder = Skriv en begrunnelse for avbestillingen. Denne meldingen sendes til kunden. \n .helperText = Gjenstående tegn: { $charsRemaining }",
        "meeting-service-delete-orders-helper-merchant": "Merk: Hvis en ressursbooking er knyttet til møteserveringsordren, blir den ikke avbestilt.",
        "meeting-service-delete-orders-helper-line-one": "OBS: Hvis en ressursbooking er knyttet til møteserveringsordren, kan du avbestille ressursbookingen på vegne av oppretteren.",
        "meeting-service-delete-orders-helper-line-two": "Vær oppmerksom på at hvis du avbestiller ressursbookingen, blir en eventuell reservasjon av lokaler og tilhørende AV-utstyr også avbestilt og frigitt til andre brukere.",
        "meeting-service-table-order-name-column": "Ordrenavn",
        "meeting-service-book-orders-title": "Bokfør ordrer",
        "meeting-service-book-orders-description": "Ordrer merket 'Fremtidig' kan ikke behandles, da leveringsdatoen er satt til en fremtidig dato. For ordrer merket 'Kontant' må du sørge for at en betalingsdato er angitt for dagen betalingen mottas.",
        "meeting-service-table-status-column": "Status",
        "meeting-service-table-cash-payment-received-column": "Kontantbetaling mottatt",
        "meeting-service-book-orders-subtotal": "Delsum",
        "meeting-service-book-orders-button": "Bokfør",
        "meeting-service-delete-orders-button": "Slett",
        "meeting-service-delete-single-order-id-label": "Ordre-ID:",
        "meeting-service-delete-single-order-delivery-date-label": "Leveringsdato:",
        "meeting-service-delete-single-order-meeting-name-label": "Møtenavn:",
        "meeting-service-delete-single-order-responsible-label": "Ansvarlig:",
        "meeting-service-delete-single-order-amount-label": "Beløp:",
        "merchant-home-meeting-service-awaiting-approval-title": "Til godkjenning",
        "filter-menu-accordion-order-status-title": "\n .title = Ordrestatus",
        "filter-menu-accordion-companies-title": "\n .title = Virksomheter",
        "filter-menu-accordion-checkbox-awaiting-approval": "\n .optionLabel = Til godkjenning",
        "filter-menu-accordion-checkbox-to-be-invoiced": "\n .optionLabel = Skal faktureres",
        "meeting-service-table-header-date-range-button": "Datointervall",
        "meeting-service-table-header-period-picker-button": "Periodevelger",
        "meeting-service-table-lock-column-locked":"\n .title = Ordren er låst av salgsstedet. Kontakt salgsstedet for oppdateringer.",
        "meeting-service-snackbar-undo": "ANGRE",
        "meeting-service-snackbar-undo-message": "{ $amount ->\n  [one] { $amount } ordre er satt til \n *[other] { $amount } ordrer er satt til \n}",
        "meeting-service-delivery-list": "Leveringsliste",
        "meeting-service-delivery-list-period": "Periode:<dateRange>{$startLabel} - {$endLabel}</dateRange><icon />",
        "meeting-service-delivery-list-period-all": "Periode:<all>Alle</all><icon />",
        "meeting-service-delivery-list-header-period": "Periode: {$startLabel} - {$endLabel}",
        "meeting-service-delivery-list-header-period-all": "Periode: Alle",
        "meeting-service-delivery-list-orders-selected": "Ordrer: {$ordersLength} valgt",
        "meeting-service-delivery-list-group-by-label": "Grupper etter:",
        "meeting-service-delivery-list-group-by-location": "Leveringssted",
        "meeting-service-delivery-list-group-by-time": "Leveringstid",
        "meeting-service-delivery-list-group-by-item": "Grupper etter: levering {$value}",
        "meeting-service-delivery-list-delivery": "Leveringstype:<value>{$value}</value>",
        "meeting-service-delivery-list-filter-all": "Alle",
        "meeting-service-delivery-list-empty": "Ingen leveringsordrer for de valgte kriteriene",
        "meeting-service-delivery-list-delivery-details-meeting-time": "\n .label = Møtetid:",
        "meeting-service-delivery-list-delivery-details-location": "\n .label = Leveringssted:",
        "meeting-service-delivery-list-delivery-details-sittings": "\n .label = Sitteplasser:",
        "meeting-service-delivery-list-contact-details-meeting-creator": "\n .label = Opprettet av:",
        "meeting-service-delivery-list-contact-details-meeting-host": "\n .label = Møteansvarlig:",
        "meeting-service-delivery-list-table-column-items": "Antall",
        "meeting-service-delivery-list-table-column-products": "Produkter",
        "meeting-service-delivery-list-table-column-delivery-time": "Leveringstid",

        // Batch modal
        "meeting-service-batch-modal-title": "\n .dialogTitle = Endre status",
        "meeting-service-batch-modal-button-change-label": "Bekreft",
        "meeting-service-batch-modal-button-close-label": "Lukk",
        "meeting-service-batch-modal-button-close-tooltip-label": "\n .title = Ingen ordrer kan endre status",
        "meeting-service-batch-modal-warning-message": "Kunne ikke endre status for ordrer med dette ikonet",
        "meeting-service-batch-modal-cancellation-reason-message": "Skriv en årsak til avbestillingen. Denne meldingen sendes til alle på listen.",
        "meeting-service-batch-modal-customer-message": "Melding til kunde",
        "meeting-service-batch-modal-order-id": "Ordre-ID",
        "meeting-service-batch-modal-delivery-time": "Leveringstid",
        "meeting-service-batch-modal-order-details": "Ordredetaljer",
        "meeting-service-batch-modal-from": "Fra",
        "meeting-service-batch-modal-to": "Til",
        "meeting-service-batch-modal-batch-error": "{ $ordersCount ->\n  [one] Kunne ikke endre status for { $ordersCount } ordre\n *[other] Kunne ikke endre status for { $ordersCount } ordrer\n}",

        // Package slip handle PDF open
        "meeting-service-handle-pdf-open-error": "Kunne ikke åpne pdf",

        // Merchant > Reports > Production > Calendar
        "orders-for-calendar-multi-select": "\n .label = Butikktype",
        "orders-for-calendar-search": "\n .label = Søk \n .placeholder = Søk etter ordre-ID eller ordrenavn",
        "expandable-search-search-button": "Søk",
        "expandable-search-clear-button": "Tøm søk",
        "production-slip-dialog-title": "Følgeseddel",
        "production-slip-dialog-table-header-items": "Antall",
        "production-slip-dialog-table-header-products": "Produkter",
        "production-slip-dialog-table-header-delivery-time": "Leveringstid",
        "production-slip-dialog-note": "Ordrenotat",
        "production-slip-dialog-order-id": "Ordre-ID: { $orderId }",
        "production-slip-dialog-delivery-details": "Leveringsdetaljer",
        "production-slip-dialog-delivery-type": "Leveringstype:",
        "production-slip-dialog-delivery-time": "Leveringstidspunkt:",
        "production-slip-dialog-delivery-meeting-time": "Møtetidspunkt:",
        "production-slip-dialog-delivery-delivery-location": "Leveringssted:",
        "production-slip-dialog-delivery-sittings": "Kuverter:",
        "production-slip-dialog-delivery-shop": "Butikk:",
        "production-slip-dialog-contact-details": "Kontaktopplysninger",
        "production-slip-dialog-contact-details-creator": "Bestiller:",
        "production-slip-dialog-contact-details-meeting-host": "Møtevert:",
        "production-slip-dialog-scan": "Se følgeseddel på mobilenhet",

        // Accounting customer
        "customer-accounting-show-customers-with-sales-only": "Vis bare kunder med salg",


        // FloatingActionButton
        "floating-action-button": "Lukk",
        "floating-action-button-picked": "Valgte elementer",
        "floating-action-button-order-status": "\n .title = Status",
        "floating-action-button-order-status-menu-item": "Endre ordrestatus",
        "floating-action-button-receipt": "Kvittering",
        "floating-action-button-print": "\n .title = Skriv ut",
        "floating-action-button-print-receipt": "\n .title = Skriv ut kvittering",
        "floating-action-button-print-label": "\n .title = Skriv ut etikett",
        "print-label-copies-modal": "\n .title = Skriv ut etikett\n .message = Hvor mange kopier vil du skrive ut?\n .buttonLabelSubmit = Skriv ut\n .buttonLabelCancel = Avbryt",
        "floating-action-button-export": "\n .title = Eksport",


        //ChangeOrderStatusModal
        "change-order-status": "Endre ordrestatus",
        "change-order-status-received": "Mottatt",
        "change-order-status-confirmed": "Bekreftet",
        "change-order-status-ready": "Klar",
        "change-order-status-cancelled": "Kansellert",
        "change-order-status-title": "Resultat",

        "change-order-status-received-info-text": "En ordre får automatisk status Mottatt når den opprettes. Hvis du vil rulle statusen tilbake fra Bekreftet til Mottatt, får kunden et varsel. Rull bare tilbake statusen hvis du ved en feil har satt den til Bekreftet.",
        "change-order-status-confirmed-info-text": "Når en ordre settes til Bekreftet, får kunden et varsel om at ordren behandles. Kunden kan forvente å motta bestillingen sin.",
        "change-order-status-ready-info-text": "Når en ordre settes til Klar, får kunden et varsel om at ordren kan hentes.",
        "change-order-status-cancelled-info-text": "Når en ordre settes til Kansellert, får kunden et varsel om at ordren ikke blir levert. Du kan skrive en kommentar til kunden om hvorfor den er kansellert.",


        //ChangeOrderStatusResponseModal
        "change-order-status-response-modal-title": "Resultat",
        "change-order-status-response-modal-order-id": "Ordre-ID",
        "change-order-status-response-modal-order-delivery": "Leveringsdato",
        "change-order-status-response-modal-order-message": "Melding",
        "change-order-status-response-modal-error": "mislyktes",
        "change-order-status-response-modal-error-aciton": "handling",
        "change-order-status-response-modal-error-acitons": "handlinger",


        // --- Surveys List ---
        "surveys-list-header": "\n .title = Brukerundersøkelser",
        "surveys-list-create-button": "Opprett ny",
        "surveys-list-survey-table-name-column": "Navn",
        "surveys-list-survey-table-start-date-column": "Startdato",
        "surveys-list-survey-table-end-date-column": "Sluttdato",
        "surveys-list-survey-table-active-column-active": "Aktiv",
        "surveys-list-survey-table-active-column-inactive": "Inaktiv",
        "surveys-list-survey-table-active-column-active-filter-yes": "Aktiv",
        "surveys-list-survey-table-active-column-inactive-filter-no": "Inaktiv",
        "surveys-table-list-delete-modal-title": "brukerundersøkelse",
        "surveys-table-list-show-ratings": "Vis vurderinger",
        "surveys-table-list-delete-success-message": "Brukerundersøkelsen ble slettet",

        // Create / edit survey
        "create-survey-header": "\n .title = Opprett brukerundersøkelse",
        "edit-survey-header": "\n .title = Rediger brukerundersøkelse",
        "nav-item-create-survey-header": "Opprett brukerundersøkelse",
        "nav-item-edit-survey-header": "Rediger brukerundersøkelse",
        "create-merchant-survey-save-button": "Opprett",
        "edit-merchant-survey-save-button": "Lagre",
        "create-or-edit-merchant-survey-field-name": "\n .label = Navn\n .placeholder = Skriv inn et navn på brukerundersøkelsen\n .helperText = Beskrivelsen vises ikke for brukeren",
        "create-or-edit-merchant-survey-field-name-required": "Navn er påkrevd",
        "create-or-edit-merchant-survey-field-description":
            "\n .label = Beskrivelse\n .placeholder = Skriv inn en valgfri beskrivelse til eget bruk\n .helperText = Beskrivelsen vises ikke for brukeren",
        "create-or-edit-merchant-survey-questions": "Dine spørsmål:",
        "create-or-edit-merchant-survey-questions-empty": "Du har ikke opprettet noen spørsmål ennå.",
        "create-or-edit-merchant-survey-field-questions-minError":"Du trenger minst ett spørsmål",
        "create-or-edit-merchant-survey-add-questions-button": "Legg til spørsmål",
        "create-or-edit-merchant-survey-title-general": "\n .title = Generelt",
        "create-or-edit-merchant-survey-field-active": "Aktiv:",
        "create-or-edit-merchant-survey-field-start-date": "Startdato",
        "create-or-edit-merchant-survey-field-end-date": "Sluttdato",
        "create-or-edit-merchant-survey-title-user-visibility": "\n .title = Brukersynlighet",
        "create-or-edit-merchant-survey-field-timeOfDay": "\n .label = Tid på dagen",
        "create-or-edit-merchant-survey-field-timeOfDay-helperText": "Bestemmer når på dagen vurderingskortet for denne brukerundersøkelsen vises.",
        "create-or-edit-merchant-survey-field-expirationDays": "\n .label = Utløpsdager\n .helperText = Dager til et ubesvart vurderingskort skjules.",
        "edit-merchant-survey-success-save-message": "Brukerundersøkelsen ble oppdatert",
        "create-merchant-survey-success-save-message": "Brukerundersøkelse opprettet",
        "create-or-edit-merchant-survey-dialog-save-button": "Lagre",
        "create-or-edit-merchant-survey-dialog-title": "Legg til spørsmål",
        "create-or-edit-merchant-survey-dialog-field-question": "\n .label = Spørsmål",
        "create-or-edit-merchant-survey-dialog-topics-title": "Velg emner:",
        "create-or-edit-merchant-survey-dialog-topics-good": "\n .label = Gode emner",
        "create-or-edit-merchant-survey-dialog-topics-bad": "\n .label = Dårlige emner",
        "create-or-edit-merchant-survey-dialog-topics-info": "Gode emner kan brukes av deltakeren til å velge hva de syntes var spesielt bra. Dårlige emner kan brukes til å angi hva de gjerne vil se forbedret.",


        // --- Company ---

        "company-home-purchases-card-group": "\n .title = Kjøp",
        "company-home-purchases-period-base-3": "Siste 3 dager",
        "company-home-purchases-period-base-14": "Siste 14 dager",
        "company-home-purchases-period-base-30": "Siste 30 dager",
        "company-home-purchases-period-base-60": "Siste 60 dager",
        "company-home-purchases-period-base-180": "Siste 180 dager",
        "company-home-purchases-pos-purchases-title": " \n .title = POS-kjøp",
        "company-home-purchases-pos-orders-title": " \n .title = POS-ordrer",
        "company-home-purchases-meeting-service-purchases-title": " \n .title = Møteserveringskjøp",
        "company-home-purchases-meeting-service-orders-title": " \n .title = Møteserveringsordrer",
        "company-home-purchases-users-title": " \n .title = Brukere",
        "company-home-purchases-check-in-title": " \n .title = Innsjekkinger",


        // Company > Admin > Home
        "company-admin-home-organization-users-card":  "\n .title = Brukere \n .description = Administrer brukere.",
        "company-admin-home-organization-bill-receivers-card":  "\n .title = Fakturamottakere \n .description = Administrer fakturamottakere.",
        "company-admin-home-organization-user-group-card":  "\n .title = Brukergrupper \n .description = Administrer brukergrupper.",
        "company-admin-home-organization-departments-card":  "\n .title = Avdelinger \n .description = Administrer avdelinger.",
        "company-admin-home-organization-workgroups-card":  "\n .title = Arbeidsgrupper \n .description = Administrer arbeidsgrupper.",
        "company-admin-home-organization-locations-card":  "\n .title = Lokasjoner \n .description = Administrer lokasjoner.",
        "company-admin-home-account-gdpr-card":  "\n .title = GDPR \n .description = Personvernforordningen \n .buttonText = Vis",
        "company-admin-home-account-administrator-card":  "\n .title = Administratorer \n .description = Administrer administratorer.",

        // Navigation
        "company-nav-item-home": "Hjem",
        "company-home-coming-soon-placeholder": "\n .title = Kommer snart",
        "company-home-coming-soon-placeholder-body": "Du er logget inn som firmaadministrator. Vi jobber med å levere denne funksjonen til deg. Foreløpig kan du bruke <externalLink>bestil-nu.net</externalLink>.",
        "company-nav-item-accounting": "\n .title = Regnskap",
        "company-nav-item-pos": "POS",
        "company-nav-item-meeting-service": "Møteservering",
        "company-nav-item-subscriptions": "Abonnementer",
        "company-nav-item-organization": "\n .title = Organisasjon",
        "company-nav-item-users": "Brukere",
        "company-nav-item-admins": "Administratorer",
        "company-nav-item-user-groups": "Brukergrupper",
        "company-nav-item-departments": "Avdelinger",
        "company-nav-item-workgroups": "Arbeidsgrupper",
        "company-nav-item-locations": "Lokasjoner",
        "company-nav-item-bill-receivers": "Fakturamottakere",
        "company-nav-item-account-dimensions": "Kontodimensjoner",
        "company-nav-item-settings": "Innstillinger",
        "company-nav-item-account-title": "\n .title = Konto",
        "company-nav-item-account": "Konto",
        "company-nav-item-gdpr": "GDPR",
        "company-nav-item-data-import-title": "\n .title = Dataimport",
        "company-nav-item-data-import": "Dataimport",
        "company-nav-item-id-cards": "ID-kort",
        "company-nav-item-account-numbers": "Kontonumre",
        "company-nav-item-import-users": "Brukere",
        "company-nav-item-import-bill-receivers": "Fakturamottakere",
        "company-nav-item-settings-title": "\n .title = Innstillinger",
        "company-nav-item-custom-jobs": "Egendefinerte jobber",


        // Company > Admin > Organization > Departments
        "company-organization-title": "\n .title = Organisasjon",
        "company-organization-departments-title": "Avdelinger",
        "company-organization-departments-header": "\n .title = Avdelinger",
        "company-organization-departments-create-button": "Opprett ny",
        "company-organization-departments-table-department-no-column": "Avdelingsnr.",
        "company-organization-departments-table-name-column": "Navn",
        "company-organization-departments-table-status-column": "Status",
        "company-organization-departments-table-active-column-active": "Aktiv",
        "company-organization-departments-table-active-column-inactive": "Inaktiv",
        "company-organization-departments-table-active-column-active-filter-yes": "Aktiv",
        "company-organization-departments-table-active-column-inactive-filter-no": "Inaktiv",
        "company-organization-departments-table-edit": "Rediger",
        "company-organization-departments-table-delete": "Slett",
        "company-organization-departments-table-delete-modal-title": "avdeling",
        "company-organization-departments-edit-title": "Rediger avdeling",
        "company-organization-departments-create-title": "Opprett avdeling",
        "create-department-header": "\n .title = Opprett avdeling",
        "edit-department-header": "\n .title = Rediger avdeling",
        "edit-department-save-button": "Lagre",
        "create-department-save-button": "Opprett",
        "create-or-edit-company-department-field-departmentNo": "\n .label = Avdelingsnr.\n .placeholder = Skriv inn avdelingsnr.",
        "create-or-edit-company-department-field-name": "\n .label = Navn\n .placeholder = Skriv inn navn",
        "create-or-edit-company-department-field-is-required": "Feltet er påkrevd",
        "create-or-edit-company-department-field-active": "Aktiv",
        "create-or-edit-company-department-settings": "\n .title = Innstillinger",
        "create-or-edit-company-department-history": "\n .title = Historikk",

        // Company > Admin > Organization > Workgroups
        "company-organization-workgroups-title": "Arbeidsgrupper",
        "company-organization-workgroups-header": "\n .title = Arbeidsgrupper",
        "company-organization-workgroups-create-button": "Opprett ny",
        "company-organization-workgroups-table-name-column": "Navn",
        "company-organization-workgroups-table-calendar-column": "E-postadresse for kalender",
        "company-organization-workgroups-table-members-column": "Medlemmer",
        "company-organization-workgroups-table-status-column": "Status",
        "company-organization-workgroups-table-edit": "Rediger",
        "company-organization-workgroups-table-delete": "Slett",
        "company-organization-workgroups-table-delete-modal-title": "arbeidsgruppe",
        "company-organization-workgroups-edit-title": "Rediger arbeidsgruppe",
        "company-organization-workgroups-create-title": "Opprett arbeidsgruppe",
        "create-workgroup-header": "\n .title = Opprett arbeidsgruppe",
        "edit-workgroup-header": "\n .title = Rediger arbeidsgruppe",
        "edit-workgroup-save-button": "Lagre",
        "create-workgroup-save-button": "Opprett",
        "create-or-edit-company-workgroup-field-name": "\n .label = Navn\n .placeholder = Skriv inn navn",
        "create-or-edit-company-workgroup-field-description": "\n .label = Beskrivelse til brukere\n .placeholder = Skriv inn beskrivelse til brukere",
        "create-or-edit-company-workgroup-field-description-info": "\n .title = Vises for brukerne når de velger en arbeidsgruppe, så beskriv hvem gruppen er for.",
        "create-or-edit-company-workgroup-field-calendar-email": "\n .label = E-postadresse for kalender\n .placeholder = Skriv inn e-postadresse for kalender",
        "create-or-edit-company-workgroup-field-calendar-email-info": "\n .title = Den delte postkassen eller kalenderadressen for denne arbeidsgruppen. Bookinger og møteserveringsordrer fra medlemmene samles her, slik at medlemmene kan se hverandres avtaler.",
        "create-or-edit-company-workgroup-field-is-required": "Feltet er påkrevd",
        "create-or-edit-company-workgroup-field-invalid-email": "Skriv inn en gyldig e-postadresse",
        "create-or-edit-company-workgroup-field-name-max-length": "Navnet kan være maks { $maxLength } tegn",
        "create-or-edit-company-workgroup-field-calendar-email-max-length": "E-postadressen for kalender kan være maks { $maxLength } tegn",
        "create-or-edit-company-workgroup-field-description-max-length": "Beskrivelsen kan være maks { $maxLength } tegn",
        "create-or-edit-company-workgroup-field-active": "Aktiv",
        "create-or-edit-company-workgroup-settings": "\n .title = Innstillinger",
        "create-or-edit-company-workgroup-history": "\n .title = Historikk",
        "create-or-edit-company-workgroup-members": "\n .title = Medlemmer",
        "create-or-edit-company-workgroup-members-empty": "\n .title = Ingen medlemmer ennå\n .description = Legg til personene som skal dele postkassen og kunne se hverandres bookinger og bestillinger av møteservering.",
        "create-or-edit-company-workgroup-members-remove": "Fjern fra gruppen",
        "create-or-edit-company-workgroup-members-add-field": "\n .label = Legg til medlem\n .placeholder = Søk på navn, minst 3 tegn",
        "create-or-edit-company-workgroup-members-table-header-user-id": "Bruker-ID",
        "create-or-edit-company-workgroup-members-table-header-name": "Navn",
        "create-or-edit-company-workgroup-members-table-header-email": "E-post",
        "create-or-edit-company-workgroup-members-table-header-status": "Status",
        "create-or-edit-company-workgroup-members-department-filter-label": "Avdeling",
        "create-or-edit-company-workgroup-members-department-filter": "\n .label = Avdeling",
        "create-or-edit-company-workgroup-members-department-filter-all": "Alle avdelinger",
        "create-or-edit-company-workgroup-members-department-filter-none": "Ingen avdeling",
        "create-or-edit-company-workgroup-members-details-button": "Detaljer",
        "create-or-edit-company-workgroup-members-removed": "{ $count ->\n [one] { $count } medlem fjernet fra gruppen\n *[other] { $count } medlemmer fjernet fra gruppen\n}",
        "create-or-edit-company-workgroup-members-undo-button": "Angre",
        "create-or-edit-company-workgroup-members-bulk-remove": "\n .title = Fjern fra gruppen",
        "create-or-edit-company-workgroup-members-remove-dialog-title": "{ $count ->\n [one] Fjerne { $count } medlem fra gruppen?\n *[other] Fjerne { $count } medlemmer fra gruppen?\n}",
        "create-or-edit-company-workgroup-members-remove-dialog-message": "{ $names }{ $hidden ->\n [0] {\"\"}\n [one] {\" \"}og { $hidden } til\n *[other] {\" \"}og { $hidden } til\n} fjernes fra { $workgroup } og vil ikke lenger se gruppens avtaler. Brukerne blir ikke slettet.",
        "create-or-edit-company-workgroup-members-remove-dialog-message-unnamed": "{ $names }{ $hidden ->\n [0] {\"\"}\n [one] {\" \"}og { $hidden } til\n *[other] {\" \"}og { $hidden } til\n} fjernes fra denne gruppen og vil ikke lenger se gruppens avtaler. Brukerne blir ikke slettet.",
        "create-or-edit-company-workgroup-members-remove-dialog": "\n .buttonLabelSubmit = { $count ->\n [one] Fjern { $count } medlem\n *[other] Fjern { $count } medlemmer\n }\n .buttonLabelCancel = Avbryt",
        "company-user-workgroups-panel": "\n .title = Arbeidsgrupper",
        "company-user-workgroups-panel-empty": "Denne brukeren er ennå ikke medlem av noen arbeidsgrupper.",
        "company-user-workgroups-panel-add-button": "Legg til",
        "company-user-workgroups-panel-remove": "Fjern",
        "company-user-workgroups-panel-add-dialog-title": "Legg til i arbeidsgruppe",
        "company-user-workgroups-panel-add-dialog-empty": "Det er ingen flere arbeidsgrupper å legge til.",

        // Company Admin Organization > Users (create/edit form)
        "company-user-create-page-title": "\n .title = Opprett bruker",
        "company-user-edit-page-title": "\n .title = Rediger bruker",
        "company-user-create-submit": "Opprett",
        "company-user-edit-submit": "Lagre",
        "company-user-create-breadcrumb": "Opprett bruker",
        "company-user-edit-breadcrumb": "Rediger bruker",
        "company-user-tab-details": "Brukerdetaljer",
        "company-user-tab-workgroups": "Arbeidsgrupper",
        "company-user-tab-approvals": "Brukergodkjenninger",
        "company-user-tab-catalog": "Kantinetilgang",
        "company-user-tab-guest-checkin": "Gjesteinnsjekking",
        "company-user-workgroups-tab-description":
            "Velg én eller flere arbeidsgrupper for brukeren. I en arbeidsgruppe kan medlemmene samarbeide, for eksempel se hverandres bookinger og møteserveringsordrer via en delt kalender.",
        "company-user-workgroups-calendar-email-label": "E-post for kalender:",
        "company-user-workgroups-empty": "Ingen arbeidsgrupper tilgjengelig.",
        "company-user-sync-warning":
            "Denne brukeren holdes i katalogsynkronisering: navn, e-post og avdeling kan bli overskrevet ved neste synkronisering. Deaktiver brukersynkronisering for å redigere dem permanent.",
        "company-user-field-user-group": "Brukergruppe",
        "company-user-field-user-group-placeholder": "Velg brukergruppe...",
        "company-user-field-department": "Avdeling",
        "company-user-field-department-placeholder": "Velg avdeling...",
        "company-user-field-employee-id": "Ansatt-ID",
        "company-user-field-employee-id-placeholder": "f.eks. 10062",
        "company-user-field-name": "Navn",
        "company-user-field-name-placeholder": "Fullt navn",
        "company-user-field-initials": "Initialer",
        "company-user-field-initials-placeholder": "Fylles ut automatisk fra navn",
        "company-user-field-username": "Brukernavn",
        "company-user-field-username-placeholder": "Genereres automatisk hvis tom",
        "company-user-field-email": "E-post",
        "company-user-field-email-placeholder": "navn@firma.no",
        "company-user-field-mobile": "Mobil",
        "company-user-field-mobile-placeholder": "12 34 56 78",
        "company-user-field-phone": "Telefonnr.",
        "company-user-field-phone-placeholder": "12 34 56 78",
        "company-user-field-language": "Språk",
        "company-user-field-select-placeholder": "Ikke valgt",
        "company-user-language-option-danish": "Dansk",
        "company-user-language-option-english": "Engelsk",
        "company-user-approvals-description": "Velg brukergruppene som denne brukeren godkjenner når medlemmene registrerer seg selv.",
        "company-user-approvals-heading": "Godkjenn brukergrupper",
        "company-user-catalog-description": "En bruker kan få tilgang til én eller flere kantiner; utvid en kantine for å velge prislistene.",
        "company-user-catalog-heading": "Delegerte kantiner / prislister",
        "company-user-catalog-summary-empty": "Ingen kantiner / prislister valgt",
        "company-user-catalog-summary-counts": "{ $count } prislister på tvers av { $canteens } kantiner",
        "company-user-catalog-search-placeholder": "Søk etter kantiner...",
        "company-user-catalog-empty": "Ingen kantiner funnet.",
        "company-user-guest-checkin-description": "Velg om denne brukeren varsles når en gjest sjekker inn.",
        "company-user-guest-checkin-toggle": "Varsle ved gjesteinnsjekking",
        "company-user-details-account-user-id": "Bruker-ID",
        "company-user-details-account-username": "Brukernavn",
        "company-user-details-account-employee-id": "Ansatt-ID",
        "company-user-details-account-user-group": "Brukergruppe",
        "company-user-details-account-department": "Avdeling",
        "company-user-details-account-phone": "Telefon",
        "company-user-details-account-language": "Språk",
        "company-user-details-section-idcard": "ID-kort",
        "company-user-details-idcard-empty": "Ingen ID-kort tilknyttet.",
        "company-user-details-last-signin": "Siste pålogging",
        "company-user-details-never": "Aldri",
        "company-user-details-section-tracking": "Sporing",
        "company-user-details-sync-status": "Brukersynkronisering",
        "company-user-details-sync-source": "Synkroniseringskilde",
        "company-user-details-sync-last-synced": "Sist synkronisert",
        "company-user-details-sync-none": "Ikke synkronisert",
        "company-user-details-section-roles": "Roller",
        "company-user-details-roles-empty": "Ingen roller tildelt.",
        "company-user-details-role-secretary": "Sekretær",
        "company-user-details-edit-button": "Rediger bruker",
        "company-user-details-impersonate-button": "Logg inn som",
        "company-user-details-error-title": "Kunne ikke laste brukeren",
        "company-user-details-error-message": "Noe gikk galt under lasting av denne brukeren. Prøv igjen.",
        "company-user-settings-panel-title": "\n .title = Innstillinger",
        "company-user-settings-active": "Aktiv",
        "company-user-settings-send-invitation": "Send e-postinvitasjon",
        "company-user-settings-send-invitation-helper": "Brukeren mottar en innloggingslenke på e-post.",
        "company-user-settings-disable-sync": "Deaktiver brukersynkronisering",
        "company-user-settings-disable-sync-helper": "Når dette er deaktivert, ignoreres denne brukeren av brukersynkroniseringsjobben.",
        "company-user-settings-secretary": "Sekretær",
        "company-user-settings-secretary-helper": "Får tilgang til sekretærverktøy for å bestille og administrere ordrer på vegne av andre brukere.",
        "company-user-validation-required": "Dette feltet er obligatorisk",
        "company-user-validation-invalid-email": "Skriv inn en gyldig e-postadresse",
        "company-user-validation-invalid-phone": "Skriv inn et gyldig telefonnummer",

        // Company Admin Organization > Users (list & bulk actions)
        "company-users-status-filter-all": "Alle",
        "company-users-status-filter-active": "Aktive",
        "company-users-status-filter-inactive": "Inaktive",
        "company-users-status-active": "Aktiv",
        "company-users-status-inactive": "Inaktiv",
        "company-users-cell-internal-id": "Intern ID: { $id }",
        "company-users-cell-sync-badge": "Sync",
        "company-users-cell-rights": "{ $count -> \n *[other] { $count } rettigheter \n [one] { $count } rettighet \n }",
        "company-users-delete-entity": "bruker",
        "company-users-bulk-status": "\n .title = Status",
        "company-users-bulk-set-active": "\n .title = Aktiv",
        "company-users-bulk-set-inactive": "\n .title = Inaktiv",
        "company-users-bulk-resend-invite": "\n .title = Send invitasjon på nytt",
        "company-users-bulk-move-group": "\n .title = Flytt til gruppe",
        "company-users-bulk-export": "\n .title = Eksporter",
        "company-users-bulk-success": "{ $count } brukere oppdatert",
        "company-users-export-header-name": "Navn",
        "company-users-export-header-first-name": "Fornavn",
        "company-users-export-header-last-name": "Etternavn",
        "company-users-export-header-username": "Brukernavn",
        "company-users-export-header-email": "E-post",
        "company-users-export-header-mobile": "Mobil",
        "company-users-export-header-phone": "Telefon",
        "company-users-export-header-employee-id": "Ansatt-ID",
        "company-users-export-header-user-group": "Brukergruppe",
        "company-users-export-header-department": "Avdeling",
        "company-users-export-header-language": "Språk",
        "company-users-export-header-roles": "Roller",
        "company-users-export-header-user-sync": "Brukersynkronisering",
        "company-users-export-header-last-signin": "Siste innlogging",
        "company-users-export-header-status": "Status",

        // Company Admin Organization > User Groups
        "company-organization-user-groups-title": "Brukergrupper",
        "company-organization-user-groups-header": "\n .title = Brukergrupper",
        "company-organization-user-groups-create-button": "Opprett ny",
        "company-organization-user-groups-table-name-column": "Navn",
        "company-organization-user-groups-table-domain-column": "Domene",
        "company-organization-user-groups-table-status-column": "Status",
        "company-organization-user-groups-table-active-column-active": "Aktiv",
        "company-organization-user-groups-table-active-column-inactive": "Inaktiv",
        "company-organization-user-groups-table-active-column-active-filter-yes": "Aktiv",
        "company-organization-user-groups-table-active-column-inactive-filter-no": "Inaktiv",
        "company-organization-user-groups-table-edit": "Rediger",
        "company-organization-user-groups-table-delete": "Slett",
        "company-organization-user-groups-table-delete-modal-title": "\n .typeOfEntity = brukergruppe",
        "company-organization-user-group-edit-title": "Rediger brukergruppe",
        "company-organization-user-group-create-title": "Opprett brukergruppe",
        "create-user-group-header": "\n .title = Opprett brukergruppe",
        "edit-user-group-header": "\n .title = Rediger brukergruppe",
        "edit-user-group-save-button": "Lagre",
        "create-user-group-save-button": "Opprett",
        "create-or-edit-company-user-group-field-name": "\n .label = Navn\n .placeholder = Skriv inn navn",
        "create-or-edit-company-user-group-field-active": "Aktiv",
        "create-or-edit-company-user-group-settings": "\n .title = Innstillinger",
        "create-or-edit-company-user-group-history": "\n .title = Historikk",
        "create-or-edit-company-user-group-connected-domains": "Tilknyttede domener",
        "create-or-edit-company-user-group-connected-domains-empty": "Du har ikke opprettet noen domener ennå.",
        "create-or-edit-company-user-group-connected-domains-add-button": "\n .title = Legg til domene",
        "create-or-edit-company-user-group-connected-domains-table-domain": "Domene",
        "create-or-edit-company-user-group-connected-domains-table-status": "Status",
        "create-or-edit-company-user-group-connected-domains-table-status-active": "Aktiv",
        "create-or-edit-company-user-group-connected-domains-table-status-pending": "Venter / Invitasjon sendt",
        "create-or-edit-company-user-group-connected-domains-table-resend-invitation": "Send invitasjon på nytt",
        "create-or-edit-company-user-group-connected-domains-table-delete": "Slett",
        "company-organization-user-groups-table-delete-modal-domain": "\n .typeOfEntity = domene",
        "create-or-edit-company-user-group-connected-domains-modal-add-domain": "Legg til domene",
        "create-or-edit-company-user-group-connected-domains-modal-resend-invitation": "Send invitasjon på nytt for domene",
        "create-or-edit-company-user-group-connected-domains-modal-field-domain": "\n .label = Domene\n .placeholder = Skriv inn domene",
        "create-or-edit-company-user-group-connected-domains-modal-field-username": "\n .label = Brukernavn\n .placeholder = Skriv inn brukernavn",
        "create-or-edit-company-user-group-connected-domains-modal-send-invitation": "Send invitasjon",
        "create-or-edit-company-user-group-connected-bill-receiver": "Fakturamottaker",
        "create-or-edit-company-user-group-connected-bill-receiver-empty": "Du har ikke opprettet en fakturamottaker ennå.",
        "create-or-edit-company-user-group-connected-bill-receiver-add-button": "\n .title = Legg til fakturamottaker",
        "create-or-edit-company-user-group-connected-bill-receiver-table-name": "Navn",
        "create-or-edit-company-user-group-connected-bill-receiver-table-address": "Adresse",
        "create-or-edit-company-user-group-connected-bill-receiver-table-end-point": "Endepunkt",
        "create-or-edit-company-user-group-connected-bill-receiver-table-remove": "Fjern",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-add-bill-receiver": "\n .title = Legg til fakturamottaker",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-update-bill-receiver": "\n .title = Fant lignende fakturamottakere. Er du sikker på at du vil opprette en ny?",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-field-search": "\n .label = Søk\n .placeholder = Søk etter navn, CVR, EAN, e-post eller adresse",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-info-text": "Begynn å skrive for å vise søkeresultater",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-info-warning": "Du bør bare opprette en ny fakturamottaker med samme identifikator (CVR, EAN, e-post) hvis kontaktopplysningene avviker. Dette kan for eksempel være nødvendig hvis fakturaen skal sendes til en annen person.",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-empty": "Ingen søkeresultater funnet",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-cvr": "CVR:",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-ean": "EAN:",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-email": "E-post:",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-address": "Adresse:",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-or": "Eller",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-submit-button": "Bruk valgt fakturamottaker",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-submit-update-button": "Oppdater valgt fakturamottaker",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-create-button": " Opprett ny fakturamottaker",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-bill-found": "{ $count } fakturamottaker(e) finnes allerede med samme identifikator.",

        // Company > Admin > Account > GDPR
        "company-account-gdpr-title":"\n .title = GDPR",

        // Company > Admin > Data import
        "data-import-csv-field-update-key": "\n .label = Oppdateringsnøkkel",
        "data-import-csv-settings": "\n .title = Innstillinger",
        "data-import-csv-field-update-identical": "Oppdater identiske",
        "data-import-csv-field-delete-existing": "Slett eksisterende",

        // Company > Admin > Data import > ID cards
        "company-data-import-id-cards-title": "\n .title = Importer ID-kort",
        "create-or-edit-company-id-cards-field-user-group": "\n .label = Brukergruppe",
        "create-or-edit-company-id-cards-select-item-all": "Alle",
        "create-or-edit-company-id-cards-update-key-mode-initials": "Initialer",
        "create-or-edit-company-id-cards-update-key-mode-email": "E-post",
        "create-or-edit-company-id-cards-update-key-mode-employee-number": "Ansattnummer",


        // Company > Admin > Data import > Account number
        "company-data-import-account-numbers-title": "\n .title = Importer kontonumre",
        "create-or-edit-company-account-numbers-field-accounting-dimension": "\n .label = Regnskapsdimensjon",
        "create-or-edit-company-account-numbers-select-item-all": "Alle",
        "create-or-edit-company-account-numbers-update-key-mode-account-number": "Kontonummer",
        "create-or-edit-company-account-numbers-update-key-mode-account-name": "Kontonavn",

        // Company > Admin > Data import > Users
        "company-data-import-users-title": "\n .title = Importer brukere",
        "company-data-import-users-field-user-group": "\n .label = Brukergruppe",
        "company-data-import-users-select-item-from-file": "Fra fil",

        // Company > Admin > Data import > Bill receivers
        "company-data-import-bill-receivers-title": "\n .title = Importer fakturamottakere",
        "company-data-import-bill-receivers-receiver-type": "\n .label = Mottakertype",
        "company-data-import-bill-receivers-receiver-type-mode-private-person": "Privatperson / forening",
        "company-data-import-bill-receivers-receiver-type-mode-public-institution": "Offentlig institusjon",
        "company-data-import-bill-receivers-receiver-type-mode-private-company": "Privat virksomhet",
        "company-data-import-bill-receivers-receiver-type-mode-from-file": "Fra fil",

        // Company > Admin > Settings > Custom jobs
        "company-admin-settings-custom-jobs-title":" \n .title = Egendefinerte jobber",
        "company-admin-settings-custom-jobs-table-name":"Navn",
        "company-admin-settings-custom-jobs-table-interval":"Intervall",
        "company-admin-settings-custom-jobs-table-last-run":"Siste kjøring",
        "company-admin-settings-custom-jobs-table-status":"Status",
        "company-admin-settings-custom-jobs-table-action-details":"Detaljer",
        "company-admin-settings-custom-jobs-table-action-run-job":"Kjør jobb",
        "company-admin-settings-custom-jobs-table-action-activate":"Aktiver",
        "company-admin-settings-custom-jobs-table-action-inactivate":"Deaktiver",

        // Import result
        "import-result-title": "\n .title = Importresultat",
        "import-result-breadcrumb": "Resultat",
        "import-result-succeeded": "Import vellykket",
        "import-result-results": "Resultater:",
        "import-result-created": "Opprettet:",
        "import-result-updated": "Endret:",
        "import-result-deleted": "Slettet:",

        // Company Meeting Service
        "company-meeting-service-title": "Møteservering",
        "company-meeting-service-header": "\n .title = Møteservering",
        "company-meeting-service-table-booked-start-date": "Bokført fra",
        "company-meeting-service-table-booked-end-date": "Bokført til",
        "company-meeting-service-table-merchant": "Salgssted",
        "company-meeting-service-table-order-id-column": "Ordre-ID",
        "company-meeting-service-table-booked-date-column": "Bokføringsdato",
        "company-meeting-service-table-delivery-time-column": "Leveringstid",
        "company-meeting-service-table-employee-column": "Ansatt",
        "company-meeting-service-table-amount-column": "Beløp (DKK)",
        "company-meeting-service-table-show-receipt": "Vis kvittering",
        "company-meeting-service-table-floating-action-bar-receipts": "\n .title = Kvitteringer",
        "company-meeting-service-table-floating-action-bar-export": "\n .title = Eksport",

        // Company Subscriptions
        "company-subscriptions-title": "Abonnementer",
        "company-subscriptions-header": "\n .title = Abonnementer",
        "company-subscriptions-table-subscription-column": "Abonnement",
        "company-subscriptions-table-order-id-column": "Ordre-ID",
        "company-subscriptions-table-employee-column": "Ansatt",
        "company-subscriptions-table-subscribed-column": "Påmeldt",
        "company-subscriptions-table-unsubscribed-column": "Avmeldt",
        "company-subscriptions-table-payment-column": "Betaling",
        "company-subscriptions-table-amount-column": "Beløp",
        "company-subscriptions-table-cancel-subscription": "Avslutt abonnement",
        "company-subscriptions-table-details": "Detaljer",

        // Accounting - POS Purchases
        "accounting-pos-table-header-title": "\n .title = POS",
        "accounting-pos-table-header-nav-item-home": "Hjem",
        "accounting-pos-table-header-nav-item-accounting": "Regnskap",
        "accounting-pos-table-header-nav-item-pos": "POS",
        "accounting-pos-table-header-order-id": "Ordre-ID",
        "accounting-pos-table-header-transaction-time": "Transaksjonstid",
        "accounting-pos-table-header-employee": "Ansatt",
        "accounting-pos-table-header-payment": "Betaling",
        "accounting-pos-table-header-amount": "Beløp (DKK)",
        "support-entity-table-button-show-receipt": "Vis kvittering",
        "accounting-pos-table-header-merchant-label":"\n .label = Salgssted",
        "accounting-pos-table-footer-total-in-period":"Totalt i denne perioden (DKK)",

          // Organization - Users
        "company-organization-users-page-header": "\n .title = Brukere",
        "company-organization-users-table-header-user-group":"Brukergruppe",
        "company-organization-users-table-header-name":"Navn",
        "company-organization-users-table-header-employee-id":"Ansatt-ID",
        "company-organization-users-table-header-email":"E-post",
        "company-organization-users-table-header-status":"Status",
        "company-organization-users-table-status-active":"Aktiv",
        "company-organization-users-table-status-inactive": "Inaktiv",
        "company-organization-users-table-button-details": "Detaljer",
        "company-organization-users-table-button-edit": "Rediger",
        "company-organization-users-table-button-delete": "Slett",
        "company-organization-users-table-button-impersonate": "Logg inn som",
        "company-organization-users-button-create": "Opprett ny",
        "company-organization-users-tooltip-export": "\n .title = Eksport",
        "company-admin-nav-item-organization": "Organisasjon",
        "company-admin-nav-item-users": "Brukere",
        "company-organization-users-table-header-select-label-user-group": "Brukergruppe",
        "company-organization-users-table-header-select-user-group-field": "\n .label = Brukergruppe",
        "company-organization-users-table-header-select-label-workgroup": "Arbeidsgruppe",
        "company-organization-users-table-header-select-workgroup-field": "\n .label = Arbeidsgruppe",
        "company-organization-users-table-header-select-item-all": "Alle",


        // Organization - Admins
        "company-organization-admins-page-header": "\n .title = Administratorer",
        "company-organization-admins-table-header-name":"Navn",
        "company-organization-admins-table-header-email":"E-post",
        "company-organization-admins-table-header-status":"Status",
        "company-organization-admins-table-status-active":"Aktiv",
        "company-organization-admins-table-status-inactive": "Inaktiv",
        "company-organization-admins-table-button-details": "Vis detaljer",
        "company-organization-admins-table-button-edit": "Rediger bruker",
        "company-organization-admins-table-button-delete": "Slett bruker",
        "company-organization-admins-table-button-impersonate": "Logg inn som",
        "merchant-admin-users-table-button-impersonate": "Logg inn som",
        "supplier-admin-account-admins-table-button-impersonate": "Logg inn som",
        "service-center-admin-account-admins-table-button-impersonate": "Logg inn som",
        "supplier-admin-merchant-admins-table-button-impersonate": "Logg inn som",
        "office-manager-admins-table-button-impersonate": "Logg inn som",
        "company-organization-admins-button-create": "Opprett ny",
        "company-admin-nav-item-admins": "Administratorer",
        "impersonation-confirm-dialog":
            "\n .title = Logge inn som { $name }?\n .buttonLabelSubmit = Logg inn som { $firstName }\n .buttonLabelCancel = Avbryt",
        "impersonation-confirm-dialog-message":
            "Du ser portalen nøyaktig slik { $firstName } ser den. Alt du gjør, registreres i { $firstName }s historikk under ditt eget navn.",

        // Company Admin Organization Locations
        "company-organization-locations-title": "Lokasjoner",
        "company-organization-locations-header": "\n .title = Lokasjoner",
        "company-organization-locations-create-button": "Opprett ny",
        "company-organization-locations-table-name-column": "Navn",
        "company-organization-locations-table-status-column": "Status",
        "company-organization-locations-table-active-column-active": "Aktiv",
        "company-organization-locations-table-active-column-inactive": "Inaktiv",
        "company-organization-locations-table-active-column-active-filter-yes": "Aktiv",
        "company-organization-locations-table-active-column-inactive-filter-no": "Inaktiv",
        "company-organization-locations-table-edit": "Rediger",
        "company-organization-locations-table-delete": "Slett",
        "company-organization-locations-table-delete-modal-title": "lokasjon",
        "company-organization-locations-edit-title": "Rediger lokasjon",
        "company-organization-locations-create-title": "Opprett lokasjon",
        "create-location-header": "\n .title = Opprett lokasjon",
        "edit-location-header": "\n .title = Rediger lokasjon",
        "edit-location-save-button": "Lagre",
        "create-location-save-button": "Opprett",
        "create-or-edit-company-location-field-name": "\n .label = Navn\n .placeholder = Skriv inn navn",
        "create-or-edit-company-location-field-is-required": "Feltet er obligatorisk",
        "create-or-edit-company-location-field-active": "Aktiv",
        "create-or-edit-company-location-settings": "\n .title = Innstillinger",
        "create-or-edit-company-location-history": "\n .title = Historikk",
        "create-or-edit-company-location-field-street": "\n .label = Gate\n .placeholder = Skriv inn gate",
        "create-or-edit-company-location-field-streetNumber": "\n .label = Gatenr.\n .placeholder = Skriv inn gatenr.",
        "create-or-edit-company-location-field-postalCode": "\n .label = Postnummer\n .placeholder = Skriv inn postnummer",
        "create-or-edit-company-location-field-city": "\n .label = By\n .placeholder = Skriv inn by",
        "create-or-edit-company-location-field-country": "\n .label = Land",
        "create-or-edit-company-location-field-country-denmark-item": "Danmark",
        "create-or-edit-company-location-field-shops": "\n .label = Tilknyttede butikker",

        // Accounting - Bill receivers
        "company-accounting-bill-receivers-table-header-title": "\n .title = Fakturamottakere",
        "company-accounting-bill-receivers-table-header-name":"Navn",
        "company-accounting-bill-receivers-table-header-endpoint":"Endepunkt",
        "company-accounting-bill-receivers-table-header-debitor-id":"Debitor-ID",
        "company-accounting-bill-receivers-table-header-status":"Status",
        "company-accounting-bill-receivers-table-status-active":"Aktiv",
        "company-accounting-bill-receivers-table-status-inactive": "Inaktiv",
        "company-accounting-bill-receivers-table-button-edit": "Rediger",
        "company-accounting-bill-receivers-table-button-delete": "Slett",
        "company-accounting-bill-receivers-button-create": "Opprett ny",
        "company-accounting-bill-receivers-table-header-nav-item-home": "Hjem",
        "company-accounting-bill-receivers-table-header-nav-item-accounting": "Regnskap",
        "company-accounting-bill-receivers-table-header-nav-item-bill-receivers": "Fakturamottakere",

        // Accounting - Bill receivers - Create Dialog
        "bill-receivers-create-dialog-title": "Opprett fakturamottaker",
        "bill-receivers-create-dialog-customer-type": "Kundetype:",
        "bill-receivers-create-dialog-select-bill-receiver": " Velg eksisterende fakturamottaker:",
        "bill-receivers-create-dialog-country": "Land:",
        "bill-receivers-create-dialog-button-create": "Opprett",
        "bill-receivers-create-dialog-button-save": "Lagre",
        "bill-receivers-form-error-label-country":"Land",
        "bill-receivers-form-error-label-debtor-number":"Debitornummer",
        "bill-receivers-form-error-label-address-line-1":"Adresselinje 1",
        "bill-receivers-form-error-label-address-line-2":"Adresselinje 2",
        "bill-receivers-form-error-label-postal-code":"Postnummer",
        "bill-receivers-form-error-label-city":"By",
        "bill-receivers-form-error-label-telephone":"Telefon",
        "bill-receivers-form-error-label-name":"Navn",
        "bill-receivers-form-error-label-institution-name":"Institusjonsnavn",
        "bill-receivers-form-error-label-email":"E-post",
        "bill-receivers-form-error-label-contact-person":"Kontaktperson",
        "bill-receivers-form-error-label-company-name":"Firmanavn",
        "bill-receivers-validation-ean-13-digits": "EAN-nummer må være 13 sifre",
        "bill-receivers-validation-cvr-8-digits": "CVR-nummer må være 8 sifre",
        "bill-receivers-validation-postal-code-4-digits": "Postnummer må være 4 sifre",
        "bill-receivers-validation-email-invalid": "Skriv inn en gyldig e-postadresse",
        "bill-receivers-validation-telephone-invalid": "Telefon kan bare inneholde sifre samt tegnene + - ( ) og mellomrom",
        "bill-receivers-validation-max-length": "{ $label } kan ha maks. { $max } tegn",
        "bill-receivers-select-type":"Velg type:",
        "bill-receivers-select-list-label": "Velg fakturamottaker",
        "bill-receivers-select-label":"Velg mottaker:",
        "bill-receivers-select-private-person":"Privatperson / forening",
        "bill-receivers-select-email":"E-post",
        "bill-receivers-select-public-institution":"Offentlig institusjon",
        "bill-receivers-select-ean-number":"EAN-nummer",
        "bill-receivers-select-private-company":"Privat selskap",
        "bill-receivers-select-cvr-number":"CVR-nummer",
        "bill-receivers-company-number":"Skriv inn CVR-nummer:",
        "bill-receivers-input-search-label-number-cvr":"\n .label = CVR-nummer",
        "bill-receivers-button-continue":"Fortsett",
        "bill-receivers-send-invoice":"Send faktura til:",
        "bill-receivers-select-label-input-type":"Type",
        "bill-receivers-dropdown-type":"\n .label = Type",
        "bill-receivers-select-item-email":"E-post",
        "bill-receivers-select-item-ean-number":"EAN-nummer",
        "bill-receivers-form-label-address-1":"\n .label = Adresselinje 1\n .placeholder = Gatenavn og gatenummer",
        "bill-receivers-form-label-address-2":"\n .label = Adresselinje 2\n .placeholder = Etasje, leilighetsnr. osv.",
        "bill-receivers-form-label-postal-code":"\n .label = Postnummer",
        "bill-receivers-form-label-city":"\n .label = By",
        "bill-receivers-form-label-country":"\n .label = Land",
        "bill-receivers-form-country-select-da": "Danmark",
        "bill-receivers-form-contact-person":"Kontaktperson",
        "bill-receivers-form-label-contact-person":"\n .label = Kontaktperson",
        "bill-receivers-form-label-email":"\n .label = E-post",
        "bill-receivers-form-label-telephone":"\n .label = Telefon",
        "bill-receivers-form-label-name":"\n .label = Navn",
        "bill-receivers-form-label-institution-name":"\n .label = Institusjonsnavn",
        "bill-receivers-form-label-debtor-number":"\n .label = Debitornummer\n .placeholder = Identifikator for debitor i regnskapssystemet ditt",
        "bill-receivers-form-label-company-name":"\n .label = Firmanavn",
        "bill-receivers-form-label-company-number":"\n .label = CVR-nummer",
        "bill-receivers-input-search-label-email":"\n .label = E-post",
        "bill-receivers-input-search-label-ean-number":"\n .label = EAN-nummer",


        // --- Service center --
        "service-center-home-coming-soon-placeholder": "\n .title = Kommer snart\n .body = Vi jobber med å levere den nye servicesenter-portalen til deg. Bruk https://bestil-nu.net inntil videre.",

        // Navigation
        "service-center-nav-item-home": "Hjem",

        // Navigation > Admin
        "service-center-admin-nav-item-organization-page-header": "\n .title = Organisasjon",
        "service-center-admin-nav-item-organization": "Organisasjon",
        "service-center-admin-nav-item-organization-resources": "Ressurser",
        "service-center-admin-nav-item-organization-devices": "Maskinvareenheter",
        "service-center-admin-nav-item-organization-devices-create": "Opprett enheter",
        "service-center-admin-nav-item-organization-devices-edit": "Rediger enheter",
        "service-center-admin-nav-item-organization-manage-bookings": "Administrer bookinger for bruker",
        "service-center-admin-nav-item-account-page-header": "\n .title = Konto",
        "service-center-admin-nav-item-reports-page-header": "\n .title = Rapporter",
        "service-center-admin-nav-item-statistics": "Statistikk",
        "service-center-admin-home-reports-statistics-card": "\n .title = Statistikk \n .description = Se forbruk, belegg og gjestestatistikk for servicesenteret ditt.",
        "service-center-admin-nav-item-account-administrators": "Administratorer",
        "service-center-admin-nav-item-organization-resource-crate-room": "Opprett rom",
        "service-center-admin-nav-item-organization-resource-update-room": "Oppdater rom",
        "service-center-admin-nav-item-organization-resource-crate-car": "Opprett bil",
        "service-center-admin-nav-item-organization-resource-update-car": "Oppdater bil",
        "service-center-admin-nav-item-organization-resource-crate-mobile-av": "Opprett Mobile AV",
        "service-center-admin-nav-item-organization-resource-update-mobile-av": "Oppdater Mobile AV",
        "service-center-admin-nav-item-communication": "Kommunikasjon",
        "service-center-admin-nav-item-communication-page-header": "\n .title = Kommunikasjon",
        "service-center-admin-nav-item-communication-messages": "Meldinger",
        "service-center-admin-nav-item-communication-reminders": "Påminnelser",
        "service-center-nav-item-messages": "Meldinger",
        "service-center-messages-list-header": "\n .title = Meldinger",
        "service-center-reminders-page-header": "\n .title = Påminnelser",
        "service-center-reminders-create-button": "Opprett ny",
        "service-center-reminders-table-confirmation-content": "Bekreftelse av booking",

        // Service center > Admin > Home >
        "service-center-admin-home-organization-resources-card": "\n .title = Ressurser \n .description = Opprett og administrer ressursene som kan bestilles i servicesenteret ditt.",
        "service-center-admin-home-organization-devices-card": "\n .title = Enheter \n .description = Administrer maskinvareenhetene dine, som romdisplayer og infoskjermer.",
        "service-center-admin-home-organization-manage-bookings-card": "\n .title = Administrer ordrer \n .description = Administrer ordrer som eies av en bruker. \n .buttonText = Administrer",
        "service-center-admin-home-account-administrators-card": "\n .title = Administratorer \n .description = Administrer administratorene for forhandleren din.",
        "service-center-admin-home-communication-messages-card": "\n .title = Push-meldinger \n .description = Send og administrer push-meldinger.",
        "service-center-admin-home-communication-reminders-card": "\n .title = Påminnelser \n .description = Administrer påminnelser som deles på tvers av ressurser.",


        // --- User --

        // Navigation
        "user-nav-item-home": "Hjem",
        "user-nav-item-archive-title": "\n .title = Arkiv" ,
        "user-nav-item-archive": "Arkiv",
        "user-nav-item-settings": "Innstillinger" ,
        "user-nav-item-wallets-title": "\n .title = Wallets" ,
        "user-nav-item-wallets": "Wallets",
        "user-nav-item-wallets-refill": "Påfyll",
        "user-nav-item-home-label": "\n .title = Gå til hjem-dashbordet" ,
        "user-nav-item-calendar-label": "\n .title = Vis kalender med ordrer" ,
        "user-nav-item-archive-label": "\n .title = Vis arkiverte ordrer" ,
        "user-nav-item-settings-label": "\n .title = Innstillinger",
        "user-nav-bottom-bar-home-label": "Hjem",
        "user-nav-bottom-bar-calendar-label": "Kalender",
        "user-nav-bottom-bar-archive-label": "Arkiv",
        "user-nav-bottom-bar-settings-label": "Innstillinger",

        // User > Home > Top bar
        "user-home-top-bar-tab-switcher-overview": "Oversikt",
        "user-home-top-bar-tab-switcher-upcoming": "Kommende",

        // User > Home > Top bar > News drawer
        "user-home-top-bar-news-title": "\n .title = Facilitynet-nyheter",
        "user-home-top-bar-news-no-notifications": "\n .title = Ingen meldinger akkurat nå\n .description = Her kan du lese meldinger fra salgsstedet og servicesenteret.",
        "user-home-top-bar-news-notification-time-type-news": "Nyhet",
        "user-home-top-bar-news-notification-time-type-info": "Informasjon",
        "user-home-top-bar-news-notification-time-type-important": "Viktig",
        "user-home-top-bar-news-notification-time-type-offer": "Tilbud",
        "user-home-top-bar-news-notification-time-type-event": "Arrangement",
        "user-home-top-bar-news-notification-time-type-reminder": "Påminnelse",
        "user-home-top-bar-news-notification-time-type-menu-change": "Meny",
        "user-home-top-bar-news-notification-time-type-feedback": "Tilbakemelding",
        "user-home-top-bar-news-notification-time-type-health": "Helse",
        "user-home-top-bar-news-notification-sender-type-merchant": "Salgssted",
        "user-home-top-bar-news-notification-sender-type-service-center": "Service",
        "user-home-top-bar-news-notification-menu-title": "Meldinger",

        // User > Home > Week menus
        "user-home-week-menu-title": "Ukens meny",
        "user-home-week-menu-no-menus-title": "Ingen meny tilgjengelig",
        "user-home-week-menu-no-menus": "Dessverre er det ikke opprettet noen menyer denne uken.",
        "user-home-week-menu-no-menus-today": "Ingen meny for denne dagen",
        "user-home-top-bar-location-button-empty": "Velg lokasjon",
        "user-home-week-menu-select-location-dialog-title": "Bytt lokasjon",
        "user-home-week-menu-select-location-dialog-title-first-time": "Velg lokasjon",
        "user-home-week-menu-select-location-search-filter": "\n .placeholder = Søk på navn, adresse, butikknummer...",
        "user-home-week-menu-select-location-dialog-kitchen-item-button": "Velg",
        "user-home-week-menu-dialog-title": "Dagens meny",
        "user-home-week-menu-dialog-allergens": "Allergener:",


        // User > Home >Dashboard
        "user-home-upcoming-orders": "Kommende ordrer",
        "user-home-reminders-check-out-title": "Sjekk ut gjester ({ $count })",
        "user-home-reminders-check-out-button": "Sjekk ut",
        "user-home-reminders-check-in-title": "Sjekk inn i { $roomName } før { $deadline }",
        "user-home-reminders-check-in-button": "Sjekk inn",
        "user-home-reminders-check-out-dialog": "\n .title = Sjekk ut gjester\n .message = Velg gjestene som går.\n .buttonLabelSubmit = { $count ->\n [0] Sjekk ut\n *[other] Sjekk ut ({ $count })\n }\n .buttonLabelCancel = Avbryt",
        "user-home-reminders-check-out-dialog-guests-title": "Gjester ({ $count })",
        "user-home-reminders-check-out-dialog-select-all-checkbox": "\n .label = Velg alle",
        "user-home-reminders-check-out-dialog-guest-checked-in": "Sjekket inn { $time }",
        "user-home-reminders-check-out-dialog-success": "{ $count ->\n [one] Gjest sjekket ut\n *[other] { $count } gjester sjekket ut\n}",
        "user-home-reminders-check-in-dialog": "\n .title = Sjekk inn i møterom\n .message = Bekreft at møtet ditt har startet.\n .buttonLabelSubmit = Sjekk inn\n .buttonLabelCancel = Avbryt",
        "user-home-reminders-check-in-dialog-deadline-label": "Før",
        "user-home-reminders-check-in-dialog-note": "Hvis ingen sjekker inn før { $deadline }, frigis rommet og blir tilgjengelig for andre.",
        "user-home-reminders-check-in-dialog-success": "Du er sjekket inn",
        "user-home-canteen": "Kantine",
        "user-home-canteen-offers": "Tilbud",
        "user-home-canteen-today-menu": "Dagens meny",
        "user-home-canteen-today-menu-show-menu": " Vis menyskilt...",
        "user-home-canteen-news": "Nyheter",
        "user-home-upcoming-meetings": "Møter",
        "user-home-upcoming-meetings-modal-title": "\n    .title = Møter",
        "user-home-upcoming-takeaway-modal-title": "\n    .title = Takeaway",
        "user-home-upcoming-canteen-purchases-modal-title": "\n    .title = Kantinekjøp",
        "user-home-upcoming-meetings-no-meetings": "Ingen møter i perioden\n    .title = Ingen møter i perioden",
        "user-home-meeting-day-today": "I dag",
        "user-home-meeting-day-tomorrow": "I morgen",
        "user-home-meeting-day-unknown": "Uten dato",
        "user-home-upcoming-meeting-min-left":
            "{ $hours ->\n    [0] { $minutes } min igjen\n   *[other] { $minutes ->\n        [0] { $hours } t igjen\n       *[other] { $hours } t { $minutes } min igjen\n    }\n}",
        "user-home-upcoming-meeting-service-sub-title": "Møteservering",
        "user-home-meetings-collapse": "Skjul møter",
        "user-home-meetings-expand": "Vis møter",
        "user-home-meetings-panel-actions": "\n .collapseAriaLabel = { user-home-meetings-collapse }\n .expandAriaLabel = { user-home-meetings-expand }",
        "user-home-panel-action-show-all": "\n    .title = Vis alle",
        "user-home-empty-offers-text": "Du har ingen tilbud akkurat nå",
        "user-home-upcoming-purchases": "Kjøp",
        "user-home-upcoming-purchases-load-error": "Kunne ikke laste kjøp",
        "user-home-wallet-my-wallet": "Min wallet",
        "user-home-wallets-section-title": "Wallets",
        "user-home-subscriptions-section-title": "Abonnementer",
        "user-home-subscription-card-used-count": "{ $used } av { $total }",
        "user-home-subscription-card-used-this-week": "brukt denne uken",
        "user-home-subscription-card-used-this-month": "brukt denne måneden",
        "user-home-subscription-card-active-from": "Aktiv fra: { $date }",
        "user-home-subscription-card-expires": "Utløper: { $date }",
        "user-home-upcoming-purchase-card-title-lunch": "Lunsjordre",
        "user-home-upcoming-purchase-card-title-take-away": "Takeaway",
        "user-home-upcoming-purchase-card-title-pos": "Lunsjordre",
        "user-home-upcoming-purchase-card-title-lunch-subscription": "Lunsjabonnement",
        "user-home-upcoming-purchases-no-purchases": "Ingen kommende kjøp",
        "user-home-upcoming-canteen-purchases": "Kantinekjøp",
        "user-home-upcoming-canteen-purchases-no-purchases": "Ingen kantinekjøp i perioden\n    .title = Ingen kantinekjøp i perioden",
        "user-home-canteen-purchases-collapse": "Skjul kantinekjøp",
        "user-home-canteen-purchases-expand": "Vis kantinekjøp",
        "user-home-upcoming-takeaway": "Takeaway",
        "user-home-upcoming-takeaway-no-orders": "Ingen takeaway i perioden\n    .title = Ingen takeaway i perioden",
        "user-home-takeaway-collapse": "Skjul takeaway",
        "user-home-takeaway-expand": "Vis takeaway",
        "user-home-upcoming-meeting-service-approved": "\n .label = Godkjent",
        "user-home-upcoming-meeting-service-approved-tooltip":  "\n .label = Ordren er godkjent av salgsstedet.",
        "user-home-upcoming-meeting-service-sittings": "{ $sittings } kuverter",
        "user-home-upcoming-meeting-service-attendees": "{ $attendees } deltakere",
        "user-home-upcoming-meeting-service-locked": "Låst",
        "user-home-upcoming-purchases-check-in-reminder": "Påminnelse om innsjekking",
        "user-home-upcoming-purchases-learn-more": "Se mer",
        "user-home-upcoming-purchases-check-in-subtitle": "Husk å sjekke inn i kantinen i dag.",
        "user-home-canteen-contact-canteen": "Kontakt kantinen",
        "user-dashboard-error-offers-unavailable": "Tilbudene er midlertidig utilgjengelige.",
        "user-dashboard-error-week-menu-unavailable": "Ukemenyen er midlertidig utilgjengelig.",
        "user-dashboard-error-news-menu-unavailable": "Nyhetsmenyen er midlertidig utilgjengelig.",
        "user-dashboard-error-merchant-contact-unavailable": "Kontaktopplysninger for forhandleren er midlertidig utilgjengelige.",
        "user-home-canteen-news-category-company": "\n .label = Bedrift",
        "user-home-canteen-news-category-service-center": "\n .label = Servicesenter",
        "user-home-canteen-news-category-kitchen": "\n .label = Kjøkken",
        "user-home-canteen-news-category-no-actions":  "Ingen handlinger tilgjengelig for ordre #{ $orderId }",
        "user-home-canteen-upcoming-orders-dialog-ok-button": "Ok",
        "user-home-canteen-upcoming-orders-cancel-order-item": "Avbestill ordre",
        "user-home-canteen-upcoming-orders-cancel-booking-item": "Avbestill booking",
        "user-home-canteen-upcoming-orders-delete-order": "Slett ordre",
        "user-home-canteen-upcoming-orders-delete-order-restriction-message": "Du har ikke tillatelse til å slette denne ordren",
        "user-home-canteen-upcoming-orders-refund-order": "Refunder ordre",
        "user-home-canteen-upcoming-orders-refund-order-restriction-message": "Du har ikke tillatelse til å refundere denne ordren",
        "user-home-canteen-upcoming-orders-receipt-item": "Kvittering",
        "user-home-canteen-upcoming-orders-edit-item": "Rediger",
        "user-home-canteen-upcoming-orders-update-booking-restriction-message": "Du har ikke tillatelse til å oppdatere booking",
        "user-home-canteen-upcoming-orders-extend-booking-item": "Forleng booking",
        "user-home-canteen-upcoming-orders-extend-booking-restriction-message": "Du har ikke tillatelse til å forlenge booking",
        "user-home-canteen-upcoming-orders-end-booking-restriction-message": "Du har ikke tillatelse til å avslutte booking",
        "user-home-canteen-upcoming-orders-update-meeting-service-item-meeting-service": "Oppdater",
        "user-home-canteen-upcoming-orders-update": "Rediger",
        "user-home-canteen-upcoming-orders-update-meeting-restriction-message": "Du har ikke tillatelse til å oppdatere denne ordren",
        "user-home-canteen-upcoming-orders-duplicate-meeting-service-item-meeting-service": "Dupliser",
        "user-home-canteen-upcoming-orders-duplicate-meeting-service-item-resource-booking": "Dupliser møteservering",
        "user-home-canteen-upcoming-orders-duplicate-meeting-service-restriction-message": "Du har ikke tillatelse til å duplisere denne ordren",
        "user-home-canteen-upcoming-orders-end-modal-confirm": "Bekreft",
        "user-home-canteen-upcoming-orders-cancel-modal-confirm": "Avbryt",
        "user-home-canteen-upcoming-orders-extend-modal-title": "Forleng booking",
        "user-home-canteen-upcoming-orders-extend-modal-subtitle": "Vil du forlenge bookingen { $meetingName } til { $meetingTime }?",
        "user-home-canteen-upcoming-orders-extend-modal-max-error": "Maksimal tilgjengelig tid er { $maxAvailableMinutes } minutter.",
        "user-home-canteen-upcoming-orders-extend-input-custom-time": "\n .label = Velg sluttidspunkt:",
        "user-home-canteen-upcoming-orders-extend-other-button": "Annet",
        "user-home-canteen-upcoming-orders-delete-modal-error": "Kunne ikke slette ordren",
        "user-home-canteen-upcoming-orders-delete-modal-booking-label": "\n .label = Avbestill booking",
        "user-home-canteen-upcoming-orders-delete-modal-meeting-label": "\n .label = Avbestill møteservering",
        "user-home-canteen-upcoming-orders-cancel-modal":
            "\n .title = Avbestill { $itemType ->\n [order] ordre\n *[booking] booking\n }\n .message = Er du sikker på at du vil avbestille { $itemType ->\n [order] ordren\n *[booking] bookingen\n } '{ $itemName }'?\n .buttonLabelSubmit = Avbestill { $itemType ->\n [order] ordre\n *[booking] booking\n }\n .buttonLabelCancel = Tilbake",
        "user-home-canteen-upcoming-orders-cancel-started-modal":
            "\n .title = Avbestill booking\n .message = Møtet #{ $orderId }, { $meetingName } har allerede startet, så bookingen avsluttes nå i stedet for å bli slettet. Vil du fortsette?\n .buttonLabelSubmit = Avbestill booking\n .buttonLabelCancel = Tilbake",
        "user-home-canteen-upcoming-orders-cancel-ended-booking-message": "Møtet er allerede over, så bookingen kan ikke lenger avbestilles.",
        "user-home-meeting-service-action-update-booking": "Oppdater booking",
        "user-home-meeting-service-action-edit": "Rediger ordre",
        "user-home-meeting-service-action-update-meeting-service": "Oppdater møteservering",
        "user-home-meeting-service-action-duplicate-meeting-service": "Dupliser ordre",
        "user-home-meeting-service-description-update-booking": "Er du sikker på at du vil oppdatere booking #{ $orderId }, { $meetingName }?",
        "user-home-meeting-service-description-update-meeting-service-catering": "Vil du oppdatere ordre #{ $orderId }, { $meetingName } med levering { $deliveryDate }?",
        "user-home-meeting-service-description-update-meeting-service": "Vil du oppdatere ordre #{ $orderId }, { $meetingName } for møte { $deliveryDate }?",
        "user-home-meeting-service-description-duplicate-meeting-service": "Vil du duplisere ordre #{ $orderId }, { $meetingName } med levering { $deliveryDate }?",
        "user-home-meeting-service-action-confirm-modal-meeting-name": "Møtenavn:",
        "user-home-meeting-service-action-confirm-modal-delivery-date-name": "Leveringsdato:",
        "user-home-meeting-service-action-confirm-modal-order-id": "Ordre-ID:",
        "user-home-canteen-upcoming-orders-extend-success-dialog-title": "Bookingen ble forlenget",
        "user-home-canteen-upcoming-orders-delete-success-dialog-title": "Bookingen ble avbestilt",
        "user-home-canteen-upcoming-orders-delete-order-success-dialog-title":
            "{ $ordersCount ->\n *[one] Ordren ble slettet\n [other] Ordrene ble slettet\n }",
        "user-home-canteen-upcoming-orders-end-success-dialog-title": "Bookingen ble avsluttet",


        // User > Home > Offers
        "user-home-offers-title": "Tilbud",

        // User > Home > Offers
        "user-home-news-from-kitchen": "Nyheter fra kjøkkenet",


         // User > Home > Opening hours
        "user-home-opening-hours-title": "Åpningstider",
        "user-home-opening-day-1": "Man:",
        "user-home-opening-day-2": "Tir:",
        "user-home-opening-day-3": "Ons:",
        "user-home-opening-day-4": "Tor:",
        "user-home-opening-day-5": "Fre:",

        // User > Home > Room finder
        "user-homeroom-finder-title": "Romfinner",
        "user-home-room-finder-resource-type-dropdown": "\n .label = Ressurstype",
        "user-home-room-finder-resource-date": "\n .label = Dato:",
        "user-home-room-finder-resource-duration": "\n .label = Varighet:",
        "user-home-room-finder-resource-time": "Tid:",
        "user-home-room-finder-resource-seats": "Plasser:",
        "user-home-room-finder-resource-book-button": "Book ({ $amount })",
        "user-home-room-finder-resource-results-amount": "{ $amount } resultater",
        "user-home-room-finder-resource-select-button": "Velg",
        "user-home-room-finder-resource-unselect-button": "Fjern",
        "user-home-room-finder-go-to-timeline-button": "Gå til tidslinje",
        "user-home-room-finder-subtitle": "Din intelligente følgesvenn for å finne ressurser.",
        "user-home-room-finder-find-a-room-button": "Finn et rom",
        "user-home-room-finder-available-rooms": "ledige rom",
        "user-home-room-finder-available-time-slot": "fra { $timeSlot }",


        // User > Upcoming orders > Meeting service
        "user-upcoming-orders-meeting-service-title": "\n .title = Møteservering",

        // User > Upcoming orders > Resource bookings
        "user-upcoming-orders-resource-booking-table-id": "Ordre-ID",
        "user-upcoming-orders-resource-booking-table-time": "Tid",
        "user-upcoming-orders-resource-booking-table-meeting": "Møte",
        "user-upcoming-orders-resource-booking-table-visibility": "Synlighet",
        "user-upcoming-orders-resource-booking-table-visibility-public": "Offentlig",
        "user-upcoming-orders-resource-booking-table-visibility-public-tooltip": "Bookingen er offentlig, noe som betyr at møtenavnet og deltakernes navn er synlige for kolleger.",
        "user-upcoming-orders-resource-booking-table-visibility-private": "Privat",
        "user-upcoming-orders-resource-booking-table-visibility-private-tooltip": "Bookingen er privat, noe som betyr at møtenavnet og deltakernes navn ikke er synlige for noen.",
        "user-upcoming-orders-resource-booking-table-action-delete": "Slett",
        "user-upcoming-orders-resource-booking-table-remove-dialog": "\n .title = Fjern booking\n .message = Er du sikker på at du vil fjerne bookingen?\n .buttonLabelSubmit = Fjern",


        // User > Settings
        "user-settings-page-title": "\n .title = Innstillinger",
        "user-settings-tab-bill-receivers": "Mine fakturamottakere",
        "user-settings-tab-guest-reception": "Gjestemottak",
        "user-settings-tab-calendar-sharing": "Kalenderdeling",
        "user-settings-tab-access-control": "Adgangskontroll",
        "user-settings-table-header-name": "Navn",
        "user-settings-table-header-address": "Adresse",
        "user-settings-table-header-endpoint": "Endepunkt",
        "user-settings-table-header-status": "Status",
        "user-settings-status-active": "Aktiv",
        "user-settings-status-inactive": "Inaktiv",
        "user-settings-status-pending": "Venter",
        "user-settings-action-edit": "Rediger",
        "user-settings-action-delete": "Slett",
        "user-settings-action-activate": "Aktiver",
        "user-settings-action-deactivate": "Deaktiver",
        "user-settings-coming-soon": "Kommer snart",
        "user-settings-bill-receivers-info": "\n .title = Her er dine personlige fakturamottakere, som du kan velge når du bestiller møteservering. Du har mulighet til å opprette en ny fakturamottaker under bestillingsprosessen, hvis den valgte kantinen tillater det.",
        "user-settings-delete-bill-receiver-dialog": "\n .typeOfEntity = fakturamottaker",
        "user-settings-edit-bill-receiver-dialog-title": "Rediger fakturamottaker",
        "user-settings-edit-bill-receiver-page-header": "\n .title = Rediger fakturamottaker",
        "user-settings-edit-bill-receiver-name-field": "\n .label = Navn",
        "user-settings-edit-bill-receiver-vatnumber-field": "\n .label = CVR-nummer",
        "user-settings-edit-bill-receiver-address-panel": "\n .title = Adresse",
        "user-settings-edit-bill-receiver-endpoint-panel": "\n .title = Fakturamottaker",
        "user-settings-edit-bill-receiver-endpoint-type-field": "\n .label = Type",
        "user-settings-edit-bill-receiver-endpoint-value-field": "\n .label = Verdi",
        "user-settings-edit-bill-receiver-contact-panel": "\n .title = Kontaktperson",
        "user-settings-edit-bill-receiver-settings-panel": "\n .title = Innstillinger",
        "user-settings-edit-bill-receiver-active-switch": "Aktiv",
        "user-settings-edit-bill-receiver-save-button": "Lagre",
        "user-nav-item-edit-bill-receiver": "Rediger fakturamottaker",

        // User > Settings > Wallets
        "user-settings-wallets-title": "\n .title = Wallets",

        // User > Wallets > Refill
        "user-wallets-refill-title": "\n .title = Fyll på wallet",
        "user-wallets-refill-manual-top-up-nav-tab": "Manuelt påfyll",
        "user-wallets-refill-automatic-top-up-nav-tab": "Automatisk påfyll",
        "user-wallets-refill-manual-type": "\n .statusLabel = Manuell",
        "user-wallets-refill-automatic-type": "\n .statusLabel = Automatisk",
        "user-wallets-refill-payment-success": "Ordre behandlet",
        "user-wallets-refill-payment-unexpected-error": "Det oppstod en uventet feil",
        "user-wallets-refill-payment-timeout": "Betalingen fikk tidsavbrudd",
        "user-wallets-refill-payment-wait-label": "Behandler betaling",
        "user-wallets-refill-payment-wait-description":  "Vent mens vi behandler betalingen din. Dette kan ta et øyeblikk.",
        "user-wallets-refill-payment-back-action-button-label": "Tilbake til dashbordet",
        "user-wallets-refill-payment-timeout-label": "Betalingen fikk tidsavbrudd",
        "user-wallets-refill-payment-timeout-description": "Vi har ikke mottatt bekreftelse fra betalingsleverandøren din. Sjekk nettbanken din for å være sikker på at betalingen ble gjennomført.",
        "user-wallets-refill-payment-canceled-label":  "Betaling avbrutt",
        "user-wallets-refill-payment-canceled-description":  "Du har avbrutt betalingsprosessen. Ingenting er trukket fra kontoen din.",
        "user-wallets-refill-payment-failed-label": "Betalingen mislyktes.",
        "user-wallets-refill-payment-failed-description": "Betalingen din kunne ikke gjennomføres. Bekreft opplysningene dine, og prøv igjen.",

        // User > Wallets > Refill > Manual tab
        "user-wallets-refill-manual-main-amount-label": "\n .label = Beløp",
        "user-wallets-refill-manual-main-amount-error":"Wallet-en din kan ikke overstige { $maxBalance}. Du kan maksimalt fylle på { $maxRefillAmount }",
        "user-wallets-refill-manual-main-amount-max-error":"Maksimalt beløp for påfyll er { $maxRefillAmount }",
        "user-wallets-refill-manual-main-amount-zero-error":"Beløpet må være større enn 0",
        "user-wallets-refill-auto-amount-max-threshold-error":"Maksimal grense er { $maxThreshold }",
        "user-wallets-refill-payment-method-error":"Betalingsmåte er påkrevd",
        "user-wallets-refill-manual-main-custom-amount-label": "\n .label = Skriv inn beløp:",
        "user-wallets-refill-manual-main-amount-amount-100": "100,00 kr",
        "user-wallets-refill-manual-main-amount-amount-300": "300,00 kr",
        "user-wallets-refill-manual-main-amount-amount-500": "500,00 kr",
        "user-wallets-refill-manual-main-amount-amount-other": "Annet",
        "user-wallets-refill-manual-main-payment-method": "Betalingsmåter:",
        "user-wallets-refill-manual-main-select-payment-method": "Velg betalingsmåte",
        "user-wallets-refill-manual-main-perform-refill-button": "Bekreft betaling",
        "user-wallets-refill-select-card-dialog-title": "Velg wallet",
        "user-wallets-refill-select-card-dialog-no-wallets": " Forhandleren tilbyr ikke digitale wallets til bedriften din.",
        "user-wallets-refill-select-card-balance": "Saldo:",


        // User > Wallets > Refill > Auto tab
        "user-wallets-refill-auto-activate-card-title": "Aktiver automatisk påfyll",
        "user-wallets-refill-auto-activate-modal-title": "Aktiver automatisk påfyll",
        "user-wallets-refill-auto-activate-modal-threshold-placeholder": "\n .label = Beløp (DKK)",
        "user-wallets-refill-auto-activate-modal-threshold-subtitle": "Når saldoen faller under:",
        "user-wallets-refill-auto-activate-modal-refill-subtitle": "Fyll på med beløp:",
        "user-wallets-refill-auto-activate-modal-submit-button": "Aktiver automatisk påfyll",
        "user-wallets-refill-auto-activate-modal-update-button": "Oppdater automatisk påfyll",
        "user-wallets-refill-auto-activate-modal-delete-button": "Slett automatisk påfyll",
        "user-wallets-refill-auto-activate-success-modal-subtitle": "Automatisk påfyll aktivert",


        // User > Archive > Drawer
        "user-archive-drawer-resource-booking": "Ressursbooking",
        "user-archive-drawer-meeting-service": "Møteservering",
        "user-archive-drawer-daily-purchases": "Daglige kjøp",
        "user-archive-drawer-refill-wallet": "Påfyll",

        // User > Archive > Drawer > Transactions
        "user-archive-transactions-table-id": "Ordre-ID",
        "user-archive-transactions-table-transaction-time": "Transaksjonstidspunkt",
        "user-archive-transactions-table-delivery-time": "Leveringstidspunkt",


         // User > Archive > Meeting service
        "user-archive-meeting-service-title": "\n .title = Møteservering",
        "user-archive-meeting-service-info-box": "I arkivet kan du bare se møteserveringsordrer som er bokført av salgsstedet.",
        "user-archive-meeting-service-table-id": "Ordre-ID",
        "user-archive-meeting-service-table-booked-date": "Bokføringsdato",
        "user-archive-meeting-service-table-delivery-time": "Leveringstidspunkt",
        "user-archive-meeting-service-table-meeting": "Møte",
        "user-archive-meeting-service-table-amount": "Beløp",
        "user-archive-meeting-service-table-action-receipt": "Kvittering",
        "user-archive-meeting-service-table-action-duplicate": "Dupliser",
        "user-archive-meeting-service-table-action-send-message": "Send melding",
        "user-archive-meeting-service-table-filter-start-date": "Startdato",
        "user-archive-meeting-service-table-filter-end-date": "Sluttdato",



        // Standard components

        // Standard components > Filter button
        "table-filters-button": "\n .title = Filtre\n .aria-label = Filtre",

        // Create order
        "create-order-access-denied-on-behalf-of": "Du har ikke tilgang til å bestille på vegne av den valgte brukeren.",
        "create-order-confirm-order-button": "Neste",
        "create-order-meeting-service-mobile-bar-continue-button": "Fortsett",
        "create-order-meeting-service-mobile-back-to-products-button": "Tilbake til produkter",
        "create-order-book-button": "Reserver",
        "create-order-update-button": "Oppdater",
        "create-order-undo-button": "\n .title = Angre alt",
        "create-order-wish": "\n .title = Ønske",
        "create-order-wish-dialog-title": "\n .dialogTitle = Legg til produktønske",
        "create-order-order-line-dialog-title": "\n .dialogTitle = Legg til produkt",
        "create-order-wish-dialog-edit-price-title": "\n .dialogTitle = Angi pris",
        "create-order-wish-dialog-message": "Hvis du legger til et produktønske, må ordren din godkjennes manuelt av butikkeieren.",
        "create-order-wish-dialog-product-name-field": "\n .label =Produktnavn \n .placeholder =Skriv inn produktnavn:",
        "create-order-wish-dialog-product-items-field": "\n .label =Antall \n .placeholder =Skriv inn antall:",
        "create-order-wish-dialog-product-price-field": "\n .label =Produktpris \n .placeholder =Skriv inn pris (DKK):",
        "create-order-wish-dialog-submit-button": "Bekreft",
        "create-order-wish-dialog-product-name-max-length": "Produktnavnet kan ikke overstige { $maxLength } tegn",
        "create-order-wish-dialog-quantity-min-value": "Antallet må være minst 1",
        "create-order-wish-dialog-quantity-max-value": "Antallet kan ikke overstige { $max }",
        "create-order-wish-dialog-price-min-value": "Prisen må være større enn 0",
        "create-order-wish-dialog-price-max-value": "Prisen kan ikke overstige { $max }",
        "create-order-favorite": "\n .title = Se favorittproduktene mine",
        "create-order-favorite-show-all-products": "\n .title = Vis alle produkter",
        "create-order-list": "\n .title = Vis en liste over produkter",
        "create-order-grid": "\n .title = Vis et rutenett med produkter",
        "create-order-products-empty": "Ingen resultater",
        "create-order-product-staff-only-tag": "Kun for ansatte",
        "create-order-product-sale-text": "Bare 10 igjen",
        "offer-tag-good-price": "God pris",
        "offer-tag-great-offer": "Flott tilbud",
        "offer-tag-buy-now": "Kjøp nå",
        "offer-tag-discount": "Tilbud",
        "offer-tag-week-offer": "Ukens tilbud",
        "offer-tag-day-offer": "Dagens tilbud",
        "offer-tag-save-x-price": "Spar { $amount } kr",
        "offer-tag-save-x-percentage": "Spar { $amount }",
        "offer-tag-limited-on-sale": "{ $amount } igjen",
        "offer-tag-available-from": "Tilgjengelig fra: { $date }",
        "create-order-tooltip-order-summary-button": "\n .title = Vis ordreoversikt",
        "create-order-order-summary-no-items": "Ordreoversikten er tom. Legg til varer i ordren for å se detaljene.",
        "create-order-order-summary": "Ordreoversikt",
        "create-order-order-summary-resources": "\n .title = Ressurser",
        "create-order-order-summary-resources-booking-time": "Booking",
        "create-order-order-summary-meeting-services": "\n .title = Møteservering",
        "create-order-order-summary-meeting-services-delivery-time": "Levering { $number }",
        "create-order-order-summary-meeting-services-total": "Totalt",
        "create-order-order-summary-meeting-services-empty": "Ingen varer lagt til ennå",
        "create-order-order-summary-meeting-services-add-order-line-button": "+ Legg til ordrelinje",
        "create-order-order-summary-meeting-services-wish-set-price-button": "Angi pris",
        "create-order-order-summary-meeting-services-wish-edit-price-button": "\n .title = Rediger pris\n .aria-label = Rediger pris",
        "create-order-order-summary-meeting-services-product-item": "{$count} vare",
        "create-order-order-summary-meeting-services-product-items": "{$count} varer",
        "create-order-order-summary-meeting-services-product-warning-price-list-tooltip": "\n .title = Den valgte prislisten samsvarer ikke med produktets prisliste — økning er ikke tilgjengelig.",
        "create-order-order-summary-meeting-services-product-warning-missing-product-tooltip": "\n .title = Dette produktet er ikke tilgjengelig i den valgte prislisten",
        "create-order-order-summary-meeting-services-product-staff-only-tooltip": "\n .title = Bare forhandleren kan endre denne varen",
        "create-order-order-summary-meeting-services-legacy-extra-service-tooltip": "\n .title = Dette er en eldre ekstratjeneste fra den gamle portalen. Den kan ikke endres, men den kan fjernes.",
        "create-order-order-summary-meeting-services-wish-locked-quantity-tooltip": "\n .title = Bare forhandleren kan endre antallet i et produktønske",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog": "\n .dialogTitle = Priser oppdatert",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-message": "Noen priser er endret siden ordren ble opprettet. Gå gjennom nedenfor for å fortsette.",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-section-price-changed": "Pris endret ({ $count })",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-section-missing-product": "Ikke tilgjengelig i prislisten { $priceList } ({ $count })",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-section-other-price-list": "Fra en annen prisliste ({ $count })",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-section-unchanged-hint": "Prisen på disse varene forblir som den er i ordren.",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-submit-button": "Oppdater",
        "create-order-order-summary-meeting-services-invalid-time-card-empty-title": "Levering uten varer",
        "create-order-order-summary-meeting-services-invalid-time-card-empty": "Ingen varer ble lagt til i leveringen kl. {$time}. Legg til varer eller fjern leveringstidspunktet.",
        "create-order-order-summary-meeting-services-invalid-times-card-empty": "Ingen varer ble lagt til i leveringen kl. {$time}. Legg til varer eller fjern leveringstidspunktene.",
        "create-order-order-summary-meeting-services-invalid-times-card-empty-button": "Ok",
        "create-order-confirm-booking-meeting-details": "Møtedetaljer",
        "create-order-outlook-private-meeting-default-name": "Privat møte",
        "create-order-outlook-on-behalf-of-chip": "På vegne av { $name }",
        "create-order-confirm-booking-update-meeting-details": "Oppdater møtedetaljer #{ $id }",
        "create-order-confirm-booking-dialog-add-attendees": "Legg til deltakere",
        "create-order-confirm-booking-dialog-back-button": "Tilbake",
        "create-order-confirm-booking-meeting-information-tab": "Møteinformasjon",
        "create-order-confirm-booking-participants-tab": "Deltakere",
        "create-order-confirm-booking-other-tab": "Annet",
        "create-order-confirm-booking-dialog-confirm-button": "Bekreft",
        "create-order-confirm-booking-dialog-submit-button": "Fullfør booking",
        "create-order-confirm-booking-dialog-add-attendee-button": "Legg til deltakere",
        "create-order-confirm-booking-dialog-bulk-add-attendees-drawer-button": "Legg til deltakere",
        "create-order-confirm-booking-dialog-bulk-add-attendees-button": "Kopier og lim inn",
        "create-order-confirm-booking-dialog-bulk-add-attendees-button-tooltip": "\n .title = Legg til flere deltakere ved å lime inn en liste over navn og firmaer",
        "create-order-confirm-booking-dialog-bulk-add-attendees-description": "Skriv inn ett navn og firma per linje.",
        "create-order-confirm-booking-dialog-bulk-add-attendees-field": "\n .placeholder = Navn, Firma",
        "create-order-confirm-booking-selected-resources": "Valgte ressurser ({ $count }):",
        "create-order-confirm-booking-booking-time": "Bookingtidspunkt: { $time }",
        "create-order-confirm-booking-rooms": "Lokaler:",
        "create-order-confirm-booking-equipment": "AV-utstyr:",
        "create-order-confirm-booking-cars": "Biler:",
        "create-order-confirm-booking-time-range-picker-from-field": "\n .label =Fra tid:",
        "create-order-confirm-booking-time-range-picker-to-field": "\n .label =Til tid:",
        "create-order-confirm-booking-time-range-picker-error": "Ressursen er ikke tilgjengelig på dette tidspunktet",
        "create-order-meeting-details-start-time-label": "Møtets starttidspunkt",
        "create-order-meeting-details-end-time-label": "Møtets sluttidspunkt",
        "create-order-meeting-details-duration-helper-text":
            "Oppgi møtevarigheten slik at kantinen kan planlegge levering og opprydding.",
        "create-order-confirm-booking-table-setup": "Bordoppsett",
        "create-order-confirm-booking-select-setup": "Velg oppsett",
        "create-order-confirm-booking-message-title": "Meldinger til servicesenter",
        "create-order-attendees-dialog-submit-button": "Lagre",
        "create-order-attendees-dialog-title": "Deltakere",
        "create-order-note-add-button": "Legg til",
        "create-order-note-edit-button": "Rediger",
        "create-order-note-dialog-title": "\n .dialogTitle = Ordremelding",
        "create-order-note-dialog-alert": "\n .title = Ordremeldingen din vil være synlig på ordrespesifikasjonen. Du må ikke oppgi personidentifiserbar informasjon, som opplysninger om helse eller religion.",
        "create-order-note-dialog-field": "\n .label = Ordremeldingen din \n .helperText = Gjenstående tegn: { $count }",
        "create-order-note-save-button": "Lagre",
        "create-order-extra-services": "Ekstra tjenester:",
        "create-order-extra-services-delivery": "\n .title = Levering kl. { $time }",
        "create-order-extra-services-min-max": "Min. { $min } - Maks. { $max }",
        "create-order-extra-services-add-button": "Legg til",
        "create-order-extra-services-remove-button": "Fjern",
        "create-order-extra-services-mandatory-tooltip": "\n .title = Denne tjenesten er obligatorisk",
        "create-order-extra-services-always-added-label": "Inkludert",
        "create-order-extra-services-auto-added-snackbar": "Et servicegebyr på { $amount } for \"{ $name }\" er lagt til i handlekurven din.",
        "create-order-extra-services-removed-notification": "\"{ $name }\" er ikke lenger tilgjengelig og er fjernet fra handlekurven din.",
        "create-order-extra-services-seats-breakdown": "{ $count } kuverter x { $price }",
        "create-order-extra-services-total": "Totalt: { $amount }",
        "create-order-extra-services-min-price": "Min. pris { $price }",
        "create-order-extra-services-max-price": "Maks. pris { $price }",
        "create-order-extra-services-tooltip-price-per-seat-label": "Pris pr. kuvert:",
        "create-order-extra-services-tooltip-min-price-label": "Min. pris:",
        "create-order-extra-services-tooltip-max-price-label": "Maks. pris:",
        "create-order-extra-services-additional-fields-title": "Ytterligere møtedetaljer:",
        "create-order-extra-services-additional-fields-intro": "\n .title = For å levere noen ekstra tjenester trenger vi ytterligere møtedetaljer.",
        "create-order-extra-services-additional-fields-start-time-label": "Starttidspunkt",
        "create-order-extra-services-additional-fields-end-time-label": "Sluttidspunkt",
        "create-order-extra-services-additional-fields-location-label": "Hvor avholdes møtet?",
        "create-order-workgroup-label": "\n .label = Arbeidsgruppe",
        "create-order-participants-add-button": "+ Legg til deltakere",
        "create-order-participants-edit-button": "Rediger deltakere",
        "create-order-participants-count-list": "{ $count } deltakere",
        "create-order-participants-count-one-item": "{ $count } deltaker",
        "create-order-share-outlook-attendees-toggle-label": "\n    .label = Legg til deltakere fra Outlook",
        "create-order-share-outlook-attendees-toggle-helper":
            "Når dette slås på, legges { $count } deltaker(e) fra Outlook-møtet ditt til.",
        "create-order-share-outlook-attendees-list-title": "Deltakere fra Outlook ({ $count }):",
        "create-order-share-outlook-attendees-show-all-button": "+{ $count } til",
        "create-order-share-outlook-attendees-show-less-button": "Vis færre",
        "create-order-share-outlook-attendees-remove": "Fjern deltaker",
        "create-order-participants-dialog-name-column": "Navn",
        "create-order-participants-dialog-company-column": "Firma",
        "create-order-participants-dialog-email-column": "E-post",
        "create-order-participants-dialog-external-internal-column": "Ekstern",
        "create-order-participants-dialog-field-name": "\n .placeholder = Deltakernavn",
        "create-order-participants-dialog-field-company": "\n .placeholder = Firma",
        "create-order-participants-dialog-field-email": "\n .placeholder = E-postadresse",
        "create-order-add-filters-button": "Legg til filtre",
        "create-order-add-search-input": "\n .placeholder = Søk",
        "create-order-view-timeline": "Tidslinje",
        "create-order-view-available-time": "Tilgjengelighet",
        "create-order-view-room-finder": "Romfinner",
        "create-order-view-room-finder-upcoming-tooltip": "\n .title = Kommende",
        "create-order-calendar-today-button": "I dag",
        "create-order-calendar-today-button-hint": "Gå til i dag",
        "create-order-calendar-prev-day-button": "Gå til forrige dag",
        "create-order-calendar-next-day-button": "Gå til neste dag",
        "create-order-calendar-go-to-date-button": "Gå til dato",
        "create-order-calendar-go-to-date-button-hint": "Velg ønsket dato",
        "create-order-calendar-no-resources-message": "Det finnes ingen tilgjengelige ressurser. Juster filtrene",
        "create-order-calendar-go-to-date-label": "\n .label = Velg dato",
        "create-order-calendar-go-button": "Gå",
        "create-order-calendar-all-day-label": "Hele dagen",
        "create-order-calendar-week-button": "Gjeldende uke",
        "create-order-calendar-prev-week-button": "Forrige uke",
        "create-order-calendar-next-week-button": "Neste uke",
        "create-order-calendar-event-tooltip": "\n .title = Klikk for å booke",
        "create-order-confirm-booking-confirm-dialog": "\n .title = Bekreft booking\n .message =Bookingen din er ikke fullført. Bekreft bookingen før du fortsetter.\n .buttonLabelSubmit = Bekreft\n .buttonLabelCancel = Avbryt",
        "create-order-confirm-booking-confirm-no-resources-dialog": "\n .title = Booking ikke fullført\n .message =Du har ikke valgt noen ressurser ennå. Hvis du forlater nå, blir ikke bookingen fullført.\n .buttonLabelSubmit = Velg ressurser\n .buttonLabelCancel = Forlat likevel",
        "create-order-change-time-dialog": "\n .title = Endre bookingtidspunkt?\n .buttonLabelSubmit = Bruk ny tid\n .buttonLabelCancel = Behold opprinnelig tid",
        "create-order-change-time-dialog-message-top": "Outlook-møteforespørselen din er planlagt til:",
        "create-order-change-time-dialog-message-bottom": "Vil du endre bookingtidspunktet til:",
        "create-order-drawer-other-location": "+ Annen plassering",
        "create-order-drawer-delivery-location-field": "\n .label = Leveringssted",
        "create-order-drawer-meeting-location-field": "\n .label = Møtested",
        "create-order-drawer-meeting-location-label": "Møtested",
        "create-order-drawer-repeat-order": "Gjenta ordre",
        "create-order-drawer-repeat-order-every": "Gjenta hver:",
        "create-order-drawer-repeat-order-every-day": "\n .label = Dag",
        "create-order-drawer-repeat-order-every-week": "\n .label = Uke",
        "create-order-drawer-repeat-order-on": "Gjenta på:",
        "create-order-drawer-repeat-order-starts": "Starter:",
        "create-order-drawer-repeat-order-start-date-locked-message": "Startdatoen er ordrens første levering. Vil du endre den, lukker du denne dialogen og retter datoen for første levering på ordren. Åpne deretter Gjenta ordre på nytt.",
        "create-order-drawer-repeat-order-ends": "Slutter:",
        "create-order-drawer-repeat-order-ends-on": "\n .label = Den",
        "create-order-drawer-repeat-order-ends-after": "\n .label = Etter",
        "create-order-drawer-repeat-order-ends-after-deliveries": "leveringer",
        "create-order-drawer-repeat-order-end-before-start-error": "Sluttdatoen må være på eller etter startdatoen",
        "create-order-drawer-repeat-order-confirm-button": "Bekreft",
        "create-order-drawer-repeat-order-summary": "Gjentas hver { $interval }{ $days }, fra { $startDate }{ $repeatCount }{ $endDate }{ $exceptions }.",
        "create-order-drawer-repeat-order-summary-interval-day": "dag",
        "create-order-drawer-repeat-order-summary-interval-days": "{ $count } dager",
        "create-order-drawer-repeat-order-summary-interval-week": "uke",
        "create-order-drawer-repeat-order-summary-interval-weeks": "{ $count } uker",
        "create-order-drawer-repeat-order-summary-days-suffix": " på { $days }",
        "create-order-drawer-repeat-order-summary-repeat-count-suffix": ", { $count } ganger",
        "create-order-drawer-repeat-order-summary-end-date-suffix": ", slutter { $date }",
        "create-order-drawer-repeat-order-summary-exceptions-suffix": "({ $count } unntak)",
        "create-order-drawer-repeat-order-delete-confirm-dialog": "\n .title = Slett gjentakelse \n .buttonLabelSubmit = Slett",
        "create-order-drawer-repeat-order-delete-confirm-dialog-message": "Gjentakelsen og eventuelle fravalgte dager fjernes. Selve ordren beholdes.",
        "create-order-drawer-repeat-order-applies-to": "Gjelder:",
        "create-order-drawer-repeat-order-applies-to-weekdays": "\n .label = Hverdager (man–fre)",
        "create-order-drawer-repeat-order-applies-to-every-day": "\n .label = Alle dager",
        "create-order-drawer-repeat-order-start-date-help": "Ordrens leveringsdato – kan ikke endres",
        "create-order-drawer-repeat-order-start-date-missing-error": "Ordren mangler en leveringsdato.",
        "create-order-drawer-repeat-order-end-date-missing-error": "Velg en sluttdato.",
        "create-order-drawer-repeat-order-span-error": "En gjentakelse kan maksimalt strekke seg over ett år.",
        "create-order-drawer-repeat-order-count-missing-error": "Angi hvor mange leveringer som skal opprettes.",
        "create-order-drawer-repeat-order-no-deliveries-error": "Denne gjentakelsen har ingen leveringsdager. Endre gjentakelsen eller fjern den.",
        "create-order-drawer-repeat-order-delivery-days": "Leveringsdager:",
        "create-order-drawer-repeat-order-delivery-days-hint": "Fjern haken ved de dagene som ikke skal leveres.",
        "create-order-drawer-repeat-order-delivery-days-reset-button": "Nullstill fravalg",
        "create-order-drawer-repeat-order-delivery-days-show-button": "Se og fravelg dager ({ $count })",
        "create-order-drawer-repeat-order-delivery-days-hide-button": "Skjul dager",
        "create-order-drawer-repeat-order-delivery-days-none-selected": "Ingen dager valgt",
        "create-order-drawer-repeat-order-delivery-days-all-selected": "Alle dager i perioden er valgt",
        "create-order-drawer-repeat-order-delivery-days-deselected": "{ $count ->\n [one] { $count } dag fravalgt\n *[other] { $count } dager fravalgt\n}",
        "create-order-drawer-repeat-order-delivery-days-month-count": "{ $count ->\n [one] { $count } levering\n *[other] { $count } leveringer\n}",
        "create-order-drawer-repeat-order-delivery-days-month-deselected": "· { $count } fravalgt",
        "create-order-drawer-repeat-order-delivery-days-start-day": "Startdato",
        "create-order-drawer-repeat-order-confirm-orders-button": "{ $count ->\n [one] Bekreft { $count } ordre\n *[other] Bekreft { $count } ordrer\n}",
        "create-order-drawer-repeat-order-summary-weekdays-suffix": "på hverdager",
        "create-order-tooltip-resource-info-button": "\n .title = Vis ressursdetaljer",
        "create-order-tooltip-resource-lock-button-has-access": "\n .title = Kan bare bookes av utvalgte brukere. Du har tilgang til å booke.",
        "create-order-tooltip-resource-lock-button-no-access": "\n .title = Kan bare bookes av utvalgte brukere. Du har ikke tilgang.",
        "create-order-tooltip-resource-image-button": "\n .title = Vis planløsning",
        "create-order-hover-local-event-start": "Starttid: { $start }",
        "create-order-hover-local-event-end": "Sluttid: { $end }",
        "create-order-hover-local-event-host": "Vert: { $host }",
        "create-order-tabs-error": "Du kan ikke legge inn en ordre",
        "create-order-tabs-error-body": "Du kan ikke legge inn en ordre fordi kontoen din ikke har nødvendig tilgang. Kontakt support hvis du trenger mer informasjon.",
        "create-order-invalid-user-permissions-merchant-meeting-service-dialog-body": "Du forsøker å opprette en møteserveringsordre på vegne av <displayName>{ $displayName }</displayName>. Brukeren har imidlertid ikke tilgang til møteserveringsbutikken din. Kontakt support for hjelp.",
        "create-order-invalid-user-permissions-merchant-resource-booking-dialog-body": "Du forsøker å opprette en ressursbooking på vegne av <displayName>{ $displayName }</displayName>. Kontakt support for hjelp.",
        "create-order-invalid-user-permissions-non-create-dialog-title": "Tilgangsbegrensning",
        "create-order-invalid-user-permissions-non-create-dialog-body": "Du har ikke tilgang til å utføre denne handlingen på vegne av <displayName>{ $displayName }</displayName>. Kontakt support for hjelp.",
        "create-order-tabs-error-dialog-close-button": "Gå tilbake",
        "create-order-tabs-error-dialog-confirm-button": "Velg en annen bruker",
        "create-order-price-list-confirm-dialog": "\n .title = Fjern produkter\n .buttonLabelSubmit = Fjern",
        "create-order-price-list-confirm-dialog-message": "Er du sikker på at du vil fjerne alle produkter fra alle leveringstidspunkter?",
        "create-order-close-confirm-dialog": "\n .title = Forkast endringer \n .buttonLabelSubmit = Forkast",
        "create-order-close-confirm-dialog-message": "Hvis du klikker på Forkast, går all inntastet informasjon tapt.",
        "create-order-drawer-messages-dialog-title": "\n .dialogTitle = Meldinger fra butikkeieren",
        "create-order-drawer-message-read-more": "...Les mer",
        "expandable-text-read-more": "Les mer",
        "expandable-text-read-less": "Vis mindre",
        "create-order-book-period-message-dialog-title": "\n .dialogTitle = Du kan ikke klikke på tidslinjen mens du bruker modusen `Reserver periode`",
        "create-order-book-period-message-dialog-note": "For å booke ressurser, klikk på ressursene i venstre panel",
        "create-order-book-period-filter-intro": "Reserver periode brukes til å booke over flere dager. Når du har valgt start- og sluttidspunkt, klikker du bare på ønsket ressurs i venstre kolonne",
        "create-order-book-period-filter-intro-recurring":
            "Dette er et gjentakende møte — klikk bare på ønsket ressurs i venstre kolonne for å booke den for alle forekomster.",
        "create-order-book-period-busy-message": "Den valgte ressursen er ikke tilgjengelig for hele perioden",
        "create-order-book-period-busy-error": "Kunne ikke sjekke ressurstilgjengelighet",
        "create-order-book-period-confirm-cancel-changes-dialog": "\n .title = Fjern gjeldende valg\n .buttonLabelSubmit = Bekreft\n .buttonLabelCancel = Avbryt",
        "create-order-book-period-confirm-cancel-changes-dialog-message": "Hvis du endrer perioden, tømmes gjeldende valg. Vil du fortsette?",
        "create-order-past-booking-attempt-message": "Du kan ikke booke bakover i tid. Starttidspunktet for bookingen må være lik eller senere enn nåværende tidspunkt",
        "create-order-book-period-past-booking": "Kan ikke velge en periode i fortiden",
        "create-order-change-current-event-dialog": "\n .title = Du oppdaterer for øyeblikket booking { $currentBooking }\n .message = Vil du tilbakestille endringene dine og bytte til { $targetBooking }?\n .buttonLabelSubmit = Bekreft\n .buttonLabelCancel = Avbryt",
        "create-order-change-current-event-create-dialog": "\n .title = Du oppretter for øyeblikket en booking\n .message = Vil du tilbakestille endringene dine og bytte til { $targetBooking }?\n .buttonLabelSubmit = Bekreft\n .buttonLabelCancel = Avbryt",
        "create-order-timeline-permission-error": "Du har ikke tillatelse til å oppdatere denne bookingen, da den tilhører en annen bruker",
        "create-order-timeline-error-select": "Dette tidsrommet er ikke tilgjengelig for de valgte ressursene",
        "create-order-timeline-error-busy-or-overlap": "Denne ressursen er allerede opptatt på det valgte tidspunktet, eller det er registrert overlapp med buffer!",
        "create-order-timeline-slot-taken-message": "Noen booket dette tidspunktet mens du valgte. Tidslinjen er oppdatert — velg et annet tidspunkt eller en annen ressurs.",
        "create-order-resource-row-events-loading-tooltip": "Kalenderhendelser lastes fortsatt. Vent før du velger en ressurs.",

        "create-order-select-price-list-dialog": "Velg prisliste",
        "create-order-empty-price-list-dialog": "Ingen prisliste tilgjengelig",
        "create-order-empty-price-list-dialog-body": "Det finnes for øyeblikket ingen tilgjengelige prislister",
        "create-order-empty-price-list-dialog-body-message": "Ta kontakt med butikkeieren for å be om tilgang til dem",
        "create-order-select-price-list-no-price-lists-title": "Det finnes for øyeblikket ingen tilgjengelige prislister. Ta kontakt med butikkeieren for å be om tilgang til dem.",
        "create-order-select-price-list-no-search-results": "Søket ga ingen resultater",
        "create-order-select-price-list-no-search-results-description": "Prøv et annet søkeord",
        "create-order-select-price-list-favorites-section": "Mine favoritter ({ $count })",
        "create-order-select-price-list-favorites-view-all": "Vis alle ({ $count })",
        "create-order-select-price-list-favorites-toggle-label": "Favoritter",
        "create-order-select-price-list-nearby-note": "Viser prislister i nærheten av det bookede lokalet ditt.",
        "create-order-select-price-list-nearby-see-all-button": "Se alle kantiner",
        "create-order-select-price-list-nearby-only-button": "Vis bare kantiner nær det bookede lokalet ditt",
        "create-order-select-price-list-other-canteens-section": "Andre kantiner",
        "create-order-no-products-dialog-title": "\n .dialogTitle = Prislisten har ingen produkter",
        "create-order-no-products-dialog-message": "Ta kontakt med butikkeieren for å få tilgang til produktene",
        "create-order-no-longer-available-dialog-title": "\n .dialogTitle = Prislisten er ikke lenger tilgjengelig",
        "create-order-no-longer-available-dialog-message": "Prislisten som ble brukt til denne ordren, er ikke lenger tilgjengelig. Velg en annen prisliste for å fortsette.",
        "create-order-no-products-dialog-button-label-cancel": "Gå til forsiden",
        "create-order-no-products-dialog-button-label-submit": "Velg en annen prisliste",
        "create-order-products-empty-favorites-title": "Du har ingen favorittvarer",
        "create-order-products-empty-favorites-description": "Du kan legge til favorittvarer slik at du kan fullføre en ordre raskere. Legg til en favorittvare ved å klikke på hjerteikonet på produktkortet",
        "create-order-credit-note-overlay-title": "Kreditnota",
        "create-order-credit-note-overlay-intro-with-order-id": "Du oppretter en kreditnota for ordre-ID <orderIdLink>#{ $orderId }</orderIdLink>.",
        "create-order-credit-note-overlay-callout-title": "Slik oppretter du en kreditnota:",
        "create-order-credit-note-overlay-callout-body": "Juster produktene i handlekurven. Varene som ligger i handlekurven, krediteres. Du kan legge til din egen ordrelinje om nødvendig.",
        "create-order-select-price-list-dialog-subtitle": "Møteservering",
        "create-order-select-price-list-search-placeholder": "\n .placeholder = Søk etter prisliste eller kantine",
        "create-order-select-price-list-close-button": "Lukk",
        "create-order-select-price-list-footer-empty": "Velg en prisliste",
        "create-order-select-price-list-footer-selected": "{ $priceList } · { $merchant }",
        "create-order-select-price-list-continue-button": "Fortsett",
        "create-order-select-price-list-selected-badge": "Valgt",
        "create-order-select-price-list-address-map-link": "Åpne i Google Maps",
        "create-order-select-price-list-address-show-map": "Vis kart",
        "create-order-select-price-list-address-hide-map": "Skjul kart",
        "create-order-select-price-list-info-button-tooltip": "Vis detaljer",
        "create-order-select-price-list-info-close-button": "Lukk detaljer",
        "create-order-select-price-list-favorite-add-button-tooltip": "Legg til i favoritter",
        "create-order-select-price-list-favorite-remove-button-tooltip": "Fjern fra favoritter",
        "create-order-on-behalf-of-dialog": "Bestill på vegne av",
        "create-order-on-behalf-of-dialog-description": "For å opprette en ordre som administrator må du først velge brukeren du legger inn ordren for.",
        "create-order-on-behalf-of-dialog-user-description": "Velg hvem du bestiller for. Personen blir arrangør og kan oppdatere ordren fra sitt dashboard.",
        "create-order-on-behalf-of-dialog-select-company-field": "\n .label = Velg firma",
        "create-order-on-behalf-of-dialog-select-user-field": "\n .label = Velg bruker\n .placeholder = Skriv inn brukernavn:",
        "create-order-on-behalf-of-dialog-user-organizer-field": "\n .label = Arrangør:\n .placeholder = Arrangørens navn",
        "create-order-on-behalf-of-dialog-select-user-field-no-results": "Ingen resultater",
        "create-order-on-behalf-of-dialog-select-company-host-field": "\n .label = Vertens firma",
        "create-order-on-behalf-of-dialog-select-host-field": "\n .label = Vertens navn\n .placeholder = Skriv inn vertens navn:",
        "create-order-on-behalf-of-dialog-button": "Fortsett",
        "create-order-bill-receiver-ean": "EAN:",
        "create-order-bill-receiver-email": "E-post:",
        "create-order-bill-receiver-contact": "Kontakt:",
        "create-order-bill-receiver-add-button": "+ Legg til fakturamottaker",
        "create-order-bill-receiver-autocomplete-no-options": "Ingen fakturamottakere funnet. Kontakt administratoren din for å legge til en.",
        "create-order-vat-included": "(inkl. MVA)",
        "create-order-vat-excl": "(ekskl. MVA)",


        "create-order-recurrence-outlook-managed": "Dette møtet gjentas (styres i Outlook)",
        "create-order-busy-resource-dates-dialog-title": "Noen datoer kunne ikke bookes",
        "create-order-busy-resource-dates-dialog-message":
            "De valgte ressursene var allerede booket på følgende datoer, så disse forekomstene ble ikke booket:",
        "create-order-busy-resource-dates-dialog-copy-button": "Kopier liste",
        "create-order-busy-resource-dates-dialog-copied-button": "Kopiert",
        "create-order-busy-resource-dates-dialog-continue-button": "Fortsett",
        "create-order-success-dialog-resource-booking-title": "Booking opprettet!",
        "create-order-success-dialog-resource-booking-title-with-order-id": "Booking #{ $orderId } opprettet!",
        "create-order-success-dialog-resource-booking-title-updated-with-order-id":
            "Booking #{ $orderId } er oppdatert!",
        "create-order-success-dialog-meeting-service-title": "Ordre opprettet!",
        "create-order-success-dialog-meeting-service-title-with-order-id": "Ordre #{ $orderId } opprettet!",
        "create-order-success-dialog-meeting-service-title-updated-with-order-id": "Ordre #{ $orderId } er oppdatert!",
        "create-order-success-dialog-series-orders-title": "{ $count } ordrer er opprettet!",
        "create-order-success-dialog-description": "Hva vil du gjøre nå?",
        "create-order-success-dialog-outlook-cancel-note":
            "Skal møtet avlyses? Avbestill ordren i Facilitynet før du sletter møtet i Outlook.",
        "create-order-success-dialog-action-meeting-service": "Legg til møteservering i ordren",
        "create-order-success-dialog-action-meeting-service-update": "Oppdater møteservering",
        "create-order-success-dialog-action-add-resource-booking": "Legg til ressursbooking",
        "create-order-success-dialog-action-update-resource-booking": "Oppdater ressursbooking",
        "create-order-success-dialog-action-create-booking": "Opprett en ny booking",
        "create-order-success-dialog-action-create-meeting-service": "Opprett ny møteservering",
        "create-order-success-dialog-action-finish": "Jeg er ferdig",
        "create-order-success-dialog-action-calendar": "Legg til møtet i kalenderen",

        "create-order-outlook-finish-step": "Du kan nå gå tilbake til Outlook",

        // Confirm order dialog
        "confirm-order-dialog-order-error": "Kunne ikke laste inn følgeseddel med id #{ $orderId }",
        "confirm-order-dialog-order-error-description": "Denne ordren kunne ikke behandles på grunn av manglende eller ugyldige data.",
        "confirm-order-dialog-title": "Bekreft ordre",
        "confirm-order-dialog-title-update-order": "Oppdater ordre #{ $id }",
        "confirm-order-dialog-title-credit-note-order": "Opprett kreditnota",
        "confirm-order-dialog-title-supplementary-order": "Opprett tilleggsordre",
        "confirm-order-dialog-meeting-details": "Møtedetaljer",
        "confirm-order-dialog-meeting-time": "Møtetidspunkt:",
        "confirm-order-dialog-delivery-date": "Leveringsdato:",
        "confirm-order-dialog-delivery-location": "Leveringssted:",
        "confirm-order-dialog-delivery-location-mode-eating-in-canteen": "Spiser i kantinen",
        "confirm-order-dialog-delivery-location-mode-pick-up": "Henting",
        "confirm-order-dialog-seats": "Kuverter:",
        "confirm-order-dialog-merchant": "Butikkeier:",
        "confirm-order-dialog-workgroup": "Arbeidsgruppe:",
        "confirm-order-dialog-workgroup-members-title": "Medlemmer i arbeidsgruppen",
        "confirm-order-dialog-workgroup-members-empty": "Ingen medlemmer å vise",
        "confirm-order-dialog-workgroup-members-error": "Vi kan ikke vise medlemmene akkurat nå",
        "confirm-order-dialog-workgroup-members-no-access": "Du har ikke tilgang til å se gruppens medlemmer",
        "confirm-order-timestamp-created": "Opprettet:",
        "confirm-order-timestamp-updated": "Oppdatert:",
        "confirm-order-dialog-contact": "Kontakt",
        "confirm-order-dialog-host": "Vert:",
        "confirm-order-dialog-ordered-by": "Bestilt av:",
        "confirm-order-dialog-bill-receiver": "Fakturamottaker",
        "confirm-order-dialog-bill-receiver-contact": "Kontakt:",
        "confirm-order-dialog-bill-receiver-contact-email": "E-post:",
        "confirm-order-dialog-bill-receiver-cost-centers": "Kostnadssteder:",
        "confirm-order-dialog-bill-receiver-meeting-type": "Møtetype:",
        "confirm-order-dialog-bill-receiver-department": "Avdeling:",
        "confirm-order-dialog-order-summary": "Ordreoversikt",
        "confirm-order-dialog-order-summary-delivery-date": "Levering: { $date }",
        "confirm-order-dialog-order-summary-delivery-date-time": "Levering: { $date }, { $time }",
        "confirm-order-dialog-order-summary-table-meeting-service": "Møteservering",
        "confirm-order-dialog-order-summary-table-items": "Antall",
        "confirm-order-dialog-order-summary-table-amount": "Beløp",
        "confirm-order-dialog-order-summary-table-amount-no-vat": "Beløp",
        "confirm-order-dialog-order-summary-table-meeting-services-total": "Totalt",
        "confirm-order-dialog-order-summary-table-meeting-services-total-no-vat": "Totalt",
        "confirm-order-dialog-order-summary-table-meeting-services-vat": "MVA utgjør ({ $percentage }%)",
        "confirm-order-dialog-order-summary-table-meeting-services-total-include-vat": "Totalbeløp inkl. MVA",
        "confirm-order-dialog-repeat-order": "\n .title = Gjenta ordre",
        "confirm-order-dialog-repeat-order-text": "Gjenta ordre",
        "confirm-order-dialog-repeat-order-summary-weekdays": "Hverdager",
        "confirm-order-dialog-repeat-order-summary-every-day": "Alle dager",
        "confirm-order-dialog-repeat-order-summary-rule": "Hver { $interval }{ $days }",
        "confirm-order-dialog-repeat-order-summary-deliveries": "{ $count ->\n [one] { $count } levering\n *[other] { $count } leveringer\n}",
        "confirm-order-dialog-repeat-order-summary-deselected": "({ $count } fravalgt)",
        "confirm-order-dialog-repeat-order-day-deselected": "fravalgt",
        "confirm-order-dialog-attendees": "\n .title = Deltakere",
        "confirm-order-dialog-attendees-subtitle": "{ $internalCount } { $internalCount ->\n  [one] intern\n *[other] interne\n}, { $externalCount } { $externalCount ->\n  [one] ekstern\n *[other] eksterne\n}",
        "confirm-order-dialog-attendees-internal": "\n .title = Interne deltakere:",
        "confirm-order-dialog-attendees-external": "\n .title = Eksterne deltakere:",
        "confirm-order-dialog-resources": "\n .title = Ressurser",
        "confirm-order-dialog-back-button": "Fortsett å redigere",
        "confirm-order-dialog-next-button": "Bekreft ordre",
        "confirm-order-dialog-booking-time": "Bookingtidspunkt: { $timeRange }",

        "user-order-receipt-page-share-button": "Del",
        "user-order-receipt-page-not-loaded-message": "  Ordre-ID { $orderId } kunne ikke leses. Kontakt support.",
        "user-order-receipt-page-not-found-public-message": "Beklager, ordren ble ikke funnet. Kontakt support på <link>{ $supportEmail }</link> hvis du trenger hjelp.",
        "user-order-receipt-page-loading": "Laster inn ordre...",
        "user-order-receipt-page-share-modal-title": "Del kvittering",
        "user-order-receipt-page-share-modal-subtitle": "Del denne lenken for å la andre se kvitteringen.",
        "user-order-receipt-page-print-button": "Skriv ut",
        "user-order-receipt-page-header-orders-count": "Ordrer: {$orderCount} valgt",
        "user-pos-order-receipt-page-header-orders-count": "Kvitteringer: {$orderCount} valgt",
        "user-order-receipt-page-navigation-counter": "Ordre { $current } av { $total }",
        "user-pos-order-receipt-page-navigation-counter": "Kvittering { $current } av { $total }",
        "receipt-order-navigation-previous-button": "Forrige",
        "receipt-order-navigation-next-button": "Neste",
        "merchant-receipt-dropdown-search-label": "\n .placeholder = Søk etter ordrenr., navn eller e-post",
        "merchant-receipt-dropdown-group-today-label": "I dag · { $date }",
        "merchant-receipt-dropdown-orders-count": "{ $count ->\n [one] { $count } ordre\n *[other] { $count } ordrer\n}",

        "create-order-delivery-times-add-button": "Legg til leveringstidspunkter",
        "create-order-delivery-times-add-btn": "Legg til",
        "create-order-delivery-times-add-delivery-time-title": "Leveringstider",
        "create-order-delivery-times-update-delivery-time": "Oppdater leveringstider",
        "create-order-delivery-times-add-delivery-time": "Legg til leveringstider:",
        "create-order-delivery-times-dialog-title-add": "Legg til leveringstidspunkter",
        "create-order-delivery-times-dialog-title-edit": "Rediger leveringstidspunkter",
        "create-order-delivery-times-dialog-subtitle": "Du må velge en dato for leveringen.",
        "create-order-delivery-times-dialog-subtitle-example": "Du kan angi flere leveringstidspunkter for heldagsmøter, f.eks. levering kl. 10:00 og kl. 13:00.",
        "create-order-delivery-times-dialog-booking-date-mismatch": "Bookingen din er { $bookingDate } kl. { $bookingTime }, men møteserveringen er { $deliveryDate }.",
        "create-order-delivery-times-dialog-delivery-date": "Leveringsdato",
        "create-order-delivery-times-dialog-delivery-date-details": "Leveringsdato:",
        "create-order-delivery-times-dialog-delivery-time-event-start": "Møtet ditt starter kl. { $bookingTime }, men butikkeieren leverer bare mellom { $minTime } og { $maxTime }. Velg et leveringstidspunkt innenfor dette tidsrommet.",
        "create-order-delivery-times-dialog-delivery-time-event-start-today": "Dessverre kan du ikke opprette en møteserveringsordre i dag, fordi butikkeieren ikke leverer senere enn { $time }",
        "create-order-delivery-times-dialog-delivery-date-close-tooltip": "Salgsstedet er stengt på denne datoen",
        "create-order-delivery-times-dialog-delivery-date-kept-tooltip":
            "Salgsstedet er stengt på denne datoen — beholdt fra den opprinnelige ordren",
        "create-order-closed-delivery-date-warning-admin":
            "Merk: Kantinen er stengt { $date }. Vanlige kantinebrukere kan ikke legge inn ordrer for denne datoen, men som kantineadministrator kan du opprette ordren.",
        "create-order-closed-delivery-date-warning-editing":
            "Merk: Kantinen er stengt { $date }. Denne ordren ble lagt inn for den datoen og kan fortsatt lagres.",
        "create-order-closed-delivery-date-banner-admin":
            "\n .title = Merk: Kantinen er stengt { $date }. Vanlige kantinebrukere kan ikke legge inn ordrer for denne datoen, men som kantineadministrator kan du opprette ordren.",
        "create-order-closed-delivery-date-banner-editing":
            "\n .title = Merk: Kantinen er stengt { $date }. Denne ordren ble lagt inn for den datoen og kan fortsatt lagres.",
        "create-order-delivery-times-dialog-delivery-times": "Leveringstidspunkter",
        "create-order-delivery-times-dialog-delivery-field": "\n .label = Levering { $count }",
        "create-order-delivery-times-dialog-add-delivery-button": "+ Legg til levering",
        "create-order-delivery-times-dialog-submit-button": "Bekreft",
        "create-order-delivery-times-dialog-close-button": "Ok",
        "create-order-delivery-times-empty-error": "Ingen aktiv leveringstid valgt",
        "create-order-cost-centers-missing-dialog-title": "Kostnadssteder er ikke tilgjengelige",
        "create-order-cost-centers-missing-message": "Det finnes ingen tilgjengelige kostnadssteder for \"{ $dimensionName }\". Kontakt administratoren din for å få opprettet kostnadssteder.",
        "create-order-delivery-location-required": "Velg et leveringssted",
        "create-order-meeting-location-required": "Møtested er påkrevd når en ekstra tjeneste krever det",
        "create-order-meeting-time-required": "Møtetidspunkt er påkrevd når en ekstra tjeneste krever det",
        "create-order-multiple-deliveries-date-and-time-required": "Du må velge en leveringsdato og minst ett leveringstidspunkt",
        "create-order-validation-date-invalid": "{ $label } må være en gyldig dato",
        "create-order-validation-must-be-checked": "{ $label } må være avkrysset",
        "create-order-validation-required": "{ $label } er påkrevd",
        "create-order-validation-min": "{ $label } må være minst { $min }",
        "create-order-validation-max": "{ $label } må være høyst { $max }",
        "create-order-validation-must-be-true": "{ $label } må være sann",
        "create-order-validation-email-invalid": "{ $label } må være en gyldig e-postadresse",
        "create-order-validation-format-invalid": "{ $label } har ikke riktig format",
        "create-order-delivery-times-same-time-error": "Samme tidspunkt kan ikke legges til to ganger",
        "create-order-delivery-times-opening-hours-error": "Det valgte tidspunktet ligger ikke innenfor åpningstidene for denne datoen",
        "create-order-delivery-times-past-time-error": "Leveringstidspunktet kan ikke ligge i fortiden",
        "create-order-refund-amount-exceeds-initial-error": "Kreditnotaen kan ikke overstige det opprinnelige beløpet",
        "create-order-refund-quantity-exceeds-initial-error": "Den krediterte mengden kan ikke overstige den opprinnelige mengden for dette produktet",
        "create-order-delivery-deadline-message-dialog-title": "\n .title = Fristen er overskredet \n .buttonLabelSubmit = Legg inn ordre \n .buttonLabelCancel = Avbryt ordre",
        "create-order-delivery-deadline-message-dialog-description": "Du kan fortsatt legge inn ordren, men den må godkjennes av personalet, noe som betyr at du ikke kan forvente at ordren blir levert.",
        "create-order-delivery-deadline-message-dialog-product-wish-staff-description": "Det er et produktønske på denne ordren. Du må angi en pris og godkjenne ordren hvis du vil imøtekomme ønsket.",
        "create-order-add-product-deadline-dialog-title": "\n .title = Fristen er overskredet \n .buttonLabelSubmit = OK",

        "create-order-timeline-booked-period": "Reserver periode",
        "create-order-timeline-booked-period-tooltip": "Velg start- og sluttidspunkt for å booke ressurser for en lengre periode",
        "create-order-timeline-booked-period-selected-tooltip": "Klikk på en ressurs i venstre kolonne for å booke den for denne perioden. Du kan ikke klikke på tidslinjen i denne modusen",
        "create-order-timeline-booked-period-recurring-tooltip": "Perioden er fastsatt av møteserien. Klikk på en ressurs i venstre kolonne for å booke den for alle forekomster",
        "create-order-timeline-booked-period-start-date-time-label": "\n .label = Starttid",
        "create-order-timeline-booked-period-end-date-time-label": "\n .label = Sluttid",
        "create-order-timeline-meeting-availability-hidden-count": "{ $count } ressurser skjult",
        "create-order-timeline-meeting-availability-show-all-button": "Vis alle",
        "create-order-timeline-meeting-fit-banner-title-fallback": "Møtet ditt",
        "create-order-timeline-meeting-fit-banner-summary":
            "{ $date }, { $time } · { $count ->\n [one] { $count } deltaker\n *[other] { $count } deltakere\n}",
        "create-order-timeline-meeting-fit-banner-summary-no-attendees": "{ $date }, { $time }",
        "create-order-timeline-meeting-fit-banner-summary-attendees-only":
            "{ $count ->\n [one] { $count } deltaker\n *[other] { $count } deltakere\n}",
        "create-order-timeline-meeting-fit-banner-fits-segment": "Passer til møtet ditt",
        "create-order-timeline-meeting-fit-banner-all-segment": "Alle ressurser",
        "create-order-timeline-meeting-fit-banner-fits-segment-tooltip-seats-and-availability":
            "Viser bare ressurser med nok plasser som er ledige i møtetidsrommet",
        "create-order-timeline-meeting-fit-banner-fits-segment-tooltip-availability":
            "Viser bare ressurser som er ledige i møtetidsrommet",
        "create-order-timeline-meeting-fit-banner-fits-segment-tooltip-seats":
            "Viser bare ressurser med nok plasser til deltakerne",
        "create-order-timeline-meeting-fit-banner-all-segment-tooltip":
            "Viser alle ressurser, også de som ikke passer til møtet",
        "create-order-timeline-meeting-fit-banner-go-to-meeting-button": "Gå til møtet",

        "resource-booking-chip-filter-select-booking-duration-hours": "timer",
        "resource-booking-chip-filter-select-booking-duration-minutes": "minutter",
        "resource-booking-chip-filter-select-meeting-type-title-internal-meeting": "Internt møte",
        "resource-booking-chip-filter-select-meeting-type-title-internal-meeting-description": "Møtet er bare med kolleger, ingen eksterne gjester.",
        "resource-booking-chip-filter-select-meeting-type-title-external-meeting": "Eksternt møte",
        "resource-booking-chip-filter-select-meeting-type-title-external-meeting-description": "Møtet har eksterne gjester.",
        "resource-booking-chip-filter-select-title-floors": "Velg etasje",
        "resource-booking-chip-filter-select-title-fixedavids": "Velg fast AV-utstyr",
        "resource-booking-chip-filter-select-title-meetingtype": "Velg møtetype",
        "resource-booking-chip-filter-select-title-sittings": "Antall plasser",
        "resource-booking-chip-filter-select-title-tablesetupids": "Velg bordoppsett",
        "resource-booking-chip-filter-select-title-deliverytype": "Velg leveringstype",
        "resource-booking-chip-filter-select-title-mobileav": "Mobilt AV-utstyr",
        "resource-booking-chip-filter-select-title-settables": "Dekking av bord",
        "resource-booking-chip-filter-select-title-cleanup": "Rydding av bord",
        "resource-booking-chip-filter-select-title-resourcetypeids": "Velg ressurstype",
        "resource-booking-chip-filter-select-title-servicecenterids": "Velg servicesentre",
        "resource-booking-chip-filter-select-title-satelliteids": "Velg satellitter",
        "resource-booking-chip-filter-select-title-meetingduration": "Bookingvarighet",
        "resource-booking-chip-filter-tooltip-resourcetypeids": "Viser bare ressurser av de valgte typene",
        "resource-booking-chip-filter-tooltip-sittings": "{ $count ->\n [one] Viser lokaler med minst { $count } plass\n *[other] Viser lokaler med minst { $count } plasser\n}",
        "resource-booking-chip-filter-tooltip-servicecenterids": "Viser bare ressurser ved de valgte servicesentrene",
        "resource-booking-chip-filter-tooltip-floors": "Viser bare ressurser i de valgte etasjene",
        "resource-booking-chip-filter-tooltip-fixedavids": "Viser bare lokaler med alt det valgte faste AV-utstyret",
        "resource-booking-chip-filter-tooltip-tablesetupids": "Viser bare lokaler som tilbyr minst ett av de valgte bordoppsettene",
        "resource-booking-chip-filter-rooms": "Lokaler",
        "resource-booking-chip-filter-equipment": "AV-utstyr",
        "resource-booking-chip-filter-cars": "Biler",

        // Resource filter API keys (groups and elements)
        "key_group_1": "Ressurstyper",
        "key_group_2": "Møtevarighet",
        "key_group_3": "Møtetidspunkt",
        "key_group_4": "Deltakere",
        "key_group_5": "Utvidet søk",
        "key_1": "Ressurstyper",
        "key_2": "Møtevarighet",
        "key_3": "Møtetidspunkt",
        "key_4": "Plasser",
        "key_5": "Servicesenter",
        "key_6": "Etasje",
        "key_7": "Bordoppsett",
        "key_8": "AV-utstyr",

        // Resource details dialog
        "resource-details-dialog-service-center": "Servicesenter",
        "resource-details-dialog-floor": "Etasje",
        "resource-details-dialog-description": "Beskrivelse",
        "resource-details-dialog-empty": "\n .title = Ingen detaljer tilgjengelig\n .description = Detaljene for denne ressursen ble ikke funnet.",
        "resource-details-dialog-square-meters": "Kvadratmeter",
        "resource-details-dialog-walk-direction":"Veibeskrivelse",
        "resource-details-dialog-capacity": "Kapasitet",
        "resource-details-dialog-capacity-quantity": "{ $quantity } personer",
        "resource-details-dialog-table-arrangement": "Bordoppsett",


        // Service center > Navigation
        "service-center-top-bar-info-screens-online": "Infoskjermer online",
        "service-center-top-bar-info-screens-offline": "{ $count ->\n [one] { $count } skjerm offline\n *[other] { $count } skjermer offline\n}",
        "service-center-nav-item-user-label": "\n .title = Hjem" ,
        "service-center-nav-item-canteen-label": "\n .title = Kommende møter" ,
        "service-center-nav-item-guests-label": "\n .title = Gjesteliste" ,
        "service-center-nav-item-meeting-rooms-label": "\n .title = Møterom" ,
        "service-center-nav-item-settings-label": "\n .title = Administrasjon" ,
        "service-center-nav-bottom-bar-home-label": "Hjem",
        "service-center-nav-bottom-bar-canteen-label": "Møter",
        "service-center-nav-bottom-bar-meeting-rooms-label": "Møterom",
        "service-center-nav-bottom-bar-guests-label": "Gjester",
        "service-center-nav-bottom-bar-settings-label": "Administrasjon",

        // Service center > Reports > Dashboard
        "service-center-reports-dashboard-check-in-button": "Sjekk inn",
        "service-center-reports-dashboard-checked-id": "Sjekket inn",
        "service-center-reports-dashboard-check-in-guests-button": "Innsjekking av gjester",
        "service-center-reports-dashboard-guests-overview-in-house-title": "Gjester i huset",
        "service-center-reports-dashboard-guests-overview-in-house-unit": "i huset",
        "service-center-reports-dashboard-guests-overview-print-guest-list": "Skriv ut gjesteliste",
        "service-center-reports-dashboard-guests-overview-export-guest-list": "Eksporter til Excel",
        "service-center-reports-dashboard-guests-overview-chart-title": "I dag",
        "service-center-reports-dashboard-guests-overview-chart-empty": "Ingen møter i dag",
        "service-center-reports-dashboard-guests-overview-chart-legend-meetings": "Møter",
        "service-center-reports-dashboard-guests-overview-chart-legend-guests": "Gjester",
        "service-center-reports-dashboard-guests-overview-chart-slot-tooltip": "{ $from }–{ $to }: { $meetings } møter, { $guests } gjester",
        "service-center-reports-dashboard-guests-overview-group-label": "Gruppe på { $count }",
        "service-center-reports-dashboard-guests-overview-print-title": "Gjester i huset · { $date }",
        "service-center-reports-dashboard-guests-overview-print-empty": "Ingen gjester i huset",
        "service-center-reports-dashboard-guests-overview-csv-name-header": "Navn",
        "service-center-reports-dashboard-guests-overview-csv-company-header": "Firma",
        "service-center-reports-dashboard-guests-overview-csv-meeting-header": "Møte",
        "service-center-reports-dashboard-guests-overview-csv-host-header": "Vert",
        "service-center-reports-dashboard-guests-overview-csv-room-header": "Rom",
        "service-center-reports-dashboard-guests-overview-csv-time-header": "Tidspunkt",
        "service-center-reports-dashboard-bookings-title": "Bookinger",
        "service-center-reports-dashboard-bookings-print-title": "Bookinger – { $tab } · { $date }",
        "service-center-reports-dashboard-bookings-tab-room": "Møter",
        "service-center-reports-dashboard-bookings-tab-car": "Biler",
        "service-center-reports-dashboard-bookings-tab-mobile-av": "AV",
        "service-center-reports-dashboard-bookings-empty-room": "Ingen møter denne dagen",
        "service-center-reports-dashboard-bookings-empty-car": "Ingen bilbookinger denne dagen",
        "service-center-reports-dashboard-bookings-empty-mobile-av": "Ingen AV-bookinger denne dagen",
        "service-center-reports-dashboard-bookings-export-menu-csv": "Eksporter til CSV",
        "service-center-reports-dashboard-meeting-audience-filter-label": "Vis møter",
        "service-center-reports-dashboard-meetings-list-row-audience-internal": "Intern",
        "service-center-reports-dashboard-meetings-list-row-audience-external": "Ekstern",
        "service-center-reports-dashboard-meetings-csv-start-header": "Start",
        "service-center-reports-dashboard-meetings-csv-end-header": "Slutt",
        "service-center-reports-dashboard-meetings-csv-title-header": "Tittel",
        "service-center-reports-dashboard-meetings-csv-type-header": "Type",
        "service-center-reports-dashboard-meetings-csv-host-header": "Vert",
        "service-center-reports-dashboard-meetings-csv-company-header": "Firma",
        "service-center-reports-dashboard-meetings-csv-location-header": "Rom",
        "service-center-reports-dashboard-search-label": "\n .placeholder = Søk",
        "service-center-reports-dashboard-meeting-pagination": "Resultater per side",
        "service-center-reports-dashboard-check-in-title": "Innsjekkingskø",
        "service-center-reports-dashboard-guest-check-in-title": "Gjesteinnsjekking",
        "service-center-reports-dashboard-no-guests":"Ingen gjester i innsjekkingskøen",
        "service-center-reports-dashboard-news-title": "Nyheter",
        "service-center-reports-dashboard-no-news":"Ingen nyheter",
        "service-center-reports-dashboard-no-meeting-selected":"Ingen møte valgt",
        "service-center-reports-dashboard-no-meetings":"Ingen kommende møter i dag",

        // Service center > Reports > Upcoming meetings
        "service-center-reports-upcoming-meetings-title": "\n .title = Kommende møter",
        "service-center-reports-upcoming-meetings-empty": "\n .title = Ingenting planlagt i perioden",
        "service-center-reports-upcoming-meetings-period-today": "I dag",
        "service-center-reports-upcoming-meetings-period-tomorrow": "I morgen",
        "service-center-reports-upcoming-meetings-period-this-week": "Denne uken",
        "service-center-reports-upcoming-meetings-period-next-7-days": "Neste 7 dager",
        "service-center-reports-upcoming-meetings-period-next-30-days": "Neste 30 dager",
        "service-center-reports-upcoming-meetings-period-all": "Alle kommende",
        "service-center-reports-upcoming-meetings-date-filter-hint-start": "Velg en startdato i kalenderen",
        "service-center-reports-upcoming-meetings-date-filter-hint-end": "Velg nå sluttdatoen i kalenderen",
        "service-center-reports-upcoming-meetings-date-filter-apply-button": "Bruk",
        "service-center-reports-upcoming-meetings-search-input": "\n .placeholder = Søk møte, nr. eller rom",
        "service-center-reports-upcoming-meetings-export-menu-csv": "Eksporter til CSV",
        "service-center-reports-upcoming-meetings-audience-filter-label": "Vis",
        "service-center-reports-upcoming-meetings-resource-type-tab-all": "Alle typer",
        "service-center-reports-upcoming-meetings-resource-type-tab-room": "Møterom",
        "service-center-reports-upcoming-meetings-resource-type-tab-mobile-av": "AV",
        "service-center-reports-upcoming-meetings-resource-type-tab-car": "Biler",
        "service-center-reports-upcoming-meetings-row-tag-room": "Rom",
        "service-center-reports-upcoming-meetings-row-tag-mobile-av": "AV",
        "service-center-reports-upcoming-meetings-row-tag-car": "Bil",
        "service-center-reports-upcoming-meetings-row-tag-meeting-service": "Møteservering",
        "service-center-reports-upcoming-meetings-group-bookings-count": "{ $count ->\n [one] { $count } booking\n *[other] { $count } bookinger\n}",
        "service-center-reports-upcoming-meetings-group-orders-count": "{ $count ->\n [one] { $count } bestilling\n *[other] { $count } bestillinger\n}",
        "service-center-reports-upcoming-meetings-csv-date-header": "Dato",
        "service-center-reports-upcoming-meetings-csv-number-header": "Nr.",
        "service-center-reports-upcoming-meetings-csv-start-header": "Start",
        "service-center-reports-upcoming-meetings-csv-end-header": "Slutt",
        "service-center-reports-upcoming-meetings-csv-title-header": "Tittel",
        "service-center-reports-upcoming-meetings-csv-type-header": "Type",
        "service-center-reports-upcoming-meetings-csv-location-header": "Rom/levering",
        "service-center-reports-upcoming-meetings-csv-price-header": "Pris",

        // Service center > Reports > Dashboard > Check in modal
        "service-center-reports-dashboard-check-in-modal-title": "Gjesteinnsjekking",
        "service-center-reports-dashboard-print-labels-modal-title": "Skriv ut gjestekort",
        "service-center-reports-dashboard-printing-labels-modal-title": "Skriver ut gjestekort",
        "service-center-reports-dashboard-printing-labels-modal-subtitle": "Gjestekort som skal skrives ut ({ $amount})",

        "service-center-reports-dashboard-printing-labels-of": "av",
        "service-center-reports-dashboard-printing-labels-cancel": "Avbryt",
        "service-center-reports-dashboard-printing-labels-print": "Skriv ut",

        // Label printer errors
        "label-printer-error-no-labels": "Ingen etiketter å skrive ut",
        "label-printer-error-cancelled": "Utskrift avbrutt av bruker",
        "label-printer-error-required-fields": "Fyll ut alle obligatoriske felt og sørg for at gruppestørrelsen er minst 1",
        "label-printer-error-failed-guest-label": "Kunne ikke skrive ut gjesteetikett",
        "label-printer-error-unknown-guest-label": "Ukjent feil ved utskrift av gjesteetikett",
        "label-printer-error-failed-label-for": "Kunne ikke skrive ut etikett for { $name }",
        "label-printer-error-printing-label-for": "Feil ved utskrift av etikett for { $name }",
        "label-printer-error-failed-group-labels": "Kunne ikke skrive ut gruppeetiketter",
        "label-printer-error-unknown-group-labels": "Ukjent feil ved utskrift av gruppeetiketter",
        "label-printer-error-failed-takeaway-labels": "Kunne ikke skrive ut Takeaway-etiketter",
        "label-printer-error-unknown-takeaway-labels": "Ukjent feil ved utskrift av Takeaway-etiketter",
        "label-printer-error-printer-not-found": "Ingen skriver ble funnet. Koble til etikettskriveren.",
        "label-printer-error-failed-labels-summary": "Kunne ikke skrive ut { $failed } av { $total } etiketter",
        "label-printer-success-labels-printed": "Etiketter skrevet ut",
        "label-printer-dialog-not-installed-title": "Skriverutvidelse påkrevd",
        "label-printer-dialog-install-chrome-button": "Installer for Chrome",
        "label-printer-dialog-install-edge-button": "Installer for Edge",
        "label-printer-dialog-install-tooltip": "Legg til Brother b-PAC-utvidelsen i nettleseren din.",
        "label-printer-dialog-refresh-after-install": "Etter installasjonen oppdaterer du siden ved å <refreshLink>klikke her</refreshLink> eller trykke F5.",
        "label-printer-dialog-need-help": "Trenger du hjelp?",
        "label-printer-dialog-printer-guide-link": "Skriverguide",
        "label-printer-dialog-order-printer-link": "Bestill en Brother-etikettskriver",
        "label-printer-dialog-not-found-title": "Ingen skriver funnet",
        "label-printer-dialog-not-found-message": "Ingen skriver ble funnet. Har du koblet til etikettskriveren?",
        "label-printer-dialog-try-again-button": "Prøv igjen",

        "service-center-reports-check-in-modal-guest-details": "Gjestedetaljer",
        "service-center-reports-check-success-title": "Gjest sjekket inn",
        "service-center-reports-check-group-success-title": "Gruppe sjekket inn",
        "service-center-reports-check-in-modal-guest-name-min": "Gjestens navn må være minst { $min } tegn",
        "service-center-reports-check-in-modal-guest-name-max": "Gjestens navn kan ikke være lengre enn { $max } tegn",
        "service-center-reports-check-in-modal-guest-company-max": "Gjestens firma kan ikke være lengre enn { $max } tegn",
        "service-center-reports-check-in-modal-number-of-guests-min": "Antall gjester må være minst { $min }",
        "service-center-reports-check-in-modal-number-of-guests-max": "Antall gjester kan være høyst { $max }",
        "service-center-reports-check-in-modal-message-max": "Meldingen kan ikke være lengre enn { $max } tegn",
        "service-center-reports-check-in-modal-single": "Enkeltperson",
        "service-center-reports-check-in-modal-group": "Gruppe",
        "service-center-reports-check-in-modal-host-name": "\n .label = Vertens navn",
        "service-center-reports-check-in-modal-host-company": "\n .label = Vertsfirma",
        "service-center-reports-check-in-modal-guest-name": "\n .label = Gjestens navn",
        "service-center-reports-check-in-modal-number-of-guests": "\n .label = Antall gjester",
        "service-center-reports-check-in-modal-guest-company": "\n .label = Gjestens firma",
        "service-center-reports-check-in-modal-guests-company": "\n .label = Gruppenavn",
        "service-center-reports-check-in-modal-print-guest-card": "\n .label = Skriv ut gjestekort",
        "service-center-reports-check-in-modal-send-host-notification": "\n .label = Varsle vert",
        "service-center-reports-check-in-modal-send-host-notification-tooltip": "\n .title = Verten får et varsel om at gjesten er sjekket inn.",
        "service-center-reports-check-in-modal-write-message-to-host": "\n .label = Skriv en melding til verten",
        "service-center-reports-check-in-modal-settings": "Innstillinger",
        "service-center-reports-check-in-modal-check-in-button": "Sjekk inn",
        "service-center-reports-check-in-modal-guest-check-in-title": "Gjesteinnsjekking",
        "service-center-reports-check-in-modal-guest-check-in-subtitle": "Gjester som skal sjekkes inn ({ $amount})",


        "service-center-check-in-error-generic": "Det oppstod en feil ved innsjekking av gjesten. Prøv igjen.",
        "service-center-check-in-error-not-found": "Gjesten eller verten ble ikke funnet. Kontroller opplysningene og prøv igjen.",
        "service-center-check-in-error-invalid-data": "Ugyldige innsjekkingsdata. Kontroller opplysningene og prøv igjen.",
        "service-center-check-in-print-failed-snackbar": "Gjesten er sjekket inn, men gjestekortet kunne ikke skrives ut.",
        "service-center-check-in-host-contact-link": "Vis vertens kontaktopplysninger",

        // Service center > Reports > Dashboard > Meetings drawer
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-title": "Vertens kontaktopplysninger",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-name": "Navn:",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-company-name": "Firma: ",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-department-name": "Avdeling: ",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-email": "E-post: ",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-business-phone": "Telefonnummer: ",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-mobile-phone": "Mobilnummer: ",
        "service-center-reports-dashboard-meetings-drawer-meeting-time": "Møtetidspunkt: ",
        "service-center-reports-dashboard-meetings-drawer-host": "Vert: ",
        "service-center-reports-dashboard-meetings-drawer-host-company": "Firma: ",
        "service-center-reports-dashboard-meetings-drawer-location": "Sted: ",
        "service-center-reports-dashboard-meetings-drawer-select-all": "\n .label = Velg alle",
        "service-center-reports-dashboard-meetings-drawer-guests-title": "Gjester",
        "service-center-reports-dashboard-meetings-drawer-guests-empty": "Ingen deltakere registrert.",
        "service-center-reports-dashboard-meetings-drawer-guests-list-checked-title": "\n .title = Sjekket inn",
        "service-center-reports-dashboard-meetings-drawer-guests-list-not-checked-title": "\n .title = Ikke sjekket inn",
        "service-center-reports-dashboard-meetings-drawer-guests-list-floating-check-action": "\n .title = Sjekk inn",
        "service-center-reports-dashboard-meetings-drawer-guests-list-floating-check-out-action": "\n .title = Sjekk ut",
        "service-center-reports-dashboard-meetings-drawer-check-out-done": "\n .title = Ferdig",
        "service-center-reports-dashboard-meetings-drawer-check-out-success": "Gjester sjekket ut",
        "service-center-reports-dashboard-meetings-drawer-guests-list-floating-print-guest-action": "Skriv ut gjestekort",
        "service-center-reports-dashboard-meetings-drawer-guests-list-floating-other-action":"\n .title = Annet",
        "service-center-reports-dashboard-meetings-drawer-selected-guests": "Valgte gjester",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-dropdown-item-manage-meeting-display": "Rediger møteskjerm",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-name-field-required-error": "Navn er påkrevd",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-success-message": "Møteskjermen er oppdatert",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-title": "Administrer møte på skjermer",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-meeting-name-label": "\n .label = Nytt møtenavn på skjermer \n .placeholder = Skriv inn nytt møtenavn",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-switch-label": "Vis som avlyst",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-show-on-screens-switch-label": "Vis på skjermer",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-submit-button": "Lagre",
        "service-center-reports-dashboard-meetings-list-row-shown-on-displays-tooltip": "\n .title = Vises på møteskjermer",
        "service-center-reports-dashboard-meetings-list-row-arrivals-tooltip": "\n .title = Sjekket inn",

        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-alert-change-name-label": "Endre møtenavn:",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-alert-change-name-description": " Hvis møtenavnet ikke egner seg for visning på møteskjermer, kan du redigere det her. Denne endringen påvirker bare navnet som vises på skjermene.",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-alert-cancel-meeting-label": "Avlys møte:",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-alert-cancel-meeting-description": " Hvis du må avlyse et møte, men vil beholde det synlig, kan du bare merke det som avlyst.",

        // Service center > Reports > Dashboard > Statistics
        "service-center-reports-statistics-page-header": "\n .title = Statistikk",
        "service-center-reports-statistics-occupancy-tab-title": "Belegg",
        "service-center-reports-statistic-occupancy-table-date-range-filter": "\n .label = Datointervall",
        "service-center-reports-statistic-occupancy-table-resource-title": "Ressurs",
        "service-center-reports-statistic-occupancy-table-occupancy-rate-title": "Beleggsgrad",
        "service-center-reports-statistic-occupancy-table-status-title": "Status",
        "service-center-reports-occupancy-dashboard-chart-title": "Belegg per ressurs",
        "service-center-reports-occupancy-dashboard-hero-overall-occupancy-label": "Samlet belegg",
        "service-center-reports-occupancy-dashboard-hero-resources-tracked-label": "Registrerte ressurser",
        "service-center-reports-occupancy-dashboard-chart-empty": "Ingen beleggsdata for denne perioden.",
        "service-center-reports-occupancy-dashboard-empty": "Ingen ressurser funnet for dette servicesenteret.",

        "service-center-reports-statistics-cancellations-tab-title": "Kanselleringer",
        "service-center-reports-statistic-cancellations-table-cancellation-rate-title": "Kanselleringsrate",

        "service-center-reports-statistics-booking-duration-tab-title": "Bookingvarighet",
        "service-center-reports-statistic-booking-duration-table-number-of-bookings-title": "Antall bookinger",
        "service-center-reports-statistic-booking-duration-table-average-duration-title":  "Gj.sn. varighet",
        "service-center-reports-bookings-dashboard-chart-title": "Gjennomsnittlig varighet per ressurs",
        "service-center-reports-bookings-dashboard-hero-total-bookings-label": "Bookinger totalt",
        "service-center-reports-bookings-dashboard-hero-average-duration-label": "Gjennomsnittlig bookingvarighet",
        "service-center-reports-bookings-dashboard-chart-empty": "Ingen bookinger for denne perioden.",
        "service-center-reports-bookings-dashboard-empty": "Ingen ressurser funnet for dette servicesenteret.",

        "service-center-reports-statistics-guests-tab-title": "Gjester",
        "service-center-reports-statistic-guests-table-date-title": "Dato",
        "service-center-reports-statistic-guests-table-guests-title": "Gjester",

        "service-center-reports-statistics-peak-hours-tab-title": "Travleste timer",
        "service-center-reports-statistics-peak-hours-heat-map-title": "Travleste timer",

        "service-center-reports-statistics-customer-usage-tab-title": "Leietakerbruk",

        // Service center > Statistics > Tenant usage (redesign)
        "service-center-usage-per-tenant-header-title": "Bruk per leietaker",
        "service-center-usage-per-tenant-header-subtitle": "Hvordan hver leietaker bruker delte ressurser i servicesenteret ditt.",
        "service-center-usage-per-tenant-filter-date-range": "\n .label = Datointervall",
        "service-center-usage-per-tenant-filter-tenant-label": "\n .label = Leietaker",
        "service-center-usage-per-tenant-resource-type-all": "Alle typer",
        "service-center-usage-per-tenant-tenant-all": "Alle leietakere",
        "service-center-usage-per-tenant-summary-center-caption": "booket i perioden",
        "service-center-usage-per-tenant-summary-hours": "{ $hours }t",
        "service-center-usage-per-tenant-summary-resources-tracked": "Registrerte ressurser",
        "service-center-usage-per-tenant-summary-tenants-active": "Aktive leietakere",
        "service-center-usage-per-tenant-summary-legend-other": "Andre ({ $count } leietakere)",
        "service-center-usage-per-tenant-detail-other-tenants": "{ $count } andre leietakere",
        "service-center-usage-per-tenant-section-title-room": "Møterom",
        "service-center-usage-per-tenant-section-title-mobile-av": "AV-utstyr",
        "service-center-usage-per-tenant-section-title-car": "Biler",
        "service-center-usage-per-tenant-section-title-unknown": "Andre ressurser",
        "service-center-usage-per-tenant-empty-resources": "Ingen ressursbruk for valgte filtre.",
        "service-center-usage-per-tenant-empty-tenants": "Ingen leietakeraktivitet for valgte filtre.",

        // Service center > Reports > Meeting rooms
        "service-center-meeting-rooms-page-header": "\n .title = Belegg i møterom",
        "service-center-meeting-rooms-status-filter-all": "Alle",
        "service-center-meeting-rooms-status-filter-booked": "Booket",
        "service-center-meeting-rooms-status-filter-available": "Ledige",
        "service-center-meeting-rooms-floor-filter-all": "Alle etasjer",
        "service-center-meeting-rooms-search-input": "\n .placeholder = Søk rom eller møteeier",
        "service-center-meeting-rooms-occupancy-by-hour-title": "Belegg i dag",
        "service-center-meeting-rooms-occupancy-by-day-title": "Belegg",
        "service-center-meeting-rooms-table-room-header": "Rom",
        "service-center-meeting-rooms-table-booking-header": "Booking",
        "service-center-meeting-rooms-table-time-header": "Tidsrom",
        "service-center-meeting-rooms-table-status-header": "Status",
        "service-center-meeting-rooms-table-room-seats": "{ $floor } · { $seats ->\n [one] { $seats } plass\n *[other] { $seats } plasser\n}",
        "service-center-meeting-rooms-table-no-booking": "Ingen booking",
        "service-center-meeting-rooms-table-occupied-without-booking": "Opptatt, ingen detaljer",
        "service-center-meeting-rooms-table-footer-count": "Viser { $shown } av { $total } rom",
        "service-center-meeting-rooms-table-free-until": "Ledig til { $time }",
        "service-center-meeting-rooms-table-free-rest-of-day": "Ledig resten av dagen",
        "service-center-meeting-rooms-view-status": "Status",
        "service-center-meeting-rooms-view-by-hour": "Per time",
        "service-center-meeting-rooms-view-by-room": "Per rom",
        "service-center-meeting-rooms-previous-day-button": "\n .aria-label = Forrige dag",
        "service-center-meeting-rooms-next-day-button": "\n .aria-label = Neste dag",
        "service-center-meeting-rooms-print-button": "\n .title = Skriv ut\n .aria-label = Skriv ut",
        "service-center-meeting-rooms-occupancy-peak-button": "Travlest { $hour } · { $peak } av { $total } rom booket <action>Vis</action>",
        "service-center-meeting-rooms-occupancy-hide-chart-button": "Skjul diagram",
        "service-center-meeting-rooms-occupancy-show-chart-button": "Vis diagram",
        "service-center-meeting-rooms-occupancy-hint": "Klikk på en time for å filtrere",
        "service-center-meeting-rooms-occupancy-peak-tooltip": "\n .title = Vis { $hour } i tabellen",
        "service-center-meeting-rooms-status-live-tooltip": "\n .title = Møte pågår nå: { $meeting } ({ $time })",
        "service-center-meeting-rooms-occupancy-now-badge": "Nå",
        "service-center-meeting-rooms-booking-state-in-progress": "Pågår",
        "service-center-meeting-rooms-booking-state-finished": "Avsluttet",
        "service-center-meeting-rooms-booking-state-upcoming": "Kommende",
        "service-center-meeting-rooms-group-hour-meta": "{ $count } av { $total } rom",
        "service-center-meeting-rooms-group-hour-empty": "Ingen bookinger i denne timen",
        "service-center-meeting-rooms-group-room-empty": "Ingen bookinger i dag",
        "service-center-meeting-rooms-drawer-room-section": "Om rommet",
        "service-center-meeting-rooms-drawer-equipment-label": "Utstyr",
        "service-center-meeting-rooms-drawer-department-label": "Avdeling",
        "service-center-meeting-rooms-drawer-phone-label": "Telefon",
        "service-center-meeting-rooms-drawer-email-label": "E-post",
        "service-center-meeting-rooms-drawer-receipt-button": "Vis kvittering",
        "service-center-meeting-rooms-drawer-status-occupied": "Opptatt til kl. { $time }",
        "service-center-meeting-rooms-drawer-status-occupied-next": "Opptatt til kl. { $time } · neste { $nextTime } { $meeting }",
        "service-center-meeting-rooms-drawer-status-free-next": "Ledig nå · neste { $nextTime } { $meeting }",
        "service-center-meeting-rooms-drawer-status-free-rest-of-day": "Ledig resten av dagen",
        "service-center-meeting-rooms-drawer-floor-label": "Etasje",
        "service-center-meeting-rooms-drawer-capacity-label": "Kapasitet",
        "service-center-meeting-rooms-drawer-capacity-value": "{ $seats ->\n [one] { $seats } person\n *[other] { $seats } personer\n}",
        "service-center-meeting-rooms-drawer-booking-id-label": "Booking-ID",
        "service-center-meeting-rooms-drawer-owner-subheading": "Møteeier",
        "service-center-meeting-rooms-drawer-name-label": "Navn",
        "service-center-meeting-rooms-drawer-activity-section": "Aktivitet",
        "service-center-meeting-rooms-drawer-activity-status-label": "Status { $time }",
        "service-center-meeting-rooms-drawer-activity-status-in-use": "I bruk",
        "service-center-meeting-rooms-drawer-activity-status-free": "Ledig",
        "service-center-meeting-rooms-drawer-next-booking-label": "Neste booking",
        "service-center-meeting-rooms-drawer-next-booking-none": "Ingen i dag",
        "service-center-meeting-rooms-drawer-next-booking-value": "{ $time } · { $meeting }",
        "service-center-meeting-rooms-drawer-bookings-today-label": "Bookinger i dag",
        "service-center-meeting-rooms-drawer-bookings-today-value": "{ $count ->\n [one] { $count } booking\n *[other] { $count } bookinger\n}",
        "service-center-meeting-rooms-drawer-timeline-hint-from-now": "{ $count ->\n [one] { $count } booking\n *[other] { $count } bookinger\n} · Fra nå av · velg et møte for detaljer",
        "service-center-meeting-rooms-drawer-timeline-hint-whole-day": "{ $count ->\n [one] { $count } booking\n *[other] { $count } bookinger\n} · Hele dagen · velg et møte for detaljer",
        "service-center-meeting-rooms-drawer-timeline-title": "Dagens program",
        "service-center-meeting-rooms-drawer-timeline-mode-from-now": "Fra nå",
        "service-center-meeting-rooms-drawer-timeline-mode-whole-day": "Hele dagen",
        "service-center-meeting-rooms-drawer-timeline-free": "Ledig",
        "service-center-meeting-rooms-drawer-timeline-occupied": "Opptatt",
        "service-center-meeting-rooms-table-free-from": "Ledig fra { $time }",
        "service-center-meeting-rooms-table-free-between": "Ledig { $timeRange }",
        "service-center-meeting-rooms-table-free-later": "deretter { $windows }{ $hidden ->\n [0] {\"\"}\n *[other] {\" \"}+{ $hidden }\n}",
        "service-center-meeting-rooms-table-booked-rest-of-day": "Opptatt resten av dagen",
        "service-center-meeting-rooms-table-no-free-time-today": "Ingen ledig tid i dag",
        "service-center-meeting-rooms-table-action-view-details": "Vis detaljer",
        "service-center-meeting-rooms-table-action-book": "Book { $hour }",
        "service-center-meeting-rooms-status-booked": "Booket { $hour }",
        "service-center-meeting-rooms-status-available": "Ledig { $hour }",
        "service-center-meeting-rooms-status-not-checked-in": "Ikke sjekket inn",
        "service-center-meeting-rooms-status-out-of-service": "Ute av drift",
        "service-center-meeting-rooms-reset-filters-button": "Tilbakestill",
        "service-center-meeting-rooms-group-hour-free-label": "Ledig",
        "service-center-meeting-rooms-group-hour-free-seats": "{ $seats ->\n [one] { $seats } plass\n *[other] { $seats } plasser\n}",
        "service-center-meeting-rooms-group-hour-free-empty": "Ingen ledige rom",
        "service-center-meeting-rooms-group-room-column-room": "Rom",
        "service-center-meeting-rooms-group-room-column-time": "Tidsrom",
        "service-center-meeting-rooms-group-room-column-meeting": "Møte",
        "service-center-meeting-rooms-group-room-column-duration": "Varighet",
        "service-center-meeting-rooms-group-room-column-attendees": "Deltakere",
        "service-center-meeting-rooms-occupancy-hour-tooltip": "\n .title = { $hour }: { $booked } av { $total } rom booket",
        "service-center-meeting-rooms-occupancy-hour-tooltip-jump-to-now": "\n .title = { $hour }: { $booked } av { $total } rom booket · klikk for å gå til nå",
        "service-center-meeting-rooms-table-no-match": "Ingen rom samsvarer med filtrene — tilbakestill status, etasje eller søk.",
        "service-center-meeting-rooms-table-footer-no-match": "Ingen rom samsvarer med filtrene",
        "service-center-meeting-rooms-booking-participants": "{ $participants ->\n [one] { $participants } person\n *[other] { $participants } personer\n}",
        "service-center-meeting-rooms-booking-participants-of-seats": "{ $participants } av { $seats ->\n [one] { $seats } plass\n *[other] { $seats } plasser\n}",
        "service-center-meeting-rooms-booking-catering-chip": "Møteservering",
        "service-center-meeting-rooms-booking-over-capacity-chip": "Over kapasitet",
        "service-center-meeting-rooms-drawer-participants-label": "Deltakere",
        "service-center-meeting-rooms-drawer-table-setup-label": "Bordoppsett",
        "service-center-meeting-rooms-drawer-catering-label": "Møteservering",
        "service-center-meeting-rooms-drawer-catering-ordered": "Bestilt",
        "service-center-meeting-rooms-drawer-catering-not-ordered": "Ikke bestilt",

        // Service center > Reports > Dashboard > Guests
        "service-center-reports-dashboard-guests-page-header": "\n .title = Gjester",
        "service-center-reports-dashboard-guests-table-guest-title": "Gjest",
        "service-center-reports-dashboard-guests-table-host-title": "Vert",
        "service-center-reports-dashboard-guests-table-check-in-time-title": "Innsjekking",
        "service-center-reports-dashboard-guests-table-check-in-time-tooltip": "Møtestart",
        "service-center-reports-dashboard-guests-table-check-out-time-title": "Utsjekking",
        "service-center-reports-dashboard-guests-table-host-company-title": "Vertsfirma",
        "service-center-reports-dashboard-guests-table-host-company-status": "Status",
        "service-center-reports-dashboard-guests-table-host-company-status-checked-in": "Sjekket inn",
        "service-center-reports-dashboard-guests-table-host-company-status-checked-out": "Sjekket ut",
        "service-center-reports-dashboard-guests-table-host-company-status-expected": "Forventet",
        "service-center-reports-dashboard-guests-table-host-company-status-pending": "Venter i kø",
        "service-center-reports-dashboard-guests-table-host-company-status-checked-in-hover-tooltip": "Gjesten er sjekket inn.",
        "service-center-reports-dashboard-guests-table-host-company-status-checked-out-hover-tooltip": "Gjesten er sjekket ut.",
        "service-center-reports-dashboard-guests-table-host-company-status-expected-hover-tooltip": "Gjesten er invitert, men har ikke sjekket inn ennå.",
        "service-center-reports-dashboard-guests-table-host-company-status-pending-hover-tooltip": "Gjesten har gjennomført selvinnsjekking, men resepsjonen bør ønske velkommen og dele ut et gjestekort.",
        "service-center-reports-dashboard-guests-table-floating-action-bar-guest-card": "\n .title = Gjestekort",
        "service-center-reports-dashboard-guests-table-date-range-filter": "\n .label = Møteperiode",


        // Service center > Admin > Organization > DEVICES
        "service-center-admin-organization-devices-title": "\n .title = Enheter",
        "service-center-admin-organization-devices-button-title": "Opprett enhet",

        // Service center > Admin > Organization > Resources
        "service-center-admin-organization-resources-title": "\n .title = Ressurser",
        "service-center-admin-organization-resources-create-button": "Opprett ny",
        "service-center-admin-organization-resources-rooms-tab": "Rom",
        "service-center-admin-organization-resources-mobile-av-equipment-tab": "AV-utstyr",
        "service-center-admin-organization-resources-cars-tab": "Biler",
        "service-center-admin-organization-resources-table-header-name": "Navn",
        "service-center-admin-organization-resources-table-room-header-id": "Romnr.",
        "service-center-admin-organization-resources-table-mobile-av-header-id": "Serienr.",
        "service-center-admin-organization-resources-table-cars-header-id": "Reg.nr.",
        "service-center-admin-organization-resources-table-header-status": "Status",
        "service-center-admin-organization-resources-table-edit-item": "Rediger",
        "service-center-admin-organization-resources-table-delete-item": "Slett",
        "service-center-admin-organization-resources-table-room-delete-modal-title": "rom",
        "service-center-admin-organization-resources-table-mobile-av-equipment-delete-modal-title": "mobilt AV-utstyr",
        "service-center-admin-organization-resources-table-car-delete-modal-title": "bil",

        "service-center-admin-organization-resources-create-room": "Rom",
        "service-center-admin-organization-resources-create-car": "Bil",
        "service-center-admin-organization-resources-status-not-approved": "Ikke godkjent",
        "service-center-admin-organization-resources-status-approved": "Godkjent",
        "service-center-admin-organization-resources-status-rejected": "Avvist",
        "service-center-admin-organization-resources-status-locked": "Låst",
        "service-center-admin-organization-resources-status-preparing": "Forberedes",
        "service-center-admin-organization-resources-status-delivered": "Levert",
        "service-center-admin-organization-resources-status-to-be-booked": "Skal bokføres",
        "service-center-admin-organization-resources-status-booked": "Bokført",
        "service-center-admin-organization-resources-status-completed": "Utført",

        "service-center-admin-organization-resources-status-menu-not-approved": "Forkast godkjenning",
        "service-center-admin-organization-resources-status-menu-approved": "Godkjenn",
        "service-center-admin-organization-resources-status-menu-rejected": "Avvis",
        "service-center-admin-organization-resources-status-menu-locked": "Lås",
        "service-center-admin-organization-resources-status-menu-preparing": "Forbered",
        "service-center-admin-organization-resources-status-menu-delivered": "Levert",
        "service-center-admin-organization-resources-status-menu-booked": "Bokfør",
        "service-center-admin-organization-resources-status-menu-ready": "Klar",
        "service-center-admin-organization-resources-status-menu-completed": "Fullfør",
        "service-center-admin-organization-resources-status-menu-default": "Ingen status",

        // Service center > Admin > Organization > Resources > Create Mobile AV
        "service-center-admin-organization-resources-create-mobile-av-title": "\n .title = Opprett Mobile AV",
        "service-center-admin-organization-resources-update-mobile-av-title": "\n .title = Oppdater Mobile AV",
        "resources-create-edit-mobile-av-general-tab-error": "Fanen Generelt har valideringsfeil",

        // Service center > Admin > Organization > Resources > Create car
        "service-center-admin-organization-resources-create-car-title": "\n .title = Opprett bil",
        "service-center-admin-organization-resources-update-car-title": "\n .title = Oppdater bil",
        "resources-create-edit-car-general-tab-error": "Fanen Generelt har valideringsfeil",

        // Service center > Admin > Organization > Resources > Create car > General
        "resources-create-edit-car-general-tab-general": "Generelt",
        "resources-create-car-tab-general-registration-number-label": "\n .label = Registreringsnummer",
        "resources-create-car-tab-general-name-label": "\n .label = Navn",
        "resources-create-car-tab-general-description-label": "\n .label = Beskrivelse",
        "resources-create-car-tab-general-car-type-label": "\n .label = Biltype",
        "resources-create-car-tab-general-location-of-keys-label": "\n .label = Nøkkelplassering",
        "resources-create-car-tab-general-parking-location-label": "\n .label = Standard parkeringssted",
        "resources-create-car-tab-general-active-label": "Aktiv:",
        "resources-create-car-tab-general-in-service-label": "I drift:",
        "resources-create-car-tab-general-side-settings": "\n .title = Innstillinger",

        // Service center > Admin > Organization > Resources > Create Mobile AV > General
        "resources-create-edit-mobile-av-general-tab-general": "Generelt",
        "resources-create-mobile-av-tab-general-serial-number-label": "\n .label = Serienummer",
        "resources-create-mobile-av-tab-general-name-label": "\n .label = Navn",
        "resources-create-mobile-av-tab-general-floor-label": "\n .label = Etasje",
        "resources-create-mobile-av-tab-general-description-label": "\n .label = Beskrivelse",
        "resources-create-mobile-av-tab-general-storage-location-label": "\n .label = Oppbevaringssted",
        "resources-create-mobile-av-tab-general-cleanup-buffer-label": "\n .label = Oppryddingsbuffer",
        "resources-create-mobile-av-tab-general-color-code-label": "\n .label = Fargekode",
        "resources-create-mobile-av-tab-general-active-label": "Aktiv:",
        "resources-create-mobile-av-tab-general-side-settings": "\n .title = Innstillinger",


        // Service center > Admin > Organization > Resources > Create room
        "service-center-admin-organization-resources-create-room-title": "\n .title = Opprett rom",
        "resources-create-edit-room-general-tab-error": "Fanen Generelt har valideringsfeil",

        // Service center > Admin > Organization > Resources > Create room > General
        "resources-create-edit-room-general-tab-general": "Generelt",
        "resources-create-room-tab-general-room-number-label": "\n .label = Romnummer",
        "resources-create-room-tab-general-name-label": "\n .label = Navn",
        "resources-create-room-tab-general-description-label": "\n .label = Beskrivelse",
        "resources-create-room-tab-general-seats-label": "\n .label = Plasser",
        "resources-create-room-tab-general-active-label": "Aktiv:",
        "resources-create-room-tab-general-other-location-label": "Annet sted:",
        "resources-create-room-tab-general-other-location-description": "\n .title = Hvis et rom merkes som \"Annet sted\", kan brukeren skrive inn et ad hoc-sted for møtet, for eksempel sitt eget kontor.",
        "resources-create-room-tab-general-side-settings": "\n .title = Innstillinger",
        "resources-create-room-tab-general-floor-label": "\n .label = Etasje",
        "resources-create-room-tab-general-walk-direction-label": "\n .label = Gangretning",
        "resources-create-room-tab-general-walk-direction-north": "Nord",
        "resources-create-room-tab-general-walk-direction-east": "Øst",
        "resources-create-room-tab-general-walk-direction-south": "Sør",
        "resources-create-room-tab-general-walk-direction-west": "Vest",
        "resources-create-room-tab-general-color-red": "Rød",
        "resources-create-room-tab-general-color-green": "Grønn",
        "resources-create-room-tab-general-color-blue": "Blå",
        "resources-create-room-tab-general-color-black": "Svart",
        "resources-create-room-tab-general-color-lightblue": "Lyseblå",
        "resources-create-room-tab-general-tags-label":  "\n .label = Tagger",
        "resources-create-room-tab-general-tags-info-description":  "\n .label = Opprett én eller flere tagger som kan brukes til å filtrere ressurser. For eksempel \"Eksternt møterom\", \"Gjestemøterom\", \"Konferanserom\", \"Telefonrom\" osv.",
        "resources-create-room-tab-general-fixed-av-equipment-label":  "\n .label = Fast AV-utstyr",
        "resources-create-room-tab-general-side-filter-details": "\n .title = Filterdetaljer",
        "resources-create-room-tab-general-area-label": "\n .label = Areal (m²) \n .placeholder = Rommets areal i m²",
        "resources-create-room-tab-general-cleanup-buffer-label": "\n .label = Oppryddingsbuffer",
        "resources-create-room-tab-general-color-code-label": "\n .label = Fargekode",
        "resources-create-room-tab-general-email-address-label": "\n .label = E-postadresse",
        "resources-create-room-tab-general-side-integrations": "\n .title = Kalenderintegrasjon",
        "resources-create-room-tab-general-side-integrations-meeting-invite": "\n .description = Brukes til integrasjon med Exchange eller andre kalendersystemer. E-postadressen legges til i møteinnkallingen av FacilityNet Outlook Add-in når rommet bookes.",
        "resources-create-room-tab-general-side-integrations-starleaf": "\n .description =Brukes til integrasjon med StarLeaf-utstyr som leveres med en dedikert e-postadresse for integrasjon.",
        "resources-create-room-tab-general-side-integrations-ews": "\n .description = Brukes til integrasjon med utstyr som leser fra en kalender. Postboksens kalender bookes ved hjelp av en EWS-tjenestekonto når rommet bookes.",

        "resources-create-room-tab-general-book-using-ews": "Book med EWS",

        // Service center > Admin > Organization > Resources > Create room > Table arrangements
        "resources-create-edit-room-general-tab-table-arrangements": "Bordoppsett",
        "service-center-reports-dashboard-meeting-filter-mobile-av": "Mobilt AV",
        "service-center-reports-dashboard-meeting-filter-set-tables": "Dekking",
        "service-center-reports-dashboard-meeting-filter-cleanup": "Rydding",
        "tab-table-arrangements-standard": "Standard",
        "tab-table-arrangements-optional-chip": "Valgfri",
        "tab-table-arrangements-make-standard-button": "Gjør til standard",
        "tab-table-arrangements-add-new-card": "Legg til nytt bordoppsett",
        "tab-table-arrangements-label-meeting-room": "Møterom",
        "tab-table-arrangements-label-cinema": "Kino",
        "tab-table-arrangements-label-u-form": "U-form",
        "tab-table-arrangements-label-school": "Skole",
        "tab-table-arrangements-label-group": "Gruppe",
        "tab-table-arrangements-label-negotiation": "Forhandling",
        "tab-table-arrangements-label-cafe": "Kafé",
        "tab-table-arrangements-label-conference": "Konferanse",
        "tab-table-arrangements-label-herringbone": "Sildebein",
        "tab-table-arrangements-create-dialog-title": "Nytt bordoppsett",
        "tab-table-arrangements-create-dialog-name-label": "\n .label = Navn",
        "tab-table-arrangements-create-dialog-image-label": "Bilde",
        "tab-table-arrangements-create-dialog-submit-button": "Opprett",
        "tab-table-arrangements-create-dialog-name-required-error": "Navn er påkrevd",
        "tab-table-arrangements-create-dialog-image-required-error": "Bilde er påkrevd",

        // Service center > Admin > Organization > Resources > Create room > Notifiations
        "resources-create-edit-room-general-tab-table-header-type": "Type",
        "resources-create-edit-room-general-tab-table-header-sent": "Sendt",
        "resources-create-edit-room-general-tab-table-header-content": "Innhold",

        // Service center > Admin > Organization > Resources > Create room > Availability
        "resources-create-edit-room-general-tab-availability": "Tilgjengelighet",
        "tab-availability-closed-periods-title": "Utilgjengelig periode",
        "tab-availability-table-start-header": "Start",
        "tab-availability-table-end-header": "Slutt",
        "tab-availability-table-reason-header": "Årsak",
        "tab-availability-table-edit-action": "Rediger",
        "tab-availability-table-delete-action": "Slett",
        "tab-availability-add-closed-period-action": "Legg til utilgjengelig periode",
        "tab-availability-side-daily-closing-times-title": "\n .title = Daglige stengetider",
        "tab-availability-side-daily-booking-times-title": "\n .title = Daglige bookingtimer",
        "tab-availability-booking-time-option-all-day": "\n .label = Tilgjengelig hele dagen",
        "tab-availability-booking-time-option-specific-hours": "\n .label = Kun tilgjengelig i bestemte timer",
        "tab-availability-booking-time-option-daily-break": "\n .label = Utilgjengelig under en daglig pause",
        "tab-availability-booking-time-from-label": "\n .label = Fra",
        "tab-availability-booking-time-to-label": "\n .label = Til",
        "tab-availability-side-start-time-label": "\n .label = Starttid",
        "tab-availability-side-end-time-label": "\n .label = Sluttid",
        "tab-availability-modal-reason-label": "\n .label = Årsak",
        "tab-availability-modal-reason-max": "Årsak kan ikke være lengre enn { $max } tegn",
        "tab-availability-modal-title": "Legg til stengt periode",
        "tab-availability-modal-add-button": "Legg til",

        "tab-availability-add-reminder-dialog-title": "Legg til påminnelse",
        "tab-availability-add-reminder-edit-dialog-title": "Rediger påminnelse",
        "tab-availability-add-reminder-dialog-field-type-label": "\n .label = Type",
        "tab-availability-add-reminder-dialog-field-time-label": "\n .label = Sendt",
        "tab-availability-add-reminder-dialog-field-text-label": "\n .label = Tekst",
        "tab-availability-add-reminder-dialog-text-max": "Teksten kan ikke være lengre enn { $max } tegn",
        "tab-availability-add-reminder-dialog-submit-button-label": "Legg til",

        "tab-availability-add-reminder-dialog-form-time-suffix-hours-before": "timer før møtestart",
        "tab-availability-add-reminder-dialog-form-time-suffix-minutes-before": "minutter før møtestart",
        "tab-availability-add-reminder-dialog-form-time-suffix-hours-after": "timer etter møteslutt",
        "tab-availability-add-reminder-dialog-form-time-suffix-minutes-after": "minutter etter møteslutt",

        "reminder-type-option-meeting-start": "Påminnelse om møtestart",
        "reminder-type-option-first-reminder": "Første påminnelse",
        "reminder-type-option-preparation": "Forberedelse",
        "reminder-type-option-cleanup": "Opprydding",
        "reminder-type-option-custom-reminder": "Tilpasset påminnelse",
        "reminder-type-option-meeting-confirmation": "Møtebekreftelse",

        "integration-type-option-none": "Ingen",
        "integration-type-option-meeting-invite": "Møteinnkalling",
        "integration-type-option-ews": "EWS",
        "integration-type-option-starleaf": "Starleaf",

        // Service center > Admin > Organization > Resources > Create room > Access control
        "resources-create-edit-room-general-tab-access-control": "Adgangskontroll",
        "tab-access-control-restricted-access-title": "\n .title =Begrenset tilgang",
        "tab-access-control-visible-everyone-switch":"Synlig for alle",
        "tab-access-control-reserved-for-company-title":"Reservert for firma:",
        "tab-access-control-bookable-by-departments-title":"Kan bookes av avdelinger:",
        "tab-access-control-select-department-select-item":"Velg en avdeling",
        "tab-access-control-add-button":"Legg til",


        // Service center > Admin > Account > Admins
        "service-center-admin-account-admins-page-header": "\n .title = Administratorer",
        "service-center-admin-account-admins-table-header-name":"Navn",
        "service-center-admin-account-admins-table-header-email":"E-post",
        "service-center-admin-account-admins-table-header-status":"Status",
        "service-center-admin-account-admins-table-status-active":"Aktiv",
        "service-center-admin-account-admins-table-status-inactive": "Inaktiv",
        "service-center-admin-account-admins-table-button-details": "Vis detaljer",
        "service-center-admin-account-admins-table-button-edit": "Rediger bruker",
        "service-center-admin-account-admins-table-button-delete": "Slett bruker",
        "service-center-admin-account-admins-delete-dialog-entity-type": "bruker",
        "service-center-admin-account-admins-button-create": "Opprett ny",

        // Service center > Admin > Organization > Manage bookings
        "service-center-admin-organization-manage-bookings-page-header": "\n .title = Administrer ordrer",
        "service-center-admin-organization-manage-bookings-breadcrumb": "Administrer ordrer",
        "service-center-admin-organization-manage-bookings-confirm-button": "Fortsett",
        "service-center-admin-organization-manage-bookings-action-move": "Flytt til ny eier",
        "service-center-admin-organization-manage-bookings-action-delete": "Slett",
        "service-center-admin-organization-manage-bookings-select-action": "\n .label = Velg handling:",
        "service-center-admin-organization-manage-bookings-select-action-placeholder": "Velg",
        "service-center-admin-organization-manage-bookings-select-company": "\n .label = Velg firma:",
        "service-center-admin-organization-manage-bookings-select-user": "\n .label = Velg bruker:",
        "service-center-admin-organization-manage-bookings-select-new-owner": "\n .label = Velg ny eier:",
        "service-center-admin-organization-manage-bookings-what-to-move-label": "Hva skal flyttes:",
        "service-center-admin-organization-manage-bookings-what-to-delete-label": "Hva skal slettes:",
        "service-center-admin-organization-manage-bookings-current-owner-title": "Nåværende eier",
        "service-center-admin-organization-manage-bookings-new-owner-title": "Ny eier",
        "service-center-admin-organization-manage-bookings-checkbox-bookings": "Bookinger",
        "service-center-admin-organization-manage-bookings-checkbox-meeting-service": "Møteserveringsordrer",
        "service-center-admin-organization-manage-bookings-error-company-required": "Firma er påkrevd",
        "service-center-admin-organization-manage-bookings-error-user-required": "Bruker er påkrevd",
        "service-center-admin-organization-manage-bookings-error-action-required": "Handling er påkrevd",
        "service-center-admin-organization-manage-bookings-error-new-owner-required": "Ny bookingeier er påkrevd",
        "service-center-admin-organization-manage-bookings-error-at-least-one-option": "Velg minst ett alternativ",
        "service-center-admin-organization-manage-bookings-alert-move": "\n .title = Ordrer flyttes til ny eier, som du velger nedenfor.",
        "service-center-admin-organization-manage-bookings-alert-delete": "\n .title = Alle fremtidige bookinger for denne brukeren blir kansellert.",
        "service-center-admin-organization-manage-bookings-confirm-modal-move-title": "Flytt ordrer",
        "service-center-admin-organization-manage-bookings-confirm-modal-delete-title": "Slett ordrer",
        "service-center-admin-organization-manage-bookings-confirm-modal-move-message": "Bekreft at du vil flytte { $count } ordrer.",
        "service-center-admin-organization-manage-bookings-confirm-modal-delete-message": "Bekreft at du vil slette { $count } ordrer.",
        "service-center-admin-organization-manage-bookings-confirm-modal-move-no-orders": "Det er ingen ordrer å flytte.",
        "service-center-admin-organization-manage-bookings-confirm-modal-delete-no-orders": "Det er ingen ordrer å slette.",
        "service-center-admin-organization-manage-bookings-confirm-modal-from": "Fra: { $name }",
        "service-center-admin-organization-manage-bookings-confirm-modal-user": "Bruker: { $name }",
        "service-center-admin-organization-manage-bookings-confirm-modal-to": "Til: { $name }",
        "service-center-admin-organization-manage-bookings-confirm-modal-user-id-tooltip": "\n .title = Intern bruker-ID",
        "service-center-admin-organization-manage-bookings-confirm-modal-submit-button": "Bekreft",
        "service-center-admin-organization-manage-bookings-confirm-modal-cancel-button": "Avbryt",
        "service-center-admin-organization-manage-bookings-confirm-modal-close-button": "Lukk",
        "service-center-admin-organization-manage-bookings-confirm-modal-excluded-orders": "\n .title = { $count } ordrer ekskludert: { $reason }",
        "service-center-admin-organization-manage-bookings-success-modal-move-title": "Ordrer flyttet",
        "service-center-admin-organization-manage-bookings-success-modal-delete-title": "Ordrer slettet",
        "service-center-admin-organization-manage-bookings-submit-missing-data-error": "Mangler påkrevde data, prøv igjen",
        "service-center-admin-organization-manage-bookings-user-no-results": "Ingen brukere funnet",
        "service-center-admin-organization-manage-bookings-select-placeholder": "Velg",

        // Product availability
        "product-unavailable-dialog-close": "Lukk",
        "product-unavailable-snackbar": "Dette produktet er ikke tilgjengelig for øyeblikket",
        "product-daily-limit-exceeded-snackbar": "Daglig kjøpsgrense nådd for dette produktet",
        "product-stock-limit-exceeded-snackbar": "Ikke nok varer på lager",
        "product-stock-negative-error": "Lagerbeholdningen kan ikke være negativ",

        // Order chat
        "order-chat-drawer-title-customer": "Chat med kantinen",
        "order-chat-drawer-title-merchant": "Chat med kunden",
        "order-chat-disclaimer-text": "Denne chatten brukes til å kommunisere om bestillingen. Meldinger vises ikke på ordrespesifikasjonen.",
        "order-chat-disclaimer-warning": "OBS: Unngå å skrive inn sensitive personopplysninger, f.eks. om du er vegetarianer eller har allergier.",
        "order-chat-disclaimer-link": "Les mer <a>her</a>.",
        "order-chat-disclaimer-accept": "Forstått",
        "order-chat-placeholder-merchant": "Melding til kunde...",
        "order-chat-placeholder-customer": "Melding til kantinen...",
        "order-chat-empty": "\n .title = Ingen meldinger ennå\n .description = Start samtalen!",
        "order-chat-exceeded-characters": "Maksimalt { $limit } tegn overskredet",
        "order-chat-menu-item-customer": "Chat med kantinen",
        "order-chat-menu-item-merchant": "Chat med kunden",
        "order-chat-tooltip-needs-response": "Ny melding - krever svar",
        "order-chat-tooltip-responded": "Chat",
        "order-chat-history-print-with-button": "Skriv ut med chathistorikk",
        "order-chat-history-print-without-button": "Skriv ut",
        "meeting-service-print-view-order-menu-print-button": "Skriv ut (med ordrenotat)",
        "meeting-service-print-view-order-menu-print-with-chat-button": "Skriv ut (med ordrenotat og chat)",
        "meeting-service-print-view-order-menu-print-section-title": "Skriv ut ordre",
        "order-chat-history-print-title": "Chathistorikk",
        "order-chat-status-card-messages-badge": "\n .label = { $count -> \n [one] { $count } melding \n *[other] { $count } meldinger \n }",
        "order-chat-status-card-reply-own": "Du svarte den { $date } kl. { $time }: <quote>“{ $message }”</quote>",
        "order-chat-status-card-reply-user": "Kunden svarte den { $date } kl. { $time }: <quote>“{ $message }”</quote>",
        "order-chat-status-card-reply-merchant": "Kantinen svarte den { $date } kl. { $time }: <quote>“{ $message }”</quote>",
    },
    "sv-SE": {
        // Preferred hour cycle for locale
        // NOTE: Only necessary to specify if default for country/region from CLDR supplementary data used by browser Intl API is incorrect
        // See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle
        // See: https://github.com/unicode-org/cldr/blob/master/common/supplemental/supplementalData.xml#L4768
        "date-time-hour-cycle": "h23",

        // Date and time formats as Luxon format strings
        // See: https://moment.github.io/luxon/docs/manual/formatting.html#table-of-tokens
        "date-time-format-date": "yyyy-MM-dd",
        "date-time-format-long-date": "d MMMM yyyy",
        "date-time-format-month-day": "d MMM",
        "date-time-format-weekday-long-date": "EEEE d MMMM yyyy",
        "date-time-format-day-and-date": "EEEE dd/MM",
        "date-time-format-time": "HH:mm",
        "date-time-format-time-hms": "HH:mm:ss",
        "date-time-format-date-and-time": "yyyy-MM-dd HH:mm",
        "date-time-format-duration-hours-minutes": "h't.' m'min.'",
        "date-time-format-duration-minutes": "m'min.'",
        "date-time-format-duration-seconds": "s's'",
        "date-time-compact-period-start": "yy-M-d 'kl.' HH:mm",
        "date-time-short-relative-units": "s|m|t|d|v|mån|år",
        "date-time-invalid-date": "E/T",

        // Money formats
        "money-amount-unit-month": "mån.",
        "money-amount-unit-year": "år",

        // Numeric field validation
        "numeric-field-invalid-error": "{ $label } måste vara ett tal",
        "numeric-field-integer-error": "{ $label } måste vara ett heltal",
        "numeric-field-positive-error": "{ $label } måste vara större än 0",
        "numeric-field-non-negative-error": "{ $label } måste vara 0 eller högre",
        "numeric-field-negative-error": "{ $label } måste vara mindre än 0",
        "numeric-field-non-positive-error": "{ $label } måste vara 0 eller lägre",
        "vat-code-vat-percentage-field-name": "Momsprocent",
        "price-list-percentage-field-name": "Procentsats",

        // User types
        "-user-type-support": "Support",
        "-user-type-supplier": "Kantinoperatör",
        "-user-type-merchant": "Butiksägare",
        "-user-type-company": "Företagsadministratör",
        "-user-type-office-manager": "Kontorschef",
        "-user-type-user": "Användare",
        "-user-type-service-center": "Servicecenter",


        // Shared components
        "error-boundary-modal": "\n .title = Något gick fel\n .message = Felkod: { $errorCode }\n .buttonLabel = Stäng fönstret",
        "query-error-boundary": "\n .title = Något gick fel\n .message = Felkod: { $errorCode }\n .buttonLabel = Försök igen",
        "confirmation-dialog-cancel": "Avbryt",
        "confirmation-dialog-approve": "Godkänn",
        "coming-soon-dialog-title": "Kommer snart",
        "coming-soon-dialog-message": "Vi arbetar på att leverera den här funktionen till dig.",
        "coming-soon-dialog-ok-button": "OK",
        "meeting-time-label-today": "Idag kl. { $period }",
        "meeting-time-label-tomorrow": "Imorgon kl. { $period }",
        "meeting-time-label-yesterday": "Igår kl. { $period }",
        "meeting-time-label-date": "{ $date } kl. { $period }",
        "error-dialog-show-details-label": "Visa detaljer",
        "error-dialog-close-button": "Stäng",
        "error-dialog-support-request": "Kontakta <supportMessage>support@facilitynet.dk</supportMessage> om problemet kvarstår.",
        "error-route": "\n .title = Något gick fel \n .message Den här sidan kan inte visas på grund av ett okänt fel \n .buttonLabel = Gå till startsidan",
        "time-or-date-picker-time-label": "Tid",
        "api-call-timeout-message": "Begäran tar längre tid än väntat",
        "api-call-generic-success": "Åtgärden genomfördes",

        // authenticate common texts
        "-authenticate-submit-button": "Nästa",

        // --- Error boundaries ---
        "app-error-boundary": "\n .title = Något gick fel\n .buttonLabel = Stäng fönstret",
        "app-error-boundary-title": "Något gick fel",
        "app-error-boundary-button": "Stäng fönstret",
        "route-error-boundary": "\n .title = Något gick fel\n .buttonLabel = Gå till startsidan",
        "inline-error-boundary-message": "Kunde inte rendera komponenten",
        "inline-error-boundary-calendar-event-message": "Kunde inte tolka händelsen",
        "query-error-boundary-message": "Fel vid inläsning av data.",
        "query-error-boundary-no-data-message": "Inga data.",
        "query-error-boundary-retry-button": "Försök igen",


        // --- Language selector ---
        "language-selector-lang-en-us": "Engelska",
        "language-selector-lang-da-dk": "Danska",
        "language-selector-lang-nb-no": "Norska",
        "language-selector-lang-sv-se": "Svenska",


        // --- Footer ---
        "footer-read-more": "Läs mer på <linkElem>{ $linkName }</linkElem>",


        // --- Avatar menu ---
        "avatar-menu-menu-item-help": "Hjälp",
        "avatar-menu-menu-item-merchant-tour": "Rundtur",
        "avatar-menu-menu-item-news": "Nyheter från Facilitynet",
        "avatar-menu-menu-item-profile": "Användarkonto",
        "avatar-menu-menu-item-archive": "Arkiv",
        "avatar-menu-menu-item-change-user-account": "Byt användarkonto",
        "avatar-menu-menu-item-swift-merchant": "Byt försäljningsställe",
        "avatar-menu-menu-item-settings": "Inställningar",
        "avatar-menu-menu-item-logout": "Logga ut",
        "avatar-menu-menu-item-system-status": "Systemstatus",
        "avatar-menu-tooltip-profile": "\n .title = Visa ditt användarkonto",
        "avatar-menu-tooltip-settings": "\n .title = Ändra inställningar för ditt användarkonto",
        "avatar-menu-tooltip-change-user-account": "\n .title = Om du har flera användarkonton kan du växla mellan dem här",
        "avatar-menu-tooltip-switch-merchant": "\n .title = Om du har tillgång till flera försäljningsställen kan du växla mellan dem här",
        "avatar-menu-tooltip-news": "\n .title = Läs nyheter från Facilitynet",
        "avatar-menu-tooltip-help": "\n .title = Få hjälp med att använda systemet",
        "avatar-menu-tooltip-merchant-tour": "\n .title = Starta rundturen",
        "avatar-menu-tooltip-system-status": "\n .title = Visa och prenumerera på viktiga meddelanden om systemet",
        "avatar-menu-tooltip-logout": "\n .title = Logga ut från systemet",


        // --- Confirm dialogs ---
        "confirm-modal-confirm-label": "Är du säker?",
        "delete-confirm-modal-title": "Ta bort { $itemType }",
        "delete-confirm-modal-question": "Är du säker på att du vill ta bort '{ $itemName }'?",
        "delete-confirm-modal-button-delete": "Ta bort",
        "delete-confirm-modal-button-cancel": "Avbryt",
        "delete-confirm-modal-button-submit": "Skicka",
        "cancel-subscription-modal-title": "Säg upp prenumeration",
        "cancel-subscription-modal-message": "Är du säker på att du vill säga upp prenumerationen '{ $subscriptionName }' för { $customerName }?",
        "cancel-subscription-modal-label-ignore-terms": "\n .label = Med omedelbar verkan",
        "cancel-subscription-modal-helper-text-ignore-terms": "Detta åsidosätter prenumerationsvillkoren.",
        "cancel-subscription-modal-button-delete": "Säg upp",


        // --- Not found ---
        "not-found-title": "Hittades inte",
        "not-found-explanation": "Sidan du letar efter finns inte.",
        "not-found-path-label": "Sökväg:",
        "not-found-go-home-button": "Gå till startsidan",


        // --- Access denied ---
        "access-denied-title": "Åtkomst nekad",
        "access-denied-explanation": "Din användarprofil har inte åtkomst till den här sidan.",
        "access-denied-required-usertype-label": "Obligatorisk användartyp:",
        "access-denied-actual-usertype-label": "Din användartyp:",
        "access-denied-path-label": "Sökväg:",
        "access-denied-go-home-button": "Gå till startsidan",
        "access-denied-logout-button": "Logga ut",

        "access-denied-usertype-support": "{ -user-type-support }",
        "access-denied-usertype-supplier": "{ -user-type-supplier }",
        "access-denied-usertype-merchant": "{ -user-type-merchant }",
        "access-denied-usertype-company": "{ -user-type-company }",
        "access-denied-usertype-office-manager": "{ -user-type-office-manager }",
        "access-denied-usertype-unknown": "Okänd",


        "login-email-label": "Logga in",
        "login-password-label": "Ange ditt lösenord",
        "login-email-field-label": "\n .label = E-post",
        "test": "Test",
        "bottom-menu-item-home": "\n .label = Hem",
        "bottom-menu-item-profile": "\n .label = Profil",

        "confirm-email-button": "Bekräfta\n .loadingLabel = Bekräftar...",
        "confirm-email-description": "Följande användarkonton är alla registrerade med e-postadressen <email>{ $email }</email> och kan växla konto. Se till att alla tillhör dig:",
        "confirm-email-title": "Bekräfta kontoåtkomst",
        "confirm-email-success-message": "Du kan nu växla mellan dina användarkonton",
        "confirm-email-error-message": "Vi kunde inte bekräfta din e-postadress",
        "confirm-email-missing-userid-or-otp": "Användar-ID eller engångskod saknas",

        "purchases-payment-method-free": "Gratis",
        "purchases-payment-method-credit-card": "Kreditkort",
        "purchases-payment-method-one-click-payment": "Kreditkort",
        "purchases-payment-method-mobile-pay": "MobilePay",
        "purchases-payment-method-payroll-deduction": "Löneavdrag",
        "purchases-payment-method-lunch-registration": "Lunchordning",
        "purchases-payment-method-gopay-wallet": "GoPay Wallet",
        "purchases-payment-method-invoice": "Faktura",
        "purchases-payment-method-cash": "Kontant",
        "purchases-payment-method-gopay-account": "GoPay Wallet",
        "purchases-payment-method-refund": "Återbetald",
        "purchases-payment-method-subscribe-payment-card": "Registrera betalkort",
        "purchases-payment-method-id-card": "ID-kort",

        // --- Error handling ---
        "api-call-error-title-unknown-error": "Okänt fel",
        "api-call-error-title-network-error": "Nätverksfel",
        "api-call-error-title-bad-request": "Begäran avvisad",
        "api-call-error-title-unauthorized": "Ogiltig inloggning",
        "api-call-error-title-forbidden": "Åtkomst nekad",
        "api-call-error-title-not-found": "Hittades inte",
        "api-call-error-title-conflict": "Konflikt",
        "api-call-error-title-too-many-requests": "För många begäranden",
        "api-call-error-title-internal-server-error": "Internt serverfel",
        "api-call-error-title-service-unavailable": "Tjänsten är inte tillgänglig",
        "api-call-error-title-request-failed": "Begäran misslyckades",
        "api-call-error-unknown-error": "Okänt fel",
        "api-call-error-no-internet-connection": "Ingen internetanslutning",
        "api-call-error-could-not-reach-server": "Kunde inte nå servern",
        "api-call-error-protocol-error": "Serverfel: { $responseCode } { $responseStatus }",
        "api-call-error-api-returned-error": "Oväntat serverfel",
        "api-call-error-response-not-json": "Oväntat svar från servern",
        "api-call-error-retry-button": "Försök igen",


        // --- Receipts ---

        // Page
        "receipt-title": "Kvitto",

        // Payment methods
        "receipt-payment-method-free": "Gratis",
        "receipt-payment-method-credit-card": "Kreditkort",
        "receipt-payment-method-one-click-payment": "Kreditkort",
        "receipt-payment-method-mobile-pay": "MobilePay",
        "receipt-payment-method-payroll-deduction": "Löneavdrag",
        "receipt-payment-method-lunch-registration": "Lunchordning",
        "receipt-payment-method-gopay-account": "GoPay Wallet",
        "receipt-payment-method-gopay-wallet": "GoPay Wallet",
        "receipt-payment-method-invoice": "Faktura",
        "receipt-payment-method-cash": "Kontant",
        "receipt-payment-method-id-card": "ID-kort",

        // Purchase section
        "receipt-purchase-details-section": "\n .heading = Köpinformation",
        "receipt-purchase-payment-status-paid": "BETALD",
        "receipt-purchase-payment-status-unpaid": "EJ BETALD",
        "receipt-purchase-payment-status-invoiced": "FAKTURERAD",
        "receipt-purchase-payment-status-refunded": "ÅTERBETALD",
        "receipt-purchase-payment-status-cancelled": "ÅTERBETALD",
        "receipt-purchase-payment-status-failed": "MISSLYCKADES",
        "receipt-purchase-address-item": "\n .label = Köpställe:",
        "receipt-purchase-seller-vat-number": "Org.nr:\u00A0{ $vatNumber }",
        "receipt-purchase-customer-item": "\n .label = Kund:",
        "receipt-purchase-employee-id-item": "\n .label = Anställnings-ID:",
        "receipt-purchase-company-item": "\n .label = Företag:",
        "receipt-purchase-time-item": "\n .label = Köptidpunkt:",
        "receipt-purchase-payment-method-item": "\n .label = Betalningsmetod:",
        "receipt-purchase-order-id-item": "\n .label = Order-ID:",
        "receipt-purchase-shop-channel-item": "\n .label = Via:",
        "receipt-purchase-receipt-error": "Kunde inte läsa in beställningen med ID #{ $orderId }",
        "receipt-purchase-receipt-error-description": "Den här beställningen kunde inte behandlas på grund av saknade eller ogiltiga data.",

        // Delivery section
        "receipt-delivery-details-section": "\n .heading = Leverans",
        "receipt-delivery-order-type-item": "\n .label = Ordertyp:",
        "receipt-order-type-catering": "Mötesförtäring",
        "receipt-order-type-lunch": "Lunch",
        "receipt-order-type-takeaway": "Takeaway",
        "receipt-order-type-take-away": "Takeaway",
        "receipt-order-type-refill-account": "Wallet-påfyllning",
        "receipt-order-type-auto-refill-account": "Automatisk påfyllningsprenumeration",
        "receipt-order-type-lunch-subscription": "Prenumeration",
        "receipt-order-type-subscribe-payment-card": "Registrering av betalkort",
        "receipt-order-type-meeting": "Möte",
        "receipt-order-type-refund": "Återbetalning",
        "receipt-delivery-type-item": "\n .label = Leveranstyp:",
        "receipt-delivery-type-pick-up": "Avhämtning",
        "receipt-delivery-type-take-away": "Takeaway",
        "receipt-delivery-location-item": "\n .label = Leveransplats:",
        "receipt-delivery-pickup-location-item": "\n .label = Avhämtningsplats:",
        "receipt-delivery-time-item": "\n .label = Leveranstid:",
        "receipt-delivery-pickup-time-item": "\n .label = Avhämtningstid:",
        "receipt-delivery-comment-item": "\n .label = Kommentar:",

        // Order details section
        "receipt-order-details-buyerparty-private": "Privatköp",
        "receipt-order-details-buyerparty-company": "Företagsköp",
        "receipt-order-details-payment-method-item": "\n .label = Betalningsmetod:",
        "receipt-order-details-total": "\n .label = Totalt:",
        "receipt-order-details-vat-total": "\n .label = Moms utgör (25%):",

        // Subscription details section
        "receipt-subscription-details-section": "\n .heading = Prenumeration",
        "receipt-subscription-details-subscription-id": "\n .label = Prenumerations-ID:",
        "receipt-subscription-details-subscription-name": "\n .label = Prenumerationsnamn:",
        "receipt-subscription-details-subscription-valid-from": "\n .label = Giltig från:",
        "receipt-subscription-details-subscription-valid-to": "\n .label = Giltig till:",
        "receipt-subscription-details-subscription-price": "\n .label = Prenumerationspris:",

        // Actions section
        "receipt-actions-forward-receipt-button": "Skicka kvitto",
        "receipt-actions-cancel-order-button": "Återbetala beställning",
        "receipt-actions-confirm-cancel-dialog": "\n .description = Du är på väg att återbetala den här beställningen. Är du säker?\n .confirmLabel = Ja\n .cancelLabel = Nej\n .loadingDescription = Återbetalar beställning...",
        "receipt-actions-cancel-disabled-dialog": "\n .title = Återbetalning är inte tillgänglig\n .message = Den här funktionen är inte klar än. Den kommer senare.\n .buttonLabel = Uppfattat",
        "receipt-actions-cancel-unavailable-dialog": "\n .buttonLabel = Uppfattat",

        "receipt-order-label": "Kvitto #{ $orderId }, { $orderDate }",

        // Forward receipt
        "receipt-forward-receipt-dialog": "\n .title = { $receipts -> \n *[one] Skicka kvitto \n [other] Skicka kvitton \n } \n .cancelButtonLabel = Avbryt\n .submitButtonLabel = Skicka\n .submitButtonLoadingLabel = Skickar...",
        "receipt-forward-receipt-email-field": "\n .label = E-postadress",
        "receipt-forward-receipt-email-field-is-required": "E-postadress måste fyllas i",
        "receipt-forward-receipt-email-field-must-be-valid": "Ogiltig e-postadress",


        // --- Login domain ---

        // login auth flow hook
        "auth-flow-authentication-result-server-error": "Klienten förväntade sig att autentiseringen var klar, men servern svarade: { $action }.",
        "auth-flow-authentication-unexpected-server-error":  "Oväntad autentiseringsåtgärd { $action } i API-svaret",

        // Create password page
        "create-password-required": "Fältet är obligatoriskt",
        "create-password-password-invalid-for-policy": "Lösenordet följer inte lösenordspolicyn",
        "create-password-new-required": "Fältet är obligatoriskt",
        "create-password-matching": "Lösenorden matchar inte",
        "create-password-title": "Nytt lösenord",
        "create-password-new-password-field": "\n .label = Nytt lösenord",
        "create-password-submit-button": "Återställ lösenord",
        "create-password-confirm-password-field": "\n .label = Bekräfta lösenord",
        "create-password-missing-token-title": "Fel",
        "create-password-missing-token-description": "Den nödvändiga token för att skapa lösenord har inte angetts.",


        // Forgot password page
        "forgot-password-username-required": "Användarnamn krävs",
        "forgot-password-username-title": "Glömt lösenord",
        "forgot-password-username-invalid": "Användarnamnet är inte giltigt",
        "forgot-password-button-label": "Nästa",
        "forgot-password-enter-username-field": "\n .label = Ange din e-postadress eller ditt användarnamn:",

        // SignInWithActivationCode page
        "sign-in-with-activation-code-min-length": "Aktiveringskoden måste vara minst 6 tecken lång",
        "sign-in-with-activation-code-required": "Aktiveringskod krävs",
        "sign-in-with-activation-code-title": "Ange din aktiveringskod",
        "sign-in-with-activation-code-field-label": "\n .label = Aktiveringskod",
        "sign-in-with-activation-code-submit-button": "Nästa",

        // SignInWithPassword page
        "sign-in-with-password-required": "Lösenord krävs",
        "sign-in-with-password-title": "Ange ditt lösenord",
        "sign-in-with-password-field-label": "\n .label = Lösenord",
        "sign-in-with-password-submit-button": "Logga in",
        "sign-in-with-password-reset-password-link": "Glömt lösenord",

        // SignInWithUsername page
        "sign-in-with-username-min-length": "Användarnamnet måste vara minst 3 tecken",
        "sign-in-with-username-required": "Användarnamn krävs",
        "sign-in-with-username-title": "Logga in",
        "sign-in-with-username-subtitle": " Välkommen till Facilitynet",
        "sign-in-with-username-field-label": "\n .label = Användarnamn\n .placeholder = Ange ditt användarnamn",
        "sign-in-with-username-remember-me": "Kom ihåg mig",
        "sign-in-with-username-submit-button": "Nästa",
        "sign-in-with-username-reset-password-link": "Glömt lösenord?",

        // StartPageLayout
        "start-page-layout-title": "Din portal för mötesplanering och kantintjänster",
        "start-page-layout-sub-title-1": "Ta emot betalningar med POS och mobiltelefon",
        "start-page-layout-sub-title-2": "Få insikt i försäljningssiffror med Facilitynet Manager",
        "start-page-layout-sub-title-3": "Bättre kommunikation mellan kök och kunder",
        "start-page-layout-login-button-label": "Logga in",

        // Login Layout
        "login-layout-card-title": "Facilitynet Manager",
        "login-layout-card-subtitle": "Kantinadministration på ett enkelt sätt",
        "auto-login-title":"Loggar in dig...",
        "auto-login-description":"Vänta medan vi automatiskt loggar in dig.",
        "auto-login-error-title":" otp-token hittades inte",
        "auto-login-error-description":"  Du har fått en ogiltig länk. Kontakta support.",

        // Invitation
        "invitation-title": "Skapa dina lösenord till Facilitynet",
        "invitation-username-rules": "Användarnamnet måste vara minst 3 tecken långt.",
        "invitation-password-rules": "Lösenordet måste vara minst 8 tecken långt och innehålla en liten bokstav, en stor bokstav och en siffra.",
        "invitation-usertype-support": "{ -user-type-support }",
        "invitation-usertype-supplier": "{ -user-type-supplier }",
        "invitation-usertype-merchant": "{ -user-type-merchant }",
        "invitation-usertype-company": "{ -user-type-company }",
        "invitation-usertype-office-manager": "{ -user-type-office-manager }",
        "invitation-usertype-unknown": "Okänd användartyp",
        "invitation-field-username": "\n .label = Användarnamn",
        "invitation-field-password": "\n .label = Lösenord",
        "invitation-field-repeat-password": "\n .label = Upprepa lösenord",
        "invitation-submit-button": "Aktivera konto\n .loadingLabel = Aktiverar...",
        "invitation-field-username-required": "Användarnamn måste fyllas i",
        "invitation-field-username-min-chars": "Användarnamnet måste vara minst { $minChars } tecken",
        "invitation-field-password-required": "Lösenord måste fyllas i",
        "invitation-field-password-invalid-for-policy": "Lösenordet följer inte lösenordspolicyn",
        "invitation-field-password-min-chars": "Lösenordet måste vara minst { $minChars } tecken",
        "invitation-field-password-contain-lowercase": "Lösenordet måste innehålla en liten bokstav",
        "invitation-field-password-contain-uppercase": "Lösenordet måste innehålla en stor bokstav",
        "invitation-field-password-contain-number": "Lösenordet måste innehålla en siffra",
        "invitation-field-repeatPassword-required": "Fältet måste fyllas i",
        "invitation-field-repeatPassword-match-password": "Lösenorden matchar inte",

        // Confirm account change
        "confirm-account-change-confirming-email-message": "Bekräftar e-postadress...",
        "confirm-account-change-login-button": "Logga in",
        "confirm-account-change-failure-message": "E-postadressen kunde inte bekräftas",

        // Id Card Signup
        "id-card-signup-title": "Slutför registreringen",
        "id-card-signup-description": "Slutför registreringsprocessen. När du har registrerat ditt ID-kort kan du använda det för att köpa mat i kantinen genom att skanna det på POS-skärmen.",
        "id-card-signup-subscription": "Välj prenumeration",
        "id-card-signup-next-button": "Nästa",
        "id-card-signup-back-button": "Tillbaka",
        "id-card-signup-field-company": "\n .label = Ditt företag:\n .placeholder = Välj det företag du arbetar för",
        "id-card-signup-field-user-group": "\n .label = Din användargrupp:\n .placeholder = Välj användargrupp",
        "id-card-signup-field-name": "\n .label = Ditt namn:\n .placeholder = Ange ditt fullständiga namn",
        "id-card-signup-field-mobile-number": "\n .label = Din telefon:\n .placeholder = Ange ditt mobilnummer (valfritt)",
        "id-card-signup-field-mobile-number-invalid": "Ogiltigt mobilnummer",
        "id-card-signup-field-name-max-length": "Namnet får inte överstiga 50 tecken",
        "id-card-signup-companies-error": "Kunde inte läsa in företag. Försök igen.",
        "id-card-activation-generic-error": "Kunde inte läsa in företag. Försök igen.",
        "id-card-signup-no-subscriptions": "Ett fel uppstod när kortet aktiverades. Försök igen.",
        "id-card-signup-using-company": "Ditt företag: ",
        "id-card-signup-using-user-group": "Din användargrupp: ",
        "id-card-signup-using-user-name": "Användarnamn: ",
        "id-card-signup-complete": "Grattis",
        "id-card-signup-complete-description": "Ditt kort är nu kopplat till prenumerationen och du kan börja använda det.",
        "id-card-signup-complete-learn-more": "Läs mer:",
        "id-card-signup-complete-learn-more-link": "Hur använder jag Facilitynets betalningslösning?",

        // Activate account
        "activation-account-username-title": "Aktivera konto",
        "activation-account-username-subtitle": "För att använda Facilitynet behöver du aktivera ditt konto nedan",
        "activation-account-username-button": "Aktivera",
        "activation-account-username-field": "\n .label = Ange din e-postadress:",
        "activation-account-username-email-required": "E-postadress krävs",
        "activation-account-username-email-invalid": "Ange en giltig e-postadress",
        "activation-account-password-title": "Skapa lösenord",
        "activation-account-password-new-password-field": "\n .label = Ange lösenord",
        "activation-account-password-button": "Skapa lösenord",

        // select company
        "authenticate-select-company-header-reason-multiple-companies-for-domain": "Välj företag",
        "authenticate-select-company-header-reason-multiple-accounts-for-username": "Välj användarkonto",
        "authenticate-select-company-reason-message-multiple-companies-for-domain": "Vi kunde inte fastställa ditt företag automatiskt eftersom din e-postdomän <duplicateValue>{ $duplicateValue }</duplicateValue> förekommer flera gånger i vårt system.",
        "authenticate-select-company-reason-message-multiple-accounts-for-username": "Vi hittade flera konton i vårt system med e-postadressen <duplicateValue>{ $duplicateValue }</duplicateValue>.",
        "authenticate-select-company-action-message-multiple-companies-for-domain": "Välj den plats (det företag) som du vill skapa ditt konto under:",
        "authenticate-select-company-action-message-multiple-accounts-for-username": "Välj det användarkonto du vill logga in med.",
        "authenticate-select-company-show-list-button": "Visa alternativ",
        "authenticate-select-company-submit-button": "{ -authenticate-submit-button }\n .loadingLabel = Sparar...",
        "authenticate-select-company-form-error-message": "Välj ett företag",
        "authenticate-select-company-company-group-unknown-uid": "Okänt företags-UID",
        "authenticate-select-company-company-group-unknown-name": "Okänt namn",
        "authenticate-select-company-company-group-unknown-address": "Okänd adress",
        "authenticate-select-company-no-companies-available": "Inga företag tillgängliga",
        "authenticate-select-company-account-role-support": "{ -user-type-support }",
        "authenticate-select-company-account-role-supplier": "{ -user-type-supplier }",
        "authenticate-select-company-account-role-merchant": "{ -user-type-merchant }",
        "authenticate-select-company-account-role-company": "{ -user-type-company }",
        "authenticate-select-company-account-role-office-manager": "{ -user-type-office-manager }",
        "authenticate-select-company-account-role-user": "{ -user-type-user }",
        "authenticate-select-company-account-role-service-center": "{ -user-type-service-center }",

        // Public > Self Sign Up
        "self-sign-up-title": "Registrera dig",
        "self-sign-up-description": "Slutför registreringsprocessen. När du har registrerat dig kan du använda kontot",
        "self-sign-up-field-company": "\n .label = Ditt företag:\n .placeholder = Välj det företag du arbetar för",
        "self-sign-up-field-user-group": "\n .label = Din användargrupp:\n .placeholder = Välj användargrupp",
        "self-sign-up-field-department": "\n .label = Avdelning:\n .placeholder = Välj din avdelning",
        "self-sign-up-department-missing-notice": "Kontakta din företagsadministratör om din avdelning saknas i listan.",
        "self-sign-up-field-name": "\n .label = Namn:\n .placeholder = Ange ditt fullständiga namn",
        "self-sign-up-field-email": "\n .label = E-post:\n .placeholder = Ange din e-postadress",
        "self-sign-up-field-mobile-number": "\n .label = Telefon:\n .placeholder = Ange ditt mobilnummer (valfritt)",
        "self-sign-up-complete-button": "Registrera dig",
        "self-sign-up-field-email-invalid": "Ogiltig e-postadress",
        "self-sign-up-email-domain-hint": "Använd en e-postadress från en godkänd domän: { $domains }",
        "self-sign-up-field-email-domain-not-allowed": "E-postadressen måste använda en godkänd domän: { $domains }",
        "self-sign-up-congratulation-title": "Grattis",
        "self-sign-up-congratulation-message": "Vi har skickat en aktiveringslänk till din e-postadress.",
        "self-sign-up-error-message": "Något gick fel. Försök igen.",
        "self-sign-up-confirm-dialog": "\n .title = Bekräfta uppgifter\n .message = Är du säker på att du vill skapa ditt konto med den angivna informationen?\n .buttonLabelSubmit = Bekräfta\n .buttonLabelCancel = Avbryt",
        "self-sign-up-confirm-company": "\n .label = Företag:",
        "self-sign-up-confirm-user-group": "\n .label = Användargrupp:",
        "self-sign-up-confirm-department": "\n .label = Avdelning:",
        "self-sign-up-confirm-name": "\n .label = Namn:",
        "self-sign-up-confirm-email": "\n .label = E-post:",
        "self-sign-up-confirm-mobile-number": "\n .label = Telefon:",

        // Booking > Confirm Booking
        'confirm-booking-complete': "Grattis",
        'confirm-booking-failed': "Misslyckades",
        'confirm-booking-loading': "Läser in...",

        // ExportButton
        "export-button-export-text": "\n .title = Exportera\n .aria-label = Exportera",
        "export-button-export-all": "Exportera alla",
        "export-button-export-all-with-filter": "Exportera alla med filter",
        "export-button-export-selected": "Exportera valda",
        "export-button-export-selected-rows": "Exportera valda rader",
        "export-button-export-as-csv-title": "\n .title = Ladda ner som CSV-fil",
        "export-button-export-as-pdf-title": "\n .title = Ladda ner som PDF-fil",
        "export-button-print": "Skriv ut",
        "export-button-remove-print-title": "\n .title = Ta bort från utskriftskön",

        // Export
        "export-period": "Period",

        // print
        "print-queued": "Din begäran står i kö",


        // --- ContextDisplay ---
        "context-display-org-unit-supplier": "\n .label = Kantinoperatör:",
        "context-display-org-unit-merchant": "\n .label = Försäljningsställe:",
        "context-display-org-unit-tenant": "\n .label = Hyresgäst:",
        "context-display-org-unit-company": "\n .label = Företag:",
        "context-display-org-unit-user": "\n .label = Användare:",
        "context-display-org-unit-service-center": "\n .label = Servicecenter:",


        // --- Environment dropdown ---
        "env-dropdown-menu-header": "Byt miljö till:",
        "env-dropdown-title-admin-support":"Administration",
        "env-dropdown-title-reports-support":"Dashboard",
        "env-dropdown-title-admin-supplier":"Administration",
        "env-dropdown-title-reports-supplier":"Dashboard",
        "env-dropdown-title-admin-merchant":"Administration",
        "env-dropdown-title-reports-merchant":"Produktion",
        "env-dropdown-title-accounting-merchant":"Redovisning",
        "env-dropdown-title-admin-company":"Administration",
        "env-dropdown-title-reports-company":"Dashboard",
        "env-dropdown-title-admin-office-manager":"Administration",
        "env-dropdown-title-reports-office-manager":"Dashboard",
        "env-dropdown-title-reports-service-center":"Dashboard",
        "env-dropdown-title-admin-service-center":"Administration",
        "env-dropdown-subtitle-admin-support":"Hantera entiteter och användare.",
        "env-dropdown-subtitle-reports-support":"Visa systemrapporter.",
        "env-dropdown-subtitle-admin-supplier":"Hantera försäljningsställen och globala inställningar.",
        "env-dropdown-subtitle-reports-supplier":"Visa övergripande rapporter över redovisningssiffror.",
        "env-dropdown-subtitle-admin-merchant":"Hantera produkter, butiker och kundkommunikation.",
        "env-dropdown-subtitle-reports-merchant":"Visa driftöversikt och produktionssiffror.",
        "env-dropdown-subtitle-admin-company":"Hantera organisationsdata, användare och administratörer.",
        "env-dropdown-subtitle-reports-company":"Visa redovisningssiffror.",
        "env-dropdown-subtitle-admin-office-manager":"Hantera användare och administratörer.",
        "env-dropdown-subtitle-reports-office-manager":"Visa redovisningssiffror.",
        "env-dropdown-subtitle-reports-service-center":"Servicecenter-rapporter",
        "env-dropdown-subtitle-admin-service-center":"Servicecenter-administration",
        "env-dropdown-subtitle-accounting-merchant":"Visa redovisningsrapporter.",


        // --- API components ---
        "api-query-table-fetch-error-message": "Fel vid inläsning av data",
        "api-query-autocomplete": "\n .loadingText = Läser in data...",
        "api-query-autocomplete-fetch-error-message": "Fel vid inläsning av data. <retryLink>Försök igen</retryLink>",

        // Top Bar
        "help-tooltip-text": "\n .title = Visa hjälp",
        "notifications-tooltip-text": "\n .title = Visa meddelanden",
        "new-order-tooltip-text": "\n .title = Skapa ny beställning",
        "qa-env-warning-part-one": "Du är i QA-miljön. Den är inte avsedd för kunder. Använd",
        "qa-env-warning-part-two": "istället.",

        // Top Bar > Help
        "help-dialog-search-title": "Hej, hur kan vi hjälpa dig?",
        "help-dialog-search":"\n .placeholder = Sök efter artiklar...",
        "help-dialog-support": "\n .title = Support",
        "help-dialog-email-support": "\n .title = E-postsupport \n .description = Om du fortfarande behöver hjälp kan du skicka ett e-postmeddelande till oss här.",
        "help-dialog-chat-support": "\n .title = Chattsupport \n .description = Har du snabba frågor kan du chatta med vårt kundtjänstteam.",
        "help-dialog-troubleshooting": "\n .title = Felsökning",
        "help-dialog-troubleshooting-pos-screen": "\n .title = POS-skärm \n .description = Få hjälp med din POS-skärm, kvittoskrivare och betalningsterminal.",
        "help-dialog-troubleshooting-check-in-screen": "\n .title = Incheckningsskärm \n .description = Få hjälp med din incheckningsskärm och kvittoskrivare.",
        "help-breadcrumb": "Hjälp",
        "help-dialog-troubleshooting-breadcrumb": "Felsökning",
        "help-dialog-troubleshooting-printer-not-working": "\n .title = Skrivaren fungerar inte",
        "help-dialog-troubleshooting-credit-card-terminal-not-working": "\n .title = Betalningsterminalen fungerar inte",
        "help-dialog-troubleshooting-pos-screen-not-working": "\n .title = POS-skärmen fungerar inte",
        "help-dialog-troubleshooting-check-in-screen-not-working": "\n .title = Incheckningsskärmen fungerar inte",
        "help-dialog-troubleshooting-start-up-backup-terminal": "\n .title = Starta backup-terminalen",
        "help-dialog-training": "\n .title = Utbildning",
        "help-dialog-training-education-center": "\n .title = Utbildningscenter \n .description = I utbildningscentret kan du se kom igång-guider och annat utbildningsmaterial.",
        "help-dialog-training-guide-button": "Visa guide",
        "consent-dialog": "\n .title = Tillåt chatt \n .message = Vi använder Intercom för vår chattsupport. Om du samtycker delar vi uppgifterna nedan med Intercom. \n .skipLabel = Inte nu \n .consentLabel = Tillåt",
        "consent-dialog-personal-information": "Personuppgifter",
        "consent-dialog-pii-category-contact-info": "Kontaktinformation",
        "consent-dialog-pii-category-identifiers": "Identifierare",
        "consent-dialog-pii-category-purchases": "Köp",
        "consent-dialog-pii-category-user-content": "Användarinnehåll",
        "consent-dialog-privacy-policy": "Integritet",
        "consent-dialog-view-company-privacy-policy": "Visa företagets integritetspolicy",
        "consent-dialog-pii-item-name": "Namn",
        "consent-dialog-pii-item-email-address": "E-post",
        "consent-dialog-pii-item-phone-number": "Telefonnummer",
        "consent-dialog-pii-item-user-id": "Användar-ID",
        "consent-dialog-pii-item-device-id": "Enhets-ID",
        "consent-dialog-pii-item-customer-support": "Kundtjänst",
        "consent-dialog-pii-item-purchase-history": "Köphistorik",
        "intercom-error-dialog": "\n .title = Chatten misslyckades\n .message = Något gick fel när chatten lästes in. Du kan skicka ett e-postmeddelande till support istället.\n .buttonLabel = Uppfattat",
        "intercom-loading-dialog": "\n .description = Chatten läses in...",
        "intercom-unavailable-snackbar": "Chattsupporten är för tillfället inte tillgänglig. Skicka istället ett e-postmeddelande till support@facilitynet.dk.",

        //ControlKitchen page
        "control-kitchen-checked-in-yes-chip": "Ja",
        "control-kitchen-checked-in-no-chip": "Nej",
        "control-kitchen-column-check-in-time": "Incheckningstid",
        "control-kitchen-column-id": "Anställnings-ID",
        "control-kitchen-column-name": "Namn",
        "control-kitchen-column-items": "Antal",
        "control-kitchen-column-order-details": "Order",
        "control-kitchen-checked-in": "Incheckad",
        "control-kitchen-checked-in-sub-title": "Dagens kontrollkod:",
        "control-kitchen-last-updated": "Senast uppdaterad: {$lastUpdated}",
        "control-kitchen-refresh": "Uppdatera sidan",
        "control-kitchen-receipt": "Kvitto",
        "control-kitchen-date-label": "Köpdatum",
        "control-kitchen-date-delivery-label": "Leveransdatum",
        "control-kitchen-datetime-from-label": "Från",
        "control-kitchen-datetime-to-label": "Till",
        "control-kitchen-period-label": "Period",
        "control-kitchen-check-in-type": "Typ",
        "control-kitchen-checked-in-filter-all": "Alla",
        "control-kitchen-checked-in-filter-checked-in": "Incheckad",
        "control-kitchen-checked-in-filter-not-checked-in": "Inte incheckad",
        "control-kitchen-control-code-not-ready": "Inte klar",

        // News folder
        "news-published": "Publiceras: {$date}",
        "news-implemented": "Implementerad: {$date}",
        "news-created": "Skapad: {$date}",
        "news-updated": "Uppdaterad: {$date}",
        "news-gopay": "Nyheter från Facilitynet ",
        "news-roadmap": "Färdplan",
        "news-new-features": "Nya funktioner",
        "news-new-load-error": "Fel vid inläsning av färdplansfunktioner",
        "news-start-date": "Startdatum",
        "news-end-date": "Slutdatum",
        "news-type": "Typ",
        "news-bug-fix": "Felrättning",
        "news-new-feature": "Ny funktion",
        "news-upcoming": "Kommande",
        "news-all": "Alla",
        "news-roadmap-type-filter-bugfix": "Felrättning",
        "news-roadmap-type-filter-feature": "Ny funktion",
        "news-roadmap-type-filter-upcoming": "Kommande",
        "news-implemented-feature": "Implementerad funktion",
        "news-upcoming-feature": "Kommande funktion",
        "news-current-news": "Aktuella nyheter",
        "news-archive-news": "Arkiv",
        "news-create-new-button": "Skapa ny",
        "news-draft-type": "Utkast",
        "news-published-type": "Publicerad",
        "news-schedule-type": "Schemalagd",
        "news-expired-type": "Utgången",
        "news-edit": "Redigera",
        "news-delete": "Ta bort",
        "news-default-error-message": "Något gick fel",
        "news-archive-title": "Titel",
        "news-archive-expiration-date": "Utgångsdatum",
        "news-archive-active-status": "Status",
        "merchant-news-header": "\n .title = Kundnyheter",
        "news-no-news-title": "Inga nyheter",
        "news-no-roadmap-title": "Inga färdplaner",
        "news-no-news-body": "Skapa din första nyhet ",
        "news-no-news-here-link": "här",
        "news-gopay-read-more": "Läs mer",
        "news-table-delete-success-message": "Artikeln har tagits bort",
        "create-news-header": "\n .title = Skapa nyhet",
        "edit-news-header": "\n .title = Redigera nyhet",
        "nav-item-create-news-header": "Skapa nyhet",
        "nav-item-edit-news-header": "Redigera nyhet",
        "create-news-save-button": "Skapa",
        "edit-news-save-button": "Spara",


        // Office folder
        "office-period-total": "Totalt för perioden: {$periodTotal}",
        "office-transation-period-total": "Totalt antal transaktioner för perioden: {$transactionPeriodTotal}",
        "office-purchase-time": "Tid",
        "office-purchase-name": "Namn",
        "office-purchase-payment-details": "Betalningsmetod",
        "office-purchase-payment-channel": "Kanal",
        "office-purchase-amount": "Belopp",
        "office-purchase-receipt": "Kvitto",
        "upcoming-orders-purchases-table-order-type": "Ordertyp",
        "upcoming-orders-purchases-table-delivery-status": "Leveransstatus",
        "upcoming-orders-purchases-table-order-type-pos": "POS",
        "upcoming-orders-purchases-table-order-type-takeaway": "Takeaway",
        "order-action-menu-refund": "Återbetala",
        "order-action-menu-print-label": "Skriv ut etikett",
        "standard-refresh-button-last-updated-label": "Uppdaterad { $relativeTime }",
        "standard-refresh-button-last-updated-just-now-label": "Uppdaterad just nu",
        "standard-refresh-button-tooltip-hint": "Klicka för att uppdatera",
        "standard-refresh-button-error-tooltip": "Uppdateringen misslyckades · klicka för att försöka igen",
        "standard-refresh-button-aria-label": "Uppdatera",
        "standard-new-items-pill-label": "{ $count ->\n [one] { $count } ny order\n *[other] { $count } nya ordrar\n}",
        "standard-new-items-pill-show-button": "Visa",

        "office-meeting-service-title": "Mötesförtäring",
        "office-meeting-service-header": "\n .title = Mötesförtäring",
        "office-meeting-service-table-booked-start-date": "Bokat startdatum",
        "office-meeting-service-table-booked-end-date": "Bokat slutdatum",
        "office-meeting-service-table-merchant": "Försäljningsställe",
        "office-meeting-service-table-order-id-column": "Order-ID",
        "office-meeting-service-table-booked-date-column": "Bokföringsdatum",
        "office-meeting-service-table-delivery-time-column": "Leveranstid",
        "office-meeting-service-table-creator-column": "Beställare",
        "office-meeting-service-table-amount-column": "Belopp (DKK)",
        "office-meeting-service-table-show-receipt": "Visa kvitto",
        "office-meeting-service-table-floating-action-bar-receipts": "\n .title = Kvitton",
        "office-meeting-service-table-floating-action-bar-export": "\n .title = Exportera",


        // --- Profile page ---
        "profile-user-account-id": "ID:",
        "profile-administrator-for": "Administratör för",
        "profile-hosted-by": "Uthyrd av",
        "profile-hosted-by-office-hotel": "Kontorshotell",
        "profile-actions": "Genvägar",
        "profile-settings-card": "Inställningar",
        "profile-password-card": "Lösenord",
        "profile-actions-change-password": "Ändra lösenord",
        "profile-actions-edit-profile": "Redigera profil",
        "profile-actions-delete-account": "Ta bort användarkonto",
        "profile-security": "Säkerhet",
        "profile-security-manage-admins": "Kan hantera andra administratörer:",
        "profile-security-manage-admins-yes": "Ja",
        "profile-security-manage-admins-no": "Nej",
        "profile-security-ip-address-allowlist": "Tillåtna IP-adresser:",
        "profile-roles": "Dina roller",
        "profile-user-info": "Användarkonto",
        "profile-user-type": "Användartyp",
        "profile-username": "Användarnamn:",
        "profile-email": "E-post:",
        "profile-phone-number": "Telefonnummer:",
        "profile-mobil-number": "Mobilnummer:",
        "profile-name": "Namn:",
        "profile-page-header": "\n .title = Användarkonto",
        "profile-nav-item-home": "Hem",
        "profile-user-type-info-mode-supplier": "Som administratör för kantinoperatör kan du få åtkomst till och hantera försäljningsställen och administratörer för ditt företags räkning. För varje försäljningsställe kan du göra allt som en administratör för ett försäljningsställe kan göra. Dessutom kan du hantera delade inställningar och se rapporter över flera försäljningsställen.",
        "profile-user-type-info-mode-merchant": "Som administratör för ett försäljningsställe kan du hantera butiker och produkter under ditt försäljningsställe. Du har även åtkomst till detaljerade redovisningsrapporter och produktionsvyer där du kan hantera och leverera kundbeställningar.",
        "profile-user-type-info-mode-company": "Som företagsadministratör kan du hantera användare och integrationer för ditt företag. Du kan även se redovisningsrapporter för beställningar som gjorts av företagets anställda.",
        "profile-user-type-info-mode-office-manager": "Som kontorschef kan du hantera användare och integrationer för din organisation. Du kan även se redovisningsrapporter för beställningar som gjorts av företagets anställda.",
        "profile-user-type-info-mode-support": "Som supportmedarbetare kan du hantera användare, enheter och entiteter för hela systemet. Du kan även slå upp nödvändig information om beställningar, användare och entiteter för att hantera supportärenden.",
        "profile-user-type-info-mode-user": "Som användare kan du lägga beställningar i systemet och se dina tidigare beställningar.",
        "profile-roles-mode-agreement-owner": "Avtalsägare",
        "profile-roles-mode-bookkeeper": "Bokförare",
        "profile-roles-mode-dpo": "DPO",
        "profile-roles-mode-it-administrator": "IT-administratör",
        "profile-roles-mode-news-subscriber": "Nyhetsprenumerant",
        "profile-roles-mode-system-operation-subscriber": "Prenumerant på systemdrift",
        "profile-roles-read-more": "Läs om administratörsroller",
        "profile-roles-no-roles": "Du har inga roller",
        "profile-tab-profile": "Allmänt",
        "profile-tab-gdpr": "GDPR",
        "profile-gdpr-info-box": "\n .description = Här kan du ladda ner en kopia av dina egna personuppgifter som vi har registrerat i Facilitynet.",
        "profile-gdpr-export-button": "Exportera mina uppgifter",
        "profile-gdpr-correction-info-box": "\n .description = Här kan du begära rättelse av dina personuppgifter.",
        "profile-gdpr-correction-button": "Begär rättelse av mina uppgifter",

        // --- Profile page > Change password ---
        "profile-change-password-page-header": "\n .title = Byt lösenord",
        "profile-change-password": "Byt lösenord",
        "profile-change-password-profile": "Profil",
        "profile-change-password-profile-currentPassword": "\n .label = Nuvarande lösenord",
        "profile-change-password-profile-newPassword": "\n .label = Nytt lösenord",
        "profile-change-password-profile-confirmPassword": "\n .label = Bekräfta lösenord",
        "profile-change-password-profile-match-password": "Lösenorden matchar inte",
        "profile-change-password-password-policy": "\n .title = Lösenordspolicy",
        "profile-change-password-default-policy": "Facilitynets standardpolicy",
        "profile-change-password-info": "Kontakta supporten för att definiera eller ändra lösenordspolicyn för ditt företag.",
        "profile-change-password-submit-button": "Uppdatera lösenord",

        // --- Change User Account > Dialog ---
        "change-user-account-dialog-title": "Byt användarkonto",
        "change-user-account-dialog-pending-state-email-has-been-sent": "Ett e-postmeddelande har skickats. Kontrollera din inkorg.",
        "change-user-account-dialog-pending-state-pending-approval":
            "Väntar på godkännande...\n .loadingLabel = Väntar på godkännande...",
        "change-user-account-dialog-confirm-email-subtitle": "Innan du kan växla mellan användarkonton måste du bekräfta att du äger e-postkontot <element>{ $email }</element>.",
        "change-user-account-dialog-click-below-subtitle": "Klicka på knappen nedan för att skicka en bekräftelselänk till mig:",
        "change-user-account-dialog-send-confirmation-button": "Skicka bekräftelselänk",
        "change-user-account-dialog-empty-content-subtitle": "Inga andra konton hittades med e-postadressen <email>{ $email }</email>.",
        "change-user-account-dialog-users-list-available-accounts-subtitle": "Du har { $totalUserAccounts } andra användarkonton med e-postadressen: { $email }",
        "change-user-account-dialog-users-list-swift-to-another-account": "Växla till ett annat konto nedan:",
        "change-user-account-dialog-error-message": "Vi kunde inte läsa in dina konton. Det kan hända att kontobyte inte är tillgängligt för den här kontotypen.",

        // User Types
        "profile-usertype-support": "{ -user-type-support }",
        "profile-usertype-supplier": "{ -user-type-supplier }",
        "profile-usertype-merchant": "{ -user-type-merchant }",
        "profile-usertype-company": "{ -user-type-company }",
        "profile-usertype-office-manager": "{ -user-type-office-manager }",
        "profile-usertype-user": "{ -user-type-user }",
        "profile-usertype-service-center": "{ -user-type-service-center }",


        // --- Settings page ---
        "settings-page-header": "\n .title = Inställningar",
        "settings-title": "Inställningar",
        "settings-nav-item-home": "Hem",
        "settings-language-setting": "Språk",
        "settings-social-media-label": "Sociala medier",
        "settings-social-media-text": "Följ oss på LinkedIn",
        "settings-notifications-label": "Aviseringar",
        "settings-sms-notifications": "SMS-aviseringar",
        "settings-receipts-meeting-service": "Kvitton för mötesservice",
        "settings-receipts-canteen": "Kvitton för kantin",


        // --- Admin home card ---
        "admin-home-card-show-all-button": "Visa alla",


        // Back Button
        "back-button-label": "Tillbaka",

        //AvatarMenu
        "avatar-menu-tooltip": "Öppna inställningar",


        // ArticleSettingsPanel
        "article-settings-panel-settings-title": "\n .title = Synlighet",
        "article-settings-panel-published": "\n .label = Publicerad",
        "article-settings-panel-schedule-for": "\n .label = Publiceringsdatum",
        "article-settings-panel-expires": "\n .label = Utgångsdatum",



        // ImageUploader
        "image-uploader-button-label": "Ladda upp bild",
        "image-uploader-drag-and-drop": "Dra och släpp eller bläddra",
        "image-uploader-max-file-size-exceeded": "Filstorleken överskrider gränsen på { $maxFileSize }.",
        "image-previewer-button-label": "Ladda upp ny bild",
        "image-previewer-button-delete": "Ta bort",

        // CreateOrEditMerchantArticle
        "create-or-edit-merchant-article-mode-normal-article": "Vanlig artikel",
        "create-or-edit-merchant-article-mode-external-article": "Extern artikel",
        "create-or-edit-merchant-article-mode-product-news": "Produktnyheter",
        "create-or-edit-merchant-article-title": "\n .label = Titel",
        "create-or-edit-merchant-article-body": "\n .placeholder = Beskrivning\n .helperText = Återstående tecken: { $charsRemaining }",
        "create-or-edit-merchant-article-body-too-long": "Du har överskridit det maximala antalet tecken: { $charsLimit }",
        "create-or-edit-merchant-article-product-id": "\n .label = Produkt-ID",
        "create-or-edit-merchant-article-info-label-draft": "\n .label = Artikeln är ett utkast. Den syns inte för användarna förrän du publicerar den.",
        "create-or-edit-merchant-article-info-label-schedule": "\n .label = Artikeln är schemalagd för publicering den: ",
        "create-or-edit-merchant-article-type": "\n .label = Artikeltyp",
        "create-or-edit-merchant-article-delete": "artikel",
        "news-create-image-field-label": "\n .label = Ladda upp bild",

        // CreateAndPublishSplitButton
        "create-and-publish-split-button-create-draft": "Utkast",
        "create-and-publish-split-button-publish": "Publicera",
        "create-and-publish-split-button-save": "Spara",
        "create-and-publish-split-button-unpublish": "Avpublicera",
        "create-and-publish-split-button-cancel-publication": "Avbryt publicering",
        "create-and-publish-split-button-republish": "Publicera igen",


        "table-summary-box-total-period": "\n .title = Totalt under perioden",
        "table-summary-box-number-of-orders": "\n .title = Antal order",
        "table-summary-box-number-of-subscriptions": "\n .title = Antal prenumerationer",

        // --- Office manager ---

        // Navigation
        "tenant-nav-item-home": "Hem",

        // - reporting
        "tenant-nav-item-accounting": "\n .title = Redovisning",
        "tenant-nav-item-accounting-header": "Redovisning",
        "tenant-nav-item-pos": "POS",
        "tenant-nav-item-meeting-service": "Mötesförtäring",
        "tenant-nav-item-subscriptions": "Prenumerationer",

        // - admin
        "tenant-nav-item-users": "Användare",
        "tenant-nav-item-organization-page-header":"\n .title = Organisation",
        "tenant-nav-item-organization-header":"Organisation",
        "tenant-nav-item-administrators": "Administratörer",

        // Reports

        // Home
        "tenant-reports-home-placeholder": "\n .title = Kontorschefens instrumentpanel kommer snart\n .body = Din instrumentpanel visar en översikt över viktiga nyckeltal så att du alltid har bra koll på inköp.",

        // Purchases
        "tenant-purchases-header": "\n .title = POS",
        "tenant-subscriptions-header": "\n .title = Prenumerationer",

        // Admin

        // Home page
        "office-manager-home-user-card-group": "\n .title = Användare",
        "office-manager-home-user-admin-placeholder": "Kommer snart. Här kommer du att kunna hantera användare och administratörer i din organisation.",
        "office-manager-home-user-card": "  \n .title = Användare\n .description = Hantera användare för din organisation",
        "office-manager-home-admin-card": "  \n .title = Administratörer\n .description = Hantera administratörer",
        "office-manager-home-card-show-all": "Visa alla",
        "office-manager-users-header": "\n .title = Användare",
        "office-manager-users-tab-users": "Användare",
        "office-manager-users-tab-admins": "Administratörer",
        "office-manager-users-table-id-column": "Anställnings-ID",
        "office-manager-users-table-name-column": "Namn",
        "office-manager-users-table-email-column": "E-post",
        "office-manager-users-table-status-column": "Status",
        "office-manager-users-table-status-column-active": "Aktiv",
        "office-manager-users-table-status-column-inactive": "Inaktiv",
        "office-manager-user-show-details": "Visa detaljer",
        "office-manager-user-edit": "Redigera användare",
        "office-manager-user-delete": "Ta bort användare",
        "office-manager-user-delete-title": "användare",
        "office-manager-users-create-user-button": "Skapa ny",
        "office-manager-users-create-admin-button": "Skapa ny",
        "office-manager-user-details-dialog-title": "Användaruppgifter",
        "office-manager-settings-panel": "\n .title = Inställningar",
        "office-manager-settings-send-invitation": "Skicka e-postinbjudan",
        "office-manager-settings-disable-sync": "Inaktivera synkronisering",
        "office-manager-settings-disable-sync-text": "När detta är inaktiverat ignoreras användaren av användarsynkroniseringsjobb",

        // show user details dialog
        "user-details-user-id": "Användar-ID:",
        "user-details-employee-id": "Anställnings-ID:",
        "user-details-user-group": "Användargrupp:",
        "user-details-department": "Avdelning:",
        "user-details-workgroups-title": "Arbetsgrupper",
        "user-details-name": "Namn:",
        "user-details-role-type-news-subscriber" : "Nyhetsprenumerant",
        "user-details-role-type-system-operation-subscriber" : "Prenumerant på systemstatus",
        "user-details-email": "E-post:",
        "user-details-mobile": "Mobil:",
        "user-details-phone": "Telefon:",
        "user-details-language": "Språk:",
        "user-details-role": "Användarroller:",
        "user-details-sync-jobs": "Frånkopplade synkroniseringsjobb:",
        "user-details-sync-jobs-ignored": "JA",
        "user-details-sync-jobs-included": "NEJ",
        "user-details-security-title": "Säkerhet",
        "user-details-settings-title": "Inställningar",
        "user-details-security-settings-yes": "JA",
        "user-details-security-settings-no": "NEJ",
        "user-details-security-manage-admins": "Kan hantera andra administratörer:",
        "user-details-security-ip-address": "Tillåtna IP-adresser:",
        "user-details-history-title": "Historik",
        "user-details-history-created": "Skapad:",
        "user-details-history-edited": "Senast ändrad:",

        // Create or edit user page
        "office-manager-create-user-form": "Skapa",
        "office-manager-edit-user-form": "Spara",
        "office-manager-create-user-form-title": "\n .title = Skapa användare",
        "office-manager-edit-user-form-title": "\n .title = Redigera användare",
        "office-manager-create-user-home-breadcrumb": "Hem",
        "office-manager-create-user-users-breadcrumb": "Konto",
        "office-manager-create-user-create-breadcrumb": "Skapa användare",
        "office-manager-create-user-edit-breadcrumb": "Redigera användare",
        "office-manager-create-user-missing-context-error":
            "Det gick inte att avgöra vilket konto användaren tillhör. Ladda om sidan och försök igen.",
        "office-manager-create-admin-missing-context-error":
            "Det gick inte att avgöra vilket konto administratören tillhör. Ladda om sidan och försök igen.",
        // Create/edit administrator pages (shared across all portals)
        "administrators-create-page-title": "\n .title = Skapa administratör",
        "administrators-create-page-save-button": "Skapa",
        "administrators-create-breadcrumb": "Skapa administratör",
        "administrators-edit-page-title": "\n .title = Redigera administratör",
        "administrators-edit-page-save-button": "Spara",
        "administrators-edit-breadcrumb": "Redigera administratör",
        "office-manager-create-user-field-id": "\n .label = Anställnings-ID",
        "office-manager-create-user-field-username": "\n .label = Användarnamn",
        "office-manager-create-user-field-name": "\n .label = Namn",
        "office-manager-create-user-field-email": "\n .label = E-post",
        "office-manager-create-user-field-mobile": "\n .label = Mobil",
        "office-manager-create-user-field-phone": "\n .label = Telefonnr",
        "office-manager-create-user-field-active": "Aktiv",
        "office-manager-settings-resend-invitation": "Skicka inbjudan igen",
        "office-manager-security-panel": "\n .title = Säkerhet",
        "office-manager-security-manage-admins": "Kan hantera andra administratörer",
        "office-manager-security-pin-field": "\n .label = PIN-kod",
        "office-manager-security-pin-info": "\n .title = PIN-koden används av personal för att logga in på POS-skärmen.",
        "office-manager-security-pin-invalid": "PIN-koden måste vara 4 siffror",
        "office-manager-create-user-required-field-empty": "Det här fältet är obligatoriskt",
        "office-manager-create-user-invalid-email-address": "Ogiltig e-postadress",
        "office-manager-create-user-invalid-phone-number": "Ogiltigt telefonnummer",

        // Create or edit room
        "resource-room-create-form-title": "\n .title = Skapa rum",
        "resource-room-edit-form-title": "\n .title = Redigera rum",
        "resource-room-create-required-field-empty": "Det här fältet är obligatoriskt",
        "resource-room-create-user-home-breadcrumb": "Hem",
        "resource-room-create-user-users-breadcrumb": "Användare",
        "resource-room-create-room-breadcrumb":"Skapa rum",
        "resource-room-edit-room-breadcrumb":"Redigera rum",

        // Purchases page
        "tenant-pos-title": "POS",
        "tenant-purchases-tab-orders":"\n .title = Order",
        "tenant-purchases-tab-subscriptions-details":"Detaljer",
        "tenant-purchases-tab-subscriptions-cancel": "Säg upp",

        //Admin roles field
        "tenant-admin-roles-field-label": "Tilldela roller",
        "tenant-admin-role-agreement-owner": "Systemägare",
        "tenant-admin-role-dpo": "GDPR-ansvarig",
        "tenant-admin-role-it-administrator": "IT-administratör",
        "tenant-admin-role-bookkeeper": "Bokförare",
        "tenant-admin-role-news-subscriber": "Nyhetsprenumerant",
        "tenant-admin-role-system-operation-subscriber": "Prenumerant på systemdrift",


        // Survey Page
        "survey-header": "\n .title = Användarnöjdhet",
        "survey-tab-overview": "Översikt",
        "survey-tab-ratings": "Alla betyg",
        "survey-tab-ratings-no-survey-data": "Inga data tillgängliga.",
        "survey-tab-overview-no-surveys": "Inga undersökningar har definierats ännu.",
        "survey-tab-overview-no-questions": "Inga frågor har definierats för den här undersökningen.",
        "survey-tab-ratings-good-topics-card": "\n .title = Nöjda med\n .datasetLabel = Röster",
        "survey-tab-ratings-bad-topics-card": "\n .title = Missnöjda med\n .datasetLabel = Röster",
        "survey-tab-overview-trend-card": "\n .title = Utveckling av nöjdhet\n .scoreLabel = Genomsnittligt betyg\n .votesLabel = Antal betyg",
        "survey-tab-comment": "Kommentarer",
        "survey-tab-surveys": "Undersökningar",
        "survey-period-select": "\n .label = Period",
        "survey-period-today": "Idag",
        "survey-period-last-day": "Senaste dygnet",
        "survey-period-last-week": "Senaste veckan",
        "survey-period-last-month": "Senaste månaden",
        "survey-period-last-quarter": "Senaste kvartalet",
        "survey-period-last-year": "Senaste året",

        // All rating
        "all-rating-time": "Tid",
        "all-rating-question": "Fråga",
        "all-rating-score": "Betyg",
        "all-rating-topics": "Ämnen",
        "all-rating-comment": "Kommentar",

        // SelectSurvey
        "select-survey": "\n .label = Undersökning",

        // --- Smiley summary card ---
        "survey-smiley-summary-card": "\n .title = Totalbetyg",
        "survey-smiley-summary-card-overall-score-label": "Betyg: { $averageScore }",

        // --- Survey participation card ---
        "survey-participation-card": "\n .title = Deltagande",
        "survey-participation-card-participants-label": "Deltagare",
        "survey-participation-card-non-participants-label": "Icke-deltagare",
        "survey-participation-card-participation-label": "Procent",
        "survey-participation-card-participation-breakdown": "{ $ratings } svar av { $orders } köp",

        // --- Survey smiley distribution card ---
        "survey-smiley-distribution-card": "\n .title = Nöjdhet",
        "survey-smiley-distribution-card-votes-label": "Röster",
        "smiley-label-bad": "Mycket dåligt",
        "smiley-label-poor": "Dåligt",
        "smiley-label-medium": "Medel",
        "smiley-label-good": "Bra",
        "smiley-label-excellent": "Utmärkt",


        // Production
        "production-meeting-service-breadcrumb": "Mötesförtäring",
        "production-planning-breadcrumb": "Planering",
        "production-pos-purchases-breadcrumb": "POS-köp",
        "production-takeaway-page-header": "\n .title = Takeaway",
        "production-takeaway-breadcrumb": "Takeaway",
        "production-transactions-print-label": "Skriv ut etikett",
        "production-table-toolbar-banner-unprinted-receipts-message": "Kvitton har inte skrivits ut på molnskrivaren.",
        "production-table-toolbar-banner-show-button": "Visa",
        "production-table-toolbar-banner-showing-unprinted-message": "Visar order som inte skrivits ut.",
        "production-table-toolbar-banner-clear-filter-button": "Rensa filter",
        "production-planning-page-header": "\n .title = Planering",
        "production-meeting-service-page-header": "\n .title = Mötesförtäring",
        "meeting-service-production-view-fullscreen-link": "Helskärmsläge",
        "meeting-service-production-view-tab-delivery-time": "Leveranstid",
        "meeting-service-production-view-tab-delivery-location": "Leveransplats",
        "meeting-service-production-view-not-approved-toggle": "Inte godkänd",
        "meeting-service-production-view-sittings-label": "\n .title = Sittplatser:",
        "meeting-service-production-view-host-label": "\n .title = Mötesansvarig:",
        "meeting-service-production-view-meeting-time-label": "\n .title = Mötestid:",
        "meeting-service-production-view-users-dialog-title": "Kontaktuppgifter",
        "meeting-service-production-view-users-dialog-name-label": "Namn:",
        "meeting-service-production-view-users-dialog-email-label": "E-post:",
        "meeting-service-production-view-users-dialog-phone-label": "Telefon:",
        "meeting-service-production-view-select-all-orders": "\n .label = Välj alla",
        "meeting-service-production-view-organizer-type-creator": "Skapare",
        "meeting-service-production-view-organizer-type-organizer": "Arrangör",
        "meeting-service-production-view-organizer-type-responsible": "Ansvarig",
        "meeting-service-production-view-hour-group-orders-count": "{ $count -> \n *[other] { $count } order \n [one] { $count } order \n }",
        "meeting-service-production-view-ready-count": "{ $ready }/{ $total } klara",
        "meeting-service-production-view-card-menu-button": "\n .aria-label = Mer",
        "meeting-service-production-view-card-full-edit": "Fullständig redigering",
        "meeting-service-production-view-card-delete-button": "Ta bort",
        "meeting-service-production-view-edit-items-button": "Redigera",
        "meeting-service-production-view-saved-dialog-title": "Order uppdaterad",
        "meeting-service-production-view-print-menu": "Skriv ut",
        "meeting-service-production-view-print-menu-tooltip": "\n .title = Skriv ut",
        "meeting-service-production-view-location-unknown": "Okänd plats",
        "meeting-service-production-view-filter-button": "Filter",
        "meeting-service-production-view-search-input": "\n .placeholder = Sök efter order-ID, mötesnamn, plats eller person.\n .title = Sök efter order-ID, mötesnamn, plats eller person.",
        "meeting-service-production-view-date-button": "Välj datum",
        "meeting-service-production-view-time-left": "{ $minutes } min kvar",
        "meeting-service-production-view-order-comment-read-more": "Läs mer",
        "meeting-service-production-view-order-comment-dialog-title": "Orderkommentar",
        "meeting-service-production-filter-delivery-title": "\n .title = Leverans",
        "meeting-service-production-filter-locked-label": "Låst",
        "meeting-service-production-filter-locked-all": "Alla",
        "meeting-service-production-filter-locked-locked": "Låst",
        "meeting-service-production-filter-locked-unlocked": "Olåst",
        "meeting-service-production-view-add-menu-button": "Lägg till produkt",
        "meeting-service-production-view-add-menu-catalog": "Artikel från katalog",
        "meeting-service-production-view-add-menu-wish": "Fritextönskemål",
        "meeting-service-production-view-add-menu-extra-service": "Tjänst",
        "meeting-service-order-drawer-order-number": "Order #{ $number }",
        "meeting-service-order-drawer-delivery-tab": "LEVERANS { $index }",
        "meeting-service-order-drawer-order-lines-title": "Orderrader",
        "meeting-service-order-drawer-total-label": "TOTALT",
        "meeting-service-order-drawer-status": "Status",
        "meeting-service-order-drawer-delivery-time": "Leveranstid",
        "meeting-service-order-drawer-contact": "Kontakt",
        "meeting-service-order-drawer-contact-info-button": "\n .title = Visa kontaktuppgifter",
        "meeting-service-order-drawer-contact-dialog-title": "Kontaktuppgifter",
        "meeting-service-contact-info-disclaimer": "\n .title = Kundens kontaktuppgifter. Hantera dem konfidentiellt.",
        "meeting-service-contact-info-print-footer": "Konfidentiellt: innehåller kundens kontaktuppgifter",
        "meeting-service-order-drawer-covers": "Kuvert",
        "meeting-service-order-drawer-covers-value": "{ $count } personer",
        "meeting-service-order-drawer-delivery-type": "Leveranstyp",
        "meeting-service-order-drawer-location": "Leveransplats",
        "meeting-service-order-drawer-order-note": "Ordernotering",
        "meeting-service-order-drawer-chat-customer": "Chatta med kantinen",
        "meeting-service-recurrence-series-button-tooltip": "Visa alla order i serien",
        "meeting-service-recurrence-series-drawer-subtitle": "Återkommande serie · { $count ->\n [one] { $count } order\n *[other] { $count } order\n}",
        "meeting-service-recurrence-series-drawer-recurrence": "Upprepning",
        "meeting-service-recurrence-series-drawer-period": "Period",
        "meeting-service-recurrence-series-drawer-contact": "Kontakt",
        "meeting-service-recurrence-series-drawer-covers": "Kuvert",
        "meeting-service-recurrence-series-drawer-covers-value": "{ $count } personer",
        "meeting-service-recurrence-series-drawer-delivery-type": "Leveranstyp",
        "meeting-service-recurrence-series-drawer-location": "Leveransplats",
        "meeting-service-recurrence-series-drawer-orders-title": "Order i serien",
        "meeting-service-recurrence-series-drawer-orders-id-column": "Order-ID",
        "meeting-service-recurrence-series-drawer-orders-date-column": "Leveransdatum",
        "meeting-service-recurrence-series-drawer-current-order": "Denna order",
        "meeting-service-recurrence-series-drawer-locked": "Låst",
        "meeting-service-recurrence-series-drawer-orders-empty": "Inga order hittades i den här serien",
        "meeting-service-recurrence-series-drawer-close-button": "Stäng",
        "meeting-service-recurrence-series-drawer-subtitle-no-count": "Återkommande serie",
        "meeting-service-recurrence-series-drawer-order-menu-button": "Fler åtgärder för order { $orderId }",
        "meeting-service-recurrence-series-drawer-order-menu-view": "Visa order",
        "meeting-service-recurrence-series-drawer-order-menu-edit": "Redigera order",
        "meeting-service-recurrence-series-drawer-order-menu-copy": "Kopiera order",
        "meeting-service-recurrence-series-drawer-order-menu-print": "Skriv ut order",
        "meeting-service-order-drawer-chat-merchant": "Chatta med kunden",
        "meeting-service-order-drawer-replied": "Besvarad",
        "meeting-service-order-drawer-quick-edit": "Snabbredigering",
        "meeting-service-order-drawer-quick-edit-save-button": "Spara",
        "meeting-service-order-drawer-full-edit": "Fullständig redigering",
        "meeting-service-order-drawer-delivery-label": "Leverans { $index }",
        "meeting-service-order-drawer-total": "Totalt",
        "meeting-service-order-drawer-vat": "Inkl. moms ({ $rate }%)",
        "meeting-service-order-drawer-order-lines-count": "{ $count } orderrader",
        "meeting-service-order-drawer-send": "Skicka",
        "meeting-service-order-drawer-add-catalog-title": "Artikel från katalog",
        "meeting-service-order-drawer-add-catalog-desc": "Sök i katalogen — priset fylls i automatiskt",
        "meeting-service-order-drawer-add-wish-title": "Fritextönskemål",
        "meeting-service-order-drawer-add-wish-desc": "Fri text — kökschefen går igenom den",
        "meeting-service-order-drawer-add-service-title": "Tjänst",
        "meeting-service-order-drawer-add-service-desc": "Dukning, servering, avdukning m.m.",
        "meeting-service-order-drawer-messages-empty": "Inga meddelanden ännu",
        "meeting-service-order-drawer-duplicate": "Duplicera",
        "meeting-service-order-drawer-resource-bookings": "Resursbokningar",
        "meeting-service-order-drawer-booking-time": "Bokningstid",
        "meeting-service-order-drawer-load-error": "Det gick inte att läsa in ordern",
        "meeting-service-order-drawer-retry": "Försök igen",
        "meeting-service-order-drawer-saved-snackbar": "Ordern har uppdaterats",
        "meeting-service-production-view-wish-badge": "\n .label = Önskemål",
        "meeting-service-production-view-service-badge": "\n .label = Tjänst",
        "meeting-service-production-view-legacy-service-tooltip": "\n .title = Det här är en äldre extratjänst från den gamla portalen. Den kan inte ändras men kan tas bort.",
        "meeting-service-production-view-service-already-added-snackbar": "Tjänsten har redan lagts till i den här leveransen och kan därför inte läggas till igen.",
        "meeting-service-production-view-only-services-snackbar": "En order kan inte bara bestå av extratjänster. Lägg till minst en produkt.",
        "meeting-service-production-view-add-service-confirm-button": "Lägg till",
        "meeting-service-production-view-add-service-required-error": "Det här fältet är obligatoriskt",
        "meeting-service-production-view-wish-name-field": "\n .placeholder = Produktnamn",
        "meeting-service-production-view-wish-price-field": "\n .placeholder = Pris",
        "meeting-service-production-view-add-product-autocomplete-label": "Välj produkt",
        "meeting-service-production-view-add-extra-service-autocomplete-label": "Välj extratjänst",
        "meeting-service-production-view-add-picker-cancel": "Avbryt",
        "meeting-service-production-view-save-changes-button": "Klar",
        "meeting-service-production-view-total-with-amount": "Totalt: { $amount }",
        "meeting-service-production-view-product-search-placeholder": "Sök maträtt",
        "meeting-service-production-view-product-out-of-stock": "Slutsåld",
        "meeting-service-production-view-product-already-added-snackbar": "Produkten har redan lagts till i den här ordern och kan därför inte läggas till igen. Uppdatera den befintliga orderraden i stället.",
        "meeting-service-production-view-product-required": "Produkt måste anges",
        "meeting-service-production-view-saved-banner": "\n .title = Order #{ $orderNumber } har uppdaterats. Totalt: { $total }",
        "meeting-service-production-view-saved-banner-no-total": "\n .title = Order #{ $orderNumber } har uppdaterats",
        "meeting-service-production-view-cancel-button": "Avbryt",
        "meeting-service-production-view-remove-line-button": "\n .aria-label = Ta bort",
        "meeting-service-production-view-product-name-dialog-title": "Produktnamn",
        "meeting-service-production-view-meeting-name-dialog-title": "Mötesnamn",
        "meeting-service-production-view-empty": "Inga order att producera",
        "production-pos-purchases-page-header": "\n .title = POS-köp",
        "production-tab-production-list": "Produktionslista",
        "production-tab-pos-transactions": "POS-transaktioner",
        "production-tab-orders": "Produktion {$amount}",
        "planning-tab-takeaway": "Takeaway",
        "planning-tab-calendar": "Kalender",
        "planning-tab-not-approved": "Väntar på godkännande {$amount}",
        "planning-tab-to-be-booked": "Ska bokföras {$amount}",
        "planning-tabs-placeholder": "\n .title = Kommer snart \n .body = Vi arbetar på att ge dig den här funktionen.",
        "production-list-no-result": "Inga resultat",
        "production-orders-action-bar-confirm-queue-remove-dialog": "\n .title = Ta bort från skrivarkön\n .message = Är du säker på att du vill ta bort de valda kvittona från skrivarkön?\n .buttonLabelSubmit = Ta bort",
        "production-orders-action-bar-confirm-print-dialog": "\n .title = Skriv ut kvitton\n .message = Är du säker på att du vill skriva ut de valda kvittona?\n .buttonLabelSubmit = Skriv ut",
        "production-meeting-service-shortcuts-button": "Genvägar",
        "production-meeting-service-shortcut-booked-orders": "Bokförda order",
        "production-meeting-service-search-field": "\n .label = Sök order\n .placeholder = Ange order-ID, mötesnamn eller värd.",
        "production-orders-search-field": "\n .label = Sök order\n .placeholder = Ange order-ID, namn eller e-post.",
        "accounting-orders-search-field": "\n .label = Sök order\n .placeholder = Ange order-ID, namn eller e-post.",
        "accounting-orders-meeting-service-search-field": "\n .label = Sök order\n .placeholder = Ange order-ID, mötesnamn eller värd.",

        // Production package slip
        "production-package-slip-order-error": "Det gick inte att läsa in följesedel med ID #{ $orderId }",
        "production-package-slip-order-error-description": "Ordern kunde inte behandlas på grund av saknade eller ogiltiga data.",
        "production-package-slip-order-id-number": "Order-ID: {$orderId}",
        "production-package-slip-section-delivery-details-title": "Leveransdetaljer",
        "production-package-slip-section-delivery-details-type": "Leveranstyp:",
        "production-package-slip-section-delivery-details-time": "Leveranstid:",
        "production-package-slip-section-delivery-details-meeting-time": "Mötestid:",
        "production-package-slip-section-delivery-details-location": "Leveransplats:",
        "production-package-slip-section-delivery-details-sittings": "Kuvert:",
        "production-package-slip-section-delivery-details-merchant": "Försäljningsställe:",
        "production-package-slip-section-contact-details-title": "Kontaktuppgifter",
        "production-package-slip-section-contact-details-meeting-creator": "\n .label = Skapare:",
        "production-package-slip-section-contact-details-meeting-host": "\n .label = Mötesvärd:",
        "production-package-slip-table-column-items": "Antal",
        "production-package-slip-table-column-products": "Produkter",
        "production-package-slip-table-column-delivery-time": "Leveranstid",
        "production-package-slip-section-note-title": "Notering",
        "production-package-slip-section-header-slip-title": "Följesedel",
        "print-page-header-printed-label": "{ $title } · utskriven { $date } kl. { $time }",
        "print-page-footer-page-counter": "Sida { $page } av { $pages }",
        "print-page-footer-order-label": "Order { $orderId }",
        "production-export-exported-label": "Exporterad",
        "production-package-slip-section-header-digital-slip-title": "Digital följesedel",
        "production-package-slip-header-orders-count": "Följesedlar: {$orderCount} valda",
        "production-package-slip-navigation-counter": "Följesedel { $current } av { $total }",

        // Production credit note
        "production-credit-note-dialog-title": "\n .dialogTitle = Skapa kreditnota",
        "production-credit-note-credit-info": "\n .title = En kreditnota används för att återföra delar av en bokförd order.",
        "production-credit-note-debit-info": "\n .title = En tilläggsorder används för att lägga till artiklar i en order som redan är bokförd.",
        "production-credit-note-table-column-order-id": "Order-ID",
        "production-credit-note-table-column-type": "Typ",
        "production-credit-note-table-column-booked": "Bokförd",
        "production-credit-note-table-column-amount": "Belopp (DKK)",
        "production-credit-note-table-column-type-cell-original-order": "Ursprunglig order",
        "production-credit-note-table-column-type-cell-credit": "Kreditnota",
        "production-credit-note-table-column-type-cell-debit": "Tilläggsorder",
        "production-credit-note-button-next": "Nästa",
        "production-credit-note-button-cancel": "Avbryt",
        "production-credit-note-select-label": "Skapa",

        // Accounting
        "accounting-header": "\n .title = Redovisning",
        "accounting-product-sales-page-header": "\n .title = Produktförsäljning",
        "merchant-nav-item-accounting-product-sales": "Produktförsäljning",
        "accounting-orders-page-header": "\n .title = Order",
        "merchant-nav-item-accounting-orders": "Order",
        "accounting-subscriptions-page-header": "\n .title = Prenumerationer",
        "merchant-nav-item-accounting-subscriptions": "Prenumerationer",
        "accounting-cash-register-page-header": "\n .title = Saldo",
        "merchant-nav-item-accounting-cash-register": "Saldo",
        "accounting-customers-page-header": "\n .title = Kunder",
        "merchant-nav-item-accounting-customers": "Kunder",
        "accounting-customer-balance-page-header": "\n .title = Användarsaldo",
        "merchant-nav-item-accounting-customer-balance": "Användarsaldo",
        "merchant-nav-item-accounting-z-report": "Z-rapport",
        "merchant-nav-item-accounting-custom-reports": "Anpassade rapporter",
        "merchant-accounting-z-reports-table-date-range-filter": "\n .label = Datumintervall",

        "accounting-product-sales-breadcrumb-title": "Produktförsäljning",
        "accounting-orders-breadcrumb-title": "Order",
        "accounting-subscriptions-breadcrumb-title": "Prenumerationer",
        "accounting-cash-register-breadcrumb-title": "Saldo",
        "accounting-customers-breadcrumb-title": "Kunder",
        "accounting-customer-balance-breadcrumb-title": "Användarsaldo",
        "accounting-customers-button-expand-all": "Expandera alla",
        "accounting-customers-button-collapse-all": "Fäll ihop alla",

        "accounting-orders-tab-transactions": "Transaktioner",
        "accounting-orders-tab-refill": "Påfyllning",
        "accounting-orders-tab-meetingService": "Mötesförtäring",
        "transactions-table-list-refund-title": "Återbetalning",
        "transactions-table-list-refund": "\n .title = Återbetalning \n .message = Är du säker på att du vill återbetala order #{ $orderId } ({ $amount })? \n .buttonLabelSubmit = Bekräfta\n .buttonLabelCancel = Avbryt",
        "transactions-table-list-refund-success-dialog-title": "Ordern har återbetalats",
        "transactions-table-list-refund-error-message": "Det gick inte att återbetala ordern. Försök igen.",
        "order-accounting-refund-pos-order-confirm-dialog": "\n .title = Återbetalning \n .message = Är du säker på att du vill återbetala order #{ $orderId }? \n .buttonLabelSubmit = Bekräfta\n .buttonLabelCancel = Avbryt",
        "order-accounting-refund-pos-order-title": "Återbetalning",
        "order-accounting-refund-pos-order-locked-dialog-title": "Ordern kan inte återbetalas",
        "order-accounting-refund-pos-order-locked-dialog-body": "Ordern kan inte återbetalas.",
        "order-accounting-refund-pos-order-already-refunded-title": "Ordern är redan återbetald",
        "order-accounting-refund-pos-order-already-refunded-body": "Ordern har redan återbetalats.",
        "transactions-table-list-message-customer": "Skicka meddelande till kund",

        "filter-menu-title": "Filter",
        "filter-menu-clear-all-button": "Rensa alla",
        "filter-menu-clear-button": "Rensa",

        "filter-menu-accordion-shops-title": "\n .title = Butiker",
        "filter-menu-accordion-customers-title": "\n .title = Kunder",
        "filter-menu-accordion-transactions-order-details-title": "\n .title = Orderdetaljer",
        "filter-menu-accordion-transactions-order-number": "\n .label = Ordernummer \n .placeholder = Sök efter ordernr...",
        "filter-menu-accordion-transactions-user": "\n .label = Användare \n .placeholder = Ange ID eller e-post",

        "standard-email-filter-label": "\n .label = E-post",
        "standard-email-filter-error-message": "Ogiltig e-postadress",
        "standard-id-filter-order-id-label": "\n .label = Order-ID",
        "standard-id-filter-employee-id-label": "\n .label = Anställnings-ID",
        "standard-id-filter-only-numbers-error-message": "Får endast innehålla siffror",
        "standard-last-4-numbers-filter": "\n .label = Kreditkort, sista 4 siffror",
        "standard-last-4-numbers-filter-error-message": "Endast de sista 4 siffrorna",
        "standard-payment-method-input-label": "Betalningsmetod",
        "standard-payment-method-item-credit-card": "Kreditkort",
        "standard-payment-method-item-contant": "Kontant",
        "standard-payment-method-item-invoicing": "Fakturering",
        "standard-payment-method-item-wallet": "Wallet",
        "standard-payment-method-item-free": "Gratis",
        "standard-merchants-filter-label": "Försäljningsställen",
        "standard-merchants-shops-filter-label": "Butiker",

        "standard-start-date-picker": "\n .label = Startdatum",
        "standard-end-date-picker": "\n .label = Slutdatum",
        "standard-period-date-picker": "Period",

        "table-select-data-type-filter-on-label": "Filtrera på",
        "table-select-data-type-filter-on-label-label": "\n .label = Filtrera på",
        "table-select-data-type-filter-on-item-order-date": "Orderdatum",
        "table-select-data-type-filter-on-item-delivery-date": "Leveransdatum",
        "table-select-data-type-filter-on-item-booked-date": "Bokföringsdatum",

        "table-select-date-period-filter-by-label": "Period",
        "table-select-date-period-filter-by-label-label": "\n .label = Period",
        "table-select-date-period-filter-by-all": "Alla",
        "table-select-date-period-filter-by-today": "Idag",
        "table-select-date-period-filter-by-yesterday": "Igår",
        "table-select-date-period-filter-by-tomorrow": "Imorgon",
        "table-select-date-period-filter-by-this-week": "Den här veckan",
        "table-select-date-period-filter-by-this-month": "Den här månaden",
        "table-select-date-period-filter-by-7d": "Kommande 7 dagar",
        "table-select-date-period-filter-by-30d": "Kommande 30 dagar",

        "table-select-resource-type-filter-by-label": "Resurstyp",
        "table-select-resource-type-filter-by-label-label": "\n .label = Resurstyp",
        "table-select-resource-type-filter-by-all": "Alla",
        "table-select-resource-type-filter-by-room": "Rum",
        "table-select-resource-type-filter-by-mobile-av": "Mobil AV",
        "table-select-resource-type-filter-by-car": "Bil",

        "resource-dashboard-type-all": "Alla typer",
        "resource-dashboard-type-room": "Mötesrum",
        "resource-dashboard-type-mobile-av": "AV-utrustning",
        "resource-dashboard-type-car": "Bilar",

        "standard-order-type-filter-mode-all": "Alla",
        "standard-order-type-filter-mode-pos": "POS",
        "standard-order-type-filter-mode-lunch": "Kantin",
        "standard-order-type-filter-mode-meeting-service": "Mötesförtäring",
        "standard-order-type-filter-mode-resource-booking": "Resursbokning",
        "standard-order-type-filter-mode-internal": "Intern",
        "standard-order-type-filter-mode-external": "Extern",
        "standard-order-type-filter-mode-take-away": "Takeaway",

        // Accounting > Orders > Meeting service
        "accounting-orders-meeting-service-receipt": "Kvitto",
        "accounting-orders-meeting-service-table-startDate-date-picker": "\n .label = Bokfört startdatum",
        "accounting-orders-meeting-service-table-endDate-date-picker": "\n .label = Bokfört slutdatum",
        "accounting-orders-meeting-service-table-number": "Order-ID",
        "accounting-orders-meeting-service-table-ref": "Ref.",
        "accounting-orders-meeting-service-table-booked-date": "Bokföringsdatum",
        "accounting-orders-meeting-service-table-delivery-date": "Leveransdatum",
        "accounting-orders-meeting-service-table-creator": "Beställare",
        "accounting-orders-meeting-service-table-status": "Status",
        "accounting-orders-meeting-service-table-amount": "Belopp",
        "filter-menu-accordion-booked-date-title": "\n .title = Bokföringsdatum",
        "filter-menu-accordion-delivery-date-title": "\n .title = Leveransdatum",
        "filter-menu-accordion-order-details-title": "\n .title = Orderdetaljer",
        "filter-menu-accordion-meeting-service-start-date-picker": "\n .label = Startdatum",
        "filter-menu-accordion-meeting-service-end-date-picker": "\n .label = Slutdatum",
        "filter-menu-accordion-meeting-service-order-number": "\n .label = Ordernummer \n .placeholder = Sök efter ordernr...",
        "filter-menu-accordion-meeting-service-customer": "\n .label = Kund \n .placeholder = Kundnamn...",
        "accounting-orders-meeting-service-payment-type-credit": "Kreditnota",
        "accounting-orders-meeting-service-payment-type-debit": "",

        // Accounting subscription
        "accounting-subscription-title": "Prenumeration",
        "accounting-subscription-name": "Namn",
        "accounting-subscription-subscribed": "Prenumererar",
        "accounting-subscription-unsubscribed": "Avslutad",
        "accounting-subscription-payment-method": "Betalningsmetod",
        "accounting-subscription-amount": "Belopp",
        "accounting-subscription-cancel": "Säg upp prenumeration",
        "accounting-subscription-cancel-true": "Din prenumeration har sagts upp",


        // Accounting product sale
        "accounting-product-sale-product-code": "Produktkod",
        "accounting-product-sale-product": "Produkter",
        "accounting-product-sale-product-quantity": "Antal",
        "accounting-product-sale-product-amount": "Belopp",
        "accounting-product-sale-export-empty": "Ingen försäljning under den här perioden.",
        "accounting-product-sale-date-range-label": "\n .label = Period",

        // Accounting balance
        "accounting-amount": "Belopp",
        "accounting-amount-no-sales": "Ingen försäljning under den angivna perioden",

        // Accounting debtors
        "accounting-debtors-export-items-label": "Antal",
        "accounting-debtors-export-amount-label": "Belopp",
        "accounting-debtors-export-subtotal-label": "Delsumma",
        "accounting-debtors-export-failed": "Det gick inte att exportera debitorer",
        "accounting-debtors-export-account-total":  "Kontototal",
        "accounting-debtors-export-subtotal": "Delsumma",
        "accounting-customers-export-sales-summary": "Kundens försäljningsöversikt",
        "accounting-customers-export-payroll": "Kundens lönefiler (ZIP-fil)",


        // Merchant > Reports > Accounting > Z-report
        "merchant-accounting-z-reports-page-header": "\n .title = Z-rapport",
        "merchant-accounting-z-reports-table-date-column": "Datum",
        "merchant-accounting-z-reports-table-pos-terminal-column": "POS-terminal",
        "merchant-accounting-z-reports-table-amount-column": "Belopp",

        // Merchant > Reports > Accounting > Z-report
        "merchant-accounting-custom-reports-page-header": "\n .title = Anpassade rapporter",
        "merchant-accounting-custom-reports-table-name-column": "Namn",
        "merchant-accounting-custom-reports-table-interval-column": "Intervall",
        "merchant-accounting-custom-reports-table-last-run-column": "Senaste körning",
        "merchant-accounting-custom-reports-table-status-column": "Status",
        "merchant-accounting-custom-reports-table-button-details": "Detaljer",
        "merchant-accounting-custom-reports-table-button-download-report": "Ladda ner rapport",
        "merchant-accounting-custom-reports-table-button-activate": "Aktivera",
        "merchant-accounting-custom-reports-table-button-deactivate": "Inaktivera",
        "merchant-accounting-custom-reports-confirm-modal-question": "Är du säker på att du vill { $status} '{ $itemName }'?",
        "merchant-accounting-custom-reports-run-modal-form-title": "Ladda ner rapport",
        "merchant-accounting-custom-reports-run-modal-form-subtitle-name": "Namn:",
        "merchant-accounting-custom-reports-run-modal-form-subtitle": "Löneavdrag",
        "merchant-accounting-custom-reports-run-modal-form-startDate-date-picker": "\n .label = Startdatum",
        "merchant-accounting-custom-reports-run-modal-form-endDate-date-picker": "\n .label = Slutdatum",
        "merchant-accounting-custom-reports-run-form-save-button": "Ladda ner",

        // SelectCustomer
        "select-customer": "\n .label = Kund",
        "select-debtor": "\n .label = Företag",
        "select-customer-all": "Alla",

        // SelectShop
        "select-shop": "Butik",
        "select-shop-label": "\n .label = Butik",
        "select-shop-all": "Alla",


        // SelectWeek
        "select-week": "Välj vecka",
        "select-week-week": "Vecka",

        // Select Kitchen
        "control-kitchen-mode-delivery-time": "Visning efter leveranstid",
        "control-kitchen-mode-purchase-time": "Visning efter inköpstid",
        "control-kitchen-mode-period-report": "Periodrapport",

        // Merchant > Reports > Menu Planning
        "merchant-menu-planning-header": "\n .title = Menyplanering",
        "merchant-menu-planning-tab-calendar": "Kalender",
        "merchant-menu-planning-tab-menus": "Menyer",
        "merchant-menu-planning-tab-digital-signage": "Digital skyltning",
        "merchant-menu-templates-row-meta": "{ $categories } kategorier · { $dishes } rätter",
        "merchant-menu-templates-row-no-channels": "Ingen kanal",
        "merchant-menu-templates-row-delete-item": "Ta bort",
        "merchant-menu-templates-row-edit-button": "Redigera",
        "merchant-menu-templates-create-button": "Skapa ny",
        "merchant-menu-templates-empty": "Inga mallar ännu. Skapa din första mall.",
        "merchant-menu-templates-load-error": "Mallen kunde inte laddas. Försök igen.",
        "merchant-menu-templates-list-load-error": "Mallarna kunde inte laddas. Försök igen.",
        "merchant-menu-templates-delete-entity": "\n .typeOfEntity = menymall",
        "merchant-menu-templates-channel-mobile-app": "Mobilapp",
        "merchant-menu-templates-channel-canteen-display": "Kantinskärm",
        "merchant-menu-templates-channel-digital-signs": "Digitala rättskyltar",
        "merchant-menu-templates-channel-print": "Utskriftsark",
        "merchant-menu-templates-editor-new-title": "Ny mall",
        "merchant-menu-templates-editor-name-label": "Mallnamn",
        "merchant-menu-templates-editor-name-field": "\n .placeholder = Mallnamn",
        "merchant-menu-templates-editor-name-hint": "Internt namn — visas inte för kunder.",
        "merchant-menu-templates-editor-channels-label": "Publiceras till",
        "merchant-menu-templates-editor-channels-hint": "Var mallens meny visas. En mall kan riktas mot en eller flera kanaler, och olika mallar kan riktas mot olika kanaler.",
        "merchant-menu-templates-editor-categories-title": "Kategorier",
        "merchant-menu-templates-editor-add-category-button": "Lägg till kategori",
        "merchant-menu-templates-editor-cancel-button": "Avbryt",
        "merchant-menu-templates-editor-save-button": "Spara mall",
        "merchant-menu-templates-category-dish-count": "{ $count } rätter",
        "merchant-menu-templates-category-edit-button": "Redigera",
        "merchant-menu-templates-category-delete-item": "Ta bort",
        "merchant-menu-templates-category-dialog-add-title": "\n .dialogTitle = Lägg till kategori",
        "merchant-menu-templates-category-dialog-edit-title": "\n .dialogTitle = Redigera kategori",
        "merchant-menu-templates-category-dialog-name-field": "\n .label = Kategorinamn \n .placeholder = t.ex. Varma rätter",
        "merchant-menu-templates-category-dialog-cancel-button": "Avbryt",
        "merchant-menu-templates-category-dialog-save-button": "Spara",
        "merchant-menu-templates-delete-category-dialog-title": "Ta bort kategori",
        "merchant-menu-templates-delete-category-dialog-message": "Är du säker på att du vill ta bort '{ $name }'?",
        "merchant-menu-templates-delete-category-dialog-dishes-warning": "{ $count ->\n [one] Den innehåller { $count } rätt, som också tas bort.\n *[other] Den innehåller { $count } rätter, som också tas bort.\n}",
        "merchant-menu-templates-delete-dish-dialog-title": "Ta bort rätt",
        "merchant-menu-templates-delete-dish-dialog-message": "Är du säker på att du vill ta bort '{ $name }'?",
        "merchant-menu-templates-delete-dish-dialog-message-unnamed": "Är du säker på att du vill ta bort den här rätten?",
        "merchant-menu-templates-add-dish-card": "Lägg till rätt",
        "merchant-menu-templates-dish-remove-button": "\n .aria-label = Ta bort rätt",
        "merchant-menu-templates-dish-name-label": "Rättens namn",
        "merchant-menu-templates-week-day-short-monday": "Må",
        "merchant-menu-templates-week-day-short-tuesday": "Ti",
        "merchant-menu-templates-week-day-short-wednesday": "On",
        "merchant-menu-templates-week-day-short-thursday": "To",
        "merchant-menu-templates-week-day-short-friday": "Fr",
        "merchant-menu-templates-week-day-short-saturday": "Lö",
        "merchant-menu-templates-week-day-short-sunday": "Sö",
        "merchant-menu-templates-dish-cancel-button": "Avbryt",
        "merchant-menu-templates-dish-done-button": "Klar",
        "merchant-menu-templates-availability-hint": "Vilka veckodagar den här rätten visas på i veckomenyn.",
        "merchant-menu-templates-dish-fields-title": "Fält",
        "merchant-menu-templates-dish-new-title": "Ny rätt",
        "merchant-menu-templates-dish-no-photo": "Inget mallfoto",
        "merchant-menu-templates-dish-no-mandatory-fields": "Inga obligatoriska fält",
        "merchant-menu-templates-ai-can-fill-label": "AI kan fylla i det här fältet",
        "merchant-menu-templates-ai-hint-on": "AI-generering i veckomenyn kan fylla i det här fältet.",
        "merchant-menu-templates-ai-hint-off": "AI-generering i veckomenyn lämnar det här fältet tomt — köket fyller i det.",
        "merchant-menu-templates-ai-off-label": "AI av",
        "merchant-menu-templates-field-value-default-label": "Standardvärde (valfritt)",
        "merchant-menu-templates-field-value-locked-label": "Låst värde · krävs för den här mallen",
        "merchant-menu-templates-field-price": "Pris",
        "merchant-menu-templates-field-description": "Beskrivning",
        "merchant-menu-templates-field-allergens": "Allergener",
        "merchant-menu-templates-field-availability": "Tillgänglighet",
        "merchant-menu-templates-field-marketing-tag": "Marknadsföringstagg",
        "merchant-menu-templates-field-image": "Bild",
        "merchant-menu-templates-field-title": "Titel",
        "merchant-menu-templates-field-ingredients": "Ingredienser",
        "merchant-menu-templates-field-nutrition": "Näringsinnehåll",
        "merchant-menu-templates-field-co2-footprint": "CO₂-avtryck",
        "merchant-menu-templates-title-value-field": "\n .placeholder = Titeltext…",
        "merchant-menu-templates-ingredients-value-field": "\n .placeholder = t.ex. Tomater, basilika, vitlök, olivolja…",
        "merchant-menu-templates-nutrition-value-field": "\n .placeholder = t.ex. 320 kcal · 12g P · 40g K · 8g F",
        "merchant-menu-templates-co2-unit": "kg CO₂-ekv.",
        "merchant-menu-templates-dish-details-title": "Detaljer",
        "merchant-menu-templates-dish-details-subtitle": "visas i en dialogruta i veckomenyn",
        "merchant-menu-templates-mode-locked": "Låst",
        "merchant-menu-templates-mode-mandatory": "Obligatorisk",
        "merchant-menu-templates-mode-optional": "Valfri",
        "merchant-menu-templates-mode-hint-locked": "Låst — ett startvärde krävs här i mallen; det förs över till varje veckomeny. Köket kan fortfarande redigera det för en viss dag.",
        "merchant-menu-templates-mode-hint-mandatory": "Obligatoriskt — köket måste fylla i det här fältet i veckomenyn. Ett standardvärde här är valfritt.",
        "merchant-menu-templates-mode-hint-optional": "Valfritt — köket kan fylla i det här fältet i veckomenyn. Ett standardvärde här är valfritt.",
        "merchant-menu-templates-field-show-toggle": "Visa",
        "merchant-menu-templates-field-hidden-hint": "Dold i veckomenyn",
        "merchant-menu-templates-price-value-field": "\n .label = Pris",
        "merchant-menu-templates-price-same-week-checkbox": "Samma pris hela veckan",
        "merchant-menu-templates-description-value-field": "\n .placeholder = Beskrivningstext…",
        "merchant-menu-templates-marketing-tag-value-field": "\n .label = Marknadsföringstagg \n .helperText = Exempel: Dagens erbjudande, Rabatt",
        "merchant-menu-templates-image-upload": "\n .label = Ladda upp bild",
        "merchant-menu-templates-validation-required": "Det här fältet är obligatoriskt",
        "merchant-menu-templates-validation-number": "Måste vara ett tal",
        "merchant-menu-planning-tab-week-menu": "Veckomeny",
        "merchant-week-menu-cell-title-field": "\n .placeholder = Skriv rättens namn…",
        "merchant-week-menu-cell-recent-dishes-title": "Tidigare menyer",
        "merchant-week-menu-cell-description-field": "\n .placeholder = Lägg till beskrivning…",
        "merchant-week-menu-cell-description-expand-tooltip": "\n .title = Öppna hela beskrivningen",
        "merchant-week-menu-cell-add-allergen-label": "Allergen",
        "merchant-week-menu-cell-price-field": "\n .placeholder = 0",
        "merchant-week-menu-cell-price-locked-all-week": "{ $price } DKK · hela veckan",
        "merchant-week-menu-cell-price-locked": "{ $price } DKK",
        "merchant-week-menu-currency-label": "DKK",
        "merchant-week-menu-cell-marketing-field": "\n .placeholder = Marknadsföringstagg (valfritt)",
        "merchant-week-menu-cell-add-image-label": "Foto",
        "merchant-week-menu-cell-image-from-template-label": "Bild från mallen",
        "merchant-week-menu-cell-image-delete-button": "\n .aria-label = Ta bort",
        "merchant-week-menu-cell-menu-button": "\n .aria-label = Åtgärder för rätten",
        "merchant-week-menu-cell-copy-tooltip": "\n .title = Kopiera till andra dagar…",
        "merchant-week-menu-cell-clear-tooltip": "\n .title = Rensa rätten",
        "merchant-week-menu-cell-details-tooltip": "\n .title = Detaljer om rätten",
        "merchant-week-menu-details-dialog": "\n .dialogTitle = Detaljer om rätten",
        "merchant-week-menu-details-ingredients-label": "Ingredienser",
        "merchant-week-menu-details-nutrition-label": "Näringsinnehåll",
        "merchant-week-menu-details-co2-label": "CO₂-avtryck (kg CO₂-ekv.)",
        "merchant-week-menu-details-dialog-close-button": "Stäng",
        "merchant-week-menu-details-dialog-save-button": "Spara",
        "merchant-week-menu-cell-unavailable": "Inte tillgänglig",
        "merchant-week-menu-cell-drag-tooltip": "\n .title = Dra till en annan dag",
        "merchant-week-menu-cell-status-ready": "Klar",
        "merchant-week-menu-cell-status-missing": "Saknas",
        "merchant-week-menu-missing-tooltip-title": "Saknas fortfarande",
        "merchant-week-menu-missing-field-name": "Namn",
        "merchant-week-menu-missing-field-description": "Beskrivning",
        "merchant-week-menu-missing-field-price": "Pris",
        "merchant-week-menu-missing-field-photo": "Foto",
        "merchant-week-menu-missing-field-allergens": "Allergener",
        "merchant-week-menu-missing-field-marketing-tag": "Marknadsföringstagg",
        "merchant-week-menu-cell-status-optional": "Valfri",
        "merchant-week-menu-cell-ai-regen-tooltip": "\n .title = Generera igen med AI",
        "merchant-week-menu-description-dialog": "\n .dialogTitle = Redigera beskrivning",
        "merchant-week-menu-description-dialog-field-label": "Beskrivning",
        "merchant-week-menu-description-dialog-field": "\n .placeholder = Skriv en längre och mer detaljerad beskrivning här…",
        "merchant-week-menu-description-dialog-close-button": "Stäng",
        "merchant-week-menu-description-dialog-save-button": "Spara",
        "merchant-week-menu-copy-dish-dialog": "\n .dialogTitle = Kopiera rätten till andra dagar",
        "merchant-week-menu-copy-week-to-label": "\n .label = Kopiera till",
        "merchant-week-menu-copy-overwrite-label": "Skriv över ifyllda rätter",
        "merchant-week-menu-copy-overwrite-sublabel": "Av — endast tomma platser fylls i, befintliga rätter behålls.",
        "merchant-week-menu-copy-overwrite-sublabel-on": "På — befintliga rätter skrivs också över.",
        "merchant-week-menu-copy-dish-cancel-button": "Avbryt",
        "merchant-week-menu-copy-dish-confirm-button": "Kopiera",
        "merchant-week-menu-week-label": "Vecka { $week } · { $period }",
        "merchant-week-menu-prev-week-button": "\n .aria-label = Föregående vecka",
        "merchant-week-menu-next-week-button": "\n .aria-label = Nästa vecka",
        "merchant-week-menu-days-ready-label": "{ $ready }/{ $total } dagar klara",
        "merchant-week-menu-dish-column-label": "Rätt",
        "merchant-week-menu-clear-week-snackbar": "Veckan har rensats",
        "merchant-week-menu-clear-week-dialog": "\n .title = Rensa vecka\n .buttonLabelSubmit = Rensa",
        "merchant-week-menu-clear-week-dialog-message": "Detta tar bort alla rätter som lagts in för den här veckan. Åtgärden kan inte ångras.",
        "merchant-week-menu-close-day-dialog": "\n .title = Stäng den här dagen\n .buttonLabelSubmit = Stäng dagen",
        "merchant-week-menu-close-day-dialog-message": "{ $count } ifyllda rätter den här dagen publiceras inte medan dagen är stängd.",
        "merchant-week-menu-remove-theme-dialog": "\n .title = Byt tillbaka till mallen\n .buttonLabelSubmit = Byt tillbaka",
        "merchant-week-menu-remove-theme-dialog-message": "Kassera { $count } temarätter den här dagen och byta tillbaka till mallen?",
        "merchant-week-menu-publish-button": "Publicera klara dagar",
        "merchant-week-menu-autosaved-label": "Sparat automatiskt",
        "merchant-week-menu-day-publish-tooltip": "\n .title = Publicera den här dagen för kunder",
        "merchant-week-menu-day-status-draft": "Utkast",
        "merchant-week-menu-day-status-published": "Publicerad",
        "merchant-week-menu-day-status-updated": "Uppdaterad",
        "merchant-week-menu-day-menu-button": "\n .aria-label = Åtgärder för dagen",
        "merchant-week-menu-day-menu-theme-item": "Gör den här dagen till en temadag",
        "merchant-week-menu-day-menu-rename-theme-item": "Redigera temats namn…",
        "merchant-week-menu-day-menu-remove-theme-item": "Byt tillbaka till mallen",
        "merchant-week-menu-day-menu-close-item": "Markera dagen som stängd",
        "merchant-week-menu-theme-dialog-add-title": "\n .dialogTitle = Gör { $day } till en temadag",
        "merchant-week-menu-theme-dialog-rename-title": "\n .dialogTitle = Redigera temats namn",
        "merchant-week-menu-theme-dialog-name-label": "Temats namn",
        "merchant-week-menu-theme-dialog-name-field": "\n .placeholder = Skriv tema...",
        "merchant-week-menu-theme-dialog-hint": "Ge temat ett kort namn som \"Spansk dag\" eller \"Jul\".",
        "merchant-week-menu-theme-dialog-close-button": "Stäng",
        "merchant-week-menu-theme-dialog-save-button": "Spara",
        "merchant-week-menu-theme-add-dish-button": "Lägg till rätt",
        "merchant-week-menu-closed-panel-title": "Stängt",
        "merchant-week-menu-closed-panel-message": "Ingen meny den här dagen. Kunderna ser dagen som stängd.",
        "merchant-week-menu-closed-reopen-button": "Öppna dagen igen",
        "merchant-week-menu-copy-week-dialog": "\n .dialogTitle = Kopiera veckan till andra veckor",
        "merchant-week-menu-copy-week-cancel-button": "Avbryt",
        "merchant-week-menu-copy-week-confirm-button": "Kopiera",
        "merchant-week-menu-ai-button": "AI",
        "merchant-week-menu-ai-menu-quick-title": "Snabbmeny",
        "merchant-week-menu-ai-menu-quick-subtitle": "Generera hela veckan automatiskt",
        "merchant-week-menu-ai-menu-customize-title": "Anpassa meny",
        "merchant-week-menu-ai-menu-customize-subtitle": "Välj teman och regler per dag och generera sedan",
        "merchant-week-menu-ai-banner-title": "AI har genererat den här menyn",
        "merchant-week-menu-ai-banner-subtitle": "Granska rätterna innan du publicerar.",
        "merchant-week-menu-ai-banner-regenerate-button": "Generera igen",
        "merchant-week-menu-ai-banner-undo-button": "Ångra",
        "merchant-week-menu-ai-banner-close-button": "\n .aria-label = Stäng",
        "merchant-week-menu-ai-dialog": "\n .dialogTitle = Anpassa menygenerering",
        "merchant-week-menu-ai-dialog-subtitle": "Välj ett tema och regler och låt AI fylla i veckan",
        "merchant-week-menu-ai-theme-label": "Tema",
        "merchant-week-menu-ai-inspiration-label": "Inspiration",
        "merchant-week-menu-ai-dialog-notes-field": "\n .placeholder = Lägg till egna idéer eller regler, t.ex. vissa krav",
        "merchant-week-menu-ai-overwrite-label": "Skriv över befintliga rätter",
        "merchant-week-menu-ai-overwrite-helper": "Av = AI fyller bara i tomma fält",
        "merchant-week-menu-ai-overwrite-dialog": "\n .dialogTitle = Den här menyn har redan rätter",
        "merchant-week-menu-ai-overwrite-subtitle": "Hur ska AI hantera dagarna som redan är ifyllda?",
        "merchant-week-menu-ai-overwrite-fill-title": "Fyll bara i tomma fält",
        "merchant-week-menu-ai-overwrite-fill-subtitle": "Behåll rätterna du redan har skrivit",
        "merchant-week-menu-ai-overwrite-replace-title": "Ersätt alla rätter",
        "merchant-week-menu-ai-overwrite-replace-subtitle": "Skriv över hela veckan",
        "merchant-week-menu-ai-overwrite-choose-button": "Välj",
        "merchant-week-menu-ai-overwrite-cancel-button": "Avbryt",
        "merchant-week-menu-ai-dialog-cancel-button": "Avbryt",
        "merchant-week-menu-ai-dialog-generate-button": "Generera",
        "merchant-week-menu-ai-theme-surprise": "Överraska mig",
        "merchant-week-menu-no-templates-title": "Inga menymallar än",
        "merchant-week-menu-no-templates-message": "För att planera en veckomeny måste du först skapa en mall med dina kategorier och rätter.",
        "merchant-week-menu-create-template-button": "Skapa mall",
        "merchant-week-menu-load-error": "Veckomenyn kunde inte laddas. Försök igen.",
        "merchant-week-menu-legend-empty": "Tom",
        "merchant-week-menu-legend-filled": "Ifylld (komplett)",
        "merchant-week-menu-legend-needs-fill": "Påbörjad, obligatoriskt fält saknas",
        "merchant-week-menu-legend-default": "Mallens standard — kan redigeras, ännu inte redigerad",
        "merchant-week-menu-legend-ai-mode": "AI-läge",
        "merchant-week-menu-cell-description-field-optional": "\n .placeholder = Lägg till beskrivning (valfritt)…",
        "merchant-week-menu-cell-add-allergen-label-optional": "Allergen (valfritt)",
        "merchant-week-menu-copy-dish-dialog-sub": "Kopierar den här rätten till samma rad på de dagar du väljer.",
        "merchant-week-menu-copy-dish-select-all": "Välj alla",
        "merchant-week-menu-theme-dish-remove-button": "\n .aria-label = Ta bort temarätten",
        "merchant-week-menu-copy-dish-clear": "Rensa",
        "merchant-week-menu-copy-dish-source-suffix": "(källa)",
        "merchant-week-menu-copy-dish-warning": "Vissa av de valda dagarna har redan en rätt. De hoppas över om du inte slår på överskrivning.",
        "merchant-week-menu-copy-dish-snackbar": "Rätten har kopierats till { $count } dagar.",
        "merchant-week-menu-copy-dish-skipped-snackbar": "Rätten har kopierats till { $count } dagar · { $skipped } hoppades över (redan ifylld).",
        "merchant-week-menu-copy-week-source-subtitle": "Hela veckans meny · { $period }",
        "merchant-week-menu-copy-week-next-prefix": "Nästa vecka ({ $label })",
        "merchant-week-menu-copy-week-snackbar": "Veckomenyn har kopierats till { $week }.",
        "merchant-week-menu-swap-snackbar": "Bytte plats på { $dish } mellan { $dayA } och { $dayB }.",
        "merchant-week-menu-theme-created-snackbar": "Temadag skapad: { $name }.",
        "merchant-week-menu-theme-reverted-snackbar": "Dagen har bytts tillbaka till mallen.",
        "merchant-week-menu-day-closed-snackbar": "{ $day } har markerats som stängd.",
        "merchant-week-menu-day-reopened-snackbar": "{ $day } har öppnats igen.",
        "merchant-week-menu-publish-count-snackbar": "{ $count } dagar har publicerats för kunder.",
        "merchant-week-menu-publish-none-snackbar": "Inga dagar är aktiverade för publicering.",
        "merchant-week-menu-ai-ready-snackbar": "AI-menyn är klar — granska och behåll.",
        "merchant-week-menu-ai-regenerated-snackbar": "Rätten har genererats igen.",
        "merchant-week-menu-ai-reverted-snackbar": "Menyn har återställts till föregående version.",
        "merchant-week-menu-ai-no-open-days-snackbar": "Inga öppna dagar att generera för den här veckan.",
        "merchant-week-menu-ai-banner-working-title": "Genererar meny…",
        "merchant-week-menu-ai-banner-working-subtitle": "Skapar rätter för { $template }",
        "merchant-week-menu-theme-dialog-create-button": "Spara",
        "merchant-week-menu-theme-dialog-warning": "{ $day } har { $count } ifyllda fält från mallen. Om du byter till en temadag kasseras de.",
        "merchant-week-menu-theme-panel-edit-tooltip": "\n .title = Redigera temats namn",
        "merchant-week-menu-theme-panel-revert-tooltip": "\n .title = Byt tillbaka till mallen",
        "merchant-week-menu-recent-dishes-matching-title": "Tidigare menyer · matchar \"{ $query }\"",
        "merchant-week-menu-recent-dishes-meta": "Den här veckan",
        "merchant-week-menu-recent-dish-price": "· { $price } DKK",
        "merchant-week-menu-details-title-label": "Titel",
        "merchant-week-menu-details-description-label": "Beskrivning",
        "merchant-week-menu-details-price-label": "Pris",
        "merchant-week-menu-details-allergens-label": "Allergener",
        "merchant-week-menu-details-marketing-label": "Marknadsföringstagg",
        "merchant-week-menu-details-image-label": "Bild",
        "merchant-week-menu-details-accordion-title": "Näring och miljö",
        "merchant-week-menu-details-co2-unit": "kg CO₂-ekv.",
        "merchant-week-menu-ai-theme-asian": "Asiatisk",
        "merchant-week-menu-ai-theme-mediterranean": "Medelhavet",
        "merchant-week-menu-ai-theme-nordic": "Nordisk",
        "merchant-week-menu-ai-theme-italian": "Italiensk",
        "merchant-week-menu-ai-theme-mexican": "Mexikansk",
        "merchant-week-menu-ai-theme-indian": "Indisk",
        "merchant-week-menu-ai-theme-middle-eastern": "Mellanöstern",
        "merchant-week-menu-ai-spice-label": "Styrka",
        "merchant-week-menu-ai-spice-low": "Mild",
        "merchant-week-menu-ai-spice-medium": "Medel",
        "merchant-week-menu-ai-spice-spicy": "Stark",
        "merchant-week-menu-ai-health-label": "Nyttighet",
        "merchant-week-menu-ai-health-healthy": "Hälsosam",
        "merchant-week-menu-ai-health-balanced": "Balanserad",
        "merchant-week-menu-ai-health-comfort": "Husmanskost",
        "merchant-week-menu-ai-style-label": "Stil",
        "merchant-week-menu-ai-style-normal": "Normal",
        "merchant-week-menu-ai-style-gourmet": "Gourmet",
        "merchant-week-menu-ai-style-fun": "Lekfull",
        "merchant-week-menu-ai-style-party": "Fest",
        "merchant-week-menu-ai-style-celebration": "Firande",
        "merchant-week-menu-ai-ingredients-label": "Ingredienser som ska ingå",
        "merchant-week-menu-ai-ingredients-input": "\n .placeholder = Skriv och tryck på Enter…",
        "merchant-week-menu-ai-mode-all": "Alla dagar lika",
        "merchant-week-menu-ai-mode-per-day": "Anpassa varje dag",
        "merchant-week-menu-marketing-popover-title": "Föreslagna taggar",
        "merchant-week-menu-marketing-add-custom-tag": "Lägg till egen tagg",
        "merchant-week-menu-overflow-button": "\n .aria-label = Fler åtgärder",
        "merchant-week-menu-overflow-manage-templates-item": "Hantera mallar",
        "merchant-week-menu-overflow-customer-preview-item": "Förhandsvisning för kunder",
        "merchant-week-menu-overflow-copy-week-item": "Kopiera vecka",
        "merchant-week-menu-overflow-clear-week-item": "Rensa vecka",
        "merchant-week-menu-overflow-export-pdf-item": "Exportera till PDF",
        "merchant-week-menu-overflow-print-item": "Skriv ut köksblad",
        "merchant-week-menu-customer-view-button": "Kundvy",
        "merchant-week-menu-feature-not-ready-snackbar": "Inte tillgänglig än",
        "merchant-week-menu-autosaved-just-now": "Sparades automatiskt nyss",
        "merchant-week-menu-autosaved-minutes": "Sparades automatiskt · för { $minutes } min sedan",
        "merchant-week-menu-row-ready-label": "{ $filled }/{ $total } klara",
        "merchant-week-menu-row-template-default-chip": "Mallens standard",
        "merchant-menu-planning-table-startDate-date-picker": "\n .label = Startdatum",
        "merchant-menu-planning-table-endDate-date-picker": "\n .label = Slutdatum",
        "merchant-menu-planning-table-week-select": "\n .label = Vecka",
        "merchant-menu-planning-table-week-select-option": "Vecka { $countOfWeek } ({ $startDate } - { $endDate })",
        "merchant-menu-planning-table-date-column": "Datum",
        "merchant-menu-planning-table-dish": "Rätt { $counter }:",
        "merchant-menu-planning-table-price": "Pris: { $price }",
        "merchant-menu-planning-table-allergens": "Allergener: { $allergens }",
        "merchant-menu-planning-table-type-mode-digital-signage": "Digital skyltning",
        "merchant-menu-planning-table-type-mode-web-menu": "Webbmeny",
        "merchant-menu-planning-table-type-recurring": "Återkommande",
        "merchant-menu-planning-table-status-column": "Status",
        "merchant-menu-planning-table-active-column-active": "Aktiv",
        "merchant-menu-planning-table-active-column-inactive": "Inaktiv",
        "merchant-menu-planning-table-active-column-active-filter-yes": "Aktiv",
        "merchant-menu-planning-table-active-column-inactive-filter-no": "Inaktiv",
        "merchant-menu-planning-table-dishes-count": "Antal rätter",
        "merchant-menu-planning-table-recurrence": "Upprepning",
        "merchant-menu-planning-table-create-button": "Skapa ny",
        "merchant-menu-planning-table-week-menu-rss-button": "Veckomeny som RSS",
        "merchant-menu-planning-table-week-menu-atom-button": "Veckomeny som Atom",
        "merchant-menu-planning-table-week-menu-page-button": "Veckomeny som webbsida",
        "public-canteen-week-menu-title": "Kantinmeny",
        "public-canteen-week-menu-week-label": "Vecka { $weekNumber }",
        "public-canteen-week-menu-allergens-label": "Allergener:",
        "public-canteen-week-menu-empty": "Tyvärr har inga menyer skapats den här veckan.",
        "public-canteen-week-menu-load-error": "Vi kunde inte ladda menyn på grund av ett fel.\n    Kontakta supporten för hjälp.",
        "public-menu-display-status-offline": "Ingen internetanslutning",
        "public-menu-display-status-server-down": "Kunde inte ansluta till servern",
        "public-menu-display-status-refresh-failed": "Menyn kunde inte uppdateras",
        "public-menu-display-header-title": "Dagens meny",
        "public-menu-display-empty-message": "Ingen meny har publicerats idag",
        "public-menu-display-unavailable-message": "Menyn kunde inte hämtas",
        "public-menu-display-pagination-label": "{$current} av {$total} menyer",
        "public-menu-display-allergens-contains-label": "Innehåller",
        "public-menu-display-scan-qr-text": "Skanna för veckomeny",
        "merchant-menu-planning-table-menu-item-edit": "Redigera",
        "merchant-menu-planning-table-menu-item-set-inactive": "Inaktivera",
        "merchant-menu-planning-table-menu-item-set-active": "Aktivera",
        "merchant-menu-planning-table-menu-item-delete": "Ta bort",
        "merchant-menu-planning-confirm-delete-shop-dialog": "\n .typeOfEntity = meny",
        "merchant-menu-planning-dialog-create-title": "Skapa meny",
        "merchant-menu-planning-dialog-edit-title": "Redigera meny",
        "merchant-menu-planning-dialog-max-dishes": "Tillgängliga rättsskyltar: { $countOfDishes }",
        "merchant-menu-planning-dialog-add-marketing-details-button": "\n .title = + Lägg till marknadsföringsdetaljer",
        "merchant-menu-planning-dialog-add-dish-button": "Lägg till rätt",
        "merchant-menu-planning-dialog-add-recurrence-button": "\n .title = + Lägg till upprepning",
        "merchant-menu-planning-dialog-remove-recurrence-button": "\n .title = Ta bort upprepning",
        "merchant-menu-planning-dialog-create-submit-button": "Skapa",
        "merchant-menu-planning-dialog-save-submit-button": "Spara",
        "merchant-menu-planning-dialog-dish": "Rätt { $countOfDish }",
        "merchant-menu-planning-dialog-publishDate-date-picker": "\n .label = Publiceringsdatum",
        "merchant-menu-planning-dialog-recurrence": "Upprepning",
        "merchant-menu-planning-dialog-name-of-dish-field": "\n .label = Rättens namn",
        "merchant-menu-planning-dialog-brief-field": "\n .label = Kort beskrivning \n .placeholder = Kort beskrivning, max 80 tecken inklusive mellanslag.",
        "merchant-menu-planning-dialog-marketing-tag-field": "\n .label = Marknadsföringstagg \n .helperText = Exempel: Dagens erbjudande, Rabatt",
        "merchant-menu-planning-dialog-from-date-picker": "\n .label = Från datum",
        "merchant-menu-planning-dialog-to-date-picker": "\n .label = Till datum",
        "merchant-menu-planning-dialog-currency-field": "\n .label = Valuta",
        "merchant-menu-planning-dialog-price-field": "\n .label = Pris",
        "merchant-menu-planning-dialog-upload-image": "\n .label = Ladda upp bild",
        "merchant-menu-planning-week-day-monday": "Måndag",
        "merchant-menu-planning-week-day-tuesday": "Tisdag",
        "merchant-menu-planning-week-day-wednesday": "Onsdag",
        "merchant-menu-planning-week-day-thursday": "Torsdag",
        "merchant-menu-planning-week-day-friday": "Fredag",
        "merchant-menu-planning-week-day-saturday": "Lördag",
        "merchant-menu-planning-week-day-sunday": "Söndag",
        "merchant-menu-planning-dialog-signageTypes-label": "Publicera till:",
        "merchant-menu-planning-dialog-signageTypes-mode-web-menu": "Webbmeny",
        "merchant-menu-planning-dialog-signageTypes-mode-buffet-sign": "Buffétskylt",
        "merchant-menu-planning-dialog-signageTypes-mode-day-menu-sign": "Dagens meny-skylt",
        "merchant-menu-planning-dialog-signageTypes-min-error": "Välj minst en skylttyp",
        "merchant-menu-planning-digital-signage-card-serial-no": "Serienr.:",
        "merchant-menu-planning-digital-signage-card-device-id": "Enhets-ID:",
        "merchant-menu-planning-digital-signage-card-device-name": "Enhetsnamn:",
        "merchant-menu-planning-digital-signage-card-last-update": "Senast uppdaterad:",
        "merchant-menu-planning-digital-signage-card-battery-status": "Batteristatus:",
        "merchant-menu-planning-digital-signage-card-battery-status-0": "Odefinierad",
        "merchant-menu-planning-digital-signage-card-battery-status-1": "Okänd",
        "merchant-menu-planning-digital-signage-card-battery-status-2": "Bra",
        "merchant-menu-planning-digital-signage-card-battery-status-3": "Dålig",
        "merchant-menu-planning-digital-signage-card-battery-status-4": "Dålig kylare",
        "merchant-menu-planning-digital-signage-card-battery-status-5": "Byt ut",
        "merchant-menu-planning-digital-signage-card-battery-status-6": "Byt ut kylare",
        "merchant-menu-planning-digital-signage-card-status-code": "Statuskod:",
        "merchant-menu-planning-digital-signage-card-status-code--99": "Okänd",
        "merchant-menu-planning-digital-signage-card-status-code--10": "Rengöring misslyckades",
        "merchant-menu-planning-digital-signage-card-status-code--2": "Systemkonfiguration misslyckades",
        "merchant-menu-planning-digital-signage-card-status-code--1": "Nätverkskonfiguration misslyckades",
        "merchant-menu-planning-digital-signage-card-status-code-0": "Inte konfigurerad",
        "merchant-menu-planning-digital-signage-card-status-code-1": "Nätverk konfigurerat",
        "merchant-menu-planning-digital-signage-card-status-code-2": "Kommunikation misslyckades",
        "merchant-menu-planning-digital-signage-card-status-code-3": "Lågt batteri",
        "merchant-menu-planning-digital-signage-card-status-code-4": "Aktuell siddesign hittades inte",
        "merchant-menu-planning-digital-signage-card-status-code-5": "Aktuell sidprodukt hittades inte",
        "merchant-menu-planning-digital-signage-card-status-code-6": "Uppdatering av aktuell sida misslyckades",
        "merchant-menu-planning-digital-signage-card-status-code-7": "Alternativ siddesign hittades inte",
        "merchant-menu-planning-digital-signage-card-status-code-8": "Alternativ sidprodukt hittades inte",
        "merchant-menu-planning-digital-signage-card-status-code-9": "Uppdatering av alternativ sida misslyckades",
        "merchant-menu-planning-digital-signage-card-status-code-10": "Ok",
        "merchant-menu-planning-digital-signage-card-status-code-11": "Hälsokontroll misslyckades",
        "merchant-menu-planning-digital-signage-card-status-code-12": "Låg temperatur",
        "merchant-menu-planning-digital-signage-card-status-code-20": "Bild överskriven",
        "merchant-menu-planning-digital-signage-card-status-code-50": "Förkonfigurerad",
        "merchant-menu-planning-digital-signage-card-status-code-99": "I kö",
        "merchant-menu-planning-digital-signage-empty": "Inga enheter för digital skyltning hittades",
        "merchant-menu-planning-digital-signage-dialog-title": "Digital skylt",
        "merchant-menu-planning-digital-signage-menu-details": "Detaljer",
        "merchant-menu-planning-digital-signage-menu-clear-sign": "Rensa skylt",
        "merchant-menu-planning-color-field-label": "\n .label = Färg",

        // --- Merchant ---

        // Navigation
        "merchant-nav-item-home": "Hem",

        //  - reporting
        "merchant-nav-item-production": "\n .title = Produktion",
        "merchant-nav-item-menu-planning": "Menyplanering",
        "merchant-nav-item-group-menu-planning": "\n .title = Menyplanering",
        "merchant-nav-item-menu-planning-header": "Menyplanering",
        "merchant-nav-item-menu-planning-v2": "Menyplanering v2",
        "merchant-nav-item-group-id-cards": "\n .title = ID-kort",
        "merchant-nav-item-id-cards-header": "ID-kort",
        "merchant-admin-menu-planning-header": "\n .title = Menyplanering",
        "merchant-nav-item-purchase-control": "Köpkontroll",
        "merchant-nav-item-survey": "Användarnöjdhet",
        "merchant-nav-item-accounting": "Redovisning",
        "merchant-nav-item-accounting-page-header": "\n .title = Redovisning",
        "merchant-nav-item-production-planning": "Planering",
        "merchant-nav-item-production-meeting-service": "Mötesförtäring",
        "merchant-nav-item-production-meeting-service-view": "Produktionsvy",
        "merchant-nav-item-production-takeaway": "Takeaway",
        "merchant-nav-item-production-pos-purchases": "POS-köp",

        //  - admin
        "merchant-nav-item-settings-page-header": "\n .title = Inställningar",
        "merchant-nav-item-settings-header": "Inställningar",
        "merchant-nav-item-customer-access": "Kundåtkomst",
        "merchant-nav-item-id-cards": "ID-kort",
        "merchant-nav-item-custom-jobs":"Anpassade jobb",
        "merchant-nav-item-merchant-news": "Kundnyheter",
        "merchant-nav-item-messaging": "Push-meddelanden",
        "merchant-nav-item-news": "Kundnyheter",
        "merchant-nav-item-info-displays": "Integrationsflöden",
        "merchant-info-displays-header": "\n .title = Integrationsflöden",
        "merchant-info-displays-page-subtitle":
            "Skärmar publicerade från Facilitynet. Förhandsgranska en skärm, dela den som länk eller inbäddning, eller återställ dess länk för att ta bort åtkomsten.",
        "merchant-info-displays-filter-all": "Alla skärmar",
        "merchant-info-displays-filter-menu": "Meny",
        "merchant-info-displays-filter-production": "Produktion",
        "merchant-info-displays-count-label": "{ $count } skärmar",
        "merchant-info-displays-card-thumbnail-label": "förhandsvisning av skärm",
        "merchant-info-displays-card-status-live": "\n .label = Live",
        "merchant-info-displays-card-status-inactive": "\n .label = Inaktiv",
        "merchant-info-displays-card-menu-simple-name": "Veckomeny — Enkel (iFrame)",
        "merchant-info-displays-card-menu-simple-description": "Används för att visa menyn på webbplats / intranät.",
        "merchant-info-displays-card-menu-layout-name": "Dagens meny — Layout 1",
        "merchant-info-displays-card-menu-layout-description": "Används för visning på skärm i kantinen.",
        "merchant-info-displays-card-production-name": "Produktionsskärm",
        "merchant-info-displays-card-production-description":
            "Används för visning på skärm i produktionsområdena för att hantera kommande beställningar.",
        "merchant-info-displays-menu-preview-item": "Förhandsgranskning",
        "merchant-info-displays-menu-link-item": "Permalänk / inbäddning",
        "merchant-info-displays-menu-permalink-item": "Permalänk",
        "merchant-info-displays-menu-reset-item": "Återställ",
        "merchant-info-displays-menu-inactivate-item": "Inaktivera",
        "merchant-info-displays-menu-activate-item": "Aktivera",
        "merchant-info-displays-link-dialog-embed": "\n .dialogTitle = Permalänk / inbäddning\n .subtitle = { $name } — alla med den här länken kan se skärmen.",
        "merchant-info-displays-link-dialog-permalink": "\n .dialogTitle = Permalänk\n .subtitle = { $name } — alla med den här länken kan se skärmen.",
        "merchant-info-displays-link-dialog-permalink-login-required": "\n .dialogTitle = Permalänk\n .subtitle = { $name } — kräver inloggning i Facilitynet; öppnar skärmen i helskärm.",
        "merchant-info-displays-link-dialog-permalink-label": "Permalänk",
        "merchant-info-displays-link-dialog-embed-label": "Inbäddningskod",
        "merchant-info-displays-copy-tooltip": "\n .title = Kopiera",
        "merchant-info-displays-link-dialog-reset-button": "Återställ länk",
        "merchant-info-displays-link-dialog-done-button": "Klar",
        "merchant-info-displays-copy-success": "Kopierat till urklipp",
        "merchant-info-displays-reset-dialog":
            "\n .title = Återställa länk?\n .message = En ny länk skapas för { $name }. Den nuvarande länken och alla inbäddningar som använder den slutar fungera omedelbart.\n .buttonLabelSubmit = Återställ länk",
        "merchant-nav-item-users": "Administratörer",
        "merchant-nav-item-shops": "Butiker",
        "merchant-nav-item-payment-links": "Betalningslänkar",
        "merchant-nav-item-products": "Produkter",
        "merchant-nav-item-product-create": "Skapa produkt",
        "merchant-nav-item-extra-service-create": "Skapa extratjänst",
        "merchant-nav-item-extra-service-edit": "Redigera extratjänst",
        "merchant-nav-item-product-update": "Redigera produkt",
        "merchant-nav-item-product-groups": "Produktgrupper",
        "merchant-nav-item-extra-services": "Extratjänster",
        "merchant-nav-item-product-group-create": "Skapa produktgrupp",
        "merchant-nav-item-product-group-update": "Redigera produktgrupp",
        "merchant-nav-item-price-lists": "Prislistor",
        "merchant-nav-item-price-list-create": "Skapa prislista",
        "merchant-nav-item-price-list-edit": "Redigera prislista",
        "merchant-nav-item-surveys": "Användarundersökningar",
        "merchant-nav-item-devices": "Hårdvaruenheter",
        "merchant-nav-item-communication-page-header":"\n .title = Kommunikation",
        "merchant-nav-item-communication-header":"Kommunikation",
        "merchant-nav-item-group-products":"\n .title = Produkter",
        "merchant-nav-item-products-header":"Produkter",
        "merchant-nav-item-group-shops":"\n .title = Butiker",
        "merchant-nav-item-offers":"Erbjudanden",
        "merchant-nav-item-vat-codes":"Momskoder",
        "merchant-nav-item-create-vat-code":"Skapa momskod",
        "merchant-nav-item-edit-vat-code":"Redigera momskod",
        "merchant-nav-item-group-organization":"\n .title = Organisation",
        "merchant-nav-item-group-account":"\n .title = Konto",
        "merchant-nav-item-billing":"Fakturor",
        "merchant-nav-item-account":"Konto",
        "merchant-nav-item-merchant-account":"Företagskonto",
        "merchant-nav-item-delivery-locations": "Leveransplatser",
        "merchant-nav-item-sales-accounts": "Försäljningskonton",
        "merchant-nav-item-live-dashboard": "Live dashboard",

        // Admin home
        "merchant-admin-home-products-group": "\n .title = Produkter",
        "merchant-admin-home-communication-group": "\n .title = Kommunikation",
        "merchant-admin-home-customers-group": "\n .title = Kunder",
        "merchant-admin-home-settings-group": "\n .title = Inställningar",
        "merchant-admin-home-customers-card": "\n .title = Kundåtkomst\n .description = Hantera kundernas åtkomst till ditt försäljningsställe.",
        "merchant-admin-home-merchant-news-card": "\n .title = Kundnyheter\n .description = Publicera nyheter för försäljningsstället till dina kunder.",
        "merchant-admin-home-admin-card": "\n .title = Administratörer\n .description = Hantera administratörer för ditt försäljningsställe.",
        "merchant-admin-home-shop": "\n .title = Butiker\n .description = Sälj dina produkter i butiker med individuell profilering.",
        "merchant-admin-home-payment-links": "\n .title = Betalningslänkar \n .description = Skapa en unik betalningslänk för gäster eller kursdeltagare.",
        "merchant-admin-home-products": "\n .title = Produkter\n .description = Lägg till och underhåll produkter för dina butiker.",
        "merchant-admin-home-product-groups": "\n .title = Produktgrupper\n .description = Dela in dina produkter i grupper och styr gruppernas synlighet under dagen.",
        "merchant-admin-home-price-list": "\n .title = Prislistor\n .description = Använd prislistor för att erbjuda differentierade produkter och priser till dina kunder.",
        "merchant-admin-home-extra-services": "\n .title = Extratjänster\n .description = Lägg till och underhåll extratjänster för dina butiker.",
        "merchant-admin-home-merchant-surveys": "\n .title = Användarundersökningar\n .description = Håll koll på kundnöjdheten genom att skapa användarundersökningar.",
        "merchant-admin-home-push-messages-card": "\n .title = Push-meddelanden\n .description = Skicka och hantera push-meddelanden till dina kunder",
        "merchant-admin-home-info-displays-card":
            "\n .title = Integrationsflöden\n .description = Förhandsgranska och dela dina integrationsflöden.",
        "merchant-admin-home-devices-card": "\n .title = Hårdvaruenheter\n .description = Visa hårdvaruenheter, som skärmar, skrivare och kortterminaler.",
        "merchant-admin-home-offers-card": "\n .title = Erbjudanden\n .description = Hantera dina erbjudanden",
        "merchant-admin-home-vat-codes-card": "\n .title = Momskoder\n .description = Hantera momskoder",
        "merchant-admin-home-id-cards-card": "\n .title = ID-kort\n .description = Visa dina kunders ID-kort som används för POS-betalning.",
        "merchant-admin-home-id-cards-group": "\n .title = ID-kort",
        "merchant-admin-home-menu-planning-card": "\n .title = Menyplanering\n .description = Skapa och hantera menymallar.",
        "merchant-admin-home-custom-jobs-card": "\n .title = Anpassade jobb\n .description = Visa och kör anpassade jobb för ditt försäljningsställe.",
        "merchant-admin-home-account-group": "\n .title = Konto",
        "merchant-admin-home-merchant-account-card": "\n .title = Företagskonto\n .description = Uppdatera företagets grunduppgifter\n .buttonText = Visa",
        "merchant-admin-home-delivery-locations-card": "\n .title = Leveransplatser\n .description = Hantera leveransplatser där kunder kan hämta beställningar.",

        // Merchant > Admin > Settings > Custom jobs
        "merchant-admin-settings-custom-jobs-title":" \n .title = Anpassade jobb",
        "merchant-admin-settings-custom-jobs-table-name":"Namn",
        "merchant-admin-settings-custom-jobs-table-interval":"Intervall",
        "merchant-admin-settings-custom-jobs-table-last-run":"Senaste körning",
        "merchant-admin-settings-custom-jobs-table-status":"Status",
        "merchant-admin-settings-custom-jobs-table-action-details":"Detaljer",
        "merchant-admin-settings-custom-jobs-table-action-run-job":"Kör jobb",
        "merchant-admin-settings-custom-jobs-table-action-activate":"Aktivera",
        "merchant-admin-settings-custom-jobs-table-action-inactivate":"Inaktivera",

        // Messages
        "messages-list-header": "\n .title = Push-meddelanden",
        "messages-list-create-button": "Skapa nytt",
        "merchant-nav-item-messages": "Push-meddelanden",
        "messages-table-subject-column" : "Ämne",
        "messages-table-publish-time-column": "Publiceringsdatum",
        "messages-table-expire-time-column": "Utgångsdatum",
        "messages-table-publish-type-filter-label": "Publiceringstyp",
        "messages-table-publish-type-filter-label-label": "\n .label = Publiceringstyp",
        "messages-table-publish-type-filter-item-published": "Publicerad",
        "messages-table-publish-type-filter-item-upcoming": "Kommande",
        "messages-table-publish-type-filter-item-expired": "Utgången",
        "messages-table-edit-button": "Redigera",
        "messages-table-delete-button": "Ta bort",
        "messages-table-delete-modal-title": "meddelande",
        "messages-table-delete-success-message": "Meddelandet har tagits bort",
        "messages-table-update-delete-dialog-title": "Det här meddelandet kan inte uppdateras eller tas bort",
        "messages-table-update-delete-dialog-description": "Meddelandet kan inte uppdateras eller tas bort eftersom det har publicerats.",
        "messages-table-update-delete-dialog-button": "Stäng",

        // create / edit messages
        "create-message-header": "\n .title = Skapa meddelande",
        "edit-message-header": "\n .title = Redigera meddelande",
        "nav-item-create-message-header": "Skapa meddelande",
        "nav-item-edit-message-header": "Redigera meddelande",
        "create-message-save-button": "Skapa",
        "edit-message-save-button": "Spara",
        "create-or-edit-message-info": "\n .title = Skicka korta, viktiga meddelanden till användarna, t.ex. om stängda dagar, evenemang eller liknande. Meddelanden är synliga för alla användare som är kopplade till dina butiker.",
        "create-or-edit-message-field-subject":
            "\n .label = Rubrik \n .placeholder = Lägg till en fängslande rubrik som användarna vill läsa * \n .helperText = Lägg till en fängslande rubrik som användarna vill läsa",
        "create-or-edit-message-dialog-field-subject-label": "Rubrik:",
        "create-or-edit-message-field-title-page": "\n .label = Rubrik\n .placeholder = Rubrik\n .helperText = Lägg till en fängslande rubrik som användarna vill läsa",
        "create-or-edit-message-dialog-field-message-label": "Meddelande:",
        "create-or-edit-message-field-message": "\n .label = Meddelande\n .placeholder = Skriv ett meddelande *\n .helperText = Återstående tecken: { $charsRemaining }",
        "create-or-edit-message-settings": "\n .title = Inställningar",
        "create-or-edit-message-field-publishDate": "\n .label = Publicering:",
        "create-or-edit-message-field-publish-title": "Publicering:",
        "create-or-edit-message-accordion-title": "Inställningar",
        "create-or-edit-message-field-publishDate-page": "\n .label = Publicering",
        "create-or-edit-message-field-publishDate-helperText": "Bestämmer när meddelandet blir synligt för användarna.",
        "create-or-edit-message-field-expirationDate-info": "\n .title = Utgångstiden gäller endast för meddelanden på informationsskärmar och mötesrumsskärmar.",
        "create-or-edit-message-field-expirationDate-title": "Utgång:",
        "create-or-edit-message-field-expirationDate": "\n .label = Utgång:",
        "create-or-edit-message-field-expirationDate-page": "\n .label = Utgång",
        "create-or-edit-message-field-title-required": "Rubrik är obligatorisk",
        "create-or-edit-message-field-body-required": "Meddelande är obligatoriskt",
        "create-or-edit-message-field-body-too-long": "Du har överskridit max antal tecken: { $charsLimit }",
        "create-or-edit-message-field-channels-required": "Välj minst en kanal",
        "create-or-edit-message-field-channel-type-mode-in-app": "Appmeddelande",
        "create-or-edit-message-field-channel-type-description-mode-in-app": "Skickas som meddelande på webben och i appen",
        "create-or-edit-message-field-channel-type-mode-push": "Push-notis",
        "create-or-edit-message-field-channel-type-description-mode-push": "Skicka som mobil push-notis",
        "create-or-edit-message-field-channel-type-mode-sms": "SMS-meddelande",
        "create-or-edit-message-field-channel-type-description-mode-sms": "Skicka som SMS",
        "create-or-edit-message-field-channel-type-mode-email": "E-post",
        "create-or-edit-message-field-channel-type-description-mode-email": "Skicka som e-post",
        "create-or-edit-message-field-channel-type-mode-in-app-card": "Appkort",
        "create-or-edit-message-field-channel-type-description-mode-in-app-card": "Visas som kort i GoPay-appen",
        "create-or-edit-message-field-channel-type-mode-info-display": "Infoskärmar",
        "create-or-edit-message-field-channel-type-description-mode-info-display": "Visa på mötesskärmar och infoskärmar",
        "create-or-edit-message-field-channel-type-mode-room-display": "Mötesrumsskärmar",
        "create-or-edit-message-field-channel-type-description-mode-room-display": "Visa på mötesrumsskärmar",
        "create-or-edit-message-field-tag": "\n .label = Ämne: \n .placeholder = Välj ett ämne",
        "create-or-edit-message-dialog-topic-label": "Ämne:",
        "create-or-edit-message-dialog-topic-placeholder": "Välj ett ämne *",
        "create-or-edit-message-field-tag-page": "\n .label = Ämne",
        "create-or-edit-message-field-tag-mode-info": "Info",
        "create-or-edit-message-field-tag-description-mode-info": "För allmän information om kantinen, öppettider, matutbud eller rutiner.",
        "create-or-edit-message-field-tag-mode-important": "Viktigt",
        "create-or-edit-message-field-tag-description-mode-important": "För kritiska meddelanden, till exempel ändrade öppettider, hälso- och säkerhetsinformation eller andra brådskande meddelanden.",
        "create-or-edit-message-field-tag-mode-offer": "Erbjudande",
        "create-or-edit-message-field-tag-description-mode-offer": "För erbjudanden, rabatter, kampanjer eller särskilda arrangemang.",
        "create-or-edit-message-field-tag-mode-menu-change": "Meny",
        "create-or-edit-message-field-tag-description-mode-menu-change": "För att informera användarna om ändringar i dagens meny, nya rätter eller säsongsbetonade erbjudanden.",
        "create-or-edit-message-field-tag-mode-event": "Evenemang",
        "create-or-edit-message-field-tag-description-mode-event": "För kommande evenemang, som temadagar, matfestivaler eller speciella evenemang i kantinen.",
        "create-or-edit-message-field-tag-mode-reminder": "Påminnelse",
        "create-or-edit-message-field-tag-description-mode-reminder": "För att påminna användarna om viktiga datum eller tidsfrister, till exempel anmälan till evenemang eller sista dag för förbeställning av mat.",
        "create-or-edit-message-field-tag-mode-feedback": "Feedback",
        "create-or-edit-message-field-tag-description-mode-feedback": "För att be om feedback på mat och service, eller användarundersökningar om nöjdhet.",
        "create-or-edit-message-field-tag-mode-news": "Nyhet",
        "create-or-edit-message-field-tag-description-mode-news": "För uppdateringar om kantinens aktiviteter, åtgärder eller ändringar i driften som kan vara av intresse för användarna.",
        "create-or-edit-message-field-tag-mode-health": "Hälsa",
        "create-or-edit-message-field-tag-description-mode-health": "För information om hälsosamma val, näringstips eller allergiinformation kopplad till menyn.",
        "create-or-edit-message-field-tag-mode-social": "Gemenskap",
        "create-or-edit-message-field-tag-description-mode-social": "För att främja gemenskapsinitiativ, temadagar och sociala evenemang.",
        "create-or-edit-message-field-tag-required": "Ämne krävs",
        "create-message-success-dialog-title": "Meddelandet har skapats",
        "create-message-success-dialog-view-archive": "Visa meddelandearkiv",
        "create-message-success-dialog-close-button": "Stäng",
        "create-message-success-dialog-view-list-button": "Gå till meddelanden",


        // Customer access
        "merchant-customer-access-header": "\n .title = Kundåtkomst",
        "merchant-customer-access-customers-table-name-column": "Namn",
        "merchant-customer-access-customers-table-active-column": "Status",
        "merchant-customer-access-customers-table-domains-column": "Domäner",
        "merchant-customer-access-customers-table-active-filter-yes": "Aktiva",
        "merchant-customer-access-customers-table-active-filter-no": "Inaktiva",
        "merchant-customer-access-customers-table-active-column-active": "Aktiv",
        "merchant-customer-access-customers-table-active-column-inactive": "Inaktiv",

        // Merchant account > Swift dialog
        "merchant-account-swift-dialog-title":"Byt försäljningsställe",
        "merchant-account-swift-dialog-subtitle":"Du har åtkomst till följande försäljningsställen. Välj ett för att byta.",
        "merchant-account-swift-dialog-empty-title":"Du har inte åtkomst till några andra försäljningsställen.",

        // Merchant home
        "merchant-home-today-card-group": "\n .title = POS-försäljning \n .subtitle = idag",
        "merchant-home-todays-control-code": "\n .title = Dagens kontrollkod",
        "merchant-home-todays-control-code-title": "Dagens kontrollkod",
        "merchant-home-todays-offers": "Dagens erbjudanden\n .title = Dagens erbjudanden",
        "merchant-product-tour-step-welcome": "Välkommen till Facilitynet. Det här är en kort introduktion till hur du använder den.",
        "merchant-product-tour-step-order-notifications-button": "Klicka här för att öppna en översikt över dagens beställningar och aktiviteter.",
        "merchant-product-tour-step-order-notifications": "Här kan du få en översikt över dagens beställningar och aktiviteter som kräver din uppmärksamhet.",
        "merchant-product-tour-step-new-button": "Klicka här för att öppna genvägar för att skapa meddelanden och beställningar.",
        "merchant-product-tour-step-new": "Klicka på knappen Ny för att skapa pushmeddelanden, beställa mötesförtäring för användares räkning och få enkel åtkomst till genvägar.",
        "merchant-product-tour-step-environment-button": "Klicka här för att öppna menyn för att växla mellan miljöer.",
        "merchant-product-tour-step-environment": "Portalen är uppdelad i 3 miljöer som var och en fokuserar på ett visst ämne. Du byter miljö här.",
        "merchant-product-tour-step-nav-production": "I Produktion kan du planera och hantera beställningar.",
        "merchant-product-tour-step-nav-menu-planning": "I Menyplanering kan du skapa veckomenyer för att hålla kantinanvändarna informerade.",
        "merchant-product-tour-step-nav-purchase-control": "Använd Köpkontroll för att säkerställa att alla betalar för sin mat.",
        "merchant-product-tour-step-nav-survey": "Se resultatet av användarfeedback och håll koll på användarnöjdheten.",
        "merchant-product-tour-locale-back": "Tillbaka",
        "merchant-product-tour-locale-next": "Nästa",
        "merchant-product-tour-locale-last": "Klar",
        "merchant-product-tour-locale-skip": "Hoppa över",
        "merchant-product-tour-locale-close": "Stäng",
        "takeaway-announcement-tour-step-intro": "Vi har lanserat en egen sida för takeaway.",
        "takeaway-announcement-tour-step-nav-takeaway": "Från och med nu hittar du takeaway-beställningar här.",
        "merchant-home-number-of-orders": "\n .title = Ordrar \n .titleTooltip = Antal POS-ordrar idag",
        "merchant-home-turnover": "\n .title = Omsättning \n .titleTooltip = Dagens totalbelopp för POS-försäljning",
        "merchant-home-avg-amount": "\n .title = Snittbelopp \n .titleTooltip = Genomsnittligt ordervärde för dagens ordrar\n .subtitle = DKK",
        "merchant-home-subscriptions": "\n .title = Abonnemang \n .titleTooltip = Dagens aktiva lunchabonnemang",
        "merchant-home-takeaway-card-group": "\n .title = Takeaway \n .subtitle = idag",
        "merchant-home-takeaway-number-of-orders": "\n .title = Ordrar \n .titleTooltip = Antal takeaway-ordrar idag",
        "merchant-home-takeaway-turnover": "\n .title = Omsättning \n .titleTooltip = Dagens totalbelopp för takeaway-försäljning",
        "merchant-home-takeaway-avg-amount": "\n .title = Snittbelopp \n .titleTooltip = Genomsnittligt ordervärde för dagens takeaway-ordrar\n .subtitle = DKK",
        "merchant-home-statistics-card-group": "\n .title = Statistik",
        "merchant-home-checkin-card": "\n .title = Incheckningsskärm\n .titleTooltip = Visar hur många kunder som kommer ihåg att skanna sitt köpbevis på incheckningsskärmen jämfört med hur många som glömmer det",
        "merchant-home-checkin-card-participants": "Incheckade ({ $checkedIn })",
        "merchant-home-checkin-card-none-participants": "Inte incheckade ({ $notCheckedIn })",
        "merchant-home-checkin-card-participation-percentage": "Procent",
        "merchant-home-survey-card-empty": "\n .title = Nöjdhet",
        "merchant-home-meeting-service-card-group": "\n .title = Mötesförtäring\n .subtitle = Idag",
        "merchant-home-meeting-service-number-of-orders-card": "\n .title = Ordrar\n .titleTooltip = Antal mötesförtäringsordrar idag",
        "merchant-home-meeting-service-awaiting-approval-card": "\n .title = Väntar på godkännande\n .titleTooltip = Totalt antal mötesförtäringsordrar som väntar på godkännande",
        "merchant-home-meeting-service-ready-for-invoicing-card": "\n .title = Redo för fakturering\n .titleTooltip = Totalt antal mötesförtäringsordrar som väntar på att bokföras",
        "merchant-home-meeting-service-ready-for-invoicing-card-description": "&gt; {$overdueDays} dagar sedan",
        "merchant-home-meeting-service-delivery-planning-card": "\n .title = Leveransplanering\n .titleTooltip = Visar fördelningen av mötesförtäringsordrar under dagen",
        "merchant-home-meeting-service-delivery-planning-delivery": "Leverans",
        "merchant-home-meeting-service-delivery-planning-picked-up": "Avhämtas",
        "merchant-home-meeting-service-delivery-planning-eating-in-canteen": "Äter i kantinen",
        "merchant-home-meeting-service-next-deliveries-card": "\n .title = Nästa {$numberOfOrders} leveranser\n .titleTooltip = De nästa 5 leveranserna idag",
        "merchant-home-meeting-service-table-name-column": "Kund",
        "merchant-home-meeting-service-table-meeting-column": "Möte",
        "merchant-home-meeting-service-table-delivery-column": "Leverans",
        "merchant-home-meeting-service-no-upcoming-deliveries": "Det finns inga kommande leveranser.",
        "merchant-home-views-button": "Live Dashboards",
        "merchant-home-views-dialog-title": "Live Dashboards",
        "merchant-home-views-dialog-subtitle": "Välj en dashboard nedan:",
        "merchant-home-views-dialog-conference": "Mässa",
        "merchant-home-views-dialog-conference-live-sales-part-1": "Live",
        "merchant-home-views-dialog-conference-live-sales-part-2": "försäljning",
        "merchant-home-views-dialog-conference-orders": "Ordrar",
        "merchant-home-views-dialog-conference-turnover": "Omsättning",
        "merchant-home-views-dialog-conference-avg-price": "Snittpris",
        "merchant-home-views-dialog-conference-free-riders": "Fripassagerare",
        "merchant-home-views-dialog-conference-satisfaction": "Nöjdhet",
        "merchant-home-statistics-pos-turnover-card": "\n .title = POS-omsättning \n .titleTooltip = Visar POS-försäljning för vald period jämfört med försäljningen för föregående period",
        "merchant-home-statistics-pos-orders-card": "\n .title = POS-ordrar \n .titleTooltip = Visar antal POS-ordrar för vald period jämfört med ordrar för föregående period",
        "merchant-home-statistics-number-of-users-card": "\n .title = Antal användare \n .titleTooltip = Visar antal nya användare för vald period jämfört med nya användare för föregående period",
        "merchant-home-statistics-period-base-3": "Senaste 3 dagarna",
        "merchant-home-statistics-period-base-14": "Senaste 14 dagarna",
        "merchant-home-statistics-period-base-30": "Senaste 30 dagarna",
        "merchant-home-statistics-period-base-60": "Senaste 60 dagarna",
        "merchant-home-statistics-period-base-180": "Senaste 180 dagarna",
        "merchant-home-statistics-compared-to-last-period": "jämfört med föregående period",

        // Merchant home tooltips
        "merchant-home-todays-control-code-tooltip": "\n .title = Koden visas på köpbeviset (appen) och på det utskrivna kvittot",
        "merchant-home-todays-offers-tooltip": "\n .title = Antal erbjudanden som är aktiva idag",

        // Merchant Account
        "merchant-update-account-page-header": "\n .title = Konto för försäljningsställe",
        "merchant-update-account-save-button": "Spara",
        "merchant-update-account-opening-hours-title":"\n .title = Öppettider",
        "merchant-update-account-opening-hours-action-button-add":"Lägg till",
        "merchant-update-account-opening-hours-action-button-edit":"Redigera",
        "merchant-update-account-opening-hours-empty-text":"Öppettider är inte angivna",
        "merchant-update-account-opening-hours-dialog-title":"Öppettider",
        "merchant-update-account-opening-hours-dialog-save-button":"Spara",
        "merchant-update-account-opening-hours-dialog-before-start-error":"Stängningstid före öppningstid",
        "merchant-update-account-opening-hours-dialog-closed-time-select-from":"\n .label = Från",
        "merchant-update-account-opening-hours-dialog-time-select-to":"\n .label = Till",
        "merchant-update-account-opening-hours-dialog-closed":"Stängt",
        "merchant-update-account-opening-hours-day-monday": "Måndag",
        "merchant-update-account-opening-hours-day-tuesday": "Tisdag",
        "merchant-update-account-opening-hours-day-wednesday": "Onsdag",
        "merchant-update-account-opening-hours-day-thursday": "Torsdag",
        "merchant-update-account-opening-hours-day-friday": "Fredag",
        "merchant-update-account-opening-hours-day-saturday": "Lördag",
        "merchant-update-account-opening-hours-day-sunday": "Söndag",



        //Merchant reports
        "merchant-reports-id-cards-title": "\n .title = ID-kort",
        "merchant-reports-id-cards-nav-item-home": "Hem",
        "merchant-reports-id-cards-nav-item-id-cars": "ID-kort",

        // Merchant ID table
        "merchant-id-cards-table-card-number": "Kortnummer",
        "merchant-id-cards-table-card-type": "Korttyp",
        "merchant-id-cards-table-user": "Användare",
        "merchant-id-cards-table-company": "Företag",
        "merchant-id-cards-table-status": "Status",
        "merchant-id-cards-table-card-type-select-label": "\n .label = Korttyp",
        "merchant-id-cards-table-company-select-label": "\n .label = Företag",
        "merchant-id-cards-table-card-type-select-item-wallet":"Wallet",
        "merchant-id-cards-table-card-type-select-item-company-credit":"Företagskredit",
        "merchant-id-cards-table-card-type-select-item-tickets":"Klippkort",
        "merchant-id-cards-table-card-type-select-item-unlimited-tickets":"Obegränsat klippkort",
        "merchant-id-cards-table-card-type-select-item-tickets-unlimited":"Obegränsade klipp",
        "merchant-id-cards-table-card-type-select-item-top-up": "Påfyllning",
        "merchant-id-cards-table-card-type-select-item-payroll-deduction": "Löneavdrag",


        // Merchant ID Cards Dialog
        "merchant-id-cards-dialog-title": "ID-kortsuppgifter",
        "merchant-id-cards-dialog-status": "Status:",
        "merchant-id-cards-dialog-card-name": "Kortnamn:",
        "merchant-id-cards-dialog-card-type": "Korttyp:",
        "merchant-id-cards-dialog-card-type-top-up": "Påfyllning",
        "merchant-id-cards-dialog-card-type-wallet": "Wallet",
        "merchant-id-cards-dialog-card-type-company-credit": "Företagskredit",
        "merchant-id-cards-dialog-card-type-tickets": "Klippkort",
        "merchant-id-cards-dialog-card-type-tickets-unlimited": "Obegränsat klippkort",
        "merchant-id-cards-dialog-card-type-payroll-deduction": "Löneavdrag",
        "merchant-id-cards-dialog-validated": "Validerat:",
        "merchant-id-cards-dialog-expiry": "Utgång:",
        "merchant-id-cards-dialog-payment-method": "Betalningsmetod:",
        "merchant-id-cards-dialog-user-id": "Användar-ID:",
        "merchant-id-cards-dialog-employee-id": "Anställnings-ID:",
        "merchant-id-cards-dialog-name": "Namn:",
        "merchant-id-cards-dialog-email": "E-post:",
        "merchant-id-cards-dialog-mobile": "Mobil:",
        "merchant-id-cards-dialog-phone": "Telefon:",

        "id-cars-table-button-details": "Detaljer",
        "id-cars-filter-card-title":"\n .title = Kort",
        "id-cars-filter-debtor-title":"\n .title = Debitor",
        "id-cars-filter-end-user-title":"\n .title = Slutanvändare",
        "id-cars-filter-card-number-label":"\n .label = Kortnummer\n .placeholder = Sök på kortnummer",
        "id-cars-filter-switch-label":"\n .label = Inkludera inaktiva kort",
        "id-cars-filter-debtor-label":"\n .label = Debitor",
        "id-cars-filter-email-label":"\n .label = E-post",
        "id-cars-filter-employee-id-label":"\n .label = Anställnings-ID",

        "merchant-production": "Produktion",

        // Merchant > Admin > Shops > Products
        "products-page-header": "\n .title = Produkter",
        "products-tab-all-products": "Alla produkter",
        "products-tab-sort-products": "Sortera produkter",
        "products-table-info-box": "Välj en butik för att fortsätta",
        "products-table-show-inactive": "\n .label = Visa inaktiverade",
        "products-move-availability-dialog":
            "\n .title = Begränsa produktens tillgänglighet?\n .message = “{ $productName }” är tillgänglig utanför dagarna eller tiderna för “{ $groupName }”. Efter flytten blir den tillgänglig: { $days }, { $hours }.\n .buttonLabelSubmit = Flytta och begränsa\n .buttonLabelCancel = Avbryt",
        "products-move-availability-dialog-no-overlap-alert":
            "\n .title = Produkten har inga dagar eller tider gemensamma med gruppen, så dess egna dagar och tider ersätts av gruppens.",
        "products-move-availability-dialog-every-day-label": "alla dagar",
        "products-move-availability-dialog-all-day-label": "hela dagen",
        "products-page-table-price-list-label": "\n .label = Prislista",
        "products-no-price-list-tab": "Ingen prislista",
        "products-action-bar-move-to-price-list": "Flytta till prislista",
        "products-action-bar-copy-to-price-list": "Kopiera till prislista",
        "products-action-bar-status": "\n .title = Status",
        "products-action-bar-set-active": "\n .title = Aktiv",
        "products-action-bar-set-inactive": "\n .title = Inaktiv",
        "products-select-price-list-label": "Välj prislista:",
        "products-move-to-price-list-dialog-title": "Flytta till prislista",
        "products-copy-to-price-list-dialog-title": "Kopiera till prislista",
        "products-price-list-dialog-accordion-title": "Produkter ({ $count })",
        "products-name-column": "Namn",
        "products-price-column": "Pris",
        "products-status-column": "Status",
        "products-create-product-button": "Skapa ny",
        "merchant-admin-enable-product-sort-button": "Aktivera produktsortering",
        "merchant-admin-enable-product-sort-info": "\n .title = När du aktiverar produktsortering för första gången sorterar vi produkterna och produktgrupperna i en standardordning. Därifrån kan du flytta runt dem som du vill.",
        "products-edit-product-menu-item": "Redigera",
        "products-delete-product-menu-item": "Ta bort",
        "products-confirm-delete-product-dialog": "\n .typeOfEntity = produkt",
        "products-export-id": "Produkt-ID",
        "products-export-product-number": "Produktnummer",
        "products-export-group": "Produktgrupp",
        "products-export-name": "Produktnamn",
        "products-export-price": "Pris",
        "products-export-status": "Status",
        "products-export-stock-total": "Lagersaldo",
        "products-export-items-for-sale-per-day": "Varor till försäljning per dag",
        "products-export-items-left-today": "Återstår idag",
        "product-offer-chip": "\n .label = Erbjudande",

        // Merchant > Admin > Products > Info icons
        "product-info-icon-deadline-label": "Deadline",
        "product-info-icon-deadline-value": "{ $daysBefore } dagar före, kl. { $timeOfDay }",
        "product-info-icon-availability-label": "Tillgänglighet",
        "product-info-icon-offer-label": "Erbjudande",
        "product-info-icon-offer-percentage-value": "-{ $percentage }%",
        "product-info-icon-offer-discount-price-value": "Nedsatt pris",
        "product-info-icon-marketing-tag-label": "Marknadsföringstagg",
        "product-info-icon-allergens-label": "Allergener",
        "product-info-icon-allow-pre-order-label": "Tillåt förbeställning",
        "product-info-icon-description-label": "Beskrivning",
        "product-info-icon-pin-code-label": "PIN-kod",
        "product-info-icon-pin-code-value": "Obligatorisk",
        "products-edit-product-group-menu-item": "Redigera",
        "products-delete-product-group-menu-item": "Ta bort",

        // Merchant > Admin > Shops > Price list dropdown selector
        "price-list-dropdown-selector-field-label": "Prislista",
        "price-list-dropdown-selector-placeholder": "Välj prislista",
        "price-list-dropdown-selector-active-only-checkbox": "\n .label = Endast aktiva",
        "price-list-dropdown-selector-inactive-chip": "\n .label = Inaktiv",
        "price-list-dropdown-selector-internal-note-label": "Intern anteckning",
        "price-list-dropdown-selector-message-to-customers-label": "Meddelande till kunder",
        "price-list-dropdown-selector-no-info": "Ingen ytterligare info",
        "price-list-dropdown-selector-vat-inclusive": "Pris inkl. moms",
        "price-list-dropdown-selector-vat-exclusive": "Pris exkl. moms",

        // Merchant > Admin > Products > Stock
        "product-stock-chip-label": "Lager: { $count }",
        "product-stock-daily-sales": "Sålt idag: { $sold }/{ $total }",
        "product-stock-on-sale-per-day-label": "Till försäljning per dag:",
        "product-stock-on-sale-per-day-info": "\n .title = Med detta kan du begränsa antalet varor som är till försäljning varje dag.\n .description = Med detta kan du begränsa antalet varor som är till försäljning varje dag.",
        "product-stock-on-sale-per-day-required-error": "Till försäljning per dag är obligatoriskt",
        "product-stock-on-sale-per-day-min-error": "Till försäljning per dag måste vara minst 1",
        "product-stock-total-stock-label": "Totalt lager:",
        "product-stock-total-stock-items": "{ $count } varor",
        "product-stock-current-stock-label": "Aktuellt lagersaldo:",
        "product-stock-tab-inventory": "Lagerjustering",
        "product-stock-tab-daily": "Till försäljning per dag",
        "product-stock-type-label": "\n .label = Typ:",
        "product-stock-type-option-inbound": "Lägg till i lager",
        "product-stock-type-option-outbound": "Ta bort från lager",
        "product-stock-adjustment-amount-label": "Antal:",
        "product-stock-adjustment-amount-tooltip": "\n .title = Ange kvantiteten som ska justeras",
        "product-stock-reason-label": "Orsak:",
        "product-stock-reason-tooltip": "\n .title = Välj orsaken till denna lagerjustering",
        // Outbound reasons
        "product-stock-reason-option-sold": "Sålt",
        "product-stock-reason-tooltip-sold": "\n .title = Varor sålda till en kund.",
        "product-stock-reason-option-reserved": "Reserverat",
        "product-stock-reason-tooltip-reserved": "\n .title = Varor som lagts åt sidan för en specifik order.",
        "product-stock-reason-option-shipped": "Skickat",
        "product-stock-reason-tooltip-shipped": "\n .title = Varor har lämnat lagret.",
        "product-stock-reason-option-returned-to-vendor": "Returnerat till leverantör",
        "product-stock-reason-tooltip-returned-to-vendor": "\n .title = Varor som skickats tillbaka till leverantören.",
        "product-stock-reason-option-consumed-in-production": "Förbrukat i produktion",
        "product-stock-reason-tooltip-consumed-in-production": "\n .title = Ingredienser som använts under matlagning/produktion.",
        "product-stock-reason-option-scrapped": "Kasserat",
        "product-stock-reason-tooltip-scrapped": "\n .title = Varor som kasserats som oanvändbara.",
        "product-stock-reason-option-lost": "Förlorat",
        "product-stock-reason-tooltip-lost": "\n .title = Varan kan inte hittas.",
        "product-stock-reason-option-stolen": "Stulet",
        "product-stock-reason-tooltip-stolen": "\n .title = Varor som tagits bort genom stöld.",
        "product-stock-reason-option-sample-given": "Utdelat varuprov",
        "product-stock-reason-tooltip-sample-given": "\n .title = Varor som delats ut för provsmakning eller test.",
        // Inbound reasons
        "product-stock-reason-option-purchased": "Inköpt",
        "product-stock-reason-tooltip-purchased": "\n .title = Nya varor som mottagits från en leverantör.",
        "product-stock-reason-option-returned-from-customer": "Returnerat av kund",
        "product-stock-reason-tooltip-returned-from-customer": "\n .title = Varor som returnerats till lagret av en kund.",
        "product-stock-reason-option-produced": "Producerat",
        "product-stock-reason-tooltip-produced": "\n .title = Färdigvaror som lagts till efter tillagning.",
        "product-stock-reason-option-found-during-count": "Hittat vid inventering",
        "product-stock-reason-tooltip-found-during-count": "\n .title = Extra varor som hittats under lagerinventering.",
        "product-stock-reason-option-transferred-in": "Överfört (in)",
        "product-stock-reason-tooltip-transferred-in": "\n .title = Varor som flyttats från en annan plats.",
        "product-stock-items-per-day-label": "Varor till försäljning per dag",
        "product-stock-items-per-day-tooltip": "\n .title = Antal varor tillgängliga för försäljning per dag",
        "product-stock-note-label": "Notering:",
        "product-stock-note-placeholder": "\n .placeholder = Valfri extra information om justeringen",
        "product-stock-confirm-button": "Bekräfta",
        "product-stock-cancel-button": "Avbryt",
        "product-stock-adjustment-button": "Lagerjustering",
        "product-stock-update-success": "Lagret har uppdaterats",
        "product-create-stock-switch-label": "Lagerhantering:",
        "product-create-stock-total-field": "\n .label = Totalt lager",
        "product-create-stock-items-per-day-field": "\n .label = Varor per dag",
        "product-create-stock-info": "Ange totalt lagersaldo och hur många varor som kan säljas per dag.",

        // Merchant > Admin > Extra Services
        "extra-services-page-header": "\n .title = Extratjänster",
        "extra-services-edit-submit-button": "Spara",
        "extra-services-create-service-button": "Skapa ny",
        "extra-services-services-column": "Tjänster",
        "extra-services-service-type-column": "Tjänsttyp",
        "extra-services-price-type-column": "Pristyp",
        "extra-services-status-column": "Status",
        "extra-services-price-subline-fixed": "Fast pris",
        "extra-services-price-subline-per-seat": "Pris per kuvert",
        "extra-services-price-subline-min": "Min. pris",
        "extra-services-price-subline-max": "Max. pris",

        // Merchant > Admin > Extra Services > Create / Edit
        "extra-services-create-page-header": "\n .title = Skapa extratjänst",
        "extra-services-edit-page-header": "\n .title = Redigera extratjänst",
        "extra-services-create-active-switch": "Aktiv:",
        "extra-services-create-mandatory": "Lägg alltid till i ordern",
        "extra-services-create-mandatory-without-pickup": "Lägg till vid avhämtning",
        "extra-services-create-meeting-location-required-switch": "Kräv mötesplats",
        "extra-services-create-meeting-time-required-switch": "Kräv mötestid",
        "extra-services-create-service-time-weekdays-min-error": "Välj minst en dag",
        "extra-services-create-price-field-label": "\n .label = Pris",
        "extra-services-create-min-price-field-label": "\n .label = Min. pris",
        "extra-services-create-max-price-field-label": "\n .label = Max. pris",
        "extra-services-create-price-per-seat-field-label": "\n .label = Pris per kuvert",
        "extra-services-create-currency-field-label": "\n .label = Valuta",
        "extra-services-create-service-description-field":  "\n .label = Beskrivning",
        "extra-services-create-service-description-field-max-length": "Beskrivningen får inte överstiga { $maxLength } tecken",
        "extra-services-create-service-name-field":  "\n .label = Namn",
        "extra-services-create-service-type-field":  "\n .label = Tjänsttyp",
        "extra-services-create-service-pricing-type-field":  "\n .label = Pristyp",
        "extra-services-create-panel-pricing": "\n .label = Prissättning",
        "extra-services-create-settings-panel": "\n .title = Inställningar",
        "extra-services-create-service-time-panel": "\n .title = Tillgängliga tider",
        "extra-services-create-form-type-dropdown-item-pickup-fee": "Avhämtningsavgift",
        "extra-services-create-form-type-dropdown-item-eat-in-canteen-fee": "Avgift för att äta i kantinen",
        "extra-services-create-form-type-dropdown-item-delivery-fee": "Leveransavgift",
        "extra-services-create-form-type-dropdown-item-table-setting-fee": "Avgift för bordsdukning",
        "extra-services-create-form-type-dropdown-item-cleanup-fee": "Avgift för städning",
        "extra-services-create-form-type-dropdown-item-out-of-opening-hours-fee": "Avgift utanför öppettider",
        "extra-services-create-form-type-dropdown-item-other": "Annat",
        "extra-services-create-form-pricing-type-dropdown-item-per-seat": "Per kuvert",
        "extra-services-create-form-pricing-type-dropdown-item-flat-fee": "Fast avgift",
        "extra-services-create-when-add-to-order-field": "\n .label = Åtgärd",
        "extra-services-create-when-add-to-order-no-action": "Inga åtgärder valda",
        "extra-services-create-form-action-dropdown-item-add-always": "Lägg alltid till",
        "extra-services-create-form-action-dropdown-item-add-when-pick-up": "Lägg till vid avhämtning",
        "extra-services-create-form-action-dropdown-item-add-when-delivered": "Lägg till vid leverans",

        // Merchant > Admin > Shops > Products > Create / Edit
        "product-create-page-header": "\n .title = Skapa produkt",
        "product-create-submit-button": "Skapa",
        "product-edit-page-header": "\n .title = Redigera produkt",
        "product-edit-submit-button": "Spara\n .loadingLabel = Sparar...",
        "product-create-shops-field-label": "Butiker",
        "product-create-group-field-label": "\n .label = Produktgrupp",
        "product-create-number-field-label": "\n .label = Produktnummer",
        "product-create-name-field-label": "\n .label = Produktnamn",
        "product-create-price-field-label": "\n .label = Pris",
        "product-create-price-field-title": "Pris",
        "product-create-price-field-vat-included-badge": "\n .label = Inkl. moms",
        "product-create-price-field-vat-excluded-badge": "\n .label = Exkl. moms",
        "product-create-price-field-no-price-list-badge": "\n .label = Välj prislista",
        "product-create-price-field-no-price-list-placeholder": "Välj prislista först",
        "product-create-currency-field-label": "\n .label = Valuta",
        "product-create-description-field-label": "\n .label = Beskrivning",
        "product-create-panel-access": "\n .title = Åtkomst",
        "product-create-panel-access-shop-alert-title": "\n .title = En butik representerar en virtuell eller fysisk försäljningsplats, till exempel webbutiker i GoPay-appen eller butiken som är kopplad till POS-terminaler i en kantin. En användare som INTE är kopplad till en prislista ser här de produkter som är direkt tilldelade butiker. ",
        "product-create-panel-access-price-list-alert-title": "\n .title = Prislistor kan användas för att erbjuda olika produktutbud eller priser till olika användargrupper. Flera prislistor kan kopplas till samma butik för att kunna erbjuda olika utbud. En användare ser alltid en prislista, eller standardutbudet. Vilken prislista som visas beror på användargruppen eller, för POS, användarens abonnemangstyp.",
        "product-create-panel-description": "\n .title = Beskrivning",
        "product-create-image-field-label": "\n .label = Bild",
        "create-image-file-support": "Filtyper som stöds: { $supportedFileTypes }. Max storlek: { $maxSize }",
        "product-create-general-panel": "\n .title = Allmänt",
        "product-create-active-switch": "Aktiv:",
        "product-create-admin-only-switch": "Endast för personal:",
        "product-create-product-description-panel": "\n .title = Produktbeskrivning",
        "product-create-product-description-marketing-tag-field": "\n .label = Marknadsföringstagg\n .helperText = Exempel: 'Erbjudande', 'CO2', 'Varmrätt', 'Vegetarisk'",
        "product-create-product-description-allergens-field": "\n .label = Allergener",
        "product-create-availability-panel": "\n .title = Tillgänglighet\n .description = Begränsa till vissa dagar och tider",
        "product-create-availability-from-date-picker": "\n .label = Från datum",
        "product-create-availability-to-date-picker": "\n .label = Till datum",
        "product-create-availability-preorder-switch": "Tillåt inte förbeställning:",
        "product-create-availability-info": "Kunder kan förbeställa produkter för framtida datum i GoPay-appen, om du inte stänger av det här.",
        "product-create-availability-date-error": "Slutdatum får inte vara före startdatum",
        "product-create-availability-week-days-label": "Tillgänglig på:",
        "product-create-availability-week-days-helper-text": "Lämna alla dagar avmarkerade för att sälja produkten alla dagar.",
        "product-create-availability-week-days-group-helper-text": "Endast produktgruppens dagar kan väljas. Lämna alla dagar avmarkerade för att sälja produkten alla dessa dagar.",
        "product-create-availability-week-days-group-error": "Välj endast dagar då produktgruppen är tillgänglig",
        "product-create-availability-from-time-picker": "\n .label = Från klockan",
        "product-create-availability-to-time-picker": "\n .label = Till klockan",
        "product-create-availability-time-helper-text": "Lämna båda tiderna tomma för att sälja produkten hela dagen.",
        "product-create-availability-time-group-helper-text": "Måste ligga inom produktgruppens tider, { $start } – { $end }. Lämna båda tiderna tomma för att använda produktgruppens tider.",
        "product-create-availability-time-incomplete-error": "Ange både 'Från klockan' och 'Till klockan'",
        "product-create-availability-time-error": "'Till klockan' måste vara senare än 'Från klockan'",
        "product-create-availability-time-group-error": "Tiderna måste ligga inom produktgruppens tider",
        "product-create-deadline-panel": "\n .title = Deadline\n .description = Hur långt före leverans beställningen måste göras",
        "product-create-deadline-purchases-subtitle": "Köp:",
        "product-create-deadline-cancellation-subtitle": "Avbokning:",
        "product-create-deadline-day-field": "\n .label = Dag",
        "product-create-deadline-day-limit-day-before": "Dagen före",
        "product-create-deadline-day-limit-x-days-before": "{ $daysBefore } dagar före",
        "product-create-deadline-time-picker": "\n .label = Tid",
        "product-create-barcode-panel": "\n .title = ERP-nummer",
        "product-create-barcode-field-label": "\n .label = Streckkod",
        "product-create-sales-rules-panel": "\n .title = Försäljningsregler",
        "product-create-offer-panel": "\n .title = Erbjudande\n .description = Tillfälligt sänkt pris under en period",
        "product-create-offer-discount-percentage": "Rabattprocent:",
        "product-create-offer-discount-price": "Nytt pris:",
        "product-create-offer-items-in-stock": "Antal varor i lager:",
        "product-create-offer-available-from": "Tillgängligt från:",
        "product-create-offer-available-to": "Tillgängligt till:",
        "product-create-offer-edit-button": "Redigera",
        "product-create-offer-create-button": "Skapa",
        "product-create-offer-dialog-create-title": "Skapa erbjudande",
        "product-create-offer-dialog-edit-title": "Redigera erbjudande",
        "product-create-offer-dialog-normal-price": "Ursprungligt pris:",
        "product-create-offer-dialog-price-adjustment-field": "\n .label = Prisjustering",
        "product-create-offer-dialog-price-adjustment-option-none": "Ingen",
        "product-create-offer-dialog-price-adjustment-option-discount-price": "Nedsatt pris",
        "product-create-offer-dialog-price-adjustment-option-discount-percentage": "Rabattprocent",
        "product-create-offer-dialog-adjust-price-field": "\n .label = Nytt pris",
        "product-create-offer-dialog-items-field": "Antal varor som erbjuds per dag:",
        "product-create-offer-dialog-percentage-field": "\n .label = Procentsats",
        "product-create-offer-dialog-available-offer-period": "Erbjudandeperiod",
        "product-create-offer-dialog-available-from-date-picker": "\n .label = Tillgängligt från",
        "product-create-offer-dialog-available-to-date-picker": "\n .label = Tillgängligt till",
        "product-create-offer-dialog-marketing-tag-label": "Marknadsföringstagg:",
        "product-create-offer-dialog-marketing-tag-mode-old-new-price-new": "25,00 kr",
        "product-create-offer-dialog-marketing-tag-mode-old-new-price-old": "35,00 kr",
        "product-create-offer-dialog-marketing-tag-mode-old-new-price": "25,00 kr 35,00 kr",
        "product-create-offer-dialog-marketing-tag-mode-save-x": "Spara [x] %",
        "product-create-offer-dialog-marketing-tag-mode-limited-on-sale": "Spara [x] kr",
        "product-create-offer-dialog-marketing-tag-mode-great-offer": "Bra erbjudande",
        "product-create-offer-dialog-marketing-tag-mode-buy-now": "Köp nu",
        "product-create-offer-dialog-marketing-tag-mode-good-price": "Bra pris",
        "product-create-offer-dialog-marketing-tag-mode-discount": "Nedsatt pris",
        "product-create-offer-dialog-marketing-tag-mode-week-offer": "Veckans erbjudande",
        "product-create-offer-dialog-marketing-tag-mode-day-offer": "Dagens erbjudande",
        "product-create-offer-dialog-save-button": "Spara",
        "product-create-add-price-list-button": "Lägg till i prislista",
        "product-create-add-to-price-list": "Lägg till i prislista",
        "product-create-price-list-step-one": "Välj prislista",
        "product-create-price-list-step-two": "Ange pris",
        "product-create-price-list-table-name-column": "Namn",
        "product-create-price-list-table-status-column": "Status",
        "product-create-price-list-table-active-column-active": "Aktiv",
        "product-create-price-list-table-active-column-inactive": "Inaktiv",
        "product-create-price-list-table-active-column-active-filter-yes": "Aktiv",
        "product-create-price-list-table-active-column-inactive-filter-no": "Inaktiv",
        "product-create-price-list-table-currency": "Valuta:",
        "product-create-price-list-table-vat": "Moms:",
        "product-create-price-list-table-connected-shops": "Kopplade butiker:",
        "product-create-price-list-table-connected-customers": "Kopplade kunder:",
        "product-create-price-list-table-vat-code": "Momskod:",
        "product-create-price-list-table-select-button": "Välj",
        "product-create-price-list-selected-price-list": "Vald prislista:",
        "product-create-price-list-price-field-label": "\n .label = Pris",
        "product-create-price-list-add-button": "Lägg till",
        "product-create-payment-panel": "\n .title = Betalning",
        "product-create-pos-panel": "\n .title = POS",
        "product-create-payment-price-switch": "Dölj pris:",
        "product-create-variable-price-switch": "Aktivera rörligt pris:",
        "product-create-require-staff-pin-switch": "Kräv personal-PIN:",
        "product-create-price-disabled-tooltip": "\n .title = Priset är inaktiverat eftersom rörligt pris är aktivt",
        "product-create-delivery-panel": "\n .title = Leverans",
        "product-create-delivery-deliveryDetails-field": "\n .label = Avhämtningsplats",
        "product-create-order-limits-panel": "\n .title = Orderbegränsningar",
        "product-create-price-lists-field-label": "\n .label = Prislistor",
        "product-create-price-list-field-label": "\n .label = Prislista",
        "products-no-price-lists-message": "Du har ingen prislista än. Du måste skapa en prislista innan du kan skapa produkter.",
        "products-go-to-price-lists-button": "Gå till prislistor",
        "product-create-item-limits-panel": "\n .title = Begränsning av antal varor",
        "product-create-item-limits-max-field": "Max. antal varor per dag och person:",
        "product-create-item-limits-max-info": "Detta avgör hur många varor av den här typen en kund totalt kan beställa per dag.",
        "product-create-item-limits-min-field": "Min. antal varor per order:",
        "product-create-item-limits-min-info": "Detta avgör det minsta antal varor av den här typen som en kund måste lägga till i en order.",
        "product-create-item-limits-error": "Antingen max. antal varor per dag eller min. antal varor per order måste fyllas i",
        "product-create-item-limits-min-error": "Min. antal varor per order måste vara tomt eller >= 2",
        "product-create-item-limits-max-error": "Max. antal varor per dag måste vara tomt eller >= 1",


        // Merchant > Admin > Shops > Product groups
        "product-groups-page-header-title": "\n .title = Produktgrupper",
        "product-groups-create-button": "Skapa ny",
        "product-groups-no-price-lists-message": "Du har ingen prislista än. Du måste skapa en prislista innan du kan skapa produktgrupper.",
        "create-product-group-create-button": "Skapa",
        "create-product-group-save-button": "Spara",
        "product-group-page-title-create": "\n .title = Skapa produktgrupp",
        "product-group-page-title-update": "\n .title = Redigera produktgrupp",
        "product-group-edit-products-outside-availability-dialog":
            "\n .title = Begränsa produkternas tillgänglighet?\n .message = De här produkterna har egna dagar eller tider utanför gruppens nya tillgänglighet. De begränsas till gruppens dagar och tider.\n .buttonLabelSubmit = Spara och begränsa\n .buttonLabelCancel = Avbryt",
        "product-group-edit-products-outside-availability-dialog-no-overlap-description":
            "Inga gemensamma dagar eller tider med gruppen, så den följer gruppens tillgänglighet.",
        "product-group-delete": "produktgrupp",
        "product-group-delete-success-message": "Produktgruppen har tagits bort",
        "product-group-code-column-header": "ERP-nr",
        "product-group-name-column-header": "Namn",
        "product-group-status-column-header": "Status",

        // Merchant > Admin > Shops > Product groups > Create / Edit
        "product-group-form-name-field": "\n .label = Namn",
        "product-group-form-code-field": "\n .label = ERP-nummer",
        "product-group-form-code-field-helper-text": "ERP-nummer används vid integration med ett redovisningssystem. De underhålls på leverantörsnivå.",
        "product-group-form-code-field-helper-text-no-items": "Inga tillgängliga produktgruppskoder för leverantör",
        "product-group-form-settings-panel": "\n .title = Inställningar",
        "product-group-form-active-switch": "Aktiv:",
        "product-group-form-pin-code-required-switch": "PIN-kod krävs:",
        "product-group-form-pin-code-required-explanation": "Det krävs en personal-PIN-kod för att köpa produkter i den här gruppen. PIN-koden finns i enhetsuppgifterna.",
        "product-group-form-limited-availability-panel-title": "\n .title = Begränsad tillgänglighet \n .offContent = Produkter i den här gruppen är alltid tillgängliga för köp",
        "product-group-form-start-time-picker": "\n .label = Från klockan",
        "product-group-form-end-time-picker": "\n .label = Till klockan",
        "product-group-form-week-day-monday": "Måndag",
        "product-group-form-week-day-tuesday": "Tisdag",
        "product-group-form-week-day-wednesday": "Onsdag",
        "product-group-form-week-day-thursday": "Torsdag",
        "product-group-form-week-day-friday": "Fredag",
        "product-group-form-week-day-saturday": "Lördag",
        "product-group-form-week-day-sunday": "Söndag",
        "product-group-form-end-time-picker-min-error-label": "Måste vara senare än 'Från klockan'",


        // Merchant > Admin > Shops > Price lists
        "price-lists-header": "\n .title = Prislistor",
        "price-lists-create-button": "Skapa ny",
        "price-list-vat-code": "Momskod:",
        "price-list-currency": "Valuta:",
        "price-list-shops": "Kopplade butiker:",
        "price-list-company": "Kopplade företag:",
        "price-list-no-result": "Det finns inga prislistor. Skapa din första prislista",
        "price-list-delete": "prislista",
        "price-list-delete-success-message": "Prislistan har tagits bort",

        // Merchant > Admin > Price lists > Adjust prices
        "price-lists-adjust-prices-action": "Justera priser",
        "adjust-price-list-page-header": "\n .title = Justera priser",
        "adjust-price-list-breadcrumb": "Justera priser",
        "adjust-price-list-page-subtitle": "{ $priceList } · { $count } varor",
        "adjust-price-list-cancel-button": "Avbryt",
        "adjust-price-list-scope-select-all": "Markera alla",
        "adjust-price-list-scope-deselect-all": "Avmarkera alla",
        "adjust-price-list-preview-summary": "{ $count ->\n [one] { $count } vara\n *[other] { $count } varor\n } ändras · t.ex. { $from } → { $to }",
        "adjust-price-list-preview-show": "Visa priser",
        "adjust-price-list-preview-hide": "Dölj",
        "adjust-price-list-preview-showing": "Visar { $shown } av { $total } varor.",
        "adjust-price-list-preview-show-all": "Visa alla",
        "adjust-price-list-summary-change": "Ändring",
        "adjust-price-list-summary-change-value": "{ $sign }{ $value }",
        "adjust-price-list-summary-rounding": "Avrundning",
        "adjust-price-list-summary-rounding-none": "Ingen",
        "adjust-price-list-summary-rounding-quarter": "{ $step }",
        "adjust-price-list-summary-rounding-half": "{ $step }",
        "adjust-price-list-summary-rounding-whole": "Hela { $currency }",
        "adjust-price-list-submit-button": "Godkänn",
        "adjust-price-list-adjustment-panel": "\n .title = Justering",
        "adjust-price-list-banner": "\n .title = En prisjustering skapar en ny prislista\n .description = Den nuvarande listan ändras inte. Du bestämmer när den nya listan träder i kraft och vilken lista den tar över från — den gamla inaktiveras automatiskt det datumet.",
        "adjust-price-list-base-list-field": "\n .label = Ta över priser från\n .helperText = Valdes när du öppnade justeringen.",
        "adjust-price-list-scope-subtitle-empty": "Välj minst en produktgrupp.",
        "adjust-price-list-preview-showing-all": "Visar alla { $total } varor.",
        "adjust-price-list-direction-increase": "Höj priser",
        "adjust-price-list-direction-reduction": "Sänk priser",
        "adjust-price-list-value-field": "\n .label = Hur mycket?",
        "adjust-price-list-value-max-value": "Värdet får inte överstiga { $max } { $unit }",
        "adjust-price-list-value-negative-price": "Ändringen skulle göra minst ett pris negativt. Välj ett mindre värde.",
        "adjust-price-list-value-no-change": "Justeringen ändrar inga priser. Välj ett större värde eller andra produktgrupper.",
        "adjust-price-list-value-field-name": "Värde",
        "adjust-price-list-no-prices": "Den här prislistan har inga priser att justera.",
        "adjust-price-list-unit-percentage": "%",
        "adjust-price-list-unit-amount": "{ $currency }",
        "adjust-price-list-rounding-field": "\n .label = Avrundning",
        "adjust-price-list-rounding-hint-none": "Priserna kan sluta på t.ex. { $example0 }.",
        "adjust-price-list-rounding-hint-quarter": "T.ex. { $example0 } eller { $example1 }.",
        "adjust-price-list-rounding-hint-half": "T.ex. { $example0 } eller { $example1 }.",
        "adjust-price-list-rounding-hint-whole": "T.ex. { $example0 } eller { $example1 }.",
        "adjust-price-list-rounding-none": "Ingen avrundning",
        "adjust-price-list-rounding-quarter": "Närmaste { $step }",
        "adjust-price-list-rounding-half": "Närmaste { $step }",
        "adjust-price-list-rounding-whole": "Närmaste hela { $currency }",
        "adjust-price-list-summary-empty": "Välj hur mycket priserna ska ändras och från vilket datum.",
        "adjust-price-list-summary-raises": "Höjer { $count } varor med { $value } från { $date }.",
        "adjust-price-list-summary-lowers": "Sänker { $count } varor med { $value } från { $date }.",
        "adjust-price-list-effective-from-field": "\n .label = Gäller från",
        "adjust-price-list-customers-notice": "\n .title = Kunderna ser ändringen\n .description = Priserna uppdateras i { $shops ->\n [one] { $shops } butik\n *[other] { $shops } butiker\n } för { $customers } kunder.",
        "adjust-price-list-effective-from-invalid": "Välj idag eller ett senare datum",
        "adjust-price-list-existing-orders-note-kept": "Obokförda ordrar behåller sina nuvarande priser.",
        "adjust-price-list-existing-orders-note-updated": "Obokförda ordrar med leverans från { $date } får de nya priserna.",
        "adjust-price-list-existing-orders-checkbox": "Uppdatera även dessa ordrar",
        "adjust-price-list-existing-orders-title": "Obokförda ordrar",
        "adjust-price-list-scope-panel": "\n .title = Omfattning",
        "adjust-price-list-scope-subtitle-all": "Alla produktgrupper · { $items } varor",
        "adjust-price-list-scope-subtitle-some": "{ $groups } av { $total } grupper · { $items } varor",
        "adjust-price-list-scope-required": "Välj minst en produktgrupp",
        "adjust-price-list-preview-panel": "\n .title = Förhandsgranskning",
        "adjust-price-list-preview-empty": "Ange en procentsats och välj minst en produktgrupp för att se de nya priserna.",
        "adjust-price-list-preview-column-item": "Vara",
        "adjust-price-list-preview-column-now": "Nu",
        "adjust-price-list-preview-column-new": "Nytt pris",
        "adjust-price-list-preview-column-change": "Ändring",
        "adjust-price-list-summary-panel": "\n .title = Så här ser det ut",
        "adjust-price-list-summary-items": "Berörda varor",

        // Merchant > Admin > Shops > Price lists > Create / Edit
        "create-price-list-page-header": "\n .title = Skapa prislista",
        "edit-price-list-page-header":"\n .title = Redigera prislista",
        "create-price-list-save-button": "Spara",
        "create-price-list-create-button": "Skapa",
        "create-price-list-tab-general": "Allmänt",
        "create-price-list-tab-customers": "Kunder",
        "create-price-list-tab-products": "Produkter",
        "create-price-list-tab-pos": "POS",
        "create-price-list-required-name": "Namn krävs",
        "create-price-list-required-shops": "Du måste koppla prislistan till en eller flera butiker",
        "create-price-list-required-price-adjustment": "Prisjustering krävs",
        "create-price-list-required-currency-code": "Valuta krävs",
        "create-price-list-required-percentage": "Procentsats krävs",
        "create-price-list-max-percentage":"Procentsatsen får inte vara över 100",
        "create-or-edit-price-list-field-name":"\n .label = Namn",
        "create-or-edit-price-list-field-shops":"\n .label = Butiker",
        "create-or-edit-price-list-field-aside-settings":"\n .title = Inställningar",
        "create-or-edit-price-list-field-active":"Aktiv:",
        "create-or-edit-price-list-field-message-to-customers":"\n .label = Meddelande till kunder",
        "create-or-edit-price-list-aside-pricing":"\n .title = Prissättning",
        "create-or-edit-price-list-field-price-includes-vat":"Prislista inkl. moms:",
        "create-or-edit-price-list-field-vat-code":"\n .label = Momskod",
        "create-or-edit-price-list-field-currency-code":"\n .label = Valuta",
        "create-or-edit-price-list-field-dropdown-dkk":"DKK",
        "create-or-edit-price-list-field-price-adjustment":"\n .label = Prisjustering",
        "create-or-edit-price-list-field-dropdown-none":"Ingen",
        "create-or-edit-price-list-field-dropdown-discount": "Rabatt",
        "create-or-edit-price-list-field-dropdown-increase": "Prishöjning",
        "create-or-edit-price-list-field-internal-note":"\n .placeholder = Intern anteckning",
        "create-or-edit-price-list-field-percentage":"Procentsats (%):",
        "create-or-edit-price-list-customer-table-header-name":"Namn",
        "create-or-edit-price-list-customer-table-header-user-group":"Användargrupp",
        "create-or-edit-price-list-customer-table-button-remove":"Ta bort",
        "create-or-edit-price-list-customer-table-button-details":"Detaljer",
        "create-or-edit-price-list-customer-subtitle":"Om inga kunder läggs till här har alla kunder åtkomst till prislistan.",
        "create-or-edit-price-list-customer-table-title":"Kunder med åtkomst",
        "create-or-edit-price-list-customer-button-add-customer":"Lägg till kund",
        "create-or-edit-price-list-customer-table-empty-state":"Alla kunder har åtkomst",
        "create-or-edit-price-list-general-tab-error":"Det finns valideringsfel under fliken Allmänt",
        "create-or-edit-price-list-customer-tab-error":"Det finns valideringsfel under fliken Kunder",
        "create-or-edit-price-list-products-tab-error":"Det finns valideringsfel under fliken Produkter",
        "create-or-edit-price-list-pos-tab-error":"Det finns valideringsfel under fliken POS",
        "create-or-edit-price-list-customer-table-add-customers-title":"Lägg till kunder",
        "create-or-edit-price-list-customer-table-add-button":"Lägg till",
        "create-or-edit-price-list-products-table-title":"Produkter",
        "create-or-edit-price-list-products-table-header-name":"Namn",
        "create-or-edit-price-list-products-table-header-product-no":"Produktnr",
        "create-or-edit-price-list-products-table-header-normal-price":"Normalpris",
        "create-or-edit-price-list-products-table-header-adjusted-price":"Justerat pris",
        "create-or-edit-price-list-products-table-header-status":"Status",
        "create-or-edit-price-list-products-table-status-active":"Aktiv",
        "create-or-edit-price-list-products-table-status-inactive":"Inaktiv",
        "create-or-edit-price-list-pos-table-title":"ID-kortsabonnemang",
        "create-or-edit-price-list-pos-info-description":"\n .description = En prislista måste alltid vara standard för POS-systemet. Om ett ID-kort skannas och dess abonnemangstyp inte är tilldelad en prislista visas standardprislistan.",
        "create-or-edit-price-list-pos-is-default-price-list":"Standardprislista",
        "create-or-edit-price-list-pos-table-type":"Typ",
        "create-or-edit-price-list-pos-table-description":"Beskrivning",

        // Merchant > Admin > Shops > Shops
        "shops-page-header": "\n .title = Butiker",
        "shops-table-case-column": "Ärendenr",
        "shops-table-name-column": "Namn",
        "shops-table-type-column": "Typ",
        "shops-table-status-column": "Status",
        "shops-table-status-column-active": "Aktiv",
        "shops-table-status-column-inactive": "Inaktiv",
        "shops-table-status-column-demo": "Demo",
        "shops-table-status-column-active-filter-active": "Aktiv",
        "shops-table-status-column-inactive-filter-inactive": "Inaktiv",
        "shops-table-status-column-demo-filter-demo": "Demo",
        "shops-table-create-button": "Skapa ny",
        "shops-table-menu-item-edit": "Redigera",
        "shops-table-menu-item-delete": "Ta bort",
        "shops-confirm-delete-shop-dialog": "\n .typeOfEntity = butik",

        // Merchant > Admin > Shops > Shops > Create - Edit shop
        "merchant-shop-create-header": "\n .title = Skapa butik",
        "merchant-shop-edit-header": "\n .title = Redigera butik",
        "merchant-shop-create-breadcrumb": "Skapa butik",
        "merchant-shop-edit-breadcrumb": "Redigera butik",
        "merchant-shop-create-button": "Skapa",
        "merchant-shop-save-button": "Spara",
        "merchant-create-edit-shop-tab-general": "Allmänt",
        "merchant-create-edit-shop-tab-settings": "Inställningar",
        "merchant-shop-form-field-name": "\n .label = Namn \n .helperText = Butikens namn visas för dina kunder.",
        "merchant-shop-form-field-type": "\n .label = Typ",
        "merchant-shop-form-field-type-helperText": "Välj typ av butik.",
        "merchant-shop-form-field-type-mode-meeting-service": "Mötesförtäring",
        "merchant-shop-form-field-type-mode-take-away": "Takeaway",
        "merchant-shop-form-field-type-mode-lunch": "GoPay",
        "merchant-shop-form-field-type-mode-pos": "POS",
        "merchant-shop-form-field-type-mode-subscription": "Abonnemang",
        "merchant-shop-form-hardware-packages": "Välj hårdvarupaket",
        "merchant-shop-form-hardware-packages-info": "\n .description = Att välja produkter nedan leder inte till ett köp. Du får därefter ett erbjudande på hårdvara som du kan godkänna.",
        "merchant-shop-form-hardware-packages-tablet-size": "Surfplattans storlek:",
        "merchant-shop-form-hardware-packages-color": "Färg:",
        "merchant-shop-form-payment-methods": "Tillgängliga betalningsmetoder",
        "merchant-shop-form-make-shop-public": "\n .title = Offentlig butik \n .offContent = Den här butiken är endast tillgänglig för inbjudna företag.",
        "merchant-shop-form-make-shop-public-info": "\n .description = En offentlig butik är tillgänglig för alla.",
        "merchant-shop-form-make-shop-public-title": "Dela följande med dina kunder",
        "merchant-shop-form-make-shop-public-description": "För att betala som gäst måste du antingen skanna en QR-kod eller ange butiksnumret för att komma åt butiken. Läs mer om offentliga butiker <externalLink>här</externalLink>.",
        "merchant-shop-form-make-shop-public-number": "Butiksnummer:",
        "merchant-shop-form-make-shop-public-url": "Direkt offentlig URL:",
        "merchant-shop-form-make-shop-public-qr-code": "- eller så kan användarna skanna den här QR-koden med sin mobil",
        "merchant-shop-form-make-shop-public-offContent": "Spara för att se delningsuppgifter.",
        "merchant-shop-form-field-isVisibleForAppUsers": "\n .label = Gör butiken synlig för interna användare i GoPay-mobilappen",
        "merchant-shop-form-general": "\n .title = Allmänt",
        "merchant-shop-form-field-active": "Aktiv:",
        "merchant-shop-form-field-demo": "Demo:",
        "merchant-shop-form-erp": "\n .title = ERP",
        "merchant-shop-form-field-case-number": "\n .label = Ärendenummer \n .helperText = Ärendenumret används för att importera försäljningsdata till din organisations ERP-system.",
        "merchant-shop-form-internal-note": "\n .title = Intern anteckning",
        "merchant-shop-form-field-internal-note": "\n .label = Intern anteckning:",
        "merchant-shop-form-posDetails-defaultLanguage-field-label": "\n .label = Standardspråk",
        "merchant-shop-form-posDetails-defaultLanguage-lang-en": "Engelska",
        "merchant-shop-form-posDetails-defaultLanguage-lang-da": "Danska",
        "merchant-shop-form-check-in": "Checka in",
        "merchant-shop-form-check-in-qr-code-on-receipt": "Visa QR-kod för incheckning på kvitto",
        "merchant-shop-form-accept-multiple-check-ins": "Tillåt flera incheckningar",
        "merchant-shop-form-deadline": "\n .title = Deadline \n .offContent = Deadline är inte aktiverad",
        "merchant-shop-form-purchases": "Köp:",
        "merchant-shop-form-cancellation": "Avbokning:",
        "merchant-shop-form-deadline-day-field": "\n .label = Dag",
        "merchant-shop-form-deadline-day-limit-day-before": "Dagen före",
        "merchant-shop-form-deadline-day-limit-x-days-before": "{ $daysBefore } dagar före",
        "merchant-shop-form-deadline-time-picker": "\n .label = Tid",
        "merchant-shop-form-posDetails-configuration-for-supporters": "\n .title = Inställningar för supportpersonal",
        "merchant-shop-form-posDetails-configuration-for-supporters-returnToHomeScreenDelay-field-label": "\n .label = Fördröjning innan återgång till startskärmen",
        "merchant-shop-form-posDetails-configuration-for-supporters-returnToHomeAfterPurchase-field-label": "\n .label = Återgå till start efter köp",
        "merchant-shop-form-posDetails-configuration-for-supporters-ms": "ms",

        // Merchant > Admin > Shops > Offers
        "offers-page-header": "\n .title = Erbjudanden",
        "offers-table-name-column": "Produktnamn",
        "offers-table-price-column": "Nytt pris",
        "offers-table-original-price-column": "Ursprungligt pris",
        "offers-table-valid-from-column": "Giltig från",
        "offers-table-expires-column": "Går ut",
        "offers-table-status-column": "Status",
        "offers-table-edit-menu-item": "Redigera",
        "offers-table-remove-offer-menu-item": "Ta bort erbjudande",
        "offers-table-remove-offer-confirm-dialog": "\n .typeOfEntity = erbjudande",
        "offers-table-remove-offer-success": "Erbjudandet har tagits bort",


        // Merchant > Admin > Shops > VAT Codes
        "merchant-vat-codes-header": "\n .title = Momskoder",
        "merchant-vat-codes-list-create-button": "Skapa ny",
        "merchant-vat-codes-create-button": "Skapa",
        "merchant-vat-codes-save-button": "Spara",
        "merchant-vat-codes-delete-entity-dialog": "\n .typeOfEntity = momskod",
        "merchant-vat-codes-table-header-vat-code":"Momskod",
        "merchant-vat-codes-table-header-name":"Namn",
        "merchant-vat-codes-table-header-percentage":"Procent",
        "merchant-vat-codes-table-button-edit":"Redigera",
        "merchant-vat-codes-table-button-delete":"Ta bort",

        // Merchant > Admin > Shops > Create/Edit VAT Codes
        "merchant-vat-codes-create-header": "\n .title = Skapa momskod",
        "merchant-vat-codes-edit-header": "\n .title = Redigera momskod",
        "merchant-vat-codes-create-edit-field-code":"\n .label = Kod",
        "merchant-vat-codes-create-edit-field-name":"\n .label = Namn",
        "merchant-vat-codes-create-edit-vat-percentage-amount":"\n .label = Momsprocent",
        "merchant-vat-codes-create-edit-required-name": "Namn krävs",
        "merchant-vat-codes-create-edit-required-code": "Kod krävs",
        "merchant-vat-codes-create-edit-required-vat-percentage-amount": "Momsprocent krävs",

        // Merchant > Admin > Shops > Delivery locations
        "merchant-delivery-locations-header": "\n .title = Leveransplatser",
        "merchant-delivery-locations-create-button-link": "Skapa ny",
        "merchant-delivery-locations-delete-entity-dialog": "\n .typeOfEntity = leveransplats",
        "merchant-delivery-locations-table-header-name": "Namn",
        "merchant-delivery-locations-table-header-webshop": "Webshop",
        "merchant-delivery-locations-table-header-status": "Status",
        "merchant-delivery-locations-table-active-column-active": "Aktiv",
        "merchant-delivery-locations-table-active-column-inactive": "Inaktiv",
        "merchant-delivery-locations-table-active-column-active-filter-yes": "Aktiv",
        "merchant-delivery-locations-table-active-column-inactive-filter-no": "Inaktiv",
        "merchant-delivery-locations-table-button-edit": "Redigera",
        "merchant-delivery-locations-table-button-delete": "Ta bort",

        // Merchant > Admin > Shops > Delivery locations
        "merchant-delivery-location-create-header": "\n .title = Skapa leveransplats",
        "merchant-delivery-location-edit-header": "\n .title = Redigera leveransplats",
        "merchant-delivery-location-create-breadcrumb": "Skapa leveransplats",
        "merchant-delivery-location-edit-breadcrumb": "Redigera leveransplats",
        "merchant-delivery-location-form-field-name": "\n .label = Namn",
        "merchant-delivery-location-form-pickup-details-title": "Uppgifter om avhämtning:",
        "merchant-delivery-location-form-field-description": "\n .label = Beskrivning",
        "merchant-delivery-location-form-pickup-time-helper": "Välj avhämtningstid så att kunden vet när beställningen kan hämtas:",
        "merchant-delivery-location-form-field-webshop": "\n .label = Webshop",
        "merchant-delivery-location-form-start-time-picker": "\n .label = Från:",
        "merchant-delivery-location-form-end-time-picker": "\n .label = Till:",
        "merchant-delivery-location-form-end-time-picker-min-error-label": "Måste vara senare än 'Från-tid'",
        "merchant-delivery-location-form-settings": "\n .title = Inställningar",
        "merchant-delivery-location-form-field-active": "Aktiv:",
        "merchant-delivery-locations-create-button": "Skapa",
        "merchant-delivery-locations-save-button": "Spara",

        // Merchant > Admin > Shops > Payment links
        "payment-links-page-header": "\n .title = Betalningslänkar",
        "payment-links-table-name-column": "Namn",
        "payment-links-table-shop-column": "Butik",
        "payment-links-table-valid-from-column": "Giltig från",
        "payment-links-table-valid-to-column": "Giltig till",
        "payment-links-table-create-button": "Skapa ny",
        "payment-links-table-menu-item-edit": "Redigera",
        "payment-links-table-menu-item-delete": "Ta bort",
        "payment-links-confirm-delete-dialog": "\n .typeOfEntity = betalningslänkar",

        // Merchant > Admin > Shops > Payment links > Create / Edit
        "payment-links-create-page-header": "\n .title = Skapa betalningslänk",
        "payment-links-create-page": "Skapa betalningslänk",
        "payment-links-form-create-submit-button": "Skapa",
        "payment-links-edit-page-header": "\n .title = Redigera betalningslänk",
        "payment-links-edit-page": "Redigera betalningslänk",
        "payment-links-form-edit-submit-button": "Spara",
        "payment-links-form-public-title-label": "\n .label = Titel",
        "payment-links-form-description-label": "\n .label = Beskrivning",
        "payment-links-form-public-shop-field-label": "\n .label = Offentlig butik",
        "payment-links-form-sales-account-field-label": "\n .label = Försäljningskonto",
        "payment-links-form-hasPasswordProtection-switch": "Lösenordsskyddad",
        "payment-links-form-password-field-label": "\n .label = Lösenord \n .helperText = Skydda din länk med ett lösenord om butiken stöder fakturering som betalningsmetod.",
        "payment-links-form-general-panel": "\n .title = Allmänt",
        "payment-links-form-active-switch": "Aktiv:",
        "payment-links-form-availability-panel": "\n .title = Giltighetsperiod \n .offContent = Giltig utan tidsbegränsning",
        "payment-links-form-availability-from-date-picker": "\n .label = Startdatum",
        "payment-links-form-availability-to-date-picker": "\n .label = Slutdatum",
        "payment-links-form-availability-error-picker": "Startdatum och slutdatum måste fyllas i",

        // Merchant > Admin > Setting > Sales accounts
        "sales-accounts-page-header": "\n .title = Försäljningskonton",
        "sales-accounts-table-name-column": "Namn",
        "sales-accounts-table-number-column": "Nummer",
        "sales-accounts-table-create-button": "Skapa ny",
        "sales-accounts-table-menu-item-edit": "Redigera",
        "sales-accounts-table-menu-item-delete": "Ta bort",
        "sales-accounts-confirm-delete-dialog": "\n .typeOfEntity = försäljningskonton",

        // Merchant > Admin > Setting > Sales accounts > Create / Edit
        "sales-accounts-create-page-header": "\n .title = Skapa försäljningskonto",
        "sales-accounts-create-page": "Skapa försäljningskonto",
        "sales-accounts-form-create-submit-button": "Skapa",
        "sales-accounts-edit-page-header": "\n .title = Redigera försäljningskonto",
        "sales-accounts-edit-page": "Redigera försäljningskonto",
        "sales-accounts-form-edit-submit-button": "Spara",
        "sales-accounts-form-public-name-label": "\n .label = Namn \n .placeholder = Ange ett namn för försäljningskontot",
        "sales-accounts-form-number-label": "\n .label = Nummer \n .placeholder = Ange kontonummer från ERP-systemet",
        "sales-accounts-form-general-panel": "\n .title = Allmänt",
        "sales-accounts-form-active-switch": "Aktiv:",

        // ADMIN DEVICES
        "merchant-admin-devices-page-header": "\n .title = Enheter",
        // Merchant users
        "merchant-admin-users-create-admin-button": "Skapa ny",
        "merchant-admin-users-page-title": "\n .title = Administratörer",


        // --- Supplier ---

        // Supplier > Navigation
        "supplier-nav-item-home": "Hem",
        "supplier-nav-item-accounting-title": "\n .title = Redovisning",
        "supplier-nav-item-accounting": "Redovisning",
        "supplier-nav-item-pos": "POS",
        "supplier-nav-item-meeting-service": "Mötesförtäring",
        "supplier-nav-item-subscriptions": "Abonnemang",
        "supplier-nav-item-z-reports": "Z-rapporter",
        "supplier-nav-item-merchant-sales": "Försäljning per försäljningsställe",
        "supplier-nav-item-customer-sales": "Kundförsäljning",
        "supplier-nav-item-balance": "Saldo",

        // Supplier > Navigation > Reports
        "supplier-nav-item-merchant-access": "Försäljningsställen",

        // Supplier > Navigation > Admin
        "supplier-nav-item-merchants-page-header":"\n .title = Försäljningsställen",
        "supplier-nav-item-settings-page-header":"\n .title = Inställningar",
        "supplier-nav-item-account-page-header":"\n .title = Konto",
        "supplier-nav-item-erp-page-header":"\n .title = ERP",
        "supplier-nav-item-acquiring-reports-page-header":"\n .title = Avstämning",
        "supplier-admin-nav-item-merchants": "Försäljningsställen",
        "supplier-admin-nav-item-merchants-create": "Skapa försäljningsställe",
        "supplier-admin-nav-item-merchants-edit": "Redigera försäljningsställe",
        "supplier-admin-nav-item-administrators": "Administratörer",
        "supplier-admin-nav-item-admins": "Administratörer",
        "supplier-admin-nav-item-devices": "Enheter",
        "supplier-admin-nav-item-settings": "Inställningar",
        "supplier-admin-nav-item-acquiring": "Kortinlösen",
        "supplier-admin-nav-item-terms-and-conditions": "Försäljningsvillkor",
        "supplier-admin-nav-item-pos-settings":"POS-inställningar",
        "supplier-admin-nav-item-pos-settings-template-create": "Skapa mall",
        "supplier-admin-nav-item-pos-settings-template-edit": "Redigera mall",
        "supplier-admin-nav-item-company-account":"Företagskonto",
        "supplier-admin-nav-item-account-gdpr":"GDPR",
        "supplier-admin-nav-item-erp":"ERP",
        "supplier-admin-nav-item-acquiring-fees": "Inlösenavgifter",
        "supplier-admin-nav-item-bank-transfers":"Banköverföringar",
        "supplier-admin-nav-item-product-numbers":"Produktnummer",
        "supplier-admin-nav-item-create-product-group-number":"Skapa produktnummer",
        "supplier-admin-nav-item-update-product-group-number":"Uppdatera produktnummer",
        "supplier-admin-nav-item-create-terms-and-conditions": "Skapa försäljningsvillkor",
        "supplier-admin-nav-item-update-terms-and-conditions": "Uppdatera försäljningsvillkor",

        // Supplier > Reports > Home

        // Supplier > Reports > Home > Accounting > Meeting Service
        "supplier-meeting-service-header": "\n .title = Mötesförtäring",
        "supplier-meeting-service-table-merchant": "Försäljningsställe",
        "supplier-meeting-service-table-order-id-column": "Order-ID",
        "supplier-meeting-service-order-id-label": "\n .label = Order-ID",
        "supplier-meeting-service-table-booked-date-column": "Bokföringsdatum",
        "supplier-meeting-service-table-delivery-time-column": "Leveranstid",
        "supplier-meeting-service-table-employee-column": "Försäljningsställe",
        "supplier-meeting-service-table-status":"Status",
        "supplier-meeting-service-table-status-confirmed":"Bekräftad",
        "supplier-meeting-service-table-status-canceled":"Annullerad",
        "supplier-meeting-service-table-amount-column": "Belopp (DKK)",
        "supplier-meeting-service-table-show-receipt": "Visa kvitto",
        "supplier-meeting-service-table-floating-action-bar-receipts": "\n .title = Kvitton",
        "supplier-meeting-service-table-floating-action-bar-export": "\n .title = Exportera",
        "supplier-meeting-service-order-title":"\n .title = Order",
        "supplier-meeting-service-drawer-pending-approval-label":"\n .label = Väntar på godkännande",
        "supplier-meeting-service-invoicing-title":"\n .title = Fakturering",
        "supplier-meeting-service-drawer-invoice-status-label":" Fakturastatus",
        "supplier-meeting-service-drawer-invoice-status-all-label":"Alla",
        "supplier-meeting-service-drawer-invoice-status-sent-label":"Skickad",
        "supplier-meeting-service-drawer-invoice-status-not-sent-label":"Ej skickad",
        "supplier-meeting-service-drawer-booked-label":"Bokförd",
        "supplier-meeting-service-drawer-booked-all-label":"Alla",
        "supplier-meeting-service-drawer-booked-booked-label":"Bokförd",
        "supplier-meeting-service-drawer-booked-not-booked-label":"Ej bokförd",
        "supplier-meeting-service-booked-date-title":"\n .title = Bokföringsdatum",
        "supplier-meeting-service-delivery-date-title":"\n .title = Leveransdatum",
        "supplier-meeting-service-merchant-title":"\n .title = Försäljningsställe",
        "supplier-meeting-service-debtor-title":"\n .title = Debitor",
        "supplier-meeting-service-end-user-title":"\n .title = Slutanvändare",
        "supplier-meeting-service-payment-title":"\n .title = Betalning",
        "supplier-meeting-service-drawer-from-date-label":"\n .label = Från datum",
        "supplier-meeting-service-drawer-to-date-label":"\n .label = Till datum",
        "supplier-meeting-service-drawer-bill-receivers-label":"Fakturamottagare",
        "supplier-meeting-service-drawer-bill-receivers-select-company-helper-text":"Välj först ett företag för att filtrera på fakturamottagare",
        "supplier-meeting-service-drawer-satellites-label":"Satelliter",
        "supplier-meeting-service-drawer-to-date-info-label":"\n .title = Använd inte leveransdatum för fakturering. Använd bokföringsdatum i stället.",

        // Supplier > Reports > Home > Accounting > POS
        "supplier-pos-table-header-title": "\n .title = POS",
        "supplier-pos-table-header-order-id": "Order-ID",
        "supplier-pos-table-header-transaction-time": "Transaktionstid",
        "supplier-pos-table-header-merchant-name": "Försäljningsställets namn",
        "supplier-pos-table-header-employee": "Skapad av",
        "supplier-pos-table-header-payment": "Betalningsmetod",
        "supplier-pos-table-header-payment-channel": "Kanal",
        "supplier-pos-table-header-amount": "Belopp (DKK)",
        "supplier-pos-table-table-button-show-receipt": "Visa kvitto",
        "supplier-pos-table-filters-order-title":"\n .title = Order",
        "supplier-pos-table-filters-period-title":"\n .title = Period",
        "supplier-pos-table-filters-merchant-title":"\n .title = Försäljningsställe",
        "supplier-pos-table-filters-debtor-title":"\n .title = Debitor",
        "supplier-pos-table-filters-end-user-title":"\n .title = Slutanvändare",
        "supplier-pos-table-filters-payment-title":"\n .title = Betalning",
        "supplier-pos-table-filters-from-date-label":"\n .label = Transaktion från datum",
        "supplier-pos-table-filters-to-date-label":"\n .label = Transaktion till datum",

        // Supplier > Reports > Home > Accounting > Subscriptions
        "supplier-subscriptions-header": "\n .title = Abonnemang",
        "supplier-subscriptions-table-order-id-column": "Order-ID",
        "supplier-subscriptions-table-employee-column": "Anställd",
        "supplier-subscriptions-table-subscribed-column": "Anmäld",
        "supplier-subscriptions-table-unsubscribed-column": "Avanmäld",
        "supplier-subscriptions-table-payment-column": "Betalningsmetod",
        "supplier-subscriptions-table-amount-column": "Belopp",
        "supplier-subscriptions-table-cancel-subscription": "Säg upp abonnemang",
        "supplier-subscriptions-table-details": "Detaljer",
        "supplier-subscriptions-table-filters-order-title":"\n .title = Order",
        "supplier-subscriptions-table-filters-period-title":"\n .title = Period",
        "supplier-subscriptions-table-filters-from-date-label":"\n .label = Giltig från datum",
        "supplier-subscriptions-table-filters-to-date-label":"\n .label = Giltig till datum",
        "supplier-subscriptions-table-filters-merchant-title":"\n .title = Försäljningsställe",
        "supplier-subscriptions-table-filters-debtor-title":"\n .title = Debitor",
        "supplier-subscriptions-table-filters-end-user-title":"\n .title = Slutanvändare",
        "supplier-subscriptions-table-filters-payment-title":"\n .title = Betalning",
        "supplier-subscriptions-drawer-subscription-label":"Abonnemang",


        // Supplier > Reports > Home > Accounting > Z-reports
        "supplier-accounting-z-reports-page-header":" \n .title = Z-rapporter",
        "supplier-accounting-z-reports-table-date-column":"Datum",
        "supplier-accounting-z-reports-table-pos-terminal-column":"POS-enhet",
        "supplier-accounting-z-reports-table-amount-column":"Belopp",

        // Supplier > Reports > Home > Accounting > Merchant Sales
        "supplier-merchant-sales-header": "\n .title = Försäljning per försäljningsställe",
        "supplier-merchant-sales-table-shop-type": "\n .label = Butikstyp",
        "supplier-merchant-sales-table-red-no-column": "Ärendenr",
        "supplier-merchant-sales-table-name-column": "Namn",
        "supplier-merchant-sales-table-upcoming-sales-column": "Kommande försäljning ({ $currencyCode })",
        "supplier-merchant-sales-table-booked-sales-column": "Bokförd försäljning ({ $currencyCode })",
        "supplier-merchant-sales-table-floating-action-bar-export": "\n .title = Exportera",
        "supplier-merchant-sales-table-shop-type-input-label": "Butikstyp",
        "supplier-merchant-sales-table-shop-type-item-pos": "POS",
        "supplier-merchant-sales-table-shop-type-item-meeting-service": "Mötesförtäring",
        "supplier-merchant-sales-table-shop-type-item-subscription": "Abonnemang",
        "supplier-merchant-sales-detailed-table-total-footer-column": "Totalt",
        "supplier-merchant-sales-detailed-table-sales-column": "Försäljning (DKK)",

        // Supplier > Reports > Home > Accounting > Customer Sales
        "supplier-customer-sales-header": "\n .title = Kundförsäljning",
        "supplier-customer-sales-table-name-column": "Namn",
        "supplier-customer-sales-table-upcoming-sales-column": "Kommande försäljning ({ $currencyCode })",
        "supplier-customer-sales-table-booked-sales-column": "Bokförd försäljning ({ $currencyCode })",
        "supplier-customer-sales-table-floating-action-bar-export": "\n .title = Exportera",
        "supplier-customer-sales-detailed-table-total-footer-column": "Totalt",
        "supplier-customer-sales-detailed-table-sales-column": "Försäljning (DKK)",


        // Supplier > Admin > Home
        "supplier-admin-home-merchants-group": "\n .title = Försäljningsställen",
        "supplier-admin-home-merchant-card": "\n .title = Försäljningsställen\n .description = Hantera försäljningsställen, som är fysiska försäljningsplatser, t.ex. kantiner.",
        "supplier-admin-home-administrators-card": "\n .title = Administratörer\n .description = Hantera leverantörs- och försäljningsställeadministratörer.",
        "supplier-admin-home-devices-card": "\n .title = Enheter\n .description = Hantera enheter, till exempel POS-surfplattor, incheckningsskärmar och skrivare.",
        "supplier-admin-home-settings-group": "\n .title = Inställningar",
        "supplier-admin-home-payment-acquiring-card": "\n .title = Kortinlösen\n .description = Hantera och kontrollera status för avtal om kortinlösen.\n .buttonText = Visa",
        "supplier-admin-home-terms-and-conditions-card": "\n .title = Försäljningsvillkor\n .description = Hantera dina försäljningsvillkor som visas för dina kunder.",
        "supplier-admin-home-pos-settings-card": "\n .title = POS-inställningar \n .description = Hantera POS-inställningar.",
        "supplier-admin-home-account-group":  "\n .title = Konto",
        "supplier-admin-home-company-account-card":  "\n .title = Företagskonto\n .description = Hantera ditt företagskonto.\n .buttonText = Visa",
        "supplier-admin-home-erp-group":  "\n .title = ERP",
        "supplier-admin-home-product-numbers-card":  "\n .title = Produktnummer\n .description = Hantera produktnummer för ERP-integration.",
        "supplier-admin-home-account-gdpr-card":  "\n .title = GDPR \n .description = Dataskyddsförordningen \n .buttonText = Visa",
        "supplier-admin-home-acquiring-reports-group":  "\n .title = Avstämning",
        "supplier-admin-home-bank-transfers-card":  "\n .title = Banköverföringar\n .description = Rapport över överföringar mellan dina inlösenkonton och bankkonton.\n .buttonText = Visa",
        "supplier-admin-home-acquiring-fees":  "\n .title = Inlösenavgifter\n .description = Rapport över inlösenavgifter. Användbar för avstämning.\n .buttonText = Visa",
        "supplier-admin-home-balance":  "\n .title = Saldo\n .description = Rapport som visar total försäljning, avgifter och överföringar för en period.\n .buttonText = Visa",

        // Supplier > Admin > Devices
        "supplier-admin-devices-page-header": "\n .title = Enheter",

        // Supplier > Admin > ERP > Product Group Numbers
        "supplier-admin-erp-product-group-numbers-header": "\n .title = Produktnummer",
        "supplier-admin-erp-product-group-numbers-create-new-button":"Skapa ny",
        "supplier-admin-erp-product-group-numbers-save-button":"Spara",
        "supplier-admin-erp-product-group-numbers-table-header-erp-number":"ERP-nr",
        "supplier-admin-erp-product-group-numbers-table-header-name":"Namn",
        "supplier-admin-erp-product-group-numbers-table-header-status":"Status",
        "supplier-admin-erp-product-group-numbers-table-active-column-active":"Aktiv",
        "supplier-admin-erp-product-group-numbers-table-active-column-inactive":"Inaktiv",
        "supplier-admin-erp-product-group-numbers-table-active-filter-yes":"Aktiv",
        "supplier-admin-erp-product-group-numbers-table-active-filter-no":"Inaktiv",
        "supplier-admin-erp-product-group-numbers-table-button-edit":"Redigera",
        "supplier-admin-erp-product-group-numbers-table-button-delete":"Ta bort",
        "supplier-admin-erp-product-group-numbers-delete-entity-dialog":"\n .typeOfEntity = produktnummer",

        // Supplier > Admin > ERP > Product Group Numbers > Create/Update
        "supplier-admin-erp-product-group-numbers-create-header": "\n .title = Skapa produktnummer",
        "supplier-admin-erp-product-group-numbers-update-header": "\n .title = Redigera produktnummer",
        "supplier-admin-erp-product-group-numbers-create-button":"Skapa",
        "supplier-admin-erp-product-group-numbers-field-code":"\n .label = ERP-nummer",
        "supplier-admin-erp-product-group-numbers-field-name":"\n .label = Namn",
        "supplier-admin-erp-product-group-numbers-description":"\n .label = Beskrivning\n .placeholder = Här kan du förklara avsedd användning av det här produktnumret",
        "supplier-admin-erp-product-group-numbers-required-code":"ERP-nummer krävs",
        "supplier-admin-erp-product-group-numbers-required-name":"Namn krävs",
        "supplier-admin-erp-product-group-numbers-aside-settings":"\n .title = Inställningar",
        "supplier-admin-erp-product-group-numbers-active":"Aktiv:",
        "supplier-admin-erp-product-group-numbers-history":"\n .title = Historik",
        "supplier-admin-erp-product-group-numbers-aside-created":"Skapad:",
        "supplier-admin-erp-product-group-numbers-aside-updated":"Uppdaterad:",

        // DEVICE TABLE GENERAL
        "devices-table-header-name": "Namn",
        "devices-table-header-group": "Grupp",
        "devices-table-header-type": "Typ",
        "devices-table-header-status": "Status",
        "devices-table-button-details": "Detaljer",
        "devices-table-button-edit": "Redigera",
        "devices-table-status-column-online": "Online",
        "devices-table-status-column-offline": "Offline",
        "devices-table-header-reg": "Reg.nr",
        "devices-table-header-merchant": "Försäljningsställe",

        // DEVICE DETAILS
        "device-details-title": "Enhetsinformation",
        "device-details-type-info-shop": "\n .label = Butik:",
        "device-details-type-info-device-number": "\n .label = Enhetsnummer:",
        "device-details-type-info-serial-number": "\n .label = Serienummer:",
        "device-details-type-info-hardware-id": "\n .label = Hårdvaru-ID:",
        "device-details-type-info-language": "\n .label = Språk:",
        "device-details-type-info-pos-mode": "\n .label = POS-läge:",
        "device-details-type-info-card-terminal-acquirer-name": "\n .label = Namn på kortterminalens inlösare:",
        "device-details-status-info-title": "\n .title = Status",
        "device-details-status-info-diagnostics-title": "\n .title = Visa diagnostik",
        "device-details-status-info-diagnostics-subject": "Ämne",
        "device-details-status-info-diagnostics-message": "Meddelande",
        "device-details-pin-code-info-title": "\n .title = PIN-kod",
        "device-details-pin-code-info-helper": "\n .title = PIN-kod: \n .description = PIN-koden används för att få åtkomst till administrationsmenyer på enheten.",
        "device-details-group-info-title": "\n .title = Grupp",
        "device-details-group-info-name": "\n .label = Namn:",
        "device-details-group-info-connected-devices": "\n .label = Anslutna enheter:",
        "device-details-group-table-header-name": "Namn",
        "device-details-group-table-header-type": "Typ",
        "device-details-group-table-header-status": "Status",
        "device-details-device-info-title": "\n .title = Enhet",
        "device-details-device-info-name": "\n .label = Namn:",
        "device-details-device-info-shop": "\n .label = Butik:",
        "device-details-device-info-device-number": "\n .label = Enhetsnummer:",
        "device-details-identification-info-title": "\n .title = Identifiering",
        "device-details-identification-info-serial-number": "\n .label = Serienummer:",
        "device-details-identification-info-hardware-id": "\n .label = Hårdvaru-ID:",
        "device-details-identification-info-acquirer": "\n .label = Namn på kortterminalens inlösare:",
        "device-details-settings-info-title": "\n .title = Inställningar",
        "device-details-settings-info-language": "\n .label = Språk:",
        "device-details-settings-info-pos-mode": "\n .label = POS-läge:",
        "device-details-settings-info-pin-code-info": "PIN-koden används för att komma åt skyddade områden i appen.",
        "device-details-history-info-title": "\n .title = Historik",
        "device-details-history-info-created": "\n .label = Skapad:",
        "device-details-history-info-edited": "\n .label = Redigerad:",
        "device-details-type-mode-cloud-pos": "GoPay CloudPOS",
        "device-details-type-mode-soft-pos": "GoPay SoftPOS",
        "device-details-type-mode-display": "Display",
        "device-details-type-mode-cloud-credit-card-reader": "Molnskrivare",
        "device-details-type-mode-star-cloud-printer": "Molnkortläsare",
        "device-details-type-mode-receipt-control": "Kvittokontroll",
        "device-details-type-mode-room-display": "Rumsdisplay",
        "device-details-type-mode-meeting-display": "Mötesdisplay",
        "device-details-type-mode-guest-check-in": "Gästincheckning",
        "device-details-group-table-device-type-filter-label": "Enhetstyp",
        "device-details-group-table-device-type-filter-placeholder": "Alla",
        "device-details-group-table-device-type-filter-label-label": "\n .label = Enhetstyp",
        "devices-table-select-filter-on-item-room-display": "Rumsdisplay",
        "devices-table-select-filter-on-item-meeting-display": "Mötesdisplay",
        "devices-table-select-filter-on-item-guest-check-in": "Gästincheckning",


        // Create or edit device
        "service-center-admin-organization-create-devices-title": "\n .title = Skapa display",
        "service-center-admin-organization-edit-devices-title": "\n .title = Redigera display",
        "devices-create-device-form": "Skapa",
        "devices-edit-device-form": "Spara",
        "devices-edit-breadcrumb": "Redigera display",
        "devices-create-breadcrumb": "Skapa display",
        "devices-create-or-edit-form-select-template-label": "\n .label = Mall",
        "devices-create-or-edit-form-select-field-name": "\n .label = Namn",
        "devices-create-or-edit-form-select-field-device-number": "\n .label = Enhetsnummer",
        "devices-create-or-edit-form-floor-label": "\n .label = Våning",
        "devices-create-or-edit-form-select-field-room": "\n .label = Rum",
        "devices-create-or-edit-form-select-field-serial-number": "\n .label = Serienummer",
        "devices-create-or-edit-form-select-display-type": "\n .label = Displaytyp",
        "devices-create-or-edit-form-type-room-details-info": "\n .title = Rumsdisplayer sätts upp framför mötesrum för att visa om rummet är ledigt eller upptaget. De erbjuder också ett enkelt sätt att boka rummet.",
        "devices-create-or-edit-form-type-meeting-details-info": "\n .title = Mötesdisplayer sätts vanligtvis upp på varje våning och är utformade för att visa var man ska gå för sitt möte.",

        "devices-create-or-edit-form-display-type-dropdown-item-room-display": "Rumsdisplay",
        "devices-create-or-edit-form-display-type-dropdown-item-meeting-display": "Mötesdisplay",
        "devices-create-or-edit-form-display-type-dropdown-item-guest-check-in": "Gästincheckning",

        // Display types
        "display-types-dropdown-select-item-room-display": "Rumsdisplay",

        // Supplier > Admin > POS settings
        "supplier-admin-pos-settings-page-header": "\n .title = POS-inställningar",
        "supplier-admin-pos-settings-tab-templates": "Mallar",
        "supplier-admin-pos-settings-tab-general": "Allmänt",
        "supplier-admin-pos-settings-create-button": "Skapa ny",
        "supplier-admin-pos-settings-templates-table-header-name": "Namn",
        "supplier-admin-pos-settings-templates-table-header-language": "Språk",
        "supplier-admin-pos-settings-templates-table-header-status": "Status",
        "supplier-admin-pos-settings-templates-table-edit-button": "Redigera",
        "supplier-admin-pos-settings-templates-table-duplicate-button": "Duplicera",
        "supplier-admin-pos-settings-templates-table-delete-button": "Ta bort",
        "supplier-admin-pos-settings-templates-table-status-column-active":"Används",
        "supplier-admin-pos-settings-templates-table-status-column-inactive":"Används inte",
        "supplier-admin-pos-settings-templates-table-status-column-active-filter-yes": "Används",
        "supplier-admin-pos-settings-templates-table-status-column-inactive-filter-no": "Används inte",

        // Supplier > Admin > POS settings > Templates > Create / Edit
        "supplier-admin-pos-settings-create-template-page-header": "\n .title = Skapa mall",
        "supplier-admin-pos-settings-edit-template-page-header": "\n .title = Redigera mall",
        "supplier-admin-pos-settings-create-submit-button": "Skapa",
        "supplier-admin-pos-settings-edit-submit-button": "Spara",
        "supplier-admin-pos-settings-template-shortcuts": "\n .title = Genvägar",
        "supplier-admin-pos-settings-template-name-field-label": "\n .label = Mallnamn",
        "supplier-admin-pos-settings-template-languageCode-field-label": "\n .label = Språk",
        "supplier-admin-pos-settings-lang-en": "Engelska",
        "supplier-admin-pos-settings-lang-da": "Danska",
        "supplier-admin-pos-settings-template-button-field-label": "\n .label = Knapptext \n .helperText = Anpassa texten på knappen för att starta köp.",
        "supplier-admin-pos-settings-template-title-field-label": "\n .label = Titel",
        "supplier-admin-pos-settings-template-subtitle-field-label": "\n .label = Undertitel",
        "supplier-admin-pos-settings-template-companyLogo-field-label": "\n .label = Ladda upp företagslogotyp:",
        "supplier-admin-pos-settings-template-companyLogo-info": "Bildtips: bakgrunden bör vara genomskinlig. Vi rekommenderar en bild på 180x180 px med logotypen centrerad.",
        "supplier-admin-pos-settings-template-shortcuts-help-field": "Hjälp / villkor:",
        "supplier-admin-pos-settings-template-shortcuts-downloadApp-field": "Ladda ner GoPay-appen:",
        "supplier-admin-pos-settings-template-frontpage-layout": "Startsidans layout",
        "supplier-admin-pos-settings-template-select-theme-style": "Välj temastil:",

        // Supplier > Admin > POS settings > General
        "supplier-admin-pos-settings-general-submit-button": "Spara",
        "supplier-admin-pos-settings-general-defaultLanguage-field-label": "\n .label = Standardspråk \n .helperText = Kan justeras på varje enhet.",
        "supplier-admin-pos-settings-general-posPrintingMode-field-label": "\n .label = Utskriftsläge för kvitto",
        "supplier-admin-pos-settings-general-posPrintingMode-option-qr-only": "Endast QR-kod",
        "supplier-admin-pos-settings-general-posPrintingMode-option-auto": "Automatisk utskrift",
        "supplier-admin-pos-settings-general-posPrintingMode-option-manually": "Manuell utskrift",
        "supplier-admin-pos-settings-general-info": "Utskriftsläget styr hur kvittot görs tillgängligt för kunden. “Automatisk utskrift” skriver automatiskt ut ett papperskvitto, medan “Manuell utskrift” låter användaren skriva ut ett papperskvitto eller skanna en QR-kod för att få ett digitalt kvitto. Välj “Endast QR-kod” om du vill ha ett pappersfritt POS-system.",
        "supplier-admin-pos-settings-general-configuration-for-supporters": "Inställningar för supportpersonal",
        "supplier-admin-pos-settings-general-configuration-for-supporters-returnToHomeScreenDelay-field-label": "\n .label = Fördröjning innan återgång till startskärmen",
        "supplier-admin-pos-settings-general-configuration-for-supporters-returnToHomeAfterPurchase-field-label": "\n .label = Återgå till start efter köp",
        "supplier-admin-pos-settings-general-configuration-for-supporters-ms": "ms",

        // Supplier > Admin > Merchant Access
        "supplier-merchant-access-page-header": "\n .title = Försäljningsställen",
        "supplier-merchant-access-table-header-case-no": "Ärendenr",
        "supplier-merchant-access-table-header-name": "Namn",
        "supplier-merchant-access-table-header-address": "Adress",
        "supplier-merchant-access-table-details-no-companies": "Det finns inga anslutna företag",
        "supplier-merchant-access-table-details-customers-title":"Kunder:",

        // Supplier > Admin > Acquiring
        "supplier-admin-pos-acquirer-page-header": "\n .title = Avtal om kortinlösen",
        "supplier-admin-pos-acquirer-adyen-question":"Vem är Adyen?",
        "supplier-admin-pos-acquirer-adyen-answer":"Adyen är vårt betalningsföretag för kreditkort med status som inlösande bank, vilket gör att du kan ta emot kortbetalningar. Adyen ansvarar för att behandla betalningar för ditt företag. Innan du kan ta emot betalkort måste du ansöka om ett avtal med Adyen.",
        "supplier-admin-pos-acquirer-adyen-read-more":"Läs mer: <externalLink>{ $adyenWebsite }</externalLink>",
        "supplier-admin-pos-acquirer-status-title":"Status:",
        "supplier-admin-pos-acquirer-status-create-business-lines": "Inga branschkoder",
        "supplier-admin-pos-acquirer-status-info-create-business-lines": "Du måste välja dina branscher innan du kan ansöka.",
        "supplier-admin-pos-acquirer-status-action-create-business-lines": "Lägg till en eller flera branschkoder nedan.",
        "supplier-admin-pos-acquirer-status-start": "Starta ansökan",
        "supplier-admin-pos-acquirer-status-info-start": "Du är nu redo att påbörja ansökan hos inlösaren.",
        "supplier-admin-pos-acquirer-status-action-start": "Starta ansökan nedan.",
        "supplier-admin-pos-acquirer-status-pending": "Under behandling",
        "supplier-admin-pos-acquirer-status-info-pending": "Verifiering pågår.",
        "supplier-admin-pos-acquirer-status-action-pending": "Vänta på att inlösaren verifierar din ansökan.",
        "supplier-admin-pos-acquirer-status-invalid": "Ogiltig",
        "supplier-admin-pos-acquirer-status-info-invalid": "Det finns fel i de angivna uppgifterna.",
        "supplier-admin-pos-acquirer-status-action-invalid": "Rätta din ansökan.",
        "supplier-admin-pos-acquirer-status-valid": "Godkänd",
        "supplier-admin-pos-acquirer-status-info-valid": "Din ansökan har godkänts.",
        "supplier-admin-pos-acquirer-status-check-valid":"Du är nu redo att ställa in kortbetalningar för dina försäljningsställen.",
        "supplier-admin-pos-acquirer-status-rejected": "Avvisad",
        "supplier-admin-pos-acquirer-status-info-rejected": "Inlösaren har verifierat uppgifterna men har funnit skäl att inte samarbeta med din organisation.",
        "supplier-admin-pos-acquirer-start-application-button": "Starta ansökan hos Adyen",
        "supplier-admin-pos-acquirer-continue-application-button": "Fortsätt ansökan hos Adyen",
        "supplier-admin-pos-acquirer-status-no-payment-title": "Du har inget avtal om kortinlösen.",
        "supplier-admin-pos-acquirer-status-no-payment-error": "Inga tillgängliga inlösare",
        "supplier-admin-acquiring-terms-and-conditions-title": "Krav på försäljningsvillkor",
        "supplier-admin-acquiring-terms-and-conditions-explanation": "För att fortsätta måste du godkänna inlösarens krav på dina <requirementsLink>försäljningsvillkor</requirementsLink>. Dessa villkor måste vara tydligt synliga för dina kunder på din webbplats.",
        "supplier-admin-acquiring-terms-and-conditions-template-text": "Du kan ladda ner vår mall för försäljningsvillkor <templateLink>här</templateLink>.",
        "supplier-admin-acquiring-terms-and-conditions-label": "\n .label = Jag förbinder mig att uppfylla dessa krav.",
        "supplier-admin-acquiring-accept-terms-dialog-title": "Godkänn krav på försäljningsvillkor",
        "supplier-admin-acquiring-accept-terms-dialog-description": "Är du säker på att du vill godkänna kraven på försäljningsvillkoren?",
        "supplier-admin-acquiring-accept-terms-dialog-button": "Godkänn",
        "supplier-acquiring-industry-codes-accordion-industry-codes-title": "Branschkoder",
        "supplier-acquiring-industry-codes-accordion-industry-codes-info-box": "\n .description = Om du ansöker för en kantin, välj branschkod 722514 - kaféer, grillbufféer.",
        "supplier-acquiring-industry-codes-table-industry-code-column": "Branschkod",
        "supplier-acquiring-industry-codes-table-description-column": "Beskrivning",
        "supplier-acquiring-industry-codes-table-remove-action": "Ta bort",
        "supplier-acquiring-industry-codes-add-industry-code": "Lägg till ny branschkod",
        "supplier-acquiring-industry-codes-info-text": "Branschkoder beskriver dina verksamhetsområden och avgör vilka typer av varor du får sälja i dina butiker. Vissa branschkoder kräver godkännande från inlösaren. Se alla branschkoder <industryCodesLink>här</industryCodesLink>.",
        "supplier-acquiring-industry-codes-confirm-delete-dialog": "\n .title = Ta bort branschkod\n .message = Vill du ta bort branschkoden { $industryCode }?\n .buttonLabelSubmit = Ta bort",
        "supplier-acquiring-bank-accounts-accordion-bank-accounts-title": "Bankkonton",
        "supplier-acquiring-bank-accounts-table-bank-name-column": "Bank",
        "supplier-acquiring-bank-accounts-table-account-column": "Konto",
        "supplier-acquiring-bank-accounts-table-merchant-caseno-column": "Ärendenr",
        "supplier-acquiring-bank-accounts-table-merchant-column": "Försäljningsställe",
        "supplier-acquiring-bank-accounts-table-status-column": "Status",
        "supplier-acquiring-bank-accounts-table-remove-action": "Ta bort",
        "supplier-acquiring-bank-accounts-add-bank-account": "Lägg till nytt bankkonto",
        "supplier-acquiring-bank-accounts-info-text": "Om du vill att försäljningen ska överföras till ett separat bankkonto för varje försäljningsställe kan du lägga till bankkontot här. Se <guideLink>guiden</guideLink> för hur du lägger till ett nytt bankkonto på Adyen-plattformen och därefter kopplar bankkontot till ditt försäljningsställe.",
        "supplier-acquiring-bank-accounts-status-pending": "Under behandling",
        "supplier-acquiring-bank-accounts-status-invalid": "Ogiltig",
        "supplier-acquiring-bank-accounts-status-valid": "Giltig",
        "supplier-acquiring-bank-accounts-status-rejected": "Avvisad",
        "supplier-acquiring-bank-accounts-confirm-delete-dialog": "\n .title = Ta bort bankkonto\n .message = Vill du ta bort bankkontot { $accountIdentifier }?\n .buttonLabelSubmit = Ta bort",
        "supplier-acquiring-industry-codes-button-add": "Lägg till",
        "supplier-acquiring-industry-codes-button-save": "Spara",
        "supplier-acquiring-industry-codes-alert-title": " Om du lägger till nya branschkoder kan statusen för ditt avtal om kortinlösen ändras till under behandling om inlösaren behöver verifiera.",

       // Supplier > Admin > Reconciliation
       "supplier-acquiring-reports": "Avstämning",
       "supplier-acquiring-reports-table-booked-time-column": "Bokförd tid",
       "supplier-acquiring-reports-table-merchant-label": "\n .label = Försäljningsställe",
       "supplier-acquiring-reports-table-adyen-account-label": "\n .label = Adyen-konto",
       "supplier-acquiring-reports-table-merchant-column": "Försäljningsställe",
       "supplier-acquiring-reports-table-amount-column": "Belopp",

       // Supplier > Admin > Reconciliation > Fees
       "supplier-acquiring-fees-header": "\n .title = Inlösenavgifter",
       "supplier-acquiring-fees": "Inlösenavgifter",
       "supplier-acquiring-fees-table-order-id-column": "Order-ID",
       "supplier-acquiring-fees-table-psp-reference-column": "PSP-referens",
       "supplier-acquiring-fees-table-available-date-column": "Tillgängligt datum",
       "supplier-acquiring-fees-table-type-column": "Typ",
       "supplier-acquiring-fees-table-select-filter-on-label": "Filtrera på",
       "supplier-acquiring-fees-table-select-filter-on-label-label": "\n .label = Filtrera på",
        "supplier-acquiring-fees-table-select-filter-on-item-booking-date": "Bokföringsdatum",
        "supplier-acquiring-fees-table-select-filter-on-item-value-date": "Tillgängligt datum",
       "supplier-acquiring-fees-table-type-mode-payment": "Betalning",
       "supplier-acquiring-fees-table-type-mode-transfer": "Överföring",
       "supplier-acquiring-fees-table-type-mode-refund": "Återbetalning",
       "supplier-acquiring-fees-table-number-of-transactions": "\n .title = Antal transaktioner",
       "supplier-acquiring-fees-table-info-banner": "\n .description = Data för den här rapporten blir tillgänglig nästa dag, så du kan inte se transaktioner för i dag.",

       // Supplier > Admin > Reconciliation > Bank transfers
       "supplier-acquiring-bank-transfers-header": "\n .title = Banköverföringar",
       "supplier-acquiring-bank-transfers": "Banköverföringar",
       "supplier-acquiring-bank-transfers-table-transfer-id-column": "Överförings-ID",
       "supplier-acquiring-bank-transfers-table-available-time-column": "Tillgänglig tid",
       "supplier-acquiring-bank-transfers-table-bank-account-column": "Bankkonto",
       "supplier-acquiring-bank-transfers-table-details-menu-item": "Detaljer",
       "supplier-acquiring-bank-transfers-table-number-of-transfers": "\n .title = Antal överföringar",
       "supplier-acquiring-bank-transfers-table-info-banner": "\n .description = Data för den här rapporten blir tillgänglig nästa dag, så du kan inte se banköverföringar för i dag eller kommande överföringar.",
        "supplier-acquiring-bank-transfers-table-details-table-order-id-column": "Order-ID",
        "supplier-acquiring-bank-transfers-table-details-table-psp-reference-column": "PSP-referens",
        "supplier-acquiring-bank-transfers-table-details-table-booked-column": "Bokförd",
        "supplier-acquiring-bank-transfers-table-details-table-available-column": "Tillgänglig",
        "supplier-acquiring-bank-transfers-table-details-table-gross-column": "Brutto",
        "supplier-acquiring-bank-transfers-table-details-table-net-column": "Netto",
        "supplier-acquiring-bank-transfers-table-details-table-fee-column": "Avgift",
        "supplier-acquiring-bank-transfers-details-dialog-title": "\n .dialogTitle = Överföringsdetaljer\n .subtitle = Period: { $periodStart} - { $periodEnd }",
        "supplier-acquiring-bank-transfers-details-dialog-title-no-start-date": "Avtalsstart",
        "supplier-acquiring-bank-transfers-details-dialog-number-of-orders": "\n .title = Antal ordrar",
        "supplier-acquiring-bank-transfers-details-dialog-table-gross-total": "\n .title = Brutto totalt",
        "supplier-acquiring-bank-transfers-details-dialog-table-fee-total": "\n .title = Avgift totalt",
        "supplier-acquiring-bank-transfers-details-dialog-table-net-total": "\n .title = Netto totalt",

       // Supplier > Admin > Reconciliation > Balance
       "supplier-overview-header": "\n .title = Saldo",
       "supplier-overview-table-amount": "Belopp",
       "supplier-overview-table-account": "Konto",
       "supplier-overview-table-view-details": "Visa detaljer",
       "supplier-overview-balance-details-dialog": "\n .dialogTitle = Saldodetaljer\n .subtitle = Period: { $periodStart} - { $periodEnd }",
       "supplier-overview-balance-details-dialog-select-order": "Visa ordrar",
       "supplier-overview-balance-details-dialog-select-order-label": "\n .label = Visa ordrar",
       "supplier-overview-balance-details-dialog-select-order-mode-net-sales": "Nettoomsättning",
       "supplier-overview-balance-details-dialog-select-order-mode-bank-transfers": "Banköverföringar",
       "supplier-overview-balance-details-dialog-select-order-mode-balance": "Saldo",
       "supplier-overview-balance-details-dialog-compact-view-label": "Visa bruttoomsättning och avgifter",
       "supplier-overview-balance-details-dialog-table-order-id-column": "Order-ID",
       "supplier-overview-balance-details-dialog-table-rsp-reference-column": "PSP-referens",
       "supplier-overview-balance-details-dialog-table-booked-column": "Bokförd",
       "supplier-overview-balance-details-dialog-table-available-column": "Tillgänglig",
       "supplier-overview-balance-details-dialog-table-gross-column": "Brutto",
       "supplier-overview-balance-details-dialog-table-fee-column": "Avgift",
       "supplier-overview-balance-details-dialog-table-net-column": "Netto",
       "supplier-overview-balance-details-dialog-table-effective-column": "Effektivt belopp",
       "supplier-overview-balance-details-dialog-table-type-column": "Typ",
       "supplier-overview-balance-details-dialog-table-payment-type-bank-transfer": "Utbetalning",
       "supplier-overview-balance-details-dialog-table-payment-type-previous-revenue": "Tidigare inbetalt",
       "supplier-overview-balance-details-dialog-table-payment-type-deferred-revenue": "Förskotterad avgift",
       "supplier-overview-balance-details-dialog-table-payment-type-normal-revenue": "Intäkt",
       "supplier-overview-balance-details-dialog-table-payment-type-accrued-revenue": "Fordran",
       "supplier-overview-balance-details-dialog-number-of-orders": "\n .title = Antal ordrar",
       "supplier-overview-balance-details-dialog-table-effective-total": "\n .title = Totalt effektivt belopp",
       "supplier-overview-balance-details-dialog-table-gross-total": "\n .title = Brutto totalt",
       "supplier-overview-balance-details-dialog-table-fee-total": "\n .title = Avgift totalt",
       "supplier-overview-balance-details-dialog-table-net-total": "\n .title = Netto totalt",

        // Supplier > Admin > Merchants
        "supplier-admin-merchants-header": "\n .title = Försäljningsställen",
        "supplier-admin-merchants-create-button": "Skapa ny",
        "supplier-admin-merchants-table-edit-button": "Redigera",
        "supplier-admin-merchants-table-delete-button": "Ta bort",
        "supplier-admin-merchants-table-delete-modal-title": "försäljningsställe",
        "supplier-admin-merchants-table-reg-no-column": "Reg.nr",
        "supplier-admin-merchants-table-merchant-column": "Försäljningsställe",
        "supplier-admin-merchants-table-connected-shops": "Butiker:",
        "supplier-admin-merchants-table-connected-customers": "Kunder:",
        "supplier-admin-merchants-table-connected-devices": "Enheter:",
        "supplier-admin-merchant-create-title": "\n .title = Skapa försäljningsställe",
        "supplier-admin-merchant-edit-title": "\n .title = Redigera försäljningsställe",
        "supplier-admin-merchants-save-button": "Spara",
        "create-or-edit-supplier-admin-merchant-field-caseNumber": "\n .label = Reg.nr\n .placeholder = Ange reg.nr\n .helperText = Ert interna referensnummer för detta försäljningsställe",
        "create-or-edit-supplier-admin-merchant-field-name": "\n .label = Namn\n .placeholder = Ange namn på försäljningsställe",
        "create-or-edit-supplier-admin-merchant-field-street": "\n .label = Gata\n .placeholder = Ange gata",
        "create-or-edit-supplier-admin-merchant-field-streetNumber": "\n .label = Gatunummer\n .placeholder = Ange gatunummer",
        "create-or-edit-supplier-admin-merchant-field-postalCode": "\n .label = Postnummer\n .placeholder = Ange postnummer",
        "create-or-edit-supplier-admin-merchant-field-city": "\n .label = Stad\n .placeholder = Ange stad",
        "create-or-edit-supplier-admin-merchant-field-country": "\n .label = Land",
        "create-or-edit-supplier-admin-merchant-contact-details-title": "\n .title = Kontaktuppgifter",
        "create-or-edit-supplier-admin-merchant-country-denmark-item": "Danmark",
        "create-or-edit-supplier-admin-merchant-contact-details-info": "Kontaktuppgifter kommer att vara offentliga för kunderna.",
        "create-or-edit-supplier-admin-merchant-field-contact-details-name": "\n .label = Namn\n .placeholder = Ange namn",
        "create-or-edit-supplier-admin-merchant-field-contact-details-email": "\n .label = E-post\n .placeholder = Ange e-post",
        "create-or-edit-supplier-admin-merchant-field-contact-details-phone": "\n .label = Telefonnummer\n .placeholder = Ange telefonnummer",
        "create-or-edit-supplier-admin-merchant-field-is-required": "Fältet är obligatoriskt",
        "create-or-edit-supplier-admin-merchant-credit-card-payments-title": "\n .title = Kreditkortsbetalningar",
        "create-or-edit-supplier-admin-merchant-status-approved": "Aktiv",
        "create-or-edit-supplier-admin-merchant-status-no-registered-bank-account": "Inget registrerat bankkonto",
        "create-or-edit-supplier-admin-merchant-status-no-registered-bank-account-description": "Registrera ett bankkonto för ditt inlösenavtal <retryLink>här.</retryLink>",
        "create-or-edit-supplier-admin-merchant-status-no-registered-bank-account-description-readonly": "Registrera ett bankkonto för ditt inlösenavtal.",
        "create-or-edit-supplier-admin-merchant-status-invalid": "Avtalet är ogiltigt",
        "create-or-edit-supplier-admin-merchant-status-invalid-description": "Rätta din ansökan om inlösenavtal <retryLink>här.</retryLink>",
        "create-or-edit-supplier-admin-merchant-status-invalid-description-readonly": "Rätta din ansökan om inlösenavtal.",
        "create-or-edit-supplier-admin-merchant-status-pending": "Avtalet väntar",
        "create-or-edit-supplier-admin-merchant-status-pending-description": "Vänta tills inlösaren har behandlat din ansökan om inlösenavtal.",
        "create-or-edit-supplier-admin-merchant-status-no-payment-setup": "Ingen betalningsinställning",
        "create-or-edit-supplier-admin-merchant-status-no-payment-setup-description": "Ställ in kreditkortsbetalningar för detta försäljningsställe för att börja ta emot betalningar.",
        "create-or-edit-supplier-admin-merchant-status-bank-account-pending": "Bankkonto väntar",
        "create-or-edit-supplier-admin-merchant-status-bank-account-pending-description": "Vänta tills inlösaren har verifierat ditt bankkonto.",
        "create-or-edit-supplier-admin-merchant-acquirer": "Inlösare:",
        "create-or-edit-supplier-admin-merchant-acquirer-type-adyen-pos": "Adyen",
        "create-or-edit-supplier-admin-merchant-acquirer-type-adyen": "Adyen",
        "create-or-edit-supplier-admin-merchant-bank-details": "Bankuppgifter:",
        "create-or-edit-supplier-admin-merchant-industry-codes": "Branschkoder:",
        "create-or-edit-supplier-admin-merchant-status-action-button-setup": "Inställning",
        "create-or-edit-supplier-admin-merchant-status-action-button-edit": "Redigera",
        "create-or-edit-supplier-admin-merchant-dialog-title": "Inställning av kreditkortsbetalning",
        "create-or-edit-supplier-admin-merchant-dialog-field-acquiring-agreement": "\n .label = Inlösenavtal",
        "create-or-edit-supplier-admin-merchant-dialog-field-sales-channels": "\n .label = Försäljningskanal",
        "create-or-edit-supplier-admin-merchant-dialog-field-bank-account": "\n .label = Bankkonto",
        "create-or-edit-supplier-admin-merchant-dialog-field-bank-account-helper": "Välj det bankkonto dit försäljningen ska överföras. Du ser bara bankkonton som har skapats i Adyen-plattformen. För att lägga till ett nytt bankkonto, se <retryLink>guide.</retryLink>",
        "create-or-edit-supplier-admin-merchant-dialog-field-industry-codes": "\n .label = Branschkoder",
        "create-or-edit-supplier-admin-merchant-dialog-field-default-currency": "\n .label = Standardvaluta",
        "create-or-edit-supplier-admin-merchant-dialog-save-button": "Spara",

        //Supplier > Admin > T&C
        "supplier-admin-settings-terms-and-conditions": "\n .title = Villkor",
        "supplier-admin-settings-terms-and-conditions-list-create-button": "Skapa ny",
        "supplier-admin-settings-terms-and-conditions-create-button": "Skapa",
        "supplier-admin-settings-terms-and-conditions-update-button": "Uppdatera",


        // TERMS AND CONDITIONS CREATE
        "supplier-terms-and-conditions-alert-title": "Villkor",
        "supplier-terms-and-conditions-alert-subtitle1": "Det är ditt eget ansvar att se till att villkoren uppfyller gällande krav.",
        "supplier-terms-and-conditions-alert-subtitle2": "Läs om Adyens obligatoriska T&C, som du måste följa, <externalLink>här</externalLink>.",
        "supplier-terms-and-conditions-alert-subtitle3": "Ladda ner vår T&C-mall: <externalLinkDA>Danska</externalLinkDA> | <externalLinkEN>Engelska</externalLinkEN>.",
        "supplier-terms-and-conditions-dropdown-english": "Engelska",
        "supplier-terms-and-conditions-dropdown-danish": "Danska",
        "supplier-terms-and-conditions-name-label": "\n .label = Namn",
        "supplier-terms-and-conditions-language-label": "\n .label = Språk",
        "supplier-terms-and-conditions-type-label": "\n .label = Typ",
        "supplier-terms-and-conditions-dropdown-pos": "POS",
        "supplier-terms-and-conditions-type-ecom": "E-handel",
        "supplier-terms-and-conditions-aside-settings": "\n .title = Inställningar",
        "supplier-terms-and-conditions-aside-active": "Aktiv: ",
        "supplier-terms-and-conditions-aside-history": "\n .title = Historik",
        "supplier-terms-and-conditions-aside-version": "Version: ",
        "supplier-terms-and-conditions-aside-created": "Skapad: ",
        "supplier-terms-and-conditions-aside-updated": "Uppdaterad: ",
        "terms-and-conditions-error-label-name": "Namn",
        "terms-and-conditions-error-label-type": "Typ",
        "terms-and-conditions-error-label-language": "Språk",
        "terms-and-conditions-error-label-text": "Text",


        // TERMS AND CONDITIONS TABLE GENERAL
        "terms-and-conditions-table-header-name": "Namn",
        "terms-and-conditions-table-header-language": "Språk",
        "terms-and-conditions-table-header-name-type": "Typ",
        "terms-and-conditions-table-header-name-status": "Status",
        "terms-and-conditions-table-button-edit":"Redigera",
        "terms-and-conditions-table-button-delete":"Ta bort",
        "terms-and-conditions-table-button-approval":"Godkännande",
        "terms-and-conditions-table-status-active":"Aktiv",
        "terms-and-conditions-table-status-inactive":"Inaktiv",
        "terms-and-conditions-table-status-pending":"Under behandling",


        "terms-and-conditions-modal-button-delete-label": "Ta bort",
        "terms-and-conditions-modal-question": "Är du säker på att du vill ta bort",
        "terms-and-conditions-modal-title": "Villkor",


        // Supplier > Admin > Administrators
        "supplier-users-page-header": "\n .title = Administratörer",
        "supplier-users-suppliers-tab-title": "Leverantörsadministratörer",
        "supplier-users-merchants-tab-title": "Administratörer för försäljningsställen",
        "supplier-users-table-merchant-column": "Försäljningsställe",
        "supplier-users-create-admin-button": "Skapa ny",


        // Supplier > Admin > Account > Company Account
        "supplier-update-account-title":"\n .title = Leverantörskonto",
        "supplier-update-account-update-button":"Uppdatera",
        "supplier-update-account-nav-item-home":"Hem",
        "supplier-update-account-nav-item-account":"Konto",
        "supplier-update-account-registration-number-label":"\n .label = Registreringsnummer",
        "supplier-update-account-error-label-registration-number":"Registreringsnummer",

        // Supplier > Admin > Account > GDPR
        "supplier-account-gdpr-title":"\n .title = GDPR",
        "supplier-account-gdpr-tab-documents":"Dokument",
        "supplier-account-gdpr-tab-export":"Export",
        "supplier-account-gdpr-export-title":"Ladda ner användare",
        "supplier-account-gdpr-export-info":"\n .description = Den här funktionen låter dig exportera administratörer och/eller användare från alla administrativa enheter, inklusive leverantör, försäljningsställe, företag, hyresgäst och servicecenter. För att ladda ner användare från andra administrativa enheter måste du registrera en eller flera e-postdomäner som är kopplade till ditt företag. Dessa domäner används för att identifiera företagets användare. Om ditt företag inte har några verifierade domäner kan du inte ladda ner användare från andra enheter. För hjälp med domänverifiering, kontakta vårt supportteam.",
        "supplier-account-gdpr-export-user-types-select-item-user": "Användare",
        "supplier-account-gdpr-export-user-types-select-item-administrator": "Administratörer",

        "supplier-account-gdpr-export-user-types-select-label":"\n .label = Användartyper",
        "supplier-account-gdpr-export-user-types-select-input-label":"Användartyper",
        "supplier-account-gdpr-export-user-deletion-period-select-input-label":"Period för radering av användare",
        "supplier-account-gdpr-export-user-deletion-period-select-label":"\n .label = Period för radering av användare",
        "supplier-account-gdpr-export-user-deletion-period-select-item-days-180":"180 dagar",
        "supplier-account-gdpr-export-user-deletion-period-select-item-days-90":"90 dagar",
        "supplier-account-gdpr-export-user-deletion-period-select-item-days-30":"30 dagar",
        "supplier-account-gdpr-export-user-deletion-period-select-item-days-7":"7 dagar",
        "supplier-account-gdpr-export-include-deleted-switch-label":"\n .label = Inkludera borttagna användare",
        "supplier-account-gdpr-export-exported-domains-subtitle":"Verifierade domäner som exporteras:",
        "supplier-account-gdpr-export-no-domains-registered":"Inga verifierade företagsdomäner har registrerats.",
        "supplier-account-gdpr-export-export-button":"Exportera till CSV",



        // --- Support ---

        // Support > Admin > Features
        "support-admin-features-header": "\n .title = Funktioner",
        "support-admin-features-table-header-name": "Namn",
        "support-admin-features-table-header-plan": "Plan",
        "support-admin-features-table-plan-none": "Ingen",
        "support-admin-features-table-plan-professional": "Professional",
        "support-admin-features-table-plan-enterprise": "Enterprise",
        "support-admin-features-table-header-status": "Status",
        "support-admin-features-table-header-enabled": "Aktiverad",
        "support-admin-features-table-action-edit": "Redigera",
        "support-admin-features-status-label-new": "\n .label = NY",
        "support-admin-features-status-label-beta": "\n .label = BETA",
        "support-admin-features-status-new": "NY",
        "support-admin-features-status-beta": "BETA",

         // Support > Admin > Features > Edit
        "support-admin-feature-edit-header": "\n .title = Redigera funktion",
        "support-admin-feature-edit-save-button": "Spara",
        "support-admin-feature-edit-nav-item-feature": "Redigera funktion",
        "support-admin-feature-edit-programmatic-id-label": "\n .label = Programmatiskt ID",
        "support-admin-feature-edit-name-label": "\n .label = Namn",
        "support-admin-feature-edit-plan-label": "\n .label = Plan",
        "support-admin-feature-edit-status-label": "\n .label = Status",
        "support-admin-feature-edit-enabled-label": "Aktiverad:",
        "support-admin-feature-edit-settings-title": "\n .title = Inställningar",

        // Support > Admin > GDPR
        "support-nav-item-gdpr": "GDPR",
        "support-admin-gdpr-page-header": "\n .title = GDPR",
        "support-admin-gdpr-breadcrumb": "GDPR",
        "support-admin-gdpr-administrators-title": "Administratörer",
        "support-admin-gdpr-user-type-label": "\n .label = Användartyp",
        "support-admin-gdpr-user-type-select-item-merchant-admins": "Administratörer för försäljningsställen",
        "support-admin-gdpr-user-type-select-item-supplier-admins": "Leverantörsadministratörer",
        "support-admin-gdpr-user-type-select-item-company-admins": "Företagsadministratörer",
        "support-admin-gdpr-user-type-select-item-company-agreement-owners": "Avtalsägare för företag",
        "support-admin-gdpr-include-active-users": "Inkludera aktiva användare",
        "support-admin-gdpr-include-inactive-users": "Inkludera inaktiva användare",
        "support-admin-gdpr-export-button": "Exportera kontaktlista",
        "support-admin-gdpr-export-button-label": "Exportera kontaktlista",
        "support-admin-gdpr-export-button-exporting": "Exporterar...",

        // Support > Reports > Entities
        "support-entity-header-title" : "\n .title = Entiteter",
        "support-entity-header-menu-button-create": "Skapa",
        "support-entity-header-menu-button-create-supplier": "Skapa leverantör",
        "support-entity-header-menu-button-create-merchant": "Skapa försäljningsställe",
        "support-entity-header-menu-button-create-company": "Skapa företag",
        "support-entity-header-menu-button-create-tenant": "Skapa hyresgäst",
        "support-entity-header-nav-item-home" : "Hem",
        "support-entity-header-nav-item-entities" : "Entiteter",
        "support-entity-table-header-id": "ID",
        "support-entity-table-header-name": "Namn",
        "support-entity-table-header-address": "Adress",
        "support-entity-table-header-type": "Typ",
        "support-entity-table-header-status": "Status",
        "support-entity-table-button-details": "Detaljer",
        "support-entity-table-button-edit": "Redigera",
        "support-entity-table-button-delete": "Ta bort",
        "support-entity-table-status-active": "Aktiv",
        "support-entity-table-status-inactive": "Inaktiv",
        "support-entity-confirm-delete-entity-dialog": "\n .typeOfEntity = entitet",
        "support-entity-table-cell-name-agreement-owner": "Avtalsägare",
        "support-entity-table-cell-name-reg-no": "Reg.nr:",
        "support-entity-table-type-supplier": "\n .label = Leverantör",
        "support-entity-table-show-inactive": "\n .label = Visa inaktiva",
        "support-entity-table-type-merchant": "\n .label = Försäljningsställe",
        "support-entity-table-type-company": "\n .label = Företag",
        "support-entity-table-type-tenant": "\n .label = Hyresgäst",
        "support-entity-table-type-service-center": "\n .label = Servicecenter",
        "support-entity-table-type-user": "\n .label = Användare",
        "support-entity-details-connected-merchants": "\n .title = Anslutna försäljningsställen",
        "support-entity-details-connected-companies": "\n .title = Anslutna företag",
        "support-entity-details-connected-suppliers": "\n .title = Anslutna leverantörer",
        "support-entity-details-connected-devices": "\n .title = Anslutna enheter",
        "support-entity-details-id": "ID: { $id }",
        "support-entity-table-entity-type-label":"Entitetstyp",
        "support-entity-table-entity-type-select-item-all":"Alla",
        "support-entity-table-entity-type-select-item-supplier":"Kantinoperatör",
        "support-entity-table-entity-type-select-item-merchant":"Försäljningsställe",
        "support-entity-table-entity-type-select-item-company":"Företag",
        "support-entity-table-entity-type-select-item-service-center":"Servicecenter",
        "support-create-entity-error-label-company-invalid-type":"Ogiltig typ",
        "support-create-entity-error-label-company-type":"Typ",
        "support-create-entity-error-label-system-owner":"Avtalsägare",
        "support-create-entity-error-label-company-number":"Företagsnummer",
        "support-create-entity-error-label-ean-number":"EAN-nummer",
        "support-create-entity-error-label-invoice-type":"Fakturatyp",
        "support-create-entity-error-label-invoice-email":"E-post",
        "support-create-entity-error-label-attention":"Att.",
        "support-create-entity-error-label-debitot-no":"Debitornummer",
        "support-create-entity-error-label-reminder-email":"E-post",
        "support-create-entity-error-label-po-number":"Inköpsordernummer",
        "support-create-entity-error-label-company-name":"Företagsnamn",
        "support-create-entity-error-label-address":"Adress",
        "support-create-entity-error-label-country":"Land",
        "support-create-entity-error-label-postal-code":"Postnummer",
        "support-create-entity-error-label-city":"Stad",
        "support-create-entity-error-label-contact-person":"Kontaktperson",
        "support-create-entity-error-label-email":"E-post",
        "support-create-entity-error-label-telephone":"Telefon",
        "support-create-entity-agreement-owner-subtitle":"Avtalsägare",
        "support-create-entity-ean-number-label":"\n .label = EAN-nummer",
        "support-create-entity-address1-label":"\n .label = Adressrad 1\n .placeholder = Gatuadress och gatunummer",
        "support-create-entity-address2-label":"\n .label = Adressrad 2\n .placeholder = Våning, lägenhetsnr osv.",
        "support-create-entity-postal-code-label":"\n .label = Postnummer",
        "support-create-entity-city-label":"\n .label = Stad",
        "support-create-entity-contact-person-label":"\n .label = Kontaktperson",
        "support-create-entity-email-label":"\n .label = E-post",
        "support-create-entity-telephone-label": "\n .label = Telefon",
        "support-create-entity-type-choose-label":"\n .label = Välj",
        "support-create-entity-dropdown-choose-yes":"Ja",
        "support-create-entity-dropdown-choose-no":"Nej",
        "support-create-entity-alert-title":"\n .title = En avtalsägare äger avtalet med FacilityNet och tar emot tillhörande fakturor. Av den anledningen behöver vi fakturauppgifter för avtalsägare.",
        "support-create-entity-subscription-details-subtitle": "Prenumerationsuppgifter",
        "support-create-entity-subscription-details-field-implementationDeadline": "\n .label = Sista datum för implementering",
        "support-create-entity-subscription-details-alert-title": "\n .title = Detta är datumet då kunden vill att systemet ska tas i produktion. Det innebär att onboarding, intern testning och eventuell provperiod måste vara avslutade före detta datum.",
        "support-create-entity-contact-details-subtitle":"Kontaktuppgifter",
        "support-create-entity-invoice-details-subtitle":"Fakturauppgifter",
        "support-create-entity-send-invoice-to-label":"\n .label = Skicka faktura till",
        "support-create-entity-dropdown-ean-number":"EAN-nummer",
        "support-create-entity-dropdown-email":"E-post",
        "support-create-entity-debitor-number-label":"\n .label = Debitornummer\n .helperText = Detta identifierar debitorn i FacilityNets redovisningssystem.",
        "support-create-entity-invoice-email-label":"\n .label = E-post",
        "support-create-entity-attention-label":"\n .label = Att.",
        "support-create-entity-reminder-email-label":"\n .label = E-post för påminnelser / kontoutdrag",
        "support-create-entity-po-number-label":"\n .label = Inköpsordernummer",
        "support-create-entity-type-label":"\n .label = Typ",
        "support-create-entity-country-label":"\n .label = Land",
        "support-create-entity-dropdown-country-denmark":"Danmark",
        "support-create-entity-dropdown-private-company":"Privat företag",
        "support-create-entity-dropdown-private-person":"Privatperson",
        "support-create-entity-dropdown-public-limited-company":"Aktiebolag",
        "support-create-entity-aside-history": "\n .title = Historik",
        "support-create-entity-aside-version": "Version:",
        "support-create-entity-aside-created": "Skapad:",
        "support-create-entity-aside-updated": "Uppdaterad:",

        // ---  Support Reports --- Messages > Email
        "support-messages-email-title": "\n .title = E-post",
        "support-messages-email-subject-label":"\n .label = E-postämne",
        "support-messages-email-receiver-label":"\n .label = Mottagare \n .placeholder = Ange e-post eller användar-ID",
        "support-messages-email-table-header-receiver":"Mottagare",
        "support-messages-email-table-header-subject":"Ämne",
        "support-messages-email-table-header-sent-time":"Skickad tid",
        "support-messages-email-table-header-status":"Status",
        "support-messages-email-table-status-sent":"Skickat",
        "support-messages-email-table-status-not-sent":"Inte skickat",
        "support-messages-email-table-cell-subject-created":"Skapad: { $time }",
        "support-messages-email-resend-button":"Skicka igen",
        "support-messages-email-export-button":"Exportera",
        "support-messages-email-details-status-label":"Status:",
        "support-messages-email-details-created-label":"Skapad:",
        "support-messages-email-details-sent-time-label":"Skickad tid:",
        "support-messages-email-details-error-message-label":"Felmeddelande:",
        "support-messages-email-details-from-label":"Från:",
        "support-messages-email-details-subject-label":"Ämne:",
        "support-messages-email-details-to-label":"Till:",
        "support-messages-email-details-cc-label":"Kopia:",
        "support-messages-email-details-bcc-label":"Dold kopia:",
        "support-messages-email-details-resend-email-button":"Skicka e-post igen",
        "support-messages-email-details-resend-email-title":"Skicka e-post igen",
        "support-messages-email-details-sent-button":"Skickat",
        "support-messages-email-resent-dialog-title":"Bekräfta att e-post skickas igen",
        "support-messages-email-resent-dialog-subtitle":"Är du säker på att du vill skicka { $itemsAmount } e-postmeddelanden igen?",
        "support-messages-email-resent-dialog-cancel-button":"Nej",
        "support-messages-email-resent-dialog-submit-button":"Ja",

        // ---  Support Reports --- Messages > SMS
        "support-messages-sms-title": "\n .title = SMS",
        "support-messages-sms-receiver-label":"\n .label = Mottagare",
        "support-messages-sms-text-body-label":"\n .label = Textinnehåll",
        "support-messages-sms-table-header-receiver":"Mottagare",
        "support-messages-sms-table-header-created":"Skapad",
        "support-messages-sms-table-header-sent":"Skickat",
        "support-messages-sms-table-header-status":"Status",
        "support-messages-sms-table-status-sent":"Skickat",
        "support-messages-sms-table-status-not-sent":"Inte skickat",
        "support-messages-sms-export-button":"Exportera",
        "support-messages-sms-details-status-label":"Status:",
        "support-messages-sms-details-id-label":"id:",
        "support-messages-sms-details-created-label":"Skapad:",
        "support-messages-sms-details-sent-time-label":"Skickad tid:",
        "support-messages-sms-details-error-message-label":"Felmeddelande:",
        "support-messages-sms-details-text-message-label":"Textmeddelande:",
        "support-messages-sms-details-from-label":"Från:",
        "support-messages-sms-details-to-label":"Till:",


        // ---  Support Reports --- Accounting > Subscriptions
        "support-subscriptions-header": "\n .title = Prenumerationer",
        "support-subscriptions-table-order-id-column": "Order-ID",
        "support-subscriptions-table-employee-column": "Anställd",
        "support-subscriptions-table-subscribed-column": "Anmäld",
        "support-subscriptions-table-unsubscribed-column": "Avanmäld",
        "support-subscriptions-table-payment-column": "Betalning",
        "support-subscriptions-table-amount-column": "Belopp",
        "support-subscriptions-table-cancel-subscription": "Avsluta prenumeration",
        "support-subscriptions-table-details": "Detaljer",
        "support-subscriptions-table-filters-merchant-title":"\n .title = Försäljningsställe",
        "support-subscriptions-table-filters-customer-title":"\n .title = Kund",
        "support-subscriptions-table-filters-payment-title":"\n .title = Betalning",

        // ---  Support Reports --- Accounting > Meeting Service
        "support-accounting-meeting-service-header": "\n .title = Mötesförtäring",
        "support-accounting-meeting-service-table-order-id-column": "Order-ID",
        "support-accounting-meeting-service-table-booked-date-column": "Bokföringsdatum",
        "support-accounting-meeting-service-table-delivery-time-column": "Leveranstid",
        "support-accounting-meeting-service-table-employee-column": "Beställare",
        "support-accounting-meeting-service-table-status":"Status",
        "support-accounting-meeting-service-table-amount-column": "Belopp (DKK)",
        "support-accounting-meeting-service-table-show-receipt": "Visa kvitto",
        "support-accounting-meeting-service-table-floating-action-bar-export": "\n .title = Exportera",


        // ---  Support Reports --> Printer Queue
        "support-printer-queue-title": "\n .title = Skrivarkö",
        "support-printer-queue-merchant-label":"\n .label = Försäljningsställe",
        "support-printer-queue-order-id-label":"\n .label = Order-ID",
        "support-printer-queue-table-header-id":"Id",
        "support-printer-queue-table-header-created":"Skapad",
        "support-printer-queue-table-header-print-at":"Skrivs ut kl.",
        "support-printer-queue-table-header-device-name":"Enhetsnamn",
        "support-printer-queue-table-header-order-id":"Order-ID",
        "support-printer-queue-table-header-status":"Status",
        "support-printer-queue-table-device-group":" Grupp: ",
        "support-printer-queue-table-status-printed":"Utskriven",
        "support-printer-queue-table-status-queue":"Kö",
        "support-printer-queue-table-raw-receipt-action":"Rått kvitto",
        "support-printer-details-status-label":"Status:",
        "support-printer-details-created-label":"Skapad:",
        "support-printer-details-printed-at-label":"Utskriven kl.:",
        "support-printer-details-device-group-subtitle":"Enhetsgrupp:",
        "support-printer-details-device-subtitle":"Enhet:",
        "support-printer-details-id-label":"ID:",
        "support-printer-details-name-label":"Namn:",
        "support-printer-details-mime-type-label":"Mime-typ:",
        "support-printer-details-priority-label":"Prioritet:",
        "support-printer-details-job-token-label":"Jobbtoken:",


         // ---  Support Reports --- Orders > POS
        "support-orders-pos-title": "\n .title = POS",
        "support-orders-pos-order-id-label":"\n .label = Order-ID",
        "support-orders-pos-email-label":"\n .label = E-post",
        "support-orders-pos-table-header-order-id":"Order-ID",
        "support-orders-pos-table-header-transaction-time":"Transaktionstid",
        "support-orders-pos-table-header-customer":"Kund",
        "support-orders-pos-table-header-merchant":"Försäljningsställe",
        "support-orders-pos-table-header-amount":"Belopp",
        "support-orders-pos-table-action-show-receipt":"Visa kvitto",
        "support-orders-pos-table-action-show-order-details":"Visa orderdetaljer",



        // --- Support entity---
        "support-create-supplier-title": "\n .title = Skapa leverantör",
        "support-update-supplier-title": "\n .title = Uppdatera leverantör",
        "support-create-supplier-create-button": "Skapa",
        "support-create-supplier-update-button": "Uppdatera",
        "support-create-supplier-nav-item-home": "Hem",
        "support-create-supplier-nav-item-entities": "Entiteter",
        "support-create-supplier-nav-item-create-supplier": "Skapa leverantör",
        "support-create-supplier-nav-item-update-supplier": "Uppdatera leverantör",
        "support-create-supplier-aside-settings": "\n .title = Inställningar",
        "support-create-supplier-aside-active": "Aktiv:",
        "support-create-supplier-company-number-label":"\n .label = Företagsnummer",
        "support-create-supplier-company-name-label":"\n .label = Företagsnamn",
        "support-create-subscription-status-title": "\n .title = Prenumerationsstatus",
        "support-create-supplier-subscription-status": "Status",
        "support-create-supplier-subscription-status-mode-creating": "Skapar",
        "support-create-supplier-subscription-status-mode-onboarding": "Onboarding",
        "support-create-supplier-subscription-status-mode-trial": "Provperiod",
        "support-create-supplier-subscription-status-mode-live": "LIVE",
        "support-create-supplier-subscription-status-mode-unsubscribing": "Avslutar",
        "support-create-supplier-subscription-status-mode-unsubscribed": "Avslutad",
        "support-create-supplier-subscription-status-created": "Skapad",
        "support-create-supplier-subscription-status-implementation-deadline": "Sista datum för implementering",
        "support-create-supplier-subscription-status-onboarding-email-sent": "Onboarding-e-post skickad",
        "support-create-supplier-subscription-status-trial-started": "Provperiod startad",
        "support-create-supplier-subscription-status-subscription-started": "Prenumeration startad",
        "support-create-supplier-subscription-status-subscription-ending": "Prenumeration avslutas",
        "support-create-supplier-subscription-status-button-mode-creating": "Skicka onboarding-artiklar",
        "support-create-supplier-subscription-status-button-mode-onboarding": "Slutför onboarding",
        "support-create-supplier-subscription-status-button-mode-trial": "Gå live",
        "support-create-supplier-subscription-status-button-mode-live": "Avsluta prenumeration",
        "support-create-supplier-subscription-status-button-mode-unsubscribing": "Redigera",
        "support-create-supplier-subscription-status-button-mode-unsubscribed": "Redigera",
        "support-create-supplier-subscription-status-begin-onboarding-dialog": "Starta onboarding",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-articles-to-send": "Artiklar att skicka",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-destination": "Destination",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-button-next": "Nästa",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-existing-administrators": "Befintliga administratörer",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-extra-receivers": "Extra mottagare",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-button-begin": "Starta",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-supplier-admin": "Leverantörsadministratör: {$adminDetails}",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-kitchen-admin": "Köksadministratör: {$adminDetails}",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-label-email": "\n .label = E-post \n .placeholder = Mottagarens e-post",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-button-add": "Lägg till",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-email-error": "Ogiltig e-postadress",
        "support-create-supplier-subscription-status-begin-onboarding-dialog-administrators-error": "Minst en administratör måste väljas",


        // --- Support company ---
        "support-create-company-title": "\n .title = Skapa företag",
        "support-update-company-title": "\n .title = Uppdatera företag",
        "support-create-company-create-button": "Skapa",
        "support-create-company-update-button": "Uppdatera",
        "support-create-company-nav-item-home": "Hem",
        "support-create-company-nav-item-entities": "Entiteter",
        "support-create-company-nav-item-create-company": "Skapa företag",
        "support-create-company-nav-item-update-company": "Uppdatera företag",
        "support-create-company-aside-settings": "\n .title = Inställningar",
        "support-create-company-aside-active": "Aktiv:",
        "support-create-company-office-hotel-label":"Kontorshotell:",
        "support-create-company-office-hotel-helper-text":"Hjälptext",
        "support-create-company-company-number-label":"\n .label = Företagsnummer",
        "support-create-company-main-ean-number-label":"\n .label = Primärt EAN-nummer",
        "support-create-company-company-name-label":"\n .label = Företagsnamn",
        "support-create-company-error-label-main-ean-number":"Primärt EAN-nummer",
        "support-create-company-error-label-url-identifier":"URL-identifikator",
        "support-create-company-aside-is-self-sign-up":"\n .title = Självregistrering",
        "support-create-company-url-identifier-label":"\n .label = Registrerings-URL-identifierare\n .helperText = Detta används för att skapa användarens registrerings-URL.",
        "support-create-company-signup-link-subtitle":"Registreringslänk:",

        // Invoicing
        "support-reports-basis-for-invoicing-page-header": "\n .title = Fakturaunderlag",
        "support-reports-invoicing-header-nav-item": "Fakturering",
        "support-reports-invoicing-header-nav-item-basis-for-invoicing": "Fakturaunderlag",
        "support-reports-invoicing-table-debtor-label": "\n .label = Debitor",
        "support-reports-invoicing-table-header-product-no": "Produktnr",
        "support-reports-invoicing-table-header-name": "Namn",
        "support-reports-invoicing-table-header-price": "Pris",
        "support-reports-invoicing-table-header-items": "Antal",
        "support-reports-invoicing-table-header-total": "Totalt",
        "support-reports-invoicing-table-bottom-transactions": "Transaktioner",
        "support-reports-invoicing-table-bottom-subscriptions": "Prenumerationer",
        "support-reports-invoicing-table-bottom-total": "Totalt",

        // Support > Reports > Health > Server Memory
        "support-reports-health-server-memory-page-header": "\n .title = Serverminne",
        "support-reports-health-server-memory-table-header-memory-type": "Minnestyp",
        "support-reports-health-server-memory-table-header-used": "Använt",
        "support-reports-health-server-memory-table-header-commited": "Allokerat",
        "support-reports-health-server-memory-table-header-max": "Max",


        // Support > Reports > Health > Database health
        "support-reports-health-database-page-header": "\n .title = Databashälsa",


        // Support > Reports > Health > Adyen
        "support-reports-health-adyen-page-header": "\n .title = Adyen",
        "support-reports-health-adyen-tab-summary": "Översikt",
        "support-reports-health-adyen-tab-account-holders": "Kontoinnehavare",
        'support-reports-health-adyen-run-button':"Kör",
        'support-reports-health-adyen-results':"Resultat:",
        'support-reports-health-adyen-api-status-unknown':"Okänd",
        'support-reports-health-adyen-api-status-ok':"Ok",
        'support-reports-health-adyen-api-status-failed':"Misslyckades",
        'support-reports-health-adyen-summary-aside-title':"Test av API-anslutning",
        'support-reports-health-adyen-summary-last-run':"Senaste körning: {$lastRun}",
        'support-reports-health-adyen-summary-legal-entity-management':"Hantering av juridiska enheter:",
        'support-reports-health-adyen-summary-balance-platform':"Saldoplattform:",
        'support-reports-health-adyen-summary-psp-platform':"PSP-plattform:",
        'support-reports-health-adyen-summary-main-title':"Terminalfusklapp",
        'support-reports-health-adyen-summary-terminal-key':"Knapp",
        'support-reports-health-adyen-summary-terminal-function':"Funktion",
        'support-reports-health-adyen-summary-terminal-key-cancel':"Avbryt",
        'support-reports-health-adyen-summary-terminal-key-clear':"Rensa",
        'support-reports-health-adyen-summary-terminal-key-confirm':"Bekräfta",
        'support-reports-health-adyen-summary-terminal-press-1':"Tryck 1 +",
        'support-reports-health-adyen-summary-terminal-press-5':"Tryck 5 +",
        'support-reports-health-adyen-summary-terminal-press-8':"Tryck 8 +",
        'support-reports-health-adyen-summary-terminal-press-9':"Tryck 9 +",
        'support-reports-health-adyen-summary-terminal-function-custom-menu':"Anpassad meny",
        'support-reports-health-adyen-summary-terminal-function-informational-menu':"Informationsmeny",
        'support-reports-health-adyen-summary-terminal-function-payments-menu':"Betalningsmeny",
        'support-reports-health-adyen-summary-terminal-function-admin-menu':"Administratörsmeny",


        // Support > Reports > Health > Adyen > Account Holders
        "adyen-account-holders-table-header-id": "ID",
        "adyen-account-holders-table-cell-entity-id": "Juridisk enhets-ID: {$entityId}",
        "adyen-account-holders-table-cell-entity-liable": "Ansvarig",
        "adyen-account-holders-table-details-balance-accounts": "Saldokonton:",
        "adyen-account-holders-table-details-stores": "Butiker:",
        "adyen-account-holders-table-header-supplier": "Kantinoperatör",
        "adyen-account-holders-table-header-status": "Status",
        "adyen-account-holders-table-header-status-valid": "Giltig",
        "adyen-account-holders-table-header-status-invalid": "Fel i ansökan",
        "adyen-account-holders-table-header-status-pending": "Under behandling",
        "adyen-account-holders-table-header-updated": "Uppdaterad",


        // Support > Reports > Health > Scheduler
        "support-reports-health-scheduler-page-header": "\n .title = Schemaläggare",
        "support-reports-health-scheduler-page-subtitle-main-job": "Huvudjobb:",
        "support-reports-health-scheduler-page-subtitle-load-in-seconds": "Belastning i sekunder:",
        "support-reports-health-scheduler-table-header-name": "Namn",
        "support-reports-health-scheduler-table-header-cron": "Cron",
        "support-reports-health-scheduler-table-header-last-run": "Senaste körning",
        "support-reports-health-scheduler-table-header-next-run": "Nästa körning",
        "support-reports-health-scheduler-table-header-status": "Status",
        "support-reports-health-scheduler-table-status-active": "Aktiv",
        "support-reports-health-scheduler-table-status-inactive": "Inaktiv",
        "support-reports-health-scheduler-table-status-paused": "Pausad",
        "support-reports-health-scheduler-table-action-edit": "Redigera",
        "support-reports-health-scheduler-table-action-pause": "Pausa",
        "support-reports-health-scheduler-table-action-start": "Starta",
        "support-reports-health-scheduler-table-action-stop": "Stoppa",


        // Support > Reports > Health > Scheduler > Edit Job
        "support-reports-health-schedule-edit-page-header": "\n .title = Redigera schemaläggarjobb",
        "support-reports-health-schedule-edit-page-nav-item-edit-job":"Redigera jobb",
        "support-reports-health-schedule-edit-page-edit-button":"Redigera",
        "support-reports-health-schedule-edit-page-start-time-label":"\n .label = Starttid",
        "support-reports-health-schedule-edit-page-cron-expression-label":"\n .label = Cron-uttryck",
        "support-reports-health-schedule-edit-page-settings-title":"\n .title = Inställningar",
        "support-reports-health-schedule-edit-page-settings-active-label":"Aktiv:",
        "support-reports-health-schedule-edit-page-information-title":"\n .title = Information",
        "support-reports-health-schedule-edit-page-information-id":"ID:",
        "support-reports-health-schedule-edit-page-information-name":"Namn:",
        "support-reports-health-schedule-edit-page-information-last-run":"Senaste körning:",

        // Support > TopBar > Awaiting approval
        "awaiting-approval-popover-not-approved-item": "\n .title = Väntar på godkännande\n .description = Ordrar som måste godkännas",
        "awaiting-approval-popover-to-be-booked-item": "\n .title = Ska faktureras\n .description = Mötesförtäringsordrar som har varit fakturerbara i 3+ dagar",
        "awaiting-approval-popover-tooltip": "\n .title = Ordernotiser",
        "awaiting-approval-popover-section-meeting-service-title": "\n .title = Mötesförtäring",
        "awaiting-approval-popover-section-takeaway-title": "\n .title = Takeaway",
        "awaiting-approval-popover-todays-orders-item": "\n .title = Dagens ordrar\n .description = Mötesförtäringsordrar för leverans i dag",
        "awaiting-approval-popover-todays-takeaway-orders-item": "\n .title = Dagens ordrar\n .description = Takeaway-ordrar för i dag",

        // Support > TopBar > Instructions Dialog
        "support-instructions-dialog-title": "Instruktioner",
        "support-instructions-button": "Instruktioner",

        // Non Admin User > TopBar > Create new

        // TopBar > New button > menu
        "top-bar-new-button": "Ny",
        "top-bar-new-menu-resource-booking-title": "Resursbokning",
        "top-bar-new-menu-resource-booking-description": "Boka rum och andra resurser",
        "top-bar-new-menu-meeting-service-title": "Mötesförtäring",
        "top-bar-new-menu-meeting-service-description": "Beställ mötesförtäring",
        "top-bar-new-menu-take-away-title": "Takeaway",
        "top-bar-new-menu-take-away-description": "Köp takeaway och andra varor",
        // Takeaway
        "takeaway-kitchen-selector-title": "Välj butik",
        "takeaway-show-order-button": "Visa beställning: { $price }",
        "create-order-take-away-title": "Takeaway",
        "create-order-take-away-title-with-kitchen": "Takeaway - { $kitchenName }",
        "takeaway-no-shops-empty": "\n .title = Inga takeaway-butiker tillgängliga",

        // Takeaway > Date bar
        "takeaway-date-bar-or": "ELLER",
        "takeaway-date-bar-view-store-details": "Visa butiksinformation",

        // Takeaway > Menu
        "takeaway-menu-no-products-for-date": "Inga produkter tillgängliga för { $date }",
        "takeaway-menu-no-products-for-date-empty": "\n .title = Inga produkter tillgängliga\n .description = Det finns inga produkter tillgängliga just nu",
        "takeaway-menu-no-favorites-empty": "\n .title = Inga favoriter ännu\n .description = Tryck på hjärtikonen på en produkt för att lägga till den som favorit",
        "takeaway-menu-no-search-results-empty": "\n .title = Inga resultat\n .description = Prova att justera sökningen",
        "takeaway-order-is-empty-button": "Ingen beställning",
        "takeaway-checkout-discount-label": "Spara -{ $percentage }%",
        "takeaway-product-sold-out-snackbar": "Varan är slutsåld",

        // Takeaway > Store details dialog
        "takeaway-store-details-title": "Butiksinformation",
        "takeaway-store-details-contact": "Kontakt",
        "takeaway-store-details-address": "Adress",
        "takeaway-store-details-show-on-map": "Visa på karta",
        "takeaway-store-details-close-button": "Stäng",
        "takeaway-store-details-opening-hours-banner": "\n .title = Öppettider: { $hours }",

        // Takeaway > Basket drawer
        "takeaway-basket-date-card-delivery-date-label": "Leveransdatum:",
        "takeaway-checkout-total-label": "Totalt",
        "takeaway-checkout-vat-label": "Moms (25%)",
        "takeaway-checkout-confirm-button": "Slutför betalning",
        "takeaway-checkout-confirm-button-with-price": "Slutför betalning: { $price }",
        "takeaway-checkout-opening-hours-banner": "\n .title = { $kitchenName } är öppet { $hours }",

        // Takeaway > Checkout dialog
        "takeaway-confirm-order-dialog-title": "Bekräfta beställning",
        "takeaway-confirm-order-dialog-go-back-button": "Gå tillbaka",
        "takeaway-checkout-order-summary-title": "Beställningsöversikt",
        "takeaway-checkout-private-section": "Privat",
        "takeaway-checkout-payment-hint-by-method": "via { $method }",
        "takeaway-confirm-order-payment-method-title": "Betalningsmetod",
        "takeaway-confirm-order-accounting-title": "Kontering",
        "takeaway-confirm-order-correct-order": "Ändra beställning",
        "takeaway-checkout-order-summary-delivery-date": "Leverans: { $date }",
        "takeaway-checkout-order-summary-delivery-label": "Leverans:",
        "takeaway-confirm-order-items-column": "ARTIKLAR",
        "takeaway-confirm-order-qty-column": "ANT.",
        "takeaway-confirm-order-amount-column": "BELOPP",
        "takeaway-confirm-order-company-section": "Företag",
        "takeaway-confirm-order-wallet-balance": "Saldo: { $balance }",
        "takeaway-confirm-order-wallet-name-with-balance": "{ $name } ({ $balance })",
        "takeaway-confirm-order-pay-using-card": "Betala med { $card }",
        "takeaway-confirm-order-card-expires": "Går ut { $date }",
        "takeaway-confirm-order-comment-title": "Kommentar till beställningen:",
        "takeaway-confirm-order-comment-placeholder": "\n .label = Skriv en kommentar (valfritt)\n .helperText = Återstående tecken: { $charsRemaining }",
        "takeaway-confirm-order-guest-name-label": "\n .label = Fullständigt namn\n .placeholder = Ditt fullständiga namn:",
        "takeaway-confirm-order-guest-email-label": "\n .label = E-post\n .placeholder = Din e-post:",
        "takeaway-confirm-order-guest-phone-label": "\n .label = Telefonnummer (valfritt)\n .placeholder = Ditt telefonnummer:",
        "takeaway-confirm-order-personal-info-title": "Personuppgifter",
        "takeaway-confirm-order-personal-info-name-label": "Namn:",
        "takeaway-confirm-order-personal-info-email-label": "E-post:",
        "takeaway-confirm-order-personal-info-phone-label": "Telefonnummer:",
        "takeaway-confirm-order-personal-info-edit-email-field": "\n .label = E-post",
        "takeaway-confirm-order-personal-info-edit-phone-field": "\n .label = Telefonnummer",
        "takeaway-confirm-order-personal-info-edit-save-button": "Spara",
        "takeaway-confirm-order-personal-info-edit-email-invalid": "Ange en giltig e-postadress",
        "takeaway-confirm-order-personal-info-edit-phone-invalid": "Telefonnumret får bara innehålla siffror samt tecknen + - ( ) och mellanslag",
        "takeaway-confirm-order-delivery-section-title": "Leverans",
        "takeaway-confirm-order-delivery-pickup-label": "Avhämtning { $hours }",
        "takeaway-checkout-delivery-location-pickup-label": "Avhämtning:",
        "takeaway-checkout-delivery-location-pickup-time": "{ $start } - { $end }",
        "takeaway-checkout-delivery-location-show-more-button": "Visa mer",
        "takeaway-payment-mobilepay-notice": "Du måste använda MobilePay-appen i din telefon för att slutföra betalningen. Du måste godkänna betalningen i MobilePay inom 5 minuter och återvända hit.",
        "takeaway-checkout-terms-accepted-label": "Jag godkänner <conditionsLink>villkoren</conditionsLink>",
        "takeaway-checkout-terms-not-accepted": "Du måste godkänna villkoren",
        "takeaway-checkout-payment-method-required": "Välj en betalningsmetod",
        "takeaway-checkout-comment-max-length": "Kommentaren får vara högst { $max } tecken",
        "takeaway-payment-poll-title": "Behandlar betalning",
        "takeaway-payment-poll-description": "Vänta medan vi behandlar din betalning. Det kan ta en stund.",
        "takeaway-payment-failed": "\n .title = Betalningen misslyckades\n .description = Betalningen kunde inte genomföras på grund av ett oväntat fel. Försök igen senare.",
        "takeaway-payment-canceled": "\n .title = Köpet avbröts\n .description = Du avbröt betalningen av ditt köp.",
        "takeaway-payment-timeout": "\n .title = Betalningen gick ut\n .description = Vi har ännu inte fått någon bekräftelse från din betalningsleverantör. Kontrollera din internetbank för att säkerställa att betalningen har genomförts.",
        "takeaway-payment-back-to-dashboard-button": "Tillbaka till översikten",
        "takeaway-order-confirmed-dialog-title": "Beställningen är slutförd!",
        "takeaway-order-confirmed-dialog-order-id": "Order-ID: { $orderId }",
        "takeaway-order-confirmed-dialog-pickup-hours-label": "Avhämtning:",
        "takeaway-order-confirmed-dialog-pickup-location-value": "{ $name } mellan { $start } och { $end }",
        "takeaway-order-confirmed-dialog-delivery-date-label": "Leveransdatum:",
        "takeaway-order-confirmed-dialog-amount-label": "Belopp:",
        "takeaway-order-confirmed-dialog-total-amount-label": "Totalbelopp:",
        "takeaway-order-confirmed-dialog-go-to-dashboard-button": "Gå till översikten",
        "takeaway-order-confirmed-dialog-show-receipt-button": "Visa kvitto",
        "takeaway-order-confirmed-dialog-show-receipts-button": "Visa { $count } kvitton",
        "takeaway-receipt-send-button": "Skicka kvitto",
        "top-bar-new-menu-make-purchase-title": "Gör ett köp",
        "top-bar-new-menu-make-purchase-description": "Beställ lunch i kantinen",
        "top-bar-new-menu-refill-wallet-title": "Fyll på wallet",
        "top-bar-new-menu-refill-wallet-description": "Fyll på pengar i din digitala wallet",
        "top-bar-new-menu-section-booking-title": "Bokning",
        "top-bar-new-menu-section-purchase-title": "Köp",
        "top-bar-new-menu-book-for-another-user-button": "Boka åt en annan användare",
        "top-bar-new-menu-push-message-title": "Pushnotis",
        "top-bar-new-menu-push-message-dialog-title": "Ny pushnotis",
        "top-bar-new-menu-push-message-description": "Skicka meddelanden till dina kunder",
        "top-bar-new-menu-shortcuts-title": "Genvägar:",
        "top-bar-new-menu-shortcut-accounting": "Redovisning",
        "top-bar-new-menu-shortcut-manage-products": "Hantera produkter",
        "top-bar-new-menu-shortcut-manage-push-messages": "Hantera pushnotiser",

        // Navigation
        "support-nav-item-home": "Hem",
        "support-nav-item-devices": "Enheter",
        "support-nav-item-messages": "\n .title = Meddelanden",
        "support-nav-item-orders-title": "\n .title = Order",
        "support-nav-item-orders": "Order",
        "support-nav-item-orders-pos": "POS",
        "support-nav-item-accounting-title": "\n .title = Redovisning",
        "support-nav-item-accounting": "Redovisning",
        "support-nav-item-subscriptions": "Prenumerationer",
        "support-nav-item-accounting-meeting-service": "Mötesförtäring",
        "support-nav-item-email": "E-post",
        "support-nav-item-sms": "SMS",
        "support-nav-item-printer-queue": "Skrivarkö",

        // Support ADMIN DEVICES
        "support-admin-nav-item-devices": "Enheter",
        "support-admin-entities-card-group": "\n .title = Entiteter",
        "support-admin-entities-card": "\n .title = Entiteter\n .description = Hantera entiteter i systemet, såsom leverantörer, försäljningsställen och företag.",
        "support-admin-devices-page-header": "\n .title = Enheter",
        "support-table-header-supplier": "Kantinoperatör",
        "support-table-header-merchant": "Försäljningsställe",

        // - reporting

        // - admin
        "support-nav-item-supplier-access": "Kantinoperatörer",
        "support-nav-item-merchant-access": "Kantiner",
        "support-nav-item-entities-access": "Entiteter",
        "support-nav-item-payments": "Betalningar",
        "support-nav-item-features": "Funktioner",
        "support-nav-item-invoicing": "\n .title = Fakturering",
        "support-nav-item-invoicing-basis-for-invoicing": "Fakturaunderlag",
        "support-nav-item-health-title": "\n .title = Hälsa",
        "support-nav-item-health": "Hälsa",
        "support-nav-item-health-database": "Databashälsa",
        "support-nav-item-health-server-memory": "Serverminne",
        "support-nav-item-health-scheduler": "Schemaläggare",
        "support-nav-item-health-adyen": "Adyen",

        // Access
        "support-supplier-access-page-header": "\n .title = Kantinoperatörer",
        "support-merchant-access-page-header": "\n .title = Kantiner",


        // Page header
        "page-header-help-tooltip": "\n .title = Klicka här för mer information",
        "page-header-help-text": "Hjälpguider",
        "page-header-help-status-mode-new": "Ny",
        "page-header-help-status-mode-beta": "Beta",
        "page-header-help-maintenance": "Tyvärr är sidan för närvarande otillgänglig eftersom den underhålls.",

        // YUP validation
        "validation-title-required": "Titel är obligatorisk",
        "validation-body-required": "Brödtext måste fyllas i",
        "validation-type-required": "Typ är obligatorisk",

        // Field validation
        "validation-date-must-be-in-past": "Datumet måste ligga i det förflutna",
        "validation-date-must-be-today-or-past": "Datumet måste vara i dag eller tidigare",
        "validation-date-must-be-in-future": "Datumet måste ligga i framtiden",
        "validation-date-must-be-today-or-future": "Datumet måste vara i dag eller senare",
        "validation-datetime-must-be-in-past": "Datum och tid måste ligga i det förflutna",
        "validation-datetime-must-be-in-future": "Datum och tid måste ligga i framtiden",
        "validation-number-exceeds-max": "Värdet får vara högst { $max }",
        "validation-number-below-min": "Värdet måste vara minst { $min }",

        // Common
        "employee-id": "Anställnings-ID",
        "id": "id",
        "name": "Namn",
        "price": "Pris",
        "email": "E-post",
        "amount": "Belopp",
        "for": "för",
        "yes": "Ja",
        "no": "Nej",
        "status": "Status",
        "active": "Aktiv",
        "inactive": "Inaktiv",
        "edit": "Redigera",
        "delete": "Ta bort",

        "create": "Skapa",
        "save": "Spara",
        "required-field": "Det här fältet är obligatoriskt",
        "invalid-email": "Ogiltig e-postadress",

        // History block
        "history-card": "\n .title = Historik",
        "history-created": "Skapad:",
        "history-edited": "Senast ändrad:",


        // Production order
        "production-order-status-received": "Mottagen",
        "production-order-status-confirmed": "Bekräftad",
        "production-order-status-cancelled": "Avbruten",
        "production-order-status-ready": "Klar",
        "production-order-number": "ID",
        "production-order-status": "Status",
        "production-order-payment-status": "Betalningsmetod",
        "production-order-payment-channel": "Kanal",
        "production-order-time": "Tid",
        "production-order-delivery-time": "Leveranstid",
        "production-order-placeholder-comment": "Kommentar till kunden",
        "production-order-show-cancelled": "Visa avbrutna",

        // Pos order
        "pos-order-delivery-date-title": "Leveranslista - takeaway",
        "pos-order-delivery-date": "\n .label =  Leveransdatum:",
        "pos-order-purchase-time": "\n .label =  Köptid:",
        "pos-order-customer": "\n .label =  Kund:",

        // Merchant > Reports > Production > Meeting service
        "meeting-service-table-approved-orders": "Godkända order",
        "meeting-service-table-unapproved-orders": "\n .label = Ej godkända order",
        "meeting-service-table-time": "Tid",
        "meeting-service-table-start-date": "Startdatum",
        "meeting-service-table-end-date": "Slutdatum",
        "meeting-service-table-delivery-type": "Leveranstyp",
        "delivery-type-filter-all": "Alla",
        "delivery-type-filter-delivery": "Leverans",
        "delivery-type-filter-pick-up": "Avhämtning",
        "delivery-type-filter-eating-in-canteen": "Äter i kantinen",
        "meeting-service-table-order-id-column": "Order-ID",
        "meeting-service-table-delivery-time-column": "Leveranstid",
        "meeting-service-table-delivery-location-column": "Möte",
        "meeting-service-table-meeting-name-column": "Mötesnamn",
        "meeting-service-table-location-column": "Plats",
        "meeting-service-table-amount-column": "Belopp",
        "meeting-service-table-changes-column": "Ändringar",
        "meeting-service-table-changes-column-tooltip-changed": "\n .title = Ordern ändrades {$date}",
        "meeting-service-table-changes-column-tooltip-unchanged": "\n .title = Ordern har inte ändrats",
        "meeting-service-table-changes-column-active-filter-yes": "Aktiv",
        "meeting-service-table-changes-column-inactive-filter-no": "Inaktiv",
        "meeting-service-table-lock-column": "Lås",
        "meeting-service-table-lock-column-tooltip-open": "\n .title = Ordern är öppen för ändringar",
        "meeting-service-table-lock-column-tooltip-closed": "\n .title = Ordern är låst för ändringar",
        "meeting-service-table-lock-column-lock-tooltip": "\n .title = Hindra beställaren från att ändra den här ordern",
        "meeting-service-table-lock-column-unlock-tooltip": "\n .title = Låt beställaren ändra den här ordern",
        "meeting-service-table-lock-column-active-filter-yes": "Aktiv",
        "meeting-service-table-lock-column-inactive-filter-no": "Inaktiv",
        "meeting-service-table-meeting": "Leverans: {$locationName}",
        "meeting-service-table-production-slip-button": "Följesedel",
        "meeting-service-table-credit-note-button": "Kreditnota",
        "meeting-service-table-receipt-button": "Kvitto",
        "meeting-service-table-update-button": "Redigera",
        "meeting-service-table-duplicate-button": "Duplicera",
        "meeting-service-table-book-button": "Bokför",
        "meeting-service-table-send-message-button": "Skicka meddelande",
        "meeting-service-table-delete-button": "Ta bort",
        "meeting-service-table-date-range-filter": "Datumintervall",
        "meeting-service-table-floating-action-bar-read": "\n .title = Läst",
        "meeting-service-table-floating-action-bar-lock-unlock": "\n .title = Lås/lås upp",
        "meeting-service-table-floating-action-bar-lock": "\n .title = Lås",
        "meeting-service-table-floating-action-bar-lock-tooltip": "\n .title = Hindra beställaren från att ändra valda order",
        "meeting-service-table-floating-action-bar-unlock": "\n .title = Lås upp",
        "meeting-service-table-floating-action-bar-unlock-tooltip": "\n .title = Låt beställaren ändra valda order",
        "meeting-service-table-floating-action-bar-book": "\n .title = Bokför",
        "meeting-service-table-floating-action-bar-status": "\n .title = Status",
        "meeting-service-table-floating-action-bar-delete": "\n .title = Ta bort",
        "meeting-service-table-floating-action-bar-print": "\n .title = Skriv ut",
        "meeting-service-table-floating-action-bar-production-slip": "\n .title = Följesedel",
        "meeting-service-table-floating-action-bar-delivery-list": "\n .title = Leveranslista",
        "meeting-service-table-floating-action-bar-receipt": "\n .title = Kvitto",
        "meeting-service-table-floating-action-bar-export": "\n .title = Exportera valda",
        "calendar-button-show-calendar": "\n .title = Visa kalender\n .aria-label = Visa kalender",
        "meeting-service-delete-orders-title": "Ta bort order",
        "meeting-service-delete-order-title": "Ta bort order",
        "meeting-service-delete-orders-checkbox-label-meeting-service": "\n .label = Mötesförtäring",
        "meeting-service-delete-orders-checkbox-label-booking": "\n .label = Avboka resursbokning",
        "meeting-service-delete-orders-checkbox-label-booking-lock": "Avboka resursbokning",
        "meeting-service-delete-orders-checkbox-label-meeting-service-cancel": "\n .label = Avboka mötesförtäring",
        "meeting-service-delete-orders-checkbox-label-meeting-service-cancel-lock": "Avboka mötesförtäring",
        "meeting-service-delete-orders-helper-merchant-cancellation-field": ".label = Avbokningsmeddelande \n .placeholder = Skriv en orsak till avbokningen. Meddelandet skickas till kunden. \n .helperText = Återstående tecken: { $charsRemaining }",
        "meeting-service-delete-orders-helper-merchant": "Obs: Om en resursbokning är kopplad till mötesförtäringsordern avbokas den inte.",
        "meeting-service-delete-orders-helper-line-one": "OBS: Om en resursbokning är kopplad till mötesförtäringsordern kan du avboka resursbokningen för beställarens räkning.",
        "meeting-service-delete-orders-helper-line-two": "Observera att om du avbokar resursbokningen avbokas även en eventuell reservation av lokaler och tillhörande AV-utrustning och frigörs för andra användare.",
        "meeting-service-table-order-name-column": "Ordernamn",
        "meeting-service-book-orders-title": "Bokför order",
        "meeting-service-book-orders-description": "Order märkta 'Framtida' kan inte behandlas eftersom leveransdatumet ligger i framtiden. För order märkta 'Kontant' måste du se till att ett betalningsdatum anges för dagen då betalningen togs emot.",
        "meeting-service-table-status-column": "Status",
        "meeting-service-table-cash-payment-received-column": "Kontantbetalning mottagen",
        "meeting-service-book-orders-subtotal": "Delsumma",
        "meeting-service-book-orders-button": "Bokför",
        "meeting-service-delete-orders-button": "Ta bort",
        "meeting-service-delete-single-order-id-label": "Order-ID:",
        "meeting-service-delete-single-order-delivery-date-label": "Leveransdatum:",
        "meeting-service-delete-single-order-meeting-name-label": "Mötesnamn:",
        "meeting-service-delete-single-order-responsible-label": "Ansvarig:",
        "meeting-service-delete-single-order-amount-label": "Belopp:",
        "merchant-home-meeting-service-awaiting-approval-title": "Väntar på godkännande",
        "filter-menu-accordion-order-status-title": "\n .title = Orderstatus",
        "filter-menu-accordion-companies-title": "\n .title = Företag",
        "filter-menu-accordion-checkbox-awaiting-approval": "\n .optionLabel = Väntar på godkännande",
        "filter-menu-accordion-checkbox-to-be-invoiced": "\n .optionLabel = Ska faktureras",
        "meeting-service-table-header-date-range-button": "Datumintervall",
        "meeting-service-table-header-period-picker-button": "Periodväljare",
        "meeting-service-table-lock-column-locked":"\n .title = Ordern har låsts av försäljningsstället. Kontakta försäljningsstället för uppdateringar.",
        "meeting-service-snackbar-undo": "ÅNGRA",
        "meeting-service-snackbar-undo-message": "{ $amount ->\n  [one] { $amount } order har ändrats till \n *[other] { $amount } order har ändrats till \n}",
        "meeting-service-delivery-list": "Leveranslista",
        "meeting-service-delivery-list-period": "Period:<dateRange>{$startLabel} - {$endLabel}</dateRange><icon />",
        "meeting-service-delivery-list-period-all": "Period:<all>Alla</all><icon />",
        "meeting-service-delivery-list-header-period": "Period: {$startLabel} - {$endLabel}",
        "meeting-service-delivery-list-header-period-all": "Period: Alla",
        "meeting-service-delivery-list-orders-selected": "Order: {$ordersLength} valda",
        "meeting-service-delivery-list-group-by-label": "Gruppera efter:",
        "meeting-service-delivery-list-group-by-location": "Leveransplats",
        "meeting-service-delivery-list-group-by-time": "Leveranstid",
        "meeting-service-delivery-list-group-by-item": "Gruppera efter: leverans {$value}",
        "meeting-service-delivery-list-delivery": "Leveranstyp:<value>{$value}</value>",
        "meeting-service-delivery-list-filter-all": "Alla",
        "meeting-service-delivery-list-empty": "Inga leveransorder för de valda kriterierna",
        "meeting-service-delivery-list-delivery-details-meeting-time": "\n .label = Mötestid:",
        "meeting-service-delivery-list-delivery-details-location": "\n .label = Leveransplats:",
        "meeting-service-delivery-list-delivery-details-sittings": "\n .label = Kuvert:",
        "meeting-service-delivery-list-contact-details-meeting-creator": "\n .label = Skapad av:",
        "meeting-service-delivery-list-contact-details-meeting-host": "\n .label = Mötesvärd:",
        "meeting-service-delivery-list-table-column-items": "Antal",
        "meeting-service-delivery-list-table-column-products": "Produkter",
        "meeting-service-delivery-list-table-column-delivery-time": "Leveranstid",

        // Batch modal
        "meeting-service-batch-modal-title": "\n .dialogTitle = Ändra status",
        "meeting-service-batch-modal-button-change-label": "Bekräfta",
        "meeting-service-batch-modal-button-close-label": "Stäng",
        "meeting-service-batch-modal-button-close-tooltip-label": "\n .title = Inga order kan ändra status",
        "meeting-service-batch-modal-warning-message": "Det gick inte att ändra status för order med den här ikonen",
        "meeting-service-batch-modal-cancellation-reason-message": "Skriv en orsak till avbokningen. Meddelandet skickas till alla i listan.",
        "meeting-service-batch-modal-customer-message": "Meddelande till kund",
        "meeting-service-batch-modal-order-id": "Order-ID",
        "meeting-service-batch-modal-delivery-time": "Leveranstid",
        "meeting-service-batch-modal-order-details": "Orderdetaljer",
        "meeting-service-batch-modal-from": "Från",
        "meeting-service-batch-modal-to": "Till",
        "meeting-service-batch-modal-batch-error": "{ $ordersCount ->\n  [one] Det gick inte att ändra status för { $ordersCount } order\n *[other] Det gick inte att ändra status för { $ordersCount } order\n}",

        // Package slip handle PDF open
        "meeting-service-handle-pdf-open-error": "Det gick inte att öppna pdf",

        // Merchant > Reports > Production > Calendar
        "orders-for-calendar-multi-select": "\n .label = Butikstyp",
        "orders-for-calendar-search": "\n .label = Sök \n .placeholder = Sök efter order-ID eller ordernamn",
        "expandable-search-search-button": "Sök",
        "expandable-search-clear-button": "Rensa sökning",
        "production-slip-dialog-title": "Följesedel",
        "production-slip-dialog-table-header-items": "Antal",
        "production-slip-dialog-table-header-products": "Produkter",
        "production-slip-dialog-table-header-delivery-time": "Leveranstid",
        "production-slip-dialog-note": "Ordernotering",
        "production-slip-dialog-order-id": "Order-ID: { $orderId }",
        "production-slip-dialog-delivery-details": "Leveransdetaljer",
        "production-slip-dialog-delivery-type": "Leveranstyp:",
        "production-slip-dialog-delivery-time": "Leveranstidpunkt:",
        "production-slip-dialog-delivery-meeting-time": "Mötestidpunkt:",
        "production-slip-dialog-delivery-delivery-location": "Leveransplats:",
        "production-slip-dialog-delivery-sittings": "Kuvert:",
        "production-slip-dialog-delivery-shop": "Butik:",
        "production-slip-dialog-contact-details": "Kontaktuppgifter",
        "production-slip-dialog-contact-details-creator": "Beställare:",
        "production-slip-dialog-contact-details-meeting-host": "Mötesvärd:",
        "production-slip-dialog-scan": "Visa följesedel på mobil enhet",

        // Accounting customer
        "customer-accounting-show-customers-with-sales-only": "Visa endast kunder med försäljning",


        // FloatingActionButton
        "floating-action-button": "Stäng",
        "floating-action-button-picked": "Valda artiklar",
        "floating-action-button-order-status": "\n .title = Status",
        "floating-action-button-order-status-menu-item": "Ändra orderstatus",
        "floating-action-button-receipt": "Kvitto",
        "floating-action-button-print": "\n .title = Skriv ut",
        "floating-action-button-print-receipt": "\n .title = Skriv ut kvitto",
        "floating-action-button-print-label": "\n .title = Skriv ut etikett",
        "print-label-copies-modal": "\n .title = Skriv ut etikett\n .message = Hur många kopior vill du skriva ut?\n .buttonLabelSubmit = Skriv ut\n .buttonLabelCancel = Avbryt",
        "floating-action-button-export": "\n .title = Exportera",


        //ChangeOrderStatusModal
        "change-order-status": "Ändra orderstatus",
        "change-order-status-received": "Mottagen",
        "change-order-status-confirmed": "Bekräftad",
        "change-order-status-ready": "Klar",
        "change-order-status-cancelled": "Avbruten",
        "change-order-status-title": "Resultat",

        "change-order-status-received-info-text": "En order får automatiskt status Mottagen när den skapas. Om du vill ändra status från Bekräftad tillbaka till Mottagen får kunden en avisering. Ändra bara tillbaka status om du av misstag har satt den till Bekräftad.",
        "change-order-status-confirmed-info-text": "När en order sätts till Bekräftad får kunden en avisering om att ordern behandlas. Kunden kan förvänta sig att få sin order.",
        "change-order-status-ready-info-text": "När en order sätts till Klar får kunden en avisering om att ordern kan hämtas.",
        "change-order-status-cancelled-info-text": "När en order sätts till Avbruten får kunden en avisering om att ordern inte kommer att levereras. Du kan skriva en kommentar till kunden om varför den har avbrutits.",


        //ChangeOrderStatusResponseModal
        "change-order-status-response-modal-title": "Resultat",
        "change-order-status-response-modal-order-id": "Order-ID",
        "change-order-status-response-modal-order-delivery": "Leveransdatum",
        "change-order-status-response-modal-order-message": "Meddelande",
        "change-order-status-response-modal-error": "misslyckades",
        "change-order-status-response-modal-error-aciton": "åtgärd",
        "change-order-status-response-modal-error-acitons": "åtgärder",


        // --- Surveys List ---
        "surveys-list-header": "\n .title = Enkäter",
        "surveys-list-create-button": "Skapa ny",
        "surveys-list-survey-table-name-column": "Namn",
        "surveys-list-survey-table-start-date-column": "Startdatum",
        "surveys-list-survey-table-end-date-column": "Slutdatum",
        "surveys-list-survey-table-active-column-active": "Aktiv",
        "surveys-list-survey-table-active-column-inactive": "Inaktiv",
        "surveys-list-survey-table-active-column-active-filter-yes": "Aktiv",
        "surveys-list-survey-table-active-column-inactive-filter-no": "Inaktiv",
        "surveys-table-list-delete-modal-title": "enkät",
        "surveys-table-list-show-ratings": "Visa betyg",
        "surveys-table-list-delete-success-message": "Enkäten har tagits bort",

        // Create / edit survey
        "create-survey-header": "\n .title = Skapa enkät",
        "edit-survey-header": "\n .title = Redigera enkät",
        "nav-item-create-survey-header": "Skapa enkät",
        "nav-item-edit-survey-header": "Redigera enkät",
        "create-merchant-survey-save-button": "Skapa",
        "edit-merchant-survey-save-button": "Spara",
        "create-or-edit-merchant-survey-field-name": "\n .label = Namn\n .placeholder = Ange ett namn på enkäten\n .helperText = Beskrivningen visas inte för användaren",
        "create-or-edit-merchant-survey-field-name-required": "Namn är obligatoriskt",
        "create-or-edit-merchant-survey-field-description":
            "\n .label = Beskrivning\n .placeholder = Ange en valfri beskrivning för eget bruk\n .helperText = Beskrivningen visas inte för användaren",
        "create-or-edit-merchant-survey-questions": "Dina frågor:",
        "create-or-edit-merchant-survey-questions-empty": "Du har inte skapat några frågor ännu.",
        "create-or-edit-merchant-survey-field-questions-minError":"Du behöver minst en fråga",
        "create-or-edit-merchant-survey-add-questions-button": "Lägg till fråga",
        "create-or-edit-merchant-survey-title-general": "\n .title = Allmänt",
        "create-or-edit-merchant-survey-field-active": "Aktiv:",
        "create-or-edit-merchant-survey-field-start-date": "Startdatum",
        "create-or-edit-merchant-survey-field-end-date": "Slutdatum",
        "create-or-edit-merchant-survey-title-user-visibility": "\n .title = Synlighet för användare",
        "create-or-edit-merchant-survey-field-timeOfDay": "\n .label = Tid på dagen",
        "create-or-edit-merchant-survey-field-timeOfDay-helperText": "Anger vid vilken tid på dagen betygskortet för den här enkäten visas.",
        "create-or-edit-merchant-survey-field-expirationDays": "\n .label = Giltighetstid i dagar\n .helperText = Antal dagar tills ett obesvarat betygskort döljs.",
        "edit-merchant-survey-success-save-message": "Enkäten har uppdaterats",
        "create-merchant-survey-success-save-message": "Enkät skapad",
        "create-or-edit-merchant-survey-dialog-save-button": "Spara",
        "create-or-edit-merchant-survey-dialog-title": "Lägg till fråga",
        "create-or-edit-merchant-survey-dialog-field-question": "\n .label = Fråga",
        "create-or-edit-merchant-survey-dialog-topics-title": "Välj ämnen:",
        "create-or-edit-merchant-survey-dialog-topics-good": "\n .label = Bra ämnen",
        "create-or-edit-merchant-survey-dialog-topics-bad": "\n .label = Dåliga ämnen",
        "create-or-edit-merchant-survey-dialog-topics-info": "Bra ämnen kan användas av deltagaren för att välja vad de tyckte var särskilt bra. Dåliga ämnen kan användas för att ange vad de gärna vill se förbättrat.",


        // --- Company ---

        "company-home-purchases-card-group": "\n .title = Köp",
        "company-home-purchases-period-base-3": "Senaste 3 dagarna",
        "company-home-purchases-period-base-14": "Senaste 14 dagarna",
        "company-home-purchases-period-base-30": "Senaste 30 dagarna",
        "company-home-purchases-period-base-60": "Senaste 60 dagarna",
        "company-home-purchases-period-base-180": "Senaste 180 dagarna",
        "company-home-purchases-pos-purchases-title": " \n .title = POS-köp",
        "company-home-purchases-pos-orders-title": " \n .title = POS-order",
        "company-home-purchases-meeting-service-purchases-title": " \n .title = Mötesförtäringsköp",
        "company-home-purchases-meeting-service-orders-title": " \n .title = Mötesförtäringsorder",
        "company-home-purchases-users-title": " \n .title = Användare",
        "company-home-purchases-check-in-title": " \n .title = Incheckningar",


        // Company > Admin > Home
        "company-admin-home-organization-users-card":  "\n .title = Användare \n .description = Hantera användare.",
        "company-admin-home-organization-bill-receivers-card":  "\n .title = Fakturamottagare \n .description = Hantera fakturamottagare.",
        "company-admin-home-organization-user-group-card":  "\n .title = Användargrupper \n .description = Hantera användargrupper.",
        "company-admin-home-organization-departments-card":  "\n .title = Avdelningar \n .description = Hantera avdelningar.",
        "company-admin-home-organization-workgroups-card":  "\n .title = Arbetsgrupper \n .description = Hantera arbetsgrupper.",
        "company-admin-home-organization-locations-card":  "\n .title = Platser \n .description = Hantera platser.",
        "company-admin-home-account-gdpr-card":  "\n .title = GDPR \n .description = Dataskyddsförordningen \n .buttonText = Visa",
        "company-admin-home-account-administrator-card":  "\n .title = Administratörer \n .description = Hantera administratörer.",

        // Navigation
        "company-nav-item-home": "Hem",
        "company-home-coming-soon-placeholder": "\n .title = Kommer snart",
        "company-home-coming-soon-placeholder-body": "Du är inloggad som företagsadministratör. Vi arbetar på att ge dig den här funktionen. Använd tills vidare <externalLink>bestil-nu.net</externalLink>.",
        "company-nav-item-accounting": "\n .title = Redovisning",
        "company-nav-item-pos": "POS",
        "company-nav-item-meeting-service": "Mötesförtäring",
        "company-nav-item-subscriptions": "Prenumerationer",
        "company-nav-item-organization": "\n .title = Organisation",
        "company-nav-item-users": "Användare",
        "company-nav-item-admins": "Administratörer",
        "company-nav-item-user-groups": "Användargrupper",
        "company-nav-item-departments": "Avdelningar",
        "company-nav-item-workgroups": "Arbetsgrupper",
        "company-nav-item-locations": "Platser",
        "company-nav-item-bill-receivers": "Fakturamottagare",
        "company-nav-item-account-dimensions": "Kontodimensioner",
        "company-nav-item-settings": "Inställningar",
        "company-nav-item-account-title": "\n .title = Konto",
        "company-nav-item-account": "Konto",
        "company-nav-item-gdpr": "GDPR",
        "company-nav-item-data-import-title": "\n .title = Dataimport",
        "company-nav-item-data-import": "Dataimport",
        "company-nav-item-id-cards": "ID-kort",
        "company-nav-item-account-numbers": "Kontonummer",
        "company-nav-item-import-users": "Användare",
        "company-nav-item-import-bill-receivers": "Fakturamottagare",
        "company-nav-item-settings-title": "\n .title = Inställningar",
        "company-nav-item-custom-jobs": "Anpassade jobb",


        // Company > Admin > Organization > Departments
        "company-organization-title": "\n .title = Organisation",
        "company-organization-departments-title": "Avdelningar",
        "company-organization-departments-header": "\n .title = Avdelningar",
        "company-organization-departments-create-button": "Skapa ny",
        "company-organization-departments-table-department-no-column": "Avdelningsnr",
        "company-organization-departments-table-name-column": "Namn",
        "company-organization-departments-table-status-column": "Status",
        "company-organization-departments-table-active-column-active": "Aktiv",
        "company-organization-departments-table-active-column-inactive": "Inaktiv",
        "company-organization-departments-table-active-column-active-filter-yes": "Aktiv",
        "company-organization-departments-table-active-column-inactive-filter-no": "Inaktiv",
        "company-organization-departments-table-edit": "Redigera",
        "company-organization-departments-table-delete": "Ta bort",
        "company-organization-departments-table-delete-modal-title": "avdelning",
        "company-organization-departments-edit-title": "Redigera avdelning",
        "company-organization-departments-create-title": "Skapa avdelning",
        "create-department-header": "\n .title = Skapa avdelning",
        "edit-department-header": "\n .title = Redigera avdelning",
        "edit-department-save-button": "Spara",
        "create-department-save-button": "Skapa",
        "create-or-edit-company-department-field-departmentNo": "\n .label = Avdelningsnr\n .placeholder = Ange avdelningsnr",
        "create-or-edit-company-department-field-name": "\n .label = Namn\n .placeholder = Ange namn",
        "create-or-edit-company-department-field-is-required": "Fältet är obligatoriskt",
        "create-or-edit-company-department-field-active": "Aktiv",
        "create-or-edit-company-department-settings": "\n .title = Inställningar",
        "create-or-edit-company-department-history": "\n .title = Historik",

        // Company > Admin > Organization > Workgroups
        "company-organization-workgroups-title": "Arbetsgrupper",
        "company-organization-workgroups-header": "\n .title = Arbetsgrupper",
        "company-organization-workgroups-create-button": "Skapa ny",
        "company-organization-workgroups-table-name-column": "Namn",
        "company-organization-workgroups-table-calendar-column": "E-postadress för kalender",
        "company-organization-workgroups-table-members-column": "Medlemmar",
        "company-organization-workgroups-table-status-column": "Status",
        "company-organization-workgroups-table-edit": "Redigera",
        "company-organization-workgroups-table-delete": "Ta bort",
        "company-organization-workgroups-table-delete-modal-title": "arbetsgrupp",
        "company-organization-workgroups-edit-title": "Redigera arbetsgrupp",
        "company-organization-workgroups-create-title": "Skapa arbetsgrupp",
        "create-workgroup-header": "\n .title = Skapa arbetsgrupp",
        "edit-workgroup-header": "\n .title = Redigera arbetsgrupp",
        "edit-workgroup-save-button": "Spara",
        "create-workgroup-save-button": "Skapa",
        "create-or-edit-company-workgroup-field-name": "\n .label = Namn\n .placeholder = Ange namn",
        "create-or-edit-company-workgroup-field-description": "\n .label = Beskrivning till användare\n .placeholder = Ange beskrivning till användare",
        "create-or-edit-company-workgroup-field-description-info": "\n .title = Visas för användarna när de väljer en arbetsgrupp, så beskriv vem gruppen är till för.",
        "create-or-edit-company-workgroup-field-calendar-email": "\n .label = E-postadress för kalender\n .placeholder = Ange e-postadress för kalender",
        "create-or-edit-company-workgroup-field-calendar-email-info": "\n .title = Den delade brevlådan eller kalenderadressen för den här arbetsgruppen. Bokningar och mötesförtäringsorder från medlemmarna samlas här, så att medlemmarna kan se varandras bokningar.",
        "create-or-edit-company-workgroup-field-is-required": "Fältet är obligatoriskt",
        "create-or-edit-company-workgroup-field-invalid-email": "Ange en giltig e-postadress",
        "create-or-edit-company-workgroup-field-name-max-length": "Namnet får vara högst { $maxLength } tecken",
        "create-or-edit-company-workgroup-field-calendar-email-max-length": "E-postadressen för kalender får vara högst { $maxLength } tecken",
        "create-or-edit-company-workgroup-field-description-max-length": "Beskrivningen får vara högst { $maxLength } tecken",
        "create-or-edit-company-workgroup-field-active": "Aktiv",
        "create-or-edit-company-workgroup-settings": "\n .title = Inställningar",
        "create-or-edit-company-workgroup-history": "\n .title = Historik",
        "create-or-edit-company-workgroup-members": "\n .title = Medlemmar",
        "create-or-edit-company-workgroup-members-empty": "\n .title = Inga medlemmar ännu\n .description = Lägg till de personer som ska dela brevlådan och kunna se varandras bokningar och beställningar av mötesförtäring.",
        "create-or-edit-company-workgroup-members-remove": "Ta bort från gruppen",
        "create-or-edit-company-workgroup-members-add-field": "\n .label = Lägg till medlem\n .placeholder = Sök på namn, minst 3 tecken",
        "create-or-edit-company-workgroup-members-table-header-user-id": "Användar-ID",
        "create-or-edit-company-workgroup-members-table-header-name": "Namn",
        "create-or-edit-company-workgroup-members-table-header-email": "E-post",
        "create-or-edit-company-workgroup-members-table-header-status": "Status",
        "create-or-edit-company-workgroup-members-department-filter-label": "Avdelning",
        "create-or-edit-company-workgroup-members-department-filter": "\n .label = Avdelning",
        "create-or-edit-company-workgroup-members-department-filter-all": "Alla avdelningar",
        "create-or-edit-company-workgroup-members-department-filter-none": "Ingen avdelning",
        "create-or-edit-company-workgroup-members-details-button": "Detaljer",
        "create-or-edit-company-workgroup-members-removed": "{ $count ->\n [one] { $count } medlem borttagen från gruppen\n *[other] { $count } medlemmar borttagna från gruppen\n}",
        "create-or-edit-company-workgroup-members-undo-button": "Ångra",
        "create-or-edit-company-workgroup-members-bulk-remove": "\n .title = Ta bort från gruppen",
        "create-or-edit-company-workgroup-members-remove-dialog-title": "{ $count ->\n [one] Ta bort { $count } medlem från gruppen?\n *[other] Ta bort { $count } medlemmar från gruppen?\n}",
        "create-or-edit-company-workgroup-members-remove-dialog-message": "{ $names }{ $hidden ->\n [0] {\"\"}\n [one] {\" \"}och { $hidden } till\n *[other] {\" \"}och { $hidden } till\n} tas bort från { $workgroup } och kommer inte längre att se gruppens bokningar. Användarna tas inte bort.",
        "create-or-edit-company-workgroup-members-remove-dialog-message-unnamed": "{ $names }{ $hidden ->\n [0] {\"\"}\n [one] {\" \"}och { $hidden } till\n *[other] {\" \"}och { $hidden } till\n} tas bort från den här gruppen och kommer inte längre att se gruppens bokningar. Användarna tas inte bort.",
        "create-or-edit-company-workgroup-members-remove-dialog": "\n .buttonLabelSubmit = { $count ->\n [one] Ta bort { $count } medlem\n *[other] Ta bort { $count } medlemmar\n }\n .buttonLabelCancel = Avbryt",
        "company-user-workgroups-panel": "\n .title = Arbetsgrupper",
        "company-user-workgroups-panel-empty": "Den här användaren är ännu inte medlem i någon arbetsgrupp.",
        "company-user-workgroups-panel-add-button": "Lägg till",
        "company-user-workgroups-panel-remove": "Ta bort",
        "company-user-workgroups-panel-add-dialog-title": "Lägg till i arbetsgrupp",
        "company-user-workgroups-panel-add-dialog-empty": "Det finns inga fler arbetsgrupper att lägga till.",

        // Company Admin Organization > Users (create/edit form)
        "company-user-create-page-title": "\n .title = Skapa användare",
        "company-user-edit-page-title": "\n .title = Redigera användare",
        "company-user-create-submit": "Skapa",
        "company-user-edit-submit": "Spara",
        "company-user-create-breadcrumb": "Skapa användare",
        "company-user-edit-breadcrumb": "Redigera användare",
        "company-user-tab-details": "Användaruppgifter",
        "company-user-tab-workgroups": "Arbetsgrupper",
        "company-user-tab-approvals": "Användargodkännanden",
        "company-user-tab-catalog": "Kantinåtkomst",
        "company-user-tab-guest-checkin": "Gästincheckning",
        "company-user-workgroups-tab-description":
            "Välj en eller flera arbetsgrupper för användaren. I en arbetsgrupp kan medlemmarna samarbeta, till exempel se varandras bokningar och mötesförtäringsorder via en delad kalender.",
        "company-user-workgroups-calendar-email-label": "E-post för kalender:",
        "company-user-workgroups-empty": "Inga arbetsgrupper tillgängliga.",
        "company-user-sync-warning":
            "Den här användaren omfattas av katalogsynkronisering: namn, e-post och avdelning kan skrivas över vid nästa synkronisering. Inaktivera användarsynkronisering för att redigera dem permanent.",
        "company-user-field-user-group": "Användargrupp",
        "company-user-field-user-group-placeholder": "Välj användargrupp...",
        "company-user-field-department": "Avdelning",
        "company-user-field-department-placeholder": "Välj avdelning...",
        "company-user-field-employee-id": "Anställnings-ID",
        "company-user-field-employee-id-placeholder": "t.ex. 10062",
        "company-user-field-name": "Namn",
        "company-user-field-name-placeholder": "Fullständigt namn",
        "company-user-field-initials": "Initialer",
        "company-user-field-initials-placeholder": "Fylls i automatiskt från namn",
        "company-user-field-username": "Användarnamn",
        "company-user-field-username-placeholder": "Genereras automatiskt om tomt",
        "company-user-field-email": "E-post",
        "company-user-field-email-placeholder": "namn@foretag.se",
        "company-user-field-mobile": "Mobil",
        "company-user-field-mobile-placeholder": "12 34 56 78",
        "company-user-field-phone": "Telefonnr",
        "company-user-field-phone-placeholder": "12 34 56 78",
        "company-user-field-language": "Språk",
        "company-user-field-select-placeholder": "Inte vald",
        "company-user-language-option-danish": "Danska",
        "company-user-language-option-english": "Engelska",
        "company-user-approvals-description": "Välj de användargrupper som den här användaren godkänner när medlemmarna registrerar sig själva.",
        "company-user-approvals-heading": "Godkänn användargrupper",
        "company-user-catalog-description": "En användare kan få åtkomst till en eller flera kantiner; expandera en kantin för att välja dess prislistor.",
        "company-user-catalog-heading": "Delegerade kantiner / prislistor",
        "company-user-catalog-summary-empty": "Inga kantiner / prislistor valda",
        "company-user-catalog-summary-counts": "{ $count } prislistor i { $canteens } kantiner",
        "company-user-catalog-search-placeholder": "Sök kantiner...",
        "company-user-catalog-empty": "Inga kantiner hittades.",
        "company-user-guest-checkin-description": "Välj om den här användaren ska aviseras när en gäst checkar in.",
        "company-user-guest-checkin-toggle": "Avisera vid gästincheckning",
        "company-user-details-account-user-id": "Användar-ID",
        "company-user-details-account-username": "Användarnamn",
        "company-user-details-account-employee-id": "Anställnings-ID",
        "company-user-details-account-user-group": "Användargrupp",
        "company-user-details-account-department": "Avdelning",
        "company-user-details-account-phone": "Telefon",
        "company-user-details-account-language": "Språk",
        "company-user-details-section-idcard": "ID-kort",
        "company-user-details-idcard-empty": "Inget ID-kort kopplat.",
        "company-user-details-last-signin": "Senaste inloggning",
        "company-user-details-never": "Aldrig",
        "company-user-details-section-tracking": "Spårning",
        "company-user-details-sync-status": "Användarsynkronisering",
        "company-user-details-sync-source": "Synkroniseringskälla",
        "company-user-details-sync-last-synced": "Senast synkroniserad",
        "company-user-details-sync-none": "Inte synkroniserad",
        "company-user-details-section-roles": "Roller",
        "company-user-details-roles-empty": "Inga roller tilldelade.",
        "company-user-details-role-secretary": "Sekreterare",
        "company-user-details-edit-button": "Redigera användare",
        "company-user-details-impersonate-button": "Logga in som",
        "company-user-details-error-title": "Det gick inte att läsa in användaren",
        "company-user-details-error-message": "Något gick fel när användaren lästes in. Försök igen.",
        "company-user-settings-panel-title": "\n .title = Inställningar",
        "company-user-settings-active": "Aktiv",
        "company-user-settings-send-invitation": "Skicka e-postinbjudan",
        "company-user-settings-send-invitation-helper": "Användaren får en inloggningslänk via e-post.",
        "company-user-settings-disable-sync": "Inaktivera användarsynkronisering",
        "company-user-settings-disable-sync-helper": "När detta är inaktiverat ignoreras användaren av synkroniseringsjobbet.",
        "company-user-settings-secretary": "Sekreterare",
        "company-user-settings-secretary-helper": "Får tillgång till sekreterarverktyg för att boka och hantera ordrar å andra användares vägnar.",
        "company-user-validation-required": "Detta fält är obligatoriskt",
        "company-user-validation-invalid-email": "Ange en giltig e-postadress",
        "company-user-validation-invalid-phone": "Ange ett giltigt telefonnummer",

        // Company Admin Organization > Users (list & bulk actions)
        "company-users-status-filter-all": "Alla",
        "company-users-status-filter-active": "Aktiva",
        "company-users-status-filter-inactive": "Inaktiva",
        "company-users-status-active": "Aktiv",
        "company-users-status-inactive": "Inaktiv",
        "company-users-cell-internal-id": "Internt ID: { $id }",
        "company-users-cell-sync-badge": "Synk",
        "company-users-cell-rights": "{ $count -> \n *[other] { $count } behörigheter \n [one] { $count } behörighet \n }",
        "company-users-delete-entity": "användare",
        "company-users-bulk-status": "\n .title = Status",
        "company-users-bulk-set-active": "\n .title = Aktiv",
        "company-users-bulk-set-inactive": "\n .title = Inaktiv",
        "company-users-bulk-resend-invite": "\n .title = Skicka inbjudan igen",
        "company-users-bulk-move-group": "\n .title = Flytta till grupp",
        "company-users-bulk-export": "\n .title = Exportera",
        "company-users-bulk-success": "{ $count } användare uppdaterade",
        "company-users-export-header-name": "Namn",
        "company-users-export-header-first-name": "Förnamn",
        "company-users-export-header-last-name": "Efternamn",
        "company-users-export-header-username": "Användarnamn",
        "company-users-export-header-email": "E-post",
        "company-users-export-header-mobile": "Mobil",
        "company-users-export-header-phone": "Telefon",
        "company-users-export-header-employee-id": "Anställnings-ID",
        "company-users-export-header-user-group": "Användargrupp",
        "company-users-export-header-department": "Avdelning",
        "company-users-export-header-language": "Språk",
        "company-users-export-header-roles": "Roller",
        "company-users-export-header-user-sync": "Användarsynkronisering",
        "company-users-export-header-last-signin": "Senaste inloggning",
        "company-users-export-header-status": "Status",

        // Company Admin Organization > User Groups
        "company-organization-user-groups-title": "Användargrupper",
        "company-organization-user-groups-header": "\n .title = Användargrupper",
        "company-organization-user-groups-create-button": "Skapa ny",
        "company-organization-user-groups-table-name-column": "Namn",
        "company-organization-user-groups-table-domain-column": "Domän",
        "company-organization-user-groups-table-status-column": "Status",
        "company-organization-user-groups-table-active-column-active": "Aktiv",
        "company-organization-user-groups-table-active-column-inactive": "Inaktiv",
        "company-organization-user-groups-table-active-column-active-filter-yes": "Aktiv",
        "company-organization-user-groups-table-active-column-inactive-filter-no": "Inaktiv",
        "company-organization-user-groups-table-edit": "Redigera",
        "company-organization-user-groups-table-delete": "Ta bort",
        "company-organization-user-groups-table-delete-modal-title": "\n .typeOfEntity = användargrupp",
        "company-organization-user-group-edit-title": "Redigera användargrupp",
        "company-organization-user-group-create-title": "Skapa användargrupp",
        "create-user-group-header": "\n .title = Skapa användargrupp",
        "edit-user-group-header": "\n .title = Redigera användargrupp",
        "edit-user-group-save-button": "Spara",
        "create-user-group-save-button": "Skapa",
        "create-or-edit-company-user-group-field-name": "\n .label = Namn\n .placeholder = Ange namn",
        "create-or-edit-company-user-group-field-active": "Aktiv",
        "create-or-edit-company-user-group-settings": "\n .title = Inställningar",
        "create-or-edit-company-user-group-history": "\n .title = Historik",
        "create-or-edit-company-user-group-connected-domains": "Anslutna domäner",
        "create-or-edit-company-user-group-connected-domains-empty": "Du har inte skapat några domäner ännu.",
        "create-or-edit-company-user-group-connected-domains-add-button": "\n .title = Lägg till domän",
        "create-or-edit-company-user-group-connected-domains-table-domain": "Domän",
        "create-or-edit-company-user-group-connected-domains-table-status": "Status",
        "create-or-edit-company-user-group-connected-domains-table-status-active": "Aktiv",
        "create-or-edit-company-user-group-connected-domains-table-status-pending": "Väntar / Inbjudan skickad",
        "create-or-edit-company-user-group-connected-domains-table-resend-invitation": "Skicka inbjudan igen",
        "create-or-edit-company-user-group-connected-domains-table-delete": "Ta bort",
        "company-organization-user-groups-table-delete-modal-domain": "\n .typeOfEntity = domän",
        "create-or-edit-company-user-group-connected-domains-modal-add-domain": "Lägg till domän",
        "create-or-edit-company-user-group-connected-domains-modal-resend-invitation": "Skicka inbjudan igen för domän",
        "create-or-edit-company-user-group-connected-domains-modal-field-domain": "\n .label = Domän\n .placeholder = Ange domän",
        "create-or-edit-company-user-group-connected-domains-modal-field-username": "\n .label = Användarnamn\n .placeholder = Ange användarnamn",
        "create-or-edit-company-user-group-connected-domains-modal-send-invitation": "Skicka inbjudan",
        "create-or-edit-company-user-group-connected-bill-receiver": "Fakturamottagare",
        "create-or-edit-company-user-group-connected-bill-receiver-empty": "Du har inte skapat någon fakturamottagare ännu.",
        "create-or-edit-company-user-group-connected-bill-receiver-add-button": "\n .title = Lägg till fakturamottagare",
        "create-or-edit-company-user-group-connected-bill-receiver-table-name": "Namn",
        "create-or-edit-company-user-group-connected-bill-receiver-table-address": "Adress",
        "create-or-edit-company-user-group-connected-bill-receiver-table-end-point": "Slutpunkt",
        "create-or-edit-company-user-group-connected-bill-receiver-table-remove": "Ta bort",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-add-bill-receiver": "\n .title = Lägg till fakturamottagare",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-update-bill-receiver": "\n .title = Liknande fakturamottagare hittades. Är du säker på att du vill skapa en ny?",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-field-search": "\n .label = Sök\n .placeholder = Sök efter namn, CVR, EAN, e-post eller adress",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-info-text": "Börja skriva för att visa sökresultat",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-info-warning": "Du bör bara skapa en ny fakturamottagare med samma identifierare (CVR, EAN, e-post) om kontaktuppgifterna skiljer sig åt. Det kan till exempel behövas om fakturan ska skickas till en annan person.",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-empty": "Inga sökresultat hittades",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-cvr": "CVR:",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-ean": "EAN:",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-email": "E-post:",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-address": "Adress:",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-or": "Eller",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-submit-button": "Använd vald fakturamottagare",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-submit-update-button": "Uppdatera vald fakturamottagare",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-create-button": " Skapa ny fakturamottagare",
        "create-or-edit-company-user-group-connected-bill-receiver-modal-bill-found": "{ $count } fakturamottagare finns redan med samma identifierare.",

        // Company > Admin > Account > GDPR
        "company-account-gdpr-title":"\n .title = GDPR",

        // Company > Admin > Data import
        "data-import-csv-field-update-key": "\n .label = Uppdateringsnyckel",
        "data-import-csv-settings": "\n .title = Inställningar",
        "data-import-csv-field-update-identical": "Uppdatera identiska",
        "data-import-csv-field-delete-existing": "Ta bort befintliga",

        // Company > Admin > Data import > ID cards
        "company-data-import-id-cards-title": "\n .title = Importera ID-kort",
        "create-or-edit-company-id-cards-field-user-group": "\n .label = Användargrupp",
        "create-or-edit-company-id-cards-select-item-all": "Alla",
        "create-or-edit-company-id-cards-update-key-mode-initials": "Initialer",
        "create-or-edit-company-id-cards-update-key-mode-email": "E-post",
        "create-or-edit-company-id-cards-update-key-mode-employee-number": "Anställningsnummer",


        // Company > Admin > Data import > Account number
        "company-data-import-account-numbers-title": "\n .title = Importera kontonummer",
        "create-or-edit-company-account-numbers-field-accounting-dimension": "\n .label = Redovisningsdimension",
        "create-or-edit-company-account-numbers-select-item-all": "Alla",
        "create-or-edit-company-account-numbers-update-key-mode-account-number": "Kontonummer",
        "create-or-edit-company-account-numbers-update-key-mode-account-name": "Kontonamn",

        // Company > Admin > Data import > Users
        "company-data-import-users-title": "\n .title = Importera användare",
        "company-data-import-users-field-user-group": "\n .label = Användargrupp",
        "company-data-import-users-select-item-from-file": "Från fil",

        // Company > Admin > Data import > Bill receivers
        "company-data-import-bill-receivers-title": "\n .title = Importera fakturamottagare",
        "company-data-import-bill-receivers-receiver-type": "\n .label = Mottagartyp",
        "company-data-import-bill-receivers-receiver-type-mode-private-person": "Privatperson / förening",
        "company-data-import-bill-receivers-receiver-type-mode-public-institution": "Offentlig institution",
        "company-data-import-bill-receivers-receiver-type-mode-private-company": "Privat företag",
        "company-data-import-bill-receivers-receiver-type-mode-from-file": "Från fil",

        // Company > Admin > Settings > Custom jobs
        "company-admin-settings-custom-jobs-title":" \n .title = Anpassade jobb",
        "company-admin-settings-custom-jobs-table-name":"Namn",
        "company-admin-settings-custom-jobs-table-interval":"Intervall",
        "company-admin-settings-custom-jobs-table-last-run":"Senaste körning",
        "company-admin-settings-custom-jobs-table-status":"Status",
        "company-admin-settings-custom-jobs-table-action-details":"Detaljer",
        "company-admin-settings-custom-jobs-table-action-run-job":"Kör jobb",
        "company-admin-settings-custom-jobs-table-action-activate":"Aktivera",
        "company-admin-settings-custom-jobs-table-action-inactivate":"Inaktivera",

        // Import result
        "import-result-title": "\n .title = Importresultat",
        "import-result-breadcrumb": "Resultat",
        "import-result-succeeded": "Importen lyckades",
        "import-result-results": "Resultat:",
        "import-result-created": "Skapade:",
        "import-result-updated": "Ändrade:",
        "import-result-deleted": "Borttagna:",

        // Company Meeting Service
        "company-meeting-service-title": "Mötesförtäring",
        "company-meeting-service-header": "\n .title = Mötesförtäring",
        "company-meeting-service-table-booked-start-date": "Bokförd från",
        "company-meeting-service-table-booked-end-date": "Bokförd till",
        "company-meeting-service-table-merchant": "Försäljningsställe",
        "company-meeting-service-table-order-id-column": "Order-ID",
        "company-meeting-service-table-booked-date-column": "Bokföringsdatum",
        "company-meeting-service-table-delivery-time-column": "Leveranstid",
        "company-meeting-service-table-employee-column": "Anställd",
        "company-meeting-service-table-amount-column": "Belopp (DKK)",
        "company-meeting-service-table-show-receipt": "Visa kvitto",
        "company-meeting-service-table-floating-action-bar-receipts": "\n .title = Kvitton",
        "company-meeting-service-table-floating-action-bar-export": "\n .title = Exportera",

        // Company Subscriptions
        "company-subscriptions-title": "Prenumerationer",
        "company-subscriptions-header": "\n .title = Prenumerationer",
        "company-subscriptions-table-subscription-column": "Prenumeration",
        "company-subscriptions-table-order-id-column": "Order-ID",
        "company-subscriptions-table-employee-column": "Anställd",
        "company-subscriptions-table-subscribed-column": "Anmäld",
        "company-subscriptions-table-unsubscribed-column": "Avanmäld",
        "company-subscriptions-table-payment-column": "Betalning",
        "company-subscriptions-table-amount-column": "Belopp",
        "company-subscriptions-table-cancel-subscription": "Avsluta prenumeration",
        "company-subscriptions-table-details": "Detaljer",

        // Accounting - POS Purchases
        "accounting-pos-table-header-title": "\n .title = POS",
        "accounting-pos-table-header-nav-item-home": "Hem",
        "accounting-pos-table-header-nav-item-accounting": "Redovisning",
        "accounting-pos-table-header-nav-item-pos": "POS",
        "accounting-pos-table-header-order-id": "Order-ID",
        "accounting-pos-table-header-transaction-time": "Transaktionstid",
        "accounting-pos-table-header-employee": "Anställd",
        "accounting-pos-table-header-payment": "Betalning",
        "accounting-pos-table-header-amount": "Belopp (DKK)",
        "support-entity-table-button-show-receipt": "Visa kvitto",
        "accounting-pos-table-header-merchant-label":"\n .label = Försäljningsställe",
        "accounting-pos-table-footer-total-in-period":"Totalt under denna period (DKK)",

          // Organization - Users
        "company-organization-users-page-header": "\n .title = Användare",
        "company-organization-users-table-header-user-group":"Användargrupp",
        "company-organization-users-table-header-name":"Namn",
        "company-organization-users-table-header-employee-id":"Anställnings-ID",
        "company-organization-users-table-header-email":"E-post",
        "company-organization-users-table-header-status":"Status",
        "company-organization-users-table-status-active":"Aktiv",
        "company-organization-users-table-status-inactive": "Inaktiv",
        "company-organization-users-table-button-details": "Detaljer",
        "company-organization-users-table-button-edit": "Redigera",
        "company-organization-users-table-button-delete": "Ta bort",
        "company-organization-users-table-button-impersonate": "Logga in som",
        "company-organization-users-button-create": "Skapa ny",
        "company-organization-users-tooltip-export": "\n .title = Exportera",
        "company-admin-nav-item-organization": "Organisation",
        "company-admin-nav-item-users": "Användare",
        "company-organization-users-table-header-select-label-user-group": "Användargrupp",
        "company-organization-users-table-header-select-user-group-field": "\n .label = Användargrupp",
        "company-organization-users-table-header-select-label-workgroup": "Arbetsgrupp",
        "company-organization-users-table-header-select-workgroup-field": "\n .label = Arbetsgrupp",
        "company-organization-users-table-header-select-item-all": "Alla",


        // Organization - Admins
        "company-organization-admins-page-header": "\n .title = Administratörer",
        "company-organization-admins-table-header-name":"Namn",
        "company-organization-admins-table-header-email":"E-post",
        "company-organization-admins-table-header-status":"Status",
        "company-organization-admins-table-status-active":"Aktiv",
        "company-organization-admins-table-status-inactive": "Inaktiv",
        "company-organization-admins-table-button-details": "Visa detaljer",
        "company-organization-admins-table-button-edit": "Redigera användare",
        "company-organization-admins-table-button-delete": "Ta bort användare",
        "company-organization-admins-table-button-impersonate": "Logga in som",
        "merchant-admin-users-table-button-impersonate": "Logga in som",
        "supplier-admin-account-admins-table-button-impersonate": "Logga in som",
        "service-center-admin-account-admins-table-button-impersonate": "Logga in som",
        "supplier-admin-merchant-admins-table-button-impersonate": "Logga in som",
        "office-manager-admins-table-button-impersonate": "Logga in som",
        "company-organization-admins-button-create": "Skapa ny",
        "company-admin-nav-item-admins": "Administratörer",
        "impersonation-confirm-dialog":
            "\n .title = Logga in som { $name }?\n .buttonLabelSubmit = Logga in som { $firstName }\n .buttonLabelCancel = Avbryt",
        "impersonation-confirm-dialog-message":
            "Du ser portalen precis som { $firstName } ser den. Allt du gör registreras i { $firstName }s historik under ditt eget namn.",

        // Company Admin Organization Locations
        "company-organization-locations-title": "Platser",
        "company-organization-locations-header": "\n .title = Platser",
        "company-organization-locations-create-button": "Skapa ny",
        "company-organization-locations-table-name-column": "Namn",
        "company-organization-locations-table-status-column": "Status",
        "company-organization-locations-table-active-column-active": "Aktiv",
        "company-organization-locations-table-active-column-inactive": "Inaktiv",
        "company-organization-locations-table-active-column-active-filter-yes": "Aktiv",
        "company-organization-locations-table-active-column-inactive-filter-no": "Inaktiv",
        "company-organization-locations-table-edit": "Redigera",
        "company-organization-locations-table-delete": "Ta bort",
        "company-organization-locations-table-delete-modal-title": "plats",
        "company-organization-locations-edit-title": "Redigera plats",
        "company-organization-locations-create-title": "Skapa plats",
        "create-location-header": "\n .title = Skapa plats",
        "edit-location-header": "\n .title = Redigera plats",
        "edit-location-save-button": "Spara",
        "create-location-save-button": "Skapa",
        "create-or-edit-company-location-field-name": "\n .label = Namn\n .placeholder = Ange namn",
        "create-or-edit-company-location-field-is-required": "Fältet är obligatoriskt",
        "create-or-edit-company-location-field-active": "Aktiv",
        "create-or-edit-company-location-settings": "\n .title = Inställningar",
        "create-or-edit-company-location-history": "\n .title = Historik",
        "create-or-edit-company-location-field-street": "\n .label = Gata\n .placeholder = Ange gata",
        "create-or-edit-company-location-field-streetNumber": "\n .label = Gatunr\n .placeholder = Ange gatunr",
        "create-or-edit-company-location-field-postalCode": "\n .label = Postnummer\n .placeholder = Ange postnummer",
        "create-or-edit-company-location-field-city": "\n .label = Stad\n .placeholder = Ange stad",
        "create-or-edit-company-location-field-country": "\n .label = Land",
        "create-or-edit-company-location-field-country-denmark-item": "Danmark",
        "create-or-edit-company-location-field-shops": "\n .label = Anslutna butiker",

        // Accounting - Bill receivers
        "company-accounting-bill-receivers-table-header-title": "\n .title = Fakturamottagare",
        "company-accounting-bill-receivers-table-header-name":"Namn",
        "company-accounting-bill-receivers-table-header-endpoint":"Slutpunkt",
        "company-accounting-bill-receivers-table-header-debitor-id":"Debitor-id",
        "company-accounting-bill-receivers-table-header-status":"Status",
        "company-accounting-bill-receivers-table-status-active":"Aktiv",
        "company-accounting-bill-receivers-table-status-inactive": "Inaktiv",
        "company-accounting-bill-receivers-table-button-edit": "Redigera",
        "company-accounting-bill-receivers-table-button-delete": "Ta bort",
        "company-accounting-bill-receivers-button-create": "Skapa ny",
        "company-accounting-bill-receivers-table-header-nav-item-home": "Hem",
        "company-accounting-bill-receivers-table-header-nav-item-accounting": "Redovisning",
        "company-accounting-bill-receivers-table-header-nav-item-bill-receivers": "Fakturamottagare",

        // Accounting - Bill receivers - Create Dialog
        "bill-receivers-create-dialog-title": "Skapa fakturamottagare",
        "bill-receivers-create-dialog-customer-type": "Kundtyp:",
        "bill-receivers-create-dialog-select-bill-receiver": " Välj befintlig fakturamottagare:",
        "bill-receivers-create-dialog-country": "Land:",
        "bill-receivers-create-dialog-button-create": "Skapa",
        "bill-receivers-create-dialog-button-save": "Spara",
        "bill-receivers-form-error-label-country":"Land",
        "bill-receivers-form-error-label-debtor-number":"Debitornummer",
        "bill-receivers-form-error-label-address-line-1":"Adressrad 1",
        "bill-receivers-form-error-label-address-line-2":"Adressrad 2",
        "bill-receivers-form-error-label-postal-code":"Postnummer",
        "bill-receivers-form-error-label-city":"Stad",
        "bill-receivers-form-error-label-telephone":"Telefon",
        "bill-receivers-form-error-label-name":"Namn",
        "bill-receivers-form-error-label-institution-name":"Institutionsnamn",
        "bill-receivers-form-error-label-email":"E-post",
        "bill-receivers-form-error-label-contact-person":"Kontaktperson",
        "bill-receivers-form-error-label-company-name":"Företagsnamn",
        "bill-receivers-validation-ean-13-digits": "EAN-nummer måste vara 13 siffror",
        "bill-receivers-validation-cvr-8-digits": "CVR-nummer måste vara 8 siffror",
        "bill-receivers-validation-postal-code-4-digits": "Postnummer måste vara 4 siffror",
        "bill-receivers-validation-email-invalid": "Ange en giltig e-postadress",
        "bill-receivers-validation-telephone-invalid": "Telefon får endast innehålla siffror samt tecknen + - ( ) och mellanslag",
        "bill-receivers-validation-max-length": "{ $label } får vara högst { $max } tecken",
        "bill-receivers-select-type":"Välj typ:",
        "bill-receivers-select-list-label": "Välj fakturamottagare",
        "bill-receivers-select-label":"Välj mottagare:",
        "bill-receivers-select-private-person":"Privatperson / förening",
        "bill-receivers-select-email":"E-post",
        "bill-receivers-select-public-institution":"Offentlig institution",
        "bill-receivers-select-ean-number":"EAN-nummer",
        "bill-receivers-select-private-company":"Privat företag",
        "bill-receivers-select-cvr-number":"CVR-nummer",
        "bill-receivers-company-number":"Ange CVR-nummer:",
        "bill-receivers-input-search-label-number-cvr":"\n .label = CVR-nummer",
        "bill-receivers-button-continue":"Fortsätt",
        "bill-receivers-send-invoice":"Skicka faktura till:",
        "bill-receivers-select-label-input-type":"Typ",
        "bill-receivers-dropdown-type":"\n .label = Typ",
        "bill-receivers-select-item-email":"E-post",
        "bill-receivers-select-item-ean-number":"EAN-nummer",
        "bill-receivers-form-label-address-1":"\n .label = Adressrad 1\n .placeholder = Gatuadress och gatunummer",
        "bill-receivers-form-label-address-2":"\n .label = Adressrad 2\n .placeholder = Våning, lägenhetsnr osv.",
        "bill-receivers-form-label-postal-code":"\n .label = Postnummer",
        "bill-receivers-form-label-city":"\n .label = Stad",
        "bill-receivers-form-label-country":"\n .label = Land",
        "bill-receivers-form-country-select-da": "Danmark",
        "bill-receivers-form-contact-person":"Kontaktperson",
        "bill-receivers-form-label-contact-person":"\n .label = Kontaktperson",
        "bill-receivers-form-label-email":"\n .label = E-post",
        "bill-receivers-form-label-telephone":"\n .label = Telefon",
        "bill-receivers-form-label-name":"\n .label = Namn",
        "bill-receivers-form-label-institution-name":"\n .label = Institutionsnamn",
        "bill-receivers-form-label-debtor-number":"\n .label = Debitornummer\n .placeholder = Identifierare för debitor i ditt redovisningssystem",
        "bill-receivers-form-label-company-name":"\n .label = Företagsnamn",
        "bill-receivers-form-label-company-number":"\n .label = CVR-nummer",
        "bill-receivers-input-search-label-email":"\n .label = E-post",
        "bill-receivers-input-search-label-ean-number":"\n .label = EAN-nummer",


        // --- Service center --
        "service-center-home-coming-soon-placeholder": "\n .title = Kommer snart\n .body = Vi arbetar på att ta fram den nya Servicecenter-portalen åt dig. Använd https://bestil-nu.net under tiden.",

        // Navigation
        "service-center-nav-item-home": "Hem",

        // Navigation > Admin
        "service-center-admin-nav-item-organization-page-header": "\n .title = Organisation",
        "service-center-admin-nav-item-organization": "Organisation",
        "service-center-admin-nav-item-organization-resources": "Resurser",
        "service-center-admin-nav-item-organization-devices": "Enheter",
        "service-center-admin-nav-item-organization-devices-create": "Skapa enheter",
        "service-center-admin-nav-item-organization-devices-edit": "Redigera enheter",
        "service-center-admin-nav-item-organization-manage-bookings": "Hantera bokningar för användare",
        "service-center-admin-nav-item-account-page-header": "\n .title = Konto",
        "service-center-admin-nav-item-reports-page-header": "\n .title = Rapporter",
        "service-center-admin-nav-item-statistics": "Statistik",
        "service-center-admin-home-reports-statistics-card": "\n .title = Statistik \n .description = Se användning, beläggning och gäststatistik för ditt Servicecenter.",
        "service-center-admin-nav-item-account-administrators": "Administratörer",
        "service-center-admin-nav-item-organization-resource-crate-room": "Skapa rum",
        "service-center-admin-nav-item-organization-resource-update-room": "Uppdatera rum",
        "service-center-admin-nav-item-organization-resource-crate-car": "Skapa bil",
        "service-center-admin-nav-item-organization-resource-update-car": "Uppdatera bil",
        "service-center-admin-nav-item-organization-resource-crate-mobile-av": "Skapa Mobile AV",
        "service-center-admin-nav-item-organization-resource-update-mobile-av": "Uppdatera Mobile AV",
        "service-center-admin-nav-item-communication": "Kommunikation",
        "service-center-admin-nav-item-communication-page-header": "\n .title = Kommunikation",
        "service-center-admin-nav-item-communication-messages": "Meddelanden",
        "service-center-admin-nav-item-communication-reminders": "Påminnelser",
        "service-center-nav-item-messages": "Meddelanden",
        "service-center-messages-list-header": "\n .title = Meddelanden",
        "service-center-reminders-page-header": "\n .title = Påminnelser",
        "service-center-reminders-create-button": "Skapa ny",
        "service-center-reminders-table-confirmation-content": "Bekräftelse av bokning",

        // Service center > Admin > Home >
        "service-center-admin-home-organization-resources-card": "\n .title = Resurser \n .description = Skapa och hantera de resurser som kan bokas i ditt Servicecenter.",
        "service-center-admin-home-organization-devices-card": "\n .title = Enheter \n .description = Hantera dina enheter, till exempel rumsdisplayer och infoskärmar.",
        "service-center-admin-home-organization-manage-bookings-card": "\n .title = Hantera ordrar \n .description = Hantera ordrar som ägs av en användare. \n .buttonText = Hantera",
        "service-center-admin-home-account-administrators-card": "\n .title = Administratörer \n .description = Hantera administratörerna för din återförsäljare.",
        "service-center-admin-home-communication-messages-card": "\n .title = Pushmeddelanden \n .description = Skicka och hantera pushmeddelanden.",
        "service-center-admin-home-communication-reminders-card": "\n .title = Påminnelser \n .description = Hantera påminnelser som delas mellan resurser.",


        // --- User --

        // Navigation
        "user-nav-item-home": "Hem",
        "user-nav-item-archive-title": "\n .title = Arkiv" ,
        "user-nav-item-archive": "Arkiv",
        "user-nav-item-settings": "Inställningar" ,
        "user-nav-item-wallets-title": "\n .title = Wallets" ,
        "user-nav-item-wallets": "Wallets",
        "user-nav-item-wallets-refill": "Påfyllning",
        "user-nav-item-home-label": "\n .title = Gå till startsidan" ,
        "user-nav-item-calendar-label": "\n .title = Visa kalender med beställningar" ,
        "user-nav-item-archive-label": "\n .title = Visa arkiverade beställningar" ,
        "user-nav-item-settings-label": "\n .title = Inställningar",
        "user-nav-bottom-bar-home-label": "Hem",
        "user-nav-bottom-bar-calendar-label": "Kalender",
        "user-nav-bottom-bar-archive-label": "Arkiv",
        "user-nav-bottom-bar-settings-label": "Inställningar",

        // User > Home > Top bar
        "user-home-top-bar-tab-switcher-overview": "Översikt",
        "user-home-top-bar-tab-switcher-upcoming": "Kommande",

        // User > Home > Top bar > News drawer
        "user-home-top-bar-news-title": "\n .title = Facilitynet-nyheter",
        "user-home-top-bar-news-no-notifications": "\n .title = Inga meddelanden just nu\n .description = Här kan du läsa meddelanden från försäljningsstället och Servicecentret.",
        "user-home-top-bar-news-notification-time-type-news": "Nyhet",
        "user-home-top-bar-news-notification-time-type-info": "Information",
        "user-home-top-bar-news-notification-time-type-important": "Viktigt",
        "user-home-top-bar-news-notification-time-type-offer": "Erbjudande",
        "user-home-top-bar-news-notification-time-type-event": "Evenemang",
        "user-home-top-bar-news-notification-time-type-reminder": "Påminnelse",
        "user-home-top-bar-news-notification-time-type-menu-change": "Meny",
        "user-home-top-bar-news-notification-time-type-feedback": "Feedback",
        "user-home-top-bar-news-notification-time-type-health": "Hälsa",
        "user-home-top-bar-news-notification-sender-type-merchant": "Försäljningsställe",
        "user-home-top-bar-news-notification-sender-type-service-center": "Service",
        "user-home-top-bar-news-notification-menu-title": "Meddelanden",

        // User > Home > Week menus
        "user-home-week-menu-title": "Veckans meny",
        "user-home-week-menu-no-menus-title": "Ingen meny tillgänglig",
        "user-home-week-menu-no-menus": "Tyvärr har inga menyer skapats den här veckan.",
        "user-home-week-menu-no-menus-today": "Ingen meny för den här dagen",
        "user-home-top-bar-location-button-empty": "Välj plats",
        "user-home-week-menu-select-location-dialog-title": "Byt plats",
        "user-home-week-menu-select-location-dialog-title-first-time": "Välj plats",
        "user-home-week-menu-select-location-search-filter": "\n .placeholder = Sök på namn, adress, butiksnummer...",
        "user-home-week-menu-select-location-dialog-kitchen-item-button": "Välj",
        "user-home-week-menu-dialog-title": "Dagens meny",
        "user-home-week-menu-dialog-allergens": "Allergener:",


        // User > Home >Dashboard
        "user-home-upcoming-orders": "Kommande beställningar",
        "user-home-reminders-check-out-title": "Checka ut gäster ({ $count })",
        "user-home-reminders-check-out-button": "Checka ut",
        "user-home-reminders-check-in-title": "Checka in i { $roomName } före { $deadline }",
        "user-home-reminders-check-in-button": "Checka in",
        "user-home-reminders-check-out-dialog": "\n .title = Checka ut gäster\n .message = Välj de gäster som går.\n .buttonLabelSubmit = { $count ->\n [0] Checka ut\n *[other] Checka ut ({ $count })\n }\n .buttonLabelCancel = Avbryt",
        "user-home-reminders-check-out-dialog-guests-title": "Gäster ({ $count })",
        "user-home-reminders-check-out-dialog-select-all-checkbox": "\n .label = Markera alla",
        "user-home-reminders-check-out-dialog-guest-checked-in": "Incheckad { $time }",
        "user-home-reminders-check-out-dialog-success": "{ $count ->\n [one] Gäst utcheckad\n *[other] { $count } gäster utcheckade\n}",
        "user-home-reminders-check-in-dialog": "\n .title = Checka in i mötesrum\n .message = Bekräfta att ditt möte har börjat.\n .buttonLabelSubmit = Checka in\n .buttonLabelCancel = Avbryt",
        "user-home-reminders-check-in-dialog-deadline-label": "Före",
        "user-home-reminders-check-in-dialog-note": "Om ingen checkar in före { $deadline } frigörs rummet och blir tillgängligt för andra.",
        "user-home-reminders-check-in-dialog-success": "Du är incheckad",
        "user-home-canteen": "Kantin",
        "user-home-canteen-offers": "Erbjudanden",
        "user-home-canteen-today-menu": "Dagens meny",
        "user-home-canteen-today-menu-show-menu": " Visa menyskylt...",
        "user-home-canteen-news": "Nyheter",
        "user-home-upcoming-meetings": "Möten",
        "user-home-upcoming-meetings-modal-title": "\n    .title = Möten",
        "user-home-upcoming-takeaway-modal-title": "\n    .title = Takeaway",
        "user-home-upcoming-canteen-purchases-modal-title": "\n    .title = Kantinköp",
        "user-home-upcoming-meetings-no-meetings": "Inga möten under perioden\n    .title = Inga möten under perioden",
        "user-home-meeting-day-today": "I dag",
        "user-home-meeting-day-tomorrow": "I morgon",
        "user-home-meeting-day-unknown": "Utan datum",
        "user-home-upcoming-meeting-min-left":
            "{ $hours ->\n    [0] { $minutes } min kvar\n   *[other] { $minutes ->\n        [0] { $hours } tim kvar\n       *[other] { $hours } tim { $minutes } min kvar\n    }\n}",
        "user-home-upcoming-meeting-service-sub-title": "Mötesförtäring",
        "user-home-meetings-collapse": "Dölj möten",
        "user-home-meetings-expand": "Visa möten",
        "user-home-meetings-panel-actions": "\n .collapseAriaLabel = { user-home-meetings-collapse }\n .expandAriaLabel = { user-home-meetings-expand }",
        "user-home-panel-action-show-all": "\n    .title = Visa alla",
        "user-home-empty-offers-text": "Du har inga erbjudanden just nu",
        "user-home-upcoming-purchases": "Köp",
        "user-home-upcoming-purchases-load-error": "Det gick inte att läsa in köp",
        "user-home-wallet-my-wallet": "Min wallet",
        "user-home-wallets-section-title": "Wallets",
        "user-home-subscriptions-section-title": "Prenumerationer",
        "user-home-subscription-card-used-count": "{ $used } av { $total }",
        "user-home-subscription-card-used-this-week": "använt denna vecka",
        "user-home-subscription-card-used-this-month": "använt denna månad",
        "user-home-subscription-card-active-from": "Aktiv från: { $date }",
        "user-home-subscription-card-expires": "Går ut: { $date }",
        "user-home-upcoming-purchase-card-title-lunch": "Lunchbeställning",
        "user-home-upcoming-purchase-card-title-take-away": "Takeaway",
        "user-home-upcoming-purchase-card-title-pos": "Lunchbeställning",
        "user-home-upcoming-purchase-card-title-lunch-subscription": "Lunchprenumeration",
        "user-home-upcoming-purchases-no-purchases": "Inga kommande köp",
        "user-home-upcoming-canteen-purchases": "Kantinköp",
        "user-home-upcoming-canteen-purchases-no-purchases": "Inga kantinköp under perioden\n    .title = Inga kantinköp under perioden",
        "user-home-canteen-purchases-collapse": "Dölj kantinköp",
        "user-home-canteen-purchases-expand": "Visa kantinköp",
        "user-home-upcoming-takeaway": "Takeaway",
        "user-home-upcoming-takeaway-no-orders": "Ingen takeaway under perioden\n    .title = Ingen takeaway under perioden",
        "user-home-takeaway-collapse": "Dölj takeaway",
        "user-home-takeaway-expand": "Visa takeaway",
        "user-home-upcoming-meeting-service-approved": "\n .label = Godkänd",
        "user-home-upcoming-meeting-service-approved-tooltip":  "\n .label = Beställningen har godkänts av försäljningsstället.",
        "user-home-upcoming-meeting-service-sittings": "{ $sittings } kuvert",
        "user-home-upcoming-meeting-service-attendees": "{ $attendees } deltagare",
        "user-home-upcoming-meeting-service-locked": "Låst",
        "user-home-upcoming-purchases-check-in-reminder": "Påminnelse om incheckning",
        "user-home-upcoming-purchases-learn-more": "Visa mer",
        "user-home-upcoming-purchases-check-in-subtitle": "Kom ihåg att checka in i kantinen i dag.",
        "user-home-canteen-contact-canteen": "Kontakta kantinen",
        "user-dashboard-error-offers-unavailable": "Erbjudandet är tillfälligt otillgängligt.",
        "user-dashboard-error-week-menu-unavailable": "Veckomenyn är tillfälligt otillgänglig.",
        "user-dashboard-error-news-menu-unavailable": "Nyhetsmenyn är tillfälligt otillgänglig.",
        "user-dashboard-error-merchant-contact-unavailable": "Kontaktuppgifter till återförsäljaren är tillfälligt otillgängliga.",
        "user-home-canteen-news-category-company": "\n .label = Företag",
        "user-home-canteen-news-category-service-center": "\n .label = Servicecenter",
        "user-home-canteen-news-category-kitchen": "\n .label = Kök",
        "user-home-canteen-news-category-no-actions":  "Inga åtgärder tillgängliga för beställning #{ $orderId }",
        "user-home-canteen-upcoming-orders-dialog-ok-button": "Ok",
        "user-home-canteen-upcoming-orders-cancel-order-item": "Avboka beställning",
        "user-home-canteen-upcoming-orders-cancel-booking-item": "Avboka bokning",
        "user-home-canteen-upcoming-orders-delete-order": "Ta bort beställning",
        "user-home-canteen-upcoming-orders-delete-order-restriction-message": "Du har inte behörighet att ta bort den här beställningen",
        "user-home-canteen-upcoming-orders-refund-order": "Återbetala beställning",
        "user-home-canteen-upcoming-orders-refund-order-restriction-message": "Du har inte behörighet att återbetala den här beställningen",
        "user-home-canteen-upcoming-orders-receipt-item": "Kvitto",
        "user-home-canteen-upcoming-orders-edit-item": "Redigera",
        "user-home-canteen-upcoming-orders-update-booking-restriction-message": "Du har inte behörighet att uppdatera bokningen",
        "user-home-canteen-upcoming-orders-extend-booking-item": "Förläng bokning",
        "user-home-canteen-upcoming-orders-extend-booking-restriction-message": "Du har inte behörighet att förlänga bokningen",
        "user-home-canteen-upcoming-orders-end-booking-restriction-message": "Du har inte behörighet att avsluta bokningen",
        "user-home-canteen-upcoming-orders-update-meeting-service-item-meeting-service": "Uppdatera",
        "user-home-canteen-upcoming-orders-update": "Redigera",
        "user-home-canteen-upcoming-orders-update-meeting-restriction-message": "Du har inte behörighet att uppdatera den här beställningen",
        "user-home-canteen-upcoming-orders-duplicate-meeting-service-item-meeting-service": "Duplicera",
        "user-home-canteen-upcoming-orders-duplicate-meeting-service-item-resource-booking": "Duplicera mötesförtäring",
        "user-home-canteen-upcoming-orders-duplicate-meeting-service-restriction-message": "Du har inte behörighet att duplicera den här beställningen",
        "user-home-canteen-upcoming-orders-end-modal-confirm": "Bekräfta",
        "user-home-canteen-upcoming-orders-cancel-modal-confirm": "Avbryt",
        "user-home-canteen-upcoming-orders-extend-modal-title": "Förläng bokning",
        "user-home-canteen-upcoming-orders-extend-modal-subtitle": "Vill du förlänga bokningen { $meetingName } till { $meetingTime }?",
        "user-home-canteen-upcoming-orders-extend-modal-max-error": "Maximal tillgänglig tid är { $maxAvailableMinutes } minuter.",
        "user-home-canteen-upcoming-orders-extend-input-custom-time": "\n .label = Välj sluttid:",
        "user-home-canteen-upcoming-orders-extend-other-button": "Annat",
        "user-home-canteen-upcoming-orders-delete-modal-error": "Det gick inte att ta bort beställningen",
        "user-home-canteen-upcoming-orders-delete-modal-booking-label": "\n .label = Avboka bokning",
        "user-home-canteen-upcoming-orders-delete-modal-meeting-label": "\n .label = Avboka mötesförtäring",
        "user-home-canteen-upcoming-orders-cancel-modal":
            "\n .title = Avboka { $itemType ->\n [order] beställning\n *[booking] bokning\n }\n .message = Är du säker på att du vill avboka { $itemType ->\n [order] beställningen\n *[booking] bokningen\n } '{ $itemName }'?\n .buttonLabelSubmit = Avboka { $itemType ->\n [order] beställning\n *[booking] bokning\n }\n .buttonLabelCancel = Tillbaka",
        "user-home-canteen-upcoming-orders-cancel-started-modal":
            "\n .title = Avboka bokning\n .message = Mötet #{ $orderId }, { $meetingName } har redan startat, så bokningen avslutas nu i stället för att tas bort. Vill du fortsätta?\n .buttonLabelSubmit = Avboka bokning\n .buttonLabelCancel = Tillbaka",
        "user-home-canteen-upcoming-orders-cancel-ended-booking-message": "Mötet är redan slut, så bokningen kan inte längre avbokas.",
        "user-home-meeting-service-action-update-booking": "Uppdatera bokning",
        "user-home-meeting-service-action-edit": "Redigera beställning",
        "user-home-meeting-service-action-update-meeting-service": "Uppdatera mötesförtäring",
        "user-home-meeting-service-action-duplicate-meeting-service": "Duplicera beställning",
        "user-home-meeting-service-description-update-booking": "Är du säker på att du vill uppdatera bokning #{ $orderId }, { $meetingName }?",
        "user-home-meeting-service-description-update-meeting-service-catering": "Vill du uppdatera beställning #{ $orderId }, { $meetingName } med leverans den { $deliveryDate }?",
        "user-home-meeting-service-description-update-meeting-service": "Vill du uppdatera beställning #{ $orderId }, { $meetingName } för mötet den { $deliveryDate }?",
        "user-home-meeting-service-description-duplicate-meeting-service": "Vill du duplicera beställning #{ $orderId }, { $meetingName } med leverans den { $deliveryDate }?",
        "user-home-meeting-service-action-confirm-modal-meeting-name": "Mötesnamn:",
        "user-home-meeting-service-action-confirm-modal-delivery-date-name": "Leveransdatum:",
        "user-home-meeting-service-action-confirm-modal-order-id": "Order-id:",
        "user-home-canteen-upcoming-orders-extend-success-dialog-title": "Bokningen förlängdes",
        "user-home-canteen-upcoming-orders-delete-success-dialog-title": "Bokningen avbokades",
        "user-home-canteen-upcoming-orders-delete-order-success-dialog-title":
            "{ $ordersCount ->\n *[one] Beställningen togs bort\n [other] Beställningarna togs bort\n }",
        "user-home-canteen-upcoming-orders-end-success-dialog-title": "Bokningen avslutades",


        // User > Home > Offers
        "user-home-offers-title": "Erbjudanden",

        // User > Home > Offers
        "user-home-news-from-kitchen": "Nyheter från köket",


         // User > Home > Opening hours
        "user-home-opening-hours-title": "Öppettider",
        "user-home-opening-day-1": "Mån:",
        "user-home-opening-day-2": "Tis:",
        "user-home-opening-day-3": "Ons:",
        "user-home-opening-day-4": "Tors:",
        "user-home-opening-day-5": "Fre:",

        // User > Home > Room finder
        "user-homeroom-finder-title": "Rumsfinnare",
        "user-home-room-finder-resource-type-dropdown": "\n .label = Resurstyp",
        "user-home-room-finder-resource-date": "\n .label = Datum:",
        "user-home-room-finder-resource-duration": "\n .label = Varaktighet:",
        "user-home-room-finder-resource-time": "Tid:",
        "user-home-room-finder-resource-seats": "Platser:",
        "user-home-room-finder-resource-book-button": "Boka ({ $amount })",
        "user-home-room-finder-resource-results-amount": "{ $amount } resultat",
        "user-home-room-finder-resource-select-button": "Välj",
        "user-home-room-finder-resource-unselect-button": "Ta bort",
        "user-home-room-finder-go-to-timeline-button": "Gå till tidslinje",
        "user-home-room-finder-subtitle": "Din intelligenta följeslagare för att hitta resurser.",
        "user-home-room-finder-find-a-room-button": "Hitta ett rum",
        "user-home-room-finder-available-rooms": "lediga rum",
        "user-home-room-finder-available-time-slot": "från { $timeSlot }",


        // User > Upcoming orders > Meeting service
        "user-upcoming-orders-meeting-service-title": "\n .title = Mötesförtäring",

        // User > Upcoming orders > Resource bookings
        "user-upcoming-orders-resource-booking-table-id": "Order-id",
        "user-upcoming-orders-resource-booking-table-time": "Tid",
        "user-upcoming-orders-resource-booking-table-meeting": "Möte",
        "user-upcoming-orders-resource-booking-table-visibility": "Synlighet",
        "user-upcoming-orders-resource-booking-table-visibility-public": "Offentlig",
        "user-upcoming-orders-resource-booking-table-visibility-public-tooltip": "Bokningen är offentlig, vilket innebär att mötesnamnet och deltagarnas namn är synliga för kollegor.",
        "user-upcoming-orders-resource-booking-table-visibility-private": "Privat",
        "user-upcoming-orders-resource-booking-table-visibility-private-tooltip": "Bokningen är privat, vilket innebär att mötesnamnet och deltagarnas namn inte är synliga för någon.",
        "user-upcoming-orders-resource-booking-table-action-delete": "Ta bort",
        "user-upcoming-orders-resource-booking-table-remove-dialog": "\n .title = Ta bort bokning\n .message = Är du säker på att du vill ta bort bokningen?\n .buttonLabelSubmit = Ta bort",


        // User > Settings
        "user-settings-page-title": "\n .title = Inställningar",
        "user-settings-tab-bill-receivers": "Mina fakturamottagare",
        "user-settings-tab-guest-reception": "Gästmottagning",
        "user-settings-tab-calendar-sharing": "Kalenderdelning",
        "user-settings-tab-access-control": "Åtkomstkontroll",
        "user-settings-table-header-name": "Namn",
        "user-settings-table-header-address": "Adress",
        "user-settings-table-header-endpoint": "Slutpunkt",
        "user-settings-table-header-status": "Status",
        "user-settings-status-active": "Aktiv",
        "user-settings-status-inactive": "Inaktiv",
        "user-settings-status-pending": "Väntar",
        "user-settings-action-edit": "Redigera",
        "user-settings-action-delete": "Ta bort",
        "user-settings-action-activate": "Aktivera",
        "user-settings-action-deactivate": "Inaktivera",
        "user-settings-coming-soon": "Kommer snart",
        "user-settings-bill-receivers-info": "\n .title = Här är dina personliga fakturamottagare, som du kan välja när du beställer mötesförtäring. Du kan skapa en ny fakturamottagare under beställningen, om den valda kantinen tillåter det.",
        "user-settings-delete-bill-receiver-dialog": "\n .typeOfEntity = fakturamottagare",
        "user-settings-edit-bill-receiver-dialog-title": "Redigera fakturamottagare",
        "user-settings-edit-bill-receiver-page-header": "\n .title = Redigera fakturamottagare",
        "user-settings-edit-bill-receiver-name-field": "\n .label = Namn",
        "user-settings-edit-bill-receiver-vatnumber-field": "\n .label = CVR-nummer",
        "user-settings-edit-bill-receiver-address-panel": "\n .title = Adress",
        "user-settings-edit-bill-receiver-endpoint-panel": "\n .title = Fakturamottagare",
        "user-settings-edit-bill-receiver-endpoint-type-field": "\n .label = Typ",
        "user-settings-edit-bill-receiver-endpoint-value-field": "\n .label = Värde",
        "user-settings-edit-bill-receiver-contact-panel": "\n .title = Kontaktperson",
        "user-settings-edit-bill-receiver-settings-panel": "\n .title = Inställningar",
        "user-settings-edit-bill-receiver-active-switch": "Aktiv",
        "user-settings-edit-bill-receiver-save-button": "Spara",
        "user-nav-item-edit-bill-receiver": "Redigera fakturamottagare",

        // User > Settings > Wallets
        "user-settings-wallets-title": "\n .title = Wallets",

        // User > Wallets > Refill
        "user-wallets-refill-title": "\n .title = Fyll på wallet",
        "user-wallets-refill-manual-top-up-nav-tab": "Manuell påfyllning",
        "user-wallets-refill-automatic-top-up-nav-tab": "Automatisk påfyllning",
        "user-wallets-refill-manual-type": "\n .statusLabel = Manuell",
        "user-wallets-refill-automatic-type": "\n .statusLabel = Automatisk",
        "user-wallets-refill-payment-success": "Beställningen har behandlats",
        "user-wallets-refill-payment-unexpected-error": "Ett oväntat fel inträffade",
        "user-wallets-refill-payment-timeout": "Tidsgränsen för betalningen överskreds",
        "user-wallets-refill-payment-wait-label": "Behandlar betalning",
        "user-wallets-refill-payment-wait-description":  "Vänta medan vi behandlar din betalning. Det kan ta en stund.",
        "user-wallets-refill-payment-back-action-button-label": "Tillbaka till startsidan",
        "user-wallets-refill-payment-timeout-label": "Tidsgränsen för betalningen överskreds",
        "user-wallets-refill-payment-timeout-description": "Vi har inte fått någon bekräftelse från din betalningsleverantör. Kontrollera din internetbank för att vara säker på att betalningen genomfördes.",
        "user-wallets-refill-payment-canceled-label":  "Betalning avbruten",
        "user-wallets-refill-payment-canceled-description":  "Du har avbrutit betalningsprocessen. Inget har dragits från ditt konto.",
        "user-wallets-refill-payment-failed-label": "Betalningen misslyckades.",
        "user-wallets-refill-payment-failed-description": "Din betalning kunde inte genomföras. Bekräfta dina uppgifter och försök igen.",

        // User > Wallets > Refill > Manual tab
        "user-wallets-refill-manual-main-amount-label": "\n .label = Belopp",
        "user-wallets-refill-manual-main-amount-error":"Din wallet kan inte överstiga { $maxBalance}. Du kan som mest fylla på { $maxRefillAmount }",
        "user-wallets-refill-manual-main-amount-max-error":"Maxbelopp för påfyllning är { $maxRefillAmount }",
        "user-wallets-refill-manual-main-amount-zero-error":"Beloppet måste vara större än 0",
        "user-wallets-refill-auto-amount-max-threshold-error":"Maxgränsen är { $maxThreshold }",
        "user-wallets-refill-payment-method-error":"Betalningsmetod krävs",
        "user-wallets-refill-manual-main-custom-amount-label": "\n .label = Ange belopp:",
        "user-wallets-refill-manual-main-amount-amount-100": "100,00 kr",
        "user-wallets-refill-manual-main-amount-amount-300": "300,00 kr",
        "user-wallets-refill-manual-main-amount-amount-500": "500,00 kr",
        "user-wallets-refill-manual-main-amount-amount-other": "Annat",
        "user-wallets-refill-manual-main-payment-method": "Betalningsmetoder:",
        "user-wallets-refill-manual-main-select-payment-method": "Välj betalningsmetod",
        "user-wallets-refill-manual-main-perform-refill-button": "Bekräfta betalning",
        "user-wallets-refill-select-card-dialog-title": "Välj wallet",
        "user-wallets-refill-select-card-dialog-no-wallets": " Återförsäljaren erbjuder inte digitala wallets till ditt företag.",
        "user-wallets-refill-select-card-balance": "Saldo:",


        // User > Wallets > Refill > Auto tab
        "user-wallets-refill-auto-activate-card-title": "Aktivera automatisk påfyllning",
        "user-wallets-refill-auto-activate-modal-title": "Aktivera automatisk påfyllning",
        "user-wallets-refill-auto-activate-modal-threshold-placeholder": "\n .label = Belopp (DKK)",
        "user-wallets-refill-auto-activate-modal-threshold-subtitle": "När saldot understiger:",
        "user-wallets-refill-auto-activate-modal-refill-subtitle": "Fyll på med belopp:",
        "user-wallets-refill-auto-activate-modal-submit-button": "Aktivera automatisk påfyllning",
        "user-wallets-refill-auto-activate-modal-update-button": "Uppdatera automatisk påfyllning",
        "user-wallets-refill-auto-activate-modal-delete-button": "Ta bort automatisk påfyllning",
        "user-wallets-refill-auto-activate-success-modal-subtitle": "Automatisk påfyllning aktiverad",


        // User > Archive > Drawer
        "user-archive-drawer-resource-booking": "Resursbokning",
        "user-archive-drawer-meeting-service": "Mötesförtäring",
        "user-archive-drawer-daily-purchases": "Dagliga köp",
        "user-archive-drawer-refill-wallet": "Påfyllning",

        // User > Archive > Drawer > Transactions
        "user-archive-transactions-table-id": "Order-ID",
        "user-archive-transactions-table-transaction-time": "Transaktionstid",
        "user-archive-transactions-table-delivery-time": "Leveranstid",


         // User > Archive > Meeting service
        "user-archive-meeting-service-title": "\n .title = Mötesförtäring",
        "user-archive-meeting-service-info-box": "I arkivet kan du bara se mötesförtäringsbeställningar som har bokförts av försäljningsstället.",
        "user-archive-meeting-service-table-id": "Order-ID",
        "user-archive-meeting-service-table-booked-date": "Bokföringsdatum",
        "user-archive-meeting-service-table-delivery-time": "Leveranstid",
        "user-archive-meeting-service-table-meeting": "Möte",
        "user-archive-meeting-service-table-amount": "Belopp",
        "user-archive-meeting-service-table-action-receipt": "Kvitto",
        "user-archive-meeting-service-table-action-duplicate": "Duplicera",
        "user-archive-meeting-service-table-action-send-message": "Skicka meddelande",
        "user-archive-meeting-service-table-filter-start-date": "Startdatum",
        "user-archive-meeting-service-table-filter-end-date": "Slutdatum",



        // Standard components

        // Standard components > Filter button
        "table-filters-button": "\n .title = Filter\n .aria-label = Filter",

        // Create order
        "create-order-access-denied-on-behalf-of": "Du har inte behörighet att beställa å den valda användarens vägnar.",
        "create-order-confirm-order-button": "Nästa",
        "create-order-meeting-service-mobile-bar-continue-button": "Fortsätt",
        "create-order-meeting-service-mobile-back-to-products-button": "Tillbaka till produkter",
        "create-order-book-button": "Boka",
        "create-order-update-button": "Uppdatera",
        "create-order-undo-button": "\n .title = Ångra allt",
        "create-order-wish": "\n .title = Önskemål",
        "create-order-wish-dialog-title": "\n .dialogTitle = Lägg till produktönskemål",
        "create-order-order-line-dialog-title": "\n .dialogTitle = Lägg till produkt",
        "create-order-wish-dialog-edit-price-title": "\n .dialogTitle = Ange pris",
        "create-order-wish-dialog-message": "Om du lägger till ett produktönskemål måste din beställning godkännas manuellt av butiksägaren.",
        "create-order-wish-dialog-product-name-field": "\n .label =Produktnamn \n .placeholder =Ange produktnamn:",
        "create-order-wish-dialog-product-items-field": "\n .label =Antal \n .placeholder =Ange antal:",
        "create-order-wish-dialog-product-price-field": "\n .label =Produktpris \n .placeholder =Ange pris (DKK):",
        "create-order-wish-dialog-submit-button": "Bekräfta",
        "create-order-wish-dialog-product-name-max-length": "Produktnamnet får inte överstiga { $maxLength } tecken",
        "create-order-wish-dialog-quantity-min-value": "Antalet måste vara minst 1",
        "create-order-wish-dialog-quantity-max-value": "Antalet får inte överstiga { $max }",
        "create-order-wish-dialog-price-min-value": "Priset måste vara större än 0",
        "create-order-wish-dialog-price-max-value": "Priset får inte överstiga { $max }",
        "create-order-favorite": "\n .title = Visa mina favoritprodukter",
        "create-order-favorite-show-all-products": "\n .title = Visa alla produkter",
        "create-order-list": "\n .title = Visa en lista över produkter",
        "create-order-grid": "\n .title = Visa ett rutnät med produkter",
        "create-order-products-empty": "Inga resultat",
        "create-order-product-staff-only-tag": "Endast för personal",
        "create-order-product-sale-text": "Endast 10 kvar",
        "offer-tag-good-price": "Bra pris",
        "offer-tag-great-offer": "Fantastiskt erbjudande",
        "offer-tag-buy-now": "Köp nu",
        "offer-tag-discount": "Rabatt",
        "offer-tag-week-offer": "Veckans erbjudande",
        "offer-tag-day-offer": "Dagens erbjudande",
        "offer-tag-save-x-price": "Spara { $amount } kr",
        "offer-tag-save-x-percentage": "Spara { $amount }",
        "offer-tag-limited-on-sale": "{ $amount } kvar",
        "offer-tag-available-from": "Tillgänglig från: { $date }",
        "create-order-tooltip-order-summary-button": "\n .title = Visa orderöversikt",
        "create-order-order-summary-no-items": "Orderöversikten är tom. Lägg till varor i din beställning för att se detaljerna.",
        "create-order-order-summary": "Orderöversikt",
        "create-order-order-summary-resources": "\n .title = Resurser",
        "create-order-order-summary-resources-booking-time": "Bokning",
        "create-order-order-summary-meeting-services": "\n .title = Mötesförtäring",
        "create-order-order-summary-meeting-services-delivery-time": "Leverans { $number }",
        "create-order-order-summary-meeting-services-total": "Totalt",
        "create-order-order-summary-meeting-services-empty": "Inga varor har lagts till än",
        "create-order-order-summary-meeting-services-add-order-line-button": "+ Lägg till orderrad",
        "create-order-order-summary-meeting-services-wish-set-price-button": "Ange pris",
        "create-order-order-summary-meeting-services-wish-edit-price-button": "\n .title = Redigera pris\n .aria-label = Redigera pris",
        "create-order-order-summary-meeting-services-product-item": "{$count} vara",
        "create-order-order-summary-meeting-services-product-items": "{$count} varor",
        "create-order-order-summary-meeting-services-product-warning-price-list-tooltip": "\n .title = Den valda prislistan matchar inte produktens prislista — ökning är inte tillgänglig.",
        "create-order-order-summary-meeting-services-product-warning-missing-product-tooltip": "\n .title = Den här produkten är inte tillgänglig i den valda prislistan",
        "create-order-order-summary-meeting-services-product-staff-only-tooltip": "\n .title = Endast återförsäljaren kan ändra den här varan",
        "create-order-order-summary-meeting-services-legacy-extra-service-tooltip": "\n .title = Det här är en extra tjänst från den gamla portalen. Den kan inte ändras, men den kan tas bort.",
        "create-order-order-summary-meeting-services-wish-locked-quantity-tooltip": "\n .title = Endast återförsäljaren kan ändra antalet i ett produktönskemål",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog": "\n .dialogTitle = Priser uppdaterade",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-message": "Vissa priser har ändrats sedan beställningen skapades. Granska nedan för att fortsätta.",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-section-price-changed": "Pris ändrat ({ $count })",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-section-missing-product": "Inte tillgänglig i prislistan { $priceList } ({ $count })",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-section-other-price-list": "Från en annan prislista ({ $count })",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-section-unchanged-hint": "Priset på dessa varor förblir som i beställningen.",
        "create-order-order-summary-meeting-services-product-price-mismatch-dialog-submit-button": "Uppdatera",
        "create-order-order-summary-meeting-services-invalid-time-card-empty-title": "Leverans utan varor",
        "create-order-order-summary-meeting-services-invalid-time-card-empty": "Inga varor lades till i leveransen kl. {$time}. Lägg till varor eller ta bort leveranstiden.",
        "create-order-order-summary-meeting-services-invalid-times-card-empty": "Inga varor lades till i leveransen kl. {$time}. Lägg till varor eller ta bort leveranstiderna.",
        "create-order-order-summary-meeting-services-invalid-times-card-empty-button": "Ok",
        "create-order-confirm-booking-meeting-details": "Mötesdetaljer",
        "create-order-outlook-private-meeting-default-name": "Privat möte",
        "create-order-outlook-on-behalf-of-chip": "På uppdrag av { $name }",
        "create-order-confirm-booking-update-meeting-details": "Uppdatera mötesdetaljer #{ $id }",
        "create-order-confirm-booking-dialog-add-attendees": "Lägg till deltagare",
        "create-order-confirm-booking-dialog-back-button": "Tillbaka",
        "create-order-confirm-booking-meeting-information-tab": "Mötesinformation",
        "create-order-confirm-booking-participants-tab": "Deltagare",
        "create-order-confirm-booking-other-tab": "Övrigt",
        "create-order-confirm-booking-dialog-confirm-button": "Bekräfta",
        "create-order-confirm-booking-dialog-submit-button": "Slutför bokning",
        "create-order-confirm-booking-dialog-add-attendee-button": "Lägg till deltagare",
        "create-order-confirm-booking-dialog-bulk-add-attendees-drawer-button": "Lägg till deltagare",
        "create-order-confirm-booking-dialog-bulk-add-attendees-button": "Kopiera och klistra in",
        "create-order-confirm-booking-dialog-bulk-add-attendees-button-tooltip": "\n .title = Lägg till flera deltagare genom att klistra in en lista med namn och företag",
        "create-order-confirm-booking-dialog-bulk-add-attendees-description": "Ange ett namn och företag per rad.",
        "create-order-confirm-booking-dialog-bulk-add-attendees-field": "\n .placeholder = Namn, Företag",
        "create-order-confirm-booking-selected-resources": "Valda resurser ({ $count }):",
        "create-order-confirm-booking-booking-time": "Bokningstid: { $time }",
        "create-order-confirm-booking-rooms": "Lokaler:",
        "create-order-confirm-booking-equipment": "AV-utrustning:",
        "create-order-confirm-booking-cars": "Bilar:",
        "create-order-confirm-booking-time-range-picker-from-field": "\n .label =Från tid:",
        "create-order-confirm-booking-time-range-picker-to-field": "\n .label =Till tid:",
        "create-order-confirm-booking-time-range-picker-error": "Resursen är inte tillgänglig vid den här tiden",
        "create-order-meeting-details-start-time-label": "Mötets starttid",
        "create-order-meeting-details-end-time-label": "Mötets sluttid",
        "create-order-meeting-details-duration-helper-text":
            "Ange mötets längd så att kantinen kan planera leverans och uppstädning.",
        "create-order-confirm-booking-table-setup": "Bordsuppställning",
        "create-order-confirm-booking-select-setup": "Välj uppställning",
        "create-order-confirm-booking-message-title": "Meddelanden till Servicecenter",
        "create-order-attendees-dialog-submit-button": "Spara",
        "create-order-attendees-dialog-title": "Deltagare",
        "create-order-note-add-button": "Lägg till",
        "create-order-note-edit-button": "Redigera",
        "create-order-note-dialog-title": "\n .dialogTitle = Ordermeddelande",
        "create-order-note-dialog-alert": "\n .title = Ditt ordermeddelande kommer att vara synligt på orderspecifikationen. Du får inte ange personuppgifter, till exempel uppgifter om hälsa eller religion.",
        "create-order-note-dialog-field": "\n .label = Ditt ordermeddelande \n .helperText = Återstående tecken: { $count }",
        "create-order-note-save-button": "Spara",
        "create-order-extra-services": "Extra tjänster:",
        "create-order-extra-services-delivery": "\n .title = Leverans kl. { $time }",
        "create-order-extra-services-min-max": "Min. { $min } - Max. { $max }",
        "create-order-extra-services-add-button": "Lägg till",
        "create-order-extra-services-remove-button": "Ta bort",
        "create-order-extra-services-mandatory-tooltip": "\n .title = Den här tjänsten är obligatorisk",
        "create-order-extra-services-always-added-label": "Ingår",
        "create-order-extra-services-auto-added-snackbar": "En serviceavgift på { $amount } för \"{ $name }\" har lagts till i din varukorg.",
        "create-order-extra-services-removed-notification": "\"{ $name }\" är inte längre tillgänglig och har tagits bort från din varukorg.",
        "create-order-extra-services-seats-breakdown": "{ $count } kuvert x { $price }",
        "create-order-extra-services-total": "Totalt: { $amount }",
        "create-order-extra-services-min-price": "Minpris { $price }",
        "create-order-extra-services-max-price": "Maxpris { $price }",
        "create-order-extra-services-tooltip-price-per-seat-label": "Pris per kuvert:",
        "create-order-extra-services-tooltip-min-price-label": "Minpris:",
        "create-order-extra-services-tooltip-max-price-label": "Maxpris:",
        "create-order-extra-services-additional-fields-title": "Ytterligare mötesdetaljer:",
        "create-order-extra-services-additional-fields-intro": "\n .title = För att kunna leverera vissa extra tjänster behöver vi ytterligare mötesdetaljer.",
        "create-order-extra-services-additional-fields-start-time-label": "Starttid",
        "create-order-extra-services-additional-fields-end-time-label": "Sluttid",
        "create-order-extra-services-additional-fields-location-label": "Var hålls mötet?",
        "create-order-workgroup-label": "\n .label = Arbetsgrupp",
        "create-order-participants-add-button": "+ Lägg till deltagare",
        "create-order-participants-edit-button": "Redigera deltagare",
        "create-order-participants-count-list": "{ $count } deltagare",
        "create-order-participants-count-one-item": "{ $count } deltagare",
        "create-order-share-outlook-attendees-toggle-label": "\n    .label = Lägg till deltagare från Outlook",
        "create-order-share-outlook-attendees-toggle-helper":
            "När detta slås på läggs { $count } deltagare från ditt Outlook-möte till.",
        "create-order-share-outlook-attendees-list-title": "Deltagare från Outlook ({ $count }):",
        "create-order-share-outlook-attendees-show-all-button": "+{ $count } till",
        "create-order-share-outlook-attendees-show-less-button": "Visa färre",
        "create-order-share-outlook-attendees-remove": "Ta bort deltagare",
        "create-order-participants-dialog-name-column": "Namn",
        "create-order-participants-dialog-company-column": "Företag",
        "create-order-participants-dialog-email-column": "E-post",
        "create-order-participants-dialog-external-internal-column": "Extern",
        "create-order-participants-dialog-field-name": "\n .placeholder = Deltagarens namn",
        "create-order-participants-dialog-field-company": "\n .placeholder = Företag",
        "create-order-participants-dialog-field-email": "\n .placeholder = E-postadress",
        "create-order-add-filters-button": "Lägg till filter",
        "create-order-add-search-input": "\n .placeholder = Sök",
        "create-order-view-timeline": "Tidslinje",
        "create-order-view-available-time": "Tillgänglighet",
        "create-order-view-room-finder": "Rumsfinnare",
        "create-order-view-room-finder-upcoming-tooltip": "\n .title = Kommande",
        "create-order-calendar-today-button": "I dag",
        "create-order-calendar-today-button-hint": "Gå till i dag",
        "create-order-calendar-prev-day-button": "Gå till föregående dag",
        "create-order-calendar-next-day-button": "Gå till nästa dag",
        "create-order-calendar-go-to-date-button": "Gå till datum",
        "create-order-calendar-go-to-date-button-hint": "Välj önskat datum",
        "create-order-calendar-no-resources-message": "Det finns inga tillgängliga resurser. Justera filtren",
        "create-order-calendar-go-to-date-label": "\n .label = Välj datum",
        "create-order-calendar-go-button": "Gå",
        "create-order-calendar-all-day-label": "Hela dagen",
        "create-order-calendar-week-button": "Aktuell vecka",
        "create-order-calendar-prev-week-button": "Föregående vecka",
        "create-order-calendar-next-week-button": "Nästa vecka",
        "create-order-calendar-event-tooltip": "\n .title = Klicka för att boka",
        "create-order-confirm-booking-confirm-dialog": "\n .title = Bekräfta bokning\n .message =Din bokning är inte slutförd. Bekräfta din bokning innan du fortsätter.\n .buttonLabelSubmit = Bekräfta\n .buttonLabelCancel = Avbryt",
        "create-order-confirm-booking-confirm-no-resources-dialog": "\n .title = Bokningen är inte slutförd\n .message =Du har inte valt några resurser än. Om du lämnar nu slutförs inte din bokning.\n .buttonLabelSubmit = Välj resurser\n .buttonLabelCancel = Lämna ändå",
        "create-order-change-time-dialog": "\n .title = Ändra bokningstid?\n .buttonLabelSubmit = Använd ny tid\n .buttonLabelCancel = Behåll ursprunglig tid",
        "create-order-change-time-dialog-message-top": "Din Outlook-mötesinbjudan är planerad till:",
        "create-order-change-time-dialog-message-bottom": "Vill du ändra bokningstiden till:",
        "create-order-drawer-other-location": "+ Annan plats",
        "create-order-drawer-delivery-location-field": "\n .label = Leveransplats",
        "create-order-drawer-meeting-location-field": "\n .label = Mötesplats",
        "create-order-drawer-meeting-location-label": "Mötesplats",
        "create-order-drawer-repeat-order": "Upprepa order",
        "create-order-drawer-repeat-order-every": "Upprepa var:",
        "create-order-drawer-repeat-order-every-day": "\n .label = Dag",
        "create-order-drawer-repeat-order-every-week": "\n .label = Vecka",
        "create-order-drawer-repeat-order-on": "Upprepa på:",
        "create-order-drawer-repeat-order-starts": "Startar:",
        "create-order-drawer-repeat-order-start-date-locked-message": "Startdatumet är orderns första leverans. Om du vill ändra det stänger du den här dialogrutan och ändrar datumet för den första leveransen på ordern. Öppna sedan Upprepa beställning igen.",
        "create-order-drawer-repeat-order-ends": "Slutar:",
        "create-order-drawer-repeat-order-ends-on": "\n .label = Den",
        "create-order-drawer-repeat-order-ends-after": "\n .label = Efter",
        "create-order-drawer-repeat-order-ends-after-deliveries": "leveranser",
        "create-order-drawer-repeat-order-end-before-start-error": "Slutdatumet måste vara samma dag som eller efter startdatumet",
        "create-order-drawer-repeat-order-confirm-button": "Bekräfta",
        "create-order-drawer-repeat-order-summary": "Upprepas var { $interval }{ $days }, från { $startDate }{ $repeatCount }{ $endDate }{ $exceptions }.",
        "create-order-drawer-repeat-order-summary-interval-day": "dag",
        "create-order-drawer-repeat-order-summary-interval-days": "{ $count -> \n [2] { $count }:a\n *[other] { $count }:e\n } dag",
        "create-order-drawer-repeat-order-summary-interval-week": "vecka",
        "create-order-drawer-repeat-order-summary-interval-weeks": "{ $count -> \n [2] { $count }:a\n *[other] { $count }:e\n } vecka",
        "create-order-drawer-repeat-order-summary-days-suffix": " på { $days }",
        "create-order-drawer-repeat-order-summary-repeat-count-suffix": ", { $count } gånger",
        "create-order-drawer-repeat-order-summary-end-date-suffix": ", slutar { $date }",
        "create-order-drawer-repeat-order-summary-exceptions-suffix": "({ $count } undantag)",
        "create-order-drawer-repeat-order-delete-confirm-dialog": "\n .title = Ta bort upprepning \n .buttonLabelSubmit = Ta bort",
        "create-order-drawer-repeat-order-delete-confirm-dialog-message": "Upprepningen och eventuella avmarkerade dagar tas bort. Själva beställningen behålls.",
        "create-order-drawer-repeat-order-applies-to": "Gäller:",
        "create-order-drawer-repeat-order-applies-to-weekdays": "\n .label = Vardagar (mån–fre)",
        "create-order-drawer-repeat-order-applies-to-every-day": "\n .label = Alla dagar",
        "create-order-drawer-repeat-order-start-date-help": "Orderns leveransdatum – kan inte ändras",
        "create-order-drawer-repeat-order-start-date-missing-error": "Ordern saknar ett leveransdatum.",
        "create-order-drawer-repeat-order-end-date-missing-error": "Välj ett slutdatum.",
        "create-order-drawer-repeat-order-span-error": "En upprepning kan högst sträcka sig över ett år.",
        "create-order-drawer-repeat-order-count-missing-error": "Ange hur många leveranser som ska skapas.",
        "create-order-drawer-repeat-order-no-deliveries-error": "Den här upprepningen har inga leveransdagar. Ändra upprepningen eller ta bort den.",
        "create-order-drawer-repeat-order-delivery-days": "Leveransdagar:",
        "create-order-drawer-repeat-order-delivery-days-hint": "Avmarkera de dagar som inte ska levereras.",
        "create-order-drawer-repeat-order-delivery-days-reset-button": "Återställ avmarkeringar",
        "create-order-drawer-repeat-order-delivery-days-show-button": "Visa och avmarkera dagar ({ $count })",
        "create-order-drawer-repeat-order-delivery-days-hide-button": "Dölj dagar",
        "create-order-drawer-repeat-order-delivery-days-none-selected": "Inga dagar valda",
        "create-order-drawer-repeat-order-delivery-days-all-selected": "Alla dagar i perioden är valda",
        "create-order-drawer-repeat-order-delivery-days-deselected": "{ $count ->\n [one] { $count } dag avmarkerad\n *[other] { $count } dagar avmarkerade\n}",
        "create-order-drawer-repeat-order-delivery-days-month-count": "{ $count ->\n [one] { $count } leverans\n *[other] { $count } leveranser\n}",
        "create-order-drawer-repeat-order-delivery-days-month-deselected": "{ $count ->\n [one] · { $count } avmarkerad\n *[other] · { $count } avmarkerade\n}",
        "create-order-drawer-repeat-order-delivery-days-start-day": "Startdatum",
        "create-order-drawer-repeat-order-confirm-orders-button": "{ $count ->\n [one] Bekräfta { $count } order\n *[other] Bekräfta { $count } ordrar\n}",
        "create-order-drawer-repeat-order-summary-weekdays-suffix": "på vardagar",
        "create-order-tooltip-resource-info-button": "\n .title = Visa resursdetaljer",
        "create-order-tooltip-resource-lock-button-has-access": "\n .title = Kan endast bokas av utvalda användare. Du har behörighet att boka.",
        "create-order-tooltip-resource-lock-button-no-access": "\n .title = Kan endast bokas av utvalda användare. Du har inte behörighet.",
        "create-order-tooltip-resource-image-button": "\n .title = Visa planritning",
        "create-order-hover-local-event-start": "Starttid: { $start }",
        "create-order-hover-local-event-end": "Sluttid: { $end }",
        "create-order-hover-local-event-host": "Värd: { $host }",
        "create-order-tabs-error": "Du kan inte lägga en beställning",
        "create-order-tabs-error-body": "Du kan inte lägga en beställning eftersom ditt konto inte har den behörighet som krävs. Kontakta supporten om du behöver mer information.",
        "create-order-invalid-user-permissions-merchant-meeting-service-dialog-body": "Du försöker skapa en mötesförtäringsbeställning på uppdrag av <displayName>{ $displayName }</displayName>. Användaren har dock inte tillgång till din mötesförtäringsbutik. Kontakta supporten för hjälp.",
        "create-order-invalid-user-permissions-merchant-resource-booking-dialog-body": "Du försöker skapa en resursbokning på uppdrag av <displayName>{ $displayName }</displayName>. Kontakta supporten för hjälp.",
        "create-order-invalid-user-permissions-non-create-dialog-title": "Åtkomstbegränsning",
        "create-order-invalid-user-permissions-non-create-dialog-body": "Du har inte behörighet att utföra den här åtgärden på uppdrag av <displayName>{ $displayName }</displayName>. Kontakta supporten för hjälp.",
        "create-order-tabs-error-dialog-close-button": "Gå tillbaka",
        "create-order-tabs-error-dialog-confirm-button": "Välj en annan användare",
        "create-order-price-list-confirm-dialog": "\n .title = Ta bort produkter\n .buttonLabelSubmit = Ta bort",
        "create-order-price-list-confirm-dialog-message": "Är du säker på att du vill ta bort alla produkter från alla leveranstider?",
        "create-order-close-confirm-dialog": "\n .title = Förkasta ändringar \n .buttonLabelSubmit = Förkasta",
        "create-order-close-confirm-dialog-message": "Om du klickar på Förkasta går all inmatad information förlorad.",
        "create-order-drawer-messages-dialog-title": "\n .dialogTitle = Meddelanden från butiksägaren",
        "create-order-drawer-message-read-more": "...Läs mer",
        "expandable-text-read-more": "Läs mer",
        "expandable-text-read-less": "Visa mindre",
        "create-order-book-period-message-dialog-title": "\n .dialogTitle = Du kan inte klicka på tidslinjen när du använder läget `Boka period`",
        "create-order-book-period-message-dialog-note": "Klicka på resurserna i vänsterpanelen för att boka resurser",
        "create-order-book-period-filter-intro": "Boka period används för att boka över flera dagar. När du har valt start- och sluttid klickar du bara på önskad resurs i vänsterkolumnen",
        "create-order-book-period-filter-intro-recurring":
            "Det här är ett återkommande möte — klicka bara på önskad resurs i vänsterkolumnen för att boka den för alla tillfällen.",
        "create-order-book-period-busy-message": "Den valda resursen är inte tillgänglig under hela perioden",
        "create-order-book-period-busy-error": "Det gick inte att kontrollera resursens tillgänglighet",
        "create-order-book-period-confirm-cancel-changes-dialog": "\n .title = Ta bort nuvarande val\n .buttonLabelSubmit = Bekräfta\n .buttonLabelCancel = Avbryt",
        "create-order-book-period-confirm-cancel-changes-dialog-message": "Om du ändrar perioden rensas ditt nuvarande val. Vill du fortsätta?",
        "create-order-past-booking-attempt-message": "Du kan inte boka bakåt i tiden. Bokningens starttid måste vara lika med eller senare än aktuell tid",
        "create-order-book-period-past-booking": "Det går inte att välja en period i det förflutna",
        "create-order-change-current-event-dialog": "\n .title = Du uppdaterar just nu bokning { $currentBooking }\n .message = Vill du återställa dina ändringar och byta till { $targetBooking }?\n .buttonLabelSubmit = Bekräfta\n .buttonLabelCancel = Avbryt",
        "create-order-change-current-event-create-dialog": "\n .title = Du skapar just nu en bokning\n .message = Vill du återställa dina ändringar och byta till { $targetBooking }?\n .buttonLabelSubmit = Bekräfta\n .buttonLabelCancel = Avbryt",
        "create-order-timeline-permission-error": "Du har inte behörighet att uppdatera den här bokningen eftersom den tillhör en annan användare",
        "create-order-timeline-error-select": "Den här tidsluckan är inte tillgänglig för de valda resurserna",
        "create-order-timeline-error-busy-or-overlap": "Den här resursen är redan upptagen vid den valda tiden, eller så har överlappning med buffert upptäckts!",
        "create-order-timeline-slot-taken-message": "Någon bokade den här tiden medan du valde. Tidslinjen har uppdaterats — välj en annan tid eller en annan resurs.",
        "create-order-resource-row-events-loading-tooltip": "Kalenderhändelser laddas fortfarande. Vänta innan du väljer en resurs.",

        "create-order-select-price-list-dialog": "Välj prislista",
        "create-order-empty-price-list-dialog": "Ingen prislista tillgänglig",
        "create-order-empty-price-list-dialog-body": "Det finns för närvarande inga tillgängliga prislistor",
        "create-order-empty-price-list-dialog-body-message": "Kontakta butiksägaren för att begära åtkomst till dem",
        "create-order-select-price-list-no-price-lists-title": "Det finns för närvarande inga tillgängliga prislistor. Kontakta butiksägaren för att begära åtkomst till dem.",
        "create-order-select-price-list-no-search-results": "Din sökning gav inga resultat",
        "create-order-select-price-list-no-search-results-description": "Prova ett annat sökord",
        "create-order-select-price-list-favorites-section": "Mina favoriter ({ $count })",
        "create-order-select-price-list-favorites-view-all": "Visa alla ({ $count })",
        "create-order-select-price-list-favorites-toggle-label": "Favoriter",
        "create-order-select-price-list-nearby-note": "Visar prislistor i närheten av ditt bokade rum.",
        "create-order-select-price-list-nearby-see-all-button": "Visa alla kantiner",
        "create-order-select-price-list-nearby-only-button": "Visa endast kantiner nära ditt bokade rum",
        "create-order-select-price-list-other-canteens-section": "Andra kantiner",
        "create-order-no-products-dialog-title": "\n .dialogTitle = Prislistan innehåller inga produkter",
        "create-order-no-products-dialog-message": "Kontakta butiksägaren för att få åtkomst till produkterna",
        "create-order-no-longer-available-dialog-title": "\n .dialogTitle = Prislistan är inte längre tillgänglig",
        "create-order-no-longer-available-dialog-message": "Prislistan som användes för den här beställningen är inte längre tillgänglig. Välj en annan prislista för att fortsätta.",
        "create-order-no-products-dialog-button-label-cancel": "Gå till startsidan",
        "create-order-no-products-dialog-button-label-submit": "Välj en annan prislista",
        "create-order-products-empty-favorites-title": "Du har inga favoritvaror",
        "create-order-products-empty-favorites-description": "Du kan lägga till favoritvaror så att du snabbare kan slutföra en beställning. Lägg till en favoritvara genom att klicka på hjärtikonen på produktkortet",
        "create-order-credit-note-overlay-title": "Kreditnota",
        "create-order-credit-note-overlay-intro-with-order-id": "Du skapar en kreditnota för order-ID <orderIdLink>#{ $orderId }</orderIdLink>.",
        "create-order-credit-note-overlay-callout-title": "Så här skapar du en kreditnota:",
        "create-order-credit-note-overlay-callout-body": "Justera produkterna i varukorgen. Varorna som finns i varukorgen krediteras. Du kan lägga till din egen orderrad om det behövs.",
        "create-order-select-price-list-dialog-subtitle": "Mötesförtäring",
        "create-order-select-price-list-search-placeholder": "\n .placeholder = Sök efter prislista eller kantin",
        "create-order-select-price-list-close-button": "Stäng",
        "create-order-select-price-list-footer-empty": "Välj en prislista",
        "create-order-select-price-list-footer-selected": "{ $priceList } · { $merchant }",
        "create-order-select-price-list-continue-button": "Fortsätt",
        "create-order-select-price-list-selected-badge": "Vald",
        "create-order-select-price-list-address-map-link": "Öppna i Google Maps",
        "create-order-select-price-list-address-show-map": "Visa karta",
        "create-order-select-price-list-address-hide-map": "Dölj karta",
        "create-order-select-price-list-info-button-tooltip": "Visa detaljer",
        "create-order-select-price-list-info-close-button": "Stäng detaljer",
        "create-order-select-price-list-favorite-add-button-tooltip": "Lägg till i favoriter",
        "create-order-select-price-list-favorite-remove-button-tooltip": "Ta bort från favoriter",
        "create-order-on-behalf-of-dialog": "Beställ på uppdrag av",
        "create-order-on-behalf-of-dialog-description": "För att skapa en beställning som administratör måste du först välja den användare du lägger beställningen åt.",
        "create-order-on-behalf-of-dialog-user-description": "Välj vem du beställer åt. Personen blir arrangör och kan uppdatera beställningen från sin dashboard.",
        "create-order-on-behalf-of-dialog-select-company-field": "\n .label = Välj företag",
        "create-order-on-behalf-of-dialog-select-user-field": "\n .label = Välj användare\n .placeholder = Ange användarnamn:",
        "create-order-on-behalf-of-dialog-user-organizer-field": "\n .label = Arrangör:\n .placeholder = Arrangörens namn",
        "create-order-on-behalf-of-dialog-select-user-field-no-results": "Inga resultat",
        "create-order-on-behalf-of-dialog-select-company-host-field": "\n .label = Värdens företag",
        "create-order-on-behalf-of-dialog-select-host-field": "\n .label = Värdens namn\n .placeholder = Ange värdens namn:",
        "create-order-on-behalf-of-dialog-button": "Fortsätt",
        "create-order-bill-receiver-ean": "EAN:",
        "create-order-bill-receiver-email": "E-post:",
        "create-order-bill-receiver-contact": "Kontakt:",
        "create-order-bill-receiver-add-button": "+ Lägg till fakturamottagare",
        "create-order-bill-receiver-autocomplete-no-options": "Inga fakturamottagare hittades. Kontakta din administratör för att lägga till en.",
        "create-order-vat-included": "(inkl. moms)",
        "create-order-vat-excl": "(exkl. moms)",


        "create-order-recurrence-outlook-managed": "Det här mötet upprepas (hanteras i Outlook)",
        "create-order-busy-resource-dates-dialog-title": "Vissa datum kunde inte bokas",
        "create-order-busy-resource-dates-dialog-message":
            "De valda resurserna var redan bokade på följande datum, så dessa tillfällen bokades inte:",
        "create-order-busy-resource-dates-dialog-copy-button": "Kopiera lista",
        "create-order-busy-resource-dates-dialog-copied-button": "Kopierat",
        "create-order-busy-resource-dates-dialog-continue-button": "Fortsätt",
        "create-order-success-dialog-resource-booking-title": "Bokning skapad!",
        "create-order-success-dialog-resource-booking-title-with-order-id": "Bokning #{ $orderId } skapad!",
        "create-order-success-dialog-resource-booking-title-updated-with-order-id":
            "Bokning #{ $orderId } är uppdaterad!",
        "create-order-success-dialog-meeting-service-title": "Beställning skapad!",
        "create-order-success-dialog-meeting-service-title-with-order-id": "Beställning #{ $orderId } skapad!",
        "create-order-success-dialog-meeting-service-title-updated-with-order-id": "Beställning #{ $orderId } är uppdaterad!",
        "create-order-success-dialog-series-orders-title": "{ $count } beställningar har skapats!",
        "create-order-success-dialog-description": "Vad vill du göra nu?",
        "create-order-success-dialog-outlook-cancel-note":
            "Behöver du avboka? Avboka beställningen i Facilitynet innan du tar bort mötet i Outlook.",
        "create-order-success-dialog-action-meeting-service": "Lägg till mötesförtäring i beställningen",
        "create-order-success-dialog-action-meeting-service-update": "Uppdatera mötesförtäring",
        "create-order-success-dialog-action-add-resource-booking": "Lägg till resursbokning",
        "create-order-success-dialog-action-update-resource-booking": "Uppdatera resursbokning",
        "create-order-success-dialog-action-create-booking": "Skapa en ny bokning",
        "create-order-success-dialog-action-create-meeting-service": "Skapa ny mötesförtäring",
        "create-order-success-dialog-action-finish": "Jag är klar",
        "create-order-success-dialog-action-calendar": "Lägg till mötet i kalendern",

        "create-order-outlook-finish-step": "Du kan nu gå tillbaka till Outlook",

        // Confirm order dialog
        "confirm-order-dialog-order-error": "Det gick inte att läsa in kvittot med id #{ $orderId }",
        "confirm-order-dialog-order-error-description": "Den här beställningen kunde inte behandlas på grund av saknade eller ogiltiga data.",
        "confirm-order-dialog-title": "Bekräfta beställning",
        "confirm-order-dialog-title-update-order": "Uppdatera beställning #{ $id }",
        "confirm-order-dialog-title-credit-note-order": "Skapa kreditnota",
        "confirm-order-dialog-title-supplementary-order": "Skapa tilläggsbeställning",
        "confirm-order-dialog-meeting-details": "Mötesdetaljer",
        "confirm-order-dialog-meeting-time": "Mötestid:",
        "confirm-order-dialog-delivery-date": "Leveransdatum:",
        "confirm-order-dialog-delivery-location": "Leveransplats:",
        "confirm-order-dialog-delivery-location-mode-eating-in-canteen": "Äter i kantinen",
        "confirm-order-dialog-delivery-location-mode-pick-up": "Avhämtning",
        "confirm-order-dialog-seats": "Kuvert:",
        "confirm-order-dialog-merchant": "Butiksägare:",
        "confirm-order-dialog-workgroup": "Arbetsgrupp:",
        "confirm-order-dialog-workgroup-members-title": "Arbetsgruppens medlemmar",
        "confirm-order-dialog-workgroup-members-empty": "Inga medlemmar att visa",
        "confirm-order-dialog-workgroup-members-error": "Vi kan inte visa medlemmarna just nu",
        "confirm-order-dialog-workgroup-members-no-access": "Du har inte behörighet att se gruppens medlemmar",
        "confirm-order-timestamp-created": "Skapad:",
        "confirm-order-timestamp-updated": "Uppdaterad:",
        "confirm-order-dialog-contact": "Kontakt",
        "confirm-order-dialog-host": "Värd:",
        "confirm-order-dialog-ordered-by": "Beställd av:",
        "confirm-order-dialog-bill-receiver": "Fakturamottagare",
        "confirm-order-dialog-bill-receiver-contact": "Kontakt:",
        "confirm-order-dialog-bill-receiver-contact-email": "E-post:",
        "confirm-order-dialog-bill-receiver-cost-centers": "Kostnadsställen:",
        "confirm-order-dialog-bill-receiver-meeting-type": "Mötestyp:",
        "confirm-order-dialog-bill-receiver-department": "Avdelning:",
        "confirm-order-dialog-order-summary": "Orderöversikt",
        "confirm-order-dialog-order-summary-delivery-date": "Leverans: { $date }",
        "confirm-order-dialog-order-summary-delivery-date-time": "Leverans: { $date }, { $time }",
        "confirm-order-dialog-order-summary-table-meeting-service": "Mötesförtäring",
        "confirm-order-dialog-order-summary-table-items": "Antal",
        "confirm-order-dialog-order-summary-table-amount": "Belopp",
        "confirm-order-dialog-order-summary-table-amount-no-vat": "Belopp",
        "confirm-order-dialog-order-summary-table-meeting-services-total": "Totalt",
        "confirm-order-dialog-order-summary-table-meeting-services-total-no-vat": "Totalt",
        "confirm-order-dialog-order-summary-table-meeting-services-vat": "Momsen uppgår till ({ $percentage }%)",
        "confirm-order-dialog-order-summary-table-meeting-services-total-include-vat": "Totalbelopp inkl. moms",
        "confirm-order-dialog-repeat-order": "\n .title = Upprepa beställning",
        "confirm-order-dialog-repeat-order-text": "Upprepa beställning",
        "confirm-order-dialog-repeat-order-summary-weekdays": "Vardagar",
        "confirm-order-dialog-repeat-order-summary-every-day": "Alla dagar",
        "confirm-order-dialog-repeat-order-summary-rule": "Var { $interval }{ $days }",
        "confirm-order-dialog-repeat-order-summary-deliveries": "{ $count ->\n [one] { $count } leverans\n *[other] { $count } leveranser\n}",
        "confirm-order-dialog-repeat-order-summary-deselected": "{ $count ->\n [one] ({ $count } avmarkerad)\n *[other] ({ $count } avmarkerade)\n}",
        "confirm-order-dialog-repeat-order-day-deselected": "avmarkerad",
        "confirm-order-dialog-attendees": "\n .title = Deltagare",
        "confirm-order-dialog-attendees-subtitle": "{ $internalCount } { $internalCount ->\n  [one] intern\n *[other] interna\n}, { $externalCount } { $externalCount ->\n  [one] extern\n *[other] externa\n}",
        "confirm-order-dialog-attendees-internal": "\n .title = Interna deltagare:",
        "confirm-order-dialog-attendees-external": "\n .title = Externa deltagare:",
        "confirm-order-dialog-resources": "\n .title = Resurser",
        "confirm-order-dialog-back-button": "Fortsätt redigera",
        "confirm-order-dialog-next-button": "Bekräfta beställning",
        "confirm-order-dialog-booking-time": "Bokningstid: { $timeRange }",

        "user-order-receipt-page-share-button": "Dela",
        "user-order-receipt-page-not-loaded-message": "  Order-ID { $orderId } kunde inte läsas. Kontakta supporten.",
        "user-order-receipt-page-not-found-public-message": "Tyvärr hittades inte beställningen. Kontakta supporten på <link>{ $supportEmail }</link> om du behöver hjälp.",
        "user-order-receipt-page-loading": "Läser in beställning...",
        "user-order-receipt-page-share-modal-title": "Dela kvitto",
        "user-order-receipt-page-share-modal-subtitle": "Dela den här länken så att andra kan se kvittot.",
        "user-order-receipt-page-print-button": "Skriv ut",
        "user-order-receipt-page-header-orders-count": "Beställningar: {$orderCount} valda",
        "user-pos-order-receipt-page-header-orders-count": "Kvitton: {$orderCount} valda",
        "user-order-receipt-page-navigation-counter": "Beställning { $current } av { $total }",
        "user-pos-order-receipt-page-navigation-counter": "Kvitto { $current } av { $total }",
        "receipt-order-navigation-previous-button": "Föregående",
        "receipt-order-navigation-next-button": "Nästa",
        "merchant-receipt-dropdown-search-label": "\n .placeholder = Sök efter ordernr., namn eller e-post",
        "merchant-receipt-dropdown-group-today-label": "Idag · { $date }",
        "merchant-receipt-dropdown-orders-count": "{ $count ->\n [one] { $count } order\n *[other] { $count } order\n}",

        "create-order-delivery-times-add-button": "Lägg till leveranstider",
        "create-order-delivery-times-add-btn": "Lägg till",
        "create-order-delivery-times-add-delivery-time-title": "Leveranstider",
        "create-order-delivery-times-update-delivery-time": "Uppdatera leveranstider",
        "create-order-delivery-times-add-delivery-time": "Lägg till leveranstider:",
        "create-order-delivery-times-dialog-title-add": "Lägg till leveranstider",
        "create-order-delivery-times-dialog-title-edit": "Redigera leveranstider",
        "create-order-delivery-times-dialog-subtitle": "Du måste välja ett datum för leveransen.",
        "create-order-delivery-times-dialog-subtitle-example": "Du kan ange flera leveranstider för heldagsmöten, t.ex. leverans kl. 10:00 och kl. 13:00.",
        "create-order-delivery-times-dialog-booking-date-mismatch": "Din bokning är den { $bookingDate } kl. { $bookingTime }, men mötesförtäringen är den { $deliveryDate }.",
        "create-order-delivery-times-dialog-delivery-date": "Leveransdatum",
        "create-order-delivery-times-dialog-delivery-date-details": "Leveransdatum:",
        "create-order-delivery-times-dialog-delivery-time-event-start": "Ditt möte startar kl. { $bookingTime }, men butiksägaren levererar bara mellan { $minTime } och { $maxTime }. Välj en leveranstid inom det tidsintervallet.",
        "create-order-delivery-times-dialog-delivery-time-event-start-today": "Tyvärr kan du inte skapa en mötesförtäringsbeställning i dag, eftersom butiksägaren inte levererar senare än { $time }",
        "create-order-delivery-times-dialog-delivery-date-close-tooltip": "Försäljningsstället är stängt detta datum",
        "create-order-delivery-times-dialog-delivery-date-kept-tooltip":
            "Försäljningsstället är stängt detta datum — behålls från den ursprungliga beställningen",
        "create-order-closed-delivery-date-warning-admin":
            "Observera: Kantinen är stängd { $date }. Vanliga kantinanvändare kan inte lägga beställningar för det här datumet, men som kantinadministratör kan du skapa beställningen.",
        "create-order-closed-delivery-date-warning-editing":
            "Observera: Kantinen är stängd { $date }. Den här beställningen lades för det datumet och kan fortfarande sparas.",
        "create-order-closed-delivery-date-banner-admin":
            "\n .title = Observera: Kantinen är stängd { $date }. Vanliga kantinanvändare kan inte lägga beställningar för det här datumet, men som kantinadministratör kan du skapa beställningen.",
        "create-order-closed-delivery-date-banner-editing":
            "\n .title = Observera: Kantinen är stängd { $date }. Den här beställningen lades för det datumet och kan fortfarande sparas.",
        "create-order-delivery-times-dialog-delivery-times": "Leveranstider",
        "create-order-delivery-times-dialog-delivery-field": "\n .label = Leverans { $count }",
        "create-order-delivery-times-dialog-add-delivery-button": "+ Lägg till leverans",
        "create-order-delivery-times-dialog-submit-button": "Bekräfta",
        "create-order-delivery-times-dialog-close-button": "Ok",
        "create-order-delivery-times-empty-error": "Ingen aktiv leveranstid vald",
        "create-order-cost-centers-missing-dialog-title": "Kostnadsställen är inte tillgängliga",
        "create-order-cost-centers-missing-message": "Det finns inga tillgängliga kostnadsställen för \"{ $dimensionName }\". Kontakta din administratör för att få kostnadsställen skapade.",
        "create-order-delivery-location-required": "Välj en leveransplats",
        "create-order-meeting-location-required": "Mötesplats krävs när en extra tjänst kräver det",
        "create-order-meeting-time-required": "Mötestid krävs när en extra tjänst kräver det",
        "create-order-multiple-deliveries-date-and-time-required": "Du måste välja ett leveransdatum och minst en leveranstid",
        "create-order-validation-date-invalid": "{ $label } måste vara ett giltigt datum",
        "create-order-validation-must-be-checked": "{ $label } måste vara ikryssad",
        "create-order-validation-required": "{ $label } krävs",
        "create-order-validation-min": "{ $label } måste vara minst { $min }",
        "create-order-validation-max": "{ $label } får högst vara { $max }",
        "create-order-validation-must-be-true": "{ $label } måste vara sant",
        "create-order-validation-email-invalid": "{ $label } måste vara en giltig e-postadress",
        "create-order-validation-format-invalid": "{ $label } har inte rätt format",
        "create-order-delivery-times-same-time-error": "Samma tid kan inte läggas till två gånger",
        "create-order-delivery-times-opening-hours-error": "Den valda tiden ligger inte inom öppettiderna för det här datumet",
        "create-order-delivery-times-past-time-error": "Leveranstiden kan inte ligga i det förflutna",
        "create-order-refund-amount-exceeds-initial-error": "Kreditnotan får inte överstiga det ursprungliga beloppet",
        "create-order-refund-quantity-exceeds-initial-error": "Den krediterade mängden får inte överstiga den ursprungliga mängden för den här produkten",
        "create-order-delivery-deadline-message-dialog-title": "\n .title = Tidsfristen har passerat \n .buttonLabelSubmit = Lägg beställning \n .buttonLabelCancel = Avbryt beställning",
        "create-order-delivery-deadline-message-dialog-description": "Du kan fortfarande lägga beställningen, men den måste godkännas av personalen, vilket innebär att du inte kan förvänta dig att beställningen levereras.",
        "create-order-delivery-deadline-message-dialog-product-wish-staff-description": "Det finns ett produktönskemål i den här beställningen. Du måste ange ett pris och godkänna beställningen om du vill tillmötesgå önskemålet.",
        "create-order-add-product-deadline-dialog-title": "\n .title = Tidsfristen har passerat \n .buttonLabelSubmit = OK",

        "create-order-timeline-booked-period": "Boka period",
        "create-order-timeline-booked-period-tooltip": "Välj start- och sluttid för att boka resurser under en längre period",
        "create-order-timeline-booked-period-selected-tooltip": "Klicka på en resurs i vänsterkolumnen för att boka den för den här perioden. Det går inte att klicka på tidslinjen i det här läget",
        "create-order-timeline-booked-period-recurring-tooltip": "Perioden bestäms av mötesserien. Klicka på en resurs i vänsterkolumnen för att boka den för alla tillfällen",
        "create-order-timeline-booked-period-start-date-time-label": "\n .label = Starttid",
        "create-order-timeline-booked-period-end-date-time-label": "\n .label = Sluttid",
        "create-order-timeline-meeting-availability-hidden-count": "{ $count } resurser dolda",
        "create-order-timeline-meeting-availability-show-all-button": "Visa alla",
        "create-order-timeline-meeting-fit-banner-title-fallback": "Ditt möte",
        "create-order-timeline-meeting-fit-banner-summary":
            "{ $date }, { $time } · { $count ->\n [one] { $count } deltagare\n *[other] { $count } deltagare\n}",
        "create-order-timeline-meeting-fit-banner-summary-no-attendees": "{ $date }, { $time }",
        "create-order-timeline-meeting-fit-banner-summary-attendees-only":
            "{ $count ->\n [one] { $count } deltagare\n *[other] { $count } deltagare\n}",
        "create-order-timeline-meeting-fit-banner-fits-segment": "Passar ditt möte",
        "create-order-timeline-meeting-fit-banner-all-segment": "Alla resurser",
        "create-order-timeline-meeting-fit-banner-fits-segment-tooltip-seats-and-availability":
            "Visar bara resurser med tillräckligt många platser som är lediga under mötestiden",
        "create-order-timeline-meeting-fit-banner-fits-segment-tooltip-availability":
            "Visar bara resurser som är lediga under mötestiden",
        "create-order-timeline-meeting-fit-banner-fits-segment-tooltip-seats":
            "Visar bara resurser med tillräckligt många platser för deltagarna",
        "create-order-timeline-meeting-fit-banner-all-segment-tooltip":
            "Visar alla resurser, även de som inte passar mötet",
        "create-order-timeline-meeting-fit-banner-go-to-meeting-button": "Gå till mötet",

        "resource-booking-chip-filter-select-booking-duration-hours": "timmar",
        "resource-booking-chip-filter-select-booking-duration-minutes": "minuter",
        "resource-booking-chip-filter-select-meeting-type-title-internal-meeting": "Internt möte",
        "resource-booking-chip-filter-select-meeting-type-title-internal-meeting-description": "Mötet är bara med kollegor, inga externa gäster.",
        "resource-booking-chip-filter-select-meeting-type-title-external-meeting": "Externt möte",
        "resource-booking-chip-filter-select-meeting-type-title-external-meeting-description": "Mötet har externa gäster.",
        "resource-booking-chip-filter-select-title-floors": "Välj våning",
        "resource-booking-chip-filter-select-title-fixedavids": "Välj fast AV-utrustning",
        "resource-booking-chip-filter-select-title-meetingtype": "Välj mötestyp",
        "resource-booking-chip-filter-select-title-sittings": "Antal platser",
        "resource-booking-chip-filter-select-title-tablesetupids": "Välj bordsuppställningar",
        "resource-booking-chip-filter-select-title-deliverytype": "Välj leveranstyp",
        "resource-booking-chip-filter-select-title-mobileav": "Mobil AV-utrustning",
        "resource-booking-chip-filter-select-title-settables": "Dukning",
        "resource-booking-chip-filter-select-title-cleanup": "Avdukning",
        "resource-booking-chip-filter-select-title-resourcetypeids": "Välj resurstyp",
        "resource-booking-chip-filter-select-title-servicecenterids": "Välj servicecenter",
        "resource-booking-chip-filter-select-title-satelliteids": "Välj satelliter",
        "resource-booking-chip-filter-select-title-meetingduration": "Bokningslängd",
        "resource-booking-chip-filter-tooltip-resourcetypeids": "Visar bara resurser av de valda typerna",
        "resource-booking-chip-filter-tooltip-sittings": "{ $count ->\n [one] Visar lokaler med minst { $count } plats\n *[other] Visar lokaler med minst { $count } platser\n}",
        "resource-booking-chip-filter-tooltip-servicecenterids": "Visar bara resurser vid de valda servicecentren",
        "resource-booking-chip-filter-tooltip-floors": "Visar bara resurser på de valda våningarna",
        "resource-booking-chip-filter-tooltip-fixedavids": "Visar bara lokaler med all den valda fasta AV-utrustningen",
        "resource-booking-chip-filter-tooltip-tablesetupids": "Visar bara lokaler som erbjuder minst en av de valda bordsuppställningarna",
        "resource-booking-chip-filter-rooms": "Lokaler",
        "resource-booking-chip-filter-equipment": "AV-utrustning",
        "resource-booking-chip-filter-cars": "Bilar",

        // Resource filter API keys (groups and elements)
        "key_group_1": "Resurstyper",
        "key_group_2": "Mötets längd",
        "key_group_3": "Mötestid",
        "key_group_4": "Deltagare",
        "key_group_5": "Utökad sökning",
        "key_1": "Resurstyper",
        "key_2": "Mötets längd",
        "key_3": "Mötestid",
        "key_4": "Platser",
        "key_5": "Servicecenter",
        "key_6": "Våning",
        "key_7": "Bordsuppställningar",
        "key_8": "AV-utrustning",

        // Resource details dialog
        "resource-details-dialog-service-center": "Servicecenter",
        "resource-details-dialog-floor": "Våning",
        "resource-details-dialog-description": "Beskrivning",
        "resource-details-dialog-empty": "\n .title = Inga detaljer tillgängliga\n .description = Detaljerna för den här resursen hittades inte.",
        "resource-details-dialog-square-meters": "Kvadratmeter",
        "resource-details-dialog-walk-direction":"Vägbeskrivning",
        "resource-details-dialog-capacity": "Kapacitet",
        "resource-details-dialog-capacity-quantity": "{ $quantity } personer",
        "resource-details-dialog-table-arrangement": "Bordsuppställning",


        // Service center > Navigation
        "service-center-top-bar-info-screens-online": "Infoskärmar online",
        "service-center-top-bar-info-screens-offline": "{ $count ->\n [one] { $count } skärm offline\n *[other] { $count } skärmar offline\n}",
        "service-center-nav-item-user-label": "\n .title = Hem" ,
        "service-center-nav-item-canteen-label": "\n .title = Kommande möten" ,
        "service-center-nav-item-guests-label": "\n .title = Gästlista" ,
        "service-center-nav-item-meeting-rooms-label": "\n .title = Mötesrum" ,
        "service-center-nav-item-settings-label": "\n .title = Administration" ,
        "service-center-nav-bottom-bar-home-label": "Hem",
        "service-center-nav-bottom-bar-canteen-label": "Möten",
        "service-center-nav-bottom-bar-meeting-rooms-label": "Mötesrum",
        "service-center-nav-bottom-bar-guests-label": "Gäster",
        "service-center-nav-bottom-bar-settings-label": "Administration",

        // Service center > Reports > Dashboard
        "service-center-reports-dashboard-check-in-button": "Checka in",
        "service-center-reports-dashboard-checked-id": "Incheckad",
        "service-center-reports-dashboard-check-in-guests-button": "Incheckning av gäster",
        "service-center-reports-dashboard-guests-overview-in-house-title": "Gäster i huset",
        "service-center-reports-dashboard-guests-overview-in-house-unit": "i huset",
        "service-center-reports-dashboard-guests-overview-print-guest-list": "Skriv ut gästlista",
        "service-center-reports-dashboard-guests-overview-export-guest-list": "Exportera till Excel",
        "service-center-reports-dashboard-guests-overview-chart-title": "I dag",
        "service-center-reports-dashboard-guests-overview-chart-empty": "Inga möten i dag",
        "service-center-reports-dashboard-guests-overview-chart-legend-meetings": "Möten",
        "service-center-reports-dashboard-guests-overview-chart-legend-guests": "Gäster",
        "service-center-reports-dashboard-guests-overview-chart-slot-tooltip": "{ $from }–{ $to }: { $meetings } möten, { $guests } gäster",
        "service-center-reports-dashboard-guests-overview-group-label": "Grupp om { $count }",
        "service-center-reports-dashboard-guests-overview-print-title": "Gäster i huset · { $date }",
        "service-center-reports-dashboard-guests-overview-print-empty": "Inga gäster i huset",
        "service-center-reports-dashboard-guests-overview-csv-name-header": "Namn",
        "service-center-reports-dashboard-guests-overview-csv-company-header": "Företag",
        "service-center-reports-dashboard-guests-overview-csv-meeting-header": "Möte",
        "service-center-reports-dashboard-guests-overview-csv-host-header": "Värd",
        "service-center-reports-dashboard-guests-overview-csv-room-header": "Rum",
        "service-center-reports-dashboard-guests-overview-csv-time-header": "Tidpunkt",
        "service-center-reports-dashboard-bookings-title": "Bokningar",
        "service-center-reports-dashboard-bookings-print-title": "Bokningar – { $tab } · { $date }",
        "service-center-reports-dashboard-bookings-tab-room": "Möten",
        "service-center-reports-dashboard-bookings-tab-car": "Bilar",
        "service-center-reports-dashboard-bookings-tab-mobile-av": "AV",
        "service-center-reports-dashboard-bookings-empty-room": "Inga möten denna dag",
        "service-center-reports-dashboard-bookings-empty-car": "Inga bilbokningar denna dag",
        "service-center-reports-dashboard-bookings-empty-mobile-av": "Inga AV-bokningar denna dag",
        "service-center-reports-dashboard-bookings-export-menu-csv": "Exportera till CSV",
        "service-center-reports-dashboard-meeting-audience-filter-label": "Visa möten",
        "service-center-reports-dashboard-meetings-list-row-audience-internal": "Intern",
        "service-center-reports-dashboard-meetings-list-row-audience-external": "Extern",
        "service-center-reports-dashboard-meetings-csv-start-header": "Start",
        "service-center-reports-dashboard-meetings-csv-end-header": "Slut",
        "service-center-reports-dashboard-meetings-csv-title-header": "Titel",
        "service-center-reports-dashboard-meetings-csv-type-header": "Typ",
        "service-center-reports-dashboard-meetings-csv-host-header": "Värd",
        "service-center-reports-dashboard-meetings-csv-company-header": "Företag",
        "service-center-reports-dashboard-meetings-csv-location-header": "Rum",
        "service-center-reports-dashboard-search-label": "\n .placeholder = Sök",
        "service-center-reports-dashboard-meeting-pagination": "Resultat per sida",
        "service-center-reports-dashboard-check-in-title": "Incheckningskö",
        "service-center-reports-dashboard-guest-check-in-title": "Gästincheckning",
        "service-center-reports-dashboard-no-guests":"Inga gäster i incheckningskön",
        "service-center-reports-dashboard-news-title": "Nyheter",
        "service-center-reports-dashboard-no-news":"Inga nyheter",
        "service-center-reports-dashboard-no-meeting-selected":"Inget möte valt",
        "service-center-reports-dashboard-no-meetings":"Inga kommande möten i dag",

        // Service center > Reports > Upcoming meetings
        "service-center-reports-upcoming-meetings-title": "\n .title = Kommande möten",
        "service-center-reports-upcoming-meetings-empty": "\n .title = Inget planerat under perioden",
        "service-center-reports-upcoming-meetings-period-today": "I dag",
        "service-center-reports-upcoming-meetings-period-tomorrow": "I morgon",
        "service-center-reports-upcoming-meetings-period-this-week": "Denna vecka",
        "service-center-reports-upcoming-meetings-period-next-7-days": "Kommande 7 dagar",
        "service-center-reports-upcoming-meetings-period-next-30-days": "Kommande 30 dagar",
        "service-center-reports-upcoming-meetings-period-all": "Alla kommande",
        "service-center-reports-upcoming-meetings-date-filter-hint-start": "Välj ett startdatum i kalendern",
        "service-center-reports-upcoming-meetings-date-filter-hint-end": "Välj nu slutdatumet i kalendern",
        "service-center-reports-upcoming-meetings-date-filter-apply-button": "Använd",
        "service-center-reports-upcoming-meetings-search-input": "\n .placeholder = Sök möte, nr eller rum",
        "service-center-reports-upcoming-meetings-export-menu-csv": "Exportera till CSV",
        "service-center-reports-upcoming-meetings-audience-filter-label": "Visa",
        "service-center-reports-upcoming-meetings-resource-type-tab-all": "Alla typer",
        "service-center-reports-upcoming-meetings-resource-type-tab-room": "Mötesrum",
        "service-center-reports-upcoming-meetings-resource-type-tab-mobile-av": "AV",
        "service-center-reports-upcoming-meetings-resource-type-tab-car": "Bilar",
        "service-center-reports-upcoming-meetings-row-tag-room": "Rum",
        "service-center-reports-upcoming-meetings-row-tag-mobile-av": "AV",
        "service-center-reports-upcoming-meetings-row-tag-car": "Bil",
        "service-center-reports-upcoming-meetings-row-tag-meeting-service": "Mötesförtäring",
        "service-center-reports-upcoming-meetings-group-bookings-count": "{ $count ->\n [one] { $count } bokning\n *[other] { $count } bokningar\n}",
        "service-center-reports-upcoming-meetings-group-orders-count": "{ $count ->\n [one] { $count } beställning\n *[other] { $count } beställningar\n}",
        "service-center-reports-upcoming-meetings-csv-date-header": "Datum",
        "service-center-reports-upcoming-meetings-csv-number-header": "Nr",
        "service-center-reports-upcoming-meetings-csv-start-header": "Start",
        "service-center-reports-upcoming-meetings-csv-end-header": "Slut",
        "service-center-reports-upcoming-meetings-csv-title-header": "Titel",
        "service-center-reports-upcoming-meetings-csv-type-header": "Typ",
        "service-center-reports-upcoming-meetings-csv-location-header": "Rum/leverans",
        "service-center-reports-upcoming-meetings-csv-price-header": "Pris",

        // Service center > Reports > Dashboard > Check in modal
        "service-center-reports-dashboard-check-in-modal-title": "Gästincheckning",
        "service-center-reports-dashboard-print-labels-modal-title": "Skriv ut gästkort",
        "service-center-reports-dashboard-printing-labels-modal-title": "Skriver ut gästkort",
        "service-center-reports-dashboard-printing-labels-modal-subtitle": "Gästkort att skriva ut ({ $amount})",

        "service-center-reports-dashboard-printing-labels-of": "av",
        "service-center-reports-dashboard-printing-labels-cancel": "Avbryt",
        "service-center-reports-dashboard-printing-labels-print": "Skriv ut",

        // Label printer errors
        "label-printer-error-no-labels": "Inga etiketter att skriva ut",
        "label-printer-error-cancelled": "Utskriften avbröts av användaren",
        "label-printer-error-required-fields": "Fyll i alla obligatoriska fält och se till att gruppstorleken är minst 1",
        "label-printer-error-failed-guest-label": "Det gick inte att skriva ut gästetiketten",
        "label-printer-error-unknown-guest-label": "Okänt fel vid utskrift av gästetikett",
        "label-printer-error-failed-label-for": "Det gick inte att skriva ut etikett för { $name }",
        "label-printer-error-printing-label-for": "Fel vid utskrift av etikett för { $name }",
        "label-printer-error-failed-group-labels": "Det gick inte att skriva ut gruppetiketter",
        "label-printer-error-unknown-group-labels": "Okänt fel vid utskrift av gruppetiketter",
        "label-printer-error-failed-takeaway-labels": "Det gick inte att skriva ut Takeaway-etiketter",
        "label-printer-error-unknown-takeaway-labels": "Okänt fel vid utskrift av Takeaway-etiketter",
        "label-printer-error-printer-not-found": "Ingen skrivare hittades. Anslut etikettskrivaren.",
        "label-printer-error-failed-labels-summary": "Det gick inte att skriva ut { $failed } av { $total } etiketter",
        "label-printer-success-labels-printed": "Etiketter utskrivna",
        "label-printer-dialog-not-installed-title": "Skrivartillägg krävs",
        "label-printer-dialog-install-chrome-button": "Installera för Chrome",
        "label-printer-dialog-install-edge-button": "Installera för Edge",
        "label-printer-dialog-install-tooltip": "Lägg till Brother b-PAC-tillägget i din webbläsare.",
        "label-printer-dialog-refresh-after-install": "Efter installationen uppdaterar du sidan genom att <refreshLink>klicka här</refreshLink> eller trycka på F5.",
        "label-printer-dialog-need-help": "Behöver du hjälp?",
        "label-printer-dialog-printer-guide-link": "Skrivarguide",
        "label-printer-dialog-order-printer-link": "Beställ en Brother-etikettskrivare",
        "label-printer-dialog-not-found-title": "Ingen skrivare hittades",
        "label-printer-dialog-not-found-message": "Ingen skrivare hittades. Har du anslutit etikettskrivaren?",
        "label-printer-dialog-try-again-button": "Försök igen",

        "service-center-reports-check-in-modal-guest-details": "Gästuppgifter",
        "service-center-reports-check-success-title": "Gäst incheckad",
        "service-center-reports-check-group-success-title": "Grupp incheckad",
        "service-center-reports-check-in-modal-guest-name-min": "Gästens namn måste vara minst { $min } tecken",
        "service-center-reports-check-in-modal-guest-name-max": "Gästens namn får vara högst { $max } tecken",
        "service-center-reports-check-in-modal-guest-company-max": "Gästens företag får vara högst { $max } tecken",
        "service-center-reports-check-in-modal-number-of-guests-min": "Antalet gäster måste vara minst { $min }",
        "service-center-reports-check-in-modal-number-of-guests-max": "Antalet gäster får vara högst { $max }",
        "service-center-reports-check-in-modal-message-max": "Meddelandet får vara högst { $max } tecken",
        "service-center-reports-check-in-modal-single": "Enskild",
        "service-center-reports-check-in-modal-group": "Grupp",
        "service-center-reports-check-in-modal-host-name": "\n .label = Värdens namn",
        "service-center-reports-check-in-modal-host-company": "\n .label = Värdföretag",
        "service-center-reports-check-in-modal-guest-name": "\n .label = Gästens namn",
        "service-center-reports-check-in-modal-number-of-guests": "\n .label = Antal gäster",
        "service-center-reports-check-in-modal-guest-company": "\n .label = Gästens företag",
        "service-center-reports-check-in-modal-guests-company": "\n .label = Gruppnamn",
        "service-center-reports-check-in-modal-print-guest-card": "\n .label = Skriv ut gästkort",
        "service-center-reports-check-in-modal-send-host-notification": "\n .label = Meddela värden",
        "service-center-reports-check-in-modal-send-host-notification-tooltip": "\n .title = Värden får ett meddelande om att gästen har checkat in.",
        "service-center-reports-check-in-modal-write-message-to-host": "\n .label = Skriv ett meddelande till värden",
        "service-center-reports-check-in-modal-settings": "Inställningar",
        "service-center-reports-check-in-modal-check-in-button": "Checka in",
        "service-center-reports-check-in-modal-guest-check-in-title": "Gästincheckning",
        "service-center-reports-check-in-modal-guest-check-in-subtitle": "Gäster att checka in ({ $amount})",


        "service-center-check-in-error-generic": "Ett fel uppstod vid incheckning av gästen. Försök igen.",
        "service-center-check-in-error-not-found": "Gästen eller värden hittades inte. Kontrollera uppgifterna och försök igen.",
        "service-center-check-in-error-invalid-data": "Ogiltiga incheckningsuppgifter. Kontrollera uppgifterna och försök igen.",
        "service-center-check-in-print-failed-snackbar": "Gästen har checkat in, men gästkortet kunde inte skrivas ut.",
        "service-center-check-in-host-contact-link": "Visa värdens kontaktuppgifter",

        // Service center > Reports > Dashboard > Meetings drawer
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-title": "Värdens kontaktuppgifter",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-name": "Namn:",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-company-name": "Företag: ",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-department-name": "Avdelning: ",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-email": "E-post: ",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-business-phone": "Telefonnummer: ",
        "service-center-reports-dashboard-meetings-drawer-user-details-dialog-mobile-phone": "Mobilnummer: ",
        "service-center-reports-dashboard-meetings-drawer-meeting-time": "Mötestid: ",
        "service-center-reports-dashboard-meetings-drawer-host": "Värd: ",
        "service-center-reports-dashboard-meetings-drawer-host-company": "Företag: ",
        "service-center-reports-dashboard-meetings-drawer-location": "Plats: ",
        "service-center-reports-dashboard-meetings-drawer-select-all": "\n .label = Välj alla",
        "service-center-reports-dashboard-meetings-drawer-guests-title": "Gäster",
        "service-center-reports-dashboard-meetings-drawer-guests-empty": "Inga deltagare registrerade.",
        "service-center-reports-dashboard-meetings-drawer-guests-list-checked-title": "\n .title = Incheckad",
        "service-center-reports-dashboard-meetings-drawer-guests-list-not-checked-title": "\n .title = Inte incheckad",
        "service-center-reports-dashboard-meetings-drawer-guests-list-floating-check-action": "\n .title = Checka in",
        "service-center-reports-dashboard-meetings-drawer-guests-list-floating-check-out-action": "\n .title = Checka ut",
        "service-center-reports-dashboard-meetings-drawer-check-out-done": "\n .title = Klar",
        "service-center-reports-dashboard-meetings-drawer-check-out-success": "Gäster utcheckade",
        "service-center-reports-dashboard-meetings-drawer-guests-list-floating-print-guest-action": "Skriv ut gästkort",
        "service-center-reports-dashboard-meetings-drawer-guests-list-floating-other-action":"\n .title = Annat",
        "service-center-reports-dashboard-meetings-drawer-selected-guests": "Valda gäster",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-dropdown-item-manage-meeting-display": "Redigera mötesskärm",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-name-field-required-error": "Namn krävs",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-success-message": "Mötesskärmen har uppdaterats",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-title": "Hantera möte på skärmar",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-meeting-name-label": "\n .label = Nytt mötesnamn på skärmar \n .placeholder = Ange nytt mötesnamn",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-switch-label": "Visa som inställt",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-show-on-screens-switch-label": "Visa på skärmar",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-submit-button": "Spara",
        "service-center-reports-dashboard-meetings-list-row-shown-on-displays-tooltip": "\n .title = Visas på mötesskärmar",
        "service-center-reports-dashboard-meetings-list-row-arrivals-tooltip": "\n .title = Incheckad",

        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-alert-change-name-label": "Ändra mötesnamn:",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-alert-change-name-description": " Om mötesnamnet inte lämpar sig för visning på mötesskärmar kan du redigera det här. Ändringen påverkar bara namnet som visas på skärmarna.",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-alert-cancel-meeting-label": "Ställ in möte:",
        "service-center-reports-dashboard-meetings-drawer-manage-meeting-modal-alert-cancel-meeting-description": " Om du behöver ställa in ett möte men vill behålla det synligt kan du helt enkelt markera det som inställt.",

        // Service center > Reports > Dashboard > Statistics
        "service-center-reports-statistics-page-header": "\n .title = Statistik",
        "service-center-reports-statistics-occupancy-tab-title": "Beläggning",
        "service-center-reports-statistic-occupancy-table-date-range-filter": "\n .label = Datumintervall",
        "service-center-reports-statistic-occupancy-table-resource-title": "Resurs",
        "service-center-reports-statistic-occupancy-table-occupancy-rate-title": "Beläggningsgrad",
        "service-center-reports-statistic-occupancy-table-status-title": "Status",
        "service-center-reports-occupancy-dashboard-chart-title": "Beläggning per resurs",
        "service-center-reports-occupancy-dashboard-hero-overall-occupancy-label": "Total beläggning",
        "service-center-reports-occupancy-dashboard-hero-resources-tracked-label": "Registrerade resurser",
        "service-center-reports-occupancy-dashboard-chart-empty": "Inga beläggningsdata för perioden.",
        "service-center-reports-occupancy-dashboard-empty": "Inga resurser hittades för detta servicecenter.",

        "service-center-reports-statistics-cancellations-tab-title": "Avbokningar",
        "service-center-reports-statistic-cancellations-table-cancellation-rate-title": "Avbokningsgrad",

        "service-center-reports-statistics-booking-duration-tab-title": "Bokningslängd",
        "service-center-reports-statistic-booking-duration-table-number-of-bookings-title": "Antal bokningar",
        "service-center-reports-statistic-booking-duration-table-average-duration-title":  "Snittlängd",
        "service-center-reports-bookings-dashboard-chart-title": "Genomsnittlig längd per resurs",
        "service-center-reports-bookings-dashboard-hero-total-bookings-label": "Bokningar totalt",
        "service-center-reports-bookings-dashboard-hero-average-duration-label": "Genomsnittlig bokningslängd",
        "service-center-reports-bookings-dashboard-chart-empty": "Inga bokningar för perioden.",
        "service-center-reports-bookings-dashboard-empty": "Inga resurser hittades för detta servicecenter.",

        "service-center-reports-statistics-guests-tab-title": "Gäster",
        "service-center-reports-statistic-guests-table-date-title": "Datum",
        "service-center-reports-statistic-guests-table-guests-title": "Gäster",

        "service-center-reports-statistics-peak-hours-tab-title": "Rusningstimmar",
        "service-center-reports-statistics-peak-hours-heat-map-title": "Rusningstimmar",

        "service-center-reports-statistics-customer-usage-tab-title": "Hyresgästanvändning",

        // Service center > Statistics > Tenant usage (redesign)
        "service-center-usage-per-tenant-header-title": "Användning per hyresgäst",
        "service-center-usage-per-tenant-header-subtitle": "Hur varje hyresgäst använder delade resurser i ditt servicecenter.",
        "service-center-usage-per-tenant-filter-date-range": "\n .label = Datumintervall",
        "service-center-usage-per-tenant-filter-tenant-label": "\n .label = Hyresgäst",
        "service-center-usage-per-tenant-resource-type-all": "Alla typer",
        "service-center-usage-per-tenant-tenant-all": "Alla hyresgäster",
        "service-center-usage-per-tenant-summary-center-caption": "bokat under perioden",
        "service-center-usage-per-tenant-summary-hours": "{ $hours } h",
        "service-center-usage-per-tenant-summary-resources-tracked": "Registrerade resurser",
        "service-center-usage-per-tenant-summary-tenants-active": "Aktiva hyresgäster",
        "service-center-usage-per-tenant-summary-legend-other": "Andra ({ $count } hyresgäster)",
        "service-center-usage-per-tenant-detail-other-tenants": "{ $count } andra hyresgäster",
        "service-center-usage-per-tenant-section-title-room": "Mötesrum",
        "service-center-usage-per-tenant-section-title-mobile-av": "AV-utrustning",
        "service-center-usage-per-tenant-section-title-car": "Bilar",
        "service-center-usage-per-tenant-section-title-unknown": "Andra resurser",
        "service-center-usage-per-tenant-empty-resources": "Ingen resursanvändning för valda filter.",
        "service-center-usage-per-tenant-empty-tenants": "Ingen hyresgästaktivitet för valda filter.",

        // Service center > Reports > Meeting rooms
        "service-center-meeting-rooms-page-header": "\n .title = Beläggning i mötesrum",
        "service-center-meeting-rooms-status-filter-all": "Alla",
        "service-center-meeting-rooms-status-filter-booked": "Bokade",
        "service-center-meeting-rooms-status-filter-available": "Lediga",
        "service-center-meeting-rooms-floor-filter-all": "Alla våningar",
        "service-center-meeting-rooms-search-input": "\n .placeholder = Sök rum eller arrangör",
        "service-center-meeting-rooms-occupancy-by-hour-title": "Beläggning i dag",
        "service-center-meeting-rooms-occupancy-by-day-title": "Beläggning",
        "service-center-meeting-rooms-table-room-header": "Rum",
        "service-center-meeting-rooms-table-booking-header": "Bokning",
        "service-center-meeting-rooms-table-time-header": "Tid",
        "service-center-meeting-rooms-table-status-header": "Status",
        "service-center-meeting-rooms-table-room-seats": "{ $floor } · { $seats ->\n [one] { $seats } plats\n *[other] { $seats } platser\n}",
        "service-center-meeting-rooms-table-no-booking": "Ingen bokning",
        "service-center-meeting-rooms-table-occupied-without-booking": "Upptaget, inga detaljer",
        "service-center-meeting-rooms-table-footer-count": "Visar { $shown } av { $total } rum",
        "service-center-meeting-rooms-table-free-until": "Ledigt till { $time }",
        "service-center-meeting-rooms-table-free-rest-of-day": "Ledigt resten av dagen",
        "service-center-meeting-rooms-view-status": "Status",
        "service-center-meeting-rooms-view-by-hour": "Per timme",
        "service-center-meeting-rooms-view-by-room": "Per rum",
        "service-center-meeting-rooms-previous-day-button": "\n .aria-label = Föregående dag",
        "service-center-meeting-rooms-next-day-button": "\n .aria-label = Nästa dag",
        "service-center-meeting-rooms-print-button": "\n .title = Skriv ut\n .aria-label = Skriv ut",
        "service-center-meeting-rooms-occupancy-peak-button": "Högst beläggning { $hour } · { $peak } av { $total } rum bokade <action>Visa</action>",
        "service-center-meeting-rooms-occupancy-hide-chart-button": "Dölj diagram",
        "service-center-meeting-rooms-occupancy-show-chart-button": "Visa diagram",
        "service-center-meeting-rooms-occupancy-hint": "Klicka på en timme för att filtrera",
        "service-center-meeting-rooms-occupancy-peak-tooltip": "\n .title = Visa { $hour } i tabellen",
        "service-center-meeting-rooms-status-live-tooltip": "\n .title = Pågående möte nu: { $meeting } ({ $time })",
        "service-center-meeting-rooms-occupancy-now-badge": "Nu",
        "service-center-meeting-rooms-booking-state-in-progress": "Pågår",
        "service-center-meeting-rooms-booking-state-finished": "Avslutat",
        "service-center-meeting-rooms-booking-state-upcoming": "Kommande",
        "service-center-meeting-rooms-group-hour-meta": "{ $count } av { $total } rum",
        "service-center-meeting-rooms-group-hour-empty": "Inga bokningar denna timme",
        "service-center-meeting-rooms-group-room-empty": "Inga bokningar i dag",
        "service-center-meeting-rooms-drawer-room-section": "Om rummet",
        "service-center-meeting-rooms-drawer-equipment-label": "Utrustning",
        "service-center-meeting-rooms-drawer-department-label": "Avdelning",
        "service-center-meeting-rooms-drawer-phone-label": "Telefon",
        "service-center-meeting-rooms-drawer-email-label": "E-post",
        "service-center-meeting-rooms-drawer-receipt-button": "Visa kvitto",
        "service-center-meeting-rooms-drawer-status-occupied": "Upptaget till kl. { $time }",
        "service-center-meeting-rooms-drawer-status-occupied-next": "Upptaget till kl. { $time } · nästa { $nextTime } { $meeting }",
        "service-center-meeting-rooms-drawer-status-free-next": "Ledigt nu · nästa { $nextTime } { $meeting }",
        "service-center-meeting-rooms-drawer-status-free-rest-of-day": "Ledigt resten av dagen",
        "service-center-meeting-rooms-drawer-floor-label": "Våning",
        "service-center-meeting-rooms-drawer-capacity-label": "Kapacitet",
        "service-center-meeting-rooms-drawer-capacity-value": "{ $seats ->\n [one] { $seats } person\n *[other] { $seats } personer\n}",
        "service-center-meeting-rooms-drawer-booking-id-label": "Boknings-ID",
        "service-center-meeting-rooms-drawer-owner-subheading": "Mötesägare",
        "service-center-meeting-rooms-drawer-name-label": "Namn",
        "service-center-meeting-rooms-drawer-activity-section": "Aktivitet",
        "service-center-meeting-rooms-drawer-activity-status-label": "Status { $time }",
        "service-center-meeting-rooms-drawer-activity-status-in-use": "Används",
        "service-center-meeting-rooms-drawer-activity-status-free": "Ledigt",
        "service-center-meeting-rooms-drawer-next-booking-label": "Nästa bokning",
        "service-center-meeting-rooms-drawer-next-booking-none": "Ingen i dag",
        "service-center-meeting-rooms-drawer-next-booking-value": "{ $time } · { $meeting }",
        "service-center-meeting-rooms-drawer-bookings-today-label": "Bokningar i dag",
        "service-center-meeting-rooms-drawer-bookings-today-value": "{ $count ->\n [one] { $count } bokning\n *[other] { $count } bokningar\n}",
        "service-center-meeting-rooms-drawer-timeline-hint-from-now": "{ $count ->\n [one] { $count } bokning\n *[other] { $count } bokningar\n} · Från och med nu · välj ett möte för detaljer",
        "service-center-meeting-rooms-drawer-timeline-hint-whole-day": "{ $count ->\n [one] { $count } bokning\n *[other] { $count } bokningar\n} · Hela dagen · välj ett möte för detaljer",
        "service-center-meeting-rooms-drawer-timeline-title": "Dagens schema",
        "service-center-meeting-rooms-drawer-timeline-mode-from-now": "Från nu",
        "service-center-meeting-rooms-drawer-timeline-mode-whole-day": "Hela dagen",
        "service-center-meeting-rooms-drawer-timeline-free": "Ledigt",
        "service-center-meeting-rooms-drawer-timeline-occupied": "Upptaget",
        "service-center-meeting-rooms-table-free-from": "Ledigt från { $time }",
        "service-center-meeting-rooms-table-free-between": "Ledigt { $timeRange }",
        "service-center-meeting-rooms-table-free-later": "därefter { $windows }{ $hidden ->\n [0] {\"\"}\n *[other] {\" \"}+{ $hidden }\n}",
        "service-center-meeting-rooms-table-booked-rest-of-day": "Upptaget resten av dagen",
        "service-center-meeting-rooms-table-no-free-time-today": "Ingen ledig tid i dag",
        "service-center-meeting-rooms-table-action-view-details": "Visa detaljer",
        "service-center-meeting-rooms-table-action-book": "Boka { $hour }",
        "service-center-meeting-rooms-status-booked": "Bokat { $hour }",
        "service-center-meeting-rooms-status-available": "Ledigt { $hour }",
        "service-center-meeting-rooms-status-not-checked-in": "Inte incheckad",
        "service-center-meeting-rooms-status-out-of-service": "Ur drift",
        "service-center-meeting-rooms-reset-filters-button": "Återställ",
        "service-center-meeting-rooms-group-hour-free-label": "Ledigt",
        "service-center-meeting-rooms-group-hour-free-seats": "{ $seats ->\n [one] { $seats } plats\n *[other] { $seats } platser\n}",
        "service-center-meeting-rooms-group-hour-free-empty": "Inga lediga rum",
        "service-center-meeting-rooms-group-room-column-room": "Rum",
        "service-center-meeting-rooms-group-room-column-time": "Tid",
        "service-center-meeting-rooms-group-room-column-meeting": "Möte",
        "service-center-meeting-rooms-group-room-column-duration": "Varaktighet",
        "service-center-meeting-rooms-group-room-column-attendees": "Deltagare",
        "service-center-meeting-rooms-occupancy-hour-tooltip": "\n .title = { $hour }: { $booked } av { $total } rum bokade",
        "service-center-meeting-rooms-occupancy-hour-tooltip-jump-to-now": "\n .title = { $hour }: { $booked } av { $total } rum bokade · klicka för att gå till nu",
        "service-center-meeting-rooms-table-no-match": "Inga rum matchar filtren — återställ status, våning eller sökning.",
        "service-center-meeting-rooms-table-footer-no-match": "Inga rum matchar filtren",
        "service-center-meeting-rooms-booking-participants": "{ $participants ->\n [one] { $participants } person\n *[other] { $participants } personer\n}",
        "service-center-meeting-rooms-booking-participants-of-seats": "{ $participants } av { $seats ->\n [one] { $seats } plats\n *[other] { $seats } platser\n}",
        "service-center-meeting-rooms-booking-catering-chip": "Mötesförtäring",
        "service-center-meeting-rooms-booking-over-capacity-chip": "Över kapacitet",
        "service-center-meeting-rooms-drawer-participants-label": "Deltagare",
        "service-center-meeting-rooms-drawer-table-setup-label": "Bordsuppställning",
        "service-center-meeting-rooms-drawer-catering-label": "Mötesförtäring",
        "service-center-meeting-rooms-drawer-catering-ordered": "Beställd",
        "service-center-meeting-rooms-drawer-catering-not-ordered": "Inte beställd",

        // Service center > Reports > Dashboard > Guests
        "service-center-reports-dashboard-guests-page-header": "\n .title = Gäster",
        "service-center-reports-dashboard-guests-table-guest-title": "Gäst",
        "service-center-reports-dashboard-guests-table-host-title": "Värd",
        "service-center-reports-dashboard-guests-table-check-in-time-title": "Incheckning",
        "service-center-reports-dashboard-guests-table-check-in-time-tooltip": "Mötesstart",
        "service-center-reports-dashboard-guests-table-check-out-time-title": "Utcheckning",
        "service-center-reports-dashboard-guests-table-host-company-title": "Värdföretag",
        "service-center-reports-dashboard-guests-table-host-company-status": "Status",
        "service-center-reports-dashboard-guests-table-host-company-status-checked-in": "Incheckad",
        "service-center-reports-dashboard-guests-table-host-company-status-checked-out": "Utcheckad",
        "service-center-reports-dashboard-guests-table-host-company-status-expected": "Väntad",
        "service-center-reports-dashboard-guests-table-host-company-status-pending": "Väntar",
        "service-center-reports-dashboard-guests-table-host-company-status-checked-in-hover-tooltip": "Gästen har checkat in.",
        "service-center-reports-dashboard-guests-table-host-company-status-checked-out-hover-tooltip": "Gästen har checkat ut.",
        "service-center-reports-dashboard-guests-table-host-company-status-expected-hover-tooltip": "Gästen har bjudits in men har inte checkat in ännu.",
        "service-center-reports-dashboard-guests-table-host-company-status-pending-hover-tooltip": "Gästen har slutfört självincheckning, men receptionen bör ändå hälsa välkommen och dela ut ett gästkort.",
        "service-center-reports-dashboard-guests-table-floating-action-bar-guest-card": "\n .title = Gästkort",
        "service-center-reports-dashboard-guests-table-date-range-filter": "\n .label = Mötesperiod",


        // Service center > Admin > Organization > DEVICES
        "service-center-admin-organization-devices-title": "\n .title = Enheter",
        "service-center-admin-organization-devices-button-title": "Skapa enhet",

        // Service center > Admin > Organization > Resources
        "service-center-admin-organization-resources-title": "\n .title = Resurser",
        "service-center-admin-organization-resources-create-button": "Skapa ny",
        "service-center-admin-organization-resources-rooms-tab": "Rum",
        "service-center-admin-organization-resources-mobile-av-equipment-tab": "AV-utrustning",
        "service-center-admin-organization-resources-cars-tab": "Bilar",
        "service-center-admin-organization-resources-table-header-name": "Namn",
        "service-center-admin-organization-resources-table-room-header-id": "Rumsnr",
        "service-center-admin-organization-resources-table-mobile-av-header-id": "Serienr",
        "service-center-admin-organization-resources-table-cars-header-id": "Regnr",
        "service-center-admin-organization-resources-table-header-status": "Status",
        "service-center-admin-organization-resources-table-edit-item": "Redigera",
        "service-center-admin-organization-resources-table-delete-item": "Ta bort",
        "service-center-admin-organization-resources-table-room-delete-modal-title": "rum",
        "service-center-admin-organization-resources-table-mobile-av-equipment-delete-modal-title": "mobil AV-utrustning",
        "service-center-admin-organization-resources-table-car-delete-modal-title": "bil",

        "service-center-admin-organization-resources-create-room": "Rum",
        "service-center-admin-organization-resources-create-car": "Bil",
        "service-center-admin-organization-resources-status-not-approved": "Inte godkänd",
        "service-center-admin-organization-resources-status-approved": "Godkänd",
        "service-center-admin-organization-resources-status-rejected": "Avvisad",
        "service-center-admin-organization-resources-status-locked": "Låst",
        "service-center-admin-organization-resources-status-preparing": "Förbereds",
        "service-center-admin-organization-resources-status-delivered": "Levererad",
        "service-center-admin-organization-resources-status-to-be-booked": "Ska bokföras",
        "service-center-admin-organization-resources-status-booked": "Bokförd",
        "service-center-admin-organization-resources-status-completed": "Utförd",

        "service-center-admin-organization-resources-status-menu-not-approved": "Återkalla godkännande",
        "service-center-admin-organization-resources-status-menu-approved": "Godkänn",
        "service-center-admin-organization-resources-status-menu-rejected": "Avvisa",
        "service-center-admin-organization-resources-status-menu-locked": "Lås",
        "service-center-admin-organization-resources-status-menu-preparing": "Förbered",
        "service-center-admin-organization-resources-status-menu-delivered": "Levererad",
        "service-center-admin-organization-resources-status-menu-booked": "Bokför",
        "service-center-admin-organization-resources-status-menu-ready": "Klar",
        "service-center-admin-organization-resources-status-menu-completed": "Slutför",
        "service-center-admin-organization-resources-status-menu-default": "Ingen status",

        // Service center > Admin > Organization > Resources > Create Mobile AV
        "service-center-admin-organization-resources-create-mobile-av-title": "\n .title = Skapa Mobile AV",
        "service-center-admin-organization-resources-update-mobile-av-title": "\n .title = Uppdatera Mobile AV",
        "resources-create-edit-mobile-av-general-tab-error": "Fliken Allmänt har valideringsfel",

        // Service center > Admin > Organization > Resources > Create car
        "service-center-admin-organization-resources-create-car-title": "\n .title = Skapa bil",
        "service-center-admin-organization-resources-update-car-title": "\n .title = Uppdatera bil",
        "resources-create-edit-car-general-tab-error": "Fliken Allmänt har valideringsfel",

        // Service center > Admin > Organization > Resources > Create car > General
        "resources-create-edit-car-general-tab-general": "Allmänt",
        "resources-create-car-tab-general-registration-number-label": "\n .label = Registreringsnummer",
        "resources-create-car-tab-general-name-label": "\n .label = Namn",
        "resources-create-car-tab-general-description-label": "\n .label = Beskrivning",
        "resources-create-car-tab-general-car-type-label": "\n .label = Biltyp",
        "resources-create-car-tab-general-location-of-keys-label": "\n .label = Nyckelplacering",
        "resources-create-car-tab-general-parking-location-label": "\n .label = Standardplats för parkering",
        "resources-create-car-tab-general-active-label": "Aktiv:",
        "resources-create-car-tab-general-in-service-label": "I drift:",
        "resources-create-car-tab-general-side-settings": "\n .title = Inställningar",

        // Service center > Admin > Organization > Resources > Create Mobile AV > General
        "resources-create-edit-mobile-av-general-tab-general": "Allmänt",
        "resources-create-mobile-av-tab-general-serial-number-label": "\n .label = Serienummer",
        "resources-create-mobile-av-tab-general-name-label": "\n .label = Namn",
        "resources-create-mobile-av-tab-general-floor-label": "\n .label = Våning",
        "resources-create-mobile-av-tab-general-description-label": "\n .label = Beskrivning",
        "resources-create-mobile-av-tab-general-storage-location-label": "\n .label = Förvaringsplats",
        "resources-create-mobile-av-tab-general-cleanup-buffer-label": "\n .label = Städbuffert",
        "resources-create-mobile-av-tab-general-color-code-label": "\n .label = Färgkod",
        "resources-create-mobile-av-tab-general-active-label": "Aktiv:",
        "resources-create-mobile-av-tab-general-side-settings": "\n .title = Inställningar",


        // Service center > Admin > Organization > Resources > Create room
        "service-center-admin-organization-resources-create-room-title": "\n .title = Skapa rum",
        "resources-create-edit-room-general-tab-error": "Fliken Allmänt har valideringsfel",

        // Service center > Admin > Organization > Resources > Create room > General
        "resources-create-edit-room-general-tab-general": "Allmänt",
        "resources-create-room-tab-general-room-number-label": "\n .label = Rumsnummer",
        "resources-create-room-tab-general-name-label": "\n .label = Namn",
        "resources-create-room-tab-general-description-label": "\n .label = Beskrivning",
        "resources-create-room-tab-general-seats-label": "\n .label = Platser",
        "resources-create-room-tab-general-active-label": "Aktiv:",
        "resources-create-room-tab-general-other-location-label": "Annan plats:",
        "resources-create-room-tab-general-other-location-description": "\n .title = Om ett rum markeras som \"Annan plats\" kan användaren skriva in en ad hoc-plats för mötet, till exempel sitt kontor.",
        "resources-create-room-tab-general-side-settings": "\n .title = Inställningar",
        "resources-create-room-tab-general-floor-label": "\n .label = Våning",
        "resources-create-room-tab-general-walk-direction-label": "\n .label = Gångriktning",
        "resources-create-room-tab-general-walk-direction-north": "Norr",
        "resources-create-room-tab-general-walk-direction-east": "Öst",
        "resources-create-room-tab-general-walk-direction-south": "Söder",
        "resources-create-room-tab-general-walk-direction-west": "Väst",
        "resources-create-room-tab-general-color-red": "Röd",
        "resources-create-room-tab-general-color-green": "Grön",
        "resources-create-room-tab-general-color-blue": "Blå",
        "resources-create-room-tab-general-color-black": "Svart",
        "resources-create-room-tab-general-color-lightblue": "Ljusblå",
        "resources-create-room-tab-general-tags-label":  "\n .label = Taggar",
        "resources-create-room-tab-general-tags-info-description":  "\n .label = Skapa en eller flera taggar som kan användas för att filtrera resurser. Till exempel \"Externt mötesrum\", \"Gästmötesrum\", \"Konferensrum\", \"Telefonrum\" osv.",
        "resources-create-room-tab-general-fixed-av-equipment-label":  "\n .label = Fast AV-utrustning",
        "resources-create-room-tab-general-side-filter-details": "\n .title = Filterdetaljer",
        "resources-create-room-tab-general-area-label": "\n .label = Yta (m²) \n .placeholder = Rummets yta i m²",
        "resources-create-room-tab-general-cleanup-buffer-label": "\n .label = Städbuffert",
        "resources-create-room-tab-general-color-code-label": "\n .label = Färgkod",
        "resources-create-room-tab-general-email-address-label": "\n .label = E-postadress",
        "resources-create-room-tab-general-side-integrations": "\n .title = Kalenderintegration",
        "resources-create-room-tab-general-side-integrations-meeting-invite": "\n .description = Används för integration med Exchange eller andra kalendersystem. E-postadressen läggs till i mötesinbjudan av FacilityNet Outlook Add-in när rummet bokas.",
        "resources-create-room-tab-general-side-integrations-starleaf": "\n .description =Används för integration med StarLeaf-utrustning som levereras med en dedikerad e-postadress för integration.",
        "resources-create-room-tab-general-side-integrations-ews": "\n .description = Används för integration med utrustning som läser från en kalender. Brevlådans kalender bokas med ett EWS-tjänstkonto när rummet bokas.",

        "resources-create-room-tab-general-book-using-ews": "Boka med EWS",

        // Service center > Admin > Organization > Resources > Create room > Table arrangements
        "resources-create-edit-room-general-tab-table-arrangements": "Bordsuppställningar",
        "service-center-reports-dashboard-meeting-filter-mobile-av": "Mobil AV",
        "service-center-reports-dashboard-meeting-filter-set-tables": "Dukning",
        "service-center-reports-dashboard-meeting-filter-cleanup": "Avdukning",
        "tab-table-arrangements-standard": "Standard",
        "tab-table-arrangements-optional-chip": "Valfri",
        "tab-table-arrangements-make-standard-button": "Gör till standard",
        "tab-table-arrangements-add-new-card": "Lägg till ny bordsuppställning",
        "tab-table-arrangements-label-meeting-room": "Mötesrum",
        "tab-table-arrangements-label-cinema": "Biosittning",
        "tab-table-arrangements-label-u-form": "U-form",
        "tab-table-arrangements-label-school": "Skolsittning",
        "tab-table-arrangements-label-group": "Grupp",
        "tab-table-arrangements-label-negotiation": "Förhandling",
        "tab-table-arrangements-label-cafe": "Café",
        "tab-table-arrangements-label-conference": "Konferens",
        "tab-table-arrangements-label-herringbone": "Fiskben",
        "tab-table-arrangements-create-dialog-title": "Ny bordsuppställning",
        "tab-table-arrangements-create-dialog-name-label": "\n .label = Namn",
        "tab-table-arrangements-create-dialog-image-label": "Bild",
        "tab-table-arrangements-create-dialog-submit-button": "Skapa",
        "tab-table-arrangements-create-dialog-name-required-error": "Namn krävs",
        "tab-table-arrangements-create-dialog-image-required-error": "Bild krävs",

        // Service center > Admin > Organization > Resources > Create room > Notifiations
        "resources-create-edit-room-general-tab-table-header-type": "Typ",
        "resources-create-edit-room-general-tab-table-header-sent": "Skickat",
        "resources-create-edit-room-general-tab-table-header-content": "Innehåll",

        // Service center > Admin > Organization > Resources > Create room > Availability
        "resources-create-edit-room-general-tab-availability": "Tillgänglighet",
        "tab-availability-closed-periods-title": "Otillgänglig period",
        "tab-availability-table-start-header": "Start",
        "tab-availability-table-end-header": "Slut",
        "tab-availability-table-reason-header": "Orsak",
        "tab-availability-table-edit-action": "Redigera",
        "tab-availability-table-delete-action": "Ta bort",
        "tab-availability-add-closed-period-action": "Lägg till otillgänglig period",
        "tab-availability-side-daily-closing-times-title": "\n .title = Dagliga stängningstider",
        "tab-availability-side-daily-booking-times-title": "\n .title = Dagliga bokningstider",
        "tab-availability-booking-time-option-all-day": "\n .label = Tillgänglig hela dagen",
        "tab-availability-booking-time-option-specific-hours": "\n .label = Endast tillgänglig vid vissa tider",
        "tab-availability-booking-time-option-daily-break": "\n .label = Otillgänglig under en daglig paus",
        "tab-availability-booking-time-from-label": "\n .label = Från",
        "tab-availability-booking-time-to-label": "\n .label = Till",
        "tab-availability-side-start-time-label": "\n .label = Starttid",
        "tab-availability-side-end-time-label": "\n .label = Sluttid",
        "tab-availability-modal-reason-label": "\n .label = Orsak",
        "tab-availability-modal-reason-max": "Orsaken får vara högst { $max } tecken",
        "tab-availability-modal-title": "Lägg till stängd period",
        "tab-availability-modal-add-button": "Lägg till",

        "tab-availability-add-reminder-dialog-title": "Lägg till påminnelse",
        "tab-availability-add-reminder-edit-dialog-title": "Redigera påminnelse",
        "tab-availability-add-reminder-dialog-field-type-label": "\n .label = Typ",
        "tab-availability-add-reminder-dialog-field-time-label": "\n .label = Skickat",
        "tab-availability-add-reminder-dialog-field-text-label": "\n .label = Text",
        "tab-availability-add-reminder-dialog-text-max": "Texten får vara högst { $max } tecken",
        "tab-availability-add-reminder-dialog-submit-button-label": "Lägg till",

        "tab-availability-add-reminder-dialog-form-time-suffix-hours-before": "timmar före mötesstart",
        "tab-availability-add-reminder-dialog-form-time-suffix-minutes-before": "minuter före mötesstart",
        "tab-availability-add-reminder-dialog-form-time-suffix-hours-after": "timmar efter mötets slut",
        "tab-availability-add-reminder-dialog-form-time-suffix-minutes-after": "minuter efter mötets slut",

        "reminder-type-option-meeting-start": "Påminnelse om mötesstart",
        "reminder-type-option-first-reminder": "Första påminnelse",
        "reminder-type-option-preparation": "Förberedelse",
        "reminder-type-option-cleanup": "Städning",
        "reminder-type-option-custom-reminder": "Anpassad påminnelse",
        "reminder-type-option-meeting-confirmation": "Mötesbekräftelse",

        "integration-type-option-none": "Ingen",
        "integration-type-option-meeting-invite": "Mötesinbjudan",
        "integration-type-option-ews": "EWS",
        "integration-type-option-starleaf": "Starleaf",

        // Service center > Admin > Organization > Resources > Create room > Access control
        "resources-create-edit-room-general-tab-access-control": "Åtkomstkontroll",
        "tab-access-control-restricted-access-title": "\n .title =Begränsad åtkomst",
        "tab-access-control-visible-everyone-switch":"Synlig för alla",
        "tab-access-control-reserved-for-company-title":"Reserverad för företag:",
        "tab-access-control-bookable-by-departments-title":"Kan bokas av avdelningar:",
        "tab-access-control-select-department-select-item":"Välj en avdelning",
        "tab-access-control-add-button":"Lägg till",


        // Service center > Admin > Account > Admins
        "service-center-admin-account-admins-page-header": "\n .title = Administratörer",
        "service-center-admin-account-admins-table-header-name":"Namn",
        "service-center-admin-account-admins-table-header-email":"E-post",
        "service-center-admin-account-admins-table-header-status":"Status",
        "service-center-admin-account-admins-table-status-active":"Aktiv",
        "service-center-admin-account-admins-table-status-inactive": "Inaktiv",
        "service-center-admin-account-admins-table-button-details": "Visa detaljer",
        "service-center-admin-account-admins-table-button-edit": "Redigera användare",
        "service-center-admin-account-admins-table-button-delete": "Ta bort användare",
        "service-center-admin-account-admins-delete-dialog-entity-type": "användare",
        "service-center-admin-account-admins-button-create": "Skapa ny",

        // Service center > Admin > Organization > Manage bookings
        "service-center-admin-organization-manage-bookings-page-header": "\n .title = Hantera ordrar",
        "service-center-admin-organization-manage-bookings-breadcrumb": "Hantera ordrar",
        "service-center-admin-organization-manage-bookings-confirm-button": "Fortsätt",
        "service-center-admin-organization-manage-bookings-action-move": "Flytta till ny ägare",
        "service-center-admin-organization-manage-bookings-action-delete": "Ta bort",
        "service-center-admin-organization-manage-bookings-select-action": "\n .label = Välj åtgärd:",
        "service-center-admin-organization-manage-bookings-select-action-placeholder": "Välj",
        "service-center-admin-organization-manage-bookings-select-company": "\n .label = Välj företag:",
        "service-center-admin-organization-manage-bookings-select-user": "\n .label = Välj användare:",
        "service-center-admin-organization-manage-bookings-select-new-owner": "\n .label = Välj ny ägare:",
        "service-center-admin-organization-manage-bookings-what-to-move-label": "Vad ska flyttas:",
        "service-center-admin-organization-manage-bookings-what-to-delete-label": "Vad ska tas bort:",
        "service-center-admin-organization-manage-bookings-current-owner-title": "Nuvarande ägare",
        "service-center-admin-organization-manage-bookings-new-owner-title": "Ny ägare",
        "service-center-admin-organization-manage-bookings-checkbox-bookings": "Bokningar",
        "service-center-admin-organization-manage-bookings-checkbox-meeting-service": "Mötesförtäringsbeställningar",
        "service-center-admin-organization-manage-bookings-error-company-required": "Företag krävs",
        "service-center-admin-organization-manage-bookings-error-user-required": "Användare krävs",
        "service-center-admin-organization-manage-bookings-error-action-required": "Åtgärd krävs",
        "service-center-admin-organization-manage-bookings-error-new-owner-required": "Ny bokningsägare krävs",
        "service-center-admin-organization-manage-bookings-error-at-least-one-option": "Välj minst ett alternativ",
        "service-center-admin-organization-manage-bookings-alert-move": "\n .title = Ordrar flyttas till en ny ägare som du väljer nedan.",
        "service-center-admin-organization-manage-bookings-alert-delete": "\n .title = Alla framtida bokningar för denna användare avbokas.",
        "service-center-admin-organization-manage-bookings-confirm-modal-move-title": "Flytta ordrar",
        "service-center-admin-organization-manage-bookings-confirm-modal-delete-title": "Ta bort ordrar",
        "service-center-admin-organization-manage-bookings-confirm-modal-move-message": "Bekräfta att du vill flytta { $count } ordrar.",
        "service-center-admin-organization-manage-bookings-confirm-modal-delete-message": "Bekräfta att du vill ta bort { $count } ordrar.",
        "service-center-admin-organization-manage-bookings-confirm-modal-move-no-orders": "Det finns inga ordrar att flytta.",
        "service-center-admin-organization-manage-bookings-confirm-modal-delete-no-orders": "Det finns inga ordrar att ta bort.",
        "service-center-admin-organization-manage-bookings-confirm-modal-from": "Från: { $name }",
        "service-center-admin-organization-manage-bookings-confirm-modal-user": "Användare: { $name }",
        "service-center-admin-organization-manage-bookings-confirm-modal-to": "Till: { $name }",
        "service-center-admin-organization-manage-bookings-confirm-modal-user-id-tooltip": "\n .title = Internt användar-ID",
        "service-center-admin-organization-manage-bookings-confirm-modal-submit-button": "Bekräfta",
        "service-center-admin-organization-manage-bookings-confirm-modal-cancel-button": "Avbryt",
        "service-center-admin-organization-manage-bookings-confirm-modal-close-button": "Stäng",
        "service-center-admin-organization-manage-bookings-confirm-modal-excluded-orders": "\n .title = { $count } ordrar uteslutna: { $reason }",
        "service-center-admin-organization-manage-bookings-success-modal-move-title": "Ordrar flyttade",
        "service-center-admin-organization-manage-bookings-success-modal-delete-title": "Ordrar borttagna",
        "service-center-admin-organization-manage-bookings-submit-missing-data-error": "Obligatoriska uppgifter saknas, försök igen",
        "service-center-admin-organization-manage-bookings-user-no-results": "Inga användare hittades",
        "service-center-admin-organization-manage-bookings-select-placeholder": "Välj",

        // Product availability
        "product-unavailable-dialog-close": "Stäng",
        "product-unavailable-snackbar": "Den här produkten är för närvarande inte tillgänglig",
        "product-daily-limit-exceeded-snackbar": "Daglig köpgräns har nåtts för den här produkten",
        "product-stock-limit-exceeded-snackbar": "Det finns inte tillräckligt många varor i lager",
        "product-stock-negative-error": "Lagersaldot kan inte vara negativt",

        // Order chat
        "order-chat-drawer-title-customer": "Chatta med kantinen",
        "order-chat-drawer-title-merchant": "Chatta med kunden",
        "order-chat-disclaimer-text": "Den här chatten används för att kommunicera om beställningen. Meddelanden visas inte på orderspecifikationen.",
        "order-chat-disclaimer-warning": "OBS: Undvik att ange känsliga personuppgifter, t.ex. om du är vegetarian eller har allergier.",
        "order-chat-disclaimer-link": "Läs mer <a>här</a>.",
        "order-chat-disclaimer-accept": "Förstått",
        "order-chat-placeholder-merchant": "Meddelande till kund...",
        "order-chat-placeholder-customer": "Meddelande till kantinen...",
        "order-chat-empty": "\n .title = Inga meddelanden ännu\n .description = Starta konversationen!",
        "order-chat-exceeded-characters": "Maxgränsen på { $limit } tecken har överskridits",
        "order-chat-menu-item-customer": "Chatta med kantinen",
        "order-chat-menu-item-merchant": "Chatta med kunden",
        "order-chat-tooltip-needs-response": "Nytt meddelande - kräver svar",
        "order-chat-tooltip-responded": "Chatt",
        "order-chat-history-print-with-button": "Skriv ut med chatthistorik",
        "order-chat-history-print-without-button": "Skriv ut",
        "meeting-service-print-view-order-menu-print-button": "Skriv ut (med orderanteckning)",
        "meeting-service-print-view-order-menu-print-with-chat-button": "Skriv ut (med orderanteckning och chatt)",
        "meeting-service-print-view-order-menu-print-section-title": "Skriv ut order",
        "order-chat-history-print-title": "Chatthistorik",
        "order-chat-status-card-messages-badge": "\n .label = { $count -> \n [one] { $count } meddelande \n *[other] { $count } meddelanden \n }",
        "order-chat-status-card-reply-own": "Du svarade den { $date } kl. { $time }: <quote>“{ $message }”</quote>",
        "order-chat-status-card-reply-user": "Kunden svarade den { $date } kl. { $time }: <quote>“{ $message }”</quote>",
        "order-chat-status-card-reply-merchant": "Kantinen svarade den { $date } kl. { $time }: <quote>“{ $message }”</quote>",
    }
}


type TranslationId = keyof typeof translations["en-US"]
type TranslationIdDa = keyof typeof translations["da-DK"]
type TranslationIdNb = keyof typeof translations["nb-NO"]
type TranslationIdSv = keyof typeof translations["sv-SE"]

// --- This section verifies at compile time that all keys in English translation is present in Danish translation and vice versa
const allEnglishTranslationKeys: TranslationId = Object.keys(translations["en-US"]) as unknown as TranslationId
const allDanishTranslationKeys: TranslationIdDa = Object.keys(translations["da-DK"]) as unknown as TranslationIdDa
const missingEnKeysInDaTranslation: TranslationIdDa = allEnglishTranslationKeys
const missingDaKeysInEnTranslation: TranslationId = allDanishTranslationKeys
const allNorwegianTranslationKeys: TranslationIdNb = Object.keys(translations["nb-NO"]) as unknown as TranslationIdNb
const allSwedishTranslationKeys: TranslationIdSv = Object.keys(translations["sv-SE"]) as unknown as TranslationIdSv
const missingEnKeysInNbTranslation: TranslationIdNb = allEnglishTranslationKeys
const missingNbKeysInEnTranslation: TranslationId = allNorwegianTranslationKeys
const missingEnKeysInSvTranslation: TranslationIdSv = allEnglishTranslationKeys
const missingSvKeysInEnTranslation: TranslationId = allSwedishTranslationKeys
// ---

export type TranslationKey = keyof typeof translations["en-US"]
export type StrictTranslations = typeof translations
export type Translations = Record<string, Record<string, string>>
